
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0300"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0300"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6THZ6", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");

var $6ZWSX = parcelRequire("6ZWSX");
var $5059ff85b35ef8d7$require$Buffer = $6ZWSX.Buffer;
var JV = Object.create;
var iy = Object.defineProperty;
var $V = Object.getOwnPropertyDescriptor;
var eU = Object.getOwnPropertyNames;
var tU = Object.getPrototypeOf, rU = Object.prototype.hasOwnProperty;
var iU = (n1, t, e)=>t in n1 ? iy(n1, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : n1[t] = e;
var Cc = (n1, t)=>()=>(t || n1((t = {
            exports: {}
        }).exports, t), t.exports), nU = (n1, t)=>{
    for(var e in t)iy(n1, e, {
        get: t[e],
        enumerable: !0
    });
}, sU = (n1, t, e, r)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let i of eU(t))!rU.call(n1, i) && i !== e && iy(n1, i, {
        get: ()=>t[i],
        enumerable: !(r = $V(t, i)) || r.enumerable
    });
    return n1;
};
var cl = (n1, t, e)=>(e = n1 != null ? JV(tU(n1)) : {}, sU(t || !n1 || !n1.__esModule ? iy(e, "default", {
        value: n1,
        enumerable: !0
    }) : e, n1));
var Pc = (n1, t, e)=>(iU(n1, typeof t != "symbol" ? t + "" : t, e), e);
var ZR = Cc((xE, QR)=>{
    (function(n1, t) {
        typeof xE == "object" ? QR.exports = t() : typeof define == "function" && define.amd ? define(t) : n1.Alea = t();
    })(xE, function() {
        "use strict";
        return n1.importState = function(e) {
            var r = new n1;
            return r.importState(e), r;
        }, n1;
        function n1() {
            return function(e) {
                var r = 0, i = 0, s1 = 0, o = 1;
                e.length == 0 && (e = [
                    +new Date
                ]);
                var a = t();
                r = a(" "), i = a(" "), s1 = a(" ");
                for(var l = 0; l < e.length; l++)r -= a(e[l]), r < 0 && (r += 1), i -= a(e[l]), i < 0 && (i += 1), s1 -= a(e[l]), s1 < 0 && (s1 += 1);
                a = null;
                var c = function() {
                    var u1 = 2091639 * r + o * 23283064365386963e-26;
                    return r = i, i = s1, s1 = u1 - (o = u1 | 0);
                };
                return c.next = c, c.uint32 = function() {
                    return c() * 4294967296;
                }, c.fract53 = function() {
                    return c() + (c() * 2097152 | 0) * 11102230246251565e-32;
                }, c.version = "Alea 0.9", c.args = e, c.exportState = function() {
                    return [
                        r,
                        i,
                        s1,
                        o
                    ];
                }, c.importState = function(u1) {
                    r = +u1[0] || 0, i = +u1[1] || 0, s1 = +u1[2] || 0, o = +u1[3] || 0;
                }, c;
            }(Array.prototype.slice.call(arguments));
        }
        function t() {
            var e = 4022871197, r = function(i) {
                i = i.toString();
                for(var s1 = 0; s1 < i.length; s1++){
                    e += i.charCodeAt(s1);
                    var o = .02519603282416938 * e;
                    e = o >>> 0, o -= e, o *= e, e = o >>> 0, o -= e, e += o * 4294967296;
                }
                return (e >>> 0) * 23283064365386963e-26;
            };
            return r.version = "Mash 0.9", r;
        }
    });
});
var SE = Cc((mx, r3)=>{
    (function(n1, t) {
        typeof mx == "object" && typeof r3 < "u" ? t(mx) : typeof define == "function" && define.amd ? define([
            "exports"
        ], t) : t((n1 = typeof globalThis < "u" ? globalThis : n1 || self).SVDJS = {});
    })(mx, function(n1) {
        "use strict";
        n1.SVD = function(t, e, r, i, s1) {
            if (e = e === void 0 || e, r = r === void 0 || r, s1 = 1e-64 / (i = i || Math.pow(2, -52)), !t) throw new TypeError("Matrix a is not defined");
            var o, a, l, c, u1, h, d, f, m, p, g, y, x = t[0].length, v = t.length;
            if (v < x) throw new TypeError("Invalid matrix: m < n");
            for(var b = [], w = [], A = [], T = e === "f" ? v : x, S = p = d = 0; S < v; S++)w[S] = new Array(T).fill(0);
            for(S = 0; S < x; S++)A[S] = new Array(x).fill(0);
            var M, C = new Array(x).fill(0);
            for(S = 0; S < v; S++)for(o = 0; o < x; o++)w[S][o] = t[S][o];
            for(S = 0; S < x; S++){
                for(b[S] = d, m = 0, l = S + 1, o = S; o < v; o++)m += Math.pow(w[o][S], 2);
                if (m < s1) d = 0;
                else for(f = (h = w[S][S]) * (d = h < 0 ? Math.sqrt(m) : -Math.sqrt(m)) - m, w[S][S] = h - d, o = l; o < x; o++){
                    for(m = 0, a = S; a < v; a++)m += w[a][S] * w[a][o];
                    for(h = m / f, a = S; a < v; a++)w[a][o] = w[a][o] + h * w[a][S];
                }
                for(C[S] = d, m = 0, o = l; o < x; o++)m += Math.pow(w[S][o], 2);
                if (m < s1) d = 0;
                else {
                    for(f = (h = w[S][S + 1]) * (d = h < 0 ? Math.sqrt(m) : -Math.sqrt(m)) - m, w[S][S + 1] = h - d, o = l; o < x; o++)b[o] = w[S][o] / f;
                    for(o = l; o < v; o++){
                        for(m = 0, a = l; a < x; a++)m += w[o][a] * w[S][a];
                        for(a = l; a < x; a++)w[o][a] = w[o][a] + m * b[a];
                    }
                }
                p < (g = Math.abs(C[S]) + Math.abs(b[S])) && (p = g);
            }
            if (r) for(S = x - 1; 0 <= S; S--){
                if (d !== 0) {
                    for(f = w[S][S + 1] * d, o = l; o < x; o++)A[o][S] = w[S][o] / f;
                    for(o = l; o < x; o++){
                        for(m = 0, a = l; a < x; a++)m += w[S][a] * A[a][o];
                        for(a = l; a < x; a++)A[a][o] = A[a][o] + m * A[a][S];
                    }
                }
                for(o = l; o < x; o++)A[S][o] = 0, A[o][S] = 0;
                A[S][S] = 1, d = b[S], l = S;
            }
            if (e) {
                if (e === "f") for(S = x; S < v; S++){
                    for(o = x; o < v; o++)w[S][o] = 0;
                    w[S][S] = 1;
                }
                for(S = x - 1; 0 <= S; S--){
                    for(l = S + 1, d = C[S], o = l; o < T; o++)w[S][o] = 0;
                    if (d !== 0) {
                        for(f = w[S][S] * d, o = l; o < T; o++){
                            for(m = 0, a = l; a < v; a++)m += w[a][S] * w[a][o];
                            for(h = m / f, a = S; a < v; a++)w[a][o] = w[a][o] + h * w[a][S];
                        }
                        for(o = S; o < v; o++)w[o][S] = w[o][S] / d;
                    } else for(o = S; o < v; o++)w[o][S] = 0;
                    w[S][S] = w[S][S] + 1;
                }
            }
            for(i *= p, a = x - 1; 0 <= a; a--)for(var P = 0; P < 50; P++){
                for(M = !1, l = a; 0 <= l; l--){
                    if (Math.abs(b[l]) <= i) {
                        M = !0;
                        break;
                    }
                    if (Math.abs(C[l - 1]) <= i) break;
                }
                if (!M) {
                    for(u1 = 0, c = l - (m = 1), S = l; S < a + 1 && (h = m * b[S], b[S] = u1 * b[S], !(Math.abs(h) <= i)); S++)if (d = C[S], C[S] = Math.sqrt(h * h + d * d), u1 = d / (f = C[S]), m = -h / f, e) for(o = 0; o < v; o++)g = w[o][c], y = w[o][S], w[o][c] = g * u1 + y * m, w[o][S] = -g * m + y * u1;
                }
                if (y = C[a], l === a) {
                    if (y < 0 && (C[a] = -y, r)) for(o = 0; o < x; o++)A[o][a] = -A[o][a];
                    break;
                }
                for(p = C[l], h = (((g = C[a - 1]) - y) * (g + y) + ((d = b[a - 1]) - (f = b[a])) * (d + f)) / (2 * f * g), d = Math.sqrt(h * h + 1), h = ((p - y) * (p + y) + f * (g / (h < 0 ? h - d : h + d) - f)) / p, S = l + (m = u1 = 1); S < a + 1; S++){
                    if (d = b[S], g = C[S], f = m * d, d *= u1, y = Math.sqrt(h * h + f * f), h = p * (u1 = h / (b[S - 1] = y)) + d * (m = f / y), d = -p * m + d * u1, f = g * m, g *= u1, r) for(o = 0; o < x; o++)p = A[o][S - 1], y = A[o][S], A[o][S - 1] = p * u1 + y * m, A[o][S] = -p * m + y * u1;
                    if (y = Math.sqrt(h * h + f * f), h = (u1 = h / (C[S - 1] = y)) * d + (m = f / y) * g, p = -m * d + u1 * g, e) for(o = 0; o < v; o++)g = w[o][S - 1], y = w[o][S], w[o][S - 1] = g * u1 + y * m, w[o][S] = -g * m + y * u1;
                }
                b[l] = 0, b[a] = h, C[a] = p;
            }
            for(S = 0; S < x; S++)C[S] < i && (C[S] = 0);
            return {
                u: w,
                q: C,
                v: A
            };
        }, n1.VERSION = "1.1.1", Object.defineProperty(n1, "__esModule", {
            value: !0
        });
    });
});
var IL = Cc((qx, _L)=>{
    "use strict";
    Object.defineProperty(qx, "__esModule", {
        value: !0
    });
    qx.default = sZ;
    function sZ(n1) {
        if (n1 === null || n1 === !0 || n1 === !1) return NaN;
        var t = Number(n1);
        return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
    }
    _L.exports = qx.default;
});
var OL = Cc((Xx, DL)=>{
    "use strict";
    Object.defineProperty(Xx, "__esModule", {
        value: !0
    });
    Xx.default = oZ;
    function oZ(n1) {
        var t = new Date(Date.UTC(n1.getFullYear(), n1.getMonth(), n1.getDate(), n1.getHours(), n1.getMinutes(), n1.getSeconds(), n1.getMilliseconds()));
        return t.setUTCFullYear(n1.getFullYear()), n1.getTime() - t.getTime();
    }
    DL.exports = Xx.default;
});
var PB = Cc((jke, CB)=>{
    "use strict";
    function tee(n1, t) {
        function e() {
            this.constructor = n1;
        }
        e.prototype = t.prototype, n1.prototype = new e;
    }
    function Au(n1, t, e, r) {
        this.message = n1, this.expected = t, this.found = e, this.location = r, this.name = "SyntaxError", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Au);
    }
    tee(Au, Error);
    Au.buildMessage = function(n1, t) {
        var e = {
            literal: function(c) {
                return '"' + i(c.text) + '"';
            },
            class: function(c) {
                var u1 = "", h;
                for(h = 0; h < c.parts.length; h++)u1 += c.parts[h] instanceof Array ? s1(c.parts[h][0]) + "-" + s1(c.parts[h][1]) : s1(c.parts[h]);
                return "[" + (c.inverted ? "^" : "") + u1 + "]";
            },
            any: function(c) {
                return "any character";
            },
            end: function(c) {
                return "end of input";
            },
            other: function(c) {
                return c.description;
            }
        };
        function r(c) {
            return c.charCodeAt(0).toString(16).toUpperCase();
        }
        function i(c) {
            return c.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(u1) {
                return "\\x0" + r(u1);
            }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(u1) {
                return "\\x" + r(u1);
            });
        }
        function s1(c) {
            return c.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(u1) {
                return "\\x0" + r(u1);
            }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(u1) {
                return "\\x" + r(u1);
            });
        }
        function o(c) {
            return e[c.type](c);
        }
        function a(c) {
            var u1 = new Array(c.length), h, d;
            for(h = 0; h < c.length; h++)u1[h] = o(c[h]);
            if (u1.sort(), u1.length > 0) {
                for(h = 1, d = 1; h < u1.length; h++)u1[h - 1] !== u1[h] && (u1[d] = u1[h], d++);
                u1.length = d;
            }
            switch(u1.length){
                case 1:
                    return u1[0];
                case 2:
                    return u1[0] + " or " + u1[1];
                default:
                    return u1.slice(0, -1).join(", ") + ", or " + u1[u1.length - 1];
            }
        }
        function l(c) {
            return c ? '"' + i(c) + '"' : "end of input";
        }
        return "Expected " + a(n1) + " but " + l(t) + " found.";
    };
    function ree(n1, t) {
        t = t !== void 0 ? t : {};
        var e = {}, r = {
            svg_path: qe
        }, i = qe, s1 = function(D) {
            if (!D) return [];
            for(var R = [], Y = 0; Y < D.length; Y++)R = R.concat.apply(R, D[Y]);
            var k = R[0];
            return k && k.code == "m" && (delete k.relative, k.code = "M"), R;
        }, o = function(D, R) {
            return Ci(D, R);
        }, a = /^[Mm]/, l = Be([
            "M",
            "m"
        ], !1, !1), c = function(D, R, Y) {
            var k = mi(D, [
                R
            ]);
            return Y && (k = k.concat(mi(D == "M" ? "L" : "l", Y[1]))), k;
        }, u1 = /^[Zz]/, h = Be([
            "Z",
            "z"
        ], !1, !1), d = function() {
            return mi("Z");
        }, f = /^[Ll]/, m = Be([
            "L",
            "l"
        ], !1, !1), p = function(D, R) {
            return mi(D, R);
        }, g = /^[Hh]/, y = Be([
            "H",
            "h"
        ], !1, !1), x = function(D, R) {
            return mi(D, R.map(function(Y) {
                return {
                    x: Y
                };
            }));
        }, v = /^[Vv]/, b = Be([
            "V",
            "v"
        ], !1, !1), w = function(D, R) {
            return mi(D, R.map(function(Y) {
                return {
                    y: Y
                };
            }));
        }, A = /^[Cc]/, T = Be([
            "C",
            "c"
        ], !1, !1), S = function(D, R, Y) {
            return {
                x1: D.x,
                y1: D.y,
                x2: R.x,
                y2: R.y,
                x: Y.x,
                y: Y.y
            };
        }, M = /^[Ss]/, C = Be([
            "S",
            "s"
        ], !1, !1), P = function(D, R) {
            return {
                x2: D.x,
                y2: D.y,
                x: R.x,
                y: R.y
            };
        }, _ = /^[Qq]/, I = Be([
            "Q",
            "q"
        ], !1, !1), O = function(D, R) {
            return {
                x1: D.x,
                y1: D.y,
                x: R.x,
                y: R.y
            };
        }, L = /^[Tt]/, j = Be([
            "T",
            "t"
        ], !1, !1), V = /^[Aa]/, H = Be([
            "A",
            "a"
        ], !1, !1), q = function(D, R, Y, k, ee, _e) {
            return {
                rx: D,
                ry: R,
                xAxisRotation: Y,
                largeArc: k,
                sweep: ee,
                x: _e.x,
                y: _e.y
            };
        }, X = function(D, R) {
            return {
                x: D,
                y: R
            };
        }, K = function(D) {
            return D * 1;
        }, z = function(D) {
            return D.join("") * 1;
        }, Q = /^[01]/, te = Be([
            "0",
            "1"
        ], !1, !1), $ = function(D) {
            return D == "1";
        }, W = function() {
            return "";
        }, oe = ",", ie = We(",", !1), re = function(D) {
            return D.join("");
        }, J = ".", Ee = We(".", !1), xe = /^[eE]/, de = Be([
            "e",
            "E"
        ], !1, !1), De = /^[+\-]/, Pe = Be([
            "+",
            "-"
        ], !1, !1), ze = /^[0-9]/, ke = Be([
            [
                "0",
                "9"
            ]
        ], !1, !1), Ue = function(D) {
            return D.join("");
        }, Le = /^[ \t\n\r]/, Qe = Be([
            " ",
            "	",
            `
`,
            "\r"
        ], !1, !1), F = 0, B = 0, N = [
            {
                line: 1,
                column: 1
            }
        ], ae = 0, ye = [], me = 0, Ne;
        if ("startRule" in t) {
            if (!(t.startRule in r)) throw new Error(`Can't start parsing from rule "` + t.startRule + '".');
            i = r[t.startRule];
        }
        function Fe() {
            return n1.substring(B, F);
        }
        function Oe() {
            return Ir(B, F);
        }
        function pe(D, R) {
            throw R = R !== void 0 ? R : Ir(B, F), Me([
                Gt(D)
            ], n1.substring(B, F), R);
        }
        function nt(D, R) {
            throw R = R !== void 0 ? R : Ir(B, F), ve(D, R);
        }
        function We(D, R) {
            return {
                type: "literal",
                text: D,
                ignoreCase: R
            };
        }
        function Be(D, R, Y) {
            return {
                type: "class",
                parts: D,
                inverted: R,
                ignoreCase: Y
            };
        }
        function tt() {
            return {
                type: "any"
            };
        }
        function ot() {
            return {
                type: "end"
            };
        }
        function Gt(D) {
            return {
                type: "other",
                description: D
            };
        }
        function xr(D) {
            var R = N[D], Y;
            if (R) return R;
            for(Y = D - 1; !N[Y];)Y--;
            for(R = N[Y], R = {
                line: R.line,
                column: R.column
            }; Y < D;)n1.charCodeAt(Y) === 10 ? (R.line++, R.column = 1) : R.column++, Y++;
            return N[D] = R, R;
        }
        function Ir(D, R) {
            var Y = xr(D), k = xr(R);
            return {
                start: {
                    offset: D,
                    line: Y.line,
                    column: Y.column
                },
                end: {
                    offset: R,
                    line: k.line,
                    column: k.column
                }
            };
        }
        function Z(D) {
            F < ae || (F > ae && (ae = F, ye = []), ye.push(D));
        }
        function ve(D, R) {
            return new Au(D, null, null, R);
        }
        function Me(D, R, Y) {
            return new Au(Au.buildMessage(D, R), D, R, Y);
        }
        function qe() {
            var D, R, Y, k, ee;
            for(D = F, R = [], Y = It(); Y !== e;)R.push(Y), Y = It();
            if (R !== e) {
                if (Y = Xe(), Y === e && (Y = null), Y !== e) {
                    for(k = [], ee = It(); ee !== e;)k.push(ee), ee = It();
                    k !== e ? (B = D, R = s1(Y), D = R) : (F = D, D = e);
                } else F = D, D = e;
            } else F = D, D = e;
            return D;
        }
        function Xe() {
            var D, R, Y, k, ee, _e;
            if (D = F, R = Rt(), R !== e) {
                for(Y = [], k = F, ee = [], _e = It(); _e !== e;)ee.push(_e), _e = It();
                for(ee !== e ? (_e = Rt(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e); k !== e;){
                    for(Y.push(k), k = F, ee = [], _e = It(); _e !== e;)ee.push(_e), _e = It();
                    ee !== e ? (_e = Rt(), _e !== e ? (ee = [
                        ee,
                        _e
                    ], k = ee) : (F = k, k = e)) : (F = k, k = e);
                }
                Y !== e ? (B = D, R = o(R, Y), D = R) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function Rt() {
            var D, R, Y, k, ee, _e;
            if (D = F, R = Wr(), R !== e) {
                for(Y = [], k = F, ee = [], _e = It(); _e !== e;)ee.push(_e), _e = It();
                for(ee !== e ? (_e = Hr(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e); k !== e;){
                    for(Y.push(k), k = F, ee = [], _e = It(); _e !== e;)ee.push(_e), _e = It();
                    ee !== e ? (_e = Hr(), _e !== e ? (ee = [
                        ee,
                        _e
                    ], k = ee) : (F = k, k = e)) : (F = k, k = e);
                }
                Y !== e ? (B = D, R = o(R, Y), D = R) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function Hr() {
            var D;
            return D = va(), D === e && (D = Dr(), D === e && (D = Rn(), D === e && (D = J1(), D === e && (D = $1(), D === e && (D = le(), D === e && (D = be(), D === e && (D = St(), D === e && (D = jt())))))))), D;
        }
        function Wr() {
            var D, R, Y, k, ee, _e, Ru;
            if (D = F, a.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && Z(l)), R !== e) {
                for(Y = [], k = It(); k !== e;)Y.push(k), k = It();
                Y !== e ? (k = Nt(), k !== e ? (ee = F, _e = xt(), _e === e && (_e = null), _e !== e ? (Ru = us(), Ru !== e ? (_e = [
                    _e,
                    Ru
                ], ee = _e) : (F = ee, ee = e)) : (F = ee, ee = e), ee === e && (ee = null), ee !== e ? (B = D, R = c(R, k, ee), D = R) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function va() {
            var D, R;
            return D = F, u1.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && Z(h)), R !== e && (B = D, R = d()), D = R, D;
        }
        function Dr() {
            var D, R, Y, k;
            if (D = F, f.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && Z(m)), R !== e) {
                for(Y = [], k = It(); k !== e;)Y.push(k), k = It();
                Y !== e ? (k = us(), k !== e ? (B = D, R = p(R, k), D = R) : (F = D, D = e)) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function us() {
            var D, R, Y, k, ee, _e;
            if (D = F, R = Nt(), R !== e) {
                for(Y = [], k = F, ee = xt(), ee === e && (ee = null), ee !== e ? (_e = Nt(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e); k !== e;)Y.push(k), k = F, ee = xt(), ee === e && (ee = null), ee !== e ? (_e = Nt(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e);
                Y !== e ? (B = D, R = o(R, Y), D = R) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function Rn() {
            var D, R, Y, k;
            if (D = F, g.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && Z(y)), R !== e) {
                for(Y = [], k = It(); k !== e;)Y.push(k), k = It();
                Y !== e ? (k = vp(), k !== e ? (B = D, R = x(R, k), D = R) : (F = D, D = e)) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function vp() {
            var D, R, Y, k, ee, _e;
            if (D = F, R = an(), R !== e) {
                for(Y = [], k = F, ee = xt(), ee === e && (ee = null), ee !== e ? (_e = an(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e); k !== e;)Y.push(k), k = F, ee = xt(), ee === e && (ee = null), ee !== e ? (_e = an(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e);
                Y !== e ? (B = D, R = o(R, Y), D = R) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function J1() {
            var D, R, Y, k;
            if (D = F, v.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && Z(b)), R !== e) {
                for(Y = [], k = It(); k !== e;)Y.push(k), k = It();
                Y !== e ? (k = vp(), k !== e ? (B = D, R = w(R, k), D = R) : (F = D, D = e)) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function $1() {
            var D, R, Y, k;
            if (D = F, A.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && Z(T)), R !== e) {
                for(Y = [], k = It(); k !== e;)Y.push(k), k = It();
                Y !== e ? (k = eS(), k !== e ? (B = D, R = p(R, k), D = R) : (F = D, D = e)) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function eS() {
            var D, R, Y, k, ee, _e;
            if (D = F, R = G(), R !== e) {
                for(Y = [], k = F, ee = xt(), ee === e && (ee = null), ee !== e ? (_e = G(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e); k !== e;)Y.push(k), k = F, ee = xt(), ee === e && (ee = null), ee !== e ? (_e = G(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e);
                Y !== e ? (B = D, R = o(R, Y), D = R) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function G() {
            var D, R, Y, k, ee, _e;
            return D = F, R = Nt(), R !== e ? (Y = xt(), Y === e && (Y = null), Y !== e ? (k = Nt(), k !== e ? (ee = xt(), ee === e && (ee = null), ee !== e ? (_e = Nt(), _e !== e ? (B = D, R = S(R, k, _e), D = R) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e), D;
        }
        function le() {
            var D, R, Y, k;
            if (D = F, M.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && Z(C)), R !== e) {
                for(Y = [], k = It(); k !== e;)Y.push(k), k = It();
                Y !== e ? (k = ge(), k !== e ? (B = D, R = p(R, k), D = R) : (F = D, D = e)) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function ge() {
            var D, R, Y, k, ee, _e;
            if (D = F, R = ne(), R !== e) {
                for(Y = [], k = F, ee = xt(), ee === e && (ee = null), ee !== e ? (_e = ne(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e); k !== e;)Y.push(k), k = F, ee = xt(), ee === e && (ee = null), ee !== e ? (_e = ne(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e);
                Y !== e ? (B = D, R = o(R, Y), D = R) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function ne() {
            var D, R, Y, k;
            return D = F, R = Nt(), R !== e ? (Y = xt(), Y === e && (Y = null), Y !== e ? (k = Nt(), k !== e ? (B = D, R = P(R, k), D = R) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e), D;
        }
        function be() {
            var D, R, Y, k;
            if (D = F, _.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && Z(I)), R !== e) {
                for(Y = [], k = It(); k !== e;)Y.push(k), k = It();
                Y !== e ? (k = st(), k !== e ? (B = D, R = p(R, k), D = R) : (F = D, D = e)) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function st() {
            var D, R, Y, k, ee, _e;
            if (D = F, R = pt(), R !== e) {
                for(Y = [], k = F, ee = xt(), ee === e && (ee = null), ee !== e ? (_e = pt(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e); k !== e;)Y.push(k), k = F, ee = xt(), ee === e && (ee = null), ee !== e ? (_e = pt(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e);
                Y !== e ? (B = D, R = o(R, Y), D = R) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function pt() {
            var D, R, Y, k;
            return D = F, R = Nt(), R !== e ? (Y = xt(), Y === e && (Y = null), Y !== e ? (k = Nt(), k !== e ? (B = D, R = O(R, k), D = R) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e), D;
        }
        function St() {
            var D, R, Y, k;
            if (D = F, L.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && Z(j)), R !== e) {
                for(Y = [], k = It(); k !== e;)Y.push(k), k = It();
                Y !== e ? (k = Et(), k !== e ? (B = D, R = p(R, k), D = R) : (F = D, D = e)) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function Et() {
            var D, R, Y, k, ee, _e;
            if (D = F, R = Nt(), R !== e) {
                for(Y = [], k = F, ee = xt(), ee === e && (ee = null), ee !== e ? (_e = Nt(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e); k !== e;)Y.push(k), k = F, ee = xt(), ee === e && (ee = null), ee !== e ? (_e = Nt(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e);
                Y !== e ? (B = D, R = o(R, Y), D = R) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function jt() {
            var D, R, Y, k;
            if (D = F, V.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && Z(H)), R !== e) {
                for(Y = [], k = It(); k !== e;)Y.push(k), k = It();
                Y !== e ? (k = Lt(), k !== e ? (B = D, R = p(R, k), D = R) : (F = D, D = e)) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function Lt() {
            var D, R, Y, k, ee, _e;
            if (D = F, R = Tt(), R !== e) {
                for(Y = [], k = F, ee = xt(), ee === e && (ee = null), ee !== e ? (_e = Tt(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e); k !== e;)Y.push(k), k = F, ee = xt(), ee === e && (ee = null), ee !== e ? (_e = Tt(), _e !== e ? (ee = [
                    ee,
                    _e
                ], k = ee) : (F = k, k = e)) : (F = k, k = e);
                Y !== e ? (B = D, R = o(R, Y), D = R) : (F = D, D = e);
            } else F = D, D = e;
            return D;
        }
        function Tt() {
            var D, R, Y, k, ee, _e, Ru, tS, ty, rS, ry, iS;
            return D = F, R = Mi(), R !== e ? (Y = xt(), Y === e && (Y = null), Y !== e ? (k = Mi(), k !== e ? (ee = xt(), ee === e && (ee = null), ee !== e ? (_e = an(), _e !== e ? (Ru = xt(), Ru !== e ? (tS = So(), tS !== e ? (ty = xt(), ty === e && (ty = null), ty !== e ? (rS = So(), rS !== e ? (ry = xt(), ry === e && (ry = null), ry !== e ? (iS = Nt(), iS !== e ? (B = D, R = q(R, k, _e, tS, rS, iS), D = R) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e), D;
        }
        function Nt() {
            var D, R, Y, k;
            return D = F, R = an(), R !== e ? (Y = xt(), Y === e && (Y = null), Y !== e ? (k = an(), k !== e ? (B = D, R = X(R, k), D = R) : (F = D, D = e)) : (F = D, D = e)) : (F = D, D = e), D;
        }
        function Mi() {
            var D, R;
            return D = F, R = Iu(), R === e && (R = Kn()), R !== e && (B = D, R = K(R)), D = R, D;
        }
        function an() {
            var D, R, Y, k;
            return D = F, R = F, Y = Du(), Y === e && (Y = null), Y !== e ? (k = Iu(), k !== e ? (Y = [
                Y,
                k
            ], R = Y) : (F = R, R = e)) : (F = R, R = e), R === e && (R = F, Y = Du(), Y === e && (Y = null), Y !== e ? (k = Kn(), k !== e ? (Y = [
                Y,
                k
            ], R = Y) : (F = R, R = e)) : (F = R, R = e)), R !== e && (B = D, R = z(R)), D = R, D;
        }
        function So() {
            var D, R;
            return D = F, Q.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && Z(te)), R !== e && (B = D, R = $(R)), D = R, D;
        }
        function xt() {
            var D, R, Y, k, ee;
            if (D = F, R = [], Y = It(), Y !== e) for(; Y !== e;)R.push(Y), Y = It();
            else R = e;
            if (R !== e) {
                if (Y = Vt(), Y === e && (Y = null), Y !== e) {
                    for(k = [], ee = It(); ee !== e;)k.push(ee), ee = It();
                    k !== e ? (R = [
                        R,
                        Y,
                        k
                    ], D = R) : (F = D, D = e);
                } else F = D, D = e;
            } else F = D, D = e;
            if (D === e) {
                if (D = F, R = F, Y = Vt(), Y !== e) {
                    for(k = [], ee = It(); ee !== e;)k.push(ee), ee = It();
                    k !== e ? (Y = [
                        Y,
                        k
                    ], R = Y) : (F = R, R = e);
                } else F = R, R = e;
                R !== e && (B = D, R = W()), D = R;
            }
            return D;
        }
        function Vt() {
            var D;
            return n1.charCodeAt(F) === 44 ? (D = oe, F++) : (D = e, me === 0 && Z(ie)), D;
        }
        function Iu() {
            var D, R, Y, k;
            return D = F, R = F, Y = pi(), Y !== e ? (k = wo(), k === e && (k = null), k !== e ? (Y = [
                Y,
                k
            ], R = Y) : (F = R, R = e)) : (F = R, R = e), R === e && (R = F, Y = Kn(), Y !== e ? (k = wo(), k !== e ? (Y = [
                Y,
                k
            ], R = Y) : (F = R, R = e)) : (F = R, R = e)), R !== e && (B = D, R = re(R)), D = R, D;
        }
        function pi() {
            var D, R, Y, k, ee;
            return D = F, R = F, Y = Kn(), Y === e && (Y = null), Y !== e ? (n1.charCodeAt(F) === 46 ? (k = J, F++) : (k = e, me === 0 && Z(Ee)), k !== e ? (ee = Kn(), ee !== e ? (Y = [
                Y,
                k,
                ee
            ], R = Y) : (F = R, R = e)) : (F = R, R = e)) : (F = R, R = e), R === e && (R = F, Y = Kn(), Y !== e ? (n1.charCodeAt(F) === 46 ? (k = J, F++) : (k = e, me === 0 && Z(Ee)), k !== e ? (Y = [
                Y,
                k
            ], R = Y) : (F = R, R = e)) : (F = R, R = e)), R !== e && (B = D, R = re(R)), D = R, D;
        }
        function wo() {
            var D, R, Y, k, ee;
            return D = F, R = F, xe.test(n1.charAt(F)) ? (Y = n1.charAt(F), F++) : (Y = e, me === 0 && Z(de)), Y !== e ? (k = Du(), k === e && (k = null), k !== e ? (ee = Kn(), ee !== e ? (Y = [
                Y,
                k,
                ee
            ], R = Y) : (F = R, R = e)) : (F = R, R = e)) : (F = R, R = e), R !== e && (B = D, R = re(R)), D = R, D;
        }
        function Du() {
            var D;
            return De.test(n1.charAt(F)) ? (D = n1.charAt(F), F++) : (D = e, me === 0 && Z(Pe)), D;
        }
        function Kn() {
            var D, R, Y;
            if (D = F, R = [], ze.test(n1.charAt(F)) ? (Y = n1.charAt(F), F++) : (Y = e, me === 0 && Z(ke)), Y !== e) for(; Y !== e;)R.push(Y), ze.test(n1.charAt(F)) ? (Y = n1.charAt(F), F++) : (Y = e, me === 0 && Z(ke));
            else R = e;
            return R !== e && (B = D, R = Ue(R)), D = R, D;
        }
        function It() {
            var D, R;
            return D = F, Le.test(n1.charAt(F)) ? (R = n1.charAt(F), F++) : (R = e, me === 0 && Z(Qe)), R !== e && (B = D, R = W()), D = R, D;
        }
        function Ci(D, R) {
            if (!R) return [
                D
            ];
            for(var Y = [
                D
            ], k = 0, ee = R.length; k < ee; k++)Y[k + 1] = R[k][1];
            return Y;
        }
        var hs = {
            m: "moveto",
            l: "lineto",
            h: "horizontal lineto",
            v: "vertical lineto",
            c: "curveto",
            s: "smooth curveto",
            q: "quadratic curveto",
            t: "smooth quadratic curveto",
            a: "elliptical arc",
            z: "closepath"
        };
        for(var Ou in hs)hs[Ou.toUpperCase()] = hs[Ou];
        function mi(D, R) {
            R || (R = [
                {}
            ]);
            for(var Y = R.length; Y--;){
                var k = {
                    code: D,
                    command: hs[D]
                };
                D == D.toLowerCase() && (k.relative = !0);
                for(var ee in R[Y])k[ee] = R[Y][ee];
                R[Y] = k;
            }
            return R;
        }
        if (Ne = i(), Ne !== e && F === n1.length) return Ne;
        throw Ne !== e && F < n1.length && Z(ot()), Me(ye, ae < n1.length ? n1.charAt(ae) : null, ae < n1.length ? Ir(ae, ae + 1) : Ir(ae, ae));
    }
    CB.exports = {
        SyntaxError: Au,
        parse: ree
    };
});
var uM = Cc((Hke, _B)=>{
    var zb = PB().parse;
    zb.parseSVG = zb;
    zb.makeAbsolute = iee;
    _B.exports = zb;
    function iee(n1) {
        var t, e = {
            x: 0,
            y: 0
        }, r = {
            x: "x0",
            y: "y0",
            x1: "x0",
            y1: "y0",
            x2: "x0",
            y2: "y0"
        };
        return n1.forEach(function(i) {
            i.command === "moveto" && (t = i), i.x0 = e.x, i.y0 = e.y;
            for(var s1 in r)s1 in i && (i[s1] += i.relative ? i[r[s1]] : 0);
            "x" in i || (i.x = e.x), "y" in i || (i.y = e.y), i.relative = !1, i.code = i.code.toUpperCase(), i.command == "closepath" && (i.x = t.x, i.y = t.y), e = i;
        }), n1;
    }
});
var qV = Cc((hZe, WV)=>{
    WV.exports = function(t, e) {
        for(var r = t.split("."), i = e.split("."), s1 = 0; s1 < 3; s1++){
            var o = Number(r[s1]), a = Number(i[s1]);
            if (o > a) return 1;
            if (a > o) return -1;
            if (!isNaN(o) && isNaN(a)) return 1;
            if (isNaN(o) && !isNaN(a)) return -1;
        }
        return 0;
    };
});
var Pa = "149";
var ts = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
}, oU = 0, EC = 1, aU = 2;
var cv = 1, lU = 2, Pp = 3, Jn = 0, xi = 1, vi = 2;
var or = 0, ml = 1, TC = 2, MC = 3, CC = 4, cU = 5, Yu = 100, uU = 101, hU = 102, PC = 103, _C = 104, dU = 200, fU = 201, pU = 202, mU = 203, t_ = 204, r_ = 205, gU = 206, yU = 207, vU = 208, xU = 209, bU = 210, SU = 0, wU = 1, AU = 2, zS = 3, EU = 4, TU = 5, MU = 6, CU = 7, i_ = 0, PU = 1, _U = 2, js = 0, IU = 1, DU = 2, OU = 3, RU = 4, LU = 5, n_ = 300, yl = 301, vl = 302, GS = 303, jS = 304, xh = 306, Hs = 1e3, tr = 1001, HS = 1002, vt = 1003, IC = 1004;
var nS = 1005;
var it = 1006, NU = 1007;
var Bc = 1008;
var Nr = 1009, BU = 1010, FU = 1011, s_ = 1012, VU = 1013, Gs = 1014, Ut = 1015, $n = 1016, UU = 1017, kU = 1018, gl = 1020, zU = 1021, br = 1023, GU = 1024, jU = 1025, Lc = 1026, xl = 1027, Zp = 1028, HU = 1029, bh = 1030, WU = 1031, Aw = 1033, sS = 33776, oS = 33777, aS = 33778, lS = 33779, DC = 35840, OC = 35841, RC = 35842, LC = 35843, qU = 36196, NC = 37492, BC = 37496, FC = 37808, VC = 37809, UC = 37810, kC = 37811, zC = 37812, GC = 37813, jC = 37814, HC = 37815, WC = 37816, qC = 37817, XC = 37818, YC = 37819, KC = 37820, QC = 37821, cS = 36492, XU = 36283, ZC = 36284, JC = 36285, $C = 36286, Ew = 2200, Tw = 2201, Jp = 2202, Ry = 2300, Ly = 2301, uS = 2302, Ku = 2400, Qu = 2401, Ny = 2402, Mw = 2500, YU = 2501;
var xn = 3e3, ut = 3001, zi = 3200, Cw = 3201, KU = 0, QU = 1;
var Ao = "srgb", Np = "srgb-linear";
var hS = 7680;
var ZU = 519, WS = 35044, o_ = 35048;
var By = "300 es", qS = 1035, ar = class {
    addEventListener(t, e) {
        this._listeners === void 0 && (this._listeners = {});
        let r = this._listeners;
        r[t] === void 0 && (r[t] = []), r[t].indexOf(e) === -1 && r[t].push(e);
    }
    hasEventListener(t, e) {
        if (this._listeners === void 0) return !1;
        let r = this._listeners;
        return r[t] !== void 0 && r[t].indexOf(e) !== -1;
    }
    removeEventListener(t, e) {
        if (this._listeners === void 0) return;
        let i = this._listeners[t];
        if (i !== void 0) {
            let s1 = i.indexOf(e);
            s1 !== -1 && i.splice(s1, 1);
        }
    }
    dispatchEvent(t) {
        if (this._listeners === void 0) return;
        let r = this._listeners[t.type];
        if (r !== void 0) {
            t.target = this;
            let i = r.slice(0);
            for(let s1 = 0, o = i.length; s1 < o; s1++)i[s1].call(this, t);
            t.target = null;
        }
    }
}, ln = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
], eP = 1234567, Ip = Math.PI / 180, Bp = 180 / Math.PI;
function fs() {
    let n1 = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, r = Math.random() * 4294967295 | 0;
    return (ln[n1 & 255] + ln[n1 >> 8 & 255] + ln[n1 >> 16 & 255] + ln[n1 >> 24 & 255] + "-" + ln[t & 255] + ln[t >> 8 & 255] + "-" + ln[t >> 16 & 15 | 64] + ln[t >> 24 & 255] + "-" + ln[e & 63 | 128] + ln[e >> 8 & 255] + "-" + ln[e >> 16 & 255] + ln[e >> 24 & 255] + ln[r & 255] + ln[r >> 8 & 255] + ln[r >> 16 & 255] + ln[r >> 24 & 255]).toLowerCase();
}
function yi(n1, t, e) {
    return Math.max(t, Math.min(e, n1));
}
function Pw(n1, t) {
    return (n1 % t + t) % t;
}
function JU(n1, t, e, r, i) {
    return r + (n1 - t) * (i - r) / (e - t);
}
function $U(n1, t, e) {
    return n1 !== t ? (e - n1) / (t - n1) : 0;
}
function Dp(n1, t, e) {
    return (1 - e) * n1 + e * t;
}
function ek(n1, t, e, r) {
    return Dp(n1, t, 1 - Math.exp(-e * r));
}
function tk(n1, t = 1) {
    return t - Math.abs(Pw(n1, t * 2) - t);
}
function rk(n1, t, e) {
    return n1 <= t ? 0 : n1 >= e ? 1 : (n1 = (n1 - t) / (e - t), n1 * n1 * (3 - 2 * n1));
}
function ik(n1, t, e) {
    return n1 <= t ? 0 : n1 >= e ? 1 : (n1 = (n1 - t) / (e - t), n1 * n1 * n1 * (n1 * (n1 * 6 - 15) + 10));
}
function nk(n1, t) {
    return n1 + Math.floor(Math.random() * (t - n1 + 1));
}
function sk(n1, t) {
    return n1 + Math.random() * (t - n1);
}
function ok(n1) {
    return n1 * (.5 - Math.random());
}
function ak(n1) {
    n1 !== void 0 && (eP = n1);
    let t = eP += 1831565813;
    return t = Math.imul(t ^ t >>> 15, t | 1), t ^= t + Math.imul(t ^ t >>> 7, t | 61), ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function lk(n1) {
    return n1 * Ip;
}
function ck(n1) {
    return n1 * Bp;
}
function XS(n1) {
    return (n1 & n1 - 1) === 0 && n1 !== 0;
}
function a_(n1) {
    return Math.pow(2, Math.ceil(Math.log(n1) / Math.LN2));
}
function Fy(n1) {
    return Math.pow(2, Math.floor(Math.log(n1) / Math.LN2));
}
function uk(n1, t, e, r, i) {
    let s1 = Math.cos, o = Math.sin, a = s1(e / 2), l = o(e / 2), c = s1((t + r) / 2), u1 = o((t + r) / 2), h = s1((t - r) / 2), d = o((t - r) / 2), f = s1((r - t) / 2), m = o((r - t) / 2);
    switch(i){
        case "XYX":
            n1.set(a * u1, l * h, l * d, a * c);
            break;
        case "YZY":
            n1.set(l * d, a * u1, l * h, a * c);
            break;
        case "ZXZ":
            n1.set(l * h, l * d, a * u1, a * c);
            break;
        case "XZX":
            n1.set(a * u1, l * m, l * f, a * c);
            break;
        case "YXY":
            n1.set(l * f, a * u1, l * m, a * c);
            break;
        case "ZYZ":
            n1.set(l * m, l * f, a * u1, a * c);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + i);
    }
}
function Ma(n1, t) {
    switch(t.constructor){
        case Float32Array:
            return n1;
        case Uint16Array:
            return n1 / 65535;
        case Uint8Array:
            return n1 / 255;
        case Int16Array:
            return Math.max(n1 / 32767, -1);
        case Int8Array:
            return Math.max(n1 / 127, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function Ar(n1, t) {
    switch(t.constructor){
        case Float32Array:
            return n1;
        case Uint16Array:
            return Math.round(n1 * 65535);
        case Uint8Array:
            return Math.round(n1 * 255);
        case Int16Array:
            return Math.round(n1 * 32767);
        case Int8Array:
            return Math.round(n1 * 127);
        default:
            throw new Error("Invalid component type.");
    }
}
var Se = Object.freeze({
    __proto__: null,
    DEG2RAD: Ip,
    RAD2DEG: Bp,
    ceilPowerOfTwo: a_,
    clamp: yi,
    damp: ek,
    degToRad: lk,
    denormalize: Ma,
    euclideanModulo: Pw,
    floorPowerOfTwo: Fy,
    generateUUID: fs,
    inverseLerp: $U,
    isPowerOfTwo: XS,
    lerp: Dp,
    mapLinear: JU,
    normalize: Ar,
    pingpong: tk,
    radToDeg: ck,
    randFloat: sk,
    randFloatSpread: ok,
    randInt: nk,
    seededRandom: ak,
    setQuaternionFromProperEuler: uk,
    smootherstep: ik,
    smoothstep: rk
}), U = class {
    constructor(t = 0, e = 0){
        U.prototype.isVector2 = !0, this.x = t, this.y = e;
    }
    get width() {
        return this.x;
    }
    set width(t) {
        this.x = t;
    }
    get height() {
        return this.y;
    }
    set height(t) {
        this.y = t;
    }
    set(t, e) {
        return this.x = t, this.y = e, this;
    }
    setScalar(t) {
        return this.x = t, this.y = t, this;
    }
    setX(t) {
        return this.x = t, this;
    }
    setY(t) {
        return this.y = t, this;
    }
    setComponent(t, e) {
        switch(t){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            default:
                throw new Error("index is out of range: " + t);
        }
        return this;
    }
    getComponent(t) {
        switch(t){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + t);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(t) {
        return this.x = t.x, this.y = t.y, this;
    }
    add(t) {
        return this.x += t.x, this.y += t.y, this;
    }
    addScalar(t) {
        return this.x += t, this.y += t, this;
    }
    addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this;
    }
    addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this;
    }
    sub(t) {
        return this.x -= t.x, this.y -= t.y, this;
    }
    subScalar(t) {
        return this.x -= t, this.y -= t, this;
    }
    subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this;
    }
    multiply(t) {
        return this.x *= t.x, this.y *= t.y, this;
    }
    multiplyScalar(t) {
        return this.x *= t, this.y *= t, this;
    }
    divide(t) {
        return this.x /= t.x, this.y /= t.y, this;
    }
    divideScalar(t) {
        return this.multiplyScalar(1 / t);
    }
    applyMatrix3(t) {
        let e = this.x, r = this.y, i = t.elements;
        return this.x = i[0] * e + i[3] * r + i[6], this.y = i[1] * e + i[4] * r + i[7], this;
    }
    min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this;
    }
    max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this;
    }
    clamp(t, e) {
        return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this;
    }
    clampScalar(t, e) {
        return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this;
    }
    clampLength(t, e) {
        let r = this.length();
        return this.divideScalar(r || 1).multiplyScalar(Math.max(t, Math.min(e, r)));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }
    roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this;
    }
    dot(t) {
        return this.x * t.x + this.y * t.y;
    }
    cross(t) {
        return this.x * t.y - this.y * t.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        return Math.atan2(-this.y, -this.x) + Math.PI;
    }
    distanceTo(t) {
        return Math.sqrt(this.distanceToSquared(t));
    }
    distanceToSquared(t) {
        let e = this.x - t.x, r = this.y - t.y;
        return e * e + r * r;
    }
    manhattanDistanceTo(t) {
        return Math.abs(this.x - t.x) + Math.abs(this.y - t.y);
    }
    setLength(t) {
        return this.normalize().multiplyScalar(t);
    }
    lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this;
    }
    lerpVectors(t, e, r) {
        return this.x = t.x + (e.x - t.x) * r, this.y = t.y + (e.y - t.y) * r, this;
    }
    equals(t) {
        return t.x === this.x && t.y === this.y;
    }
    fromArray(t, e = 0) {
        return this.x = t[e], this.y = t[e + 1], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.x, t[e + 1] = this.y, t;
    }
    fromBufferAttribute(t, e) {
        return this.x = t.getX(e), this.y = t.getY(e), this;
    }
    rotateAround(t, e) {
        let r = Math.cos(e), i = Math.sin(e), s1 = this.x - t.x, o = this.y - t.y;
        return this.x = s1 * r - o * i + t.x, this.y = s1 * i + o * r + t.y, this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y;
    }
}, Sr = class {
    constructor(){
        Sr.prototype.isMatrix3 = !0, this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
    }
    set(t, e, r, i, s1, o, a, l, c) {
        let u1 = this.elements;
        return u1[0] = t, u1[1] = i, u1[2] = a, u1[3] = e, u1[4] = s1, u1[5] = l, u1[6] = r, u1[7] = o, u1[8] = c, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
    }
    copy(t) {
        let e = this.elements, r = t.elements;
        return e[0] = r[0], e[1] = r[1], e[2] = r[2], e[3] = r[3], e[4] = r[4], e[5] = r[5], e[6] = r[6], e[7] = r[7], e[8] = r[8], this;
    }
    extractBasis(t, e, r) {
        return t.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), r.setFromMatrix3Column(this, 2), this;
    }
    setFromMatrix4(t) {
        let e = t.elements;
        return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
    }
    multiply(t) {
        return this.multiplyMatrices(this, t);
    }
    premultiply(t) {
        return this.multiplyMatrices(t, this);
    }
    multiplyMatrices(t, e) {
        let r = t.elements, i = e.elements, s1 = this.elements, o = r[0], a = r[3], l = r[6], c = r[1], u1 = r[4], h = r[7], d = r[2], f = r[5], m = r[8], p = i[0], g = i[3], y = i[6], x = i[1], v = i[4], b = i[7], w = i[2], A = i[5], T = i[8];
        return s1[0] = o * p + a * x + l * w, s1[3] = o * g + a * v + l * A, s1[6] = o * y + a * b + l * T, s1[1] = c * p + u1 * x + h * w, s1[4] = c * g + u1 * v + h * A, s1[7] = c * y + u1 * b + h * T, s1[2] = d * p + f * x + m * w, s1[5] = d * g + f * v + m * A, s1[8] = d * y + f * b + m * T, this;
    }
    multiplyScalar(t) {
        let e = this.elements;
        return e[0] *= t, e[3] *= t, e[6] *= t, e[1] *= t, e[4] *= t, e[7] *= t, e[2] *= t, e[5] *= t, e[8] *= t, this;
    }
    determinant() {
        let t = this.elements, e = t[0], r = t[1], i = t[2], s1 = t[3], o = t[4], a = t[5], l = t[6], c = t[7], u1 = t[8];
        return e * o * u1 - e * a * c - r * s1 * u1 + r * a * l + i * s1 * c - i * o * l;
    }
    invert() {
        let t = this.elements, e = t[0], r = t[1], i = t[2], s1 = t[3], o = t[4], a = t[5], l = t[6], c = t[7], u1 = t[8], h = u1 * o - a * c, d = a * l - u1 * s1, f = c * s1 - o * l, m = e * h + r * d + i * f;
        if (m === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        let p = 1 / m;
        return t[0] = h * p, t[1] = (i * c - u1 * r) * p, t[2] = (a * r - i * o) * p, t[3] = d * p, t[4] = (u1 * e - i * l) * p, t[5] = (i * s1 - a * e) * p, t[6] = f * p, t[7] = (r * l - c * e) * p, t[8] = (o * e - r * s1) * p, this;
    }
    transpose() {
        let t, e = this.elements;
        return t = e[1], e[1] = e[3], e[3] = t, t = e[2], e[2] = e[6], e[6] = t, t = e[5], e[5] = e[7], e[7] = t, this;
    }
    getNormalMatrix(t) {
        return this.setFromMatrix4(t).invert().transpose();
    }
    transposeIntoArray(t) {
        let e = this.elements;
        return t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8], this;
    }
    setUvTransform(t, e, r, i, s1, o, a) {
        let l = Math.cos(s1), c = Math.sin(s1);
        return this.set(r * l, r * c, -r * (l * o + c * a) + o + t, -i * c, i * l, -i * (-c * o + l * a) + a + e, 0, 0, 1), this;
    }
    scale(t, e) {
        return this.premultiply(dS.makeScale(t, e)), this;
    }
    rotate(t) {
        return this.premultiply(dS.makeRotation(-t)), this;
    }
    translate(t, e) {
        return this.premultiply(dS.makeTranslation(t, e)), this;
    }
    makeTranslation(t, e) {
        return this.set(1, 0, t, 0, 1, e, 0, 0, 1), this;
    }
    makeRotation(t) {
        let e = Math.cos(t), r = Math.sin(t);
        return this.set(e, -r, 0, r, e, 0, 0, 0, 1), this;
    }
    makeScale(t, e) {
        return this.set(t, 0, 0, 0, e, 0, 0, 0, 1), this;
    }
    equals(t) {
        let e = this.elements, r = t.elements;
        for(let i = 0; i < 9; i++)if (e[i] !== r[i]) return !1;
        return !0;
    }
    fromArray(t, e = 0) {
        for(let r = 0; r < 9; r++)this.elements[r] = t[r + e];
        return this;
    }
    toArray(t = [], e = 0) {
        let r = this.elements;
        return t[e] = r[0], t[e + 1] = r[1], t[e + 2] = r[2], t[e + 3] = r[3], t[e + 4] = r[4], t[e + 5] = r[5], t[e + 6] = r[6], t[e + 7] = r[7], t[e + 8] = r[8], t;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}, dS = new Sr;
function l_(n1) {
    for(let t = n1.length - 1; t >= 0; --t)if (n1[t] >= 65535) return !0;
    return !1;
}
var hk = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function ny(n1, t) {
    return new hk[n1](t);
}
function Fp(n1) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", n1);
}
function dk(n1, t, e) {
    return new Promise(function(r, i) {
        function s1() {
            switch(n1.clientWaitSync(t, n1.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case n1.WAIT_FAILED:
                    i();
                    break;
                case n1.TIMEOUT_EXPIRED:
                    setTimeout(s1, e);
                    break;
                default:
                    r();
            }
        }
        setTimeout(s1, e);
    });
}
function Nc(n1) {
    return n1 < .04045 ? n1 * .0773993808 : Math.pow(n1 * .9478672986 + .0521327014, 2.4);
}
function Oy(n1) {
    return n1 < .0031308 ? n1 * 12.92 : 1.055 * Math.pow(n1, .41666) - .055;
}
var fS = {
    [Ao]: {
        [Np]: Nc
    },
    [Np]: {
        [Ao]: Oy
    }
}, gn = {
    legacyMode: !0,
    get workingColorSpace () {
        return Np;
    },
    set workingColorSpace (n){
        console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
    },
    convert: function(n1, t, e) {
        if (this.legacyMode || t === e || !t || !e) return n1;
        if (fS[t] && fS[t][e] !== void 0) {
            let r = fS[t][e];
            return n1.r = r(n1.r), n1.g = r(n1.g), n1.b = r(n1.b), n1;
        }
        throw new Error("Unsupported color space conversion.");
    },
    fromWorkingColorSpace: function(n1, t) {
        return this.convert(n1, this.workingColorSpace, t);
    },
    toWorkingColorSpace: function(n1, t) {
        return this.convert(n1, t, this.workingColorSpace);
    }
}, c_ = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
}, Pi = {
    r: 0,
    g: 0,
    b: 0
}, Us = {
    h: 0,
    s: 0,
    l: 0
}, sy = {
    h: 0,
    s: 0,
    l: 0
};
function pS(n1, t, e) {
    return e < 0 && (e += 1), e > 1 && (e -= 1), e < 1 / 6 ? n1 + (t - n1) * 6 * e : e < 0.5 ? t : e < 2 / 3 ? n1 + (t - n1) * 6 * (2 / 3 - e) : n1;
}
function oy(n1, t) {
    return t.r = n1.r, t.g = n1.g, t.b = n1.b, t;
}
var Ge = class {
    constructor(t, e, r){
        return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, e === void 0 && r === void 0 ? this.set(t) : this.setRGB(t, e, r);
    }
    set(t) {
        return t && t.isColor ? this.copy(t) : typeof t == "number" ? this.setHex(t) : typeof t == "string" && this.setStyle(t), this;
    }
    setScalar(t) {
        return this.r = t, this.g = t, this.b = t, this;
    }
    setHex(t, e = Ao) {
        return t = Math.floor(t), this.r = (t >> 16 & 255) / 255, this.g = (t >> 8 & 255) / 255, this.b = (t & 255) / 255, gn.toWorkingColorSpace(this, e), this;
    }
    setRGB(t, e, r, i = gn.workingColorSpace) {
        return this.r = t, this.g = e, this.b = r, gn.toWorkingColorSpace(this, i), this;
    }
    setHSL(t, e, r, i = gn.workingColorSpace) {
        if (t = Pw(t, 1), e = yi(e, 0, 1), r = yi(r, 0, 1), e === 0) this.r = this.g = this.b = r;
        else {
            let s1 = r <= .5 ? r * (1 + e) : r + e - r * e, o = 2 * r - s1;
            this.r = pS(o, s1, t + 1 / 3), this.g = pS(o, s1, t), this.b = pS(o, s1, t - 1 / 3);
        }
        return gn.toWorkingColorSpace(this, i), this;
    }
    setStyle(t, e = Ao) {
        function r(s1) {
            s1 !== void 0 && parseFloat(s1) < 1 && console.warn("THREE.Color: Alpha component of " + t + " will be ignored.");
        }
        let i;
        if (i = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(t)) {
            let s1, o = i[1], a = i[2];
            switch(o){
                case "rgb":
                case "rgba":
                    if (s1 = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.r = Math.min(255, parseInt(s1[1], 10)) / 255, this.g = Math.min(255, parseInt(s1[2], 10)) / 255, this.b = Math.min(255, parseInt(s1[3], 10)) / 255, gn.toWorkingColorSpace(this, e), r(s1[4]), this;
                    if (s1 = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.r = Math.min(100, parseInt(s1[1], 10)) / 100, this.g = Math.min(100, parseInt(s1[2], 10)) / 100, this.b = Math.min(100, parseInt(s1[3], 10)) / 100, gn.toWorkingColorSpace(this, e), r(s1[4]), this;
                    break;
                case "hsl":
                case "hsla":
                    if (s1 = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) {
                        let l = parseFloat(s1[1]) / 360, c = parseFloat(s1[2]) / 100, u1 = parseFloat(s1[3]) / 100;
                        return r(s1[4]), this.setHSL(l, c, u1, e);
                    }
                    break;
            }
        } else if (i = /^\#([A-Fa-f\d]+)$/.exec(t)) {
            let s1 = i[1], o = s1.length;
            if (o === 3) return this.r = parseInt(s1.charAt(0) + s1.charAt(0), 16) / 255, this.g = parseInt(s1.charAt(1) + s1.charAt(1), 16) / 255, this.b = parseInt(s1.charAt(2) + s1.charAt(2), 16) / 255, gn.toWorkingColorSpace(this, e), this;
            if (o === 6) return this.r = parseInt(s1.charAt(0) + s1.charAt(1), 16) / 255, this.g = parseInt(s1.charAt(2) + s1.charAt(3), 16) / 255, this.b = parseInt(s1.charAt(4) + s1.charAt(5), 16) / 255, gn.toWorkingColorSpace(this, e), this;
        }
        return t && t.length > 0 ? this.setColorName(t, e) : this;
    }
    setColorName(t, e = Ao) {
        let r = c_[t.toLowerCase()];
        return r !== void 0 ? this.setHex(r, e) : console.warn("THREE.Color: Unknown color " + t), this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(t) {
        return this.r = t.r, this.g = t.g, this.b = t.b, this;
    }
    copySRGBToLinear(t) {
        return this.r = Nc(t.r), this.g = Nc(t.g), this.b = Nc(t.b), this;
    }
    copyLinearToSRGB(t) {
        return this.r = Oy(t.r), this.g = Oy(t.g), this.b = Oy(t.b), this;
    }
    convertSRGBToLinear() {
        return this.copySRGBToLinear(this), this;
    }
    convertLinearToSRGB() {
        return this.copyLinearToSRGB(this), this;
    }
    getHex(t = Ao) {
        return gn.fromWorkingColorSpace(oy(this, Pi), t), yi(Pi.r * 255, 0, 255) << 16 ^ yi(Pi.g * 255, 0, 255) << 8 ^ yi(Pi.b * 255, 0, 255) << 0;
    }
    getHexString(t = Ao) {
        return ("000000" + this.getHex(t).toString(16)).slice(-6);
    }
    getHSL(t, e = gn.workingColorSpace) {
        gn.fromWorkingColorSpace(oy(this, Pi), e);
        let r = Pi.r, i = Pi.g, s1 = Pi.b, o = Math.max(r, i, s1), a = Math.min(r, i, s1), l, c, u1 = (a + o) / 2;
        if (a === o) l = 0, c = 0;
        else {
            let h = o - a;
            switch(c = u1 <= .5 ? h / (o + a) : h / (2 - o - a), o){
                case r:
                    l = (i - s1) / h + (i < s1 ? 6 : 0);
                    break;
                case i:
                    l = (s1 - r) / h + 2;
                    break;
                case s1:
                    l = (r - i) / h + 4;
                    break;
            }
            l /= 6;
        }
        return t.h = l, t.s = c, t.l = u1, t;
    }
    getRGB(t, e = gn.workingColorSpace) {
        return gn.fromWorkingColorSpace(oy(this, Pi), e), t.r = Pi.r, t.g = Pi.g, t.b = Pi.b, t;
    }
    getStyle(t = Ao) {
        return gn.fromWorkingColorSpace(oy(this, Pi), t), t !== Ao ? `color(${t} ${Pi.r} ${Pi.g} ${Pi.b})` : `rgb(${Pi.r * 255 | 0},${Pi.g * 255 | 0},${Pi.b * 255 | 0})`;
    }
    offsetHSL(t, e, r) {
        return this.getHSL(Us), Us.h += t, Us.s += e, Us.l += r, this.setHSL(Us.h, Us.s, Us.l), this;
    }
    add(t) {
        return this.r += t.r, this.g += t.g, this.b += t.b, this;
    }
    addColors(t, e) {
        return this.r = t.r + e.r, this.g = t.g + e.g, this.b = t.b + e.b, this;
    }
    addScalar(t) {
        return this.r += t, this.g += t, this.b += t, this;
    }
    sub(t) {
        return this.r = Math.max(0, this.r - t.r), this.g = Math.max(0, this.g - t.g), this.b = Math.max(0, this.b - t.b), this;
    }
    multiply(t) {
        return this.r *= t.r, this.g *= t.g, this.b *= t.b, this;
    }
    multiplyScalar(t) {
        return this.r *= t, this.g *= t, this.b *= t, this;
    }
    lerp(t, e) {
        return this.r += (t.r - this.r) * e, this.g += (t.g - this.g) * e, this.b += (t.b - this.b) * e, this;
    }
    lerpColors(t, e, r) {
        return this.r = t.r + (e.r - t.r) * r, this.g = t.g + (e.g - t.g) * r, this.b = t.b + (e.b - t.b) * r, this;
    }
    lerpHSL(t, e) {
        this.getHSL(Us), t.getHSL(sy);
        let r = Dp(Us.h, sy.h, e), i = Dp(Us.s, sy.s, e), s1 = Dp(Us.l, sy.l, e);
        return this.setHSL(r, i, s1), this;
    }
    equals(t) {
        return t.r === this.r && t.g === this.g && t.b === this.b;
    }
    fromArray(t, e = 0) {
        return this.r = t[e], this.g = t[e + 1], this.b = t[e + 2], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.r, t[e + 1] = this.g, t[e + 2] = this.b, t;
    }
    fromBufferAttribute(t, e) {
        return this.r = t.getX(e), this.g = t.getY(e), this.b = t.getZ(e), this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r, yield this.g, yield this.b;
    }
};
Ge.NAMES = c_;
var Lu, Vy = class {
    static getDataURL(t) {
        if (/^data:/i.test(t.src) || typeof HTMLCanvasElement > "u") return t.src;
        let e;
        if (t instanceof HTMLCanvasElement) e = t;
        else {
            Lu === void 0 && (Lu = Fp("canvas")), Lu.width = t.width, Lu.height = t.height;
            let r = Lu.getContext("2d");
            t instanceof ImageData ? r.putImageData(t, 0, 0) : r.drawImage(t, 0, 0, t.width, t.height), e = Lu;
        }
        return e.width > 2048 || e.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t), e.toDataURL("image/jpeg", .6)) : e.toDataURL("image/png");
    }
    static sRGBToLinear(t) {
        if (typeof HTMLImageElement < "u" && t instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && t instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && t instanceof ImageBitmap) {
            let e = Fp("canvas");
            e.width = t.width, e.height = t.height;
            let r = e.getContext("2d");
            r.drawImage(t, 0, 0, t.width, t.height);
            let i = r.getImageData(0, 0, t.width, t.height), s1 = i.data;
            for(let o = 0; o < s1.length; o++)s1[o] = Nc(s1[o] / 255) * 255;
            return r.putImageData(i, 0, 0), e;
        } else if (t.data) {
            let e = t.data.slice(0);
            for(let r = 0; r < e.length; r++)e instanceof Uint8Array || e instanceof Uint8ClampedArray ? e[r] = Math.floor(Nc(e[r] / 255) * 255) : e[r] = Nc(e[r]);
            return {
                data: e,
                width: t.width,
                height: t.height
            };
        } else return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t;
    }
}, Uy = class {
    constructor(t = null){
        this.isSource = !0, this.uuid = fs(), this.data = t, this.version = 0;
    }
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string";
        if (!e && t.images[this.uuid] !== void 0) return t.images[this.uuid];
        let r = {
            uuid: this.uuid,
            url: ""
        }, i = this.data;
        if (i !== null) {
            let s1;
            if (Array.isArray(i)) {
                s1 = [];
                for(let o = 0, a = i.length; o < a; o++)i[o].isDataTexture ? s1.push(mS(i[o].image)) : s1.push(mS(i[o]));
            } else s1 = mS(i);
            r.url = s1;
        }
        return e || (t.images[this.uuid] = r), r;
    }
};
function mS(n1) {
    return typeof HTMLImageElement < "u" && n1 instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && n1 instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && n1 instanceof ImageBitmap ? Vy.getDataURL(n1) : n1.data ? {
        data: Array.from(n1.data),
        width: n1.width,
        height: n1.height,
        type: n1.data.constructor.name
    } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}
var fk = 0, Zt = class extends ar {
    constructor(t = Zt.DEFAULT_IMAGE, e = Zt.DEFAULT_MAPPING, r = tr, i = tr, s1 = it, o = Bc, a = br, l = Nr, c = Zt.DEFAULT_ANISOTROPY, u1 = xn){
        super(), this.isTexture = !0, Object.defineProperty(this, "id", {
            value: fk++
        }), this.uuid = fs(), this.name = "", this.source = new Uy(t), this.mipmaps = [], this.mapping = e, this.wrapS = r, this.wrapT = i, this.magFilter = s1, this.minFilter = o, this.anisotropy = c, this.format = a, this.internalFormat = null, this.type = l, this.offset = new U(0, 0), this.repeat = new U(1, 1), this.center = new U(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Sr, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.encoding = u1, this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
    }
    get image() {
        return this.source.data;
    }
    set image(t) {
        this.source.data = t;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.name = t.name, this.source = t.source, this.mipmaps = t.mipmaps.slice(0), this.mapping = t.mapping, this.wrapS = t.wrapS, this.wrapT = t.wrapT, this.magFilter = t.magFilter, this.minFilter = t.minFilter, this.anisotropy = t.anisotropy, this.format = t.format, this.internalFormat = t.internalFormat, this.type = t.type, this.offset.copy(t.offset), this.repeat.copy(t.repeat), this.center.copy(t.center), this.rotation = t.rotation, this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrix.copy(t.matrix), this.generateMipmaps = t.generateMipmaps, this.premultiplyAlpha = t.premultiplyAlpha, this.flipY = t.flipY, this.unpackAlignment = t.unpackAlignment, this.encoding = t.encoding, this.userData = JSON.parse(JSON.stringify(t.userData)), this.needsUpdate = !0, this;
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string";
        if (!e && t.textures[this.uuid] !== void 0) return t.textures[this.uuid];
        let r = {
            metadata: {
                version: 4.5,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(t).uuid,
            mapping: this.mapping,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        return Object.keys(this.userData).length > 0 && (r.userData = this.userData), e || (t.textures[this.uuid] = r), r;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(t) {
        if (this.mapping !== n_) return t;
        if (t.applyMatrix3(this.matrix), t.x < 0 || t.x > 1) switch(this.wrapS){
            case Hs:
                t.x = t.x - Math.floor(t.x);
                break;
            case tr:
                t.x = t.x < 0 ? 0 : 1;
                break;
            case HS:
                Math.abs(Math.floor(t.x) % 2) === 1 ? t.x = Math.ceil(t.x) - t.x : t.x = t.x - Math.floor(t.x);
                break;
        }
        if (t.y < 0 || t.y > 1) switch(this.wrapT){
            case Hs:
                t.y = t.y - Math.floor(t.y);
                break;
            case tr:
                t.y = t.y < 0 ? 0 : 1;
                break;
            case HS:
                Math.abs(Math.floor(t.y) % 2) === 1 ? t.y = Math.ceil(t.y) - t.y : t.y = t.y - Math.floor(t.y);
                break;
        }
        return this.flipY && (t.y = 1 - t.y), t;
    }
    set needsUpdate(t) {
        t === !0 && (this.version++, this.source.needsUpdate = !0);
    }
};
Zt.DEFAULT_IMAGE = null;
Zt.DEFAULT_MAPPING = n_;
Zt.DEFAULT_ANISOTROPY = 1;
var Ze = class {
    constructor(t = 0, e = 0, r = 0, i = 1){
        Ze.prototype.isVector4 = !0, this.x = t, this.y = e, this.z = r, this.w = i;
    }
    get width() {
        return this.z;
    }
    set width(t) {
        this.z = t;
    }
    get height() {
        return this.w;
    }
    set height(t) {
        this.w = t;
    }
    set(t, e, r, i) {
        return this.x = t, this.y = e, this.z = r, this.w = i, this;
    }
    setScalar(t) {
        return this.x = t, this.y = t, this.z = t, this.w = t, this;
    }
    setX(t) {
        return this.x = t, this;
    }
    setY(t) {
        return this.y = t, this;
    }
    setZ(t) {
        return this.z = t, this;
    }
    setW(t) {
        return this.w = t, this;
    }
    setComponent(t, e) {
        switch(t){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            case 2:
                this.z = e;
                break;
            case 3:
                this.w = e;
                break;
            default:
                throw new Error("index is out of range: " + t);
        }
        return this;
    }
    getComponent(t) {
        switch(t){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + t);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(t) {
        return this.x = t.x, this.y = t.y, this.z = t.z, this.w = t.w !== void 0 ? t.w : 1, this;
    }
    add(t) {
        return this.x += t.x, this.y += t.y, this.z += t.z, this.w += t.w, this;
    }
    addScalar(t) {
        return this.x += t, this.y += t, this.z += t, this.w += t, this;
    }
    addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this.w = t.w + e.w, this;
    }
    addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this.w += t.w * e, this;
    }
    sub(t) {
        return this.x -= t.x, this.y -= t.y, this.z -= t.z, this.w -= t.w, this;
    }
    subScalar(t) {
        return this.x -= t, this.y -= t, this.z -= t, this.w -= t, this;
    }
    subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this.w = t.w - e.w, this;
    }
    multiply(t) {
        return this.x *= t.x, this.y *= t.y, this.z *= t.z, this.w *= t.w, this;
    }
    multiplyScalar(t) {
        return this.x *= t, this.y *= t, this.z *= t, this.w *= t, this;
    }
    applyMatrix4(t) {
        let e = this.x, r = this.y, i = this.z, s1 = this.w, o = t.elements;
        return this.x = o[0] * e + o[4] * r + o[8] * i + o[12] * s1, this.y = o[1] * e + o[5] * r + o[9] * i + o[13] * s1, this.z = o[2] * e + o[6] * r + o[10] * i + o[14] * s1, this.w = o[3] * e + o[7] * r + o[11] * i + o[15] * s1, this;
    }
    divideScalar(t) {
        return this.multiplyScalar(1 / t);
    }
    setAxisAngleFromQuaternion(t) {
        this.w = 2 * Math.acos(t.w);
        let e = Math.sqrt(1 - t.w * t.w);
        return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t.x / e, this.y = t.y / e, this.z = t.z / e), this;
    }
    setAxisAngleFromRotationMatrix(t) {
        let e, r, i, s1, l = t.elements, c = l[0], u1 = l[4], h = l[8], d = l[1], f = l[5], m = l[9], p = l[2], g = l[6], y = l[10];
        if (Math.abs(u1 - d) < .01 && Math.abs(h - p) < .01 && Math.abs(m - g) < .01) {
            if (Math.abs(u1 + d) < .1 && Math.abs(h + p) < .1 && Math.abs(m + g) < .1 && Math.abs(c + f + y - 3) < .1) return this.set(1, 0, 0, 0), this;
            e = Math.PI;
            let v = (c + 1) / 2, b = (f + 1) / 2, w = (y + 1) / 2, A = (u1 + d) / 4, T = (h + p) / 4, S = (m + g) / 4;
            return v > b && v > w ? v < .01 ? (r = 0, i = .707106781, s1 = .707106781) : (r = Math.sqrt(v), i = A / r, s1 = T / r) : b > w ? b < .01 ? (r = .707106781, i = 0, s1 = .707106781) : (i = Math.sqrt(b), r = A / i, s1 = S / i) : w < .01 ? (r = .707106781, i = .707106781, s1 = 0) : (s1 = Math.sqrt(w), r = T / s1, i = S / s1), this.set(r, i, s1, e), this;
        }
        let x = Math.sqrt((g - m) * (g - m) + (h - p) * (h - p) + (d - u1) * (d - u1));
        return Math.abs(x) < .001 && (x = 1), this.x = (g - m) / x, this.y = (h - p) / x, this.z = (d - u1) / x, this.w = Math.acos((c + f + y - 1) / 2), this;
    }
    min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this.w = Math.min(this.w, t.w), this;
    }
    max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this.w = Math.max(this.w, t.w), this;
    }
    clamp(t, e) {
        return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this.w = Math.max(t.w, Math.min(e.w, this.w)), this;
    }
    clampScalar(t, e) {
        return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this.w = Math.max(t, Math.min(e, this.w)), this;
    }
    clampLength(t, e) {
        let r = this.length();
        return this.divideScalar(r || 1).multiplyScalar(Math.max(t, Math.min(e, r)));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
    }
    roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
    }
    dot(t) {
        return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(t) {
        return this.normalize().multiplyScalar(t);
    }
    lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this.w += (t.w - this.w) * e, this;
    }
    lerpVectors(t, e, r) {
        return this.x = t.x + (e.x - t.x) * r, this.y = t.y + (e.y - t.y) * r, this.z = t.z + (e.z - t.z) * r, this.w = t.w + (e.w - t.w) * r, this;
    }
    equals(t) {
        return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w;
    }
    fromArray(t, e = 0) {
        return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this.w = t[e + 3], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t[e + 3] = this.w, t;
    }
    fromBufferAttribute(t, e) {
        return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this.w = t.getW(e), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z, yield this.w;
    }
}, at = class extends ar {
    constructor(t = 1, e = 1, r = {}){
        super(), this.isWebGLRenderTarget = !0, this.width = t, this.height = e, this.depth = 1, this.scissor = new Ze(0, 0, t, e), this.scissorTest = !1, this.viewport = new Ze(0, 0, t, e);
        let i = {
            width: t,
            height: e,
            depth: 1
        };
        this.texture = new Zt(i, r.mapping, r.wrapS, r.wrapT, r.magFilter, r.minFilter, r.format, r.type, r.anisotropy, r.encoding), this.texture.isRenderTargetTexture = !0, this.texture.flipY = !1, this.texture.generateMipmaps = r.generateMipmaps !== void 0 ? r.generateMipmaps : !1, this.texture.internalFormat = r.internalFormat !== void 0 ? r.internalFormat : null, this.texture.minFilter = r.minFilter !== void 0 ? r.minFilter : it, this.depthBuffer = r.depthBuffer !== void 0 ? r.depthBuffer : !0, this.stencilBuffer = r.stencilBuffer !== void 0 ? r.stencilBuffer : !1, this.depthTexture = r.depthTexture !== void 0 ? r.depthTexture : null, this.samples = r.samples !== void 0 ? r.samples : 0;
    }
    setSize(t, e, r = 1) {
        (this.width !== t || this.height !== e || this.depth !== r) && (this.width = t, this.height = e, this.depth = r, this.texture.image.width = t, this.texture.image.height = e, this.texture.image.depth = r, this.dispose()), this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.width = t.width, this.height = t.height, this.depth = t.depth, this.viewport.copy(t.viewport), this.texture = t.texture.clone(), this.texture.isRenderTargetTexture = !0;
        let e = Object.assign({}, t.texture.image);
        return this.texture.source = new Uy(e), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, t.depthTexture !== null && (this.depthTexture = t.depthTexture.clone()), this.samples = t.samples, this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}, ky = class extends Zt {
    constructor(t = null, e = 1, r = 1, i = 1){
        super(null), this.isDataArrayTexture = !0, this.image = {
            data: t,
            width: e,
            height: r,
            depth: i
        }, this.magFilter = vt, this.minFilter = vt, this.wrapR = tr, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
};
var zy = class extends Zt {
    constructor(t = null, e = 1, r = 1, i = 1){
        super(null), this.isData3DTexture = !0, this.image = {
            data: t,
            width: e,
            height: r,
            depth: i
        }, this.magFilter = vt, this.minFilter = vt, this.wrapR = tr, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
};
var eh = class extends at {
    constructor(t = 1, e = 1, r = 1, i = {}){
        super(t, e, i), this.isWebGLMultipleRenderTargets = !0;
        let s1 = this.texture;
        this.texture = [];
        for(let o = 0; o < r; o++)this.texture[o] = s1.clone(), this.texture[o].isRenderTargetTexture = !0;
    }
    setSize(t, e, r = 1) {
        if (this.width !== t || this.height !== e || this.depth !== r) {
            this.width = t, this.height = e, this.depth = r;
            for(let i = 0, s1 = this.texture.length; i < s1; i++)this.texture[i].image.width = t, this.texture[i].image.height = e, this.texture[i].image.depth = r;
            this.dispose();
        }
        return this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e), this;
    }
    copy(t) {
        this.dispose(), this.width = t.width, this.height = t.height, this.depth = t.depth, this.viewport.set(0, 0, this.width, this.height), this.scissor.set(0, 0, this.width, this.height), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, t.depthTexture !== null && (this.depthTexture = t.depthTexture.clone()), this.texture.length = 0;
        for(let e = 0, r = t.texture.length; e < r; e++)this.texture[e] = t.texture[e].clone(), this.texture[e].isRenderTargetTexture = !0;
        return this;
    }
}, Ye = class {
    constructor(t = 0, e = 0, r = 0, i = 1){
        this.isQuaternion = !0, this._x = t, this._y = e, this._z = r, this._w = i;
    }
    static slerpFlat(t, e, r, i, s1, o, a) {
        let l = r[i + 0], c = r[i + 1], u1 = r[i + 2], h = r[i + 3], d = s1[o + 0], f = s1[o + 1], m = s1[o + 2], p = s1[o + 3];
        if (a === 0) {
            t[e + 0] = l, t[e + 1] = c, t[e + 2] = u1, t[e + 3] = h;
            return;
        }
        if (a === 1) {
            t[e + 0] = d, t[e + 1] = f, t[e + 2] = m, t[e + 3] = p;
            return;
        }
        if (h !== p || l !== d || c !== f || u1 !== m) {
            let g = 1 - a, y = l * d + c * f + u1 * m + h * p, x = y >= 0 ? 1 : -1, v = 1 - y * y;
            if (v > Number.EPSILON) {
                let w = Math.sqrt(v), A = Math.atan2(w, y * x);
                g = Math.sin(g * A) / w, a = Math.sin(a * A) / w;
            }
            let b = a * x;
            if (l = l * g + d * b, c = c * g + f * b, u1 = u1 * g + m * b, h = h * g + p * b, g === 1 - a) {
                let w = 1 / Math.sqrt(l * l + c * c + u1 * u1 + h * h);
                l *= w, c *= w, u1 *= w, h *= w;
            }
        }
        t[e] = l, t[e + 1] = c, t[e + 2] = u1, t[e + 3] = h;
    }
    static multiplyQuaternionsFlat(t, e, r, i, s1, o) {
        let a = r[i], l = r[i + 1], c = r[i + 2], u1 = r[i + 3], h = s1[o], d = s1[o + 1], f = s1[o + 2], m = s1[o + 3];
        return t[e] = a * m + u1 * h + l * f - c * d, t[e + 1] = l * m + u1 * d + c * h - a * f, t[e + 2] = c * m + u1 * f + a * d - l * h, t[e + 3] = u1 * m - a * h - l * d - c * f, t;
    }
    get x() {
        return this._x;
    }
    set x(t) {
        this._x = t, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(t) {
        this._y = t, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(t) {
        this._z = t, this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(t) {
        this._w = t, this._onChangeCallback();
    }
    set(t, e, r, i) {
        return this._x = t, this._y = e, this._z = r, this._w = i, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(t) {
        return this._x = t.x, this._y = t.y, this._z = t.z, this._w = t.w, this._onChangeCallback(), this;
    }
    setFromEuler(t, e) {
        let r = t._x, i = t._y, s1 = t._z, o = t._order, a = Math.cos, l = Math.sin, c = a(r / 2), u1 = a(i / 2), h = a(s1 / 2), d = l(r / 2), f = l(i / 2), m = l(s1 / 2);
        switch(o){
            case "XYZ":
                this._x = d * u1 * h + c * f * m, this._y = c * f * h - d * u1 * m, this._z = c * u1 * m + d * f * h, this._w = c * u1 * h - d * f * m;
                break;
            case "YXZ":
                this._x = d * u1 * h + c * f * m, this._y = c * f * h - d * u1 * m, this._z = c * u1 * m - d * f * h, this._w = c * u1 * h + d * f * m;
                break;
            case "ZXY":
                this._x = d * u1 * h - c * f * m, this._y = c * f * h + d * u1 * m, this._z = c * u1 * m + d * f * h, this._w = c * u1 * h - d * f * m;
                break;
            case "ZYX":
                this._x = d * u1 * h - c * f * m, this._y = c * f * h + d * u1 * m, this._z = c * u1 * m - d * f * h, this._w = c * u1 * h + d * f * m;
                break;
            case "YZX":
                this._x = d * u1 * h + c * f * m, this._y = c * f * h + d * u1 * m, this._z = c * u1 * m - d * f * h, this._w = c * u1 * h - d * f * m;
                break;
            case "XZY":
                this._x = d * u1 * h - c * f * m, this._y = c * f * h - d * u1 * m, this._z = c * u1 * m + d * f * h, this._w = c * u1 * h + d * f * m;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + o);
        }
        return e !== !1 && this._onChangeCallback(), this;
    }
    setFromAxisAngle(t, e) {
        let r = e / 2, i = Math.sin(r);
        return this._x = t.x * i, this._y = t.y * i, this._z = t.z * i, this._w = Math.cos(r), this._onChangeCallback(), this;
    }
    setFromRotationMatrix(t) {
        let e = t.elements, r = e[0], i = e[4], s1 = e[8], o = e[1], a = e[5], l = e[9], c = e[2], u1 = e[6], h = e[10], d = r + a + h;
        if (d > 0) {
            let f = .5 / Math.sqrt(d + 1);
            this._w = .25 / f, this._x = (u1 - l) * f, this._y = (s1 - c) * f, this._z = (o - i) * f;
        } else if (r > a && r > h) {
            let f = 2 * Math.sqrt(1 + r - a - h);
            this._w = (u1 - l) / f, this._x = .25 * f, this._y = (i + o) / f, this._z = (s1 + c) / f;
        } else if (a > h) {
            let f = 2 * Math.sqrt(1 + a - r - h);
            this._w = (s1 - c) / f, this._x = (i + o) / f, this._y = .25 * f, this._z = (l + u1) / f;
        } else {
            let f = 2 * Math.sqrt(1 + h - r - a);
            this._w = (o - i) / f, this._x = (s1 + c) / f, this._y = (l + u1) / f, this._z = .25 * f;
        }
        return this._onChangeCallback(), this;
    }
    setFromUnitVectors(t, e) {
        let r = t.dot(e) + 1;
        return r < Number.EPSILON ? (r = 0, Math.abs(t.x) > Math.abs(t.z) ? (this._x = -t.y, this._y = t.x, this._z = 0, this._w = r) : (this._x = 0, this._y = -t.z, this._z = t.y, this._w = r)) : (this._x = t.y * e.z - t.z * e.y, this._y = t.z * e.x - t.x * e.z, this._z = t.x * e.y - t.y * e.x, this._w = r), this.normalize();
    }
    angleTo(t) {
        return 2 * Math.acos(Math.abs(yi(this.dot(t), -1, 1)));
    }
    rotateTowards(t, e) {
        let r = this.angleTo(t);
        if (r === 0) return this;
        let i = Math.min(1, e / r);
        return this.slerp(t, i), this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        return this.conjugate();
    }
    conjugate() {
        return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
    }
    dot(t) {
        return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let t = this.length();
        return t === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t = 1 / t, this._x = this._x * t, this._y = this._y * t, this._z = this._z * t, this._w = this._w * t), this._onChangeCallback(), this;
    }
    multiply(t) {
        return this.multiplyQuaternions(this, t);
    }
    premultiply(t) {
        return this.multiplyQuaternions(t, this);
    }
    multiplyQuaternions(t, e) {
        let r = t._x, i = t._y, s1 = t._z, o = t._w, a = e._x, l = e._y, c = e._z, u1 = e._w;
        return this._x = r * u1 + o * a + i * c - s1 * l, this._y = i * u1 + o * l + s1 * a - r * c, this._z = s1 * u1 + o * c + r * l - i * a, this._w = o * u1 - r * a - i * l - s1 * c, this._onChangeCallback(), this;
    }
    slerp(t, e) {
        if (e === 0) return this;
        if (e === 1) return this.copy(t);
        let r = this._x, i = this._y, s1 = this._z, o = this._w, a = o * t._w + r * t._x + i * t._y + s1 * t._z;
        if (a < 0 ? (this._w = -t._w, this._x = -t._x, this._y = -t._y, this._z = -t._z, a = -a) : this.copy(t), a >= 1) return this._w = o, this._x = r, this._y = i, this._z = s1, this;
        let l = 1 - a * a;
        if (l <= Number.EPSILON) {
            let f = 1 - e;
            return this._w = f * o + e * this._w, this._x = f * r + e * this._x, this._y = f * i + e * this._y, this._z = f * s1 + e * this._z, this.normalize(), this._onChangeCallback(), this;
        }
        let c = Math.sqrt(l), u1 = Math.atan2(c, a), h = Math.sin((1 - e) * u1) / c, d = Math.sin(e * u1) / c;
        return this._w = o * h + this._w * d, this._x = r * h + this._x * d, this._y = i * h + this._y * d, this._z = s1 * h + this._z * d, this._onChangeCallback(), this;
    }
    slerpQuaternions(t, e, r) {
        return this.copy(t).slerp(e, r);
    }
    random() {
        let t = Math.random(), e = Math.sqrt(1 - t), r = Math.sqrt(t), i = 2 * Math.PI * Math.random(), s1 = 2 * Math.PI * Math.random();
        return this.set(e * Math.cos(i), r * Math.sin(s1), r * Math.cos(s1), e * Math.sin(i));
    }
    equals(t) {
        return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w;
    }
    fromArray(t, e = 0) {
        return this._x = t[e], this._y = t[e + 1], this._z = t[e + 2], this._w = t[e + 3], this._onChangeCallback(), this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._w, t;
    }
    fromBufferAttribute(t, e) {
        return this._x = t.getX(e), this._y = t.getY(e), this._z = t.getZ(e), this._w = t.getW(e), this;
    }
    _onChange(t) {
        return this._onChangeCallback = t, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._w;
    }
}, E = class {
    constructor(t = 0, e = 0, r = 0){
        E.prototype.isVector3 = !0, this.x = t, this.y = e, this.z = r;
    }
    set(t, e, r) {
        return r === void 0 && (r = this.z), this.x = t, this.y = e, this.z = r, this;
    }
    setScalar(t) {
        return this.x = t, this.y = t, this.z = t, this;
    }
    setX(t) {
        return this.x = t, this;
    }
    setY(t) {
        return this.y = t, this;
    }
    setZ(t) {
        return this.z = t, this;
    }
    setComponent(t, e) {
        switch(t){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            case 2:
                this.z = e;
                break;
            default:
                throw new Error("index is out of range: " + t);
        }
        return this;
    }
    getComponent(t) {
        switch(t){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + t);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(t) {
        return this.x = t.x, this.y = t.y, this.z = t.z, this;
    }
    add(t) {
        return this.x += t.x, this.y += t.y, this.z += t.z, this;
    }
    addScalar(t) {
        return this.x += t, this.y += t, this.z += t, this;
    }
    addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this;
    }
    addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this;
    }
    sub(t) {
        return this.x -= t.x, this.y -= t.y, this.z -= t.z, this;
    }
    subScalar(t) {
        return this.x -= t, this.y -= t, this.z -= t, this;
    }
    subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this;
    }
    multiply(t) {
        return this.x *= t.x, this.y *= t.y, this.z *= t.z, this;
    }
    multiplyScalar(t) {
        return this.x *= t, this.y *= t, this.z *= t, this;
    }
    multiplyVectors(t, e) {
        return this.x = t.x * e.x, this.y = t.y * e.y, this.z = t.z * e.z, this;
    }
    applyEuler(t) {
        return this.applyQuaternion(tP.setFromEuler(t));
    }
    applyAxisAngle(t, e) {
        return this.applyQuaternion(tP.setFromAxisAngle(t, e));
    }
    applyMatrix3(t) {
        let e = this.x, r = this.y, i = this.z, s1 = t.elements;
        return this.x = s1[0] * e + s1[3] * r + s1[6] * i, this.y = s1[1] * e + s1[4] * r + s1[7] * i, this.z = s1[2] * e + s1[5] * r + s1[8] * i, this;
    }
    applyNormalMatrix(t) {
        return this.applyMatrix3(t).normalize();
    }
    applyMatrix4(t) {
        let e = this.x, r = this.y, i = this.z, s1 = t.elements, o = 1 / (s1[3] * e + s1[7] * r + s1[11] * i + s1[15]);
        return this.x = (s1[0] * e + s1[4] * r + s1[8] * i + s1[12]) * o, this.y = (s1[1] * e + s1[5] * r + s1[9] * i + s1[13]) * o, this.z = (s1[2] * e + s1[6] * r + s1[10] * i + s1[14]) * o, this;
    }
    applyQuaternion(t) {
        let e = this.x, r = this.y, i = this.z, s1 = t.x, o = t.y, a = t.z, l = t.w, c = l * e + o * i - a * r, u1 = l * r + a * e - s1 * i, h = l * i + s1 * r - o * e, d = -s1 * e - o * r - a * i;
        return this.x = c * l + d * -s1 + u1 * -a - h * -o, this.y = u1 * l + d * -o + h * -s1 - c * -a, this.z = h * l + d * -a + c * -o - u1 * -s1, this;
    }
    project(t) {
        return this.applyMatrix4(t.matrixWorldInverse).applyMatrix4(t.projectionMatrix);
    }
    unproject(t) {
        return this.applyMatrix4(t.projectionMatrixInverse).applyMatrix4(t.matrixWorld);
    }
    transformDirection(t) {
        let e = this.x, r = this.y, i = this.z, s1 = t.elements;
        return this.x = s1[0] * e + s1[4] * r + s1[8] * i, this.y = s1[1] * e + s1[5] * r + s1[9] * i, this.z = s1[2] * e + s1[6] * r + s1[10] * i, this.normalize();
    }
    divide(t) {
        return this.x /= t.x, this.y /= t.y, this.z /= t.z, this;
    }
    divideScalar(t) {
        return this.multiplyScalar(1 / t);
    }
    min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this;
    }
    max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this;
    }
    clamp(t, e) {
        return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this;
    }
    clampScalar(t, e) {
        return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this;
    }
    clampLength(t, e) {
        let r = this.length();
        return this.divideScalar(r || 1).multiplyScalar(Math.max(t, Math.min(e, r)));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
    }
    roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
    }
    dot(t) {
        return this.x * t.x + this.y * t.y + this.z * t.z;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(t) {
        return this.normalize().multiplyScalar(t);
    }
    lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this;
    }
    lerpVectors(t, e, r) {
        return this.x = t.x + (e.x - t.x) * r, this.y = t.y + (e.y - t.y) * r, this.z = t.z + (e.z - t.z) * r, this;
    }
    cross(t) {
        return this.crossVectors(this, t);
    }
    crossVectors(t, e) {
        let r = t.x, i = t.y, s1 = t.z, o = e.x, a = e.y, l = e.z;
        return this.x = i * l - s1 * a, this.y = s1 * o - r * l, this.z = r * a - i * o, this;
    }
    projectOnVector(t) {
        let e = t.lengthSq();
        if (e === 0) return this.set(0, 0, 0);
        let r = t.dot(this) / e;
        return this.copy(t).multiplyScalar(r);
    }
    projectOnPlane(t) {
        return gS.copy(this).projectOnVector(t), this.sub(gS);
    }
    reflect(t) {
        return this.sub(gS.copy(t).multiplyScalar(2 * this.dot(t)));
    }
    angleTo(t) {
        let e = Math.sqrt(this.lengthSq() * t.lengthSq());
        if (e === 0) return Math.PI / 2;
        let r = this.dot(t) / e;
        return Math.acos(yi(r, -1, 1));
    }
    distanceTo(t) {
        return Math.sqrt(this.distanceToSquared(t));
    }
    distanceToSquared(t) {
        let e = this.x - t.x, r = this.y - t.y, i = this.z - t.z;
        return e * e + r * r + i * i;
    }
    manhattanDistanceTo(t) {
        return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z);
    }
    setFromSpherical(t) {
        return this.setFromSphericalCoords(t.radius, t.phi, t.theta);
    }
    setFromSphericalCoords(t, e, r) {
        let i = Math.sin(e) * t;
        return this.x = i * Math.sin(r), this.y = Math.cos(e) * t, this.z = i * Math.cos(r), this;
    }
    setFromCylindrical(t) {
        return this.setFromCylindricalCoords(t.radius, t.theta, t.y);
    }
    setFromCylindricalCoords(t, e, r) {
        return this.x = t * Math.sin(e), this.y = r, this.z = t * Math.cos(e), this;
    }
    setFromMatrixPosition(t) {
        let e = t.elements;
        return this.x = e[12], this.y = e[13], this.z = e[14], this;
    }
    setFromMatrixScale(t) {
        let e = this.setFromMatrixColumn(t, 0).length(), r = this.setFromMatrixColumn(t, 1).length(), i = this.setFromMatrixColumn(t, 2).length();
        return this.x = e, this.y = r, this.z = i, this;
    }
    setFromMatrixColumn(t, e) {
        return this.fromArray(t.elements, e * 4);
    }
    setFromMatrix3Column(t, e) {
        return this.fromArray(t.elements, e * 3);
    }
    setFromEuler(t) {
        return this.x = t._x, this.y = t._y, this.z = t._z, this;
    }
    equals(t) {
        return t.x === this.x && t.y === this.y && t.z === this.z;
    }
    fromArray(t, e = 0) {
        return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t;
    }
    fromBufferAttribute(t, e) {
        return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
    }
    randomDirection() {
        let t = (Math.random() - .5) * 2, e = Math.random() * Math.PI * 2, r = Math.sqrt(1 - t ** 2);
        return this.x = r * Math.cos(e), this.y = r * Math.sin(e), this.z = t, this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z;
    }
}, gS = new E, tP = new Ye, Yt = class {
    constructor(t = new E(1 / 0, 1 / 0, 1 / 0), e = new E(-1 / 0, -1 / 0, -1 / 0)){
        this.isBox3 = !0, this.min = t, this.max = e;
    }
    set(t, e) {
        return this.min.copy(t), this.max.copy(e), this;
    }
    setFromArray(t) {
        let e = 1 / 0, r = 1 / 0, i = 1 / 0, s1 = -1 / 0, o = -1 / 0, a = -1 / 0;
        for(let l = 0, c = t.length; l < c; l += 3){
            let u1 = t[l], h = t[l + 1], d = t[l + 2];
            u1 < e && (e = u1), h < r && (r = h), d < i && (i = d), u1 > s1 && (s1 = u1), h > o && (o = h), d > a && (a = d);
        }
        return this.min.set(e, r, i), this.max.set(s1, o, a), this;
    }
    setFromBufferAttribute(t) {
        let e = 1 / 0, r = 1 / 0, i = 1 / 0, s1 = -1 / 0, o = -1 / 0, a = -1 / 0;
        for(let l = 0, c = t.count; l < c; l++){
            let u1 = t.getX(l), h = t.getY(l), d = t.getZ(l);
            u1 < e && (e = u1), h < r && (r = h), d < i && (i = d), u1 > s1 && (s1 = u1), h > o && (o = h), d > a && (a = d);
        }
        return this.min.set(e, r, i), this.max.set(s1, o, a), this;
    }
    setFromPoints(t) {
        this.makeEmpty();
        for(let e = 0, r = t.length; e < r; e++)this.expandByPoint(t[e]);
        return this;
    }
    setFromCenterAndSize(t, e) {
        let r = _c.copy(e).multiplyScalar(.5);
        return this.min.copy(t).sub(r), this.max.copy(t).add(r), this;
    }
    setFromObject(t, e = !1) {
        return this.makeEmpty(), this.expandByObject(t, e);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.min.copy(t.min), this.max.copy(t.max), this;
    }
    makeEmpty() {
        return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
    }
    isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(t) {
        return this.isEmpty() ? t.set(0, 0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(t) {
        return this.isEmpty() ? t.set(0, 0, 0) : t.subVectors(this.max, this.min);
    }
    expandByPoint(t) {
        return this.min.min(t), this.max.max(t), this;
    }
    expandByVector(t) {
        return this.min.sub(t), this.max.add(t), this;
    }
    expandByScalar(t) {
        return this.min.addScalar(-t), this.max.addScalar(t), this;
    }
    expandByObject(t, e = !1) {
        t.updateWorldMatrix(!1, !1);
        let r = t.geometry;
        if (r !== void 0) {
            if (e && r.attributes != null && r.attributes.position !== void 0) {
                let s1 = r.attributes.position;
                for(let o = 0, a = s1.count; o < a; o++)_c.fromBufferAttribute(s1, o).applyMatrix4(t.matrixWorld), this.expandByPoint(_c);
            } else r.boundingBox === null && r.computeBoundingBox(), yS.copy(r.boundingBox), yS.applyMatrix4(t.matrixWorld), this.union(yS);
        }
        let i = t.children;
        for(let s1 = 0, o = i.length; s1 < o; s1++)this.expandByObject(i[s1], e);
        return this;
    }
    containsPoint(t) {
        return !(t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y || t.z < this.min.z || t.z > this.max.z);
    }
    containsBox(t) {
        return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y && this.min.z <= t.min.z && t.max.z <= this.max.z;
    }
    getParameter(t, e) {
        return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y), (t.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(t) {
        return !(t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y || t.max.z < this.min.z || t.min.z > this.max.z);
    }
    intersectsSphere(t) {
        return this.clampPoint(t.center, _c), _c.distanceToSquared(t.center) <= t.radius * t.radius;
    }
    intersectsPlane(t) {
        let e, r;
        return t.normal.x > 0 ? (e = t.normal.x * this.min.x, r = t.normal.x * this.max.x) : (e = t.normal.x * this.max.x, r = t.normal.x * this.min.x), t.normal.y > 0 ? (e += t.normal.y * this.min.y, r += t.normal.y * this.max.y) : (e += t.normal.y * this.max.y, r += t.normal.y * this.min.y), t.normal.z > 0 ? (e += t.normal.z * this.min.z, r += t.normal.z * this.max.z) : (e += t.normal.z * this.max.z, r += t.normal.z * this.min.z), e <= -t.constant && r >= -t.constant;
    }
    intersectsTriangle(t) {
        if (this.isEmpty()) return !1;
        this.getCenter(xp), ay.subVectors(this.max, xp), Nu.subVectors(t.a, xp), Bu.subVectors(t.b, xp), Fu.subVectors(t.c, xp), ul.subVectors(Bu, Nu), hl.subVectors(Fu, Bu), Ic.subVectors(Nu, Fu);
        let e = [
            0,
            -ul.z,
            ul.y,
            0,
            -hl.z,
            hl.y,
            0,
            -Ic.z,
            Ic.y,
            ul.z,
            0,
            -ul.x,
            hl.z,
            0,
            -hl.x,
            Ic.z,
            0,
            -Ic.x,
            -ul.y,
            ul.x,
            0,
            -hl.y,
            hl.x,
            0,
            -Ic.y,
            Ic.x,
            0
        ];
        return !vS(e, Nu, Bu, Fu, ay) || (e = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], !vS(e, Nu, Bu, Fu, ay)) ? !1 : (ly.crossVectors(ul, hl), e = [
            ly.x,
            ly.y,
            ly.z
        ], vS(e, Nu, Bu, Fu, ay));
    }
    clampPoint(t, e) {
        return e.copy(t).clamp(this.min, this.max);
    }
    distanceToPoint(t) {
        return _c.copy(t).clamp(this.min, this.max).sub(t).length();
    }
    getBoundingSphere(t) {
        return this.getCenter(t.center), t.radius = this.getSize(_c).length() * .5, t;
    }
    intersect(t) {
        return this.min.max(t.min), this.max.min(t.max), this.isEmpty() && this.makeEmpty(), this;
    }
    union(t) {
        return this.min.min(t.min), this.max.max(t.max), this;
    }
    applyMatrix4(t) {
        return this.isEmpty() ? this : (xa[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t), xa[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t), xa[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t), xa[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t), xa[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t), xa[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t), xa[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t), xa[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t), this.setFromPoints(xa), this);
    }
    translate(t) {
        return this.min.add(t), this.max.add(t), this;
    }
    equals(t) {
        return t.min.equals(this.min) && t.max.equals(this.max);
    }
}, xa = [
    new E,
    new E,
    new E,
    new E,
    new E,
    new E,
    new E,
    new E
], _c = new E, yS = new Yt, Nu = new E, Bu = new E, Fu = new E, ul = new E, hl = new E, Ic = new E, xp = new E, ay = new E, ly = new E, Dc = new E;
function vS(n1, t, e, r, i) {
    for(let s1 = 0, o = n1.length - 3; s1 <= o; s1 += 3){
        Dc.fromArray(n1, s1);
        let a = i.x * Math.abs(Dc.x) + i.y * Math.abs(Dc.y) + i.z * Math.abs(Dc.z), l = t.dot(Dc), c = e.dot(Dc), u1 = r.dot(Dc);
        if (Math.max(-Math.max(l, c, u1), Math.min(l, c, u1)) > a) return !1;
    }
    return !0;
}
var pk = new Yt, bp = new E, xS = new E, ei = class {
    constructor(t = new E, e = -1){
        this.center = t, this.radius = e;
    }
    set(t, e) {
        return this.center.copy(t), this.radius = e, this;
    }
    setFromPoints(t, e) {
        let r = this.center;
        e !== void 0 ? r.copy(e) : pk.setFromPoints(t).getCenter(r);
        let i = 0;
        for(let s1 = 0, o = t.length; s1 < o; s1++)i = Math.max(i, r.distanceToSquared(t[s1]));
        return this.radius = Math.sqrt(i), this;
    }
    copy(t) {
        return this.center.copy(t.center), this.radius = t.radius, this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        return this.center.set(0, 0, 0), this.radius = -1, this;
    }
    containsPoint(t) {
        return t.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(t) {
        return t.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(t) {
        let e = this.radius + t.radius;
        return t.center.distanceToSquared(this.center) <= e * e;
    }
    intersectsBox(t) {
        return t.intersectsSphere(this);
    }
    intersectsPlane(t) {
        return Math.abs(t.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(t, e) {
        let r = this.center.distanceToSquared(t);
        return e.copy(t), r > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center)), e;
    }
    getBoundingBox(t) {
        return this.isEmpty() ? (t.makeEmpty(), t) : (t.set(this.center, this.center), t.expandByScalar(this.radius), t);
    }
    applyMatrix4(t) {
        return this.center.applyMatrix4(t), this.radius = this.radius * t.getMaxScaleOnAxis(), this;
    }
    translate(t) {
        return this.center.add(t), this;
    }
    expandByPoint(t) {
        if (this.isEmpty()) return this.center.copy(t), this.radius = 0, this;
        bp.subVectors(t, this.center);
        let e = bp.lengthSq();
        if (e > this.radius * this.radius) {
            let r = Math.sqrt(e), i = (r - this.radius) * .5;
            this.center.addScaledVector(bp, i / r), this.radius += i;
        }
        return this;
    }
    union(t) {
        return t.isEmpty() ? this : this.isEmpty() ? (this.copy(t), this) : (this.center.equals(t.center) === !0 ? this.radius = Math.max(this.radius, t.radius) : (xS.subVectors(t.center, this.center).setLength(t.radius), this.expandByPoint(bp.copy(t.center).add(xS)), this.expandByPoint(bp.copy(t.center).sub(xS))), this);
    }
    equals(t) {
        return t.center.equals(this.center) && t.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, ba = new E, bS = new E, cy = new E, dl = new E, SS = new E, uy = new E, wS = new E, Ws = class {
    constructor(t = new E, e = new E(0, 0, -1)){
        this.origin = t, this.direction = e;
    }
    set(t, e) {
        return this.origin.copy(t), this.direction.copy(e), this;
    }
    copy(t) {
        return this.origin.copy(t.origin), this.direction.copy(t.direction), this;
    }
    at(t, e) {
        return e.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
    lookAt(t) {
        return this.direction.copy(t).sub(this.origin).normalize(), this;
    }
    recast(t) {
        return this.origin.copy(this.at(t, ba)), this;
    }
    closestPointToPoint(t, e) {
        e.subVectors(t, this.origin);
        let r = e.dot(this.direction);
        return r < 0 ? e.copy(this.origin) : e.copy(this.direction).multiplyScalar(r).add(this.origin);
    }
    distanceToPoint(t) {
        return Math.sqrt(this.distanceSqToPoint(t));
    }
    distanceSqToPoint(t) {
        let e = ba.subVectors(t, this.origin).dot(this.direction);
        return e < 0 ? this.origin.distanceToSquared(t) : (ba.copy(this.direction).multiplyScalar(e).add(this.origin), ba.distanceToSquared(t));
    }
    distanceSqToSegment(t, e, r, i) {
        bS.copy(t).add(e).multiplyScalar(.5), cy.copy(e).sub(t).normalize(), dl.copy(this.origin).sub(bS);
        let s1 = t.distanceTo(e) * .5, o = -this.direction.dot(cy), a = dl.dot(this.direction), l = -dl.dot(cy), c = dl.lengthSq(), u1 = Math.abs(1 - o * o), h, d, f, m;
        if (u1 > 0) {
            if (h = o * l - a, d = o * a - l, m = s1 * u1, h >= 0) {
                if (d >= -m) {
                    if (d <= m) {
                        let p = 1 / u1;
                        h *= p, d *= p, f = h * (h + o * d + 2 * a) + d * (o * h + d + 2 * l) + c;
                    } else d = s1, h = Math.max(0, -(o * d + a)), f = -h * h + d * (d + 2 * l) + c;
                } else d = -s1, h = Math.max(0, -(o * d + a)), f = -h * h + d * (d + 2 * l) + c;
            } else d <= -m ? (h = Math.max(0, -(-o * s1 + a)), d = h > 0 ? -s1 : Math.min(Math.max(-s1, -l), s1), f = -h * h + d * (d + 2 * l) + c) : d <= m ? (h = 0, d = Math.min(Math.max(-s1, -l), s1), f = d * (d + 2 * l) + c) : (h = Math.max(0, -(o * s1 + a)), d = h > 0 ? s1 : Math.min(Math.max(-s1, -l), s1), f = -h * h + d * (d + 2 * l) + c);
        } else d = o > 0 ? -s1 : s1, h = Math.max(0, -(o * d + a)), f = -h * h + d * (d + 2 * l) + c;
        return r && r.copy(this.direction).multiplyScalar(h).add(this.origin), i && i.copy(cy).multiplyScalar(d).add(bS), f;
    }
    intersectSphere(t, e) {
        ba.subVectors(t.center, this.origin);
        let r = ba.dot(this.direction), i = ba.dot(ba) - r * r, s1 = t.radius * t.radius;
        if (i > s1) return null;
        let o = Math.sqrt(s1 - i), a = r - o, l = r + o;
        return a < 0 && l < 0 ? null : a < 0 ? this.at(l, e) : this.at(a, e);
    }
    intersectsSphere(t) {
        return this.distanceSqToPoint(t.center) <= t.radius * t.radius;
    }
    distanceToPlane(t) {
        let e = t.normal.dot(this.direction);
        if (e === 0) return t.distanceToPoint(this.origin) === 0 ? 0 : null;
        let r = -(this.origin.dot(t.normal) + t.constant) / e;
        return r >= 0 ? r : null;
    }
    intersectPlane(t, e) {
        let r = this.distanceToPlane(t);
        return r === null ? null : this.at(r, e);
    }
    intersectsPlane(t) {
        let e = t.distanceToPoint(this.origin);
        return e === 0 || t.normal.dot(this.direction) * e < 0;
    }
    intersectBox(t, e) {
        let r, i, s1, o, a, l, c = 1 / this.direction.x, u1 = 1 / this.direction.y, h = 1 / this.direction.z, d = this.origin;
        return c >= 0 ? (r = (t.min.x - d.x) * c, i = (t.max.x - d.x) * c) : (r = (t.max.x - d.x) * c, i = (t.min.x - d.x) * c), u1 >= 0 ? (s1 = (t.min.y - d.y) * u1, o = (t.max.y - d.y) * u1) : (s1 = (t.max.y - d.y) * u1, o = (t.min.y - d.y) * u1), r > o || s1 > i || ((s1 > r || isNaN(r)) && (r = s1), (o < i || isNaN(i)) && (i = o), h >= 0 ? (a = (t.min.z - d.z) * h, l = (t.max.z - d.z) * h) : (a = (t.max.z - d.z) * h, l = (t.min.z - d.z) * h), r > l || a > i) || ((a > r || r !== r) && (r = a), (l < i || i !== i) && (i = l), i < 0) ? null : this.at(r >= 0 ? r : i, e);
    }
    intersectsBox(t) {
        return this.intersectBox(t, ba) !== null;
    }
    intersectTriangle(t, e, r, i, s1) {
        SS.subVectors(e, t), uy.subVectors(r, t), wS.crossVectors(SS, uy);
        let o = this.direction.dot(wS), a;
        if (o > 0) {
            if (i) return null;
            a = 1;
        } else if (o < 0) a = -1, o = -o;
        else return null;
        dl.subVectors(this.origin, t);
        let l = a * this.direction.dot(uy.crossVectors(dl, uy));
        if (l < 0) return null;
        let c = a * this.direction.dot(SS.cross(dl));
        if (c < 0 || l + c > o) return null;
        let u1 = -a * dl.dot(wS);
        return u1 < 0 ? null : this.at(u1 / o, s1);
    }
    applyMatrix4(t) {
        return this.origin.applyMatrix4(t), this.direction.transformDirection(t), this;
    }
    equals(t) {
        return t.origin.equals(this.origin) && t.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, ue = class {
    constructor(){
        ue.prototype.isMatrix4 = !0, this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
    }
    set(t, e, r, i, s1, o, a, l, c, u1, h, d, f, m, p, g) {
        let y = this.elements;
        return y[0] = t, y[4] = e, y[8] = r, y[12] = i, y[1] = s1, y[5] = o, y[9] = a, y[13] = l, y[2] = c, y[6] = u1, y[10] = h, y[14] = d, y[3] = f, y[7] = m, y[11] = p, y[15] = g, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    clone() {
        return new ue().fromArray(this.elements);
    }
    copy(t) {
        let e = this.elements, r = t.elements;
        return e[0] = r[0], e[1] = r[1], e[2] = r[2], e[3] = r[3], e[4] = r[4], e[5] = r[5], e[6] = r[6], e[7] = r[7], e[8] = r[8], e[9] = r[9], e[10] = r[10], e[11] = r[11], e[12] = r[12], e[13] = r[13], e[14] = r[14], e[15] = r[15], this;
    }
    copyPosition(t) {
        let e = this.elements, r = t.elements;
        return e[12] = r[12], e[13] = r[13], e[14] = r[14], this;
    }
    setFromMatrix3(t) {
        let e = t.elements;
        return this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this;
    }
    extractBasis(t, e, r) {
        return t.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), r.setFromMatrixColumn(this, 2), this;
    }
    makeBasis(t, e, r) {
        return this.set(t.x, e.x, r.x, 0, t.y, e.y, r.y, 0, t.z, e.z, r.z, 0, 0, 0, 0, 1), this;
    }
    extractRotation(t) {
        let e = this.elements, r = t.elements, i = 1 / Vu.setFromMatrixColumn(t, 0).length(), s1 = 1 / Vu.setFromMatrixColumn(t, 1).length(), o = 1 / Vu.setFromMatrixColumn(t, 2).length();
        return e[0] = r[0] * i, e[1] = r[1] * i, e[2] = r[2] * i, e[3] = 0, e[4] = r[4] * s1, e[5] = r[5] * s1, e[6] = r[6] * s1, e[7] = 0, e[8] = r[8] * o, e[9] = r[9] * o, e[10] = r[10] * o, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
    makeRotationFromEuler(t) {
        let e = this.elements, r = t.x, i = t.y, s1 = t.z, o = Math.cos(r), a = Math.sin(r), l = Math.cos(i), c = Math.sin(i), u1 = Math.cos(s1), h = Math.sin(s1);
        if (t.order === "XYZ") {
            let d = o * u1, f = o * h, m = a * u1, p = a * h;
            e[0] = l * u1, e[4] = -l * h, e[8] = c, e[1] = f + m * c, e[5] = d - p * c, e[9] = -a * l, e[2] = p - d * c, e[6] = m + f * c, e[10] = o * l;
        } else if (t.order === "YXZ") {
            let d = l * u1, f = l * h, m = c * u1, p = c * h;
            e[0] = d + p * a, e[4] = m * a - f, e[8] = o * c, e[1] = o * h, e[5] = o * u1, e[9] = -a, e[2] = f * a - m, e[6] = p + d * a, e[10] = o * l;
        } else if (t.order === "ZXY") {
            let d = l * u1, f = l * h, m = c * u1, p = c * h;
            e[0] = d - p * a, e[4] = -o * h, e[8] = m + f * a, e[1] = f + m * a, e[5] = o * u1, e[9] = p - d * a, e[2] = -o * c, e[6] = a, e[10] = o * l;
        } else if (t.order === "ZYX") {
            let d = o * u1, f = o * h, m = a * u1, p = a * h;
            e[0] = l * u1, e[4] = m * c - f, e[8] = d * c + p, e[1] = l * h, e[5] = p * c + d, e[9] = f * c - m, e[2] = -c, e[6] = a * l, e[10] = o * l;
        } else if (t.order === "YZX") {
            let d = o * l, f = o * c, m = a * l, p = a * c;
            e[0] = l * u1, e[4] = p - d * h, e[8] = m * h + f, e[1] = h, e[5] = o * u1, e[9] = -a * u1, e[2] = -c * u1, e[6] = f * h + m, e[10] = d - p * h;
        } else if (t.order === "XZY") {
            let d = o * l, f = o * c, m = a * l, p = a * c;
            e[0] = l * u1, e[4] = -h, e[8] = c * u1, e[1] = d * h + p, e[5] = o * u1, e[9] = f * h - m, e[2] = m * h - f, e[6] = a * u1, e[10] = p * h + d;
        }
        return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
    makeRotationFromQuaternion(t) {
        return this.compose(mk, t, gk);
    }
    lookAt(t, e, r) {
        let i = this.elements;
        return Qn.subVectors(t, e), Qn.lengthSq() === 0 && (Qn.z = 1), Qn.normalize(), fl.crossVectors(r, Qn), fl.lengthSq() === 0 && (Math.abs(r.z) === 1 ? Qn.x += 1e-4 : Qn.z += 1e-4, Qn.normalize(), fl.crossVectors(r, Qn)), fl.normalize(), hy.crossVectors(Qn, fl), i[0] = fl.x, i[4] = hy.x, i[8] = Qn.x, i[1] = fl.y, i[5] = hy.y, i[9] = Qn.y, i[2] = fl.z, i[6] = hy.z, i[10] = Qn.z, this;
    }
    multiply(t) {
        return this.multiplyMatrices(this, t);
    }
    premultiply(t) {
        return this.multiplyMatrices(t, this);
    }
    multiplyMatrices(t, e) {
        let r = t.elements, i = e.elements, s1 = this.elements, o = r[0], a = r[4], l = r[8], c = r[12], u1 = r[1], h = r[5], d = r[9], f = r[13], m = r[2], p = r[6], g = r[10], y = r[14], x = r[3], v = r[7], b = r[11], w = r[15], A = i[0], T = i[4], S = i[8], M = i[12], C = i[1], P = i[5], _ = i[9], I = i[13], O = i[2], L = i[6], j = i[10], V = i[14], H = i[3], q = i[7], X = i[11], K = i[15];
        return s1[0] = o * A + a * C + l * O + c * H, s1[4] = o * T + a * P + l * L + c * q, s1[8] = o * S + a * _ + l * j + c * X, s1[12] = o * M + a * I + l * V + c * K, s1[1] = u1 * A + h * C + d * O + f * H, s1[5] = u1 * T + h * P + d * L + f * q, s1[9] = u1 * S + h * _ + d * j + f * X, s1[13] = u1 * M + h * I + d * V + f * K, s1[2] = m * A + p * C + g * O + y * H, s1[6] = m * T + p * P + g * L + y * q, s1[10] = m * S + p * _ + g * j + y * X, s1[14] = m * M + p * I + g * V + y * K, s1[3] = x * A + v * C + b * O + w * H, s1[7] = x * T + v * P + b * L + w * q, s1[11] = x * S + v * _ + b * j + w * X, s1[15] = x * M + v * I + b * V + w * K, this;
    }
    multiplyScalar(t) {
        let e = this.elements;
        return e[0] *= t, e[4] *= t, e[8] *= t, e[12] *= t, e[1] *= t, e[5] *= t, e[9] *= t, e[13] *= t, e[2] *= t, e[6] *= t, e[10] *= t, e[14] *= t, e[3] *= t, e[7] *= t, e[11] *= t, e[15] *= t, this;
    }
    determinant() {
        let t = this.elements, e = t[0], r = t[4], i = t[8], s1 = t[12], o = t[1], a = t[5], l = t[9], c = t[13], u1 = t[2], h = t[6], d = t[10], f = t[14], m = t[3], p = t[7], g = t[11], y = t[15];
        return m * (+s1 * l * h - i * c * h - s1 * a * d + r * c * d + i * a * f - r * l * f) + p * (+e * l * f - e * c * d + s1 * o * d - i * o * f + i * c * u1 - s1 * l * u1) + g * (+e * c * h - e * a * f - s1 * o * h + r * o * f + s1 * a * u1 - r * c * u1) + y * (-i * a * u1 - e * l * h + e * a * d + i * o * h - r * o * d + r * l * u1);
    }
    transpose() {
        let t = this.elements, e;
        return e = t[1], t[1] = t[4], t[4] = e, e = t[2], t[2] = t[8], t[8] = e, e = t[6], t[6] = t[9], t[9] = e, e = t[3], t[3] = t[12], t[12] = e, e = t[7], t[7] = t[13], t[13] = e, e = t[11], t[11] = t[14], t[14] = e, this;
    }
    setPosition(t, e, r) {
        let i = this.elements;
        return t.isVector3 ? (i[12] = t.x, i[13] = t.y, i[14] = t.z) : (i[12] = t, i[13] = e, i[14] = r), this;
    }
    invert() {
        let t = this.elements, e = t[0], r = t[1], i = t[2], s1 = t[3], o = t[4], a = t[5], l = t[6], c = t[7], u1 = t[8], h = t[9], d = t[10], f = t[11], m = t[12], p = t[13], g = t[14], y = t[15], x = h * g * c - p * d * c + p * l * f - a * g * f - h * l * y + a * d * y, v = m * d * c - u1 * g * c - m * l * f + o * g * f + u1 * l * y - o * d * y, b = u1 * p * c - m * h * c + m * a * f - o * p * f - u1 * a * y + o * h * y, w = m * h * l - u1 * p * l - m * a * d + o * p * d + u1 * a * g - o * h * g, A = e * x + r * v + i * b + s1 * w;
        if (A === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        let T = 1 / A;
        return t[0] = x * T, t[1] = (p * d * s1 - h * g * s1 - p * i * f + r * g * f + h * i * y - r * d * y) * T, t[2] = (a * g * s1 - p * l * s1 + p * i * c - r * g * c - a * i * y + r * l * y) * T, t[3] = (h * l * s1 - a * d * s1 - h * i * c + r * d * c + a * i * f - r * l * f) * T, t[4] = v * T, t[5] = (u1 * g * s1 - m * d * s1 + m * i * f - e * g * f - u1 * i * y + e * d * y) * T, t[6] = (m * l * s1 - o * g * s1 - m * i * c + e * g * c + o * i * y - e * l * y) * T, t[7] = (o * d * s1 - u1 * l * s1 + u1 * i * c - e * d * c - o * i * f + e * l * f) * T, t[8] = b * T, t[9] = (m * h * s1 - u1 * p * s1 - m * r * f + e * p * f + u1 * r * y - e * h * y) * T, t[10] = (o * p * s1 - m * a * s1 + m * r * c - e * p * c - o * r * y + e * a * y) * T, t[11] = (u1 * a * s1 - o * h * s1 - u1 * r * c + e * h * c + o * r * f - e * a * f) * T, t[12] = w * T, t[13] = (u1 * p * i - m * h * i + m * r * d - e * p * d - u1 * r * g + e * h * g) * T, t[14] = (m * a * i - o * p * i - m * r * l + e * p * l + o * r * g - e * a * g) * T, t[15] = (o * h * i - u1 * a * i + u1 * r * l - e * h * l - o * r * d + e * a * d) * T, this;
    }
    scale(t) {
        let e = this.elements, r = t.x, i = t.y, s1 = t.z;
        return e[0] *= r, e[4] *= i, e[8] *= s1, e[1] *= r, e[5] *= i, e[9] *= s1, e[2] *= r, e[6] *= i, e[10] *= s1, e[3] *= r, e[7] *= i, e[11] *= s1, this;
    }
    getMaxScaleOnAxis() {
        let t = this.elements, e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2], r = t[4] * t[4] + t[5] * t[5] + t[6] * t[6], i = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];
        return Math.sqrt(Math.max(e, r, i));
    }
    makeTranslation(t, e, r) {
        return this.set(1, 0, 0, t, 0, 1, 0, e, 0, 0, 1, r, 0, 0, 0, 1), this;
    }
    makeRotationX(t) {
        let e = Math.cos(t), r = Math.sin(t);
        return this.set(1, 0, 0, 0, 0, e, -r, 0, 0, r, e, 0, 0, 0, 0, 1), this;
    }
    makeRotationY(t) {
        let e = Math.cos(t), r = Math.sin(t);
        return this.set(e, 0, r, 0, 0, 1, 0, 0, -r, 0, e, 0, 0, 0, 0, 1), this;
    }
    makeRotationZ(t) {
        let e = Math.cos(t), r = Math.sin(t);
        return this.set(e, -r, 0, 0, r, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    makeRotationAxis(t, e) {
        let r = Math.cos(e), i = Math.sin(e), s1 = 1 - r, o = t.x, a = t.y, l = t.z, c = s1 * o, u1 = s1 * a;
        return this.set(c * o + r, c * a - i * l, c * l + i * a, 0, c * a + i * l, u1 * a + r, u1 * l - i * o, 0, c * l - i * a, u1 * l + i * o, s1 * l * l + r, 0, 0, 0, 0, 1), this;
    }
    makeScale(t, e, r) {
        return this.set(t, 0, 0, 0, 0, e, 0, 0, 0, 0, r, 0, 0, 0, 0, 1), this;
    }
    makeShear(t, e, r, i, s1, o) {
        return this.set(1, r, s1, 0, t, 1, o, 0, e, i, 1, 0, 0, 0, 0, 1), this;
    }
    compose(t, e, r) {
        let i = this.elements, s1 = e._x, o = e._y, a = e._z, l = e._w, c = s1 + s1, u1 = o + o, h = a + a, d = s1 * c, f = s1 * u1, m = s1 * h, p = o * u1, g = o * h, y = a * h, x = l * c, v = l * u1, b = l * h, w = r.x, A = r.y, T = r.z;
        return i[0] = (1 - (p + y)) * w, i[1] = (f + b) * w, i[2] = (m - v) * w, i[3] = 0, i[4] = (f - b) * A, i[5] = (1 - (d + y)) * A, i[6] = (g + x) * A, i[7] = 0, i[8] = (m + v) * T, i[9] = (g - x) * T, i[10] = (1 - (d + p)) * T, i[11] = 0, i[12] = t.x, i[13] = t.y, i[14] = t.z, i[15] = 1, this;
    }
    decompose(t, e, r) {
        let i = this.elements, s1 = Vu.set(i[0], i[1], i[2]).length(), o = Vu.set(i[4], i[5], i[6]).length(), a = Vu.set(i[8], i[9], i[10]).length();
        this.determinant() < 0 && (s1 = -s1), t.x = i[12], t.y = i[13], t.z = i[14], ks.copy(this);
        let c = 1 / s1, u1 = 1 / o, h = 1 / a;
        return ks.elements[0] *= c, ks.elements[1] *= c, ks.elements[2] *= c, ks.elements[4] *= u1, ks.elements[5] *= u1, ks.elements[6] *= u1, ks.elements[8] *= h, ks.elements[9] *= h, ks.elements[10] *= h, e.setFromRotationMatrix(ks), r.x = s1, r.y = o, r.z = a, this;
    }
    makePerspective(t, e, r, i, s1, o) {
        let a = this.elements, l = 2 * s1 / (e - t), c = 2 * s1 / (r - i), u1 = (e + t) / (e - t), h = (r + i) / (r - i), d = -(o + s1) / (o - s1), f = -2 * o * s1 / (o - s1);
        return a[0] = l, a[4] = 0, a[8] = u1, a[12] = 0, a[1] = 0, a[5] = c, a[9] = h, a[13] = 0, a[2] = 0, a[6] = 0, a[10] = d, a[14] = f, a[3] = 0, a[7] = 0, a[11] = -1, a[15] = 0, this;
    }
    makeOrthographic(t, e, r, i, s1, o) {
        let a = this.elements, l = 1 / (e - t), c = 1 / (r - i), u1 = 1 / (o - s1), h = (e + t) * l, d = (r + i) * c, f = (o + s1) * u1;
        return a[0] = 2 * l, a[4] = 0, a[8] = 0, a[12] = -h, a[1] = 0, a[5] = 2 * c, a[9] = 0, a[13] = -d, a[2] = 0, a[6] = 0, a[10] = -2 * u1, a[14] = -f, a[3] = 0, a[7] = 0, a[11] = 0, a[15] = 1, this;
    }
    equals(t) {
        let e = this.elements, r = t.elements;
        for(let i = 0; i < 16; i++)if (e[i] !== r[i]) return !1;
        return !0;
    }
    fromArray(t, e = 0) {
        for(let r = 0; r < 16; r++)this.elements[r] = t[r + e];
        return this;
    }
    toArray(t = [], e = 0) {
        let r = this.elements;
        return t[e] = r[0], t[e + 1] = r[1], t[e + 2] = r[2], t[e + 3] = r[3], t[e + 4] = r[4], t[e + 5] = r[5], t[e + 6] = r[6], t[e + 7] = r[7], t[e + 8] = r[8], t[e + 9] = r[9], t[e + 10] = r[10], t[e + 11] = r[11], t[e + 12] = r[12], t[e + 13] = r[13], t[e + 14] = r[14], t[e + 15] = r[15], t;
    }
}, Vu = new E, ks = new ue, mk = new E(0, 0, 0), gk = new E(1, 1, 1), fl = new E, hy = new E, Qn = new E, rP = new ue, iP = new Ye, Jt = class {
    constructor(t = 0, e = 0, r = 0, i = Jt.DEFAULT_ORDER){
        this.isEuler = !0, this._x = t, this._y = e, this._z = r, this._order = i;
    }
    get x() {
        return this._x;
    }
    set x(t) {
        this._x = t, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(t) {
        this._y = t, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(t) {
        this._z = t, this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(t) {
        this._order = t, this._onChangeCallback();
    }
    set(t, e, r, i = this._order) {
        return this._x = t, this._y = e, this._z = r, this._order = i, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(t) {
        return this._x = t._x, this._y = t._y, this._z = t._z, this._order = t._order, this._onChangeCallback(), this;
    }
    setFromRotationMatrix(t, e = this._order, r = !0) {
        let i = t.elements, s1 = i[0], o = i[4], a = i[8], l = i[1], c = i[5], u1 = i[9], h = i[2], d = i[6], f = i[10];
        switch(e){
            case "XYZ":
                this._y = Math.asin(yi(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(-u1, f), this._z = Math.atan2(-o, s1)) : (this._x = Math.atan2(d, c), this._z = 0);
                break;
            case "YXZ":
                this._x = Math.asin(-yi(u1, -1, 1)), Math.abs(u1) < .9999999 ? (this._y = Math.atan2(a, f), this._z = Math.atan2(l, c)) : (this._y = Math.atan2(-h, s1), this._z = 0);
                break;
            case "ZXY":
                this._x = Math.asin(yi(d, -1, 1)), Math.abs(d) < .9999999 ? (this._y = Math.atan2(-h, f), this._z = Math.atan2(-o, c)) : (this._y = 0, this._z = Math.atan2(l, s1));
                break;
            case "ZYX":
                this._y = Math.asin(-yi(h, -1, 1)), Math.abs(h) < .9999999 ? (this._x = Math.atan2(d, f), this._z = Math.atan2(l, s1)) : (this._x = 0, this._z = Math.atan2(-o, c));
                break;
            case "YZX":
                this._z = Math.asin(yi(l, -1, 1)), Math.abs(l) < .9999999 ? (this._x = Math.atan2(-u1, c), this._y = Math.atan2(-h, s1)) : (this._x = 0, this._y = Math.atan2(a, f));
                break;
            case "XZY":
                this._z = Math.asin(-yi(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(d, c), this._y = Math.atan2(a, s1)) : (this._x = Math.atan2(-u1, f), this._y = 0);
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + e);
        }
        return this._order = e, r === !0 && this._onChangeCallback(), this;
    }
    setFromQuaternion(t, e, r) {
        return rP.makeRotationFromQuaternion(t), this.setFromRotationMatrix(rP, e, r);
    }
    setFromVector3(t, e = this._order) {
        return this.set(t.x, t.y, t.z, e);
    }
    reorder(t) {
        return iP.setFromEuler(this), this.setFromQuaternion(iP, t);
    }
    equals(t) {
        return t._x === this._x && t._y === this._y && t._z === this._z && t._order === this._order;
    }
    fromArray(t) {
        return this._x = t[0], this._y = t[1], this._z = t[2], t[3] !== void 0 && (this._order = t[3]), this._onChangeCallback(), this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._order, t;
    }
    _onChange(t) {
        return this._onChangeCallback = t, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._order;
    }
};
Jt.DEFAULT_ORDER = "XYZ";
var Vp = class {
    constructor(){
        this.mask = 1;
    }
    set(t) {
        this.mask = (1 << t | 0) >>> 0;
    }
    enable(t) {
        this.mask |= 1 << t | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(t) {
        this.mask ^= 1 << t | 0;
    }
    disable(t) {
        this.mask &= ~(1 << t | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(t) {
        return (this.mask & t.mask) !== 0;
    }
    isEnabled(t) {
        return (this.mask & (1 << t | 0)) !== 0;
    }
}, yk = 0, nP = new E, Uu = new Ye, Sa = new ue, dy = new E, Sp = new E, vk = new E, xk = new Ye, sP = new E(1, 0, 0), oP = new E(0, 1, 0), aP = new E(0, 0, 1), bk = {
    type: "added"
}, lP = {
    type: "removed"
}, Dt = class extends ar {
    constructor(){
        super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
            value: yk++
        }), this.uuid = fs(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = Dt.DEFAULT_UP.clone();
        let t = new E, e = new Jt, r = new Ye, i = new E(1, 1, 1);
        function s1() {
            r.setFromEuler(e, !1);
        }
        function o() {
            e.setFromQuaternion(r, void 0, !1);
        }
        e._onChange(s1), r._onChange(o), Object.defineProperties(this, {
            position: {
                configurable: !0,
                enumerable: !0,
                value: t
            },
            rotation: {
                configurable: !0,
                enumerable: !0,
                value: e
            },
            quaternion: {
                configurable: !0,
                enumerable: !0,
                value: r
            },
            scale: {
                configurable: !0,
                enumerable: !0,
                value: i
            },
            modelViewMatrix: {
                value: new ue
            },
            normalMatrix: {
                value: new Sr
            }
        }), this.matrix = new ue, this.matrixWorld = new ue, this.matrixAutoUpdate = Dt.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.matrixWorldAutoUpdate = Dt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.layers = new Vp, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(t) {
        this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t), this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(t) {
        return this.quaternion.premultiply(t), this;
    }
    setRotationFromAxisAngle(t, e) {
        this.quaternion.setFromAxisAngle(t, e);
    }
    setRotationFromEuler(t) {
        this.quaternion.setFromEuler(t, !0);
    }
    setRotationFromMatrix(t) {
        this.quaternion.setFromRotationMatrix(t);
    }
    setRotationFromQuaternion(t) {
        this.quaternion.copy(t);
    }
    rotateOnAxis(t, e) {
        return Uu.setFromAxisAngle(t, e), this.quaternion.multiply(Uu), this;
    }
    rotateOnWorldAxis(t, e) {
        return Uu.setFromAxisAngle(t, e), this.quaternion.premultiply(Uu), this;
    }
    rotateX(t) {
        return this.rotateOnAxis(sP, t);
    }
    rotateY(t) {
        return this.rotateOnAxis(oP, t);
    }
    rotateZ(t) {
        return this.rotateOnAxis(aP, t);
    }
    translateOnAxis(t, e) {
        return nP.copy(t).applyQuaternion(this.quaternion), this.position.add(nP.multiplyScalar(e)), this;
    }
    translateX(t) {
        return this.translateOnAxis(sP, t);
    }
    translateY(t) {
        return this.translateOnAxis(oP, t);
    }
    translateZ(t) {
        return this.translateOnAxis(aP, t);
    }
    localToWorld(t) {
        return this.updateWorldMatrix(!0, !1), t.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(t) {
        return this.updateWorldMatrix(!0, !1), t.applyMatrix4(Sa.copy(this.matrixWorld).invert());
    }
    lookAt(t, e, r) {
        t.isVector3 ? dy.copy(t) : dy.set(t, e, r);
        let i = this.parent;
        this.updateWorldMatrix(!0, !1), Sp.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? Sa.lookAt(Sp, dy, this.up) : Sa.lookAt(dy, Sp, this.up), this.quaternion.setFromRotationMatrix(Sa), i && (Sa.extractRotation(i.matrixWorld), Uu.setFromRotationMatrix(Sa), this.quaternion.premultiply(Uu.invert()));
    }
    add(t) {
        if (arguments.length > 1) {
            for(let e = 0; e < arguments.length; e++)this.add(arguments[e]);
            return this;
        }
        return t === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t), this) : (t && t.isObject3D ? (t.parent !== null && t.parent.remove(t), t.parent = this, this.children.push(t), t.dispatchEvent(bk)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t), this);
    }
    remove(t) {
        if (arguments.length > 1) {
            for(let r = 0; r < arguments.length; r++)this.remove(arguments[r]);
            return this;
        }
        let e = this.children.indexOf(t);
        return e !== -1 && (t.parent = null, this.children.splice(e, 1), t.dispatchEvent(lP)), this;
    }
    removeFromParent() {
        let t = this.parent;
        return t !== null && t.remove(this), this;
    }
    clear() {
        for(let t = 0; t < this.children.length; t++){
            let e = this.children[t];
            e.parent = null, e.dispatchEvent(lP);
        }
        return this.children.length = 0, this;
    }
    attach(t) {
        return this.updateWorldMatrix(!0, !1), Sa.copy(this.matrixWorld).invert(), t.parent !== null && (t.parent.updateWorldMatrix(!0, !1), Sa.multiply(t.parent.matrixWorld)), t.applyMatrix4(Sa), this.add(t), t.updateWorldMatrix(!1, !0), this;
    }
    getObjectById(t) {
        return this.getObjectByProperty("id", t);
    }
    getObjectByName(t) {
        return this.getObjectByProperty("name", t);
    }
    getObjectByProperty(t, e) {
        if (this[t] === e) return this;
        for(let r = 0, i = this.children.length; r < i; r++){
            let o = this.children[r].getObjectByProperty(t, e);
            if (o !== void 0) return o;
        }
    }
    getObjectsByProperty(t, e) {
        let r = [];
        this[t] === e && r.push(this);
        for(let i = 0, s1 = this.children.length; i < s1; i++){
            let o = this.children[i].getObjectsByProperty(t, e);
            o.length > 0 && (r = r.concat(o));
        }
        return r;
    }
    getWorldPosition(t) {
        return this.updateWorldMatrix(!0, !1), t.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(t) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Sp, t, vk), t;
    }
    getWorldScale(t) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Sp, xk, t), t;
    }
    getWorldDirection(t) {
        this.updateWorldMatrix(!0, !1);
        let e = this.matrixWorld.elements;
        return t.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(t) {
        t(this);
        let e = this.children;
        for(let r = 0, i = e.length; r < i; r++)e[r].traverse(t);
    }
    traverseVisible(t) {
        if (this.visible === !1) return;
        t(this);
        let e = this.children;
        for(let r = 0, i = e.length; r < i; r++)e[r].traverseVisible(t);
    }
    traverseAncestors(t) {
        let e = this.parent;
        e !== null && (t(e), e.traverseAncestors(t));
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
    }
    updateMatrixWorld(t) {
        this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t) && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, t = !0);
        let e = this.children;
        for(let r = 0, i = e.length; r < i; r++){
            let s1 = e[r];
            (s1.matrixWorldAutoUpdate === !0 || t === !0) && s1.updateMatrixWorld(t);
        }
    }
    updateWorldMatrix(t, e) {
        let r = this.parent;
        if (t === !0 && r !== null && r.matrixWorldAutoUpdate === !0 && r.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), e === !0) {
            let i = this.children;
            for(let s1 = 0, o = i.length; s1 < o; s1++){
                let a = i[s1];
                a.matrixWorldAutoUpdate === !0 && a.updateWorldMatrix(!1, !0);
            }
        }
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string", r = {};
        e && (t = {
            geometries: {},
            materials: {},
            textures: {},
            images: {},
            shapes: {},
            skeletons: {},
            animations: {},
            nodes: {}
        }, r.metadata = {
            version: 4.5,
            type: "Object",
            generator: "Object3D.toJSON"
        });
        let i = {};
        i.uuid = this.uuid, i.type = this.type, this.name !== "" && (i.name = this.name), this.castShadow === !0 && (i.castShadow = !0), this.receiveShadow === !0 && (i.receiveShadow = !0), this.visible === !1 && (i.visible = !1), this.frustumCulled === !1 && (i.frustumCulled = !1), this.renderOrder !== 0 && (i.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), this.matrixAutoUpdate === !1 && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (i.instanceColor = this.instanceColor.toJSON()));
        function s1(a, l) {
            return a[l.uuid] === void 0 && (a[l.uuid] = l.toJSON(t)), l.uuid;
        }
        if (this.isScene) this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(t).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (i.environment = this.environment.toJSON(t).uuid);
        else if (this.isMesh || this.isLine || this.isPoints) {
            i.geometry = s1(t.geometries, this.geometry);
            let a = this.geometry.parameters;
            if (a !== void 0 && a.shapes !== void 0) {
                let l = a.shapes;
                if (Array.isArray(l)) for(let c = 0, u1 = l.length; c < u1; c++){
                    let h = l[c];
                    s1(t.shapes, h);
                }
                else s1(t.shapes, l);
            }
        }
        if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (s1(t.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), this.material !== void 0) {
            if (Array.isArray(this.material)) {
                let a = [];
                for(let l = 0, c = this.material.length; l < c; l++)a.push(s1(t.materials, this.material[l]));
                i.material = a;
            } else i.material = s1(t.materials, this.material);
        }
        if (this.children.length > 0) {
            i.children = [];
            for(let a = 0; a < this.children.length; a++)i.children.push(this.children[a].toJSON(t).object);
        }
        if (this.animations.length > 0) {
            i.animations = [];
            for(let a = 0; a < this.animations.length; a++){
                let l = this.animations[a];
                i.animations.push(s1(t.animations, l));
            }
        }
        if (e) {
            let a = o(t.geometries), l = o(t.materials), c = o(t.textures), u1 = o(t.images), h = o(t.shapes), d = o(t.skeletons), f = o(t.animations), m = o(t.nodes);
            a.length > 0 && (r.geometries = a), l.length > 0 && (r.materials = l), c.length > 0 && (r.textures = c), u1.length > 0 && (r.images = u1), h.length > 0 && (r.shapes = h), d.length > 0 && (r.skeletons = d), f.length > 0 && (r.animations = f), m.length > 0 && (r.nodes = m);
        }
        return r.object = i, r;
        function o(a) {
            let l = [];
            for(let c in a){
                let u1 = a[c];
                delete u1.metadata, l.push(u1);
            }
            return l;
        }
    }
    clone(t) {
        return new this.constructor().copy(this, t);
    }
    copy(t, e = !0) {
        if (this.name = t.name, this.up.copy(t.up), this.position.copy(t.position), this.rotation.order = t.rotation.order, this.quaternion.copy(t.quaternion), this.scale.copy(t.scale), this.matrix.copy(t.matrix), this.matrixWorld.copy(t.matrixWorld), this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrixWorldNeedsUpdate = t.matrixWorldNeedsUpdate, this.matrixWorldAutoUpdate = t.matrixWorldAutoUpdate, this.layers.mask = t.layers.mask, this.visible = t.visible, this.castShadow = t.castShadow, this.receiveShadow = t.receiveShadow, this.frustumCulled = t.frustumCulled, this.renderOrder = t.renderOrder, this.userData = JSON.parse(JSON.stringify(t.userData)), e === !0) for(let r = 0; r < t.children.length; r++){
            let i = t.children[r];
            this.add(i.clone());
        }
        return this;
    }
};
Dt.DEFAULT_UP = new E(0, 1, 0);
Dt.DEFAULT_MATRIX_AUTO_UPDATE = !0;
Dt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
var zs = new E, wa = new E, AS = new E, Aa = new E, ku = new E, zu = new E, cP = new E, ES = new E, TS = new E, MS = new E, Or = class {
    constructor(t = new E, e = new E, r = new E){
        this.a = t, this.b = e, this.c = r;
    }
    static getNormal(t, e, r, i) {
        i.subVectors(r, e), zs.subVectors(t, e), i.cross(zs);
        let s1 = i.lengthSq();
        return s1 > 0 ? i.multiplyScalar(1 / Math.sqrt(s1)) : i.set(0, 0, 0);
    }
    static getBarycoord(t, e, r, i, s1) {
        zs.subVectors(i, e), wa.subVectors(r, e), AS.subVectors(t, e);
        let o = zs.dot(zs), a = zs.dot(wa), l = zs.dot(AS), c = wa.dot(wa), u1 = wa.dot(AS), h = o * c - a * a;
        if (h === 0) return s1.set(-2, -1, -1);
        let d = 1 / h, f = (c * l - a * u1) * d, m = (o * u1 - a * l) * d;
        return s1.set(1 - f - m, m, f);
    }
    static containsPoint(t, e, r, i) {
        return this.getBarycoord(t, e, r, i, Aa), Aa.x >= 0 && Aa.y >= 0 && Aa.x + Aa.y <= 1;
    }
    static getUV(t, e, r, i, s1, o, a, l) {
        return this.getBarycoord(t, e, r, i, Aa), l.set(0, 0), l.addScaledVector(s1, Aa.x), l.addScaledVector(o, Aa.y), l.addScaledVector(a, Aa.z), l;
    }
    static isFrontFacing(t, e, r, i) {
        return zs.subVectors(r, e), wa.subVectors(t, e), zs.cross(wa).dot(i) < 0;
    }
    set(t, e, r) {
        return this.a.copy(t), this.b.copy(e), this.c.copy(r), this;
    }
    setFromPointsAndIndices(t, e, r, i) {
        return this.a.copy(t[e]), this.b.copy(t[r]), this.c.copy(t[i]), this;
    }
    setFromAttributeAndIndices(t, e, r, i) {
        return this.a.fromBufferAttribute(t, e), this.b.fromBufferAttribute(t, r), this.c.fromBufferAttribute(t, i), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.a.copy(t.a), this.b.copy(t.b), this.c.copy(t.c), this;
    }
    getArea() {
        return zs.subVectors(this.c, this.b), wa.subVectors(this.a, this.b), zs.cross(wa).length() * .5;
    }
    getMidpoint(t) {
        return t.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(t) {
        return Or.getNormal(this.a, this.b, this.c, t);
    }
    getPlane(t) {
        return t.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(t, e) {
        return Or.getBarycoord(t, this.a, this.b, this.c, e);
    }
    getUV(t, e, r, i, s1) {
        return Or.getUV(t, this.a, this.b, this.c, e, r, i, s1);
    }
    containsPoint(t) {
        return Or.containsPoint(t, this.a, this.b, this.c);
    }
    isFrontFacing(t) {
        return Or.isFrontFacing(this.a, this.b, this.c, t);
    }
    intersectsBox(t) {
        return t.intersectsTriangle(this);
    }
    closestPointToPoint(t, e) {
        let r = this.a, i = this.b, s1 = this.c, o, a;
        ku.subVectors(i, r), zu.subVectors(s1, r), ES.subVectors(t, r);
        let l = ku.dot(ES), c = zu.dot(ES);
        if (l <= 0 && c <= 0) return e.copy(r);
        TS.subVectors(t, i);
        let u1 = ku.dot(TS), h = zu.dot(TS);
        if (u1 >= 0 && h <= u1) return e.copy(i);
        let d = l * h - u1 * c;
        if (d <= 0 && l >= 0 && u1 <= 0) return o = l / (l - u1), e.copy(r).addScaledVector(ku, o);
        MS.subVectors(t, s1);
        let f = ku.dot(MS), m = zu.dot(MS);
        if (m >= 0 && f <= m) return e.copy(s1);
        let p = f * c - l * m;
        if (p <= 0 && c >= 0 && m <= 0) return a = c / (c - m), e.copy(r).addScaledVector(zu, a);
        let g = u1 * m - f * h;
        if (g <= 0 && h - u1 >= 0 && f - m >= 0) return cP.subVectors(s1, i), a = (h - u1) / (h - u1 + (f - m)), e.copy(i).addScaledVector(cP, a);
        let y = 1 / (g + p + d);
        return o = p * y, a = d * y, e.copy(r).addScaledVector(ku, o).addScaledVector(zu, a);
    }
    equals(t) {
        return t.a.equals(this.a) && t.b.equals(this.b) && t.c.equals(this.c);
    }
}, Sk = 0, Fc = class extends ar {
    constructor(){
        super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
            value: Sk++
        }), this.uuid = fs(), this.name = "", this.type = "Material", this.blending = ml, this.side = Jn, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.blendSrc = t_, this.blendDst = r_, this.blendEquation = Yu, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.depthFunc = zS, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = ZU, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = hS, this.stencilZFail = hS, this.stencilZPass = hS, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(t) {
        this._alphaTest > 0 != t > 0 && this.version++, this._alphaTest = t;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(t) {
        if (t !== void 0) for(let e in t){
            let r = t[e];
            if (r === void 0) {
                console.warn("THREE.Material: '" + e + "' parameter is undefined.");
                continue;
            }
            let i = this[e];
            if (i === void 0) {
                console.warn("THREE." + this.type + ": '" + e + "' is not a property of this material.");
                continue;
            }
            i && i.isColor ? i.set(r) : i && i.isVector3 && r && r.isVector3 ? i.copy(r) : this[e] = r;
        }
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string";
        e && (t = {
            textures: {},
            images: {}
        });
        let r = {
            metadata: {
                version: 4.5,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        r.uuid = this.uuid, r.type = this.type, this.name !== "" && (r.name = this.name), this.color && this.color.isColor && (r.color = this.color.getHex()), this.roughness !== void 0 && (r.roughness = this.roughness), this.metalness !== void 0 && (r.metalness = this.metalness), this.sheen !== void 0 && (r.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (r.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (r.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (r.emissive = this.emissive.getHex()), this.emissiveIntensity && this.emissiveIntensity !== 1 && (r.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (r.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (r.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (r.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (r.shininess = this.shininess), this.clearcoat !== void 0 && (r.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (r.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (r.clearcoatMap = this.clearcoatMap.toJSON(t).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (r.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (r.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t).uuid, r.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.iridescence !== void 0 && (r.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (r.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (r.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (r.iridescenceMap = this.iridescenceMap.toJSON(t).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (r.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(t).uuid), this.map && this.map.isTexture && (r.map = this.map.toJSON(t).uuid), this.matcap && this.matcap.isTexture && (r.matcap = this.matcap.toJSON(t).uuid), this.alphaMap && this.alphaMap.isTexture && (r.alphaMap = this.alphaMap.toJSON(t).uuid), this.lightMap && this.lightMap.isTexture && (r.lightMap = this.lightMap.toJSON(t).uuid, r.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (r.aoMap = this.aoMap.toJSON(t).uuid, r.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (r.bumpMap = this.bumpMap.toJSON(t).uuid, r.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (r.normalMap = this.normalMap.toJSON(t).uuid, r.normalMapType = this.normalMapType, r.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (r.displacementMap = this.displacementMap.toJSON(t).uuid, r.displacementScale = this.displacementScale, r.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (r.roughnessMap = this.roughnessMap.toJSON(t).uuid), this.metalnessMap && this.metalnessMap.isTexture && (r.metalnessMap = this.metalnessMap.toJSON(t).uuid), this.emissiveMap && this.emissiveMap.isTexture && (r.emissiveMap = this.emissiveMap.toJSON(t).uuid), this.specularMap && this.specularMap.isTexture && (r.specularMap = this.specularMap.toJSON(t).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (r.specularIntensityMap = this.specularIntensityMap.toJSON(t).uuid), this.specularColorMap && this.specularColorMap.isTexture && (r.specularColorMap = this.specularColorMap.toJSON(t).uuid), this.envMap && this.envMap.isTexture && (r.envMap = this.envMap.toJSON(t).uuid, this.combine !== void 0 && (r.combine = this.combine)), this.envMapIntensity !== void 0 && (r.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (r.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (r.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (r.gradientMap = this.gradientMap.toJSON(t).uuid), this.transmission !== void 0 && (r.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (r.transmissionMap = this.transmissionMap.toJSON(t).uuid), this.thickness !== void 0 && (r.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (r.thicknessMap = this.thicknessMap.toJSON(t).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (r.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (r.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (r.size = this.size), this.shadowSide !== null && (r.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (r.sizeAttenuation = this.sizeAttenuation), this.blending !== ml && (r.blending = this.blending), this.side !== Jn && (r.side = this.side), this.vertexColors && (r.vertexColors = !0), this.opacity < 1 && (r.opacity = this.opacity), this.transparent === !0 && (r.transparent = this.transparent), r.depthFunc = this.depthFunc, r.depthTest = this.depthTest, r.depthWrite = this.depthWrite, r.colorWrite = this.colorWrite, r.stencilWrite = this.stencilWrite, r.stencilWriteMask = this.stencilWriteMask, r.stencilFunc = this.stencilFunc, r.stencilRef = this.stencilRef, r.stencilFuncMask = this.stencilFuncMask, r.stencilFail = this.stencilFail, r.stencilZFail = this.stencilZFail, r.stencilZPass = this.stencilZPass, this.rotation !== void 0 && this.rotation !== 0 && (r.rotation = this.rotation), this.polygonOffset === !0 && (r.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (r.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (r.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (r.linewidth = this.linewidth), this.dashSize !== void 0 && (r.dashSize = this.dashSize), this.gapSize !== void 0 && (r.gapSize = this.gapSize), this.scale !== void 0 && (r.scale = this.scale), this.dithering === !0 && (r.dithering = !0), this.alphaTest > 0 && (r.alphaTest = this.alphaTest), this.alphaToCoverage === !0 && (r.alphaToCoverage = this.alphaToCoverage), this.premultipliedAlpha === !0 && (r.premultipliedAlpha = this.premultipliedAlpha), this.forceSinglePass === !0 && (r.forceSinglePass = this.forceSinglePass), this.wireframe === !0 && (r.wireframe = this.wireframe), this.wireframeLinewidth > 1 && (r.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (r.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (r.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (r.flatShading = this.flatShading), this.visible === !1 && (r.visible = !1), this.toneMapped === !1 && (r.toneMapped = !1), this.fog === !1 && (r.fog = !1), Object.keys(this.userData).length > 0 && (r.userData = this.userData);
        function i(s1) {
            let o = [];
            for(let a in s1){
                let l = s1[a];
                delete l.metadata, o.push(l);
            }
            return o;
        }
        if (e) {
            let s1 = i(t.textures), o = i(t.images);
            s1.length > 0 && (r.textures = s1), o.length > 0 && (r.images = o);
        }
        return r;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.name = t.name, this.blending = t.blending, this.side = t.side, this.vertexColors = t.vertexColors, this.opacity = t.opacity, this.transparent = t.transparent, this.blendSrc = t.blendSrc, this.blendDst = t.blendDst, this.blendEquation = t.blendEquation, this.blendSrcAlpha = t.blendSrcAlpha, this.blendDstAlpha = t.blendDstAlpha, this.blendEquationAlpha = t.blendEquationAlpha, this.depthFunc = t.depthFunc, this.depthTest = t.depthTest, this.depthWrite = t.depthWrite, this.stencilWriteMask = t.stencilWriteMask, this.stencilFunc = t.stencilFunc, this.stencilRef = t.stencilRef, this.stencilFuncMask = t.stencilFuncMask, this.stencilFail = t.stencilFail, this.stencilZFail = t.stencilZFail, this.stencilZPass = t.stencilZPass, this.stencilWrite = t.stencilWrite;
        let e = t.clippingPlanes, r = null;
        if (e !== null) {
            let i = e.length;
            r = new Array(i);
            for(let s1 = 0; s1 !== i; ++s1)r[s1] = e[s1].clone();
        }
        return this.clippingPlanes = r, this.clipIntersection = t.clipIntersection, this.clipShadows = t.clipShadows, this.shadowSide = t.shadowSide, this.colorWrite = t.colorWrite, this.precision = t.precision, this.polygonOffset = t.polygonOffset, this.polygonOffsetFactor = t.polygonOffsetFactor, this.polygonOffsetUnits = t.polygonOffsetUnits, this.dithering = t.dithering, this.alphaTest = t.alphaTest, this.alphaToCoverage = t.alphaToCoverage, this.premultipliedAlpha = t.premultipliedAlpha, this.forceSinglePass = t.forceSinglePass, this.visible = t.visible, this.toneMapped = t.toneMapped, this.userData = JSON.parse(JSON.stringify(t.userData)), this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
}, un = class extends Fc {
    constructor(t){
        super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Ge(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = i_, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.fog = t.fog, this;
    }
}, gi = new E, fy = new U, je = class {
    constructor(t, e, r = !1){
        if (Array.isArray(t)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = !0, this.name = "", this.array = t, this.itemSize = e, this.count = t !== void 0 ? t.length / e : 0, this.normalized = r, this.usage = WS, this.updateRange = {
            offset: 0,
            count: -1
        }, this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
    setUsage(t) {
        return this.usage = t, this;
    }
    copy(t) {
        return this.name = t.name, this.array = new t.array.constructor(t.array), this.itemSize = t.itemSize, this.count = t.count, this.normalized = t.normalized, this.usage = t.usage, this;
    }
    copyAt(t, e, r) {
        t *= this.itemSize, r *= e.itemSize;
        for(let i = 0, s1 = this.itemSize; i < s1; i++)this.array[t + i] = e.array[r + i];
        return this;
    }
    copyArray(t) {
        return this.array.set(t), this;
    }
    applyMatrix3(t) {
        if (this.itemSize === 2) for(let e = 0, r = this.count; e < r; e++)fy.fromBufferAttribute(this, e), fy.applyMatrix3(t), this.setXY(e, fy.x, fy.y);
        else if (this.itemSize === 3) for(let e = 0, r = this.count; e < r; e++)gi.fromBufferAttribute(this, e), gi.applyMatrix3(t), this.setXYZ(e, gi.x, gi.y, gi.z);
        return this;
    }
    applyMatrix4(t) {
        for(let e = 0, r = this.count; e < r; e++)gi.fromBufferAttribute(this, e), gi.applyMatrix4(t), this.setXYZ(e, gi.x, gi.y, gi.z);
        return this;
    }
    applyNormalMatrix(t) {
        for(let e = 0, r = this.count; e < r; e++)gi.fromBufferAttribute(this, e), gi.applyNormalMatrix(t), this.setXYZ(e, gi.x, gi.y, gi.z);
        return this;
    }
    transformDirection(t) {
        for(let e = 0, r = this.count; e < r; e++)gi.fromBufferAttribute(this, e), gi.transformDirection(t), this.setXYZ(e, gi.x, gi.y, gi.z);
        return this;
    }
    set(t, e = 0) {
        return this.array.set(t, e), this;
    }
    getX(t) {
        let e = this.array[t * this.itemSize];
        return this.normalized && (e = Ma(e, this.array)), e;
    }
    setX(t, e) {
        return this.normalized && (e = Ar(e, this.array)), this.array[t * this.itemSize] = e, this;
    }
    getY(t) {
        let e = this.array[t * this.itemSize + 1];
        return this.normalized && (e = Ma(e, this.array)), e;
    }
    setY(t, e) {
        return this.normalized && (e = Ar(e, this.array)), this.array[t * this.itemSize + 1] = e, this;
    }
    getZ(t) {
        let e = this.array[t * this.itemSize + 2];
        return this.normalized && (e = Ma(e, this.array)), e;
    }
    setZ(t, e) {
        return this.normalized && (e = Ar(e, this.array)), this.array[t * this.itemSize + 2] = e, this;
    }
    getW(t) {
        let e = this.array[t * this.itemSize + 3];
        return this.normalized && (e = Ma(e, this.array)), e;
    }
    setW(t, e) {
        return this.normalized && (e = Ar(e, this.array)), this.array[t * this.itemSize + 3] = e, this;
    }
    setXY(t, e, r) {
        return t *= this.itemSize, this.normalized && (e = Ar(e, this.array), r = Ar(r, this.array)), this.array[t + 0] = e, this.array[t + 1] = r, this;
    }
    setXYZ(t, e, r, i) {
        return t *= this.itemSize, this.normalized && (e = Ar(e, this.array), r = Ar(r, this.array), i = Ar(i, this.array)), this.array[t + 0] = e, this.array[t + 1] = r, this.array[t + 2] = i, this;
    }
    setXYZW(t, e, r, i, s1) {
        return t *= this.itemSize, this.normalized && (e = Ar(e, this.array), r = Ar(r, this.array), i = Ar(i, this.array), s1 = Ar(s1, this.array)), this.array[t + 0] = e, this.array[t + 1] = r, this.array[t + 2] = i, this.array[t + 3] = s1, this;
    }
    onUpload(t) {
        return this.onUploadCallback = t, this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        let t = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        return this.name !== "" && (t.name = this.name), this.usage !== WS && (t.usage = this.usage), (this.updateRange.offset !== 0 || this.updateRange.count !== -1) && (t.updateRange = this.updateRange), t;
    }
    copyColorsArray() {
        console.error("THREE.BufferAttribute: copyColorsArray() was removed in r144.");
    }
    copyVector2sArray() {
        console.error("THREE.BufferAttribute: copyVector2sArray() was removed in r144.");
    }
    copyVector3sArray() {
        console.error("THREE.BufferAttribute: copyVector3sArray() was removed in r144.");
    }
    copyVector4sArray() {
        console.error("THREE.BufferAttribute: copyVector4sArray() was removed in r144.");
    }
};
var Gy = class extends je {
    constructor(t, e, r){
        super(new Uint16Array(t), e, r);
    }
};
var To = class extends je {
    constructor(t, e, r){
        super(new Uint32Array(t), e, r);
    }
};
var Te = class extends je {
    constructor(t, e, r){
        super(new Float32Array(t), e, r);
    }
};
var wk = 0, ds = new ue, CS = new Dt, Gu = new E, Zn = new Yt, wp = new Yt, ki = new E, Ce = class extends ar {
    constructor(){
        super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
            value: wk++
        }), this.uuid = fs(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
            start: 0,
            count: 1 / 0
        }, this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(t) {
        return Array.isArray(t) ? this.index = new (l_(t) ? To : Gy)(t, 1) : this.index = t, this;
    }
    getAttribute(t) {
        return this.attributes[t];
    }
    setAttribute(t, e) {
        return this.attributes[t] = e, this;
    }
    deleteAttribute(t) {
        return delete this.attributes[t], this;
    }
    hasAttribute(t) {
        return this.attributes[t] !== void 0;
    }
    addGroup(t, e, r = 0) {
        this.groups.push({
            start: t,
            count: e,
            materialIndex: r
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(t, e) {
        this.drawRange.start = t, this.drawRange.count = e;
    }
    applyMatrix4(t) {
        let e = this.attributes.position;
        e !== void 0 && (e.applyMatrix4(t), e.needsUpdate = !0);
        let r = this.attributes.normal;
        if (r !== void 0) {
            let s1 = new Sr().getNormalMatrix(t);
            r.applyNormalMatrix(s1), r.needsUpdate = !0;
        }
        let i = this.attributes.tangent;
        return i !== void 0 && (i.transformDirection(t), i.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
    }
    applyQuaternion(t) {
        return ds.makeRotationFromQuaternion(t), this.applyMatrix4(ds), this;
    }
    rotateX(t) {
        return ds.makeRotationX(t), this.applyMatrix4(ds), this;
    }
    rotateY(t) {
        return ds.makeRotationY(t), this.applyMatrix4(ds), this;
    }
    rotateZ(t) {
        return ds.makeRotationZ(t), this.applyMatrix4(ds), this;
    }
    translate(t, e, r) {
        return ds.makeTranslation(t, e, r), this.applyMatrix4(ds), this;
    }
    scale(t, e, r) {
        return ds.makeScale(t, e, r), this.applyMatrix4(ds), this;
    }
    lookAt(t) {
        return CS.lookAt(t), CS.updateMatrix(), this.applyMatrix4(CS.matrix), this;
    }
    center() {
        return this.computeBoundingBox(), this.boundingBox.getCenter(Gu).negate(), this.translate(Gu.x, Gu.y, Gu.z), this;
    }
    setFromPoints(t) {
        let e = [];
        for(let r = 0, i = t.length; r < i; r++){
            let s1 = t[r];
            e.push(s1.x, s1.y, s1.z || 0);
        }
        return this.setAttribute("position", new Te(e, 3)), this;
    }
    computeBoundingBox() {
        this.boundingBox === null && (this.boundingBox = new Yt);
        let t = this.attributes.position, e = this.morphAttributes.position;
        if (t && t.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingBox.set(new E(-1 / 0, -1 / 0, -1 / 0), new E(1 / 0, 1 / 0, 1 / 0));
            return;
        }
        if (t !== void 0) {
            if (this.boundingBox.setFromBufferAttribute(t), e) for(let r = 0, i = e.length; r < i; r++){
                let s1 = e[r];
                Zn.setFromBufferAttribute(s1), this.morphTargetsRelative ? (ki.addVectors(this.boundingBox.min, Zn.min), this.boundingBox.expandByPoint(ki), ki.addVectors(this.boundingBox.max, Zn.max), this.boundingBox.expandByPoint(ki)) : (this.boundingBox.expandByPoint(Zn.min), this.boundingBox.expandByPoint(Zn.max));
            }
        } else this.boundingBox.makeEmpty();
        (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        this.boundingSphere === null && (this.boundingSphere = new ei);
        let t = this.attributes.position, e = this.morphAttributes.position;
        if (t && t.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingSphere.set(new E, 1 / 0);
            return;
        }
        if (t) {
            let r = this.boundingSphere.center;
            if (Zn.setFromBufferAttribute(t), e) for(let s1 = 0, o = e.length; s1 < o; s1++){
                let a = e[s1];
                wp.setFromBufferAttribute(a), this.morphTargetsRelative ? (ki.addVectors(Zn.min, wp.min), Zn.expandByPoint(ki), ki.addVectors(Zn.max, wp.max), Zn.expandByPoint(ki)) : (Zn.expandByPoint(wp.min), Zn.expandByPoint(wp.max));
            }
            Zn.getCenter(r);
            let i = 0;
            for(let s1 = 0, o = t.count; s1 < o; s1++)ki.fromBufferAttribute(t, s1), i = Math.max(i, r.distanceToSquared(ki));
            if (e) for(let s1 = 0, o = e.length; s1 < o; s1++){
                let a = e[s1], l = this.morphTargetsRelative;
                for(let c = 0, u1 = a.count; c < u1; c++)ki.fromBufferAttribute(a, c), l && (Gu.fromBufferAttribute(t, c), ki.add(Gu)), i = Math.max(i, r.distanceToSquared(ki));
            }
            this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        let t = this.index, e = this.attributes;
        if (t === null || e.position === void 0 || e.normal === void 0 || e.uv === void 0) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        let r = t.array, i = e.position.array, s1 = e.normal.array, o = e.uv.array, a = i.length / 3;
        this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new je(new Float32Array(4 * a), 4));
        let l = this.getAttribute("tangent").array, c = [], u1 = [];
        for(let C = 0; C < a; C++)c[C] = new E, u1[C] = new E;
        let h = new E, d = new E, f = new E, m = new U, p = new U, g = new U, y = new E, x = new E;
        function v(C, P, _) {
            h.fromArray(i, C * 3), d.fromArray(i, P * 3), f.fromArray(i, _ * 3), m.fromArray(o, C * 2), p.fromArray(o, P * 2), g.fromArray(o, _ * 2), d.sub(h), f.sub(h), p.sub(m), g.sub(m);
            let I = 1 / (p.x * g.y - g.x * p.y);
            !isFinite(I) || (y.copy(d).multiplyScalar(g.y).addScaledVector(f, -p.y).multiplyScalar(I), x.copy(f).multiplyScalar(p.x).addScaledVector(d, -g.x).multiplyScalar(I), c[C].add(y), c[P].add(y), c[_].add(y), u1[C].add(x), u1[P].add(x), u1[_].add(x));
        }
        let b = this.groups;
        b.length === 0 && (b = [
            {
                start: 0,
                count: r.length
            }
        ]);
        for(let C = 0, P = b.length; C < P; ++C){
            let _ = b[C], I = _.start, O = _.count;
            for(let L = I, j = I + O; L < j; L += 3)v(r[L + 0], r[L + 1], r[L + 2]);
        }
        let w = new E, A = new E, T = new E, S = new E;
        function M(C) {
            T.fromArray(s1, C * 3), S.copy(T);
            let P = c[C];
            w.copy(P), w.sub(T.multiplyScalar(T.dot(P))).normalize(), A.crossVectors(S, P);
            let I = A.dot(u1[C]) < 0 ? -1 : 1;
            l[C * 4] = w.x, l[C * 4 + 1] = w.y, l[C * 4 + 2] = w.z, l[C * 4 + 3] = I;
        }
        for(let C = 0, P = b.length; C < P; ++C){
            let _ = b[C], I = _.start, O = _.count;
            for(let L = I, j = I + O; L < j; L += 3)M(r[L + 0]), M(r[L + 1]), M(r[L + 2]);
        }
    }
    computeVertexNormals() {
        let t = this.index, e = this.getAttribute("position");
        if (e !== void 0) {
            let r = this.getAttribute("normal");
            if (r === void 0) r = new je(new Float32Array(e.count * 3), 3), this.setAttribute("normal", r);
            else for(let d = 0, f = r.count; d < f; d++)r.setXYZ(d, 0, 0, 0);
            let i = new E, s1 = new E, o = new E, a = new E, l = new E, c = new E, u1 = new E, h = new E;
            if (t) for(let d = 0, f = t.count; d < f; d += 3){
                let m = t.getX(d + 0), p = t.getX(d + 1), g = t.getX(d + 2);
                i.fromBufferAttribute(e, m), s1.fromBufferAttribute(e, p), o.fromBufferAttribute(e, g), u1.subVectors(o, s1), h.subVectors(i, s1), u1.cross(h), a.fromBufferAttribute(r, m), l.fromBufferAttribute(r, p), c.fromBufferAttribute(r, g), a.add(u1), l.add(u1), c.add(u1), r.setXYZ(m, a.x, a.y, a.z), r.setXYZ(p, l.x, l.y, l.z), r.setXYZ(g, c.x, c.y, c.z);
            }
            else for(let d = 0, f = e.count; d < f; d += 3)i.fromBufferAttribute(e, d + 0), s1.fromBufferAttribute(e, d + 1), o.fromBufferAttribute(e, d + 2), u1.subVectors(o, s1), h.subVectors(i, s1), u1.cross(h), r.setXYZ(d + 0, u1.x, u1.y, u1.z), r.setXYZ(d + 1, u1.x, u1.y, u1.z), r.setXYZ(d + 2, u1.x, u1.y, u1.z);
            this.normalizeNormals(), r.needsUpdate = !0;
        }
    }
    merge() {
        return console.error("THREE.BufferGeometry.merge() has been removed. Use THREE.BufferGeometryUtils.mergeBufferGeometries() instead."), this;
    }
    normalizeNormals() {
        let t = this.attributes.normal;
        for(let e = 0, r = t.count; e < r; e++)ki.fromBufferAttribute(t, e), ki.normalize(), t.setXYZ(e, ki.x, ki.y, ki.z);
    }
    toNonIndexed() {
        function t(a, l) {
            let c = a.array, u1 = a.itemSize, h = a.normalized, d = new c.constructor(l.length * u1), f = 0, m = 0;
            for(let p = 0, g = l.length; p < g; p++){
                a.isInterleavedBufferAttribute ? f = l[p] * a.data.stride + a.offset : f = l[p] * u1;
                for(let y = 0; y < u1; y++)d[m++] = c[f++];
            }
            return new je(d, u1, h);
        }
        if (this.index === null) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
        let e = new Ce, r = this.index.array, i = this.attributes;
        for(let a in i){
            let l = i[a], c = t(l, r);
            e.setAttribute(a, c);
        }
        let s1 = this.morphAttributes;
        for(let a in s1){
            let l = [], c = s1[a];
            for(let u1 = 0, h = c.length; u1 < h; u1++){
                let d = c[u1], f = t(d, r);
                l.push(f);
            }
            e.morphAttributes[a] = l;
        }
        e.morphTargetsRelative = this.morphTargetsRelative;
        let o = this.groups;
        for(let a = 0, l = o.length; a < l; a++){
            let c = o[a];
            e.addGroup(c.start, c.count, c.materialIndex);
        }
        return e;
    }
    toJSON() {
        let t = {
            metadata: {
                version: 4.5,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        if (t.uuid = this.uuid, t.type = this.type, this.name !== "" && (t.name = this.name), Object.keys(this.userData).length > 0 && (t.userData = this.userData), this.parameters !== void 0) {
            let l = this.parameters;
            for(let c in l)l[c] !== void 0 && (t[c] = l[c]);
            return t;
        }
        t.data = {
            attributes: {}
        };
        let e = this.index;
        e !== null && (t.data.index = {
            type: e.array.constructor.name,
            array: Array.prototype.slice.call(e.array)
        });
        let r = this.attributes;
        for(let l in r){
            let c = r[l];
            t.data.attributes[l] = c.toJSON(t.data);
        }
        let i = {}, s1 = !1;
        for(let l in this.morphAttributes){
            let c = this.morphAttributes[l], u1 = [];
            for(let h = 0, d = c.length; h < d; h++){
                let f = c[h];
                u1.push(f.toJSON(t.data));
            }
            u1.length > 0 && (i[l] = u1, s1 = !0);
        }
        s1 && (t.data.morphAttributes = i, t.data.morphTargetsRelative = this.morphTargetsRelative);
        let o = this.groups;
        o.length > 0 && (t.data.groups = JSON.parse(JSON.stringify(o)));
        let a = this.boundingSphere;
        return a !== null && (t.data.boundingSphere = {
            center: a.center.toArray(),
            radius: a.radius
        }), t;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
        let e = {};
        this.name = t.name;
        let r = t.index;
        r !== null && this.setIndex(r.clone(e));
        let i = t.attributes;
        for(let c in i){
            let u1 = i[c];
            this.setAttribute(c, u1.clone(e));
        }
        let s1 = t.morphAttributes;
        for(let c in s1){
            let u1 = [], h = s1[c];
            for(let d = 0, f = h.length; d < f; d++)u1.push(h[d].clone(e));
            this.morphAttributes[c] = u1;
        }
        this.morphTargetsRelative = t.morphTargetsRelative;
        let o = t.groups;
        for(let c = 0, u1 = o.length; c < u1; c++){
            let h = o[c];
            this.addGroup(h.start, h.count, h.materialIndex);
        }
        let a = t.boundingBox;
        a !== null && (this.boundingBox = a.clone());
        let l = t.boundingSphere;
        return l !== null && (this.boundingSphere = l.clone()), this.drawRange.start = t.drawRange.start, this.drawRange.count = t.drawRange.count, this.userData = t.userData, t.parameters !== void 0 && (this.parameters = Object.assign({}, t.parameters)), this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}, uP = new ue, ju = new Ws, PS = new ei, Ap = new E, Ep = new E, Tp = new E, _S = new E, py = new E, my = new U, gy = new U, yy = new U, IS = new E, vy = new E, Mt = class extends Dt {
    constructor(t = new Ce, e = new un){
        super(), this.isMesh = !0, this.type = "Mesh", this.geometry = t, this.material = e, this.updateMorphTargets();
    }
    copy(t, e) {
        return super.copy(t, e), t.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = t.morphTargetInfluences.slice()), t.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, t.morphTargetDictionary)), this.material = t.material, this.geometry = t.geometry, this;
    }
    updateMorphTargets() {
        let e = this.geometry.morphAttributes, r = Object.keys(e);
        if (r.length > 0) {
            let i = e[r[0]];
            if (i !== void 0) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let s1 = 0, o = i.length; s1 < o; s1++){
                    let a = i[s1].name || String(s1);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[a] = s1;
                }
            }
        }
    }
    getVertexPosition(t, e) {
        let r = this.geometry, i = r.attributes.position, s1 = r.morphAttributes.position, o = r.morphTargetsRelative;
        e.fromBufferAttribute(i, t);
        let a = this.morphTargetInfluences;
        if (s1 && a) {
            py.set(0, 0, 0);
            for(let l = 0, c = s1.length; l < c; l++){
                let u1 = a[l], h = s1[l];
                u1 !== 0 && (_S.fromBufferAttribute(h, t), o ? py.addScaledVector(_S, u1) : py.addScaledVector(_S.sub(e), u1));
            }
            e.add(py);
        }
        return this.isSkinnedMesh && this.boneTransform(t, e), e;
    }
    raycast(t, e) {
        let r = this.geometry, i = this.material, s1 = this.matrixWorld;
        if (i === void 0 || (r.boundingSphere === null && r.computeBoundingSphere(), PS.copy(r.boundingSphere), PS.applyMatrix4(s1), t.ray.intersectsSphere(PS) === !1) || (uP.copy(s1).invert(), ju.copy(t.ray).applyMatrix4(uP), r.boundingBox !== null && ju.intersectsBox(r.boundingBox) === !1)) return;
        let o, a = r.index, l = r.attributes.position, c = r.attributes.uv, u1 = r.attributes.uv2, h = r.groups, d = r.drawRange;
        if (a !== null) {
            if (Array.isArray(i)) for(let f = 0, m = h.length; f < m; f++){
                let p = h[f], g = i[p.materialIndex], y = Math.max(p.start, d.start), x = Math.min(a.count, Math.min(p.start + p.count, d.start + d.count));
                for(let v = y, b = x; v < b; v += 3){
                    let w = a.getX(v), A = a.getX(v + 1), T = a.getX(v + 2);
                    o = xy(this, g, t, ju, c, u1, w, A, T), o && (o.faceIndex = Math.floor(v / 3), o.face.materialIndex = p.materialIndex, e.push(o));
                }
            }
            else {
                let f = Math.max(0, d.start), m = Math.min(a.count, d.start + d.count);
                for(let p = f, g = m; p < g; p += 3){
                    let y = a.getX(p), x = a.getX(p + 1), v = a.getX(p + 2);
                    o = xy(this, i, t, ju, c, u1, y, x, v), o && (o.faceIndex = Math.floor(p / 3), e.push(o));
                }
            }
        } else if (l !== void 0) {
            if (Array.isArray(i)) for(let f = 0, m = h.length; f < m; f++){
                let p = h[f], g = i[p.materialIndex], y = Math.max(p.start, d.start), x = Math.min(l.count, Math.min(p.start + p.count, d.start + d.count));
                for(let v = y, b = x; v < b; v += 3){
                    let w = v, A = v + 1, T = v + 2;
                    o = xy(this, g, t, ju, c, u1, w, A, T), o && (o.faceIndex = Math.floor(v / 3), o.face.materialIndex = p.materialIndex, e.push(o));
                }
            }
            else {
                let f = Math.max(0, d.start), m = Math.min(l.count, d.start + d.count);
                for(let p = f, g = m; p < g; p += 3){
                    let y = p, x = p + 1, v = p + 2;
                    o = xy(this, i, t, ju, c, u1, y, x, v), o && (o.faceIndex = Math.floor(p / 3), e.push(o));
                }
            }
        }
    }
};
function Ak(n1, t, e, r, i, s1, o, a) {
    let l;
    if (t.side === xi ? l = r.intersectTriangle(o, s1, i, !0, a) : l = r.intersectTriangle(i, s1, o, t.side === Jn, a), l === null) return null;
    vy.copy(a), vy.applyMatrix4(n1.matrixWorld);
    let c = e.ray.origin.distanceTo(vy);
    return c < e.near || c > e.far ? null : {
        distance: c,
        point: vy.clone(),
        object: n1
    };
}
function xy(n1, t, e, r, i, s1, o, a, l) {
    n1.getVertexPosition(o, Ap), n1.getVertexPosition(a, Ep), n1.getVertexPosition(l, Tp);
    let c = Ak(n1, t, e, r, Ap, Ep, Tp, IS);
    if (c) {
        i && (my.fromBufferAttribute(i, o), gy.fromBufferAttribute(i, a), yy.fromBufferAttribute(i, l), c.uv = Or.getUV(IS, Ap, Ep, Tp, my, gy, yy, new U)), s1 && (my.fromBufferAttribute(s1, o), gy.fromBufferAttribute(s1, a), yy.fromBufferAttribute(s1, l), c.uv2 = Or.getUV(IS, Ap, Ep, Tp, my, gy, yy, new U));
        let u1 = {
            a: o,
            b: a,
            c: l,
            normal: new E,
            materialIndex: 0
        };
        Or.getNormal(Ap, Ep, Tp, u1.normal), c.face = u1;
    }
    return c;
}
var bi = class extends Ce {
    constructor(t = 1, e = 1, r = 1, i = 1, s1 = 1, o = 1){
        super(), this.type = "BoxGeometry", this.parameters = {
            width: t,
            height: e,
            depth: r,
            widthSegments: i,
            heightSegments: s1,
            depthSegments: o
        };
        let a = this;
        i = Math.floor(i), s1 = Math.floor(s1), o = Math.floor(o);
        let l = [], c = [], u1 = [], h = [], d = 0, f = 0;
        m("z", "y", "x", -1, -1, r, e, t, o, s1, 0), m("z", "y", "x", 1, -1, r, e, -t, o, s1, 1), m("x", "z", "y", 1, 1, t, r, e, i, o, 2), m("x", "z", "y", 1, -1, t, r, -e, i, o, 3), m("x", "y", "z", 1, -1, t, e, r, i, s1, 4), m("x", "y", "z", -1, -1, t, e, -r, i, s1, 5), this.setIndex(l), this.setAttribute("position", new Te(c, 3)), this.setAttribute("normal", new Te(u1, 3)), this.setAttribute("uv", new Te(h, 2));
        function m(p, g, y, x, v, b, w, A, T, S, M) {
            let C = b / T, P = w / S, _ = b / 2, I = w / 2, O = A / 2, L = T + 1, j = S + 1, V = 0, H = 0, q = new E;
            for(let X = 0; X < j; X++){
                let K = X * P - I;
                for(let z = 0; z < L; z++){
                    let Q = z * C - _;
                    q[p] = Q * x, q[g] = K * v, q[y] = O, c.push(q.x, q.y, q.z), q[p] = 0, q[g] = 0, q[y] = A > 0 ? 1 : -1, u1.push(q.x, q.y, q.z), h.push(z / T), h.push(1 - X / S), V += 1;
                }
            }
            for(let X = 0; X < S; X++)for(let K = 0; K < T; K++){
                let z = d + K + L * X, Q = d + K + L * (X + 1), te = d + (K + 1) + L * (X + 1), $ = d + (K + 1) + L * X;
                l.push(z, Q, $), l.push(Q, te, $), H += 6;
            }
            a.addGroup(f, H, M), f += H, d += V;
        }
    }
    static fromJSON(t) {
        return new bi(t.width, t.height, t.depth, t.widthSegments, t.heightSegments, t.depthSegments);
    }
};
function th(n1) {
    let t = {};
    for(let e in n1){
        t[e] = {};
        for(let r in n1[e]){
            let i = n1[e][r];
            i && (i.isColor || i.isMatrix3 || i.isMatrix4 || i.isVector2 || i.isVector3 || i.isVector4 || i.isTexture || i.isQuaternion) ? t[e][r] = i.clone() : Array.isArray(i) ? t[e][r] = i.slice() : t[e][r] = i;
        }
    }
    return t;
}
function vn(n1) {
    let t = {};
    for(let e = 0; e < n1.length; e++){
        let r = th(n1[e]);
        for(let i in r)t[i] = r[i];
    }
    return t;
}
function Ek(n1) {
    let t = [];
    for(let e = 0; e < n1.length; e++)t.push(n1[e].clone());
    return t;
}
function u_(n1) {
    return n1.getRenderTarget() === null && n1.outputEncoding === ut ? Ao : Np;
}
var Xs = {
    clone: th,
    merge: vn
}, Tk = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, Mk = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`, $e = class extends Fc {
    constructor(t){
        super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = Tk, this.fragmentShader = Mk, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.extensions = {
            derivatives: !1,
            fragDepth: !1,
            drawBuffers: !1,
            shaderTextureLOD: !1
        }, this.defaultAttributeValues = {
            color: [
                1,
                1,
                1
            ],
            uv: [
                0,
                0
            ],
            uv2: [
                0,
                0
            ]
        }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, t !== void 0 && this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.fragmentShader = t.fragmentShader, this.vertexShader = t.vertexShader, this.uniforms = th(t.uniforms), this.uniformsGroups = Ek(t.uniformsGroups), this.defines = Object.assign({}, t.defines), this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.fog = t.fog, this.lights = t.lights, this.clipping = t.clipping, this.extensions = Object.assign({}, t.extensions), this.glslVersion = t.glslVersion, this;
    }
    toJSON(t) {
        let e = super.toJSON(t);
        e.glslVersion = this.glslVersion, e.uniforms = {};
        for(let i in this.uniforms){
            let o = this.uniforms[i].value;
            o && o.isTexture ? e.uniforms[i] = {
                type: "t",
                value: o.toJSON(t).uuid
            } : o && o.isColor ? e.uniforms[i] = {
                type: "c",
                value: o.getHex()
            } : o && o.isVector2 ? e.uniforms[i] = {
                type: "v2",
                value: o.toArray()
            } : o && o.isVector3 ? e.uniforms[i] = {
                type: "v3",
                value: o.toArray()
            } : o && o.isVector4 ? e.uniforms[i] = {
                type: "v4",
                value: o.toArray()
            } : o && o.isMatrix3 ? e.uniforms[i] = {
                type: "m3",
                value: o.toArray()
            } : o && o.isMatrix4 ? e.uniforms[i] = {
                type: "m4",
                value: o.toArray()
            } : e.uniforms[i] = {
                value: o
            };
        }
        Object.keys(this.defines).length > 0 && (e.defines = this.defines), e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader;
        let r = {};
        for(let i in this.extensions)this.extensions[i] === !0 && (r[i] = !0);
        return Object.keys(r).length > 0 && (e.extensions = r), e;
    }
}, bn = class extends Dt {
    constructor(){
        super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new ue, this.projectionMatrix = new ue, this.projectionMatrixInverse = new ue;
    }
    copy(t, e) {
        return super.copy(t, e), this.matrixWorldInverse.copy(t.matrixWorldInverse), this.projectionMatrix.copy(t.projectionMatrix), this.projectionMatrixInverse.copy(t.projectionMatrixInverse), this;
    }
    getWorldDirection(t) {
        this.updateWorldMatrix(!0, !1);
        let e = this.matrixWorld.elements;
        return t.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(t, e) {
        super.updateWorldMatrix(t, e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, si = class extends bn {
    constructor(t = 50, e = 1, r = .1, i = 2e3){
        super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = t, this.zoom = 1, this.near = r, this.far = i, this.focus = 10, this.aspect = e, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
    }
    copy(t, e) {
        return super.copy(t, e), this.fov = t.fov, this.zoom = t.zoom, this.near = t.near, this.far = t.far, this.focus = t.focus, this.aspect = t.aspect, this.view = t.view === null ? null : Object.assign({}, t.view), this.filmGauge = t.filmGauge, this.filmOffset = t.filmOffset, this;
    }
    setFocalLength(t) {
        let e = .5 * this.getFilmHeight() / t;
        this.fov = Bp * 2 * Math.atan(e), this.updateProjectionMatrix();
    }
    getFocalLength() {
        let t = Math.tan(Ip * .5 * this.fov);
        return .5 * this.getFilmHeight() / t;
    }
    getEffectiveFOV() {
        return Bp * 2 * Math.atan(Math.tan(Ip * .5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    setViewOffset(t, e, r, i, s1, o) {
        this.aspect = t / e, this.view === null && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = r, this.view.offsetY = i, this.view.width = s1, this.view.height = o, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        let t = this.near, e = t * Math.tan(Ip * .5 * this.fov) / this.zoom, r = 2 * e, i = this.aspect * r, s1 = -0.5 * i, o = this.view;
        if (this.view !== null && this.view.enabled) {
            let l = o.fullWidth, c = o.fullHeight;
            s1 += o.offsetX * i / l, e -= o.offsetY * r / c, i *= o.width / l, r *= o.height / c;
        }
        let a = this.filmOffset;
        a !== 0 && (s1 += t * a / this.getFilmWidth()), this.projectionMatrix.makePerspective(s1, s1 + i, e, e - r, t, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return e.object.fov = this.fov, e.object.zoom = this.zoom, e.object.near = this.near, e.object.far = this.far, e.object.focus = this.focus, e.object.aspect = this.aspect, this.view !== null && (e.object.view = Object.assign({}, this.view)), e.object.filmGauge = this.filmGauge, e.object.filmOffset = this.filmOffset, e;
    }
}, Hu = -90, Wu = 1, YS = class extends Dt {
    constructor(t, e, r){
        super(), this.type = "CubeCamera", this.renderTarget = r;
        let i = new si(Hu, Wu, t, e);
        i.layers = this.layers, i.up.set(0, 1, 0), i.lookAt(1, 0, 0), this.add(i);
        let s1 = new si(Hu, Wu, t, e);
        s1.layers = this.layers, s1.up.set(0, 1, 0), s1.lookAt(-1, 0, 0), this.add(s1);
        let o = new si(Hu, Wu, t, e);
        o.layers = this.layers, o.up.set(0, 0, -1), o.lookAt(0, 1, 0), this.add(o);
        let a = new si(Hu, Wu, t, e);
        a.layers = this.layers, a.up.set(0, 0, 1), a.lookAt(0, -1, 0), this.add(a);
        let l = new si(Hu, Wu, t, e);
        l.layers = this.layers, l.up.set(0, 1, 0), l.lookAt(0, 0, 1), this.add(l);
        let c = new si(Hu, Wu, t, e);
        c.layers = this.layers, c.up.set(0, 1, 0), c.lookAt(0, 0, -1), this.add(c);
    }
    update(t, e) {
        this.parent === null && this.updateMatrixWorld();
        let r = this.renderTarget, [i, s1, o, a, l, c] = this.children, u1 = t.getRenderTarget(), h = t.toneMapping, d = t.xr.enabled;
        t.toneMapping = js, t.xr.enabled = !1;
        let f = r.texture.generateMipmaps;
        r.texture.generateMipmaps = !1, t.setRenderTarget(r, 0), t.render(e, i), t.setRenderTarget(r, 1), t.render(e, s1), t.setRenderTarget(r, 2), t.render(e, o), t.setRenderTarget(r, 3), t.render(e, a), t.setRenderTarget(r, 4), t.render(e, l), r.texture.generateMipmaps = f, t.setRenderTarget(r, 5), t.render(e, c), t.setRenderTarget(u1), t.toneMapping = h, t.xr.enabled = d, r.texture.needsPMREMUpdate = !0;
    }
}, rh = class extends Zt {
    constructor(t, e, r, i, s1, o, a, l, c, u1){
        t = t !== void 0 ? t : [], e = e !== void 0 ? e : yl, super(t, e, r, i, s1, o, a, l, c, u1), this.isCubeTexture = !0, this.flipY = !1;
    }
    get images() {
        return this.image;
    }
    set images(t) {
        this.image = t;
    }
}, KS = class extends at {
    constructor(t = 1, e = {}){
        super(t, t, e), this.isWebGLCubeRenderTarget = !0;
        let r = {
            width: t,
            height: t,
            depth: 1
        }, i = [
            r,
            r,
            r,
            r,
            r,
            r
        ];
        this.texture = new rh(i, e.mapping, e.wrapS, e.wrapT, e.magFilter, e.minFilter, e.format, e.type, e.anisotropy, e.encoding), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = e.generateMipmaps !== void 0 ? e.generateMipmaps : !1, this.texture.minFilter = e.minFilter !== void 0 ? e.minFilter : it;
    }
    fromEquirectangularTexture(t, e) {
        this.texture.type = e.type, this.texture.encoding = e.encoding, this.texture.generateMipmaps = e.generateMipmaps, this.texture.minFilter = e.minFilter, this.texture.magFilter = e.magFilter;
        let r = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        }, i = new bi(5, 5, 5), s1 = new $e({
            name: "CubemapFromEquirect",
            uniforms: th(r.uniforms),
            vertexShader: r.vertexShader,
            fragmentShader: r.fragmentShader,
            side: xi,
            blending: or
        });
        s1.uniforms.tEquirect.value = e;
        let o = new Mt(i, s1), a = e.minFilter;
        return e.minFilter === Bc && (e.minFilter = it), new YS(1, 10, this).update(t, o), e.minFilter = a, o.geometry.dispose(), o.material.dispose(), this;
    }
    clear(t, e, r, i) {
        let s1 = t.getRenderTarget();
        for(let o = 0; o < 6; o++)t.setRenderTarget(this, o), t.clear(e, r, i);
        t.setRenderTarget(s1);
    }
}, DS = new E, Ck = new E, Pk = new Sr, qr = class {
    constructor(t = new E(1, 0, 0), e = 0){
        this.isPlane = !0, this.normal = t, this.constant = e;
    }
    set(t, e) {
        return this.normal.copy(t), this.constant = e, this;
    }
    setComponents(t, e, r, i) {
        return this.normal.set(t, e, r), this.constant = i, this;
    }
    setFromNormalAndCoplanarPoint(t, e) {
        return this.normal.copy(t), this.constant = -e.dot(this.normal), this;
    }
    setFromCoplanarPoints(t, e, r) {
        let i = DS.subVectors(r, e).cross(Ck.subVectors(t, e)).normalize();
        return this.setFromNormalAndCoplanarPoint(i, t), this;
    }
    copy(t) {
        return this.normal.copy(t.normal), this.constant = t.constant, this;
    }
    normalize() {
        let t = 1 / this.normal.length();
        return this.normal.multiplyScalar(t), this.constant *= t, this;
    }
    negate() {
        return this.constant *= -1, this.normal.negate(), this;
    }
    distanceToPoint(t) {
        return this.normal.dot(t) + this.constant;
    }
    distanceToSphere(t) {
        return this.distanceToPoint(t.center) - t.radius;
    }
    projectPoint(t, e) {
        return e.copy(this.normal).multiplyScalar(-this.distanceToPoint(t)).add(t);
    }
    intersectLine(t, e) {
        let r = t.delta(DS), i = this.normal.dot(r);
        if (i === 0) return this.distanceToPoint(t.start) === 0 ? e.copy(t.start) : null;
        let s1 = -(t.start.dot(this.normal) + this.constant) / i;
        return s1 < 0 || s1 > 1 ? null : e.copy(r).multiplyScalar(s1).add(t.start);
    }
    intersectsLine(t) {
        let e = this.distanceToPoint(t.start), r = this.distanceToPoint(t.end);
        return e < 0 && r > 0 || r < 0 && e > 0;
    }
    intersectsBox(t) {
        return t.intersectsPlane(this);
    }
    intersectsSphere(t) {
        return t.intersectsPlane(this);
    }
    coplanarPoint(t) {
        return t.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(t, e) {
        let r = e || Pk.getNormalMatrix(t), i = this.coplanarPoint(DS).applyMatrix4(t), s1 = this.normal.applyMatrix3(r).normalize();
        return this.constant = -i.dot(s1), this;
    }
    translate(t) {
        return this.constant -= t.dot(this.normal), this;
    }
    equals(t) {
        return t.normal.equals(this.normal) && t.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, qu = new ei, by = new E, Up = class {
    constructor(t = new qr, e = new qr, r = new qr, i = new qr, s1 = new qr, o = new qr){
        this.planes = [
            t,
            e,
            r,
            i,
            s1,
            o
        ];
    }
    set(t, e, r, i, s1, o) {
        let a = this.planes;
        return a[0].copy(t), a[1].copy(e), a[2].copy(r), a[3].copy(i), a[4].copy(s1), a[5].copy(o), this;
    }
    copy(t) {
        let e = this.planes;
        for(let r = 0; r < 6; r++)e[r].copy(t.planes[r]);
        return this;
    }
    setFromProjectionMatrix(t) {
        let e = this.planes, r = t.elements, i = r[0], s1 = r[1], o = r[2], a = r[3], l = r[4], c = r[5], u1 = r[6], h = r[7], d = r[8], f = r[9], m = r[10], p = r[11], g = r[12], y = r[13], x = r[14], v = r[15];
        return e[0].setComponents(a - i, h - l, p - d, v - g).normalize(), e[1].setComponents(a + i, h + l, p + d, v + g).normalize(), e[2].setComponents(a + s1, h + c, p + f, v + y).normalize(), e[3].setComponents(a - s1, h - c, p - f, v - y).normalize(), e[4].setComponents(a - o, h - u1, p - m, v - x).normalize(), e[5].setComponents(a + o, h + u1, p + m, v + x).normalize(), this;
    }
    intersectsObject(t) {
        let e = t.geometry;
        return e.boundingSphere === null && e.computeBoundingSphere(), qu.copy(e.boundingSphere).applyMatrix4(t.matrixWorld), this.intersectsSphere(qu);
    }
    intersectsSprite(t) {
        return qu.center.set(0, 0, 0), qu.radius = .7071067811865476, qu.applyMatrix4(t.matrixWorld), this.intersectsSphere(qu);
    }
    intersectsSphere(t) {
        let e = this.planes, r = t.center, i = -t.radius;
        for(let s1 = 0; s1 < 6; s1++)if (e[s1].distanceToPoint(r) < i) return !1;
        return !0;
    }
    intersectsBox(t) {
        let e = this.planes;
        for(let r = 0; r < 6; r++){
            let i = e[r];
            if (by.x = i.normal.x > 0 ? t.max.x : t.min.x, by.y = i.normal.y > 0 ? t.max.y : t.min.y, by.z = i.normal.z > 0 ? t.max.z : t.min.z, i.distanceToPoint(by) < 0) return !1;
        }
        return !0;
    }
    containsPoint(t) {
        let e = this.planes;
        for(let r = 0; r < 6; r++)if (e[r].distanceToPoint(t) < 0) return !1;
        return !0;
    }
    clone() {
        return new this.constructor().copy(this);
    }
};
function h_() {
    let n1 = null, t = !1, e = null, r = null;
    function i(s1, o) {
        e(s1, o), r = n1.requestAnimationFrame(i);
    }
    return {
        start: function() {
            t !== !0 && e !== null && (r = n1.requestAnimationFrame(i), t = !0);
        },
        stop: function() {
            n1.cancelAnimationFrame(r), t = !1;
        },
        setAnimationLoop: function(s1) {
            e = s1;
        },
        setContext: function(s1) {
            n1 = s1;
        }
    };
}
function _k(n1, t) {
    let e = t.isWebGL2, r = new WeakMap;
    function i(c, u1) {
        let h = c.array, d = c.usage, f = n1.createBuffer();
        n1.bindBuffer(u1, f), n1.bufferData(u1, h, d), c.onUploadCallback();
        let m;
        if (h instanceof Float32Array) m = 5126;
        else if (h instanceof Uint16Array) {
            if (c.isFloat16BufferAttribute) {
                if (e) m = 5131;
                else throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
            } else m = 5123;
        } else if (h instanceof Int16Array) m = 5122;
        else if (h instanceof Uint32Array) m = 5125;
        else if (h instanceof Int32Array) m = 5124;
        else if (h instanceof Int8Array) m = 5120;
        else if (h instanceof Uint8Array) m = 5121;
        else if (h instanceof Uint8ClampedArray) m = 5121;
        else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + h);
        return {
            buffer: f,
            type: m,
            bytesPerElement: h.BYTES_PER_ELEMENT,
            version: c.version
        };
    }
    function s1(c, u1, h) {
        let d = u1.array, f = u1.updateRange;
        n1.bindBuffer(h, c), f.count === -1 ? n1.bufferSubData(h, 0, d) : (e ? n1.bufferSubData(h, f.offset * d.BYTES_PER_ELEMENT, d, f.offset, f.count) : n1.bufferSubData(h, f.offset * d.BYTES_PER_ELEMENT, d.subarray(f.offset, f.offset + f.count)), f.count = -1), u1.onUploadCallback();
    }
    function o(c) {
        return c.isInterleavedBufferAttribute && (c = c.data), r.get(c);
    }
    function a(c) {
        c.isInterleavedBufferAttribute && (c = c.data);
        let u1 = r.get(c);
        u1 && (n1.deleteBuffer(u1.buffer), r.delete(c));
    }
    function l(c, u1) {
        if (c.isGLBufferAttribute) {
            let d = r.get(c);
            (!d || d.version < c.version) && r.set(c, {
                buffer: c.buffer,
                type: c.type,
                bytesPerElement: c.elementSize,
                version: c.version
            });
            return;
        }
        c.isInterleavedBufferAttribute && (c = c.data);
        let h = r.get(c);
        h === void 0 ? r.set(c, i(c, u1)) : h.version < c.version && (s1(h.buffer, c, u1), h.version = c.version);
    }
    return {
        get: o,
        remove: a,
        update: l
    };
}
var Si = class extends Ce {
    constructor(t = 1, e = 1, r = 1, i = 1){
        super(), this.type = "PlaneGeometry", this.parameters = {
            width: t,
            height: e,
            widthSegments: r,
            heightSegments: i
        };
        let s1 = t / 2, o = e / 2, a = Math.floor(r), l = Math.floor(i), c = a + 1, u1 = l + 1, h = t / a, d = e / l, f = [], m = [], p = [], g = [];
        for(let y = 0; y < u1; y++){
            let x = y * d - o;
            for(let v = 0; v < c; v++){
                let b = v * h - s1;
                m.push(b, -x, 0), p.push(0, 0, 1), g.push(v / a), g.push(1 - y / l);
            }
        }
        for(let y = 0; y < l; y++)for(let x = 0; x < a; x++){
            let v = x + c * y, b = x + c * (y + 1), w = x + 1 + c * (y + 1), A = x + 1 + c * y;
            f.push(v, b, A), f.push(b, w, A);
        }
        this.setIndex(f), this.setAttribute("position", new Te(m, 3)), this.setAttribute("normal", new Te(p, 3)), this.setAttribute("uv", new Te(g, 2));
    }
    static fromJSON(t) {
        return new Si(t.width, t.height, t.widthSegments, t.heightSegments);
    }
}, Ik = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vUv ).g;
#endif`, Dk = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, Ok = `#ifdef USE_ALPHATEST
	if ( diffuseColor.a < alphaTest ) discard;
#endif`, Rk = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`, Lk = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`, Nk = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`, Bk = "vec3 transformed = vec3( position );", Fk = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`, Vk = `vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
	float D = D_GGX( alpha, dotNH );
	return F * ( V * D );
}
#ifdef USE_IRIDESCENCE
	vec3 BRDF_GGX_Iridescence( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float iridescence, const in vec3 iridescenceFresnel, const in float roughness ) {
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = mix( F_Schlick( f0, f90, dotVH ), iridescenceFresnel, iridescence );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif`, Uk = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			 return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float R21 = R12;
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`, kk = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vUv );
		vec2 dSTdy = dFdy( vUv );
		float Hll = bumpScale * texture2D( bumpMap, vUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = dFdx( surf_pos.xyz );
		vec3 vSigmaY = dFdy( surf_pos.xyz );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`, zk = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#pragma unroll_loop_start
	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
		plane = clippingPlanes[ i ];
		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
	}
	#pragma unroll_loop_end
	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
		bool clipped = true;
		#pragma unroll_loop_start
		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
		}
		#pragma unroll_loop_end
		if ( clipped ) discard;
	#endif
#endif`, Gk = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`, jk = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`, Hk = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`, Wk = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`, qk = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`, Xk = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	varying vec3 vColor;
#endif`, Yk = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif`, Kk = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
struct GeometricContext {
	vec3 position;
	vec3 normal;
	vec3 viewDir;
#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal;
#endif
};
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
mat3 transposeMat3( const in mat3 m ) {
	mat3 tmp;
	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );
	return tmp;
}
float luminance( const in vec3 rgb ) {
	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );
	return dot( weights, rgb );
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}`, Qk = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_v0 0.339
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_v1 0.276
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_v4 0.046
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_v5 0.016
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_v6 0.0038
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`, Zk = `vec3 transformedNormal = objectNormal;
#ifdef USE_INSTANCING
	mat3 m = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );
	transformedNormal = m * transformedNormal;
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`, Jk = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`, $k = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );
#endif`, ez = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vUv );
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`, tz = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`, rz = "gl_FragColor = linearToOutputTexel( gl_FragColor );", iz = `vec4 LinearToLinear( in vec4 value ) {
	return value;
}
vec4 LinearTosRGB( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`, nz = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`, sz = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
	
#endif`, oz = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`, az = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`, lz = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`, cz = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`, uz = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`, hz = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`, dz = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`, fz = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`, pz = `#ifdef USE_LIGHTMAP
	vec4 lightMapTexel = texture2D( lightMap, vUv2 );
	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
	reflectedLight.indirectDiffuse += lightMapIrradiance;
#endif`, mz = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`, gz = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`, yz = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`, vz = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
uniform vec3 lightProbe[ 9 ];
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	#if defined ( PHYSICALLY_CORRECT_LIGHTS )
		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
		if ( cutoffDistance > 0.0 ) {
			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
		}
		return distanceFalloff;
	#else
		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {
			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );
		}
		return 1.0;
	#endif
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometry.position;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometry.position;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`, xz = `#if defined( USE_ENVMAP )
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#if defined( ENVMAP_TYPE_CUBE_UV )
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#if defined( ENVMAP_TYPE_CUBE_UV )
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
#endif`, bz = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`, Sz = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`, wz = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`, Az = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`, Ez = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );
vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULARINTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;
		#endif
		#ifdef USE_SPECULARCOLORMAP
			specularColorFactor *= texture2D( specularColorMap, vUv ).rgb;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEENCOLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );
	#ifdef USE_SHEENROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;
	#endif
#endif`, Tz = `struct PhysicalMaterial {
	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
};
vec3 clearcoatSpecular = vec3( 0.0 );
vec3 sheenSpecular = vec3( 0.0 );
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;
	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;
	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );
	return saturate( DG * RECIPROCAL_PI );
}
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );
	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );
	vec4 r = roughness * c0 + c1;
	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;
	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;
	return fab;
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometry.normal;
		vec3 viewDir = geometry.viewDir;
		vec3 position = geometry.position;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );
	#endif
	#ifdef USE_IRIDESCENCE
		reflectedLight.directSpecular += irradiance * BRDF_GGX_Iridescence( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness );
	#else
		reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );
	#endif
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );
	#endif
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );
	#else
		computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );
	#endif
	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );
	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;
	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`, Mz = `
GeometricContext geometry;
geometry.position = - vViewPosition;
geometry.normal = normal;
geometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
#ifdef USE_CLEARCOAT
	geometry.clearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometry.viewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometry, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometry, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, geometry, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`, Cz = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vUv2 );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometry.normal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`, Pz = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );
#endif`, _z = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`, Iz = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, Dz = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		varying float vFragDepth;
		varying float vIsPerspective;
	#else
		uniform float logDepthBufFC;
	#endif
#endif`, Oz = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		vFragDepth = 1.0 + gl_Position.w;
		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
	#else
		if ( isPerspectiveMatrix( projectionMatrix ) ) {
			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;
			gl_Position.z *= gl_Position.w;
		}
	#endif
#endif`, Rz = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`, Lz = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`, Nz = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`, Bz = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	uniform mat3 uvTransform;
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, Fz = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vUv );
	metalnessFactor *= texelMetalness.b;
#endif`, Vz = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`, Uz = `#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`, kz = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];
		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];
		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];
		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];
	#endif
#endif`, zz = `#ifdef USE_MORPHTARGETS
	uniform float morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
		uniform sampler2DArray morphTargetsTexture;
		uniform ivec2 morphTargetsTextureSize;
		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
			int y = texelIndex / morphTargetsTextureSize.x;
			int x = texelIndex - y * morphTargetsTextureSize.x;
			ivec3 morphUV = ivec3( x, y, morphTargetIndex );
			return texelFetch( morphTargetsTexture, morphUV, 0 );
		}
	#else
		#ifndef USE_MORPHNORMALS
			uniform float morphTargetInfluences[ 8 ];
		#else
			uniform float morphTargetInfluences[ 4 ];
		#endif
	#endif
#endif`, Gz = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		transformed += morphTarget0 * morphTargetInfluences[ 0 ];
		transformed += morphTarget1 * morphTargetInfluences[ 1 ];
		transformed += morphTarget2 * morphTargetInfluences[ 2 ];
		transformed += morphTarget3 * morphTargetInfluences[ 3 ];
		#ifndef USE_MORPHNORMALS
			transformed += morphTarget4 * morphTargetInfluences[ 4 ];
			transformed += morphTarget5 * morphTargetInfluences[ 5 ];
			transformed += morphTarget6 * morphTargetInfluences[ 6 ];
			transformed += morphTarget7 * morphTargetInfluences[ 7 ];
		#endif
	#endif
#endif`, jz = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	#ifdef USE_TANGENT
		vec3 tangent = normalize( vTangent );
		vec3 bitangent = normalize( vBitangent );
		#ifdef DOUBLE_SIDED
			tangent = tangent * faceDirection;
			bitangent = bitangent * faceDirection;
		#endif
		#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )
			mat3 vTBN = mat3( tangent, bitangent, normal );
		#endif
	#endif
#endif
vec3 geometryNormal = normal;`, Hz = `#ifdef OBJECTSPACE_NORMALMAP
	normal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( TANGENTSPACE_NORMALMAP )
	vec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	#ifdef USE_TANGENT
		normal = normalize( vTBN * mapN );
	#else
		normal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );
	#endif
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`, Wz = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, qz = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, Xz = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`, Yz = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef OBJECTSPACE_NORMALMAP
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )
	vec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( vUv.st );
		vec2 st1 = dFdy( vUv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );
		return normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );
	}
#endif`, Kz = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = geometryNormal;
#endif`, Qz = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	#ifdef USE_TANGENT
		clearcoatNormal = normalize( vTBN * clearcoatMapN );
	#else
		clearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );
	#endif
#endif`, Zz = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif`, Jz = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`, $z = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha + 0.1;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`, eG = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;
const vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );
const vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );
const float ShiftRight8 = 1. / 256.;
vec4 packDepthToRGBA( const in float v ) {
	vec4 r = vec4( fract( v * PackFactors ), v );
	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors );
}
vec2 packDepthToRG( in highp float v ) {
	return packDepthToRGBA( v ).yx;
}
float unpackRGToDepth( const in highp vec2 v ) {
	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );
}
vec4 pack2HalfToRGBA( vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {
	return linearClipZ * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * invClipZ - far );
}`, tG = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`, rG = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`, iG = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`, nG = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`, sG = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vUv );
	roughnessFactor *= texelRoughness.g;
#endif`, oG = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`, aG = `#if NUM_SPOT_LIGHT_COORDS > 0
  varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
  uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );
	}
	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
		return unpackRGBATo2Half( texture2D( shadow, uv ) );
	}
	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){
		float occlusion = 1.0;
		vec2 distribution = texture2DDistribution( shadow, uv );
		float hard_shadow = step( compare , distribution.x );
		if (hard_shadow != 1.0 ) {
			float distance = compare - distribution.x ;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
		}
		return occlusion;
	}
	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
		float shadow = 1.0;
		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;
		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
		if ( frustumTest ) {
		#if defined( SHADOWMAP_TYPE_PCF )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;
			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );
		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;
			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;
			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );
		#elif defined( SHADOWMAP_TYPE_VSM )
			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
		#else
			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
		#endif
		}
		return shadow;
	}
	vec2 cubeToUV( vec3 v, float texelSizeY ) {
		vec3 absV = abs( v );
		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
		vec2 planar = v.xy;
		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;
		if ( absV.z >= almostOne ) {
			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;
		} else if ( absV.x >= almostOne ) {
			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;
		} else if ( absV.y >= almostOne ) {
			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;
		}
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
	}
	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
		vec3 lightToPosition = shadowCoord.xyz;
		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;
		vec3 bd3D = normalize( lightToPosition );
		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
			return (
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
			) * ( 1.0 / 9.0 );
		#else
			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
		#endif
	}
#endif`, lG = `#if NUM_SPOT_LIGHT_COORDS > 0
  uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
  varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`, cG = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`, uG = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`, hG = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`, dG = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	uniform int boneTextureSize;
	mat4 getBoneMatrix( const in float i ) {
		float j = i * 4.0;
		float x = mod( j, float( boneTextureSize ) );
		float y = floor( j / float( boneTextureSize ) );
		float dx = 1.0 / float( boneTextureSize );
		float dy = 1.0 / float( boneTextureSize );
		y = dy * ( y + 0.5 );
		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );
		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );
		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );
		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );
		mat4 bone = mat4( v1, v2, v3, v4 );
		return bone;
	}
#endif`, fG = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`, pG = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`, mG = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`, gG = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`, yG = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`, vG = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return toneMappingExposure * color;
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 OptimizedCineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`, xG = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmission = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmission.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmission.rgb, material.transmission );
#endif`, bG = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		#ifdef texture2DLodEXT
			return texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );
		#else
			return texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );
		#endif
	}
	vec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return radiance;
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance * radiance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
		vec3 refractedRayExit = position + transmissionRay;
		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
		vec2 refractionCoords = ndcPos.xy / ndcPos.w;
		refractionCoords += 1.0;
		refractionCoords /= 2.0;
		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
		vec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		return vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );
	}
#endif`, SG = `#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )
	varying vec2 vUv;
#endif`, wG = `#ifdef USE_UV
	#ifdef UVS_VERTEX_ONLY
		vec2 vUv;
	#else
		varying vec2 vUv;
	#endif
	uniform mat3 uvTransform;
#endif`, AG = `#ifdef USE_UV
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
#endif`, EG = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	varying vec2 vUv2;
#endif`, TG = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	attribute vec2 uv2;
	varying vec2 vUv2;
	uniform mat3 uv2Transform;
#endif`, MG = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	vUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;
#endif`, CG = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`, PG = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`, _G = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, IG = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, DG = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, OG = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, RG = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, LG = `#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`, NG = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <logdepthbuf_fragment>
	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#endif
}`, BG = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`, FG = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = packDepthToRGBA( dist );
}`, VG = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`, UG = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, kG = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, zG = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, GG = `#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`, jG = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vUv2 );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, HG = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, WG = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, qG = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`, XG = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, YG = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	vViewPosition = - mvPosition.xyz;
#endif
}`, KG = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	varying vec3 vViewPosition;
#endif
#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`, QG = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, ZG = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, JG = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`, $G = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULARINTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
	#ifdef USE_SPECULARCOLORMAP
		uniform sampler2D specularColorMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEENCOLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEENROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <bsdfs>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );
		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;
	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;
	#endif
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, e4 = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, t4 = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, r4 = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`, i4 = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, n4 = `#include <common>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, s4 = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
}`, o4 = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
	vec2 scale;
	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, a4 = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
}`, wt = {
    alphamap_fragment: Ik,
    alphamap_pars_fragment: Dk,
    alphatest_fragment: Ok,
    alphatest_pars_fragment: Rk,
    aomap_fragment: Lk,
    aomap_pars_fragment: Nk,
    begin_vertex: Bk,
    beginnormal_vertex: Fk,
    bsdfs: Vk,
    iridescence_fragment: Uk,
    bumpmap_pars_fragment: kk,
    clipping_planes_fragment: zk,
    clipping_planes_pars_fragment: Gk,
    clipping_planes_pars_vertex: jk,
    clipping_planes_vertex: Hk,
    color_fragment: Wk,
    color_pars_fragment: qk,
    color_pars_vertex: Xk,
    color_vertex: Yk,
    common: Kk,
    cube_uv_reflection_fragment: Qk,
    defaultnormal_vertex: Zk,
    displacementmap_pars_vertex: Jk,
    displacementmap_vertex: $k,
    emissivemap_fragment: ez,
    emissivemap_pars_fragment: tz,
    encodings_fragment: rz,
    encodings_pars_fragment: iz,
    envmap_fragment: nz,
    envmap_common_pars_fragment: sz,
    envmap_pars_fragment: oz,
    envmap_pars_vertex: az,
    envmap_physical_pars_fragment: xz,
    envmap_vertex: lz,
    fog_vertex: cz,
    fog_pars_vertex: uz,
    fog_fragment: hz,
    fog_pars_fragment: dz,
    gradientmap_pars_fragment: fz,
    lightmap_fragment: pz,
    lightmap_pars_fragment: mz,
    lights_lambert_fragment: gz,
    lights_lambert_pars_fragment: yz,
    lights_pars_begin: vz,
    lights_toon_fragment: bz,
    lights_toon_pars_fragment: Sz,
    lights_phong_fragment: wz,
    lights_phong_pars_fragment: Az,
    lights_physical_fragment: Ez,
    lights_physical_pars_fragment: Tz,
    lights_fragment_begin: Mz,
    lights_fragment_maps: Cz,
    lights_fragment_end: Pz,
    logdepthbuf_fragment: _z,
    logdepthbuf_pars_fragment: Iz,
    logdepthbuf_pars_vertex: Dz,
    logdepthbuf_vertex: Oz,
    map_fragment: Rz,
    map_pars_fragment: Lz,
    map_particle_fragment: Nz,
    map_particle_pars_fragment: Bz,
    metalnessmap_fragment: Fz,
    metalnessmap_pars_fragment: Vz,
    morphcolor_vertex: Uz,
    morphnormal_vertex: kz,
    morphtarget_pars_vertex: zz,
    morphtarget_vertex: Gz,
    normal_fragment_begin: jz,
    normal_fragment_maps: Hz,
    normal_pars_fragment: Wz,
    normal_pars_vertex: qz,
    normal_vertex: Xz,
    normalmap_pars_fragment: Yz,
    clearcoat_normal_fragment_begin: Kz,
    clearcoat_normal_fragment_maps: Qz,
    clearcoat_pars_fragment: Zz,
    iridescence_pars_fragment: Jz,
    output_fragment: $z,
    packing: eG,
    premultiplied_alpha_fragment: tG,
    project_vertex: rG,
    dithering_fragment: iG,
    dithering_pars_fragment: nG,
    roughnessmap_fragment: sG,
    roughnessmap_pars_fragment: oG,
    shadowmap_pars_fragment: aG,
    shadowmap_pars_vertex: lG,
    shadowmap_vertex: cG,
    shadowmask_pars_fragment: uG,
    skinbase_vertex: hG,
    skinning_pars_vertex: dG,
    skinning_vertex: fG,
    skinnormal_vertex: pG,
    specularmap_fragment: mG,
    specularmap_pars_fragment: gG,
    tonemapping_fragment: yG,
    tonemapping_pars_fragment: vG,
    transmission_fragment: xG,
    transmission_pars_fragment: bG,
    uv_pars_fragment: SG,
    uv_pars_vertex: wG,
    uv_vertex: AG,
    uv2_pars_fragment: EG,
    uv2_pars_vertex: TG,
    uv2_vertex: MG,
    worldpos_vertex: CG,
    background_vert: PG,
    background_frag: _G,
    backgroundCube_vert: IG,
    backgroundCube_frag: DG,
    cube_vert: OG,
    cube_frag: RG,
    depth_vert: LG,
    depth_frag: NG,
    distanceRGBA_vert: BG,
    distanceRGBA_frag: FG,
    equirect_vert: VG,
    equirect_frag: UG,
    linedashed_vert: kG,
    linedashed_frag: zG,
    meshbasic_vert: GG,
    meshbasic_frag: jG,
    meshlambert_vert: HG,
    meshlambert_frag: WG,
    meshmatcap_vert: qG,
    meshmatcap_frag: XG,
    meshnormal_vert: YG,
    meshnormal_frag: KG,
    meshphong_vert: QG,
    meshphong_frag: ZG,
    meshphysical_vert: JG,
    meshphysical_frag: $G,
    meshtoon_vert: e4,
    meshtoon_frag: t4,
    points_vert: r4,
    points_frag: i4,
    shadow_vert: n4,
    shadow_frag: s4,
    sprite_vert: o4,
    sprite_frag: a4
}, Ie = {
    common: {
        diffuse: {
            value: new Ge(16777215)
        },
        opacity: {
            value: 1
        },
        map: {
            value: null
        },
        uvTransform: {
            value: new Sr
        },
        uv2Transform: {
            value: new Sr
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: .98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalScale: {
            value: new U(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 25e-5
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2e3
        },
        fogColor: {
            value: new Ge(16777215)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: new Ge(16777215)
        },
        opacity: {
            value: 1
        },
        size: {
            value: 1
        },
        scale: {
            value: 1
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new Sr
        }
    },
    sprite: {
        diffuse: {
            value: new Ge(16777215)
        },
        opacity: {
            value: 1
        },
        center: {
            value: new U(.5, .5)
        },
        rotation: {
            value: 0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new Sr
        }
    }
}, Eo = {
    basic: {
        uniforms: vn([
            Ie.common,
            Ie.specularmap,
            Ie.envmap,
            Ie.aomap,
            Ie.lightmap,
            Ie.fog
        ]),
        vertexShader: wt.meshbasic_vert,
        fragmentShader: wt.meshbasic_frag
    },
    lambert: {
        uniforms: vn([
            Ie.common,
            Ie.specularmap,
            Ie.envmap,
            Ie.aomap,
            Ie.lightmap,
            Ie.emissivemap,
            Ie.bumpmap,
            Ie.normalmap,
            Ie.displacementmap,
            Ie.fog,
            Ie.lights,
            {
                emissive: {
                    value: new Ge(0)
                }
            }
        ]),
        vertexShader: wt.meshlambert_vert,
        fragmentShader: wt.meshlambert_frag
    },
    phong: {
        uniforms: vn([
            Ie.common,
            Ie.specularmap,
            Ie.envmap,
            Ie.aomap,
            Ie.lightmap,
            Ie.emissivemap,
            Ie.bumpmap,
            Ie.normalmap,
            Ie.displacementmap,
            Ie.fog,
            Ie.lights,
            {
                emissive: {
                    value: new Ge(0)
                },
                specular: {
                    value: new Ge(1118481)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: wt.meshphong_vert,
        fragmentShader: wt.meshphong_frag
    },
    standard: {
        uniforms: vn([
            Ie.common,
            Ie.envmap,
            Ie.aomap,
            Ie.lightmap,
            Ie.emissivemap,
            Ie.bumpmap,
            Ie.normalmap,
            Ie.displacementmap,
            Ie.roughnessmap,
            Ie.metalnessmap,
            Ie.fog,
            Ie.lights,
            {
                emissive: {
                    value: new Ge(0)
                },
                roughness: {
                    value: 1
                },
                metalness: {
                    value: 0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: wt.meshphysical_vert,
        fragmentShader: wt.meshphysical_frag
    },
    toon: {
        uniforms: vn([
            Ie.common,
            Ie.aomap,
            Ie.lightmap,
            Ie.emissivemap,
            Ie.bumpmap,
            Ie.normalmap,
            Ie.displacementmap,
            Ie.gradientmap,
            Ie.fog,
            Ie.lights,
            {
                emissive: {
                    value: new Ge(0)
                }
            }
        ]),
        vertexShader: wt.meshtoon_vert,
        fragmentShader: wt.meshtoon_frag
    },
    matcap: {
        uniforms: vn([
            Ie.common,
            Ie.bumpmap,
            Ie.normalmap,
            Ie.displacementmap,
            Ie.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: wt.meshmatcap_vert,
        fragmentShader: wt.meshmatcap_frag
    },
    points: {
        uniforms: vn([
            Ie.points,
            Ie.fog
        ]),
        vertexShader: wt.points_vert,
        fragmentShader: wt.points_frag
    },
    dashed: {
        uniforms: vn([
            Ie.common,
            Ie.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: wt.linedashed_vert,
        fragmentShader: wt.linedashed_frag
    },
    depth: {
        uniforms: vn([
            Ie.common,
            Ie.displacementmap
        ]),
        vertexShader: wt.depth_vert,
        fragmentShader: wt.depth_frag
    },
    normal: {
        uniforms: vn([
            Ie.common,
            Ie.bumpmap,
            Ie.normalmap,
            Ie.displacementmap,
            {
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: wt.meshnormal_vert,
        fragmentShader: wt.meshnormal_frag
    },
    sprite: {
        uniforms: vn([
            Ie.sprite,
            Ie.fog
        ]),
        vertexShader: wt.sprite_vert,
        fragmentShader: wt.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new Sr
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: wt.background_vert,
        fragmentShader: wt.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: wt.backgroundCube_vert,
        fragmentShader: wt.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1
            }
        },
        vertexShader: wt.cube_vert,
        fragmentShader: wt.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: wt.equirect_vert,
        fragmentShader: wt.equirect_frag
    },
    distanceRGBA: {
        uniforms: vn([
            Ie.common,
            Ie.displacementmap,
            {
                referencePosition: {
                    value: new E
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1e3
                }
            }
        ]),
        vertexShader: wt.distanceRGBA_vert,
        fragmentShader: wt.distanceRGBA_frag
    },
    shadow: {
        uniforms: vn([
            Ie.lights,
            Ie.fog,
            {
                color: {
                    value: new Ge(0)
                },
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: wt.shadow_vert,
        fragmentShader: wt.shadow_frag
    }
};
Eo.physical = {
    uniforms: vn([
        Eo.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatNormalScale: {
                value: new U(1, 1)
            },
            clearcoatNormalMap: {
                value: null
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: new Ge(0)
            },
            sheenColorMap: {
                value: null
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionSamplerSize: {
                value: new U
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: new Ge(0)
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularColor: {
                value: new Ge(1, 1, 1)
            },
            specularColorMap: {
                value: null
            }
        }
    ]),
    vertexShader: wt.meshphysical_vert,
    fragmentShader: wt.meshphysical_frag
};
var Sy = {
    r: 0,
    b: 0,
    g: 0
};
function l4(n1, t, e, r, i, s1, o) {
    let a = new Ge(0), l = s1 === !0 ? 0 : 1, c, u1, h = null, d = 0, f = null;
    function m(g, y) {
        let x = !1, v = y.isScene === !0 ? y.background : null;
        v && v.isTexture && (v = (y.backgroundBlurriness > 0 ? e : t).get(v));
        let b = n1.xr, w = b.getSession && b.getSession();
        w && w.environmentBlendMode === "additive" && (v = null), v === null ? p(a, l) : v && v.isColor && (p(v, 1), x = !0), (n1.autoClear || x) && n1.clear(n1.autoClearColor, n1.autoClearDepth, n1.autoClearStencil), v && (v.isCubeTexture || v.mapping === xh) ? (u1 === void 0 && (u1 = new Mt(new bi(1, 1, 1), new $e({
            name: "BackgroundCubeMaterial",
            uniforms: th(Eo.backgroundCube.uniforms),
            vertexShader: Eo.backgroundCube.vertexShader,
            fragmentShader: Eo.backgroundCube.fragmentShader,
            side: xi,
            depthTest: !1,
            depthWrite: !1,
            fog: !1
        })), u1.geometry.deleteAttribute("normal"), u1.geometry.deleteAttribute("uv"), u1.onBeforeRender = function(A, T, S) {
            this.matrixWorld.copyPosition(S.matrixWorld);
        }, Object.defineProperty(u1.material, "envMap", {
            get: function() {
                return this.uniforms.envMap.value;
            }
        }), i.update(u1)), u1.material.uniforms.envMap.value = v, u1.material.uniforms.flipEnvMap.value = v.isCubeTexture && v.isRenderTargetTexture === !1 ? -1 : 1, u1.material.uniforms.backgroundBlurriness.value = y.backgroundBlurriness, u1.material.uniforms.backgroundIntensity.value = y.backgroundIntensity, u1.material.toneMapped = v.encoding !== ut, (h !== v || d !== v.version || f !== n1.toneMapping) && (u1.material.needsUpdate = !0, h = v, d = v.version, f = n1.toneMapping), u1.layers.enableAll(), g.unshift(u1, u1.geometry, u1.material, 0, 0, null)) : v && v.isTexture && (c === void 0 && (c = new Mt(new Si(2, 2), new $e({
            name: "BackgroundMaterial",
            uniforms: th(Eo.background.uniforms),
            vertexShader: Eo.background.vertexShader,
            fragmentShader: Eo.background.fragmentShader,
            side: Jn,
            depthTest: !1,
            depthWrite: !1,
            fog: !1
        })), c.geometry.deleteAttribute("normal"), Object.defineProperty(c.material, "map", {
            get: function() {
                return this.uniforms.t2D.value;
            }
        }), i.update(c)), c.material.uniforms.t2D.value = v, c.material.uniforms.backgroundIntensity.value = y.backgroundIntensity, c.material.toneMapped = v.encoding !== ut, v.matrixAutoUpdate === !0 && v.updateMatrix(), c.material.uniforms.uvTransform.value.copy(v.matrix), (h !== v || d !== v.version || f !== n1.toneMapping) && (c.material.needsUpdate = !0, h = v, d = v.version, f = n1.toneMapping), c.layers.enableAll(), g.unshift(c, c.geometry, c.material, 0, 0, null));
    }
    function p(g, y) {
        g.getRGB(Sy, u_(n1)), r.buffers.color.setClear(Sy.r, Sy.g, Sy.b, y, o);
    }
    return {
        getClearColor: function() {
            return a;
        },
        setClearColor: function(g, y = 1) {
            a.set(g), l = y, p(a, l);
        },
        getClearAlpha: function() {
            return l;
        },
        setClearAlpha: function(g) {
            l = g, p(a, l);
        },
        render: m
    };
}
function c4(n1, t, e, r) {
    let i = n1.getParameter(34921), s1 = r.isWebGL2 ? null : t.get("OES_vertex_array_object"), o = r.isWebGL2 || s1 !== null, a = {}, l = g(null), c = l, u1 = !1;
    function h(O, L, j, V, H) {
        let q = !1;
        if (o) {
            let X = p(V, j, L);
            c !== X && (c = X, f(c.object)), q = y(O, V, j, H), q && x(O, V, j, H);
        } else {
            let X = L.wireframe === !0;
            (c.geometry !== V.id || c.program !== j.id || c.wireframe !== X) && (c.geometry = V.id, c.program = j.id, c.wireframe = X, q = !0);
        }
        H !== null && e.update(H, 34963), (q || u1) && (u1 = !1, S(O, L, j, V), H !== null && n1.bindBuffer(34963, e.get(H).buffer));
    }
    function d() {
        return r.isWebGL2 ? n1.createVertexArray() : s1.createVertexArrayOES();
    }
    function f(O) {
        return r.isWebGL2 ? n1.bindVertexArray(O) : s1.bindVertexArrayOES(O);
    }
    function m(O) {
        return r.isWebGL2 ? n1.deleteVertexArray(O) : s1.deleteVertexArrayOES(O);
    }
    function p(O, L, j) {
        let V = j.wireframe === !0, H = a[O.id];
        H === void 0 && (H = {}, a[O.id] = H);
        let q = H[L.id];
        q === void 0 && (q = {}, H[L.id] = q);
        let X = q[V];
        return X === void 0 && (X = g(d()), q[V] = X), X;
    }
    function g(O) {
        let L = [], j = [], V = [];
        for(let H = 0; H < i; H++)L[H] = 0, j[H] = 0, V[H] = 0;
        return {
            geometry: null,
            program: null,
            wireframe: !1,
            newAttributes: L,
            enabledAttributes: j,
            attributeDivisors: V,
            object: O,
            attributes: {},
            index: null
        };
    }
    function y(O, L, j, V) {
        let H = c.attributes, q = L.attributes, X = 0, K = j.getAttributes();
        for(let z in K)if (K[z].location >= 0) {
            let te = H[z], $ = q[z];
            if ($ === void 0 && (z === "instanceMatrix" && O.instanceMatrix && ($ = O.instanceMatrix), z === "instanceColor" && O.instanceColor && ($ = O.instanceColor)), te === void 0 || te.attribute !== $ || $ && te.data !== $.data) return !0;
            X++;
        }
        return c.attributesNum !== X || c.index !== V;
    }
    function x(O, L, j, V) {
        let H = {}, q = L.attributes, X = 0, K = j.getAttributes();
        for(let z in K)if (K[z].location >= 0) {
            let te = q[z];
            te === void 0 && (z === "instanceMatrix" && O.instanceMatrix && (te = O.instanceMatrix), z === "instanceColor" && O.instanceColor && (te = O.instanceColor));
            let $ = {};
            $.attribute = te, te && te.data && ($.data = te.data), H[z] = $, X++;
        }
        c.attributes = H, c.attributesNum = X, c.index = V;
    }
    function v() {
        let O = c.newAttributes;
        for(let L = 0, j = O.length; L < j; L++)O[L] = 0;
    }
    function b(O) {
        w(O, 0);
    }
    function w(O, L) {
        let j = c.newAttributes, V = c.enabledAttributes, H = c.attributeDivisors;
        j[O] = 1, V[O] === 0 && (n1.enableVertexAttribArray(O), V[O] = 1), H[O] !== L && ((r.isWebGL2 ? n1 : t.get("ANGLE_instanced_arrays"))[r.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](O, L), H[O] = L);
    }
    function A() {
        let O = c.newAttributes, L = c.enabledAttributes;
        for(let j = 0, V = L.length; j < V; j++)L[j] !== O[j] && (n1.disableVertexAttribArray(j), L[j] = 0);
    }
    function T(O, L, j, V, H, q) {
        r.isWebGL2 === !0 && (j === 5124 || j === 5125) ? n1.vertexAttribIPointer(O, L, j, H, q) : n1.vertexAttribPointer(O, L, j, V, H, q);
    }
    function S(O, L, j, V) {
        if (r.isWebGL2 === !1 && (O.isInstancedMesh || V.isInstancedBufferGeometry) && t.get("ANGLE_instanced_arrays") === null) return;
        v();
        let H = V.attributes, q = j.getAttributes(), X = L.defaultAttributeValues;
        for(let K in q){
            let z = q[K];
            if (z.location >= 0) {
                let Q = H[K];
                if (Q === void 0 && (K === "instanceMatrix" && O.instanceMatrix && (Q = O.instanceMatrix), K === "instanceColor" && O.instanceColor && (Q = O.instanceColor)), Q !== void 0) {
                    let te = Q.normalized, $ = Q.itemSize, W = e.get(Q);
                    if (W === void 0) continue;
                    let oe = W.buffer, ie = W.type, re = W.bytesPerElement;
                    if (Q.isInterleavedBufferAttribute) {
                        let J = Q.data, Ee = J.stride, xe = Q.offset;
                        if (J.isInstancedInterleavedBuffer) {
                            for(let de = 0; de < z.locationSize; de++)w(z.location + de, J.meshPerAttribute);
                            O.isInstancedMesh !== !0 && V._maxInstanceCount === void 0 && (V._maxInstanceCount = J.meshPerAttribute * J.count);
                        } else for(let de = 0; de < z.locationSize; de++)b(z.location + de);
                        n1.bindBuffer(34962, oe);
                        for(let de = 0; de < z.locationSize; de++)T(z.location + de, $ / z.locationSize, ie, te, Ee * re, (xe + $ / z.locationSize * de) * re);
                    } else {
                        if (Q.isInstancedBufferAttribute) {
                            for(let J = 0; J < z.locationSize; J++)w(z.location + J, Q.meshPerAttribute);
                            O.isInstancedMesh !== !0 && V._maxInstanceCount === void 0 && (V._maxInstanceCount = Q.meshPerAttribute * Q.count);
                        } else for(let J = 0; J < z.locationSize; J++)b(z.location + J);
                        n1.bindBuffer(34962, oe);
                        for(let J = 0; J < z.locationSize; J++)T(z.location + J, $ / z.locationSize, ie, te, $ * re, $ / z.locationSize * J * re);
                    }
                } else if (X !== void 0) {
                    let te = X[K];
                    if (te !== void 0) switch(te.length){
                        case 2:
                            n1.vertexAttrib2fv(z.location, te);
                            break;
                        case 3:
                            n1.vertexAttrib3fv(z.location, te);
                            break;
                        case 4:
                            n1.vertexAttrib4fv(z.location, te);
                            break;
                        default:
                            n1.vertexAttrib1fv(z.location, te);
                    }
                }
            }
        }
        A();
    }
    function M() {
        _();
        for(let O in a){
            let L = a[O];
            for(let j in L){
                let V = L[j];
                for(let H in V)m(V[H].object), delete V[H];
                delete L[j];
            }
            delete a[O];
        }
    }
    function C(O) {
        if (a[O.id] === void 0) return;
        let L = a[O.id];
        for(let j in L){
            let V = L[j];
            for(let H in V)m(V[H].object), delete V[H];
            delete L[j];
        }
        delete a[O.id];
    }
    function P(O) {
        for(let L in a){
            let j = a[L];
            if (j[O.id] === void 0) continue;
            let V = j[O.id];
            for(let H in V)m(V[H].object), delete V[H];
            delete j[O.id];
        }
    }
    function _() {
        I(), u1 = !0, c !== l && (c = l, f(c.object));
    }
    function I() {
        l.geometry = null, l.program = null, l.wireframe = !1;
    }
    return {
        setup: h,
        reset: _,
        resetDefaultState: I,
        dispose: M,
        releaseStatesOfGeometry: C,
        releaseStatesOfProgram: P,
        initAttributes: v,
        enableAttribute: b,
        disableUnusedAttributes: A
    };
}
function u4(n1, t, e, r) {
    let i = r.isWebGL2, s1;
    function o(c) {
        s1 = c;
    }
    function a(c, u1) {
        n1.drawArrays(s1, c, u1), e.update(u1, s1, 1);
    }
    function l(c, u1, h) {
        if (h === 0) return;
        let d, f;
        if (i) d = n1, f = "drawArraysInstanced";
        else if (d = t.get("ANGLE_instanced_arrays"), f = "drawArraysInstancedANGLE", d === null) {
            console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
            return;
        }
        d[f](s1, c, u1, h), e.update(u1, s1, h);
    }
    this.setMode = o, this.render = a, this.renderInstances = l;
}
function h4(n1, t, e) {
    let r;
    function i() {
        if (r !== void 0) return r;
        if (t.has("EXT_texture_filter_anisotropic") === !0) {
            let T = t.get("EXT_texture_filter_anisotropic");
            r = n1.getParameter(T.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else r = 0;
        return r;
    }
    function s1(T) {
        if (T === "highp") {
            if (n1.getShaderPrecisionFormat(35633, 36338).precision > 0 && n1.getShaderPrecisionFormat(35632, 36338).precision > 0) return "highp";
            T = "mediump";
        }
        return T === "mediump" && n1.getShaderPrecisionFormat(35633, 36337).precision > 0 && n1.getShaderPrecisionFormat(35632, 36337).precision > 0 ? "mediump" : "lowp";
    }
    let o = typeof WebGL2RenderingContext < "u" && n1 instanceof WebGL2RenderingContext, a = e.precision !== void 0 ? e.precision : "highp", l = s1(a);
    l !== a && (console.warn("THREE.WebGLRenderer:", a, "not supported, using", l, "instead."), a = l);
    let c = o || t.has("WEBGL_draw_buffers"), u1 = e.logarithmicDepthBuffer === !0, h = n1.getParameter(34930), d = n1.getParameter(35660), f = n1.getParameter(3379), m = n1.getParameter(34076), p = n1.getParameter(34921), g = n1.getParameter(36347), y = n1.getParameter(36348), x = n1.getParameter(36349), v = d > 0, b = o || t.has("OES_texture_float"), w = v && b, A = o ? n1.getParameter(36183) : 0;
    return {
        isWebGL2: o,
        drawBuffers: c,
        getMaxAnisotropy: i,
        getMaxPrecision: s1,
        precision: a,
        logarithmicDepthBuffer: u1,
        maxTextures: h,
        maxVertexTextures: d,
        maxTextureSize: f,
        maxCubemapSize: m,
        maxAttributes: p,
        maxVertexUniforms: g,
        maxVaryings: y,
        maxFragmentUniforms: x,
        vertexTextures: v,
        floatFragmentTextures: b,
        floatVertexTextures: w,
        maxSamples: A
    };
}
function d4(n1) {
    let t = this, e = null, r = 0, i = !1, s1 = !1, o = new qr, a = new Sr, l = {
        value: null,
        needsUpdate: !1
    };
    this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(h, d) {
        let f = h.length !== 0 || d || r !== 0 || i;
        return i = d, r = h.length, f;
    }, this.beginShadows = function() {
        s1 = !0, u1(null);
    }, this.endShadows = function() {
        s1 = !1;
    }, this.setGlobalState = function(h, d) {
        e = u1(h, d, 0);
    }, this.setState = function(h, d, f) {
        let m = h.clippingPlanes, p = h.clipIntersection, g = h.clipShadows, y = n1.get(h);
        if (!i || m === null || m.length === 0 || s1 && !g) s1 ? u1(null) : c();
        else {
            let x = s1 ? 0 : r, v = x * 4, b = y.clippingState || null;
            l.value = b, b = u1(m, d, v, f);
            for(let w = 0; w !== v; ++w)b[w] = e[w];
            y.clippingState = b, this.numIntersection = p ? this.numPlanes : 0, this.numPlanes += x;
        }
    };
    function c() {
        l.value !== e && (l.value = e, l.needsUpdate = r > 0), t.numPlanes = r, t.numIntersection = 0;
    }
    function u1(h, d, f, m) {
        let p = h !== null ? h.length : 0, g = null;
        if (p !== 0) {
            if (g = l.value, m !== !0 || g === null) {
                let y = f + p * 4, x = d.matrixWorldInverse;
                a.getNormalMatrix(x), (g === null || g.length < y) && (g = new Float32Array(y));
                for(let v = 0, b = f; v !== p; ++v, b += 4)o.copy(h[v]).applyMatrix4(x, a), o.normal.toArray(g, b), g[b + 3] = o.constant;
            }
            l.value = g, l.needsUpdate = !0;
        }
        return t.numPlanes = p, t.numIntersection = 0, g;
    }
}
function f4(n1) {
    let t = new WeakMap;
    function e(o, a) {
        return a === GS ? o.mapping = yl : a === jS && (o.mapping = vl), o;
    }
    function r(o) {
        if (o && o.isTexture && o.isRenderTargetTexture === !1) {
            let a = o.mapping;
            if (a === GS || a === jS) {
                if (t.has(o)) {
                    let l = t.get(o).texture;
                    return e(l, o.mapping);
                } else {
                    let l = o.image;
                    if (l && l.height > 0) {
                        let c = new KS(l.height / 2);
                        return c.fromEquirectangularTexture(n1, o), t.set(o, c), o.addEventListener("dispose", i), e(c.texture, o.mapping);
                    } else return null;
                }
            }
        }
        return o;
    }
    function i(o) {
        let a = o.target;
        a.removeEventListener("dispose", i);
        let l = t.get(a);
        l !== void 0 && (t.delete(a), l.dispose());
    }
    function s1() {
        t = new WeakMap;
    }
    return {
        get: r,
        dispose: s1
    };
}
var bl = class extends bn {
    constructor(t = -1, e = 1, r = 1, i = -1, s1 = .1, o = 2e3){
        super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = t, this.right = e, this.top = r, this.bottom = i, this.near = s1, this.far = o, this.updateProjectionMatrix();
    }
    copy(t, e) {
        return super.copy(t, e), this.left = t.left, this.right = t.right, this.top = t.top, this.bottom = t.bottom, this.near = t.near, this.far = t.far, this.zoom = t.zoom, this.view = t.view === null ? null : Object.assign({}, t.view), this;
    }
    setViewOffset(t, e, r, i, s1, o) {
        this.view === null && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = r, this.view.offsetY = i, this.view.width = s1, this.view.height = o, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        let t = (this.right - this.left) / (2 * this.zoom), e = (this.top - this.bottom) / (2 * this.zoom), r = (this.right + this.left) / 2, i = (this.top + this.bottom) / 2, s1 = r - t, o = r + t, a = i + e, l = i - e;
        if (this.view !== null && this.view.enabled) {
            let c = (this.right - this.left) / this.view.fullWidth / this.zoom, u1 = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            s1 += c * this.view.offsetX, o = s1 + c * this.view.width, a -= u1 * this.view.offsetY, l = a - u1 * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(s1, o, a, l, this.near, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return e.object.zoom = this.zoom, e.object.left = this.left, e.object.right = this.right, e.object.top = this.top, e.object.bottom = this.bottom, e.object.near = this.near, e.object.far = this.far, this.view !== null && (e.object.view = Object.assign({}, this.view)), e;
    }
}, Zu = 4, hP = [
    .125,
    .215,
    .35,
    .446,
    .526,
    .582
], Rc = 20, OS = new bl, dP = new Ge, RS = null, Oc = (1 + Math.sqrt(5)) / 2, Xu = 1 / Oc, fP = [
    new E(1, 1, 1),
    new E(-1, 1, 1),
    new E(1, 1, -1),
    new E(-1, 1, -1),
    new E(0, Oc, Xu),
    new E(0, Oc, -Xu),
    new E(Xu, 0, Oc),
    new E(-Xu, 0, Oc),
    new E(Oc, Xu, 0),
    new E(-Oc, Xu, 0)
], jy = class {
    constructor(t){
        this._renderer = t, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
    }
    fromScene(t, e = 0, r = .1, i = 100) {
        RS = this._renderer.getRenderTarget(), this._setSize(256);
        let s1 = this._allocateTargets();
        return s1.depthBuffer = !0, this._sceneToCubeUV(t, r, i, s1), e > 0 && this._blur(s1, 0, 0, e), this._applyPMREM(s1), this._cleanup(s1), s1;
    }
    fromEquirectangular(t, e = null) {
        return this._fromTexture(t, e);
    }
    fromCubemap(t, e = null) {
        return this._fromTexture(t, e);
    }
    compileCubemapShader() {
        this._cubemapMaterial === null && (this._cubemapMaterial = gP(), this._compileMaterial(this._cubemapMaterial));
    }
    compileEquirectangularShader() {
        this._equirectMaterial === null && (this._equirectMaterial = mP(), this._compileMaterial(this._equirectMaterial));
    }
    dispose() {
        this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose();
    }
    _setSize(t) {
        this._lodMax = Math.floor(Math.log2(t)), this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        this._blurMaterial !== null && this._blurMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
        for(let t = 0; t < this._lodPlanes.length; t++)this._lodPlanes[t].dispose();
    }
    _cleanup(t) {
        this._renderer.setRenderTarget(RS), t.scissorTest = !1, wy(t, 0, 0, t.width, t.height);
    }
    _fromTexture(t, e) {
        t.mapping === yl || t.mapping === vl ? this._setSize(t.image.length === 0 ? 16 : t.image[0].width || t.image[0].image.width) : this._setSize(t.image.width / 4), RS = this._renderer.getRenderTarget();
        let r = e || this._allocateTargets();
        return this._textureToCubeUV(t, r), this._applyPMREM(r), this._cleanup(r), r;
    }
    _allocateTargets() {
        let t = 3 * Math.max(this._cubeSize, 112), e = 4 * this._cubeSize, r = {
            magFilter: it,
            minFilter: it,
            generateMipmaps: !1,
            type: $n,
            format: br,
            encoding: xn,
            depthBuffer: !1
        }, i = pP(t, e, r);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== t || this._pingPongRenderTarget.height !== e) {
            this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = pP(t, e, r);
            let { _lodMax: s1 } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = p4(s1)), this._blurMaterial = m4(s1, t, e);
        }
        return i;
    }
    _compileMaterial(t) {
        let e = new Mt(this._lodPlanes[0], t);
        this._renderer.compile(e, OS);
    }
    _sceneToCubeUV(t, e, r, i) {
        let a = new si(90, 1, e, r), l = [
            1,
            -1,
            1,
            1,
            1,
            1
        ], c = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ], u1 = this._renderer, h = u1.autoClear, d = u1.toneMapping;
        u1.getClearColor(dP), u1.toneMapping = js, u1.autoClear = !1;
        let f = new un({
            name: "PMREM.Background",
            side: xi,
            depthWrite: !1,
            depthTest: !1
        }), m = new Mt(new bi, f), p = !1, g = t.background;
        g ? g.isColor && (f.color.copy(g), t.background = null, p = !0) : (f.color.copy(dP), p = !0);
        for(let y = 0; y < 6; y++){
            let x = y % 3;
            x === 0 ? (a.up.set(0, l[y], 0), a.lookAt(c[y], 0, 0)) : x === 1 ? (a.up.set(0, 0, l[y]), a.lookAt(0, c[y], 0)) : (a.up.set(0, l[y], 0), a.lookAt(0, 0, c[y]));
            let v = this._cubeSize;
            wy(i, x * v, y > 2 ? v : 0, v, v), u1.setRenderTarget(i), p && u1.render(m, a), u1.render(t, a);
        }
        m.geometry.dispose(), m.material.dispose(), u1.toneMapping = d, u1.autoClear = h, t.background = g;
    }
    _textureToCubeUV(t, e) {
        let r = this._renderer, i = t.mapping === yl || t.mapping === vl;
        i ? (this._cubemapMaterial === null && (this._cubemapMaterial = gP()), this._cubemapMaterial.uniforms.flipEnvMap.value = t.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = mP());
        let s1 = i ? this._cubemapMaterial : this._equirectMaterial, o = new Mt(this._lodPlanes[0], s1), a = s1.uniforms;
        a.envMap.value = t;
        let l = this._cubeSize;
        wy(e, 0, 0, 3 * l, 2 * l), r.setRenderTarget(e), r.render(o, OS);
    }
    _applyPMREM(t) {
        let e = this._renderer, r = e.autoClear;
        e.autoClear = !1;
        for(let i = 1; i < this._lodPlanes.length; i++){
            let s1 = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]), o = fP[(i - 1) % fP.length];
            this._blur(t, i - 1, i, s1, o);
        }
        e.autoClear = r;
    }
    _blur(t, e, r, i, s1) {
        let o = this._pingPongRenderTarget;
        this._halfBlur(t, o, e, r, i, "latitudinal", s1), this._halfBlur(o, t, r, r, i, "longitudinal", s1);
    }
    _halfBlur(t, e, r, i, s1, o, a) {
        let l = this._renderer, c = this._blurMaterial;
        o !== "latitudinal" && o !== "longitudinal" && console.error("blur direction must be either latitudinal or longitudinal!");
        let u1 = 3, h = new Mt(this._lodPlanes[i], c), d = c.uniforms, f = this._sizeLods[r] - 1, m = isFinite(s1) ? Math.PI / (2 * f) : 2 * Math.PI / (2 * Rc - 1), p = s1 / m, g = isFinite(s1) ? 1 + Math.floor(u1 * p) : Rc;
        g > Rc && console.warn(`sigmaRadians, ${s1}, is too large and will clip, as it requested ${g} samples when the maximum is set to ${Rc}`);
        let y = [], x = 0;
        for(let T = 0; T < Rc; ++T){
            let S = T / p, M = Math.exp(-S * S / 2);
            y.push(M), T === 0 ? x += M : T < g && (x += 2 * M);
        }
        for(let T = 0; T < y.length; T++)y[T] = y[T] / x;
        d.envMap.value = t.texture, d.samples.value = g, d.weights.value = y, d.latitudinal.value = o === "latitudinal", a && (d.poleAxis.value = a);
        let { _lodMax: v } = this;
        d.dTheta.value = m, d.mipInt.value = v - r;
        let b = this._sizeLods[i], w = 3 * b * (i > v - Zu ? i - v + Zu : 0), A = 4 * (this._cubeSize - b);
        wy(e, w, A, 3 * b, 2 * b), l.setRenderTarget(e), l.render(h, OS);
    }
};
function p4(n1) {
    let t = [], e = [], r = [], i = n1, s1 = n1 - Zu + 1 + hP.length;
    for(let o = 0; o < s1; o++){
        let a = Math.pow(2, i);
        e.push(a);
        let l = 1 / a;
        o > n1 - Zu ? l = hP[o - n1 + Zu - 1] : o === 0 && (l = 0), r.push(l);
        let c = 1 / (a - 2), u1 = -c, h = 1 + c, d = [
            u1,
            u1,
            h,
            u1,
            h,
            h,
            u1,
            u1,
            h,
            h,
            u1,
            h
        ], f = 6, m = 6, p = 3, g = 2, y = 1, x = new Float32Array(p * m * f), v = new Float32Array(g * m * f), b = new Float32Array(y * m * f);
        for(let A = 0; A < f; A++){
            let T = A % 3 * 2 / 3 - 1, S = A > 2 ? 0 : -1, M = [
                T,
                S,
                0,
                T + 2 / 3,
                S,
                0,
                T + 2 / 3,
                S + 1,
                0,
                T,
                S,
                0,
                T + 2 / 3,
                S + 1,
                0,
                T,
                S + 1,
                0
            ];
            x.set(M, p * m * A), v.set(d, g * m * A);
            let C = [
                A,
                A,
                A,
                A,
                A,
                A
            ];
            b.set(C, y * m * A);
        }
        let w = new Ce;
        w.setAttribute("position", new je(x, p)), w.setAttribute("uv", new je(v, g)), w.setAttribute("faceIndex", new je(b, y)), t.push(w), i > Zu && i--;
    }
    return {
        lodPlanes: t,
        sizeLods: e,
        sigmas: r
    };
}
function pP(n1, t, e) {
    let r = new at(n1, t, e);
    return r.texture.mapping = xh, r.texture.name = "PMREM.cubeUv", r.scissorTest = !0, r;
}
function wy(n1, t, e, r, i) {
    n1.viewport.set(t, e, r, i), n1.scissor.set(t, e, r, i);
}
function m4(n1, t, e) {
    let r = new Float32Array(Rc), i = new E(0, 1, 0);
    return new $e({
        name: "SphericalGaussianBlur",
        defines: {
            n: Rc,
            CUBEUV_TEXEL_WIDTH: 1 / t,
            CUBEUV_TEXEL_HEIGHT: 1 / e,
            CUBEUV_MAX_MIP: `${n1}.0`
        },
        uniforms: {
            envMap: {
                value: null
            },
            samples: {
                value: 1
            },
            weights: {
                value: r
            },
            latitudinal: {
                value: !1
            },
            dTheta: {
                value: 0
            },
            mipInt: {
                value: 0
            },
            poleAxis: {
                value: i
            }
        },
        vertexShader: _w(),
        fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: or,
        depthTest: !1,
        depthWrite: !1
    });
}
function mP() {
    return new $e({
        name: "EquirectangularToCubeUV",
        uniforms: {
            envMap: {
                value: null
            }
        },
        vertexShader: _w(),
        fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: or,
        depthTest: !1,
        depthWrite: !1
    });
}
function gP() {
    return new $e({
        name: "CubemapToCubeUV",
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            }
        },
        vertexShader: _w(),
        fragmentShader: `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: or,
        depthTest: !1,
        depthWrite: !1
    });
}
function _w() {
    return `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function g4(n1) {
    let t = new WeakMap, e = null;
    function r(a) {
        if (a && a.isTexture) {
            let l = a.mapping, c = l === GS || l === jS, u1 = l === yl || l === vl;
            if (c || u1) {
                if (a.isRenderTargetTexture && a.needsPMREMUpdate === !0) {
                    a.needsPMREMUpdate = !1;
                    let h = t.get(a);
                    return e === null && (e = new jy(n1)), h = c ? e.fromEquirectangular(a, h) : e.fromCubemap(a, h), t.set(a, h), h.texture;
                } else {
                    if (t.has(a)) return t.get(a).texture;
                    {
                        let h = a.image;
                        if (c && h && h.height > 0 || u1 && h && i(h)) {
                            e === null && (e = new jy(n1));
                            let d = c ? e.fromEquirectangular(a) : e.fromCubemap(a);
                            return t.set(a, d), a.addEventListener("dispose", s1), d.texture;
                        } else return null;
                    }
                }
            }
        }
        return a;
    }
    function i(a) {
        let l = 0, c = 6;
        for(let u1 = 0; u1 < c; u1++)a[u1] !== void 0 && l++;
        return l === c;
    }
    function s1(a) {
        let l = a.target;
        l.removeEventListener("dispose", s1);
        let c = t.get(l);
        c !== void 0 && (t.delete(l), c.dispose());
    }
    function o() {
        t = new WeakMap, e !== null && (e.dispose(), e = null);
    }
    return {
        get: r,
        dispose: o
    };
}
function y4(n1) {
    let t = {};
    function e(r) {
        if (t[r] !== void 0) return t[r];
        let i;
        switch(r){
            case "WEBGL_depth_texture":
                i = n1.getExtension("WEBGL_depth_texture") || n1.getExtension("MOZ_WEBGL_depth_texture") || n1.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                i = n1.getExtension("EXT_texture_filter_anisotropic") || n1.getExtension("MOZ_EXT_texture_filter_anisotropic") || n1.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                i = n1.getExtension("WEBGL_compressed_texture_s3tc") || n1.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || n1.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                i = n1.getExtension("WEBGL_compressed_texture_pvrtc") || n1.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                i = n1.getExtension(r);
        }
        return t[r] = i, i;
    }
    return {
        has: function(r) {
            return e(r) !== null;
        },
        init: function(r) {
            r.isWebGL2 ? e("EXT_color_buffer_float") : (e("WEBGL_depth_texture"), e("OES_texture_float"), e("OES_texture_half_float"), e("OES_texture_half_float_linear"), e("OES_standard_derivatives"), e("OES_element_index_uint"), e("OES_vertex_array_object"), e("ANGLE_instanced_arrays")), e("OES_texture_float_linear"), e("EXT_color_buffer_half_float"), e("WEBGL_multisampled_render_to_texture");
        },
        get: function(r) {
            let i = e(r);
            return i === null && console.warn("THREE.WebGLRenderer: " + r + " extension not supported."), i;
        }
    };
}
function v4(n1, t, e, r) {
    let i = {}, s1 = new WeakMap;
    function o(h) {
        let d = h.target;
        d.index !== null && t.remove(d.index);
        for(let m in d.attributes)t.remove(d.attributes[m]);
        d.removeEventListener("dispose", o), delete i[d.id];
        let f = s1.get(d);
        f && (t.remove(f), s1.delete(d)), r.releaseStatesOfGeometry(d), d.isInstancedBufferGeometry === !0 && delete d._maxInstanceCount, e.memory.geometries--;
    }
    function a(h, d) {
        return i[d.id] === !0 || (d.addEventListener("dispose", o), i[d.id] = !0, e.memory.geometries++), d;
    }
    function l(h) {
        let d = h.attributes;
        for(let m in d)t.update(d[m], 34962);
        let f = h.morphAttributes;
        for(let m in f){
            let p = f[m];
            for(let g = 0, y = p.length; g < y; g++)t.update(p[g], 34962);
        }
    }
    function c(h) {
        let d = [], f = h.index, m = h.attributes.position, p = 0;
        if (f !== null) {
            let x = f.array;
            p = f.version;
            for(let v = 0, b = x.length; v < b; v += 3){
                let w = x[v + 0], A = x[v + 1], T = x[v + 2];
                d.push(w, A, A, T, T, w);
            }
        } else {
            let x = m.array;
            p = m.version;
            for(let v = 0, b = x.length / 3 - 1; v < b; v += 3){
                let w = v + 0, A = v + 1, T = v + 2;
                d.push(w, A, A, T, T, w);
            }
        }
        let g = new (l_(d) ? To : Gy)(d, 1);
        g.version = p;
        let y = s1.get(h);
        y && t.remove(y), s1.set(h, g);
    }
    function u1(h) {
        let d = s1.get(h);
        if (d) {
            let f = h.index;
            f !== null && d.version < f.version && c(h);
        } else c(h);
        return s1.get(h);
    }
    return {
        get: a,
        update: l,
        getWireframeAttribute: u1
    };
}
function x4(n1, t, e, r) {
    let i = r.isWebGL2, s1;
    function o(d) {
        s1 = d;
    }
    let a, l;
    function c(d) {
        a = d.type, l = d.bytesPerElement;
    }
    function u1(d, f) {
        n1.drawElements(s1, f, a, d * l), e.update(f, s1, 1);
    }
    function h(d, f, m) {
        if (m === 0) return;
        let p, g;
        if (i) p = n1, g = "drawElementsInstanced";
        else if (p = t.get("ANGLE_instanced_arrays"), g = "drawElementsInstancedANGLE", p === null) {
            console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
            return;
        }
        p[g](s1, f, a, d * l, m), e.update(f, s1, m);
    }
    this.setMode = o, this.setIndex = c, this.render = u1, this.renderInstances = h;
}
function b4(n1) {
    let t = {
        geometries: 0,
        textures: 0
    }, e = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function r(s1, o, a) {
        switch(e.calls++, o){
            case 4:
                e.triangles += a * (s1 / 3);
                break;
            case 1:
                e.lines += a * (s1 / 2);
                break;
            case 3:
                e.lines += a * (s1 - 1);
                break;
            case 2:
                e.lines += a * s1;
                break;
            case 0:
                e.points += a * s1;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", o);
                break;
        }
    }
    function i() {
        e.frame++, e.calls = 0, e.triangles = 0, e.points = 0, e.lines = 0;
    }
    return {
        memory: t,
        render: e,
        programs: null,
        autoReset: !0,
        reset: i,
        update: r
    };
}
function S4(n1, t) {
    return n1[0] - t[0];
}
function w4(n1, t) {
    return Math.abs(t[1]) - Math.abs(n1[1]);
}
function A4(n1, t, e) {
    let r = {}, i = new Float32Array(8), s1 = new WeakMap, o = new Ze, a = [];
    for(let c = 0; c < 8; c++)a[c] = [
        c,
        0
    ];
    function l(c, u1, h, d) {
        let f = c.morphTargetInfluences;
        if (t.isWebGL2 === !0) {
            let m = u1.morphAttributes.position || u1.morphAttributes.normal || u1.morphAttributes.color, p = m !== void 0 ? m.length : 0, g = s1.get(u1);
            if (g === void 0 || g.count !== p) {
                let L = function() {
                    I.dispose(), s1.delete(u1), u1.removeEventListener("dispose", L);
                };
                g !== void 0 && g.texture.dispose();
                let v = u1.morphAttributes.position !== void 0, b = u1.morphAttributes.normal !== void 0, w = u1.morphAttributes.color !== void 0, A = u1.morphAttributes.position || [], T = u1.morphAttributes.normal || [], S = u1.morphAttributes.color || [], M = 0;
                v === !0 && (M = 1), b === !0 && (M = 2), w === !0 && (M = 3);
                let C = u1.attributes.position.count * M, P = 1;
                C > t.maxTextureSize && (P = Math.ceil(C / t.maxTextureSize), C = t.maxTextureSize);
                let _ = new Float32Array(C * P * 4 * p), I = new ky(_, C, P, p);
                I.type = Ut, I.needsUpdate = !0;
                let O = M * 4;
                for(let j = 0; j < p; j++){
                    let V = A[j], H = T[j], q = S[j], X = C * P * 4 * j;
                    for(let K = 0; K < V.count; K++){
                        let z = K * O;
                        v === !0 && (o.fromBufferAttribute(V, K), _[X + z + 0] = o.x, _[X + z + 1] = o.y, _[X + z + 2] = o.z, _[X + z + 3] = 0), b === !0 && (o.fromBufferAttribute(H, K), _[X + z + 4] = o.x, _[X + z + 5] = o.y, _[X + z + 6] = o.z, _[X + z + 7] = 0), w === !0 && (o.fromBufferAttribute(q, K), _[X + z + 8] = o.x, _[X + z + 9] = o.y, _[X + z + 10] = o.z, _[X + z + 11] = q.itemSize === 4 ? o.w : 1);
                    }
                }
                g = {
                    count: p,
                    texture: I,
                    size: new U(C, P)
                }, s1.set(u1, g), u1.addEventListener("dispose", L);
            }
            let y = 0;
            for(let v = 0; v < f.length; v++)y += f[v];
            let x = u1.morphTargetsRelative ? 1 : 1 - y;
            d.getUniforms().setValue(n1, "morphTargetBaseInfluence", x), d.getUniforms().setValue(n1, "morphTargetInfluences", f), d.getUniforms().setValue(n1, "morphTargetsTexture", g.texture, e), d.getUniforms().setValue(n1, "morphTargetsTextureSize", g.size);
        } else {
            let m = f === void 0 ? 0 : f.length, p = r[u1.id];
            if (p === void 0 || p.length !== m) {
                p = [];
                for(let b = 0; b < m; b++)p[b] = [
                    b,
                    0
                ];
                r[u1.id] = p;
            }
            for(let b = 0; b < m; b++){
                let w = p[b];
                w[0] = b, w[1] = f[b];
            }
            p.sort(w4);
            for(let b = 0; b < 8; b++)b < m && p[b][1] ? (a[b][0] = p[b][0], a[b][1] = p[b][1]) : (a[b][0] = Number.MAX_SAFE_INTEGER, a[b][1] = 0);
            a.sort(S4);
            let g = u1.morphAttributes.position, y = u1.morphAttributes.normal, x = 0;
            for(let b = 0; b < 8; b++){
                let w = a[b], A = w[0], T = w[1];
                A !== Number.MAX_SAFE_INTEGER && T ? (g && u1.getAttribute("morphTarget" + b) !== g[A] && u1.setAttribute("morphTarget" + b, g[A]), y && u1.getAttribute("morphNormal" + b) !== y[A] && u1.setAttribute("morphNormal" + b, y[A]), i[b] = T, x += T) : (g && u1.hasAttribute("morphTarget" + b) === !0 && u1.deleteAttribute("morphTarget" + b), y && u1.hasAttribute("morphNormal" + b) === !0 && u1.deleteAttribute("morphNormal" + b), i[b] = 0);
            }
            let v = u1.morphTargetsRelative ? 1 : 1 - x;
            d.getUniforms().setValue(n1, "morphTargetBaseInfluence", v), d.getUniforms().setValue(n1, "morphTargetInfluences", i);
        }
    }
    return {
        update: l
    };
}
function E4(n1, t, e, r) {
    let i = new WeakMap;
    function s1(l) {
        let c = r.render.frame, u1 = l.geometry, h = t.get(l, u1);
        return i.get(h) !== c && (t.update(h), i.set(h, c)), l.isInstancedMesh && (l.hasEventListener("dispose", a) === !1 && l.addEventListener("dispose", a), e.update(l.instanceMatrix, 34962), l.instanceColor !== null && e.update(l.instanceColor, 34962)), h;
    }
    function o() {
        i = new WeakMap;
    }
    function a(l) {
        let c = l.target;
        c.removeEventListener("dispose", a), e.remove(c.instanceMatrix), c.instanceColor !== null && e.remove(c.instanceColor);
    }
    return {
        update: s1,
        dispose: o
    };
}
var d_ = new Zt, f_ = new ky, p_ = new zy, m_ = new rh, yP = [], vP = [], xP = new Float32Array(16), bP = new Float32Array(9), SP = new Float32Array(4);
function Sh(n1, t, e) {
    let r = n1[0];
    if (r == null || r <= 0 || r > 0) return n1;
    let i = t * e, s1 = yP[i];
    if (s1 === void 0 && (s1 = new Float32Array(i), yP[i] = s1), t !== 0) {
        r.toArray(s1, 0);
        for(let o = 1, a = 0; o !== t; ++o)a += e, n1[o].toArray(s1, a);
    }
    return s1;
}
function _i(n1, t) {
    if (n1.length !== t.length) return !1;
    for(let e = 0, r = n1.length; e < r; e++)if (n1[e] !== t[e]) return !1;
    return !0;
}
function Ii(n1, t) {
    for(let e = 0, r = t.length; e < r; e++)n1[e] = t[e];
}
function uv(n1, t) {
    let e = vP[t];
    e === void 0 && (e = new Int32Array(t), vP[t] = e);
    for(let r = 0; r !== t; ++r)e[r] = n1.allocateTextureUnit();
    return e;
}
function T4(n1, t) {
    let e = this.cache;
    e[0] !== t && (n1.uniform1f(this.addr, t), e[0] = t);
}
function M4(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y) && (n1.uniform2f(this.addr, t.x, t.y), e[0] = t.x, e[1] = t.y);
    else {
        if (_i(e, t)) return;
        n1.uniform2fv(this.addr, t), Ii(e, t);
    }
}
function C4(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z) && (n1.uniform3f(this.addr, t.x, t.y, t.z), e[0] = t.x, e[1] = t.y, e[2] = t.z);
    else if (t.r !== void 0) (e[0] !== t.r || e[1] !== t.g || e[2] !== t.b) && (n1.uniform3f(this.addr, t.r, t.g, t.b), e[0] = t.r, e[1] = t.g, e[2] = t.b);
    else {
        if (_i(e, t)) return;
        n1.uniform3fv(this.addr, t), Ii(e, t);
    }
}
function P4(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z || e[3] !== t.w) && (n1.uniform4f(this.addr, t.x, t.y, t.z, t.w), e[0] = t.x, e[1] = t.y, e[2] = t.z, e[3] = t.w);
    else {
        if (_i(e, t)) return;
        n1.uniform4fv(this.addr, t), Ii(e, t);
    }
}
function _4(n1, t) {
    let e = this.cache, r = t.elements;
    if (r === void 0) {
        if (_i(e, t)) return;
        n1.uniformMatrix2fv(this.addr, !1, t), Ii(e, t);
    } else {
        if (_i(e, r)) return;
        SP.set(r), n1.uniformMatrix2fv(this.addr, !1, SP), Ii(e, r);
    }
}
function I4(n1, t) {
    let e = this.cache, r = t.elements;
    if (r === void 0) {
        if (_i(e, t)) return;
        n1.uniformMatrix3fv(this.addr, !1, t), Ii(e, t);
    } else {
        if (_i(e, r)) return;
        bP.set(r), n1.uniformMatrix3fv(this.addr, !1, bP), Ii(e, r);
    }
}
function D4(n1, t) {
    let e = this.cache, r = t.elements;
    if (r === void 0) {
        if (_i(e, t)) return;
        n1.uniformMatrix4fv(this.addr, !1, t), Ii(e, t);
    } else {
        if (_i(e, r)) return;
        xP.set(r), n1.uniformMatrix4fv(this.addr, !1, xP), Ii(e, r);
    }
}
function O4(n1, t) {
    let e = this.cache;
    e[0] !== t && (n1.uniform1i(this.addr, t), e[0] = t);
}
function R4(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y) && (n1.uniform2i(this.addr, t.x, t.y), e[0] = t.x, e[1] = t.y);
    else {
        if (_i(e, t)) return;
        n1.uniform2iv(this.addr, t), Ii(e, t);
    }
}
function L4(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z) && (n1.uniform3i(this.addr, t.x, t.y, t.z), e[0] = t.x, e[1] = t.y, e[2] = t.z);
    else {
        if (_i(e, t)) return;
        n1.uniform3iv(this.addr, t), Ii(e, t);
    }
}
function N4(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z || e[3] !== t.w) && (n1.uniform4i(this.addr, t.x, t.y, t.z, t.w), e[0] = t.x, e[1] = t.y, e[2] = t.z, e[3] = t.w);
    else {
        if (_i(e, t)) return;
        n1.uniform4iv(this.addr, t), Ii(e, t);
    }
}
function B4(n1, t) {
    let e = this.cache;
    e[0] !== t && (n1.uniform1ui(this.addr, t), e[0] = t);
}
function F4(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y) && (n1.uniform2ui(this.addr, t.x, t.y), e[0] = t.x, e[1] = t.y);
    else {
        if (_i(e, t)) return;
        n1.uniform2uiv(this.addr, t), Ii(e, t);
    }
}
function V4(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z) && (n1.uniform3ui(this.addr, t.x, t.y, t.z), e[0] = t.x, e[1] = t.y, e[2] = t.z);
    else {
        if (_i(e, t)) return;
        n1.uniform3uiv(this.addr, t), Ii(e, t);
    }
}
function U4(n1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z || e[3] !== t.w) && (n1.uniform4ui(this.addr, t.x, t.y, t.z, t.w), e[0] = t.x, e[1] = t.y, e[2] = t.z, e[3] = t.w);
    else {
        if (_i(e, t)) return;
        n1.uniform4uiv(this.addr, t), Ii(e, t);
    }
}
function k4(n1, t, e) {
    let r = this.cache, i = e.allocateTextureUnit();
    r[0] !== i && (n1.uniform1i(this.addr, i), r[0] = i), e.setTexture2D(t || d_, i);
}
function z4(n1, t, e) {
    let r = this.cache, i = e.allocateTextureUnit();
    r[0] !== i && (n1.uniform1i(this.addr, i), r[0] = i), e.setTexture3D(t || p_, i);
}
function G4(n1, t, e) {
    let r = this.cache, i = e.allocateTextureUnit();
    r[0] !== i && (n1.uniform1i(this.addr, i), r[0] = i), e.setTextureCube(t || m_, i);
}
function j4(n1, t, e) {
    let r = this.cache, i = e.allocateTextureUnit();
    r[0] !== i && (n1.uniform1i(this.addr, i), r[0] = i), e.setTexture2DArray(t || f_, i);
}
function H4(n1) {
    switch(n1){
        case 5126:
            return T4;
        case 35664:
            return M4;
        case 35665:
            return C4;
        case 35666:
            return P4;
        case 35674:
            return _4;
        case 35675:
            return I4;
        case 35676:
            return D4;
        case 5124:
        case 35670:
            return O4;
        case 35667:
        case 35671:
            return R4;
        case 35668:
        case 35672:
            return L4;
        case 35669:
        case 35673:
            return N4;
        case 5125:
            return B4;
        case 36294:
            return F4;
        case 36295:
            return V4;
        case 36296:
            return U4;
        case 35678:
        case 36198:
        case 36298:
        case 36306:
        case 35682:
            return k4;
        case 35679:
        case 36299:
        case 36307:
            return z4;
        case 35680:
        case 36300:
        case 36308:
        case 36293:
            return G4;
        case 36289:
        case 36303:
        case 36311:
        case 36292:
            return j4;
    }
}
function W4(n1, t) {
    n1.uniform1fv(this.addr, t);
}
function q4(n1, t) {
    let e = Sh(t, this.size, 2);
    n1.uniform2fv(this.addr, e);
}
function X4(n1, t) {
    let e = Sh(t, this.size, 3);
    n1.uniform3fv(this.addr, e);
}
function Y4(n1, t) {
    let e = Sh(t, this.size, 4);
    n1.uniform4fv(this.addr, e);
}
function K4(n1, t) {
    let e = Sh(t, this.size, 4);
    n1.uniformMatrix2fv(this.addr, !1, e);
}
function Q4(n1, t) {
    let e = Sh(t, this.size, 9);
    n1.uniformMatrix3fv(this.addr, !1, e);
}
function Z4(n1, t) {
    let e = Sh(t, this.size, 16);
    n1.uniformMatrix4fv(this.addr, !1, e);
}
function J4(n1, t) {
    n1.uniform1iv(this.addr, t);
}
function $4(n1, t) {
    n1.uniform2iv(this.addr, t);
}
function e5(n1, t) {
    n1.uniform3iv(this.addr, t);
}
function t5(n1, t) {
    n1.uniform4iv(this.addr, t);
}
function r5(n1, t) {
    n1.uniform1uiv(this.addr, t);
}
function i5(n1, t) {
    n1.uniform2uiv(this.addr, t);
}
function n5(n1, t) {
    n1.uniform3uiv(this.addr, t);
}
function s5(n1, t) {
    n1.uniform4uiv(this.addr, t);
}
function o5(n1, t, e) {
    let r = this.cache, i = t.length, s1 = uv(e, i);
    _i(r, s1) || (n1.uniform1iv(this.addr, s1), Ii(r, s1));
    for(let o = 0; o !== i; ++o)e.setTexture2D(t[o] || d_, s1[o]);
}
function a5(n1, t, e) {
    let r = this.cache, i = t.length, s1 = uv(e, i);
    _i(r, s1) || (n1.uniform1iv(this.addr, s1), Ii(r, s1));
    for(let o = 0; o !== i; ++o)e.setTexture3D(t[o] || p_, s1[o]);
}
function l5(n1, t, e) {
    let r = this.cache, i = t.length, s1 = uv(e, i);
    _i(r, s1) || (n1.uniform1iv(this.addr, s1), Ii(r, s1));
    for(let o = 0; o !== i; ++o)e.setTextureCube(t[o] || m_, s1[o]);
}
function c5(n1, t, e) {
    let r = this.cache, i = t.length, s1 = uv(e, i);
    _i(r, s1) || (n1.uniform1iv(this.addr, s1), Ii(r, s1));
    for(let o = 0; o !== i; ++o)e.setTexture2DArray(t[o] || f_, s1[o]);
}
function u5(n1) {
    switch(n1){
        case 5126:
            return W4;
        case 35664:
            return q4;
        case 35665:
            return X4;
        case 35666:
            return Y4;
        case 35674:
            return K4;
        case 35675:
            return Q4;
        case 35676:
            return Z4;
        case 5124:
        case 35670:
            return J4;
        case 35667:
        case 35671:
            return $4;
        case 35668:
        case 35672:
            return e5;
        case 35669:
        case 35673:
            return t5;
        case 5125:
            return r5;
        case 36294:
            return i5;
        case 36295:
            return n5;
        case 36296:
            return s5;
        case 35678:
        case 36198:
        case 36298:
        case 36306:
        case 35682:
            return o5;
        case 35679:
        case 36299:
        case 36307:
            return a5;
        case 35680:
        case 36300:
        case 36308:
        case 36293:
            return l5;
        case 36289:
        case 36303:
        case 36311:
        case 36292:
            return c5;
    }
}
var QS = class {
    constructor(t, e, r){
        this.id = t, this.addr = r, this.cache = [], this.setValue = H4(e.type);
    }
}, ZS = class {
    constructor(t, e, r){
        this.id = t, this.addr = r, this.cache = [], this.size = e.size, this.setValue = u5(e.type);
    }
}, JS = class {
    constructor(t){
        this.id = t, this.seq = [], this.map = {};
    }
    setValue(t, e, r) {
        if (e === void 0) return;
        let i = this.seq;
        for(let s1 = 0, o = i.length; s1 !== o; ++s1){
            let a = i[s1];
            a.setValue(t, e[a.id], r);
        }
    }
}, LS = /(\w+)(\])?(\[|\.)?/g;
function wP(n1, t) {
    n1.seq.push(t), n1.map[t.id] = t;
}
function h5(n1, t, e) {
    let r = n1.name, i = r.length;
    for(LS.lastIndex = 0;;){
        let s1 = LS.exec(r), o = LS.lastIndex, a = s1[1], l = s1[2] === "]", c = s1[3];
        if (l && (a = a | 0), c === void 0 || c === "[" && o + 2 === i) {
            wP(e, c === void 0 ? new QS(a, n1, t) : new ZS(a, n1, t));
            break;
        } else {
            let h = e.map[a];
            h === void 0 && (h = new JS(a), wP(e, h)), e = h;
        }
    }
}
var $u = class {
    constructor(t, e){
        this.seq = [], this.map = {};
        let r = t.getProgramParameter(e, 35718);
        for(let i = 0; i < r; ++i){
            let s1 = t.getActiveUniform(e, i), o = t.getUniformLocation(e, s1.name);
            h5(s1, o, this);
        }
    }
    setValue(t, e, r, i) {
        let s1 = this.map[e];
        s1 !== void 0 && s1.setValue(t, r, i);
    }
    setOptional(t, e, r) {
        let i = e[r];
        i !== void 0 && this.setValue(t, r, i);
    }
    static upload(t, e, r, i) {
        for(let s1 = 0, o = e.length; s1 !== o; ++s1){
            let a = e[s1], l = r[a.id];
            l.needsUpdate !== !1 && a.setValue(t, l.value, i);
        }
    }
    static seqWithValue(t, e) {
        let r = [];
        for(let i = 0, s1 = t.length; i !== s1; ++i){
            let o = t[i];
            o.id in e && r.push(o);
        }
        return r;
    }
};
function AP(n1, t, e) {
    let r = n1.createShader(t);
    return n1.shaderSource(r, e), n1.compileShader(r), r;
}
var d5 = 0;
function f5(n1, t) {
    let e = n1.split(`
`), r = [], i = Math.max(t - 6, 0), s1 = Math.min(t + 6, e.length);
    for(let o = i; o < s1; o++){
        let a = o + 1;
        r.push(`${a === t ? ">" : " "} ${a}: ${e[o]}`);
    }
    return r.join(`
`);
}
function p5(n1) {
    switch(n1){
        case xn:
            return [
                "Linear",
                "( value )"
            ];
        case ut:
            return [
                "sRGB",
                "( value )"
            ];
        default:
            return console.warn("THREE.WebGLProgram: Unsupported encoding:", n1), [
                "Linear",
                "( value )"
            ];
    }
}
function EP(n1, t, e) {
    let r = n1.getShaderParameter(t, 35713), i = n1.getShaderInfoLog(t).trim();
    if (r && i === "") return "";
    let s1 = /ERROR: 0:(\d+)/.exec(i);
    if (s1) {
        let o = parseInt(s1[1]);
        return e.toUpperCase() + `

` + i + `

` + f5(n1.getShaderSource(t), o);
    } else return i;
}
function m5(n1, t) {
    let e = p5(t);
    return "vec4 " + n1 + "( vec4 value ) { return LinearTo" + e[0] + e[1] + "; }";
}
function g5(n1, t) {
    let e;
    switch(t){
        case IU:
            e = "Linear";
            break;
        case DU:
            e = "Reinhard";
            break;
        case OU:
            e = "OptimizedCineon";
            break;
        case RU:
            e = "ACESFilmic";
            break;
        case LU:
            e = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", t), e = "Linear";
    }
    return "vec3 " + n1 + "( vec3 color ) { return " + e + "ToneMapping( color ); }";
}
function y5(n1) {
    return [
        n1.extensionDerivatives || !!n1.envMapCubeUVHeight || n1.bumpMap || n1.tangentSpaceNormalMap || n1.clearcoatNormalMap || n1.flatShading || n1.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
        (n1.extensionFragDepth || n1.logarithmicDepthBuffer) && n1.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
        n1.extensionDrawBuffers && n1.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
        (n1.extensionShaderTextureLOD || n1.envMap || n1.transmission) && n1.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
    ].filter(_p).join(`
`);
}
function v5(n1) {
    let t = [];
    for(let e in n1){
        let r = n1[e];
        r !== !1 && t.push("#define " + e + " " + r);
    }
    return t.join(`
`);
}
function x5(n1, t) {
    let e = {}, r = n1.getProgramParameter(t, 35721);
    for(let i = 0; i < r; i++){
        let s1 = n1.getActiveAttrib(t, i), o = s1.name, a = 1;
        s1.type === 35674 && (a = 2), s1.type === 35675 && (a = 3), s1.type === 35676 && (a = 4), e[o] = {
            type: s1.type,
            location: n1.getAttribLocation(t, o),
            locationSize: a
        };
    }
    return e;
}
function _p(n1) {
    return n1 !== "";
}
function TP(n1, t) {
    let e = t.numSpotLightShadows + t.numSpotLightMaps - t.numSpotLightShadowsWithMaps;
    return n1.replace(/NUM_DIR_LIGHTS/g, t.numDirLights).replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, t.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, e).replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, t.numPointLights).replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, t.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, t.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, t.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, t.numPointLightShadows);
}
function MP(n1, t) {
    return n1.replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, t.numClippingPlanes - t.numClipIntersection);
}
var b5 = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $S(n1) {
    return n1.replace(b5, S5);
}
function S5(n1, t) {
    let e = wt[t];
    if (e === void 0) throw new Error("Can not resolve #include <" + t + ">");
    return $S(e);
}
var w5 = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function CP(n1) {
    return n1.replace(w5, A5);
}
function A5(n1, t, e, r) {
    let i = "";
    for(let s1 = parseInt(t); s1 < parseInt(e); s1++)i += r.replace(/\[\s*i\s*\]/g, "[ " + s1 + " ]").replace(/UNROLLED_LOOP_INDEX/g, s1);
    return i;
}
function PP(n1) {
    let t = "precision " + n1.precision + ` float;
precision ` + n1.precision + " int;";
    return n1.precision === "highp" ? t += `
#define HIGH_PRECISION` : n1.precision === "mediump" ? t += `
#define MEDIUM_PRECISION` : n1.precision === "lowp" && (t += `
#define LOW_PRECISION`), t;
}
function E5(n1) {
    let t = "SHADOWMAP_TYPE_BASIC";
    return n1.shadowMapType === cv ? t = "SHADOWMAP_TYPE_PCF" : n1.shadowMapType === lU ? t = "SHADOWMAP_TYPE_PCF_SOFT" : n1.shadowMapType === Pp && (t = "SHADOWMAP_TYPE_VSM"), t;
}
function T5(n1) {
    let t = "ENVMAP_TYPE_CUBE";
    if (n1.envMap) switch(n1.envMapMode){
        case yl:
        case vl:
            t = "ENVMAP_TYPE_CUBE";
            break;
        case xh:
            t = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return t;
}
function M5(n1) {
    let t = "ENVMAP_MODE_REFLECTION";
    if (n1.envMap) switch(n1.envMapMode){
        case vl:
            t = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return t;
}
function C5(n1) {
    let t = "ENVMAP_BLENDING_NONE";
    if (n1.envMap) switch(n1.combine){
        case i_:
            t = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case PU:
            t = "ENVMAP_BLENDING_MIX";
            break;
        case _U:
            t = "ENVMAP_BLENDING_ADD";
            break;
    }
    return t;
}
function P5(n1) {
    let t = n1.envMapCubeUVHeight;
    if (t === null) return null;
    let e = Math.log2(t) - 2, r = 1 / t;
    return {
        texelWidth: 1 / (3 * Math.max(Math.pow(2, e), 112)),
        texelHeight: r,
        maxMip: e
    };
}
function _5(n1, t, e, r) {
    let i = n1.getContext(), s1 = e.defines, o = e.vertexShader, a = e.fragmentShader, l = E5(e), c = T5(e), u1 = M5(e), h = C5(e), d = P5(e), f = e.isWebGL2 ? "" : y5(e), m = v5(s1), p = i.createProgram(), g, y, x = e.glslVersion ? "#version " + e.glslVersion + `
` : "";
    e.isRawShaderMaterial ? (g = [
        m
    ].filter(_p).join(`
`), g.length > 0 && (g += `
`), y = [
        f,
        m
    ].filter(_p).join(`
`), y.length > 0 && (y += `
`)) : (g = [
        PP(e),
        "#define SHADER_NAME " + e.shaderName,
        m,
        e.instancing ? "#define USE_INSTANCING" : "",
        e.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
        e.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "",
        e.useFog && e.fog ? "#define USE_FOG" : "",
        e.useFog && e.fogExp2 ? "#define FOG_EXP2" : "",
        e.map ? "#define USE_MAP" : "",
        e.envMap ? "#define USE_ENVMAP" : "",
        e.envMap ? "#define " + u1 : "",
        e.lightMap ? "#define USE_LIGHTMAP" : "",
        e.aoMap ? "#define USE_AOMAP" : "",
        e.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        e.bumpMap ? "#define USE_BUMPMAP" : "",
        e.normalMap ? "#define USE_NORMALMAP" : "",
        e.normalMap && e.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
        e.normalMap && e.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
        e.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        e.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        e.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        e.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        e.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        e.displacementMap && e.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "",
        e.specularMap ? "#define USE_SPECULARMAP" : "",
        e.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
        e.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
        e.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        e.metalnessMap ? "#define USE_METALNESSMAP" : "",
        e.alphaMap ? "#define USE_ALPHAMAP" : "",
        e.transmission ? "#define USE_TRANSMISSION" : "",
        e.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        e.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        e.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
        e.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
        e.vertexTangents ? "#define USE_TANGENT" : "",
        e.vertexColors ? "#define USE_COLOR" : "",
        e.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        e.vertexUvs ? "#define USE_UV" : "",
        e.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
        e.flatShading ? "#define FLAT_SHADED" : "",
        e.skinning ? "#define USE_SKINNING" : "",
        e.morphTargets ? "#define USE_MORPHTARGETS" : "",
        e.morphNormals && e.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
        e.morphColors && e.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
        e.morphTargetsCount > 0 && e.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
        e.morphTargetsCount > 0 && e.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + e.morphTextureStride : "",
        e.morphTargetsCount > 0 && e.isWebGL2 ? "#define MORPHTARGETS_COUNT " + e.morphTargetsCount : "",
        e.doubleSided ? "#define DOUBLE_SIDED" : "",
        e.flipSided ? "#define FLIP_SIDED" : "",
        e.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        e.shadowMapEnabled ? "#define " + l : "",
        e.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
        e.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        e.logarithmicDepthBuffer && e.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
        "uniform mat4 modelMatrix;",
        "uniform mat4 modelViewMatrix;",
        "uniform mat4 projectionMatrix;",
        "uniform mat4 viewMatrix;",
        "uniform mat3 normalMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        "#ifdef USE_INSTANCING",
        "	attribute mat4 instanceMatrix;",
        "#endif",
        "#ifdef USE_INSTANCING_COLOR",
        "	attribute vec3 instanceColor;",
        "#endif",
        "attribute vec3 position;",
        "attribute vec3 normal;",
        "attribute vec2 uv;",
        "#ifdef USE_TANGENT",
        "	attribute vec4 tangent;",
        "#endif",
        "#if defined( USE_COLOR_ALPHA )",
        "	attribute vec4 color;",
        "#elif defined( USE_COLOR )",
        "	attribute vec3 color;",
        "#endif",
        "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
        "	attribute vec3 morphTarget0;",
        "	attribute vec3 morphTarget1;",
        "	attribute vec3 morphTarget2;",
        "	attribute vec3 morphTarget3;",
        "	#ifdef USE_MORPHNORMALS",
        "		attribute vec3 morphNormal0;",
        "		attribute vec3 morphNormal1;",
        "		attribute vec3 morphNormal2;",
        "		attribute vec3 morphNormal3;",
        "	#else",
        "		attribute vec3 morphTarget4;",
        "		attribute vec3 morphTarget5;",
        "		attribute vec3 morphTarget6;",
        "		attribute vec3 morphTarget7;",
        "	#endif",
        "#endif",
        "#ifdef USE_SKINNING",
        "	attribute vec4 skinIndex;",
        "	attribute vec4 skinWeight;",
        "#endif",
        `
`
    ].filter(_p).join(`
`), y = [
        f,
        PP(e),
        "#define SHADER_NAME " + e.shaderName,
        m,
        e.useFog && e.fog ? "#define USE_FOG" : "",
        e.useFog && e.fogExp2 ? "#define FOG_EXP2" : "",
        e.map ? "#define USE_MAP" : "",
        e.matcap ? "#define USE_MATCAP" : "",
        e.envMap ? "#define USE_ENVMAP" : "",
        e.envMap ? "#define " + c : "",
        e.envMap ? "#define " + u1 : "",
        e.envMap ? "#define " + h : "",
        d ? "#define CUBEUV_TEXEL_WIDTH " + d.texelWidth : "",
        d ? "#define CUBEUV_TEXEL_HEIGHT " + d.texelHeight : "",
        d ? "#define CUBEUV_MAX_MIP " + d.maxMip + ".0" : "",
        e.lightMap ? "#define USE_LIGHTMAP" : "",
        e.aoMap ? "#define USE_AOMAP" : "",
        e.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        e.bumpMap ? "#define USE_BUMPMAP" : "",
        e.normalMap ? "#define USE_NORMALMAP" : "",
        e.normalMap && e.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
        e.normalMap && e.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
        e.clearcoat ? "#define USE_CLEARCOAT" : "",
        e.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        e.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        e.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        e.iridescence ? "#define USE_IRIDESCENCE" : "",
        e.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        e.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        e.specularMap ? "#define USE_SPECULARMAP" : "",
        e.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
        e.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
        e.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        e.metalnessMap ? "#define USE_METALNESSMAP" : "",
        e.alphaMap ? "#define USE_ALPHAMAP" : "",
        e.alphaTest ? "#define USE_ALPHATEST" : "",
        e.sheen ? "#define USE_SHEEN" : "",
        e.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
        e.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
        e.transmission ? "#define USE_TRANSMISSION" : "",
        e.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        e.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        e.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
        e.vertexTangents ? "#define USE_TANGENT" : "",
        e.vertexColors || e.instancingColor ? "#define USE_COLOR" : "",
        e.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        e.vertexUvs ? "#define USE_UV" : "",
        e.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
        e.gradientMap ? "#define USE_GRADIENTMAP" : "",
        e.flatShading ? "#define FLAT_SHADED" : "",
        e.doubleSided ? "#define DOUBLE_SIDED" : "",
        e.flipSided ? "#define FLIP_SIDED" : "",
        e.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        e.shadowMapEnabled ? "#define " + l : "",
        e.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
        e.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "",
        e.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        e.logarithmicDepthBuffer && e.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
        "uniform mat4 viewMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        e.toneMapping !== js ? "#define TONE_MAPPING" : "",
        e.toneMapping !== js ? wt.tonemapping_pars_fragment : "",
        e.toneMapping !== js ? g5("toneMapping", e.toneMapping) : "",
        e.dithering ? "#define DITHERING" : "",
        e.opaque ? "#define OPAQUE" : "",
        wt.encodings_pars_fragment,
        m5("linearToOutputTexel", e.outputEncoding),
        e.useDepthPacking ? "#define DEPTH_PACKING " + e.depthPacking : "",
        `
`
    ].filter(_p).join(`
`)), o = $S(o), o = TP(o, e), o = MP(o, e), a = $S(a), a = TP(a, e), a = MP(a, e), o = CP(o), a = CP(a), e.isWebGL2 && e.isRawShaderMaterial !== !0 && (x = `#version 300 es
`, g = [
        "precision mediump sampler2DArray;",
        "#define attribute in",
        "#define varying out",
        "#define texture2D texture"
    ].join(`
`) + `
` + g, y = [
        "#define varying in",
        e.glslVersion === By ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
        e.glslVersion === By ? "" : "#define gl_FragColor pc_fragColor",
        "#define gl_FragDepthEXT gl_FragDepth",
        "#define texture2D texture",
        "#define textureCube texture",
        "#define texture2DProj textureProj",
        "#define texture2DLodEXT textureLod",
        "#define texture2DProjLodEXT textureProjLod",
        "#define textureCubeLodEXT textureLod",
        "#define texture2DGradEXT textureGrad",
        "#define texture2DProjGradEXT textureProjGrad",
        "#define textureCubeGradEXT textureGrad"
    ].join(`
`) + `
` + y);
    let v = x + g + o, b = x + y + a, w = AP(i, 35633, v), A = AP(i, 35632, b);
    if (i.attachShader(p, w), i.attachShader(p, A), e.index0AttributeName !== void 0 ? i.bindAttribLocation(p, 0, e.index0AttributeName) : e.morphTargets === !0 && i.bindAttribLocation(p, 0, "position"), i.linkProgram(p), n1.debug.checkShaderErrors) {
        let M = i.getProgramInfoLog(p).trim(), C = i.getShaderInfoLog(w).trim(), P = i.getShaderInfoLog(A).trim(), _ = !0, I = !0;
        if (i.getProgramParameter(p, 35714) === !1) {
            _ = !1;
            let O = EP(i, w, "vertex"), L = EP(i, A, "fragment");
            console.error("THREE.WebGLProgram: Shader Error " + i.getError() + " - VALIDATE_STATUS " + i.getProgramParameter(p, 35715) + `

Program Info Log: ` + M + `
` + O + `
` + L);
        } else M !== "" ? console.warn("THREE.WebGLProgram: Program Info Log:", M) : (C === "" || P === "") && (I = !1);
        I && (this.diagnostics = {
            runnable: _,
            programLog: M,
            vertexShader: {
                log: C,
                prefix: g
            },
            fragmentShader: {
                log: P,
                prefix: y
            }
        });
    }
    i.deleteShader(w), i.deleteShader(A);
    let T;
    this.getUniforms = function() {
        return T === void 0 && (T = new $u(i, p)), T;
    };
    let S;
    return this.getAttributes = function() {
        return S === void 0 && (S = x5(i, p)), S;
    }, this.destroy = function() {
        r.releaseStatesOfProgram(this), i.deleteProgram(p), this.program = void 0;
    }, this.name = e.shaderName, this.id = d5++, this.cacheKey = t, this.usedTimes = 1, this.program = p, this.vertexShader = w, this.fragmentShader = A, this;
}
var I5 = 0, ew = class {
    constructor(){
        this.shaderCache = new Map, this.materialCache = new Map;
    }
    update(t) {
        let e = t.vertexShader, r = t.fragmentShader, i = this._getShaderStage(e), s1 = this._getShaderStage(r), o = this._getShaderCacheForMaterial(t);
        return o.has(i) === !1 && (o.add(i), i.usedTimes++), o.has(s1) === !1 && (o.add(s1), s1.usedTimes++), this;
    }
    remove(t) {
        let e = this.materialCache.get(t);
        for (let r of e)r.usedTimes--, r.usedTimes === 0 && this.shaderCache.delete(r.code);
        return this.materialCache.delete(t), this;
    }
    getVertexShaderID(t) {
        return this._getShaderStage(t.vertexShader).id;
    }
    getFragmentShaderID(t) {
        return this._getShaderStage(t.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear(), this.materialCache.clear();
    }
    _getShaderCacheForMaterial(t) {
        let e = this.materialCache, r = e.get(t);
        return r === void 0 && (r = new Set, e.set(t, r)), r;
    }
    _getShaderStage(t) {
        let e = this.shaderCache, r = e.get(t);
        return r === void 0 && (r = new tw(t), e.set(t, r)), r;
    }
}, tw = class {
    constructor(t){
        this.id = I5++, this.code = t, this.usedTimes = 0;
    }
};
function D5(n1, t, e, r, i, s1, o) {
    let a = new Vp, l = new ew, c = [], u1 = i.isWebGL2, h = i.logarithmicDepthBuffer, d = i.vertexTextures, f = i.precision, m = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function p(S, M, C, P, _) {
        let I = P.fog, O = _.geometry, L = S.isMeshStandardMaterial ? P.environment : null, j = (S.isMeshStandardMaterial ? e : t).get(S.envMap || L), V = !!j && j.mapping === xh ? j.image.height : null, H = m[S.type];
        S.precision !== null && (f = i.getMaxPrecision(S.precision), f !== S.precision && console.warn("THREE.WebGLProgram.getParameters:", S.precision, "not supported, using", f, "instead."));
        let q = O.morphAttributes.position || O.morphAttributes.normal || O.morphAttributes.color, X = q !== void 0 ? q.length : 0, K = 0;
        O.morphAttributes.position !== void 0 && (K = 1), O.morphAttributes.normal !== void 0 && (K = 2), O.morphAttributes.color !== void 0 && (K = 3);
        let z, Q, te, $;
        if (H) {
            let Ee = Eo[H];
            z = Ee.vertexShader, Q = Ee.fragmentShader;
        } else z = S.vertexShader, Q = S.fragmentShader, l.update(S), te = l.getVertexShaderID(S), $ = l.getFragmentShaderID(S);
        let W = n1.getRenderTarget(), oe = S.alphaTest > 0, ie = S.clearcoat > 0, re = S.iridescence > 0;
        return {
            isWebGL2: u1,
            shaderID: H,
            shaderName: S.type,
            vertexShader: z,
            fragmentShader: Q,
            defines: S.defines,
            customVertexShaderID: te,
            customFragmentShaderID: $,
            isRawShaderMaterial: S.isRawShaderMaterial === !0,
            glslVersion: S.glslVersion,
            precision: f,
            instancing: _.isInstancedMesh === !0,
            instancingColor: _.isInstancedMesh === !0 && _.instanceColor !== null,
            supportsVertexTextures: d,
            outputEncoding: W === null ? n1.outputEncoding : W.isXRRenderTarget === !0 ? W.texture.encoding : xn,
            map: !!S.map,
            matcap: !!S.matcap,
            envMap: !!j,
            envMapMode: j && j.mapping,
            envMapCubeUVHeight: V,
            lightMap: !!S.lightMap,
            aoMap: !!S.aoMap,
            emissiveMap: !!S.emissiveMap,
            bumpMap: !!S.bumpMap,
            normalMap: !!S.normalMap,
            objectSpaceNormalMap: S.normalMapType === QU,
            tangentSpaceNormalMap: S.normalMapType === KU,
            decodeVideoTexture: !!S.map && S.map.isVideoTexture === !0 && S.map.encoding === ut,
            clearcoat: ie,
            clearcoatMap: ie && !!S.clearcoatMap,
            clearcoatRoughnessMap: ie && !!S.clearcoatRoughnessMap,
            clearcoatNormalMap: ie && !!S.clearcoatNormalMap,
            iridescence: re,
            iridescenceMap: re && !!S.iridescenceMap,
            iridescenceThicknessMap: re && !!S.iridescenceThicknessMap,
            displacementMap: !!S.displacementMap,
            roughnessMap: !!S.roughnessMap,
            metalnessMap: !!S.metalnessMap,
            specularMap: !!S.specularMap,
            specularIntensityMap: !!S.specularIntensityMap,
            specularColorMap: !!S.specularColorMap,
            opaque: S.transparent === !1 && S.blending === ml,
            alphaMap: !!S.alphaMap,
            alphaTest: oe,
            gradientMap: !!S.gradientMap,
            sheen: S.sheen > 0,
            sheenColorMap: !!S.sheenColorMap,
            sheenRoughnessMap: !!S.sheenRoughnessMap,
            transmission: S.transmission > 0,
            transmissionMap: !!S.transmissionMap,
            thicknessMap: !!S.thicknessMap,
            combine: S.combine,
            vertexTangents: !!S.normalMap && !!O.attributes.tangent,
            vertexColors: S.vertexColors,
            vertexAlphas: S.vertexColors === !0 && !!O.attributes.color && O.attributes.color.itemSize === 4,
            vertexUvs: !!S.map || !!S.bumpMap || !!S.normalMap || !!S.specularMap || !!S.alphaMap || !!S.emissiveMap || !!S.roughnessMap || !!S.metalnessMap || !!S.clearcoatMap || !!S.clearcoatRoughnessMap || !!S.clearcoatNormalMap || !!S.iridescenceMap || !!S.iridescenceThicknessMap || !!S.displacementMap || !!S.transmissionMap || !!S.thicknessMap || !!S.specularIntensityMap || !!S.specularColorMap || !!S.sheenColorMap || !!S.sheenRoughnessMap,
            uvsVertexOnly: !(!!S.map || !!S.bumpMap || !!S.normalMap || !!S.specularMap || !!S.alphaMap || !!S.emissiveMap || !!S.roughnessMap || !!S.metalnessMap || !!S.clearcoatNormalMap || !!S.iridescenceMap || !!S.iridescenceThicknessMap || S.transmission > 0 || !!S.transmissionMap || !!S.thicknessMap || !!S.specularIntensityMap || !!S.specularColorMap || S.sheen > 0 || !!S.sheenColorMap || !!S.sheenRoughnessMap) && !!S.displacementMap,
            fog: !!I,
            useFog: S.fog === !0,
            fogExp2: I && I.isFogExp2,
            flatShading: !!S.flatShading,
            sizeAttenuation: S.sizeAttenuation,
            logarithmicDepthBuffer: h,
            skinning: _.isSkinnedMesh === !0,
            morphTargets: O.morphAttributes.position !== void 0,
            morphNormals: O.morphAttributes.normal !== void 0,
            morphColors: O.morphAttributes.color !== void 0,
            morphTargetsCount: X,
            morphTextureStride: K,
            numDirLights: M.directional.length,
            numPointLights: M.point.length,
            numSpotLights: M.spot.length,
            numSpotLightMaps: M.spotLightMap.length,
            numRectAreaLights: M.rectArea.length,
            numHemiLights: M.hemi.length,
            numDirLightShadows: M.directionalShadowMap.length,
            numPointLightShadows: M.pointShadowMap.length,
            numSpotLightShadows: M.spotShadowMap.length,
            numSpotLightShadowsWithMaps: M.numSpotLightShadowsWithMaps,
            numClippingPlanes: o.numPlanes,
            numClipIntersection: o.numIntersection,
            dithering: S.dithering,
            shadowMapEnabled: n1.shadowMap.enabled && C.length > 0,
            shadowMapType: n1.shadowMap.type,
            toneMapping: S.toneMapped ? n1.toneMapping : js,
            physicallyCorrectLights: n1.physicallyCorrectLights,
            premultipliedAlpha: S.premultipliedAlpha,
            doubleSided: S.side === vi,
            flipSided: S.side === xi,
            useDepthPacking: !!S.depthPacking,
            depthPacking: S.depthPacking || 0,
            index0AttributeName: S.index0AttributeName,
            extensionDerivatives: S.extensions && S.extensions.derivatives,
            extensionFragDepth: S.extensions && S.extensions.fragDepth,
            extensionDrawBuffers: S.extensions && S.extensions.drawBuffers,
            extensionShaderTextureLOD: S.extensions && S.extensions.shaderTextureLOD,
            rendererExtensionFragDepth: u1 || r.has("EXT_frag_depth"),
            rendererExtensionDrawBuffers: u1 || r.has("WEBGL_draw_buffers"),
            rendererExtensionShaderTextureLod: u1 || r.has("EXT_shader_texture_lod"),
            customProgramCacheKey: S.customProgramCacheKey()
        };
    }
    function g(S) {
        let M = [];
        if (S.shaderID ? M.push(S.shaderID) : (M.push(S.customVertexShaderID), M.push(S.customFragmentShaderID)), S.defines !== void 0) for(let C in S.defines)M.push(C), M.push(S.defines[C]);
        return S.isRawShaderMaterial === !1 && (y(M, S), x(M, S), M.push(n1.outputEncoding)), M.push(S.customProgramCacheKey), M.join();
    }
    function y(S, M) {
        S.push(M.precision), S.push(M.outputEncoding), S.push(M.envMapMode), S.push(M.envMapCubeUVHeight), S.push(M.combine), S.push(M.vertexUvs), S.push(M.fogExp2), S.push(M.sizeAttenuation), S.push(M.morphTargetsCount), S.push(M.morphAttributeCount), S.push(M.numDirLights), S.push(M.numPointLights), S.push(M.numSpotLights), S.push(M.numSpotLightMaps), S.push(M.numHemiLights), S.push(M.numRectAreaLights), S.push(M.numDirLightShadows), S.push(M.numPointLightShadows), S.push(M.numSpotLightShadows), S.push(M.numSpotLightShadowsWithMaps), S.push(M.shadowMapType), S.push(M.toneMapping), S.push(M.numClippingPlanes), S.push(M.numClipIntersection), S.push(M.depthPacking);
    }
    function x(S, M) {
        a.disableAll(), M.isWebGL2 && a.enable(0), M.supportsVertexTextures && a.enable(1), M.instancing && a.enable(2), M.instancingColor && a.enable(3), M.map && a.enable(4), M.matcap && a.enable(5), M.envMap && a.enable(6), M.lightMap && a.enable(7), M.aoMap && a.enable(8), M.emissiveMap && a.enable(9), M.bumpMap && a.enable(10), M.normalMap && a.enable(11), M.objectSpaceNormalMap && a.enable(12), M.tangentSpaceNormalMap && a.enable(13), M.clearcoat && a.enable(14), M.clearcoatMap && a.enable(15), M.clearcoatRoughnessMap && a.enable(16), M.clearcoatNormalMap && a.enable(17), M.iridescence && a.enable(18), M.iridescenceMap && a.enable(19), M.iridescenceThicknessMap && a.enable(20), M.displacementMap && a.enable(21), M.specularMap && a.enable(22), M.roughnessMap && a.enable(23), M.metalnessMap && a.enable(24), M.gradientMap && a.enable(25), M.alphaMap && a.enable(26), M.alphaTest && a.enable(27), M.vertexColors && a.enable(28), M.vertexAlphas && a.enable(29), M.vertexUvs && a.enable(30), M.vertexTangents && a.enable(31), M.uvsVertexOnly && a.enable(32), S.push(a.mask), a.disableAll(), M.fog && a.enable(0), M.useFog && a.enable(1), M.flatShading && a.enable(2), M.logarithmicDepthBuffer && a.enable(3), M.skinning && a.enable(4), M.morphTargets && a.enable(5), M.morphNormals && a.enable(6), M.morphColors && a.enable(7), M.premultipliedAlpha && a.enable(8), M.shadowMapEnabled && a.enable(9), M.physicallyCorrectLights && a.enable(10), M.doubleSided && a.enable(11), M.flipSided && a.enable(12), M.useDepthPacking && a.enable(13), M.dithering && a.enable(14), M.specularIntensityMap && a.enable(15), M.specularColorMap && a.enable(16), M.transmission && a.enable(17), M.transmissionMap && a.enable(18), M.thicknessMap && a.enable(19), M.sheen && a.enable(20), M.sheenColorMap && a.enable(21), M.sheenRoughnessMap && a.enable(22), M.decodeVideoTexture && a.enable(23), M.opaque && a.enable(24), S.push(a.mask);
    }
    function v(S) {
        let M = m[S.type], C;
        if (M) {
            let P = Eo[M];
            C = Xs.clone(P.uniforms);
        } else C = S.uniforms;
        return C;
    }
    function b(S, M) {
        let C;
        for(let P = 0, _ = c.length; P < _; P++){
            let I = c[P];
            if (I.cacheKey === M) {
                C = I, ++C.usedTimes;
                break;
            }
        }
        return C === void 0 && (C = new _5(n1, M, S, s1), c.push(C)), C;
    }
    function w(S) {
        if (--S.usedTimes === 0) {
            let M = c.indexOf(S);
            c[M] = c[c.length - 1], c.pop(), S.destroy();
        }
    }
    function A(S) {
        l.remove(S);
    }
    function T() {
        l.dispose();
    }
    return {
        getParameters: p,
        getProgramCacheKey: g,
        getUniforms: v,
        acquireProgram: b,
        releaseProgram: w,
        releaseShaderCache: A,
        programs: c,
        dispose: T
    };
}
function O5() {
    let n1 = new WeakMap;
    function t(s1) {
        let o = n1.get(s1);
        return o === void 0 && (o = {}, n1.set(s1, o)), o;
    }
    function e(s1) {
        n1.delete(s1);
    }
    function r(s1, o, a) {
        n1.get(s1)[o] = a;
    }
    function i() {
        n1 = new WeakMap;
    }
    return {
        get: t,
        remove: e,
        update: r,
        dispose: i
    };
}
function R5(n1, t) {
    return n1.groupOrder !== t.groupOrder ? n1.groupOrder - t.groupOrder : n1.renderOrder !== t.renderOrder ? n1.renderOrder - t.renderOrder : n1.material.id !== t.material.id ? n1.material.id - t.material.id : n1.z !== t.z ? n1.z - t.z : n1.id - t.id;
}
function _P(n1, t) {
    return n1.groupOrder !== t.groupOrder ? n1.groupOrder - t.groupOrder : n1.renderOrder !== t.renderOrder ? n1.renderOrder - t.renderOrder : n1.z !== t.z ? t.z - n1.z : n1.id - t.id;
}
function IP() {
    let n1 = [], t = 0, e = [], r = [], i = [];
    function s1() {
        t = 0, e.length = 0, r.length = 0, i.length = 0;
    }
    function o(h, d, f, m, p, g) {
        let y = n1[t];
        return y === void 0 ? (y = {
            id: h.id,
            object: h,
            geometry: d,
            material: f,
            groupOrder: m,
            renderOrder: h.renderOrder,
            z: p,
            group: g
        }, n1[t] = y) : (y.id = h.id, y.object = h, y.geometry = d, y.material = f, y.groupOrder = m, y.renderOrder = h.renderOrder, y.z = p, y.group = g), t++, y;
    }
    function a(h, d, f, m, p, g) {
        let y = o(h, d, f, m, p, g);
        f.transmission > 0 ? r.push(y) : f.transparent === !0 ? i.push(y) : e.push(y);
    }
    function l(h, d, f, m, p, g) {
        let y = o(h, d, f, m, p, g);
        f.transmission > 0 ? r.unshift(y) : f.transparent === !0 ? i.unshift(y) : e.unshift(y);
    }
    function c(h, d) {
        e.length > 1 && e.sort(h || R5), r.length > 1 && r.sort(d || _P), i.length > 1 && i.sort(d || _P);
    }
    function u1() {
        for(let h = t, d = n1.length; h < d; h++){
            let f = n1[h];
            if (f.id === null) break;
            f.id = null, f.object = null, f.geometry = null, f.material = null, f.group = null;
        }
    }
    return {
        opaque: e,
        transmissive: r,
        transparent: i,
        init: s1,
        push: a,
        unshift: l,
        finish: u1,
        sort: c
    };
}
function L5() {
    let n1 = new WeakMap;
    function t(r, i) {
        let s1 = n1.get(r), o;
        return s1 === void 0 ? (o = new IP, n1.set(r, [
            o
        ])) : i >= s1.length ? (o = new IP, s1.push(o)) : o = s1[i], o;
    }
    function e() {
        n1 = new WeakMap;
    }
    return {
        get: t,
        dispose: e
    };
}
function N5() {
    let n1 = {};
    return {
        get: function(t) {
            if (n1[t.id] !== void 0) return n1[t.id];
            let e;
            switch(t.type){
                case "DirectionalLight":
                    e = {
                        direction: new E,
                        color: new Ge
                    };
                    break;
                case "SpotLight":
                    e = {
                        position: new E,
                        direction: new E,
                        color: new Ge,
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    e = {
                        position: new E,
                        color: new Ge,
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    e = {
                        direction: new E,
                        skyColor: new Ge,
                        groundColor: new Ge
                    };
                    break;
                case "RectAreaLight":
                    e = {
                        color: new Ge,
                        position: new E,
                        halfWidth: new E,
                        halfHeight: new E
                    };
                    break;
            }
            return n1[t.id] = e, e;
        }
    };
}
function B5() {
    let n1 = {};
    return {
        get: function(t) {
            if (n1[t.id] !== void 0) return n1[t.id];
            let e;
            switch(t.type){
                case "DirectionalLight":
                    e = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new U
                    };
                    break;
                case "SpotLight":
                    e = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new U
                    };
                    break;
                case "PointLight":
                    e = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new U,
                        shadowCameraNear: 1,
                        shadowCameraFar: 1e3
                    };
                    break;
            }
            return n1[t.id] = e, e;
        }
    };
}
var F5 = 0;
function V5(n1, t) {
    return (t.castShadow ? 2 : 0) - (n1.castShadow ? 2 : 0) + (t.map ? 1 : 0) - (n1.map ? 1 : 0);
}
function U5(n1, t) {
    let e = new N5, r = B5(), i = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0
    };
    for(let u1 = 0; u1 < 9; u1++)i.probe.push(new E);
    let s1 = new E, o = new ue, a = new ue;
    function l(u1, h) {
        let d = 0, f = 0, m = 0;
        for(let P = 0; P < 9; P++)i.probe[P].set(0, 0, 0);
        let p = 0, g = 0, y = 0, x = 0, v = 0, b = 0, w = 0, A = 0, T = 0, S = 0;
        u1.sort(V5);
        let M = h !== !0 ? Math.PI : 1;
        for(let P = 0, _ = u1.length; P < _; P++){
            let I = u1[P], O = I.color, L = I.intensity, j = I.distance, V = I.shadow && I.shadow.map ? I.shadow.map.texture : null;
            if (I.isAmbientLight) d += O.r * L * M, f += O.g * L * M, m += O.b * L * M;
            else if (I.isLightProbe) for(let H = 0; H < 9; H++)i.probe[H].addScaledVector(I.sh.coefficients[H], L);
            else if (I.isDirectionalLight) {
                let H = e.get(I);
                if (H.color.copy(I.color).multiplyScalar(I.intensity * M), I.castShadow) {
                    let q = I.shadow, X = r.get(I);
                    X.shadowBias = q.bias, X.shadowNormalBias = q.normalBias, X.shadowRadius = q.radius, X.shadowMapSize = q.mapSize, i.directionalShadow[p] = X, i.directionalShadowMap[p] = V, i.directionalShadowMatrix[p] = I.shadow.matrix, b++;
                }
                i.directional[p] = H, p++;
            } else if (I.isSpotLight) {
                let H = e.get(I);
                H.position.setFromMatrixPosition(I.matrixWorld), H.color.copy(O).multiplyScalar(L * M), H.distance = j, H.coneCos = Math.cos(I.angle), H.penumbraCos = Math.cos(I.angle * (1 - I.penumbra)), H.decay = I.decay, i.spot[y] = H;
                let q = I.shadow;
                if (I.map && (i.spotLightMap[T] = I.map, T++, q.updateMatrices(I), I.castShadow && S++), i.spotLightMatrix[y] = q.matrix, I.castShadow) {
                    let X = r.get(I);
                    X.shadowBias = q.bias, X.shadowNormalBias = q.normalBias, X.shadowRadius = q.radius, X.shadowMapSize = q.mapSize, i.spotShadow[y] = X, i.spotShadowMap[y] = V, A++;
                }
                y++;
            } else if (I.isRectAreaLight) {
                let H = e.get(I);
                H.color.copy(O).multiplyScalar(L), H.halfWidth.set(I.width * .5, 0, 0), H.halfHeight.set(0, I.height * .5, 0), i.rectArea[x] = H, x++;
            } else if (I.isPointLight) {
                let H = e.get(I);
                if (H.color.copy(I.color).multiplyScalar(I.intensity * M), H.distance = I.distance, H.decay = I.decay, I.castShadow) {
                    let q = I.shadow, X = r.get(I);
                    X.shadowBias = q.bias, X.shadowNormalBias = q.normalBias, X.shadowRadius = q.radius, X.shadowMapSize = q.mapSize, X.shadowCameraNear = q.camera.near, X.shadowCameraFar = q.camera.far, i.pointShadow[g] = X, i.pointShadowMap[g] = V, i.pointShadowMatrix[g] = I.shadow.matrix, w++;
                }
                i.point[g] = H, g++;
            } else if (I.isHemisphereLight) {
                let H = e.get(I);
                H.skyColor.copy(I.color).multiplyScalar(L * M), H.groundColor.copy(I.groundColor).multiplyScalar(L * M), i.hemi[v] = H, v++;
            }
        }
        x > 0 && (t.isWebGL2 || n1.has("OES_texture_float_linear") === !0 ? (i.rectAreaLTC1 = Ie.LTC_FLOAT_1, i.rectAreaLTC2 = Ie.LTC_FLOAT_2) : n1.has("OES_texture_half_float_linear") === !0 ? (i.rectAreaLTC1 = Ie.LTC_HALF_1, i.rectAreaLTC2 = Ie.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), i.ambient[0] = d, i.ambient[1] = f, i.ambient[2] = m;
        let C = i.hash;
        (C.directionalLength !== p || C.pointLength !== g || C.spotLength !== y || C.rectAreaLength !== x || C.hemiLength !== v || C.numDirectionalShadows !== b || C.numPointShadows !== w || C.numSpotShadows !== A || C.numSpotMaps !== T) && (i.directional.length = p, i.spot.length = y, i.rectArea.length = x, i.point.length = g, i.hemi.length = v, i.directionalShadow.length = b, i.directionalShadowMap.length = b, i.pointShadow.length = w, i.pointShadowMap.length = w, i.spotShadow.length = A, i.spotShadowMap.length = A, i.directionalShadowMatrix.length = b, i.pointShadowMatrix.length = w, i.spotLightMatrix.length = A + T - S, i.spotLightMap.length = T, i.numSpotLightShadowsWithMaps = S, C.directionalLength = p, C.pointLength = g, C.spotLength = y, C.rectAreaLength = x, C.hemiLength = v, C.numDirectionalShadows = b, C.numPointShadows = w, C.numSpotShadows = A, C.numSpotMaps = T, i.version = F5++);
    }
    function c(u1, h) {
        let d = 0, f = 0, m = 0, p = 0, g = 0, y = h.matrixWorldInverse;
        for(let x = 0, v = u1.length; x < v; x++){
            let b = u1[x];
            if (b.isDirectionalLight) {
                let w = i.directional[d];
                w.direction.setFromMatrixPosition(b.matrixWorld), s1.setFromMatrixPosition(b.target.matrixWorld), w.direction.sub(s1), w.direction.transformDirection(y), d++;
            } else if (b.isSpotLight) {
                let w = i.spot[m];
                w.position.setFromMatrixPosition(b.matrixWorld), w.position.applyMatrix4(y), w.direction.setFromMatrixPosition(b.matrixWorld), s1.setFromMatrixPosition(b.target.matrixWorld), w.direction.sub(s1), w.direction.transformDirection(y), m++;
            } else if (b.isRectAreaLight) {
                let w = i.rectArea[p];
                w.position.setFromMatrixPosition(b.matrixWorld), w.position.applyMatrix4(y), a.identity(), o.copy(b.matrixWorld), o.premultiply(y), a.extractRotation(o), w.halfWidth.set(b.width * .5, 0, 0), w.halfHeight.set(0, b.height * .5, 0), w.halfWidth.applyMatrix4(a), w.halfHeight.applyMatrix4(a), p++;
            } else if (b.isPointLight) {
                let w = i.point[f];
                w.position.setFromMatrixPosition(b.matrixWorld), w.position.applyMatrix4(y), f++;
            } else if (b.isHemisphereLight) {
                let w = i.hemi[g];
                w.direction.setFromMatrixPosition(b.matrixWorld), w.direction.transformDirection(y), g++;
            }
        }
    }
    return {
        setup: l,
        setupView: c,
        state: i
    };
}
function DP(n1, t) {
    let e = new U5(n1, t), r = [], i = [];
    function s1() {
        r.length = 0, i.length = 0;
    }
    function o(h) {
        r.push(h);
    }
    function a(h) {
        i.push(h);
    }
    function l(h) {
        e.setup(r, h);
    }
    function c(h) {
        e.setupView(r, h);
    }
    return {
        init: s1,
        state: {
            lightsArray: r,
            shadowsArray: i,
            lights: e
        },
        setupLights: l,
        setupLightsView: c,
        pushLight: o,
        pushShadow: a
    };
}
function k5(n1, t) {
    let e = new WeakMap;
    function r(s1, o = 0) {
        let a = e.get(s1), l;
        return a === void 0 ? (l = new DP(n1, t), e.set(s1, [
            l
        ])) : o >= a.length ? (l = new DP(n1, t), a.push(l)) : l = a[o], l;
    }
    function i() {
        e = new WeakMap;
    }
    return {
        get: r,
        dispose: i
    };
}
var kp = class extends Fc {
    constructor(t){
        super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = zi, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.depthPacking = t.depthPacking, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this;
    }
}, rw = class extends Fc {
    constructor(t){
        super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.referencePosition = new E, this.nearDistance = 1, this.farDistance = 1e3, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.referencePosition.copy(t.referencePosition), this.nearDistance = t.nearDistance, this.farDistance = t.farDistance, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this;
    }
}, z5 = `void main() {
	gl_Position = vec4( position, 1.0 );
}`, G5 = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
#include <packing>
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( squared_mean - mean * mean );
	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );
}`;
function j5(n1, t, e) {
    let r = new Up, i = new U, s1 = new U, o = new Ze, a = new kp({
        depthPacking: Cw
    }), l = new rw, c = {}, u1 = e.maxTextureSize, h = {
        [Jn]: xi,
        [xi]: Jn,
        [vi]: vi
    }, d = new $e({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new U
            },
            radius: {
                value: 4
            }
        },
        vertexShader: z5,
        fragmentShader: G5
    }), f = d.clone();
    f.defines.HORIZONTAL_PASS = 1;
    let m = new Ce;
    m.setAttribute("position", new je(new Float32Array([
        -1,
        -1,
        .5,
        3,
        -1,
        .5,
        -1,
        3,
        .5
    ]), 3));
    let p = new Mt(m, d), g = this;
    this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = cv, this.render = function(b, w, A) {
        if (g.enabled === !1 || g.autoUpdate === !1 && g.needsUpdate === !1 || b.length === 0) return;
        let T = n1.getRenderTarget(), S = n1.getActiveCubeFace(), M = n1.getActiveMipmapLevel(), C = n1.state;
        C.setBlending(or), C.buffers.color.setClear(1, 1, 1, 1), C.buffers.depth.setTest(!0), C.setScissorTest(!1);
        for(let P = 0, _ = b.length; P < _; P++){
            let I = b[P], O = I.shadow;
            if (O === void 0) {
                console.warn("THREE.WebGLShadowMap:", I, "has no shadow.");
                continue;
            }
            if (O.autoUpdate === !1 && O.needsUpdate === !1) continue;
            i.copy(O.mapSize);
            let L = O.getFrameExtents();
            if (i.multiply(L), s1.copy(O.mapSize), (i.x > u1 || i.y > u1) && (i.x > u1 && (s1.x = Math.floor(u1 / L.x), i.x = s1.x * L.x, O.mapSize.x = s1.x), i.y > u1 && (s1.y = Math.floor(u1 / L.y), i.y = s1.y * L.y, O.mapSize.y = s1.y)), O.map === null) {
                let V = this.type !== Pp ? {
                    minFilter: vt,
                    magFilter: vt
                } : {};
                O.map = new at(i.x, i.y, V), O.map.texture.name = I.name + ".shadowMap", O.camera.updateProjectionMatrix();
            }
            n1.setRenderTarget(O.map), n1.clear();
            let j = O.getViewportCount();
            for(let V = 0; V < j; V++){
                let H = O.getViewport(V);
                o.set(s1.x * H.x, s1.y * H.y, s1.x * H.z, s1.y * H.w), C.viewport(o), O.updateMatrices(I, V), r = O.getFrustum(), v(w, A, O.camera, I, this.type);
            }
            O.isPointLightShadow !== !0 && this.type === Pp && y(O, A), O.needsUpdate = !1;
        }
        g.needsUpdate = !1, n1.setRenderTarget(T, S, M);
    };
    function y(b, w) {
        let A = t.update(p);
        d.defines.VSM_SAMPLES !== b.blurSamples && (d.defines.VSM_SAMPLES = b.blurSamples, f.defines.VSM_SAMPLES = b.blurSamples, d.needsUpdate = !0, f.needsUpdate = !0), b.mapPass === null && (b.mapPass = new at(i.x, i.y)), d.uniforms.shadow_pass.value = b.map.texture, d.uniforms.resolution.value = b.mapSize, d.uniforms.radius.value = b.radius, n1.setRenderTarget(b.mapPass), n1.clear(), n1.renderBufferDirect(w, null, A, d, p, null), f.uniforms.shadow_pass.value = b.mapPass.texture, f.uniforms.resolution.value = b.mapSize, f.uniforms.radius.value = b.radius, n1.setRenderTarget(b.map), n1.clear(), n1.renderBufferDirect(w, null, A, f, p, null);
    }
    function x(b, w, A, T, S, M) {
        let C = null, P = A.isPointLight === !0 ? b.customDistanceMaterial : b.customDepthMaterial;
        if (P !== void 0) C = P;
        else if (C = A.isPointLight === !0 ? l : a, n1.localClippingEnabled && w.clipShadows === !0 && Array.isArray(w.clippingPlanes) && w.clippingPlanes.length !== 0 || w.displacementMap && w.displacementScale !== 0 || w.alphaMap && w.alphaTest > 0 || w.map && w.alphaTest > 0) {
            let _ = C.uuid, I = w.uuid, O = c[_];
            O === void 0 && (O = {}, c[_] = O);
            let L = O[I];
            L === void 0 && (L = C.clone(), O[I] = L), C = L;
        }
        return C.visible = w.visible, C.wireframe = w.wireframe, M === Pp ? C.side = w.shadowSide !== null ? w.shadowSide : w.side : C.side = w.shadowSide !== null ? w.shadowSide : h[w.side], C.alphaMap = w.alphaMap, C.alphaTest = w.alphaTest, C.map = w.map, C.clipShadows = w.clipShadows, C.clippingPlanes = w.clippingPlanes, C.clipIntersection = w.clipIntersection, C.displacementMap = w.displacementMap, C.displacementScale = w.displacementScale, C.displacementBias = w.displacementBias, C.wireframeLinewidth = w.wireframeLinewidth, C.linewidth = w.linewidth, A.isPointLight === !0 && C.isMeshDistanceMaterial === !0 && (C.referencePosition.setFromMatrixPosition(A.matrixWorld), C.nearDistance = T, C.farDistance = S), C;
    }
    function v(b, w, A, T, S) {
        if (b.visible === !1) return;
        if (b.layers.test(w.layers) && (b.isMesh || b.isLine || b.isPoints) && (b.castShadow || b.receiveShadow && S === Pp) && (!b.frustumCulled || r.intersectsObject(b))) {
            b.modelViewMatrix.multiplyMatrices(A.matrixWorldInverse, b.matrixWorld);
            let P = t.update(b), _ = b.material;
            if (Array.isArray(_)) {
                let I = P.groups;
                for(let O = 0, L = I.length; O < L; O++){
                    let j = I[O], V = _[j.materialIndex];
                    if (V && V.visible) {
                        let H = x(b, V, T, A.near, A.far, S);
                        n1.renderBufferDirect(A, null, P, H, b, j);
                    }
                }
            } else if (_.visible) {
                let I = x(b, _, T, A.near, A.far, S);
                n1.renderBufferDirect(A, null, P, I, b, null);
            }
        }
        let C = b.children;
        for(let P = 0, _ = C.length; P < _; P++)v(C[P], w, A, T, S);
    }
}
function H5(n1, t, e) {
    let r = e.isWebGL2;
    function i() {
        let Z = !1, ve = new Ze, Me = null, qe = new Ze(0, 0, 0, 0);
        return {
            setMask: function(Xe) {
                Me !== Xe && !Z && (n1.colorMask(Xe, Xe, Xe, Xe), Me = Xe);
            },
            setLocked: function(Xe) {
                Z = Xe;
            },
            setClear: function(Xe, Rt, Hr, Wr, va) {
                va === !0 && (Xe *= Wr, Rt *= Wr, Hr *= Wr), ve.set(Xe, Rt, Hr, Wr), qe.equals(ve) === !1 && (n1.clearColor(Xe, Rt, Hr, Wr), qe.copy(ve));
            },
            reset: function() {
                Z = !1, Me = null, qe.set(-1, 0, 0, 0);
            }
        };
    }
    function s1() {
        let Z = !1, ve = null, Me = null, qe = null;
        return {
            setTest: function(Xe) {
                Xe ? oe(2929) : ie(2929);
            },
            setMask: function(Xe) {
                ve !== Xe && !Z && (n1.depthMask(Xe), ve = Xe);
            },
            setFunc: function(Xe) {
                if (Me !== Xe) {
                    switch(Xe){
                        case SU:
                            n1.depthFunc(512);
                            break;
                        case wU:
                            n1.depthFunc(519);
                            break;
                        case AU:
                            n1.depthFunc(513);
                            break;
                        case zS:
                            n1.depthFunc(515);
                            break;
                        case EU:
                            n1.depthFunc(514);
                            break;
                        case TU:
                            n1.depthFunc(518);
                            break;
                        case MU:
                            n1.depthFunc(516);
                            break;
                        case CU:
                            n1.depthFunc(517);
                            break;
                        default:
                            n1.depthFunc(515);
                    }
                    Me = Xe;
                }
            },
            setLocked: function(Xe) {
                Z = Xe;
            },
            setClear: function(Xe) {
                qe !== Xe && (n1.clearDepth(Xe), qe = Xe);
            },
            reset: function() {
                Z = !1, ve = null, Me = null, qe = null;
            }
        };
    }
    function o() {
        let Z = !1, ve = null, Me = null, qe = null, Xe = null, Rt = null, Hr = null, Wr = null, va = null;
        return {
            setTest: function(Dr) {
                Z || (Dr ? oe(2960) : ie(2960));
            },
            setMask: function(Dr) {
                ve !== Dr && !Z && (n1.stencilMask(Dr), ve = Dr);
            },
            setFunc: function(Dr, us, Rn) {
                (Me !== Dr || qe !== us || Xe !== Rn) && (n1.stencilFunc(Dr, us, Rn), Me = Dr, qe = us, Xe = Rn);
            },
            setOp: function(Dr, us, Rn) {
                (Rt !== Dr || Hr !== us || Wr !== Rn) && (n1.stencilOp(Dr, us, Rn), Rt = Dr, Hr = us, Wr = Rn);
            },
            setLocked: function(Dr) {
                Z = Dr;
            },
            setClear: function(Dr) {
                va !== Dr && (n1.clearStencil(Dr), va = Dr);
            },
            reset: function() {
                Z = !1, ve = null, Me = null, qe = null, Xe = null, Rt = null, Hr = null, Wr = null, va = null;
            }
        };
    }
    let a = new i, l = new s1, c = new o, u1 = new WeakMap, h = new WeakMap, d = {}, f = {}, m = new WeakMap, p = [], g = null, y = !1, x = null, v = null, b = null, w = null, A = null, T = null, S = null, M = !1, C = null, P = null, _ = null, I = null, O = null, L = n1.getParameter(35661), j = !1, V = 0, H = n1.getParameter(7938);
    H.indexOf("WebGL") !== -1 ? (V = parseFloat(/^WebGL (\d)/.exec(H)[1]), j = V >= 1) : H.indexOf("OpenGL ES") !== -1 && (V = parseFloat(/^OpenGL ES (\d)/.exec(H)[1]), j = V >= 2);
    let q = null, X = {}, K = n1.getParameter(3088), z = n1.getParameter(2978), Q = new Ze().fromArray(K), te = new Ze().fromArray(z);
    function $(Z, ve, Me) {
        let qe = new Uint8Array(4), Xe = n1.createTexture();
        n1.bindTexture(Z, Xe), n1.texParameteri(Z, 10241, 9728), n1.texParameteri(Z, 10240, 9728);
        for(let Rt = 0; Rt < Me; Rt++)n1.texImage2D(ve + Rt, 0, 6408, 1, 1, 0, 6408, 5121, qe);
        return Xe;
    }
    let W = {};
    W[3553] = $(3553, 3553, 1), W[34067] = $(34067, 34069, 6), a.setClear(0, 0, 0, 1), l.setClear(1), c.setClear(0), oe(2929), l.setFunc(zS), ze(!1), ke(EC), oe(2884), De(or);
    function oe(Z) {
        d[Z] !== !0 && (n1.enable(Z), d[Z] = !0);
    }
    function ie(Z) {
        d[Z] !== !1 && (n1.disable(Z), d[Z] = !1);
    }
    function re(Z, ve) {
        return f[Z] !== ve ? (n1.bindFramebuffer(Z, ve), f[Z] = ve, r && (Z === 36009 && (f[36160] = ve), Z === 36160 && (f[36009] = ve)), !0) : !1;
    }
    function J(Z, ve) {
        let Me = p, qe = !1;
        if (Z) {
            if (Me = m.get(ve), Me === void 0 && (Me = [], m.set(ve, Me)), Z.isWebGLMultipleRenderTargets) {
                let Xe = Z.texture;
                if (Me.length !== Xe.length || Me[0] !== 36064) {
                    for(let Rt = 0, Hr = Xe.length; Rt < Hr; Rt++)Me[Rt] = 36064 + Rt;
                    Me.length = Xe.length, qe = !0;
                }
            } else Me[0] !== 36064 && (Me[0] = 36064, qe = !0);
        } else Me[0] !== 1029 && (Me[0] = 1029, qe = !0);
        qe && (e.isWebGL2 ? n1.drawBuffers(Me) : t.get("WEBGL_draw_buffers").drawBuffersWEBGL(Me));
    }
    function Ee(Z) {
        return g !== Z ? (n1.useProgram(Z), g = Z, !0) : !1;
    }
    let xe = {
        [Yu]: 32774,
        [uU]: 32778,
        [hU]: 32779
    };
    if (r) xe[PC] = 32775, xe[_C] = 32776;
    else {
        let Z = t.get("EXT_blend_minmax");
        Z !== null && (xe[PC] = Z.MIN_EXT, xe[_C] = Z.MAX_EXT);
    }
    let de = {
        [dU]: 0,
        [fU]: 1,
        [pU]: 768,
        [t_]: 770,
        [bU]: 776,
        [vU]: 774,
        [gU]: 772,
        [mU]: 769,
        [r_]: 771,
        [xU]: 775,
        [yU]: 773
    };
    function De(Z, ve, Me, qe, Xe, Rt, Hr, Wr) {
        if (Z === or) {
            y === !0 && (ie(3042), y = !1);
            return;
        }
        if (y === !1 && (oe(3042), y = !0), Z !== cU) {
            if (Z !== x || Wr !== M) {
                if ((v !== Yu || A !== Yu) && (n1.blendEquation(32774), v = Yu, A = Yu), Wr) switch(Z){
                    case ml:
                        n1.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case TC:
                        n1.blendFunc(1, 1);
                        break;
                    case MC:
                        n1.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case CC:
                        n1.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", Z);
                        break;
                }
                else switch(Z){
                    case ml:
                        n1.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case TC:
                        n1.blendFunc(770, 1);
                        break;
                    case MC:
                        n1.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case CC:
                        n1.blendFunc(0, 768);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", Z);
                        break;
                }
                b = null, w = null, T = null, S = null, x = Z, M = Wr;
            }
            return;
        }
        Xe = Xe || ve, Rt = Rt || Me, Hr = Hr || qe, (ve !== v || Xe !== A) && (n1.blendEquationSeparate(xe[ve], xe[Xe]), v = ve, A = Xe), (Me !== b || qe !== w || Rt !== T || Hr !== S) && (n1.blendFuncSeparate(de[Me], de[qe], de[Rt], de[Hr]), b = Me, w = qe, T = Rt, S = Hr), x = Z, M = !1;
    }
    function Pe(Z, ve) {
        Z.side === vi ? ie(2884) : oe(2884);
        let Me = Z.side === xi;
        ve && (Me = !Me), ze(Me), Z.blending === ml && Z.transparent === !1 ? De(or) : De(Z.blending, Z.blendEquation, Z.blendSrc, Z.blendDst, Z.blendEquationAlpha, Z.blendSrcAlpha, Z.blendDstAlpha, Z.premultipliedAlpha), l.setFunc(Z.depthFunc), l.setTest(Z.depthTest), l.setMask(Z.depthWrite), a.setMask(Z.colorWrite);
        let qe = Z.stencilWrite;
        c.setTest(qe), qe && (c.setMask(Z.stencilWriteMask), c.setFunc(Z.stencilFunc, Z.stencilRef, Z.stencilFuncMask), c.setOp(Z.stencilFail, Z.stencilZFail, Z.stencilZPass)), Le(Z.polygonOffset, Z.polygonOffsetFactor, Z.polygonOffsetUnits), Z.alphaToCoverage === !0 ? oe(32926) : ie(32926);
    }
    function ze(Z) {
        C !== Z && (Z ? n1.frontFace(2304) : n1.frontFace(2305), C = Z);
    }
    function ke(Z) {
        Z !== oU ? (oe(2884), Z !== P && (Z === EC ? n1.cullFace(1029) : Z === aU ? n1.cullFace(1028) : n1.cullFace(1032))) : ie(2884), P = Z;
    }
    function Ue(Z) {
        Z !== _ && (j && n1.lineWidth(Z), _ = Z);
    }
    function Le(Z, ve, Me) {
        Z ? (oe(32823), (I !== ve || O !== Me) && (n1.polygonOffset(ve, Me), I = ve, O = Me)) : ie(32823);
    }
    function Qe(Z) {
        Z ? oe(3089) : ie(3089);
    }
    function F(Z) {
        Z === void 0 && (Z = 33984 + L - 1), q !== Z && (n1.activeTexture(Z), q = Z);
    }
    function B(Z, ve, Me) {
        Me === void 0 && (q === null ? Me = 33984 + L - 1 : Me = q);
        let qe = X[Me];
        qe === void 0 && (qe = {
            type: void 0,
            texture: void 0
        }, X[Me] = qe), (qe.type !== Z || qe.texture !== ve) && (q !== Me && (n1.activeTexture(Me), q = Me), n1.bindTexture(Z, ve || W[Z]), qe.type = Z, qe.texture = ve);
    }
    function N() {
        let Z = X[q];
        Z !== void 0 && Z.type !== void 0 && (n1.bindTexture(Z.type, null), Z.type = void 0, Z.texture = void 0);
    }
    function ae() {
        try {
            n1.compressedTexImage2D.apply(n1, arguments);
        } catch (Z) {
            console.error("THREE.WebGLState:", Z);
        }
    }
    function ye() {
        try {
            n1.compressedTexImage3D.apply(n1, arguments);
        } catch (Z) {
            console.error("THREE.WebGLState:", Z);
        }
    }
    function me() {
        try {
            n1.texSubImage2D.apply(n1, arguments);
        } catch (Z) {
            console.error("THREE.WebGLState:", Z);
        }
    }
    function Ne() {
        try {
            n1.texSubImage3D.apply(n1, arguments);
        } catch (Z) {
            console.error("THREE.WebGLState:", Z);
        }
    }
    function Fe() {
        try {
            n1.compressedTexSubImage2D.apply(n1, arguments);
        } catch (Z) {
            console.error("THREE.WebGLState:", Z);
        }
    }
    function Oe() {
        try {
            n1.compressedTexSubImage3D.apply(n1, arguments);
        } catch (Z) {
            console.error("THREE.WebGLState:", Z);
        }
    }
    function pe() {
        try {
            n1.texStorage2D.apply(n1, arguments);
        } catch (Z) {
            console.error("THREE.WebGLState:", Z);
        }
    }
    function nt() {
        try {
            n1.texStorage3D.apply(n1, arguments);
        } catch (Z) {
            console.error("THREE.WebGLState:", Z);
        }
    }
    function We() {
        try {
            n1.texImage2D.apply(n1, arguments);
        } catch (Z) {
            console.error("THREE.WebGLState:", Z);
        }
    }
    function Be() {
        try {
            n1.texImage3D.apply(n1, arguments);
        } catch (Z) {
            console.error("THREE.WebGLState:", Z);
        }
    }
    function tt(Z) {
        Q.equals(Z) === !1 && (n1.scissor(Z.x, Z.y, Z.z, Z.w), Q.copy(Z));
    }
    function ot(Z) {
        te.equals(Z) === !1 && (n1.viewport(Z.x, Z.y, Z.z, Z.w), te.copy(Z));
    }
    function Gt(Z, ve) {
        let Me = h.get(ve);
        Me === void 0 && (Me = new WeakMap, h.set(ve, Me));
        let qe = Me.get(Z);
        qe === void 0 && (qe = n1.getUniformBlockIndex(ve, Z.name), Me.set(Z, qe));
    }
    function xr(Z, ve) {
        let qe = h.get(ve).get(Z);
        u1.get(ve) !== qe && (n1.uniformBlockBinding(ve, qe, Z.__bindingPointIndex), u1.set(ve, qe));
    }
    function Ir() {
        n1.disable(3042), n1.disable(2884), n1.disable(2929), n1.disable(32823), n1.disable(3089), n1.disable(2960), n1.disable(32926), n1.blendEquation(32774), n1.blendFunc(1, 0), n1.blendFuncSeparate(1, 0, 1, 0), n1.colorMask(!0, !0, !0, !0), n1.clearColor(0, 0, 0, 0), n1.depthMask(!0), n1.depthFunc(513), n1.clearDepth(1), n1.stencilMask(4294967295), n1.stencilFunc(519, 0, 4294967295), n1.stencilOp(7680, 7680, 7680), n1.clearStencil(0), n1.cullFace(1029), n1.frontFace(2305), n1.polygonOffset(0, 0), n1.activeTexture(33984), n1.bindFramebuffer(36160, null), r === !0 && (n1.bindFramebuffer(36009, null), n1.bindFramebuffer(36008, null)), n1.useProgram(null), n1.lineWidth(1), n1.scissor(0, 0, n1.canvas.width, n1.canvas.height), n1.viewport(0, 0, n1.canvas.width, n1.canvas.height), d = {}, q = null, X = {}, f = {}, m = new WeakMap, p = [], g = null, y = !1, x = null, v = null, b = null, w = null, A = null, T = null, S = null, M = !1, C = null, P = null, _ = null, I = null, O = null, Q.set(0, 0, n1.canvas.width, n1.canvas.height), te.set(0, 0, n1.canvas.width, n1.canvas.height), a.reset(), l.reset(), c.reset();
    }
    return {
        buffers: {
            color: a,
            depth: l,
            stencil: c
        },
        enable: oe,
        disable: ie,
        bindFramebuffer: re,
        drawBuffers: J,
        useProgram: Ee,
        setBlending: De,
        setMaterial: Pe,
        setFlipSided: ze,
        setCullFace: ke,
        setLineWidth: Ue,
        setPolygonOffset: Le,
        setScissorTest: Qe,
        activeTexture: F,
        bindTexture: B,
        unbindTexture: N,
        compressedTexImage2D: ae,
        compressedTexImage3D: ye,
        texImage2D: We,
        texImage3D: Be,
        updateUBOMapping: Gt,
        uniformBlockBinding: xr,
        texStorage2D: pe,
        texStorage3D: nt,
        texSubImage2D: me,
        texSubImage3D: Ne,
        compressedTexSubImage2D: Fe,
        compressedTexSubImage3D: Oe,
        scissor: tt,
        viewport: ot,
        reset: Ir
    };
}
function W5(n1, t, e, r, i, s1, o) {
    let a = i.isWebGL2, l = i.maxTextures, c = i.maxCubemapSize, u1 = i.maxTextureSize, h = i.maxSamples, d = t.has("WEBGL_multisampled_render_to_texture") ? t.get("WEBGL_multisampled_render_to_texture") : null, f = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), m = new WeakMap, p, g = new WeakMap, y = !1;
    try {
        y = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch  {}
    function x(B, N) {
        return y ? new OffscreenCanvas(B, N) : Fp("canvas");
    }
    function v(B, N, ae, ye) {
        let me = 1;
        if ((B.width > ye || B.height > ye) && (me = ye / Math.max(B.width, B.height)), me < 1 || N === !0) {
            if (typeof HTMLImageElement < "u" && B instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && B instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && B instanceof ImageBitmap) {
                let Ne = N ? Fy : Math.floor, Fe = Ne(me * B.width), Oe = Ne(me * B.height);
                p === void 0 && (p = x(Fe, Oe));
                let pe = ae ? x(Fe, Oe) : p;
                return pe.width = Fe, pe.height = Oe, pe.getContext("2d").drawImage(B, 0, 0, Fe, Oe), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + B.width + "x" + B.height + ") to (" + Fe + "x" + Oe + ")."), pe;
            } else return "data" in B && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + B.width + "x" + B.height + ")."), B;
        }
        return B;
    }
    function b(B) {
        return XS(B.width) && XS(B.height);
    }
    function w(B) {
        return a ? !1 : B.wrapS !== tr || B.wrapT !== tr || B.minFilter !== vt && B.minFilter !== it;
    }
    function A(B, N) {
        return B.generateMipmaps && N && B.minFilter !== vt && B.minFilter !== it;
    }
    function T(B) {
        n1.generateMipmap(B);
    }
    function S(B, N, ae, ye, me = !1) {
        if (a === !1) return N;
        if (B !== null) {
            if (n1[B] !== void 0) return n1[B];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + B + "'");
        }
        let Ne = N;
        return N === 6403 && (ae === 5126 && (Ne = 33326), ae === 5131 && (Ne = 33325), ae === 5121 && (Ne = 33321)), N === 33319 && (ae === 5126 && (Ne = 33328), ae === 5131 && (Ne = 33327), ae === 5121 && (Ne = 33323)), N === 6408 && (ae === 5126 && (Ne = 34836), ae === 5131 && (Ne = 34842), ae === 5121 && (Ne = ye === ut && me === !1 ? 35907 : 32856), ae === 32819 && (Ne = 32854), ae === 32820 && (Ne = 32855)), (Ne === 33325 || Ne === 33326 || Ne === 33327 || Ne === 33328 || Ne === 34842 || Ne === 34836) && t.get("EXT_color_buffer_float"), Ne;
    }
    function M(B, N, ae) {
        return A(B, ae) === !0 || B.isFramebufferTexture && B.minFilter !== vt && B.minFilter !== it ? Math.log2(Math.max(N.width, N.height)) + 1 : B.mipmaps !== void 0 && B.mipmaps.length > 0 ? B.mipmaps.length : B.isCompressedTexture && Array.isArray(B.image) ? N.mipmaps.length : 1;
    }
    function C(B) {
        return B === vt || B === IC || B === nS ? 9728 : 9729;
    }
    function P(B) {
        let N = B.target;
        N.removeEventListener("dispose", P), I(N), N.isVideoTexture && m.delete(N);
    }
    function _(B) {
        let N = B.target;
        N.removeEventListener("dispose", _), L(N);
    }
    function I(B) {
        let N = r.get(B);
        if (N.__webglInit === void 0) return;
        let ae = B.source, ye = g.get(ae);
        if (ye) {
            let me = ye[N.__cacheKey];
            me.usedTimes--, me.usedTimes === 0 && O(B), Object.keys(ye).length === 0 && g.delete(ae);
        }
        r.remove(B);
    }
    function O(B) {
        let N = r.get(B);
        n1.deleteTexture(N.__webglTexture);
        let ae = B.source, ye = g.get(ae);
        delete ye[N.__cacheKey], o.memory.textures--;
    }
    function L(B) {
        let N = B.texture, ae = r.get(B), ye = r.get(N);
        if (ye.__webglTexture !== void 0 && (n1.deleteTexture(ye.__webglTexture), o.memory.textures--), B.depthTexture && B.depthTexture.dispose(), B.isWebGLCubeRenderTarget) for(let me = 0; me < 6; me++)n1.deleteFramebuffer(ae.__webglFramebuffer[me]), ae.__webglDepthbuffer && n1.deleteRenderbuffer(ae.__webglDepthbuffer[me]);
        else {
            if (n1.deleteFramebuffer(ae.__webglFramebuffer), ae.__webglDepthbuffer && n1.deleteRenderbuffer(ae.__webglDepthbuffer), ae.__webglMultisampledFramebuffer && n1.deleteFramebuffer(ae.__webglMultisampledFramebuffer), ae.__webglColorRenderbuffer) for(let me = 0; me < ae.__webglColorRenderbuffer.length; me++)ae.__webglColorRenderbuffer[me] && n1.deleteRenderbuffer(ae.__webglColorRenderbuffer[me]);
            ae.__webglDepthRenderbuffer && n1.deleteRenderbuffer(ae.__webglDepthRenderbuffer);
        }
        if (B.isWebGLMultipleRenderTargets) for(let me = 0, Ne = N.length; me < Ne; me++){
            let Fe = r.get(N[me]);
            Fe.__webglTexture && (n1.deleteTexture(Fe.__webglTexture), o.memory.textures--), r.remove(N[me]);
        }
        r.remove(N), r.remove(B);
    }
    let j = 0;
    function V() {
        j = 0;
    }
    function H() {
        let B = j;
        return B >= l && console.warn("THREE.WebGLTextures: Trying to use " + B + " texture units while this GPU supports only " + l), j += 1, B;
    }
    function q(B) {
        let N = [];
        return N.push(B.wrapS), N.push(B.wrapT), N.push(B.wrapR || 0), N.push(B.magFilter), N.push(B.minFilter), N.push(B.anisotropy), N.push(B.internalFormat), N.push(B.format), N.push(B.type), N.push(B.generateMipmaps), N.push(B.premultiplyAlpha), N.push(B.flipY), N.push(B.unpackAlignment), N.push(B.encoding), N.join();
    }
    function X(B, N) {
        let ae = r.get(B);
        if (B.isVideoTexture && Qe(B), B.isRenderTargetTexture === !1 && B.version > 0 && ae.__version !== B.version) {
            let ye = B.image;
            if (ye === null) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
            else if (ye.complete === !1) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                ie(ae, B, N);
                return;
            }
        }
        e.bindTexture(3553, ae.__webglTexture, 33984 + N);
    }
    function K(B, N) {
        let ae = r.get(B);
        if (B.version > 0 && ae.__version !== B.version) {
            ie(ae, B, N);
            return;
        }
        e.bindTexture(35866, ae.__webglTexture, 33984 + N);
    }
    function z(B, N) {
        let ae = r.get(B);
        if (B.version > 0 && ae.__version !== B.version) {
            ie(ae, B, N);
            return;
        }
        e.bindTexture(32879, ae.__webglTexture, 33984 + N);
    }
    function Q(B, N) {
        let ae = r.get(B);
        if (B.version > 0 && ae.__version !== B.version) {
            re(ae, B, N);
            return;
        }
        e.bindTexture(34067, ae.__webglTexture, 33984 + N);
    }
    let te = {
        [Hs]: 10497,
        [tr]: 33071,
        [HS]: 33648
    }, $ = {
        [vt]: 9728,
        [IC]: 9984,
        [nS]: 9986,
        [it]: 9729,
        [NU]: 9985,
        [Bc]: 9987
    };
    function W(B, N, ae) {
        if (ae ? (n1.texParameteri(B, 10242, te[N.wrapS]), n1.texParameteri(B, 10243, te[N.wrapT]), (B === 32879 || B === 35866) && n1.texParameteri(B, 32882, te[N.wrapR]), n1.texParameteri(B, 10240, $[N.magFilter]), n1.texParameteri(B, 10241, $[N.minFilter])) : (n1.texParameteri(B, 10242, 33071), n1.texParameteri(B, 10243, 33071), (B === 32879 || B === 35866) && n1.texParameteri(B, 32882, 33071), (N.wrapS !== tr || N.wrapT !== tr) && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), n1.texParameteri(B, 10240, C(N.magFilter)), n1.texParameteri(B, 10241, C(N.minFilter)), N.minFilter !== vt && N.minFilter !== it && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), t.has("EXT_texture_filter_anisotropic") === !0) {
            let ye = t.get("EXT_texture_filter_anisotropic");
            if (N.magFilter === vt || N.minFilter !== nS && N.minFilter !== Bc || N.type === Ut && t.has("OES_texture_float_linear") === !1 || a === !1 && N.type === $n && t.has("OES_texture_half_float_linear") === !1) return;
            (N.anisotropy > 1 || r.get(N).__currentAnisotropy) && (n1.texParameterf(B, ye.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(N.anisotropy, i.getMaxAnisotropy())), r.get(N).__currentAnisotropy = N.anisotropy);
        }
    }
    function oe(B, N) {
        let ae = !1;
        B.__webglInit === void 0 && (B.__webglInit = !0, N.addEventListener("dispose", P));
        let ye = N.source, me = g.get(ye);
        me === void 0 && (me = {}, g.set(ye, me));
        let Ne = q(N);
        if (Ne !== B.__cacheKey) {
            me[Ne] === void 0 && (me[Ne] = {
                texture: n1.createTexture(),
                usedTimes: 0
            }, o.memory.textures++, ae = !0), me[Ne].usedTimes++;
            let Fe = me[B.__cacheKey];
            Fe !== void 0 && (me[B.__cacheKey].usedTimes--, Fe.usedTimes === 0 && O(N)), B.__cacheKey = Ne, B.__webglTexture = me[Ne].texture;
        }
        return ae;
    }
    function ie(B, N, ae) {
        let ye = 3553;
        (N.isDataArrayTexture || N.isCompressedArrayTexture) && (ye = 35866), N.isData3DTexture && (ye = 32879);
        let me = oe(B, N), Ne = N.source;
        e.bindTexture(ye, B.__webglTexture, 33984 + ae);
        let Fe = r.get(Ne);
        if (Ne.version !== Fe.__version || me === !0) {
            e.activeTexture(33984 + ae), n1.pixelStorei(37440, N.flipY), n1.pixelStorei(37441, N.premultiplyAlpha), n1.pixelStorei(3317, N.unpackAlignment), n1.pixelStorei(37443, 0);
            let Oe = w(N) && b(N.image) === !1, pe = v(N.image, Oe, !1, u1);
            pe = F(N, pe);
            let nt = b(pe) || a, We = s1.convert(N.format, N.encoding), Be = s1.convert(N.type), tt = S(N.internalFormat, We, Be, N.encoding, N.isVideoTexture);
            W(ye, N, nt);
            let ot, Gt = N.mipmaps, xr = a && N.isVideoTexture !== !0, Ir = Fe.__version === void 0 || me === !0, Z = M(N, pe, nt);
            if (N.isDepthTexture) tt = 6402, a ? N.type === Ut ? tt = 36012 : N.type === Gs ? tt = 33190 : N.type === gl ? tt = 35056 : tt = 33189 : N.type === Ut && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), N.format === Lc && tt === 6402 && N.type !== s_ && N.type !== Gs && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), N.type = Gs, Be = s1.convert(N.type)), N.format === xl && tt === 6402 && (tt = 34041, N.type !== gl && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), N.type = gl, Be = s1.convert(N.type))), Ir && (xr ? e.texStorage2D(3553, 1, tt, pe.width, pe.height) : e.texImage2D(3553, 0, tt, pe.width, pe.height, 0, We, Be, null));
            else if (N.isDataTexture) {
                if (Gt.length > 0 && nt) {
                    xr && Ir && e.texStorage2D(3553, Z, tt, Gt[0].width, Gt[0].height);
                    for(let ve = 0, Me = Gt.length; ve < Me; ve++)ot = Gt[ve], xr ? e.texSubImage2D(3553, ve, 0, 0, ot.width, ot.height, We, Be, ot.data) : e.texImage2D(3553, ve, tt, ot.width, ot.height, 0, We, Be, ot.data);
                    N.generateMipmaps = !1;
                } else xr ? (Ir && e.texStorage2D(3553, Z, tt, pe.width, pe.height), e.texSubImage2D(3553, 0, 0, 0, pe.width, pe.height, We, Be, pe.data)) : e.texImage2D(3553, 0, tt, pe.width, pe.height, 0, We, Be, pe.data);
            } else if (N.isCompressedTexture) {
                if (N.isCompressedArrayTexture) {
                    xr && Ir && e.texStorage3D(35866, Z, tt, Gt[0].width, Gt[0].height, pe.depth);
                    for(let ve = 0, Me = Gt.length; ve < Me; ve++)ot = Gt[ve], N.format !== br ? We !== null ? xr ? e.compressedTexSubImage3D(35866, ve, 0, 0, 0, ot.width, ot.height, pe.depth, We, ot.data, 0, 0) : e.compressedTexImage3D(35866, ve, tt, ot.width, ot.height, pe.depth, 0, ot.data, 0, 0) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : xr ? e.texSubImage3D(35866, ve, 0, 0, 0, ot.width, ot.height, pe.depth, We, Be, ot.data) : e.texImage3D(35866, ve, tt, ot.width, ot.height, pe.depth, 0, We, Be, ot.data);
                } else {
                    xr && Ir && e.texStorage2D(3553, Z, tt, Gt[0].width, Gt[0].height);
                    for(let ve = 0, Me = Gt.length; ve < Me; ve++)ot = Gt[ve], N.format !== br ? We !== null ? xr ? e.compressedTexSubImage2D(3553, ve, 0, 0, ot.width, ot.height, We, ot.data) : e.compressedTexImage2D(3553, ve, tt, ot.width, ot.height, 0, ot.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : xr ? e.texSubImage2D(3553, ve, 0, 0, ot.width, ot.height, We, Be, ot.data) : e.texImage2D(3553, ve, tt, ot.width, ot.height, 0, We, Be, ot.data);
                }
            } else if (N.isDataArrayTexture) xr ? (Ir && e.texStorage3D(35866, Z, tt, pe.width, pe.height, pe.depth), e.texSubImage3D(35866, 0, 0, 0, 0, pe.width, pe.height, pe.depth, We, Be, pe.data)) : e.texImage3D(35866, 0, tt, pe.width, pe.height, pe.depth, 0, We, Be, pe.data);
            else if (N.isData3DTexture) xr ? (Ir && e.texStorage3D(32879, Z, tt, pe.width, pe.height, pe.depth), e.texSubImage3D(32879, 0, 0, 0, 0, pe.width, pe.height, pe.depth, We, Be, pe.data)) : e.texImage3D(32879, 0, tt, pe.width, pe.height, pe.depth, 0, We, Be, pe.data);
            else if (N.isFramebufferTexture) {
                if (Ir) {
                    if (xr) e.texStorage2D(3553, Z, tt, pe.width, pe.height);
                    else {
                        let ve = pe.width, Me = pe.height;
                        for(let qe = 0; qe < Z; qe++)e.texImage2D(3553, qe, tt, ve, Me, 0, We, Be, null), ve >>= 1, Me >>= 1;
                    }
                }
            } else if (Gt.length > 0 && nt) {
                xr && Ir && e.texStorage2D(3553, Z, tt, Gt[0].width, Gt[0].height);
                for(let ve = 0, Me = Gt.length; ve < Me; ve++)ot = Gt[ve], xr ? e.texSubImage2D(3553, ve, 0, 0, We, Be, ot) : e.texImage2D(3553, ve, tt, We, Be, ot);
                N.generateMipmaps = !1;
            } else xr ? (Ir && e.texStorage2D(3553, Z, tt, pe.width, pe.height), e.texSubImage2D(3553, 0, 0, 0, We, Be, pe)) : e.texImage2D(3553, 0, tt, We, Be, pe);
            A(N, nt) && T(ye), Fe.__version = Ne.version, N.onUpdate && N.onUpdate(N);
        }
        B.__version = N.version;
    }
    function re(B, N, ae) {
        if (N.image.length !== 6) return;
        let ye = oe(B, N), me = N.source;
        e.bindTexture(34067, B.__webglTexture, 33984 + ae);
        let Ne = r.get(me);
        if (me.version !== Ne.__version || ye === !0) {
            e.activeTexture(33984 + ae), n1.pixelStorei(37440, N.flipY), n1.pixelStorei(37441, N.premultiplyAlpha), n1.pixelStorei(3317, N.unpackAlignment), n1.pixelStorei(37443, 0);
            let Fe = N.isCompressedTexture || N.image[0].isCompressedTexture, Oe = N.image[0] && N.image[0].isDataTexture, pe = [];
            for(let ve = 0; ve < 6; ve++)!Fe && !Oe ? pe[ve] = v(N.image[ve], !1, !0, c) : pe[ve] = Oe ? N.image[ve].image : N.image[ve], pe[ve] = F(N, pe[ve]);
            let nt = pe[0], We = b(nt) || a, Be = s1.convert(N.format, N.encoding), tt = s1.convert(N.type), ot = S(N.internalFormat, Be, tt, N.encoding), Gt = a && N.isVideoTexture !== !0, xr = Ne.__version === void 0 || ye === !0, Ir = M(N, nt, We);
            W(34067, N, We);
            let Z;
            if (Fe) {
                Gt && xr && e.texStorage2D(34067, Ir, ot, nt.width, nt.height);
                for(let ve = 0; ve < 6; ve++){
                    Z = pe[ve].mipmaps;
                    for(let Me = 0; Me < Z.length; Me++){
                        let qe = Z[Me];
                        N.format !== br ? Be !== null ? Gt ? e.compressedTexSubImage2D(34069 + ve, Me, 0, 0, qe.width, qe.height, Be, qe.data) : e.compressedTexImage2D(34069 + ve, Me, ot, qe.width, qe.height, 0, qe.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : Gt ? e.texSubImage2D(34069 + ve, Me, 0, 0, qe.width, qe.height, Be, tt, qe.data) : e.texImage2D(34069 + ve, Me, ot, qe.width, qe.height, 0, Be, tt, qe.data);
                    }
                }
            } else {
                Z = N.mipmaps, Gt && xr && (Z.length > 0 && Ir++, e.texStorage2D(34067, Ir, ot, pe[0].width, pe[0].height));
                for(let ve = 0; ve < 6; ve++)if (Oe) {
                    Gt ? e.texSubImage2D(34069 + ve, 0, 0, 0, pe[ve].width, pe[ve].height, Be, tt, pe[ve].data) : e.texImage2D(34069 + ve, 0, ot, pe[ve].width, pe[ve].height, 0, Be, tt, pe[ve].data);
                    for(let Me = 0; Me < Z.length; Me++){
                        let Xe = Z[Me].image[ve].image;
                        Gt ? e.texSubImage2D(34069 + ve, Me + 1, 0, 0, Xe.width, Xe.height, Be, tt, Xe.data) : e.texImage2D(34069 + ve, Me + 1, ot, Xe.width, Xe.height, 0, Be, tt, Xe.data);
                    }
                } else {
                    Gt ? e.texSubImage2D(34069 + ve, 0, 0, 0, Be, tt, pe[ve]) : e.texImage2D(34069 + ve, 0, ot, Be, tt, pe[ve]);
                    for(let Me = 0; Me < Z.length; Me++){
                        let qe = Z[Me];
                        Gt ? e.texSubImage2D(34069 + ve, Me + 1, 0, 0, Be, tt, qe.image[ve]) : e.texImage2D(34069 + ve, Me + 1, ot, Be, tt, qe.image[ve]);
                    }
                }
            }
            A(N, We) && T(34067), Ne.__version = me.version, N.onUpdate && N.onUpdate(N);
        }
        B.__version = N.version;
    }
    function J(B, N, ae, ye, me) {
        let Ne = s1.convert(ae.format, ae.encoding), Fe = s1.convert(ae.type), Oe = S(ae.internalFormat, Ne, Fe, ae.encoding);
        r.get(N).__hasExternalTextures || (me === 32879 || me === 35866 ? e.texImage3D(me, 0, Oe, N.width, N.height, N.depth, 0, Ne, Fe, null) : e.texImage2D(me, 0, Oe, N.width, N.height, 0, Ne, Fe, null)), e.bindFramebuffer(36160, B), Le(N) ? d.framebufferTexture2DMultisampleEXT(36160, ye, me, r.get(ae).__webglTexture, 0, Ue(N)) : (me === 3553 || me >= 34069 && me <= 34074) && n1.framebufferTexture2D(36160, ye, me, r.get(ae).__webglTexture, 0), e.bindFramebuffer(36160, null);
    }
    function Ee(B, N, ae) {
        if (n1.bindRenderbuffer(36161, B), N.depthBuffer && !N.stencilBuffer) {
            let ye = 33189;
            if (ae || Le(N)) {
                let me = N.depthTexture;
                me && me.isDepthTexture && (me.type === Ut ? ye = 36012 : me.type === Gs && (ye = 33190));
                let Ne = Ue(N);
                Le(N) ? d.renderbufferStorageMultisampleEXT(36161, Ne, ye, N.width, N.height) : n1.renderbufferStorageMultisample(36161, Ne, ye, N.width, N.height);
            } else n1.renderbufferStorage(36161, ye, N.width, N.height);
            n1.framebufferRenderbuffer(36160, 36096, 36161, B);
        } else if (N.depthBuffer && N.stencilBuffer) {
            let ye = Ue(N);
            ae && Le(N) === !1 ? n1.renderbufferStorageMultisample(36161, ye, 35056, N.width, N.height) : Le(N) ? d.renderbufferStorageMultisampleEXT(36161, ye, 35056, N.width, N.height) : n1.renderbufferStorage(36161, 34041, N.width, N.height), n1.framebufferRenderbuffer(36160, 33306, 36161, B);
        } else {
            let ye = N.isWebGLMultipleRenderTargets === !0 ? N.texture : [
                N.texture
            ];
            for(let me = 0; me < ye.length; me++){
                let Ne = ye[me], Fe = s1.convert(Ne.format, Ne.encoding), Oe = s1.convert(Ne.type), pe = S(Ne.internalFormat, Fe, Oe, Ne.encoding), nt = Ue(N);
                ae && Le(N) === !1 ? n1.renderbufferStorageMultisample(36161, nt, pe, N.width, N.height) : Le(N) ? d.renderbufferStorageMultisampleEXT(36161, nt, pe, N.width, N.height) : n1.renderbufferStorage(36161, pe, N.width, N.height);
            }
        }
        n1.bindRenderbuffer(36161, null);
    }
    function xe(B, N) {
        if (N && N.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
        if (e.bindFramebuffer(36160, B), !(N.depthTexture && N.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        (!r.get(N.depthTexture).__webglTexture || N.depthTexture.image.width !== N.width || N.depthTexture.image.height !== N.height) && (N.depthTexture.image.width = N.width, N.depthTexture.image.height = N.height, N.depthTexture.needsUpdate = !0), X(N.depthTexture, 0);
        let ye = r.get(N.depthTexture).__webglTexture, me = Ue(N);
        if (N.depthTexture.format === Lc) Le(N) ? d.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, ye, 0, me) : n1.framebufferTexture2D(36160, 36096, 3553, ye, 0);
        else if (N.depthTexture.format === xl) Le(N) ? d.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, ye, 0, me) : n1.framebufferTexture2D(36160, 33306, 3553, ye, 0);
        else throw new Error("Unknown depthTexture format");
    }
    function de(B) {
        let N = r.get(B), ae = B.isWebGLCubeRenderTarget === !0;
        if (B.depthTexture && !N.__autoAllocateDepthBuffer) {
            if (ae) throw new Error("target.depthTexture not supported in Cube render targets");
            xe(N.__webglFramebuffer, B);
        } else if (ae) {
            N.__webglDepthbuffer = [];
            for(let ye = 0; ye < 6; ye++)e.bindFramebuffer(36160, N.__webglFramebuffer[ye]), N.__webglDepthbuffer[ye] = n1.createRenderbuffer(), Ee(N.__webglDepthbuffer[ye], B, !1);
        } else e.bindFramebuffer(36160, N.__webglFramebuffer), N.__webglDepthbuffer = n1.createRenderbuffer(), Ee(N.__webglDepthbuffer, B, !1);
        e.bindFramebuffer(36160, null);
    }
    function De(B, N, ae) {
        let ye = r.get(B);
        N !== void 0 && J(ye.__webglFramebuffer, B, B.texture, 36064, 3553), ae !== void 0 && de(B);
    }
    function Pe(B) {
        let N = B.texture, ae = r.get(B), ye = r.get(N);
        B.addEventListener("dispose", _), B.isWebGLMultipleRenderTargets !== !0 && (ye.__webglTexture === void 0 && (ye.__webglTexture = n1.createTexture()), ye.__version = N.version, o.memory.textures++);
        let me = B.isWebGLCubeRenderTarget === !0, Ne = B.isWebGLMultipleRenderTargets === !0, Fe = b(B) || a;
        if (me) {
            ae.__webglFramebuffer = [];
            for(let Oe = 0; Oe < 6; Oe++)ae.__webglFramebuffer[Oe] = n1.createFramebuffer();
        } else {
            if (ae.__webglFramebuffer = n1.createFramebuffer(), Ne) {
                if (i.drawBuffers) {
                    let Oe = B.texture;
                    for(let pe = 0, nt = Oe.length; pe < nt; pe++){
                        let We = r.get(Oe[pe]);
                        We.__webglTexture === void 0 && (We.__webglTexture = n1.createTexture(), o.memory.textures++);
                    }
                } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
            }
            if (a && B.samples > 0 && Le(B) === !1) {
                let Oe = Ne ? N : [
                    N
                ];
                ae.__webglMultisampledFramebuffer = n1.createFramebuffer(), ae.__webglColorRenderbuffer = [], e.bindFramebuffer(36160, ae.__webglMultisampledFramebuffer);
                for(let pe = 0; pe < Oe.length; pe++){
                    let nt = Oe[pe];
                    ae.__webglColorRenderbuffer[pe] = n1.createRenderbuffer(), n1.bindRenderbuffer(36161, ae.__webglColorRenderbuffer[pe]);
                    let We = s1.convert(nt.format, nt.encoding), Be = s1.convert(nt.type), tt = S(nt.internalFormat, We, Be, nt.encoding, B.isXRRenderTarget === !0), ot = Ue(B);
                    n1.renderbufferStorageMultisample(36161, ot, tt, B.width, B.height), n1.framebufferRenderbuffer(36160, 36064 + pe, 36161, ae.__webglColorRenderbuffer[pe]);
                }
                n1.bindRenderbuffer(36161, null), B.depthBuffer && (ae.__webglDepthRenderbuffer = n1.createRenderbuffer(), Ee(ae.__webglDepthRenderbuffer, B, !0)), e.bindFramebuffer(36160, null);
            }
        }
        if (me) {
            e.bindTexture(34067, ye.__webglTexture), W(34067, N, Fe);
            for(let Oe = 0; Oe < 6; Oe++)J(ae.__webglFramebuffer[Oe], B, N, 36064, 34069 + Oe);
            A(N, Fe) && T(34067), e.unbindTexture();
        } else if (Ne) {
            let Oe = B.texture;
            for(let pe = 0, nt = Oe.length; pe < nt; pe++){
                let We = Oe[pe], Be = r.get(We);
                e.bindTexture(3553, Be.__webglTexture), W(3553, We, Fe), J(ae.__webglFramebuffer, B, We, 36064 + pe, 3553), A(We, Fe) && T(3553);
            }
            e.unbindTexture();
        } else {
            let Oe = 3553;
            (B.isWebGL3DRenderTarget || B.isWebGLArrayRenderTarget) && (a ? Oe = B.isWebGL3DRenderTarget ? 32879 : 35866 : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), e.bindTexture(Oe, ye.__webglTexture), W(Oe, N, Fe), J(ae.__webglFramebuffer, B, N, 36064, Oe), A(N, Fe) && T(Oe), e.unbindTexture();
        }
        B.depthBuffer && de(B);
    }
    function ze(B) {
        let N = b(B) || a, ae = B.isWebGLMultipleRenderTargets === !0 ? B.texture : [
            B.texture
        ];
        for(let ye = 0, me = ae.length; ye < me; ye++){
            let Ne = ae[ye];
            if (A(Ne, N)) {
                let Fe = B.isWebGLCubeRenderTarget ? 34067 : 3553, Oe = r.get(Ne).__webglTexture;
                e.bindTexture(Fe, Oe), T(Fe), e.unbindTexture();
            }
        }
    }
    function ke(B) {
        if (a && B.samples > 0 && Le(B) === !1) {
            let N = B.isWebGLMultipleRenderTargets ? B.texture : [
                B.texture
            ], ae = B.width, ye = B.height, me = 16384, Ne = [], Fe = B.stencilBuffer ? 33306 : 36096, Oe = r.get(B), pe = B.isWebGLMultipleRenderTargets === !0;
            if (pe) for(let nt = 0; nt < N.length; nt++)e.bindFramebuffer(36160, Oe.__webglMultisampledFramebuffer), n1.framebufferRenderbuffer(36160, 36064 + nt, 36161, null), e.bindFramebuffer(36160, Oe.__webglFramebuffer), n1.framebufferTexture2D(36009, 36064 + nt, 3553, null, 0);
            e.bindFramebuffer(36008, Oe.__webglMultisampledFramebuffer), e.bindFramebuffer(36009, Oe.__webglFramebuffer);
            for(let nt = 0; nt < N.length; nt++){
                Ne.push(36064 + nt), B.depthBuffer && Ne.push(Fe);
                let We = Oe.__ignoreDepthValues !== void 0 ? Oe.__ignoreDepthValues : !1;
                if (We === !1 && (B.depthBuffer && (me |= 256), B.stencilBuffer && (me |= 1024)), pe && n1.framebufferRenderbuffer(36008, 36064, 36161, Oe.__webglColorRenderbuffer[nt]), We === !0 && (n1.invalidateFramebuffer(36008, [
                    Fe
                ]), n1.invalidateFramebuffer(36009, [
                    Fe
                ])), pe) {
                    let Be = r.get(N[nt]).__webglTexture;
                    n1.framebufferTexture2D(36009, 36064, 3553, Be, 0);
                }
                n1.blitFramebuffer(0, 0, ae, ye, 0, 0, ae, ye, me, 9728), f && n1.invalidateFramebuffer(36008, Ne);
            }
            if (e.bindFramebuffer(36008, null), e.bindFramebuffer(36009, null), pe) for(let nt = 0; nt < N.length; nt++){
                e.bindFramebuffer(36160, Oe.__webglMultisampledFramebuffer), n1.framebufferRenderbuffer(36160, 36064 + nt, 36161, Oe.__webglColorRenderbuffer[nt]);
                let We = r.get(N[nt]).__webglTexture;
                e.bindFramebuffer(36160, Oe.__webglFramebuffer), n1.framebufferTexture2D(36009, 36064 + nt, 3553, We, 0);
            }
            e.bindFramebuffer(36009, Oe.__webglMultisampledFramebuffer);
        }
    }
    function Ue(B) {
        return Math.min(h, B.samples);
    }
    function Le(B) {
        let N = r.get(B);
        return a && B.samples > 0 && t.has("WEBGL_multisampled_render_to_texture") === !0 && N.__useRenderToTexture !== !1;
    }
    function Qe(B) {
        let N = o.render.frame;
        m.get(B) !== N && (m.set(B, N), B.update());
    }
    function F(B, N) {
        let ae = B.encoding, ye = B.format, me = B.type;
        return B.isCompressedTexture === !0 || B.isVideoTexture === !0 || B.format === qS || ae !== xn && (ae === ut ? a === !1 ? t.has("EXT_sRGB") === !0 && ye === br ? (B.format = qS, B.minFilter = it, B.generateMipmaps = !1) : N = Vy.sRGBToLinear(N) : (ye !== br || me !== Nr) && console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture encoding:", ae)), N;
    }
    this.allocateTextureUnit = H, this.resetTextureUnits = V, this.setTexture2D = X, this.setTexture2DArray = K, this.setTexture3D = z, this.setTextureCube = Q, this.rebindTextures = De, this.setupRenderTarget = Pe, this.updateRenderTargetMipmap = ze, this.updateMultisampleRenderTarget = ke, this.setupDepthRenderbuffer = de, this.setupFrameBufferTexture = J, this.useMultisampledRTT = Le;
}
function q5(n1, t, e) {
    let r = e.isWebGL2;
    function i(s1, o = null) {
        let a;
        if (s1 === Nr) return 5121;
        if (s1 === UU) return 32819;
        if (s1 === kU) return 32820;
        if (s1 === BU) return 5120;
        if (s1 === FU) return 5122;
        if (s1 === s_) return 5123;
        if (s1 === VU) return 5124;
        if (s1 === Gs) return 5125;
        if (s1 === Ut) return 5126;
        if (s1 === $n) return r ? 5131 : (a = t.get("OES_texture_half_float"), a !== null ? a.HALF_FLOAT_OES : null);
        if (s1 === zU) return 6406;
        if (s1 === br) return 6408;
        if (s1 === GU) return 6409;
        if (s1 === jU) return 6410;
        if (s1 === Lc) return 6402;
        if (s1 === xl) return 34041;
        if (s1 === qS) return a = t.get("EXT_sRGB"), a !== null ? a.SRGB_ALPHA_EXT : null;
        if (s1 === Zp) return 6403;
        if (s1 === HU) return 36244;
        if (s1 === bh) return 33319;
        if (s1 === WU) return 33320;
        if (s1 === Aw) return 36249;
        if (s1 === sS || s1 === oS || s1 === aS || s1 === lS) {
            if (o === ut) {
                if (a = t.get("WEBGL_compressed_texture_s3tc_srgb"), a !== null) {
                    if (s1 === sS) return a.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (s1 === oS) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (s1 === aS) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (s1 === lS) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else if (a = t.get("WEBGL_compressed_texture_s3tc"), a !== null) {
                if (s1 === sS) return a.COMPRESSED_RGB_S3TC_DXT1_EXT;
                if (s1 === oS) return a.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                if (s1 === aS) return a.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                if (s1 === lS) return a.COMPRESSED_RGBA_S3TC_DXT5_EXT;
            } else return null;
        }
        if (s1 === DC || s1 === OC || s1 === RC || s1 === LC) {
            if (a = t.get("WEBGL_compressed_texture_pvrtc"), a !== null) {
                if (s1 === DC) return a.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (s1 === OC) return a.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (s1 === RC) return a.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (s1 === LC) return a.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        if (s1 === qU) return a = t.get("WEBGL_compressed_texture_etc1"), a !== null ? a.COMPRESSED_RGB_ETC1_WEBGL : null;
        if (s1 === NC || s1 === BC) {
            if (a = t.get("WEBGL_compressed_texture_etc"), a !== null) {
                if (s1 === NC) return o === ut ? a.COMPRESSED_SRGB8_ETC2 : a.COMPRESSED_RGB8_ETC2;
                if (s1 === BC) return o === ut ? a.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : a.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        if (s1 === FC || s1 === VC || s1 === UC || s1 === kC || s1 === zC || s1 === GC || s1 === jC || s1 === HC || s1 === WC || s1 === qC || s1 === XC || s1 === YC || s1 === KC || s1 === QC) {
            if (a = t.get("WEBGL_compressed_texture_astc"), a !== null) {
                if (s1 === FC) return o === ut ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : a.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (s1 === VC) return o === ut ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : a.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (s1 === UC) return o === ut ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : a.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (s1 === kC) return o === ut ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : a.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (s1 === zC) return o === ut ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : a.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (s1 === GC) return o === ut ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : a.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (s1 === jC) return o === ut ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : a.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (s1 === HC) return o === ut ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : a.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (s1 === WC) return o === ut ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : a.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (s1 === qC) return o === ut ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : a.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (s1 === XC) return o === ut ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : a.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (s1 === YC) return o === ut ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : a.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (s1 === KC) return o === ut ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : a.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (s1 === QC) return o === ut ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : a.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        if (s1 === cS) {
            if (a = t.get("EXT_texture_compression_bptc"), a !== null) {
                if (s1 === cS) return o === ut ? a.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : a.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        if (s1 === XU || s1 === ZC || s1 === JC || s1 === $C) {
            if (a = t.get("EXT_texture_compression_rgtc"), a !== null) {
                if (s1 === cS) return a.COMPRESSED_RED_RGTC1_EXT;
                if (s1 === ZC) return a.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (s1 === JC) return a.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (s1 === $C) return a.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        return s1 === gl ? r ? 34042 : (a = t.get("WEBGL_depth_texture"), a !== null ? a.UNSIGNED_INT_24_8_WEBGL : null) : n1[s1] !== void 0 ? n1[s1] : null;
    }
    return {
        convert: i
    };
}
var iw = class extends si {
    constructor(t = []){
        super(), this.isArrayCamera = !0, this.cameras = t;
    }
}, cn = class extends Dt {
    constructor(){
        super(), this.isGroup = !0, this.type = "Group";
    }
}, X5 = {
    type: "move"
}, Op = class {
    constructor(){
        this._targetRay = null, this._grip = null, this._hand = null;
    }
    getHandSpace() {
        return this._hand === null && (this._hand = new cn, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
            pinching: !1
        }), this._hand;
    }
    getTargetRaySpace() {
        return this._targetRay === null && (this._targetRay = new cn, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new E, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new E), this._targetRay;
    }
    getGripSpace() {
        return this._grip === null && (this._grip = new cn, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new E, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new E), this._grip;
    }
    dispatchEvent(t) {
        return this._targetRay !== null && this._targetRay.dispatchEvent(t), this._grip !== null && this._grip.dispatchEvent(t), this._hand !== null && this._hand.dispatchEvent(t), this;
    }
    connect(t) {
        if (t && t.hand) {
            let e = this._hand;
            if (e) for (let r of t.hand.values())this._getHandJoint(e, r);
        }
        return this.dispatchEvent({
            type: "connected",
            data: t
        }), this;
    }
    disconnect(t) {
        return this.dispatchEvent({
            type: "disconnected",
            data: t
        }), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
    }
    update(t, e, r) {
        let i = null, s1 = null, o = null, a = this._targetRay, l = this._grip, c = this._hand;
        if (t && e.session.visibilityState !== "visible-blurred") {
            if (c && t.hand) {
                o = !0;
                for (let p of t.hand.values()){
                    let g = e.getJointPose(p, r), y = this._getHandJoint(c, p);
                    g !== null && (y.matrix.fromArray(g.transform.matrix), y.matrix.decompose(y.position, y.rotation, y.scale), y.jointRadius = g.radius), y.visible = g !== null;
                }
                let u1 = c.joints["index-finger-tip"], h = c.joints["thumb-tip"], d = u1.position.distanceTo(h.position), f = .02, m = .005;
                c.inputState.pinching && d > f + m ? (c.inputState.pinching = !1, this.dispatchEvent({
                    type: "pinchend",
                    handedness: t.handedness,
                    target: this
                })) : !c.inputState.pinching && d <= f - m && (c.inputState.pinching = !0, this.dispatchEvent({
                    type: "pinchstart",
                    handedness: t.handedness,
                    target: this
                }));
            } else l !== null && t.gripSpace && (s1 = e.getPose(t.gripSpace, r), s1 !== null && (l.matrix.fromArray(s1.transform.matrix), l.matrix.decompose(l.position, l.rotation, l.scale), s1.linearVelocity ? (l.hasLinearVelocity = !0, l.linearVelocity.copy(s1.linearVelocity)) : l.hasLinearVelocity = !1, s1.angularVelocity ? (l.hasAngularVelocity = !0, l.angularVelocity.copy(s1.angularVelocity)) : l.hasAngularVelocity = !1));
            a !== null && (i = e.getPose(t.targetRaySpace, r), i === null && s1 !== null && (i = s1), i !== null && (a.matrix.fromArray(i.transform.matrix), a.matrix.decompose(a.position, a.rotation, a.scale), i.linearVelocity ? (a.hasLinearVelocity = !0, a.linearVelocity.copy(i.linearVelocity)) : a.hasLinearVelocity = !1, i.angularVelocity ? (a.hasAngularVelocity = !0, a.angularVelocity.copy(i.angularVelocity)) : a.hasAngularVelocity = !1, this.dispatchEvent(X5)));
        }
        return a !== null && (a.visible = i !== null), l !== null && (l.visible = s1 !== null), c !== null && (c.visible = o !== null), this;
    }
    _getHandJoint(t, e) {
        if (t.joints[e.jointName] === void 0) {
            let r = new cn;
            r.matrixAutoUpdate = !1, r.visible = !1, t.joints[e.jointName] = r, t.add(r);
        }
        return t.joints[e.jointName];
    }
}, ps = class extends Zt {
    constructor(t, e, r, i, s1, o, a, l, c, u1){
        if (u1 = u1 !== void 0 ? u1 : Lc, u1 !== Lc && u1 !== xl) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        r === void 0 && u1 === Lc && (r = Gs), r === void 0 && u1 === xl && (r = gl), super(null, i, s1, o, a, l, u1, r, c), this.isDepthTexture = !0, this.image = {
            width: t,
            height: e
        }, this.magFilter = a !== void 0 ? a : vt, this.minFilter = l !== void 0 ? l : vt, this.flipY = !1, this.generateMipmaps = !1;
    }
}, nw = class extends ar {
    constructor(t, e){
        super();
        let r = this, i = null, s1 = 1, o = null, a = "local-floor", l = 1, c = null, u1 = null, h = null, d = null, f = null, m = null, p = e.getContextAttributes(), g = null, y = null, x = [], v = [], b = new Set, w = new Map, A = new si;
        A.layers.enable(1), A.viewport = new Ze;
        let T = new si;
        T.layers.enable(2), T.viewport = new Ze;
        let S = [
            A,
            T
        ], M = new iw;
        M.layers.enable(1), M.layers.enable(2);
        let C = null, P = null;
        this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(z) {
            let Q = x[z];
            return Q === void 0 && (Q = new Op, x[z] = Q), Q.getTargetRaySpace();
        }, this.getControllerGrip = function(z) {
            let Q = x[z];
            return Q === void 0 && (Q = new Op, x[z] = Q), Q.getGripSpace();
        }, this.getHand = function(z) {
            let Q = x[z];
            return Q === void 0 && (Q = new Op, x[z] = Q), Q.getHandSpace();
        };
        function _(z) {
            let Q = v.indexOf(z.inputSource);
            if (Q === -1) return;
            let te = x[Q];
            te !== void 0 && te.dispatchEvent({
                type: z.type,
                data: z.inputSource
            });
        }
        function I() {
            i.removeEventListener("select", _), i.removeEventListener("selectstart", _), i.removeEventListener("selectend", _), i.removeEventListener("squeeze", _), i.removeEventListener("squeezestart", _), i.removeEventListener("squeezeend", _), i.removeEventListener("end", I), i.removeEventListener("inputsourceschange", O);
            for(let z = 0; z < x.length; z++){
                let Q = v[z];
                Q !== null && (v[z] = null, x[z].disconnect(Q));
            }
            C = null, P = null, t.setRenderTarget(g), f = null, d = null, h = null, i = null, y = null, K.stop(), r.isPresenting = !1, r.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(z) {
            s1 = z, r.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        }, this.setReferenceSpaceType = function(z) {
            a = z, r.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        }, this.getReferenceSpace = function() {
            return c || o;
        }, this.setReferenceSpace = function(z) {
            c = z;
        }, this.getBaseLayer = function() {
            return d !== null ? d : f;
        }, this.getBinding = function() {
            return h;
        }, this.getFrame = function() {
            return m;
        }, this.getSession = function() {
            return i;
        }, this.setSession = async function(z) {
            if (i = z, i !== null) {
                if (g = t.getRenderTarget(), i.addEventListener("select", _), i.addEventListener("selectstart", _), i.addEventListener("selectend", _), i.addEventListener("squeeze", _), i.addEventListener("squeezestart", _), i.addEventListener("squeezeend", _), i.addEventListener("end", I), i.addEventListener("inputsourceschange", O), p.xrCompatible !== !0 && await e.makeXRCompatible(), i.renderState.layers === void 0 || t.capabilities.isWebGL2 === !1) {
                    let Q = {
                        antialias: i.renderState.layers === void 0 ? p.antialias : !0,
                        alpha: p.alpha,
                        depth: p.depth,
                        stencil: p.stencil,
                        framebufferScaleFactor: s1
                    };
                    f = new XRWebGLLayer(i, e, Q), i.updateRenderState({
                        baseLayer: f
                    }), y = new at(f.framebufferWidth, f.framebufferHeight, {
                        format: br,
                        type: Nr,
                        encoding: t.outputEncoding,
                        stencilBuffer: p.stencil
                    });
                } else {
                    let Q = null, te = null, $ = null;
                    p.depth && ($ = p.stencil ? 35056 : 33190, Q = p.stencil ? xl : Lc, te = p.stencil ? gl : Gs);
                    let W = {
                        colorFormat: 32856,
                        depthFormat: $,
                        scaleFactor: s1
                    };
                    h = new XRWebGLBinding(i, e), d = h.createProjectionLayer(W), i.updateRenderState({
                        layers: [
                            d
                        ]
                    }), y = new at(d.textureWidth, d.textureHeight, {
                        format: br,
                        type: Nr,
                        depthTexture: new ps(d.textureWidth, d.textureHeight, te, void 0, void 0, void 0, void 0, void 0, void 0, Q),
                        stencilBuffer: p.stencil,
                        encoding: t.outputEncoding,
                        samples: p.antialias ? 4 : 0
                    });
                    let oe = t.properties.get(y);
                    oe.__ignoreDepthValues = d.ignoreDepthValues;
                }
                y.isXRRenderTarget = !0, this.setFoveation(l), c = null, o = await i.requestReferenceSpace(a), K.setContext(i), K.start(), r.isPresenting = !0, r.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        function O(z) {
            for(let Q = 0; Q < z.removed.length; Q++){
                let te = z.removed[Q], $ = v.indexOf(te);
                $ >= 0 && (v[$] = null, x[$].disconnect(te));
            }
            for(let Q = 0; Q < z.added.length; Q++){
                let te = z.added[Q], $ = v.indexOf(te);
                if ($ === -1) {
                    for(let oe = 0; oe < x.length; oe++)if (oe >= v.length) {
                        v.push(te), $ = oe;
                        break;
                    } else if (v[oe] === null) {
                        v[oe] = te, $ = oe;
                        break;
                    }
                    if ($ === -1) break;
                }
                let W = x[$];
                W && W.connect(te);
            }
        }
        let L = new E, j = new E;
        function V(z, Q, te) {
            L.setFromMatrixPosition(Q.matrixWorld), j.setFromMatrixPosition(te.matrixWorld);
            let $ = L.distanceTo(j), W = Q.projectionMatrix.elements, oe = te.projectionMatrix.elements, ie = W[14] / (W[10] - 1), re = W[14] / (W[10] + 1), J = (W[9] + 1) / W[5], Ee = (W[9] - 1) / W[5], xe = (W[8] - 1) / W[0], de = (oe[8] + 1) / oe[0], De = ie * xe, Pe = ie * de, ze = $ / (-xe + de), ke = ze * -xe;
            Q.matrixWorld.decompose(z.position, z.quaternion, z.scale), z.translateX(ke), z.translateZ(ze), z.matrixWorld.compose(z.position, z.quaternion, z.scale), z.matrixWorldInverse.copy(z.matrixWorld).invert();
            let Ue = ie + ze, Le = re + ze, Qe = De - ke, F = Pe + ($ - ke), B = J * re / Le * Ue, N = Ee * re / Le * Ue;
            z.projectionMatrix.makePerspective(Qe, F, B, N, Ue, Le);
        }
        function H(z, Q) {
            Q === null ? z.matrixWorld.copy(z.matrix) : z.matrixWorld.multiplyMatrices(Q.matrixWorld, z.matrix), z.matrixWorldInverse.copy(z.matrixWorld).invert();
        }
        this.updateCamera = function(z) {
            if (i === null) return;
            M.near = T.near = A.near = z.near, M.far = T.far = A.far = z.far, (C !== M.near || P !== M.far) && (i.updateRenderState({
                depthNear: M.near,
                depthFar: M.far
            }), C = M.near, P = M.far);
            let Q = z.parent, te = M.cameras;
            H(M, Q);
            for(let W = 0; W < te.length; W++)H(te[W], Q);
            M.matrixWorld.decompose(M.position, M.quaternion, M.scale), z.matrix.copy(M.matrix), z.matrix.decompose(z.position, z.quaternion, z.scale);
            let $ = z.children;
            for(let W = 0, oe = $.length; W < oe; W++)$[W].updateMatrixWorld(!0);
            te.length === 2 ? V(M, A, T) : M.projectionMatrix.copy(A.projectionMatrix);
        }, this.getCamera = function() {
            return M;
        }, this.getFoveation = function() {
            if (!(d === null && f === null)) return l;
        }, this.setFoveation = function(z) {
            l = z, d !== null && (d.fixedFoveation = z), f !== null && f.fixedFoveation !== void 0 && (f.fixedFoveation = z);
        }, this.getPlanes = function() {
            return b;
        };
        let q = null;
        function X(z, Q) {
            if (u1 = Q.getViewerPose(c || o), m = Q, u1 !== null) {
                let te = u1.views;
                f !== null && (t.setRenderTargetFramebuffer(y, f.framebuffer), t.setRenderTarget(y));
                let $ = !1;
                te.length !== M.cameras.length && (M.cameras.length = 0, $ = !0);
                for(let W = 0; W < te.length; W++){
                    let oe = te[W], ie = null;
                    if (f !== null) ie = f.getViewport(oe);
                    else {
                        let J = h.getViewSubImage(d, oe);
                        ie = J.viewport, W === 0 && (t.setRenderTargetTextures(y, J.colorTexture, d.ignoreDepthValues ? void 0 : J.depthStencilTexture), t.setRenderTarget(y));
                    }
                    let re = S[W];
                    re === void 0 && (re = new si, re.layers.enable(W), re.viewport = new Ze, S[W] = re), re.matrix.fromArray(oe.transform.matrix), re.projectionMatrix.fromArray(oe.projectionMatrix), re.viewport.set(ie.x, ie.y, ie.width, ie.height), W === 0 && M.matrix.copy(re.matrix), $ === !0 && M.cameras.push(re);
                }
            }
            for(let te = 0; te < x.length; te++){
                let $ = v[te], W = x[te];
                $ !== null && W !== void 0 && W.update($, Q, c || o);
            }
            if (q && q(z, Q), Q.detectedPlanes) {
                r.dispatchEvent({
                    type: "planesdetected",
                    data: Q.detectedPlanes
                });
                let te = null;
                for (let $ of b)Q.detectedPlanes.has($) || (te === null && (te = []), te.push($));
                if (te !== null) for (let $ of te)b.delete($), w.delete($), r.dispatchEvent({
                    type: "planeremoved",
                    data: $
                });
                for (let $ of Q.detectedPlanes)if (!b.has($)) b.add($), w.set($, Q.lastChangedTime), r.dispatchEvent({
                    type: "planeadded",
                    data: $
                });
                else {
                    let W = w.get($);
                    $.lastChangedTime > W && (w.set($, $.lastChangedTime), r.dispatchEvent({
                        type: "planechanged",
                        data: $
                    }));
                }
            }
            m = null;
        }
        let K = new h_;
        K.setAnimationLoop(X), this.setAnimationLoop = function(z) {
            q = z;
        }, this.dispose = function() {};
    }
};
function Y5(n1, t) {
    function e(p, g) {
        g.color.getRGB(p.fogColor.value, u_(n1)), g.isFog ? (p.fogNear.value = g.near, p.fogFar.value = g.far) : g.isFogExp2 && (p.fogDensity.value = g.density);
    }
    function r(p, g, y, x, v) {
        g.isMeshBasicMaterial || g.isMeshLambertMaterial ? i(p, g) : g.isMeshToonMaterial ? (i(p, g), u1(p, g)) : g.isMeshPhongMaterial ? (i(p, g), c(p, g)) : g.isMeshStandardMaterial ? (i(p, g), h(p, g), g.isMeshPhysicalMaterial && d(p, g, v)) : g.isMeshMatcapMaterial ? (i(p, g), f(p, g)) : g.isMeshDepthMaterial ? i(p, g) : g.isMeshDistanceMaterial ? (i(p, g), m(p, g)) : g.isMeshNormalMaterial ? i(p, g) : g.isLineBasicMaterial ? (s1(p, g), g.isLineDashedMaterial && o(p, g)) : g.isPointsMaterial ? a(p, g, y, x) : g.isSpriteMaterial ? l(p, g) : g.isShadowMaterial ? (p.color.value.copy(g.color), p.opacity.value = g.opacity) : g.isShaderMaterial && (g.uniformsNeedUpdate = !1);
    }
    function i(p, g) {
        p.opacity.value = g.opacity, g.color && p.diffuse.value.copy(g.color), g.emissive && p.emissive.value.copy(g.emissive).multiplyScalar(g.emissiveIntensity), g.map && (p.map.value = g.map), g.alphaMap && (p.alphaMap.value = g.alphaMap), g.bumpMap && (p.bumpMap.value = g.bumpMap, p.bumpScale.value = g.bumpScale, g.side === xi && (p.bumpScale.value *= -1)), g.displacementMap && (p.displacementMap.value = g.displacementMap, p.displacementScale.value = g.displacementScale, p.displacementBias.value = g.displacementBias), g.emissiveMap && (p.emissiveMap.value = g.emissiveMap), g.normalMap && (p.normalMap.value = g.normalMap, p.normalScale.value.copy(g.normalScale), g.side === xi && p.normalScale.value.negate()), g.specularMap && (p.specularMap.value = g.specularMap), g.alphaTest > 0 && (p.alphaTest.value = g.alphaTest);
        let y = t.get(g).envMap;
        if (y && (p.envMap.value = y, p.flipEnvMap.value = y.isCubeTexture && y.isRenderTargetTexture === !1 ? -1 : 1, p.reflectivity.value = g.reflectivity, p.ior.value = g.ior, p.refractionRatio.value = g.refractionRatio), g.lightMap) {
            p.lightMap.value = g.lightMap;
            let b = n1.physicallyCorrectLights !== !0 ? Math.PI : 1;
            p.lightMapIntensity.value = g.lightMapIntensity * b;
        }
        g.aoMap && (p.aoMap.value = g.aoMap, p.aoMapIntensity.value = g.aoMapIntensity);
        let x;
        g.map ? x = g.map : g.specularMap ? x = g.specularMap : g.displacementMap ? x = g.displacementMap : g.normalMap ? x = g.normalMap : g.bumpMap ? x = g.bumpMap : g.roughnessMap ? x = g.roughnessMap : g.metalnessMap ? x = g.metalnessMap : g.alphaMap ? x = g.alphaMap : g.emissiveMap ? x = g.emissiveMap : g.clearcoatMap ? x = g.clearcoatMap : g.clearcoatNormalMap ? x = g.clearcoatNormalMap : g.clearcoatRoughnessMap ? x = g.clearcoatRoughnessMap : g.iridescenceMap ? x = g.iridescenceMap : g.iridescenceThicknessMap ? x = g.iridescenceThicknessMap : g.specularIntensityMap ? x = g.specularIntensityMap : g.specularColorMap ? x = g.specularColorMap : g.transmissionMap ? x = g.transmissionMap : g.thicknessMap ? x = g.thicknessMap : g.sheenColorMap ? x = g.sheenColorMap : g.sheenRoughnessMap && (x = g.sheenRoughnessMap), x !== void 0 && (x.isWebGLRenderTarget && (x = x.texture), x.matrixAutoUpdate === !0 && x.updateMatrix(), p.uvTransform.value.copy(x.matrix));
        let v;
        g.aoMap ? v = g.aoMap : g.lightMap && (v = g.lightMap), v !== void 0 && (v.isWebGLRenderTarget && (v = v.texture), v.matrixAutoUpdate === !0 && v.updateMatrix(), p.uv2Transform.value.copy(v.matrix));
    }
    function s1(p, g) {
        p.diffuse.value.copy(g.color), p.opacity.value = g.opacity;
    }
    function o(p, g) {
        p.dashSize.value = g.dashSize, p.totalSize.value = g.dashSize + g.gapSize, p.scale.value = g.scale;
    }
    function a(p, g, y, x) {
        p.diffuse.value.copy(g.color), p.opacity.value = g.opacity, p.size.value = g.size * y, p.scale.value = x * .5, g.map && (p.map.value = g.map), g.alphaMap && (p.alphaMap.value = g.alphaMap), g.alphaTest > 0 && (p.alphaTest.value = g.alphaTest);
        let v;
        g.map ? v = g.map : g.alphaMap && (v = g.alphaMap), v !== void 0 && (v.matrixAutoUpdate === !0 && v.updateMatrix(), p.uvTransform.value.copy(v.matrix));
    }
    function l(p, g) {
        p.diffuse.value.copy(g.color), p.opacity.value = g.opacity, p.rotation.value = g.rotation, g.map && (p.map.value = g.map), g.alphaMap && (p.alphaMap.value = g.alphaMap), g.alphaTest > 0 && (p.alphaTest.value = g.alphaTest);
        let y;
        g.map ? y = g.map : g.alphaMap && (y = g.alphaMap), y !== void 0 && (y.matrixAutoUpdate === !0 && y.updateMatrix(), p.uvTransform.value.copy(y.matrix));
    }
    function c(p, g) {
        p.specular.value.copy(g.specular), p.shininess.value = Math.max(g.shininess, 1e-4);
    }
    function u1(p, g) {
        g.gradientMap && (p.gradientMap.value = g.gradientMap);
    }
    function h(p, g) {
        p.roughness.value = g.roughness, p.metalness.value = g.metalness, g.roughnessMap && (p.roughnessMap.value = g.roughnessMap), g.metalnessMap && (p.metalnessMap.value = g.metalnessMap), t.get(g).envMap && (p.envMapIntensity.value = g.envMapIntensity);
    }
    function d(p, g, y) {
        p.ior.value = g.ior, g.sheen > 0 && (p.sheenColor.value.copy(g.sheenColor).multiplyScalar(g.sheen), p.sheenRoughness.value = g.sheenRoughness, g.sheenColorMap && (p.sheenColorMap.value = g.sheenColorMap), g.sheenRoughnessMap && (p.sheenRoughnessMap.value = g.sheenRoughnessMap)), g.clearcoat > 0 && (p.clearcoat.value = g.clearcoat, p.clearcoatRoughness.value = g.clearcoatRoughness, g.clearcoatMap && (p.clearcoatMap.value = g.clearcoatMap), g.clearcoatRoughnessMap && (p.clearcoatRoughnessMap.value = g.clearcoatRoughnessMap), g.clearcoatNormalMap && (p.clearcoatNormalScale.value.copy(g.clearcoatNormalScale), p.clearcoatNormalMap.value = g.clearcoatNormalMap, g.side === xi && p.clearcoatNormalScale.value.negate())), g.iridescence > 0 && (p.iridescence.value = g.iridescence, p.iridescenceIOR.value = g.iridescenceIOR, p.iridescenceThicknessMinimum.value = g.iridescenceThicknessRange[0], p.iridescenceThicknessMaximum.value = g.iridescenceThicknessRange[1], g.iridescenceMap && (p.iridescenceMap.value = g.iridescenceMap), g.iridescenceThicknessMap && (p.iridescenceThicknessMap.value = g.iridescenceThicknessMap)), g.transmission > 0 && (p.transmission.value = g.transmission, p.transmissionSamplerMap.value = y.texture, p.transmissionSamplerSize.value.set(y.width, y.height), g.transmissionMap && (p.transmissionMap.value = g.transmissionMap), p.thickness.value = g.thickness, g.thicknessMap && (p.thicknessMap.value = g.thicknessMap), p.attenuationDistance.value = g.attenuationDistance, p.attenuationColor.value.copy(g.attenuationColor)), p.specularIntensity.value = g.specularIntensity, p.specularColor.value.copy(g.specularColor), g.specularIntensityMap && (p.specularIntensityMap.value = g.specularIntensityMap), g.specularColorMap && (p.specularColorMap.value = g.specularColorMap);
    }
    function f(p, g) {
        g.matcap && (p.matcap.value = g.matcap);
    }
    function m(p, g) {
        p.referencePosition.value.copy(g.referencePosition), p.nearDistance.value = g.nearDistance, p.farDistance.value = g.farDistance;
    }
    return {
        refreshFogUniforms: e,
        refreshMaterialUniforms: r
    };
}
function K5(n1, t, e, r) {
    let i = {}, s1 = {}, o = [], a = e.isWebGL2 ? n1.getParameter(35375) : 0;
    function l(x, v) {
        let b = v.program;
        r.uniformBlockBinding(x, b);
    }
    function c(x, v) {
        let b = i[x.id];
        b === void 0 && (m(x), b = u1(x), i[x.id] = b, x.addEventListener("dispose", g));
        let w = v.program;
        r.updateUBOMapping(x, w);
        let A = t.render.frame;
        s1[x.id] !== A && (d(x), s1[x.id] = A);
    }
    function u1(x) {
        let v = h();
        x.__bindingPointIndex = v;
        let b = n1.createBuffer(), w = x.__size, A = x.usage;
        return n1.bindBuffer(35345, b), n1.bufferData(35345, w, A), n1.bindBuffer(35345, null), n1.bindBufferBase(35345, v, b), b;
    }
    function h() {
        for(let x = 0; x < a; x++)if (o.indexOf(x) === -1) return o.push(x), x;
        return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
    }
    function d(x) {
        let v = i[x.id], b = x.uniforms, w = x.__cache;
        n1.bindBuffer(35345, v);
        for(let A = 0, T = b.length; A < T; A++){
            let S = b[A];
            if (f(S, A, w) === !0) {
                let M = S.__offset, C = Array.isArray(S.value) ? S.value : [
                    S.value
                ], P = 0;
                for(let _ = 0; _ < C.length; _++){
                    let I = C[_], O = p(I);
                    typeof I == "number" ? (S.__data[0] = I, n1.bufferSubData(35345, M + P, S.__data)) : I.isMatrix3 ? (S.__data[0] = I.elements[0], S.__data[1] = I.elements[1], S.__data[2] = I.elements[2], S.__data[3] = I.elements[0], S.__data[4] = I.elements[3], S.__data[5] = I.elements[4], S.__data[6] = I.elements[5], S.__data[7] = I.elements[0], S.__data[8] = I.elements[6], S.__data[9] = I.elements[7], S.__data[10] = I.elements[8], S.__data[11] = I.elements[0]) : (I.toArray(S.__data, P), P += O.storage / Float32Array.BYTES_PER_ELEMENT);
                }
                n1.bufferSubData(35345, M, S.__data);
            }
        }
        n1.bindBuffer(35345, null);
    }
    function f(x, v, b) {
        let w = x.value;
        if (b[v] === void 0) {
            if (typeof w == "number") b[v] = w;
            else {
                let A = Array.isArray(w) ? w : [
                    w
                ], T = [];
                for(let S = 0; S < A.length; S++)T.push(A[S].clone());
                b[v] = T;
            }
            return !0;
        } else if (typeof w == "number") {
            if (b[v] !== w) return b[v] = w, !0;
        } else {
            let A = Array.isArray(b[v]) ? b[v] : [
                b[v]
            ], T = Array.isArray(w) ? w : [
                w
            ];
            for(let S = 0; S < A.length; S++){
                let M = A[S];
                if (M.equals(T[S]) === !1) return M.copy(T[S]), !0;
            }
        }
        return !1;
    }
    function m(x) {
        let v = x.uniforms, b = 0, w = 16, A = 0;
        for(let T = 0, S = v.length; T < S; T++){
            let M = v[T], C = {
                boundary: 0,
                storage: 0
            }, P = Array.isArray(M.value) ? M.value : [
                M.value
            ];
            for(let _ = 0, I = P.length; _ < I; _++){
                let O = P[_], L = p(O);
                C.boundary += L.boundary, C.storage += L.storage;
            }
            if (M.__data = new Float32Array(C.storage / Float32Array.BYTES_PER_ELEMENT), M.__offset = b, T > 0) {
                A = b % w;
                let _ = w - A;
                A !== 0 && _ - C.boundary < 0 && (b += w - A, M.__offset = b);
            }
            b += C.storage;
        }
        return A = b % w, A > 0 && (b += w - A), x.__size = b, x.__cache = {}, this;
    }
    function p(x) {
        let v = {
            boundary: 0,
            storage: 0
        };
        return typeof x == "number" ? (v.boundary = 4, v.storage = 4) : x.isVector2 ? (v.boundary = 8, v.storage = 8) : x.isVector3 || x.isColor ? (v.boundary = 16, v.storage = 12) : x.isVector4 ? (v.boundary = 16, v.storage = 16) : x.isMatrix3 ? (v.boundary = 48, v.storage = 48) : x.isMatrix4 ? (v.boundary = 64, v.storage = 64) : x.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", x), v;
    }
    function g(x) {
        let v = x.target;
        v.removeEventListener("dispose", g);
        let b = o.indexOf(v.__bindingPointIndex);
        o.splice(b, 1), n1.deleteBuffer(i[v.id]), delete i[v.id], delete s1[v.id];
    }
    function y() {
        for(let x in i)n1.deleteBuffer(i[x]);
        o = [], i = {}, s1 = {};
    }
    return {
        bind: l,
        update: c,
        dispose: y
    };
}
function Q5() {
    let n1 = Fp("canvas");
    return n1.style.display = "block", n1;
}
function Iw(n1 = {}) {
    this.isWebGLRenderer = !0;
    let t = n1.canvas !== void 0 ? n1.canvas : Q5(), e = n1.context !== void 0 ? n1.context : null, r = n1.depth !== void 0 ? n1.depth : !0, i = n1.stencil !== void 0 ? n1.stencil : !0, s1 = n1.antialias !== void 0 ? n1.antialias : !1, o = n1.premultipliedAlpha !== void 0 ? n1.premultipliedAlpha : !0, a = n1.preserveDrawingBuffer !== void 0 ? n1.preserveDrawingBuffer : !1, l = n1.powerPreference !== void 0 ? n1.powerPreference : "default", c = n1.failIfMajorPerformanceCaveat !== void 0 ? n1.failIfMajorPerformanceCaveat : !1, u1;
    e !== null ? u1 = e.getContextAttributes().alpha : u1 = n1.alpha !== void 0 ? n1.alpha : !1;
    let h = null, d = null, f = [], m = [];
    this.domElement = t, this.debug = {
        checkShaderErrors: !0
    }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.outputEncoding = xn, this.physicallyCorrectLights = !1, this.toneMapping = js, this.toneMappingExposure = 1;
    let p = this, g = !1, y = 0, x = 0, v = null, b = -1, w = null, A = new Ze, T = new Ze, S = null, M = t.width, C = t.height, P = 1, _ = null, I = null, O = new Ze(0, 0, M, C), L = new Ze(0, 0, M, C), j = !1, V = new Up, H = !1, q = !1, X = null, K = new ue, z = new U, Q = new E, te = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: !0
    };
    function $() {
        return v === null ? P : 1;
    }
    let W = e;
    function oe(G, le) {
        for(let ge = 0; ge < G.length; ge++){
            let ne = G[ge], be = t.getContext(ne, le);
            if (be !== null) return be;
        }
        return null;
    }
    try {
        let G = {
            alpha: !0,
            depth: r,
            stencil: i,
            antialias: s1,
            premultipliedAlpha: o,
            preserveDrawingBuffer: a,
            powerPreference: l,
            failIfMajorPerformanceCaveat: c
        };
        if ("setAttribute" in t && t.setAttribute("data-engine", `three.js r${Pa}`), t.addEventListener("webglcontextlost", tt, !1), t.addEventListener("webglcontextrestored", ot, !1), t.addEventListener("webglcontextcreationerror", Gt, !1), W === null) {
            let le = [
                "webgl2",
                "webgl",
                "experimental-webgl"
            ];
            if (p.isWebGL1Renderer === !0 && le.shift(), W = oe(le, G), W === null) throw oe(le) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
        }
        W.getShaderPrecisionFormat === void 0 && (W.getShaderPrecisionFormat = function() {
            return {
                rangeMin: 1,
                rangeMax: 1,
                precision: 1
            };
        });
    } catch (G) {
        throw console.error("THREE.WebGLRenderer: " + G.message), G;
    }
    let ie, re, J, Ee, xe, de, De, Pe, ze, ke, Ue, Le, Qe, F, B, N, ae, ye, me, Ne, Fe, Oe, pe, nt;
    function We() {
        ie = new y4(W), re = new h4(W, ie, n1), ie.init(re), Oe = new q5(W, ie, re), J = new H5(W, ie, re), Ee = new b4, xe = new O5, de = new W5(W, ie, J, xe, re, Oe, Ee), De = new f4(p), Pe = new g4(p), ze = new _k(W, re), pe = new c4(W, ie, ze, re), ke = new v4(W, ze, Ee, pe), Ue = new E4(W, ke, ze, Ee), me = new A4(W, re, de), N = new d4(xe), Le = new D5(p, De, Pe, ie, re, pe, N), Qe = new Y5(p, xe), F = new L5, B = new k5(ie, re), ye = new l4(p, De, Pe, J, Ue, u1, o), ae = new j5(p, Ue, re), nt = new K5(W, Ee, re, J), Ne = new u4(W, ie, Ee, re), Fe = new x4(W, ie, Ee, re), Ee.programs = Le.programs, p.capabilities = re, p.extensions = ie, p.properties = xe, p.renderLists = F, p.shadowMap = ae, p.state = J, p.info = Ee;
    }
    We();
    let Be = new nw(p, W);
    this.xr = Be, this.getContext = function() {
        return W;
    }, this.getContextAttributes = function() {
        return W.getContextAttributes();
    }, this.forceContextLoss = function() {
        let G = ie.get("WEBGL_lose_context");
        G && G.loseContext();
    }, this.forceContextRestore = function() {
        let G = ie.get("WEBGL_lose_context");
        G && G.restoreContext();
    }, this.getPixelRatio = function() {
        return P;
    }, this.setPixelRatio = function(G) {
        G !== void 0 && (P = G, this.setSize(M, C, !1));
    }, this.getSize = function(G) {
        return G.set(M, C);
    }, this.setSize = function(G, le, ge) {
        if (Be.isPresenting) {
            console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
            return;
        }
        M = G, C = le, t.width = Math.floor(G * P), t.height = Math.floor(le * P), ge !== !1 && (t.style.width = G + "px", t.style.height = le + "px"), this.setViewport(0, 0, G, le);
    }, this.getDrawingBufferSize = function(G) {
        return G.set(M * P, C * P).floor();
    }, this.setDrawingBufferSize = function(G, le, ge) {
        M = G, C = le, P = ge, t.width = Math.floor(G * ge), t.height = Math.floor(le * ge), this.setViewport(0, 0, G, le);
    }, this.getCurrentViewport = function(G) {
        return G.copy(A);
    }, this.getViewport = function(G) {
        return G.copy(O);
    }, this.setViewport = function(G, le, ge, ne) {
        G.isVector4 ? O.set(G.x, G.y, G.z, G.w) : O.set(G, le, ge, ne), J.viewport(A.copy(O).multiplyScalar(P).floor());
    }, this.getScissor = function(G) {
        return G.copy(L);
    }, this.setScissor = function(G, le, ge, ne) {
        G.isVector4 ? L.set(G.x, G.y, G.z, G.w) : L.set(G, le, ge, ne), J.scissor(T.copy(L).multiplyScalar(P).floor());
    }, this.getScissorTest = function() {
        return j;
    }, this.setScissorTest = function(G) {
        J.setScissorTest(j = G);
    }, this.setOpaqueSort = function(G) {
        _ = G;
    }, this.setTransparentSort = function(G) {
        I = G;
    }, this.getClearColor = function(G) {
        return G.copy(ye.getClearColor());
    }, this.setClearColor = function() {
        ye.setClearColor.apply(ye, arguments);
    }, this.getClearAlpha = function() {
        return ye.getClearAlpha();
    }, this.setClearAlpha = function() {
        ye.setClearAlpha.apply(ye, arguments);
    }, this.clear = function(G = !0, le = !0, ge = !0) {
        let ne = 0;
        G && (ne |= 16384), le && (ne |= 256), ge && (ne |= 1024), W.clear(ne);
    }, this.clearColor = function() {
        this.clear(!0, !1, !1);
    }, this.clearDepth = function() {
        this.clear(!1, !0, !1);
    }, this.clearStencil = function() {
        this.clear(!1, !1, !0);
    }, this.dispose = function() {
        t.removeEventListener("webglcontextlost", tt, !1), t.removeEventListener("webglcontextrestored", ot, !1), t.removeEventListener("webglcontextcreationerror", Gt, !1), F.dispose(), B.dispose(), xe.dispose(), De.dispose(), Pe.dispose(), Ue.dispose(), pe.dispose(), nt.dispose(), Le.dispose(), Be.dispose(), Be.removeEventListener("sessionstart", qe), Be.removeEventListener("sessionend", Xe), X && (X.dispose(), X = null), Rt.stop();
    };
    function tt(G) {
        G.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), g = !0;
    }
    function ot() {
        console.log("THREE.WebGLRenderer: Context Restored."), g = !1;
        let G = Ee.autoReset, le = ae.enabled, ge = ae.autoUpdate, ne = ae.needsUpdate, be = ae.type;
        We(), Ee.autoReset = G, ae.enabled = le, ae.autoUpdate = ge, ae.needsUpdate = ne, ae.type = be;
    }
    function Gt(G) {
        console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", G.statusMessage);
    }
    function xr(G) {
        let le = G.target;
        le.removeEventListener("dispose", xr), Ir(le);
    }
    function Ir(G) {
        Z(G), xe.remove(G);
    }
    function Z(G) {
        let le = xe.get(G).programs;
        le !== void 0 && (le.forEach(function(ge) {
            Le.releaseProgram(ge);
        }), G.isShaderMaterial && Le.releaseShaderCache(G));
    }
    this.renderBufferDirect = function(G, le, ge, ne, be, st) {
        le === null && (le = te);
        let pt = be.isMesh && be.matrixWorld.determinant() < 0, St = J1(G, le, ge, ne, be);
        J.setMaterial(ne, pt);
        let Et = ge.index, jt = 1;
        ne.wireframe === !0 && (Et = ke.getWireframeAttribute(ge), jt = 2);
        let Lt = ge.drawRange, Tt = ge.attributes.position, Nt = Lt.start * jt, Mi = (Lt.start + Lt.count) * jt;
        st !== null && (Nt = Math.max(Nt, st.start * jt), Mi = Math.min(Mi, (st.start + st.count) * jt)), Et !== null ? (Nt = Math.max(Nt, 0), Mi = Math.min(Mi, Et.count)) : Tt != null && (Nt = Math.max(Nt, 0), Mi = Math.min(Mi, Tt.count));
        let an = Mi - Nt;
        if (an < 0 || an === 1 / 0) return;
        pe.setup(be, ne, St, ge, Et);
        let So, xt = Ne;
        if (Et !== null && (So = ze.get(Et), xt = Fe, xt.setIndex(So)), be.isMesh) ne.wireframe === !0 ? (J.setLineWidth(ne.wireframeLinewidth * $()), xt.setMode(1)) : xt.setMode(4);
        else if (be.isLine) {
            let Vt = ne.linewidth;
            Vt === void 0 && (Vt = 1), J.setLineWidth(Vt * $()), be.isLineSegments ? xt.setMode(1) : be.isLineLoop ? xt.setMode(2) : xt.setMode(3);
        } else be.isPoints ? xt.setMode(0) : be.isSprite && xt.setMode(4);
        if (be.isInstancedMesh) xt.renderInstances(Nt, an, be.count);
        else if (ge.isInstancedBufferGeometry) {
            let Vt = ge._maxInstanceCount !== void 0 ? ge._maxInstanceCount : 1 / 0, Iu = Math.min(ge.instanceCount, Vt);
            xt.renderInstances(Nt, an, Iu);
        } else xt.render(Nt, an);
    }, this.compile = function(G, le) {
        function ge(ne, be, st) {
            ne.transparent === !0 && ne.side === vi && ne.forceSinglePass === !1 ? (ne.side = xi, ne.needsUpdate = !0, Rn(ne, be, st), ne.side = Jn, ne.needsUpdate = !0, Rn(ne, be, st), ne.side = vi) : Rn(ne, be, st);
        }
        d = B.get(G), d.init(), m.push(d), G.traverseVisible(function(ne) {
            ne.isLight && ne.layers.test(le.layers) && (d.pushLight(ne), ne.castShadow && d.pushShadow(ne));
        }), d.setupLights(p.physicallyCorrectLights), G.traverse(function(ne) {
            let be = ne.material;
            if (be) {
                if (Array.isArray(be)) for(let st = 0; st < be.length; st++){
                    let pt = be[st];
                    ge(pt, G, ne);
                }
                else ge(be, G, ne);
            }
        }), m.pop(), d = null;
    };
    let ve = null;
    function Me(G) {
        ve && ve(G);
    }
    function qe() {
        Rt.stop();
    }
    function Xe() {
        Rt.start();
    }
    let Rt = new h_;
    Rt.setAnimationLoop(Me), typeof self < "u" && Rt.setContext(self), this.setAnimationLoop = function(G) {
        ve = G, Be.setAnimationLoop(G), G === null ? Rt.stop() : Rt.start();
    }, Be.addEventListener("sessionstart", qe), Be.addEventListener("sessionend", Xe), this.render = function(G, le) {
        if (le !== void 0 && le.isCamera !== !0) {
            console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
            return;
        }
        if (g === !0) return;
        G.matrixWorldAutoUpdate === !0 && G.updateMatrixWorld(), le.parent === null && le.matrixWorldAutoUpdate === !0 && le.updateMatrixWorld(), Be.enabled === !0 && Be.isPresenting === !0 && (Be.cameraAutoUpdate === !0 && Be.updateCamera(le), le = Be.getCamera()), G.isScene === !0 && G.onBeforeRender(p, G, le, v), d = B.get(G, m.length), d.init(), m.push(d), K.multiplyMatrices(le.projectionMatrix, le.matrixWorldInverse), V.setFromProjectionMatrix(K), q = this.localClippingEnabled, H = N.init(this.clippingPlanes, q), h = F.get(G, f.length), h.init(), f.push(h), Hr(G, le, 0, p.sortObjects), h.finish(), p.sortObjects === !0 && h.sort(_, I), H === !0 && N.beginShadows();
        let ge = d.state.shadowsArray;
        if (ae.render(ge, G, le), H === !0 && N.endShadows(), this.info.autoReset === !0 && this.info.reset(), ye.render(h, G), d.setupLights(p.physicallyCorrectLights), le.isArrayCamera) {
            let ne = le.cameras;
            for(let be = 0, st = ne.length; be < st; be++){
                let pt = ne[be];
                Wr(h, G, pt, pt.viewport);
            }
        } else Wr(h, G, le);
        v !== null && (de.updateMultisampleRenderTarget(v), de.updateRenderTargetMipmap(v)), G.isScene === !0 && G.onAfterRender(p, G, le), pe.resetDefaultState(), b = -1, w = null, m.pop(), m.length > 0 ? d = m[m.length - 1] : d = null, f.pop(), f.length > 0 ? h = f[f.length - 1] : h = null;
    };
    function Hr(G, le, ge, ne) {
        if (G.visible === !1) return;
        if (G.layers.test(le.layers)) {
            if (G.isGroup) ge = G.renderOrder;
            else if (G.isLOD) G.autoUpdate === !0 && G.update(le);
            else if (G.isLight) d.pushLight(G), G.castShadow && d.pushShadow(G);
            else if (G.isSprite) {
                if (!G.frustumCulled || V.intersectsSprite(G)) {
                    ne && Q.setFromMatrixPosition(G.matrixWorld).applyMatrix4(K);
                    let pt = Ue.update(G), St = G.material;
                    St.visible && h.push(G, pt, St, ge, Q.z, null);
                }
            } else if ((G.isMesh || G.isLine || G.isPoints) && (G.isSkinnedMesh && G.skeleton.frame !== Ee.render.frame && (G.skeleton.update(), G.skeleton.frame = Ee.render.frame), !G.frustumCulled || V.intersectsObject(G))) {
                ne && Q.setFromMatrixPosition(G.matrixWorld).applyMatrix4(K);
                let pt = Ue.update(G), St = G.material;
                if (Array.isArray(St)) {
                    let Et = pt.groups;
                    for(let jt = 0, Lt = Et.length; jt < Lt; jt++){
                        let Tt = Et[jt], Nt = St[Tt.materialIndex];
                        Nt && Nt.visible && h.push(G, pt, Nt, ge, Q.z, Tt);
                    }
                } else St.visible && h.push(G, pt, St, ge, Q.z, null);
            }
        }
        let st = G.children;
        for(let pt = 0, St = st.length; pt < St; pt++)Hr(st[pt], le, ge, ne);
    }
    function Wr(G, le, ge, ne) {
        let be = G.opaque, st = G.transmissive, pt = G.transparent;
        d.setupLightsView(ge), H === !0 && N.setGlobalState(p.clippingPlanes, ge), st.length > 0 && va(be, le, ge), ne && J.viewport(A.copy(ne)), be.length > 0 && Dr(be, le, ge), st.length > 0 && Dr(st, le, ge), pt.length > 0 && Dr(pt, le, ge), J.buffers.depth.setTest(!0), J.buffers.depth.setMask(!0), J.buffers.color.setMask(!0), J.setPolygonOffset(!1);
    }
    function va(G, le, ge) {
        let ne = re.isWebGL2;
        X === null && (X = new at(1, 1, {
            generateMipmaps: !0,
            type: ie.has("EXT_color_buffer_half_float") ? $n : Nr,
            minFilter: Bc,
            samples: ne && s1 === !0 ? 4 : 0
        })), p.getDrawingBufferSize(z), ne ? X.setSize(z.x, z.y) : X.setSize(Fy(z.x), Fy(z.y));
        let be = p.getRenderTarget();
        p.setRenderTarget(X), p.clear();
        let st = p.toneMapping;
        p.toneMapping = js, Dr(G, le, ge), p.toneMapping = st, de.updateMultisampleRenderTarget(X), de.updateRenderTargetMipmap(X), p.setRenderTarget(be);
    }
    function Dr(G, le, ge) {
        let ne = le.isScene === !0 ? le.overrideMaterial : null;
        for(let be = 0, st = G.length; be < st; be++){
            let pt = G[be], St = pt.object, Et = pt.geometry, jt = ne === null ? pt.material : ne, Lt = pt.group;
            St.layers.test(ge.layers) && us(St, le, ge, Et, jt, Lt);
        }
    }
    function us(G, le, ge, ne, be, st) {
        G.onBeforeRender(p, le, ge, ne, be, st), G.modelViewMatrix.multiplyMatrices(ge.matrixWorldInverse, G.matrixWorld), G.normalMatrix.getNormalMatrix(G.modelViewMatrix), be.onBeforeRender(p, le, ge, ne, G, st), be.transparent === !0 && be.side === vi && be.forceSinglePass === !1 ? (be.side = xi, be.needsUpdate = !0, p.renderBufferDirect(ge, le, ne, be, G, st), be.side = Jn, be.needsUpdate = !0, p.renderBufferDirect(ge, le, ne, be, G, st), be.side = vi) : p.renderBufferDirect(ge, le, ne, be, G, st), G.onAfterRender(p, le, ge, ne, be, st);
    }
    function Rn(G, le, ge) {
        le.isScene !== !0 && (le = te);
        let ne = xe.get(G), be = d.state.lights, st = d.state.shadowsArray, pt = be.state.version, St = Le.getParameters(G, be.state, st, le, ge), Et = Le.getProgramCacheKey(St), jt = ne.programs;
        ne.environment = G.isMeshStandardMaterial ? le.environment : null, ne.fog = le.fog, ne.envMap = (G.isMeshStandardMaterial ? Pe : De).get(G.envMap || ne.environment), jt === void 0 && (G.addEventListener("dispose", xr), jt = new Map, ne.programs = jt);
        let Lt = jt.get(Et);
        if (Lt !== void 0) {
            if (ne.currentProgram === Lt && ne.lightsStateVersion === pt) return vp(G, St), Lt;
        } else St.uniforms = Le.getUniforms(G), G.onBuild(ge, St, p), G.onBeforeCompile(St, p), Lt = Le.acquireProgram(St, Et), jt.set(Et, Lt), ne.uniforms = St.uniforms;
        let Tt = ne.uniforms;
        (!G.isShaderMaterial && !G.isRawShaderMaterial || G.clipping === !0) && (Tt.clippingPlanes = N.uniform), vp(G, St), ne.needsLights = eS(G), ne.lightsStateVersion = pt, ne.needsLights && (Tt.ambientLightColor.value = be.state.ambient, Tt.lightProbe.value = be.state.probe, Tt.directionalLights.value = be.state.directional, Tt.directionalLightShadows.value = be.state.directionalShadow, Tt.spotLights.value = be.state.spot, Tt.spotLightShadows.value = be.state.spotShadow, Tt.rectAreaLights.value = be.state.rectArea, Tt.ltc_1.value = be.state.rectAreaLTC1, Tt.ltc_2.value = be.state.rectAreaLTC2, Tt.pointLights.value = be.state.point, Tt.pointLightShadows.value = be.state.pointShadow, Tt.hemisphereLights.value = be.state.hemi, Tt.directionalShadowMap.value = be.state.directionalShadowMap, Tt.directionalShadowMatrix.value = be.state.directionalShadowMatrix, Tt.spotShadowMap.value = be.state.spotShadowMap, Tt.spotLightMatrix.value = be.state.spotLightMatrix, Tt.spotLightMap.value = be.state.spotLightMap, Tt.pointShadowMap.value = be.state.pointShadowMap, Tt.pointShadowMatrix.value = be.state.pointShadowMatrix);
        let Nt = Lt.getUniforms(), Mi = $u.seqWithValue(Nt.seq, Tt);
        return ne.currentProgram = Lt, ne.uniformsList = Mi, Lt;
    }
    function vp(G, le) {
        let ge = xe.get(G);
        ge.outputEncoding = le.outputEncoding, ge.instancing = le.instancing, ge.skinning = le.skinning, ge.morphTargets = le.morphTargets, ge.morphNormals = le.morphNormals, ge.morphColors = le.morphColors, ge.morphTargetsCount = le.morphTargetsCount, ge.numClippingPlanes = le.numClippingPlanes, ge.numIntersection = le.numClipIntersection, ge.vertexAlphas = le.vertexAlphas, ge.vertexTangents = le.vertexTangents, ge.toneMapping = le.toneMapping;
    }
    function J1(G, le, ge, ne, be) {
        le.isScene !== !0 && (le = te), de.resetTextureUnits();
        let st = le.fog, pt = ne.isMeshStandardMaterial ? le.environment : null, St = v === null ? p.outputEncoding : v.isXRRenderTarget === !0 ? v.texture.encoding : xn, Et = (ne.isMeshStandardMaterial ? Pe : De).get(ne.envMap || pt), jt = ne.vertexColors === !0 && !!ge.attributes.color && ge.attributes.color.itemSize === 4, Lt = !!ne.normalMap && !!ge.attributes.tangent, Tt = !!ge.morphAttributes.position, Nt = !!ge.morphAttributes.normal, Mi = !!ge.morphAttributes.color, an = ne.toneMapped ? p.toneMapping : js, So = ge.morphAttributes.position || ge.morphAttributes.normal || ge.morphAttributes.color, xt = So !== void 0 ? So.length : 0, Vt = xe.get(ne), Iu = d.state.lights;
        if (H === !0 && (q === !0 || G !== w)) {
            let mi = G === w && ne.id === b;
            N.setState(ne, G, mi);
        }
        let pi = !1;
        ne.version === Vt.__version ? (Vt.needsLights && Vt.lightsStateVersion !== Iu.state.version || Vt.outputEncoding !== St || be.isInstancedMesh && Vt.instancing === !1 || !be.isInstancedMesh && Vt.instancing === !0 || be.isSkinnedMesh && Vt.skinning === !1 || !be.isSkinnedMesh && Vt.skinning === !0 || Vt.envMap !== Et || ne.fog === !0 && Vt.fog !== st || Vt.numClippingPlanes !== void 0 && (Vt.numClippingPlanes !== N.numPlanes || Vt.numIntersection !== N.numIntersection) || Vt.vertexAlphas !== jt || Vt.vertexTangents !== Lt || Vt.morphTargets !== Tt || Vt.morphNormals !== Nt || Vt.morphColors !== Mi || Vt.toneMapping !== an || re.isWebGL2 === !0 && Vt.morphTargetsCount !== xt) && (pi = !0) : (pi = !0, Vt.__version = ne.version);
        let wo = Vt.currentProgram;
        pi === !0 && (wo = Rn(ne, le, be));
        let Du = !1, Kn = !1, It = !1, Ci = wo.getUniforms(), hs = Vt.uniforms;
        if (J.useProgram(wo.program) && (Du = !0, Kn = !0, It = !0), ne.id !== b && (b = ne.id, Kn = !0), Du || w !== G) {
            if (Ci.setValue(W, "projectionMatrix", G.projectionMatrix), re.logarithmicDepthBuffer && Ci.setValue(W, "logDepthBufFC", 2 / (Math.log(G.far + 1) / Math.LN2)), w !== G && (w = G, Kn = !0, It = !0), ne.isShaderMaterial || ne.isMeshPhongMaterial || ne.isMeshToonMaterial || ne.isMeshStandardMaterial || ne.envMap) {
                let mi = Ci.map.cameraPosition;
                mi !== void 0 && mi.setValue(W, Q.setFromMatrixPosition(G.matrixWorld));
            }
            (ne.isMeshPhongMaterial || ne.isMeshToonMaterial || ne.isMeshLambertMaterial || ne.isMeshBasicMaterial || ne.isMeshStandardMaterial || ne.isShaderMaterial) && Ci.setValue(W, "isOrthographic", G.isOrthographicCamera === !0), (ne.isMeshPhongMaterial || ne.isMeshToonMaterial || ne.isMeshLambertMaterial || ne.isMeshBasicMaterial || ne.isMeshStandardMaterial || ne.isShaderMaterial || ne.isShadowMaterial || be.isSkinnedMesh) && Ci.setValue(W, "viewMatrix", G.matrixWorldInverse);
        }
        if (be.isSkinnedMesh) {
            Ci.setOptional(W, be, "bindMatrix"), Ci.setOptional(W, be, "bindMatrixInverse");
            let mi = be.skeleton;
            mi && (re.floatVertexTextures ? (mi.boneTexture === null && mi.computeBoneTexture(), Ci.setValue(W, "boneTexture", mi.boneTexture, de), Ci.setValue(W, "boneTextureSize", mi.boneTextureSize)) : console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."));
        }
        let Ou = ge.morphAttributes;
        if ((Ou.position !== void 0 || Ou.normal !== void 0 || Ou.color !== void 0 && re.isWebGL2 === !0) && me.update(be, ge, ne, wo), (Kn || Vt.receiveShadow !== be.receiveShadow) && (Vt.receiveShadow = be.receiveShadow, Ci.setValue(W, "receiveShadow", be.receiveShadow)), ne.isMeshGouraudMaterial && ne.envMap !== null && (hs.envMap.value = Et, hs.flipEnvMap.value = Et.isCubeTexture && Et.isRenderTargetTexture === !1 ? -1 : 1), Kn && (Ci.setValue(W, "toneMappingExposure", p.toneMappingExposure), Vt.needsLights && $1(hs, It), st && ne.fog === !0 && Qe.refreshFogUniforms(hs, st), Qe.refreshMaterialUniforms(hs, ne, P, C, X), $u.upload(W, Vt.uniformsList, hs, de)), ne.isShaderMaterial && ne.uniformsNeedUpdate === !0 && ($u.upload(W, Vt.uniformsList, hs, de), ne.uniformsNeedUpdate = !1), ne.isSpriteMaterial && Ci.setValue(W, "center", be.center), Ci.setValue(W, "modelViewMatrix", be.modelViewMatrix), Ci.setValue(W, "normalMatrix", be.normalMatrix), Ci.setValue(W, "modelMatrix", be.matrixWorld), be.previousModelViewMatrix && Ci.setValue(W, "previousModelViewMatrix", be.previousModelViewMatrix), G.previousProjectionMatrix && Ci.setValue(W, "previousProjectionMatrix", G.previousProjectionMatrix), ne.isShaderMaterial || ne.isRawShaderMaterial) {
            let mi = ne.uniformsGroups;
            for(let D = 0, R = mi.length; D < R; D++)if (re.isWebGL2) {
                let Y = mi[D];
                nt.update(Y, wo), nt.bind(Y, wo);
            } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
        }
        return wo;
    }
    function $1(G, le) {
        G.ambientLightColor.needsUpdate = le, G.lightProbe.needsUpdate = le, G.directionalLights.needsUpdate = le, G.directionalLightShadows.needsUpdate = le, G.pointLights.needsUpdate = le, G.pointLightShadows.needsUpdate = le, G.spotLights.needsUpdate = le, G.spotLightShadows.needsUpdate = le, G.rectAreaLights.needsUpdate = le, G.hemisphereLights.needsUpdate = le;
    }
    function eS(G) {
        return G.isMeshLambertMaterial || G.isMeshToonMaterial || G.isMeshPhongMaterial || G.isMeshStandardMaterial || G.isShadowMaterial || G.isShaderMaterial && G.lights === !0;
    }
    this.getActiveCubeFace = function() {
        return y;
    }, this.getActiveMipmapLevel = function() {
        return x;
    }, this.getRenderTarget = function() {
        return v;
    }, this.setRenderTargetTextures = function(G, le, ge) {
        xe.get(G.texture).__webglTexture = le, xe.get(G.depthTexture).__webglTexture = ge;
        let ne = xe.get(G);
        ne.__hasExternalTextures = !0, ne.__hasExternalTextures && (ne.__autoAllocateDepthBuffer = ge === void 0, ne.__autoAllocateDepthBuffer || ie.has("WEBGL_multisampled_render_to_texture") === !0 && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), ne.__useRenderToTexture = !1));
    }, this.setRenderTargetFramebuffer = function(G, le) {
        let ge = xe.get(G);
        ge.__webglFramebuffer = le, ge.__useDefaultFramebuffer = le === void 0;
    }, this.setRenderTarget = function(G, le = 0, ge = 0) {
        v = G, y = le, x = ge;
        let ne = !0, be = null, st = !1, pt = !1;
        if (G) {
            let Et = xe.get(G);
            Et.__useDefaultFramebuffer !== void 0 ? (J.bindFramebuffer(36160, null), ne = !1) : Et.__webglFramebuffer === void 0 ? de.setupRenderTarget(G) : Et.__hasExternalTextures && de.rebindTextures(G, xe.get(G.texture).__webglTexture, xe.get(G.depthTexture).__webglTexture);
            let jt = G.texture;
            (jt.isData3DTexture || jt.isDataArrayTexture || jt.isCompressedArrayTexture) && (pt = !0);
            let Lt = xe.get(G).__webglFramebuffer;
            G.isWebGLCubeRenderTarget ? (be = Lt[le], st = !0) : re.isWebGL2 && G.samples > 0 && de.useMultisampledRTT(G) === !1 ? be = xe.get(G).__webglMultisampledFramebuffer : be = Lt, A.copy(G.viewport), T.copy(G.scissor), S = G.scissorTest;
        } else A.copy(O).multiplyScalar(P).floor(), T.copy(L).multiplyScalar(P).floor(), S = j;
        if (J.bindFramebuffer(36160, be) && re.drawBuffers && ne && J.drawBuffers(G, be), J.viewport(A), J.scissor(T), J.setScissorTest(S), st) {
            let Et = xe.get(G.texture);
            W.framebufferTexture2D(36160, 36064, 34069 + le, Et.__webglTexture, ge);
        } else if (pt) {
            let Et = xe.get(G.texture), jt = le || 0;
            W.framebufferTextureLayer(36160, 36064, Et.__webglTexture, ge || 0, jt);
        }
        b = -1;
    }, this.readRenderTargetPixels = function(G, le, ge, ne, be, st, pt) {
        if (!(G && G.isWebGLRenderTarget)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            return;
        }
        let St = xe.get(G).__webglFramebuffer;
        if (G.isWebGLCubeRenderTarget && pt !== void 0 && (St = St[pt]), St) {
            J.bindFramebuffer(36160, St);
            try {
                let Et = G.texture, jt = Et.format, Lt = Et.type;
                if (jt !== br && Oe.convert(jt) !== W.getParameter(35739)) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                    return;
                }
                let Tt = Lt === $n && (ie.has("EXT_color_buffer_half_float") || re.isWebGL2 && ie.has("EXT_color_buffer_float"));
                if (Lt !== Nr && Oe.convert(Lt) !== W.getParameter(35738) && !(Lt === Ut && (re.isWebGL2 || ie.has("OES_texture_float") || ie.has("WEBGL_color_buffer_float"))) && !Tt) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                    return;
                }
                le >= 0 && le <= G.width - ne && ge >= 0 && ge <= G.height - be && W.readPixels(le, ge, ne, be, Oe.convert(jt), Oe.convert(Lt), st);
            } finally{
                let Et = v !== null ? xe.get(v).__webglFramebuffer : null;
                J.bindFramebuffer(36160, Et);
            }
        }
    }, this.readRenderTargetPixelsAsync = async function(G, le, ge, ne, be, st, pt) {
        if (!(G && G.isWebGLRenderTarget)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
        let St = xe.get(G).__webglFramebuffer;
        if (G.isWebGLCubeRenderTarget && pt !== void 0 && (St = St[pt]), St) {
            let Et = G.texture, jt = Et.format, Lt = Et.type;
            if (le >= 0 && le <= G.width - ne && ge >= 0 && ge <= G.height - be) {
                J.bindFramebuffer(W.FRAMEBUFFER, St);
                let Tt = W.createBuffer();
                W.bindBuffer(W.PIXEL_PACK_BUFFER, Tt), W.bufferData(W.PIXEL_PACK_BUFFER, st.byteLength, W.STREAM_READ), W.readPixels(le, ge, ne, be, Oe.convert(jt), Oe.convert(Lt), 0);
                let Nt = v !== null ? xe.get(v).__webglFramebuffer : null;
                J.bindFramebuffer(W.FRAMEBUFFER, Nt);
                let Mi = W.fenceSync(W.SYNC_GPU_COMMANDS_COMPLETE, 0);
                return W.flush(), await dk(W, Mi, 4), W.bindBuffer(W.PIXEL_PACK_BUFFER, Tt), W.getBufferSubData(W.PIXEL_PACK_BUFFER, 0, st), W.deleteBuffer(Tt), W.deleteSync(Mi), st;
            } else throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
        }
    }, this.copyFramebufferToTexture = function(G, le, ge = 0) {
        let ne = Math.pow(2, -ge), be = Math.floor(le.image.width * ne), st = Math.floor(le.image.height * ne);
        de.setTexture2D(le, 0), W.copyTexSubImage2D(3553, ge, 0, 0, G.x, G.y, be, st), J.unbindTexture();
    }, this.copyTextureToTexture = function(G, le, ge, ne = 0) {
        let be = le.image.width, st = le.image.height, pt = Oe.convert(ge.format), St = Oe.convert(ge.type);
        de.setTexture2D(ge, 0), W.pixelStorei(37440, ge.flipY), W.pixelStorei(37441, ge.premultiplyAlpha), W.pixelStorei(3317, ge.unpackAlignment), le.isDataTexture ? W.texSubImage2D(3553, ne, G.x, G.y, be, st, pt, St, le.image.data) : le.isCompressedTexture ? W.compressedTexSubImage2D(3553, ne, G.x, G.y, le.mipmaps[0].width, le.mipmaps[0].height, pt, le.mipmaps[0].data) : W.texSubImage2D(3553, ne, G.x, G.y, pt, St, le.image), ne === 0 && ge.generateMipmaps && W.generateMipmap(3553), J.unbindTexture();
    }, this.copyTextureToTexture3D = function(G, le, ge, ne, be = 0) {
        if (p.isWebGL1Renderer) {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
            return;
        }
        let st = G.max.x - G.min.x + 1, pt = G.max.y - G.min.y + 1, St = G.max.z - G.min.z + 1, Et = Oe.convert(ne.format), jt = Oe.convert(ne.type), Lt;
        if (ne.isData3DTexture) de.setTexture3D(ne, 0), Lt = 32879;
        else if (ne.isDataArrayTexture) de.setTexture2DArray(ne, 0), Lt = 35866;
        else {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
            return;
        }
        W.pixelStorei(37440, ne.flipY), W.pixelStorei(37441, ne.premultiplyAlpha), W.pixelStorei(3317, ne.unpackAlignment);
        let Tt = W.getParameter(3314), Nt = W.getParameter(32878), Mi = W.getParameter(3316), an = W.getParameter(3315), So = W.getParameter(32877), xt = ge.isCompressedTexture ? ge.mipmaps[0] : ge.image;
        W.pixelStorei(3314, xt.width), W.pixelStorei(32878, xt.height), W.pixelStorei(3316, G.min.x), W.pixelStorei(3315, G.min.y), W.pixelStorei(32877, G.min.z), ge.isDataTexture || ge.isData3DTexture ? W.texSubImage3D(Lt, be, le.x, le.y, le.z, st, pt, St, Et, jt, xt.data) : ge.isCompressedArrayTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), W.compressedTexSubImage3D(Lt, be, le.x, le.y, le.z, st, pt, St, Et, xt.data)) : W.texSubImage3D(Lt, be, le.x, le.y, le.z, st, pt, St, Et, jt, xt), W.pixelStorei(3314, Tt), W.pixelStorei(32878, Nt), W.pixelStorei(3316, Mi), W.pixelStorei(3315, an), W.pixelStorei(32877, So), be === 0 && ne.generateMipmaps && W.generateMipmap(Lt), J.unbindTexture();
    }, this.initRenderTarget = function(G) {
        xe.get(G).__webglFramebuffer === void 0 && de.setupRenderTarget(G);
    }, this.initTexture = function(G) {
        G.isCubeTexture ? de.setTextureCube(G, 0) : G.isData3DTexture ? de.setTexture3D(G, 0) : G.isDataArrayTexture || G.isCompressedArrayTexture ? de.setTexture2DArray(G, 0) : de.setTexture2D(G, 0), J.unbindTexture();
    }, this.resetState = function() {
        y = 0, x = 0, v = null, J.reset(), pe.reset();
    }, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
        detail: this
    }));
}
var sw = class extends Iw {
};
sw.prototype.isWebGL1Renderer = !0;
var ih = class {
    constructor(t, e = 1, r = 1e3){
        this.isFog = !0, this.name = "", this.color = new Ge(t), this.near = e, this.far = r;
    }
    clone() {
        return new ih(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}, Er = class extends Dt {
    constructor(){
        super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(t, e) {
        return super.copy(t, e), t.background !== null && (this.background = t.background.clone()), t.environment !== null && (this.environment = t.environment.clone()), t.fog !== null && (this.fog = t.fog.clone()), this.backgroundBlurriness = t.backgroundBlurriness, this.backgroundIntensity = t.backgroundIntensity, t.overrideMaterial !== null && (this.overrideMaterial = t.overrideMaterial.clone()), this.matrixAutoUpdate = t.matrixAutoUpdate, this;
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return this.fog !== null && (e.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (e.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (e.object.backgroundIntensity = this.backgroundIntensity), e;
    }
    get autoUpdate() {
        return console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144."), this.matrixWorldAutoUpdate;
    }
    set autoUpdate(t) {
        console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144."), this.matrixWorldAutoUpdate = t;
    }
}, Hy = class {
    constructor(t, e){
        this.isInterleavedBuffer = !0, this.array = t, this.stride = e, this.count = t !== void 0 ? t.length / e : 0, this.usage = WS, this.updateRange = {
            offset: 0,
            count: -1
        }, this.version = 0, this.uuid = fs();
    }
    onUploadCallback() {}
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
    setUsage(t) {
        return this.usage = t, this;
    }
    copy(t) {
        return this.array = new t.array.constructor(t.array), this.count = t.count, this.stride = t.stride, this.usage = t.usage, this;
    }
    copyAt(t, e, r) {
        t *= this.stride, r *= e.stride;
        for(let i = 0, s1 = this.stride; i < s1; i++)this.array[t + i] = e.array[r + i];
        return this;
    }
    set(t, e = 0) {
        return this.array.set(t, e), this;
    }
    clone(t) {
        t.arrayBuffers === void 0 && (t.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = fs()), t.arrayBuffers[this.array.buffer._uuid] === void 0 && (t.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
        let e = new this.array.constructor(t.arrayBuffers[this.array.buffer._uuid]), r = new this.constructor(e, this.stride);
        return r.setUsage(this.usage), r;
    }
    onUpload(t) {
        return this.onUploadCallback = t, this;
    }
    toJSON(t) {
        return t.arrayBuffers === void 0 && (t.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = fs()), t.arrayBuffers[this.array.buffer._uuid] === void 0 && (t.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}, yn = new E, Vc = class {
    constructor(t, e, r, i = !1){
        this.isInterleavedBufferAttribute = !0, this.name = "", this.data = t, this.itemSize = e, this.offset = r, this.normalized = i;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(t) {
        this.data.needsUpdate = t;
    }
    applyMatrix4(t) {
        for(let e = 0, r = this.data.count; e < r; e++)yn.fromBufferAttribute(this, e), yn.applyMatrix4(t), this.setXYZ(e, yn.x, yn.y, yn.z);
        return this;
    }
    applyNormalMatrix(t) {
        for(let e = 0, r = this.count; e < r; e++)yn.fromBufferAttribute(this, e), yn.applyNormalMatrix(t), this.setXYZ(e, yn.x, yn.y, yn.z);
        return this;
    }
    transformDirection(t) {
        for(let e = 0, r = this.count; e < r; e++)yn.fromBufferAttribute(this, e), yn.transformDirection(t), this.setXYZ(e, yn.x, yn.y, yn.z);
        return this;
    }
    setX(t, e) {
        return this.normalized && (e = Ar(e, this.array)), this.data.array[t * this.data.stride + this.offset] = e, this;
    }
    setY(t, e) {
        return this.normalized && (e = Ar(e, this.array)), this.data.array[t * this.data.stride + this.offset + 1] = e, this;
    }
    setZ(t, e) {
        return this.normalized && (e = Ar(e, this.array)), this.data.array[t * this.data.stride + this.offset + 2] = e, this;
    }
    setW(t, e) {
        return this.normalized && (e = Ar(e, this.array)), this.data.array[t * this.data.stride + this.offset + 3] = e, this;
    }
    getX(t) {
        let e = this.data.array[t * this.data.stride + this.offset];
        return this.normalized && (e = Ma(e, this.array)), e;
    }
    getY(t) {
        let e = this.data.array[t * this.data.stride + this.offset + 1];
        return this.normalized && (e = Ma(e, this.array)), e;
    }
    getZ(t) {
        let e = this.data.array[t * this.data.stride + this.offset + 2];
        return this.normalized && (e = Ma(e, this.array)), e;
    }
    getW(t) {
        let e = this.data.array[t * this.data.stride + this.offset + 3];
        return this.normalized && (e = Ma(e, this.array)), e;
    }
    setXY(t, e, r) {
        return t = t * this.data.stride + this.offset, this.normalized && (e = Ar(e, this.array), r = Ar(r, this.array)), this.data.array[t + 0] = e, this.data.array[t + 1] = r, this;
    }
    setXYZ(t, e, r, i) {
        return t = t * this.data.stride + this.offset, this.normalized && (e = Ar(e, this.array), r = Ar(r, this.array), i = Ar(i, this.array)), this.data.array[t + 0] = e, this.data.array[t + 1] = r, this.data.array[t + 2] = i, this;
    }
    setXYZW(t, e, r, i, s1) {
        return t = t * this.data.stride + this.offset, this.normalized && (e = Ar(e, this.array), r = Ar(r, this.array), i = Ar(i, this.array), s1 = Ar(s1, this.array)), this.data.array[t + 0] = e, this.data.array[t + 1] = r, this.data.array[t + 2] = i, this.data.array[t + 3] = s1, this;
    }
    clone(t) {
        if (t === void 0) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
            let e = [];
            for(let r = 0; r < this.count; r++){
                let i = r * this.data.stride + this.offset;
                for(let s1 = 0; s1 < this.itemSize; s1++)e.push(this.data.array[i + s1]);
            }
            return new je(new this.array.constructor(e), this.itemSize, this.normalized);
        } else return t.interleavedBuffers === void 0 && (t.interleavedBuffers = {}), t.interleavedBuffers[this.data.uuid] === void 0 && (t.interleavedBuffers[this.data.uuid] = this.data.clone(t)), new Vc(t.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
    }
    toJSON(t) {
        if (t === void 0) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
            let e = [];
            for(let r = 0; r < this.count; r++){
                let i = r * this.data.stride + this.offset;
                for(let s1 = 0; s1 < this.itemSize; s1++)e.push(this.data.array[i + s1]);
            }
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: e,
                normalized: this.normalized
            };
        } else return t.interleavedBuffers === void 0 && (t.interleavedBuffers = {}), t.interleavedBuffers[this.data.uuid] === void 0 && (t.interleavedBuffers[this.data.uuid] = this.data.toJSON(t)), {
            isInterleavedBufferAttribute: !0,
            itemSize: this.itemSize,
            data: this.data.uuid,
            offset: this.offset,
            normalized: this.normalized
        };
    }
};
var zp = class extends Dt {
    constructor(){
        super(), this.isBone = !0, this.type = "Bone";
    }
}, Ur = class extends Zt {
    constructor(t = null, e = 1, r = 1, i, s1, o, a, l, c = vt, u1 = vt, h, d){
        super(null, o, a, l, c, u1, i, s1, h, d), this.isDataTexture = !0, this.image = {
            data: t,
            width: e,
            height: r
        }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
}, OP = new ue, Z5 = new ue, Sl = class {
    constructor(t = [], e = []){
        this.uuid = fs(), this.bones = t.slice(0), this.boneInverses = e, this.boneMatrices = null, this.boneTexture = null, this.boneTextureSize = 0, this.frame = -1, this.init();
    }
    init() {
        let t = this.bones, e = this.boneInverses;
        if (this.boneMatrices = new Float32Array(t.length * 16), e.length === 0) this.calculateInverses();
        else if (t.length !== e.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];
            for(let r = 0, i = this.bones.length; r < i; r++)this.boneInverses.push(new ue);
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let t = 0, e = this.bones.length; t < e; t++){
            let r = new ue;
            this.bones[t] && r.copy(this.bones[t].matrixWorld).invert(), this.boneInverses.push(r);
        }
    }
    pose() {
        for(let t = 0, e = this.bones.length; t < e; t++){
            let r = this.bones[t];
            r && r.matrixWorld.copy(this.boneInverses[t]).invert();
        }
        for(let t = 0, e = this.bones.length; t < e; t++){
            let r = this.bones[t];
            r && (r.parent && r.parent.isBone ? (r.matrix.copy(r.parent.matrixWorld).invert(), r.matrix.multiply(r.matrixWorld)) : r.matrix.copy(r.matrixWorld), r.matrix.decompose(r.position, r.quaternion, r.scale));
        }
    }
    update() {
        let t = this.bones, e = this.boneInverses, r = this.boneMatrices, i = this.boneTexture;
        for(let s1 = 0, o = t.length; s1 < o; s1++){
            let a = t[s1] ? t[s1].matrixWorld : Z5;
            OP.multiplyMatrices(a, e[s1]), OP.toArray(r, s1 * 16);
        }
        i !== null && (i.needsUpdate = !0);
    }
    clone() {
        return new Sl(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        let t = Math.sqrt(this.bones.length * 4);
        t = a_(t), t = Math.max(t, 4);
        let e = new Float32Array(t * t * 4);
        e.set(this.boneMatrices);
        let r = new Ur(e, t, t, br, Ut);
        return r.needsUpdate = !0, this.boneMatrices = e, this.boneTexture = r, this.boneTextureSize = t, this;
    }
    getBoneByName(t) {
        for(let e = 0, r = this.bones.length; e < r; e++){
            let i = this.bones[e];
            if (i.name === t) return i;
        }
    }
    dispose() {
        this.boneTexture !== null && (this.boneTexture.dispose(), this.boneTexture = null);
    }
    fromJSON(t, e) {
        this.uuid = t.uuid;
        for(let r = 0, i = t.bones.length; r < i; r++){
            let s1 = t.bones[r], o = e[s1];
            o === void 0 && (console.warn("THREE.Skeleton: No bone found with UUID:", s1), o = new zp), this.bones.push(o), this.boneInverses.push(new ue().fromArray(t.boneInverses[r]));
        }
        return this.init(), this;
    }
    toJSON() {
        let t = {
            metadata: {
                version: 4.5,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        t.uuid = this.uuid;
        let e = this.bones, r = this.boneInverses;
        for(let i = 0, s1 = e.length; i < s1; i++){
            let o = e[i];
            t.bones.push(o.uuid);
            let a = r[i];
            t.boneInverses.push(a.toArray());
        }
        return t;
    }
}, Mo = class extends je {
    constructor(t, e, r, i = 1){
        super(t, e, r), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = i;
    }
    copy(t) {
        return super.copy(t), this.meshPerAttribute = t.meshPerAttribute, this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.meshPerAttribute = this.meshPerAttribute, t.isInstancedBufferAttribute = !0, t;
    }
}, RP = new ue, LP = new ue, Ay = [], J5 = new ue, Mp = new Mt, Wy = class extends Mt {
    constructor(t, e, r){
        super(t, e), this.isInstancedMesh = !0, this.instanceMatrix = new Mo(new Float32Array(r * 16), 16), this.instanceColor = null, this.count = r, this.frustumCulled = !1;
        for(let i = 0; i < r; i++)this.setMatrixAt(i, J5);
    }
    copy(t, e) {
        return super.copy(t, e), this.instanceMatrix.copy(t.instanceMatrix), t.instanceColor !== null && (this.instanceColor = t.instanceColor.clone()), this.count = t.count, this;
    }
    getColorAt(t, e) {
        e.fromArray(this.instanceColor.array, t * 3);
    }
    getMatrixAt(t, e) {
        e.fromArray(this.instanceMatrix.array, t * 16);
    }
    raycast(t, e) {
        let r = this.matrixWorld, i = this.count;
        if (Mp.geometry = this.geometry, Mp.material = this.material, Mp.material !== void 0) for(let s1 = 0; s1 < i; s1++){
            this.getMatrixAt(s1, RP), LP.multiplyMatrices(r, RP), Mp.matrixWorld = LP, Mp.raycast(t, Ay);
            for(let o = 0, a = Ay.length; o < a; o++){
                let l = Ay[o];
                l.instanceId = s1, l.object = this, e.push(l);
            }
            Ay.length = 0;
        }
    }
    setColorAt(t, e) {
        this.instanceColor === null && (this.instanceColor = new Mo(new Float32Array(this.instanceMatrix.count * 3), 3)), e.toArray(this.instanceColor.array, t * 3);
    }
    setMatrixAt(t, e) {
        e.toArray(this.instanceMatrix.array, t * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}, ms = class extends Fc {
    constructor(t){
        super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new Ge(16777215), this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.linewidth = t.linewidth, this.linecap = t.linecap, this.linejoin = t.linejoin, this.fog = t.fog, this;
    }
}, NP = new E, BP = new E, FP = new ue, NS = new Ws, Ey = new ei, Uc = class extends Dt {
    constructor(t = new Ce, e = new ms){
        super(), this.isLine = !0, this.type = "Line", this.geometry = t, this.material = e, this.updateMorphTargets();
    }
    copy(t, e) {
        return super.copy(t, e), this.material = t.material, this.geometry = t.geometry, this;
    }
    computeLineDistances() {
        let t = this.geometry;
        if (t.index === null) {
            let e = t.attributes.position, r = [
                0
            ];
            for(let i = 1, s1 = e.count; i < s1; i++)NP.fromBufferAttribute(e, i - 1), BP.fromBufferAttribute(e, i), r[i] = r[i - 1], r[i] += NP.distanceTo(BP);
            t.setAttribute("lineDistance", new Te(r, 1));
        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(t, e) {
        let r = this.geometry, i = this.matrixWorld, s1 = t.params.Line.threshold, o = r.drawRange;
        if (r.boundingSphere === null && r.computeBoundingSphere(), Ey.copy(r.boundingSphere), Ey.applyMatrix4(i), Ey.radius += s1, t.ray.intersectsSphere(Ey) === !1) return;
        FP.copy(i).invert(), NS.copy(t.ray).applyMatrix4(FP);
        let a = s1 / ((this.scale.x + this.scale.y + this.scale.z) / 3), l = a * a, c = new E, u1 = new E, h = new E, d = new E, f = this.isLineSegments ? 2 : 1, m = r.index, g = r.attributes.position;
        if (m !== null) {
            let y = Math.max(0, o.start), x = Math.min(m.count, o.start + o.count);
            for(let v = y, b = x - 1; v < b; v += f){
                let w = m.getX(v), A = m.getX(v + 1);
                if (c.fromBufferAttribute(g, w), u1.fromBufferAttribute(g, A), NS.distanceSqToSegment(c, u1, d, h) > l) continue;
                d.applyMatrix4(this.matrixWorld);
                let S = t.ray.origin.distanceTo(d);
                S < t.near || S > t.far || e.push({
                    distance: S,
                    point: h.clone().applyMatrix4(this.matrixWorld),
                    index: v,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            let y = Math.max(0, o.start), x = Math.min(g.count, o.start + o.count);
            for(let v = y, b = x - 1; v < b; v += f){
                if (c.fromBufferAttribute(g, v), u1.fromBufferAttribute(g, v + 1), NS.distanceSqToSegment(c, u1, d, h) > l) continue;
                d.applyMatrix4(this.matrixWorld);
                let A = t.ray.origin.distanceTo(d);
                A < t.near || A > t.far || e.push({
                    distance: A,
                    point: h.clone().applyMatrix4(this.matrixWorld),
                    index: v,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        let e = this.geometry.morphAttributes, r = Object.keys(e);
        if (r.length > 0) {
            let i = e[r[0]];
            if (i !== void 0) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let s1 = 0, o = i.length; s1 < o; s1++){
                    let a = i[s1].name || String(s1);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[a] = s1;
                }
            }
        }
    }
}, VP = new E, UP = new E, wl = class extends Uc {
    constructor(t, e){
        super(t, e), this.isLineSegments = !0, this.type = "LineSegments";
    }
    computeLineDistances() {
        let t = this.geometry;
        if (t.index === null) {
            let e = t.attributes.position, r = [];
            for(let i = 0, s1 = e.count; i < s1; i += 2)VP.fromBufferAttribute(e, i), UP.fromBufferAttribute(e, i + 1), r[i] = i === 0 ? 0 : r[i - 1], r[i + 1] = r[i] + VP.distanceTo(UP);
            t.setAttribute("lineDistance", new Te(r, 1));
        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
};
var qy = class extends Zt {
    constructor(t, e, r, i, s1, o, a, l, c){
        super(t, e, r, i, s1, o, a, l, c), this.isVideoTexture = !0, this.minFilter = o !== void 0 ? o : it, this.magFilter = s1 !== void 0 ? s1 : it, this.generateMipmaps = !1;
        let u1 = this;
        function h() {
            u1.needsUpdate = !0, t.requestVideoFrameCallback(h);
        }
        "requestVideoFrameCallback" in t && t.requestVideoFrameCallback(h);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        let t = this.image;
        "requestVideoFrameCallback" in t === !1 && t.readyState >= t.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
    }
};
var Xy = class extends Zt {
    constructor(t, e, r, i, s1, o, a, l, c){
        super(t, e, r, i, s1, o, a, l, c), this.isCanvasTexture = !0, this.needsUpdate = !0;
    }
}, gs = class {
    constructor(){
        this.type = "Curve", this.arcLengthDivisions = 200;
    }
    getPoint() {
        return console.warn("THREE.Curve: .getPoint() not implemented."), null;
    }
    getPointAt(t, e) {
        let r = this.getUtoTmapping(t);
        return this.getPoint(r, e);
    }
    getPoints(t = 5) {
        let e = [];
        for(let r = 0; r <= t; r++)e.push(this.getPoint(r / t));
        return e;
    }
    getSpacedPoints(t = 5) {
        let e = [];
        for(let r = 0; r <= t; r++)e.push(this.getPointAt(r / t));
        return e;
    }
    getLength() {
        let t = this.getLengths();
        return t[t.length - 1];
    }
    getLengths(t = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === t + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = !1;
        let e = [], r, i = this.getPoint(0), s1 = 0;
        e.push(0);
        for(let o = 1; o <= t; o++)r = this.getPoint(o / t), s1 += r.distanceTo(i), e.push(s1), i = r;
        return this.cacheArcLengths = e, e;
    }
    updateArcLengths() {
        this.needsUpdate = !0, this.getLengths();
    }
    getUtoTmapping(t, e) {
        let r = this.getLengths(), i = 0, s1 = r.length, o;
        e ? o = e : o = t * r[s1 - 1];
        let a = 0, l = s1 - 1, c;
        for(; a <= l;)if (i = Math.floor(a + (l - a) / 2), c = r[i] - o, c < 0) a = i + 1;
        else if (c > 0) l = i - 1;
        else {
            l = i;
            break;
        }
        if (i = l, r[i] === o) return i / (s1 - 1);
        let u1 = r[i], d = r[i + 1] - u1, f = (o - u1) / d;
        return (i + f) / (s1 - 1);
    }
    getTangent(t, e) {
        let i = t - 1e-4, s1 = t + 1e-4;
        i < 0 && (i = 0), s1 > 1 && (s1 = 1);
        let o = this.getPoint(i), a = this.getPoint(s1), l = e || (o.isVector2 ? new U : new E);
        return l.copy(a).sub(o).normalize(), l;
    }
    getTangentAt(t, e) {
        let r = this.getUtoTmapping(t);
        return this.getTangent(r, e);
    }
    computeFrenetFrames(t, e) {
        let r = new E, i = [], s1 = [], o = [], a = new E, l = new ue;
        for(let f = 0; f <= t; f++){
            let m = f / t;
            i[f] = this.getTangentAt(m, new E);
        }
        s1[0] = new E, o[0] = new E;
        let c = Number.MAX_VALUE, u1 = Math.abs(i[0].x), h = Math.abs(i[0].y), d = Math.abs(i[0].z);
        u1 <= c && (c = u1, r.set(1, 0, 0)), h <= c && (c = h, r.set(0, 1, 0)), d <= c && r.set(0, 0, 1), a.crossVectors(i[0], r).normalize(), s1[0].crossVectors(i[0], a), o[0].crossVectors(i[0], s1[0]);
        for(let f = 1; f <= t; f++){
            if (s1[f] = s1[f - 1].clone(), o[f] = o[f - 1].clone(), a.crossVectors(i[f - 1], i[f]), a.length() > Number.EPSILON) {
                a.normalize();
                let m = Math.acos(yi(i[f - 1].dot(i[f]), -1, 1));
                s1[f].applyMatrix4(l.makeRotationAxis(a, m));
            }
            o[f].crossVectors(i[f], s1[f]);
        }
        if (e === !0) {
            let f = Math.acos(yi(s1[0].dot(s1[t]), -1, 1));
            f /= t, i[0].dot(a.crossVectors(s1[0], s1[t])) > 0 && (f = -f);
            for(let m = 1; m <= t; m++)s1[m].applyMatrix4(l.makeRotationAxis(i[m], f * m)), o[m].crossVectors(i[m], s1[m]);
        }
        return {
            tangents: i,
            normals: s1,
            binormals: o
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.arcLengthDivisions = t.arcLengthDivisions, this;
    }
    toJSON() {
        let t = {
            metadata: {
                version: 4.5,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        return t.arcLengthDivisions = this.arcLengthDivisions, t.type = this.type, t;
    }
    fromJSON(t) {
        return this.arcLengthDivisions = t.arcLengthDivisions, this;
    }
}, kc = class extends gs {
    constructor(t = 0, e = 0, r = 1, i = 1, s1 = 0, o = Math.PI * 2, a = !1, l = 0){
        super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = t, this.aY = e, this.xRadius = r, this.yRadius = i, this.aStartAngle = s1, this.aEndAngle = o, this.aClockwise = a, this.aRotation = l;
    }
    getPoint(t, e) {
        let r = e || new U, i = Math.PI * 2, s1 = this.aEndAngle - this.aStartAngle, o = Math.abs(s1) < Number.EPSILON;
        for(; s1 < 0;)s1 += i;
        for(; s1 > i;)s1 -= i;
        s1 < Number.EPSILON && (o ? s1 = 0 : s1 = i), this.aClockwise === !0 && !o && (s1 === i ? s1 = -i : s1 = s1 - i);
        let a = this.aStartAngle + t * s1, l = this.aX + this.xRadius * Math.cos(a), c = this.aY + this.yRadius * Math.sin(a);
        if (this.aRotation !== 0) {
            let u1 = Math.cos(this.aRotation), h = Math.sin(this.aRotation), d = l - this.aX, f = c - this.aY;
            l = d * u1 - f * h + this.aX, c = d * h + f * u1 + this.aY;
        }
        return r.set(l, c);
    }
    copy(t) {
        return super.copy(t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.aX = this.aX, t.aY = this.aY, t.xRadius = this.xRadius, t.yRadius = this.yRadius, t.aStartAngle = this.aStartAngle, t.aEndAngle = this.aEndAngle, t.aClockwise = this.aClockwise, t.aRotation = this.aRotation, t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
    }
}, ow = class extends kc {
    constructor(t, e, r, i, s1, o){
        super(t, e, r, r, i, s1, o), this.isArcCurve = !0, this.type = "ArcCurve";
    }
};
function Dw() {
    let n1 = 0, t = 0, e = 0, r = 0;
    function i(s1, o, a, l) {
        n1 = s1, t = a, e = -3 * s1 + 3 * o - 2 * a - l, r = 2 * s1 - 2 * o + a + l;
    }
    return {
        initCatmullRom: function(s1, o, a, l, c) {
            i(o, a, c * (a - s1), c * (l - o));
        },
        initNonuniformCatmullRom: function(s1, o, a, l, c, u1, h) {
            let d = (o - s1) / c - (a - s1) / (c + u1) + (a - o) / u1, f = (a - o) / u1 - (l - o) / (u1 + h) + (l - a) / h;
            d *= u1, f *= u1, i(o, a, d, f);
        },
        calc: function(s1) {
            let o = s1 * s1, a = o * s1;
            return n1 + t * s1 + e * o + r * a;
        }
    };
}
var Ty = new E, BS = new Dw, FS = new Dw, VS = new Dw, aw = class extends gs {
    constructor(t = [], e = !1, r = "centripetal", i = .5){
        super(), this.isCatmullRomCurve3 = !0, this.type = "CatmullRomCurve3", this.points = t, this.closed = e, this.curveType = r, this.tension = i;
    }
    getPoint(t, e = new E) {
        let r = e, i = this.points, s1 = i.length, o = (s1 - (this.closed ? 0 : 1)) * t, a = Math.floor(o), l = o - a;
        this.closed ? a += a > 0 ? 0 : (Math.floor(Math.abs(a) / s1) + 1) * s1 : l === 0 && a === s1 - 1 && (a = s1 - 2, l = 1);
        let c, u1;
        this.closed || a > 0 ? c = i[(a - 1) % s1] : (Ty.subVectors(i[0], i[1]).add(i[0]), c = Ty);
        let h = i[a % s1], d = i[(a + 1) % s1];
        if (this.closed || a + 2 < s1 ? u1 = i[(a + 2) % s1] : (Ty.subVectors(i[s1 - 1], i[s1 - 2]).add(i[s1 - 1]), u1 = Ty), this.curveType === "centripetal" || this.curveType === "chordal") {
            let f = this.curveType === "chordal" ? .5 : .25, m = Math.pow(c.distanceToSquared(h), f), p = Math.pow(h.distanceToSquared(d), f), g = Math.pow(d.distanceToSquared(u1), f);
            p < 1e-4 && (p = 1), m < 1e-4 && (m = p), g < 1e-4 && (g = p), BS.initNonuniformCatmullRom(c.x, h.x, d.x, u1.x, m, p, g), FS.initNonuniformCatmullRom(c.y, h.y, d.y, u1.y, m, p, g), VS.initNonuniformCatmullRom(c.z, h.z, d.z, u1.z, m, p, g);
        } else this.curveType === "catmullrom" && (BS.initCatmullRom(c.x, h.x, d.x, u1.x, this.tension), FS.initCatmullRom(c.y, h.y, d.y, u1.y, this.tension), VS.initCatmullRom(c.z, h.z, d.z, u1.z, this.tension));
        return r.set(BS.calc(l), FS.calc(l), VS.calc(l)), r;
    }
    copy(t) {
        super.copy(t), this.points = [];
        for(let e = 0, r = t.points.length; e < r; e++){
            let i = t.points[e];
            this.points.push(i.clone());
        }
        return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
    toJSON() {
        let t = super.toJSON();
        t.points = [];
        for(let e = 0, r = this.points.length; e < r; e++){
            let i = this.points[e];
            t.points.push(i.toArray());
        }
        return t.closed = this.closed, t.curveType = this.curveType, t.tension = this.tension, t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.points = [];
        for(let e = 0, r = t.points.length; e < r; e++){
            let i = t.points[e];
            this.points.push(new E().fromArray(i));
        }
        return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
};
function kP(n1, t, e, r, i) {
    let s1 = (r - t) * .5, o = (i - e) * .5, a = n1 * n1, l = n1 * a;
    return (2 * e - 2 * r + s1 + o) * l + (-3 * e + 3 * r - 2 * s1 - o) * a + s1 * n1 + e;
}
function $5(n1, t) {
    let e = 1 - n1;
    return e * e * t;
}
function ej(n1, t) {
    return 2 * (1 - n1) * n1 * t;
}
function tj(n1, t) {
    return n1 * n1 * t;
}
function Rp(n1, t, e, r) {
    return $5(n1, t) + ej(n1, e) + tj(n1, r);
}
function rj(n1, t) {
    let e = 1 - n1;
    return e * e * e * t;
}
function ij(n1, t) {
    let e = 1 - n1;
    return 3 * e * e * n1 * t;
}
function nj(n1, t) {
    return 3 * (1 - n1) * n1 * n1 * t;
}
function sj(n1, t) {
    return n1 * n1 * n1 * t;
}
function Lp(n1, t, e, r, i) {
    return rj(n1, t) + ij(n1, e) + nj(n1, r) + sj(n1, i);
}
var hn = class extends gs {
    constructor(t = new U, e = new U, r = new U, i = new U){
        super(), this.isCubicBezierCurve = !0, this.type = "CubicBezierCurve", this.v0 = t, this.v1 = e, this.v2 = r, this.v3 = i;
    }
    getPoint(t, e = new U) {
        let r = e, i = this.v0, s1 = this.v1, o = this.v2, a = this.v3;
        return r.set(Lp(t, i.x, s1.x, o.x, a.x), Lp(t, i.y, s1.y, o.y, a.y)), r;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
    }
}, zc = class extends gs {
    constructor(t = new E, e = new E, r = new E, i = new E){
        super(), this.isCubicBezierCurve3 = !0, this.type = "CubicBezierCurve3", this.v0 = t, this.v1 = e, this.v2 = r, this.v3 = i;
    }
    getPoint(t, e = new E) {
        let r = e, i = this.v0, s1 = this.v1, o = this.v2, a = this.v3;
        return r.set(Lp(t, i.x, s1.x, o.x, a.x), Lp(t, i.y, s1.y, o.y, a.y), Lp(t, i.z, s1.z, o.z, a.z)), r;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
    }
}, dn = class extends gs {
    constructor(t = new U, e = new U){
        super(), this.isLineCurve = !0, this.type = "LineCurve", this.v1 = t, this.v2 = e;
    }
    getPoint(t, e = new U) {
        let r = e;
        return t === 1 ? r.copy(this.v2) : (r.copy(this.v2).sub(this.v1), r.multiplyScalar(t).add(this.v1)), r;
    }
    getPointAt(t, e) {
        return this.getPoint(t, e);
    }
    getTangent(t, e) {
        let r = e || new U;
        return r.copy(this.v2).sub(this.v1).normalize(), r;
    }
    copy(t) {
        return super.copy(t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, Gp = class extends gs {
    constructor(t = new E, e = new E){
        super(), this.isLineCurve3 = !0, this.type = "LineCurve3", this.v1 = t, this.v2 = e;
    }
    getPoint(t, e = new E) {
        let r = e;
        return t === 1 ? r.copy(this.v2) : (r.copy(this.v2).sub(this.v1), r.multiplyScalar(t).add(this.v1)), r;
    }
    getPointAt(t, e) {
        return this.getPoint(t, e);
    }
    copy(t) {
        return super.copy(t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, es = class extends gs {
    constructor(t = new U, e = new U, r = new U){
        super(), this.isQuadraticBezierCurve = !0, this.type = "QuadraticBezierCurve", this.v0 = t, this.v1 = e, this.v2 = r;
    }
    getPoint(t, e = new U) {
        let r = e, i = this.v0, s1 = this.v1, o = this.v2;
        return r.set(Rp(t, i.x, s1.x, o.x), Rp(t, i.y, s1.y, o.y)), r;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, lw = class extends gs {
    constructor(t = new E, e = new E, r = new E){
        super(), this.isQuadraticBezierCurve3 = !0, this.type = "QuadraticBezierCurve3", this.v0 = t, this.v1 = e, this.v2 = r;
    }
    getPoint(t, e = new E) {
        let r = e, i = this.v0, s1 = this.v1, o = this.v2;
        return r.set(Rp(t, i.x, s1.x, o.x), Rp(t, i.y, s1.y, o.y), Rp(t, i.z, s1.z, o.z)), r;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, nh = class extends gs {
    constructor(t = []){
        super(), this.isSplineCurve = !0, this.type = "SplineCurve", this.points = t;
    }
    getPoint(t, e = new U) {
        let r = e, i = this.points, s1 = (i.length - 1) * t, o = Math.floor(s1), a = s1 - o, l = i[o === 0 ? o : o - 1], c = i[o], u1 = i[o > i.length - 2 ? i.length - 1 : o + 1], h = i[o > i.length - 3 ? i.length - 1 : o + 2];
        return r.set(kP(a, l.x, c.x, u1.x, h.x), kP(a, l.y, c.y, u1.y, h.y)), r;
    }
    copy(t) {
        super.copy(t), this.points = [];
        for(let e = 0, r = t.points.length; e < r; e++){
            let i = t.points[e];
            this.points.push(i.clone());
        }
        return this;
    }
    toJSON() {
        let t = super.toJSON();
        t.points = [];
        for(let e = 0, r = this.points.length; e < r; e++){
            let i = this.points[e];
            t.points.push(i.toArray());
        }
        return t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.points = [];
        for(let e = 0, r = t.points.length; e < r; e++){
            let i = t.points[e];
            this.points.push(new U().fromArray(i));
        }
        return this;
    }
}, oj = Object.freeze({
    __proto__: null,
    ArcCurve: ow,
    CatmullRomCurve3: aw,
    CubicBezierCurve: hn,
    CubicBezierCurve3: zc,
    EllipseCurve: kc,
    LineCurve: dn,
    LineCurve3: Gp,
    QuadraticBezierCurve: es,
    QuadraticBezierCurve3: lw,
    SplineCurve: nh
}), jp = class extends gs {
    constructor(){
        super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
    }
    add(t) {
        this.curves.push(t);
    }
    closePath() {
        let t = this.curves[0].getPoint(0), e = this.curves[this.curves.length - 1].getPoint(1);
        t.equals(e) || this.curves.push(new dn(e, t));
    }
    getPoint(t, e) {
        let r = t * this.getLength(), i = this.getCurveLengths(), s1 = 0;
        for(; s1 < i.length;){
            if (i[s1] >= r) {
                let o = i[s1] - r, a = this.curves[s1], l = a.getLength(), c = l === 0 ? 0 : 1 - o / l;
                return a.getPointAt(c, e);
            }
            s1++;
        }
        return null;
    }
    getLength() {
        let t = this.getCurveLengths();
        return t[t.length - 1];
    }
    updateArcLengths() {
        this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
    }
    getCurveLengths() {
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        let t = [], e = 0;
        for(let r = 0, i = this.curves.length; r < i; r++)e += this.curves[r].getLength(), t.push(e);
        return this.cacheLengths = t, t;
    }
    getSpacedPoints(t = 40) {
        let e = [];
        for(let r = 0; r <= t; r++)e.push(this.getPoint(r / t));
        return this.autoClose && e.push(e[0]), e;
    }
    getPoints(t = 12) {
        let e = [], r;
        for(let i = 0, s1 = this.curves; i < s1.length; i++){
            let o = s1[i], a = o.isEllipseCurve ? t * 2 : o.isLineCurve || o.isLineCurve3 ? 1 : o.isSplineCurve ? t * o.points.length : t, l = o.getPoints(a);
            for(let c = 0; c < l.length; c++){
                let u1 = l[c];
                r && r.equals(u1) || (e.push(u1), r = u1);
            }
        }
        return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
    }
    copy(t) {
        super.copy(t), this.curves = [];
        for(let e = 0, r = t.curves.length; e < r; e++){
            let i = t.curves[e];
            this.curves.push(i.clone());
        }
        return this.autoClose = t.autoClose, this;
    }
    toJSON() {
        let t = super.toJSON();
        t.autoClose = this.autoClose, t.curves = [];
        for(let e = 0, r = this.curves.length; e < r; e++){
            let i = this.curves[e];
            t.curves.push(i.toJSON());
        }
        return t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.autoClose = t.autoClose, this.curves = [];
        for(let e = 0, r = t.curves.length; e < r; e++){
            let i = t.curves[e];
            this.curves.push(new oj[i.type]().fromJSON(i));
        }
        return this;
    }
}, Gc = class extends jp {
    constructor(t){
        super(), this.type = "Path", this.currentPoint = new U, t && this.setFromPoints(t);
    }
    setFromPoints(t) {
        this.moveTo(t[0].x, t[0].y);
        for(let e = 1, r = t.length; e < r; e++)this.lineTo(t[e].x, t[e].y);
        return this;
    }
    moveTo(t, e) {
        return this.currentPoint.set(t, e), this;
    }
    lineTo(t, e) {
        let r = new dn(this.currentPoint.clone(), new U(t, e));
        return this.curves.push(r), this.currentPoint.set(t, e), this;
    }
    quadraticCurveTo(t, e, r, i) {
        let s1 = new es(this.currentPoint.clone(), new U(t, e), new U(r, i));
        return this.curves.push(s1), this.currentPoint.set(r, i), this;
    }
    bezierCurveTo(t, e, r, i, s1, o) {
        let a = new hn(this.currentPoint.clone(), new U(t, e), new U(r, i), new U(s1, o));
        return this.curves.push(a), this.currentPoint.set(s1, o), this;
    }
    splineThru(t) {
        let e = [
            this.currentPoint.clone()
        ].concat(t), r = new nh(e);
        return this.curves.push(r), this.currentPoint.copy(t[t.length - 1]), this;
    }
    arc(t, e, r, i, s1, o) {
        let a = this.currentPoint.x, l = this.currentPoint.y;
        return this.absarc(t + a, e + l, r, i, s1, o), this;
    }
    absarc(t, e, r, i, s1, o) {
        return this.absellipse(t, e, r, r, i, s1, o), this;
    }
    ellipse(t, e, r, i, s1, o, a, l) {
        let c = this.currentPoint.x, u1 = this.currentPoint.y;
        return this.absellipse(t + c, e + u1, r, i, s1, o, a, l), this;
    }
    absellipse(t, e, r, i, s1, o, a, l) {
        let c = new kc(t, e, r, i, s1, o, a, l);
        if (this.curves.length > 0) {
            let h = c.getPoint(0);
            h.equals(this.currentPoint) || this.lineTo(h.x, h.y);
        }
        this.curves.push(c);
        let u1 = c.getPoint(1);
        return this.currentPoint.copy(u1), this;
    }
    copy(t) {
        return super.copy(t), this.currentPoint.copy(t.currentPoint), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.currentPoint = this.currentPoint.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.currentPoint.fromArray(t.currentPoint), this;
    }
}, sh = class extends Ce {
    constructor(t = [
        new U(0, -0.5),
        new U(.5, 0),
        new U(0, .5)
    ], e = 12, r = 0, i = Math.PI * 2){
        super(), this.type = "LatheGeometry", this.parameters = {
            points: t,
            segments: e,
            phiStart: r,
            phiLength: i
        }, e = Math.floor(e), i = yi(i, 0, Math.PI * 2);
        let s1 = [], o = [], a = [], l = [], c = [], u1 = 1 / e, h = new E, d = new U, f = new E, m = new E, p = new E, g = 0, y = 0;
        for(let x = 0; x <= t.length - 1; x++)switch(x){
            case 0:
                g = t[x + 1].x - t[x].x, y = t[x + 1].y - t[x].y, f.x = y * 1, f.y = -g, f.z = y * 0, p.copy(f), f.normalize(), l.push(f.x, f.y, f.z);
                break;
            case t.length - 1:
                l.push(p.x, p.y, p.z);
                break;
            default:
                g = t[x + 1].x - t[x].x, y = t[x + 1].y - t[x].y, f.x = y * 1, f.y = -g, f.z = y * 0, m.copy(f), f.x += p.x, f.y += p.y, f.z += p.z, f.normalize(), l.push(f.x, f.y, f.z), p.copy(m);
        }
        for(let x = 0; x <= e; x++){
            let v = r + x * u1 * i, b = Math.sin(v), w = Math.cos(v);
            for(let A = 0; A <= t.length - 1; A++){
                h.x = t[A].x * b, h.y = t[A].y, h.z = t[A].x * w, o.push(h.x, h.y, h.z), d.x = x / e, d.y = A / (t.length - 1), a.push(d.x, d.y);
                let T = l[3 * A + 0] * b, S = l[3 * A + 1], M = l[3 * A + 0] * w;
                c.push(T, S, M);
            }
        }
        for(let x = 0; x < e; x++)for(let v = 0; v < t.length - 1; v++){
            let b = v + x * t.length, w = b, A = b + t.length, T = b + t.length + 1, S = b + 1;
            s1.push(w, A, S), s1.push(T, S, A);
        }
        this.setIndex(s1), this.setAttribute("position", new Te(o, 3)), this.setAttribute("uv", new Te(a, 2)), this.setAttribute("normal", new Te(c, 3));
    }
    static fromJSON(t) {
        return new sh(t.points, t.segments, t.phiStart, t.phiLength);
    }
};
var jc = class extends Ce {
    constructor(t = 1, e = 1, r = 1, i = 32, s1 = 1, o = !1, a = 0, l = Math.PI * 2){
        super(), this.type = "CylinderGeometry", this.parameters = {
            radiusTop: t,
            radiusBottom: e,
            height: r,
            radialSegments: i,
            heightSegments: s1,
            openEnded: o,
            thetaStart: a,
            thetaLength: l
        };
        let c = this;
        i = Math.floor(i), s1 = Math.floor(s1);
        let u1 = [], h = [], d = [], f = [], m = 0, p = [], g = r / 2, y = 0;
        x(), o === !1 && (t > 0 && v(!0), e > 0 && v(!1)), this.setIndex(u1), this.setAttribute("position", new Te(h, 3)), this.setAttribute("normal", new Te(d, 3)), this.setAttribute("uv", new Te(f, 2));
        function x() {
            let b = new E, w = new E, A = 0, T = (e - t) / r;
            for(let S = 0; S <= s1; S++){
                let M = [], C = S / s1, P = C * (e - t) + t;
                for(let _ = 0; _ <= i; _++){
                    let I = _ / i, O = I * l + a, L = Math.sin(O), j = Math.cos(O);
                    w.x = P * L, w.y = -C * r + g, w.z = P * j, h.push(w.x, w.y, w.z), b.set(L, T, j).normalize(), d.push(b.x, b.y, b.z), f.push(I, 1 - C), M.push(m++);
                }
                p.push(M);
            }
            for(let S = 0; S < i; S++)for(let M = 0; M < s1; M++){
                let C = p[M][S], P = p[M + 1][S], _ = p[M + 1][S + 1], I = p[M][S + 1];
                u1.push(C, P, I), u1.push(P, _, I), A += 6;
            }
            c.addGroup(y, A, 0), y += A;
        }
        function v(b) {
            let w = m, A = new U, T = new E, S = 0, M = b === !0 ? t : e, C = b === !0 ? 1 : -1;
            for(let _ = 1; _ <= i; _++)h.push(0, g * C, 0), d.push(0, C, 0), f.push(.5, .5), m++;
            let P = m;
            for(let _ = 0; _ <= i; _++){
                let O = _ / i * l + a, L = Math.cos(O), j = Math.sin(O);
                T.x = M * j, T.y = g * C, T.z = M * L, h.push(T.x, T.y, T.z), d.push(0, C, 0), A.x = L * .5 + .5, A.y = j * .5 * C + .5, f.push(A.x, A.y), m++;
            }
            for(let _ = 0; _ < i; _++){
                let I = w + _, O = P + _;
                b === !0 ? u1.push(O, O + 1, I) : u1.push(O + 1, O, I), S += 3;
            }
            c.addGroup(y, S, b === !0 ? 1 : 2), y += S;
        }
    }
    static fromJSON(t) {
        return new jc(t.radiusTop, t.radiusBottom, t.height, t.radialSegments, t.heightSegments, t.openEnded, t.thetaStart, t.thetaLength);
    }
}, Al = class extends jc {
    constructor(t = 1, e = 1, r = 32, i = 1, s1 = !1, o = 0, a = Math.PI * 2){
        super(0, t, e, r, i, s1, o, a), this.type = "ConeGeometry", this.parameters = {
            radius: t,
            height: e,
            radialSegments: r,
            heightSegments: i,
            openEnded: s1,
            thetaStart: o,
            thetaLength: a
        };
    }
    static fromJSON(t) {
        return new Al(t.radius, t.height, t.radialSegments, t.heightSegments, t.openEnded, t.thetaStart, t.thetaLength);
    }
}, oh = class extends Ce {
    constructor(t = [], e = [], r = 1, i = 0){
        super(), this.type = "PolyhedronGeometry", this.parameters = {
            vertices: t,
            indices: e,
            radius: r,
            detail: i
        };
        let s1 = [], o = [];
        a(i), c(r), u1(), this.setAttribute("position", new Te(s1, 3)), this.setAttribute("normal", new Te(s1.slice(), 3)), this.setAttribute("uv", new Te(o, 2)), i === 0 ? this.computeVertexNormals() : this.normalizeNormals();
        function a(x) {
            let v = new E, b = new E, w = new E;
            for(let A = 0; A < e.length; A += 3)f(e[A + 0], v), f(e[A + 1], b), f(e[A + 2], w), l(v, b, w, x);
        }
        function l(x, v, b, w) {
            let A = w + 1, T = [];
            for(let S = 0; S <= A; S++){
                T[S] = [];
                let M = x.clone().lerp(b, S / A), C = v.clone().lerp(b, S / A), P = A - S;
                for(let _ = 0; _ <= P; _++)_ === 0 && S === A ? T[S][_] = M : T[S][_] = M.clone().lerp(C, _ / P);
            }
            for(let S = 0; S < A; S++)for(let M = 0; M < 2 * (A - S) - 1; M++){
                let C = Math.floor(M / 2);
                M % 2 === 0 ? (d(T[S][C + 1]), d(T[S + 1][C]), d(T[S][C])) : (d(T[S][C + 1]), d(T[S + 1][C + 1]), d(T[S + 1][C]));
            }
        }
        function c(x) {
            let v = new E;
            for(let b = 0; b < s1.length; b += 3)v.x = s1[b + 0], v.y = s1[b + 1], v.z = s1[b + 2], v.normalize().multiplyScalar(x), s1[b + 0] = v.x, s1[b + 1] = v.y, s1[b + 2] = v.z;
        }
        function u1() {
            let x = new E;
            for(let v = 0; v < s1.length; v += 3){
                x.x = s1[v + 0], x.y = s1[v + 1], x.z = s1[v + 2];
                let b = g(x) / 2 / Math.PI + .5, w = y(x) / Math.PI + .5;
                o.push(b, 1 - w);
            }
            m(), h();
        }
        function h() {
            for(let x = 0; x < o.length; x += 6){
                let v = o[x + 0], b = o[x + 2], w = o[x + 4], A = Math.max(v, b, w), T = Math.min(v, b, w);
                A > .9 && T < .1 && (v < .2 && (o[x + 0] += 1), b < .2 && (o[x + 2] += 1), w < .2 && (o[x + 4] += 1));
            }
        }
        function d(x) {
            s1.push(x.x, x.y, x.z);
        }
        function f(x, v) {
            let b = x * 3;
            v.x = t[b + 0], v.y = t[b + 1], v.z = t[b + 2];
        }
        function m() {
            let x = new E, v = new E, b = new E, w = new E, A = new U, T = new U, S = new U;
            for(let M = 0, C = 0; M < s1.length; M += 9, C += 6){
                x.set(s1[M + 0], s1[M + 1], s1[M + 2]), v.set(s1[M + 3], s1[M + 4], s1[M + 5]), b.set(s1[M + 6], s1[M + 7], s1[M + 8]), A.set(o[C + 0], o[C + 1]), T.set(o[C + 2], o[C + 3]), S.set(o[C + 4], o[C + 5]), w.copy(x).add(v).add(b).divideScalar(3);
                let P = g(w);
                p(A, C + 0, x, P), p(T, C + 2, v, P), p(S, C + 4, b, P);
            }
        }
        function p(x, v, b, w) {
            w < 0 && x.x === 1 && (o[v] = x.x - 1), b.x === 0 && b.z === 0 && (o[v] = w / 2 / Math.PI + .5);
        }
        function g(x) {
            return Math.atan2(x.z, -x.x);
        }
        function y(x) {
            return Math.atan2(-x.y, Math.sqrt(x.x * x.x + x.z * x.z));
        }
    }
    static fromJSON(t) {
        return new oh(t.vertices, t.indices, t.radius, t.details);
    }
}, ah = class extends oh {
    constructor(t = 1, e = 0){
        let r = (1 + Math.sqrt(5)) / 2, i = 1 / r, s1 = [
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            0,
            -i,
            -r,
            0,
            -i,
            r,
            0,
            i,
            -r,
            0,
            i,
            r,
            -i,
            -r,
            0,
            -i,
            r,
            0,
            i,
            -r,
            0,
            i,
            r,
            0,
            -r,
            0,
            -i,
            r,
            0,
            -i,
            -r,
            0,
            i,
            r,
            0,
            i
        ], o = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(s1, o, t, e), this.type = "DodecahedronGeometry", this.parameters = {
            radius: t,
            detail: e
        };
    }
    static fromJSON(t) {
        return new ah(t.radius, t.detail);
    }
};
var Ca = class extends Gc {
    constructor(t){
        super(t), this.uuid = fs(), this.type = "Shape", this.holes = [];
    }
    getPointsHoles(t) {
        let e = [];
        for(let r = 0, i = this.holes.length; r < i; r++)e[r] = this.holes[r].getPoints(t);
        return e;
    }
    extractPoints(t) {
        return {
            shape: this.getPoints(t),
            holes: this.getPointsHoles(t)
        };
    }
    copy(t) {
        super.copy(t), this.holes = [];
        for(let e = 0, r = t.holes.length; e < r; e++){
            let i = t.holes[e];
            this.holes.push(i.clone());
        }
        return this;
    }
    toJSON() {
        let t = super.toJSON();
        t.uuid = this.uuid, t.holes = [];
        for(let e = 0, r = this.holes.length; e < r; e++){
            let i = this.holes[e];
            t.holes.push(i.toJSON());
        }
        return t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.uuid = t.uuid, this.holes = [];
        for(let e = 0, r = t.holes.length; e < r; e++){
            let i = t.holes[e];
            this.holes.push(new Gc().fromJSON(i));
        }
        return this;
    }
}, aj = {
    triangulate: function(n1, t, e = 2) {
        let r = t && t.length, i = r ? t[0] * e : n1.length, s1 = g_(n1, 0, i, e, !0), o = [];
        if (!s1 || s1.next === s1.prev) return o;
        let a, l, c, u1, h, d, f;
        if (r && (s1 = dj(n1, t, s1, e)), n1.length > 80 * e) {
            a = c = n1[0], l = u1 = n1[1];
            for(let m = e; m < i; m += e)h = n1[m], d = n1[m + 1], h < a && (a = h), d < l && (l = d), h > c && (c = h), d > u1 && (u1 = d);
            f = Math.max(c - a, u1 - l), f = f !== 0 ? 32767 / f : 0;
        }
        return Hp(s1, o, e, a, l, f, 0), o;
    }
};
function g_(n1, t, e, r, i) {
    let s1, o;
    if (i === Aj(n1, t, e, r) > 0) for(s1 = t; s1 < e; s1 += r)o = zP(s1, n1[s1], n1[s1 + 1], o);
    else for(s1 = e - r; s1 >= t; s1 -= r)o = zP(s1, n1[s1], n1[s1 + 1], o);
    return o && hv(o, o.next) && (qp(o), o = o.next), o;
}
function Hc(n1, t) {
    if (!n1) return n1;
    t || (t = n1);
    let e = n1, r;
    do if (r = !1, !e.steiner && (hv(e, e.next) || Xr(e.prev, e, e.next) === 0)) {
        if (qp(e), e = t = e.prev, e === e.next) break;
        r = !0;
    } else e = e.next;
    while (r || e !== t);
    return t;
}
function Hp(n1, t, e, r, i, s1, o) {
    if (!n1) return;
    !o && s1 && yj(n1, r, i, s1);
    let a = n1, l, c;
    for(; n1.prev !== n1.next;){
        if (l = n1.prev, c = n1.next, s1 ? cj(n1, r, i, s1) : lj(n1)) {
            t.push(l.i / e | 0), t.push(n1.i / e | 0), t.push(c.i / e | 0), qp(n1), n1 = c.next, a = c.next;
            continue;
        }
        if (n1 = c, n1 === a) {
            o ? o === 1 ? (n1 = uj(Hc(n1), t, e), Hp(n1, t, e, r, i, s1, 2)) : o === 2 && hj(n1, t, e, r, i, s1) : Hp(Hc(n1), t, e, r, i, s1, 1);
            break;
        }
    }
}
function lj(n1) {
    let t = n1.prev, e = n1, r = n1.next;
    if (Xr(t, e, r) >= 0) return !1;
    let i = t.x, s1 = e.x, o = r.x, a = t.y, l = e.y, c = r.y, u1 = i < s1 ? i < o ? i : o : s1 < o ? s1 : o, h = a < l ? a < c ? a : c : l < c ? l : c, d = i > s1 ? i > o ? i : o : s1 > o ? s1 : o, f = a > l ? a > c ? a : c : l > c ? l : c, m = r.next;
    for(; m !== t;){
        if (m.x >= u1 && m.x <= d && m.y >= h && m.y <= f && Ju(i, a, s1, l, o, c, m.x, m.y) && Xr(m.prev, m, m.next) >= 0) return !1;
        m = m.next;
    }
    return !0;
}
function cj(n1, t, e, r) {
    let i = n1.prev, s1 = n1, o = n1.next;
    if (Xr(i, s1, o) >= 0) return !1;
    let a = i.x, l = s1.x, c = o.x, u1 = i.y, h = s1.y, d = o.y, f = a < l ? a < c ? a : c : l < c ? l : c, m = u1 < h ? u1 < d ? u1 : d : h < d ? h : d, p = a > l ? a > c ? a : c : l > c ? l : c, g = u1 > h ? u1 > d ? u1 : d : h > d ? h : d, y = cw(f, m, t, e, r), x = cw(p, g, t, e, r), v = n1.prevZ, b = n1.nextZ;
    for(; v && v.z >= y && b && b.z <= x;){
        if (v.x >= f && v.x <= p && v.y >= m && v.y <= g && v !== i && v !== o && Ju(a, u1, l, h, c, d, v.x, v.y) && Xr(v.prev, v, v.next) >= 0 || (v = v.prevZ, b.x >= f && b.x <= p && b.y >= m && b.y <= g && b !== i && b !== o && Ju(a, u1, l, h, c, d, b.x, b.y) && Xr(b.prev, b, b.next) >= 0)) return !1;
        b = b.nextZ;
    }
    for(; v && v.z >= y;){
        if (v.x >= f && v.x <= p && v.y >= m && v.y <= g && v !== i && v !== o && Ju(a, u1, l, h, c, d, v.x, v.y) && Xr(v.prev, v, v.next) >= 0) return !1;
        v = v.prevZ;
    }
    for(; b && b.z <= x;){
        if (b.x >= f && b.x <= p && b.y >= m && b.y <= g && b !== i && b !== o && Ju(a, u1, l, h, c, d, b.x, b.y) && Xr(b.prev, b, b.next) >= 0) return !1;
        b = b.nextZ;
    }
    return !0;
}
function uj(n1, t, e) {
    let r = n1;
    do {
        let i = r.prev, s1 = r.next.next;
        !hv(i, s1) && y_(i, r, r.next, s1) && Wp(i, s1) && Wp(s1, i) && (t.push(i.i / e | 0), t.push(r.i / e | 0), t.push(s1.i / e | 0), qp(r), qp(r.next), r = n1 = s1), r = r.next;
    }while (r !== n1);
    return Hc(r);
}
function hj(n1, t, e, r, i, s1) {
    let o = n1;
    do {
        let a = o.next.next;
        for(; a !== o.prev;){
            if (o.i !== a.i && bj(o, a)) {
                let l = v_(o, a);
                o = Hc(o, o.next), l = Hc(l, l.next), Hp(o, t, e, r, i, s1, 0), Hp(l, t, e, r, i, s1, 0);
                return;
            }
            a = a.next;
        }
        o = o.next;
    }while (o !== n1);
}
function dj(n1, t, e, r) {
    let i = [], s1, o, a, l, c;
    for(s1 = 0, o = t.length; s1 < o; s1++)a = t[s1] * r, l = s1 < o - 1 ? t[s1 + 1] * r : n1.length, c = g_(n1, a, l, r, !1), c === c.next && (c.steiner = !0), i.push(xj(c));
    for(i.sort(fj), s1 = 0; s1 < i.length; s1++)e = pj(i[s1], e);
    return e;
}
function fj(n1, t) {
    return n1.x - t.x;
}
function pj(n1, t) {
    let e = mj(n1, t);
    if (!e) return t;
    let r = v_(e, n1);
    return Hc(r, r.next), Hc(e, e.next);
}
function mj(n1, t) {
    let e = t, r = -1 / 0, i, s1 = n1.x, o = n1.y;
    do {
        if (o <= e.y && o >= e.next.y && e.next.y !== e.y) {
            let d = e.x + (o - e.y) * (e.next.x - e.x) / (e.next.y - e.y);
            if (d <= s1 && d > r && (r = d, i = e.x < e.next.x ? e : e.next, d === s1)) return i;
        }
        e = e.next;
    }while (e !== t);
    if (!i) return null;
    let a = i, l = i.x, c = i.y, u1 = 1 / 0, h;
    e = i;
    do s1 >= e.x && e.x >= l && s1 !== e.x && Ju(o < c ? s1 : r, o, l, c, o < c ? r : s1, o, e.x, e.y) && (h = Math.abs(o - e.y) / (s1 - e.x), Wp(e, n1) && (h < u1 || h === u1 && (e.x > i.x || e.x === i.x && gj(i, e))) && (i = e, u1 = h)), e = e.next;
    while (e !== a);
    return i;
}
function gj(n1, t) {
    return Xr(n1.prev, n1, t.prev) < 0 && Xr(t.next, n1, n1.next) < 0;
}
function yj(n1, t, e, r) {
    let i = n1;
    do i.z === 0 && (i.z = cw(i.x, i.y, t, e, r)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
    while (i !== n1);
    i.prevZ.nextZ = null, i.prevZ = null, vj(i);
}
function vj(n1) {
    let t, e, r, i, s1, o, a, l, c = 1;
    do {
        for(e = n1, n1 = null, s1 = null, o = 0; e;){
            for(o++, r = e, a = 0, t = 0; t < c && (a++, r = r.nextZ, !!r); t++);
            for(l = c; a > 0 || l > 0 && r;)a !== 0 && (l === 0 || !r || e.z <= r.z) ? (i = e, e = e.nextZ, a--) : (i = r, r = r.nextZ, l--), s1 ? s1.nextZ = i : n1 = i, i.prevZ = s1, s1 = i;
            e = r;
        }
        s1.nextZ = null, c *= 2;
    }while (o > 1);
    return n1;
}
function cw(n1, t, e, r, i) {
    return n1 = (n1 - e) * i | 0, t = (t - r) * i | 0, n1 = (n1 | n1 << 8) & 16711935, n1 = (n1 | n1 << 4) & 252645135, n1 = (n1 | n1 << 2) & 858993459, n1 = (n1 | n1 << 1) & 1431655765, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, n1 | t << 1;
}
function xj(n1) {
    let t = n1, e = n1;
    do (t.x < e.x || t.x === e.x && t.y < e.y) && (e = t), t = t.next;
    while (t !== n1);
    return e;
}
function Ju(n1, t, e, r, i, s1, o, a) {
    return (i - o) * (t - a) >= (n1 - o) * (s1 - a) && (n1 - o) * (r - a) >= (e - o) * (t - a) && (e - o) * (s1 - a) >= (i - o) * (r - a);
}
function bj(n1, t) {
    return n1.next.i !== t.i && n1.prev.i !== t.i && !Sj(n1, t) && (Wp(n1, t) && Wp(t, n1) && wj(n1, t) && (Xr(n1.prev, n1, t.prev) || Xr(n1, t.prev, t)) || hv(n1, t) && Xr(n1.prev, n1, n1.next) > 0 && Xr(t.prev, t, t.next) > 0);
}
function Xr(n1, t, e) {
    return (t.y - n1.y) * (e.x - t.x) - (t.x - n1.x) * (e.y - t.y);
}
function hv(n1, t) {
    return n1.x === t.x && n1.y === t.y;
}
function y_(n1, t, e, r) {
    let i = Cy(Xr(n1, t, e)), s1 = Cy(Xr(n1, t, r)), o = Cy(Xr(e, r, n1)), a = Cy(Xr(e, r, t));
    return !!(i !== s1 && o !== a || i === 0 && My(n1, e, t) || s1 === 0 && My(n1, r, t) || o === 0 && My(e, n1, r) || a === 0 && My(e, t, r));
}
function My(n1, t, e) {
    return t.x <= Math.max(n1.x, e.x) && t.x >= Math.min(n1.x, e.x) && t.y <= Math.max(n1.y, e.y) && t.y >= Math.min(n1.y, e.y);
}
function Cy(n1) {
    return n1 > 0 ? 1 : n1 < 0 ? -1 : 0;
}
function Sj(n1, t) {
    let e = n1;
    do {
        if (e.i !== n1.i && e.next.i !== n1.i && e.i !== t.i && e.next.i !== t.i && y_(e, e.next, n1, t)) return !0;
        e = e.next;
    }while (e !== n1);
    return !1;
}
function Wp(n1, t) {
    return Xr(n1.prev, n1, n1.next) < 0 ? Xr(n1, t, n1.next) >= 0 && Xr(n1, n1.prev, t) >= 0 : Xr(n1, t, n1.prev) < 0 || Xr(n1, n1.next, t) < 0;
}
function wj(n1, t) {
    let e = n1, r = !1, i = (n1.x + t.x) / 2, s1 = (n1.y + t.y) / 2;
    do e.y > s1 != e.next.y > s1 && e.next.y !== e.y && i < (e.next.x - e.x) * (s1 - e.y) / (e.next.y - e.y) + e.x && (r = !r), e = e.next;
    while (e !== n1);
    return r;
}
function v_(n1, t) {
    let e = new uw(n1.i, n1.x, n1.y), r = new uw(t.i, t.x, t.y), i = n1.next, s1 = t.prev;
    return n1.next = t, t.prev = n1, e.next = i, i.prev = e, r.next = e, e.prev = r, s1.next = r, r.prev = s1, r;
}
function zP(n1, t, e, r) {
    let i = new uw(n1, t, e);
    return r ? (i.next = r.next, i.prev = r, r.next.prev = i, r.next = i) : (i.prev = i, i.next = i), i;
}
function qp(n1) {
    n1.next.prev = n1.prev, n1.prev.next = n1.next, n1.prevZ && (n1.prevZ.nextZ = n1.nextZ), n1.nextZ && (n1.nextZ.prevZ = n1.prevZ);
}
function uw(n1, t, e) {
    this.i = n1, this.x = t, this.y = e, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
}
function Aj(n1, t, e, r) {
    let i = 0;
    for(let s1 = t, o = e - r; s1 < e; s1 += r)i += (n1[o] - n1[s1]) * (n1[s1 + 1] + n1[o + 1]), o = s1;
    return i;
}
var lh = class {
    static area(t) {
        let e = t.length, r = 0;
        for(let i = e - 1, s1 = 0; s1 < e; i = s1++)r += t[i].x * t[s1].y - t[s1].x * t[i].y;
        return r * .5;
    }
    static isClockWise(t) {
        return lh.area(t) < 0;
    }
    static triangulateShape(t, e) {
        let r = [], i = [], s1 = [];
        GP(t), jP(r, t);
        let o = t.length;
        e.forEach(GP);
        for(let l = 0; l < e.length; l++)i.push(o), o += e[l].length, jP(r, e[l]);
        let a = aj.triangulate(r, i);
        for(let l = 0; l < a.length; l += 3)s1.push(a.slice(l, l + 3));
        return s1;
    }
};
function GP(n1) {
    let t = n1.length;
    t > 2 && n1[t - 1].equals(n1[0]) && n1.pop();
}
function jP(n1, t) {
    for(let e = 0; e < t.length; e++)n1.push(t[e].x), n1.push(t[e].y);
}
var ch = class extends oh {
    constructor(t = 1, e = 0){
        let r = (1 + Math.sqrt(5)) / 2, i = [
            -1,
            r,
            0,
            1,
            r,
            0,
            -1,
            -r,
            0,
            1,
            -r,
            0,
            0,
            -1,
            r,
            0,
            1,
            r,
            0,
            -1,
            -r,
            0,
            1,
            -r,
            r,
            0,
            -1,
            r,
            0,
            1,
            -r,
            0,
            -1,
            -r,
            0,
            1
        ], s1 = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(i, s1, t, e), this.type = "IcosahedronGeometry", this.parameters = {
            radius: t,
            detail: e
        };
    }
    static fromJSON(t) {
        return new ch(t.radius, t.detail);
    }
};
var qs = class extends Ce {
    constructor(t = 1, e = 32, r = 16, i = 0, s1 = Math.PI * 2, o = 0, a = Math.PI){
        super(), this.type = "SphereGeometry", this.parameters = {
            radius: t,
            widthSegments: e,
            heightSegments: r,
            phiStart: i,
            phiLength: s1,
            thetaStart: o,
            thetaLength: a
        }, e = Math.max(3, Math.floor(e)), r = Math.max(2, Math.floor(r));
        let l = Math.min(o + a, Math.PI), c = 0, u1 = [], h = new E, d = new E, f = [], m = [], p = [], g = [];
        for(let y = 0; y <= r; y++){
            let x = [], v = y / r, b = 0;
            y == 0 && o == 0 ? b = .5 / e : y == r && l == Math.PI && (b = -0.5 / e);
            for(let w = 0; w <= e; w++){
                let A = w / e;
                h.x = -t * Math.cos(i + A * s1) * Math.sin(o + v * a), h.y = t * Math.cos(o + v * a), h.z = t * Math.sin(i + A * s1) * Math.sin(o + v * a), m.push(h.x, h.y, h.z), d.copy(h).normalize(), p.push(d.x, d.y, d.z), g.push(A + b, 1 - v), x.push(c++);
            }
            u1.push(x);
        }
        for(let y = 0; y < r; y++)for(let x = 0; x < e; x++){
            let v = u1[y][x + 1], b = u1[y][x], w = u1[y + 1][x], A = u1[y + 1][x + 1];
            (y !== 0 || o > 0) && f.push(v, b, A), (y !== r - 1 || l < Math.PI) && f.push(b, w, A);
        }
        this.setIndex(f), this.setAttribute("position", new Te(m, 3)), this.setAttribute("normal", new Te(p, 3)), this.setAttribute("uv", new Te(g, 2));
    }
    static fromJSON(t) {
        return new qs(t.radius, t.widthSegments, t.heightSegments, t.phiStart, t.phiLength, t.thetaStart, t.thetaLength);
    }
};
var uh = class extends Ce {
    constructor(t = 1, e = .4, r = 12, i = 48, s1 = Math.PI * 2){
        super(), this.type = "TorusGeometry", this.parameters = {
            radius: t,
            tube: e,
            radialSegments: r,
            tubularSegments: i,
            arc: s1
        }, r = Math.floor(r), i = Math.floor(i);
        let o = [], a = [], l = [], c = [], u1 = new E, h = new E, d = new E;
        for(let f = 0; f <= r; f++)for(let m = 0; m <= i; m++){
            let p = m / i * s1, g = f / r * Math.PI * 2;
            h.x = (t + e * Math.cos(g)) * Math.cos(p), h.y = (t + e * Math.cos(g)) * Math.sin(p), h.z = e * Math.sin(g), a.push(h.x, h.y, h.z), u1.x = t * Math.cos(p), u1.y = t * Math.sin(p), d.subVectors(h, u1).normalize(), l.push(d.x, d.y, d.z), c.push(m / i), c.push(f / r);
        }
        for(let f = 1; f <= r; f++)for(let m = 1; m <= i; m++){
            let p = (i + 1) * f + m - 1, g = (i + 1) * (f - 1) + m - 1, y = (i + 1) * (f - 1) + m, x = (i + 1) * f + m;
            o.push(p, g, x), o.push(g, y, x);
        }
        this.setIndex(o), this.setAttribute("position", new Te(a, 3)), this.setAttribute("normal", new Te(l, 3)), this.setAttribute("uv", new Te(c, 2));
    }
    static fromJSON(t) {
        return new uh(t.radius, t.tube, t.radialSegments, t.tubularSegments, t.arc);
    }
}, hh = class extends Ce {
    constructor(t = 1, e = .4, r = 64, i = 8, s1 = 2, o = 3){
        super(), this.type = "TorusKnotGeometry", this.parameters = {
            radius: t,
            tube: e,
            tubularSegments: r,
            radialSegments: i,
            p: s1,
            q: o
        }, r = Math.floor(r), i = Math.floor(i);
        let a = [], l = [], c = [], u1 = [], h = new E, d = new E, f = new E, m = new E, p = new E, g = new E, y = new E;
        for(let v = 0; v <= r; ++v){
            let b = v / r * s1 * Math.PI * 2;
            x(b, s1, o, t, f), x(b + .01, s1, o, t, m), g.subVectors(m, f), y.addVectors(m, f), p.crossVectors(g, y), y.crossVectors(p, g), p.normalize(), y.normalize();
            for(let w = 0; w <= i; ++w){
                let A = w / i * Math.PI * 2, T = -e * Math.cos(A), S = e * Math.sin(A);
                h.x = f.x + (T * y.x + S * p.x), h.y = f.y + (T * y.y + S * p.y), h.z = f.z + (T * y.z + S * p.z), l.push(h.x, h.y, h.z), d.subVectors(h, f).normalize(), c.push(d.x, d.y, d.z), u1.push(v / r), u1.push(w / i);
            }
        }
        for(let v = 1; v <= r; v++)for(let b = 1; b <= i; b++){
            let w = (i + 1) * (v - 1) + (b - 1), A = (i + 1) * v + (b - 1), T = (i + 1) * v + b, S = (i + 1) * (v - 1) + b;
            a.push(w, A, S), a.push(A, T, S);
        }
        this.setIndex(a), this.setAttribute("position", new Te(l, 3)), this.setAttribute("normal", new Te(c, 3)), this.setAttribute("uv", new Te(u1, 2));
        function x(v, b, w, A, T) {
            let S = Math.cos(v), M = Math.sin(v), C = w / b * v, P = Math.cos(C);
            T.x = A * (2 + P) * .5 * S, T.y = A * (2 + P) * M * .5, T.z = A * Math.sin(C) * .5;
        }
    }
    static fromJSON(t) {
        return new hh(t.radius, t.tube, t.tubularSegments, t.radialSegments, t.p, t.q);
    }
};
var Yy = class extends $e {
    constructor(t){
        super(t), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
    }
};
function pl(n1, t, e) {
    return x_(n1) ? new n1.constructor(n1.subarray(t, e !== void 0 ? e : n1.length)) : n1.slice(t, e);
}
function Py(n1, t, e) {
    return !n1 || !e && n1.constructor === t ? n1 : typeof t.BYTES_PER_ELEMENT == "number" ? new t(n1) : Array.prototype.slice.call(n1);
}
function x_(n1) {
    return ArrayBuffer.isView(n1) && !(n1 instanceof DataView);
}
function Ej(n1) {
    function t(i, s1) {
        return n1[i] - n1[s1];
    }
    let e = n1.length, r = new Array(e);
    for(let i = 0; i !== e; ++i)r[i] = i;
    return r.sort(t), r;
}
function HP(n1, t, e) {
    let r = n1.length, i = new n1.constructor(r);
    for(let s1 = 0, o = 0; o !== r; ++s1){
        let a = e[s1] * t;
        for(let l = 0; l !== t; ++l)i[o++] = n1[a + l];
    }
    return i;
}
function b_(n1, t, e, r) {
    let i = 1, s1 = n1[0];
    for(; s1 !== void 0 && s1[r] === void 0;)s1 = n1[i++];
    if (s1 === void 0) return;
    let o = s1[r];
    if (o !== void 0) {
        if (Array.isArray(o)) do o = s1[r], o !== void 0 && (t.push(s1.time), e.push.apply(e, o)), s1 = n1[i++];
        while (s1 !== void 0);
        else if (o.toArray !== void 0) do o = s1[r], o !== void 0 && (t.push(s1.time), o.toArray(e, e.length)), s1 = n1[i++];
        while (s1 !== void 0);
        else do o = s1[r], o !== void 0 && (t.push(s1.time), e.push(o)), s1 = n1[i++];
        while (s1 !== void 0);
    }
}
var dh = class {
    constructor(t, e, r, i){
        this.parameterPositions = t, this._cachedIndex = 0, this.resultBuffer = i !== void 0 ? i : new e.constructor(r), this.sampleValues = e, this.valueSize = r, this.settings = null, this.DefaultSettings_ = {};
    }
    evaluate(t) {
        let e = this.parameterPositions, r = this._cachedIndex, i = e[r], s1 = e[r - 1];
        e: {
            t: {
                let o;
                r: {
                    i: if (!(t < i)) {
                        for(let a = r + 2;;){
                            if (i === void 0) {
                                if (t < s1) break i;
                                return r = e.length, this._cachedIndex = r, this.copySampleValue_(r - 1);
                            }
                            if (r === a) break;
                            if (s1 = i, i = e[++r], t < i) break t;
                        }
                        o = e.length;
                        break r;
                    }
                    if (!(t >= s1)) {
                        let a = e[1];
                        t < a && (r = 2, s1 = a);
                        for(let l = r - 2;;){
                            if (s1 === void 0) return this._cachedIndex = 0, this.copySampleValue_(0);
                            if (r === l) break;
                            if (i = s1, s1 = e[--r - 1], t >= s1) break t;
                        }
                        o = r, r = 0;
                        break r;
                    }
                    break e;
                }
                for(; r < o;){
                    let a = r + o >>> 1;
                    t < e[a] ? o = a : r = a + 1;
                }
                if (i = e[r], s1 = e[r - 1], s1 === void 0) return this._cachedIndex = 0, this.copySampleValue_(0);
                if (i === void 0) return r = e.length, this._cachedIndex = r, this.copySampleValue_(r - 1);
            }
            this._cachedIndex = r, this.intervalChanged_(r, s1, i);
        }
        return this.interpolate_(r, s1, t, i);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(t) {
        let e = this.resultBuffer, r = this.sampleValues, i = this.valueSize, s1 = t * i;
        for(let o = 0; o !== i; ++o)e[o] = r[s1 + o];
        return e;
    }
    interpolate_() {
        throw new Error("call to abstract method");
    }
    intervalChanged_() {}
}, hw = class extends dh {
    constructor(t, e, r, i){
        super(t, e, r, i), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
            endingStart: Ku,
            endingEnd: Ku
        };
    }
    intervalChanged_(t, e, r) {
        let i = this.parameterPositions, s1 = t - 2, o = t + 1, a = i[s1], l = i[o];
        if (a === void 0) switch(this.getSettings_().endingStart){
            case Qu:
                s1 = t, a = 2 * e - r;
                break;
            case Ny:
                s1 = i.length - 2, a = e + i[s1] - i[s1 + 1];
                break;
            default:
                s1 = t, a = r;
        }
        if (l === void 0) switch(this.getSettings_().endingEnd){
            case Qu:
                o = t, l = 2 * r - e;
                break;
            case Ny:
                o = 1, l = r + i[1] - i[0];
                break;
            default:
                o = t - 1, l = e;
        }
        let c = (r - e) * .5, u1 = this.valueSize;
        this._weightPrev = c / (e - a), this._weightNext = c / (l - r), this._offsetPrev = s1 * u1, this._offsetNext = o * u1;
    }
    interpolate_(t, e, r, i) {
        let s1 = this.resultBuffer, o = this.sampleValues, a = this.valueSize, l = t * a, c = l - a, u1 = this._offsetPrev, h = this._offsetNext, d = this._weightPrev, f = this._weightNext, m = (r - e) / (i - e), p = m * m, g = p * m, y = -d * g + 2 * d * p - d * m, x = (1 + d) * g + (-1.5 - 2 * d) * p + (-0.5 + d) * m + 1, v = (-1 - f) * g + (1.5 + f) * p + .5 * m, b = f * g - f * p;
        for(let w = 0; w !== a; ++w)s1[w] = y * o[u1 + w] + x * o[c + w] + v * o[l + w] + b * o[h + w];
        return s1;
    }
}, Ky = class extends dh {
    constructor(t, e, r, i){
        super(t, e, r, i);
    }
    interpolate_(t, e, r, i) {
        let s1 = this.resultBuffer, o = this.sampleValues, a = this.valueSize, l = t * a, c = l - a, u1 = (r - e) / (i - e), h = 1 - u1;
        for(let d = 0; d !== a; ++d)s1[d] = o[c + d] * h + o[l + d] * u1;
        return s1;
    }
}, dw = class extends dh {
    constructor(t, e, r, i){
        super(t, e, r, i);
    }
    interpolate_(t) {
        return this.copySampleValue_(t - 1);
    }
}, ys = class {
    constructor(t, e, r, i){
        if (t === void 0) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (e === void 0 || e.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + t);
        this.name = t, this.times = Py(e, this.TimeBufferType), this.values = Py(r, this.ValueBufferType), this.setInterpolation(i || this.DefaultInterpolation);
    }
    static toJSON(t) {
        let e = t.constructor, r;
        if (e.toJSON !== this.toJSON) r = e.toJSON(t);
        else {
            r = {
                name: t.name,
                times: Py(t.times, Array),
                values: Py(t.values, Array)
            };
            let i = t.getInterpolation();
            i !== t.DefaultInterpolation && (r.interpolation = i);
        }
        return r.type = t.ValueTypeName, r;
    }
    InterpolantFactoryMethodDiscrete(t) {
        return new dw(this.times, this.values, this.getValueSize(), t);
    }
    InterpolantFactoryMethodLinear(t) {
        return new Ky(this.times, this.values, this.getValueSize(), t);
    }
    InterpolantFactoryMethodSmooth(t) {
        return new hw(this.times, this.values, this.getValueSize(), t);
    }
    setInterpolation(t) {
        let e;
        switch(t){
            case Ry:
                e = this.InterpolantFactoryMethodDiscrete;
                break;
            case Ly:
                e = this.InterpolantFactoryMethodLinear;
                break;
            case uS:
                e = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (e === void 0) {
            let r = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === void 0) {
                if (t !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(r);
            }
            return console.warn("THREE.KeyframeTrack:", r), this;
        }
        return this.createInterpolant = e, this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return Ry;
            case this.InterpolantFactoryMethodLinear:
                return Ly;
            case this.InterpolantFactoryMethodSmooth:
                return uS;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    shift(t) {
        if (t !== 0) {
            let e = this.times;
            for(let r = 0, i = e.length; r !== i; ++r)e[r] += t;
        }
        return this;
    }
    scale(t) {
        if (t !== 1) {
            let e = this.times;
            for(let r = 0, i = e.length; r !== i; ++r)e[r] *= t;
        }
        return this;
    }
    trim(t, e) {
        let r = this.times, i = r.length, s1 = 0, o = i - 1;
        for(; s1 !== i && r[s1] < t;)++s1;
        for(; o !== -1 && r[o] > e;)--o;
        if (++o, s1 !== 0 || o !== i) {
            s1 >= o && (o = Math.max(o, 1), s1 = o - 1);
            let a = this.getValueSize();
            this.times = pl(r, s1, o), this.values = pl(this.values, s1 * a, o * a);
        }
        return this;
    }
    validate() {
        let t = !0, e = this.getValueSize();
        e - Math.floor(e) !== 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), t = !1);
        let r = this.times, i = this.values, s1 = r.length;
        s1 === 0 && (console.error("THREE.KeyframeTrack: Track is empty.", this), t = !1);
        let o = null;
        for(let a = 0; a !== s1; a++){
            let l = r[a];
            if (typeof l == "number" && isNaN(l)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, a, l), t = !1;
                break;
            }
            if (o !== null && o > l) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, a, l, o), t = !1;
                break;
            }
            o = l;
        }
        if (i !== void 0 && x_(i)) for(let a = 0, l = i.length; a !== l; ++a){
            let c = i[a];
            if (isNaN(c)) {
                console.error("THREE.KeyframeTrack: Value is not a valid number.", this, a, c), t = !1;
                break;
            }
        }
        return t;
    }
    optimize() {
        let t = pl(this.times), e = pl(this.values), r = this.getValueSize(), i = this.getInterpolation() === uS, s1 = t.length - 1, o = 1;
        for(let a = 1; a < s1; ++a){
            let l = !1, c = t[a], u1 = t[a + 1];
            if (c !== u1 && (a !== 1 || c !== t[0])) {
                if (i) l = !0;
                else {
                    let h = a * r, d = h - r, f = h + r;
                    for(let m = 0; m !== r; ++m){
                        let p = e[h + m];
                        if (p !== e[d + m] || p !== e[f + m]) {
                            l = !0;
                            break;
                        }
                    }
                }
            }
            if (l) {
                if (a !== o) {
                    t[o] = t[a];
                    let h = a * r, d = o * r;
                    for(let f = 0; f !== r; ++f)e[d + f] = e[h + f];
                }
                ++o;
            }
        }
        if (s1 > 0) {
            t[o] = t[s1];
            for(let a = s1 * r, l = o * r, c = 0; c !== r; ++c)e[l + c] = e[a + c];
            ++o;
        }
        return o !== t.length ? (this.times = pl(t, 0, o), this.values = pl(e, 0, o * r)) : (this.times = t, this.values = e), this;
    }
    clone() {
        let t = pl(this.times, 0), e = pl(this.values, 0), r = this.constructor, i = new r(this.name, t, e);
        return i.createInterpolant = this.createInterpolant, i;
    }
};
ys.prototype.TimeBufferType = Float32Array;
ys.prototype.ValueBufferType = Float32Array;
ys.prototype.DefaultInterpolation = Ly;
var El = class extends ys {
};
El.prototype.ValueTypeName = "bool";
El.prototype.ValueBufferType = Array;
El.prototype.DefaultInterpolation = Ry;
El.prototype.InterpolantFactoryMethodLinear = void 0;
El.prototype.InterpolantFactoryMethodSmooth = void 0;
var Qy = class extends ys {
};
Qy.prototype.ValueTypeName = "color";
var fh = class extends ys {
};
fh.prototype.ValueTypeName = "number";
var fw = class extends dh {
    constructor(t, e, r, i){
        super(t, e, r, i);
    }
    interpolate_(t, e, r, i) {
        let s1 = this.resultBuffer, o = this.sampleValues, a = this.valueSize, l = (r - e) / (i - e), c = t * a;
        for(let u1 = c + a; c !== u1; c += 4)Ye.slerpFlat(s1, 0, o, c - a, o, c, l);
        return s1;
    }
}, Wc = class extends ys {
    InterpolantFactoryMethodLinear(t) {
        return new fw(this.times, this.values, this.getValueSize(), t);
    }
};
Wc.prototype.ValueTypeName = "quaternion";
Wc.prototype.DefaultInterpolation = Ly;
Wc.prototype.InterpolantFactoryMethodSmooth = void 0;
var Tl = class extends ys {
};
Tl.prototype.ValueTypeName = "string";
Tl.prototype.ValueBufferType = Array;
Tl.prototype.DefaultInterpolation = Ry;
Tl.prototype.InterpolantFactoryMethodLinear = void 0;
Tl.prototype.InterpolantFactoryMethodSmooth = void 0;
var ph = class extends ys {
};
ph.prototype.ValueTypeName = "vector";
var mh = class {
    constructor(t, e = -1, r, i = Mw){
        this.name = t, this.tracks = r, this.duration = e, this.blendMode = i, this.uuid = fs(), this.duration < 0 && this.resetDuration();
    }
    static parse(t) {
        let e = [], r = t.tracks, i = 1 / (t.fps || 1);
        for(let o = 0, a = r.length; o !== a; ++o)e.push(Mj(r[o]).scale(i));
        let s1 = new this(t.name, t.duration, e, t.blendMode);
        return s1.uuid = t.uuid, s1;
    }
    static toJSON(t) {
        let e = [], r = t.tracks, i = {
            name: t.name,
            duration: t.duration,
            tracks: e,
            uuid: t.uuid,
            blendMode: t.blendMode
        };
        for(let s1 = 0, o = r.length; s1 !== o; ++s1)e.push(ys.toJSON(r[s1]));
        return i;
    }
    static CreateFromMorphTargetSequence(t, e, r, i) {
        let s1 = e.length, o = [];
        for(let a = 0; a < s1; a++){
            let l = [], c = [];
            l.push((a + s1 - 1) % s1, a, (a + 1) % s1), c.push(0, 1, 0);
            let u1 = Ej(l);
            l = HP(l, 1, u1), c = HP(c, 1, u1), !i && l[0] === 0 && (l.push(s1), c.push(c[0])), o.push(new fh(".morphTargetInfluences[" + e[a].name + "]", l, c).scale(1 / r));
        }
        return new this(t, -1, o);
    }
    static findByName(t, e) {
        let r = t;
        if (!Array.isArray(t)) {
            let i = t;
            r = i.geometry && i.geometry.animations || i.animations;
        }
        for(let i = 0; i < r.length; i++)if (r[i].name === e) return r[i];
        return null;
    }
    static CreateClipsFromMorphTargetSequences(t, e, r) {
        let i = {}, s1 = /^([\w-]*?)([\d]+)$/;
        for(let a = 0, l = t.length; a < l; a++){
            let c = t[a], u1 = c.name.match(s1);
            if (u1 && u1.length > 1) {
                let h = u1[1], d = i[h];
                d || (i[h] = d = []), d.push(c);
            }
        }
        let o = [];
        for(let a in i)o.push(this.CreateFromMorphTargetSequence(a, i[a], e, r));
        return o;
    }
    static parseAnimation(t, e) {
        if (!t) return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;
        let r = function(h, d, f, m, p) {
            if (f.length !== 0) {
                let g = [], y = [];
                b_(f, g, y, m), g.length !== 0 && p.push(new h(d, g, y));
            }
        }, i = [], s1 = t.name || "default", o = t.fps || 30, a = t.blendMode, l = t.length || -1, c = t.hierarchy || [];
        for(let h = 0; h < c.length; h++){
            let d = c[h].keys;
            if (!(!d || d.length === 0)) {
                if (d[0].morphTargets) {
                    let f = {}, m;
                    for(m = 0; m < d.length; m++)if (d[m].morphTargets) for(let p = 0; p < d[m].morphTargets.length; p++)f[d[m].morphTargets[p]] = -1;
                    for(let p in f){
                        let g = [], y = [];
                        for(let x = 0; x !== d[m].morphTargets.length; ++x){
                            let v = d[m];
                            g.push(v.time), y.push(v.morphTarget === p ? 1 : 0);
                        }
                        i.push(new fh(".morphTargetInfluence[" + p + "]", g, y));
                    }
                    l = f.length * o;
                } else {
                    let f = ".bones[" + e[h].name + "]";
                    r(ph, f + ".position", d, "pos", i), r(Wc, f + ".quaternion", d, "rot", i), r(ph, f + ".scale", d, "scl", i);
                }
            }
        }
        return i.length === 0 ? null : new this(s1, l, i, a);
    }
    resetDuration() {
        let t = this.tracks, e = 0;
        for(let r = 0, i = t.length; r !== i; ++r){
            let s1 = this.tracks[r];
            e = Math.max(e, s1.times[s1.times.length - 1]);
        }
        return this.duration = e, this;
    }
    trim() {
        for(let t = 0; t < this.tracks.length; t++)this.tracks[t].trim(0, this.duration);
        return this;
    }
    validate() {
        let t = !0;
        for(let e = 0; e < this.tracks.length; e++)t = t && this.tracks[e].validate();
        return t;
    }
    optimize() {
        for(let t = 0; t < this.tracks.length; t++)this.tracks[t].optimize();
        return this;
    }
    clone() {
        let t = [];
        for(let e = 0; e < this.tracks.length; e++)t.push(this.tracks[e].clone());
        return new this.constructor(this.name, this.duration, t, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
};
function Tj(n1) {
    switch(n1.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return fh;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return ph;
        case "color":
            return Qy;
        case "quaternion":
            return Wc;
        case "bool":
        case "boolean":
            return El;
        case "string":
            return Tl;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + n1);
}
function Mj(n1) {
    if (n1.type === void 0) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    let t = Tj(n1.type);
    if (n1.times === void 0) {
        let e = [], r = [];
        b_(n1.keys, e, r, "value"), n1.times = e, n1.values = r;
    }
    return t.parse !== void 0 ? t.parse(n1) : new t(n1.name, n1.times, n1.values, n1.interpolation);
}
var Zy = {
    enabled: !1,
    files: {},
    add: function(n1, t) {
        this.enabled !== !1 && (this.files[n1] = t);
    },
    get: function(n1) {
        if (this.enabled !== !1) return this.files[n1];
    },
    remove: function(n1) {
        delete this.files[n1];
    },
    clear: function() {
        this.files = {};
    }
}, Xp = class {
    constructor(t, e, r){
        let i = this, s1 = !1, o = 0, a = 0, l, c = [];
        this.onStart = void 0, this.onLoad = t, this.onProgress = e, this.onError = r, this.itemStart = function(u1) {
            a++, s1 === !1 && i.onStart !== void 0 && i.onStart(u1, o, a), s1 = !0;
        }, this.itemEnd = function(u1) {
            o++, i.onProgress !== void 0 && i.onProgress(u1, o, a), o === a && (s1 = !1, i.onLoad !== void 0 && i.onLoad());
        }, this.itemError = function(u1) {
            i.onError !== void 0 && i.onError(u1);
        }, this.resolveURL = function(u1) {
            return l ? l(u1) : u1;
        }, this.setURLModifier = function(u1) {
            return l = u1, this;
        }, this.addHandler = function(u1, h) {
            return c.push(u1, h), this;
        }, this.removeHandler = function(u1) {
            let h = c.indexOf(u1);
            return h !== -1 && c.splice(h, 2), this;
        }, this.getHandler = function(u1) {
            for(let h = 0, d = c.length; h < d; h += 2){
                let f = c[h], m = c[h + 1];
                if (f.global && (f.lastIndex = 0), f.test(u1)) return m;
            }
            return null;
        };
    }
}, Cj = new Xp, Ml = class {
    constructor(t){
        this.manager = t !== void 0 ? t : Cj, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
    }
    load() {}
    loadAsync(t, e) {
        let r = this;
        return new Promise(function(i, s1) {
            r.load(t, i, e, s1);
        });
    }
    parse() {}
    setCrossOrigin(t) {
        return this.crossOrigin = t, this;
    }
    setWithCredentials(t) {
        return this.withCredentials = t, this;
    }
    setPath(t) {
        return this.path = t, this;
    }
    setResourcePath(t) {
        return this.resourcePath = t, this;
    }
    setRequestHeader(t) {
        return this.requestHeader = t, this;
    }
}, Ea = {}, pw = class extends Error {
    constructor(t, e){
        super(t), this.response = e;
    }
}, gh = class extends Ml {
    constructor(t){
        super(t);
    }
    load(t, e, r, i) {
        t === void 0 && (t = ""), this.path !== void 0 && (t = this.path + t), t = this.manager.resolveURL(t);
        let s1 = Zy.get(t);
        if (s1 !== void 0) return this.manager.itemStart(t), setTimeout(()=>{
            e && e(s1), this.manager.itemEnd(t);
        }, 0), s1;
        if (Ea[t] !== void 0) {
            Ea[t].push({
                onLoad: e,
                onProgress: r,
                onError: i
            });
            return;
        }
        Ea[t] = [], Ea[t].push({
            onLoad: e,
            onProgress: r,
            onError: i
        });
        let o = new Request(t, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        }), a = this.mimeType, l = this.responseType;
        fetch(o).then((c)=>{
            if (c.status === 200 || c.status === 0) {
                if (c.status === 0 && console.warn("THREE.FileLoader: HTTP Status 0 received."), typeof ReadableStream > "u" || c.body === void 0 || c.body.getReader === void 0) return c;
                let u1 = Ea[t], h = c.body.getReader(), d = c.headers.get("Content-Length") || c.headers.get("X-File-Size"), f = d ? parseInt(d) : 0, m = f !== 0, p = 0, g = new ReadableStream({
                    start (y) {
                        x();
                        function x() {
                            h.read().then(({ done: v, value: b })=>{
                                if (v) y.close();
                                else {
                                    p += b.byteLength;
                                    let w = new ProgressEvent("progress", {
                                        lengthComputable: m,
                                        loaded: p,
                                        total: f
                                    });
                                    for(let A = 0, T = u1.length; A < T; A++){
                                        let S = u1[A];
                                        S.onProgress && S.onProgress(w);
                                    }
                                    y.enqueue(b), x();
                                }
                            });
                        }
                    }
                });
                return new Response(g);
            } else throw new pw(`fetch for "${c.url}" responded with ${c.status}: ${c.statusText}`, c);
        }).then((c)=>{
            switch(l){
                case "arraybuffer":
                    return c.arrayBuffer();
                case "blob":
                    return c.blob();
                case "document":
                    return c.text().then((u1)=>new DOMParser().parseFromString(u1, a));
                case "json":
                    return c.json();
                default:
                    if (a === void 0) return c.text();
                    {
                        let h = /charset="?([^;"\s]*)"?/i.exec(a), d = h && h[1] ? h[1].toLowerCase() : void 0, f = new TextDecoder(d);
                        return c.arrayBuffer().then((m)=>f.decode(m));
                    }
            }
        }).then((c)=>{
            Zy.add(t, c);
            let u1 = Ea[t];
            delete Ea[t];
            for(let h = 0, d = u1.length; h < d; h++){
                let f = u1[h];
                f.onLoad && f.onLoad(c);
            }
        }).catch((c)=>{
            let u1 = Ea[t];
            if (u1 === void 0) throw this.manager.itemError(t), c;
            delete Ea[t];
            for(let h = 0, d = u1.length; h < d; h++){
                let f = u1[h];
                f.onError && f.onError(c);
            }
            this.manager.itemError(t);
        }).finally(()=>{
            this.manager.itemEnd(t);
        }), this.manager.itemStart(t);
    }
    setResponseType(t) {
        return this.responseType = t, this;
    }
    setMimeType(t) {
        return this.mimeType = t, this;
    }
};
var mw = class extends Ml {
    constructor(t){
        super(t);
    }
    load(t, e, r, i) {
        this.path !== void 0 && (t = this.path + t), t = this.manager.resolveURL(t);
        let s1 = this, o = Zy.get(t);
        if (o !== void 0) return s1.manager.itemStart(t), setTimeout(function() {
            e && e(o), s1.manager.itemEnd(t);
        }, 0), o;
        let a = Fp("img");
        function l() {
            u1(), Zy.add(t, this), e && e(this), s1.manager.itemEnd(t);
        }
        function c(h) {
            u1(), i && i(h), s1.manager.itemError(t), s1.manager.itemEnd(t);
        }
        function u1() {
            a.removeEventListener("load", l, !1), a.removeEventListener("error", c, !1);
        }
        return a.addEventListener("load", l, !1), a.addEventListener("error", c, !1), t.slice(0, 5) !== "data:" && this.crossOrigin !== void 0 && (a.crossOrigin = this.crossOrigin), s1.manager.itemStart(t), a.src = t, a;
    }
};
var Jy = class extends Ml {
    constructor(t){
        super(t);
    }
    load(t, e, r, i) {
        let s1 = new Zt, o = new mw(this.manager);
        return o.setCrossOrigin(this.crossOrigin), o.setPath(this.path), o.load(t, function(a) {
            s1.image = a, s1.needsUpdate = !0, e !== void 0 && e(s1);
        }, r, i), s1;
    }
}, Cl = class extends Dt {
    constructor(t, e = 1){
        super(), this.isLight = !0, this.type = "Light", this.color = new Ge(t), this.intensity = e;
    }
    dispose() {}
    copy(t, e) {
        return super.copy(t, e), this.color.copy(t.color), this.intensity = t.intensity, this;
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return e.object.color = this.color.getHex(), e.object.intensity = this.intensity, this.groundColor !== void 0 && (e.object.groundColor = this.groundColor.getHex()), this.distance !== void 0 && (e.object.distance = this.distance), this.angle !== void 0 && (e.object.angle = this.angle), this.decay !== void 0 && (e.object.decay = this.decay), this.penumbra !== void 0 && (e.object.penumbra = this.penumbra), this.shadow !== void 0 && (e.object.shadow = this.shadow.toJSON()), e;
    }
}, $y = class extends Cl {
    constructor(t, e, r){
        super(t, r), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy(Dt.DEFAULT_UP), this.updateMatrix(), this.groundColor = new Ge(e);
    }
    copy(t, e) {
        return super.copy(t, e), this.groundColor.copy(t.groundColor), this;
    }
}, US = new ue, WP = new E, qP = new E, Yp = class {
    constructor(t){
        this.camera = t, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new U(512, 512), this.map = null, this.mapPass = null, this.matrix = new ue, this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new Up, this._frameExtents = new U(1, 1), this._viewportCount = 1, this._viewports = [
            new Ze(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(t) {
        let e = this.camera, r = this.matrix;
        WP.setFromMatrixPosition(t.matrixWorld), e.position.copy(WP), qP.setFromMatrixPosition(t.target.matrixWorld), e.lookAt(qP), e.updateMatrixWorld(), US.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), this._frustum.setFromProjectionMatrix(US), r.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), r.multiply(US);
    }
    getViewport(t) {
        return this._viewports[t];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
    }
    copy(t) {
        return this.camera = t.camera.clone(), this.bias = t.bias, this.radius = t.radius, this.mapSize.copy(t.mapSize), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        let t = {};
        return this.bias !== 0 && (t.bias = this.bias), this.normalBias !== 0 && (t.normalBias = this.normalBias), this.radius !== 1 && (t.radius = this.radius), (this.mapSize.x !== 512 || this.mapSize.y !== 512) && (t.mapSize = this.mapSize.toArray()), t.camera = this.camera.toJSON(!1).object, delete t.camera.matrix, t;
    }
}, gw = class extends Yp {
    constructor(){
        super(new si(50, 1, .5, 500)), this.isSpotLightShadow = !0, this.focus = 1;
    }
    updateMatrices(t) {
        let e = this.camera, r = Bp * 2 * t.angle * this.focus, i = this.mapSize.width / this.mapSize.height, s1 = t.distance || e.far;
        (r !== e.fov || i !== e.aspect || s1 !== e.far) && (e.fov = r, e.aspect = i, e.far = s1, e.updateProjectionMatrix()), super.updateMatrices(t);
    }
    copy(t) {
        return super.copy(t), this.focus = t.focus, this;
    }
}, ev = class extends Cl {
    constructor(t, e, r = 0, i = Math.PI / 3, s1 = 0, o = 2){
        super(t, e), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy(Dt.DEFAULT_UP), this.updateMatrix(), this.target = new Dt, this.distance = r, this.angle = i, this.penumbra = s1, this.decay = o, this.map = null, this.shadow = new gw;
    }
    get power() {
        return this.intensity * Math.PI;
    }
    set power(t) {
        this.intensity = t / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t, e) {
        return super.copy(t, e), this.distance = t.distance, this.angle = t.angle, this.penumbra = t.penumbra, this.decay = t.decay, this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
    }
}, XP = new ue, Cp = new E, kS = new E, yw = class extends Yp {
    constructor(){
        super(new si(90, 1, .5, 500)), this.isPointLightShadow = !0, this._frameExtents = new U(4, 2), this._viewportCount = 6, this._viewports = [
            new Ze(2, 1, 1, 1),
            new Ze(0, 1, 1, 1),
            new Ze(3, 1, 1, 1),
            new Ze(1, 1, 1, 1),
            new Ze(3, 0, 1, 1),
            new Ze(1, 0, 1, 1)
        ], this._cubeDirections = [
            new E(1, 0, 0),
            new E(-1, 0, 0),
            new E(0, 0, 1),
            new E(0, 0, -1),
            new E(0, 1, 0),
            new E(0, -1, 0)
        ], this._cubeUps = [
            new E(0, 1, 0),
            new E(0, 1, 0),
            new E(0, 1, 0),
            new E(0, 1, 0),
            new E(0, 0, 1),
            new E(0, 0, -1)
        ];
    }
    updateMatrices(t, e = 0) {
        let r = this.camera, i = this.matrix, s1 = t.distance || r.far;
        s1 !== r.far && (r.far = s1, r.updateProjectionMatrix()), Cp.setFromMatrixPosition(t.matrixWorld), r.position.copy(Cp), kS.copy(r.position), kS.add(this._cubeDirections[e]), r.up.copy(this._cubeUps[e]), r.lookAt(kS), r.updateMatrixWorld(), i.makeTranslation(-Cp.x, -Cp.y, -Cp.z), XP.multiplyMatrices(r.projectionMatrix, r.matrixWorldInverse), this._frustum.setFromProjectionMatrix(XP);
    }
}, tv = class extends Cl {
    constructor(t, e, r = 0, i = 2){
        super(t, e), this.isPointLight = !0, this.type = "PointLight", this.distance = r, this.decay = i, this.shadow = new yw;
    }
    get power() {
        return this.intensity * 4 * Math.PI;
    }
    set power(t) {
        this.intensity = t / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t, e) {
        return super.copy(t, e), this.distance = t.distance, this.decay = t.decay, this.shadow = t.shadow.clone(), this;
    }
}, vw = class extends Yp {
    constructor(){
        super(new bl(-5, 5, 5, -5, .5, 500)), this.isDirectionalLightShadow = !0;
    }
}, rv = class extends Cl {
    constructor(t, e){
        super(t, e), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(Dt.DEFAULT_UP), this.updateMatrix(), this.target = new Dt, this.shadow = new vw;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t) {
        return super.copy(t), this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
    }
};
var Kp = class extends Ce {
    constructor(){
        super(), this.isInstancedBufferGeometry = !0, this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
    }
    copy(t) {
        return super.copy(t), this.instanceCount = t.instanceCount, this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.instanceCount = this.instanceCount, t.isInstancedBufferGeometry = !0, t;
    }
}, yh = class extends Ml {
    constructor(t){
        super(t);
    }
    load(t, e, r, i) {
        let s1 = this, o = new gh(s1.manager);
        o.setPath(s1.path), o.setRequestHeader(s1.requestHeader), o.setWithCredentials(s1.withCredentials), o.load(t, function(a) {
            try {
                e(s1.parse(JSON.parse(a)));
            } catch (l) {
                i ? i(l) : console.error(l), s1.manager.itemError(t);
            }
        }, r, i);
    }
    parse(t) {
        let e = {}, r = {};
        function i(f, m) {
            if (e[m] !== void 0) return e[m];
            let g = f.interleavedBuffers[m], y = s1(f, g.buffer), x = ny(g.type, y), v = new Hy(x, g.stride);
            return v.uuid = g.uuid, e[m] = v, v;
        }
        function s1(f, m) {
            if (r[m] !== void 0) return r[m];
            let g = f.arrayBuffers[m], y = new Uint32Array(g).buffer;
            return r[m] = y, y;
        }
        let o = t.isInstancedBufferGeometry ? new Kp : new Ce, a = t.data.index;
        if (a !== void 0) {
            let f = ny(a.type, a.array);
            o.setIndex(new je(f, 1));
        }
        let l = t.data.attributes;
        for(let f in l){
            let m = l[f], p;
            if (m.isInterleavedBufferAttribute) {
                let g = i(t.data, m.data);
                p = new Vc(g, m.itemSize, m.offset, m.normalized);
            } else {
                let g = ny(m.type, m.array), y = m.isInstancedBufferAttribute ? Mo : je;
                p = new y(g, m.itemSize, m.normalized);
            }
            m.name !== void 0 && (p.name = m.name), m.usage !== void 0 && p.setUsage(m.usage), m.updateRange !== void 0 && (p.updateRange.offset = m.updateRange.offset, p.updateRange.count = m.updateRange.count), o.setAttribute(f, p);
        }
        let c = t.data.morphAttributes;
        if (c) for(let f in c){
            let m = c[f], p = [];
            for(let g = 0, y = m.length; g < y; g++){
                let x = m[g], v;
                if (x.isInterleavedBufferAttribute) {
                    let b = i(t.data, x.data);
                    v = new Vc(b, x.itemSize, x.offset, x.normalized);
                } else {
                    let b = ny(x.type, x.array);
                    v = new je(b, x.itemSize, x.normalized);
                }
                x.name !== void 0 && (v.name = x.name), p.push(v);
            }
            o.morphAttributes[f] = p;
        }
        t.data.morphTargetsRelative && (o.morphTargetsRelative = !0);
        let h = t.data.groups || t.data.drawcalls || t.data.offsets;
        if (h !== void 0) for(let f = 0, m = h.length; f !== m; ++f){
            let p = h[f];
            o.addGroup(p.start, p.count, p.materialIndex);
        }
        let d = t.data.boundingSphere;
        if (d !== void 0) {
            let f = new E;
            d.center !== void 0 && f.fromArray(d.center), o.boundingSphere = new ei(f, d.radius);
        }
        return t.name && (o.name = t.name), t.userData && (o.userData = t.userData), o;
    }
};
var iv = class {
    constructor(t = !0){
        this.autoStart = t, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
    }
    start() {
        this.startTime = YP(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
    }
    stop() {
        this.getElapsedTime(), this.running = !1, this.autoStart = !1;
    }
    getElapsedTime() {
        return this.getDelta(), this.elapsedTime;
    }
    getDelta() {
        let t = 0;
        if (this.autoStart && !this.running) return this.start(), 0;
        if (this.running) {
            let e = YP();
            t = (e - this.oldTime) / 1e3, this.oldTime = e, this.elapsedTime += t;
        }
        return t;
    }
};
function YP() {
    return (typeof performance > "u" ? Date : performance).now();
}
var xw = class {
    constructor(t, e, r){
        this.binding = t, this.valueSize = r;
        let i, s1, o;
        switch(e){
            case "quaternion":
                i = this._slerp, s1 = this._slerpAdditive, o = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(r * 6), this._workIndex = 5;
                break;
            case "string":
            case "bool":
                i = this._select, s1 = this._select, o = this._setAdditiveIdentityOther, this.buffer = new Array(r * 5);
                break;
            default:
                i = this._lerp, s1 = this._lerpAdditive, o = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(r * 5);
        }
        this._mixBufferRegion = i, this._mixBufferRegionAdditive = s1, this._setIdentity = o, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
    }
    accumulate(t, e) {
        let r = this.buffer, i = this.valueSize, s1 = t * i + i, o = this.cumulativeWeight;
        if (o === 0) {
            for(let a = 0; a !== i; ++a)r[s1 + a] = r[a];
            o = e;
        } else {
            o += e;
            let a = e / o;
            this._mixBufferRegion(r, s1, 0, a, i);
        }
        this.cumulativeWeight = o;
    }
    accumulateAdditive(t) {
        let e = this.buffer, r = this.valueSize, i = r * this._addIndex;
        this.cumulativeWeightAdditive === 0 && this._setIdentity(), this._mixBufferRegionAdditive(e, i, 0, t, r), this.cumulativeWeightAdditive += t;
    }
    apply(t) {
        let e = this.valueSize, r = this.buffer, i = t * e + e, s1 = this.cumulativeWeight, o = this.cumulativeWeightAdditive, a = this.binding;
        if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, s1 < 1) {
            let l = e * this._origIndex;
            this._mixBufferRegion(r, i, l, 1 - s1, e);
        }
        o > 0 && this._mixBufferRegionAdditive(r, i, this._addIndex * e, 1, e);
        for(let l = e, c = e + e; l !== c; ++l)if (r[l] !== r[l + e]) {
            a.setValue(r, i);
            break;
        }
    }
    saveOriginalState() {
        let t = this.binding, e = this.buffer, r = this.valueSize, i = r * this._origIndex;
        t.getValue(e, i);
        for(let s1 = r, o = i; s1 !== o; ++s1)e[s1] = e[i + s1 % r];
        this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
    }
    restoreOriginalState() {
        let t = this.valueSize * 3;
        this.binding.setValue(this.buffer, t);
    }
    _setAdditiveIdentityNumeric() {
        let t = this._addIndex * this.valueSize, e = t + this.valueSize;
        for(let r = t; r < e; r++)this.buffer[r] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        let t = this._origIndex * this.valueSize, e = this._addIndex * this.valueSize;
        for(let r = 0; r < this.valueSize; r++)this.buffer[e + r] = this.buffer[t + r];
    }
    _select(t, e, r, i, s1) {
        if (i >= .5) for(let o = 0; o !== s1; ++o)t[e + o] = t[r + o];
    }
    _slerp(t, e, r, i) {
        Ye.slerpFlat(t, e, t, e, t, r, i);
    }
    _slerpAdditive(t, e, r, i, s1) {
        let o = this._workIndex * s1;
        Ye.multiplyQuaternionsFlat(t, o, t, e, t, r), Ye.slerpFlat(t, e, t, e, t, o, i);
    }
    _lerp(t, e, r, i, s1) {
        let o = 1 - i;
        for(let a = 0; a !== s1; ++a){
            let l = e + a;
            t[l] = t[l] * o + t[r + a] * i;
        }
    }
    _lerpAdditive(t, e, r, i, s1) {
        for(let o = 0; o !== s1; ++o){
            let a = e + o;
            t[a] = t[a] + t[r + o] * i;
        }
    }
}, Ow = "\\[\\]\\.:\\/", Pj = new RegExp("[" + Ow + "]", "g"), Rw = "[^" + Ow + "]", _j = "[^" + Ow.replace("\\.", "") + "]", Ij = /((?:WC+[\/:])*)/.source.replace("WC", Rw), Dj = /(WCOD+)?/.source.replace("WCOD", _j), Oj = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", Rw), Rj = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", Rw), Lj = new RegExp("^" + Ij + Dj + Oj + Rj + "$"), Nj = [
    "material",
    "materials",
    "bones",
    "map"
], bw = class {
    constructor(t, e, r){
        let i = r || sr.parseTrackName(e);
        this._targetGroup = t, this._bindings = t.subscribe_(e, i);
    }
    getValue(t, e) {
        this.bind();
        let r = this._targetGroup.nCachedObjects_, i = this._bindings[r];
        i !== void 0 && i.getValue(t, e);
    }
    setValue(t, e) {
        let r = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, s1 = r.length; i !== s1; ++i)r[i].setValue(t, e);
    }
    bind() {
        let t = this._bindings;
        for(let e = this._targetGroup.nCachedObjects_, r = t.length; e !== r; ++e)t[e].bind();
    }
    unbind() {
        let t = this._bindings;
        for(let e = this._targetGroup.nCachedObjects_, r = t.length; e !== r; ++e)t[e].unbind();
    }
}, sr = class {
    constructor(t, e, r){
        this.path = e, this.parsedPath = r || sr.parseTrackName(e), this.node = sr.findNode(t, this.parsedPath.nodeName) || t, this.rootNode = t, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
    static create(t, e, r) {
        return t && t.isAnimationObjectGroup ? new sr.Composite(t, e, r) : new sr(t, e, r);
    }
    static sanitizeNodeName(t) {
        return t.replace(/\s/g, "_").replace(Pj, "");
    }
    static parseTrackName(t) {
        let e = Lj.exec(t);
        if (e === null) throw new Error("PropertyBinding: Cannot parse trackName: " + t);
        let r = {
            nodeName: e[2],
            objectName: e[3],
            objectIndex: e[4],
            propertyName: e[5],
            propertyIndex: e[6]
        }, i = r.nodeName && r.nodeName.lastIndexOf(".");
        if (i !== void 0 && i !== -1) {
            let s1 = r.nodeName.substring(i + 1);
            Nj.indexOf(s1) !== -1 && (r.nodeName = r.nodeName.substring(0, i), r.objectName = s1);
        }
        if (r.propertyName === null || r.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + t);
        return r;
    }
    static findNode(t, e) {
        if (e === void 0 || e === "" || e === "." || e === -1 || e === t.name || e === t.uuid) return t;
        if (t.skeleton) {
            let r = t.skeleton.getBoneByName(e);
            if (r !== void 0) return r;
        }
        if (t.children) {
            let r = function(s1) {
                for(let o = 0; o < s1.length; o++){
                    let a = s1[o];
                    if (a.name === e || a.uuid === e) return a;
                    let l = r(a.children);
                    if (l) return l;
                }
                return null;
            }, i = r(t.children);
            if (i) return i;
        }
        return null;
    }
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    _getValue_direct(t, e) {
        t[e] = this.targetObject[this.propertyName];
    }
    _getValue_array(t, e) {
        let r = this.resolvedProperty;
        for(let i = 0, s1 = r.length; i !== s1; ++i)t[e++] = r[i];
    }
    _getValue_arrayElement(t, e) {
        t[e] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(t, e) {
        this.resolvedProperty.toArray(t, e);
    }
    _setValue_direct(t, e) {
        this.targetObject[this.propertyName] = t[e];
    }
    _setValue_direct_setNeedsUpdate(t, e) {
        this.targetObject[this.propertyName] = t[e], this.targetObject.needsUpdate = !0;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(t, e) {
        this.targetObject[this.propertyName] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_array(t, e) {
        let r = this.resolvedProperty;
        for(let i = 0, s1 = r.length; i !== s1; ++i)r[i] = t[e++];
    }
    _setValue_array_setNeedsUpdate(t, e) {
        let r = this.resolvedProperty;
        for(let i = 0, s1 = r.length; i !== s1; ++i)r[i] = t[e++];
        this.targetObject.needsUpdate = !0;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(t, e) {
        let r = this.resolvedProperty;
        for(let i = 0, s1 = r.length; i !== s1; ++i)r[i] = t[e++];
        this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_arrayElement(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e];
    }
    _setValue_arrayElement_setNeedsUpdate(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.needsUpdate = !0;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_fromArray(t, e) {
        this.resolvedProperty.fromArray(t, e);
    }
    _setValue_fromArray_setNeedsUpdate(t, e) {
        this.resolvedProperty.fromArray(t, e), this.targetObject.needsUpdate = !0;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(t, e) {
        this.resolvedProperty.fromArray(t, e), this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _getValue_unbound(t, e) {
        this.bind(), this.getValue(t, e);
    }
    _setValue_unbound(t, e) {
        this.bind(), this.setValue(t, e);
    }
    bind() {
        let t = this.node, e = this.parsedPath, r = e.objectName, i = e.propertyName, s1 = e.propertyIndex;
        if (t || (t = sr.findNode(this.rootNode, e.nodeName) || this.rootNode, this.node = t), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !t) {
            console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
            return;
        }
        if (r) {
            let c = e.objectIndex;
            switch(r){
                case "materials":
                    if (!t.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!t.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    t = t.material.materials;
                    break;
                case "bones":
                    if (!t.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    t = t.skeleton.bones;
                    for(let u1 = 0; u1 < t.length; u1++)if (t[u1].name === c) {
                        c = u1;
                        break;
                    }
                    break;
                case "map":
                    if ("map" in t) {
                        t = t.map;
                        break;
                    }
                    if (!t.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!t.material.map) {
                        console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                        return;
                    }
                    t = t.material.map;
                    break;
                default:
                    if (t[r] === void 0) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    t = t[r];
            }
            if (c !== void 0) {
                if (t[c] === void 0) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t);
                    return;
                }
                t = t[c];
            }
        }
        let o = t[i];
        if (o === void 0) {
            let c = e.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + c + "." + i + " but it wasn't found.", t);
            return;
        }
        let a = this.Versioning.None;
        this.targetObject = t, t.needsUpdate !== void 0 ? a = this.Versioning.NeedsUpdate : t.matrixWorldNeedsUpdate !== void 0 && (a = this.Versioning.MatrixWorldNeedsUpdate);
        let l = this.BindingType.Direct;
        if (s1 !== void 0) {
            if (i === "morphTargetInfluences") {
                if (!t.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (!t.geometry.morphAttributes) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                    return;
                }
                t.morphTargetDictionary[s1] !== void 0 && (s1 = t.morphTargetDictionary[s1]);
            }
            l = this.BindingType.ArrayElement, this.resolvedProperty = o, this.propertyIndex = s1;
        } else o.fromArray !== void 0 && o.toArray !== void 0 ? (l = this.BindingType.HasFromToArray, this.resolvedProperty = o) : Array.isArray(o) ? (l = this.BindingType.EntireArray, this.resolvedProperty = o) : this.propertyName = i;
        this.getValue = this.GetterByBindingType[l], this.setValue = this.SetterByBindingTypeAndVersioning[l][a];
    }
    unbind() {
        this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
};
sr.Composite = bw;
sr.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
sr.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
sr.prototype.GetterByBindingType = [
    sr.prototype._getValue_direct,
    sr.prototype._getValue_array,
    sr.prototype._getValue_arrayElement,
    sr.prototype._getValue_toArray
];
sr.prototype.SetterByBindingTypeAndVersioning = [
    [
        sr.prototype._setValue_direct,
        sr.prototype._setValue_direct_setNeedsUpdate,
        sr.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        sr.prototype._setValue_array,
        sr.prototype._setValue_array_setNeedsUpdate,
        sr.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        sr.prototype._setValue_arrayElement,
        sr.prototype._setValue_arrayElement_setNeedsUpdate,
        sr.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        sr.prototype._setValue_fromArray,
        sr.prototype._setValue_fromArray_setNeedsUpdate,
        sr.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
var Sw = class {
    constructor(t, e, r = null, i = e.blendMode){
        this._mixer = t, this._clip = e, this._localRoot = r, this.blendMode = i;
        let s1 = e.tracks, o = s1.length, a = new Array(o), l = {
            endingStart: Ku,
            endingEnd: Ku
        };
        for(let c = 0; c !== o; ++c){
            let u1 = s1[c].createInterpolant(null);
            a[c] = u1, u1.settings = l;
        }
        this._interpolantSettings = l, this._interpolants = a, this._propertyBindings = new Array(o), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = Tw, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
    }
    play() {
        return this._mixer._activateAction(this), this;
    }
    stop() {
        return this._mixer._deactivateAction(this), this.reset();
    }
    reset() {
        return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(t) {
        return this._startTime = t, this;
    }
    setLoop(t, e) {
        return this.loop = t, this.repetitions = e, this;
    }
    setEffectiveWeight(t) {
        return this.weight = t, this._effectiveWeight = this.enabled ? t : 0, this.stopFading();
    }
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(t) {
        return this._scheduleFading(t, 0, 1);
    }
    fadeOut(t) {
        return this._scheduleFading(t, 1, 0);
    }
    crossFadeFrom(t, e, r) {
        if (t.fadeOut(e), this.fadeIn(e), r) {
            let i = this._clip.duration, s1 = t._clip.duration, o = s1 / i, a = i / s1;
            t.warp(1, o, e), this.warp(a, 1, e);
        }
        return this;
    }
    crossFadeTo(t, e, r) {
        return t.crossFadeFrom(this, e, r);
    }
    stopFading() {
        let t = this._weightInterpolant;
        return t !== null && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(t)), this;
    }
    setEffectiveTimeScale(t) {
        return this.timeScale = t, this._effectiveTimeScale = this.paused ? 0 : t, this.stopWarping();
    }
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(t) {
        return this.timeScale = this._clip.duration / t, this.stopWarping();
    }
    syncWith(t) {
        return this.time = t.time, this.timeScale = t.timeScale, this.stopWarping();
    }
    halt(t) {
        return this.warp(this._effectiveTimeScale, 0, t);
    }
    warp(t, e, r) {
        let i = this._mixer, s1 = i.time, o = this.timeScale, a = this._timeScaleInterpolant;
        a === null && (a = i._lendControlInterpolant(), this._timeScaleInterpolant = a);
        let l = a.parameterPositions, c = a.sampleValues;
        return l[0] = s1, l[1] = s1 + r, c[0] = t / o, c[1] = e / o, this;
    }
    stopWarping() {
        let t = this._timeScaleInterpolant;
        return t !== null && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(t)), this;
    }
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    _update(t, e, r, i) {
        if (!this.enabled) {
            this._updateWeight(t);
            return;
        }
        let s1 = this._startTime;
        if (s1 !== null) {
            let l = (t - s1) * r;
            l < 0 || r === 0 ? e = 0 : (this._startTime = null, e = r * l);
        }
        e *= this._updateTimeScale(t);
        let o = this._updateTime(e), a = this._updateWeight(t);
        if (a > 0) {
            let l = this._interpolants, c = this._propertyBindings;
            switch(this.blendMode){
                case YU:
                    for(let u1 = 0, h = l.length; u1 !== h; ++u1)l[u1].evaluate(o), c[u1].accumulateAdditive(a);
                    break;
                case Mw:
                default:
                    for(let u1 = 0, h = l.length; u1 !== h; ++u1)l[u1].evaluate(o), c[u1].accumulate(i, a);
            }
        }
    }
    _updateWeight(t) {
        let e = 0;
        if (this.enabled) {
            e = this.weight;
            let r = this._weightInterpolant;
            if (r !== null) {
                let i = r.evaluate(t)[0];
                e *= i, t > r.parameterPositions[1] && (this.stopFading(), i === 0 && (this.enabled = !1));
            }
        }
        return this._effectiveWeight = e, e;
    }
    _updateTimeScale(t) {
        let e = 0;
        if (!this.paused) {
            e = this.timeScale;
            let r = this._timeScaleInterpolant;
            if (r !== null) {
                let i = r.evaluate(t)[0];
                e *= i, t > r.parameterPositions[1] && (this.stopWarping(), e === 0 ? this.paused = !0 : this.timeScale = e);
            }
        }
        return this._effectiveTimeScale = e, e;
    }
    _updateTime(t) {
        let e = this._clip.duration, r = this.loop, i = this.time + t, s1 = this._loopCount, o = r === Jp;
        if (t === 0) return s1 === -1 ? i : o && (s1 & 1) === 1 ? e - i : i;
        if (r === Ew) {
            s1 === -1 && (this._loopCount = 0, this._setEndings(!0, !0, !1));
            e: {
                if (i >= e) i = e;
                else if (i < 0) i = 0;
                else {
                    this.time = i;
                    break e;
                }
                this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = i, this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: t < 0 ? -1 : 1
                });
            }
        } else {
            if (s1 === -1 && (t >= 0 ? (s1 = 0, this._setEndings(!0, this.repetitions === 0, o)) : this._setEndings(this.repetitions === 0, !0, o)), i >= e || i < 0) {
                let a = Math.floor(i / e);
                i -= e * a, s1 += Math.abs(a);
                let l = this.repetitions - s1;
                if (l <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, i = t > 0 ? e : 0, this.time = i, this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: t > 0 ? 1 : -1
                });
                else {
                    if (l === 1) {
                        let c = t < 0;
                        this._setEndings(c, !c, o);
                    } else this._setEndings(!1, !1, o);
                    this._loopCount = s1, this.time = i, this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: a
                    });
                }
            } else this.time = i;
            if (o && (s1 & 1) === 1) return e - i;
        }
        return i;
    }
    _setEndings(t, e, r) {
        let i = this._interpolantSettings;
        r ? (i.endingStart = Qu, i.endingEnd = Qu) : (t ? i.endingStart = this.zeroSlopeAtStart ? Qu : Ku : i.endingStart = Ny, e ? i.endingEnd = this.zeroSlopeAtEnd ? Qu : Ku : i.endingEnd = Ny);
    }
    _scheduleFading(t, e, r) {
        let i = this._mixer, s1 = i.time, o = this._weightInterpolant;
        o === null && (o = i._lendControlInterpolant(), this._weightInterpolant = o);
        let a = o.parameterPositions, l = o.sampleValues;
        return a[0] = s1, l[0] = e, a[1] = s1 + t, l[1] = r, this;
    }
}, Bj = new Float32Array(1), nv = class extends ar {
    constructor(t){
        super(), this._root = t, this._initMemoryManager(), this._accuIndex = 0, this.time = 0, this.timeScale = 1;
    }
    _bindAction(t, e) {
        let r = t._localRoot || this._root, i = t._clip.tracks, s1 = i.length, o = t._propertyBindings, a = t._interpolants, l = r.uuid, c = this._bindingsByRootAndName, u1 = c[l];
        u1 === void 0 && (u1 = {}, c[l] = u1);
        for(let h = 0; h !== s1; ++h){
            let d = i[h], f = d.name, m = u1[f];
            if (m !== void 0) ++m.referenceCount, o[h] = m;
            else {
                if (m = o[h], m !== void 0) {
                    m._cacheIndex === null && (++m.referenceCount, this._addInactiveBinding(m, l, f));
                    continue;
                }
                let p = e && e._propertyBindings[h].binding.parsedPath;
                m = new xw(sr.create(r, f, p), d.ValueTypeName, d.getValueSize()), ++m.referenceCount, this._addInactiveBinding(m, l, f), o[h] = m;
            }
            a[h].resultBuffer = m.buffer;
        }
    }
    _activateAction(t) {
        if (!this._isActiveAction(t)) {
            if (t._cacheIndex === null) {
                let r = (t._localRoot || this._root).uuid, i = t._clip.uuid, s1 = this._actionsByClip[i];
                this._bindAction(t, s1 && s1.knownActions[0]), this._addInactiveAction(t, i, r);
            }
            let e = t._propertyBindings;
            for(let r = 0, i = e.length; r !== i; ++r){
                let s1 = e[r];
                s1.useCount++ === 0 && (this._lendBinding(s1), s1.saveOriginalState());
            }
            this._lendAction(t);
        }
    }
    _deactivateAction(t) {
        if (this._isActiveAction(t)) {
            let e = t._propertyBindings;
            for(let r = 0, i = e.length; r !== i; ++r){
                let s1 = e[r];
                --s1.useCount === 0 && (s1.restoreOriginalState(), this._takeBackBinding(s1));
            }
            this._takeBackAction(t);
        }
    }
    _initMemoryManager() {
        this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
        let t = this;
        this.stats = {
            actions: {
                get total () {
                    return t._actions.length;
                },
                get inUse () {
                    return t._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return t._bindings.length;
                },
                get inUse () {
                    return t._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return t._controlInterpolants.length;
                },
                get inUse () {
                    return t._nActiveControlInterpolants;
                }
            }
        };
    }
    _isActiveAction(t) {
        let e = t._cacheIndex;
        return e !== null && e < this._nActiveActions;
    }
    _addInactiveAction(t, e, r) {
        let i = this._actions, s1 = this._actionsByClip, o = s1[e];
        if (o === void 0) o = {
            knownActions: [
                t
            ],
            actionByRoot: {}
        }, t._byClipCacheIndex = 0, s1[e] = o;
        else {
            let a = o.knownActions;
            t._byClipCacheIndex = a.length, a.push(t);
        }
        t._cacheIndex = i.length, i.push(t), o.actionByRoot[r] = t;
    }
    _removeInactiveAction(t) {
        let e = this._actions, r = e[e.length - 1], i = t._cacheIndex;
        r._cacheIndex = i, e[i] = r, e.pop(), t._cacheIndex = null;
        let s1 = t._clip.uuid, o = this._actionsByClip, a = o[s1], l = a.knownActions, c = l[l.length - 1], u1 = t._byClipCacheIndex;
        c._byClipCacheIndex = u1, l[u1] = c, l.pop(), t._byClipCacheIndex = null;
        let h = a.actionByRoot, d = (t._localRoot || this._root).uuid;
        delete h[d], l.length === 0 && delete o[s1], this._removeInactiveBindingsForAction(t);
    }
    _removeInactiveBindingsForAction(t) {
        let e = t._propertyBindings;
        for(let r = 0, i = e.length; r !== i; ++r){
            let s1 = e[r];
            --s1.referenceCount === 0 && this._removeInactiveBinding(s1);
        }
    }
    _lendAction(t) {
        let e = this._actions, r = t._cacheIndex, i = this._nActiveActions++, s1 = e[i];
        t._cacheIndex = i, e[i] = t, s1._cacheIndex = r, e[r] = s1;
    }
    _takeBackAction(t) {
        let e = this._actions, r = t._cacheIndex, i = --this._nActiveActions, s1 = e[i];
        t._cacheIndex = i, e[i] = t, s1._cacheIndex = r, e[r] = s1;
    }
    _addInactiveBinding(t, e, r) {
        let i = this._bindingsByRootAndName, s1 = this._bindings, o = i[e];
        o === void 0 && (o = {}, i[e] = o), o[r] = t, t._cacheIndex = s1.length, s1.push(t);
    }
    _removeInactiveBinding(t) {
        let e = this._bindings, r = t.binding, i = r.rootNode.uuid, s1 = r.path, o = this._bindingsByRootAndName, a = o[i], l = e[e.length - 1], c = t._cacheIndex;
        l._cacheIndex = c, e[c] = l, e.pop(), delete a[s1], Object.keys(a).length === 0 && delete o[i];
    }
    _lendBinding(t) {
        let e = this._bindings, r = t._cacheIndex, i = this._nActiveBindings++, s1 = e[i];
        t._cacheIndex = i, e[i] = t, s1._cacheIndex = r, e[r] = s1;
    }
    _takeBackBinding(t) {
        let e = this._bindings, r = t._cacheIndex, i = --this._nActiveBindings, s1 = e[i];
        t._cacheIndex = i, e[i] = t, s1._cacheIndex = r, e[r] = s1;
    }
    _lendControlInterpolant() {
        let t = this._controlInterpolants, e = this._nActiveControlInterpolants++, r = t[e];
        return r === void 0 && (r = new Ky(new Float32Array(2), new Float32Array(2), 1, Bj), r.__cacheIndex = e, t[e] = r), r;
    }
    _takeBackControlInterpolant(t) {
        let e = this._controlInterpolants, r = t.__cacheIndex, i = --this._nActiveControlInterpolants, s1 = e[i];
        t.__cacheIndex = i, e[i] = t, s1.__cacheIndex = r, e[r] = s1;
    }
    clipAction(t, e, r) {
        let i = e || this._root, s1 = i.uuid, o = typeof t == "string" ? mh.findByName(i, t) : t, a = o !== null ? o.uuid : t, l = this._actionsByClip[a], c = null;
        if (r === void 0 && (o !== null ? r = o.blendMode : r = Mw), l !== void 0) {
            let h = l.actionByRoot[s1];
            if (h !== void 0 && h.blendMode === r) return h;
            c = l.knownActions[0], o === null && (o = c._clip);
        }
        if (o === null) return null;
        let u1 = new Sw(this, o, e, r);
        return this._bindAction(u1, c), this._addInactiveAction(u1, a, s1), u1;
    }
    existingAction(t, e) {
        let r = e || this._root, i = r.uuid, s1 = typeof t == "string" ? mh.findByName(r, t) : t, o = s1 ? s1.uuid : t, a = this._actionsByClip[o];
        return a !== void 0 && a.actionByRoot[i] || null;
    }
    stopAllAction() {
        let t = this._actions, e = this._nActiveActions;
        for(let r = e - 1; r >= 0; --r)t[r].stop();
        return this;
    }
    update(t) {
        t *= this.timeScale;
        let e = this._actions, r = this._nActiveActions, i = this.time += t, s1 = Math.sign(t), o = this._accuIndex ^= 1;
        for(let c = 0; c !== r; ++c)e[c]._update(i, t, s1, o);
        let a = this._bindings, l = this._nActiveBindings;
        for(let c = 0; c !== l; ++c)a[c].apply(o);
        return this;
    }
    setTime(t) {
        this.time = 0;
        for(let e = 0; e < this._actions.length; e++)this._actions[e].time = 0;
        return this.update(t);
    }
    getRoot() {
        return this._root;
    }
    uncacheClip(t) {
        let e = this._actions, r = t.uuid, i = this._actionsByClip, s1 = i[r];
        if (s1 !== void 0) {
            let o = s1.knownActions;
            for(let a = 0, l = o.length; a !== l; ++a){
                let c = o[a];
                this._deactivateAction(c);
                let u1 = c._cacheIndex, h = e[e.length - 1];
                c._cacheIndex = null, c._byClipCacheIndex = null, h._cacheIndex = u1, e[u1] = h, e.pop(), this._removeInactiveBindingsForAction(c);
            }
            delete i[r];
        }
    }
    uncacheRoot(t) {
        let e = t.uuid, r = this._actionsByClip;
        for(let o in r){
            let a = r[o].actionByRoot, l = a[e];
            l !== void 0 && (this._deactivateAction(l), this._removeInactiveAction(l));
        }
        let i = this._bindingsByRootAndName, s1 = i[e];
        if (s1 !== void 0) for(let o in s1){
            let a = s1[o];
            a.restoreOriginalState(), this._removeInactiveBinding(a);
        }
    }
    uncacheAction(t, e) {
        let r = this.existingAction(t, e);
        r !== null && (this._deactivateAction(r), this._removeInactiveAction(r));
    }
}, ce = class {
    constructor(t){
        this.value = t;
    }
    clone() {
        return new ce(this.value.clone === void 0 ? this.value : this.value.clone());
    }
};
var vh = class {
    constructor(t, e, r = 0, i = 1 / 0){
        this.ray = new Ws(t, e), this.near = r, this.far = i, this.camera = null, this.layers = new Vp, this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(t, e) {
        this.ray.set(t, e);
    }
    setFromCamera(t, e) {
        e.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(t.x, t.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : e.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, (e.near + e.far) / (e.near - e.far)).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : console.error("THREE.Raycaster: Unsupported camera type: " + e.type);
    }
    intersectObject(t, e = !0, r = []) {
        return ww(t, this, r, e), r.sort(KP), r;
    }
    intersectObjects(t, e = !0, r = []) {
        for(let i = 0, s1 = t.length; i < s1; i++)ww(t[i], this, r, e);
        return r.sort(KP), r;
    }
};
function KP(n1, t) {
    return n1.distance - t.distance;
}
function ww(n1, t, e, r) {
    if (n1.layers.test(t.layers) && n1.raycast(t, e), r === !0) {
        let i = n1.children;
        for(let s1 = 0, o = i.length; s1 < o; s1++)ww(i[s1], t, e, !0);
    }
}
var Qp = class {
    constructor(t = 1, e = 0, r = 0){
        return this.radius = t, this.phi = e, this.theta = r, this;
    }
    set(t, e, r) {
        return this.radius = t, this.phi = e, this.theta = r, this;
    }
    copy(t) {
        return this.radius = t.radius, this.phi = t.phi, this.theta = t.theta, this;
    }
    makeSafe() {
        return this.phi = Math.max(1e-6, Math.min(Math.PI - 1e-6, this.phi)), this;
    }
    setFromVector3(t) {
        return this.setFromCartesianCoords(t.x, t.y, t.z);
    }
    setFromCartesianCoords(t, e, r) {
        return this.radius = Math.sqrt(t * t + e * e + r * r), this.radius === 0 ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(t, r), this.phi = Math.acos(yi(e / this.radius, -1, 1))), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
};
var QP = new U, Pl = class {
    constructor(t = new U(1 / 0, 1 / 0), e = new U(-1 / 0, -1 / 0)){
        this.isBox2 = !0, this.min = t, this.max = e;
    }
    set(t, e) {
        return this.min.copy(t), this.max.copy(e), this;
    }
    setFromPoints(t) {
        this.makeEmpty();
        for(let e = 0, r = t.length; e < r; e++)this.expandByPoint(t[e]);
        return this;
    }
    setFromCenterAndSize(t, e) {
        let r = QP.copy(e).multiplyScalar(.5);
        return this.min.copy(t).sub(r), this.max.copy(t).add(r), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.min.copy(t.min), this.max.copy(t.max), this;
    }
    makeEmpty() {
        return this.min.x = this.min.y = 1 / 0, this.max.x = this.max.y = -1 / 0, this;
    }
    isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(t) {
        return this.isEmpty() ? t.set(0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(t) {
        return this.isEmpty() ? t.set(0, 0) : t.subVectors(this.max, this.min);
    }
    expandByPoint(t) {
        return this.min.min(t), this.max.max(t), this;
    }
    expandByVector(t) {
        return this.min.sub(t), this.max.add(t), this;
    }
    expandByScalar(t) {
        return this.min.addScalar(-t), this.max.addScalar(t), this;
    }
    containsPoint(t) {
        return !(t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y);
    }
    containsBox(t) {
        return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y;
    }
    getParameter(t, e) {
        return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(t) {
        return !(t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y);
    }
    clampPoint(t, e) {
        return e.copy(t).clamp(this.min, this.max);
    }
    distanceToPoint(t) {
        return QP.copy(t).clamp(this.min, this.max).sub(t).length();
    }
    intersect(t) {
        return this.min.max(t.min), this.max.min(t.max), this;
    }
    union(t) {
        return this.min.min(t.min), this.max.max(t.max), this;
    }
    translate(t) {
        return this.min.add(t), this.max.add(t), this;
    }
    equals(t) {
        return t.min.equals(this.min) && t.max.equals(this.max);
    }
}, ZP = new E, _y = new E, Di = class {
    constructor(t = new E, e = new E){
        this.start = t, this.end = e;
    }
    set(t, e) {
        return this.start.copy(t), this.end.copy(e), this;
    }
    copy(t) {
        return this.start.copy(t.start), this.end.copy(t.end), this;
    }
    getCenter(t) {
        return t.addVectors(this.start, this.end).multiplyScalar(.5);
    }
    delta(t) {
        return t.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, e) {
        return this.delta(e).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(t, e) {
        ZP.subVectors(t, this.start), _y.subVectors(this.end, this.start);
        let r = _y.dot(_y), s1 = _y.dot(ZP) / r;
        return e && (s1 = yi(s1, 0, 1)), s1;
    }
    closestPointToPoint(t, e, r) {
        let i = this.closestPointToPointParameter(t, e);
        return this.delta(r).multiplyScalar(i).add(this.start);
    }
    applyMatrix4(t) {
        return this.start.applyMatrix4(t), this.end.applyMatrix4(t), this;
    }
    equals(t) {
        return t.start.equals(this.start) && t.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, JP = new E, sv = class extends Dt {
    constructor(t, e){
        super(), this.light = t, this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.color = e, this.type = "SpotLightHelper";
        let r = new Ce, i = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let o = 0, a = 1, l = 32; o < l; o++, a++){
            let c = o / l * Math.PI * 2, u1 = a / l * Math.PI * 2;
            i.push(Math.cos(c), Math.sin(c), 1, Math.cos(u1), Math.sin(u1), 1);
        }
        r.setAttribute("position", new Te(i, 3));
        let s1 = new ms({
            fog: !1,
            toneMapped: !1
        });
        this.cone = new wl(r, s1), this.add(this.cone), this.update();
    }
    dispose() {
        this.cone.geometry.dispose(), this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1);
        let t = this.light.distance ? this.light.distance : 1e3, e = t * Math.tan(this.light.angle);
        this.cone.scale.set(e, e, t), JP.setFromMatrixPosition(this.light.target.matrixWorld), this.cone.lookAt(JP), this.color !== void 0 ? this.cone.material.color.set(this.color) : this.cone.material.color.copy(this.light.color);
    }
};
var ov = class extends Mt {
    constructor(t, e, r){
        let i = new qs(e, 4, 2), s1 = new un({
            wireframe: !0,
            fog: !1,
            toneMapped: !1
        });
        super(i, s1), this.light = t, this.color = r, this.type = "PointLightHelper", this.matrix = this.light.matrixWorld, this.matrixAutoUpdate = !1, this.update();
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.color !== void 0 ? this.material.color.set(this.color) : this.material.color.copy(this.light.color);
    }
};
var $P = new E, Iy = new E, e_ = new E, av = class extends Dt {
    constructor(t, e, r){
        super(), this.light = t, this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.color = r, this.type = "DirectionalLightHelper", e === void 0 && (e = 1);
        let i = new Ce;
        i.setAttribute("position", new Te([
            -e,
            e,
            0,
            e,
            e,
            0,
            e,
            -e,
            0,
            -e,
            -e,
            0,
            -e,
            e,
            0
        ], 3));
        let s1 = new ms({
            fog: !1,
            toneMapped: !1
        });
        this.lightPlane = new Uc(i, s1), this.add(this.lightPlane), i = new Ce, i.setAttribute("position", new Te([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3)), this.targetLine = new Uc(i, s1), this.add(this.targetLine), this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose(), this.lightPlane.material.dispose(), this.targetLine.geometry.dispose(), this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1), $P.setFromMatrixPosition(this.light.matrixWorld), Iy.setFromMatrixPosition(this.light.target.matrixWorld), e_.subVectors(Iy, $P), this.lightPlane.lookAt(Iy), this.color !== void 0 ? (this.lightPlane.material.color.set(this.color), this.targetLine.material.color.set(this.color)) : (this.lightPlane.material.color.copy(this.light.color), this.targetLine.material.color.copy(this.light.color)), this.targetLine.lookAt(Iy), this.targetLine.scale.z = e_.length();
    }
}, Dy = new E, $r = new bn, _l = class extends wl {
    constructor(t){
        let e = new Ce, r = new ms({
            color: 16777215,
            vertexColors: !0,
            toneMapped: !1
        }), i = [], s1 = [], o = {};
        a("n1", "n2"), a("n2", "n4"), a("n4", "n3"), a("n3", "n1"), a("f1", "f2"), a("f2", "f4"), a("f4", "f3"), a("f3", "f1"), a("n1", "f1"), a("n2", "f2"), a("n3", "f3"), a("n4", "f4"), a("p", "n1"), a("p", "n2"), a("p", "n3"), a("p", "n4"), a("u1", "u2"), a("u2", "u3"), a("u3", "u1"), a("c", "t"), a("p", "c"), a("cn1", "cn2"), a("cn3", "cn4"), a("cf1", "cf2"), a("cf3", "cf4");
        function a(m, p) {
            l(m), l(p);
        }
        function l(m) {
            i.push(0, 0, 0), s1.push(0, 0, 0), o[m] === void 0 && (o[m] = []), o[m].push(i.length / 3 - 1);
        }
        e.setAttribute("position", new Te(i, 3)), e.setAttribute("color", new Te(s1, 3)), super(e, r), this.type = "CameraHelper", this.camera = t, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = o, this.update();
        let c = new Ge(16755200), u1 = new Ge(16711680), h = new Ge(43775), d = new Ge(16777215), f = new Ge(3355443);
        this.setColors(c, u1, h, d, f);
    }
    setColors(t, e, r, i, s1) {
        let a = this.geometry.getAttribute("color");
        a.setXYZ(0, t.r, t.g, t.b), a.setXYZ(1, t.r, t.g, t.b), a.setXYZ(2, t.r, t.g, t.b), a.setXYZ(3, t.r, t.g, t.b), a.setXYZ(4, t.r, t.g, t.b), a.setXYZ(5, t.r, t.g, t.b), a.setXYZ(6, t.r, t.g, t.b), a.setXYZ(7, t.r, t.g, t.b), a.setXYZ(8, t.r, t.g, t.b), a.setXYZ(9, t.r, t.g, t.b), a.setXYZ(10, t.r, t.g, t.b), a.setXYZ(11, t.r, t.g, t.b), a.setXYZ(12, t.r, t.g, t.b), a.setXYZ(13, t.r, t.g, t.b), a.setXYZ(14, t.r, t.g, t.b), a.setXYZ(15, t.r, t.g, t.b), a.setXYZ(16, t.r, t.g, t.b), a.setXYZ(17, t.r, t.g, t.b), a.setXYZ(18, t.r, t.g, t.b), a.setXYZ(19, t.r, t.g, t.b), a.setXYZ(20, t.r, t.g, t.b), a.setXYZ(21, t.r, t.g, t.b), a.setXYZ(22, t.r, t.g, t.b), a.setXYZ(23, t.r, t.g, t.b), a.setXYZ(24, e.r, e.g, e.b), a.setXYZ(25, e.r, e.g, e.b), a.setXYZ(26, e.r, e.g, e.b), a.setXYZ(27, e.r, e.g, e.b), a.setXYZ(28, e.r, e.g, e.b), a.setXYZ(29, e.r, e.g, e.b), a.setXYZ(30, e.r, e.g, e.b), a.setXYZ(31, e.r, e.g, e.b), a.setXYZ(32, r.r, r.g, r.b), a.setXYZ(33, r.r, r.g, r.b), a.setXYZ(34, r.r, r.g, r.b), a.setXYZ(35, r.r, r.g, r.b), a.setXYZ(36, r.r, r.g, r.b), a.setXYZ(37, r.r, r.g, r.b), a.setXYZ(38, i.r, i.g, i.b), a.setXYZ(39, i.r, i.g, i.b), a.setXYZ(40, s1.r, s1.g, s1.b), a.setXYZ(41, s1.r, s1.g, s1.b), a.setXYZ(42, s1.r, s1.g, s1.b), a.setXYZ(43, s1.r, s1.g, s1.b), a.setXYZ(44, s1.r, s1.g, s1.b), a.setXYZ(45, s1.r, s1.g, s1.b), a.setXYZ(46, s1.r, s1.g, s1.b), a.setXYZ(47, s1.r, s1.g, s1.b), a.setXYZ(48, s1.r, s1.g, s1.b), a.setXYZ(49, s1.r, s1.g, s1.b), a.needsUpdate = !0;
    }
    update() {
        let t = this.geometry, e = this.pointMap, r = 1, i = 1;
        $r.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse), ni("c", e, t, $r, 0, 0, -1), ni("t", e, t, $r, 0, 0, 1), ni("n1", e, t, $r, -r, -i, -1), ni("n2", e, t, $r, r, -i, -1), ni("n3", e, t, $r, -r, i, -1), ni("n4", e, t, $r, r, i, -1), ni("f1", e, t, $r, -r, -i, 1), ni("f2", e, t, $r, r, -i, 1), ni("f3", e, t, $r, -r, i, 1), ni("f4", e, t, $r, r, i, 1), ni("u1", e, t, $r, r * .7, i * 1.1, -1), ni("u2", e, t, $r, -r * .7, i * 1.1, -1), ni("u3", e, t, $r, 0, i * 2, -1), ni("cf1", e, t, $r, -r, 0, 1), ni("cf2", e, t, $r, r, 0, 1), ni("cf3", e, t, $r, 0, -i, 1), ni("cf4", e, t, $r, 0, i, 1), ni("cn1", e, t, $r, -r, 0, -1), ni("cn2", e, t, $r, r, 0, -1), ni("cn3", e, t, $r, 0, -i, -1), ni("cn4", e, t, $r, 0, i, -1), t.getAttribute("position").needsUpdate = !0;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
function ni(n1, t, e, r, i, s1, o) {
    Dy.set(i, s1, o).unproject(r);
    let a = t[n1];
    if (a !== void 0) {
        let l = e.getAttribute("position");
        for(let c = 0, u1 = a.length; c < u1; c++)l.setXYZ(a[c], Dy.x, Dy.y, Dy.z);
    }
}
var Il = class extends wl {
    constructor(t, e = 16776960){
        let r = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]), i = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ], s1 = new Ce;
        s1.setIndex(new je(r, 1)), s1.setAttribute("position", new Te(i, 3)), super(s1, new ms({
            color: e,
            toneMapped: !1
        })), this.box = t, this.type = "Box3Helper", this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(t) {
        let e = this.box;
        e.isEmpty() || (e.getCenter(this.position), e.getSize(this.scale), this.scale.multiplyScalar(.5), super.updateMatrixWorld(t));
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
var lv = class extends wl {
    constructor(t = 1){
        let e = [
            0,
            0,
            0,
            t,
            0,
            0,
            0,
            0,
            0,
            0,
            t,
            0,
            0,
            0,
            0,
            0,
            0,
            t
        ], r = [
            1,
            0,
            0,
            1,
            .6,
            0,
            0,
            1,
            0,
            .6,
            1,
            0,
            0,
            0,
            1,
            0,
            .6,
            1
        ], i = new Ce;
        i.setAttribute("position", new Te(e, 3)), i.setAttribute("color", new Te(r, 3));
        let s1 = new ms({
            vertexColors: !0,
            toneMapped: !1
        });
        super(i, s1), this.type = "AxesHelper";
    }
    setColors(t, e, r) {
        let i = new Ge, s1 = this.geometry.attributes.color.array;
        return i.set(t), i.toArray(s1, 0), i.toArray(s1, 3), i.set(e), i.toArray(s1, 6), i.toArray(s1, 9), i.set(r), i.toArray(s1, 12), i.toArray(s1, 15), this.geometry.attributes.color.needsUpdate = !0, this;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
var Ta = Fj();
function Fj() {
    let n1 = new ArrayBuffer(4), t = new Float32Array(n1), e = new Uint32Array(n1), r = new Uint32Array(512), i = new Uint32Array(512);
    for(let l = 0; l < 256; ++l){
        let c = l - 127;
        c < -27 ? (r[l] = 0, r[l | 256] = 32768, i[l] = 24, i[l | 256] = 24) : c < -14 ? (r[l] = 1024 >> -c - 14, r[l | 256] = 1024 >> -c - 14 | 32768, i[l] = -c - 1, i[l | 256] = -c - 1) : c <= 15 ? (r[l] = c + 15 << 10, r[l | 256] = c + 15 << 10 | 32768, i[l] = 13, i[l | 256] = 13) : c < 128 ? (r[l] = 31744, r[l | 256] = 64512, i[l] = 24, i[l | 256] = 24) : (r[l] = 31744, r[l | 256] = 64512, i[l] = 13, i[l | 256] = 13);
    }
    let s1 = new Uint32Array(2048), o = new Uint32Array(64), a = new Uint32Array(64);
    for(let l = 1; l < 1024; ++l){
        let c = l << 13, u1 = 0;
        for(; (c & 8388608) === 0;)c <<= 1, u1 -= 8388608;
        c &= -8388609, u1 += 947912704, s1[l] = c | u1;
    }
    for(let l = 1024; l < 2048; ++l)s1[l] = 939524096 + (l - 1024 << 13);
    for(let l = 1; l < 31; ++l)o[l] = l << 23;
    o[31] = 1199570944, o[32] = 2147483648;
    for(let l = 33; l < 63; ++l)o[l] = 2147483648 + (l - 32 << 23);
    o[63] = 3347054592;
    for(let l = 1; l < 64; ++l)l !== 32 && (a[l] = 1024);
    return {
        floatView: t,
        uint32View: e,
        baseTable: r,
        shiftTable: i,
        mantissaTable: s1,
        exponentTable: o,
        offsetTable: a
    };
}
function Vj(n1) {
    Math.abs(n1) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), n1 = yi(n1, -65504, 65504), Ta.floatView[0] = n1;
    let t = Ta.uint32View[0], e = t >> 23 & 511;
    return Ta.baseTable[e] + ((t & 8388607) >> Ta.shiftTable[e]);
}
function Uj(n1) {
    let t = n1 >> 10;
    return Ta.uint32View[0] = Ta.mantissaTable[Ta.offsetTable[t] + (n1 & 1023)] + Ta.exponentTable[t], Ta.floatView[0];
}
var S_ = Object.freeze({
    __proto__: null,
    fromHalfFloat: Uj,
    toHalfFloat: Vj
});
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: Pa
    }
}));
typeof window < "u" && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = Pa);
var wh = ".", $p = Symbol("target"), Lw = Symbol("unsubscribe");
function em(n1) {
    return n1 instanceof Date || n1 instanceof Set || n1 instanceof Map || n1 instanceof WeakSet || n1 instanceof WeakMap || ArrayBuffer.isView(n1);
}
function w_(n1) {
    return (typeof n1 == "object" ? n1 === null : typeof n1 != "function") || n1 instanceof RegExp;
}
var rs = Array.isArray;
function qc(n1) {
    return typeof n1 == "symbol";
}
var kj = {
    after: (n1, t)=>rs(n1) ? n1.slice(t.length) : t === "" ? n1 : n1.slice(t.length + 1),
    concat: (n1, t)=>rs(n1) ? (n1 = [
            ...n1
        ], t && n1.push(t), n1) : t && t.toString !== void 0 ? (n1 !== "" && (n1 += wh), qc(t) ? n1 + t.toString() : n1 + t) : n1,
    initial: (n1)=>{
        if (rs(n1)) return n1.slice(0, -1);
        if (n1 === "") return n1;
        let t = n1.lastIndexOf(wh);
        return t === -1 ? "" : n1.slice(0, t);
    },
    last: (n1)=>{
        if (rs(n1)) return n1[n1.length - 1] || "";
        if (n1 === "") return n1;
        let t = n1.lastIndexOf(wh);
        return t === -1 ? n1 : n1.slice(t + 1);
    },
    walk: (n1, t)=>{
        if (rs(n1)) for (let e of n1)t(e);
        else if (n1 !== "") {
            let e = 0, r = n1.indexOf(wh);
            if (r === -1) t(n1);
            else for(; e < n1.length;)r === -1 && (r = n1.length), t(n1.slice(e, r)), e = r + 1, r = n1.indexOf(wh, e);
        }
    },
    get (n1, t) {
        return this.walk(t, (e)=>{
            n1 && (n1 = n1[e]);
        }), n1;
    }
}, Sn = kj;
function Nw(n1) {
    return typeof n1 == "object" && typeof n1.next == "function";
}
function Bw(n1, t, e, r, i) {
    let s1 = n1.next;
    if (t.name === "entries") n1.next = function() {
        let o = s1.call(this);
        return o.done === !1 && (o.value[0] = i(o.value[0], t, o.value[0], r), o.value[1] = i(o.value[1], t, o.value[0], r)), o;
    };
    else if (t.name === "values") {
        let o = e[$p].keys();
        n1.next = function() {
            let a = s1.call(this);
            return a.done === !1 && (a.value = i(a.value, t, o.next().value, r)), a;
        };
    } else n1.next = function() {
        let o = s1.call(this);
        return o.done === !1 && (o.value = i(o.value, t, o.value, r)), o;
    };
    return n1;
}
function dv(n1, t, e) {
    return n1.isUnsubscribed || t.ignoreSymbols && qc(e) || t.ignoreUnderscores && e.charAt(0) === "_" || "ignoreKeys" in t && t.ignoreKeys.includes(e);
}
var tm = class {
    constructor(t){
        this._equals = t, this._proxyCache = new WeakMap, this._pathCache = new WeakMap, this.isUnsubscribed = !1;
    }
    _getDescriptorCache() {
        return this._descriptorCache === void 0 && (this._descriptorCache = new WeakMap), this._descriptorCache;
    }
    _getProperties(t) {
        let e = this._getDescriptorCache(), r = e.get(t);
        return r === void 0 && (r = {}, e.set(t, r)), r;
    }
    _getOwnPropertyDescriptor(t, e) {
        if (this.isUnsubscribed) return Reflect.getOwnPropertyDescriptor(t, e);
        let r = this._getProperties(t), i = r[e];
        return i === void 0 && (i = Reflect.getOwnPropertyDescriptor(t, e), r[e] = i), i;
    }
    getProxy(t, e, r, i) {
        if (this.isUnsubscribed) return t;
        let s1 = t[i], o = s1 || t;
        this._pathCache.set(o, e);
        let a = this._proxyCache.get(o);
        return a === void 0 && (a = s1 === void 0 ? new Proxy(t, r) : t, this._proxyCache.set(o, a)), a;
    }
    getPath(t) {
        return this.isUnsubscribed ? void 0 : this._pathCache.get(t);
    }
    isDetached(t, e) {
        return !Object.is(t, Sn.get(e, this.getPath(t)));
    }
    defineProperty(t, e, r) {
        return Reflect.defineProperty(t, e, r) ? (this.isUnsubscribed || (this._getProperties(t)[e] = r), !0) : !1;
    }
    setProperty(t, e, r, i, s1) {
        if (!this._equals(s1, r) || !(e in t)) {
            let o = this._getOwnPropertyDescriptor(t, e);
            return o !== void 0 && "set" in o ? Reflect.set(t, e, r, i) : Reflect.set(t, e, r);
        }
        return !0;
    }
    deleteProperty(t, e, r) {
        if (Reflect.deleteProperty(t, e)) {
            if (!this.isUnsubscribed) {
                let i = this._getDescriptorCache().get(t);
                i && (delete i[e], this._pathCache.delete(r));
            }
            return !0;
        }
        return !1;
    }
    isSameDescriptor(t, e, r) {
        let i = this._getOwnPropertyDescriptor(e, r);
        return t !== void 0 && i !== void 0 && Object.is(t.value, i.value) && (t.writable || !1) === (i.writable || !1) && (t.enumerable || !1) === (i.enumerable || !1) && (t.configurable || !1) === (i.configurable || !1) && t.get === i.get && t.set === i.set;
    }
    isGetInvariant(t, e) {
        let r = this._getOwnPropertyDescriptor(t, e);
        return r !== void 0 && r.configurable !== !0 && r.writable !== !0;
    }
    unsubscribe() {
        this._descriptorCache = null, this._pathCache = null, this._proxyCache = null, this.isUnsubscribed = !0;
    }
};
function Ah(n1) {
    return toString.call(n1) === "[object Object]";
}
function Eh() {
    return !0;
}
function Dl(n1, t) {
    return n1.length !== t.length || n1.some((e, r)=>t[r] !== e);
}
var fv = new Set([
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
]);
var zj = new Set([
    "concat",
    "includes",
    "indexOf",
    "join",
    "keys",
    "lastIndexOf"
]), Fw = {
    push: Eh,
    pop: Eh,
    shift: Eh,
    unshift: Eh,
    copyWithin: Dl,
    reverse: Dl,
    sort: Dl,
    splice: Dl,
    flat: Dl,
    fill: Dl
}, A_ = new Set([
    ...fv,
    ...zj,
    ...Object.keys(Fw)
]);
function Th(n1, t) {
    if (n1.size !== t.size) return !0;
    for (let e of n1)if (!t.has(e)) return !0;
    return !1;
}
var Vw = [
    "keys",
    "values",
    "entries"
], Uw = new Set([
    "has",
    "toString"
]), kw = {
    add: Th,
    clear: Th,
    delete: Th,
    forEach: Th
}, E_ = new Set([
    ...Uw,
    ...Object.keys(kw),
    ...Vw
]);
function Mh(n1, t) {
    if (n1.size !== t.size) return !0;
    let e;
    for (let [r, i] of n1)if (e = t.get(r), e !== i || e === void 0 && !t.has(r)) return !0;
    return !1;
}
var Gj = new Set([
    ...Uw,
    "get"
]), zw = {
    set: Mh,
    clear: Mh,
    delete: Mh,
    forEach: Mh
}, T_ = new Set([
    ...Gj,
    ...Object.keys(zw),
    ...Vw
]);
var Gi = class {
    constructor(t, e, r, i){
        this._path = e, this._isChanged = !1, this._clonedCache = new Set, this._hasOnValidate = i, this._changes = i ? [] : null, this.clone = e === void 0 ? t : this._shallowClone(t);
    }
    static isHandledMethod(t) {
        return fv.has(t);
    }
    _shallowClone(t) {
        let e = t;
        if (Ah(t)) e = {
            ...t
        };
        else if (rs(t)) e = [
            ...t
        ];
        else if (t instanceof Date) e = new Date(t);
        else if (t instanceof Set) e = new Set([
            ...t
        ].map((r)=>this._shallowClone(r)));
        else if (t instanceof Map) {
            e = new Map;
            for (let [r, i] of t.entries())e.set(r, this._shallowClone(i));
        }
        return this._clonedCache.add(e), e;
    }
    preferredThisArg(t, e, r, i) {
        return t ? (rs(i) ? this._onIsChanged = Fw[e] : i instanceof Set ? this._onIsChanged = kw[e] : i instanceof Map && (this._onIsChanged = zw[e]), i) : r;
    }
    update(t, e, r) {
        let i = Sn.after(t, this._path);
        if (e !== "length") {
            let s1 = this.clone;
            Sn.walk(i, (o)=>{
                s1 && s1[o] && (this._clonedCache.has(s1[o]) || (s1[o] = this._shallowClone(s1[o])), s1 = s1[o]);
            }), this._hasOnValidate && this._changes.push({
                path: i,
                property: e,
                previous: r
            }), s1 && s1[e] && (s1[e] = r);
        }
        this._isChanged = !0;
    }
    undo(t) {
        let e;
        for(let r = this._changes.length - 1; r !== -1; r--)e = this._changes[r], Sn.get(t, e.path)[e.property] = e.previous;
    }
    isChanged(t) {
        return this._onIsChanged === void 0 ? this._isChanged : this._onIsChanged(this.clone, t);
    }
};
var Ch = class extends Gi {
    static isHandledMethod(t) {
        return A_.has(t);
    }
};
var rm = class extends Gi {
    undo(t) {
        t.setTime(this.clone.getTime());
    }
    isChanged(t, e) {
        return !e(this.clone.valueOf(), t.valueOf());
    }
};
var Ph = class extends Gi {
    static isHandledMethod(t) {
        return E_.has(t);
    }
    undo(t) {
        for (let e of this.clone)t.add(e);
        for (let e of t)this.clone.has(e) || t.delete(e);
    }
};
var _h = class extends Gi {
    static isHandledMethod(t) {
        return T_.has(t);
    }
    undo(t) {
        for (let [e, r] of this.clone.entries())t.set(e, r);
        for (let e of t.keys())this.clone.has(e) || t.delete(e);
    }
};
var im = class extends Gi {
    constructor(t, e, r, i){
        super(void 0, e, r, i), this._arg1 = r[0], this._weakValue = t.has(this._arg1);
    }
    isChanged(t) {
        return this._weakValue !== t.has(this._arg1);
    }
    undo(t) {
        this._weakValue && !t.has(this._arg1) ? t.add(this._arg1) : t.delete(this._arg1);
    }
};
var nm = class extends Gi {
    constructor(t, e, r, i){
        super(void 0, e, r, i), this._weakKey = r[0], this._weakHas = t.has(this._weakKey), this._weakValue = t.get(this._weakKey);
    }
    isChanged(t) {
        return this._weakValue !== t.get(this._weakKey);
    }
    undo(t) {
        let e = t.has(this._weakKey);
        this._weakHas && !e ? t.set(this._weakKey, this._weakValue) : !this._weakHas && e ? t.delete(this._weakKey) : this._weakValue !== t.get(this._weakKey) && t.set(this._weakKey, this._weakValue);
    }
};
var Ys = class {
    constructor(t){
        this._stack = [], this._hasOnValidate = t;
    }
    static isHandledType(t) {
        return Ah(t) || rs(t) || em(t);
    }
    static isHandledMethod(t, e) {
        return Ah(t) ? Gi.isHandledMethod(e) : rs(t) ? Ch.isHandledMethod(e) : t instanceof Set ? Ph.isHandledMethod(e) : t instanceof Map ? _h.isHandledMethod(e) : em(t);
    }
    get isCloning() {
        return this._stack.length > 0;
    }
    start(t, e, r) {
        let i = Gi;
        rs(t) ? i = Ch : t instanceof Date ? i = rm : t instanceof Set ? i = Ph : t instanceof Map ? i = _h : t instanceof WeakSet ? i = im : t instanceof WeakMap && (i = nm), this._stack.push(new i(t, e, r, this._hasOnValidate));
    }
    update(t, e, r) {
        this._stack[this._stack.length - 1].update(t, e, r);
    }
    preferredThisArg(t, e, r) {
        let { name: i } = t, s1 = Ys.isHandledMethod(r, i);
        return this._stack[this._stack.length - 1].preferredThisArg(s1, i, e, r);
    }
    isChanged(t, e, r) {
        return this._stack[this._stack.length - 1].isChanged(t, e, r);
    }
    undo(t) {
        this._previousClone !== void 0 && this._previousClone.undo(t);
    }
    stop() {
        return this._previousClone = this._stack.pop(), this._previousClone.clone;
    }
};
var jj = {
    equals: Object.is,
    isShallow: !1,
    pathAsArray: !1,
    ignoreSymbols: !1,
    ignoreUnderscores: !1,
    ignoreDetached: !1,
    details: !1
}, Gw = (n1, t, e = {})=>{
    e = {
        ...jj,
        ...e
    };
    let r = Symbol("ProxyTarget"), { equals: i, isShallow: s1, ignoreDetached: o, details: a } = e, l = new tm(i), c = typeof e.onValidate == "function", u1 = new Ys(c), h = (x, v, b, w, A)=>!c || u1.isCloning || e.onValidate(Sn.concat(l.getPath(x), v), b, w, A) === !0, d = (x, v, b, w)=>{
        !dv(l, e, v) && !(o && l.isDetached(x, n1)) && f(l.getPath(x), v, b, w);
    }, f = (x, v, b, w, A)=>{
        u1.isCloning ? u1.update(x, v, w) : t(Sn.concat(x, v), b, w, A);
    }, m = (x)=>x && (x[r] || x), p = (x, v, b, w)=>w_(x) || b === "constructor" || s1 && !Ys.isHandledMethod(v, b) || dv(l, e, b) || l.isGetInvariant(v, b) || o && l.isDetached(v, n1) ? x : (w === void 0 && (w = l.getPath(v)), l.getProxy(x, Sn.concat(w, b), g, r)), g = {
        get (x, v, b) {
            if (qc(v)) {
                if (v === r || v === $p) return x;
                if (v === Lw && !l.isUnsubscribed && l.getPath(x).length === 0) return l.unsubscribe(), x;
            }
            let w = em(x) ? Reflect.get(x, v) : Reflect.get(x, v, b);
            return p(w, x, v);
        },
        set (x, v, b, w) {
            b = m(b);
            let A = x[r] || x, T = A[v];
            if (i(T, b) && v in x) return !0;
            let S = h(x, v, b, T);
            return S && l.setProperty(A, v, b, w, T) ? (d(x, v, x[v], T), !0) : !S;
        },
        defineProperty (x, v, b) {
            if (!l.isSameDescriptor(b, x, v)) {
                let w = x[v];
                h(x, v, b.value, w) && l.defineProperty(x, v, b, w) && d(x, v, b.value, w);
            }
            return !0;
        },
        deleteProperty (x, v) {
            if (!Reflect.has(x, v)) return !0;
            let b = Reflect.get(x, v), w = h(x, v, void 0, b);
            return w && l.deleteProperty(x, v, b) ? (d(x, v, void 0, b), !0) : !w;
        },
        apply (x, v, b) {
            let w = v[r] || v;
            if (l.isUnsubscribed) return Reflect.apply(x, w, b);
            if ((a === !1 || a !== !0 && !a.includes(x.name)) && Ys.isHandledType(w)) {
                let A = Sn.initial(l.getPath(x)), T = Ys.isHandledMethod(w, x.name);
                u1.start(w, A, b);
                let S = Reflect.apply(x, u1.preferredThisArg(x, v, w), T ? b.map((P)=>m(P)) : b), M = u1.isChanged(w, i), C = u1.stop();
                if (Ys.isHandledType(S) && T && (v instanceof Map && x.name === "get" && (A = Sn.concat(A, b[0])), S = l.getProxy(S, A, g)), M) {
                    let P = {
                        name: x.name,
                        args: b,
                        result: S
                    }, _ = u1.isCloning ? Sn.initial(A) : A, I = u1.isCloning ? Sn.last(A) : "";
                    h(Sn.get(n1, _), I, w, C, P) ? f(_, I, w, C, P) : u1.undo(w);
                }
                return (v instanceof Map || v instanceof Set) && Nw(S) ? Bw(S, x, v, A, p) : S;
            }
            return Reflect.apply(x, v, b);
        }
    }, y = l.getProxy(n1, e.pathAsArray ? [] : "", g);
    return t = t.bind(y), c && (e.onValidate = e.onValidate.bind(y)), y;
};
Gw.target = (n1)=>n1 && n1[$p] || n1;
Gw.unsubscribe = (n1)=>n1[Lw] || n1;
var jw = Gw;
var Hj = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global, pv = Hj;
var Wj = typeof self == "object" && self && self.Object === Object && self, qj = pv || Wj || Function("return this")(), ti = qj;
var Xj = ti.Symbol, ji = Xj;
var M_ = Object.prototype, Yj = M_.hasOwnProperty, Kj = M_.toString, sm = ji ? ji.toStringTag : void 0;
function Qj(n1) {
    var t = Yj.call(n1, sm), e = n1[sm];
    try {
        n1[sm] = void 0;
        var r = !0;
    } catch  {}
    var i = Kj.call(n1);
    return r && (t ? n1[sm] = e : delete n1[sm]), i;
}
var C_ = Qj;
var Zj = Object.prototype, Jj = Zj.toString;
function $j(n1) {
    return Jj.call(n1);
}
var P_ = $j;
var eH = "[object Null]", tH = "[object Undefined]", __ = ji ? ji.toStringTag : void 0;
function rH(n1) {
    return n1 == null ? n1 === void 0 ? tH : eH : __ && __ in Object(n1) ? C_(n1) : P_(n1);
}
var is = rH;
function iH(n1) {
    return n1 != null && typeof n1 == "object";
}
var Zi = iH;
var nH = "[object Symbol]";
function sH(n1) {
    return typeof n1 == "symbol" || Zi(n1) && is(n1) == nH;
}
var Co = sH;
function oH(n1, t) {
    for(var e = -1, r = n1 == null ? 0 : n1.length, i = Array(r); ++e < r;)i[e] = t(n1[e], e, n1);
    return i;
}
var mv = oH;
var aH = Array.isArray, Oi = aH;
var lH = 1 / 0, I_ = ji ? ji.prototype : void 0, D_ = I_ ? I_.toString : void 0;
function O_(n1) {
    if (typeof n1 == "string") return n1;
    if (Oi(n1)) return mv(n1, O_) + "";
    if (Co(n1)) return D_ ? D_.call(n1) : "";
    var t = n1 + "";
    return t == "0" && 1 / n1 == -lH ? "-0" : t;
}
var gv = O_;
var cH = /\s/;
function uH(n1) {
    for(var t = n1.length; t-- && cH.test(n1.charAt(t)););
    return t;
}
var yv = uH;
var hH = /^\s+/;
function dH(n1) {
    return n1 && n1.slice(0, yv(n1) + 1).replace(hH, "");
}
var R_ = dH;
function fH(n1) {
    var t = typeof n1;
    return n1 != null && (t == "object" || t == "function");
}
var kr = fH;
var L_ = 0 / 0, pH = /^[-+]0x[0-9a-f]+$/i, mH = /^0b[01]+$/i, gH = /^0o[0-7]+$/i, yH = parseInt;
function vH(n1) {
    if (typeof n1 == "number") return n1;
    if (Co(n1)) return L_;
    if (kr(n1)) {
        var t = typeof n1.valueOf == "function" ? n1.valueOf() : n1;
        n1 = kr(t) ? t + "" : t;
    }
    if (typeof n1 != "string") return n1 === 0 ? n1 : +n1;
    n1 = R_(n1);
    var e = mH.test(n1);
    return e || gH.test(n1) ? yH(n1.slice(2), e ? 2 : 8) : pH.test(n1) ? L_ : +n1;
}
var Hw = vH;
function xH(n1) {
    return n1;
}
var vv = xH;
var bH = "[object AsyncFunction]", SH = "[object Function]", wH = "[object GeneratorFunction]", AH = "[object Proxy]";
function EH(n1) {
    if (!kr(n1)) return !1;
    var t = is(n1);
    return t == SH || t == wH || t == bH || t == AH;
}
var xv = EH;
var TH = ti["__core-js_shared__"], bv = TH;
var N_ = function() {
    var n1 = /[^.]+$/.exec(bv && bv.keys && bv.keys.IE_PROTO || "");
    return n1 ? "Symbol(src)_1." + n1 : "";
}();
function MH(n1) {
    return !!N_ && N_ in n1;
}
var B_ = MH;
var CH = Function.prototype, PH = CH.toString;
function _H(n1) {
    if (n1 != null) {
        try {
            return PH.call(n1);
        } catch  {}
        try {
            return n1 + "";
        } catch  {}
    }
    return "";
}
var _a = _H;
var IH = /[\\^$.*+?()[\]{}|]/g, DH = /^\[object .+?Constructor\]$/, OH = Function.prototype, RH = Object.prototype, LH = OH.toString, NH = RH.hasOwnProperty, BH = RegExp("^" + LH.call(NH).replace(IH, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function FH(n1) {
    if (!kr(n1) || B_(n1)) return !1;
    var t = xv(n1) ? BH : DH;
    return t.test(_a(n1));
}
var F_ = FH;
function VH(n1, t) {
    return n1?.[t];
}
var V_ = VH;
function UH(n1, t) {
    var e = V_(n1, t);
    return F_(e) ? e : void 0;
}
var Ln = UH;
var kH = Ln(ti, "WeakMap"), Sv = kH;
var U_ = Object.create, zH = function() {
    function n1() {}
    return function(t) {
        if (!kr(t)) return {};
        if (U_) return U_(t);
        n1.prototype = t;
        var e = new n1;
        return n1.prototype = void 0, e;
    };
}(), k_ = zH;
function GH(n1, t, e) {
    switch(e.length){
        case 0:
            return n1.call(t);
        case 1:
            return n1.call(t, e[0]);
        case 2:
            return n1.call(t, e[0], e[1]);
        case 3:
            return n1.call(t, e[0], e[1], e[2]);
    }
    return n1.apply(t, e);
}
var z_ = GH;
function jH(n1, t) {
    var e = -1, r = n1.length;
    for(t || (t = Array(r)); ++e < r;)t[e] = n1[e];
    return t;
}
var G_ = jH;
var HH = 800, WH = 16, qH = Date.now;
function XH(n1) {
    var t = 0, e = 0;
    return function() {
        var r = qH(), i = WH - (r - e);
        if (e = r, i > 0) {
            if (++t >= HH) return arguments[0];
        } else t = 0;
        return n1.apply(void 0, arguments);
    };
}
var j_ = XH;
function YH(n1) {
    return function() {
        return n1;
    };
}
var H_ = YH;
var KH = function() {
    try {
        var n1 = Ln(Object, "defineProperty");
        return n1({}, "", {}), n1;
    } catch  {}
}(), Ih = KH;
var QH = Ih ? function(n1, t) {
    return Ih(n1, "toString", {
        configurable: !0,
        enumerable: !1,
        value: H_(t),
        writable: !0
    });
} : vv, W_ = QH;
var ZH = j_(W_), q_ = ZH;
function JH(n1, t) {
    for(var e = -1, r = n1 == null ? 0 : n1.length; ++e < r && t(n1[e], e, n1) !== !1;);
    return n1;
}
var X_ = JH;
function $H(n1, t, e, r) {
    for(var i = n1.length, s1 = e + (r ? 1 : -1); r ? s1-- : ++s1 < i;)if (t(n1[s1], s1, n1)) return s1;
    return -1;
}
var Y_ = $H;
function eW(n1) {
    return n1 !== n1;
}
var K_ = eW;
function tW(n1, t, e) {
    for(var r = e - 1, i = n1.length; ++r < i;)if (n1[r] === t) return r;
    return -1;
}
var Q_ = tW;
function rW(n1, t, e) {
    return t === t ? Q_(n1, t, e) : Y_(n1, K_, e);
}
var Z_ = rW;
var iW = 9007199254740991, nW = /^(?:0|[1-9]\d*)$/;
function sW(n1, t) {
    var e = typeof n1;
    return t = t ?? iW, !!t && (e == "number" || e != "symbol" && nW.test(n1)) && n1 > -1 && n1 % 1 == 0 && n1 < t;
}
var Dh = sW;
function oW(n1, t, e) {
    t == "__proto__" && Ih ? Ih(n1, t, {
        configurable: !0,
        enumerable: !0,
        value: e,
        writable: !0
    }) : n1[t] = e;
}
var wv = oW;
function aW(n1, t) {
    return n1 === t || n1 !== n1 && t !== t;
}
var Oh = aW;
var lW = Object.prototype, cW = lW.hasOwnProperty;
function uW(n1, t, e) {
    var r = n1[t];
    (!(cW.call(n1, t) && Oh(r, e)) || e === void 0 && !(t in n1)) && wv(n1, t, e);
}
var Rh = uW;
function hW(n1, t, e, r) {
    var i = !e;
    e || (e = {});
    for(var s1 = -1, o = t.length; ++s1 < o;){
        var a = t[s1], l = r ? r(e[a], n1[a], a, e, n1) : void 0;
        l === void 0 && (l = n1[a]), i ? wv(e, a, l) : Rh(e, a, l);
    }
    return e;
}
var Po = hW;
var J_ = Math.max;
function dW(n1, t, e) {
    return t = J_(t === void 0 ? n1.length - 1 : t, 0), function() {
        for(var r = arguments, i = -1, s1 = J_(r.length - t, 0), o = Array(s1); ++i < s1;)o[i] = r[t + i];
        i = -1;
        for(var a = Array(t + 1); ++i < t;)a[i] = r[i];
        return a[t] = e(o), z_(n1, this, a);
    };
}
var $_ = dW;
var fW = 9007199254740991;
function pW(n1) {
    return typeof n1 == "number" && n1 > -1 && n1 % 1 == 0 && n1 <= fW;
}
var Lh = pW;
function mW(n1) {
    return n1 != null && Lh(n1.length) && !xv(n1);
}
var Av = mW;
var gW = Object.prototype;
function yW(n1) {
    var t = n1 && n1.constructor, e = typeof t == "function" && t.prototype || gW;
    return n1 === e;
}
var Nh = yW;
function vW(n1, t) {
    for(var e = -1, r = Array(n1); ++e < n1;)r[e] = t(e);
    return r;
}
var e2 = vW;
var xW = "[object Arguments]";
function bW(n1) {
    return Zi(n1) && is(n1) == xW;
}
var Ww = bW;
var t2 = Object.prototype, SW = t2.hasOwnProperty, wW = t2.propertyIsEnumerable, AW = Ww(function() {
    return arguments;
}()) ? Ww : function(n1) {
    return Zi(n1) && SW.call(n1, "callee") && !wW.call(n1, "callee");
}, Bh = AW;
function EW() {
    return !1;
}
var r2 = EW;
var s2 = exports && !exports.nodeType && exports, i2 = s2 && true && module && !module.nodeType && module, TW = i2 && i2.exports === s2, n2 = TW ? ti.Buffer : void 0, MW = n2 ? n2.isBuffer : void 0, CW = MW || r2, Xc = CW;
var PW = "[object Arguments]", _W = "[object Array]", IW = "[object Boolean]", DW = "[object Date]", OW = "[object Error]", RW = "[object Function]", LW = "[object Map]", NW = "[object Number]", BW = "[object Object]", FW = "[object RegExp]", VW = "[object Set]", UW = "[object String]", kW = "[object WeakMap]", zW = "[object ArrayBuffer]", GW = "[object DataView]", jW = "[object Float32Array]", HW = "[object Float64Array]", WW = "[object Int8Array]", qW = "[object Int16Array]", XW = "[object Int32Array]", YW = "[object Uint8Array]", KW = "[object Uint8ClampedArray]", QW = "[object Uint16Array]", ZW = "[object Uint32Array]", Br = {};
Br[jW] = Br[HW] = Br[WW] = Br[qW] = Br[XW] = Br[YW] = Br[KW] = Br[QW] = Br[ZW] = !0;
Br[PW] = Br[_W] = Br[zW] = Br[IW] = Br[GW] = Br[DW] = Br[OW] = Br[RW] = Br[LW] = Br[NW] = Br[BW] = Br[FW] = Br[VW] = Br[UW] = Br[kW] = !1;
function JW(n1) {
    return Zi(n1) && Lh(n1.length) && !!Br[is(n1)];
}
var o2 = JW;
function $W(n1) {
    return function(t) {
        return n1(t);
    };
}
var Fh = $W;
var a2 = exports && !exports.nodeType && exports, om = a2 && true && module && !module.nodeType && module, e6 = om && om.exports === a2, qw = e6 && pv.process, t6 = function() {
    try {
        var n1 = om && om.require && om.require("util").types;
        return n1 || qw && qw.binding && qw.binding("util");
    } catch  {}
}(), Ia = t6;
var l2 = Ia && Ia.isTypedArray, r6 = l2 ? Fh(l2) : o2, Ev = r6;
var i6 = Object.prototype, n6 = i6.hasOwnProperty;
function s6(n1, t) {
    var e = Oi(n1), r = !e && Bh(n1), i = !e && !r && Xc(n1), s1 = !e && !r && !i && Ev(n1), o = e || r || i || s1, a = o ? e2(n1.length, String) : [], l = a.length;
    for(var c in n1)(t || n6.call(n1, c)) && !(o && (c == "length" || i && (c == "offset" || c == "parent") || s1 && (c == "buffer" || c == "byteLength" || c == "byteOffset") || Dh(c, l))) && a.push(c);
    return a;
}
var Tv = s6;
function o6(n1, t) {
    return function(e) {
        return n1(t(e));
    };
}
var Mv = o6;
var a6 = Mv(Object.keys, Object), c2 = a6;
var l6 = Object.prototype, c6 = l6.hasOwnProperty;
function u6(n1) {
    if (!Nh(n1)) return c2(n1);
    var t = [];
    for(var e in Object(n1))c6.call(n1, e) && e != "constructor" && t.push(e);
    return t;
}
var u2 = u6;
function h6(n1) {
    return Av(n1) ? Tv(n1) : u2(n1);
}
var Vh = h6;
function d6(n1) {
    var t = [];
    if (n1 != null) for(var e in Object(n1))t.push(e);
    return t;
}
var h2 = d6;
var f6 = Object.prototype, p6 = f6.hasOwnProperty;
function m6(n1) {
    if (!kr(n1)) return h2(n1);
    var t = Nh(n1), e = [];
    for(var r in n1)r == "constructor" && (t || !p6.call(n1, r)) || e.push(r);
    return e;
}
var d2 = m6;
function g6(n1) {
    return Av(n1) ? Tv(n1, !0) : d2(n1);
}
var vs = g6;
var y6 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, v6 = /^\w*$/;
function x6(n1, t) {
    if (Oi(n1)) return !1;
    var e = typeof n1;
    return e == "number" || e == "symbol" || e == "boolean" || n1 == null || Co(n1) ? !0 : v6.test(n1) || !y6.test(n1) || t != null && n1 in Object(t);
}
var f2 = x6;
var b6 = Ln(Object, "create"), Da = b6;
function S6() {
    this.__data__ = Da ? Da(null) : {}, this.size = 0;
}
var p2 = S6;
function w6(n1) {
    var t = this.has(n1) && delete this.__data__[n1];
    return this.size -= t ? 1 : 0, t;
}
var m2 = w6;
var A6 = "__lodash_hash_undefined__", E6 = Object.prototype, T6 = E6.hasOwnProperty;
function M6(n1) {
    var t = this.__data__;
    if (Da) {
        var e = t[n1];
        return e === A6 ? void 0 : e;
    }
    return T6.call(t, n1) ? t[n1] : void 0;
}
var g2 = M6;
var C6 = Object.prototype, P6 = C6.hasOwnProperty;
function _6(n1) {
    var t = this.__data__;
    return Da ? t[n1] !== void 0 : P6.call(t, n1);
}
var y2 = _6;
var I6 = "__lodash_hash_undefined__";
function D6(n1, t) {
    var e = this.__data__;
    return this.size += this.has(n1) ? 0 : 1, e[n1] = Da && t === void 0 ? I6 : t, this;
}
var v2 = D6;
function Uh(n1) {
    var t = -1, e = n1 == null ? 0 : n1.length;
    for(this.clear(); ++t < e;){
        var r = n1[t];
        this.set(r[0], r[1]);
    }
}
Uh.prototype.clear = p2;
Uh.prototype.delete = m2;
Uh.prototype.get = g2;
Uh.prototype.has = y2;
Uh.prototype.set = v2;
var Xw = Uh;
function O6() {
    this.__data__ = [], this.size = 0;
}
var x2 = O6;
function R6(n1, t) {
    for(var e = n1.length; e--;)if (Oh(n1[e][0], t)) return e;
    return -1;
}
var Ol = R6;
var L6 = Array.prototype, N6 = L6.splice;
function B6(n1) {
    var t = this.__data__, e = Ol(t, n1);
    if (e < 0) return !1;
    var r = t.length - 1;
    return e == r ? t.pop() : N6.call(t, e, 1), --this.size, !0;
}
var b2 = B6;
function F6(n1) {
    var t = this.__data__, e = Ol(t, n1);
    return e < 0 ? void 0 : t[e][1];
}
var S2 = F6;
function V6(n1) {
    return Ol(this.__data__, n1) > -1;
}
var w2 = V6;
function U6(n1, t) {
    var e = this.__data__, r = Ol(e, n1);
    return r < 0 ? (++this.size, e.push([
        n1,
        t
    ])) : e[r][1] = t, this;
}
var A2 = U6;
function kh(n1) {
    var t = -1, e = n1 == null ? 0 : n1.length;
    for(this.clear(); ++t < e;){
        var r = n1[t];
        this.set(r[0], r[1]);
    }
}
kh.prototype.clear = x2;
kh.prototype.delete = b2;
kh.prototype.get = S2;
kh.prototype.has = w2;
kh.prototype.set = A2;
var Rl = kh;
var k6 = Ln(ti, "Map"), Ll = k6;
function z6() {
    this.size = 0, this.__data__ = {
        hash: new Xw,
        map: new (Ll || Rl),
        string: new Xw
    };
}
var E2 = z6;
function G6(n1) {
    var t = typeof n1;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n1 !== "__proto__" : n1 === null;
}
var T2 = G6;
function j6(n1, t) {
    var e = n1.__data__;
    return T2(t) ? e[typeof t == "string" ? "string" : "hash"] : e.map;
}
var Nl = j6;
function H6(n1) {
    var t = Nl(this, n1).delete(n1);
    return this.size -= t ? 1 : 0, t;
}
var M2 = H6;
function W6(n1) {
    return Nl(this, n1).get(n1);
}
var C2 = W6;
function q6(n1) {
    return Nl(this, n1).has(n1);
}
var P2 = q6;
function X6(n1, t) {
    var e = Nl(this, n1), r = e.size;
    return e.set(n1, t), this.size += e.size == r ? 0 : 1, this;
}
var _2 = X6;
function zh(n1) {
    var t = -1, e = n1 == null ? 0 : n1.length;
    for(this.clear(); ++t < e;){
        var r = n1[t];
        this.set(r[0], r[1]);
    }
}
zh.prototype.clear = E2;
zh.prototype.delete = M2;
zh.prototype.get = C2;
zh.prototype.has = P2;
zh.prototype.set = _2;
var Yc = zh;
var Y6 = "Expected a function";
function Yw(n1, t) {
    if (typeof n1 != "function" || t != null && typeof t != "function") throw new TypeError(Y6);
    var e = function() {
        var r = arguments, i = t ? t.apply(this, r) : r[0], s1 = e.cache;
        if (s1.has(i)) return s1.get(i);
        var o = n1.apply(this, r);
        return e.cache = s1.set(i, o) || s1, o;
    };
    return e.cache = new (Yw.Cache || Yc), e;
}
Yw.Cache = Yc;
var I2 = Yw;
var K6 = 500;
function Q6(n1) {
    var t = I2(n1, function(r) {
        return e.size === K6 && e.clear(), r;
    }), e = t.cache;
    return t;
}
var D2 = Q6;
var Z6 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, J6 = /\\(\\)?/g, $6 = D2(function(n1) {
    var t = [];
    return n1.charCodeAt(0) === 46 && t.push(""), n1.replace(Z6, function(e, r, i, s1) {
        t.push(i ? s1.replace(J6, "$1") : r || e);
    }), t;
}), O2 = $6;
function e8(n1) {
    return n1 == null ? "" : gv(n1);
}
var Cv = e8;
function t8(n1, t) {
    return Oi(n1) ? n1 : f2(n1, t) ? [
        n1
    ] : O2(Cv(n1));
}
var xs = t8;
var r8 = 1 / 0;
function i8(n1) {
    if (typeof n1 == "string" || Co(n1)) return n1;
    var t = n1 + "";
    return t == "0" && 1 / n1 == -r8 ? "-0" : t;
}
var Bl = i8;
function n8(n1, t) {
    t = xs(t, n1);
    for(var e = 0, r = t.length; n1 != null && e < r;)n1 = n1[Bl(t[e++])];
    return e && e == r ? n1 : void 0;
}
var Pv = n8;
function s8(n1, t) {
    for(var e = -1, r = t.length, i = n1.length; ++e < r;)n1[i + e] = t[e];
    return n1;
}
var Gh = s8;
var R2 = ji ? ji.isConcatSpreadable : void 0;
function o8(n1) {
    return Oi(n1) || Bh(n1) || !!(R2 && n1 && n1[R2]);
}
var L2 = o8;
function N2(n1, t, e, r, i) {
    var s1 = -1, o = n1.length;
    for(e || (e = L2), i || (i = []); ++s1 < o;){
        var a = n1[s1];
        t > 0 && e(a) ? t > 1 ? N2(a, t - 1, e, r, i) : Gh(i, a) : r || (i[i.length] = a);
    }
    return i;
}
var B2 = N2;
function a8(n1) {
    var t = n1 == null ? 0 : n1.length;
    return t ? B2(n1, 1) : [];
}
var F2 = a8;
function l8(n1) {
    return q_($_(n1, void 0, F2), n1 + "");
}
var _v = l8;
var c8 = Mv(Object.getPrototypeOf, Object), jh = c8;
var u8 = "[object Object]", h8 = Function.prototype, d8 = Object.prototype, V2 = h8.toString, f8 = d8.hasOwnProperty, p8 = V2.call(Object);
function m8(n1) {
    if (!Zi(n1) || is(n1) != u8) return !1;
    var t = jh(n1);
    if (t === null) return !0;
    var e = f8.call(t, "constructor") && t.constructor;
    return typeof e == "function" && e instanceof e && V2.call(e) == p8;
}
var U2 = m8;
function g8(n1, t, e) {
    var r = -1, i = n1.length;
    t < 0 && (t = -t > i ? 0 : i + t), e = e > i ? i : e, e < 0 && (e += i), i = t > e ? 0 : e - t >>> 0, t >>>= 0;
    for(var s1 = Array(i); ++r < i;)s1[r] = n1[r + t];
    return s1;
}
var Iv = g8;
function y8(n1, t, e) {
    var r = n1.length;
    return e = e === void 0 ? r : e, !t && e >= r ? n1 : Iv(n1, t, e);
}
var k2 = y8;
var v8 = "\ud800-\udfff", x8 = "\\u0300-\\u036f", b8 = "\\ufe20-\\ufe2f", S8 = "\\u20d0-\\u20ff", w8 = x8 + b8 + S8, A8 = "\\ufe0e\\ufe0f", E8 = "\\u200d", T8 = RegExp("[" + E8 + v8 + w8 + A8 + "]");
function M8(n1) {
    return T8.test(n1);
}
var z2 = M8;
function C8(n1) {
    return n1.split("");
}
var G2 = C8;
var j2 = "\ud800-\udfff", P8 = "\\u0300-\\u036f", _8 = "\\ufe20-\\ufe2f", I8 = "\\u20d0-\\u20ff", D8 = P8 + _8 + I8, O8 = "\\ufe0e\\ufe0f", R8 = "[" + j2 + "]", Kw = "[" + D8 + "]", Qw = "\ud83c[\udffb-\udfff]", L8 = "(?:" + Kw + "|" + Qw + ")", H2 = "[^" + j2 + "]", W2 = "(?:\ud83c[\udde6-\uddff]){2}", q2 = "[\ud800-\udbff][\udc00-\udfff]", N8 = "\\u200d", X2 = L8 + "?", Y2 = "[" + O8 + "]?", B8 = "(?:" + N8 + "(?:" + [
    H2,
    W2,
    q2
].join("|") + ")" + Y2 + X2 + ")*", F8 = Y2 + X2 + B8, V8 = "(?:" + [
    H2 + Kw + "?",
    Kw,
    W2,
    q2,
    R8
].join("|") + ")", U8 = RegExp(Qw + "(?=" + Qw + ")|" + V8 + F8, "g");
function k8(n1) {
    return n1.match(U8) || [];
}
var K2 = k8;
function z8(n1) {
    return z2(n1) ? K2(n1) : G2(n1);
}
var Zw = z8;
function G8() {
    this.__data__ = new Rl, this.size = 0;
}
var Q2 = G8;
function j8(n1) {
    var t = this.__data__, e = t.delete(n1);
    return this.size = t.size, e;
}
var Z2 = j8;
function H8(n1) {
    return this.__data__.get(n1);
}
var J2 = H8;
function W8(n1) {
    return this.__data__.has(n1);
}
var $2 = W8;
var q8 = 200;
function X8(n1, t) {
    var e = this.__data__;
    if (e instanceof Rl) {
        var r = e.__data__;
        if (!Ll || r.length < q8 - 1) return r.push([
            n1,
            t
        ]), this.size = ++e.size, this;
        e = this.__data__ = new Yc(r);
    }
    return e.set(n1, t), this.size = e.size, this;
}
var eI = X8;
function Hh(n1) {
    var t = this.__data__ = new Rl(n1);
    this.size = t.size;
}
Hh.prototype.clear = Q2;
Hh.prototype.delete = Z2;
Hh.prototype.get = J2;
Hh.prototype.has = $2;
Hh.prototype.set = eI;
var Wh = Hh;
function Y8(n1, t) {
    return n1 && Po(t, Vh(t), n1);
}
var tI = Y8;
function K8(n1, t) {
    return n1 && Po(t, vs(t), n1);
}
var rI = K8;
var oI = exports && !exports.nodeType && exports, iI = oI && true && module && !module.nodeType && module, Q8 = iI && iI.exports === oI, nI = Q8 ? ti.Buffer : void 0, sI = nI ? nI.allocUnsafe : void 0;
function Z8(n1, t) {
    if (t) return n1.slice();
    var e = n1.length, r = sI ? sI(e) : new n1.constructor(e);
    return n1.copy(r), r;
}
var aI = Z8;
function J8(n1, t) {
    for(var e = -1, r = n1 == null ? 0 : n1.length, i = 0, s1 = []; ++e < r;){
        var o = n1[e];
        t(o, e, n1) && (s1[i++] = o);
    }
    return s1;
}
var lI = J8;
function $8() {
    return [];
}
var Dv = $8;
var e9 = Object.prototype, t9 = e9.propertyIsEnumerable, cI = Object.getOwnPropertySymbols, r9 = cI ? function(n1) {
    return n1 == null ? [] : (n1 = Object(n1), lI(cI(n1), function(t) {
        return t9.call(n1, t);
    }));
} : Dv, qh = r9;
function i9(n1, t) {
    return Po(n1, qh(n1), t);
}
var uI = i9;
var n9 = Object.getOwnPropertySymbols, s9 = n9 ? function(n1) {
    for(var t = []; n1;)Gh(t, qh(n1)), n1 = jh(n1);
    return t;
} : Dv, Ov = s9;
function o9(n1, t) {
    return Po(n1, Ov(n1), t);
}
var hI = o9;
function a9(n1, t, e) {
    var r = t(n1);
    return Oi(n1) ? r : Gh(r, e(n1));
}
var Rv = a9;
function l9(n1) {
    return Rv(n1, Vh, qh);
}
var am = l9;
function c9(n1) {
    return Rv(n1, vs, Ov);
}
var Lv = c9;
var u9 = Ln(ti, "DataView"), Nv = u9;
var h9 = Ln(ti, "Promise"), Bv = h9;
var d9 = Ln(ti, "Set"), Fv = d9;
var dI = "[object Map]", f9 = "[object Object]", fI = "[object Promise]", pI = "[object Set]", mI = "[object WeakMap]", gI = "[object DataView]", p9 = _a(Nv), m9 = _a(Ll), g9 = _a(Bv), y9 = _a(Fv), v9 = _a(Sv), Kc = is;
(Nv && Kc(new Nv(new ArrayBuffer(1))) != gI || Ll && Kc(new Ll) != dI || Bv && Kc(Bv.resolve()) != fI || Fv && Kc(new Fv) != pI || Sv && Kc(new Sv) != mI) && (Kc = function(n1) {
    var t = is(n1), e = t == f9 ? n1.constructor : void 0, r = e ? _a(e) : "";
    if (r) switch(r){
        case p9:
            return gI;
        case m9:
            return dI;
        case g9:
            return fI;
        case y9:
            return pI;
        case v9:
            return mI;
    }
    return t;
});
var Oa = Kc;
var x9 = Object.prototype, b9 = x9.hasOwnProperty;
function S9(n1) {
    var t = n1.length, e = new n1.constructor(t);
    return t && typeof n1[0] == "string" && b9.call(n1, "index") && (e.index = n1.index, e.input = n1.input), e;
}
var yI = S9;
var w9 = ti.Uint8Array, Xh = w9;
function A9(n1) {
    var t = new n1.constructor(n1.byteLength);
    return new Xh(t).set(new Xh(n1)), t;
}
var Yh = A9;
function E9(n1, t) {
    var e = t ? Yh(n1.buffer) : n1.buffer;
    return new n1.constructor(e, n1.byteOffset, n1.byteLength);
}
var vI = E9;
var T9 = /\w*$/;
function M9(n1) {
    var t = new n1.constructor(n1.source, T9.exec(n1));
    return t.lastIndex = n1.lastIndex, t;
}
var xI = M9;
var bI = ji ? ji.prototype : void 0, SI = bI ? bI.valueOf : void 0;
function C9(n1) {
    return SI ? Object(SI.call(n1)) : {};
}
var wI = C9;
function P9(n1, t) {
    var e = t ? Yh(n1.buffer) : n1.buffer;
    return new n1.constructor(e, n1.byteOffset, n1.length);
}
var AI = P9;
var _9 = "[object Boolean]", I9 = "[object Date]", D9 = "[object Map]", O9 = "[object Number]", R9 = "[object RegExp]", L9 = "[object Set]", N9 = "[object String]", B9 = "[object Symbol]", F9 = "[object ArrayBuffer]", V9 = "[object DataView]", U9 = "[object Float32Array]", k9 = "[object Float64Array]", z9 = "[object Int8Array]", G9 = "[object Int16Array]", j9 = "[object Int32Array]", H9 = "[object Uint8Array]", W9 = "[object Uint8ClampedArray]", q9 = "[object Uint16Array]", X9 = "[object Uint32Array]";
function Y9(n1, t, e) {
    var r = n1.constructor;
    switch(t){
        case F9:
            return Yh(n1);
        case _9:
        case I9:
            return new r(+n1);
        case V9:
            return vI(n1, e);
        case U9:
        case k9:
        case z9:
        case G9:
        case j9:
        case H9:
        case W9:
        case q9:
        case X9:
            return AI(n1, e);
        case D9:
            return new r;
        case O9:
        case N9:
            return new r(n1);
        case R9:
            return xI(n1);
        case L9:
            return new r;
        case B9:
            return wI(n1);
    }
}
var EI = Y9;
function K9(n1) {
    return typeof n1.constructor == "function" && !Nh(n1) ? k_(jh(n1)) : {};
}
var TI = K9;
var Q9 = "[object Map]";
function Z9(n1) {
    return Zi(n1) && Oa(n1) == Q9;
}
var MI = Z9;
var CI = Ia && Ia.isMap, J9 = CI ? Fh(CI) : MI, PI = J9;
var $9 = "[object Set]";
function eq(n1) {
    return Zi(n1) && Oa(n1) == $9;
}
var _I = eq;
var II = Ia && Ia.isSet, tq = II ? Fh(II) : _I, DI = tq;
var rq = 1, iq = 2, nq = 4, OI = "[object Arguments]", sq = "[object Array]", oq = "[object Boolean]", aq = "[object Date]", lq = "[object Error]", RI = "[object Function]", cq = "[object GeneratorFunction]", uq = "[object Map]", hq = "[object Number]", LI = "[object Object]", dq = "[object RegExp]", fq = "[object Set]", pq = "[object String]", mq = "[object Symbol]", gq = "[object WeakMap]", yq = "[object ArrayBuffer]", vq = "[object DataView]", xq = "[object Float32Array]", bq = "[object Float64Array]", Sq = "[object Int8Array]", wq = "[object Int16Array]", Aq = "[object Int32Array]", Eq = "[object Uint8Array]", Tq = "[object Uint8ClampedArray]", Mq = "[object Uint16Array]", Cq = "[object Uint32Array]", Rr = {};
Rr[OI] = Rr[sq] = Rr[yq] = Rr[vq] = Rr[oq] = Rr[aq] = Rr[xq] = Rr[bq] = Rr[Sq] = Rr[wq] = Rr[Aq] = Rr[uq] = Rr[hq] = Rr[LI] = Rr[dq] = Rr[fq] = Rr[pq] = Rr[mq] = Rr[Eq] = Rr[Tq] = Rr[Mq] = Rr[Cq] = !0;
Rr[lq] = Rr[RI] = Rr[gq] = !1;
function Vv(n1, t, e, r, i, s1) {
    var o, a = t & rq, l = t & iq, c = t & nq;
    if (e && (o = i ? e(n1, r, i, s1) : e(n1)), o !== void 0) return o;
    if (!kr(n1)) return n1;
    var u1 = Oi(n1);
    if (u1) {
        if (o = yI(n1), !a) return G_(n1, o);
    } else {
        var h = Oa(n1), d = h == RI || h == cq;
        if (Xc(n1)) return aI(n1, a);
        if (h == LI || h == OI || d && !i) {
            if (o = l || d ? {} : TI(n1), !a) return l ? hI(n1, rI(o, n1)) : uI(n1, tI(o, n1));
        } else {
            if (!Rr[h]) return i ? n1 : {};
            o = EI(n1, h, a);
        }
    }
    s1 || (s1 = new Wh);
    var f = s1.get(n1);
    if (f) return f;
    s1.set(n1, o), DI(n1) ? n1.forEach(function(g) {
        o.add(Vv(g, t, e, g, n1, s1));
    }) : PI(n1) && n1.forEach(function(g, y) {
        o.set(y, Vv(g, t, e, y, n1, s1));
    });
    var m = c ? l ? Lv : am : l ? vs : Vh, p = u1 ? void 0 : m(n1);
    return X_(p || n1, function(g, y) {
        p && (y = g, g = n1[y]), Rh(o, y, Vv(g, t, e, y, n1, s1));
    }), o;
}
var Uv = Vv;
var Pq = 1, _q = 4;
function Iq(n1) {
    return Uv(n1, Pq | _q);
}
var Ra = Iq;
var Dq = "__lodash_hash_undefined__";
function Oq(n1) {
    return this.__data__.set(n1, Dq), this;
}
var NI = Oq;
function Rq(n1) {
    return this.__data__.has(n1);
}
var BI = Rq;
function kv(n1) {
    var t = -1, e = n1 == null ? 0 : n1.length;
    for(this.__data__ = new Yc; ++t < e;)this.add(n1[t]);
}
kv.prototype.add = kv.prototype.push = NI;
kv.prototype.has = BI;
var FI = kv;
function Lq(n1, t) {
    for(var e = -1, r = n1 == null ? 0 : n1.length; ++e < r;)if (t(n1[e], e, n1)) return !0;
    return !1;
}
var VI = Lq;
function Nq(n1, t) {
    return n1.has(t);
}
var UI = Nq;
var Bq = 1, Fq = 2;
function Vq(n1, t, e, r, i, s1) {
    var o = e & Bq, a = n1.length, l = t.length;
    if (a != l && !(o && l > a)) return !1;
    var c = s1.get(n1), u1 = s1.get(t);
    if (c && u1) return c == t && u1 == n1;
    var h = -1, d = !0, f = e & Fq ? new FI : void 0;
    for(s1.set(n1, t), s1.set(t, n1); ++h < a;){
        var m = n1[h], p = t[h];
        if (r) var g = o ? r(p, m, h, t, n1, s1) : r(m, p, h, n1, t, s1);
        if (g !== void 0) {
            if (g) continue;
            d = !1;
            break;
        }
        if (f) {
            if (!VI(t, function(y, x) {
                if (!UI(f, x) && (m === y || i(m, y, e, r, s1))) return f.push(x);
            })) {
                d = !1;
                break;
            }
        } else if (!(m === p || i(m, p, e, r, s1))) {
            d = !1;
            break;
        }
    }
    return s1.delete(n1), s1.delete(t), d;
}
var zv = Vq;
function Uq(n1) {
    var t = -1, e = Array(n1.size);
    return n1.forEach(function(r, i) {
        e[++t] = [
            i,
            r
        ];
    }), e;
}
var kI = Uq;
function kq(n1) {
    var t = -1, e = Array(n1.size);
    return n1.forEach(function(r) {
        e[++t] = r;
    }), e;
}
var zI = kq;
var zq = 1, Gq = 2, jq = "[object Boolean]", Hq = "[object Date]", Wq = "[object Error]", qq = "[object Map]", Xq = "[object Number]", Yq = "[object RegExp]", Kq = "[object Set]", Qq = "[object String]", Zq = "[object Symbol]", Jq = "[object ArrayBuffer]", $q = "[object DataView]", GI = ji ? ji.prototype : void 0, Jw = GI ? GI.valueOf : void 0;
function e7(n1, t, e, r, i, s1, o) {
    switch(e){
        case $q:
            if (n1.byteLength != t.byteLength || n1.byteOffset != t.byteOffset) return !1;
            n1 = n1.buffer, t = t.buffer;
        case Jq:
            return !(n1.byteLength != t.byteLength || !s1(new Xh(n1), new Xh(t)));
        case jq:
        case Hq:
        case Xq:
            return Oh(+n1, +t);
        case Wq:
            return n1.name == t.name && n1.message == t.message;
        case Yq:
        case Qq:
            return n1 == t + "";
        case qq:
            var a = kI;
        case Kq:
            var l = r & zq;
            if (a || (a = zI), n1.size != t.size && !l) return !1;
            var c = o.get(n1);
            if (c) return c == t;
            r |= Gq, o.set(n1, t);
            var u1 = zv(a(n1), a(t), r, i, s1, o);
            return o.delete(n1), u1;
        case Zq:
            if (Jw) return Jw.call(n1) == Jw.call(t);
    }
    return !1;
}
var jI = e7;
var t7 = 1, r7 = Object.prototype, i7 = r7.hasOwnProperty;
function n7(n1, t, e, r, i, s1) {
    var o = e & t7, a = am(n1), l = a.length, c = am(t), u1 = c.length;
    if (l != u1 && !o) return !1;
    for(var h = l; h--;){
        var d = a[h];
        if (!(o ? d in t : i7.call(t, d))) return !1;
    }
    var f = s1.get(n1), m = s1.get(t);
    if (f && m) return f == t && m == n1;
    var p = !0;
    s1.set(n1, t), s1.set(t, n1);
    for(var g = o; ++h < l;){
        d = a[h];
        var y = n1[d], x = t[d];
        if (r) var v = o ? r(x, y, d, t, n1, s1) : r(y, x, d, n1, t, s1);
        if (!(v === void 0 ? y === x || i(y, x, e, r, s1) : v)) {
            p = !1;
            break;
        }
        g || (g = d == "constructor");
    }
    if (p && !g) {
        var b = n1.constructor, w = t.constructor;
        b != w && "constructor" in n1 && "constructor" in t && !(typeof b == "function" && b instanceof b && typeof w == "function" && w instanceof w) && (p = !1);
    }
    return s1.delete(n1), s1.delete(t), p;
}
var HI = n7;
var s7 = 1, WI = "[object Arguments]", qI = "[object Array]", Gv = "[object Object]", o7 = Object.prototype, XI = o7.hasOwnProperty;
function a7(n1, t, e, r, i, s1) {
    var o = Oi(n1), a = Oi(t), l = o ? qI : Oa(n1), c = a ? qI : Oa(t);
    l = l == WI ? Gv : l, c = c == WI ? Gv : c;
    var u1 = l == Gv, h = c == Gv, d = l == c;
    if (d && Xc(n1)) {
        if (!Xc(t)) return !1;
        o = !0, u1 = !1;
    }
    if (d && !u1) return s1 || (s1 = new Wh), o || Ev(n1) ? zv(n1, t, e, r, i, s1) : jI(n1, t, l, e, r, i, s1);
    if (!(e & s7)) {
        var f = u1 && XI.call(n1, "__wrapped__"), m = h && XI.call(t, "__wrapped__");
        if (f || m) {
            var p = f ? n1.value() : n1, g = m ? t.value() : t;
            return s1 || (s1 = new Wh), i(p, g, e, r, s1);
        }
    }
    return d ? (s1 || (s1 = new Wh), HI(n1, t, e, r, i, s1)) : !1;
}
var YI = a7;
function KI(n1, t, e, r, i) {
    return n1 === t ? !0 : n1 == null || t == null || !Zi(n1) && !Zi(t) ? n1 !== n1 && t !== t : YI(n1, t, e, r, KI, i);
}
var QI = KI;
function l7(n1, t) {
    return n1 != null && t in Object(n1);
}
var ZI = l7;
function c7(n1, t, e) {
    t = xs(t, n1);
    for(var r = -1, i = t.length, s1 = !1; ++r < i;){
        var o = Bl(t[r]);
        if (!(s1 = n1 != null && e(n1, o))) break;
        n1 = n1[o];
    }
    return s1 || ++r != i ? s1 : (i = n1 == null ? 0 : n1.length, !!i && Lh(i) && Dh(o, i) && (Oi(n1) || Bh(n1)));
}
var JI = c7;
function u7(n1, t) {
    return n1 != null && JI(n1, t, ZI);
}
var $I = u7;
var h7 = function() {
    return ti.Date.now();
}, jv = h7;
var d7 = "Expected a function", f7 = Math.max, p7 = Math.min;
function m7(n1, t, e) {
    var r, i, s1, o, a, l, c = 0, u1 = !1, h = !1, d = !0;
    if (typeof n1 != "function") throw new TypeError(d7);
    t = Hw(t) || 0, kr(e) && (u1 = !!e.leading, h = "maxWait" in e, s1 = h ? f7(Hw(e.maxWait) || 0, t) : s1, d = "trailing" in e ? !!e.trailing : d);
    function f(A) {
        var T = r, S = i;
        return r = i = void 0, c = A, o = n1.apply(S, T), o;
    }
    function m(A) {
        return c = A, a = setTimeout(y, t), u1 ? f(A) : o;
    }
    function p(A) {
        var T = A - l, S = A - c, M = t - T;
        return h ? p7(M, s1 - S) : M;
    }
    function g(A) {
        var T = A - l, S = A - c;
        return l === void 0 || T >= t || T < 0 || h && S >= s1;
    }
    function y() {
        var A = jv();
        if (g(A)) return x(A);
        a = setTimeout(y, p(A));
    }
    function x(A) {
        return a = void 0, d && r ? f(A) : (r = i = void 0, o);
    }
    function v() {
        a !== void 0 && clearTimeout(a), c = 0, r = l = i = a = void 0;
    }
    function b() {
        return a === void 0 ? o : x(jv());
    }
    function w() {
        var A = jv(), T = g(A);
        if (r = arguments, i = this, l = A, T) {
            if (a === void 0) return m(l);
            if (h) return clearTimeout(a), a = setTimeout(y, t), f(l);
        }
        return a === void 0 && (a = setTimeout(y, t)), o;
    }
    return w.cancel = v, w.flush = b, w;
}
var _o = m7;
function g7(n1) {
    var t = n1 == null ? 0 : n1.length;
    return t ? n1[t - 1] : void 0;
}
var eD = g7;
function y7(n1, t) {
    return n1 > t;
}
var tD = y7;
function v7(n1, t) {
    return t.length < 2 ? n1 : Pv(n1, Iv(t, 0, -1));
}
var rD = v7;
function x7(n1, t) {
    return QI(n1, t);
}
var Qc = x7;
function b7(n1, t, e) {
    for(var r = -1, i = n1.length; ++r < i;){
        var s1 = n1[r], o = t(s1);
        if (o != null && (a === void 0 ? o === o && !Co(o) : e(o, a))) var a = o, l = s1;
    }
    return l;
}
var iD = b7;
function S7(n1) {
    return n1 && n1.length ? iD(n1, vv, tD) : void 0;
}
var $w = S7;
function w7(n1, t) {
    return t = xs(t, n1), n1 = rD(n1, t), n1 == null || delete n1[Bl(eD(t))];
}
var nD = w7;
function A7(n1) {
    return U2(n1) ? void 0 : n1;
}
var sD = A7;
var E7 = 1, T7 = 2, M7 = 4, C7 = _v(function(n1, t) {
    var e = {};
    if (n1 == null) return e;
    var r = !1;
    t = mv(t, function(s1) {
        return s1 = xs(s1, n1), r || (r = s1.length > 1), s1;
    }), Po(n1, Lv(n1), e), r && (e = Uv(e, E7 | T7 | M7, sD));
    for(var i = t.length; i--;)nD(e, t[i]);
    return e;
}), Kh = C7;
function P7(n1, t, e, r) {
    if (!kr(n1)) return n1;
    t = xs(t, n1);
    for(var i = -1, s1 = t.length, o = s1 - 1, a = n1; a != null && ++i < s1;){
        var l = Bl(t[i]), c = e;
        if (l === "__proto__" || l === "constructor" || l === "prototype") return n1;
        if (i != o) {
            var u1 = a[l];
            c = r ? r(u1, l, a) : void 0, c === void 0 && (c = kr(u1) ? u1 : Dh(t[i + 1]) ? [] : {});
        }
        Rh(a, l, c), a = a[l];
    }
    return n1;
}
var oD = P7;
function _7(n1, t, e) {
    for(var r = -1, i = t.length, s1 = {}; ++r < i;){
        var o = t[r], a = Pv(n1, o);
        e(a, o) && oD(s1, xs(o, n1), a);
    }
    return s1;
}
var aD = _7;
function I7(n1, t) {
    return aD(n1, t, function(e, r) {
        return $I(n1, r);
    });
}
var lD = I7;
var D7 = _v(function(n1, t) {
    return n1 == null ? {} : lD(n1, t);
}), Nn = D7;
var O7 = "Expected a function";
function R7(n1, t, e) {
    var r = !0, i = !0;
    if (typeof n1 != "function") throw new TypeError(O7);
    return kr(e) && (r = "leading" in e ? !!e.leading : r, i = "trailing" in e ? !!e.trailing : i), _o(n1, t, {
        leading: r,
        maxWait: t,
        trailing: i
    });
}
var eA = R7;
function L7(n1, t) {
    for(var e = n1.length; e-- && Z_(t, n1[e], 0) > -1;);
    return e;
}
var cD = L7;
function N7(n1, t, e) {
    if (n1 = Cv(n1), n1 && (e || t === void 0)) return n1.slice(0, yv(n1) + 1);
    if (!n1 || !(t = gv(t))) return n1;
    var r = Zw(n1), i = cD(r, Zw(t)) + 1;
    return k2(r, 0, i).join("");
}
var tA = N7;
function Hv(n1) {
    for (let t of Object.keys(n1))n1[t] === void 0 && delete n1[t];
    return n1;
}
function Ri(n1, t) {
    return Object.setPrototypeOf(n1, t), n1;
}
var B7 = ()=>typeof window > "u" ? !1 : window.navigator.userAgent.toLowerCase().includes(" electron/"), F7 = ()=>typeof window > "u" ? !1 : window.navigator.platform.toUpperCase().includes("MAC"), V7 = ()=>typeof window > "u" ? !1 : /iPad|iPhone|iPod/.test(window.navigator.userAgent) || Qh && "ontouchend" in document, U7 = ()=>typeof window > "u" ? !1 : window.navigator.userAgent.toLowerCase().indexOf("firefox") > -1, k7 = ()=>typeof window > "u" ? !1 : "ontouchstart" in window || navigator.maxTouchPoints > 0, z7 = ()=>{
    if (typeof window > "u") return !1;
    let n1 = navigator.userAgent, t = navigator.vendor;
    return /Safari/i.test(n1) && /Apple Computer/.test(t);
}, G7 = ()=>{
    if (typeof window > "u") return null;
    let t = navigator.userAgent.match(/Version\/(\d+\.\d)/);
    return t && t[1];
}, j7 = ()=>{
    if (typeof window > "u") return;
    let t = new URLSearchParams(window.location.search).get("desktop-app-version");
    return t ? (window.localStorage.setItem("desktop-app-version", t), t) : window.localStorage.getItem("desktop-app-version") ?? "0.0.6";
}, rA = B7(), Lde = rA ? j7() : void 0, Qh = F7(), bs = V7(), uD = U7(), Li = k7(), iA = z7(), hD = Number(G7());
function Wv(n1) {
    return Array.isArray(n1) ? n1 : [
        n1
    ];
}
function qv(n1, t) {
    let e = 0;
    for(; e < n1.length && e < t.length;){
        if (n1[e] < t[e]) return -1;
        if (n1[e] > t[e]) return 1;
        e += 1;
    }
    return e !== t.length ? -1 : e !== n1.length ? 1 : 0;
}
function lm(n1) {
    return Qh ? n1.metaKey : n1.ctrlKey;
}
function dD(n1) {
    return n1.wheelDeltaY === 0 || n1.deltaY === 0 ? Qh && n1.shiftKey && Math.abs(n1.wheelDeltaX) >= 120 ? !1 : n1.wheelDeltaX ? n1.wheelDeltaX === -3 * n1.deltaX || n1.wheelDeltaX === -3 * window.devicePixelRatio * n1.deltaX : n1.deltaMode === 0 : n1.wheelDeltaY ? n1.wheelDeltaY === -3 * n1.deltaY || n1.wheelDeltaY === -3 * window.devicePixelRatio * n1.deltaY : n1.deltaMode === 0;
}
var et = [], Yv = {}, cm = {}, Xv = {};
function fD(n1) {
    et.includes(n1) || et.push(n1);
}
function Zh(n1) {
    delete Yv[n1.pointerId];
    for(let t = 0; t < et.length; t++)if (et[t].pointerId === n1.pointerId) {
        et.splice(t, 1);
        break;
    }
}
function pD() {
    et.splice(0, et.length);
}
function Kv(n1) {
    if (n1.pointerType !== "touch") return;
    let t = Yv[n1.pointerId];
    t === void 0 && (t = {
        x: 0,
        y: 0
    }, Yv[n1.pointerId] = t), t.x = n1.pageX, t.y = n1.pageY;
}
function Qv(n1) {
    let t = n1.pointerId === et[0].pointerId ? et[1] : et[0];
    return Yv[t.pointerId];
}
function mD(n1) {
    cm[n1.key] = !0, Xv[n1.key] = Xv[n1.key] === void 0 ? 1 : Xv[n1.key] + 1;
}
function gD(n1) {
    if (Qh && cm.Meta) for(let t in cm)cm[t] = !1;
    else cm[n1.key] = !1;
    Xv = {};
}
function yD(n1) {
    n1.addEventListener("pointerdown", fD, !0), n1.addEventListener("pointerdown", Kv, !0), n1.addEventListener("pointermove", Kv, !0), n1.addEventListener("pointerup", Zh, !0), n1.addEventListener("pointercancel", Zh, !0), n1.addEventListener("pointerleave", Zh, !0), window.addEventListener("keydown", mD, !0), window.addEventListener("keyup", gD, !0);
}
function vD(n1) {
    n1.removeEventListener("pointerdown", fD, !0), n1.removeEventListener("pointerdown", Kv, !0), n1.removeEventListener("pointermove", Kv, !0), n1.removeEventListener("pointerup", Zh, !0), n1.removeEventListener("pointercancel", Zh, !0), n1.removeEventListener("pointerleave", Zh, !0), window.removeEventListener("keydown", mD, !0), window.removeEventListener("keyup", gD, !0);
}
var xD, bD = new Promise((n1)=>{
    xD = n1;
});
var Zv;

function SD(n1) {
    if (Zv) return Zv;
    async function t() {
        let r = n1 ?? "https://unpkg.com/@splinetool/navmesh-wasm@1.12.53/build", s1 = (parcelRequire("8b5hF")), [o, a] = await Promise.all([
            s1,
            fetch(`${r}/navmesh.wasm`).then((u1)=>u1.arrayBuffer())
        ]), l = o.default, c = await l({
            wasmBinary: a
        });
        xD(c);
    }
    return Zv = t(), Zv;
}
var wD, AD = new Promise((n1)=>{
    wD = n1;
});
var Jv;

function ED() {
    if (Jv) return Jv;
    async function n1() {
        let e = await (parcelRequire("lUNnT"));
        await e.init(), wD(e);
    }
    return Jv = n1(), Jv;
}
var He = class {
    modifyById(t, e) {
        let r = this;
        if (r[t] === void 0) throw new Error("not expected");
        {
            let s1 = {
                ...r,
                [t]: e
            };
            return Object.setPrototypeOf(s1, He.prototype), s1;
        }
    }
    add(t, e) {
        return this.runOp({
            type: 1,
            id: t,
            data: e
        })?.data ?? this;
    }
    runOp(t) {
        let e = this;
        if (t.type === 1) {
            let r = e[t.id], i;
            r === void 0 ? i = {
                type: 2,
                id: t.id
            } : i = {
                type: 1,
                id: t.id,
                data: r
            };
            let { id: s1, data: o } = t, a = {
                ...e,
                [s1]: o
            };
            return Object.setPrototypeOf(a, He.prototype), {
                data: a,
                actual: t,
                reverse: i
            };
        } else if (t.type === 2) {
            let { id: r } = t, i = e[r];
            if (i === void 0) return null;
            {
                let s1 = {
                    ...e
                };
                return Object.setPrototypeOf(s1, He.prototype), delete s1[r], {
                    data: s1,
                    actual: t,
                    reverse: {
                        type: 1,
                        id: r,
                        data: i
                    }
                };
            }
        }
        return null;
    }
};
function um(n1) {
    if (n1.deepFreeze !== void 0) {
        n1.deepFreeze(n1);
        return;
    }
    let t = Object.getOwnPropertyNames(n1);
    for (let e of t){
        let r = n1[e];
        r && typeof r == "object" && um(r);
    }
    return Object.freeze(n1);
}
function TD(n1, t) {
    let e = 0;
    for(; e < n1.length && e < t.length;){
        if (n1[e] < t[e]) return -1;
        if (n1[e] > t[e]) return 1;
        e += 1;
    }
    return e !== t.length ? -1 : e !== n1.length ? 1 : 0;
}
var Jh = class extends Error {
};
function $v(n1) {
    let t = {
        ...n1
    };
    return Object.setPrototypeOf(t, Object.getPrototypeOf(n1)), t;
}
function Io(n1, t, e) {
    if (n1 === void 0 ? t === void 0 ? (n1 = 0, t = 10) : n1 = t - 10 : t === void 0 && (t = n1 + 10), n1 > t) {
        let s1 = n1;
        n1 = t, t = s1;
    }
    let r = [], i = 1 / (e + 1);
    for(let s1 = 0; s1 < e; s1++){
        let o = n1 + (t - n1) * (s1 + .75 + Math.random() * .5) * i;
        r.push(o);
    }
    return r;
}
function $h(n1) {
    return n1 instanceof Uint8Array || n1 instanceof Uint16Array || n1 instanceof Uint32Array || n1 instanceof Int8Array || n1 instanceof Int16Array || n1 instanceof Int32Array || n1 instanceof Float32Array || n1 instanceof Float64Array;
}
function MD() {
    return typeof $hPtJY < "u";
}
function CD(n1, t) {
    for (let e of n1)t(e.id, e.data) !== !0 && CD(e.children, t);
}
function PD(n1, t) {
    if (t(n1.id, n1.data) !== !0) for (let e of n1.children)PD(e, t);
}
var wr = class extends Array {
    constructor(...e){
        super(...e);
        Object.setPrototypeOf(this, wr.prototype);
    }
    deepFreeze() {
        let e = 0;
        for(; e < this.length;)um(this[e]), e++;
    }
    fillCaches0(e, r) {
        this.objCaches.set(e.id, e), this.parentCaches.set(e.id, r);
        for (let i of e.children)this.fillCaches0(i, e.id);
    }
    fillCaches() {
        if (this.objCaches === void 0) {
            this.objCaches = new Map, this.parentCaches = new Map;
            for (let e of this)this.fillCaches0(e, null);
        }
    }
    randomId() {
        this.fillCaches();
        let e = Array.from(this.objCaches.keys());
        if (e.length !== 0) return e[Math.max(0, Math.floor(Math.random() * e.length) - 1)];
    }
    nonExistOrDescendantOf(e, r) {
        if (!this.has(e)) return !0;
        for(; e;){
            let i = this.parent(e);
            if (i === r) return !0;
            e = i;
        }
        return !1;
    }
    rootAcestor(e) {
        for(; e;){
            let r = this.parent(e);
            if (r) e = r;
            else return e;
        }
        return e;
    }
    isDescendantOf(e, r) {
        for(; e;){
            let i = this.parent(e);
            if (i === r) return !0;
            e = i;
        }
        return !1;
    }
    data(e) {
        return this.get(e)?.data;
    }
    has(e) {
        return this.childrenOf(e) !== void 0;
    }
    get(e) {
        return this.fillCaches(), this.objCaches.get(e);
    }
    childrenOf(e) {
        return e === null ? this : this.get(e)?.children;
    }
    traverseFrom(e, r) {
        if (e === null) this.traverse(r);
        else {
            let i = this.get(e);
            i && PD(i, r);
        }
    }
    traverse(e) {
        CD(this, e);
    }
    totalSize() {
        return this.fillCaches(), this.objCaches.size;
    }
    parent(e) {
        return this.fillCaches(), this.parentCaches.get(e);
    }
    childrenArray(e) {
        return e === null ? this : this.get(e).children;
    }
    modifyById(e, r) {
        if (this.get(e) === void 0) throw new Error("not expected");
        {
            let s1 = this.parent(e), o = this.childrenArray(s1), a = o.findIndex((u1)=>u1.id === e);
            if (a < 0) throw new Error("not expected");
            let l = o[a];
            return o = [
                ...o
            ], o[a] = {
                ...l,
                data: r
            }, this.modifyArrayBy(s1, o);
        }
    }
    modifyArrayBy(e, r) {
        let i = e, s1 = r;
        for(; i !== null;){
            let a = s1, l = i;
            if (i = this.parent(i), i === void 0) throw new Error;
            s1 = this.childrenArray(i);
            let c = s1.findIndex((u1)=>u1.id === l);
            if (c < 0) throw new Error;
            s1 = [
                ...s1
            ], s1[c] = {
                ...s1[c],
                children: a
            };
        }
        Object.setPrototypeOf(s1, wr.prototype);
        let o = s1;
        return o.fillCaches(), o;
    }
    runOp(e) {
        switch(e.type){
            case 7:
                return this.addOp(e);
            case 8:
                return this.deleteOp(e);
            case 9:
                return this.moveOp(e);
        }
        return null;
    }
    checkDuplicatedIdRec({ id: e, children: r }) {
        if (this.get(e) !== void 0) return !0;
        for (let i of r)if (this.checkDuplicatedIdRec(i)) return !0;
        return !1;
    }
    addOp(e) {
        let { parent: r, fi: i, id: s1, data: o, children: a } = e;
        if (r !== null && this.get(r) === void 0) return null;
        if (this.checkDuplicatedIdRec(e)) return null;
        {
            let l = r, c = this.childrenArray(l), u1 = {
                fi: i,
                id: s1,
                data: o,
                children: a
            };
            return c = [
                ...c,
                u1
            ], c.sort((d, f)=>d.fi - f.fi), e.localIndex = c.indexOf(u1), {
                data: this.modifyArrayBy(l, c),
                actual: e,
                reverse: {
                    type: 8,
                    id: s1
                }
            };
        }
    }
    deleteOp(e) {
        let { id: r } = e;
        if (this.get(r) === null) return null;
        {
            let i = this.parent(r);
            if (i === void 0) return null;
            let s1 = this.childrenArray(i), o = s1.findIndex((c)=>c.id === r);
            e.localIndex = o, s1 = [
                ...s1
            ];
            let a = s1.splice(o, 1)[0];
            return {
                data: this.modifyArrayBy(i, s1),
                actual: e,
                reverse: {
                    type: 7,
                    ...a,
                    parent: i
                }
            };
        }
    }
    moveOp(e) {
        let { parent: r, fi: i, id: s1 } = e;
        if (r !== null && this.get(r) === void 0) return this.deleteOp({
            type: 8,
            id: s1
        });
        if (r !== null) {
            let f = r;
            for(; f !== null;){
                if (f === void 0) throw new Error;
                if (f === s1) throw new Jh("cyclic tree");
                f = this.parent(f);
            }
        }
        let o = this.parent(s1);
        if (o === void 0) return null;
        let a = o, l = this.childrenArray(o), c = l.findIndex((f)=>f.id === s1);
        l = [
            ...l
        ];
        let u1 = l.splice(c, 1)[0], h = this.modifyArrayBy(o, l);
        o = r, l = h.childrenArray(o);
        let d = u1.fi;
        return u1 = {
            ...u1,
            fi: i
        }, l = [
            ...l,
            u1
        ], l.sort((f, m)=>f.fi - m.fi), e.localIndex = l.indexOf(u1), h = h.modifyArrayBy(o, l), {
            data: h,
            actual: e,
            reverse: {
                type: 9,
                parent: a,
                fi: d,
                id: s1
            }
        };
    }
    previous(e, r) {
        if (r === null) {
            let s1 = this.childrenArray(e);
            return s1.length === 0 ? null : s1[s1.length - 1].id;
        }
        let i = null;
        for (let s1 of this.childrenArray(e)){
            if (s1.id === r) return i;
            i = s1.id;
        }
        return null;
    }
    traverseSortNext(e) {
        let r = this.parent(e);
        if (r !== void 0) {
            let i = this.childrenArray(r), s1 = i.findIndex((o)=>o.id === e) + 1;
            if (s1 < i.length) return i[s1].id;
            if (r) return this.traverseSortNext(r);
        }
    }
    sortNext(e) {
        let r = this.childrenArray(e);
        return r.length > 0 ? r[0].id : this.traverseSortNext(e);
    }
    traverseSortPrevious(e) {
        let r = this.childrenArray(e);
        return r.length > 0 ? this.traverseSortPrevious(r[r.length - 1].id) : e;
    }
    sortPrevious(e) {
        let r = this.parent(e);
        if (r !== void 0) {
            let i = this.childrenArray(r), s1 = i.findIndex((o)=>o.id === e) - 1;
            return s1 >= 0 ? this.traverseSortPrevious(i[s1].id) : r;
        }
    }
    getAllSorted(e) {
        let r = [];
        for (let i of e){
            let s1 = this.getWithSortKey(i.id);
            s1 !== void 0 && r.push({
                ...i,
                ...s1
            });
        }
        r.sort((i, s1)=>TD(i.sortKey, s1.sortKey));
        for (let i of r)delete i.sortKey;
        return r;
    }
    getWithSortKey(e) {
        var r = e;
        let i = [], s1 = this.get(r), o = s1;
        if (s1 !== void 0) {
            for(; r;)i.splice(0, 0, s1.fi), r = this.parent(r), r !== null && (s1 = this.get(r));
            return {
                ...o,
                sortKey: i
            };
        }
    }
    insertBeforeHelper(e, r, i) {
        return this.insertAfterHelper(e, this.previous(e, r), i);
    }
    insertAfterHelper(e, r, i) {
        let s1 = this.childrenArray(e);
        if (r === null) {
            if (s1.length === 0) return Io(0, i, i);
            {
                let o = s1[0].fi;
                return Io(o - i, o, i);
            }
        } else {
            let o = this.get(r);
            if (o === void 0 || this.parent(r) !== e) throw new Error("illegal args");
            let a = s1.find((l)=>l.fi > o.fi);
            if (a === void 0) {
                let l = s1[s1.length - 1].fi;
                return Io(l, l + i, i);
            } else return Io(o.fi, a.fi, i);
        }
    }
};
var ed;
((t)=>{
    function n1(e, r) {
        if (r.type !== 0) return null;
        if (Array.isArray(e)) {
            let i = r.props, s1 = {}, o = [
                ...e
            ], a = !1;
            if (i) for (let l of Object.keys(i)){
                let c = parseInt(l);
                if (isNaN(c)) throw new Error("wrong index");
                s1[l] = o[c], o[c] = i[l], a = !0;
            }
            return a ? {
                data: o,
                actual: r,
                reverse: {
                    type: 0,
                    props: s1
                }
            } : null;
        } else {
            let i = r.props, s1 = {}, o = {
                ...e
            }, a = !1;
            if (i) for (let l of Object.keys(i)){
                s1[l] = o[l];
                let c = i[l];
                c === void 0 ? delete o[l] : o[l] = c, a = !0;
            }
            return a ? {
                data: o,
                actual: r,
                reverse: {
                    type: 0,
                    props: s1
                }
            } : null;
        }
    }
    t.runOp = n1;
})(ed || (ed = {}));
var Re = class extends Array {
    constructor(...e){
        super(...e);
        Object.setPrototypeOf(this, Re.prototype);
    }
    deepFreeze() {
        let e = 0;
        for(; e < this.length;)um(this[e]), e++;
    }
    fillCaches0(e) {
        this.objCaches.set(e.id, e);
    }
    fillCaches() {
        if (this.objCaches === void 0) {
            this.objCaches = new Map, Object.getOwnPropertyDescriptor(this, "objCaches").enumerable = !1;
            for (let e of this)this.fillCaches0(e);
        }
    }
    randomId() {
        this.fillCaches();
        let e = Array.from(this.objCaches.keys());
        if (e.length !== 0) return e[Math.max(0, Math.floor(Math.random() * e.length) - 1)];
    }
    data(e) {
        return this.get(e)?.data;
    }
    get(e) {
        return this.fillCaches(), this.objCaches.get(e);
    }
    modifyById(e, r) {
        if (this.get(e) === void 0) throw new Error("not expected");
        {
            let s1 = this, o = s1.findIndex((c)=>c.id === e);
            if (o < 0) throw new Error("not expected");
            let a = s1[o];
            return s1 = [
                ...s1
            ], s1[o] = {
                ...a,
                data: r
            }, this.modifyArrayBy(s1);
        }
    }
    modifyArrayBy(e) {
        Object.setPrototypeOf(e, Re.prototype);
        let r = e;
        return MD() || r.fillCaches(), r;
    }
    runOp(e) {
        switch(e.type){
            case 4:
                return this.addOp(e);
            case 5:
                return this.deleteOp(e);
            case 6:
                return this.moveOp(e);
        }
        return null;
    }
    addOp(e) {
        let { fi: r, id: i, data: s1 } = e, o = this, a = {
            fi: r,
            id: i,
            data: s1
        };
        return o = [
            ...o,
            a
        ], o.sort((c, u1)=>c.fi - u1.fi), e.localIndex = o.indexOf(a), {
            data: this.modifyArrayBy(o),
            actual: e,
            reverse: {
                type: 5,
                id: i
            }
        };
    }
    deleteOp(e) {
        let { id: r } = e, i = this, s1 = i.findIndex((l)=>l.id === r);
        if (s1 === -1) return null;
        e.localIndex = s1, i = [
            ...i
        ];
        let o = i.splice(s1, 1)[0];
        return {
            data: this.modifyArrayBy(i),
            actual: e,
            reverse: {
                type: 4,
                ...o
            }
        };
    }
    moveOp(e) {
        let { fi: r, id: i } = e, s1 = this;
        s1 = [
            ...s1
        ];
        let o = s1.findIndex((u1)=>u1.id === i);
        if (o === -1) return null;
        let a = s1[o].fi, l = {
            ...s1[o],
            fi: r
        };
        return s1[o] = l, s1.sort((u1, h)=>u1.fi - h.fi), e.localIndex = s1.indexOf(l), {
            data: this.modifyArrayBy(s1),
            actual: e,
            reverse: {
                type: 6,
                fi: a,
                id: i
            }
        };
    }
    previous(e) {
        if (e === null) return this.length === 0 ? null : this[this.length - 1].id;
        let r = null;
        for (let i of this){
            if (i.id === e) return r;
            r = i.id;
        }
        return null;
    }
    insertBeforeHelper(e, r) {
        return this.insertAfterHelper(this.previous(e), r);
    }
    insertAfterHelper(e, r) {
        let i = this;
        if (e === null) {
            if (i.length === 0) return Io(0, r, r);
            {
                let s1 = i[0].fi;
                return Io(s1 - r, s1, r);
            }
        } else {
            let s1 = this.get(e);
            if (s1 === void 0) throw new Error("illegal args");
            let o = i.find((a)=>a.fi > s1.fi);
            if (o === void 0) {
                let a = i[i.length - 1].fi;
                return Io(a, a + r, r);
            } else return Io(s1.fi, o.fi, r);
        }
    }
};
function td(n1) {
    return n1 && typeof n1 == "object" && n1 instanceof lr;
}
var lr = class {
    unusedFunOverridesTable(t) {}
    runOp(t) {
        let e = [], r = this, i = 0, s1 = {};
        for(; i < t.path.length;){
            if (e.push(r), r = r === void 0 ? void 0 : r[t.path[i]], r !== void 0 && !td(r)) return null;
            i += 1;
        }
        r = r ? $v(r) : new lr;
        for (let [l, c] of Object.entries(t.props)){
            let u1 = r[l];
            s1[l] = u1, c === void 0 ? delete r[l] : r[l] = c;
        }
        for(; i > 0;){
            if (Object.keys(r).length === 0) {
                let l = e[i - 1];
                l && (r = $v(l), delete r[t.path[i - 1]]);
            } else {
                let l = e[i - 1];
                if (l) {
                    let c = $v(l);
                    c[t.path[i - 1]] = r, r = c;
                } else {
                    let c = new lr;
                    c[t.path[i - 1]] = r, r = c;
                }
            }
            i -= 1;
        }
        let o = Object.setPrototypeOf(r, lr.prototype), a = {
            ...t,
            props: s1
        };
        return {
            data: o,
            actual: t,
            reverse: a
        };
    }
}, Do;
((r)=>{
    function n1(i, s1) {
        return hm(i, s1) ?? i;
    }
    r.apply = n1;
    function t(i, s1) {
        return sA(i, s1);
    }
    r.merge = t;
    function e(i, s1) {
        let o = 0, a = s1.path, l = i;
        for(; o < a.length && l !== void 0;){
            if (l = Mr.zoomOnce(l, a[o]), l === void 0) return s1;
            if (!td(l)) return;
            o += 1;
        }
        if (l === void 0) return s1;
        if (!!td(l)) {
            if (s1.type === 0) {
                let c = {
                    ...s1.props
                };
                for (let u1 of Object.keys(l))delete c[u1];
                return {
                    ...s1,
                    props: c
                };
            } else if (s1.type === 1 || s1.type === 4 || s1.type === 7) {
                let c = nA([
                    s1
                ], l);
                return c ? c[0] : s1;
            } else return s1;
        }
    }
    r.filterOp = e;
})(Do || (Do = {}));
function nA(n1, t) {
    if (t === void 0) return;
    let e = !1, r = n1.map((i)=>{
        let s1 = i.id, o = hm(i.data, t[s1]);
        if (e = e || o !== void 0, o === void 0 && (o = i.data), i.children) {
            let a = nA(i.children, t);
            return a !== void 0 ? e = !0 : a = i.children, {
                ...i,
                id: s1,
                data: o,
                children: a
            };
        } else return {
            ...i,
            id: s1,
            data: o
        };
    });
    if (e) return r;
}
function H7(n1, t) {
    if (t === void 0) return;
    let e = !1, r = n1.map((i)=>{
        let s1 = i.id, o = hm(i.data, t[s1]);
        return e = e || o !== void 0, o === void 0 && (o = i.data), {
            ...i,
            id: s1,
            data: o
        };
    });
    if (e) return Object.setPrototypeOf(r, Object.getPrototypeOf(n1)), r;
}
function hm(n1, t) {
    if (!td(t)) return t;
    if (n1 instanceof wr) {
        let e = nA(n1, t);
        return e !== void 0 && Object.setPrototypeOf(e, Object.getPrototypeOf(n1)), e;
    } else {
        if (n1 instanceof Re) return H7(n1, t);
        if (Array.isArray(n1)) {
            let e = !1, r = n1.map((i, s1)=>{
                let o = hm(i, t[s1]);
                return e = e || o !== void 0, o === void 0 && (o = i), o;
            });
            return e ? (Object.setPrototypeOf(r, Object.getPrototypeOf(n1)), r) : void 0;
        } else {
            if (n1 instanceof lr) return sA(n1, t);
            if (n1 && typeof n1 == "object") {
                let e = {}, r = !1;
                for (let [i, s1] of Object.entries(n1)){
                    let o = hm(s1, t[i]);
                    r = r || o !== void 0, o === void 0 && (o = s1), e[i] = o;
                }
                return r ? (Object.setPrototypeOf(e, Object.getPrototypeOf(n1)), e) : void 0;
            }
        }
    }
}
function sA(n1, t) {
    if (n1 === void 0) return t;
    if (t === void 0) return n1;
    if (!td(t)) return t;
    if (!td(n1)) return Do.apply(n1, t);
    let e = new Set;
    for (let i of Object.keys(n1))e.add(i);
    for (let i of Object.keys(t))e.add(i);
    let r = new lr;
    for (let i of e){
        let s1 = sA(n1 === void 0 ? void 0 : n1[i], t === void 0 ? void 0 : t[i]);
        r[i] = s1;
    }
    return r;
}
function _D(n1, t) {
    let e = {
        cur: [],
        result: [],
        len: 0
    };
    return n1 = dm(n1, t, e) ?? n1, [
        n1,
        e.result
    ];
}
function e0(n1, t) {
    return n1 === null ? null : (n1.cur[n1.len] = t, n1.len += 1, n1);
}
function t0(n1) {
    n1 && (n1.len -= 1);
}
function W7(n1) {
    if (n1 === null) return null;
    n1.result.push(n1.cur.slice(0, n1.len));
}
function ID(n1, t, e) {
    let r = !1, i = n1.map((s1)=>{
        let o = s1.id, a = t[o];
        if (a !== void 0 && typeof a == "string" && (r = !0, o = a, e !== null)) throw new Error("not supported");
        let l = dm(s1.data, t, e0(e, o));
        t0(e), r = r || l !== void 0, l === void 0 && (l = s1.data);
        let c = ID(s1.children, t, e);
        return c !== void 0 ? r = !0 : c = s1.children, {
            ...s1,
            id: o,
            data: l,
            children: c
        };
    });
    if (r) return i;
}
function q7(n1, t, e) {
    let r = !1, i = n1.map((s1)=>{
        let o = s1.id, a = t[o];
        if (a !== void 0 && typeof a == "string" && (r = !0, o = a, e !== null)) throw new Error("not supported");
        let l = dm(s1.data, t, e0(e, o));
        return t0(e), r = r || l !== void 0, l === void 0 && (l = s1.data), {
            ...s1,
            id: o,
            data: l
        };
    });
    if (r) return Object.setPrototypeOf(i, Object.getPrototypeOf(n1)), i;
}
function dm(n1, t, e) {
    if (n1 instanceof wr) {
        let r = ID(n1, t, e);
        return r !== void 0 && Object.setPrototypeOf(r, Object.getPrototypeOf(n1)), r;
    } else {
        if (n1 instanceof Re) return q7(n1, t, e);
        if (Array.isArray(n1)) {
            let r = !1, i = n1.map((s1, o)=>{
                let a = dm(s1, t, e0(e, o));
                return t0(e), r = r || a !== void 0, a === void 0 && (a = s1), a;
            });
            return r ? (Object.setPrototypeOf(i, Object.getPrototypeOf(n1)), i) : void 0;
        } else if (n1 && typeof n1 == "object" && !$h(n1)) {
            let r = {}, i = !1;
            for (let [s1, o] of Object.entries(n1))if (s1 !== "name" && s1 !== "variableId") {
                let a = t[s1];
                if (typeof a == "string") {
                    if (e !== null) throw new Error("not supported");
                    i = !0, s1 = a;
                }
                let l = dm(o, t, e0(e, s1));
                t0(e), i = i || l !== void 0, l === void 0 && (l = o), r[s1] = l;
            } else r[s1] = o;
            return i ? (Object.setPrototypeOf(r, Object.getPrototypeOf(n1)), r) : void 0;
        } else if (typeof n1 == "string") {
            let r = t[n1];
            return r !== void 0 && W7(e), r;
        } else return;
    }
}
var rd;
((t)=>{
    function n1(e, r) {
        let i = Mr.zoom(r, e.path);
        if (typeof i == "object") {
            let s1 = {};
            for (let o of Object.keys(e.props))s1[o] = i[o];
            return {
                ...e,
                props: s1
            };
        } else return {
            ...e,
            props: {}
        };
    }
    t.replaceProps = n1;
})(rd || (rd = {}));
var zr;
((a)=>{
    function n1(l, c) {
        return {
            ...l,
            path: l.path.slice(c)
        };
    }
    a.drop = n1;
    function t(l, c) {
        return e(l, c)?.data ?? l;
    }
    a.applySimple = t;
    function e(l, c) {
        let u1 = c.path;
        for(var h = [];;){
            let d;
            if (l instanceof lr && c.type === 0 && (d = l.runOp({
                ...c,
                path: u1.slice(h.length)
            }), d === null && (d = void 0)), d === void 0 && h.length === u1.length && (l instanceof wr || l instanceof Re || l instanceof He ? d = l.runOp(c) : d = ed.runOp(l, c)), d !== void 0) {
                if (d !== null) {
                    let p = d.data;
                    for(let g = h.length - 1; g >= 0; g--){
                        let y = u1[g], x = h[g];
                        if (x instanceof wr) {
                            if (typeof y == "number") throw new Error("illegal arg");
                            p = x.modifyById(y, p);
                        } else if (x instanceof Re) {
                            if (typeof y == "number") throw new Error("illegal arg");
                            p = x.modifyById(y, p);
                        } else if (x instanceof He) {
                            if (typeof y == "number") throw new Error("illegal arg");
                            p = x.modifyById(y, p);
                        } else if (x instanceof lr) {
                            let v = {
                                ...x,
                                [y]: p
                            };
                            p = Object.setPrototypeOf(v, lr.prototype);
                        } else if (typeof x == "object") {
                            if (Array.isArray(x)) {
                                if (typeof y == "string" && (y = parseInt(y), isNaN(y))) throw new Error("Invalid path");
                                let v = p;
                                p = [
                                    ...x
                                ], p[y] = v;
                            } else p = {
                                ...x,
                                [y]: p
                            };
                        } else return null;
                    }
                    return {
                        data: p,
                        actual: {
                            ...d.actual,
                            path: u1
                        },
                        reverse: {
                            ...d.reverse,
                            path: u1
                        }
                    };
                } else return null;
            }
            let f = u1[h.length], m;
            if (l instanceof wr) {
                if (typeof f == "number") throw new Error("");
                m = l.get(f)?.data;
            } else if (l instanceof Re) {
                if (typeof f == "number") throw new Error("");
                m = l.get(f)?.data;
            } else l !== null && (m = l[f]);
            if (m !== void 0) h.push(l), l = m;
            else return null;
        }
    }
    a.apply = e;
    function r(l, c) {
        for(let u1 = 0; u1 < l.length && u1 < c.length; u1++)if (l[u1] !== c[u1]) return !0;
        return !1;
    }
    a.pathDisjoint = r;
    function i(l, c) {
        if (l.length !== c.length) return !1;
        for(let u1 = 0; u1 < l.length; u1++)if (l[u1] !== c[u1]) return !1;
        return !0;
    }
    a.pathEq = i;
    function s1(l, c) {
        return r(l.path, c.path);
    }
    a.commutative = s1;
    function o(l, c) {
        return l.type === 0 && c.type === 0 && i(l.path, c.path) ? Object.keys(l.props).every((u1)=>c.props[u1] !== void 0) : !1;
    }
    a.subsumed = o;
})(zr || (zr = {}));
var fm;
((l)=>{
    function n1() {
        return [];
    }
    l.empty = n1;
    function t(c, u1) {
        let h = [];
        for (let d of c){
            let [f, ...m] = d.path;
            f === u1 && h.push({
                ...d,
                path: m
            });
        }
        return h;
    }
    l.removePrefix = t;
    function e(c, u1) {
        return c.map((h)=>({
                ...h,
                path: [
                    u1,
                    ...h.path
                ]
            }));
    }
    l.addPrefix = e;
    function r(c, u1) {
        return [
            ...c,
            ...u1
        ];
    }
    l.concat = r;
    function i(c, u1) {
        return [
            ...c.filter((d)=>!u1.some((f)=>zr.subsumed(d, f))),
            ...u1
        ];
    }
    l.compress = i;
    function s1(c, u1) {
        return c.every((h)=>u1.every((d)=>zr.commutative(h, d)));
    }
    l.commutative = s1;
    function o(c, u1) {
        for (let h of u1){
            let d = a(c, h);
            d !== null && (c = d.data);
        }
        return c;
    }
    l.applyAll = o;
    function a(c, u1) {
        var h = c;
        let d = [], f = [];
        for (let m of u1)try {
            if (m.type === 3 || m.type === 5 && m.path[m.path.length - 1] === "variables") {
                let p, g, y;
                if (m.type === 3 ? (p = Mr.zoom(h, [
                    ...m.path,
                    m.id
                ]), y = zr.apply(h, {
                    ...m,
                    type: 2
                })) : (p = Mr.zoom(h, [
                    ...m.path,
                    m.id,
                    "value"
                ]), y = zr.apply(h, m)), y !== null) {
                    h = y.data;
                    let [x, v] = _D(h, {
                        [m.id]: p
                    });
                    h = x;
                    for(let b = 0; b < v.length; b++){
                        let w = v[b], A = w.pop();
                        if (typeof A == "number") {
                            let T = [
                                A
                            ];
                            for(let M = b + 1; M < v.length; M++){
                                let C = v[M], P = C[C.length - 1];
                                if (typeof P == "number" && Mr.equal(w, C.slice(0, C.length - 1))) T.push(P), v.splice(M, 1);
                                else break;
                            }
                            let S = Mr.zoom(h, w);
                            g = S.map((M, C)=>T.includes(C) ? m.id : M), p = S, A = w.pop();
                        } else {
                            if (A === "alphaOverride" || A === "alpha") {
                                p /= 100;
                                let T = p, S = Mr.zoom(h, w.slice(0, w.length - 2)), M = S.layers.map((C)=>C.id === w[w.length - 1] ? {
                                        ...C,
                                        data: {
                                            ...C.data,
                                            [A]: T
                                        }
                                    } : C);
                                Object.setPrototypeOf(M, Object.getPrototypeOf(S.layers)), S.layers = M;
                            }
                            g = m.id;
                        }
                        d.push({
                            type: 0,
                            path: w,
                            props: {
                                [A]: p
                            }
                        }), f.push({
                            type: 0,
                            path: w,
                            props: {
                                [A]: g
                            }
                        });
                    }
                    f.push(y.reverse), d.push(y.actual);
                }
            } else {
                let p = zr.apply(h, m);
                p !== null && (d.push(p.actual), h = p.data, f.push(p.reverse));
            }
        } catch (p) {
            if (p instanceof Jh) return null;
            throw p;
        }
        return {
            data: h,
            actual: d,
            reverse: f.reverse()
        };
    }
    l.apply = a;
})(fm || (fm = {}));
var DD = Symbol(), X7 = Symbol(), i0 = Symbol(), Zc = class {
    reportOp(t, e, r = []) {
        let i = this;
        if (e === null) return;
        i._current = e.data;
        let s1 = r;
        for(; !(i instanceof r0);){
            let o = i._path, a = i._current;
            if (o !== "" && s1.splice(0, 0, o), i = i._parent, i === null) return;
            i.update(o, a);
        }
        i.push(s1, t, e.actual, e.reverse);
    }
    deleteChildren(t) {
        if (this._children) {
            let e = this._children[t];
            if (e) {
                let r = e[i0];
                r && r(), delete this._children[t];
            }
        }
    }
}, aA = class extends Zc {
    constructor(t, e, r){
        super(), this._parent = t, this._path = e, this._current = r;
    }
    update(t, e) {
        if (Array.isArray(this._current)) {
            if (typeof t == "string" && (t = parseInt(t), isNaN(t))) throw new Error("Invalid path");
            this._current = [
                ...this._current
            ], this._current[t] = e;
        } else if (this._current instanceof lr) {
            let r = {
                ...this._current,
                [t]: e
            };
            this._current = Object.setPrototypeOf(r, lr.prototype);
        } else this._current = {
            ...this._current,
            [t]: e
        };
    }
    runOp(t) {
        this.reportOp(t, ed.runOp(this._current, t), t.path);
    }
}, lA = class extends Zc {
    constructor(t, e, r){
        super(), this._parent = t, this._path = e, this._current = r;
    }
    update(t, e) {
        this._current = {
            ...this._current,
            [t]: e
        }, Object.setPrototypeOf(this._current, He.prototype);
    }
    runOp(t) {
        this.reportOp(t, this._current.runOp(t));
    }
}, OD = {
    get (n1, t) {
        if (t === i0) return ()=>{
            n1._parent = null;
        };
        if (t === DD) return n1._current;
        if (t === X7) return n1;
        let { _current: e, _children: r } = n1;
        if (t === "push" && Array.isArray(e)) throw new Error("not supported to expand array");
        let i = r === void 0 ? void 0 : r[t];
        if (i !== void 0) return i;
        let s1 = e[t], o = n0(n1, t, s1);
        return o !== s1 ? (r === void 0 && (r = {}, n1._children = r), r[t] = o, o) : s1;
    },
    has (n1, t) {
        return t in n1._current;
    },
    ownKeys (n1) {
        return Reflect.ownKeys(n1._current);
    },
    defineProperty () {
        throw Error("not supported");
    },
    getPrototypeOf (n1) {
        return Object.getPrototypeOf(n1._current);
    },
    setPrototypeOf () {
        throw Error("not supported");
    },
    getOwnPropertyDescriptor (n1, t) {
        let e = n1._current, r = Reflect.getOwnPropertyDescriptor(e, t);
        return r && {
            writable: !0,
            configurable: !0,
            enumerable: r.enumerable,
            value: e[t]
        };
    }
}, Y7 = {
    ...OD,
    set (n1, t, e) {
        let r = {
            type: 0,
            props: {
                [t]: Yr(e) ?? e
            }
        };
        return n1.deleteChildren(t), n1.runOp(r), !0;
    },
    deleteProperty (n1, t) {
        let e = {
            type: 0,
            props: {
                [t]: void 0
            }
        };
        return n1.deleteChildren(t), n1.runOp(e), !0;
    }
}, K7 = {
    ...OD,
    set (n1, t, e) {
        return e === void 0 ? this.deleteProperty(n1, t) : (n1.deleteChildren(t), n1.runOp({
            type: 1,
            id: t,
            data: e
        })), !0;
    },
    deleteProperty (n1, t) {
        return n1.runOp({
            type: 2,
            id: t
        }), !0;
    }
}, id = class extends Zc {
    constructor(t, e, r){
        super(), this._children = {}, this._parent = t, this._path = e, this._current = r, this[i0] = ()=>{
            this._parent = null;
        };
    }
    unproxy() {
        return this._current;
    }
    update(t, e) {
        this._current = this._current.modifyById(t, e);
    }
    runOp(t) {
        this.reportOp(t, this._current.runOp(t));
    }
    randomId() {
        return this._current.randomId();
    }
    isDescendantOf(t, e) {
        return this._current.isDescendantOf(t, e);
    }
    childrenOf(t) {
        return this._current.childrenOf(t);
    }
    traverse(t) {
        return this._current.traverse(t);
    }
    get(t) {
        return this._current.get(t);
    }
    parent(t) {
        return this._current.parent(t);
    }
    traverse(t) {
        this._current.traverse((e, r)=>{
            t(e, this.data(e));
        });
    }
    data(t) {
        let { _current: e, _children: r } = this, i = r === void 0 ? void 0 : r[t];
        if (i !== void 0) return i;
        let s1 = e.get(t)?.data, o = n0(this, t, s1);
        return o !== s1 ? (r === void 0 && (r = {}, this._children = r), r[t] = o, o) : s1;
    }
    add(t, e, r, i, s1) {
        this.runOp({
            type: 7,
            parent: t,
            fi: e,
            id: r,
            data: i,
            children: s1
        });
    }
    move(t, e, r) {
        this.runOp({
            type: 9,
            parent: t,
            fi: e,
            id: r
        });
    }
    insertAfter(t, e, r) {
        let i = this._current.insertAfterHelper(t, e, r.length);
        for(let s1 = 0; s1 < r.length; s1++){
            let o = r[s1];
            this.add(t, i[s1], o.id, o.data, o.children);
        }
    }
    insertBefore(t, e, r) {
        let i = this._current.insertBeforeHelper(t, e, r.length);
        for(let s1 = 0; s1 < r.length; s1++){
            let o = r[s1];
            this.add(t, i[s1], o.id, o.data, o.children);
        }
    }
    moveAfter(t, e, r) {
        let i = this._current.insertAfterHelper(t, e, r.length);
        for(let s1 = 0; s1 < r.length; s1++){
            let o = r[s1];
            this.move(t, i[s1], o);
        }
    }
    moveBefore(t, e, r) {
        let i = this._current.insertBeforeHelper(t, e, r.length);
        for(let s1 = 0; s1 < r.length; s1++){
            let o = r[s1];
            this.move(t, i[s1], o);
        }
    }
    delete(t) {
        this.deleteChildren(t), this.runOp({
            type: 8,
            id: t
        });
    }
    sortNext(t) {
        return this._current.sortNext(t);
    }
    sortPrevious(t) {
        return this._current.sortPrevious(t);
    }
    getAllSorted(t) {
        return this._current.getAllSorted(t);
    }
}, nd = class extends Zc {
    constructor(t, e, r){
        super(), this._children = {}, this._parent = t, this._path = e, this._current = r, this[i0] = ()=>{
            this._parent = null;
        };
    }
    unproxy() {
        return this._current;
    }
    get length() {
        return this._current.length;
    }
    forEach(t) {
        let e = this.length;
        for(let r = 0; r < e; r++){
            let i = this._current[r].id, s1 = this._current[r].fi;
            t(this.data(this._current[r].id), i, s1);
        }
    }
    find(t) {
        let e = this.length;
        for(let r = 0; r < e; r++){
            let i = this._current[r].id;
            if (t(this.data(i), i)) return this.get(i);
        }
    }
    update(t, e) {
        this._current = this._current.modifyById(t, e);
    }
    randomId() {
        return this._current.randomId();
    }
    get(t) {
        return {
            ...this._current.get(t),
            data: this.data(t)
        };
    }
    data(t) {
        let { _current: e, _children: r } = this, i = r === void 0 ? void 0 : r[t];
        if (i !== void 0) return i;
        let s1 = e.get(t)?.data, o = n0(this, t, s1);
        return o !== s1 ? (r === void 0 && (r = {}, this._children = r), r[t] = o, o) : s1;
    }
    runOp(t) {
        this.reportOp(t, this._current.runOp(t));
    }
    add(t, e, r) {
        this.runOp({
            type: 4,
            fi: t,
            id: e,
            data: r
        });
    }
    move(t, e) {
        this.runOp({
            type: 6,
            fi: t,
            id: e
        });
    }
    insertAfter(t, e) {
        let r = this._current.insertAfterHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s1 = e[i];
            this.add(r[i], s1.id, s1.data);
        }
    }
    insertBefore(t, e) {
        let r = this._current.insertBeforeHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s1 = e[i];
            this.add(r[i], s1.id, s1.data);
        }
    }
    moveAfter(t, e) {
        let r = this._current.insertAfterHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s1 = e[i];
            this.move(r[i], s1);
        }
    }
    moveBefore(t, e) {
        let r = this._current.insertBeforeHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s1 = e[i];
            this.move(r[i], s1);
        }
    }
    delete(t) {
        this.deleteChildren(t), this.runOp({
            type: 5,
            id: t
        });
    }
};
function oA(n1, t, e) {
    if (n1.length > 0) {
        let r = n1[n1.length - 1];
        if (r.type === 0 && t.type === 0 && Mr.equal(r.path, e)) {
            Object.assign(r.props, t.props);
            return;
        }
    }
    n1.push({
        ...t,
        path: e
    });
}
var r0 = class extends Zc {
    constructor(t){
        super(), this.ts = [], this.actual = [], this.reverse = [], this._current = t;
    }
    update(t, e) {
        if (t !== "") throw new Error("");
        this._current = e;
    }
    push(t, e, r, i) {
        oA(this.ts, e, t), oA(this.actual, r, t), oA(this.reverse, i, t);
    }
    result() {
        return {
            data: this._current,
            ts: this.ts,
            actual: this.actual,
            reverse: this.reverse.reverse()
        };
    }
};
function n0(n1, t, e) {
    return e instanceof wr ? new id(n1, t, e) : e instanceof Re ? new nd(n1, t, e) : e instanceof He ? new Proxy(new lA(n1, t, e), K7) : e !== null && typeof e == "object" ? $h(e) ? e : new Proxy(new aA(n1, t, e), Y7) : e;
}
function cA(n1) {
    let t = new r0(n1);
    return [
        n0(t, "", n1),
        t
    ];
}
function Fl(n1, t) {
    let [e, r] = cA(n1);
    return t(e), r.result();
}
function Yr(n1) {
    return n1 instanceof id || n1 instanceof nd ? n1._current : n1 !== null && typeof n1 == "object" ? n1[DD] : n1;
}
var Mr;
((i)=>{
    function n1(s1, o) {
        if (o.length === s1.length) for(var a = 0; a < s1.length;){
            if (s1[a] !== o[a]) return !1;
            a += 1;
        }
        else return !1;
        return !0;
    }
    i.equal = n1;
    function t(s1, o, a) {
        let l = r(a, s1);
        if (l !== void 0 && typeof l == "object" && l !== null) {
            let c = {
                ...o
            };
            return Object.keys(l).forEach((u1)=>{
                delete c[u1];
            }), c;
        } else return o;
    }
    i.removeOverridden = t;
    function e(s1, o) {
        if ((s1 instanceof wr || s1 instanceof id) && typeof o == "string") return s1.data(o);
        if ((s1 instanceof Re || s1 instanceof nd) && typeof o == "string") return s1.data(o);
        if (typeof o == "number" && Array.isArray(s1)) return s1[o];
        if (typeof o == "string" && typeof s1 == "object" && s1 !== null) return s1[o];
    }
    i.zoomOnce = e;
    function r(s1, o, a = 0) {
        for(; a < o.length && s1 !== void 0;)s1 = e(s1, o[a]), a += 1;
        return s1;
    }
    i.zoom = r;
})(Mr || (Mr = {}));
function RD(n1, t) {
    let e = [];
    if (t.length === n1.length) for(var r = 0; r < n1.length;){
        if (t[r] === "*") e.push(n1[r]);
        else if (n1[r] !== t[r]) return null;
        r += 1;
    }
    else return null;
    return e;
}
function kt(n1, t) {
    let e = [];
    if (t.length <= n1.length) for(var r = 0; r < t.length;){
        if (t[r] === "*") e.push(n1[r]);
        else if (n1[r] !== t[r]) return null;
        r += 1;
    }
    else return null;
    return e;
}
var s0 = class {
}, pm = class extends s0 {
    constructor(e){
        super();
        this.id = e;
    }
}, mm = class extends s0 {
    constructor(e){
        super();
        this.data = e;
    }
};
var hA;
try {
    hA = new TextDecoder;
} catch  {}
var Ke, Ul, se = 0;
var zD = [], dA = zD, fA = 0, Bn = {}, rr, Vl, Ss = 0, Oo = 0, ns, La, wn = [], fr, LD = {
    useRecords: !1,
    mapsAsObjects: !0
}, gm = class {
}, mA = new gm;
mA.name = "MessagePack 0xC1";
var sd = !1, Ro = class {
    constructor(t){
        t && (t.useRecords === !1 && t.mapsAsObjects === void 0 && (t.mapsAsObjects = !0), t.structures ? t.structures.sharedLength = t.structures.length : t.getStructures && ((t.structures = []).uninitialized = !0, t.structures.sharedLength = 0)), Object.assign(this, t);
    }
    unpack(t, e) {
        if (Ke) return qD(()=>(a0(), this ? this.unpack(t, e) : Ro.prototype.unpack.call(LD, t, e)));
        Ul = e > -1 ? e : t.length, se = 0, fA = 0, Oo = 0, Vl = null, dA = zD, ns = null, Ke = t;
        try {
            fr = t.dataView || (t.dataView = new DataView(t.buffer, t.byteOffset, t.byteLength));
        } catch (r) {
            throw Ke = null, t instanceof Uint8Array ? r : new Error("Source must be a Uint8Array or Buffer but was a " + (t && typeof t == "object" ? t.constructor.name : typeof t));
        }
        if (this instanceof Ro) {
            if (Bn = this, this.structures) return rr = this.structures, o0();
            (!rr || rr.length > 0) && (rr = []);
        } else Bn = LD, (!rr || rr.length > 0) && (rr = []);
        return o0();
    }
    unpackMultiple(t, e) {
        let r, i = 0;
        try {
            sd = !0;
            let s1 = t.length, o = this ? this.unpack(t, s1) : u0.unpack(t, s1);
            if (e) {
                for(e(o); se < s1;)if (i = se, e(o0()) === !1) return;
            } else {
                for(r = [
                    o
                ]; se < s1;)i = se, r.push(o0());
                return r;
            }
        } catch (s1) {
            throw s1.lastPosition = i, s1.values = r, s1;
        } finally{
            sd = !1, a0();
        }
    }
    _mergeStructures(t, e) {
        t = t || [];
        for(let r = 0, i = t.length; r < i; r++){
            let s1 = t[r];
            s1 && (s1.isShared = !0, r >= 32 && (s1.highByte = r - 32 >> 5));
        }
        t.sharedLength = t.length;
        for(let r in e || [])if (r >= 0) {
            let i = t[r], s1 = e[r];
            s1 && (i && ((t.restoreStructures || (t.restoreStructures = []))[r] = i), t[r] = s1);
        }
        return this.structures = t;
    }
    decode(t, e) {
        return this.unpack(t, e);
    }
};
function o0() {
    try {
        if (!Bn.trusted && !sd) {
            let t = rr.sharedLength || 0;
            t < rr.length && (rr.length = t);
        }
        let n1 = ri();
        if (se == Ul) rr.restoreStructures && ND(), rr = null, Ke = null, La && (La = null);
        else if (se > Ul) {
            let t = new Error("Unexpected end of MessagePack data");
            throw t.incomplete = !0, t;
        } else if (!sd) throw new Error("Data read, but end of buffer not reached");
        return n1;
    } catch (n1) {
        throw rr.restoreStructures && ND(), a0(), (n1 instanceof RangeError || n1.message.startsWith("Unexpected end of buffer")) && (n1.incomplete = !0), n1;
    }
}
function ND() {
    for(let n1 in rr.restoreStructures)rr[n1] = rr.restoreStructures[n1];
    rr.restoreStructures = null;
}
function ri() {
    let n1 = Ke[se++];
    if (n1 < 160) {
        if (n1 < 128) {
            if (n1 < 64) return n1;
            {
                let t = rr[n1 & 63] || Bn.getStructures && GD()[n1 & 63];
                return t ? (t.read || (t.read = gA(t, n1 & 63)), t.read()) : n1;
            }
        } else if (n1 < 144) {
            if (n1 -= 128, Bn.mapsAsObjects) {
                let t = {};
                for(let e = 0; e < n1; e++)t[HD()] = ri();
                return t;
            } else {
                let t = new Map;
                for(let e = 0; e < n1; e++)t.set(ri(), ri());
                return t;
            }
        } else {
            n1 -= 144;
            let t = new Array(n1);
            for(let e = 0; e < n1; e++)t[e] = ri();
            return t;
        }
    } else if (n1 < 192) {
        let t = n1 - 160;
        if (Oo >= se) return Vl.slice(se - Ss, (se += t) - Ss);
        if (Oo == 0 && Ul < 140) {
            let e = t < 16 ? yA(t) : jD(t);
            if (e != null) return e;
        }
        return pA(t);
    } else {
        let t;
        switch(n1){
            case 192:
                return null;
            case 193:
                return ns ? (t = ri(), t > 0 ? ns[1].slice(ns.position1, ns.position1 += t) : ns[0].slice(ns.position0, ns.position0 -= t)) : mA;
            case 194:
                return !1;
            case 195:
                return !0;
            case 196:
                return uA(Ke[se++]);
            case 197:
                return t = fr.getUint16(se), se += 2, uA(t);
            case 198:
                return t = fr.getUint32(se), se += 4, uA(t);
            case 199:
                return Jc(Ke[se++]);
            case 200:
                return t = fr.getUint16(se), se += 2, Jc(t);
            case 201:
                return t = fr.getUint32(se), se += 4, Jc(t);
            case 202:
                if (t = fr.getFloat32(se), Bn.useFloat32 > 2) {
                    let e = c0[(Ke[se] & 127) << 1 | Ke[se + 1] >> 7];
                    return se += 4, (e * t + (t > 0 ? .5 : -0.5) >> 0) / e;
                }
                return se += 4, t;
            case 203:
                return t = fr.getFloat64(se), se += 8, t;
            case 204:
                return Ke[se++];
            case 205:
                return t = fr.getUint16(se), se += 2, t;
            case 206:
                return t = fr.getUint32(se), se += 4, t;
            case 207:
                return Bn.int64AsNumber ? (t = fr.getUint32(se) * 4294967296, t += fr.getUint32(se + 4)) : t = fr.getBigUint64(se), se += 8, t;
            case 208:
                return fr.getInt8(se++);
            case 209:
                return t = fr.getInt16(se), se += 2, t;
            case 210:
                return t = fr.getInt32(se), se += 4, t;
            case 211:
                return Bn.int64AsNumber ? (t = fr.getInt32(se) * 4294967296, t += fr.getUint32(se + 4)) : t = fr.getBigInt64(se), se += 8, t;
            case 212:
                if (t = Ke[se++], t == 114) return kD(Ke[se++] & 63);
                {
                    let e = wn[t];
                    if (e) return e.read ? (se++, e.read(ri())) : e.noBuffer ? (se++, e()) : e(Ke.subarray(se, ++se));
                    throw new Error("Unknown extension " + t);
                }
            case 213:
                return t = Ke[se], t == 114 ? (se++, kD(Ke[se++] & 63, Ke[se++])) : Jc(2);
            case 214:
                return Jc(4);
            case 215:
                return Jc(8);
            case 216:
                return Jc(16);
            case 217:
                return t = Ke[se++], Oo >= se ? Vl.slice(se - Ss, (se += t) - Ss) : Z7(t);
            case 218:
                return t = fr.getUint16(se), se += 2, Oo >= se ? Vl.slice(se - Ss, (se += t) - Ss) : J7(t);
            case 219:
                return t = fr.getUint32(se), se += 4, Oo >= se ? Vl.slice(se - Ss, (se += t) - Ss) : $7(t);
            case 220:
                return t = fr.getUint16(se), se += 2, FD(t);
            case 221:
                return t = fr.getUint32(se), se += 4, FD(t);
            case 222:
                return t = fr.getUint16(se), se += 2, VD(t);
            case 223:
                return t = fr.getUint32(se), se += 4, VD(t);
            default:
                if (n1 >= 224) return n1 - 256;
                if (n1 === void 0) {
                    let e = new Error("Unexpected end of MessagePack data");
                    throw e.incomplete = !0, e;
                }
                throw new Error("Unknown MessagePack token " + n1);
        }
    }
}
var Q7 = /^[a-zA-Z_$][a-zA-Z\d_$]*$/;
function gA(n1, t) {
    function e() {
        if (e.count++ > 2) {
            let i = n1.read = new Function("r", "return function(){return {" + n1.map((s1)=>Q7.test(s1) ? s1 + ":r()" : "[" + JSON.stringify(s1) + "]:r()").join(",") + "}}")(ri);
            return n1.highByte === 0 && (n1.read = BD(t, n1.read)), i();
        }
        let r = {};
        for(let i = 0, s1 = n1.length; i < s1; i++){
            let o = n1[i];
            r[o] = ri();
        }
        return r;
    }
    return e.count = 0, n1.highByte === 0 ? BD(t, e) : e;
}
var BD = (n1, t)=>function() {
        let e = Ke[se++];
        if (e === 0) return t();
        let r = n1 < 32 ? -(n1 + (e << 5)) : n1 + (e << 5), i = rr[r] || GD()[r];
        if (!i) throw new Error("Record id is not defined for " + r);
        return i.read || (i.read = gA(i, n1)), i.read();
    };
function GD() {
    let n1 = qD(()=>(Ke = null, Bn.getStructures()));
    return rr = Bn._mergeStructures(n1, rr);
}
var pA = l0, Z7 = l0, J7 = l0, $7 = l0;
function l0(n1) {
    let t;
    if (n1 < 16 && (t = yA(n1))) return t;
    if (n1 > 64 && hA) return hA.decode(Ke.subarray(se, se += n1));
    let e = se + n1, r = [];
    for(t = ""; se < e;){
        let i = Ke[se++];
        if ((i & 128) === 0) r.push(i);
        else if ((i & 224) === 192) {
            let s1 = Ke[se++] & 63;
            r.push((i & 31) << 6 | s1);
        } else if ((i & 240) === 224) {
            let s1 = Ke[se++] & 63, o = Ke[se++] & 63;
            r.push((i & 31) << 12 | s1 << 6 | o);
        } else if ((i & 248) === 240) {
            let s1 = Ke[se++] & 63, o = Ke[se++] & 63, a = Ke[se++] & 63, l = (i & 7) << 18 | s1 << 12 | o << 6 | a;
            l > 65535 && (l -= 65536, r.push(l >>> 10 & 1023 | 55296), l = 56320 | l & 1023), r.push(l);
        } else r.push(i);
        r.length >= 4096 && (t += Hi.apply(String, r), r.length = 0);
    }
    return r.length > 0 && (t += Hi.apply(String, r)), t;
}
function FD(n1) {
    let t = new Array(n1);
    for(let e = 0; e < n1; e++)t[e] = ri();
    return t;
}
function VD(n1) {
    if (Bn.mapsAsObjects) {
        let t = {};
        for(let e = 0; e < n1; e++)t[HD()] = ri();
        return t;
    } else {
        let t = new Map;
        for(let e = 0; e < n1; e++)t.set(ri(), ri());
        return t;
    }
}
var Hi = String.fromCharCode;
function jD(n1) {
    let t = se, e = new Array(n1);
    for(let r = 0; r < n1; r++){
        let i = Ke[se++];
        if ((i & 128) > 0) {
            se = t;
            return;
        }
        e[r] = i;
    }
    return Hi.apply(String, e);
}
function yA(n1) {
    if (n1 < 4) {
        if (n1 < 2) {
            if (n1 === 0) return "";
            {
                let t = Ke[se++];
                if ((t & 128) > 1) {
                    se -= 1;
                    return;
                }
                return Hi(t);
            }
        } else {
            let t = Ke[se++], e = Ke[se++];
            if ((t & 128) > 0 || (e & 128) > 0) {
                se -= 2;
                return;
            }
            if (n1 < 3) return Hi(t, e);
            let r = Ke[se++];
            if ((r & 128) > 0) {
                se -= 3;
                return;
            }
            return Hi(t, e, r);
        }
    } else {
        let t = Ke[se++], e = Ke[se++], r = Ke[se++], i = Ke[se++];
        if ((t & 128) > 0 || (e & 128) > 0 || (r & 128) > 0 || (i & 128) > 0) {
            se -= 4;
            return;
        }
        if (n1 < 6) {
            if (n1 === 4) return Hi(t, e, r, i);
            {
                let s1 = Ke[se++];
                if ((s1 & 128) > 0) {
                    se -= 5;
                    return;
                }
                return Hi(t, e, r, i, s1);
            }
        } else if (n1 < 8) {
            let s1 = Ke[se++], o = Ke[se++];
            if ((s1 & 128) > 0 || (o & 128) > 0) {
                se -= 6;
                return;
            }
            if (n1 < 7) return Hi(t, e, r, i, s1, o);
            let a = Ke[se++];
            if ((a & 128) > 0) {
                se -= 7;
                return;
            }
            return Hi(t, e, r, i, s1, o, a);
        } else {
            let s1 = Ke[se++], o = Ke[se++], a = Ke[se++], l = Ke[se++];
            if ((s1 & 128) > 0 || (o & 128) > 0 || (a & 128) > 0 || (l & 128) > 0) {
                se -= 8;
                return;
            }
            if (n1 < 10) {
                if (n1 === 8) return Hi(t, e, r, i, s1, o, a, l);
                {
                    let c = Ke[se++];
                    if ((c & 128) > 0) {
                        se -= 9;
                        return;
                    }
                    return Hi(t, e, r, i, s1, o, a, l, c);
                }
            } else if (n1 < 12) {
                let c = Ke[se++], u1 = Ke[se++];
                if ((c & 128) > 0 || (u1 & 128) > 0) {
                    se -= 10;
                    return;
                }
                if (n1 < 11) return Hi(t, e, r, i, s1, o, a, l, c, u1);
                let h = Ke[se++];
                if ((h & 128) > 0) {
                    se -= 11;
                    return;
                }
                return Hi(t, e, r, i, s1, o, a, l, c, u1, h);
            } else {
                let c = Ke[se++], u1 = Ke[se++], h = Ke[se++], d = Ke[se++];
                if ((c & 128) > 0 || (u1 & 128) > 0 || (h & 128) > 0 || (d & 128) > 0) {
                    se -= 12;
                    return;
                }
                if (n1 < 14) {
                    if (n1 === 12) return Hi(t, e, r, i, s1, o, a, l, c, u1, h, d);
                    {
                        let f = Ke[se++];
                        if ((f & 128) > 0) {
                            se -= 13;
                            return;
                        }
                        return Hi(t, e, r, i, s1, o, a, l, c, u1, h, d, f);
                    }
                } else {
                    let f = Ke[se++], m = Ke[se++];
                    if ((f & 128) > 0 || (m & 128) > 0) {
                        se -= 14;
                        return;
                    }
                    if (n1 < 15) return Hi(t, e, r, i, s1, o, a, l, c, u1, h, d, f, m);
                    let p = Ke[se++];
                    if ((p & 128) > 0) {
                        se -= 15;
                        return;
                    }
                    return Hi(t, e, r, i, s1, o, a, l, c, u1, h, d, f, m, p);
                }
            }
        }
    }
}
function uA(n1) {
    return Bn.copyBuffers ? Uint8Array.prototype.slice.call(Ke, se, se += n1) : Ke.subarray(se, se += n1);
}
function Jc(n1) {
    let t = Ke[se++];
    if (wn[t]) return wn[t](Ke.subarray(se, se += n1));
    throw new Error("Unknown extension type " + t);
}
var UD = new Array(4096);
function HD() {
    let n1 = Ke[se++];
    if (n1 >= 160 && n1 < 192) {
        if (n1 = n1 - 160, Oo >= se) return Vl.slice(se - Ss, (se += n1) - Ss);
        if (!(Oo == 0 && Ul < 180)) return pA(n1);
    } else return se--, ri();
    let t = (n1 << 5 ^ (n1 > 1 ? fr.getUint16(se) : n1 > 0 ? Ke[se] : 0)) & 4095, e = UD[t], r = se, i = se + n1 - 3, s1, o = 0;
    if (e && e.bytes == n1) {
        for(; r < i;){
            if (s1 = fr.getUint32(r), s1 != e[o++]) {
                r = 1879048192;
                break;
            }
            r += 4;
        }
        for(i += 3; r < i;)if (s1 = Ke[r++], s1 != e[o++]) {
            r = 1879048192;
            break;
        }
        if (r === i) return se = r, e.string;
        i -= 3, r = se;
    }
    for(e = [], UD[t] = e, e.bytes = n1; r < i;)s1 = fr.getUint32(r), e.push(s1), r += 4;
    for(i += 3; r < i;)s1 = Ke[r++], e.push(s1);
    let a = n1 < 16 ? yA(n1) : jD(n1);
    return a != null ? e.string = a : e.string = pA(n1);
}
var kD = (n1, t)=>{
    var e = ri();
    let r = n1;
    t !== void 0 && (n1 = n1 < 32 ? -((t << 5) + n1) : (t << 5) + n1, e.highByte = t);
    let i = rr[n1];
    return i && i.isShared && ((rr.restoreStructures || (rr.restoreStructures = []))[n1] = i), rr[n1] = e, e.read = gA(e, r), e.read();
}, WD = typeof self == "object" ? self : $parcel$global;
wn[0] = ()=>{};
wn[0].noBuffer = !0;
wn[101] = ()=>{
    let n1 = ri();
    return (WD[n1[0]] || Error)(n1[1]);
};
wn[105] = (n1)=>{
    let t = fr.getUint32(se - 4);
    La || (La = new Map);
    let e = Ke[se], r;
    e >= 144 && e < 160 || e == 220 || e == 221 ? r = [] : r = {};
    let i = {
        target: r
    };
    La.set(t, i);
    let s1 = ri();
    return i.used ? Object.assign(r, s1) : (i.target = s1, s1);
};
wn[112] = (n1)=>{
    let t = fr.getUint32(se - 4), e = La.get(t);
    return e.used = !0, e.target;
};
wn[115] = ()=>new Set(ri());
var vA = [
    "Int8",
    "Uint8",
    "Uint8Clamped",
    "Int16",
    "Uint16",
    "Int32",
    "Uint32",
    "Float32",
    "Float64",
    "BigInt64",
    "BigUint64"
].map((n1)=>n1 + "Array");
wn[116] = (n1)=>{
    let t = n1[0], e = vA[t];
    if (!e) throw new Error("Could not find typed array for code " + t);
    return new WD[e](Uint8Array.prototype.slice.call(n1, 1).buffer);
};
wn[120] = ()=>{
    let n1 = ri();
    return new RegExp(n1[0], n1[1]);
};
wn[98] = (n1)=>{
    let t = (n1[0] << 24) + (n1[1] << 16) + (n1[2] << 8) + n1[3], e = se;
    se += t - 4, ns = [
        ri(),
        ri()
    ], ns.position0 = 0, ns.position1 = 0;
    let r = se;
    se = e;
    try {
        return ri();
    } finally{
        se = r;
    }
};
wn[255] = (n1)=>n1.length == 4 ? new Date((n1[0] * 16777216 + (n1[1] << 16) + (n1[2] << 8) + n1[3]) * 1e3) : n1.length == 8 ? new Date(((n1[0] << 22) + (n1[1] << 14) + (n1[2] << 6) + (n1[3] >> 2)) / 1e6 + ((n1[3] & 3) * 4294967296 + n1[4] * 16777216 + (n1[5] << 16) + (n1[6] << 8) + n1[7]) * 1e3) : n1.length == 12 ? new Date(((n1[0] << 24) + (n1[1] << 16) + (n1[2] << 8) + n1[3]) / 1e6 + ((n1[4] & 128 ? -281474976710656 : 0) + n1[6] * 1099511627776 + n1[7] * 4294967296 + n1[8] * 16777216 + (n1[9] << 16) + (n1[10] << 8) + n1[11]) * 1e3) : new Date("invalid");
function qD(n1) {
    let t = Ul, e = se, r = fA, i = Ss, s1 = Oo, o = Vl, a = dA, l = La, c = ns, u1 = new Uint8Array(Ke.slice(0, Ul)), h = rr, d = rr.slice(0, rr.length), f = Bn, m = sd, p = n1();
    return Ul = t, se = e, fA = r, Ss = i, Oo = s1, Vl = o, dA = a, La = l, ns = c, Ke = u1, sd = m, rr = h, rr.splice(0, rr.length, ...d), Bn = f, fr = new DataView(Ke.buffer, Ke.byteOffset, Ke.byteLength), p;
}
function a0() {
    Ke = null, La = null, rr = null;
}
function XD(n1) {
    n1.unpack ? wn[n1.type] = n1.unpack : wn[n1.type] = n1;
}
var c0 = new Array(147);
for(let n1 = 0; n1 < 256; n1++)c0[n1] = +("1e" + Math.floor(45.15 - n1 * .30103));
var u0 = new Ro({
    useRecords: !1
}), eX = u0.unpack, tX = u0.unpackMultiple, rX = u0.unpack, h0 = {
    NEVER: 0,
    ALWAYS: 1,
    DECIMAL_ROUND: 3,
    DECIMAL_FIT: 4
}, iX = new Float32Array(1), qfe = new Uint8Array(iX.buffer, 0, 4);
var d0;
try {
    d0 = new TextEncoder;
} catch  {}
var f0, bA, p0 = typeof $5059ff85b35ef8d7$require$Buffer < "u", xA = p0 ? $5059ff85b35ef8d7$require$Buffer.allocUnsafeSlow : Uint8Array, ZD = p0 ? $5059ff85b35ef8d7$require$Buffer : Uint8Array, YD = p0 ? 4294967296 : 2144337920, we, oi, he = 0, Lo, No = null, nX = /[\u0080-\uFFFF]/, ym = Symbol("record-id"), $c = class extends Ro {
    constructor(t){
        super(t), this.offset = 0;
        let e, r, i, s1, o, a, l = 0, c = ZD.prototype.utf8Write ? function(S, M, C) {
            return we.utf8Write(S, M, C);
        } : d0 && d0.encodeInto ? function(S, M) {
            return d0.encodeInto(S, we.subarray(M)).written;
        } : !1, u1 = this;
        t || (t = {});
        let h = t && t.sequential, d = t.structures || t.saveStructures, f = t.maxSharedStructures;
        if (f == null && (f = d ? 32 : 0), f > 8160) throw new Error("Maximum maxSharedStructure is 8160");
        let m = t.maxOwnStructures;
        m == null && (m = d ? 32 : 64), h && !t.saveStructures && (this.structures = []);
        let p = f > 32 || m + f > 64, g = f + 64, y = f + m + 64;
        if (y > 8256) throw new Error("Maximum maxSharedStructure + maxOwnStructure is 8192");
        let x = [], v = 0, b = 0;
        this.pack = this.encode = function(S, M) {
            if (we || (we = new xA(8192), oi = new DataView(we.buffer, 0, 8192), he = 0), Lo = we.length - 10, Lo - he < 2048 ? (we = new xA(we.length), oi = new DataView(we.buffer, 0, we.length), Lo = we.length - 10, he = 0) : he = he + 7 & 2147483640, r = he, a = u1.structuredClone ? new Map : null, u1.bundleStrings ? (No = [
                "",
                ""
            ], we[he++] = 214, we[he++] = 98, No.position = he - r, he += 4) : No = null, i = u1.structures, i) {
                i.uninitialized && (i = u1._mergeStructures(u1.getStructures()));
                let C = i.sharedLength || 0;
                if (C > f) throw new Error("Shared structures is larger than maximum shared structures, try increasing maxSharedStructures to " + i.sharedLength);
                if (!i.transitions) {
                    i.transitions = Object.create(null);
                    for(let P = 0; P < C; P++){
                        let _ = i[P];
                        if (!_) continue;
                        let I, O = i.transitions;
                        for(let L = 0, j = _.length; L < j; L++){
                            let V = _[L];
                            I = O[V], I || (I = O[V] = Object.create(null)), O = I;
                        }
                        O[ym] = P + 64;
                    }
                    l = C;
                }
                h || (i.nextId = C + 64);
            }
            s1 && (s1 = !1), o = i || [];
            try {
                if (w(S), No) {
                    oi.setUint32(No.position + r, he - No.position - r);
                    let C = No;
                    No = null, w(C[0]), w(C[1]);
                }
                if (u1.offset = he, a && a.idsToInsert) {
                    he += a.idsToInsert.length * 6, he > Lo && T(he), u1.offset = he;
                    let C = oX(we.subarray(r, he), a.idsToInsert);
                    return a = null, C;
                }
                return M & $D ? (we.start = r, we.end = he, we) : we.subarray(r, he);
            } finally{
                if (i) {
                    if (b < 10 && b++, v > 1e4) i.transitions = null, b = 0, v = 0, x.length > 0 && (x = []);
                    else if (x.length > 0 && !h) {
                        for(let C = 0, P = x.length; C < P; C++)x[C][ym] = 0;
                        x = [];
                    }
                    if (s1 && u1.saveStructures) {
                        let C = i.sharedLength || f;
                        i.length > C && (i = i.slice(0, C));
                        let P = we.subarray(r, he);
                        return u1.saveStructures(i, l) === !1 ? (u1._mergeStructures(u1.getStructures()), u1.pack(S)) : (l = C, P);
                    }
                }
                M & fX && (he = r);
            }
        };
        let w = (S)=>{
            he > Lo && (we = T(he));
            var M = typeof S, C;
            if (M === "string") {
                let P = S.length;
                if (No && P >= 8 && P < 4096) {
                    let O = nX.test(S);
                    No[O ? 0 : 1] += S, we[he++] = 193, w(O ? -P : P);
                    return;
                }
                let _;
                P < 32 ? _ = 1 : P < 256 ? _ = 2 : P < 65536 ? _ = 3 : _ = 5;
                let I = P * 3;
                if (he + I > Lo && (we = T(he + I)), P < 64 || !c) {
                    let O, L, j, V = he + _;
                    for(O = 0; O < P; O++)L = S.charCodeAt(O), L < 128 ? we[V++] = L : L < 2048 ? (we[V++] = L >> 6 | 192, we[V++] = L & 63 | 128) : (L & 64512) === 55296 && ((j = S.charCodeAt(O + 1)) & 64512) === 56320 ? (L = 65536 + ((L & 1023) << 10) + (j & 1023), O++, we[V++] = L >> 18 | 240, we[V++] = L >> 12 & 63 | 128, we[V++] = L >> 6 & 63 | 128, we[V++] = L & 63 | 128) : (we[V++] = L >> 12 | 224, we[V++] = L >> 6 & 63 | 128, we[V++] = L & 63 | 128);
                    C = V - he - _;
                } else C = c(S, he + _, I);
                C < 32 ? we[he++] = 160 | C : C < 256 ? (_ < 2 && we.copyWithin(he + 2, he + 1, he + 1 + C), we[he++] = 217, we[he++] = C) : C < 65536 ? (_ < 3 && we.copyWithin(he + 3, he + 2, he + 2 + C), we[he++] = 218, we[he++] = C >> 8, we[he++] = C & 255) : (_ < 5 && we.copyWithin(he + 5, he + 3, he + 3 + C), we[he++] = 219, oi.setUint32(he, C), he += 4), he += C;
            } else if (M === "number") {
                if (S >>> 0 === S) S < 64 ? we[he++] = S : S < 256 ? (we[he++] = 204, we[he++] = S) : S < 65536 ? (we[he++] = 205, we[he++] = S >> 8, we[he++] = S & 255) : (we[he++] = 206, oi.setUint32(he, S), he += 4);
                else if (S >> 0 === S) S >= -32 ? we[he++] = 256 + S : S >= -128 ? (we[he++] = 208, we[he++] = S + 256) : S >= -32768 ? (we[he++] = 209, oi.setInt16(he, S), he += 2) : (we[he++] = 210, oi.setInt32(he, S), he += 4);
                else {
                    let P;
                    if ((P = this.useFloat32) > 0 && S < 4294967296 && S >= -2147483648) {
                        we[he++] = 202, oi.setFloat32(he, S);
                        let _;
                        if (P < 4 || (_ = S * c0[(we[he] & 127) << 1 | we[he + 1] >> 7]) >> 0 === _) {
                            he += 4;
                            return;
                        } else he--;
                    }
                    we[he++] = 203, oi.setFloat64(he, S), he += 8;
                }
            } else if (M === "object") {
                if (!S) we[he++] = 192;
                else {
                    if (a) {
                        let _ = a.get(S);
                        if (_) {
                            if (!_.id) {
                                let I = a.idsToInsert || (a.idsToInsert = []);
                                _.id = I.push(_);
                            }
                            we[he++] = 214, we[he++] = 112, oi.setUint32(he, _.id), he += 4;
                            return;
                        } else a.set(S, {
                            offset: he - r
                        });
                    }
                    let P = S.constructor;
                    if (P === Object) A(S, !0);
                    else if (P === Array) {
                        C = S.length, C < 16 ? we[he++] = 144 | C : C < 65536 ? (we[he++] = 220, we[he++] = C >> 8, we[he++] = C & 255) : (we[he++] = 221, oi.setUint32(he, C), he += 4);
                        for(let _ = 0; _ < C; _++)w(S[_]);
                    } else if (P === Map) {
                        C = S.size, C < 16 ? we[he++] = 128 | C : C < 65536 ? (we[he++] = 222, we[he++] = C >> 8, we[he++] = C & 255) : (we[he++] = 223, oi.setUint32(he, C), he += 4);
                        for (let [_, I] of S)w(_), w(I);
                    } else {
                        for(let _ = 0, I = f0.length; _ < I; _++){
                            let O = bA[_];
                            if (S instanceof O) {
                                let L = f0[_];
                                if (L.write) {
                                    L.type && (we[he++] = 212, we[he++] = L.type, we[he++] = 0), w(L.write.call(this, S));
                                    return;
                                }
                                let j = we, V = oi, H = he;
                                we = null;
                                let q;
                                try {
                                    q = L.pack.call(this, S, (X)=>(we = j, j = null, he += X, he > Lo && T(he), {
                                            target: we,
                                            targetView: oi,
                                            position: he - X
                                        }), w);
                                } finally{
                                    j && (we = j, oi = V, he = H, Lo = we.length - 10);
                                }
                                q && (q.length + he > Lo && T(q.length + he), he = sX(q, we, he, L.type));
                                return;
                            }
                        }
                        A(S, !S.hasOwnProperty);
                    }
                }
            } else if (M === "boolean") we[he++] = S ? 195 : 194;
            else if (M === "bigint") {
                if (S < BigInt(1) << BigInt(63) && S >= -(BigInt(1) << BigInt(63))) we[he++] = 211, oi.setBigInt64(he, S);
                else if (S < BigInt(1) << BigInt(64) && S > 0) we[he++] = 207, oi.setBigUint64(he, S);
                else if (this.largeBigIntToFloat) we[he++] = 203, oi.setFloat64(he, Number(S));
                else throw new RangeError(S + " was too large to fit in MessagePack 64-bit integer format, set largeBigIntToFloat to convert to float-64");
                he += 8;
            } else if (M === "undefined") this.encodeUndefinedAsNil ? we[he++] = 192 : (we[he++] = 212, we[he++] = 0, we[he++] = 0);
            else if (M === "function") w(this.writeFunction && this.writeFunction());
            else throw new Error("Unknown type: " + M);
        }, A = this.useRecords === !1 ? this.variableMapSize ? (S)=>{
            let M = Object.keys(S), C = M.length;
            C < 16 ? we[he++] = 128 | C : C < 65536 ? (we[he++] = 222, we[he++] = C >> 8, we[he++] = C & 255) : (we[he++] = 223, oi.setUint32(he, C), he += 4);
            let P;
            for(let _ = 0; _ < C; _++)w(P = M[_]), w(S[P]);
        } : (S, M)=>{
            we[he++] = 222;
            let C = he - r;
            he += 2;
            let P = 0;
            for(let _ in S)(M || S.hasOwnProperty(_)) && (w(_), w(S[_]), P++);
            we[C++ + r] = P >> 8, we[C + r] = P & 255;
        } : (S)=>{
            let M = Object.keys(S), C, P = o.transitions || (o.transitions = Object.create(null)), _ = 0;
            for(let O = 0, L = M.length; O < L; O++){
                let j = M[O];
                C = P[j], C || (C = P[j] = Object.create(null), _++), P = C;
            }
            let I = P[ym];
            if (I) I >= 96 && p ? (we[he++] = ((I -= 96) & 31) + 96, we[he++] = I >> 5) : we[he++] = I;
            else {
                I = o.nextId, I || (I = 64), I < g && this.shouldShareStructure && !this.shouldShareStructure(M) ? (I = o.nextOwnId, I < y || (I = g), o.nextOwnId = I + 1) : (I >= y && (I = g), o.nextId = I + 1);
                let O = M.highByte = I >= 96 && p ? I - 96 >> 5 : -1;
                P[ym] = I, o[I - 64] = M, I < g ? (M.isShared = !0, o.sharedLength = I - 63, s1 = !0, O >= 0 ? (we[he++] = (I & 31) + 96, we[he++] = O) : we[he++] = I) : (O >= 0 ? (we[he++] = 213, we[he++] = 114, we[he++] = (I & 31) + 96, we[he++] = O) : (we[he++] = 212, we[he++] = 114, we[he++] = I), _ && (v += b * _), x.length >= m && (x.shift()[ym] = 0), x.push(P), w(M));
            }
            for(let O = 0, L = M.length; O < L; O++)w(S[M[O]]);
        }, T = (S)=>{
            let M;
            if (S > 16777216) {
                if (S - r > YD) throw new Error("Packed buffer would be larger than maximum buffer size");
                M = Math.min(YD, Math.round(Math.max((S - r) * (S > 67108864 ? 1.25 : 2), 4194304) / 4096) * 4096);
            } else M = (Math.max(S - r << 2, we.length - 1) >> 12) + 1 << 12;
            let C = new xA(M);
            return oi = new DataView(C.buffer, 0, M), we.copy ? we.copy(C, 0, r, S) : C.set(we.slice(r, S)), he -= r, r = 0, Lo = C.length - 10, we = C;
        };
    }
    useBuffer(t) {
        we = t, oi = new DataView(we.buffer, we.byteOffset, we.byteLength), he = 0;
    }
};
bA = [
    Date,
    Set,
    Error,
    RegExp,
    ArrayBuffer,
    Object.getPrototypeOf(Uint8Array.prototype).constructor,
    gm
];
f0 = [
    {
        pack (n1, t, e) {
            let r = n1.getTime() / 1e3;
            if ((this.useTimestamp32 || n1.getMilliseconds() === 0) && r >= 0 && r < 4294967296) {
                let { target: i, targetView: s1, position: o } = t(6);
                i[o++] = 214, i[o++] = 255, s1.setUint32(o, r);
            } else if (r > 0 && r < 17179869184) {
                let { target: i, targetView: s1, position: o } = t(10);
                i[o++] = 215, i[o++] = 255, s1.setUint32(o, n1.getMilliseconds() * 4e6 + (r / 1e3 / 4294967296 >> 0)), s1.setUint32(o + 4, r);
            } else if (isNaN(r)) {
                if (this.onInvalidDate) return t(0), e(this.onInvalidDate());
                let { target: i, targetView: s1, position: o } = t(3);
                i[o++] = 212, i[o++] = 255, i[o++] = 255;
            } else {
                let { target: i, targetView: s1, position: o } = t(15);
                i[o++] = 199, i[o++] = 12, i[o++] = 255, s1.setUint32(o, n1.getMilliseconds() * 1e6), s1.setBigInt64(o + 4, BigInt(Math.floor(r)));
            }
        }
    },
    {
        pack (n1, t, e) {
            let r = Array.from(n1), { target: i, position: s1 } = t(this.structuredClone ? 3 : 0);
            this.structuredClone && (i[s1++] = 212, i[s1++] = 115, i[s1++] = 0), e(r);
        }
    },
    {
        pack (n1, t, e) {
            let { target: r, position: i } = t(this.structuredClone ? 3 : 0);
            this.structuredClone && (r[i++] = 212, r[i++] = 101, r[i++] = 0), e([
                n1.name,
                n1.message
            ]);
        }
    },
    {
        pack (n1, t, e) {
            let { target: r, position: i } = t(this.structuredClone ? 3 : 0);
            this.structuredClone && (r[i++] = 212, r[i++] = 120, r[i++] = 0), e([
                n1.source,
                n1.flags
            ]);
        }
    },
    {
        pack (n1, t) {
            this.structuredClone ? KD(n1, 16, t) : QD(p0 ? $5059ff85b35ef8d7$require$Buffer.from(n1) : new Uint8Array(n1), t);
        }
    },
    {
        pack (n1, t) {
            let e = n1.constructor;
            e !== ZD && this.structuredClone ? KD(n1, vA.indexOf(e.name), t) : QD(n1, t);
        }
    },
    {
        pack (n1, t) {
            let { target: e, position: r } = t(1);
            e[r] = 193;
        }
    }
];
function KD(n1, t, e, r) {
    let i = n1.byteLength;
    if (i + 1 < 256) {
        var { target: s1, position: o } = e(4 + i);
        s1[o++] = 199, s1[o++] = i + 1;
    } else if (i + 1 < 65536) {
        var { target: s1, position: o } = e(5 + i);
        s1[o++] = 200, s1[o++] = i + 1 >> 8, s1[o++] = i + 1 & 255;
    } else {
        var { target: s1, position: o, targetView: a } = e(7 + i);
        s1[o++] = 201, a.setUint32(o, i + 1), o += 4;
    }
    s1[o++] = 116, s1[o++] = t, s1.set(new Uint8Array(n1.buffer, n1.byteOffset, n1.byteLength), o);
}
function QD(n1, t) {
    let e = n1.byteLength;
    var r, i;
    if (e < 256) {
        var { target: r, position: i } = t(e + 2);
        r[i++] = 196, r[i++] = e;
    } else if (e < 65536) {
        var { target: r, position: i } = t(e + 3);
        r[i++] = 197, r[i++] = e >> 8, r[i++] = e & 255;
    } else {
        var { target: r, position: i, targetView: s1 } = t(e + 5);
        r[i++] = 198, s1.setUint32(i, e), i += 4;
    }
    r.set(n1, i);
}
function sX(n1, t, e, r) {
    let i = n1.length;
    switch(i){
        case 1:
            t[e++] = 212;
            break;
        case 2:
            t[e++] = 213;
            break;
        case 4:
            t[e++] = 214;
            break;
        case 8:
            t[e++] = 215;
            break;
        case 16:
            t[e++] = 216;
            break;
        default:
            i < 256 ? (t[e++] = 199, t[e++] = i) : i < 65536 ? (t[e++] = 200, t[e++] = i >> 8, t[e++] = i & 255) : (t[e++] = 201, t[e++] = i >> 24, t[e++] = i >> 16 & 255, t[e++] = i >> 8 & 255, t[e++] = i & 255);
    }
    return t[e++] = r, t.set(n1, e), e += i, e;
}
function oX(n1, t) {
    let e, r = t.length * 6, i = n1.length - r;
    for(t.sort((s1, o)=>s1.offset > o.offset ? 1 : -1); e = t.pop();){
        let s1 = e.offset, o = e.id;
        n1.copyWithin(s1 + r, s1, i), r -= 6;
        let a = s1 + r;
        n1[a++] = 214, n1[a++] = 105, n1[a++] = o >> 24, n1[a++] = o >> 16 & 255, n1[a++] = o >> 8 & 255, n1[a++] = o & 255, i = s1;
    }
    return n1;
}
function kl(n1) {
    if (n1.Class) {
        if (!n1.pack && !n1.write) throw new Error("Extension has no pack or write function");
        if (n1.pack && !n1.type) throw new Error("Extension has no type (numeric code to identify the extension)");
        bA.unshift(n1.Class), f0.unshift(n1);
    }
    XD(n1);
}
var JD = new $c({
    useRecords: !1
}), aX = JD.pack, lX = JD.pack;
var { NEVER: cX, ALWAYS: uX, DECIMAL_ROUND: hX, DECIMAL_FIT: dX } = h0, $D = 512, fX = 1024;
var eO = new $c({
    structuredClone: !0
});
kl({
    Class: He.prototype.constructor,
    type: 1,
    write (n1) {
        return {
            ...n1
        };
    },
    read (n1) {
        return Object.setPrototypeOf(n1, He.prototype), n1;
    }
});
kl({
    Class: Re.prototype.constructor,
    type: 2,
    write (n1) {
        return [
            ...n1
        ];
    },
    read (n1) {
        return Object.setPrototypeOf(n1, Re.prototype), n1;
    }
});
kl({
    Class: wr.prototype.constructor,
    type: 3,
    write (n1) {
        return [
            ...n1
        ];
    },
    read (n1) {
        return Object.setPrototypeOf(n1, wr.prototype), n1;
    }
});
kl({
    Class: pm.prototype.constructor,
    type: 4,
    write (n1) {
        return n1.id;
    },
    read (n1) {
        return new pm(n1);
    }
});
kl({
    Class: mm.prototype.constructor,
    type: 5,
    write (n1) {
        return n1.data;
    },
    read (n1) {
        return new mm(n1);
    }
});
kl({
    Class: lr.prototype.constructor,
    type: 6,
    write (n1) {
        return {
            ...n1
        };
    },
    read (n1) {
        return Object.setPrototypeOf(n1, lr.prototype), n1;
    }
});
function pX(n1) {
    var t = 0;
    if (n1.length === 0) return t;
    for(let e = 0; e < n1.length; e++){
        let r = n1[e];
        t = (t << 5) - t + r, t = t & t;
    }
    return t;
}
function SA(n1) {
    if ($h(n1)) return n1;
    if (Array.isArray(n1)) return n1.map(SA);
    if (typeof n1 == "object" && n1 !== null) {
        let t = {};
        for (let e of Object.keys(n1).sort())t[e] = SA(n1[e]);
        return Object.setPrototypeOf(t, Object.getPrototypeOf(n1)), t;
    } else return n1;
}
var od;
((r)=>{
    function n1(i) {
        return eO.pack(i);
    }
    r.serialize = n1;
    function t(i) {
        return eO.unpack(i);
    }
    r.deserialize = t;
    function e(i) {
        return pX(n1(SA(i))).toString();
    }
    r.checksum = e;
})(od || (od = {}));
var tO;
((e)=>{
    function n1(r) {
        return r.type === "Conditional" ? r.condition.type === "Distance" ? "Distance" : "StateChange" : r.type;
    }
    e.toEventUIType = n1;
    function t(r) {
        return r === "Distance" || r === "StateChange" ? "Conditional" : r;
    }
    e.fromEventUIType = t;
})(tO || (tO = {}));
function vm(n1) {
    return n1 === "MouseDown" || n1 === "MouseUp" || n1 === "KeyDown" || n1 === "KeyUp" || n1 === "Collision" || n1 === "Trigger";
}
var Wi = {
    ["LookAt"]: [],
    ["Follow"]: [
        "Create"
    ],
    ["DragDrop"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Create",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["MouseHover"]: [
        "Transition",
        "Animation",
        "TimelineAnimation",
        "Particles",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["Scroll"]: [
        "Transition",
        "Animation",
        "TimelineAnimation",
        "Create",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["Start"]: [
        "Transition",
        "Animation",
        "TimelineAnimation",
        "Audio",
        "Particles",
        "Video",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["Conditional"]: [
        "Transition",
        "Animation",
        "TimelineAnimation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["MouseDown"]: [
        "Transition",
        "Animation",
        "TimelineAnimation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["MouseUp"]: [
        "Transition",
        "Animation",
        "TimelineAnimation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["MousePress"]: [
        "Transition",
        "Animation",
        "TimelineAnimation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["KeyDown"]: [
        "Transition",
        "Animation",
        "TimelineAnimation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["KeyUp"]: [
        "Transition",
        "Animation",
        "TimelineAnimation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["KeyPress"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "SwitchCamera",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["GameControl"]: [
        "Transition",
        "Animation",
        "TimelineAnimation",
        "Audio",
        "Particles",
        "Create",
        "Conditional"
    ],
    ["Collision"]: [
        "Transition",
        "Animation",
        "TimelineAnimation",
        "Audio",
        "Particles",
        "Video",
        "Create",
        "Destroy",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["Trigger"]: [
        "Transition",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["Resize"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["VariableChange"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["API"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["WEBHOOK"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ],
    ["AIAssistantListener"]: [
        "SetVariable"
    ],
    ["AIAssistantTrigger"]: [
        "Transition",
        "Animation",
        "Audio",
        "Particles",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "SwitchCamera",
        "SceneTransition",
        "Reset",
        "SetVariable",
        "DynamicVariablePlay",
        "Conditional",
        "ClearLocalStorage",
        "UserAPI"
    ]
}, rO;
((e)=>{
    function n1(r) {
        return r.type === "MouseDown" || r.type === "MouseUp" || r.type === "MousePress" || r.type === "KeyDown" || r.type === "KeyUp" || r.type === "KeyPress";
    }
    e.is = n1;
    function t(r) {
        return r === "MouseDown" || r === "MouseUp" || r === "MousePress" ? {
            type: r,
            mode: "Object",
            disabled: !1,
            name: "",
            actions: new Re
        } : {
            type: r,
            disabled: !1,
            name: "",
            key: void 0,
            actions: new Re
        };
    }
    e.defaultData = t;
})(rO || (rO = {}));
var m0;
((e)=>{
    function n1(r) {
        return {
            type: "Property",
            value: [
                r ?? null,
                "position",
                "x"
            ]
        };
    }
    e.propertyDefaultData = n1, e.valueDefaultData = {
        type: "Literal",
        value: 0
    };
})(m0 || (m0 = {}));
var wA;
((r)=>{
    function n1(i) {
        return {
            type: "Comparison",
            operator: "==",
            lOperand: m0.propertyDefaultData(i),
            rOperand: {
                ...m0.valueDefaultData
            }
        };
    }
    r.comparisonDefaultData = n1;
    function t(i) {
        return {
            type: "Distance",
            toObject: i ?? null,
            fromObject: i ?? null,
            distance: 200
        };
    }
    r.distanceDefaultData = t;
    function e(i, s1) {
        return {
            type: "State",
            object: i ?? null,
            state: s1 ?? null
        };
    }
    r.stateDefaultData = e;
})(wA || (wA = {}));
var iO;
((t)=>{
    function n1(e) {
        return e.find((r)=>r === "ifActions" || r === "elseActions") !== void 0;
    }
    t.isConditionalSubActions = n1;
})(iO || (iO = {}));
var nO;
((e)=>{
    function n1(r) {
        return r.type === "Conditional";
    }
    e.is = n1;
    function t(r) {
        return {
            type: "Conditional",
            disabled: !1,
            name: "",
            inActions: new Re,
            outActions: new Re,
            condition: wA.distanceDefaultData(r)
        };
    }
    e.defaultData = t;
})(nO || (nO = {}));
var sO;
((t)=>t.defaultData = {
        type: "DragDrop",
        name: "",
        cursor: "hand",
        disabled: !1,
        dampingFactor: 1,
        objects: [],
        snapTo: "center",
        snapSurfaceMode: "bbox",
        snapSurfaceOffset: 0,
        dropOn: "all",
        autoOrient: !0,
        dropDestinations: [],
        plane: "adaptive",
        planeMode: "locked",
        referenceFrame: "global",
        limits: [
            -1 / 0,
            1 / 0,
            -1 / 0,
            1 / 0,
            -1 / 0,
            1 / 0
        ],
        drop: !1,
        resetOnSnapFail: !1,
        snapSpeed: 20,
        resetSpeed: 20,
        dragDropActions: {
            drag: new Re,
            drop: new Re
        }
    })(sO || (sO = {}));
var g0;
((t)=>t.defaultData = {
        type: "Follow",
        disabled: !1,
        name: "",
        maxDelta: 0,
        dampingFactor: 1,
        target: "cursor",
        plane: "custom",
        resetOnPointerLeave: !0,
        resetAfterDistanceLimit: !0,
        enabledTranslation: [
            !0,
            !0,
            !0
        ],
        limitDistanceEnabled: !1,
        limitDistance: 1e3,
        snapDelay: 0,
        resetSpeed: 5,
        actions: new Re
    })(g0 || (g0 = {}));
var y0;
((t)=>t.defaultData = {
        type: "LookAt",
        disabled: !1,
        name: "",
        distance: 1e3,
        dampingFactor: 1,
        target: "cursor",
        tilt: "up",
        axis: "z",
        plane: "custom",
        resetOnPointerLeave: !0,
        resetAfterDistanceLimit: !0,
        enabledRotation: [
            !0,
            !0,
            !0
        ],
        limitDistanceEnabled: !1,
        limitDistance: 1e3,
        snapDelay: 0,
        resetSpeed: 5
    })(y0 || (y0 = {}));
var oO;
((e)=>{
    function n1(r) {
        return r.type === "MouseHover";
    }
    e.is = n1;
    function t() {
        return {
            type: "MouseHover",
            disabled: !1,
            name: "",
            actions: new Re
        };
    }
    e.defaultData = t;
})(oO || (oO = {}));
var aO;
((e)=>{
    function n1(r) {
        return r.type === "Scroll";
    }
    e.is = n1;
    function t() {
        return {
            type: "Scroll",
            disabled: !1,
            name: "",
            steps: 100,
            trigger: "load",
            startFrom: "enter",
            enterAnchor: "top",
            startOffset: 0,
            endAfter: 400,
            actions: new Re
        };
    }
    e.defaultData = t;
})(aO || (aO = {}));
var lO;
((e)=>{
    function n1(r) {
        return r.type === "Start";
    }
    e.is = n1;
    function t() {
        return {
            type: "Start",
            disabled: !1,
            name: "",
            actions: new Re
        };
    }
    e.defaultData = t;
})(lO || (lO = {}));
var cO;
((e)=>{
    function n1(r) {
        return r.type === "Collision";
    }
    e.is = n1;
    function t() {
        return {
            type: "Collision",
            disabled: !1,
            name: "",
            target: "character",
            actions: new Re
        };
    }
    e.defaultData = t;
})(cO || (cO = {}));
var uO;
((e)=>{
    function n1(r) {
        return r.type === "Trigger";
    }
    e.is = n1;
    function t(r, i) {
        return {
            type: "Trigger",
            name: "",
            disabled: !1,
            target: "all",
            triggeringObjects: [],
            actions: new Re,
            triggerZone: "box",
            position: i.toArray(),
            rotation: [
                0,
                0,
                0
            ],
            size: r.toArray(),
            radius: r.length() / 2,
            helperVisible: !0
        };
    }
    e.defaultData = t;
})(uO || (uO = {}));
var v0;
((o)=>{
    o.defaultSizes = {
        mobile: [
            480,
            480
        ],
        tablet: [
            768,
            768
        ],
        desktop: [
            1200,
            1200
        ],
        custom: [
            769,
            1200
        ]
    };
    function t(a) {
        return a.type === "Resize";
    }
    o.is = t;
    function e(a) {
        return typeof a == "string" ? a : "custom";
    }
    o.sizeToDevice = e;
    function r(a) {
        return typeof a == "string" ? [
            ...o.defaultSizes[a]
        ] : [
            ...a
        ];
    }
    o.deviceToSize = r;
    function i() {
        let a = {
            size: "mobile",
            operator: "<",
            actions: new Re
        }, l = {
            size: "tablet",
            operator: "<",
            actions: new Re
        }, c = {
            size: [
                ...o.defaultSizes.custom
            ],
            operator: "<>",
            actions: new Re
        }, u1 = new Re;
        return u1.push({
            id: Se.generateUUID(),
            fi: 0,
            data: a
        }, {
            id: Se.generateUUID(),
            fi: 1,
            data: l
        }, {
            id: Se.generateUUID(),
            fi: 2,
            data: c
        }), {
            type: "Resize",
            disabled: !1,
            name: "",
            orientation: "horizontal",
            breakpoints: u1
        };
    }
    o.defaultData = i;
    function s1() {
        return {
            size: [
                ...o.defaultSizes.custom
            ],
            operator: "<>",
            actions: new Re
        };
    }
    o.defaultBreakpointData = s1;
})(v0 || (v0 = {}));
var x0;
((r)=>{
    r.propertyPaths = {
        Position: [
            "position"
        ],
        "Position X": [
            "position",
            "x"
        ],
        "Position Y": [
            "position",
            "y"
        ],
        "Position Z": [
            "position",
            "z"
        ],
        Rotation: [
            "rotation"
        ],
        "Rotation X": [
            "rotation",
            "x"
        ],
        "Rotation Y": [
            "rotation",
            "y"
        ],
        "Rotation Z": [
            "rotation",
            "z"
        ],
        Scale: [
            "scale"
        ],
        "Scale X": [
            "scale",
            "x"
        ],
        "Scale Y": [
            "scale",
            "y"
        ],
        "Scale Z": [
            "scale",
            "z"
        ],
        Width: [
            "width"
        ],
        Height: [
            "height"
        ],
        Depth: [
            "depth"
        ],
        "Mouse Position X": [
            "mouse",
            "x"
        ],
        "Mouse Position Y": [
            "mouse",
            "y"
        ],
        "Mouse Pressed": [
            "mouse",
            "pressed"
        ],
        "Screen Width": [
            "mouse",
            "width"
        ],
        "Screen Height": [
            "mouse",
            "height"
        ],
        "Hit Position X": [
            "raycast",
            "x"
        ],
        "Hit Position Y": [
            "raycast",
            "y"
        ],
        "Hit Position Z": [
            "raycast",
            "z"
        ],
        "Hit Object Position X": [
            "raycast",
            "objX"
        ],
        "Hit Object Position Y": [
            "raycast",
            "objY"
        ],
        "Hit Object Position Z": [
            "raycast",
            "objZ"
        ]
    };
    function t(i) {
        return i.type === "VariableChange";
    }
    r.is = t;
    function e() {
        return {
            disabled: !1,
            type: "VariableChange",
            name: "",
            actions: new Re,
            variableId: "",
            objectId: null,
            property: "Position X"
        };
    }
    r.defaultData = e;
})(x0 || (x0 = {}));
var hO;
((e)=>{
    function n1(r) {
        return r.type === "API";
    }
    e.is = n1;
    function t() {
        return {
            disabled: !1,
            type: "API",
            name: "",
            successActions: new Re,
            errorActions: new Re,
            userAPIId: ""
        };
    }
    e.defaultData = t;
})(hO || (hO = {}));
var dO;
((e)=>{
    function n1(r) {
        return r.type === "WEBHOOK";
    }
    e.is = n1;
    function t() {
        return {
            disabled: !1,
            type: "WEBHOOK",
            name: "",
            actions: new Re,
            userWebhookId: ""
        };
    }
    e.defaultData = t;
})(dO || (dO = {}));
var fO;
((e)=>{
    function n1(r) {
        return r.type === "AIAssistantListener";
    }
    e.is = n1;
    function t() {
        return {
            disabled: !1,
            type: "AIAssistantListener",
            name: "",
            actions: new Re,
            analysis: "average",
            analysisRange: [
                0,
                71
            ],
            analysisSingle: 0
        };
    }
    e.defaultData = t;
})(fO || (fO = {}));
var pO;
((e)=>{
    function n1(r) {
        return r.type === "AIAssistantTrigger";
    }
    e.is = n1;
    function t() {
        return {
            disabled: !1,
            description: "",
            name: "",
            type: "AIAssistantTrigger",
            actions: new Re
        };
    }
    e.defaultData = t;
})(pO || (pO = {}));
var As = "personal camera", Gl = "a218fcc3-276b-49b9-b485-49037fd14f5f", gO = 2960946;
var ai = 5526619, AA = ((r)=>(r.x = "x", r.y = "y", r.z = "z", r))(AA || {}), ss;
((f)=>{
    function n1(m, p) {
        return m[0] === p[0] && m[1] === p[1];
    }
    f.isEqual = n1;
    function t(m, p, g) {
        return [
            m[0] + (p[0] - m[0]) * g,
            m[1] + (p[1] - m[1]) * g
        ];
    }
    f.lerp = t;
    function e(m, p) {
        return [
            m[0] + p[0],
            m[1] + p[1]
        ];
    }
    f.add = e;
    function r(m, p) {
        return [
            m[0] - p[0],
            m[1] - p[1]
        ];
    }
    f.sub = r;
    function i(m, p) {
        return [
            m[0] * p[0],
            m[1] * p[1]
        ];
    }
    f.multiply = i;
    function s1(m, p) {
        return [
            m[0] / p[0],
            m[1] / p[1]
        ];
    }
    f.divide = s1;
    function o(m, p) {
        return Math.pow(p[0] - m[0], 2) + Math.pow(p[1] - m[1], 2);
    }
    f.distanceSquared = o;
    function a(m, p) {
        return Math.sqrt(o(m, p));
    }
    f.distance = a;
    function l(m, p) {
        return m[0] * p[0] + m[1] * p[1];
    }
    f.dot = l;
    function c(m, p) {
        return [
            m[0] * p,
            m[1] * p
        ];
    }
    f.scalarMultiply = c;
    function u1(m, p, g) {
        let y = f.sub(p, m), x = f.sub(g, m), v = f.dot(y, x) / f.dot(y, y), b = f.scalarMultiply(y, v);
        return f.add(m, b);
    }
    f.projectionOnto = u1;
    function h(m, p, g) {
        return a(m, u1(m, p, g));
    }
    f.projectionOntoDistance = h;
    function d(m, p) {
        return [
            (m[0] + p[0]) * .5,
            (m[1] + p[1]) * .5
        ];
    }
    f.center = d;
})(ss || (ss = {}));
var ws;
((a)=>{
    function n1(l, c) {
        return l[0] === c[0] && l[1] === c[1] && l[2] === c[2];
    }
    a.isEqual = n1;
    function t(l, c) {
        return [
            l[0] + c[0],
            l[1] + c[1],
            l[2] + c[2]
        ];
    }
    a.add = t;
    function e(l, c) {
        return [
            l[0] - c[0],
            l[1] - c[1],
            l[2] - c[2]
        ];
    }
    a.sub = e;
    function r(l, c) {
        return [
            l[0] / c[0],
            l[1] / c[1],
            l[2] / c[2]
        ];
    }
    a.div = r;
    function i(l, c) {
        return [
            l[0] * c[0],
            l[1] * c[1],
            l[2] * c[2]
        ];
    }
    a.mul = i;
    function s1(l, c) {
        return Math.hypot(l[0] - c[0], l[1] - c[1], l[2] - c[2]);
    }
    a.dist = s1;
    function o(l, c, u1) {
        return [
            l[0] + (c[0] - l[0]) * u1,
            l[1] + (c[1] - l[1]) * u1,
            l[2] + (c[2] - l[2]) * u1
        ];
    }
    a.lerp = o;
})(ws || (ws = {}));
var eu;
((e)=>{
    function n1(r, i) {
        return r[0] === i[0] && r[1] === i[1] && r[2] === i[2] && r[3] === i[3];
    }
    e.isEqual = n1;
    function t(r, i, s1) {
        return [
            r[0] + (i[0] - r[0]) * s1,
            r[1] + (i[1] - r[1]) * s1,
            r[2] + (i[2] - r[2]) * s1,
            r[3] + (i[3] - r[3]) * s1
        ];
    }
    e.lerp = t;
})(eu || (eu = {}));
var mO;
((o)=>{
    let n1 = 180 / Math.PI, t = Math.PI / 180;
    function e(a) {
        return typeof a == "number" ? a * n1 : a;
    }
    function r(a) {
        return typeof a == "number" ? a * t : a;
    }
    function i(a) {
        return [
            e(a[0]),
            e(a[1]),
            e(a[2])
        ];
    }
    o.radToDeg = i;
    function s1(a) {
        return [
            r(a[0]),
            r(a[1]),
            r(a[2])
        ];
    }
    o.degToRad = s1;
})(mO || (mO = {}));
var zl;
((i)=>{
    i.identity = [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
    function t(s1, o) {
        for(let a = 0; a < 16; a++)if (s1[a] !== o[a]) return !1;
        return !0;
    }
    i.isEqual = t;
    function e(s1) {
        return s1 ?? i.identity;
    }
    i.simplify = e;
    function r(s1, o) {
        let a = o.slice(0);
        for(var l = 0, c = o.length; l < c; l += 3){
            let u1 = s1[3] * o[l] + s1[7] * o[l + 1] + s1[11] * o[l + 2] + s1[15];
            a[l] = (s1[0] * o[l] + s1[4] * o[l + 1] + s1[8] * o[l + 2] + s1[12]) / u1, a[l + 1] = (s1[1] * o[l] + s1[5] * o[l + 1] + s1[9] * o[l + 2] + s1[13]) / u1, a[l + 2] = (s1[2] * o[l] + s1[6] * o[l + 1] + s1[10] * o[l + 2] + s1[14]) / u1;
        }
        return a;
    }
    i.applyMatrix4 = r;
})(zl || (zl = {}));
var Fr;
((d)=>{
    function n1(f) {
        return typeof f == "object" && typeof f.r == "number" && typeof f.g == "number" && typeof f.b == "number";
    }
    d.isRGB = n1, d.white = {
        r: 1,
        g: 1,
        b: 1
    }, d.red = {
        r: 1,
        g: 0,
        b: 0
    }, d.black = {
        r: 0,
        g: 0,
        b: 0
    };
    function i(f) {
        return {
            r: Math.round(f.r * 255),
            g: Math.round(f.g * 255),
            b: Math.round(f.b * 255),
            a: 1
        };
    }
    d.toRgb255a1 = i;
    function s1(f) {
        return {
            r: f.r,
            g: f.g,
            b: f.b
        };
    }
    d.clone = s1;
    function o(f) {
        return f = Math.floor(f), {
            r: (f >> 16 & 255) / 255,
            g: (f >> 8 & 255) / 255,
            b: (f & 255) / 255
        };
    }
    d.fromHex = o;
    function a(f) {
        return Math.round(f.r * 255) * 65536 + Math.round(f.g * 255) * 256 + Math.round(f.b * 255);
    }
    d.toHex = a;
    function l(f, m) {
        return f.r === m.r && f.g === m.g && f.b === m.b;
    }
    d.equals = l;
    function c(f, m) {
        return f.r.toFixed(2) === m.r.toFixed(2) && f.g.toFixed(2) === m.g.toFixed(2) && f.b.toFixed(2) === m.b.toFixed(2);
    }
    d.equalsFixed = c;
    function u1(f, m, p) {
        return {
            r: f.r + (m.r - f.r) * p,
            g: f.g + (m.g - f.g) * p,
            b: f.b + (m.b - f.b) * p
        };
    }
    d.lerp = u1;
    function h(f) {
        return kr(f) ? "r" in f && "g" in f && "b" in f && !("a" in f) : !1;
    }
    d.is = h;
})(Fr || (Fr = {}));
var At;
((u1)=>{
    u1.white = {
        ...Fr.white,
        a: 1
    };
    function t(h) {
        return kr(h) ? "r" in h && "g" in h && "b" in h && "a" in h : !1;
    }
    u1.is = t, u1.transparent = {
        ...Fr.white,
        a: 0
    };
    function r(h) {
        return {
            r: h[0],
            g: h[1],
            b: h[2],
            a: h[3]
        };
    }
    u1.from0to1 = r;
    function i(h, d) {
        return {
            ...Fr.fromHex(h),
            a: d
        };
    }
    u1.fromHexAndA = i;
    function s1(h) {
        return {
            r: Math.round(h.r * 255),
            g: Math.round(h.g * 255),
            b: Math.round(h.b * 255),
            a: h.a
        };
    }
    u1.toRgb255a1 = s1;
    function o(h, d) {
        return Fr.equals(h, d) && h.a === d.a;
    }
    u1.equals = o;
    function a(h, d) {
        return Fr.equalsFixed(h, d) && h.a.toFixed(2) === d.a.toFixed(2);
    }
    u1.equalsFixed = a;
    function l(h, d, f) {
        return {
            r: h.r + (d.r - h.r) * f,
            g: h.g + (d.g - h.g) * f,
            b: h.b + (d.b - h.b) * f,
            a: h.a + (d.a - h.a) * f
        };
    }
    u1.lerp = l;
    function c({ r: h, g: d, b: f, a: m } = u1.white) {
        return `rgba(${h * 255}, ${d * 255}, ${f * 255}, ${m})`;
    }
    u1.toStyle = c;
})(At || (At = {}));
var b0;
((t)=>t.identity = {
        position: [
            0,
            0,
            0
        ],
        rotation: [
            0,
            0,
            0
        ],
        scale: [
            1,
            1,
            1
        ],
        pivot: [
            0,
            0,
            0
        ],
        pivotRotation: [
            0,
            0,
            0
        ]
    })(b0 || (b0 = {}));
var cd = ((c)=>(c[c.LINEAR = 0] = "LINEAR", c[c.EASE = 1] = "EASE", c[c.EASE_IN = 2] = "EASE_IN", c[c.EASE_OUT = 3] = "EASE_OUT", c[c.EASE_IN_OUT = 4] = "EASE_IN_OUT", c[c.CUBIC = 5] = "CUBIC", c[c.SPRING = 6] = "SPRING", c[c.ARC = 7] = "ARC", c[c.NONE = 8] = "NONE", c))(cd || {}), ad;
((t)=>t.defaultData = {
        mass: 1,
        stiffness: 80,
        damping: 10,
        velocity: 0
    })(ad || (ad = {}));
var ld;
((t)=>t.defaultData = {
        control1: [
            .5,
            0
        ],
        control2: [
            .5,
            1
        ]
    })(ld || (ld = {}));
var Na;
((s1)=>(s1.linear = [
        0,
        0,
        1,
        1
    ], s1.ease = [
        .25,
        .1,
        .25,
        1
    ], s1.easeIn = [
        .42,
        0,
        1,
        1
    ], s1.easeOut = [
        0,
        0,
        .58,
        1
    ], s1.easeInOut = [
        .42,
        0,
        .58,
        1
    ]))(Na || (Na = {}));
function EA(n1) {
    return typeof n1 == "string" && n1.length === 36 ? /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(n1) : !1;
}
var Ks;
((e)=>{
    e.all = [
        "PerspectiveCamera",
        "OrthographicCamera"
    ];
    function t(r) {
        return e.all.includes(r);
    }
    e.is = t;
})(Ks || (Ks = {}));
var jl;
((i)=>{
    i.DefaultUp = [
        0,
        1,
        0
    ], i.DefaultTargetOffset = 1e3, i.defaultData = {
        far: 1e5,
        type: "OrthographicCamera",
        perspective: {
            near: 70,
            fov: 45,
            zoom: 1
        },
        orthographic: {
            near: -100000,
            zoom: 1
        },
        up: i.DefaultUp,
        isUpVectorFlipped: !1,
        targetOffset: i.DefaultTargetOffset
    };
    function r(s1) {
        return s1.type === "PerspectiveCamera" ? s1.perspective?.zoom ?? 1 : s1.orthographic?.zoom ?? 1;
    }
    i.getZoom = r;
})(jl || (jl = {}));
var Bo;
((r)=>{
    function n1(i, s1 = .1) {
        return {
            disabled: !1,
            type: "linear",
            hideBase: !1,
            count: 3,
            radial: {
                radius: Math.max(typeof i[0] == "number" ? i[0] : 1, typeof i[1] == "number" ? i[1] : 1) * 2,
                start: 0,
                end: 360,
                alignment: !1,
                axis: "y",
                scale: [
                    1,
                    1,
                    1
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                pivot: [
                    0,
                    0,
                    0
                ],
                pivotRotation: [
                    0,
                    0,
                    0
                ]
            },
            toObject: {
                object: "",
                spreadType: "random",
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                axis: "x",
                seed: 0,
                count: 99,
                align: "normal",
                pivot: [
                    0,
                    0,
                    0
                ],
                pivotRotation: [
                    0,
                    0,
                    0
                ]
            },
            linear: {
                scale: [
                    1,
                    1,
                    1
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    (typeof i[0] == "number" ? i[0] + i[0] : 1) * s1,
                    0,
                    0
                ],
                pivot: [
                    0,
                    0,
                    0
                ],
                pivotRotation: [
                    0,
                    0,
                    0
                ]
            },
            grid: {
                count: [
                    2,
                    2,
                    2
                ],
                size: i.map((o)=>(typeof o == "number" ? o : 1) * (1 + s1)),
                useCenter: !0
            },
            randomness: !1,
            randomnessObject: {
                strength: 100,
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                movement: 1,
                seed: 0,
                freqScale: 10,
                noiseType: "perlin"
            }
        };
    }
    r.defaultData = n1;
    function t(i, s1) {
        let o = {
            ...i
        };
        if (TA.forEach((a)=>{
            Object.assign(o, {
                [a]: s1[a] ?? i[a]
            });
        }), o.radial = {
            ...i.radial
        }, s1.radial) {
            let a = i.radial, l = s1.radial;
            w0.forEach((c)=>{
                Object.assign(o.radial, {
                    [c]: l[c] ?? a[c]
                });
            });
        }
        if (o.linear = {
            ...i.linear
        }, s1.linear) {
            let a = i.linear, l = s1.linear;
            A0.forEach((c)=>{
                Object.assign(o.linear, {
                    [c]: l[c] ?? a[c]
                });
            });
        }
        if (o.grid = {
            ...i.grid
        }, s1.grid) {
            let a = i.grid, l = s1.grid;
            E0.forEach((c)=>{
                Object.assign(o.grid, {
                    [c]: l[c] ?? a[c]
                });
            });
        }
        if (o.toObject = {
            ...i.toObject
        }, s1.toObject) {
            let a = i.toObject, l = s1.toObject;
            T0.forEach((c)=>{
                Object.assign(o.toObject, {
                    [c]: l[c] ?? a[c]
                });
            });
        }
        if (o.randomnessObject = {
            ...i.randomnessObject
        }, s1.randomnessObject) {
            let a = i.randomnessObject, l = s1.randomnessObject;
            M0.forEach((c)=>{
                Object.assign(o.randomnessObject, {
                    [c]: l[c] ?? a[c]
                });
            });
        }
        return o;
    }
    r.merge = t;
    function e(i) {
        return !!(i.randomnessObject || i.toObject);
    }
    r.isPartial = e;
})(Bo || (Bo = {}));
var S0;
((r)=>{
    r.defaultData = {
        radial: {},
        linear: {},
        grid: {},
        toObject: {},
        randomnessObject: {}
    };
    let t = [
        "radial",
        "linear",
        "grid",
        "toObject",
        "randomnessObject"
    ];
    function e(i, s1) {
        let o = [];
        i.count !== void 0 && o.push({
            type: 0,
            path: s1,
            props: {
                count: i.count
            }
        });
        for (let a of t){
            let l = i[a];
            l && Object.keys(l).length > 0 && o.push({
                type: 0,
                path: [
                    ...s1,
                    a
                ],
                props: l
            });
        }
        return o;
    }
    r.toOps = e;
})(S0 || (S0 = {}));
var TA = [
    "count"
], w0 = [
    "radius",
    "start",
    "end",
    "position",
    "scale",
    "rotation"
], A0 = [
    "position",
    "scale",
    "rotation"
], E0 = [
    "count",
    "size"
], T0 = [
    "count",
    "position",
    "scale",
    "rotation"
], M0 = [
    "strength",
    "scale",
    "rotation",
    "position",
    "movement",
    "seed",
    "freqScale"
];
var C0;
((e)=>{
    e.all = [
        "PointLight",
        "SpotLight",
        "DirectionalLight",
        "HemisphereLight"
    ];
    function t(r) {
        return e.all.includes(r);
    }
    e.is = t;
})(C0 || (C0 = {}));
var P0;
((e)=>{
    function n1(r) {
        return t(r);
    }
    e.defaultData = n1;
    function t(r) {
        if (r === "PointLight") return {
            type: r,
            color: At.white,
            intensity: 1,
            distance: 2e3,
            decay: 1,
            shadows: !0,
            shadowResolution: 1024,
            shadowRadius: 1,
            penumbraSize: .5,
            depth: 1e5
        };
        if (r === "SpotLight") return {
            type: r,
            color: At.white,
            intensity: 1,
            distance: 2e3,
            decay: 1,
            shadows: !0,
            penumbra: 0,
            angle: 30 / 180 * Math.PI,
            depth: 1e5,
            penumbraSize: .5,
            shadowResolution: 1024,
            shadowRadius: 1
        };
        if (r === "DirectionalLight") return {
            type: r,
            color: At.white,
            intensity: 1,
            shadows: !0,
            size: 2e3,
            depth: 1e5,
            penumbraSize: .5,
            shadowResolution: 1024,
            shadowRadius: 1
        };
        throw new Error("not implemented");
    }
})(P0 || (P0 = {}));
var ud;
((r)=>(r.defaultShapeData = {
        type: "PlaneEmitterShape",
        size: [
            100,
            100,
            100
        ]
    }, r.defaultCollisionData = {
        colliderEntityId: null,
        collisionBounce: .75
    }, r.defaultData = {
        renderMaterial: {
            type: "particleMaterial",
            color: {
                r: 1,
                g: .2,
                b: .545,
                a: 1
            },
            color2: {
                r: .945,
                g: .714,
                b: .184,
                a: 1
            },
            coloring: "gradient",
            ease: "linearFadeOut",
            easeSize: "linearFadeOut",
            transparent: !0,
            size: [
                40,
                40
            ],
            texture: "pt_default_particle",
            spriteRotation: [
                0,
                0
            ]
        },
        birthRatePerSec: 50,
        gravity: 1,
        noiseStrength: 0,
        noiseScale: 0,
        noiseSeed: 1,
        noiseType: "curl",
        randomRotation: 0,
        randomScale: .2,
        randomMass: .5,
        rootObjectType: "instancedMesh",
        life: 1,
        direction: [
            0,
            0,
            0
        ],
        directionMode: "axis",
        speed: 10,
        shape: r.defaultShapeData,
        autoPlay: !0,
        emitTimeDelay: 0,
        emitTimeCycle: "infinity",
        emitTimeDuration: 1,
        ...r.defaultCollisionData
    }))(ud || (ud = {}));
var Hl;
((t)=>t.defaultData = {
        enabled: "visibility",
        fusedBody: !0,
        rigidBody: "positioned",
        density: 1,
        pointMass: 0,
        gravityScale: 1,
        friction: .5,
        damping: 0,
        restitution: .2,
        colliderType: "convex",
        enabledRotation: [
            !0,
            !0,
            !0
        ],
        enabledTranslation: [
            !0,
            !0,
            !0
        ]
    })(Hl || (Hl = {}));
var vO = ((r)=>(r[r.Front = 0] = "Front", r[r.Back = 1] = "Back", r[r.Double = 2] = "Double", r))(vO || {}), MA;
((e)=>{
    e.defaultData = {
        castShadow: !0,
        receiveShadow: !0
    };
    function t(r, i) {
        return r.castShadow === i.castShadow && r.receiveShadow === i.receiveShadow;
    }
    e.equals = t;
})(MA || (MA = {}));
var CA;
((e)=>{
    e.defaultData = {
        flatShading: !1,
        wireframe: !1,
        side: 0
    };
    function t(r, i) {
        return r.flatShading === i.flatShading && r.side === i.side && r.wireframe === i.wireframe;
    }
    e.equals = t;
})(CA || (CA = {}));
var _0;
((t)=>t.defaultData = {
        ...CA.defaultData,
        ...MA.defaultData
    })(_0 || (_0 = {}));
var yO;
((t)=>{
    function n1(e, r) {
        let i = [];
        if ("material" in e) {
            let s1 = typeof e.material == "string" ? r.materials[e.material] ?? r.lib.materials[e.material]?.asset : e.material;
            s1 && i.push(s1);
        } else if ("materials" in e) for (let s1 of e.materials){
            let o = typeof s1 == "string" ? r.materials[s1] ?? r.lib.materials[s1]?.asset : s1;
            o && i.push(o);
        }
        return i;
    }
    t.getMaterialData = n1;
})(yO || (yO = {}));
var hd;
((e)=>(e.defaultVideo = {
        data: "",
        thumb: "/_assets/_videos/catThumb.png",
        type: "video",
        name: "Cat video"
    }, e.maxSize = 3e7))(hd || (hd = {}));
var xO;
((t)=>{
    function n1(e) {
        return e === "texture" || e === "video" || e === "color" || e === "depth" || e === "normal" || e === "gradient" || e === "noise" || e === "fresnel" || e === "rainbow" || e === "toon" || e === "outline" || e === "particle" || e === "transmission" || e === "matcap" || e === "displace" || e === "pattern" || e === "light";
    }
    t.is = n1;
})(xO || (xO = {}));
function SO(n1) {
    return n1.type !== "displace";
}
var bO;
((t)=>{
    function n1(e) {
        return e === "phong" || e === "toon" || e === "lambert" || e === "physical";
    }
    t.is = n1;
})(bO || (bO = {}));
var PA = ((r)=>(r[r.Linear = 0] = "Linear", r[r.Radial = 1] = "Radial", r[r.Polar = 2] = "Polar", r))(PA || {}), I0 = ((r)=>(r[r.RepeatWrapping = 1e3] = "RepeatWrapping", r[r.ClampToEdgeWrapping = 1001] = "ClampToEdgeWrapping", r[r.MirroredRepeatWrapping = 1002] = "MirroredRepeatWrapping", r))(I0 || {}), _A = ((r)=>(r[r.NearestFilter = 1003] = "NearestFilter", r[r.LinearFilter = 1006] = "LinearFilter", r[r.LinearMipmapLinearFilter = 1008] = "LinearMipmapLinearFilter", r))(_A || {}), wO = ((s1)=>(s1[s1.UV = 0] = "UV", s1[s1.Planar = 1] = "Planar", s1[s1.Spherical = 2] = "Spherical", s1[s1.Cylindrical = 3] = "Cylindrical", s1[s1.Triplanar = 4] = "Triplanar", s1))(wO || {}), AO = ((o)=>(o[o.Simplex = 0] = "Simplex", o[o.SimplexFractal = 1] = "SimplexFractal", o[o.Ashima = 2] = "Ashima", o[o.Fbm = 3] = "Fbm", o[o.Perlin = 4] = "Perlin", o[o.Voronoi = 5] = "Voronoi", o))(AO || {}), IA = ((l)=>(l[l.F1 = 0] = "F1", l[l.F2 = 1] = "F2", l[l.F2MinusF1 = 2] = "F2MinusF1", l[l.SmoothBlend = 3] = "SmoothBlend", l[l.Edge = 4] = "Edge", l[l.Power = 5] = "Power", l[l.Lines = 6] = "Lines", l[l.Cells = 7] = "Cells", l))(IA || {}), EO = ((r)=>(r[r.Lights = 0] = "Lights", r[r.Static = 1] = "Static", r[r.Camera = 2] = "Camera", r))(EO || {}), TO = ((l)=>(l[l.Circle = 0] = "Circle", l[l.Ring = 1] = "Ring", l[l.Polygon = 2] = "Polygon", l[l.Cross = 3] = "Cross", l[l.Diamond = 4] = "Diamond", l[l.Checkerboard = 5] = "Checkerboard", l[l.Line = 6] = "Line", l[l.Wave = 7] = "Wave", l))(TO || {}), D0 = [
    "mode",
    "gradientType",
    "noiseType",
    "displacementType",
    "projection",
    "cnormal",
    "crop",
    "axis",
    "side"
], MO = [
    "wrapping",
    "image",
    "video",
    "name",
    "minFilter",
    "magFilter"
], Cr;
((s1)=>{
    function n1(o, a) {
        let { texture: l, ...c } = a;
        if (Object.assign(o, c), l) {
            let u1 = o.texture;
            u1 && Object.assign(u1, l);
        }
    }
    s1.patch = n1;
    function t(o) {
        return {
            ...s1.defaultData("color"),
            color: o
        };
    }
    s1.defaultColorLayer = t;
    function e(o, a) {
        return o === "light" && a ? r(a) : i(o);
    }
    s1.defaultData = e;
    function r(o) {
        let a = {
            mode: 0,
            isMask: !1,
            visible: !0,
            bumpMap: void 0,
            bumpMapIntensity: 5,
            roughnessMap: void 0,
            alphaOverride: 1
        };
        switch(o){
            case "phong":
                return {
                    ...a,
                    category: "phong",
                    specular: {
                        r: .2,
                        g: .2,
                        b: .2
                    },
                    shininess: 5,
                    type: "light",
                    visible: !0,
                    mode: 0,
                    occlusion: !0,
                    alpha: .6
                };
            case "toon":
                return {
                    ...a,
                    category: "toon",
                    specular: {
                        r: .2,
                        g: .2,
                        b: .2
                    },
                    shininess: 10,
                    type: "light",
                    alpha: 1
                };
            case "lambert":
                return {
                    ...a,
                    category: "lambert",
                    emissive: {
                        r: 0,
                        g: 0,
                        b: 0
                    },
                    type: "light",
                    alpha: 1,
                    visible: !0,
                    mode: 0,
                    occlusion: !0
                };
            case "physical":
                return {
                    ...a,
                    category: "physical",
                    roughness: .2,
                    metalness: .2,
                    reflectivity: .2,
                    type: "light",
                    alpha: 1,
                    visible: !0,
                    mode: 0,
                    occlusion: !0
                };
        }
    }
    function i(o) {
        let a = {
            alpha: 1,
            mode: 0,
            isMask: !1,
            visible: !0
        };
        switch(o){
            case "texture":
                return {
                    ...a,
                    type: "texture",
                    size: [
                        128,
                        128
                    ],
                    blending: 0,
                    axis: "x",
                    side: 2,
                    projection: 0,
                    texture: {
                        image: "image_0",
                        wrapping: 1e3,
                        repeat: [
                            1,
                            1
                        ],
                        offset: [
                            0,
                            0
                        ],
                        rotation: 0,
                        minFilter: 1008,
                        magFilter: 1006
                    },
                    crop: !1
                };
            case "video":
                return {
                    ...a,
                    type: "video",
                    size: [
                        128,
                        128
                    ],
                    blending: 0,
                    axis: "x",
                    side: 2,
                    projection: 0,
                    texture: {
                        video: hd.defaultVideo,
                        wrapping: 1001,
                        repeat: [
                            1,
                            1
                        ],
                        offset: [
                            0,
                            0
                        ],
                        rotation: 0,
                        minFilter: 1008,
                        magFilter: 1006
                    },
                    crop: !1
                };
            case "color":
                return {
                    ...a,
                    type: "color",
                    color: Fr.fromHex(ai)
                };
            case "depth":
                return {
                    ...a,
                    type: "depth",
                    gradientType: 1,
                    smooth: !1,
                    isVector: !0,
                    isWorldSpace: !1,
                    origin: [
                        0,
                        0,
                        0
                    ],
                    direction: [
                        1,
                        0,
                        0
                    ],
                    colors: [
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ],
                    steps: [
                        0,
                        1
                    ],
                    near: 50,
                    far: 200
                };
            case "normal":
                return {
                    ...a,
                    type: "normal",
                    cnormal: [
                        1,
                        1,
                        1
                    ]
                };
            case "gradient":
                return {
                    ...a,
                    type: "gradient",
                    gradientType: 0,
                    smooth: !1,
                    colors: [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ]
                    ],
                    steps: [
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    num: 2,
                    angle: 0,
                    offset: [
                        0,
                        0
                    ],
                    morph: [
                        0,
                        0
                    ]
                };
            case "noise":
                return {
                    ...a,
                    type: "noise",
                    size: [
                        100,
                        100,
                        100
                    ],
                    noiseType: 0,
                    scale: 1,
                    move: 1,
                    colorA: {
                        ...Fr.fromHex(6710886),
                        a: 1
                    },
                    colorB: {
                        ...Fr.fromHex(6710886),
                        a: 1
                    },
                    colorC: {
                        ...Fr.fromHex(16777215),
                        a: 1
                    },
                    colorD: {
                        ...Fr.fromHex(16777215),
                        a: 1
                    },
                    distortion: [
                        1,
                        1
                    ],
                    fA: [
                        1.7,
                        9.2
                    ],
                    fB: [
                        8.3,
                        2.8
                    ],
                    voronoiStyle: 0,
                    highCut: 1,
                    lowCut: 0,
                    smoothness: .3,
                    seed: 0,
                    quality: 1
                };
            case "fresnel":
                return {
                    ...a,
                    type: "fresnel",
                    color: At.fromHexAndA(16777215, 1),
                    bias: .1,
                    scale: 1,
                    intensity: 2,
                    factor: 1
                };
            case "rainbow":
                return {
                    ...a,
                    type: "rainbow",
                    filmThickness: 30,
                    movement: 0,
                    wavelengths: [
                        0,
                        0,
                        0
                    ],
                    noiseStrength: 0,
                    noiseScale: 1,
                    offset: [
                        0,
                        0,
                        0
                    ]
                };
            case "toon":
                return {
                    ...a,
                    type: "toon",
                    positioning: 2,
                    colors: [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            .5,
                            .5,
                            .5,
                            1
                        ],
                        [
                            .5,
                            .5,
                            .5,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ]
                    ],
                    steps: [
                        0,
                        .475,
                        .525,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    num: 4,
                    source: [
                        0,
                        1e3,
                        0
                    ],
                    isWorldSpace: !0,
                    noiseStrength: 0,
                    noiseScale: 1,
                    shadowColor: At.fromHexAndA(0, 0),
                    offset: [
                        0,
                        0,
                        0
                    ]
                };
            case "outline":
                return {
                    ...a,
                    type: "outline",
                    outlineColor: At.fromHexAndA(0, 1),
                    contourColor: At.fromHexAndA(0, 1),
                    outlineWidth: 2,
                    contourWidth: 5,
                    outlineThreshold: .4,
                    contourThreshold: 0,
                    outlineSmoothing: 0,
                    contourFrequency: 10,
                    contourDirection: [
                        0,
                        1,
                        0
                    ],
                    positionalLines: !1,
                    compensation: !0
                };
            case "matcap":
                return {
                    ...a,
                    type: "matcap",
                    texture: {
                        image: "matcap_0",
                        wrapping: 1001,
                        repeat: [
                            1,
                            1
                        ],
                        offset: [
                            0,
                            0
                        ],
                        rotation: 0,
                        minFilter: 1008,
                        magFilter: 1006
                    }
                };
            case "transmission":
                return {
                    ...a,
                    type: "transmission",
                    thickness: 10,
                    ior: 1.5,
                    roughness: 1
                };
            case "displace":
                return {
                    visible: !0,
                    type: "displace",
                    displacementType: "noise",
                    noiseType: 0,
                    scale: 10,
                    movement: 1,
                    offset: [
                        0,
                        0,
                        0
                    ],
                    intensity: 8,
                    voronoiStyle: 0,
                    smoothness: .3,
                    seed: 0,
                    highCut: 1,
                    lowCut: 0,
                    quality: 1
                };
            case "pattern":
                return {
                    ...a,
                    type: "pattern",
                    style: 0,
                    projection: 0,
                    axis: "y",
                    blending: 0,
                    offset: [
                        0,
                        0
                    ],
                    colorA: {
                        ...Fr.fromHex(0),
                        a: 1
                    },
                    colorB: {
                        ...Fr.fromHex(16777215),
                        a: 1
                    },
                    frequency: [
                        10,
                        10
                    ],
                    size: .5,
                    variation: 0,
                    smoothness: .5,
                    zigzag: 0,
                    rotation: 0,
                    vertical: [
                        0,
                        1
                    ],
                    horizontal: [
                        0,
                        1
                    ],
                    sides: 6
                };
        }
    }
})(Cr || (Cr = {}));
var Kr;
((u1)=>{
    function n1(h) {
        return !h.layers.some((f)=>f.data.type === "texture" && f.data.projection !== 0 || f.data.type === "depth" && !f.data.isWorldSpace || f.data.type === "noise" || f.data.type === "displace");
    }
    u1.isMergable = n1;
    function t(h) {
        let d = "";
        return h.layers.forEach((f)=>{
            Object.entries(f.data).forEach(([m, p])=>{
                d += `${m}${p}`, Array.isArray(p) ? p.forEach((g)=>d += `${g}`) : typeof p == "object" ? Object.values(p).forEach((g)=>{
                    typeof g == "number" ? d += `${g.toFixed(4)}` : d += `${g}`;
                }) : d += `${p}`;
            });
        }), d;
    }
    u1.getHash = t;
    function e() {
        return {
            layers: new Re
        };
    }
    u1.defaultEmptyData = e;
    function r(h = "layer1", d = "layer2") {
        return s1("phong", h, d);
    }
    u1.defaultData = r;
    function i(h, d) {
        return {
            ...h,
            name: d
        };
    }
    u1.withName = i;
    function s1(h, d = "layer1", f = "layer2", m = Fr.fromHex(16777215)) {
        let p = new Re;
        return p.push({
            fi: 0,
            data: Cr.defaultData("light", h),
            id: d
        }), p.push({
            fi: 1,
            data: Cr.defaultData("color"),
            id: f
        }), {
            layers: p
        };
    }
    u1.defaultTwoLayerData = s1;
    function o(h, d, f = "layer1", m = "layer2") {
        let p = new Re;
        return p.push({
            fi: 0,
            data: Cr.defaultData("light", d),
            id: f
        }), p.push({
            fi: 1,
            data: Cr.defaultColorLayer(h),
            id: m
        }), {
            layers: p
        };
    }
    u1.defaultColorMaterial = o;
    function a(h) {
        let d = Cr.defaultData("texture");
        h && Object.assign(d.texture, {
            image: h
        });
        let f = new Re;
        return f.push({
            fi: 0,
            data: d,
            id: "layer1"
        }), f.push({
            fi: 1,
            data: {
                ...Cr.defaultData("transmission"),
                alpha: 1
            },
            id: "layer2"
        }), f.push({
            fi: 2,
            data: {
                ...Cr.defaultData("light", "lambert"),
                alpha: 0
            },
            id: "layer3"
        }), {
            layers: f
        };
    }
    u1.defaultUIObjectMaterial = a;
    function l(h, d = "phong", f = "layer1", m = "layer2") {
        let p = Cr.defaultData("texture");
        Object.assign(p.texture, {
            image: h
        });
        let g = new Re;
        return g.push({
            fi: 0,
            data: p,
            id: f
        }), g.push({
            fi: 1,
            data: Cr.defaultData("light", d),
            id: m
        }), {
            layers: g
        };
    }
    u1.defaultTwoLayerTextureData = l;
    function c(h, d = "phong", f = "layer1", m = "layer2") {
        let p = Cr.defaultData("video");
        Object.assign(p.texture, {
            video: h
        });
        let g = new Re;
        return g.push({
            fi: 0,
            data: p,
            id: f
        }), g.push({
            fi: 1,
            data: Cr.defaultData("light", d),
            id: m
        }), {
            layers: g
        };
    }
    u1.defaultTwoLayerVideoTextureData = c;
})(Kr || (Kr = {}));
var dd;
((t)=>{
    function n1() {
        return {
            points: new Re,
            roundness: 0,
            shapeHoles: [],
            isClosed: !1
        };
    }
    t.defaultData = n1;
})(dd || (dd = {}));
var fd;
((t)=>{
    function n1() {
        return {
            points: new Re,
            lastInsertionPlane: null,
            subdivisions: 12,
            isClosed: !1,
            subdivisionMode: "parametric"
        };
    }
    t.defaultData = n1;
})(fd || (fd = {}));
var tu = {
    type: "Ellipse",
    width: 50,
    height: 50,
    spikes: 16,
    angle: 360,
    innerRadius: 0
};
var O0;
((t)=>{
    function n1(e, r) {
        let i = {
            ...e
        };
        return L0.forEach((s1)=>{
            Object.assign(i, {
                [s1]: r[s1] ?? e[s1]
            });
        }), i;
    }
    t.merge = n1;
})(O0 || (O0 = {}));
var R0 = {
    shape: tu,
    depth: 1,
    offset: 0,
    bevel: 50,
    bevelSides: 6,
    angle: 0,
    twist: 0,
    startScale: 1,
    endScale: 1,
    capType: "flat"
}, L0 = [
    "depth",
    "offset",
    "angle",
    "twist",
    "startScale",
    "endScale"
];
var xm;
((r)=>{
    function n1(i) {
        return i === "PolygonGeometry" || i === "RectangleGeometry" || i === "StarGeometry" || i === "TriangleGeometry" || i === "EllipseGeometry" || i === "UIGeometry";
    }
    r.is2DParametricMesh = n1;
    function t(i) {
        return i === "PolygonGeometry" || i === "RectangleGeometry" || i === "StarGeometry" || i === "TriangleGeometry" || i === "EllipseGeometry" || i === "PathGeometry" || i === "VectorGeometry" || i === "ConeGeometry" || i === "CubeGeometry" || i === "CylinderGeometry" || i === "DodecahedronGeometry" || i === "HelixGeometry" || i === "IcosahedronGeometry" || i === "LatheGeometry" || i === "PyramidGeometry" || i === "SphereGeometry" || i === "PlaneGeometry" || i === "BackdropGeometry" || i === "TorusGeometry" || i === "TorusKnotGeometry" || i === "BooleanGeometry" || i === "TextGeometry" || i === "InputGeometry";
    }
    r.isParametricMesh = t;
    function e(i) {
        return i === "PolygonGeometry" || i === "RectangleGeometry" || i === "StarGeometry" || i === "TriangleGeometry" || i === "EllipseGeometry" || i === "PathGeometry" || i === "VectorGeometry" || i === "ConeGeometry" || i === "CubeGeometry" || i === "CylinderGeometry" || i === "DodecahedronGeometry" || i === "HelixGeometry" || i === "IcosahedronGeometry" || i === "LatheGeometry" || i === "PyramidGeometry" || i === "SphereGeometry" || i === "PlaneGeometry" || i === "BackdropGeometry" || i === "TorusGeometry" || i === "TorusKnotGeometry" || i === "TextGeometry" || i === "SubdivGeometry" || i === "NonParametricGeometry";
    }
    r.isSwappableGeometry = e;
})(xm || (xm = {}));
var N0;
((t)=>{
    function n1(e, r) {
        let i = {
            ...e
        };
        return Object.assign(i, r), i.type === "PathGeometry" && "extrusion" in r && r.extrusion && (i.extrusion = {
            ...e.extrusion
        }, Object.assign(i.extrusion, O0.merge(i.extrusion, r.extrusion))), i;
    }
    t.merge = n1;
})(N0 || (N0 = {}));
var Fo;
((t)=>{
    function n1(e) {
        if (e === "RectangleGeometry") return {
            width: 320,
            height: 320,
            type: e,
            cornerRadius: [
                0,
                0,
                0,
                0
            ],
            cornerType: 0,
            depth: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        };
        if (e === "UIGeometry") return {
            type: e,
            frame: "",
            cornerRadius: [
                0,
                0,
                0,
                0
            ],
            cornerType: 0,
            width: 1,
            height: 1
        };
        if (e === "PathGeometry") return {
            type: e,
            width: 1,
            height: 1,
            depth: 1,
            path: fd.defaultData(),
            extrusion: R0
        };
        if (e === "VectorGeometry") return {
            width: 1,
            height: 1,
            type: e,
            subdivisions: 12,
            shape: dd.defaultData(),
            depth: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        };
        if (e === "BooleanGeometry") return {
            type: e,
            operation: 2,
            width: 0,
            height: 0,
            depth: 0,
            phongAngle: 35
        };
        if (e === "ShapeBlendGeometry") return {
            type: e,
            width: 0,
            height: 0,
            depth: 0,
            resolutionLevel: 6,
            blendRange: 100,
            useChildrenColors: !1
        };
        if (e === "TextGeometry") return {
            type: e,
            width: 100,
            height: 100,
            depth: 0,
            horizontalAlign: 1,
            verticalAlign: 1,
            fontSize: 16,
            lineHeight: 1.2,
            letterSpacing: 0,
            text: {
                textValue: ""
            },
            textTransform: 1,
            font: "Roboto_regular",
            editable: !1,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        };
        if (e === "InputGeometry") return {
            ...t.defaultData("TextGeometry"),
            type: e,
            editable: !0
        };
        if (e === "SphereGeometry") return {
            type: "SphereGeometry",
            width: 100,
            height: 100,
            depth: 100,
            widthSegments: 64,
            heightSegments: 64,
            phiStart: 0,
            phiLength: 2 * Math.PI,
            thetaStart: 0,
            thetaLength: 180
        };
        throw new Error("not implemented");
    }
    t.defaultData = n1;
})(Fo || (Fo = {}));
var B0 = [
    "width",
    "height",
    "depth"
];
var F0;
((t)=>t.defaultData = {
        enabled: !1,
        useBackgroundColor: !1,
        color: Fr.white,
        near: .1,
        far: 2e3
    })(F0 || (F0 = {}));
var pd;
((e)=>{
    let n1 = {
        opacity: 1,
        blendFunction: 13,
        enabled: !1
    };
    e.defaultData = {
        enabled: !1,
        pixelation: {
            ...n1,
            blendFunction: 16,
            granularity: 15
        },
        bloom: {
            ...n1,
            blendFunction: 16,
            intensity: 1,
            blurScale: 1,
            luminanceThreshold: .25,
            luminanceSmoothing: .025,
            kernelSize: 3
        },
        chromaticAberration: {
            ...n1,
            offset: [
                2,
                2
            ]
        },
        vignette: {
            ...n1,
            darkness: 1,
            offset: 0
        },
        hueSaturation: {
            ...n1,
            hue: 3,
            saturation: 0
        },
        brightnessContrast: {
            ...n1,
            brightness: .25,
            contrast: 0
        },
        depthOfField: {
            ...n1,
            focusDistance: 100,
            focalLength: 20,
            bokehScale: 5
        },
        noise: {
            ...n1,
            blendFunction: 16
        }
    };
})(pd || (pd = {}));
var DA;
((t)=>t.defaultData = {
        softShadowQuality: "low"
    })(DA || (DA = {}));
var OA;
((t)=>t.defaultData = {
        enabled: !0,
        color: {
            r: .8274509803921568,
            g: .8274509803921568,
            b: .8274509803921568
        },
        intensity: .75
    })(OA || (OA = {}));
var RA;
((t)=>t.defaultData = {
        occlusion: !1,
        aoFullRes: !1,
        radius: 256,
        bias: .5,
        aoColor: {
            r: .19607843137254902,
            g: .19607843137254902,
            b: .19607843137254902
        }
    })(RA || (RA = {}));
var Wl;
((t)=>t.defaultData = {
        usePhysics: !1,
        gravity: -10
    })(Wl || (Wl = {}));
var LA;
((t)=>t.defaultData = {
        playCamera: As,
        gameControlObject: null
    })(LA || (LA = {}));
var V0;
((t)=>t.defaultData = {
        backgroundColor: At.fromHexAndA(gO, 1),
        postprocessing: pd.defaultData,
        fog: F0.defaultData,
        globalPhysics: Wl.defaultData,
        ambient: OA.defaultData,
        ao: RA.defaultData,
        shadow: DA.defaultData,
        publish: LA.defaultData
    })(V0 || (V0 = {}));
var U0;
((t)=>t.defaultData = {
        colliderType: "box",
        size: [
            100,
            100,
            100
        ],
        colliderHelperVisible: !0,
        forceType: "collider",
        forceRange: "global",
        forceIntensity: .5,
        forceDambing: .95
    })(U0 || (U0 = {}));
var CO;
((e)=>{
    function n1(r) {
        return r === "Component" || r === "Instance";
    }
    e.isComponentRelated = n1;
    function t(r) {
        return r === "Empty" || r === "Instance";
    }
    e.isEmptyOrComponent = t;
})(CO || (CO = {}));
var md;
((i)=>{
    i.identity = {
        ...b0.identity,
        hiddenMatrix: zl.identity
    };
    function t(s1) {
        return {
            position: s1.position,
            rotation: s1.rotation,
            scale: s1.scale,
            pivot: s1.pivot,
            pivotRotation: s1.pivotRotation,
            hiddenMatrix: s1.hiddenMatrix
        };
    }
    i.fromObject = t;
    function e(s1, o) {
        return {
            position: o?.position || s1.position,
            rotation: o?.rotation || s1.rotation,
            pivot: o?.pivot || s1.pivot,
            pivotRotation: o?.pivotRotation || s1.pivotRotation,
            scale: o?.scale || s1.scale,
            hiddenMatrix: o?.hiddenMatrix || s1.hiddenMatrix
        };
    }
    i.merge = e;
    function r(s1, o) {
        return Hv({
            position: ws.isEqual(s1.position, o.position) ? void 0 : o.position,
            rotation: ws.isEqual(s1.rotation, o.rotation) ? void 0 : o.rotation,
            scale: ws.isEqual(s1.scale, o.scale) ? null : o.scale,
            hiddenMatrix: zl.isEqual(s1.hiddenMatrix, o.hiddenMatrix) ? void 0 : o.hiddenMatrix
        });
    }
    i.diff = r;
})(md || (md = {}));
var DO = [
    "slide",
    "offset"
], li;
((t)=>t.defaultData = {
        states: new Re,
        events: new Re,
        timelineAnimations: new He,
        visible: !0,
        raycastLock: !1,
        physics: Hl.defaultData,
        pathSnapping: {
            pathId: null,
            slide: 0,
            offset: 0,
            orientation: "tangential"
        },
        ...md.identity,
        cloner: null
    })(li || (li = {}));
var k0;
((t)=>t.defaultData = {
        type: "Empty",
        ...li.defaultData
    })(k0 || (k0 = {}));
var PO;
((t)=>t.defaultData = {
        type: "ParticleCollider",
        ...U0.defaultData,
        ...li.defaultData
    })(PO || (PO = {}));
var _O;
((t)=>t.defaultData = {
        type: "Component",
        ...li.defaultData
    })(_O || (_O = {}));
var IO;
((t)=>t.defaultData = {
        type: "Particle",
        ...li.defaultData,
        ...ud.defaultData
    })(IO || (IO = {}));
var Ba;
((t)=>t.defaultData = {
        type: "Mesh",
        ...li.defaultData,
        ..._0.defaultData
    })(Ba || (Ba = {}));
var ru;
((t)=>t.defaultData = {
        ...li.defaultData,
        ...md.identity,
        position: [
            0,
            0,
            jl.DefaultTargetOffset
        ],
        ...jl.defaultData
    })(ru || (ru = {}));
var z0;
((e)=>{
    function n1(r) {
        return {
            ...li.defaultData,
            ...P0.defaultData(r)
        };
    }
    e.defaultData = n1, e.defaultDirectionalLightData = {
        ...e.defaultData("DirectionalLight"),
        position: [
            200,
            300,
            300
        ],
        name: "Directional Light",
        intensity: .7
    };
})(z0 || (z0 = {}));
var gd;
((e)=>{
    function n1(r, i, s1 = 0) {
        for(; s1 < i.length;){
            let o = r ? r[i[s1]] : void 0;
            if (i.length === s1 + 1) return o;
            if (o) r = o.descendants, s1 += 1;
            else return;
        }
    }
    e.resolveWithDes = n1;
    function t(r, i, s1 = 0) {
        let o = n1(r, i, s1);
        if (o) {
            let a = Object.keys(o);
            if (a.length === 1 && a[0] === "descendants") return;
        }
        return o;
    }
    e.resolve = t;
})(gd || (gd = {}));
var Vo;
((s1)=>{
    s1.rootOverrideProps = [
        "physics",
        "events"
    ], s1.compositeNonOptionalOverrideProps = [
        "geometry"
    ], s1.compositeEntireOverrideOverrideProps = [
        "material"
    ];
    function r(o, a) {
        return {
            ...li.defaultData,
            ...a,
            component: o,
            overrides: new lr,
            physics: void 0,
            events: void 0,
            type: "Instance"
        };
    }
    s1.ofComponent = r;
    function i(o) {
        let a = md.fromObject(o.data);
        return r(o.id, a);
    }
    s1.fromComponentData = i;
})(Vo || (Vo = {}));
var Fa;
((e)=>{
    e.defaultData = {
        type: "Page",
        ...li.defaultData,
        physics: {
            ...Hl.defaultData,
            fusedBody: !1
        },
        ...V0.defaultData,
        camera: ru.defaultData
    };
    function t(r) {
        return r.uiScene !== void 0;
    }
    e.isUIPage = t;
})(Fa || (Fa = {}));
var G0;
((a)=>(a.defaultCamera = {
        position: [
            0,
            0,
            1e3
        ],
        scale: [
            1,
            1,
            1
        ],
        rotation: [
            0,
            0,
            0
        ],
        pivot: [
            0,
            0,
            0
        ],
        pivotRotation: [
            0,
            0,
            0
        ],
        hiddenMatrix: zl.identity,
        name: "Play Camera",
        visible: !0,
        raycastLock: !1,
        physics: Hl.defaultData,
        states: new Re,
        events: new Re,
        timelineAnimations: new He,
        cloner: null,
        pathSnapping: {
            pathId: null,
            orientation: "tangential",
            slide: 0,
            offset: 0
        },
        ...jl.defaultData
    }, a.KeysByResetCategory = {
        States: [
            "states"
        ],
        Events: [
            "events"
        ],
        Material: [
            "material",
            "materials"
        ],
        Geometry: [
            "geometry"
        ],
        Position: [
            "position"
        ],
        Rotation: [
            "rotation"
        ],
        Scale: [
            "scale"
        ],
        Transform: [
            "position",
            "scale",
            "rotation",
            "hiddenMatrix"
        ],
        Name: [
            "name"
        ],
        Visibility: [
            "visible",
            "raycastLock",
            "flatShading",
            "wireframe",
            "side"
        ],
        Shadows: [
            "castShadow",
            "receiveShadow"
        ],
        Cloner: [
            "cloner"
        ],
        Physics: [
            "physics"
        ]
    }, a.defaultMeshObject = {
        name: "Rectangle",
        ...li.defaultData,
        ...Ba.defaultData,
        geometry: Fo.defaultData("RectangleGeometry"),
        material: Kr.defaultTwoLayerData("phong", "layer1", "layer2")
    }, a.defaultBooleanObject = {
        name: "Boolean",
        ...li.defaultData,
        ...Ba.defaultData,
        geometry: Fo.defaultData("BooleanGeometry"),
        material: Kr.defaultTwoLayerData("phong", "layer1", "layer2")
    }, a.defaultShapeBlendObject = {
        name: "Shape Blend",
        ...li.defaultData,
        ...Ba.defaultData,
        geometry: Fo.defaultData("ShapeBlendGeometry"),
        material: Kr.defaultTwoLayerData("phong", "layer1", "layer2")
    }, a.defaultTextObject = {
        name: "Text",
        ...li.defaultData,
        ...Ba.defaultData,
        geometry: Fo.defaultData("TextGeometry"),
        material: Kr.defaultTwoLayerData("phong", "layer1", "layer2")
    }, a.defaultInputObject = {
        name: "Input",
        ...li.defaultData,
        ...Ba.defaultData,
        geometry: Fo.defaultData("InputGeometry"),
        material: Kr.defaultTwoLayerData("phong", "layer1", "layer2")
    }))(G0 || (G0 = {}));
var Qs;
((i)=>{
    function n1(s1, o) {
        let a = {
            name: o
        };
        return s1.type === "Mesh" ? (a.geometry = {}, "material" in s1 && (a.material = {
            layers: new lr
        }), "materials" in s1 && (a.materials = s1.materials.map((l)=>({
                layers: new lr
            })))) : Ks.is(s1.type) && (a.perspective = {}, a.orthographic = {}), a;
    }
    i.newEmpty = n1;
    function t(s1, o) {
        if (o === void 0) return s1;
        let a = {
            ...s1
        };
        return "material" in a && "material" in o && o.material && (a.material = Fl(a.material, (l)=>{
            if (typeof l != "string") for (let [c, u1] of Object.entries(o.material.layers)){
                let h = l.layers.data(c);
                h && Cr.patch(h, u1);
            }
        }).data), a.materials && o.materials && (a.materials = Fl(a.materials, (l)=>{
            for(let c = 0; c < a.materials.length; c++){
                let u1 = o.materials[c];
                if (typeof u1 != "string") for (let [h, d] of Object.entries(u1.layers)){
                    let f = l[c]?.layers?.data(h);
                    f && Cr.patch(f, d);
                }
            }
        }).data), a;
    }
    function e(s1, o) {
        let a, l = [], c = {
            orthographic: 0,
            perspective: 0,
            geometry: 0
        };
        function u1(h, d) {
            for (let [f, m] of Object.entries(d.layers)){
                let { texture: p, ...g } = m;
                if (p !== void 0 && Object.keys(p).length > 0) {
                    let y = {
                        path: [
                            ...h,
                            "layers",
                            f,
                            "texture"
                        ],
                        props: p,
                        type: 0
                    };
                    l.push(y);
                }
                if (Object.keys(g).length > 0) {
                    let y = {
                        path: [
                            ...h,
                            "layers",
                            f
                        ],
                        props: g,
                        type: 0
                    };
                    l.push(y);
                }
            }
        }
        for (let [h, d] of Object.entries(o))if (h !== "name") {
            if (h === "cloner") l.push(...S0.toOps(d, [
                "cloner"
            ]));
            else if (h === "pathSnapping") l.push({
                path: [
                    h
                ],
                props: {
                    slide: d.slide,
                    offset: d.offset
                },
                type: 0
            });
            else if (h === "material") u1([
                "material"
            ], d);
            else if (h === "materials") for (let [f, m] of Object.entries(d))u1([
                "materials",
                f
            ], m);
            else if (c[h] === 0) {
                if (h === "geometry" && d.extrusion !== void 0) {
                    let f = {
                        path: [
                            h,
                            "extrusion"
                        ],
                        props: d.extrusion,
                        type: 0
                    };
                    l.push(f), d = {
                        ...d
                    }, delete d.extrusion;
                }
                if (Object.keys(d).length > 0) {
                    let f = {
                        path: [
                            h
                        ],
                        props: d,
                        type: 0
                    };
                    l.push(f);
                }
            } else a === void 0 && (a = {
                path: [],
                props: {},
                type: 0
            }, l.push(a)), a.props[h] = d;
        }
        return l;
    }
    i.toOps = e;
    function r(s1, o) {
        if (o === void 0) return s1;
        let a = {
            ...s1
        };
        if (Object.assign(a, md.merge(a, o)), Object.assign(a, {
            pathSnapping: Object.assign({}, a.pathSnapping, {
                slide: o.pathSnapping?.slide ?? a.pathSnapping?.slide ?? 0,
                offset: o.pathSnapping?.offset ?? a.pathSnapping?.offset ?? 0
            })
        }), Ks.is(s1.type)) {
            a.orthographic = {
                ...a.orthographic
            }, a.perspective = {
                ...a.perspective
            };
            let l = o;
            l.orthographic?.zoom !== void 0 && (a.orthographic.zoom = l.orthographic.zoom), l.perspective?.zoom !== void 0 && (a.perspective.zoom = l.perspective.zoom), l.isUpVectorFlipped !== void 0 && (a.isUpVectorFlipped = l.isUpVectorFlipped), l.targetOffset !== void 0 && (a.targetOffset = l.targetOffset);
        } else if (s1.type === "Mesh") "geometry" in o && Object.assign(a, {
            geometry: N0.merge(a.geometry, o.geometry)
        }), (o.material || o.materials) && (a = t(a, o)), a.cloner && "cloner" in o && Object.assign(a, {
            cloner: Bo.merge(a.cloner, o.cloner)
        });
        else if (s1.type === "Empty") a.cloner && "cloner" in o && Object.assign(a, {
            cloner: Bo.merge(a.cloner, o.cloner)
        });
        else if (C0.is(s1.type)) {
            let l = o;
            l.intensity !== void 0 && (a.intensity = l.intensity), l.color !== void 0 && (typeof l.color == "string" ? a.color = l.color : a.color = Fr.clone(l.color));
        }
        return a;
    }
    i.patch = r;
})(Qs || (Qs = {}));
var yd;
((t)=>t.defaultData = {
        enablePan: !0,
        enableZoom: !0,
        enableRotate: !0,
        enableDamping: !0,
        rotationLimitsMode: 0,
        rotationVerticalOffset: {
            min: Math.PI / 4,
            max: Math.PI / 4
        },
        rotationHorizontalOffset: {
            min: Math.PI / 4,
            max: Math.PI / 4
        },
        rotationSoftLimit: 2,
        rotationSpeed: 1,
        panLimitsMode: 0,
        panVerticalOffset: {
            min: 250,
            max: 250
        },
        panHorizontalOffset: {
            min: 250,
            max: 250
        },
        panSoftLimit: 2,
        zoomLimitsEnabled: !1,
        zoomLimits: {
            min: .1,
            max: 2
        },
        autoRotate: !1,
        autoRotateSpeed: 2,
        autoRotateClockwise: !0,
        hoverRotatePanMode: 0,
        hoverRotatePanStrength: 20,
        hoverRotateDamping: .125,
        isTouchZoom: !0,
        orbitTouches: 2,
        panTouches: 3,
        resetHoverEffectOnPointerLeave: !0
    })(yd || (yd = {}));
var Es;
((t)=>t.defaultData = {
        orbitControls: yd.defaultData,
        playPage: Gl,
        withBackground: !0,
        preventScroll: !1,
        preventTouchScroll: !1,
        hideCursor: !1,
        mouseEventTarget: "canvas",
        joystickSizeAndXYOffset: Array(12).fill(0).map((e, r)=>{
            let i = 0, s1 = 0;
            return r < 5 ? s1 = -30 : r < 10 && (s1 = 30), r === 0 || r === 10 || r === 5 ? i = 30 : (r === 4 || r === 11 || r === 9) && (i = -30), [
                120,
                [
                    i,
                    s1
                ],
                "show"
            ];
        }),
        settings: {
            image: {
                format: "jpg",
                ratio: 1,
                colorSpace: "display-p3"
            },
            videoStatic: {
                fps: 60,
                mbps: 150,
                ratio: 1,
                duration: 1e3,
                format: "mp4",
                imageFormat: "jpg",
                activeTimeline: null,
                colorSpace: "display-p3"
            },
            web: {
                logo: !0,
                compress: !0,
                preset: 1,
                preload: !0,
                hint: !1,
                imageQuality: 70,
                pixelRatioMobile: 0,
                pixelRatioDesktop: 0
            }
        },
        stopRaycast: !0,
        hdTransmission: !1
    })(Es || (Es = {}));
var NA;
((t)=>t.defaultData = {
        id: "basic",
        label: "Basic",
        style: "None",
        prompt: ""
    })(NA || (NA = {}));
var BA;
((t)=>t.defaultData = {
        weather: 0,
        shadows: 0,
        lightOrigin: 0,
        temperature: 0,
        sun: 0,
        camera: 0,
        environment: 0,
        particles: 0,
        nature: 0,
        floor: 0
    })(BA || (BA = {}));
var Va;
((e)=>(e.defaultData = ()=>({
            mode: "line-art-both",
            prompt: "",
            negativePrompt: "",
            style: {
                ...NA.defaultData
            },
            isRandomSeed: !0,
            seed: e.generateSeed(),
            guessMode: !1,
            advanced: !1,
            steps: 20,
            guidanceScale: 7.5,
            controlNetScale: 1,
            modifiers: BA.defaultData
        }), e.generateSeed = ()=>Math.round(Math.random() * 1e5)))(Va || (Va = {}));
var ql;
((e)=>{
    function n1(r) {
        return r.find((i)=>i.data.type === "Page" && i.data.globalPhysics.usePhysics) !== void 0;
    }
    e.physicsEnabled = n1;
    function t(r, i, s1) {
        r.scene.objects.traverseFrom(i, (o, a)=>{
            if (a.type === "Instance") {
                let l = Uo.getComponentData(r, a.component)?.data;
                l && s1(o, a, l.events);
            } else s1(o, a, a.events);
        });
    }
    e.traverseModuleInstances = t;
})(ql || (ql = {}));
var Ua;
((c)=>{
    c.TRASH_CAN_ID = "830a2708-8ed9-49cf-a68e-085299892222", c.defaultLight = {
        fi: -1,
        data: z0.defaultDirectionalLightData,
        id: "830a2708-8ed9-49cf-a68e-085299899103",
        children: []
    };
    function e(u1 = !0, h = []) {
        let d = [], f = G0.defaultMeshObject;
        u1 && (d.push({
            ...c.defaultLight
        }), d.push({
            fi: 1,
            id: "7ba78968-2a55-48f2-b14c-5191da3e075e",
            data: f,
            children: []
        })), d.push(...h);
        let m = new wr;
        return m.push({
            fi: 1,
            id: Gl,
            data: {
                ...Fa.defaultData,
                name: "Scene 1"
            },
            children: d
        }), m;
    }
    c.createDefaultObjectTreeWithPage = e, c.defaultData = {
        objects: e(),
        publish: Es.defaultData,
        styles: Va.defaultData()
    }, c.emptyDataWithoutPage = function() {
        return {
            objects: new wr,
            publish: Es.defaultData,
            styles: Va.defaultData()
        };
    }, c.emptyDataWithPage = function(u1 = !0) {
        return {
            objects: e(u1),
            publish: Es.defaultData,
            styles: Va.defaultData()
        };
    }, c.emptyData = function() {
        return {
            objects: new wr,
            publish: {
                ...Es.defaultData
            },
            styles: Va.defaultData()
        };
    };
    function a(u1) {
        return {
            ...c.defaultData,
            objects: Ri(u1, wr.prototype)
        };
    }
    c.withObjs = a;
    function l(u1, h) {
        return a([
            {
                id: u1,
                data: h,
                children: [],
                fi: 0
            }
        ]);
    }
    c.withObj = l;
})(Ua || (Ua = {}));
var vd;
((t)=>t.defaultData = {
        preset: "fullscreen",
        allowResponsive: !1,
        size: [
            512,
            512
        ],
        coords: [
            0,
            0
        ],
        sceneScale: 1,
        color: {
            r: 0,
            g: 0,
            b: 0,
            a: .5
        }
    })(vd || (vd = {}));
var j0;
((e)=>(e.defaultData = (r)=>({
            url: r,
            name: "New Webhook",
            parametersSchemas: new Re
        }), e.defaultParameterValueByType = (r)=>r === "number" ? 0 : r === "boolean" ? !1 : ""))(j0 || (j0 = {}));
var OO;
((t)=>t.defaultData = (e, r = "GET")=>({
            url: e,
            method: r,
            name: "New API",
            headers: new Re,
            queries: new Re,
            autoStart: !0
        }))(OO || (OO = {}));
var Gr;
((s1)=>{
    function n1(o) {
        return o.textValue !== void 0;
    }
    s1.isTextValue = n1;
    function t(o) {
        return typeof o == "number";
    }
    s1.isNumber = t;
    function e(o) {
        return typeof o == "boolean";
    }
    s1.isBoolean = e;
    function r(o) {
        return n1(o) ? "string" : e(o) ? "boolean" : "number";
    }
    s1.typeOfVariable = r;
    function i(o) {
        return s1.isTextValue(o) ? Array.isArray(o.textValue) ? o.textValue.map((a)=>a.toString().padStart(o.padding ?? 2, "0")).join(o.deliminator ?? ":") + (o.suffix !== void 0 ? " " + o.suffix : "") : o.textValue.toString() : s1.isBoolean(o) ? o ? "True" : "False" : s1.isNumber(o) ? parseFloat(o.toFixed(3)).toString() : o.toString();
    }
    s1.getDisplayedValue = i;
})(Gr || (Gr = {}));
var FA;
((t)=>t.all = [
        "images",
        "videos",
        "colors",
        "audios",
        "particles",
        "fonts",
        "materials",
        "variables"
    ])(FA || (FA = {}));
var RO;
((t)=>t.all = [
        ...FA.all,
        "components"
    ])(RO || (RO = {}));
var LO;
((t)=>{
    function n1() {
        return {
            images: new He,
            videos: new He,
            colors: new He,
            audios: new He,
            particles: new He,
            fonts: new He,
            materials: new He,
            components: new He,
            variables: new He,
            userAPIs: new He,
            userWebhooks: new He,
            timelineAnimations: new He
        };
    }
    t.defaultData = n1;
})(LO || (LO = {}));
var Zs;
((t)=>{
    function n1() {
        return {
            images: new He,
            videos: new He,
            colors: new He,
            audios: new He,
            particles: new He,
            fonts: new He,
            materials: new He,
            components: new He,
            variables: new He,
            userAPIs: new He,
            userWebhooks: new He,
            timelineAnimations: new He
        };
    }
    t.defaultData = n1;
})(Zs || (Zs = {}));
var An;
((s1)=>{
    function n1() {
        let o = {};
        return o["89b10010-844c-11ec-a8a3-0242ac120002"] = {
            r: .5,
            g: .5,
            b: .5,
            a: 1,
            name: "Default Color"
        }, Ri(o, He.prototype);
    }
    s1.defaultColors = n1;
    function t() {
        return Ri({}, He.prototype);
    }
    s1.defaultImages = t;
    function e() {
        return {
            catelogs: new He,
            materials: new He,
            images: new He,
            videos: new He,
            colors: new He,
            timelineAnimations: new He,
            audios: new He,
            particles: new He,
            fonts: new He,
            variables: new Re,
            userAPIs: new He,
            userWebhooks: new He,
            lib: Zs.defaultData()
        };
    }
    s1.emptyData = e;
    function r(o) {
        switch(o){
            case "number":
                return {
                    value: 0,
                    name: "Number"
                };
            case "boolean":
                return {
                    value: !1,
                    name: "Boolean"
                };
            case "string":
                return {
                    value: {
                        textValue: "String value"
                    },
                    name: "String"
                };
            case "time":
                let a = [
                    0,
                    0,
                    0
                ];
                return {
                    name: "Time",
                    value: {
                        textValue: a,
                        deliminator: ":",
                        padding: 2,
                        suffix: "AM"
                    },
                    dynamicVariableType: "time",
                    format: "HH:mm:ss",
                    format12h24h: "12ampm",
                    timeZone: null,
                    hasEnd: !1,
                    endValue: {
                        textValue: a,
                        deliminator: ":",
                        padding: 2,
                        suffix: "AM"
                    },
                    autoStart: !0,
                    repeat: !1
                };
            case "counter":
                return {
                    name: "Counter",
                    value: 0,
                    dynamicVariableType: "counter",
                    updateInterval: 1e3,
                    increment: 1,
                    autoStart: !0,
                    hasEnd: !0,
                    endValue: 60,
                    repeat: !0,
                    randomStart: !1,
                    range: [
                        0,
                        100
                    ],
                    decimals: 0
                };
            case "random":
                return {
                    name: "Random",
                    value: 0,
                    dynamicVariableType: "random",
                    updateInterval: 1e3,
                    increment: 1,
                    autoStart: !0,
                    isStatic: !1,
                    hasEnd: !0,
                    endValue: 60,
                    repeat: !0,
                    min: 0,
                    max: 100,
                    decimals: 0
                };
            default:
                console.error("Unknown variable type", o);
        }
    }
    s1.defaultVariables = r;
    function i(o, a) {
        if (a.format === "HH:mm:ss") {
            let l = Math.floor(o / 3600), c = Math.floor((o - l * 3600) / 60), u1 = Math.round(o - l * 3600 - c * 60);
            return {
                textValue: [
                    l,
                    c,
                    u1
                ]
            };
        } else if (a.format === "mm:ss") {
            let l = Math.floor(o / 60), c = Math.round(o - l * 60);
            return {
                textValue: [
                    l,
                    c
                ]
            };
        } else return a.format === "number" ? o = Math.round(o) : o = Math.round(o * 1e3) / 1e3, o;
    }
    s1.getFormattedTimerTime = i;
})(An || (An = {}));
var xd;
((t)=>t.list = [
        "idle",
        "move",
        "jump",
        "run"
    ])(xd || (xd = {}));
var bd;
((e)=>(e.defaultColliderData = {
        type: "capsule",
        height: 200,
        radius: 50,
        position: [
            0,
            0,
            0
        ],
        rotation: [
            0,
            0,
            0
        ]
    }, e.defaultDataThirdPerson = {
        moveMode: "walk",
        forwardDirection: "+z",
        speedTranslate: 1e3,
        speedRotate: 100,
        runMultiplier: 2,
        rotationMode: "normal",
        rotBy: "keys",
        rotByTouch: "drag",
        delayPos: [
            .3,
            .3
        ],
        delayRot: [
            .3,
            .3
        ],
        keyAssignments: [
            [
                "moveNegZ",
                "W"
            ],
            [
                "moveNegX",
                "A"
            ],
            [
                "movePosZ",
                "S"
            ],
            [
                "movePosX",
                "D"
            ],
            [
                "rotPosX",
                "\u25B2"
            ],
            [
                "rotPosY",
                "\u25C0"
            ],
            [
                "rotNegX",
                "\u25BC"
            ],
            [
                "rotNegY",
                "\u25B6"
            ],
            [
                "jump",
                "Space"
            ],
            [
                "run",
                "\u21E7"
            ],
            [
                "none",
                "Ctrl"
            ]
        ],
        touchControl: !0,
        joystickPosLoc: 5,
        joystickRotLoc: 11,
        jumpTouchButtonLoc: 9,
        collider: e.defaultColliderData,
        colliderHelperVisible: !0,
        collisionEnabled: !0,
        jumpPower: 100,
        resetYPosition: 3e3,
        alignToGround: !1,
        autoOrientMove: !0,
        orientWith: "camera",
        orientMode: "radial",
        delayPosCamera: .3,
        delayRotCamera: .3,
        camera: "",
        cameraXAxis: "Limit",
        cameraYAxis: "Free",
        cameraRotXLimits: [
            0,
            Math.PI / 2
        ],
        cameraRotYLimits: [
            -Math.PI / 2,
            Math.PI / 2
        ],
        gameActions: {
            idle: new Re,
            move: new Re,
            jump: new Re,
            run: new Re
        },
        navmesh: {
            enabled: !1,
            ch: 6,
            cs: 6,
            walkableClimb: 5,
            walkableHeight: 1,
            walkableRadius: 0,
            zones: "all",
            objects: [],
            helperVisible: !0,
            destinationHelperRadius: 0,
            destinationHelperColor: At.fromHexAndA(3728051, 1)
        }
    }))(bd || (bd = {}));
function NO(n1) {
    n1.layers.forEach((t)=>{
        if (t.type === "depth" && t.colorA !== void 0) {
            let e = t.colorA, r = t.colorB, i = [
                [
                    e.r,
                    e.g,
                    e.b,
                    e.a
                ],
                [
                    r.r,
                    r.g,
                    r.b,
                    r.a
                ]
            ], s1 = [
                0,
                1
            ];
            for(let a = 2; a < 10; a++)i.push(i[1]), s1.push(1);
            let o = {
                ...Nn(Yr(t), "type", "visible", "isVector", "isWorldSpace", "origin", "alpha", "mode"),
                near: Math.max(0, t.near),
                far: Math.max(0, t.far),
                colors: i,
                steps: s1,
                num: 2,
                direction: [
                    1,
                    0,
                    0
                ],
                smooth: !1,
                gradientType: 1
            };
            Object.assign(t, o);
        } else if (t.type === "depth" && t.gradientType === 1 && (t.near < 0 || t.far < 0)) {
            let e = {
                ...Yr(t),
                near: Math.max(t.near, 0),
                far: Math.max(t.far, 0)
            };
            Object.assign(t, e);
        }
    });
}
function ka(n1, t) {
    Object.values(n1.shared.materials).forEach((e)=>t(e));
}
function za(n1, t) {
    n1.scene.objects.traverse((e, r)=>{
        "materials" in r ? r.materials.forEach((i, s1)=>{
            i === void 0 && (r.materials[s1] = Kr.defaultData(), i = r.materials[s1]), typeof i != "string" && t(i);
        }) : "material" in r ? typeof r.material != "string" && (r.material === void 0 && (r.material = Kr.defaultData()), t(r.material)) : r.type === "Mesh" && (r.material === void 0 && (r.material = Kr.defaultData()), t(r.material)), "overrides" in r && Object.values(r.overrides).forEach((i)=>{
            i.material && typeof i.material != "string" && Object.getPrototypeOf(i.material) !== lr.prototype && t(i.material);
        });
    });
}
function mX(n1) {
    Object.assign(n1.scene.publish, {
        orbitControls: {
            ...yd.defaultData,
            ...Yr(n1.scene.publish.orbitControls)
        }
    });
}
function gX(n1) {
    Object.assign(n1.scene.publish.settings, {
        video: {
            ...Es.defaultData.settings.video,
            ...Yr(n1.scene.publish.settings.video)
        }
    });
}
function yX(n1) {
    function t(e) {
        if (e.layers) {
            for (let r of Object.values(e.layers))if (r) {
                for (let [i, s1] of Object.entries(r))if ((D0.includes(i) || typeof s1 == "boolean") && delete r[i], i === "texture") for (let [o, a] of Object.entries(s1))(MO.includes(o) || typeof a == "boolean") && delete s1[o];
            }
        }
    }
    n1.scene.objects.traverse((e, r)=>{
        r.states.forEach((i)=>{
            let s1 = i;
            s1.material ? t(s1.material) : s1.materials && s1.materials.forEach((o)=>{
                t(o);
            });
        });
    });
}
function vX(n1) {
    n1.scene.publish.withBackground = !0;
}
function xX(n1) {
    n1.scene.publish.settings.web = {
        compress: !0,
        preload: !0,
        preset: 1,
        logo: !0,
        hint: !1
    };
}
function bX(n1) {
    n1.scene.objects.traverse((t, e)=>{
        let r = e.cloner;
        r && (r.radial.scale = r.radial.scale.map((i)=>i + 1), r.linear.scale = r.linear.scale.map((i)=>i + 1));
    });
}
function SX(n1) {
    n1.scene.objects.traverse((t, e)=>{
        let r = e.geometry;
        r && (r.type === "DodecahedronGeometry" || r.type === "IcosahedronGeometry") && (r.detail = Math.round(r.detail));
    });
}
function wX(n1) {
    n1.scene.objects.traverse((t, e)=>{
        let r = n1.scene.objects.unproxy().parent(t);
        if (r) {
            let i = Yr(n1.scene.objects.data(r));
            i && i.type === "Mesh" && i.geometry.type === "BooleanGeometry" && e.type === "Mesh" && (e.visible = Yr(e).booleanExclude !== !0);
        }
    });
}
function AX(n1) {
    n1.scene.objects.traverse((t, e)=>{
        if (e.type === "Mesh") {
            let r = e;
            e.geometry.type === "NonParametricGeometry" ? r.material !== void 0 && delete r.material : r.materials !== void 0 && delete r.materials;
        }
    });
}
function EX(n1) {
    function t(r) {
        Object.setPrototypeOf(r, lr.prototype), r.texture && Object.setPrototypeOf(r.texture, lr.prototype);
    }
    function e(r) {
        Object.setPrototypeOf(r, lr.prototype);
        for(let i in r)t(r[i]);
    }
    n1.scene.objects.traverse((r, i)=>{
        i.states.forEach((s1)=>{
            let o = s1;
            if (o.material) {
                let a = Yr(o.material).layers;
                e(a), o.material.layers = a;
            }
            if (o.materials) for(let a = 0; a < o.materials.length; a++){
                let l = o.materials[a], c = Yr(l).layers;
                e(c), l.layers = c;
            }
        });
    });
}
function BO(n1) {
    n1.layers === void 0 && Object.assign(n1, Kr.defaultTwoLayerData("lambert"));
}
function VA(n1) {
    !n1.layers || n1.layers.forEach((t)=>{
        if (t.type === "depth" && t.colors.length === 10) {
            let e = [
                ...t.colors
            ];
            e.push(t.colors[9]);
            let r = [
                ...t.steps
            ];
            r.push(t.steps[9]);
            let i = {
                ...Yr(t),
                colors: e,
                steps: r
            };
            Object.assign(t, i);
        }
    });
}
function TX(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.type === "Mesh" && (e.geometry.type === "BooleanGeometry" || e.geometry.type === "SubdivGeometry") && (e.geometry.phongAngle = 35);
    });
}
function FO(n1) {
    n1.scene.objects.traverse((t, e)=>{
        "materials" in e ? e.materials.forEach((r)=>{
            typeof r != "string" && VA(r);
        }) : "material" in e && typeof e.material != "string" && VA(e.material);
    }), Object.values(n1.shared.materials).forEach((t)=>VA(t));
}
function MX(n1) {
    n1.scene.environment.ambientLight.softShadows = !1, n1.scene.environment.ambientLight.softShadowQuality = "low", n1.scene.objects.traverse((t, e)=>{
        (e.type === "DirectionalLight" || e.type === "SpotLight") && (e.shadowResolution = 1024, e.shadowRadius = 1, e.depth = 1e5);
    }), n1.shared.penumbraSize = new Array(5).fill(.5);
}
function CX(n1) {
    n1.shared.audios = Ri({}, He.prototype);
}
function PX(n1) {
    n1.shared.videos = Ri({}, He.prototype);
}
function _X(n1) {
    let t = n1.shared.materials;
    Object.entries(t).forEach(([e, r])=>{
        if (!r.layers) {
            let i = {
                name: "Untitled Material",
                layers: [
                    {
                        fi: 0,
                        data: {
                            type: "light",
                            category: "phong",
                            alpha: .6,
                            visible: !0,
                            mode: 0,
                            specular: {
                                r: .2,
                                g: .2,
                                b: .2
                            },
                            shininess: 5
                        },
                        id: "layer1"
                    },
                    {
                        fi: 1,
                        data: {
                            type: "color",
                            alpha: 1,
                            visible: !0,
                            mode: 0,
                            color: {
                                r: .2823529411764706,
                                g: .2823529411764706,
                                b: .30196078431372547
                            }
                        },
                        id: "layer2"
                    }
                ]
            };
            Object.assign(t, {
                [e]: i
            });
        }
    });
}
function IX(n1) {
    Object.entries(Yr(n1.shared.images)).filter((r)=>r[1].asset === !1).map((r)=>r[0]).forEach((r)=>{
        delete n1.shared.images[r];
    }), Object.entries(Yr(n1.shared.audios)).filter((r)=>r[1].asset === !1).map((r)=>r[0]).forEach((r)=>{
        delete n1.shared.audios[r];
    });
}
function DX(n1) {
    n1.scene.publish.settings.web.preload = !1;
}
function VO(n1) {
    n1.layers && n1.layers.forEach((t)=>{
        t.type === "depth" && t.num !== void 0 && (t.colors = t.colors.slice(0, t.num), t.steps = t.steps.slice(0, t.num), delete t.num);
    });
}
function UO(n1) {
    n1.layers && n1.layers.forEach((t)=>{
        SO(t) && t.isMask === void 0 && (t.isMask = !1), (t.type === "texture" || t.type === "video") && t.blending === void 0 && (t.blending = 0), (t.type === "noise" || t.type === "displace" && t.displacementType === "noise") && (t.voronoiStyle === void 0 && (t.voronoiStyle = 0), t.highCut === void 0 && (t.highCut = 1), t.lowCut === void 0 && (t.lowCut = 0), t.smoothness === void 0 && (t.smoothness = .3), t.seed === void 0 && (t.seed = 0), t.quality === void 0 && (t.quality = 1));
    });
}
function OX(n1) {
    n1.shared.fonts = Ri({}, He.prototype);
}
function RX(n1) {
    return n1.replace(".typeface", "").replace(/optimer/gi, "open sans").replace("space_mono", "space mono").replace(/alma_mono/gi, "varela round").replace(/droid_sans_mono/gi, "noto sans mono").replace(/droid_sans|gentilis|gnomon_(simple|foreground)|helvetiker/gi, "roboto").replace(/droid_serif/gi, "roboto slab").replace("_sans", " sans").replace("crimson_text", "crimson text").replace("medium_medium", "medium").replace("fatface_fatface", "fatface").replace("100hairline", "thin").replace("200thin", "extralight").replace("300light", "light").replace("500medium", "medium").replace("600semi", "semibold").replace("800heavy", "extrabold").replace("900black", "black").replace(/bodoni_(11|16|24|36|48|72|96)([^_])/gi, "bodoni_$1_$2").replace(/bodoni_(11|16|24|36|48|72|96)/gi, "bodoni moda").replace(/(thin|hairline)(_regular)?/gi, "100").replace(/(extra|ultra)light(_regular)?/gi, "200").replace(/light(_regular)?/gi, "300").replace(/_book|_normal|_roman/gi, "_regular").replace(/medium(_regular)?/gi, "500").replace(/(semi|demi)bold(_regular)?/gi, "600").replace(/(extra|ultra)bold(_regular)?/gi, "800").replace(/bold(_regular)?/gi, "700").replace(/(black|heavy|fatface)(_regular)?/gi, "900").replace(/([1-9]00)_italic/gi, "$1italic").replace(/regularitalic/gi, "italic").replace(/regularitalic/gi, "italic").split(" ").map((e)=>e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
}
function LX(n1) {
    let t = [];
    n1.scene.objects.traverse((e, r)=>{
        let i = r;
        if (i.type === "TextFrame") {
            let s1 = Kr.defaultTwoLayerData("phong"), o = typeof i.color == "string" ? n1.shared.colors[i.color] : i.color;
            s1.layers[1].data.color = {
                r: o.r,
                g: o.g,
                b: o.b
            }, s1.layers[1].data.alpha = i.alpha;
            let a = RX(i.font);
            n1.shared.fonts[a] === void 0 && (n1.shared.fonts[a] = {
                name: a
            });
            let l = {
                name: i.name,
                ...li.defaultData,
                ...Ba.defaultData,
                flatShading: !1,
                wireframe: !1,
                geometry: {
                    ...Fo.defaultData("TextGeometry"),
                    width: i.width,
                    height: i.height,
                    font: a,
                    depth: 0,
                    horizontalAlign: i.horizontalAlign,
                    verticalAlign: i.verticalAlign,
                    fontSize: i.fontSize * 1.40625,
                    lineHeight: i.lineHeight / 1.40625,
                    letterSpacing: i.letterSpacing - 1,
                    text: i.text,
                    textTransform: i.textTransform,
                    extrudeBevelSize: 0,
                    extrudeBevelSegments: 1
                },
                material: s1,
                states: Yr(i.states),
                events: Yr(i.events),
                visible: i.visible,
                raycastLock: i.raycastLock,
                position: i.position,
                rotation: i.rotation,
                scale: i.scale,
                hiddenMatrix: i.hiddenMatrix
            }, c = Yr(n1.scene.objects).parent(e);
            n1.scene.objects.insertAfter(c ?? null, e, [
                {
                    id: e + "new",
                    data: l,
                    children: []
                }
            ]), t.push(e);
        }
    }), t.forEach((e)=>{
        n1.scene.objects.delete(e);
    });
}
function NX(n1) {
    let t = {
        0: "MouseDown",
        1: "MouseUp",
        2: "MouseHover",
        5: "KeyDown",
        6: "KeyUp",
        7: "Start",
        9: "LookAt",
        10: "Follow",
        11: "Scroll",
        12: "Audio",
        13: "GameControl"
    };
    n1.scene.objects.traverse((e, r)=>{
        r.events.forEach((i)=>{
            if (!!t[Number(i.type)]) {
                if (Object.assign(i, {
                    type: t[Number(i.type)]
                }), i.type === "Audio" && "audioEvent" in i && (Object.assign(i, {
                    playAudio: i.audioEvent
                }), delete i.audioEvent), i.type === "GameControl") Object.assign(i, {
                    gameActions: {
                        idle: new Re,
                        move: new Re,
                        jump: new Re
                    }
                });
                else {
                    let s1 = new Re;
                    Object.assign(i, {
                        actions: s1
                    }), (i.type === "MouseDown" || i.type === "MouseUp" || i.type === "KeyDown" || i.type === "KeyUp") && "url" in i && s1.push({
                        fi: 0,
                        id: Se.generateUUID(),
                        data: {
                            type: "Link",
                            url: i.url,
                            delay: 0
                        }
                    }), "targets" in i && (i.targets.forEach((o, a, l)=>{
                        let c = {
                            state: void 0,
                            repeat: 0,
                            delay: 0,
                            delayDirection: void 0,
                            direction: "normal",
                            duration: 0,
                            easing: 4
                        }, u1 = {
                            easing: o.easing,
                            duration: o.duration
                        };
                        o.easing === 6 ? Object.assign(u1, Nn(o, "mass", "stiffness", "damping", "velocity")) : o.easing === 5 && Object.assign(u1, {
                            control1: {
                                ...o.control1
                            },
                            control2: {
                                ...o.control2
                            }
                        });
                        let h = {
                            repeat: o.repeat ? -1 : 0,
                            delay: o.delay,
                            delayDirection: o.delayDirection,
                            direction: o.cycle && o.rewind ? "pingpong-rewind" : o.cycle ? "pingpong" : "normal"
                        }, d = {
                            state: o.state,
                            ...h,
                            ...u1
                        }, f = {
                            allowSlerp: !0,
                            type: "Transition",
                            object: o.object,
                            repeat: 0,
                            delay: 0,
                            delayDirection: void 0,
                            direction: "normal",
                            tweens: new Re({
                                fi: 0,
                                id: Se.generateUUID(),
                                data: c
                            }, {
                                fi: 1,
                                id: Se.generateUUID(),
                                data: d
                            })
                        };
                        s1.push({
                            fi: l,
                            id: a,
                            data: f
                        });
                    }), delete i.targets);
                }
            }
        });
    });
}
function BX(n1) {
    n1.scene.objects.traverse((t, e)=>{
        function r(i, s1) {
            let o = new Re, a = [];
            if (e.events.forEach((l, c, u1)=>{
                if (l.type === "Audio" && l.trigger === s1) {
                    let h;
                    a.push(c), l.interaction === "play" ? h = {
                        ...Nn(l, "interaction", "audio", "delay", "volume", "loop"),
                        triggerAfter: "after" in l ? l.after : void 0,
                        toggle: "after" in l ? l.toggle : void 0,
                        type: "Audio"
                    } : (l.interaction === "pause" || l.interaction === "stop") && (h = {
                        ...Nn(l, "interaction", "delay", "object", "playAudio"),
                        type: "Audio"
                    }), h && o.push({
                        fi: u1,
                        id: c,
                        data: h
                    });
                }
            }), a.forEach((l)=>e.events.delete(l)), o.length) {
                let l = e.events.find((c)=>c.type === i)?.data;
                l ? "actions" in l && l.actions.insertBefore(null, o) : e.events.insertBefore(null, [
                    {
                        id: Se.generateUUID(),
                        data: {
                            type: i,
                            actions: o
                        }
                    }
                ]);
            }
        }
        r("Start", "start"), r("MouseDown", "mouseDown"), r("MouseUp", "mouseUp"), r("KeyDown", "keyDown"), r("KeyUp", "keyUp");
    });
}
function kO(n1) {
    let t = n1.layers.find((e)=>e.type === "light")?.data;
    if (t?.category === "basic") {
        let e = Cr.defaultData("light", "phong"), r = t;
        Object.assign(r, e), r.visible = !1;
    }
}
function zO(n1) {
    ka(n1, kO), za(n1, kO);
}
function FX(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.type === "Mesh" && e.geometry.type === "SubdivGeometry" && (e.geometry.scaleBaked || (e.geometry.scaleBaked = [
            1,
            1,
            1
        ]));
    });
}
function VX(n1) {
    n1.scene.objects.traverse((t, e)=>{
        (e.type === "Empty" || e.type === "Mesh") && e.cloner && !e.cloner.randomnessObject && !e.cloner.toObject && !e.cloner.randomness && (e.cloner = {
            ...e.cloner,
            toObject: {
                object: "",
                spreadType: "random",
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                axis: "x",
                seed: 0,
                count: 99,
                align: "normal"
            },
            randomness: !1,
            randomnessObject: {
                strength: 100,
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                movement: 1,
                seed: 0,
                freqScale: 10,
                noiseType: "perlin"
            }
        });
    });
}
function UX(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.type === "Mesh" && e.geometry.type === "NonParametricGeometry" && !("material" in e) && !("materials" in e) && (e.material = Kr.defaultTwoLayerData("phong"));
    });
}
function kX(n1) {
    n1.scene.publish.orbitControls.autoZoom === void 0 && (n1.scene.publish.orbitControls.autoZoom = !1), n1.scene.objects.traverse((t, e)=>{
        (e.type === "OrthographicCamera" || e.type === "PerspectiveCamera") && (e.orthographic.autoZoom === void 0 && (e.orthographic.autoZoom = !1), e.orthographic.autoZoomFrustumSize === void 0 && (e.orthographic.autoZoomFrustumSize = 790));
    });
}
function zX(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.pathSnapping === void 0 && (e.pathSnapping = {
            pathId: null,
            slide: 0,
            offset: 0,
            orientation: "tangential"
        }), e.pathSnapping.offset === void 0 && (e.pathSnapping.offset = 0);
    });
}
function GX(n1) {
    n1.scene.publish.mouseEventTarget === void 0 && (n1.scene.publish.mouseEventTarget = "canvas"), n1.scene.publish.settings.web.hint === void 0 && (n1.scene.publish.settings.web.hint = !1);
}
function jX(n1) {
    let { video: t } = n1.scene.publish.settings;
    t.format === "gif" && t.fps > 48 && (t.fps = 15);
}
function HX(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.events.forEach((r)=>{
            r.type === "GameControl" && (r.resetYPosition = Math.abs(r.resetYPosition - e.position[1]));
        });
    });
}
function WX(n1) {
    let t = n1.scene.environment.usePhysics;
    n1.scene.objects.traverse((e, r)=>{
        t && r.physics === null ? r.collision = !1 : r.collision = "visibility";
    });
}
function qX(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.events.forEach((r)=>{
            r.type === "GameControl" && (r.navmesh = bd.defaultDataThirdPerson.navmesh);
        });
    });
}
function XX(n1) {
    n1.scene.styles || (n1.scene.styles = Va.defaultData());
}
function GO(n1) {
    n1.layers.forEach((t)=>{
        t.type === "light" && t.category !== "toon" && t.occlusion === void 0 && (t.occlusion = !0);
    });
}
function YX(n1) {
    n1.scene.environment.ambientLight.occlusion === void 0 && (n1.scene.environment.ambientLight.occlusion = !1), n1.scene.environment.ambientLight.aoFullRes === void 0 && (n1.scene.environment.ambientLight.aoFullRes = !1), n1.scene.environment.ambientLight.radius === void 0 && (n1.scene.environment.ambientLight.radius = 256), n1.scene.environment.ambientLight.bias === void 0 && (n1.scene.environment.ambientLight.bias = .5), n1.scene.environment.ambientLight.aoColor === void 0 && (n1.scene.environment.ambientLight.aoColor = {
        r: .19607843137254902,
        g: .19607843137254902,
        b: .19607843137254902
    }), za(n1, GO), ka(n1, GO);
}
function KX(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.events.forEach((r)=>{
            r.type === "GameControl" && Object.assign(r.gameActions, {
                run: new Re
            });
        });
    });
}
function QX(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.events.forEach((r)=>{
            r.type === "GameControl" && (r.keyAssignments = [
                ...r.keyAssignments,
                [
                    "run",
                    "\u21E7"
                ],
                [
                    "none",
                    "Ctrl"
                ]
            ]);
        });
    });
}
function jO(n1) {
    n1.layers && n1.layers.forEach((t)=>{
        t.type === "light" && t.bumpMapIntensity === void 0 && (t.bumpMapIntensity = 5);
    });
}
function HO(n1, t) {
    if (t < 1 && (za(n1, NO), ka(n1, NO), n1.schema = 1), t < 2 && (mX(n1), n1.schema = 2), t < 3 && (yX(n1), n1.schema = 3), t < 4 && (vX(n1), n1.schema = 4), t < 5 && (xX(n1), n1.schema = 5), t < 6 && (bX(n1), n1.schema = 6), t < 7 && (SX(n1), n1.schema = 7), t < 8 && (n1.schema = 8), t < 9 && (FO(n1), n1.schema = 9), t < 10 && (TX(n1), n1.schema = 10), t < 11 && (MX(n1), n1.schema = 11), t < 12 && (FO(n1), n1.schema = 12), t < 13 && (CX(n1), n1.schema = 13), t < 14 && (_X(n1), n1.schema = 14), t < 15 && (IX(n1), n1.schema = 15), t < 16 && (DX(n1), n1.schema = 16), t < 17 && (za(n1, VO), ka(n1, VO), n1.schema = 17), t < 18 && (za(n1, BO), ka(n1, BO), n1.schema = 18), t < 19 && (gX(n1), n1.schema = 19), t < 20 && (OX(n1), LX(n1), n1.schema = 20), t < 21 && (NX(n1), BX(n1), n1.schema = 21), t < 22 && (zO(n1), n1.schema = 22), t < 23 && (FX(n1), n1.schema = 23), t < 24 && (VX(n1), n1.schema = 24), (t < 25 || n1.shared.videos === void 0) && (PX(n1), t < 25 && (n1.schema = 25)), t < 26 && (wX(n1), n1.schema = 26), t < 27 && (AX(n1), n1.schema = 27), t < 28 && (zO(n1), n1.schema = 28), t < 29 && (EX(n1), n1.schema = 29), t < 30 && (UX(n1), n1.schema = 30), t < 31 && (kX(n1), n1.schema = 31), t < 33 && (zX(n1), n1.schema = 33), t < 34 && (GX(n1), n1.schema = 34), t < 35 && (jX(n1), n1.schema = 35), t < 36 && (HX(n1), n1.schema = 36), t < 37 && (WX(n1), n1.schema = 37), t < 38 && (za(n1, UO), ka(n1, UO), n1.schema = 38), t < 39 && (qX(n1), n1.schema = 39), t < 40 && (XX(n1), n1.schema = 40), t < 41 && (YX(n1), n1.schema = 41), t < 42 && (KX(n1), n1.schema = 42), t < 43 && (QX(n1), n1.schema = 43), t < 99) {
        za(n1, jO), ka(n1, jO), n1.scene.publish.playCamera === null && (n1.scene.publish.playCamera = As);
        let e = Yr(n1.scene.objects), r = n1.scene.objects;
        n1.scene.publish.playPage = Gl, r.insertBefore(null, null, [
            {
                id: Gl,
                data: {
                    ...Fa.defaultData,
                    backgroundColor: n1.scene.backgroundColor,
                    fog: n1.scene.fog,
                    postprocessing: n1.scene.postprocessing,
                    ao: Nn(n1.scene.environment.ambientLight, "occlusion", "aoFullRes", "radius", "bias", "aoColor"),
                    publish: {
                        playCamera: n1.scene.publish.playCamera,
                        gameControlObject: n1.scene.publish.gameControlObject
                    },
                    shadow: Nn(n1.scene.environment.ambientLight, "softShadowQuality"),
                    globalPhysics: {
                        ...Wl.defaultData,
                        ...Nn(n1.scene.environment, "usePhysics", "gravity")
                    },
                    camera: Yr(n1.scene.ownerCamera) ?? Fa.defaultData.camera,
                    name: "Scene"
                },
                children: []
            }
        ]);
        for (let o of e)o.id !== Ua.TRASH_CAN_ID && r.move(Gl, o.fi, o.id);
        let i = 0, s1 = 0;
        n1.shared.penumbraSize && n1.scene.objects.traverse((o, a)=>{
            a.type === "DirectionalLight" ? (a.penumbraSize = n1.shared.penumbraSize[Math.min(i, 2)], i += 1) : a.type === "SpotLight" && (a.penumbraSize = n1.shared.penumbraSize[3 + Math.min(s1, 1)], s1 += 1), (a.physics === void 0 || a.physics === null) && a.type !== "Instance" && (a.physics = {}, Object.assign(a.physics, Hl.defaultData)), a.physics !== void 0 && a.physics !== null && (a.physics.enabled = a.collision ?? "visibility", delete a.collision);
        }), n1.schema = 99;
    }
}
function WO(n1) {
    n1.layers && n1.layers.forEach((t)=>{
        t.type === "light" && t.alphaOverride === void 0 && (t.alphaOverride = 1);
    });
}
function ZX(n1) {
    n1.scene.objects.traverse((t, e)=>{
        let r = e.geometry;
        r && r.type === "PathGeometry" && (r.extrusion.capType = "flat", r.extrusion.bevel = 50, r.extrusion.bevelSides = 6, r.extrusion.shape.type === "Custom" && (r.extrusion.shape.shapeQuality = "low"));
    });
}
function JX(n1) {
    Array.isArray(Yr(n1.events)) && n1.events?.forEach((t)=>{
        "disabled" in t || (t.disabled = !1), (t.type === "MouseDown" || t.type === "MouseUp" || t.type === "MousePress") && (t.mode = t.mode || "Object");
    });
}
var Sd = 180 / Math.PI;
function qO(n1) {
    n1.rotation = n1.rotation.slice(0, 3).map((t)=>t * Sd);
}
function XO(n1) {
    qO(n1), n1.type === "Page" && qO(n1.camera), n1.states?.forEach((e)=>{
        e.rotation === void 0 || e.rotation === null || (e.rotation = e.rotation.slice(0, 3).map((r)=>r * Sd));
    });
    let t = n1.geometry;
    t && t.type === "SphereGeometry" && (t.thetaLength = (t.thetaLength ?? 180) * Sd), t && t.type === "TorusGeometry" && (t.arc = t.arc * Sd), t && t.type === "PathGeometry" && (t.extrusion.angle *= Sd, t.extrusion.twist *= Sd), n1.type === "Mesh" && n1.geometry.type === "TextGeometry" && (n1.geometry.text = {
        textValue: n1.geometry.text
    }), Array.isArray(Yr(n1.events)) && n1.events?.forEach((e)=>{
        (e.type === "MouseDown" || e.type === "MouseUp" || e.type === "MousePress" || e.type === "KeyDown" || e.type === "KeyUp" || e.type === "KeyPress" || e.type === "Collision" || e.type === "Trigger") && (e.runMode = e.toggle ? "Toggle" : "Repeat");
    });
}
function $X(n1) {
    n1.shared.variables = Ri({}, He.prototype);
}
function eY(n1) {
    let t = Yr(n1.shared.variables);
    n1.shared.variables = Ri(Object.entries(t ?? {}).map(([e, r], i)=>({
            fi: i,
            id: e,
            data: r
        })), Re.prototype);
}
var ko = 122;
function H0(n1, t) {
    t(n1.data);
    for (let e of n1.children)H0(e, t);
}
function tY(n1) {
    let t = n1.schema ?? 104;
    t !== ko && (t < 105 && (H0(n1.asset, XO), n1.schema = 105), t < 118 && (H0(n1.asset, YO), n1.schema = 118), t < 121 && (H0(n1.asset, UA), n1.schema = 121));
}
function rY(n1) {
    n1.shared.particles = Ri({}, He.prototype), n1.shared.lib && (n1.shared.lib.particles = Zs.defaultData().particles);
}
function iY(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.type === "Particle" && typeof e.renderMaterial.size == "number" && Object.assign(e.renderMaterial, {
            size: [
                e.renderMaterial.size,
                e.renderMaterial.size
            ]
        });
    });
}
function nY(n1) {
    n1.scene.objects.traverse((t, e)=>{
        e.type === "Page" && (e.postprocessing.depthOfField.focusDistance = 100, e.postprocessing.depthOfField.focalLength = 20, e.postprocessing.depthOfField.bokehScale = 5);
    });
}
function sY(n1) {
    n1.scene.objects.traverse((t, e)=>{
        Array.isArray(Yr(e.events)) !== !1 && e.events?.forEach((r)=>{
            let i = r.runMode;
            r.type === "MouseDown" || r.type === "MouseUp" || r.type === "KeyDown" || r.type === "KeyUp" || r.type === "Collision" || r.type === "Trigger" ? r.actions?.forEach((s1)=>{
                s1.type === "Transition" && (s1.runMode = i ?? "Repeat"), (s1.type === "Animation" || s1.type === "SwitchCamera") && (s1.runMode = i === "Toggle" ? "Toggle" : "Normal");
            }) : r.type === "MouseHover" || r.type === "MousePress" || r.type === "KeyPress" ? r.actions?.forEach((s1)=>{
                (s1.type === "Transition" || s1.type === "Animation" || s1.type === "SwitchCamera") && (s1.runMode = "Toggle");
            }) : r.type === "GameControl" ? (delete r.actions, Object.keys(r.gameActions).forEach((o)=>{
                r.gameActions[o]?.forEach((a)=>{
                    a.type === "Transition" && (a.runMode = "Repeat"), a.type === "Animation" && (a.runMode = "Normal");
                });
            })) : r.type === "DragDrop" ? (delete r.actions, r.dragDropActions?.drag?.forEach((s1)=>{
                (s1.type === "Transition" || s1.type === "Animation" || s1.type === "SwitchCamera") && (s1.runMode = "Toggle");
            }), r.dragDropActions?.drop?.forEach((s1)=>{
                (s1.type === "Transition" || s1.type === "Animation" || s1.type === "SwitchCamera") && (s1.runMode = "Toggle");
            })) : r.type === "Resize" ? (delete r.actions, r.breakpoints?.forEach((s1)=>{
                s1.actions?.forEach((o)=>{
                    (o.type === "Transition" || o.type === "Animation" || o.type === "SwitchCamera") && (o.runMode = "Toggle");
                });
            })) : r.type === "Start" ? r.actions?.forEach((s1)=>{
                s1.type === "Transition" && (s1.runMode = "Once"), (s1.type === "Animation" || s1.type === "SwitchCamera") && (s1.runMode = "Normal");
            }) : r.type === "VariableChange" || r.type === "Scroll" ? r.actions?.forEach((s1)=>{
                s1.type === "Transition" && (s1.runMode = "Repeat"), (s1.type === "Animation" || s1.type === "SwitchCamera") && (s1.runMode = "Normal");
            }) : r.type === "Conditional" && (delete r.actions, r.inActions?.forEach((s1)=>{
                s1.type === "Transition" && (s1.runMode = "Repeat"), (s1.type === "Animation" || s1.type === "SwitchCamera") && (s1.runMode = "Normal");
            }), r.outActions?.forEach((s1)=>{
                s1.type === "Transition" && (s1.runMode = "Repeat"), (s1.type === "Animation" || s1.type === "SwitchCamera") && (s1.runMode = "Normal");
            }));
        });
    });
}
function oY(n1) {
    n1.shared.userAPIs = Ri({}, He.prototype), n1.shared.userWebhooks = Ri({}, He.prototype), n1.shared.lib && (n1.shared.lib.userAPIs = Zs.defaultData().userAPIs, n1.shared.lib.userWebhooks = Zs.defaultData().userWebhooks);
}
function aY(n1) {
    n1.scene.publish.settings.videoStatic === void 0 && (n1.scene.publish.settings.videoStatic = Es.defaultData.settings.videoStatic);
}
function YO(n1) {
    n1.timelineAnimations = Ri({}, He.prototype);
}
function UA(n1) {
    console.log("Updating pivot for object:", n1.name), n1.pivot = [
        0,
        0,
        0
    ], n1.pivotRotation = [
        0,
        0,
        0
    ];
}
function W0(n1) {
    let t = n1.schema ?? 0;
    if (t !== ko) {
        console.warn("updating from ", t, "to ", ko), HO(n1, t), t < 100 && (n1.scene.publish.joystickSizeAndXYOffset === void 0 && (n1.scene.publish.joystickSizeAndXYOffset = Es.defaultData.joystickSizeAndXYOffset), n1.schema = 100), t < 101 && (za(n1, WO), ka(n1, WO), n1.schema = 101), t < 102 && (ZX(n1), n1.schema = 102), t < 104 && (n1.shared.catelogs = new He, n1.shared.lib = Zs.defaultData(), n1.schema = 104), t < 105 && ($X(n1), n1.scene.objects.traverse((e, r)=>{
            XO(r);
        }), n1.schema = 105);
        for (let e of Object.values(n1.shared.lib.components))tY(e);
        t < 106 && (eY(n1), n1.schema = 106), t < 107 && (n1.shared.lib.variables = Zs.defaultData().variables, n1.schema = 107), t < 109 && (rY(n1), n1.schema = 109), t < 110 && (iY(n1), n1.schema = 110), t < 111 && (n1.scene.objects.traverse((e, r)=>{
            JX(r);
        }), n1.schema = 111), t < 112 && (nY(n1), n1.schema = 112), t < 113 && (sY(n1), n1.schema = 113), t < 114 && (n1.scene.publish.settings.web.imageQuality === void 0 && (n1.scene.publish.settings.web.imageQuality = 70), n1.schema = 114), t < 115 && (oY(n1), n1.schema = 115), t < 116 && (aY(n1), n1.schema = 116), t < 117 && (n1.scene.publish.settings.web.pixelRatioMobile === void 0 && (n1.scene.publish.settings.web.pixelRatioMobile = 0), n1.scene.publish.settings.web.pixelRatioDesktop === void 0 && (n1.scene.publish.settings.web.pixelRatioDesktop = 0), n1.schema = 117), t < 118 && (n1.shared.timelineAnimations = Ri({}, He.prototype), n1.scene.objects.traverse((e, r)=>{
            YO(r);
        }), n1.schema = 118), t < 119 && (n1.scene.publish.settings.videoStatic.format = Uo.defaultData.scene.publish.settings.videoStatic.format, n1.scene.publish.settings.videoStatic.imageFormat = Uo.defaultData.scene.publish.settings.videoStatic.imageFormat, n1.schema = 119), t < 120 && (n1.scene.publish.settings.image.colorSpace = "display-p3", n1.scene.publish.settings.videoStatic.colorSpace = "display-p3", n1.schema = 120), t < 121 && (n1.scene.objects.traverse((e, r)=>{
            UA(r), r.type === "Page" && UA(r.camera);
        }), n1.schema = 121), t < 122 && (delete n1.scene.publish.settings.video, n1.scene.publish.orbitControls.rotationSpeed = Uo.defaultData.scene.publish.orbitControls.rotationSpeed, n1.schema = 122);
    }
}
var Uo;
((c)=>{
    c.defaultData = {
        schema: ko,
        scene: Ua.defaultData,
        frames: new He().add("72fc2993-2da3-4b6b-96ac-2879db3a28bd", vd.defaultData),
        shared: {
            ...An.emptyData(),
            colors: An.defaultColors()
        }
    }, c.emptyDataForImports = function() {
        let u1 = Ua.emptyDataWithPage();
        return {
            schema: ko,
            scene: u1,
            frames: new He().add("72fc2993-2da3-4b6b-96ac-2879db3a28bd", vd.defaultData),
            shared: {
                ...An.emptyData(),
                colors: An.defaultColors(),
                images: An.defaultImages()
            }
        };
    }, c.emptyData = function() {
        return {
            schema: ko,
            scene: Ua.emptyDataWithPage(),
            frames: new He().add("72fc2993-2da3-4b6b-96ac-2879db3a28bd", vd.defaultData),
            shared: An.emptyData()
        };
    }, c.clipboard2dData = function() {
        return {
            schema: ko,
            scene: Ua.emptyData(),
            frames: new He,
            shared: An.emptyData()
        };
    }, c.collabHelper = {
        ...fm,
        updateSchema (u1) {
            return (u1.schema ?? 0) < ko ? Fl(u1, W0) : (u1.schema ?? 0) - ko;
        }
    };
    function s1(u1) {
        let h = c.collabHelper.updateSchema(u1);
        return typeof h == "number" ? h === 0 ? u1 : null : h.data;
    }
    c.updateSchemaDirectly = s1;
    function o(u1) {
        return {
            ...u1,
            shared: {
                ...u1.shared,
                lib: Zs.defaultData()
            }
        };
    }
    c.withoutLib = o;
    function a(u1, h) {
        let d = u1.scene.objects.get(h);
        if (d && d.data.type === "Component") return d;
        {
            let f = u1.shared.lib.components[h];
            if (f) return {
                ...f.asset,
                id: h
            };
        }
    }
    c.getComponentData = a;
    function l(u1) {
        let h = Object.values(u1.shared.userAPIs);
        for (let d of h){
            let f = d.headers;
            for (let m of f)if (m.data.key.toLowerCase() === "authorization" && m.data.value !== "") return !0;
        }
        return !1;
    }
    c.hasSensitiveData = l;
})(Uo || (Uo = {}));
var q0;
((t)=>t.emptyImage = {
        data: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=",
        name: "empty"
    })(q0 || (q0 = {}));
var KO;
((t)=>{
    function n1(e) {
        return !0;
    }
    t.is = n1;
})(KO || (KO = {}));
var X0;
((r)=>{
    r.defaultData = {
        position: [
            0,
            0
        ],
        scale: [
            1,
            1
        ],
        rotation: 0,
        shear: [
            0,
            0
        ]
    };
    function t(i, s1) {
        return {
            position: s1?.position ?? i.position,
            rotation: s1?.rotation ?? i.rotation,
            scale: s1?.scale ?? i.scale,
            shear: s1?.shear ?? i.shear
        };
    }
    r.merge = t;
    function e(i, s1) {
        return Hv({
            position: ss.isEqual(i.position, s1.position) ? void 0 : s1.position,
            rotation: i.rotation === s1.rotation ? void 0 : s1.rotation,
            scale: ss.isEqual(i.scale, s1.scale) ? void 0 : s1.scale,
            shear: i.shear && s1.shear && ss.isEqual(i.shear, s1.shear) ? void 0 : s1.shear
        });
    }
    r.diff = e;
})(X0 || (X0 = {}));
var kA;
((t)=>t.defaultData = {
        horizontalConstraint: 0,
        verticalConstraint: 0
    })(kA || (kA = {}));
var QO;
((t)=>t.defaultData = {
        direction: "row",
        wrap: "unwrap",
        align: "top-left",
        gap: 10,
        rowGap: 10,
        autoGap: !1,
        autoRowGap: !1,
        leftPadding: 8,
        rightPadding: 8,
        topPadding: 8,
        bottomPadding: 8
    })(QO || (QO = {}));
var Y0;
((t)=>t.defaultData = {
        opacity: 1,
        fill: {
            color: At.fromHexAndA(ai, 1),
            enabled: !0
        },
        stroke: {
            color: At.from0to1([
                0,
                0,
                0,
                1
            ]),
            thickness: 1,
            enabled: !1,
            mode: "inside"
        },
        layerBlur: {
            radius: 2,
            enabled: !1
        },
        backgroundBlur: {
            radius: 2,
            enabled: !1
        },
        dropShadow: {
            offset: [
                10,
                10
            ],
            blurRadius: 10,
            color: At.from0to1([
                0,
                0,
                0,
                1
            ]),
            enabled: !1,
            spread: 0
        },
        innerShadow: {
            offset: [
                10,
                10
            ],
            blurRadius: 10,
            color: At.from0to1([
                0,
                0,
                0,
                1
            ]),
            enabled: !1,
            spread: 0
        }
    })(Y0 || (Y0 = {}));
var Ga;
((s1)=>{
    function n1(o, a) {
        return {
            name: a
        };
    }
    s1.newEmpty = n1;
    function t(o, a) {
        if (a === void 0) return o;
        let l = {
            ...o
        }, c = [
            "width",
            "height",
            "cornerRadius"
        ];
        for (let u1 of c)u1 in l && u1 in a && a[u1] !== void 0 && Object.assign(l, {
            [u1]: a[u1]
        });
        return l;
    }
    function e(o, a) {
        if (a === void 0) return o;
        let l = {
            ...o
        };
        return "fill" in l && "fill" in a && a.fill !== void 0 && Object.assign(l, {
            fill: {
                ...l.fill,
                ...a.fill
            }
        }), "stroke" in l && "stroke" in a && a.stroke !== void 0 && Object.assign(l, {
            stroke: {
                ...l.stroke,
                ...a.stroke
            }
        }), "layerBlur" in l && "layerBlur" in a && a.layerBlur !== void 0 && Object.assign(l, {
            layerBlur: {
                ...l.layerBlur,
                ...a.layerBlur
            }
        }), "backgroundBlur" in l && "backgroundBlur" in a && a.backgroundBlur !== void 0 && Object.assign(l, {
            backgroundBlur: {
                ...l.backgroundBlur,
                ...a.backgroundBlur
            }
        }), "dropShadow" in l && "dropShadow" in a && a.dropShadow !== void 0 && Object.assign(l, {
            dropShadow: {
                ...l.dropShadow,
                ...a.dropShadow
            }
        }), "innerShadow" in l && "innerShadow" in a && a.innerShadow !== void 0 && Object.assign(l, {
            innerShadow: {
                ...l.innerShadow,
                ...a.innerShadow
            }
        }), l;
    }
    function r(o, a) {
        if (a === void 0) return o;
        let l = {
            ...o
        };
        return Object.assign(l, X0.merge(l, a)), l = t(l, a), l = e(l, a), l;
    }
    s1.patch = r;
    function i(o, a) {
        let l, c = [];
        for (let [u1, h] of Object.entries(a))u1 !== "name" && (l === void 0 && (l = {
            path: [],
            props: {},
            type: 0
        }, c.push(l)), l.props[u1] = h);
        return c;
    }
    s1.toOps = i;
})(Ga || (Ga = {}));
var bm;
((t)=>t.defaultData = {
        ...X0.defaultData,
        ...kA.defaultData,
        states: new Re,
        events: new Re,
        visible: !0,
        raycastLock: !1
    })(bm || (bm = {}));
var wd;
((t)=>t.defaultData = {
        ...bm.defaultData,
        ...Y0.defaultData
    })(wd || (wd = {}));
var K0;
((t)=>t.defaultData = {
        cornerRadius: [
            0,
            0,
            0,
            0
        ]
    })(K0 || (K0 = {}));
var zA;
((t)=>t.defaultData = {
        ...wd.defaultData,
        type: "ellipse2d",
        width: 100,
        height: 100,
        name: "Ellipse"
    })(zA || (zA = {}));
var Ad;
((t)=>t.defaultData = {
        ...wd.defaultData,
        ...K0.defaultData,
        type: "rectangle2d",
        width: 100,
        height: 100,
        name: "Rectangle"
    })(Ad || (Ad = {}));
var GA;
((t)=>t.defaultData = {
        ...wd.defaultData,
        type: "text2d",
        width: 100,
        height: 100,
        fontSize: 12,
        lineHeight: 1.2,
        letterSpacing: 0,
        text: {
            textValue: "Hello world"
        },
        horizontalAlign: 1,
        verticalAlign: 1,
        textTransform: 1,
        font: "Roboto_regular",
        name: "Text"
    })(GA || (GA = {}));
var jA;
((t)=>t.defaultData = {
        ...wd.defaultData,
        type: "path2d",
        path: "",
        name: "Path"
    })(jA || (jA = {}));
var ZO;
((t)=>{
    function n1(e) {
        return e.type === "ellipse2d" || e.type === "rectangle2d" || e.type === "text2d" || e.type === "vector2d" || e.type === "path2d";
    }
    t.is = n1;
})(ZO || (ZO = {}));
var Sm;
((t)=>t.defaultData = {
        ...bm.defaultData,
        name: "Group",
        type: "group2d"
    })(Sm || (Sm = {}));
var HA;
((t)=>t.defaultData = ()=>({
            ...bm.defaultData,
            ...K0.defaultData,
            ...Y0.defaultData,
            name: "Frame",
            type: "frame2d",
            clipped: !0,
            width: 200,
            height: 200,
            fill: {
                color: At.fromHexAndA(4737101, 1),
                enabled: !0
            },
            stroke: {
                color: At.fromHexAndA(0, 1),
                thickness: 1,
                enabled: !1,
                mode: "inside"
            },
            backgroundBlur: {
                radius: 2,
                enabled: !1
            },
            layerBlur: {
                radius: 2,
                enabled: !1
            }
        }))(HA || (HA = {}));
var ja;
((s1)=>{
    function n1(o) {
        switch(o){
            case "rectangle2d":
                return {
                    ...Ad.defaultData
                };
            case "ellipse2d":
                return {
                    ...zA.defaultData
                };
            case "text2d":
                return {
                    ...GA.defaultData
                };
            case "vector2d":
                return {
                    ...Ad.defaultData
                };
            case "path2d":
                return {
                    ...jA.defaultData
                };
            case "frame2d":
                return {
                    ...HA.defaultData()
                };
            case "group2d":
                return {
                    ...Sm.defaultData
                };
        }
    }
    s1.defaultData = n1;
    function t(o) {
        return "width" in o && "height" in o ? [
            typeof o.width == "number" ? o.width * .5 : 0,
            typeof o.height == "number" ? o.height * .5 : 0
        ] : [
            0,
            0
        ];
    }
    s1.getPivot = t;
    function e(o) {
        return o.type === "rectangle2d" || o.type === "ellipse2d" || o.type === "text2d" || o.type === "frame2d";
    }
    s1.isResizeable = e;
    function r(o) {
        return o.type === "frame2d" && o.autoLayout !== void 0;
    }
    s1.isAutoLayoutable = r;
    function i(o) {
        return o.type === "rectangle2d" || o.type === "frame2d";
    }
    s1.hasCorners = i;
})(ja || (ja = {}));
var Q0;
((e)=>(e.defaultData = {
        name: "UI",
        type: "scene2d",
        objects: new wr
    }, e.emptyData = function() {
        return {
            type: "scene2d",
            objects: new wr
        };
    }))(Q0 || (Q0 = {}));
function Js(n1, t = !1) {
    let e = n1[0].index !== null, r = new Set(Object.keys(n1[0].attributes)), i = new Set(Object.keys(n1[0].morphAttributes)), s1 = {}, o = {}, a = n1[0].morphTargetsRelative, l = new Ce, c = 0;
    for(let u1 = 0; u1 < n1.length; ++u1){
        let h = n1[u1], d = 0;
        if (e !== (h.index !== null)) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + u1 + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them."), null;
        for(let f in h.attributes){
            if (!r.has(f)) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + u1 + '. All geometries must have compatible attributes; make sure "' + f + '" attribute exists among all geometries, or in none of them.'), null;
            s1[f] === void 0 && (s1[f] = []), s1[f].push(h.attributes[f]), d++;
        }
        if (d !== r.size) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + u1 + ". Make sure all geometries have the same number of attributes."), null;
        if (a !== h.morphTargetsRelative) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + u1 + ". .morphTargetsRelative must be consistent throughout all geometries."), null;
        for(let f in h.morphAttributes){
            if (!i.has(f)) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + u1 + ".  .morphAttributes must be consistent throughout all geometries."), null;
            o[f] === void 0 && (o[f] = []), o[f].push(h.morphAttributes[f]);
        }
        if (t) {
            let f;
            if (e) f = h.index.count;
            else if (h.attributes.position !== void 0) f = h.attributes.position.count;
            else return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + u1 + ". The geometry must have either an index or a position attribute"), null;
            l.addGroup(c, f, u1), c += f;
        }
    }
    if (e) {
        let u1 = 0, h = [];
        for(let d = 0; d < n1.length; ++d){
            let f = n1[d].index;
            for(let m = 0; m < f.count; ++m)h.push(f.getX(m) + u1);
            u1 += n1[d].attributes.position.count;
        }
        l.setIndex(h);
    }
    for(let u1 in s1){
        let h = JO(s1[u1]);
        if (!h) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + u1 + " attribute."), null;
        l.setAttribute(u1, h);
    }
    for(let u1 in o){
        let h = o[u1][0].length;
        if (h === 0) break;
        l.morphAttributes = l.morphAttributes || {}, l.morphAttributes[u1] = [];
        for(let d = 0; d < h; ++d){
            let f = [];
            for(let p = 0; p < o[u1].length; ++p)f.push(o[u1][p][d]);
            let m = JO(f);
            if (!m) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + u1 + " morphAttribute."), null;
            l.morphAttributes[u1].push(m);
        }
    }
    return l;
}
function JO(n1) {
    let t, e, r, i = 0;
    for(let a = 0; a < n1.length; ++a){
        let l = n1[a];
        if (l.isInterleavedBufferAttribute) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. InterleavedBufferAttributes are not supported."), null;
        if (t === void 0 && (t = l.array.constructor), t !== l.array.constructor) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes."), null;
        if (e === void 0 && (e = l.itemSize), e !== l.itemSize) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes."), null;
        if (r === void 0 && (r = l.normalized), r !== l.normalized) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes."), null;
        i += l.array.length;
    }
    let s1 = new t(i), o = 0;
    for(let a = 0; a < n1.length; ++a)s1.set(n1[a].array, o), o += n1[a].array.length;
    return new je(s1, e, r);
}
var nR = {
    update: null,
    begin: null,
    loopBegin: null,
    changeBegin: null,
    change: null,
    changeComplete: null,
    timelineChangeComplete: null,
    loopComplete: null,
    complete: null,
    loop: 1,
    direction: "normal",
    autoplay: !0,
    timelineOffset: 0,
    rewind: !0
}, KA = {
    duration: 1e3,
    delay: 0,
    endDelay: 0,
    startOnceDelay: 0,
    pingPongDelayCorrection: 0,
    pingPongEndDelayCorrection: 0,
    easing: "easeOutElastic(1, .5)",
    round: 0
}, lY = [
    "translateX",
    "translateY",
    "translateZ",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "scaleX",
    "scaleY",
    "scaleZ",
    "skew",
    "skewX",
    "skewY",
    "perspective",
    "matrix",
    "matrix3d"
], Z0 = {
    CSS: {},
    springs: {}
};
function $s(n1, t, e) {
    return Math.min(Math.max(n1, t), e);
}
function wm(n1, t) {
    return n1.indexOf(t) > -1;
}
function WA(n1, t) {
    return n1.apply(null, t);
}
var dt = {
    arr: function(n1) {
        return Array.isArray(n1);
    },
    obj: function(n1) {
        return wm(Object.prototype.toString.call(n1), "Object");
    },
    pth: function(n1) {
        return dt.obj(n1) && n1.hasOwnProperty("totalLength");
    },
    svg: function(n1) {
        return n1 instanceof SVGElement;
    },
    inp: function(n1) {
        return n1 instanceof HTMLInputElement;
    },
    dom: function(n1) {
        return !("isNode" in n1) && (n1.nodeType || dt.svg(n1));
    },
    str: function(n1) {
        return typeof n1 == "string";
    },
    fnc: function(n1) {
        return typeof n1 == "function";
    },
    und: function(n1) {
        return typeof n1 > "u";
    },
    hex: function(n1) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(n1);
    },
    rgb: function(n1) {
        return /^rgb/.test(n1);
    },
    hsl: function(n1) {
        return /^hsl/.test(n1);
    },
    col: function(n1) {
        return dt.hex(n1) || dt.rgb(n1) || dt.hsl(n1);
    },
    key: function(n1) {
        return !nR.hasOwnProperty(n1) && !KA.hasOwnProperty(n1) && n1 !== "targets" && n1 !== "keyframes";
    }
};
function sR(n1) {
    var t = /\(([^)]+)\)/.exec(n1);
    return t ? t[1].split(",").map(function(e) {
        return parseFloat(e);
    }) : [];
}
function oR(n1, t) {
    var e = sR(n1), r = $s(dt.und(e[0]) ? 1 : e[0], .1, 100), i = $s(dt.und(e[1]) ? 100 : e[1], .1, 100), s1 = $s(dt.und(e[2]) ? 10 : e[2], .1, 100), o = $s(dt.und(e[3]) ? 0 : e[3], .1, 100), a = Math.sqrt(i / r), l = s1 / (2 * Math.sqrt(i * r)), c = l < 1 ? a * Math.sqrt(1 - l * l) : 0, u1 = 1, h = l < 1 ? (l * a + -o) / c : -o + a;
    function d(m) {
        var p = t ? t * m / 1e3 : m;
        return l < 1 ? p = Math.exp(-p * l * a) * (u1 * Math.cos(c * p) + h * Math.sin(c * p)) : p = (u1 + h * p) * Math.exp(-p * a), m === 0 || m === 1 ? m : 1 - p;
    }
    function f() {
        var m = Z0.springs[n1];
        if (m) return m;
        for(var p = 1 / 6, g = 0, y = 0;;)if (g += p, d(g) === 1) {
            if (y++, y >= 16) break;
        } else y = 0;
        var x = g * p * 1e3;
        return Z0.springs[n1] = x, x;
    }
    return t ? d : f;
}
function cY(n1) {
    return n1 === void 0 && (n1 = 10), function(t) {
        return Math.ceil($s(t, 1e-6, 1) * n1) * (1 / n1);
    };
}
var uY = function() {
    var n1 = 11, t = 1 / (n1 - 1);
    function e(u1, h) {
        return 1 - 3 * h + 3 * u1;
    }
    function r(u1, h) {
        return 3 * h - 6 * u1;
    }
    function i(u1) {
        return 3 * u1;
    }
    function s1(u1, h, d) {
        return ((e(h, d) * u1 + r(h, d)) * u1 + i(h)) * u1;
    }
    function o(u1, h, d) {
        return 3 * e(h, d) * u1 * u1 + 2 * r(h, d) * u1 + i(h);
    }
    function a(u1, h, d, f, m) {
        var p, g, y = 0;
        do g = h + (d - h) / 2, p = s1(g, f, m) - u1, p > 0 ? d = g : h = g;
        while (Math.abs(p) > 1e-7 && ++y < 10);
        return g;
    }
    function l(u1, h, d, f) {
        for(var m = 0; m < 4; ++m){
            var p = o(h, d, f);
            if (p === 0) return h;
            var g = s1(h, d, f) - u1;
            h -= g / p;
        }
        return h;
    }
    function c(u1, h, d, f) {
        if (!(0 <= u1 && u1 <= 1 && 0 <= d && d <= 1)) return;
        var m = new Float32Array(n1);
        if (u1 !== h || d !== f) for(var p = 0; p < n1; ++p)m[p] = s1(p * t, u1, d);
        function g(y) {
            for(var x = 0, v = 1, b = n1 - 1; v !== b && m[v] <= y; ++v)x += t;
            --v;
            var w = (y - m[v]) / (m[v + 1] - m[v]), A = x + w * t, T = o(A, u1, d);
            return T >= .001 ? l(y, A, u1, d) : T === 0 ? A : a(y, x, x + t, u1, d);
        }
        return function(y) {
            return u1 === h && d === f || y === 0 || y === 1 ? y : s1(g(y), h, f);
        };
    }
    return c;
}(), aR = function() {
    var n1 = {
        linear: function() {
            return function(r) {
                return r;
            };
        }
    }, t = {
        Sine: function() {
            return function(r) {
                return 1 - Math.cos(r * Math.PI / 2);
            };
        },
        Circ: function() {
            return function(r) {
                return 1 - Math.sqrt(1 - r * r);
            };
        },
        Back: function() {
            return function(r) {
                return r * r * (3 * r - 2);
            };
        },
        Bounce: function() {
            return function(r) {
                for(var i, s1 = 4; r < ((i = Math.pow(2, --s1)) - 1) / 11;);
                return 1 / Math.pow(4, 3 - s1) - 7.5625 * Math.pow((i * 3 - 2) / 22 - r, 2);
            };
        },
        Elastic: function(r, i) {
            r === void 0 && (r = 1), i === void 0 && (i = .5);
            var s1 = $s(r, 1, 10), o = $s(i, .1, 2);
            return function(a) {
                return a === 0 || a === 1 ? a : -s1 * Math.pow(2, 10 * (a - 1)) * Math.sin((a - 1 - o / (Math.PI * 2) * Math.asin(1 / s1)) * (Math.PI * 2) / o);
            };
        }
    }, e = [
        "Quad",
        "Cubic",
        "Quart",
        "Quint",
        "Expo"
    ];
    return e.forEach(function(r, i) {
        t[r] = function() {
            return function(s1) {
                return Math.pow(s1, i + 2);
            };
        };
    }), Object.keys(t).forEach(function(r) {
        var i = t[r];
        n1["easeIn" + r] = i, n1["easeOut" + r] = function(s1, o) {
            return function(a) {
                return 1 - i(s1, o)(1 - a);
            };
        }, n1["easeInOut" + r] = function(s1, o) {
            return function(a) {
                return a < .5 ? i(s1, o)(a * 2) / 2 : 1 - i(s1, o)(a * -2 + 2) / 2;
            };
        };
    }), n1;
}();
function QA(n1, t) {
    if (dt.fnc(n1)) return n1;
    var e = n1.split("(")[0], r = aR[e], i = sR(n1);
    switch(e){
        case "spring":
            return oR(n1, t);
        case "cubicBezier":
            return WA(uY, i);
        case "steps":
            return WA(cY, i);
        default:
            return WA(r, i);
    }
}
function lR(n1) {
    try {
        var t = document.querySelectorAll(n1);
        return t;
    } catch  {
        return;
    }
}
function J0(n1, t) {
    for(var e = n1.length, r = arguments.length >= 2 ? arguments[1] : void 0, i = [], s1 = 0; s1 < e; s1++)if (s1 in n1) {
        var o = n1[s1];
        t.call(r, o, s1, n1) && i.push(o);
    }
    return i;
}
function $0(n1) {
    return n1.reduce(function(t, e) {
        return t.concat(dt.arr(e) ? $0(e) : e);
    }, []);
}
function $O(n1) {
    return dt.arr(n1) ? n1 : (dt.str(n1) && (n1 = lR(n1) || n1), n1 instanceof NodeList || n1 instanceof HTMLCollection ? [].slice.call(n1) : [
        n1
    ]);
}
function ZA(n1, t) {
    return n1.some(function(e) {
        return e === t;
    });
}
function JA(n1) {
    var t = {};
    for(var e in n1)t[e] = n1[e];
    return t;
}
function qA(n1, t) {
    var e = JA(n1);
    for(var r in n1)e[r] = t.hasOwnProperty(r) ? t[r] : n1[r];
    return e;
}
function ex(n1, t) {
    var e = JA(n1);
    for(var r in t)e[r] = dt.und(n1[r]) ? t[r] : n1[r];
    return e;
}
function hY(n1) {
    var t = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(n1);
    return t ? "rgba(" + t[1] + ",1)" : n1;
}
function dY(n1) {
    var t = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, e = n1.replace(t, function(a, l, c, u1) {
        return l + l + c + c + u1 + u1;
    }), r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e), i = parseInt(r[1], 16), s1 = parseInt(r[2], 16), o = parseInt(r[3], 16);
    return "rgba(" + i + "," + s1 + "," + o + ",1)";
}
function fY(n1) {
    var t = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(n1) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(n1), e = parseInt(t[1], 10) / 360, r = parseInt(t[2], 10) / 100, i = parseInt(t[3], 10) / 100, s1 = t[4] || 1;
    function o(d, f, m) {
        return m < 0 && (m += 1), m > 1 && (m -= 1), m < 1 / 6 ? d + (f - d) * 6 * m : m < 0.5 ? f : m < 2 / 3 ? d + (f - d) * (2 / 3 - m) * 6 : d;
    }
    var a, l, c;
    if (r == 0) a = l = c = i;
    else {
        var u1 = i < .5 ? i * (1 + r) : i + r - i * r, h = 2 * i - u1;
        a = o(h, u1, e + 1 / 3), l = o(h, u1, e), c = o(h, u1, e - 1 / 3);
    }
    return "rgba(" + a * 255 + "," + l * 255 + "," + c * 255 + "," + s1 + ")";
}
function pY(n1) {
    if (dt.rgb(n1)) return hY(n1);
    if (dt.hex(n1)) return dY(n1);
    if (dt.hsl(n1)) return fY(n1);
}
function Ha(n1) {
    var t = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(n1);
    if (t) return t[1];
}
function mY(n1) {
    if (wm(n1, "translate") || n1 === "perspective") return "px";
    if (wm(n1, "rotate") || wm(n1, "skew")) return "deg";
}
function XA(n1, t) {
    return dt.fnc(n1) ? n1(t.target, t.id, t.total) : n1;
}
function zo(n1, t) {
    return n1.getAttribute(t);
}
function $A(n1, t, e) {
    var r = Ha(t);
    if (ZA([
        e,
        "deg",
        "rad",
        "turn"
    ], r)) return t;
    var i = Z0.CSS[t + e];
    if (!dt.und(i)) return i;
    var s1 = 100, o = document.createElement(n1.tagName), a = n1.parentNode && n1.parentNode !== document ? n1.parentNode : document.body;
    a.appendChild(o), o.style.position = "absolute", o.style.width = s1 + e;
    var l = s1 / o.offsetWidth;
    a.removeChild(o);
    var c = l * parseFloat(t);
    return Z0.CSS[t + e] = c, c;
}
function cR(n1, t, e) {
    if (t in n1.style) {
        var r = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), i = n1.style[t] || getComputedStyle(n1).getPropertyValue(r) || "0";
        return e ? $A(n1, i, e) : i;
    }
}
function eE(n1, t) {
    if (dt.dom(n1) && !dt.inp(n1) && (zo(n1, t) || dt.svg(n1) && n1[t])) return "attribute";
    if (dt.dom(n1) && ZA(lY, t)) return "transform";
    if (dt.dom(n1) && t !== "transform" && cR(n1, t)) return "css";
    if (n1[t] != null) return "object";
}
function uR(n1) {
    if (!!dt.dom(n1)) {
        for(var t = n1.style.transform || "", e = /(\w+)\(([^)]*)\)/g, r = new Map, i; i = e.exec(t);)r.set(i[1], i[2]);
        return r;
    }
}
function gY(n1, t, e, r) {
    var i = wm(t, "scale") ? 1 : 0 + mY(t), s1 = uR(n1).get(t) || i;
    return e && (e.transforms.list.set(t, s1), e.transforms.last = t), r ? $A(n1, s1, r) : s1;
}
function tE(n1, t, e, r) {
    switch(eE(n1, t)){
        case "transform":
            return gY(n1, t, r, e);
        case "css":
            return cR(n1, t, e);
        case "attribute":
            return zo(n1, t);
        default:
            return n1[t] || 0;
    }
}
function rE(n1, t) {
    var e = /^(\*=|\+=|-=)/.exec(n1);
    if (!e) return n1;
    var r = Ha(n1) || 0, i = parseFloat(t), s1 = parseFloat(n1.replace(e[0], ""));
    switch(e[0][0]){
        case "+":
            return i + s1 + r;
        case "-":
            return i - s1 + r;
        case "*":
            return i * s1 + r;
    }
}
function hR(n1, t) {
    if (dt.col(n1)) return pY(n1);
    if (/\s/g.test(n1)) return n1;
    var e = Ha(n1), r = e ? n1.substr(0, n1.length - e.length) : n1;
    return t ? r + t : r;
}
function iE(n1, t) {
    return Math.sqrt(Math.pow(t.x - n1.x, 2) + Math.pow(t.y - n1.y, 2));
}
function yY(n1) {
    return Math.PI * 2 * zo(n1, "r");
}
function vY(n1) {
    return zo(n1, "width") * 2 + zo(n1, "height") * 2;
}
function xY(n1) {
    return iE({
        x: zo(n1, "x1"),
        y: zo(n1, "y1")
    }, {
        x: zo(n1, "x2"),
        y: zo(n1, "y2")
    });
}
function dR(n1) {
    for(var t = n1.points, e = 0, r, i = 0; i < t.numberOfItems; i++){
        var s1 = t.getItem(i);
        i > 0 && (e += iE(r, s1)), r = s1;
    }
    return e;
}
function bY(n1) {
    var t = n1.points;
    return dR(n1) + iE(t.getItem(t.numberOfItems - 1), t.getItem(0));
}
function fR(n1) {
    if (n1.getTotalLength) return n1.getTotalLength();
    switch(n1.tagName.toLowerCase()){
        case "circle":
            return yY(n1);
        case "rect":
            return vY(n1);
        case "line":
            return xY(n1);
        case "polyline":
            return dR(n1);
        case "polygon":
            return bY(n1);
    }
}
function SY(n1) {
    var t = fR(n1);
    return n1.setAttribute("stroke-dasharray", t), t;
}
function wY(n1) {
    for(var t = n1.parentNode; dt.svg(t) && dt.svg(t.parentNode);)t = t.parentNode;
    return t;
}
function pR(n1, t) {
    var e = t || {}, r = e.el || wY(n1), i = r.getBoundingClientRect(), s1 = zo(r, "viewBox"), o = i.width, a = i.height, l = e.viewBox || (s1 ? s1.split(" ") : [
        0,
        0,
        o,
        a
    ]);
    return {
        el: r,
        viewBox: l,
        x: l[0] / 1,
        y: l[1] / 1,
        w: o / l[2],
        h: a / l[3]
    };
}
function AY(n1, t) {
    var e = dt.str(n1) ? lR(n1)[0] : n1, r = t || 100;
    return function(i) {
        return {
            property: i,
            el: e,
            svg: pR(e),
            totalLength: fR(e) * (r / 100)
        };
    };
}
function EY(n1, t) {
    function e(a) {
        a === void 0 && (a = 0);
        var l = t + a >= 1 ? t + a : 0;
        return n1.el.getPointAtLength(l);
    }
    var r = pR(n1.el, n1.svg), i = e(), s1 = e(-1), o = e(1);
    switch(n1.property){
        case "x":
            return (i.x - r.x) * r.w;
        case "y":
            return (i.y - r.y) * r.h;
        case "angle":
            return Math.atan2(o.y - s1.y, o.x - s1.x) * 180 / Math.PI;
    }
}
function eR(n1, t) {
    var e = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g, r = hR(dt.pth(n1) ? n1.totalLength : n1, t) + "";
    return {
        original: r,
        numbers: r.match(e) ? r.match(e).map(Number) : [
            0
        ],
        strings: dt.str(n1) || t ? r.split(e) : []
    };
}
function mR(n1) {
    var t = n1 ? $0(dt.arr(n1) ? n1.map($O) : $O(n1)) : [];
    return J0(t, function(e, r, i) {
        return i.indexOf(e) === r;
    });
}
function gR(n1) {
    var t = mR(n1);
    return t.map(function(e, r) {
        return {
            target: e,
            id: r,
            total: t.length,
            transforms: {
                list: uR(e)
            }
        };
    });
}
function TY(n1, t) {
    var e = JA(t);
    if (/^spring/.test(e.easing) && (e.duration = oR(e.easing)), dt.arr(n1)) {
        var r = n1.length, i = r === 2 && !dt.obj(n1[0]);
        i ? n1 = {
            value: n1
        } : dt.fnc(t.duration) || (e.duration = t.duration / r);
    }
    var s1 = dt.arr(n1) ? n1 : [
        n1
    ];
    return s1.map(function(o, a) {
        var l = dt.obj(o) && !dt.pth(o) ? o : {
            value: o
        };
        return dt.und(l.delay) && (l.delay = a ? 0 : t.delay), dt.und(l.endDelay) && (l.endDelay = a === s1.length - 1 ? t.endDelay : 0), l;
    }).map(function(o) {
        return ex(o, e);
    });
}
function MY(n1) {
    for(var t = J0($0(n1.map(function(s1) {
        return Object.keys(s1);
    })), function(s1) {
        return dt.key(s1);
    }).reduce(function(s1, o) {
        return s1.indexOf(o) < 0 && s1.push(o), s1;
    }, []), e = {}, r = function(s1) {
        var o = t[s1];
        e[o] = n1.map(function(a) {
            var l = {};
            for(var c in a)dt.key(c) ? c == o && (l.value = a[c]) : l[c] = a[c];
            return l;
        });
    }, i = 0; i < t.length; i++)r(i);
    return e;
}
function CY(n1, t) {
    var e = [], r = t.keyframes;
    r && (t = ex(MY(r), t));
    for(var i in t)dt.key(i) && e.push({
        name: i,
        tweens: TY(t[i], n1)
    });
    return e;
}
function PY(n1, t) {
    var e = {};
    for(var r in n1){
        var i = XA(n1[r], t);
        dt.arr(i) && (i = i.map(function(s1) {
            return XA(s1, t);
        }), i.length === 1 && (i = i[0])), e[r] = i;
    }
    return e.duration = parseFloat(e.duration), e.delay = parseFloat(e.delay), e;
}
function _Y(n1, t) {
    var e;
    return n1.tweens.map(function(r) {
        var i = PY(r, t), s1 = i.value, o = dt.arr(s1) ? s1[1] : s1, a = Ha(o), l = tE(t.target, n1.name, a, t), c = e ? e.to.original : l, u1 = dt.arr(s1) ? s1[0] : c, h = Ha(u1) || Ha(l), d = a || h;
        return dt.und(o) && (o = c), i.from = eR(u1, d), i.to = eR(rE(o, u1), d), i.start = e ? e.end : 0, i.end = i.start + i.delay + i.duration + i.endDelay, i.easing = QA(i.easing, i.duration), i.isPath = dt.pth(s1), i.isColor = dt.col(i.from.original), i.isColor && (i.round = 1), e = i, i;
    });
}
var yR = {
    css: function(n1, t, e) {
        return n1.style[t] = e;
    },
    attribute: function(n1, t, e) {
        return n1.setAttribute(t, e);
    },
    object: function(n1, t, e) {
        return n1[t] = e;
    },
    transform: function(n1, t, e, r, i) {
        if (r.list.set(t, e), t === r.last || i) {
            var s1 = "";
            r.list.forEach(function(o, a) {
                s1 += a + "(" + o + ") ";
            }), n1.style.transform = s1;
        }
    }
};
function vR(n1, t) {
    var e = gR(n1);
    e.forEach(function(r) {
        for(var i in t){
            var s1 = XA(t[i], r), o = r.target, a = Ha(s1), l = tE(o, i, a, r), c = a || Ha(l), u1 = rE(hR(s1, c), l), h = eE(o, i);
            yR[h](o, i, u1, r.transforms, !0);
        }
    });
}
function IY(n1, t) {
    var e = eE(n1.target, t.name);
    if (e) {
        var r = _Y(t, n1), i = r[r.length - 1];
        return {
            type: e,
            property: t.name,
            animatable: n1,
            tweens: r,
            duration: i.end,
            delay: r[0].delay,
            endDelay: i.endDelay
        };
    }
}
function DY(n1, t) {
    return J0($0(n1.map(function(e) {
        return t.map(function(r) {
            return IY(e, r);
        });
    })), function(e) {
        return !dt.und(e);
    });
}
function xR(n1, t) {
    var e = n1.length, r = function(s1) {
        return s1.timelineOffset ? s1.timelineOffset : 0;
    }, i = {};
    return i.duration = e ? Math.max.apply(Math, n1.map(function(s1) {
        let o = s1.startOnceDelay ?? 0, a = s1.pingPongDelayCorrection ?? 0, l = s1.pingPongEndDelayCorrection ?? 0;
        return r(s1) + o + a + l + s1.duration * (s1.loop ?? 1);
    })) : t.duration, i.delay = e ? Math.min.apply(Math, n1.map(function(s1) {
        let o = s1.startOnceDelay ?? 0, a = s1.pingPongDelayCorrection ?? 0;
        return r(s1) + o + a + s1.delay;
    })) : t.delay, i.endDelay = e ? i.duration - Math.max.apply(Math, n1.map(function(s1) {
        let o = s1.startOnceDelay ?? 0, a = s1.pingPongDelayCorrection ?? 0, l = s1.pingPongEndDelayCorrection ?? 0;
        return r(s1) + o + a + s1.duration * (s1.loop ?? 1) - s1.endDelay - l;
    })) : t.endDelay, i;
}
var tR = 0;
function OY(n1) {
    var t = qA(nR, n1), e = qA(KA, n1), r = CY(e, n1), i = gR(n1.targets), s1 = DY(i, r), o = xR(s1, e), a = tR;
    return tR++, ex(t, {
        id: a,
        children: [],
        animatables: i,
        animations: s1,
        duration: o.duration,
        delay: o.delay,
        endDelay: o.endDelay,
        startOnceDelay: e.startOnceDelay,
        pingPongDelayCorrection: e.pingPongDelayCorrection,
        pingPongEndDelayCorrection: e.pingPongEndDelayCorrection
    });
}
var Ts = [], rR = [], Ed, YA = function() {
    let n1 = 0, t = !0;
    function e(s1) {
        let o = Ts.length;
        if (o) {
            let a = 0;
            for(; a < o;){
                let l = Ts[a];
                l.paused ? (Ts.splice(a, 1), o--) : (l.tick(s1), a++);
            }
            t && (Ed = requestAnimationFrame(e));
        } else Ed && (cancelAnimationFrame(Ed), Ed = null);
    }
    function r() {
        n1 = performance.now(), Ed = requestAnimationFrame(e);
    }
    function i(s1) {
        n1 += s1, e(n1);
    }
    return {
        get isUsingInternalRaf () {
            return t;
        },
        set isUsingInternalRaf (s){
            t = s;
        },
        play: r,
        update: i
    };
}();
function RY(n1) {
    !YA.isUsingInternalRaf || (document.hidden ? (Ts.forEach(function(t) {
        return t.pause(n1.timeStamp);
    }), rR = Ts.slice(0), ci.running = Ts = []) : rR.forEach(function(t) {
        return t.play(n1.timeStamp);
    }));
}
typeof document < "u" && document.addEventListener("visibilitychange", RY);
function ci(n1) {
    n1 === void 0 && (n1 = {});
    var t = 0, e = 0, r = 0, i, s1, o = 0, a = null;
    function l(T) {
        var S = window.Promise && new Promise(function(M) {
            return a = M;
        });
        return T.finished = S, S;
    }
    var c = OY(n1), u1 = l(c);
    function h() {
        var T = c.direction;
        T !== "alternate" && (c.direction = T !== "normal" ? "normal" : "reverse"), c.reversed = !c.reversed, s1.forEach(function(S) {
            (S.loop === 1 || S.loop % 2 === 0) && (S.reversed = c.reversed);
        });
    }
    function d() {
        c.direction = "normal", c.reversed = !1, s1.forEach(function(T) {
            return T.reversed = !1;
        });
    }
    function f(T) {
        return c.reversed ? c.duration - T : T;
    }
    function m() {
        t = 0, e = f(c.currentTime) * (1 / ci.speed);
    }
    function p(T, S, M = !1) {
        S && (c.reversed ? S.seek(S.duration * S.loop - (T - S.timelineOffset - S.pingPongDelayCorrection), M) : S.seek(T - S.timelineOffset - S.startOnceDelay - S.pingPongDelayCorrection, M));
    }
    function g(T, S = !1) {
        if (c.reversed) for(var C = o; C--;)p(T, s1[C], S);
        else for(var M = 0; M < o; M++)p(T, s1[M], S);
    }
    function y(T) {
        var S = 0, M = c.animations, C = M.length;
        for(c.direction !== "alternate" && c.parent?.direction === "alternate" ? c.parent?.rewind === !1 && c.reversePlayback === !0 && c.rewind === !1 && (c.parent?.reversed && c.direction === "alternate" ? T = c.duration - c.delay + c.endDelay - T : T = c.duration + c.delay - c.endDelay - T) : w(!1, c.parent?.rewind, c.rewind, c.parent?.reversePlayback, c.reversePlayback) && (c.parent?.reversed && c.direction === "alternate" ? T = c.duration - c.delay + c.endDelay - T : T = c.duration + c.delay - c.endDelay - T); S < C;){
            var P = M[S], _ = P.animatable, I = P.tweens, O = I.length - 1, L = I[O];
            O && (L = J0(I, function(J) {
                return T < J.end;
            })[0] || L);
            let re;
            c.parent?.reversed && c.direction === "alternate" ? re = $s(T - L.start - L.endDelay, 0, L.duration) / L.duration : re = $s(T - L.start - L.delay, 0, L.duration) / L.duration;
            for(var j = isNaN(re) ? 1 : L.easing(re), V = L.to.strings, H = L.round, q = [], X = L.to.numbers.length, K = void 0, z = 0; z < X; z++){
                var Q = void 0;
                let J, Ee;
                c.direction !== "alternate" ? c.parent?.rewind === !1 && c.reversePlayback === !0 && c.rewind === !1 ? (J = L.to.numbers[z], Ee = L.from.numbers[z] || 0) : (Ee = L.to.numbers[z], J = L.from.numbers[z] || 0) : w(!0, c.parent?.rewind, c.rewind, c.parent?.reversePlayback, c.reversePlayback) ? (J = L.to.numbers[z], Ee = L.from.numbers[z] || 0) : (Ee = L.to.numbers[z], J = L.from.numbers[z] || 0), L.isPath ? Q = EY(L.value, j * Ee) : Q = J + j * (Ee - J), H && (L.isColor && z > 2 || (Q = Math.round(Q * H) / H)), q.push(Q);
            }
            var te = V.length;
            if (!te) K = q[0];
            else {
                K = V[0];
                for(var $ = 0; $ < te; $++){
                    var W = V[$], oe = V[$ + 1], ie = q[$];
                    isNaN(ie) || (oe ? K += ie + oe : K += ie + " ");
                }
            }
            yR[P.type](_.target, P.property, K, _.transforms), P.currentValue = K, S++;
        }
    }
    function x(T) {
        c[T] && !c.passThrough && c[T](c);
    }
    function v() {
        c.remaining && c.remaining !== !0 && c.remaining--;
    }
    let b = {
        0: !1,
        1: !0,
        2: !1,
        3: !0,
        4: !1,
        5: !1,
        6: !1,
        7: !1,
        8: !1,
        9: !0,
        10: !0,
        11: !1,
        12: !1,
        13: !1,
        14: !0,
        15: !0,
        16: !1,
        17: !0,
        18: !0,
        19: !1,
        20: !1,
        21: !1,
        22: !0,
        23: !0,
        24: !1,
        25: !0,
        26: !1,
        27: !0,
        28: !1,
        29: !1,
        30: !1,
        31: !1
    };
    function w(T, S, M, C, P) {
        return b[T << 4 | S << 3 | M << 2 | C << 1 | P];
    }
    function A(T, S = !1) {
        var M = c.duration;
        let C = c.delay, P = M - c.endDelay;
        c.parent?.reversed && c.direction === "alternate" && (C = c.endDelay, P = M - c.delay);
        var _ = f(T);
        if (c.progress = $s(_ / M * 100, 0, 100), S || (c.reversePlayback = _ < c.currentTime), o && g(_, S), !c.began && _ >= C && (c.began = !0), !c.loopBegan && c.currentTime > 0 && (c.loopBegan = !0, x("loopBegin")), (c.reversed || _ >= 0) && _ <= C && c.currentTime !== 0 && (y(0), x("change")), (_ >= P && c.currentTime !== M + c.pingPongDelayCorrection || !M) && (y(M), x("change")), _ > C && _ < P ? (c.changeBegan || (c.changeBegan = !0, c.changeCompleted = !1, x("changeBegin")), y(_), x("change")) : c.changeBegan ? (c.changeCompleted = !0, c.changeBegan = !1, x("change"), o && x("timelineChangeComplete")) : c.began && _ > P && x("changeComplete"), c.currentTime = $s(_, 0, M + c.pingPongDelayCorrection), c.began && x("update"), T >= M) {
            if (v(), !c.remaining) c.paused = !0, c.completed || (c.completed = !0, x("loopComplete"), x("complete"), !c.passThrough && "Promise" in window && (a(), u1 = l(c)));
            else {
                o ? t += c.duration / ci.speed : t += c.duration;
                for (let I of s1)I.setStartTime(0), I.remaining = I.loop;
                x("loopComplete"), c.loopBegan = !1, c.direction === "alternate" ? h() : o && d();
            }
        }
    }
    return c.reset = function() {
        var T = c.direction;
        c.passThrough = !1, c.currentTime = 0, c.progress = 0, c.paused = !0, c.began = !1, c.loopBegan = !1, c.changeBegan = !1, c.completed = !1, c.changeCompleted = !1, c.reversed = T === "reverse", c.remaining = c.loop, s1 = c.children, o = s1.length;
        for(var S = o; S--;)c.children[S].reset();
        y(c.reversed ? c.duration : 0);
    }, c.setStartTime = function(T) {
        t = T;
    }, c.set = function(T, S) {
        return vR(T, S), c;
    }, c.tick = function(T) {
        r = T, t || (t = r), A((r + (e - t)) * ci.speed);
    }, c.seek = function(T, S = !1) {
        A(T - t, S);
    }, c.pause = function(T) {
        c.paused = !0, o && (i = T ?? performance.now());
    }, c.play = function(T) {
        !c.paused || (c.completed && c.reset(), c.paused = !1, Ts.push(c), o && i !== void 0 && (t += (T ?? performance.now()) - i), !Ed && YA.isUsingInternalRaf && YA.play());
    }, c.reverse = function(T = 0) {
        h(), c.completed = !c.reversed, t = void 0, e = T;
    }, c.restart = function() {
        c.reset(), t = void 0, e = 0, c.play();
    }, c.reset(), c.autoplay && c.play(), c;
}
function iR(n1, t) {
    for(var e = t.length; e--;)ZA(n1, t[e].animatable.target) && t.splice(e, 1);
}
function LY(n1) {
    for(var t = mR(n1), e = Ts.length; e--;){
        var r = Ts[e], i = r.animations, s1 = r.children;
        iR(t, i);
        for(var o = s1.length; o--;){
            var a = s1[o], l = a.animations;
            iR(t, l), !l.length && !a.children.length && s1.splice(o, 1);
        }
        !i.length && !s1.length && r.pause();
    }
}
function NY(n1, t) {
    t === void 0 && (t = {});
    var e = t.direction || "normal", r = t.easing ? QA(t.easing) : null, i = t.grid, s1 = t.axis, o = t.from || 0, a = o === "first", l = o === "center", c = o === "last", u1 = dt.arr(n1), h = parseFloat(u1 ? n1[0] : n1), d = u1 ? parseFloat(n1[1]) : 0, f = Ha(u1 ? n1[1] : n1) || 0, m = t.start || 0 + (u1 ? h : 0), p = [], g = 0;
    return function(y, x, v) {
        if (a && (o = 0), l && (o = (v - 1) / 2), c && (o = v - 1), !p.length) {
            for(var b = 0; b < v; b++){
                if (!i) p.push(Math.abs(o - b));
                else {
                    var w = l ? (i[0] - 1) / 2 : o % i[0], A = l ? (i[1] - 1) / 2 : Math.floor(o / i[0]), T = b % i[0], S = Math.floor(b / i[0]), M = w - T, C = A - S, P = Math.sqrt(M * M + C * C);
                    s1 === "x" && (P = -M), s1 === "y" && (P = -C), p.push(P);
                }
                g = Math.max.apply(Math, p);
            }
            r && (p = p.map(function(I) {
                return r(I / g) * g;
            })), e === "reverse" && (p = p.map(function(I) {
                return s1 ? I < 0 ? I * -1 : -I : Math.abs(g - I);
            }));
        }
        var _ = u1 ? (d - h) / g : h;
        return m + _ * (Math.round(p[x] * 100) / 100) + f;
    };
}
function BY(n1) {
    n1 === void 0 && (n1 = {});
    var t = ci(n1);
    return t.duration = 0, t.add = function(e, r) {
        var i = Ts.indexOf(t), s1 = t.children;
        i > -1 && Ts.splice(i, 1);
        function o(d) {
            d.passThrough = !0;
        }
        for(var a = 0; a < s1.length; a++)o(s1[a]);
        var l = ex(e, qA(KA, n1));
        l.targets = l.targets || n1.targets;
        var c = t.duration;
        l.autoplay = !1, l.timelineOffset = dt.und(r) ? c : rE(r, c), o(t);
        var u1 = ci(l);
        o(u1), s1.push(u1), u1.parent = t;
        var h = xR(s1, n1);
        return t.delay = h.delay, t.endDelay = h.endDelay, t.duration = h.duration, u1.loop === !0 && (t.duration = 1 / 0), t.seek(0), t.reset(), t.autoplay && t.play(), t;
    }, t;
}
ci.version = "3.2.0";
ci.speed = 1;
ci.running = Ts;
ci.remove = LY;
ci.get = tE;
ci.set = vR;
ci.convertPx = $A;
ci.path = AY;
ci.setDashoffset = SY;
ci.stagger = NY;
ci.timeline = BY;
ci.easing = QA;
ci.penner = aR;
ci.random = function(n1, t) {
    return Math.floor(Math.random() * (t - n1 + 1)) + n1;
};
var Ms = ci;
var cr = class extends Ge {
    constructor(e, r, i, s1){
        super(e, r, i);
        this.isColorA = !0;
        this.a = s1;
    }
    setRGBA(e, r, i, s1) {
        super.setRGB(e, r, i), this.a = s1;
    }
    copy(e) {
        return super.copy(e), this.a = "a" in e ? e.a : 1, this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b, this.a);
    }
    equals(e) {
        return super.equals(e) && this.a === e.a;
    }
    setStyle(e, r = "srgb") {
        let i;
        if (e === "transparent") return this.setRGBA(0, 0, 0, 0), this;
        if (i = /^((?:rgb|hsl)a?)\(([^)]*)\)/.exec(e)) {
            let s1, o = i[1], a = i[2];
            switch(o){
                case "rgb":
                case "rgba":
                    if (s1 = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.a = o === "rgba" ? parseFloat(s1[4]) : 1, super.setStyle(e, r);
                    break;
                case "hsl":
                case "hsla":
                    if (s1 = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)%\s*,\s*(\d*\.?\d+)%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.a = o === "hsla" ? parseFloat(s1[4]) : 1, super.setStyle(e, r);
                    break;
            }
        }
        return super.setStyle(e, r);
    }
    get x() {
        return this.r;
    }
    get y() {
        return this.g;
    }
    get z() {
        return this.b;
    }
    get w() {
        return this.a;
    }
    set x(e) {
        this.r = e;
    }
    set y(e) {
        this.g = e;
    }
    set z(e) {
        this.b = e;
    }
    set w(e) {
        this.a = e;
    }
};
var { degToRad: Wye, radToDeg: qye } = Se, bR = new E, SR = new E, wR = new Ye, FY = 1e-4;
function ER(n1, t, e, r) {
    if (r === 0) return e.copy(n1);
    if (r === 1) return e.copy(t);
    let i = n1.w * t.w + n1.x * t.x + n1.y * t.y + n1.z * t.z;
    if (i >= 1) return e.copy(n1);
    let s1 = 1 - i * i;
    if (s1 <= Number.EPSILON) {
        let u1 = 1 - r;
        return e.w = u1 * n1.w + r * t.w, e.x = u1 * n1.x + r * t.x, e.y = u1 * n1.y + r * t.y, e.z = u1 * n1.z + r * t.z, e.normalize(), e;
    }
    let o = Math.sqrt(s1), a = Math.atan2(o, i), l = Math.sin((1 - r) * a) / o, c = Math.sin(r * a) / o;
    return e.w = n1.w * l + t.w * c, e.x = n1.x * l + t.x * c, e.y = n1.y * l + t.y * c, e.z = n1.z * l + t.z * c, e;
}
function ii(n1, t, e, r, i, s1) {
    let o = e[n1] !== void 0 ? e[n1] : void 0, a = r[n1];
    if (a == null) return;
    let l = o != null ? typeof o == "string" ? Number(i.getVariable(o) ?? 0) : o : t[n1], c = typeof a == "string" ? Number(i.getVariable(a) ?? 0) : a;
    if (l !== c) return {
        update: (u1)=>{
            let h = Se.lerp(l, c, u1);
            s1 ? t[n1] = Math.trunc(h) : t[n1] = h;
        },
        start: ()=>{
            t[n1] = l;
        },
        end: ()=>{
            t[n1] = c;
        }
    };
}
function Em(n1, t, e, r, i, s1) {
    let o = e[n1] ? e[n1] : void 0, a = r[n1];
    if (!a) return;
    let l = t[n1], c = [
        ...o ?? l
    ].map((h)=>typeof h == "string" ? Number(i.getVariable(h) ?? 0) : h), u1 = [
        ...a
    ].map((h)=>typeof h == "string" ? Number(i.getVariable(h) ?? 0) : h);
    if (!(c.length !== u1.length || Qc(c, u1))) return {
        update: (h)=>{
            c.forEach((d, f)=>{
                let m = Se.lerp(d, u1[f], h);
                t[n1][f] = s1 ? Math.trunc(m) : m;
            });
        },
        start: ()=>{
            Object.assign(t[n1], c);
        },
        end: ()=>{
            Object.assign(t[n1], u1);
        }
    };
}
function Am(n1, t, e) {
    return t.forEach((r, i)=>{
        n1.setComponent(i, typeof r == "string" ? Number(e.getVariable(r) ?? 0) : r);
    }), n1;
}
function nE(n1, t, e, r, i) {
    let s1 = e[n1] ? e[n1] : void 0, o = r[n1];
    if (!o) return;
    let a = t[n1], l = s1 ? Am(new E, s1, i) : a.clone(), c = Am(new E, o, i);
    if (!l.equals(c)) return {
        update: (u1)=>{
            a.lerpVectors(l, c, u1);
        },
        start: ()=>{
            a.copy(l);
        },
        end: ()=>{
            a.copy(c);
        }
    };
}
function AR(n1, t, e) {
    return t.forEach((r, i)=>{
        n1.setComponent(i, typeof r == "string" ? Number(e.getVariable(r) ?? 0) : r);
    }), n1;
}
function Td(n1, t, e, r, i) {
    let s1 = e[n1] ? e[n1] : void 0, o = r[n1];
    if (!o) return;
    let a = t[n1], l = !(a instanceof U), c = a instanceof U ? a : new U().fromArray(a), u1 = s1 ? AR(new U, s1, i) : c.clone(), h = AR(new U, o, i);
    if (!u1.equals(h)) return {
        update: (d)=>{
            c.lerpVectors(u1, h, d), l && (t[n1] = c.toArray());
        },
        start: ()=>{
            c.copy(u1), l && (t[n1] = c.toArray());
        },
        end: ()=>{
            c.copy(h), l && (t[n1] = c.toArray());
        }
    };
}
function TR(n1, t, e, r) {
    let i = e[n1] ? e[n1] : void 0, s1 = r[n1];
    if (!s1) return;
    let o = t[n1], a = i ? new ue().fromArray(i) : o.clone(), l = new E, c = new Ye, u1 = new E;
    a.decompose(l, c, u1);
    let h = new ue().fromArray(s1), d = new E, f = new Ye, m = new E;
    if (h.decompose(d, f, m), !a.equals(h)) return {
        update: (p)=>{
            wR.slerpQuaternions(c, f, p), bR.lerpVectors(l, d, p), SR.lerpVectors(u1, m, p), o.compose(bR, wR, SR);
        },
        start: ()=>{
            o.compose(l, c, u1);
        },
        end: ()=>{
            o.compose(d, f, m);
        }
    };
}
function MR(n1, t, e, r, i) {
    let s1 = e[n1] ? e[n1] : void 0, o = r[n1];
    if (!o) return;
    let a = t[n1], l = s1 ? typeof s1 == "string" ? i.getColor(s1).clone() : new Ge().setRGB(s1.r, s1.g, s1.b) : a.clone(), c = typeof o == "string" ? i.getColor(o).clone() : new Ge().setRGB(o.r, o.g, o.b);
    if (l.equals(c)) return;
    let u1 = a.clone();
    return {
        update: (h)=>{
            u1.lerpColors(l, c, h), t[n1]?.copy?.(u1);
        },
        start: ()=>{
            u1.copy(l);
        },
        end: ()=>{
            u1.copy(c);
        }
    };
}
function Tm(n1, t, e, r, i) {
    let s1 = e[n1] ? e[n1] : void 0, o = r[n1];
    if (!o) return;
    let a = t[n1], l = new cr(a.r, a.g, a.b, a.a), c = s1 ? typeof s1 == "string" ? i.getColor(s1).clone() : new cr(s1.r, s1.g, s1.b, s1.a) : l.clone(), u1 = typeof o == "string" ? i.getColor(o).clone() : new cr(o.r, o.g, o.b, o.a);
    if (!c.equals(u1)) return {
        update: (h)=>{
            l.lerpColors(c, u1, h);
            let d = Se.lerp(c.a, u1.a, h);
            l.a = d, t[n1] = {
                r: l.r,
                g: l.g,
                b: l.b,
                a: l.a
            };
        },
        start: ()=>{
            l.copy(c);
        },
        end: ()=>{
            l.copy(u1);
        }
    };
}
function Go(n1, t, e, r, i) {
    if (typeof t[n1] == "number") return ii(n1, t, e ?? {}, r, i);
    if (Array.isArray(t[n1])) return Em(n1, t, e ?? {}, r, i);
}
var Xye = new Jt;
function jo(n1, t, e, r, i) {
    let s1 = e[n1], o = r[n1];
    if (typeof t[n1] == "number") Math.abs(s1 - o) > FY && (t[n1] = Se.lerp(s1, o, i));
    else if (Array.isArray(t[n1])) for(let a = 0, l = s1.length; a < l; a++)t[n1][a] = Se.lerp(s1[a], o[a], i);
}
function CR(n1, t, e, r) {
    let i = [];
    if (!("cloner" in e) || !n1.cloner) return i;
    let s1 = n1.cloner, o = "cloner" in t ? t.cloner : {}, a = e.cloner;
    TA.forEach((f)=>{
        let m;
        f === "count" ? m = ii("count", s1.parameters, o, a, r.shared, !0) : m = Go(f, s1.parameters, o ?? {}, a, r.shared), m && i.push(m);
    });
    let l = VY(s1, o, a, r.shared);
    l?.length && i.push(...l);
    let c = UY(s1, o, a, r.shared);
    c?.length && i.push(...c);
    let u1 = kY(s1, o, a, r.shared);
    u1?.length && i.push(...u1);
    let h = zY(s1, o, a, r.shared);
    h?.length && i.push(...h);
    let d = GY(s1, o, a, r.shared);
    return d?.length && i.push(...d), i.length && i.push({
        update: ()=>{
            s1.update(r);
        }
    }), i;
}
function VY(n1, t, e, r) {
    if (n1.parameters.type !== "radial") return;
    let i = t.radial, s1 = e.radial;
    if (!s1) return;
    let o = n1.parameters.radial, a = [];
    return w0.forEach((l)=>{
        let c = Go(l, o, i ?? {}, s1, r);
        c && a.push(c);
    }), a;
}
function UY(n1, t, e, r) {
    if (n1.parameters.type !== "linear") return;
    let i = t.linear, s1 = e.linear;
    if (!s1) return;
    let o = [], a = n1.parameters.linear;
    return A0.forEach((l)=>{
        let c = Go(l, a, i ?? {}, s1, r);
        c && o.push(c);
    }), o;
}
function kY(n1, t, e, r) {
    if (n1.parameters.type !== "grid") return;
    let i = t.grid, s1 = e.grid;
    if (!s1) return;
    let o = [], a = n1.parameters.grid;
    return E0.forEach((l)=>{
        let c;
        l === "count" ? c = Em(l, a, i ?? {}, s1, r, !0) : c = Go(l, a, i ?? {}, s1, r), c && o.push(c);
    }), o;
}
function zY(n1, t, e, r) {
    if (n1.parameters.type !== "toObject") return;
    let i = t.toObject, s1 = e.toObject;
    if (!s1) return;
    let o = [], a = n1.parameters.toObject;
    return T0.forEach((l)=>{
        let c;
        l === "count" ? c = ii(l, a, i ?? {}, s1, r, !0) : c = Go(l, a, i ?? {}, s1, r), c && o.push(c);
    }), o;
}
function GY(n1, t, e, r) {
    if (!n1.parameters.randomness) return;
    let i = t.randomnessObject, s1 = e.randomnessObject;
    if (!s1) return;
    let o = [], a = n1.parameters.randomnessObject;
    return M0.forEach((l)=>{
        let c = Go(l, a, i ?? {}, s1, r);
        c && o.push(c);
    }), o;
}
function PR(n1, t, e, r) {
    let i = r.cloner?.parameters;
    if (!!i) {
        jo("count", i, n1, t, e), i.count = Math.trunc(i.count);
        for (let s1 of w0)jo(s1, i.radial, n1.radial, t.radial, e);
        for (let s1 of A0)jo(s1, i.linear, n1.linear, t.linear, e);
        for (let s1 of E0)jo(s1, i.grid, n1.grid, t.grid, e);
        for (let s1 of T0)jo(s1, i.toObject, n1.toObject, t.toObject, e);
        return i;
    }
}
function _R(n1, t, e, r) {
    let i = r.cloner?.parameters;
    if (!!i) {
        for (let s1 of M0)jo(s1, i.randomnessObject, n1.randomnessObject, t.randomnessObject, e);
        return i;
    }
}
function wi(n1, t = [
    0,
    0
]) {
    let e = n1 && !isNaN(n1[0]) ? n1[0] : t[0], r = n1 && !isNaN(n1[1]) ? n1[1] : t[1];
    return [
        e,
        r
    ];
}
function En(n1, t, e) {
    switch(n1){
        case 0:
            return "cubicBezier( 0, 0, 1, 1 )";
        case 1:
            return "cubicBezier( .25, .1, .25, 1 )";
        case 2:
            return "cubicBezier( .42, 0, 1, 1 )";
        case 3:
            return "cubicBezier( 0, 0, .58, 1 )";
        case 4:
            return "cubicBezier( .42, 0, .58, 1 )";
        case 7:
            return "cubicBezier( .25, 1, .5, 1 )";
        case 5:
            let { control1: r, control2: i } = t ?? {
                ...ld.defaultData
            };
            return `cubicBezier( ${r[0]}, ${r[1]}, ${i[0]}, ${i[1]} )`;
        case 6:
            let { mass: s1, stiffness: o, damping: a, velocity: l } = e ?? {
                ...ad.defaultData
            }, c = new sE(s1, o, a, l), u1 = c.solve(1);
            return ()=>(h)=>c.solve(h) / u1;
        case 8:
            return ()=>(h)=>Math.floor(h);
    }
}
var IR;
((t)=>{
    function n1(e) {
        return e && typeof e.x == "number" && typeof e.y == "number" && typeof e.z == "number";
    }
    t.is = n1;
})(IR || (IR = {}));
var tx;
((a)=>{
    function n1(l, c) {
        let u1 = [
            0,
            0
        ], h = [
            1,
            1
        ];
        if (l?.cubicControls) u1 = wi(l.cubicControls.control1, u1);
        else switch(l?.type){
            case 2:
                u1 = [
                    .42,
                    0
                ];
                break;
            case 3:
                u1 = [
                    0,
                    0
                ];
                break;
            case 4:
                u1 = [
                    .42,
                    0
                ];
                break;
            case 1:
                u1 = [
                    .25,
                    .1
                ];
                break;
            case 0:
                u1 = [
                    0,
                    0
                ];
                break;
            case 7:
                u1 = [
                    .25,
                    1
                ];
                break;
        }
        if (c?.cubicControls) h = wi(c.cubicControls.control2, h);
        else switch(c?.type){
            case 2:
                h = [
                    1,
                    1
                ];
                break;
            case 3:
                h = [
                    .58,
                    1
                ];
                break;
            case 4:
                h = [
                    .58,
                    1
                ];
                break;
            case 1:
                h = [
                    .25,
                    1
                ];
                break;
            case 0:
                h = [
                    1,
                    1
                ];
                break;
            case 7:
                h = [
                    .5,
                    1
                ];
                break;
        }
        return {
            control1: u1,
            control2: h
        };
    }
    a.getControlsWithDefault = n1;
    function t(l, c) {
        return {
            id: l,
            name: c,
            to: 5,
            properties: new Re
        };
    }
    a.defaultData = t;
    function e(l) {
        let c = new Re;
        return l.forEach(({ data: u1, id: h, fi: d })=>{
            if (u1.type === "light") {
                let f = DR([
                    "material",
                    `${u1.category} lighting`
                ], h, d);
                c.push(f);
            } else {
                let f = DR([
                    "material",
                    u1.type
                ], h, d);
                c.push(f);
            }
        }), c;
    }
    a.createMaterialGroup = e;
    function r(l) {
        return Object.entries(l).reduce((c, [u1, h])=>(typeof h != "string" && c.push({
                name: h.name
            }), c), []);
    }
    a.createName = r;
    function i(l, c, u1) {
        let h = Ms.timeline({
            easing: En(0),
            begin () {
                l.resetBBoxNeedsUpdate();
            },
            change () {
                l.resetBBoxNeedsUpdate();
            },
            direction: c.direction,
            autoplay: !1
        });
        return s1(l, c, u1).forEach((f)=>h.add(f, 0)), h.duration = c.to * 1e3, h;
    }
    a.createTimeline = i;
    function s1(l, c, u1, h) {
        let d = [];
        return c.properties.forEach((f, m)=>{
            let p = f.data.path?.[0];
            if (p && [
                "position",
                "rotation",
                "scale"
            ].includes(p)) {
                let g = jY(f.data, u1?.[p]);
                g && d.push(...g);
            }
            if (p && p === "shape size" && "geometry" in l) {
                let g = HY(l, f.data, u1?.shapeSize);
                g && d.push(...g);
            }
            if (p && p === "path extrusion" && l instanceof qo) {
                let g = WY(l, f.data, u1?.pathExtrusion);
                g && d.push(g);
            }
            if (p && p === "path snapping" && l.data.pathSnapping) {
                let g = qY(l, f.data, u1?.pathSnapping);
                g && d.push(g);
            }
            if (p && p === "material" && l.type === "Mesh" && "material" in l && l.material instanceof fn) {
                let g = f.data.id;
                if (g) {
                    let y = l.material.getLayerByUuid(g);
                    if (y) {
                        let x = OR(y, f.data, u1?.material, h);
                        x && d.push(x);
                    } else {
                        let x = l.material.getLayersOfType(f.data.type);
                        if (x) for (let v of x){
                            let b = OR(v, f.data, u1?.material, h);
                            b && d.push(b);
                        }
                    }
                }
            }
            if (p && p === "opacity" && l.type === "Mesh" && "material" in l) {
                let g = XY(f.data, u1?.opacity);
                g && d.push(g);
            }
            if (p && p === "cloner") {
                let g = YY(l, f.data, u1?.cloner);
                g && d.push(g);
            }
            if (p && p === "camera" && l instanceof ir) {
                let g = KY(l, f.data, u1?.camera, "zoom");
                g && d.push(g);
            }
            if (p && p === "light" && (l instanceof Ho || l instanceof Xl || l instanceof Wo)) {
                let g = QY(l, f.data, u1?.light, f.data.path[1], h);
                g && d.push(g);
            }
        }), d;
    }
    a.addKeyframesToTimeline = s1, a.Presets = [
        {
            name: "Slide in",
            animationParams: {
                translateX: {
                    value: [
                        -20,
                        0
                    ],
                    easing: En(3),
                    duration: 1e3
                },
                opacity: {
                    value: [
                        0,
                        1
                    ],
                    easing: En(3),
                    duration: 1e3
                },
                endDelay: 250,
                loop: !0
            }
        },
        {
            name: "Rotate",
            animationParams: {
                rotate: {
                    value: [
                        0,
                        "1turn"
                    ],
                    easing: En(5),
                    duration: 700
                },
                endDelay: 250,
                loop: !0
            }
        },
        {
            name: "Scale Out",
            animationParams: {
                scale: {
                    value: [
                        1,
                        1.5
                    ],
                    easing: En(4),
                    duration: 1e3
                },
                endDelay: 250,
                loop: !0
            }
        },
        {
            name: "Jump",
            animationParams: {
                translateY: [
                    {
                        value: 0,
                        duration: 200,
                        easing: "linear"
                    },
                    {
                        value: -20,
                        easing: "linear",
                        duration: 200
                    },
                    {
                        value: 0,
                        easing: "linear",
                        duration: 100
                    }
                ],
                endDelay: 500,
                loop: !0
            }
        },
        {
            name: "Jump Rotate",
            animationParams: {
                translateY: [
                    {
                        value: 0,
                        duration: 200,
                        easing: "linear"
                    },
                    {
                        value: -20,
                        easing: "linear",
                        duration: 200
                    },
                    {
                        value: 0,
                        easing: "linear",
                        duration: 100
                    }
                ],
                rotate: {
                    value: [
                        0,
                        "1turn"
                    ],
                    easing: En(5),
                    duration: 500
                },
                endDelay: 500,
                loop: !0
            }
        },
        {
            name: "Bounce",
            animationParams: {
                translateY: {
                    value: [
                        "20px",
                        "-20px"
                    ],
                    duration: 575,
                    easing: "easeOutQuad"
                },
                direction: "alternate",
                loop: !0
            }
        }
    ];
})(tx || (tx = {}));
function DR(n1, t, e) {
    let r = t;
    return {
        id: r,
        fi: e,
        data: {
            id: r,
            path: n1,
            keyframes: new Re
        }
    };
}
var RR = [
    "x",
    "y",
    "z"
];
function jY(n1, t = ()=>{}) {
    let e = [];
    for (let r of RR){
        let i = [
            ...n1.keyframes ?? []
        ].filter((a)=>a.data.value[r] !== void 0).sort((a, l)=>a.data.time - l.data.time), s1 = i[0];
        s1 && t?.(s1.data.value);
        let o = {
            index: [],
            t: []
        };
        for(let a = 0; a < i.length - 1; a++){
            let l = i[a], c = i[a + 1] ?? l, u1 = {
                duration: (c?.data?.time - l.data.time) * 1e3,
                delay: a === 0 ? i[0].data.time * 1e3 : 0
            };
            a < i.length - 1 && (o.t.push({
                ...u1,
                value: a % 2 === 0 ? 1 : 0,
                easing: En(l.data.easing.type, {
                    control1: wi(l.data.easing.cubicControls?.control1, [
                        0,
                        0
                    ]),
                    control2: wi(c.data.easing.cubicControls?.control2, [
                        1,
                        1
                    ])
                }, l.data.easing.springParameters)
            }), o.index.push({
                ...u1,
                value: a,
                easing: "linear"
            }));
        }
        if (i.length > 1) {
            let a = {
                t: 0,
                index: 0
            };
            e.push({
                targets: a,
                ...o,
                update: (l)=>{
                    let c = Math.ceil(a.index), u1 = c % 2 === 0 ? a.t : 1 - a.t, h = i?.[c].data.value, d = i?.[c + 1]?.data.value;
                    if (h !== void 0 && d !== void 0) {
                        let f = {
                            [r]: h[r] + (d[r] - h[r]) * u1
                        };
                        t?.(f);
                    }
                }
            });
        }
    }
    return e;
}
function HY(n1, t, e) {
    let r = [];
    for (let i of RR){
        let s1 = {}, o = [
            ...t.keyframes ?? []
        ].filter((l)=>l.data.value[i] !== void 0).sort((l, c)=>l.data.time - c.data.time), a = o[0];
        a && e?.(a.data.value), s1 = {
            index: [],
            t: []
        };
        for(let l = 0; l < o.length - 1; l++){
            let c = o[l], u1 = o[l + 1] ?? c, h = {
                duration: (u1?.data?.time - c.data.time) * 1e3,
                delay: l === 0 ? o[0].data.time * 1e3 : 0
            };
            l < o.length - 1 && (s1.t.push({
                ...h,
                value: l % 2 === 0 ? 1 : 0,
                easing: En(c.data.easing.type, {
                    control1: wi(c.data.easing.cubicControls?.control1, [
                        0,
                        0
                    ]),
                    control2: wi(u1.data.easing.cubicControls?.control2, [
                        1,
                        1
                    ])
                }, c.data.easing.springParameters)
            }), s1.index.push({
                ...h,
                value: l,
                easing: "linear"
            }));
        }
        if (o.length > 1) {
            let l = {
                t: 0,
                index: 0
            };
            r.push({
                targets: l,
                ...s1,
                update: (c)=>{
                    let u1 = Math.ceil(l.index), h = u1 % 2 === 0 ? l.t : 1 - l.t, d = o?.[u1].data.value, f = o?.[u1 + 1]?.data.value;
                    if (d !== void 0 && f !== void 0) {
                        let m = {
                            [i]: d[i] + (f[i] - d[i]) * h
                        };
                        e?.(m);
                    }
                }
            });
        }
    }
    return r;
}
function WY(n1, t, e) {
    let r = {}, i = [
        ...t.keyframes ?? []
    ].sort((o, a)=>o.data.time - a.data.time), s1 = i[0];
    s1 && e?.(n1, s1.data.value), r = {
        index: [],
        t: []
    };
    for(let o = 0; o < i.length - 1; o++){
        let a = i[o], l = i[o + 1] ?? a, c = {
            duration: (l?.data?.time - a.data.time) * 1e3,
            delay: o === 0 ? i[0].data.time * 1e3 : 0
        };
        o < i.length - 1 && (r.t.push({
            ...c,
            value: o % 2 === 0 ? 1 : 0,
            easing: En(a.data.easing.type, {
                control1: wi(a.data.easing.cubicControls?.control1, [
                    0,
                    0
                ]),
                control2: wi(l.data.easing.cubicControls?.control2, [
                    1,
                    1
                ])
            }, a.data.easing.springParameters)
        }), r.index.push({
            ...c,
            value: o,
            easing: "linear"
        }));
    }
    if (i.length > 1) {
        let o = {
            t: 0,
            index: 0
        };
        return {
            targets: o,
            ...r,
            update: (a)=>{
                let l = Math.ceil(o.index), c = l % 2 === 0 ? o.t : 1 - o.t, u1 = i?.[Math.min(l, i.length - 1)].data.value, h = i?.[Math.min(l, i.length - 1) + 1]?.data.value;
                e?.(n1, LR(n1, u1, h, c));
            }
        };
    }
}
function qY(n1, t, e) {
    let r = {}, i = [
        ...t.keyframes ?? []
    ].sort((o, a)=>o.data.time - a.data.time), s1 = i[0];
    s1 && e?.(s1.data.value), r = {
        index: [],
        t: []
    };
    for(let o = 0; o < i.length - 1; o++){
        let a = i[o], l = i[o + 1] ?? a, c = {
            duration: (l?.data?.time - a.data.time) * 1e3,
            delay: o === 0 ? i[0].data.time * 1e3 : 0
        };
        o < i.length - 1 && (r.t.push({
            ...c,
            value: o % 2 === 0 ? 1 : 0,
            easing: En(a.data.easing.type, {
                control1: wi(a.data.easing.cubicControls?.control1, [
                    0,
                    0
                ]),
                control2: wi(l.data.easing.cubicControls?.control2, [
                    1,
                    1
                ])
            }, a.data.easing.springParameters)
        }), r.index.push({
            ...c,
            value: o,
            easing: "linear"
        }));
    }
    if (i.length > 1) {
        let o = {
            t: 0,
            index: 0
        };
        return {
            targets: o,
            ...r,
            update: (a)=>{
                let l = Math.ceil(o.index), c = l % 2 === 0 ? o.t : 1 - o.t, u1 = i?.[Math.min(l, i.length - 1)].data.value, h = i?.[Math.min(l, i.length - 1) + 1]?.data.value;
                e?.(NR(n1, u1, h, c));
            }
        };
    }
}
function OR(n1, t, e, r) {
    if (t) {
        let i = {}, s1 = [
            ...t.keyframes ?? []
        ].sort((o, a)=>o.data.time - a.data.time);
        if ("data" in n1) {
            let o = s1[0];
            o && e?.(o.data.value, n1), i = {
                index: [],
                t: []
            };
            for(let a = 0; a < s1.length - 1; a++){
                let l = s1[a], c = s1[a + 1] ?? l, u1 = {
                    duration: (c?.data?.time - l.data.time) * 1e3,
                    delay: a === 0 ? s1[0].data.time * 1e3 : 0
                };
                a < s1.length - 1 && (i.t.push({
                    ...u1,
                    value: a % 2 === 0 ? 1 : 0,
                    easing: En(l.data.easing.type, {
                        control1: wi(l.data.easing.cubicControls?.control1, [
                            0,
                            0
                        ]),
                        control2: wi(c.data.easing.cubicControls?.control2, [
                            1,
                            1
                        ])
                    }, l.data.easing.springParameters)
                }), i.index.push({
                    ...u1,
                    value: a,
                    easing: "linear"
                }));
            }
            if (s1.length > 1) {
                let a = {
                    t: 0,
                    index: 0
                };
                return {
                    targets: a,
                    ...i,
                    update: (l)=>{
                        let c = Math.ceil(a.index), u1 = c % 2 === 0 ? a.t : 1 - a.t, h = s1?.[Math.min(c, s1.length - 1)].data.value, d = s1?.[Math.min(c, s1.length - 1) + 1]?.data.value, f = {}, m = {};
                        if (Object.keys(h).length > 0 && Object.keys(d).length > 0) {
                            for(let p in n1.data)if (p in h && p in d) {
                                let g = oE(h[p], d[p], u1, r);
                                g !== void 0 && (f[p] = g, m[p] = {
                                    start: h,
                                    end: d,
                                    t: u1
                                });
                            }
                        }
                        e?.({
                            ...f
                        }, n1, m);
                    }
                };
            }
        }
    }
}
function XY(n1, t) {
    if (n1) {
        let e = {}, r = [
            ...n1.keyframes ?? []
        ].sort((s1, o)=>s1.data.time - o.data.time), i = r[0];
        i && t?.(i.data.value), e = {
            index: [],
            t: []
        };
        for(let s1 = 0; s1 < r.length - 1; s1++){
            let o = r[s1], a = r[s1 + 1] ?? o, l = {
                duration: (a?.data?.time - o.data.time) * 1e3,
                delay: s1 === 0 ? r[0].data.time * 1e3 : 0
            };
            s1 < r.length - 1 && (e.t.push({
                ...l,
                value: s1 % 2 === 0 ? 1 : 0,
                easing: En(o.data.easing.type, {
                    control1: wi(o.data.easing.cubicControls?.control1, [
                        0,
                        0
                    ]),
                    control2: wi(a.data.easing.cubicControls?.control2, [
                        1,
                        1
                    ])
                }, o.data.easing.springParameters)
            }), e.index.push({
                ...l,
                value: s1,
                easing: "linear"
            }));
        }
        if (r.length > 1) {
            let s1 = {
                t: 0,
                index: 0
            };
            return {
                targets: s1,
                ...e,
                update: (o)=>{
                    let a = Math.ceil(s1.index), l = a % 2 === 0 ? s1.t : 1 - s1.t, c = r?.[Math.min(a, r.length - 1)].data.value, u1 = r?.[Math.min(a, r.length - 1) + 1]?.data.value, h = Se.lerp(c, u1, l);
                    t?.(h);
                }
            };
        }
    }
}
function YY(n1, t, e) {
    let r = {}, i = [
        ...t.keyframes ?? []
    ].sort((o, a)=>o.data.time - a.data.time), s1 = i[0];
    s1 && e?.(n1, s1.data.value, s1.data.value), r = {
        index: [],
        t: []
    };
    for(let o = 0; o < i.length - 1; o++){
        let a = i[o], l = i[o + 1] ?? a, c = {
            duration: (l?.data?.time - a.data.time) * 1e3,
            delay: o === 0 ? i[0].data.time * 1e3 : 0
        };
        o < i.length - 1 && (r.t.push({
            ...c,
            value: o % 2 === 0 ? 1 : 0,
            easing: En(a.data.easing.type, {
                control1: wi(a.data.easing.cubicControls?.control1, [
                    0,
                    0
                ]),
                control2: wi(l.data.easing.cubicControls?.control2, [
                    1,
                    1
                ])
            }, a.data.easing.springParameters)
        }), r.index.push({
            ...c,
            value: o,
            easing: "linear"
        }));
    }
    if (i.length > 1) {
        let o = {
            t: 0,
            index: 0
        };
        return {
            targets: o,
            ...r,
            update: (a)=>{
                let l = Math.ceil(o.index), c = l % 2 === 0 ? o.t : 1 - o.t, u1 = i?.[Math.min(l, i.length - 1)].data.value, h = i?.[Math.min(l, i.length - 1) + 1]?.data.value;
                e?.(n1, u1.randomnessObject ? void 0 : PR(u1, h, c, n1), u1.randomnessObject ? _R(u1, h, c, n1) : void 0);
            }
        };
    }
}
function oE(n1, t, e, r) {
    if (typeof n1 == "string" && r && (n1 = r.color(n1)), typeof t == "string" && r && (n1 = r.color(t)), typeof n1 == "number") return n1 === t ? void 0 : Se.lerp(n1, t, e);
    if (At.is(n1)) return At.lerp(n1, t, e);
    if (Fr.is(n1)) return Fr.lerp(n1, t, e);
    if (Array.isArray(n1)) return (n1.length > t.length ? t : n1).map((s1, o, a)=>{
        if (Array.isArray(s1)) {
            let l = n1[o].length > t[o].length ? t[o].length : n1[o].length;
            return (l === 4 ? eu : l === 3 ? ws : ss).lerp(n1[o], t[o], e);
        } else return Se.lerp(n1[o], t[o], e);
    });
    if (typeof n1 == "object" && n1 !== null) {
        let i = {};
        for(let s1 in n1){
            let o = oE(n1[s1], t[s1], e, r);
            o !== void 0 && (i[s1] = o);
        }
        return i;
    }
}
function KY(n1, t, e, r) {
    if (t) {
        let i = {
            [r]: []
        }, s1 = [
            ...t.keyframes ?? []
        ].sort((a, l)=>a.data.time - l.data.time), o = s1[0];
        o && (n1[r] = o.data.value, o && e?.(r, o.data.value));
        for(let a = 0; a < s1.length - 1; a++){
            let l = s1[a];
            if (!Number.isFinite(l.data.value)) continue;
            let c = s1[a + 1] ?? l, u1 = c.data.value;
            i[r].push({
                value: u1,
                easing: En(l.data.easing.type, {
                    control1: wi(l.data.easing.cubicControls?.control1, [
                        0,
                        0
                    ]),
                    control2: wi(c.data.easing.cubicControls?.control2, [
                        1,
                        1
                    ])
                }, l.data.easing.springParameters),
                duration: (c?.data?.time - l.data.time) * 1e3,
                delay: a === 0 ? s1[0].data.time * 1e3 : 0
            });
        }
        if (s1.length > 1) return {
            targets: n1,
            ...i,
            update: ()=>{
                e?.(r, n1[r]);
            }
        };
    }
}
function QY(n1, t, e, r, i) {
    if (t) {
        let s1 = {}, o = [
            ...t.keyframes ?? []
        ].sort((l, c)=>l.data.time - c.data.time), a = o[0];
        if (a) {
            let l = a.data.value;
            n1[r] = l, e?.(r, l);
        }
        s1 = {
            index: [],
            t: []
        };
        for(let l = 0; l < o.length - 1; l++){
            let c = o[l], u1 = o[l + 1] ?? c, h = {
                duration: (u1?.data?.time - c.data.time) * 1e3,
                delay: l === 0 ? o[0].data.time * 1e3 : 0
            };
            l < o.length - 1 && (s1.t.push({
                ...h,
                value: l % 2 === 0 ? 1 : 0,
                easing: En(c.data.easing.type, {
                    control1: wi(c.data.easing.cubicControls?.control1, [
                        0,
                        0
                    ]),
                    control2: wi(u1.data.easing.cubicControls?.control2, [
                        1,
                        1
                    ])
                }, c.data.easing.springParameters)
            }), s1.index.push({
                ...h,
                value: l,
                easing: "linear"
            }));
        }
        if (o.length > 1) {
            let l = {
                t: 0,
                index: 0
            };
            return {
                targets: l,
                ...s1,
                update: ()=>{
                    let c = Math.ceil(l.index), u1 = c % 2 === 0 ? l.t : 1 - l.t, h = o?.[Math.min(c, o.length - 1)].data.value, d = o?.[Math.min(c, o.length - 1) + 1]?.data.value, f = oE(h, d, u1, i);
                    e?.(r, f);
                }
            };
        }
    }
}
var sE = class {
    constructor(t = 1, e = 100, r = 10, i = 0){
        this.mass = t, this.stiffness = e, this.damping = r, this.initialVelocity = i, this.m_w0 = Math.sqrt(e / t), this.m_zeta = r / (2 * Math.sqrt(e * t)), this.m_zeta < 1 ? (this.m_wd = this.m_w0 * Math.sqrt(1 - this.m_zeta * this.m_zeta), this.m_A = 1, this.m_B = (this.m_zeta * this.m_w0 + -i) / this.m_wd) : (this.m_wd = 0, this.m_A = 1, this.m_B = -i + this.m_w0);
    }
    solve(t) {
        return this.m_zeta < 1 ? t = Math.exp(-t * this.m_zeta * this.m_w0) * (this.m_A * Math.cos(this.m_wd * t) + this.m_B * Math.sin(this.m_wd * t)) : t = (this.m_A + this.m_B * t) * Math.exp(-t * this.m_w0), 1 - t;
    }
    getDuration() {
        let t = .16666666666666666, e = 0, r = 0;
        for(;;)if (e += t, this.solve(e) === 1) {
            if (r++, r >= 16) break;
        } else r = 0;
        return e * t * 1e3;
    }
};
var BR = Math.pow(2, -24);
var iu = class {
    constructor(){}
};
function Cs(n1, t, e) {
    return e.min.x = t[n1], e.min.y = t[n1 + 1], e.min.z = t[n1 + 2], e.max.x = t[n1 + 3], e.max.y = t[n1 + 4], e.max.z = t[n1 + 5], e;
}
function aE(n1) {
    let t = -1, e = -1 / 0;
    for(let r = 0; r < 3; r++){
        let i = n1[r + 3] - n1[r];
        i > e && (e = i, t = r);
    }
    return t;
}
function lE(n1, t) {
    t.set(n1);
}
function cE(n1, t, e) {
    let r, i;
    for(let s1 = 0; s1 < 3; s1++){
        let o = s1 + 3;
        r = n1[s1], i = t[s1], e[s1] = r < i ? r : i, r = n1[o], i = t[o], e[o] = r > i ? r : i;
    }
}
function Mm(n1, t, e) {
    for(let r = 0; r < 3; r++){
        let i = t[n1 + 2 * r], s1 = t[n1 + 2 * r + 1], o = i - s1, a = i + s1;
        o < e[r] && (e[r] = o), a > e[r + 3] && (e[r + 3] = a);
    }
}
function Md(n1) {
    let t = n1[3] - n1[0], e = n1[4] - n1[1], r = n1[5] - n1[2];
    return 2 * (t * e + e * r + r * t);
}
function $Y(n1, t) {
    if (!n1.index) {
        let e = n1.attributes.position.count, r = t.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer, i;
        e > 65535 ? i = new Uint32Array(new r(4 * e)) : i = new Uint16Array(new r(2 * e)), n1.setIndex(new je(i, 1));
        for(let s1 = 0; s1 < e; s1++)i[s1] = s1;
    }
}
function eK(n1) {
    if (!n1.groups || !n1.groups.length) return [
        {
            offset: 0,
            count: n1.index.count / 3
        }
    ];
    let t = [], e = new Set;
    for (let i of n1.groups)e.add(i.start), e.add(i.start + i.count);
    let r = Array.from(e.values()).sort((i, s1)=>i - s1);
    for(let i = 0; i < r.length - 1; i++){
        let s1 = r[i], o = r[i + 1];
        t.push({
            offset: s1 / 3,
            count: (o - s1) / 3
        });
    }
    return t;
}
function hE(n1, t, e, r, i = null) {
    let s1 = 1 / 0, o = 1 / 0, a = 1 / 0, l = -1 / 0, c = -1 / 0, u1 = -1 / 0, h = 1 / 0, d = 1 / 0, f = 1 / 0, m = -1 / 0, p = -1 / 0, g = -1 / 0, y = i !== null;
    for(let x = t * 6, v = (t + e) * 6; x < v; x += 6){
        let b = n1[x + 0], w = n1[x + 1], A = b - w, T = b + w;
        A < s1 && (s1 = A), T > l && (l = T), y && b < h && (h = b), y && b > m && (m = b);
        let S = n1[x + 2], M = n1[x + 3], C = S - M, P = S + M;
        C < o && (o = C), P > c && (c = P), y && S < d && (d = S), y && S > p && (p = S);
        let _ = n1[x + 4], I = n1[x + 5], O = _ - I, L = _ + I;
        O < a && (a = O), L > u1 && (u1 = L), y && _ < f && (f = _), y && _ > g && (g = _);
    }
    r[0] = s1, r[1] = o, r[2] = a, r[3] = l, r[4] = c, r[5] = u1, y && (i[0] = h, i[1] = d, i[2] = f, i[3] = m, i[4] = p, i[5] = g);
}
function tK(n1, t, e, r) {
    let i = 1 / 0, s1 = 1 / 0, o = 1 / 0, a = -1 / 0, l = -1 / 0, c = -1 / 0;
    for(let u1 = t * 6, h = (t + e) * 6; u1 < h; u1 += 6){
        let d = n1[u1 + 0];
        d < i && (i = d), d > a && (a = d);
        let f = n1[u1 + 2];
        f < s1 && (s1 = f), f > l && (l = f);
        let m = n1[u1 + 4];
        m < o && (o = m), m > c && (c = m);
    }
    r[0] = i, r[1] = s1, r[2] = o, r[3] = a, r[4] = l, r[5] = c;
}
function rK(n1, t, e, r, i) {
    let s1 = e, o = e + r - 1, a = i.pos, l = i.axis * 2;
    for(;;){
        for(; s1 <= o && t[s1 * 6 + l] < a;)s1++;
        for(; s1 <= o && t[o * 6 + l] >= a;)o--;
        if (s1 < o) {
            for(let c = 0; c < 3; c++){
                let u1 = n1[s1 * 3 + c];
                n1[s1 * 3 + c] = n1[o * 3 + c], n1[o * 3 + c] = u1;
                let h = t[s1 * 6 + c * 2 + 0];
                t[s1 * 6 + c * 2 + 0] = t[o * 6 + c * 2 + 0], t[o * 6 + c * 2 + 0] = h;
                let d = t[s1 * 6 + c * 2 + 1];
                t[s1 * 6 + c * 2 + 1] = t[o * 6 + c * 2 + 1], t[o * 6 + c * 2 + 1] = d;
            }
            s1++, o--;
        } else return s1;
    }
}
var Wa = 32, iK = (n1, t)=>n1.candidate - t.candidate, Yl = new Array(Wa).fill().map(()=>({
        count: 0,
        bounds: new Float32Array(6),
        rightCacheBounds: new Float32Array(6),
        leftCacheBounds: new Float32Array(6),
        candidate: 0
    })), rx = new Float32Array(6);
function nK(n1, t, e, r, i, s1) {
    let o = -1, a = 0;
    if (s1 === 0) o = aE(t), o !== -1 && (a = (t[o] + t[o + 3]) / 2);
    else if (s1 === 1) o = aE(n1), o !== -1 && (a = sK(e, r, i, o));
    else if (s1 === 2) {
        let l = Md(n1), c = 1.25 * i, u1 = r * 6, h = (r + i) * 6;
        for(let d = 0; d < 3; d++){
            let f = t[d], g = (t[d + 3] - f) / Wa;
            if (i < Wa / 4) {
                let y = [
                    ...Yl
                ];
                y.length = i;
                let x = 0;
                for(let b = u1; b < h; b += 6, x++){
                    let w = y[x];
                    w.candidate = e[b + 2 * d], w.count = 0;
                    let { bounds: A, leftCacheBounds: T, rightCacheBounds: S } = w;
                    for(let M = 0; M < 3; M++)S[M] = 1 / 0, S[M + 3] = -1 / 0, T[M] = 1 / 0, T[M + 3] = -1 / 0, A[M] = 1 / 0, A[M + 3] = -1 / 0;
                    Mm(b, e, A);
                }
                y.sort(iK);
                let v = i;
                for(let b = 0; b < v; b++){
                    let w = y[b];
                    for(; b + 1 < v && y[b + 1].candidate === w.candidate;)y.splice(b + 1, 1), v--;
                }
                for(let b = u1; b < h; b += 6){
                    let w = e[b + 2 * d];
                    for(let A = 0; A < v; A++){
                        let T = y[A];
                        w >= T.candidate ? Mm(b, e, T.rightCacheBounds) : (Mm(b, e, T.leftCacheBounds), T.count++);
                    }
                }
                for(let b = 0; b < v; b++){
                    let w = y[b], A = w.count, T = i - w.count, S = w.leftCacheBounds, M = w.rightCacheBounds, C = 0;
                    A !== 0 && (C = Md(S) / l);
                    let P = 0;
                    T !== 0 && (P = Md(M) / l);
                    let _ = 1 + 1.25 * (C * A + P * T);
                    _ < c && (o = d, c = _, a = w.candidate);
                }
            } else {
                for(let v = 0; v < Wa; v++){
                    let b = Yl[v];
                    b.count = 0, b.candidate = f + g + v * g;
                    let w = b.bounds;
                    for(let A = 0; A < 3; A++)w[A] = 1 / 0, w[A + 3] = -1 / 0;
                }
                for(let v = u1; v < h; v += 6){
                    let A = ~~((e[v + 2 * d] - f) / g);
                    A >= Wa && (A = Wa - 1);
                    let T = Yl[A];
                    T.count++, Mm(v, e, T.bounds);
                }
                let y = Yl[Wa - 1];
                lE(y.bounds, y.rightCacheBounds);
                for(let v = Wa - 2; v >= 0; v--){
                    let b = Yl[v], w = Yl[v + 1];
                    cE(b.bounds, w.rightCacheBounds, b.rightCacheBounds);
                }
                let x = 0;
                for(let v = 0; v < Wa - 1; v++){
                    let b = Yl[v], w = b.count, A = b.bounds, S = Yl[v + 1].rightCacheBounds;
                    w !== 0 && (x === 0 ? lE(A, rx) : cE(A, rx, rx)), x += w;
                    let M = 0, C = 0;
                    x !== 0 && (M = Md(rx) / l);
                    let P = i - x;
                    P !== 0 && (C = Md(S) / l);
                    let _ = 1 + 1.25 * (M * x + C * P);
                    _ < c && (o = d, c = _, a = b.candidate);
                }
            }
        }
    } else console.warn(`MeshBVH: Invalid build strategy value ${s1} used.`);
    return {
        axis: o,
        pos: a
    };
}
function sK(n1, t, e, r) {
    let i = 0;
    for(let s1 = t, o = t + e; s1 < o; s1++)i += n1[s1 * 6 + r * 2];
    return i / e;
}
function oK(n1, t) {
    let e = n1.attributes.position, r = n1.index.array, i = r.length / 3, s1 = new Float32Array(i * 6), o = e.normalized, a = e.array, l = e.offset || 0, c = 3;
    e.isInterleavedBufferAttribute && (c = e.data.stride);
    let u1 = [
        "getX",
        "getY",
        "getZ"
    ];
    for(let h = 0; h < i; h++){
        let d = h * 3, f = h * 6, m, p, g;
        o ? (m = r[d + 0], p = r[d + 1], g = r[d + 2]) : (m = r[d + 0] * c + l, p = r[d + 1] * c + l, g = r[d + 2] * c + l);
        for(let y = 0; y < 3; y++){
            let x, v, b;
            o ? (x = e[u1[y]](m), v = e[u1[y]](p), b = e[u1[y]](g)) : (x = a[m + y], v = a[p + y], b = a[g + y]);
            let w = x;
            v < w && (w = v), b < w && (w = b);
            let A = x;
            v > A && (A = v), b > A && (A = b);
            let T = (A - w) / 2, S = y * 2;
            s1[f + S + 0] = w + T, s1[f + S + 1] = T + (Math.abs(w) + T) * BR, w < t[y] && (t[y] = w), A > t[y + 3] && (t[y + 3] = A);
        }
    }
    return s1;
}
function aK(n1, t) {
    function e(y) {
        d && d(y / f);
    }
    function r(y, x, v, b = null, w = 0) {
        if (!m && w >= l && (m = !0, c && (console.warn(`MeshBVH: Max depth of ${l} reached when generating BVH. Consider increasing maxDepth.`), console.warn(n1))), v <= u1 || w >= l) return e(x + v), y.offset = x, y.count = v, y;
        let A = nK(y.boundingData, b, o, x, v, h);
        if (A.axis === -1) return e(x + v), y.offset = x, y.count = v, y;
        let T = rK(a, o, x, v, A);
        if (T === x || T === x + v) e(x + v), y.offset = x, y.count = v;
        else {
            y.splitAxis = A.axis;
            let S = new iu, M = x, C = T - x;
            y.left = S, S.boundingData = new Float32Array(6), hE(o, M, C, S.boundingData, s1), r(S, M, C, s1, w + 1);
            let P = new iu, _ = T, I = v - C;
            y.right = P, P.boundingData = new Float32Array(6), hE(o, _, I, P.boundingData, s1), r(P, _, I, s1, w + 1);
        }
        return y;
    }
    $Y(n1, t);
    let i = new Float32Array(6), s1 = new Float32Array(6), o = oK(n1, i), a = n1.index.array, l = t.maxDepth, c = t.verbose, u1 = t.maxLeafTris, h = t.strategy, d = t.onProgress, f = n1.index.count / 3, m = !1, p = [], g = eK(n1);
    if (g.length === 1) {
        let y = g[0], x = new iu;
        x.boundingData = i, tK(o, y.offset, y.count, s1), r(x, y.offset, y.count, s1), p.push(x);
    } else for (let y of g){
        let x = new iu;
        x.boundingData = new Float32Array(6), hE(o, y.offset, y.count, x.boundingData, s1), r(x, y.offset, y.count, s1), p.push(x);
    }
    return p;
}
function UR(n1, t) {
    let e = aK(n1, t), r, i, s1, o = [], a = t.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;
    for(let u1 = 0; u1 < e.length; u1++){
        let h = e[u1], d = l(h), f = new a(32 * d);
        r = new Float32Array(f), i = new Uint32Array(f), s1 = new Uint16Array(f), c(0, h), o.push(f);
    }
    return o;
    function l(u1) {
        return u1.count ? 1 : 1 + l(u1.left) + l(u1.right);
    }
    function c(u1, h) {
        let d = u1 / 4, f = u1 / 2, m = !!h.count, p = h.boundingData;
        for(let g = 0; g < 6; g++)r[d + g] = p[g];
        if (m) {
            let g = h.offset, y = h.count;
            return i[d + 6] = g, s1[f + 14] = y, s1[f + 15] = 65535, u1 + 32;
        } else {
            let g = h.left, y = h.right, x = h.splitAxis, v;
            if (v = c(u1 + 32, g), v / 4 > Math.pow(2, 32)) throw new Error("MeshBVH: Cannot store child pointer greater than 32 bits.");
            return i[d + 6] = v / 4, v = c(v, y), i[d + 7] = x, v;
        }
    }
}
var Fn = class {
    constructor(){
        this.min = 1 / 0, this.max = -1 / 0;
    }
    setFromPointsField(t, e) {
        let r = 1 / 0, i = -1 / 0;
        for(let s1 = 0, o = t.length; s1 < o; s1++){
            let l = t[s1][e];
            r = l < r ? l : r, i = l > i ? l : i;
        }
        this.min = r, this.max = i;
    }
    setFromPoints(t, e) {
        let r = 1 / 0, i = -1 / 0;
        for(let s1 = 0, o = e.length; s1 < o; s1++){
            let a = e[s1], l = t.dot(a);
            r = l < r ? l : r, i = l > i ? l : i;
        }
        this.min = r, this.max = i;
    }
    isSeparated(t) {
        return this.min > t.max || t.min > this.max;
    }
};
Fn.prototype.setFromBox = function() {
    let n1 = new E;
    return function(e, r) {
        let i = r.min, s1 = r.max, o = 1 / 0, a = -1 / 0;
        for(let l = 0; l <= 1; l++)for(let c = 0; c <= 1; c++)for(let u1 = 0; u1 <= 1; u1++){
            n1.x = i.x * l + s1.x * (1 - l), n1.y = i.y * c + s1.y * (1 - c), n1.z = i.z * u1 + s1.z * (1 - u1);
            let h = e.dot(n1);
            o = Math.min(h, o), a = Math.max(h, a);
        }
        this.min = o, this.max = a;
    };
}();
var Rve = function() {
    let n1 = new Fn;
    return function(e, r) {
        let i = e.points, s1 = e.satAxes, o = e.satBounds, a = r.points, l = r.satAxes, c = r.satBounds;
        for(let u1 = 0; u1 < 3; u1++){
            let h = o[u1], d = s1[u1];
            if (n1.setFromPoints(d, a), h.isSeparated(n1)) return !1;
        }
        for(let u1 = 0; u1 < 3; u1++){
            let h = c[u1], d = l[u1];
            if (n1.setFromPoints(d, i), h.isSeparated(n1)) return !1;
        }
    };
}();
var lK = function() {
    let n1 = new E, t = new E, e = new E;
    return function(i, s1, o) {
        let a = i.start, l = n1, c = s1.start, u1 = t;
        e.subVectors(a, c), n1.subVectors(i.end, i.start), t.subVectors(s1.end, s1.start);
        let h = e.dot(u1), d = u1.dot(l), f = u1.dot(u1), m = e.dot(l), g = l.dot(l) * f - d * d, y, x;
        g !== 0 ? y = (h * d - m * f) / g : y = 0, x = (h + y * d) / f, o.x = y, o.y = x;
    };
}(), Cm = function() {
    let n1 = new U, t = new E, e = new E;
    return function(i, s1, o, a) {
        lK(i, s1, n1);
        let l = n1.x, c = n1.y;
        if (l >= 0 && l <= 1 && c >= 0 && c <= 1) {
            i.at(l, o), s1.at(c, a);
            return;
        } else if (l >= 0 && l <= 1) {
            c < 0 ? s1.at(0, a) : s1.at(1, a), i.closestPointToPoint(a, !0, o);
            return;
        } else if (c >= 0 && c <= 1) {
            l < 0 ? i.at(0, o) : i.at(1, o), s1.closestPointToPoint(o, !0, a);
            return;
        } else {
            let u1;
            l < 0 ? u1 = i.start : u1 = i.end;
            let h;
            c < 0 ? h = s1.start : h = s1.end;
            let d = t, f = e;
            if (i.closestPointToPoint(h, !0, t), s1.closestPointToPoint(u1, !0, e), d.distanceToSquared(h) <= f.distanceToSquared(u1)) {
                o.copy(d), a.copy(h);
                return;
            } else {
                o.copy(u1), a.copy(f);
                return;
            }
        }
    };
}(), kR = function() {
    let n1 = new E, t = new E, e = new qr, r = new Di;
    return function(s1, o) {
        let { radius: a, center: l } = s1, { a: c, b: u1, c: h } = o;
        if (r.start = c, r.end = u1, r.closestPointToPoint(l, !0, n1).distanceTo(l) <= a || (r.start = c, r.end = h, r.closestPointToPoint(l, !0, n1).distanceTo(l) <= a) || (r.start = u1, r.end = h, r.closestPointToPoint(l, !0, n1).distanceTo(l) <= a)) return !0;
        let p = o.getPlane(e);
        if (Math.abs(p.distanceToPoint(l)) <= a) {
            let y = p.projectPoint(l, t);
            if (o.containsPoint(y)) return !0;
        }
        return !1;
    };
}();
var cK = 1e-15;
function Cd(n1) {
    return Math.abs(n1) < cK;
}
var Vn = class extends Or {
    constructor(...t){
        super(...t), this.isExtendedTriangle = !0, this.satAxes = new Array(4).fill().map(()=>new E), this.satBounds = new Array(4).fill().map(()=>new Fn), this.points = [
            this.a,
            this.b,
            this.c
        ], this.sphere = new ei, this.plane = new qr, this.needsUpdate = !0;
    }
    intersectsSphere(t) {
        return kR(t, this);
    }
    update() {
        let t = this.a, e = this.b, r = this.c, i = this.points, s1 = this.satAxes, o = this.satBounds, a = s1[0], l = o[0];
        this.getNormal(a), l.setFromPoints(a, i);
        let c = s1[1], u1 = o[1];
        c.subVectors(t, e), u1.setFromPoints(c, i);
        let h = s1[2], d = o[2];
        h.subVectors(e, r), d.setFromPoints(h, i);
        let f = s1[3], m = o[3];
        f.subVectors(r, t), m.setFromPoints(f, i), this.sphere.setFromPoints(this.points), this.plane.setFromNormalAndCoplanarPoint(a, t), this.needsUpdate = !1;
    }
};
Vn.prototype.closestPointToSegment = function() {
    let n1 = new E, t = new E, e = new Di;
    return function(i, s1 = null, o = null) {
        let { start: a, end: l } = i, c = this.points, u1, h = 1 / 0;
        for(let d = 0; d < 3; d++){
            let f = (d + 1) % 3;
            e.start.copy(c[d]), e.end.copy(c[f]), Cm(e, i, n1, t), u1 = n1.distanceToSquared(t), u1 < h && (h = u1, s1 && s1.copy(n1), o && o.copy(t));
        }
        return this.closestPointToPoint(a, n1), u1 = a.distanceToSquared(n1), u1 < h && (h = u1, s1 && s1.copy(n1), o && o.copy(a)), this.closestPointToPoint(l, n1), u1 = l.distanceToSquared(n1), u1 < h && (h = u1, s1 && s1.copy(n1), o && o.copy(l)), Math.sqrt(h);
    };
}();
Vn.prototype.intersectsTriangle = function() {
    let n1 = new Vn, t = new Array(3), e = new Array(3), r = new Fn, i = new Fn, s1 = new E, o = new E, a = new E, l = new E, c = new Di, u1 = new Di, h = new Di;
    return function(f, m = null, p = !1) {
        this.needsUpdate && this.update(), f.isExtendedTriangle ? f.needsUpdate && f.update() : (n1.copy(f), n1.update(), f = n1);
        let g = this.plane, y = f.plane;
        if (Math.abs(g.normal.dot(y.normal)) > 1 - 1e-10) {
            let x = this.satBounds, v = this.satAxes;
            e[0] = f.a, e[1] = f.b, e[2] = f.c;
            for(let A = 0; A < 4; A++){
                let T = x[A], S = v[A];
                if (r.setFromPoints(S, e), T.isSeparated(r)) return !1;
            }
            let b = f.satBounds, w = f.satAxes;
            t[0] = this.a, t[1] = this.b, t[2] = this.c;
            for(let A = 0; A < 4; A++){
                let T = b[A], S = w[A];
                if (r.setFromPoints(S, t), T.isSeparated(r)) return !1;
            }
            for(let A = 0; A < 4; A++){
                let T = v[A];
                for(let S = 0; S < 4; S++){
                    let M = w[S];
                    if (s1.crossVectors(T, M), r.setFromPoints(s1, t), i.setFromPoints(s1, e), r.isSeparated(i)) return !1;
                }
            }
            return m && (p || console.warn("ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0."), m.start.set(0, 0, 0), m.end.set(0, 0, 0)), !0;
        } else {
            let x = this.points, v = !1, b = 0;
            for(let O = 0; O < 3; O++){
                let L = x[O], j = x[(O + 1) % 3];
                c.start.copy(L), c.end.copy(j), c.delta(o);
                let V = v ? u1.start : u1.end, H = Cd(y.distanceToPoint(L));
                if (Cd(y.normal.dot(o)) && H) {
                    u1.copy(c), b = 2;
                    break;
                }
                if ((y.intersectLine(c, V) || H) && !Cd(V.distanceTo(j))) {
                    if (b++, v) break;
                    v = !0;
                }
            }
            if (b === 1 && f.containsPoint(u1.end)) return m && (m.start.copy(u1.end), m.end.copy(u1.end)), !0;
            if (b !== 2) return !1;
            let w = f.points, A = !1, T = 0;
            for(let O = 0; O < 3; O++){
                let L = w[O], j = w[(O + 1) % 3];
                c.start.copy(L), c.end.copy(j), c.delta(a);
                let V = A ? h.start : h.end, H = Cd(g.distanceToPoint(L));
                if (Cd(g.normal.dot(a)) && H) {
                    h.copy(c), T = 2;
                    break;
                }
                if ((g.intersectLine(c, V) || H) && !Cd(V.distanceTo(j))) {
                    if (T++, A) break;
                    A = !0;
                }
            }
            if (T === 1 && this.containsPoint(h.end)) return m && (m.start.copy(h.end), m.end.copy(h.end)), !0;
            if (T !== 2) return !1;
            if (u1.delta(o), h.delta(a), o.dot(a) < 0) {
                let O = h.start;
                h.start = h.end, h.end = O;
            }
            let S = u1.start.dot(o), M = u1.end.dot(o), C = h.start.dot(o), P = h.end.dot(o), _ = M < C, I = S < P;
            return S !== P && C !== M && _ === I ? !1 : (m && (l.subVectors(u1.start, h.start), l.dot(o) > 0 ? m.start.copy(u1.start) : m.start.copy(h.start), l.subVectors(u1.end, h.end), l.dot(o) < 0 ? m.end.copy(u1.end) : m.end.copy(h.end)), !0);
        }
    };
}();
Vn.prototype.distanceToPoint = function() {
    let n1 = new E;
    return function(e) {
        return this.closestPointToPoint(e, n1), e.distanceTo(n1);
    };
}();
Vn.prototype.distanceToTriangle = function() {
    let n1 = new E, t = new E, e = [
        "a",
        "b",
        "c"
    ], r = new Di, i = new Di;
    return function(o, a = null, l = null) {
        let c = a || l ? r : null;
        if (this.intersectsTriangle(o, c)) return (a || l) && (a && c.getCenter(a), l && c.getCenter(l)), 0;
        let u1 = 1 / 0;
        for(let h = 0; h < 3; h++){
            let d, f = e[h], m = o[f];
            this.closestPointToPoint(m, n1), d = m.distanceToSquared(n1), d < u1 && (u1 = d, a && a.copy(n1), l && l.copy(m));
            let p = this[f];
            o.closestPointToPoint(p, n1), d = p.distanceToSquared(n1), d < u1 && (u1 = d, a && a.copy(p), l && l.copy(n1));
        }
        for(let h = 0; h < 3; h++){
            let d = e[h], f = e[(h + 1) % 3];
            r.set(this[d], this[f]);
            for(let m = 0; m < 3; m++){
                let p = e[m], g = e[(m + 1) % 3];
                i.set(o[p], o[g]), Cm(r, i, n1, t);
                let y = n1.distanceToSquared(t);
                y < u1 && (u1 = y, a && a.copy(n1), l && l.copy(t));
            }
        }
        return Math.sqrt(u1);
    };
}();
var Un = class {
    constructor(t, e, r){
        this.isOrientedBox = !0, this.min = new E, this.max = new E, this.matrix = new ue, this.invMatrix = new ue, this.points = new Array(8).fill().map(()=>new E), this.satAxes = new Array(3).fill().map(()=>new E), this.satBounds = new Array(3).fill().map(()=>new Fn), this.alignedSatBounds = new Array(3).fill().map(()=>new Fn), this.needsUpdate = !1, t && this.min.copy(t), e && this.max.copy(e), r && this.matrix.copy(r);
    }
    set(t, e, r) {
        this.min.copy(t), this.max.copy(e), this.matrix.copy(r), this.needsUpdate = !0;
    }
    copy(t) {
        this.min.copy(t.min), this.max.copy(t.max), this.matrix.copy(t.matrix), this.needsUpdate = !0;
    }
};
Un.prototype.update = function() {
    return function() {
        let t = this.matrix, e = this.min, r = this.max, i = this.points;
        for(let c = 0; c <= 1; c++)for(let u1 = 0; u1 <= 1; u1++)for(let h = 0; h <= 1; h++){
            let d = 1 * c | 2 * u1 | 4 * h, f = i[d];
            f.x = c ? r.x : e.x, f.y = u1 ? r.y : e.y, f.z = h ? r.z : e.z, f.applyMatrix4(t);
        }
        let s1 = this.satBounds, o = this.satAxes, a = i[0];
        for(let c = 0; c < 3; c++){
            let u1 = o[c], h = s1[c], d = 1 << c, f = i[d];
            u1.subVectors(a, f), h.setFromPoints(u1, i);
        }
        let l = this.alignedSatBounds;
        l[0].setFromPointsField(i, "x"), l[1].setFromPointsField(i, "y"), l[2].setFromPointsField(i, "z"), this.invMatrix.copy(this.matrix).invert(), this.needsUpdate = !1;
    };
}();
Un.prototype.intersectsBox = function() {
    let n1 = new Fn;
    return function(e) {
        this.needsUpdate && this.update();
        let r = e.min, i = e.max, s1 = this.satBounds, o = this.satAxes, a = this.alignedSatBounds;
        if (n1.min = r.x, n1.max = i.x, a[0].isSeparated(n1) || (n1.min = r.y, n1.max = i.y, a[1].isSeparated(n1)) || (n1.min = r.z, n1.max = i.z, a[2].isSeparated(n1))) return !1;
        for(let l = 0; l < 3; l++){
            let c = o[l], u1 = s1[l];
            if (n1.setFromBox(c, e), u1.isSeparated(n1)) return !1;
        }
        return !0;
    };
}();
Un.prototype.intersectsTriangle = function() {
    let n1 = new Vn, t = new Array(3), e = new Fn, r = new Fn, i = new E;
    return function(o) {
        this.needsUpdate && this.update(), o.isExtendedTriangle ? o.needsUpdate && o.update() : (n1.copy(o), n1.update(), o = n1);
        let a = this.satBounds, l = this.satAxes;
        t[0] = o.a, t[1] = o.b, t[2] = o.c;
        for(let d = 0; d < 3; d++){
            let f = a[d], m = l[d];
            if (e.setFromPoints(m, t), f.isSeparated(e)) return !1;
        }
        let c = o.satBounds, u1 = o.satAxes, h = this.points;
        for(let d = 0; d < 3; d++){
            let f = c[d], m = u1[d];
            if (e.setFromPoints(m, h), f.isSeparated(e)) return !1;
        }
        for(let d = 0; d < 3; d++){
            let f = l[d];
            for(let m = 0; m < 4; m++){
                let p = u1[m];
                if (i.crossVectors(f, p), e.setFromPoints(i, t), r.setFromPoints(i, h), e.isSeparated(r)) return !1;
            }
        }
        return !0;
    };
}();
Un.prototype.closestPointToPoint = function() {
    return function(t, e) {
        return this.needsUpdate && this.update(), e.copy(t).applyMatrix4(this.invMatrix).clamp(this.min, this.max).applyMatrix4(this.matrix), e;
    };
}();
Un.prototype.distanceToPoint = function() {
    let n1 = new E;
    return function(e) {
        return this.closestPointToPoint(e, n1), e.distanceTo(n1);
    };
}();
Un.prototype.distanceToBox = function() {
    let n1 = [
        "x",
        "y",
        "z"
    ], t = new Array(12).fill().map(()=>new Di), e = new Array(12).fill().map(()=>new Di), r = new E, i = new E;
    return function(o, a = 0, l = null, c = null) {
        if (this.needsUpdate && this.update(), this.intersectsBox(o)) return (l || c) && (o.getCenter(i), this.closestPointToPoint(i, r), o.closestPointToPoint(r, i), l && l.copy(r), c && c.copy(i)), 0;
        let u1 = a * a, h = o.min, d = o.max, f = this.points, m = 1 / 0;
        for(let g = 0; g < 8; g++){
            let y = f[g];
            i.copy(y).clamp(h, d);
            let x = y.distanceToSquared(i);
            if (x < m && (m = x, l && l.copy(y), c && c.copy(i), x < u1)) return Math.sqrt(x);
        }
        let p = 0;
        for(let g = 0; g < 3; g++)for(let y = 0; y <= 1; y++)for(let x = 0; x <= 1; x++){
            let v = (g + 1) % 3, b = (g + 2) % 3, w = y << v | x << b, A = 1 << g | y << v | x << b, T = f[w], S = f[A];
            t[p].set(T, S);
            let C = n1[g], P = n1[v], _ = n1[b], I = e[p], O = I.start, L = I.end;
            O[C] = h[C], O[P] = y ? h[P] : d[P], O[_] = x ? h[_] : d[P], L[C] = d[C], L[P] = y ? h[P] : d[P], L[_] = x ? h[_] : d[P], p++;
        }
        for(let g = 0; g <= 1; g++)for(let y = 0; y <= 1; y++)for(let x = 0; x <= 1; x++){
            i.x = g ? d.x : h.x, i.y = y ? d.y : h.y, i.z = x ? d.z : h.z, this.closestPointToPoint(i, r);
            let v = i.distanceToSquared(r);
            if (v < m && (m = v, l && l.copy(r), c && c.copy(i), v < u1)) return Math.sqrt(v);
        }
        for(let g = 0; g < 12; g++){
            let y = t[g];
            for(let x = 0; x < 12; x++){
                let v = e[x];
                Cm(y, v, r, i);
                let b = r.distanceToSquared(i);
                if (b < m && (m = b, l && l.copy(r), c && c.copy(i), b < u1)) return Math.sqrt(b);
            }
        }
        return Math.sqrt(m);
    };
}();
var Pd = new E, _d = new E, Id = new E, nx = new U, sx = new U, ox = new U, zR = new E, GR = new E, jR = new E, ax = new E;
function uK(n1, t, e, r, i, s1) {
    let o;
    return s1 === xi ? o = n1.intersectTriangle(r, e, t, !0, i) : o = n1.intersectTriangle(t, e, r, s1 !== vi, i), o === null ? null : {
        distance: n1.origin.distanceTo(i),
        point: i.clone()
    };
}
function hK(n1, t, e, r, i, s1, o, a, l) {
    Pd.fromBufferAttribute(t, s1), _d.fromBufferAttribute(t, o), Id.fromBufferAttribute(t, a);
    let c = uK(n1, Pd, _d, Id, ax, l);
    if (c) {
        r && (nx.fromBufferAttribute(r, s1), sx.fromBufferAttribute(r, o), ox.fromBufferAttribute(r, a), c.uv = Or.getInterpolation(ax, Pd, _d, Id, nx, sx, ox, new U)), i && (nx.fromBufferAttribute(i, s1), sx.fromBufferAttribute(i, o), ox.fromBufferAttribute(i, a), c.uv1 = Or.getInterpolation(ax, Pd, _d, Id, nx, sx, ox, new U)), e && (zR.fromBufferAttribute(e, s1), GR.fromBufferAttribute(e, o), jR.fromBufferAttribute(e, a), c.normal = Or.getInterpolation(ax, Pd, _d, Id, zR, GR, jR, new E), c.normal.dot(n1.direction) > 0 && c.normal.multiplyScalar(-1));
        let u1 = {
            a: s1,
            b: o,
            c: a,
            normal: new E,
            materialIndex: 0
        };
        Or.getNormal(Pd, _d, Id, u1.normal), c.face = u1, c.faceIndex = s1;
    }
    return c;
}
function fE(n1, t, e, r, i) {
    let s1 = r * 3, o = n1.index.getX(s1), a = n1.index.getX(s1 + 1), l = n1.index.getX(s1 + 2), { position: c, normal: u1, uv: h, uv1: d } = n1.attributes, f = hK(e, c, u1, h, d, o, a, l, t);
    return f ? (f.faceIndex = r, i && i.push(f), f) : null;
}
function HR(n1, t, e, r, i, s1) {
    for(let o = r, a = r + i; o < a; o++)fE(n1, t, e, o, s1);
}
function WR(n1, t, e, r, i) {
    let s1 = 1 / 0, o = null;
    for(let a = r, l = r + i; a < l; a++){
        let c = fE(n1, t, e, a);
        c && c.distance < s1 && (o = c, s1 = c.distance);
    }
    return o;
}
function Ps(n1, t, e, r) {
    let i = n1.a, s1 = n1.b, o = n1.c, a = t, l = t + 1, c = t + 2;
    e && (a = e.getX(t), l = e.getX(t + 1), c = e.getX(t + 2)), i.x = r.getX(a), i.y = r.getY(a), i.z = r.getZ(a), s1.x = r.getX(l), s1.y = r.getY(l), s1.z = r.getZ(l), o.x = r.getX(c), o.y = r.getY(c), o.z = r.getZ(c);
}
function pE(n1, t, e, r, i, s1, o) {
    let a = e.index, l = e.attributes.position;
    for(let c = n1, u1 = t + n1; c < u1; c++)if (Ps(o, c * 3, a, l), o.needsUpdate = !0, r(o, c, i, s1)) return !0;
    return !1;
}
var Dd = class {
    constructor(t){
        this._getNewPrimitive = t, this._primitives = [];
    }
    getPrimitive() {
        let t = this._primitives;
        return t.length === 0 ? this._getNewPrimitive() : t.pop();
    }
    releasePrimitive(t) {
        this._primitives.push(t);
    }
};
function qa(n1, t) {
    return t[n1 + 15] === 65535;
}
function nu(n1, t) {
    return t[n1 + 6];
}
function Od(n1, t) {
    return t[n1 + 14];
}
function Rd(n1) {
    return n1 + 8;
}
function Ld(n1, t) {
    return t[n1 + 6];
}
function qR(n1, t) {
    return t[n1 + 7];
}
var Nd = new Yt, cx = new E, fK = [
    "x",
    "y",
    "z"
];
function ux(n1, t, e, r, i) {
    let s1 = n1 * 2, o = Bd, a = Kl, l = Ql;
    if (qa(s1, a)) {
        let u1 = nu(n1, l), h = Od(s1, a);
        HR(t, e, r, u1, h, i);
    } else {
        let u1 = Rd(n1);
        dx(u1, o, r, cx) && ux(u1, t, e, r, i);
        let h = Ld(n1, l);
        dx(h, o, r, cx) && ux(h, t, e, r, i);
    }
}
function hx(n1, t, e, r) {
    let i = n1 * 2, s1 = Bd, o = Kl, a = Ql;
    if (qa(i, o)) {
        let c = nu(n1, a), u1 = Od(i, o);
        return WR(t, e, r, c, u1);
    } else {
        let c = qR(n1, a), u1 = fK[c], d = r.direction[u1] >= 0, f, m;
        d ? (f = Rd(n1), m = Ld(n1, a)) : (f = Ld(n1, a), m = Rd(n1));
        let g = dx(f, s1, r, cx) ? hx(f, t, e, r) : null;
        if (g) {
            let v = g.point[u1];
            if (d ? v <= s1[m + c] : v >= s1[m + c + 3]) return g;
        }
        let x = dx(m, s1, r, cx) ? hx(m, t, e, r) : null;
        return g && x ? g.distance <= x.distance ? g : x : g || x || null;
    }
}
var XR = function() {
    let n1, t, e = [], r = new Dd(()=>new Yt);
    return function(...o) {
        n1 = r.getPrimitive(), t = r.getPrimitive(), e.push(n1, t);
        let a = i(...o);
        r.releasePrimitive(n1), r.releasePrimitive(t), e.pop(), e.pop();
        let l = e.length;
        return l > 0 && (t = e[l - 1], n1 = e[l - 2]), a;
    };
    function i(s1, o, a, l, c = null, u1 = 0, h = 0) {
        function d(v) {
            let b = v * 2, w = Kl, A = Ql;
            for(; !qa(b, w);)v = Rd(v), b = v * 2;
            return nu(v, A);
        }
        function f(v) {
            let b = v * 2, w = Kl, A = Ql;
            for(; !qa(b, w);)v = Ld(v, A), b = v * 2;
            return nu(v, A) + Od(b, w);
        }
        let m = s1 * 2, p = Bd, g = Kl, y = Ql;
        if (qa(m, g)) {
            let v = nu(s1, y), b = Od(m, g);
            return Cs(s1, p, n1), l(v, b, !1, h, u1 + s1, n1);
        } else {
            let v = Rd(s1), b = Ld(s1, y), w = v, A = b, T, S, M, C;
            if (c && (M = n1, C = t, Cs(w, p, M), Cs(A, p, C), T = c(M), S = c(C), S < T)) {
                w = b, A = v;
                let V = T;
                T = S, S = V, M = C;
            }
            M || (M = n1, Cs(w, p, M));
            let P = qa(w * 2, g), _ = a(M, P, T, h + 1, u1 + w), I;
            if (_ === 2) {
                let V = d(w), q = f(w) - V;
                I = l(V, q, !0, h + 1, u1 + w, M);
            } else I = _ && i(w, o, a, l, c, u1, h + 1);
            if (I) return !0;
            C = t, Cs(A, p, C);
            let O = qa(A * 2, g), L = a(C, O, S, h + 1, u1 + A), j;
            if (L === 2) {
                let V = d(A), q = f(A) - V;
                j = l(V, q, !0, h + 1, u1 + A, C);
            } else j = L && i(A, o, a, l, c, u1, h + 1);
            return !!j;
        }
    }
}(), YR = function() {
    let n1 = new Vn, t = new Vn, e = new ue, r = new Un, i = new Un;
    return function s1(o, a, l, c, u1 = null) {
        let h = o * 2, d = Bd, f = Kl, m = Ql;
        if (u1 === null && (l.boundingBox || l.computeBoundingBox(), r.set(l.boundingBox.min, l.boundingBox.max, c), u1 = r), qa(h, f)) {
            let g = a, y = g.index, x = g.attributes.position, v = l.index, b = l.attributes.position, w = nu(o, m), A = Od(h, f);
            if (e.copy(c).invert(), l.boundsTree) return Cs(o, d, i), i.matrix.copy(e), i.needsUpdate = !0, l.boundsTree.shapecast({
                intersectsBounds: (S)=>i.intersectsBox(S),
                intersectsTriangle: (S)=>{
                    S.a.applyMatrix4(c), S.b.applyMatrix4(c), S.c.applyMatrix4(c), S.needsUpdate = !0;
                    for(let M = w * 3, C = (A + w) * 3; M < C; M += 3)if (Ps(t, M, y, x), t.needsUpdate = !0, S.intersectsTriangle(t)) return !0;
                    return !1;
                }
            });
            for(let T = w * 3, S = A + w * 3; T < S; T += 3){
                Ps(n1, T, y, x), n1.a.applyMatrix4(e), n1.b.applyMatrix4(e), n1.c.applyMatrix4(e), n1.needsUpdate = !0;
                for(let M = 0, C = v.count; M < C; M += 3)if (Ps(t, M, v, b), t.needsUpdate = !0, n1.intersectsTriangle(t)) return !0;
            }
        } else {
            let g = o + 8, y = m[o + 6];
            return Cs(g, d, Nd), !!(u1.intersectsBox(Nd) && s1(g, a, l, c, u1) || (Cs(y, d, Nd), u1.intersectsBox(Nd) && s1(y, a, l, c, u1)));
        }
    };
}();
function dx(n1, t, e, r) {
    return Cs(n1, t, Nd), e.intersectBox(Nd, r);
}
var mE = [], lx, Bd, Kl, Ql;
function Fd(n1) {
    lx && mE.push(lx), lx = n1, Bd = new Float32Array(n1), Kl = new Uint16Array(n1), Ql = new Uint32Array(n1);
}
function Pm() {
    lx = null, Bd = null, Kl = null, Ql = null, mE.length && Fd(mE.pop());
}
var gE = Symbol("skip tree generation"), yE = new Yt, vE = new Yt, Vd = new ue, su = new Un, _m = new Un, Im = new E, fx = new E, pK = new E, mK = new E, gK = new E, KR = new Yt, Xo = new Dd(()=>new Vn), Yo = class {
    static serialize(t, e = {}) {
        if (e.isBufferGeometry) return console.warn("MeshBVH.serialize: The arguments for the function have changed. See documentation for new signature."), Yo.serialize(arguments[0], {
            cloneBuffers: arguments[2] === void 0 ? !0 : arguments[2]
        });
        e = {
            cloneBuffers: !0,
            ...e
        };
        let r = t.geometry, i = t._roots, s1 = r.getIndex(), o;
        return e.cloneBuffers ? o = {
            roots: i.map((a)=>a.slice()),
            index: s1.array.slice()
        } : o = {
            roots: i,
            index: s1.array
        }, o;
    }
    static deserialize(t, e, r = {}) {
        if (typeof r == "boolean") return console.warn("MeshBVH.deserialize: The arguments for the function have changed. See documentation for new signature."), Yo.deserialize(arguments[0], arguments[1], {
            setIndex: arguments[2] === void 0 ? !0 : arguments[2]
        });
        r = {
            setIndex: !0,
            ...r
        };
        let { index: i, roots: s1 } = t, o = new Yo(e, {
            ...r,
            [gE]: !0
        });
        if (o._roots = s1, r.setIndex) {
            let a = e.getIndex();
            if (a === null) {
                let l = new je(t.index, 1, !1);
                e.setIndex(l);
            } else a.array !== i && (a.array.set(i), a.needsUpdate = !0);
        }
        return o;
    }
    constructor(t, e = {}){
        if (t.isBufferGeometry) {
            if (t.index && t.index.isInterleavedBufferAttribute) throw new Error("MeshBVH: InterleavedBufferAttribute is not supported for the index attribute.");
        } else throw new Error("MeshBVH: Only BufferGeometries are supported.");
        if (e = Object.assign({
            strategy: 0,
            maxDepth: 40,
            maxLeafTris: 10,
            verbose: !0,
            useSharedArrayBuffer: !1,
            setBoundingBox: !0,
            onProgress: null,
            [gE]: !1
        }, e), e.useSharedArrayBuffer && typeof SharedArrayBuffer > "u") throw new Error("MeshBVH: SharedArrayBuffer is not available.");
        this._roots = null, e[gE] || (this._roots = UR(t, e), !t.boundingBox && e.setBoundingBox && (t.boundingBox = this.getBoundingBox(new Yt))), this.geometry = t;
    }
    refit(t = null) {
        t && Array.isArray(t) && (t = new Set(t));
        let e = this.geometry, r = e.index.array, i = e.attributes.position, s1, o, a, l, c = 0, u1 = this._roots;
        for(let d = 0, f = u1.length; d < f; d++)s1 = u1[d], o = new Uint32Array(s1), a = new Uint16Array(s1), l = new Float32Array(s1), h(0, c), c += s1.byteLength;
        function h(d, f, m = !1) {
            let p = d * 2;
            if (a[p + 15] === 65535) {
                let y = o[d + 6], x = a[p + 14], v = 1 / 0, b = 1 / 0, w = 1 / 0, A = -1 / 0, T = -1 / 0, S = -1 / 0;
                for(let M = 3 * y, C = 3 * (y + x); M < C; M++){
                    let P = r[M], _ = i.getX(P), I = i.getY(P), O = i.getZ(P);
                    _ < v && (v = _), _ > A && (A = _), I < b && (b = I), I > T && (T = I), O < w && (w = O), O > S && (S = O);
                }
                return l[d + 0] !== v || l[d + 1] !== b || l[d + 2] !== w || l[d + 3] !== A || l[d + 4] !== T || l[d + 5] !== S ? (l[d + 0] = v, l[d + 1] = b, l[d + 2] = w, l[d + 3] = A, l[d + 4] = T, l[d + 5] = S, !0) : !1;
            } else {
                let y = d + 8, x = o[d + 6], v = y + f, b = x + f, w = m, A = !1, T = !1;
                t ? w || (A = t.has(v), T = t.has(b), w = !A && !T) : (A = !0, T = !0);
                let S = w || A, M = w || T, C = !1;
                S && (C = h(y, f, w));
                let P = !1;
                M && (P = h(x, f, w));
                let _ = C || P;
                if (_) for(let I = 0; I < 3; I++){
                    let O = y + I, L = x + I, j = l[O], V = l[O + 3], H = l[L], q = l[L + 3];
                    l[d + I] = j < H ? j : H, l[d + I + 3] = V > q ? V : q;
                }
                return _;
            }
        }
    }
    traverse(t, e = 0) {
        let r = this._roots[e], i = new Uint32Array(r), s1 = new Uint16Array(r);
        o(0);
        function o(a, l = 0) {
            let c = a * 2, u1 = s1[c + 15] === 65535;
            if (u1) {
                let h = i[a + 6], d = s1[c + 14];
                t(l, u1, new Float32Array(r, a * 4, 6), h, d);
            } else {
                let h = a + 8, d = i[a + 6], f = i[a + 7];
                t(l, u1, new Float32Array(r, a * 4, 6), f) || (o(h, l + 1), o(d, l + 1));
            }
        }
    }
    raycast(t, e = Jn) {
        let r = this._roots, i = this.geometry, s1 = [], o = e.isMaterial, a = Array.isArray(e), l = i.groups, c = o ? e.side : e;
        for(let u1 = 0, h = r.length; u1 < h; u1++){
            let d = a ? e[l[u1].materialIndex].side : c, f = s1.length;
            if (Fd(r[u1]), ux(0, i, d, t, s1), Pm(), a) {
                let m = l[u1].materialIndex;
                for(let p = f, g = s1.length; p < g; p++)s1[p].face.materialIndex = m;
            }
        }
        return s1;
    }
    raycastFirst(t, e = Jn) {
        let r = this._roots, i = this.geometry, s1 = e.isMaterial, o = Array.isArray(e), a = null, l = i.groups, c = s1 ? e.side : e;
        for(let u1 = 0, h = r.length; u1 < h; u1++){
            let d = o ? e[l[u1].materialIndex].side : c;
            Fd(r[u1]);
            let f = hx(0, i, d, t);
            Pm(), f != null && (a == null || f.distance < a.distance) && (a = f, o && (f.face.materialIndex = l[u1].materialIndex));
        }
        return a;
    }
    intersectsGeometry(t, e) {
        let r = this.geometry, i = !1;
        for (let s1 of this._roots)if (Fd(s1), i = YR(0, r, t, e), Pm(), i) break;
        return i;
    }
    shapecast(t, e, r) {
        let i = this.geometry;
        if (t instanceof Function) {
            if (e) {
                let d = e;
                e = (f, m, p, g)=>{
                    let y = m * 3;
                    return d(f, y, y + 1, y + 2, p, g);
                };
            }
            t = {
                boundsTraverseOrder: r,
                intersectsBounds: t,
                intersectsTriangle: e,
                intersectsRange: null
            }, console.warn("MeshBVH: Shapecast function signature has changed and now takes an object of callbacks as a second argument. See docs for new signature.");
        }
        let s1 = Xo.getPrimitive(), { boundsTraverseOrder: o, intersectsBounds: a, intersectsRange: l, intersectsTriangle: c } = t;
        if (l && c) {
            let d = l;
            l = (f, m, p, g, y)=>d(f, m, p, g, y) ? !0 : pE(f, m, i, c, p, g, s1);
        } else l || (c ? l = (d, f, m, p)=>pE(d, f, i, c, m, p, s1) : l = (d, f, m)=>m);
        let u1 = !1, h = 0;
        for (let d of this._roots){
            if (Fd(d), u1 = XR(0, i, a, l, o, h), Pm(), u1) break;
            h += d.byteLength;
        }
        return Xo.releasePrimitive(s1), u1;
    }
    bvhcast(t, e, r) {
        let { intersectsRanges: i, intersectsTriangles: s1 } = r, o = this.geometry.index, a = this.geometry.attributes.position, l = t.geometry.index, c = t.geometry.attributes.position;
        Vd.copy(e).invert();
        let u1 = Xo.getPrimitive(), h = Xo.getPrimitive();
        if (s1) {
            let f = function(m, p, g, y, x, v, b, w) {
                for(let A = g, T = g + y; A < T; A++){
                    Ps(h, A * 3, l, c), h.a.applyMatrix4(e), h.b.applyMatrix4(e), h.c.applyMatrix4(e), h.needsUpdate = !0;
                    for(let S = m, M = m + p; S < M; S++)if (Ps(u1, S * 3, o, a), u1.needsUpdate = !0, s1(u1, h, S, A, x, v, b, w)) return !0;
                }
                return !1;
            };
            if (i) {
                let m = i;
                i = function(p, g, y, x, v, b, w, A) {
                    return m(p, g, y, x, v, b, w, A) ? !0 : f(p, g, y, x, v, b, w, A);
                };
            } else i = f;
        }
        t.getBoundingBox(vE), vE.applyMatrix4(e);
        let d = this.shapecast({
            intersectsBounds: (f)=>vE.intersectsBox(f),
            intersectsRange: (f, m, p, g, y, x)=>(yE.copy(x), yE.applyMatrix4(Vd), t.shapecast({
                    intersectsBounds: (v)=>yE.intersectsBox(v),
                    intersectsRange: (v, b, w, A, T)=>i(f, m, v, b, g, y, A, T)
                }))
        });
        return Xo.releasePrimitive(u1), Xo.releasePrimitive(h), d;
    }
    intersectsBox(t, e) {
        return su.set(t.min, t.max, e), su.needsUpdate = !0, this.shapecast({
            intersectsBounds: (r)=>su.intersectsBox(r),
            intersectsTriangle: (r)=>su.intersectsTriangle(r)
        });
    }
    intersectsSphere(t) {
        return this.shapecast({
            intersectsBounds: (e)=>t.intersectsBox(e),
            intersectsTriangle: (e)=>e.intersectsSphere(t)
        });
    }
    closestPointToGeometry(t, e, r = {}, i = {}, s1 = 0, o = 1 / 0) {
        t.boundingBox || t.computeBoundingBox(), su.set(t.boundingBox.min, t.boundingBox.max, e), su.needsUpdate = !0;
        let a = this.geometry, l = a.attributes.position, c = a.index, u1 = t.attributes.position, h = t.index, d = Xo.getPrimitive(), f = Xo.getPrimitive(), m = fx, p = pK, g = null, y = null;
        i && (g = mK, y = gK);
        let x = 1 / 0, v = null, b = null;
        return Vd.copy(e).invert(), _m.matrix.copy(Vd), this.shapecast({
            boundsTraverseOrder: (w)=>su.distanceToBox(w),
            intersectsBounds: (w, A, T)=>T < x && T < o ? (A && (_m.min.copy(w.min), _m.max.copy(w.max), _m.needsUpdate = !0), !0) : !1,
            intersectsRange: (w, A)=>{
                if (t.boundsTree) return t.boundsTree.shapecast({
                    boundsTraverseOrder: (T)=>_m.distanceToBox(T),
                    intersectsBounds: (T, S, M)=>M < x && M < o,
                    intersectsRange: (T, S)=>{
                        for(let M = T * 3, C = (T + S) * 3; M < C; M += 3){
                            Ps(f, M, h, u1), f.a.applyMatrix4(e), f.b.applyMatrix4(e), f.c.applyMatrix4(e), f.needsUpdate = !0;
                            for(let P = w * 3, _ = (w + A) * 3; P < _; P += 3){
                                Ps(d, P, c, l), d.needsUpdate = !0;
                                let I = d.distanceToTriangle(f, m, g);
                                if (I < x && (p.copy(m), y && y.copy(g), x = I, v = P / 3, b = M / 3), I < s1) return !0;
                            }
                        }
                    }
                });
                {
                    let T = h ? h.count : u1.count;
                    for(let S = 0, M = T; S < M; S += 3){
                        Ps(f, S, h, u1), f.a.applyMatrix4(e), f.b.applyMatrix4(e), f.c.applyMatrix4(e), f.needsUpdate = !0;
                        for(let C = w * 3, P = (w + A) * 3; C < P; C += 3){
                            Ps(d, C, c, l), d.needsUpdate = !0;
                            let _ = d.distanceToTriangle(f, m, g);
                            if (_ < x && (p.copy(m), y && y.copy(g), x = _, v = C / 3, b = S / 3), _ < s1) return !0;
                        }
                    }
                }
            }
        }), Xo.releasePrimitive(d), Xo.releasePrimitive(f), x === 1 / 0 ? null : (r.point ? r.point.copy(p) : r.point = p.clone(), r.distance = x, r.faceIndex = v, i && (i.point ? i.point.copy(y) : i.point = y.clone(), i.point.applyMatrix4(Vd), p.applyMatrix4(Vd), i.distance = p.sub(i.point).length(), i.faceIndex = b), r);
    }
    closestPointToPoint(t, e = {}, r = 0, i = 1 / 0) {
        let s1 = r * r, o = i * i, a = 1 / 0, l = null;
        if (this.shapecast({
            boundsTraverseOrder: (u1)=>(Im.copy(t).clamp(u1.min, u1.max), Im.distanceToSquared(t)),
            intersectsBounds: (u1, h, d)=>d < a && d < o,
            intersectsTriangle: (u1, h)=>{
                u1.closestPointToPoint(t, Im);
                let d = t.distanceToSquared(Im);
                return d < a && (fx.copy(Im), a = d, l = h), d < s1;
            }
        }), a === 1 / 0) return null;
        let c = Math.sqrt(a);
        return e.point ? e.point.copy(fx) : e.point = fx.clone(), e.distance = c, e.faceIndex = l, e;
    }
    getBoundingBox(t) {
        return t.makeEmpty(), this._roots.forEach((r)=>{
            Cs(0, new Float32Array(r), KR), t.union(KR);
        }), t;
    }
};
var hb = cl(ZR());
var yK = .5 * (Math.sqrt(3) - 1), Dm = (3 - Math.sqrt(3)) / 6, vK = 1 / 3, Ko = 1 / 6, M0e = (Math.sqrt(5) - 1) / 4, C0e = (5 - Math.sqrt(5)) / 20, Om = (n1)=>Math.floor(n1) | 0, JR = new Float64Array([
    1,
    1,
    -1,
    1,
    1,
    -1,
    -1,
    -1,
    1,
    0,
    -1,
    0,
    1,
    0,
    -1,
    0,
    0,
    1,
    0,
    -1,
    0,
    1,
    0,
    -1
]), bE = new Float64Array([
    1,
    1,
    0,
    -1,
    1,
    0,
    1,
    -1,
    0,
    -1,
    -1,
    0,
    1,
    0,
    1,
    -1,
    0,
    1,
    1,
    0,
    -1,
    -1,
    0,
    -1,
    0,
    1,
    1,
    0,
    -1,
    1,
    0,
    1,
    -1,
    0,
    -1,
    -1
]);
function $R(n1 = Math.random) {
    let t = t3(n1), e = new Float64Array(t).map((i)=>JR[i % 12 * 2]), r = new Float64Array(t).map((i)=>JR[i % 12 * 2 + 1]);
    return function(s1, o) {
        let a = 0, l = 0, c = 0, u1 = (s1 + o) * yK, h = Om(s1 + u1), d = Om(o + u1), f = (h + d) * Dm, m = h - f, p = d - f, g = s1 - m, y = o - p, x, v;
        g > y ? (x = 1, v = 0) : (x = 0, v = 1);
        let b = g - x + Dm, w = y - v + Dm, A = g - 1 + 2 * Dm, T = y - 1 + 2 * Dm, S = h & 255, M = d & 255, C = .5 - g * g - y * y;
        if (C >= 0) {
            let I = S + t[M], O = e[I], L = r[I];
            C *= C, a = C * C * (O * g + L * y);
        }
        let P = .5 - b * b - w * w;
        if (P >= 0) {
            let I = S + x + t[M + v], O = e[I], L = r[I];
            P *= P, l = P * P * (O * b + L * w);
        }
        let _ = .5 - A * A - T * T;
        if (_ >= 0) {
            let I = S + 1 + t[M + 1], O = e[I], L = r[I];
            _ *= _, c = _ * _ * (O * A + L * T);
        }
        return 70 * (a + l + c);
    };
}
function e3(n1 = Math.random) {
    let t = t3(n1), e = new Float64Array(t).map((s1)=>bE[s1 % 12 * 3]), r = new Float64Array(t).map((s1)=>bE[s1 % 12 * 3 + 1]), i = new Float64Array(t).map((s1)=>bE[s1 % 12 * 3 + 2]);
    return function(o, a, l) {
        let c, u1, h, d, f = (o + a + l) * vK, m = Om(o + f), p = Om(a + f), g = Om(l + f), y = (m + p + g) * Ko, x = m - y, v = p - y, b = g - y, w = o - x, A = a - v, T = l - b, S, M, C, P, _, I;
        w >= A ? A >= T ? (S = 1, M = 0, C = 0, P = 1, _ = 1, I = 0) : w >= T ? (S = 1, M = 0, C = 0, P = 1, _ = 0, I = 1) : (S = 0, M = 0, C = 1, P = 1, _ = 0, I = 1) : A < T ? (S = 0, M = 0, C = 1, P = 0, _ = 1, I = 1) : w < T ? (S = 0, M = 1, C = 0, P = 0, _ = 1, I = 1) : (S = 0, M = 1, C = 0, P = 1, _ = 1, I = 0);
        let O = w - S + Ko, L = A - M + Ko, j = T - C + Ko, V = w - P + 2 * Ko, H = A - _ + 2 * Ko, q = T - I + 2 * Ko, X = w - 1 + 3 * Ko, K = A - 1 + 3 * Ko, z = T - 1 + 3 * Ko, Q = m & 255, te = p & 255, $ = g & 255, W = .6 - w * w - A * A - T * T;
        if (W < 0) c = 0;
        else {
            let J = Q + t[te + t[$]];
            W *= W, c = W * W * (e[J] * w + r[J] * A + i[J] * T);
        }
        let oe = .6 - O * O - L * L - j * j;
        if (oe < 0) u1 = 0;
        else {
            let J = Q + S + t[te + M + t[$ + C]];
            oe *= oe, u1 = oe * oe * (e[J] * O + r[J] * L + i[J] * j);
        }
        let ie = .6 - V * V - H * H - q * q;
        if (ie < 0) h = 0;
        else {
            let J = Q + P + t[te + _ + t[$ + I]];
            ie *= ie, h = ie * ie * (e[J] * V + r[J] * H + i[J] * q);
        }
        let re = .6 - X * X - K * K - z * z;
        if (re < 0) d = 0;
        else {
            let J = Q + 1 + t[te + 1 + t[$ + 1]];
            re *= re, d = re * re * (e[J] * X + r[J] * K + i[J] * z);
        }
        return 32 * (c + u1 + h + d);
    };
}
function t3(n1) {
    let e = new Uint8Array(512);
    for(let r = 0; r < 256; r++)e[r] = r;
    for(let r = 0; r < 255; r++){
        let i = r + ~~(n1() * (256 - r)), s1 = e[r];
        e[r] = e[i], e[i] = s1;
    }
    for(let r = 256; r < 512; r++)e[r] = e[r - 256];
    return e;
}
var eo = new Or, px = class {
    constructor(t){
        this.weightAttribute = null;
        let e = t.geometry;
        if (!e.isBufferGeometry || e.attributes.position.itemSize !== 3) throw new Error("THREE.MeshSurfaceSampler: Requires BufferGeometry triangle mesh.");
        e.index && (e = e.toNonIndexed()), this.geometry = e, this.randomFunction = Math.random, this.positionAttribute = this.geometry.getAttribute("position"), this.distribution = null;
    }
    build() {
        let t = this.positionAttribute, e = new Float32Array(t.count / 3);
        for(let i = 0; i < t.count; i += 3){
            let s1 = 1;
            eo.a.fromBufferAttribute(t, i), eo.b.fromBufferAttribute(t, i + 1), eo.c.fromBufferAttribute(t, i + 2), s1 *= eo.getArea(), e[i / 3] = s1;
        }
        this.distribution = new Float32Array(t.count / 3);
        let r = 0;
        for(let i = 0; i < e.length; i++)r += e[i], this.distribution[i] = r;
        return this;
    }
    setRandomGenerator(t) {
        return this.randomFunction = t, this;
    }
    sample(t, e) {
        if (this.distribution) {
            let r = this.distribution[this.distribution.length - 1], i = this.binarySearch(this.randomFunction() * r);
            return this.sampleFace(i, t, e);
        }
    }
    binarySearch(t) {
        if (!this.distribution) return 0;
        let e = this.distribution, r = 0, i = e.length - 1, s1 = -1;
        for(; r <= i;){
            let o = Math.ceil((r + i) / 2);
            if (o === 0 || e[o - 1] <= t && e[o] > t) {
                s1 = o;
                break;
            } else t < e[o] ? i = o - 1 : r = o + 1;
        }
        return s1;
    }
    sampleFace(t, e, r) {
        let i = this.randomFunction(), s1 = this.randomFunction();
        return i + s1 > 1 && (i = 1 - i, s1 = 1 - s1), eo.a.fromBufferAttribute(this.positionAttribute, t * 3), eo.b.fromBufferAttribute(this.positionAttribute, t * 3 + 1), eo.c.fromBufferAttribute(this.positionAttribute, t * 3 + 2), e.set(0, 0, 0).addScaledVector(eo.a, i).addScaledVector(eo.b, s1).addScaledVector(eo.c, 1 - (i + s1)), eo.getNormal(r), this;
    }
};
var i3 = cl(SE()), xK = new ue, bK = new ue, SK = new ue, Xa;
((t)=>{
    function n1(e) {
        return e && e.__isSPEObject;
    }
    t.is = n1;
})(Xa || (Xa = {}));
var Ud = (n1)=>class extends n1 {
        constructor(){
            super(...arguments);
            this.previousModelViewMatrix = new ue;
            this.copyPreviousMatrix = !0;
            this.hiddenMatrix = new ue;
            this.pivotMatrix = new ue;
            this.matrixWorldRigid = new ue;
            this.shearScale = new ue;
            this.shearScaleInv = new ue;
        }
        get __isSPEObject() {
            return !0;
        }
        isDescendantOf(r) {
            r instanceof Dt && (r = r.uuid);
            let i = this;
            for(; i.parent;){
                if (i.parent.uuid === r) return !0;
                i = i.parent;
            }
            return !1;
        }
        updateMatrixWorld(r) {
            this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || r) && (this.parent === null ? this.matrixWorld.multiplyMatrices(this.hiddenMatrix, this.matrix) : (this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.hiddenMatrix), this.matrixWorld.multiplyMatrices(this.matrixWorld, this.matrix)), this.matrixWorld.multiply(this.pivotMatrix), this.matrixWorldNeedsUpdate = !1, r = !0);
            for (let i of this.children)i.updateMatrixWorld(r);
        }
        updateWorldMatrix(r, i) {
            let s1 = this.parent;
            if (r && s1 !== null && s1.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.parent === null ? this.matrixWorld.multiplyMatrices(this.hiddenMatrix, this.matrix) : (this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.hiddenMatrix), this.matrixWorld.multiplyMatrices(this.matrixWorld, this.matrix)), this.matrixWorld.multiply(this.pivotMatrix), i) for (let o of this.children)o.updateWorldMatrix(!1, !0);
        }
        traverseChildren(r, i = 0) {
            for (let s1 of this.children)Xa.is(s1) && s1.traverseObject(r, i + 1);
        }
        traverseObject(r, i = 0) {
            if (r(this, i) !== !0) for (let o of this.children)Xa.is(o) && o.traverseObject(r, i + 1);
        }
        updateMatrixWorldSVD() {
            let r = this.matrixWorld.elements, i = [
                [
                    r[0],
                    r[4],
                    r[8]
                ],
                [
                    r[1],
                    r[5],
                    r[9]
                ],
                [
                    r[2],
                    r[6],
                    r[10]
                ]
            ], { u: s1, v: o, q: a } = (0, i3.SVD)(i), l = xK.set(s1[0][0], s1[0][1], s1[0][2], 0, s1[1][0], s1[1][1], s1[1][2], 0, s1[2][0], s1[2][1], s1[2][2], 0, 0, 0, 0, 1), c = bK.set(o[0][0], o[0][1], o[0][2], 0, o[1][0], o[1][1], o[1][2], 0, o[2][0], o[2][1], o[2][2], 0, 0, 0, 0, 1), u1 = SK.copy(c).transpose();
            this.shearScale.makeScale(a[0], a[1], a[2]).multiply(u1).premultiply(c), this.shearScaleInv.copy(this.shearScale).invert(), this.matrixWorldRigid.multiplyMatrices(l, u1).copyPosition(this.matrixWorld), a.every((h)=>Math.abs(a[0] - h) < .01) ? this.hasNonUniformScale = !1 : this.hasNonUniformScale = !0;
        }
        attach(r, i) {
            this.updateWorldMatrix(!0, !1);
            let s1 = new ue().copy(this.matrixWorld).invert();
            return r.parent !== null && (r.parent.updateWorldMatrix(!0, !1), s1.multiply(r.parent.matrixWorld)), "hiddenMatrix" in r && r.hiddenMatrix instanceof ue ? r.hiddenMatrix.premultiply(s1) : r.applyMatrix4(s1), r.updateWorldMatrix(!1, !1), this.add(r), i !== void 0 && (this.children.pop(), this.children.splice(i, 0, r)), this;
        }
        copy(r, i = !1) {
            return super.copy(r, i), this.hasNonUniformScale = r.hasNonUniformScale, this;
        }
        onAfterRender(r, i, s1, o, a, l) {
            this.copyPreviousMatrix && this.previousModelViewMatrix.copy(this.modelViewMatrix);
        }
    };
var wE = class extends Ud(Dt) {
}, wK = (n1)=>n1.type === "Mesh", Lr = class extends wE {
    constructor(e){
        super();
        this.object = e;
        this.matrixAutoUpdate = !1, this.hasNonUniformScale = e.hasNonUniformScale;
    }
    raycast(e, r) {}
    expand() {
        let e = 0, r = this.object.entityChildren(e);
        for(; r;){
            let i = this.children[e];
            i?.object !== r && (i && this.remove(i), i = new Lr(r), this.add(i), this.children.splice(e, 0, this.children.pop()), i.matrixWorldNeedsUpdate = !0, i.matrixAutoUpdate = !1, i.matrix = r.matrix, i.hiddenMatrix = r.hiddenMatrix, i.pivotMatrix = r.pivotMatrix), i.expand(), e += 1, r = this.object.entityChildren(e);
        }
        for(; this.children.length > e;)this.remove(this.children[e]);
        this.pivotMatrix = this.object.pivotMatrix;
    }
    get visible() {
        return this.playModeVisible !== void 0 ? this.playModeVisible : this.object.visible || this.object.dataPatched.visible && this.object.dataPatched.cloner?.hideBase === !0;
    }
    set visible(e) {}
    get castShadow() {
        return this.object.castShadow;
    }
    set castShadow(e) {}
    get receiveShadow() {
        return this.object.receiveShadow;
    }
    set receiveShadow(e) {}
    get isMesh() {
        return wK(this.object);
    }
    get isLight() {
        return this.object.isLight;
    }
    get layers() {
        return this.object.layers;
    }
    set layers(e) {}
    get isCamera() {
        return !1;
    }
    get geometry() {
        if (this.object.geometry) return this.object.geometry;
    }
    get material() {
        if (this.object.material) return this.object.material;
    }
    get morphTargetInfluences() {
        if (this.object.morphTargetInfluences) return this.object.morphTargetInfluences;
    }
    set morphTargetInfluences(e) {}
};
var ou = new E, au = new E, kd = new ue, s3 = [
    new E(-1, 1, 1),
    new E(-1, -1, 1),
    new E(1, -1, 1),
    new E(1, 1, 1),
    new E(-1, 1, -1),
    new E(-1, -1, -1),
    new E(1, -1, -1),
    new E(1, 1, -1)
], AK = [
    [
        0,
        3
    ],
    [
        1,
        2
    ],
    [
        5,
        6
    ],
    [
        4,
        7
    ],
    [
        0,
        1
    ],
    [
        3,
        2
    ],
    [
        7,
        6
    ],
    [
        4,
        5
    ],
    [
        0,
        4
    ],
    [
        1,
        5
    ],
    [
        2,
        6
    ],
    [
        3,
        7
    ]
], EK = [
    [
        0,
        2
    ],
    [
        7,
        5
    ],
    [
        4,
        1
    ],
    [
        3,
        6
    ],
    [
        4,
        3
    ],
    [
        1,
        6
    ]
], n3 = (n1, t, e)=>{
    n1.updateEntityBoxSize(ou, au), kd.copy(t).multiply(n1.matrixWorld), au.x === 0 && au.y === 0 && au.z === 0 ? e.push(new E(ou.x, ou.y, ou.z).applyMatrix4(kd)) : s3.forEach((r)=>{
        e.push(r.clone().multiply(au).add(ou).applyMatrix4(kd));
    });
}, Rm = class extends Yt {
    constructor(){
        super(...arguments);
        this.matrix = new ue;
        this.vertices = [];
        this.faces = [];
        this.edges = [];
        this.centerEdges = [];
    }
    copy(e) {
        return super.copy(e), this.matrix.copy(e.matrix), this.vertices = e.vertices.map((r)=>r.clone()), this.faces = e.faces.map((r)=>r.clone()), this.edges = e.edges.map((r)=>r.clone()), this.centerEdges = e.centerEdges.map((r)=>r.clone()), this;
    }
    setFromObjectSize(e, r = !1) {
        e.updateWorldMatrix(!1, r), this.makeEmpty(), this.matrix.copy(e.matrixWorld);
        let i = new ue().copy(e.matrixWorld).invert();
        return this.expandByObjectSize(e, i, r);
    }
    expandByObjectSize(e, r, i = !1) {
        let s1 = [];
        return i === !0 ? e.traverseEntity((o)=>{
            if (o.visible || o.cloner && o.data.visible) {
                if (!("geometry" in o)) {
                    s1.push(new E);
                    return;
                }
                n3(o, r, s1);
            }
        }) : n3(e, r, s1), this.setFromPoints(s1);
    }
    getCenter(e) {
        return e = super.getCenter(e), e.applyMatrix4(this.matrix), e;
    }
    getPositionToCenter(e) {
        return e = super.getCenter(e), e.applyMatrix4(kd.copy(this.matrix).setPosition(0, 0, 0)), e;
    }
    computeVertices() {
        this.getSize(au).multiplyScalar(.5), this.getCenter(ou), kd.copy(this.matrix).setPosition(ou), this.vertices = s3.map((e)=>e.clone().multiply(au).applyMatrix4(kd));
    }
    computeEdges() {
        this.vertices.length > 0 && this.computeVertices(), this.edges = AK.map(([e, r])=>new Di(this.vertices[e], this.vertices[r])), this.centerEdges = this.edges.map((e)=>e.getCenter(new E));
    }
    computeFaces() {
        this.vertices.length > 0 && this.computeVertices(), this.faces = EK.map(([e, r])=>this.vertices[e].clone().add(this.vertices[r]).multiplyScalar(.5));
    }
};
var to = {
    Cloner: ()=>{},
    changeEntityProptotype: ()=>{},
    createEntity: ()=>{}
};
var EE = class extends jp {
    constructor(){
        super();
    }
    getPoints(t = 12) {
        let e = [], r, i = this.getCurveLengths(), o = i[i.length - 1] / i.length;
        for(let a = 0, l = this.curves; a < l.length; a++){
            let c = l[a], u1 = a === 0 ? i[a] : i[a] - i[a - 1], h = Math.ceil(t * u1 / o), d = c.getPoints(h);
            for(let f = 0; f < d.length; f++){
                let m = d[f];
                r && r.equals(m) || (e.push(m), r = m);
            }
        }
        return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
    }
};
var TE = .001;
function ME(n1, t, e) {
    return t.clone().sub(n1).cross(t.clone().sub(e)).length() <= TE;
}
function AE(n1, t) {
    let e = new E(...n1.position), r = new E(...n1.controlNext.position), i = new E(...t.controlPrevious.position), s1 = new E(...t.position);
    return ME(e, r, s1) && ME(e, i, s1);
}
function gx(n1) {
    let t = n1.points.map((u1)=>new E(...u1.data.position)), e = [
        n1.points[0]
    ], r = new E(...e[0].data.position);
    for(let u1 = 0; u1 < n1.points.length - 1; u1++)ME(r, t[u1], t[u1 + 1]) || (e.push(n1.points[u1]), r = t[u1]);
    e.push(n1.points[n1.points.length - 1]);
    let i = n1.isClosed, s1 = e.length - (i ? 0 : 1), o = e.length, a = [];
    for(let u1 = 0; u1 < o; u1++){
        let h = e[u1].data, d = new E(...h.position), f = new E(...h.controlPrevious.position), m = new E(...h.controlNext.position), p = {
            position: d,
            baseRoundness: h.roundness,
            controlPrevious: f,
            controlNext: m
        };
        if (h.roundness === 0 || !n1.isClosed && (u1 === 0 || u1 === o - 1)) {
            a[u1] = {
                ...p,
                removedLength: 0
            };
            continue;
        }
        let g = i && u1 == 0 ? o - 1 : u1 - 1, y = i && u1 == o - 1 ? 0 : u1 + 1, x = e[g].data, v = e[y].data, b = new E(...x.position), w = new E(...v.position), A = b.clone().sub(d).normalize(), T = w.clone().sub(d).normalize();
        Object.assign(p, {
            prevDir: A,
            nextDir: T
        });
        let S = AE(x, h), M = AE(h, v);
        if (!S || !M) a[u1] = {
            ...p,
            removedLength: 0
        };
        else {
            let C = A.clone().add(T).normalize(), P = C.clone().cross(A).length() / A.dot(C);
            a[u1] = {
                ...p,
                tan: P,
                removedLength: h.roundness / P
            };
        }
    }
    for(let u1 = 0; u1 < s1; u1++){
        let h = u1, d = i && u1 === o - 1 ? 0 : u1 + 1, f = a[h], m = a[d];
        if (f.removedLength !== 0 || m.removedLength !== 0) {
            let p = f.position.distanceTo(m.position);
            f.removedLength = Math.min(f.removedLength, p / 2), m.removedLength = Math.min(m.removedLength, p / 2);
        }
    }
    let l = [];
    for(let u1 = 0; u1 < s1; u1++){
        let h = u1, d = i && u1 === o - 1 ? 0 : u1 + 1, f = a[h], m = a[d], p = null;
        if (!AE(e[h].data, e[d].data)) f.position.distanceTo(m.position) > TE && (p = new zc(f.position, f.controlNext, m.controlPrevious, m.position));
        else {
            let g = f.position.clone(), y = m.position.clone();
            (f.removedLength !== 0 || m.removedLength !== 0) && (f.nextDir && g.add(f.nextDir.clone().setLength(f.removedLength)), m.prevDir && y.add(m.prevDir.clone().setLength(m.removedLength))), g.distanceTo(y) > TE && (p = new zc(g, g.clone().lerp(y, .3), y.clone().lerp(g, .3), y));
        }
        l[2 * u1 + 1] = p;
    }
    for(let u1 = 0; u1 < o; u1++){
        let h = a[u1];
        if (h.removedLength === 0) {
            l[2 * u1] = null;
            continue;
        }
        let d = h.position, f = h.prevDir.clone().multiplyScalar(h.removedLength).add(d), m = h.nextDir.clone().multiplyScalar(h.removedLength).add(d), p = h.tan * h.removedLength, g = h.prevDir.clone().add(h.nextDir).normalize(), y = f.clone().lerp(m, .5), x = f.distanceTo(m) / 2, v = g.clone().multiplyScalar(Math.sqrt(Math.pow(p, 2) - Math.pow(x, 2))).add(y), b = g.clone().multiplyScalar(-p).add(v), w = d.distanceTo(b) / d.distanceTo(y), A = h.prevDir.clone().multiplyScalar(w * d.distanceTo(f)).add(d), T = A.clone().lerp(b, 2), S = f.clone().lerp(A, 4 / 3), M = m.clone().lerp(T, 4 / 3);
        l[2 * u1] = new zc(f, S, M, m);
    }
    let c = new EE;
    return l.forEach((u1)=>{
        u1 && c.add(u1);
    }), c;
}
var gt;
((t)=>{
    function n1(e) {
        return e && e.__isEntity;
    }
    t.is = n1;
})(gt || (gt = {}));
var Qo = (n1)=>gt.is(n1), TK = {
    type: "completeState",
    isfromEntity: !0
}, MK = [
    "x",
    "y",
    "z"
], Lm = new E, o3 = new E(1, 1, 1), CE = new Ye, a3 = new Jt, CK = new E().set(0, 1, 0), zd = (n1)=>class extends Ud(n1) {
        constructor(){
            super(...arguments);
            this.raycastLock = !1;
            this.scaleLock = !1;
            this.disposed = !1;
            this.stateSelection = null;
            this.destroyedInAction = !1;
            this.instances = [];
            this.prevState = null;
            this.currentState = null;
            this.currentAnimationAction = null;
            this.reversibleToState = null;
            this.currentTransitionEvent = null;
            this.previousAction = null;
            this._singleBBox = new Rm;
            this._recursiveBBox = new Rm;
            this.singleBBoxNeedsUpdate = !0;
            this.recursiveBBoxNeedsUpdate = !0;
            this._needApplyPathSnapping = !0;
            this.attachedPaths = new Set;
        }
        get __isEntity() {
            return !0;
        }
        entityChildren(r) {
            let i = this.children[r];
            if (gt.is(i)) return i;
        }
        entityChildrenCount() {
            let r = this.children.length;
            for(; r--;)if (gt.is(this.children[r])) return r + 1;
            return 0;
        }
        get isConcreteEntity() {
            return typeof this.identity == "string";
        }
        get isVirtualEntity() {
            return typeof this.identity != "string";
        }
        get isInstanceRoot() {
            return this.isConcreteEntity && this.data.type === "Instance";
        }
        nearestInstanceSelfOrParent() {
            let r = this;
            for(; r.data.type !== "Instance";){
                let i = r.parent;
                if (gt.is(i)) r = i;
                else return;
            }
            return r;
        }
        forInstancesRec(r) {
            this.instances.forEach((i)=>{
                i.disposed || r(i), i.forInstancesRec(r);
            });
        }
        super_Entity(r, i) {
            typeof r == "string" && (this.uuid = r), this.identity = r, this.data = i, this.matrixAutoUpdate = !1, this.dataPatched = this.data;
        }
        changeSelectedState(r, i, s1 = !1) {
            if (!(this.data.states.length === 0 && !s1)) {
                for (let o of this.data.states)Qs.toOps(this.data, o.data).forEach((l)=>{
                    let c = rd.replaceProps(l, this.data);
                    this.dataPatched = this.data, this.updateByPatchedOp(c, this.data, i);
                });
                if (r !== null) {
                    let o = this.data.states.data(r);
                    o && (this.dataPatched = Qs.patch(this.data, o), Qs.toOps(this.data, o).forEach((l)=>{
                        this.updateByPatchedOp(l, this.dataPatched, i);
                    }));
                }
                s1 && this.updateTransformState(this.dataPatched, i), this.stateSelection = r, this.updatePathSnapping(this.dataPatched.pathSnapping);
            }
        }
        get singleBBox() {
            return this.singleBBoxNeedsUpdate && (this.singleBBoxNeedsUpdate = !1, this._singleBBox.setFromObjectSize(this, !1), this._singleBBox.computeVertices(), this._singleBBox.computeEdges(), this._singleBBox.computeFaces()), this._singleBBox;
        }
        get recursiveBBox() {
            return this.recursiveBBoxNeedsUpdate && (this.recursiveBBoxNeedsUpdate = !1, this._recursiveBBox.setFromObjectSize(this, !0), this._recursiveBBox.computeVertices(), this._recursiveBBox.computeEdges(), this._recursiveBBox.computeFaces()), this._recursiveBBox;
        }
        updateEntityBoxSize(r, i) {
            r.setScalar(0), i.setScalar(0);
        }
        resetBBoxNeedsUpdateSelf() {
            this.singleBBoxNeedsUpdate = !0, this.recursiveBBoxNeedsUpdate = !0;
        }
        resetBBoxNeedsUpdate() {
            this.resetBBoxNeedsUpdateSelf(), this.traverseAncestors((r)=>{
                Qo(r) && r.resetBBoxNeedsUpdateSelf();
            }), this.traverseEntity((r)=>{
                r.resetBBoxNeedsUpdateSelf();
            });
        }
        find(r) {
            let i;
            return this.traverseEntity((s1)=>{
                s1.uuid === r && (i = s1);
            }), i;
        }
        traverseSortNextHelper() {
            let r = this.parent;
            if (r) {
                let i = r.children, s1 = i.indexOf(this) + 1;
                if (gt.is(i[s1])) return i[s1];
                if (gt.is(r)) return r.traverseSortNextHelper();
            }
        }
        sortNext() {
            let r = this.children;
            return this.children.length > 0 && gt.is(this.children[0]) ? r[0] : this.traverseSortNextHelper();
        }
        goUp(r) {
            let i = this;
            for(; r > 0 && i !== null;)i = i.parent, r -= 1;
            return i;
        }
        hasAnccestorOrSelf(r) {
            return this === r || this.hasAnccestor(r);
        }
        hasAnccestor(r) {
            let i = this.parent;
            for(; i;){
                if (r === i) return !0;
                i = i.parent;
            }
            return !1;
        }
        countToAccestor(r) {
            let i = 0, s1 = this;
            for(; s1 !== r;){
                if (s1 === null) return -1;
                s1 = s1.parent, i += 1;
            }
            return i;
        }
        forEachEntity(r) {
            for (let i of this.children)Qo(i) && r(i);
        }
        traverseEntityAncestors(r) {
            this.traverseAncestors((i)=>{
                gt.is(i) && r(i);
            });
        }
        traverseConcreteEntity(r, i = 0) {
            if (r(this, i) !== !0) for (let o of this.children)Qo(o) && o.isConcreteEntity && o.traverseEntity(r, i + 1);
        }
        traverseEntity(r, i = 0) {
            if (r(this, i) !== !0) for (let o of this.children)Qo(o) && o.traverseEntity(r, i + 1);
        }
        traverseVisibleEntity(r) {
            r(this);
            for (let i of this.children)Qo(i) && i.visible && i.traverseVisibleEntity(r);
        }
        updateMatrix() {
            super.updateMatrix(), this.cloner && this.cloner.onObjUpdateMatrix(), this.dispatchEvent({
                type: "updateMatrix"
            });
        }
        updateMatrixWorld(r) {
            super.updateMatrixWorld(r), this.dispatchEvent({
                type: "updateMatrixWorld"
            });
        }
        copy(r, i = !1) {
            return super.copy(r, i), this.dataPatched = r.dataPatched, this.raycastLock = r.raycastLock, this.scaleLock = r.scaleLock, this.hiddenMatrix.copy(r.hiddenMatrix), this;
        }
        hasEntityChild() {
            return this.children.some((r)=>Qo(r));
        }
        isAncestorOf(r) {
            if (this.uuid === r) return !1;
            let i = !1;
            return this.traverseEntity((s1)=>{
                s1.uuid === r && (i = !0);
            }), i;
        }
        toObjectTransformState(r = []) {
            this.updateWorldMatrix(!0, !1);
            let i = {
                position: this.position.toArray(),
                rotation: [
                    this.rotation.x * Se.RAD2DEG,
                    this.rotation.y * Se.RAD2DEG,
                    this.rotation.z * Se.RAD2DEG
                ],
                scale: this.scale.toArray(),
                hiddenMatrix: this.hiddenMatrix.toArray(),
                pivot: [
                    0,
                    0,
                    0
                ],
                pivotRotation: [
                    0,
                    0,
                    0
                ]
            };
            return Kh(i, r);
        }
        getTransformValues(r, i, s1) {
            return i[r].map((o, a)=>s1?.shared.getVariable(o, [
                    this.uuid,
                    r,
                    MK[a]
                ]) ?? o);
        }
        updateTransformState(r, i) {
            let s1 = !1;
            if (r.position && (this.position.fromArray(this.getTransformValues("position", r, i)), s1 = !0), r.rotation && (Lm.fromArray(this.getTransformValues("rotation", r, i)).multiplyScalar(Se.DEG2RAD), this.rotation.setFromVector3(Lm), s1 = !0), r.scale && (this.scale.fromArray(this.getTransformValues("scale", r, i)), s1 = !0), r.hiddenMatrix !== void 0 && (s1 = !0, this.hiddenMatrix.fromArray(r.hiddenMatrix ?? zl.identity)), r.pivot !== void 0 || r.pivotRotation !== void 0) {
                if (s1 = !0, r.pivot !== void 0 && r.pivotRotation !== void 0) this.pivotMatrix.compose(Lm.fromArray(r.pivot).negate(), CE.setFromEuler(a3.fromArray(r.pivotRotation.map((o)=>o * Se.DEG2RAD))).invert(), o3);
                else if (r.pivot !== void 0) this.pivotMatrix.setPosition(-r.pivot[0], -r.pivot[1], -r.pivot[2]);
                else if (r.pivotRotation !== void 0) {
                    let o = Lm.setFromMatrixPosition(this.pivotMatrix);
                    CE.setFromEuler(a3.fromArray(r.pivotRotation.map((a)=>a * Se.DEG2RAD))).invert(), this.pivotMatrix.compose(o, CE, o3);
                }
            }
            return s1 && (this.updateMatrix(), this.resetBBoxNeedsUpdate(), this.invalidateClonerTransform(this), this.traverseEntityAncestors((o)=>{
                o.invalidateClonerTransform(this);
            })), r.position && r.rotation && r.scale && r.hiddenMatrix !== void 0 && this.updateWorldMatrix(!1, !0), s1;
        }
        onVariableUpdate(r = !1) {
            if (r) {
                this.resetBBoxNeedsUpdate();
                return;
            }
            this.updateMatrix(), this.resetBBoxNeedsUpdate(), this.invalidateClonerTransform(this), this.traverseEntityAncestors((i)=>{
                i.invalidateClonerTransform(this);
            }), this.requestRender();
        }
        dispose() {
            this.disposed = !0, this.cloner && (this.cloner.removeFromParent(), this.cloner = void 0);
        }
        disposeChildrenRecursively() {
            for (let r of this.children)gt.is(r) && r.disposeRecursively();
        }
        disposeRecursively() {
            this.dispose(), this.children.forEach((r)=>{
                gt.is(r) && r.disposeRecursively();
            });
        }
        toState(r = []) {
            let i = {
                name: this.name,
                visible: this.visible,
                raycastLock: this.raycastLock,
                ...this.toObjectTransformState(r)
            };
            return Kh(i, r);
        }
        updateByObjUpdateOp(r, i) {
            r !== void 0 && this.updateByOp({
                type: 0,
                props: r,
                path: []
            }, {
                ...this.data,
                ...r
            }, i, !1);
        }
        updateByOp(r, i, s1, o) {
            let a = this.data;
            this.data = i;
            let l = r, c = kt(r.path, [
                "states",
                "*"
            ]);
            if (c !== null) {
                if (r.type === 0) {
                    let [u1] = c;
                    if (this?.stateSelection === u1) {
                        let h = {
                            ...r.props
                        };
                        if (delete h.name, Object.values(r.props).some((d)=>d === void 0)) {
                            let d = this.data;
                            if (d !== void 0) {
                                let f = Mr.zoom(d, r.path.slice(2));
                                if (f) for(let m in r.props)r.props[m] === void 0 && m in f && (h[m] = f[m]);
                            }
                        }
                        l = {
                            ...r,
                            props: h,
                            path: r.path.slice(2)
                        };
                    }
                }
            } else if (r.type === 0) {
                let u1 = this.stateSelection ? this.data.states.data(this.stateSelection) : void 0;
                if (u1 !== void 0) {
                    if (r.props.name !== void 0 && u1.name) {
                        let { name: d, ...f } = u1;
                        u1 = f;
                    }
                    if (r.props.material !== void 0 && "material" in u1) {
                        let { material: d, ...f } = u1;
                        u1 = f;
                    }
                    let h = Mr.removeOverridden(r.path, r.props, u1);
                    l = {
                        ...r,
                        props: h
                    };
                }
            }
            if (this.updateByPatchedOpBase(l, Qs.patch(this.data, this.stateSelection ? this.data.states.data(this.stateSelection) : void 0), s1), kt(r.path, [
                "overrides"
            ])) {
                let u1 = [], h = [
                    ...r.path
                ];
                for(u1.push(h[1]), h.splice(0, 2); h.length > 0 && h[0] === "descendants";)u1.push(h[1]), h.splice(0, 2);
                if (u1[u1.length - 1] === void 0) {
                    if (r.type === 0) for (let d of Object.keys(r.props)){
                        u1[u1.length - 1] = d;
                        let f = s1.scene.findInstance([
                            this.uuid,
                            ...u1
                        ]);
                        f && (f.overrideData = r.props[d], f.updateState(Do.apply(f.component.data, f.overrideData), s1));
                    }
                } else {
                    let d = s1.scene.findInstance([
                        this.uuid,
                        ...u1
                    ]);
                    if (d) {
                        let f = Mr.zoom(d.component.data, h);
                        if (r = {
                            ...r,
                            path: h
                        }, r.type === 0) {
                            let m = r.props;
                            if (f) for (let [p, g] of Object.entries(r.props))g === void 0 && (m === r.props && (m = {
                                ...r.props
                            }), m[p] = f[p]);
                            r = {
                                ...r,
                                props: m
                            };
                        }
                        d.overrideData = gd.resolve(i.overrides, u1), d.updateByOp(r, zr.applySimple(d.data, r), s1, !1);
                    }
                }
            } else if (this.instances.length > 0) {
                let u1;
                if (r.path.length === 0 && r.type === 0) {
                    let h;
                    for (let d of Vo.rootOverrideProps)d in r.props && (h === void 0 && (h = {}), h[d] = r.props[d]);
                    h && (u1 = {
                        ...r,
                        props: h
                    });
                } else for (let h of Vo.rootOverrideProps)if (kt(r.path, [
                    h
                ])) {
                    u1 = r;
                    break;
                }
                u1 !== void 0 && this.instances.forEach((h)=>{
                    if (h.isInstanceRoot) {
                        let d = Do.filterOp(h.overrideData, u1);
                        d && h.updateByOp(d, zr.applySimple(h.data, d), s1, !0);
                    }
                }), this.instances.forEach((h)=>{
                    if (!h.isInstanceRoot) {
                        let d = Do.filterOp(h.overrideData, r);
                        if (d) {
                            let f;
                            a === h.data && r === d ? f = i : f = zr.applySimple(h.data, d), h.updateByOp(d, f, s1, !0);
                        }
                    }
                });
            }
        }
        updateByPatchedOpBase(r, i, s1) {
            if (this.dataPatched = i, r.path.length === 0 && r.type === 0) r.props.type !== void 0 && !Ks.is(r.props.type) && to.changeEntityProptotype(this, i, s1);
            else if (r.path.length === 1 && r.path[0] === "geometry" && r.type === 0 && "type" in r.props) {
                to.changeEntityProptotype(this, i, s1);
                for (let o of this.children)gt.is(o) && o.updateVisible(s1.scene);
            }
            this.updateByPatchedOp(r, i, s1);
        }
        updateByPatchedOp(r, i, s1) {
            if (r.path.length === 0 && r.type === 0 ? this.updateState(r.props, s1) : r.type === 0 && ("resolutionLevel" in r.props || "useChildrenColors" in r.props) && this.updateState(i, s1), r.path[0] === "morphTargetInfluences" && r.type === 0) {
                let a = i.morphTargetInfluences.get(r.path[1])?.data.name;
                a && this.updateMorphInfluences(a, s1.shared.getVariable(r.props.value, [
                    this.uuid,
                    "morphTargetInfluences",
                    a
                ]));
            }
            if (kt(r.path, [
                "pathSnapping"
            ]) !== null && this.updatePathSnapping(i.pathSnapping), kt(r.path, [
                "cloner"
            ]) !== null) {
                let o = zr.drop(r, 1);
                o.path.length === 0 && o.type === 0 && o.props.disabled === !0 ? this.setFromClonerState(null, s1) : this.cloner ? this.cloner.updateState(i.cloner, s1) : (this.setFromClonerState(i.cloner, s1), this.expandCloner(s1)), this.updateVisible(s1.scene);
            }
        }
        updatePathSnapping(r = this.dataPatched.pathSnapping) {
            this._updatedPathSnapping = r, this._needApplyPathSnapping = !0;
        }
        get updatedPathSnapping() {
            return this._updatedPathSnapping;
        }
        applyPathSnapping(r) {
            let i = this._updatedPathSnapping?.pathId ?? this.dataPatched.pathSnapping.pathId, s1 = this._updatedPathSnapping?.slide ?? this.dataPatched.pathSnapping.slide ?? 0, o = this._updatedPathSnapping?.offset ?? this.dataPatched.pathSnapping.offset ?? 0, a = this._updatedPathSnapping?.orientation ?? this.dataPatched.pathSnapping.orientation;
            if (i === null) return;
            let l = r.find(i);
            if (!l || this._needApplyPathSnapping === !1) return;
            this._needApplyPathSnapping = !1;
            let c = l.data;
            if (c.geometry.path.points.length <= 1) return;
            let u1 = gx(c.geometry.path), h = (s1 + o) % 1;
            s1 + o === 1 && h === 0 && (h = 1);
            let d = null;
            try {
                d = u1.curves.length ? u1.getPointAt(h) : null;
            } catch (g) {}
            if (d === null) return;
            let f = this.parent ? this.parent?.matrixWorld : new ue;
            l.updateMatrixWorld();
            let m = new ue().multiplyMatrices(f.clone().invert(), l.matrixWorld);
            d.applyMatrix4(m);
            let p = {
                position: d.toArray(),
                rotation: c.rotation
            };
            if (a === "tangential") {
                let g = new ue().extractRotation(l.matrixWorld), y = u1.getTangentAt(h).applyMatrix4(g).add(d), x = new ue().lookAt(d, y, CK), v = Lm.setFromEuler(new Jt().setFromRotationMatrix(x)).multiplyScalar(Se.RAD2DEG);
                p = {
                    ...p,
                    rotation: v.toArray()
                };
            }
            this.updateTransformState(p), this.traverseEntity((g)=>{
                g._cameraType && g.dispatchEvent(TK);
            });
        }
        updateVisible(r) {
            if (this.visible = this.dataPatched.visible && (!this.dataPatched.cloner || (this.dataPatched.cloner.disabled ?? !1) || this.dataPatched.cloner?.hideBase !== !0), !r) return;
            let i = !1;
            this.traverseEntity((s1)=>{
                if (s1.data.type === "Splat") return i = !0, !0;
            }), i && r.reloadSplats();
        }
        updateState_Entity(r, i) {
            r.name !== void 0 && (this.name = r.name), r.raycastLock !== void 0 && (this.raycastLock = r.raycastLock), r.visible !== void 0 && (this.updateVisible(i?.scene), this.resetBBoxNeedsUpdate()), i && "cloner" in r && r.cloner !== void 0 && (this.setFromClonerState(r.cloner, i), this.updateVisible(i.scene)), this.updateTransformState(r, i);
        }
        get attachedSurfaceCloners() {
            return this.children.filter((r)=>r instanceof to.Cloner && r.parameters.type === "toObject");
        }
        setFromClonerState(r, i) {
            this.disposed || (r === null || r.disabled ? (this.cloner && this.cloner.removeFromParent(), this.cloner = void 0) : this.cloner === void 0 ? (this.cloner = new to.Cloner(this, r), i.scene.addPendingExpandCloner(this)) : this.cloner.updateState(r, i));
        }
        expandCloner(r) {
            !this.disposed && this.cloner && this.cloner.expandClones(r);
        }
        invalidateClonerTransform(r) {
            this.cloner && this.cloner.invalidateTransform(r);
        }
        requestRender() {
            this.dispatchEvent({
                type: "requestRender"
            });
        }
    };
var yx = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = n1.parameters?.radiusTop, r = n1.parameters?.radiusBottom, i = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 64,
            heightSegments: 1,
            openEnded: !1,
            thetaStart: 0,
            thetaLength: 360,
            cornerRadius: 8,
            cornerSegments: 8,
            hollow: 0
        }, n1.parameters);
        i.thetaLength = Se.clamp(i.thetaLength, 0, 360);
        let s1 = i.width / 2, o = i.radiusTop ?? s1, a = i.radiusBottom ?? s1;
        if (o === a ? (o = s1, a = s1) : o > a ? (o = s1, a = a * s1 / o) : (o = o * s1 / a, a = s1), i.shapeBlendNode) {
            o = e ?? s1, a = r ?? s1;
            let l = Math.max(o, a) * 2;
            i.width = l, i.depth = l;
        }
        return {
            parameters: Object.assign(i, {
                width: Math.abs(i.width),
                height: Math.abs(i.height ?? i.width),
                depth: Math.abs(i.depth ?? i.width),
                radiusTop: o,
                radiusBottom: a
            })
        };
    }
    static build(n1) {
        let { width: t, depth: e, height: r, radialSegments: i, heightSegments: s1, openEnded: o, thetaStart: a, thetaLength: l, radiusTop: c, radiusBottom: u1, cornerRadius: h, cornerSegments: d, hollow: f } = n1.parameters, m;
        return l === 0 ? (m = new Ce, m.setAttribute("position", new Te([], 3))) : h || f ? m = new Nm(c, u1, r, i, s1, o, a, l * Math.PI / 180, h, h, d, f) : m = new jc(c, u1, r, i, s1, o, a, l * Math.PI / 180), m.scale(1, 1, e / t), Object.assign(m, {
            userData: {
                ...n1,
                type: "CylinderGeometry"
            }
        });
    }
};
function Zl(n1, t, e) {
    e.x = n1.x * t.x, e.y = n1.y, e.z = n1.x * t.y;
}
function l3(n1) {
    return new U(n1.y, -n1.x);
}
var Nm = class extends Ce {
    constructor(t, e, r, i, s1, o, a, l, c, u1, h, d, f = !1){
        super(), this.type = "RoundedCylinderBufferGeometry", t = t !== void 0 ? t : 1, e = e !== void 0 ? e : 1, r = r || 1, i = Math.floor(i) || 8, s1 = Math.floor(s1) || 1, o = o !== void 0 ? o : !1, a = a !== void 0 ? a : 0, l = l !== void 0 ? l : Math.PI * 2, o && (c = 0, u1 = 0);
        let m = [], p = [], g = [], y = [], x = 0, v = r / 2, b = new E, w = new E;
        f && t == 0 && (t = c), f && e == 0 && (e = u1);
        let A = new U(t, v), T = new U(e, -v), S = null, M = null, C = null, P = null, _ = A.clone().sub(T), I = 0, O = 0, L = 0;
        d > 0 && (I = Math.min(t, e) * (1 - d), O = t - I, L = e - I);
        let j = A.clone();
        j.x -= I;
        let V = Math.PI - _.angle(), H = _.angle(), q = Math.tan(H / 2), X = Math.tan(V / 2), K = q + X, z = d ? K : X, Q = d ? K : q;
        if (c = Math.min(c, (t - O) / z, _.length() / K), u1 = Math.min(u1, (e - L) / Q, _.length() / K), c > 0) {
            let re = c / q;
            S = A.clone().sub(new U(re, c)), d && (C = S.clone(), C.x -= I - K * c), A.sub(_.clone().setLength(re));
        }
        if (u1 > 0) {
            let re = u1 / X;
            M = T.clone().sub(new U(re, -u1)), T.add(_.clone().setLength(re)), d && (P = M.clone(), P.x -= I - K * u1, j.sub(_.clone().setLength(re)));
        }
        _ = A.clone().sub(T);
        let te = _.length() < .5, $ = [];
        for(let re = 0; re <= i; re++){
            let J = [], Ee = re / i, xe = Ee * l + a, de = new U(Math.sin(xe), Math.cos(xe));
            P && M ? (W(J, Ee, de, V, u1, P, -1, !0), W(J, Ee, de, H, u1, M, -1, !1)) : M ? (oe(J, de, M.x, 0, -1), W(J, Ee, de, H, u1, M, -1, !1)) : o || oe(J, de, e, L, -1);
            let De = l3(_).normalize();
            if (Zl(De, de, b), !te) for(let Pe = 0; Pe <= s1; Pe++){
                let ze = Pe / s1, ke = _.clone().multiplyScalar(ze).add(T);
                Zl(ke, de, w), p.push(w.x, w.y, w.z), g.push(b.x, b.y, b.z), y.push(Ee, .5 + w.y / r), J.push(x++);
            }
            if (C && S ? (W(J, Ee, de, V, c, S, 1, !1), W(J, Ee, de, H, c, C, 1, !0)) : S ? (W(J, Ee, de, V, c, S, 1, !1), oe(J, de, S.x, 0, 1)) : o || oe(J, de, t, O, 1), d && !te) {
                let Pe = l3(_).multiplyScalar(-1).normalize();
                Zl(Pe, de, b);
                for(let ze = 0; ze <= s1; ze++){
                    let ke = ze / s1, Ue = _.clone().multiplyScalar(-ke).add(j);
                    Zl(Ue, de, w), p.push(w.x, w.y, w.z), g.push(b.x, b.y, b.z), y.push(Ee, .5 + w.y / r), J.push(x++);
                }
            }
            d && !o && J.push(J[0]), $.push(J);
        }
        for(let re = 0; re < $.length - 1; re++)for(let J = 0; J < $[0].length - 1; J++){
            if (o && d && J == s1) continue;
            let Ee = $[re][J], xe = $[re + 1][J], de = $[re + 1][J + 1], De = $[re][J + 1], Pe = p[de * 3 + 0], ze = p[de * 3 + 2];
            m.push(Ee, xe, De), (Pe != 0 || ze != 0) && m.push(xe, de, De);
        }
        l < Math.PI * 2 && (ie(-1, $[0], a), ie(1, $[$.length - 1], a + l)), this.setIndex(m), this.setAttribute("position", new Te(p, 3)), this.setAttribute("normal", new Te(g, 3)), this.setAttribute("uv", new Te(y, 2));
        function W(re, J, Ee, xe, de, De, Pe, ze) {
            for(let ke = 0; ke < h + 1; ke++){
                let Ue = ke / h, Le = Pe < 0 ? Ue : 1 - Ue;
                ze && (Le -= 1), Le *= xe;
                let Qe = new U(Math.sin(Le), Math.cos(Le) * Pe), F = Qe.clone().multiplyScalar(de).add(De);
                Zl(F, Ee, w), p.push(w.x, w.y, w.z), Zl(Qe, Ee, b), g.push(b.x, b.y, b.z), y.push(J, .5 + w.y / r), re.push(x++);
            }
        }
        function oe(re, J, Ee, xe, de) {
            let De = new E, Pe = new U, ze = [
                Ee,
                xe
            ];
            de < 0 && ze.reverse();
            for (let ke of ze)Pe.set(ke, v * de), Zl(Pe, J, De), p.push(De.x, De.y, De.z), g.push(0, de, 0), y.push(.5, .5), re.push(x++);
        }
        function ie(re, J, Ee) {
            let xe = new U(Math.sin(Ee), Math.cos(Ee)), de = new U(-Math.cos(Ee), Math.sin(Ee)), De = new E, Pe = re < 0 ? (Ue, Le, Qe)=>m.push(Ue, Le, Qe) : (Ue, Le, Qe)=>m.push(Ue, Qe, Le), ze = new U((t + e + O + L) / 4, 0);
            Zl(ze, xe, De), p.push(De.x, De.y, De.z), g.push(de.x, 0, de.y), y.push(.5, .5);
            let ke = x++;
            for (let Ue of J){
                let Le = p.slice(Ue * 3, Ue * 3 + 3);
                p.push(...Le), g.push(de.x, 0, de.y);
                let Qe = y.slice(Ue * 2, Ue * 2 + 2);
                y.push(...Qe), x++;
            }
            for(let Ue = ke + 1; Ue < x - 1; Ue++)Pe(ke, Ue, Ue + 1);
            Pe(ke, x - 1, ke + 1);
        }
    }
};
var c3 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 32,
            heightSegments: 8,
            openEnded: !1,
            thetaStart: 0,
            thetaLength: 360,
            cornerRadiusTop: 8,
            cornerRadiusBottom: 8,
            cornerSegments: 8
        }, n1.parameters);
        return e.thetaLength = Se.clamp(e.thetaLength, 0, 360), {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, depth: e, height: r, radialSegments: i, heightSegments: s1, openEnded: o, thetaStart: a, thetaLength: l, cornerRadiusTop: c, cornerRadiusBottom: u1, cornerSegments: h } = n1.parameters, d;
        return l === 0 ? (d = new Ce, d.setAttribute("position", new Te([], 3))) : c > 0 || u1 > 0 || l < 360 ? d = new Nm(0, t / 2, r, i, s1, o, a, l * Math.PI / 180, c, u1, h, 0, !0) : d = new Al(t / 2, r, i, s1, o), d.scale(1, 1, e / t), Object.assign(d, {
            userData: {
                ...n1,
                type: "ConeGeometry"
            }
        });
    }
};
var u3 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            widthSegments: 1,
            heightSegments: 1,
            depthSegments: 1,
            cornerRadius: 8,
            cornerSegments: 8
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, widthSegments: i, heightSegments: s1, depthSegments: o, cornerRadius: a, cornerSegments: l } = n1.parameters, c;
        return a === 0 ? c = new bi(t, e, r, i, s1, o) : c = new _E(t, e, r, i, s1, o, a, l), Object.assign(c, {
            userData: {
                ...n1,
                type: "CubeGeometry"
            }
        });
    }
}, PE = Math.PI / 2, _E = class extends Ce {
    constructor(t = 1, e = 1, r = 1, i = 1, s1 = 1, o = 1, a = 0, l = 4){
        super(), this.type = "BoxGeometry", i = Math.floor(i), s1 = Math.floor(s1), o = Math.floor(o), l = Math.floor(l), a = Math.min(a, t / 2, e / 2, r / 2);
        let c = [], u1 = [], h = [], d = [], f = 0;
        m("z", "y", "x", -1, -1, r, e, t, o, s1), m("z", "y", "x", 1, -1, r, e, -t, o, s1), m("x", "z", "y", 1, 1, t, r, e, i, o), m("x", "z", "y", 1, -1, t, r, -e, i, o), m("x", "y", "z", 1, -1, t, e, r, i, s1), m("x", "y", "z", -1, -1, t, e, -r, i, s1), a > 0 && (p("z", "y", "x", -1, -1, 1, r, e, t, o), p("z", "y", "x", 1, -1, -1, r, e, t, o), p("z", "y", "x", -1, 1, -1, r, e, t, o), p("z", "y", "x", 1, 1, 1, r, e, t, o), p("x", "y", "z", -1, -1, -1, t, e, r, i), p("x", "y", "z", 1, -1, 1, t, e, r, i), p("x", "y", "z", -1, 1, 1, t, e, r, i), p("x", "y", "z", 1, 1, -1, t, e, r, i), p("y", "x", "z", -1, -1, 1, e, t, r, s1), p("y", "x", "z", 1, -1, -1, e, t, r, s1), p("y", "x", "z", 1, 1, 1, e, t, r, s1), p("y", "x", "z", -1, 1, -1, e, t, r, s1), g(1, 1, 1), g(-1, 1, 1), g(1, -1, 1), g(-1, -1, 1), g(1, 1, -1), g(-1, 1, -1), g(1, -1, -1), g(-1, -1, -1)), this.setIndex(c), this.setAttribute("position", new Te(u1, 3)), this.setAttribute("normal", new Te(h, 3)), this.setAttribute("uv", new Te(d, 2));
        function m(y, x, v, b, w, A, T, S, M, C) {
            let P = (A - 2 * a) / M, _ = (T - 2 * a) / C, I = A / 2 - a, O = T / 2 - a, L = S / 2, j = M + 1, V = C + 1, H = 0, q = new E;
            for(let X = 0; X < V; X++){
                let K = X * _ - O;
                for(let z = 0; z < j; z++){
                    let Q = z * P - I;
                    q[y] = Q * b, q[x] = K * w, q[v] = L, u1.push(q.x, q.y, q.z), q[y] = 0, q[x] = 0, q[v] = S > 0 ? 1 : -1, h.push(q.x, q.y, q.z), d.push(z / M), d.push(1 - X / C), H += 1;
                }
            }
            for(let X = 0; X < C; X++)for(let K = 0; K < M; K++){
                let z = f + K + j * X, Q = f + K + j * (X + 1), te = f + (K + 1) + j * (X + 1), $ = f + (K + 1) + j * X;
                c.push(z, Q, $), c.push(Q, te, $);
            }
            f += H;
        }
        function p(y, x, v, b, w, A, T, S, M, C) {
            let P = (T - 2 * a) / C, _ = T / 2 - a, I = S / 2 - a, O = M / 2, L = C + 1, j = 0, V = new E, H = new E;
            for(let q = 0; q < l + 1; q++){
                let X = q / l * PE, K = Math.sin(X) * a, z = (1 - Math.cos(X)) * a, Q = Math.sin(X), te = Math.cos(X);
                V[x] = (I + K) * w, V[v] = (O - z) * A, H[y] = 0, H[x] = Q * Math.sign(V[x]), H[v] = te * Math.sign(V[v]);
                for(let $ = 0; $ < L; $++){
                    let W = $ * P - _;
                    V[y] = W * b, u1.push(V.x, V.y, V.z), h.push(H.x, H.y, H.z), d.push($ / C), d.push(0), j += 1;
                }
            }
            for(let q = 0; q < l; q++)for(let X = 0; X < C; X++){
                let K = f + X + L * q, z = f + X + L * (q + 1), Q = f + (X + 1) + L * (q + 1), te = f + (X + 1) + L * q;
                c.push(K, z, te), c.push(z, Q, te);
            }
            f += j;
        }
        function g(y, x, v) {
            let b = new E, w = new E(t / 2, e / 2, r / 2);
            w.subScalar(a);
            let A = [], T = y * x * v > 0 ? (M, C, P)=>c.push(M, C, P) : (M, C, P)=>c.push(M, P, C);
            for(let M = 0; M <= l; M++){
                let C = [], P = PE * (1 - M / l), _ = Math.cos(P), I = Math.sin(P), O = 0;
                for(let L = 0; L <= M; L++){
                    let j = Math.cos(O), V = Math.sin(O);
                    b.x = _ * j, b.y = I, b.z = _ * V;
                    let H = w.clone().addScaledVector(b, a);
                    u1.push(y * H.x, x * H.y, v * H.z), h.push(y * b.x, x * b.y, v * b.z), d.push(0, 0), C.push(f++), O += PE / M;
                }
                A.push(C);
            }
            let S = A.length - 1;
            for(let M = 0; M < S; M++){
                let C = A[M], P = A[M + 1], _ = C.length - 1;
                T(C[0], P[1], P[0]);
                for(let I = 1; I <= _; I++)T(C[I - 1], C[I], P[I]), T(C[I], P[I + 1], P[I]);
            }
        }
    }
};
var Jl = class extends Ce {
    constructor(t = [], e = [], r = "", i = 1, s1 = .2, o = 4){
        super(), this.type = "PolyhedronGeometryRound";
        let a = [], l = [], c = [];
        u1(), h(), this.setAttribute("position", new Te(a, 3)), this.setAttribute("normal", new Te(c, 3)), this.setAttribute("uv", new Te(l, 2));
        return;
        function u1() {
            s1 = Math.min(1 - 1e-5, s1), s1 == 0 && (o = 0);
            let f = {
                IcosahedronGeometry: 5,
                DodecahedronGeometry: 3,
                HexahedronGeometry: 3,
                OctahedronGeometry: 4,
                TetrahedronGeometry: 3
            }[r], m = new E, p = m.clone(), g = new Or, y = s1 * i, x = i - y, v = o + 1, b = new E, w = (q, X)=>b.subVectors(q, X).normalize(), A = (q, X)=>Array(q).fill(void 0).map(X), T = A(t.length / 3, (q, X)=>new E().fromArray(t, X * 3).setLength(i)), S = [], M = 1e6;
            for(let q = 0; q < T.length; q++){
                let X = T[q], K = [], z, Q, te, $ = 1e10, W = -1;
                for(; (W = e.indexOf(q, W + 1)) != -1;){
                    let J = W - W % 3;
                    z = e[J + (W + 1) % 3], Q = e[J + (W + 2) % 3], te = X.distanceToSquared(T[z]), $ = Math.min($, te), K.push([
                        z,
                        Q,
                        te
                    ]);
                }
                $ += 1e-6;
                let oe = [], ie = 0, re = K.length;
                for(let J = 0; J < re; J++){
                    [z, Q, te] = K[ie];
                    let Ee = S[z]?.includes(q) == !0;
                    te <= $ && oe.push(z + +Ee * M), ie = K.findIndex((xe)=>xe[0] == Q);
                }
                S.push(oe);
            }
            let C = [];
            {
                let q = 0, X = 0, K, z, Q = f == 3;
                for(let te = 0; te <= o; te++){
                    K = te * (te + 1) / 2, z = (te + 1) * (te + 2) / 2;
                    for(let $ = 0; $ < o - te; $++)[q, X] = [
                        K + $ + te + 2,
                        z + $ + te + 3
                    ], C.push(K, z, ...Q ? [
                        X,
                        K
                    ] : [
                        q,
                        z
                    ], X, q), [K, z] = [
                        q,
                        X
                    ];
                    C.push(K, z, K + o + 2);
                }
            }
            let P = m.clone(), _ = m.clone(), I = m.clone(), O = m.clone(), L = m.clone(), j = [], V = A(T.length, ()=>A(f, ()=>m.clone()));
            for(let q = 0; q < T.length; q++){
                m.copy(T[q]).normalize(), P.copy(m).multiplyScalar(x);
                let X = S[q];
                for(let oe = 0; oe < X.length; oe++){
                    let ie = X[oe], re = X[(oe + 1) % f];
                    g.setFromPointsAndIndices(T, q, ie % M, re % M), g.b.sub(g.a).setLength(1e10).add(g.a), g.c.sub(g.a).setLength(1e10).add(g.a), g.closestPointToPoint(P, V[q][oe]);
                }
                let K = [], z = [], Q = [], te = new E;
                o == 0 && [
                    ...V[q]
                ].reduce((oe, ie)=>oe.add(ie), te).multiplyScalar(1 / f);
                for(let oe = 0; oe < f; oe++){
                    let ie = [], re = (oe - 1 + f) % f, J = V[q][re], Ee = V[q][oe];
                    m.copy(J).sub(P), p.copy(Ee).sub(P);
                    let xe = P.angleTo(m), de = m.angleTo(p), De = Math.cos(xe) * y;
                    o == 0 ? _.copy(te) : _.copy(P).setLength(x + De), z.push(De);
                    let Pe = [
                        _,
                        J,
                        Ee
                    ];
                    for(let ze = 0; ze < 2; ze++){
                        let ke = Pe[ze], Ue = Pe[ze + 1];
                        O.subVectors(ke, P), L.subVectors(Ue, P), I.crossVectors(O, L).normalize();
                        for(let Le = 0; Le < v; Le++){
                            let Qe = [
                                xe,
                                de
                            ][ze] * Le / v;
                            m.copy(O).applyAxisAngle(I, Qe).add(P), K.push(m.clone()), ze && (w(m, P), ie.push([
                                Le == 0 ? ke : m.clone(),
                                b.clone()
                            ]));
                        }
                        ze && (w(Ue, P), ie.push([
                            Ue,
                            b.clone()
                        ]));
                    }
                    Q.push(ie);
                }
                j.push(Q);
                let $ = 2 * v, W = 2;
                for(let oe = 0; oe < f; oe++){
                    let ie = $ * oe, re = $ * ((oe + 1) % f), J = [
                        K[ie]
                    ];
                    for(let xe = 1; xe < v; xe++){
                        O = K[ie + xe], L = K[re + xe], J.push(O);
                        for(let de = 1, De = xe - W + 1; de <= De; de++)m.lerpVectors(O, L, de / (De + 1)), m.sub(P).setLength(z[oe]).add(P), J.push(m.clone());
                        J.push(L);
                    }
                    for(let xe = 0; xe < v; xe++)J.push(K[xe + v + ie]);
                    J.push(K[re + v]);
                    let Ee = C.map((xe)=>J[xe]);
                    a.push(...Ee.map((xe)=>[
                            xe.x,
                            xe.y,
                            xe.z
                        ]).flat()), c.push(...Ee.map((xe)=>(w(xe, P), [
                            b.x,
                            b.y,
                            b.z
                        ])).flat());
                }
            }
            let H = [];
            for(let q = 0; q < S.length; q++)for(let X = 0; X < f; X++){
                let K = S[q][X];
                if (K < M) {
                    let z = S[K].findIndex(($)=>$ % M == q), Q = j[q][X], te = j[K][z];
                    for(let $ = 0; $ < v; $++){
                        let W = Q[$], oe = te[v - $], ie = Q[$ + 1], re = te[v - ($ + 1)];
                        [
                            W,
                            oe,
                            ie,
                            ie,
                            oe,
                            re
                        ].forEach((J)=>{
                            a.push(J[0].x, J[0].y, J[0].z), c.push(J[1].x, J[1].y, J[1].z);
                        });
                    }
                    H.push(Q[0][0], te[v][0], Q[v][0], te[0][0]);
                }
            }
            for(; H.length;){
                let q, X, K, z;
                [q, X] = H.splice(0, 2);
                let Q = [
                    q
                ];
                for(; q != X;)Q.push(X), K = H.indexOf(X), z = K % 2, X = H.splice(K - z, 2)[1 - z];
                b.subVectors(Q[0], Q[1]).cross(m.subVectors(Q[0], Q[2])).normalize();
                let te = b.dot(Q[0]) < 0;
                te && b.negate();
                for(let $ = 1; $ <= Q.length - 2; $++)[
                    Q[$ + +te],
                    Q[$ + 1 - +te],
                    Q[0]
                ].forEach((W)=>{
                    a.push(W.x, W.y, W.z), c.push(b.x, b.y, b.z);
                });
            }
        }
        function h() {
            let d = new E;
            for(let T = 0; T < a.length; T += 3){
                d.x = a[T + 0], d.y = a[T + 1], d.z = a[T + 2];
                let S = w(d) / 2 / Math.PI + .5, M = A(d) / Math.PI + .5;
                l.push(S, 1 - M);
            }
            let f = new E, m = new E, p = new E, g = new E, y = new U, x = new U, v = new U, b = (T, S, M, C)=>{
                C < 0 && T.x === 1 && (l[S] = T.x - 1), M.x === 0 && M.z === 0 && (l[S] = C / 2 / Math.PI + .5);
            };
            for(let T = 0, S = 0; T < a.length; T += 9, S += 6){
                f.set(a[T + 0], a[T + 1], a[T + 2]), m.set(a[T + 3], a[T + 4], a[T + 5]), p.set(a[T + 6], a[T + 7], a[T + 8]), y.set(l[S + 0], l[S + 1]), x.set(l[S + 2], l[S + 3]), v.set(l[S + 4], l[S + 5]), g.copy(f).add(m).add(p).divideScalar(3);
                let M = w(g);
                b(y, S + 0, f, M), b(x, S + 2, m, M), b(v, S + 4, p, M);
            }
            for(let T = 0; T < l.length; T += 6){
                let S = l[T + 0], M = l[T + 2], C = l[T + 4], P = Math.max(S, M, C), _ = Math.min(S, M, C);
                P > .9 && _ < .1 && (S < .2 && (l[T + 0] += 1), M < .2 && (l[T + 2] += 1), C < .2 && (l[T + 4] += 1));
            }
            function w(T) {
                return Math.atan2(T.z, -T.x);
            }
            function A(T) {
                return Math.atan2(-T.y, Math.sqrt(T.x * T.x + T.z * T.z));
            }
        }
    }
    static fromJSON(t) {
        return new Jl(t.vertices, t.indices, t.radius, t.corner, t.cornerSides);
    }
};
var h3 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            detail: 0,
            corner: 0,
            cornerSides: 4
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, detail: i, corner: s1, cornerSides: o } = n1.parameters, a = i === 0 && s1 !== 0 ? new Bm(t * .5, s1, o) : new ah(t * .5, i);
        return a.scale(1, e / t, r / t), Object.assign(a, {
            userData: {
                ...n1,
                type: "DodecahedronGeometry"
            }
        });
    }
}, Bm = class extends Jl {
    constructor(t = 1, e = .2, r = 4){
        let i = (1 + Math.sqrt(5)) / 2, s1 = 1 / i, o = [
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            0,
            -s1,
            -i,
            0,
            -s1,
            i,
            0,
            s1,
            -i,
            0,
            s1,
            i,
            -s1,
            -i,
            0,
            -s1,
            i,
            0,
            s1,
            -i,
            0,
            s1,
            i,
            0,
            -i,
            0,
            -s1,
            i,
            0,
            -s1,
            -i,
            0,
            s1,
            i,
            0,
            s1
        ], a = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ], l = "DodecahedronGeometry";
        super(o, a, l, t, e, r), this.type = l;
    }
    static fromJSON(t) {
        return new Bm(t.radius, t.corner, t.cornerSides);
    }
};
var Fm = 1e-12, Gd = class {
    constructor(t){
        this.position = new U;
        this.startPosition = new U;
        this.uuid = Se.generateUUID();
        this.position = t.clone();
    }
    start() {
        this.reset();
    }
    reset() {
        this.startPosition.copy(this.position);
    }
    applyOffset(t) {
        this.position.copy(this.startPosition).add(t);
    }
    copy(t) {
        return this.position.copy(t.position), this.startPosition.copy(t.startPosition), this;
    }
    clone() {
        return new Gd(this.position).copy(this);
    }
    toJSON() {
        return [
            this.position.x,
            this.position.y
        ];
    }
}, jd = class extends Gd {
    constructor(e){
        super(e.position);
        this.parent = e;
    }
    copy(e) {
        return super.copy(e), this;
    }
    clone() {
        return new jd(this.parent).copy(this);
    }
}, ro = class extends Gd {
    constructor(e, r){
        super(r);
        this.controls = [];
        this.roundness = 0;
        this.areControlsDirectionsMirrored = !0;
        this.uuid = e, this.controls.push(new jd(this), new jd(this));
    }
    static create(e, r) {
        let i = new ro(e, new U(...r.position));
        return i.controls[0].position.set(...r.controlPrevious.position), i.controls[1].position.set(...r.controlNext.position), i.roundness = r.roundness, i.areControlsDirectionsMirrored = r.areControlsDirectionsMirrored, i;
    }
    getOppositeControl(e) {
        let r = this.controls.indexOf(e);
        return r === 0 ? this.controls[1] : r === 1 ? this.controls[0] : null;
    }
    applyOffsetToControls(e, r = 1) {
        for(let i = 0, s1 = this.controls.length; i < s1; i++){
            let o = this.controls[i];
            this.position.distanceTo(o.position) <= r ? o.position.copy(this.position) : o.applyOffset(e);
        }
    }
    controlsMoved() {
        return !(this.position.equals(this.controls[0].position) && this.position.equals(this.controls[1].position));
    }
    copy(e) {
        return super.copy(e), this.controls[0].copy(e.controls[0]), this.controls[1].copy(e.controls[1]), this.roundness = e.roundness, this.uuid = e.uuid, this;
    }
    clone() {
        return new ro(this.uuid, this.position).copy(this);
    }
    toJSON() {
        return super.toJSON().concat(this.controls[0].toJSON(), this.controls[1].toJSON(), [
            this.roundness
        ]);
    }
    computeTangents() {
        let e = this.curveBefore?.getTangentAt(1), r = this.curveAfter?.getTangentAt(0);
        return [
            e,
            r
        ];
    }
    computeNormals(e = new U, r = new U) {
        let [i, s1] = this.computeTangents();
        return i && s1 && (d3(i, e), d3(s1, r)), [
            e,
            r
        ];
    }
    computeTangent(e = new U) {
        let [r, i] = this.computeTangents();
        return r && i && e.copy(r).add(i).normalize(), e;
    }
    computeNormal(e = new U) {
        let [r, i] = this.computeNormals();
        return e.copy(r).add(i).normalize(), e;
    }
};
function d3(n1, t = new U) {
    let e = n1.length();
    return t.set(-n1.y / e, n1.x / e);
}
var DE = (n1)=>n1, Hd = new U, vx = new U, PK = new U, _K = new U, IK = new U, DK = new U, p3 = new E, m3 = new E;
function g3(n1) {
    let t = new U;
    t.addVectors(n1.v0, Hd.subVectors(n1.v1, n1.v0).multiplyScalar(2 / 3));
    let e = new U;
    return e.addVectors(n1.v2, vx.subVectors(n1.v1, n1.v2).multiplyScalar(2 / 3)), new hn(n1.v0, t, e, n1.v2);
}
function Vm(n1, t, e = Number.EPSILON) {
    return Math.abs(n1 - t) < e;
}
function OK(n1, t, e = Number.EPSILON) {
    return n1.distanceTo(t) < e;
}
function RK(n1, t, e = Number.EPSILON) {
    return n1.distanceTo(t) < e;
}
function OE(n1, t, e) {
    let r = Math.sqrt(Math.pow(t.x - n1.x, 2) + Math.pow(t.y - n1.y, 2)), i = Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2)), s1 = Math.sqrt(Math.pow(e.x - n1.x, 2) + Math.pow(e.y - n1.y, 2));
    return Math.acos((i * i + r * r - s1 * s1) / (2 * i * r));
}
function y3(n1, t, e) {
    return f3(n1, t) && f3(t, e) && IE(n1.position, t.position, e.position);
}
function IE(n1, t, e) {
    return Hd.copy(t).sub(n1).cross(vx.copy(e).sub(n1)) === 0;
}
function v3(n1, t, e, r, i) {
    let s1 = Math.sqrt(Math.pow(t.x - n1.x, 2) + Math.pow(t.y - n1.y, 2)), o = (n1.y + t.y) / 2, a = (n1.x + t.x) / 2, l = Math.sqrt(Math.pow(e, 2) - Math.pow(s1 / 2, 2)) * (n1.y - t.y) / s1, c = Math.sqrt(Math.pow(e, 2) - Math.pow(s1 / 2, 2)) * (t.x - n1.x) / s1;
    return r.set(a + l, o + c), i.set(a - l, o - c), [
        r,
        i
    ];
}
function x3(n1, t, e) {
    let r = n1.distanceTo(e), i = t.distanceTo(e);
    return r < i ? t : n1;
}
function b3(n1, t, e, r, i, s1) {
    let o = t.x - n1.x, a = t.y - n1.y, l = e.x - n1.x, c = e.y - n1.y, u1 = Math.sqrt((o + l) * (o + l) + (a + c) * (a + c)), h;
    return OE(t, n1, e) > Math.PI && (u1 *= -1), Vm(c, a) ? h = (a + c) * (r / u1 - .5) * 8 / 3 / (o - l) : h = (o + l) * (r / u1 - .5) * 8 / 3 / (c - a), i.set(t.x - h * a, t.y + h * o), s1.set(e.x + h * c, e.y - h * l), [
        i,
        s1
    ];
}
function RE(n1, t) {
    return n1.position.equals(n1.controls[1].position) && t.position.equals(t.controls[0].position);
}
function f3(n1, t) {
    return IE(n1.position, n1.controls[1].position, t.position) && IE(n1.position, t.controls[0].position, t.position);
}
function S3(n1, t, e, r, i = .5) {
    let s1 = Hd.subVectors(t, n1).multiplyScalar(i).add(n1), o = vx.subVectors(e, t).multiplyScalar(i).add(t), a = PK.subVectors(r, e).multiplyScalar(i).add(e), l = s1, c = _K.subVectors(o, s1).multiplyScalar(i).add(s1), u1 = IK.subVectors(a, o).multiplyScalar(i).add(o), h = a, d = DK.subVectors(u1, c).multiplyScalar(i).add(c);
    return [
        n1.x,
        n1.y,
        l.x,
        l.y,
        c.x,
        c.y,
        d.x,
        d.y,
        u1.x,
        u1.y,
        h.x,
        h.y,
        r.x,
        r.y
    ];
}
function w3(n1, t, e = 12, r = !0) {
    let i = m3.set(0, 0, 0), s1, o = 0, a = [];
    for(let l = 0; l < t.length; l++){
        let c = DE(t[l]), u1 = Hd, h = $l(c, e);
        a.push(h);
        for(let d = 0; d <= h; d++)if (c instanceof hn || c instanceof es || c instanceof dn) {
            if (c.getPoint(d / h, u1), i.set(u1.x, u1.y, 0), s1 !== void 0 && RK(s1, i)) continue;
            s1 === void 0 && (s1 = p3), s1.copy(i), n1.setXYZ(o, i.x, i.y, i.z), o++;
        }
    }
    return r && o > 1 && !(n1.getX(o - 1) === n1.getX(0) && n1.getY(o - 1) === n1.getY(0) && n1.getZ(o - 1) === n1.getZ(0)) && (n1.setXYZ(o, n1.getX(0), n1.getY(0), n1.getZ(0)), o++), n1;
}
function A3(n1, t, e, r = 12, i = !0) {
    let s1 = m3.set(0, 0, 0), o = 0, a = [];
    for(let l = 0; l < t.length; l++){
        if (e[l] === !1) continue;
        let c, u1 = DE(t[l]), h = Hd, d = $l(u1, r);
        a.push(d);
        for(let f = 0; f <= d; f++)if (u1 instanceof hn || u1 instanceof es || u1 instanceof dn) {
            if (u1.getPoint(f / d, h), s1.set(h.x, h.y, 0), c?.equals(s1)) continue;
            c === void 0 ? c = p3 : (n1.setXYZ(o, c.x, c.y, c.z), o++, n1.setXYZ(o, s1.x, s1.y, s1.z), o++), c.copy(s1);
        }
    }
    return i && o > 1 && !(n1.getX(o - 1) === n1.getX(0) && n1.getY(o - 1) === n1.getY(0) && n1.getZ(o - 1) === n1.getZ(0)) && (n1.setXYZ(o, n1.getX(0), n1.getY(0), n1.getZ(0)), o++), a;
}
function LE(n1, t = 12, e = !1) {
    let r = [];
    for(let i = 0, s1 = n1.length; i < s1; i++){
        let o = n1[i], a = 0;
        if (e && o.roundedCurveCorner !== void 0) {
            let l = $l(o.roundedCurveCorner, t) * .5;
            i > 0 && (r[i - 1] += l), a += l;
        }
        o.curveAfter !== void 0 && (a += $l(o.curveAfter, t)), r.push(a);
    }
    return n1.length > 0 && e && n1[0].roundedCurveCorner !== void 0 && (r[n1.length - 1] += $l(n1[0].roundedCurveCorner, t) * .5), r;
}
function $l(n1, t = 12) {
    return n1 && n1 instanceof kc ? t * 2 : n1 && (n1 instanceof dn || n1 instanceof Gp) ? 1 : n1 && n1 instanceof nh ? t * n1.points.length : t;
}
function E3(n1, t, e = 12, r = !0) {
    let i, s1 = 0;
    for(let o = 0; o < t.length; o++){
        let a = DE(t[o]), l = $l(a, e), c = Hd;
        for(let u1 = 0; u1 <= l; u1++)if (a instanceof hn || a instanceof es || a instanceof dn) {
            if (a.getPoint(u1 / l, c), i !== void 0 && OK(i, c, Fm)) continue;
            i === void 0 && (i = vx), i.copy(c), n1.push(c.x, c.y), s1++;
        }
    }
    return Vm(n1[0], n1[n1.length - 2], Fm) && Vm(n1[1], n1[n1.length - 1], Fm) && (n1.pop(), n1.pop()), r && s1 > 1 && !(Vm(n1[s1 - 1], n1[1], Fm) && Vm(n1[s1 - 2], n1[0], Fm)) && (n1.push(n1[0], n1[1]), s1++), n1;
}
var NE = new U, LK = new U, NK = new U, BK = new U, FK = new U, VK = new U, $t = class extends Ca {
    constructor(e = 100, r = 100){
        super();
        this.points = [];
        this.shapeHoles = [];
        this.plane = new qr(new E(0, 0, -1));
        this.subdivision = 0;
        this.controlSnapDistance = 4;
        this.pointIDs = 0;
        this.isMesh2D = !1;
        this.isText = !1;
        this._roundness = 0;
        this.isClosed = !1;
        this.useCubicForRoundedCorners = !0;
        this.uuid = Se.generateUUID();
        this.needsUpdate = !1;
        this.roundedCurves = [];
        this._width = e, this._height = r;
    }
    static createFromState(e, r, i) {
        let s1 = new $t;
        return s1.isClosed = e.isClosed, s1.points = e.points.map((o)=>ro.create(o.id, o.data)), typeof e.roundness == "number" && (s1.roundness = e.roundness), s1.shapeHoles = e.shapeHoles.map((o)=>$t.createFromState(o)), r !== void 0 && i !== void 0 && s1.applySize(r, i), s1.update(), s1;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    get roundness() {
        return this._roundness;
    }
    set roundness(e) {
        if (this._roundness !== e) {
            this._roundness = e;
            for(let r = 0, i = this.points.length; r < i; r++)this.points[r].roundness = e;
            this.needsUpdate = !0;
        }
    }
    getPointsIndexesByIds(e) {
        return e.map((r)=>this.getPointIndexById(r)).filter((r)=>r >= 0);
    }
    getPointIndexById(e) {
        let r = this.points.length, i = this.points.findIndex((s1)=>s1.uuid === e);
        if (i < 0) {
            let s1 = r;
            for(let o = 0, a = this.shapeHoles.length; o < a; o++){
                let l = this.shapeHoles[o], c = l.points.length, u1 = l.getPointIndexById(e);
                if (u1 < 0) s1 += c;
                else return u1 + s1;
            }
        }
        return i;
    }
    getLineIndexById(e) {
        return this.getPointIndexById(e);
    }
    getBezierPoint(e) {
        if (e <= this.points.length - 1) return this.points[e];
        if (this.shapeHoles.length > 0) {
            let r = this.points.length;
            for(let i = 0, s1 = this.shapeHoles.length; i < s1; i++){
                let o = this.shapeHoles[i], a = e - r;
                if (a <= o.points.length - 1) return o.points[a];
                r += o.points.length;
            }
        }
        throw new Error("This shape does not have a point for this index: " + e);
    }
    getBezierPointIndex(e) {
        let r = this.points.indexOf(e);
        if (r >= 0) return r;
        if (r = this.points.length, this.shapeHoles.length > 0) for(let i = 0, s1 = this.shapeHoles.length; i < s1; i++){
            let o = this.shapeHoles[i], a = o.points.indexOf(e);
            if (a >= 0) return r + a;
            r += o.points.length;
        }
        return -1;
    }
    getAllPoints() {
        let e = [].concat(...this.shapeHoles.map((r)=>r.points));
        return [
            ...this.points,
            ...e
        ];
    }
    applySize(e, r) {
        e === 0 && (e = .001), r === 0 && (r = .001), this._width = e, this._height = r;
    }
    applyScale(e, r) {
        let i = NE.set(e, r);
        for(let s1 = 0, o = this.points.length; s1 < o; s1++){
            let a = this.points[s1];
            a.position.multiply(i), a.controls[0].position.multiply(i), a.controls[1].position.multiply(i);
        }
        for(let s1 = 0, o = this.shapeHoles.length; s1 < o; s1++)this.shapeHoles[s1].applyScale(e, r);
        this._update();
    }
    createPoint(e, r = 0, i = Se.generateUUID()) {
        let s1;
        e instanceof U ? s1 = e : s1 = new U(e, r);
        let o = new ro(i, s1);
        return o.roundness = this.roundness, o;
    }
    addPoint(e) {
        this.points.push(e), this.needsUpdate = !0;
    }
    addPointAt(e, r) {
        this.points.splice(r, 0, e), this.needsUpdate = !0;
    }
    getPointByUuid(e) {
        for(let r = 0, i = this.points.length; r < i; r++){
            let s1 = this.points[r];
            if (s1.uuid === e) return s1;
        }
        for(let r = 0, i = this.shapeHoles.length; r < i; r++){
            let o = this.shapeHoles[r].getPointByUuid(e);
            if (o) return o;
        }
    }
    getFirstPoint() {
        return this.points[0];
    }
    getLastPoint() {
        return this.points[this.points.length - 1];
    }
    removePoint(e) {
        let r = this.points.indexOf(e);
        r >= 0 && this.points.splice(r, 1), this.needsUpdate = !0;
    }
    removePointById(e) {
        let r = this.points.find((i)=>i.uuid === e);
        r && this.removePoint(r);
    }
    update() {
        for(let e = 0, r = this.shapeHoles.length; e < r; e++)this.shapeHoles[e].update();
        this._update();
    }
    extractShapePointsToBuffer(e, r = 12, i = !1) {
        this.subdivision = r, this.curveDivisions === void 0 && this.computeCurveDivisions(r);
        let s1 = i ? this.roundedCurveDivisions : this.curveDivisions;
        return w3(e, i ? this.roundedCurves : this.curves, r, this.autoClose), s1.reduce((o, a)=>o + a, 0) + 1;
    }
    computeCurveDivisions(e = 12) {
        return this.curveDivisions = LE(this.points, e, !1), this.roundedCurveDivisions = LE(this.points, e, !0), this.curveDivisions;
    }
    extractFilteredShapePointsToBuffer(e, r, i = 12) {
        return A3(e, this.curves, r, i, this.autoClose).reduce((o, a)=>o + a, 0) * 2;
    }
    extractShapePointsToFlatArray(e, r = 12) {
        return this.subdivision = r, this.curveDivisions === void 0 && this.computeCurveDivisions(r), E3(e, this.roundedCurves, r, this.autoClose);
    }
    getCurveIndexFromVertexId(e, r = !1) {
        let i = 0;
        this.curveDivisions === void 0 && this.computeCurveDivisions(this.subdivision);
        let s1 = r ? this.roundedCurveDivisions : this.curveDivisions, o = 0;
        r && this.points[0].roundedCurveCorner !== void 0 && (o = $l(this.points[0].roundedCurveCorner, this.subdivision) * .5);
        let a = e - o;
        a < 0 && (a += s1.reduce((l, c)=>l + c, 0));
        for(let l = 0, c = s1.length; l < c; l++){
            let u1 = s1[l];
            if (a < i + u1) return [
                l,
                (a - i + 1) / u1
            ];
            i += u1;
        }
        return [
            0,
            1
        ];
    }
    getCurveT(e, r, i) {
        let s1 = this.points[e], o = this.points[e >= this.points.length - 1 ? 0 : e + 1], a = this.curveDivisions, l = a[e];
        if (RE(s1, o)) {
            let h = s1.position.distanceTo(o.position);
            return s1.position.distanceTo(NE.set(i.x, i.y)) / h;
        }
        let c = 0;
        for(let h = 0; h < e; h++)c += a[h];
        return (r - c) / l;
    }
    dispose() {}
    _applyCurveForPoint(e, r) {
        RE(r, e) ? this.lineTo(e.position.x, e.position.y) : this.bezierCurveTo(r.controls[1].position.x, r.controls[1].position.y, e.controls[0].position.x, e.controls[0].position.y, e.position.x, e.position.y);
        let i = this.curves[this.curves.length - 1];
        e.curveBefore = i, r.curveAfter = i;
        let s1 = i.clone();
        e.roundedCurveBefore = s1, r.roundedCurveAfter = s1, e.roundedCurveCorner = void 0, this.roundedCurves.push(s1);
    }
    _update() {
        if (this.curves = [], this.roundedCurves = [], !this.points.length) return;
        for(let r = 0, i = this.points.length; r < i; r++){
            let s1 = this.points[r];
            if (r === 0) this.moveTo(s1.position.x, s1.position.y);
            else {
                let o = this.points[r - 1];
                this._applyCurveForPoint(s1, o);
            }
        }
        let e = this.getLastPoint();
        if (e?.curveAfter && (e.curveAfter = void 0), this.isClosed) {
            let r = this.points[0], i = this.points[this.points.length - 1];
            this._applyCurveForPoint(r, i);
        }
        if (this.points.length > 2) {
            let r = 0;
            for(let i = 0, s1 = this.points.length; i < s1; i++){
                let o = this.points[i], a = this.points[i - 1] ?? this.points[this.points.length - 1], l = this.points[i + 1] ?? this.points[0], c = o.roundness, u1 = a && l && y3(a, o, l);
                if (!o.controlsMoved() && c > 0 && !u1) {
                    let h = o.curveBefore, d = o.curveAfter;
                    if (h === void 0 || d === void 0) continue;
                    let f = o.roundedCurveBefore, m = o.roundedCurveAfter, p = h.getLength(), g = d.getLength(), y = Math.min(c, p * .499), x = Math.min(c, g * .499), v = Math.min(y, x), b = 1 - v / p, w = v / g, A = h.getPointAt(b, NE), T = d.getPointAt(w, LK);
                    this._subSplitCurve(h, f, b, A, void 0), this._subSplitCurve(d, m, w, void 0, T);
                    let S;
                    if (this.useCubicForRoundedCorners) {
                        let M = OE(A, o.position, T) / 2, C = Math.tan(M) * A.distanceTo(o.position), [P, _] = v3(A, T, C, NK, BK), I = x3(P, _, o.position), [O, L] = b3(I, A, T, C, FK, VK);
                        S = new hn(A.clone(), O.clone(), L.clone(), T.clone());
                    } else S = new es(A.clone(), o.position.clone(), T.clone());
                    o.roundedCurveCorner = S, this.roundedCurves.splice(i + r, 0, S), r++;
                }
            }
        }
    }
    _subSplitCurve(e, r, i, s1, o) {
        if (e instanceof dn) s1 !== void 0 && r.v2.copy(s1), o !== void 0 && r.v1.copy(o);
        else {
            let a = e, l = r, c = a.getUtoTmapping(i, 0), u1 = S3(a.v0, a.v1, a.v2, a.v3, c);
            return s1 !== void 0 && (l.v0.set(u1[0], u1[1]), l.v1.set(u1[2], u1[3]), l.v2.set(u1[4], u1[5]), l.v3.set(u1[6], u1[7])), o !== void 0 && (l.v0.set(u1[6], u1[7]), l.v1.set(u1[8], u1[9]), l.v2.set(u1[10], u1[11]), l.v3.set(u1[12], u1[13])), l;
        }
        return r;
    }
    clone() {
        let e = new $t(this._width, this._height);
        return e.points = this.points.map((r)=>r.clone()), e.isClosed = this.isClosed, e.roundness = this.roundness, e.isMesh2D = this.isMesh2D, e.shapeHoles = this.shapeHoles.map((r)=>r.clone()), e;
    }
    toJSON() {
        return {
            points: this.points.reduce((e, r)=>e.concat(r.toJSON()), []),
            shapeHoles: this.shapeHoles.map((e)=>e.toJSON()),
            isClosed: this.isClosed,
            roundness: this.roundness
        };
    }
    fromJSON(e) {
        this.points = [], this.pointIDs = 0;
        let r = e.points.length / 7;
        for(let i = 0; i < r; i++){
            let s1 = i * 7, o = e.points[s1 + 0], a = e.points[s1 + 1], l = e.points[s1 + 2], c = e.points[s1 + 3], u1 = e.points[s1 + 4], h = e.points[s1 + 5], d = e.points[s1 + 6], f = new ro(Se.generateUUID(), new U(o, a));
            f.controls[0].position.set(l, c), f.controls[1].position.set(u1, h), f.roundness = d, this.points.push(f);
        }
        return this.shapeHoles = e.shapeHoles?.length ? e.shapeHoles.map((i)=>{
            let s1 = new $t;
            return s1.fromJSON(i), s1;
        }) : [], this.isClosed = e.isClosed, this._roundness = e.roundness, this._update(), this;
    }
    fromShape(e, r = !1) {
        this.isText = r;
        let i = (o, a)=>{
            a instanceof hn && a.v3.equals(o.position) && o.controls[0].position.copy(a.v2);
        }, s1 = (o)=>{
            let a = [], l, c;
            for(l = 0, c = o.length; l < c; l++)o[l] instanceof es && (o[l] = g3(o[l]));
            for(l = 0, c = o.length; l < c; l++){
                let d = o[l], f = l > 0 ? o[l - 1] : null, m;
                d instanceof hn ? (m = this.createPoint(d.v0), m.controls[1].position.copy(d.v1)) : d instanceof dn && (m = this.createPoint(d.v1)), m !== void 0 && (f !== null && i(m, f), a.push(m));
            }
            let u1 = o[o.length - 1], h = !1;
            return u1 instanceof hn ? u1.v3.equals(a[0].position) && (a[0].controls[0].position.copy(u1.v2), h = !0) : u1 instanceof dn && u1.v2.equals(a[0].position) && (h = !0), this.isClosed = h, a;
        };
        return this.points = s1(e.curves), e instanceof Ca && (this.shapeHoles = e.holes.map((o)=>{
            let a = new $t;
            return a.fromShape(o), a;
        })), this.update(), this;
    }
    updatePoint(e, r) {
        let i = this.getPointByUuid(e);
        i && (r.position !== void 0 && i.position.fromArray(r.position), r.roundness !== void 0 && (i.roundness = r.roundness), r.areControlsDirectionsMirrored !== void 0 && (i.areControlsDirectionsMirrored = r.areControlsDirectionsMirrored), this.needsUpdate = !0);
    }
    updatePreviousControl(e, r) {
        let s1 = this.getPointByUuid(e)?.controls[0];
        s1 && (r.position && s1.position.fromArray(r.position), this.needsUpdate = !0);
    }
    updateNextControl(e, r) {
        let s1 = this.getPointByUuid(e)?.controls[1];
        s1 && (r.position && s1.position.fromArray(r.position), this.needsUpdate = !0);
    }
};
var FE = Math.PI * 2;
function BE({ x: n1, y: t }, e, r, i, s1) {
    return {
        x: n1 * e + i,
        y: t * r + s1
    };
}
function UK(n1, t) {
    let e = t === 1.5707963267948966 ? .551915024494 : t === -1.5707963267948966 ? -0.551915024494 : 1.3333333333333333 * Math.tan(t / 4), r = Math.cos(n1), i = Math.sin(n1), s1 = Math.cos(n1 + t), o = Math.sin(n1 + t);
    return [
        {
            x: r - i * e,
            y: i + r * e
        },
        {
            x: s1 + o * e,
            y: o - s1 * e
        },
        {
            x: s1,
            y: o
        }
    ];
}
function T3(n1, t, e, r) {
    let i = n1 * r - t * e < 0 ? -1 : 1, s1 = Math.min(1, Math.max(-1, n1 * e + t * r));
    return i * Math.acos(s1);
}
function kK(n1, t, e, r, i, s1, o, a, l, c) {
    let u1 = Math.pow(i, 2), h = Math.pow(s1, 2), d = Math.pow(o, 2), f = Math.pow(a, 2), m = u1 * h - u1 * f - h * d;
    m < 0 && (m = 0), m /= u1 * f + h * d, m = Math.sqrt(m) * (l === c ? -1 : 1);
    let p = m * i / s1 * a, g = m * -s1 / i * o, y = p + (n1 + e) / 2, x = g + (t + r) / 2, v = (o - p) / i, b = (a - g) / s1, w = (-o - p) / i, A = (-a - g) / s1, T = T3(1, 0, v, b), S = T3(v, b, w, A);
    return !c && S > 0 && (S -= FE), c && S < 0 && (S += FE), {
        centerx: y,
        centery: x,
        ang1: T,
        ang2: S
    };
}
function M3({ px: n1, py: t, cx: e, cy: r, rx: i, ry: s1, largeArcFlag: o, sweepFlag: a }) {
    let l = [];
    if (i === 0 || s1 === 0) return [];
    let c = (n1 - e) / 2, u1 = (t - r) / 2;
    if (c === 0 && u1 === 0) return [];
    i = Math.abs(i), s1 = Math.abs(s1);
    let h = Math.pow(c, 2) / Math.pow(i, 2) + Math.pow(u1, 2) / Math.pow(s1, 2);
    h > 1 && (i *= Math.sqrt(h), s1 *= Math.sqrt(h));
    let d = kK(n1, t, e, r, i, s1, c, u1, o, a), { ang1: f, ang2: m } = d, { centerx: p, centery: g } = d, y = Math.abs(m) / (FE / 4);
    Math.abs(1 - y) < 1e-7 && (y = 1);
    let x = Math.max(Math.ceil(y), 1);
    m /= x;
    for(let v = 0; v < x; v++)l.push(UK(f, m)), f += m;
    return l.map((v)=>{
        let { x: b, y: w } = BE(v[0], i, s1, p, g), { x: A, y: T } = BE(v[1], i, s1, p, g), { x: S, y: M } = BE(v[2], i, s1, p, g);
        return {
            x1: b,
            y1: w,
            x2: A,
            y2: T,
            x: S,
            y: M
        };
    });
}
var qt;
(function(n1) {
    n1[n1.ODD = 0] = "ODD", n1[n1.NONZERO = 1] = "NONZERO", n1[n1.POSITIVE = 2] = "POSITIVE", n1[n1.NEGATIVE = 3] = "NEGATIVE", n1[n1.ABS_GEQ_TWO = 4] = "ABS_GEQ_TWO";
})(qt || (qt = {}));
var Qr;
(function(n1) {
    n1[n1.POLYGONS = 0] = "POLYGONS", n1[n1.CONNECTED_POLYGONS = 1] = "CONNECTED_POLYGONS", n1[n1.BOUNDARY_CONTOURS = 2] = "BOUNDARY_CONTOURS";
})(Qr || (Qr = {}));
function ft(n1, t) {
    if (!n1) throw t || "Assertion Failed!";
}
var lt = function() {
    function n1() {}
    return n1.vertEq = function(t, e) {
        return t.s === e.s && t.t === e.t;
    }, n1.vertLeq = function(t, e) {
        return t.s < e.s || t.s === e.s && t.t <= e.t;
    }, n1.transLeq = function(t, e) {
        return t.t < e.t || t.t === e.t && t.s <= e.s;
    }, n1.edgeGoesLeft = function(t) {
        return n1.vertLeq(t.Dst, t.Org);
    }, n1.edgeGoesRight = function(t) {
        return n1.vertLeq(t.Org, t.Dst);
    }, n1.vertL1dist = function(t, e) {
        return Math.abs(t.s - e.s) + Math.abs(t.t - e.t);
    }, n1.edgeEval = function(t, e, r) {
        ft(n1.vertLeq(t, e) && n1.vertLeq(e, r));
        var i = e.s - t.s, s1 = r.s - e.s;
        return i + s1 > 0 ? i < s1 ? e.t - t.t + (t.t - r.t) * (i / (i + s1)) : e.t - r.t + (r.t - t.t) * (s1 / (i + s1)) : 0;
    }, n1.edgeSign = function(t, e, r) {
        ft(n1.vertLeq(t, e) && n1.vertLeq(e, r));
        var i = e.s - t.s, s1 = r.s - e.s;
        return i + s1 > 0 ? (e.t - r.t) * i + (e.t - t.t) * s1 : 0;
    }, n1.transEval = function(t, e, r) {
        ft(n1.transLeq(t, e) && n1.transLeq(e, r));
        var i = e.t - t.t, s1 = r.t - e.t;
        return i + s1 > 0 ? i < s1 ? e.s - t.s + (t.s - r.s) * (i / (i + s1)) : e.s - r.s + (r.s - t.s) * (s1 / (i + s1)) : 0;
    }, n1.transSign = function(t, e, r) {
        ft(n1.transLeq(t, e) && n1.transLeq(e, r));
        var i = e.t - t.t, s1 = r.t - e.t;
        return i + s1 > 0 ? (e.s - r.s) * i + (e.s - t.s) * s1 : 0;
    }, n1.vertCCW = function(t, e, r) {
        return t.s * (e.t - r.t) + e.s * (r.t - t.t) + r.s * (t.t - e.t) >= 0;
    }, n1.interpolate = function(t, e, r, i) {
        return t = t < 0 ? 0 : t, r = r < 0 ? 0 : r, t <= r ? r === 0 ? (e + i) / 2 : e + (i - e) * (t / (t + r)) : i + (e - i) * (r / (t + r));
    }, n1.intersect = function(t, e, r, i, s1) {
        var o, a, l;
        n1.vertLeq(t, e) || (l = t, t = e, e = l), n1.vertLeq(r, i) || (l = r, r = i, i = l), n1.vertLeq(t, r) || (l = t, t = r, r = l, l = e, e = i, i = l), n1.vertLeq(r, e) ? n1.vertLeq(e, i) ? (o = n1.edgeEval(t, r, e), a = n1.edgeEval(r, e, i), o + a < 0 && (o = -o, a = -a), s1.s = n1.interpolate(o, r.s, a, e.s)) : (o = n1.edgeSign(t, r, e), a = -n1.edgeSign(t, i, e), o + a < 0 && (o = -o, a = -a), s1.s = n1.interpolate(o, r.s, a, i.s)) : s1.s = (r.s + e.s) / 2, n1.transLeq(t, e) || (l = t, t = e, e = l), n1.transLeq(r, i) || (l = r, r = i, i = l), n1.transLeq(t, r) || (l = t, t = r, r = l, l = e, e = i, i = l), n1.transLeq(r, e) ? n1.transLeq(e, i) ? (o = n1.transEval(t, r, e), a = n1.transEval(r, e, i), o + a < 0 && (o = -o, a = -a), s1.t = n1.interpolate(o, r.t, a, e.t)) : (o = n1.transSign(t, r, e), a = -n1.transSign(t, i, e), o + a < 0 && (o = -o, a = -a), s1.t = n1.interpolate(o, r.t, a, i.t)) : s1.t = (r.t + e.t) / 2;
    }, n1;
}(), Um = function() {
    function n1() {
        this.next = null, this.prev = null, this.anEdge = null, this.trail = null, this.n = 0, this.marked = !1, this.inside = !1;
    }
    return n1;
}(), xx = function() {
    function n1(t) {
        this.side = t, this.next = null, this.Org = null, this.Sym = null, this.Onext = null, this.Lnext = null, this.Lface = null, this.activeRegion = null, this.winding = 0;
    }
    return Object.defineProperty(n1.prototype, "Rface", {
        get: function() {
            return this.Sym.Lface;
        },
        set: function(t) {
            this.Sym.Lface = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Dst", {
        get: function() {
            return this.Sym.Org;
        },
        set: function(t) {
            this.Sym.Org = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Oprev", {
        get: function() {
            return this.Sym.Lnext;
        },
        set: function(t) {
            this.Sym.Lnext = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Lprev", {
        get: function() {
            return this.Onext.Sym;
        },
        set: function(t) {
            this.Onext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Dprev", {
        get: function() {
            return this.Lnext.Sym;
        },
        set: function(t) {
            this.Lnext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Rprev", {
        get: function() {
            return this.Sym.Onext;
        },
        set: function(t) {
            this.Sym.Onext = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Dnext", {
        get: function() {
            return this.Sym.Onext.Sym;
        },
        set: function(t) {
            this.Sym.Onext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n1.prototype, "Rnext", {
        get: function() {
            return this.Sym.Lnext.Sym;
        },
        set: function(t) {
            this.Sym.Lnext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), n1;
}(), Wd = function() {
    function n1() {
        this.next = null, this.prev = null, this.anEdge = null, this.coords = [
            0,
            0,
            0
        ], this.s = 0, this.t = 0, this.pqHandle = 0, this.n = 0, this.idx = 0;
    }
    return n1;
}(), C3 = function() {
    function n1() {
        var t = new Wd, e = new Um, r = new xx(0), i = new xx(1);
        t.next = t.prev = t, t.anEdge = null, e.next = e.prev = e, r.next = r, r.Sym = i, i.next = i, i.Sym = r, this.vHead = t, this.fHead = e, this.eHead = r, this.eHeadSym = i;
    }
    return n1.prototype.makeEdge_ = function(t) {
        var e = new xx(0), r = new xx(1);
        t.Sym.side < t.side && (t = t.Sym);
        var i = t.Sym.next;
        return r.next = i, i.Sym.next = e, e.next = t, t.Sym.next = r, e.Sym = r, e.Onext = e, e.Lnext = r, e.Org = null, e.Lface = null, e.winding = 0, e.activeRegion = null, r.Sym = e, r.Onext = r, r.Lnext = e, r.Org = null, r.Lface = null, r.winding = 0, r.activeRegion = null, e;
    }, n1.prototype.splice_ = function(t, e) {
        var r = t.Onext, i = e.Onext;
        r.Sym.Lnext = e, i.Sym.Lnext = t, t.Onext = i, e.Onext = r;
    }, n1.prototype.makeVertex_ = function(t, e, r) {
        var i = t;
        ft(i, "Vertex can't be null!");
        var s1 = r.prev;
        i.prev = s1, s1.next = i, i.next = r, r.prev = i, i.anEdge = e;
        var o = e;
        do o.Org = i, o = o.Onext;
        while (o !== e);
    }, n1.prototype.makeFace_ = function(t, e, r) {
        var i = t;
        ft(i, "Face can't be null");
        var s1 = r.prev;
        i.prev = s1, s1.next = i, i.next = r, r.prev = i, i.anEdge = e, i.trail = null, i.marked = !1, i.inside = r.inside;
        var o = e;
        do o.Lface = i, o = o.Lnext;
        while (o !== e);
    }, n1.prototype.killEdge_ = function(t) {
        t.Sym.side < t.side && (t = t.Sym);
        var e = t.next, r = t.Sym.next;
        e.Sym.next = r, r.Sym.next = e;
    }, n1.prototype.killVertex_ = function(t, e) {
        var r = t.anEdge, i = r;
        do i.Org = e, i = i.Onext;
        while (i !== r);
        var s1 = t.prev, o = t.next;
        o.prev = s1, s1.next = o;
    }, n1.prototype.killFace_ = function(t, e) {
        var r = t.anEdge, i = r;
        do i.Lface = e, i = i.Lnext;
        while (i !== r);
        var s1 = t.prev, o = t.next;
        o.prev = s1, s1.next = o;
    }, n1.prototype.makeEdge = function() {
        var t = new Wd, e = new Wd, r = new Um, i = this.makeEdge_(this.eHead);
        return this.makeVertex_(t, i, this.vHead), this.makeVertex_(e, i.Sym, this.vHead), this.makeFace_(r, i, this.fHead), i;
    }, n1.prototype.splice = function(t, e) {
        var r = !1, i = !1;
        if (t !== e) {
            if (e.Org !== t.Org && (i = !0, this.killVertex_(e.Org, t.Org)), e.Lface !== t.Lface && (r = !0, this.killFace_(e.Lface, t.Lface)), this.splice_(e, t), !i) {
                var s1 = new Wd;
                this.makeVertex_(s1, e, t.Org), t.Org.anEdge = t;
            }
            if (!r) {
                var o = new Um;
                this.makeFace_(o, e, t.Lface), t.Lface.anEdge = t;
            }
        }
    }, n1.prototype.delete = function(t) {
        var e = t.Sym, r = !1;
        if (t.Lface !== t.Rface && (r = !0, this.killFace_(t.Lface, t.Rface)), t.Onext === t) this.killVertex_(t.Org, null);
        else if (t.Rface.anEdge = t.Oprev, t.Org.anEdge = t.Onext, this.splice_(t, t.Oprev), !r) {
            var i = new Um;
            this.makeFace_(i, t, t.Lface);
        }
        e.Onext === e ? (this.killVertex_(e.Org, null), this.killFace_(e.Lface, null)) : (t.Lface.anEdge = e.Oprev, e.Org.anEdge = e.Onext, this.splice_(e, e.Oprev)), this.killEdge_(t);
    }, n1.prototype.addEdgeVertex = function(t) {
        var e = this.makeEdge_(t), r = e.Sym;
        this.splice_(e, t.Lnext), e.Org = t.Dst;
        var i = new Wd;
        return this.makeVertex_(i, r, e.Org), e.Lface = r.Lface = t.Lface, e;
    }, n1.prototype.splitEdge = function(t) {
        var e = this.addEdgeVertex(t), r = e.Sym;
        return this.splice_(t.Sym, t.Sym.Oprev), this.splice_(t.Sym, r), t.Dst = r.Org, r.Dst.anEdge = r.Sym, r.Rface = t.Rface, r.winding = t.winding, r.Sym.winding = t.Sym.winding, r.idx = t.idx, r.Sym.idx = t.Sym.idx, r;
    }, n1.prototype.connect = function(t, e) {
        var r = !1, i = this.makeEdge_(t), s1 = i.Sym;
        if (e.Lface !== t.Lface && (r = !0, this.killFace_(e.Lface, t.Lface)), this.splice_(i, t.Lnext), this.splice_(s1, e), i.Org = t.Dst, s1.Org = e.Org, i.Lface = s1.Lface = t.Lface, t.Lface.anEdge = s1, !r) {
            var o = new Um;
            this.makeFace_(o, i, t.Lface);
        }
        return i;
    }, n1.prototype.zapFace = function(t) {
        var e = t.anEdge, r, i, s1, o, a;
        i = e.Lnext;
        do r = i, i = r.Lnext, r.Lface = null, r.Rface === null && (r.Onext === r ? this.killVertex_(r.Org, null) : (r.Org.anEdge = r.Onext, this.splice_(r, r.Oprev)), s1 = r.Sym, s1.Onext === s1 ? this.killVertex_(s1.Org, null) : (s1.Org.anEdge = s1.Onext, this.splice_(s1, s1.Oprev)), this.killEdge_(r));
        while (r != e);
        o = t.prev, a = t.next, a.prev = o, o.next = a;
    }, n1.prototype.countFaceVerts_ = function(t) {
        var e = t.anEdge, r = 0;
        do r++, e = e.Lnext;
        while (e !== t.anEdge);
        return r;
    }, n1.prototype.mergeConvexFaces = function(t) {
        var e, r, i, s1, o, a, l;
        for(e = this.fHead.next; e !== this.fHead; e = e.next)if (!!e.inside) for(r = e.anEdge, o = r.Org; i = r.Lnext, s1 = r.Sym, s1 && s1.Lface && s1.Lface.inside && (a = this.countFaceVerts_(e), l = this.countFaceVerts_(s1.Lface), a + l - 2 <= t && lt.vertCCW(r.Lprev.Org, r.Org, s1.Lnext.Lnext.Org) && lt.vertCCW(s1.Lprev.Org, s1.Org, r.Lnext.Lnext.Org) && (i = s1.Lnext, this.delete(s1), r = null, s1 = null)), !(r && r.Lnext.Org === o);)r = i;
        return !0;
    }, n1.prototype.check = function() {
        var t = this.fHead, e = this.vHead, r = this.eHead, i, s1, o, a, l, c;
        for(s1 = t, s1 = t; (i = s1.next) !== t; s1 = i){
            ft(i.prev === s1), l = i.anEdge;
            do ft(l.Sym !== l), ft(l.Sym.Sym === l), ft(l.Lnext.Onext.Sym === l), ft(l.Onext.Sym.Lnext === l), ft(l.Lface === i), l = l.Lnext;
            while (l !== i.anEdge);
        }
        for(ft(i.prev === s1 && i.anEdge === null), a = e, a = e; (o = a.next) !== e; a = o){
            ft(o.prev === a), l = o.anEdge;
            do ft(l.Sym !== l), ft(l.Sym.Sym === l), ft(l.Lnext.Onext.Sym === l), ft(l.Onext.Sym.Lnext === l), ft(l.Org === o), l = l.Onext;
            while (l !== o.anEdge);
        }
        for(ft(o.prev === a && o.anEdge === null), c = r, c = r; (l = c.next) !== r; c = l)ft(l.Sym.next === c.Sym), ft(l.Sym !== l), ft(l.Sym.Sym === l), ft(l.Org !== null), ft(l.Dst !== null), ft(l.Lnext.Onext.Sym === l), ft(l.Onext.Sym.Lnext === l);
        ft(l.Sym.next === c.Sym && l.Sym === this.eHeadSym && l.Sym.Sym === l && l.Org === null && l.Dst === null && l.Lface === null && l.Rface === null);
    }, n1;
}(), P3 = function() {
    function n1() {
        this.handle = null;
    }
    return n1;
}(), _3 = function() {
    function n1() {
        this.key = null, this.node = 0;
    }
    return n1;
}(), zK = function() {
    function n1(t, e) {
        this.leq = e, this.max = 0, this.nodes = [], this.handles = [], this.initialized = !1, this.freeList = 0, this.size = 0, this.max = t, this.nodes = [], this.handles = [];
        for(var r = 0; r < t + 1; r++)this.nodes[r] = new P3, this.handles[r] = new _3;
        this.initialized = !1, this.nodes[1].handle = 1, this.handles[1].key = null;
    }
    return n1.prototype.floatDown_ = function(t) {
        var e = this.nodes, r = this.handles, i, s1, o;
        for(i = e[t].handle;;){
            if (o = t << 1, o < this.size && this.leq(r[e[o + 1].handle].key, r[e[o].handle].key) && ++o, ft(o <= this.max), s1 = e[o].handle, o > this.size || this.leq(r[i].key, r[s1].key)) {
                e[t].handle = i, r[i].node = t;
                break;
            }
            e[t].handle = s1, r[s1].node = t, t = o;
        }
    }, n1.prototype.floatUp_ = function(t) {
        var e = this.nodes, r = this.handles, i, s1, o;
        for(i = e[t].handle;;){
            if (o = t >> 1, s1 = e[o].handle, o === 0 || this.leq(r[s1].key, r[i].key)) {
                e[t].handle = i, r[i].node = t;
                break;
            }
            e[t].handle = s1, r[s1].node = t, t = o;
        }
    }, n1.prototype.init = function() {
        for(var t = this.size; t >= 1; --t)this.floatDown_(t);
        this.initialized = !0;
    }, n1.prototype.min = function() {
        return this.handles[this.nodes[1].handle].key;
    }, n1.prototype.insert = function(t) {
        var e, r;
        if (e = ++this.size, e * 2 > this.max) {
            this.max *= 2;
            var i, s1;
            for(s1 = this.nodes.length, this.nodes.length = this.max + 1, i = s1; i < this.nodes.length; i++)this.nodes[i] = new P3;
            for(s1 = this.handles.length, this.handles.length = this.max + 1, i = s1; i < this.handles.length; i++)this.handles[i] = new _3;
        }
        return this.freeList === 0 ? r = e : (r = this.freeList, this.freeList = this.handles[r].node), this.nodes[e].handle = r, this.handles[r].node = e, this.handles[r].key = t, this.initialized && this.floatUp_(e), r;
    }, n1.prototype.extractMin = function() {
        var t = this.nodes, e = this.handles, r = t[1].handle, i = e[r].key;
        return this.size > 0 && (t[1].handle = t[this.size].handle, e[t[1].handle].node = 1, e[r].key = null, e[r].node = this.freeList, this.freeList = r, --this.size, this.size > 0 && this.floatDown_(1)), i;
    }, n1.prototype.delete = function(t) {
        var e = this.nodes, r = this.handles, i;
        ft(t >= 1 && t <= this.max && r[t].key !== null), i = r[t].node, e[i].handle = e[this.size].handle, r[e[i].handle].node = i, --this.size, i <= this.size && (i <= 1 || this.leq(r[e[i >> 1].handle].key, r[e[i].handle].key) ? this.floatDown_(i) : this.floatUp_(i)), r[t].key = null, r[t].node = this.freeList, this.freeList = t;
    }, n1;
}(), VE = function() {
    function n1() {
        this.eUp = null, this.nodeUp = null, this.windingNumber = 0, this.inside = !1, this.sentinel = !1, this.dirty = !1, this.fixUpperEdge = !1;
    }
    return n1;
}(), I3 = function() {
    function n1() {
        this.key = null, this.next = null, this.prev = null;
    }
    return n1;
}(), GK = function() {
    function n1(t, e) {
        this.frame = t, this.leq = e, this.head = new I3, this.head.next = this.head, this.head.prev = this.head;
    }
    return n1.prototype.min = function() {
        return this.head.next;
    }, n1.prototype.max = function() {
        return this.head.prev;
    }, n1.prototype.insert = function(t) {
        return this.insertBefore(this.head, t);
    }, n1.prototype.search = function(t) {
        var e = this.head;
        do e = e.next;
        while (e.key !== null && !this.leq(this.frame, t, e.key));
        return e;
    }, n1.prototype.insertBefore = function(t, e) {
        do t = t.prev;
        while (t.key !== null && !this.leq(this.frame, t.key, e));
        var r = new I3;
        return r.key = e, r.next = t.next, t.next.prev = r, r.prev = t, t.next = r, r;
    }, n1.prototype.delete = function(t) {
        t.next.prev = t.prev, t.prev.next = t.next;
    }, n1;
}(), jK = function() {
    function n1() {}
    return n1.regionBelow = function(t) {
        return t.nodeUp.prev.key;
    }, n1.regionAbove = function(t) {
        return t.nodeUp.next.key;
    }, n1.debugEvent = function(t) {}, n1.addWinding = function(t, e) {
        t.winding += e.winding, t.Sym.winding += e.Sym.winding;
    }, n1.edgeLeq = function(t, e, r) {
        var i = t.event, s1 = e.eUp, o = r.eUp;
        if (s1.Dst === i) return o.Dst === i ? lt.vertLeq(s1.Org, o.Org) ? lt.edgeSign(o.Dst, s1.Org, o.Org) <= 0 : lt.edgeSign(s1.Dst, o.Org, s1.Org) >= 0 : lt.edgeSign(o.Dst, i, o.Org) <= 0;
        if (o.Dst === i) return lt.edgeSign(s1.Dst, i, s1.Org) >= 0;
        var a = lt.edgeEval(s1.Dst, i, s1.Org), l = lt.edgeEval(o.Dst, i, o.Org);
        return a >= l;
    }, n1.deleteRegion = function(t, e) {
        e.fixUpperEdge && ft(e.eUp.winding === 0), e.eUp.activeRegion = null, t.dict.delete(e.nodeUp);
    }, n1.fixUpperEdge = function(t, e, r) {
        ft(e.fixUpperEdge), t.mesh.delete(e.eUp), e.fixUpperEdge = !1, e.eUp = r, r.activeRegion = e;
    }, n1.topLeftRegion = function(t, e) {
        var r = e.eUp.Org, i;
        do e = n1.regionAbove(e);
        while (e.eUp.Org === r);
        if (e.fixUpperEdge) {
            if (i = t.mesh.connect(n1.regionBelow(e).eUp.Sym, e.eUp.Lnext), i === null) return null;
            n1.fixUpperEdge(t, e, i), e = n1.regionAbove(e);
        }
        return e;
    }, n1.topRightRegion = function(t) {
        var e = t.eUp.Dst;
        do t = n1.regionAbove(t);
        while (t.eUp.Dst === e);
        return t;
    }, n1.addRegionBelow = function(t, e, r) {
        var i = new VE;
        return i.eUp = r, i.nodeUp = t.dict.insertBefore(e.nodeUp, i), i.fixUpperEdge = !1, i.sentinel = !1, i.dirty = !1, r.activeRegion = i, i;
    }, n1.isWindingInside = function(t, e) {
        switch(t.windingRule){
            case qt.ODD:
                return (e & 1) !== 0;
            case qt.NONZERO:
                return e !== 0;
            case qt.POSITIVE:
                return e > 0;
            case qt.NEGATIVE:
                return e < 0;
            case qt.ABS_GEQ_TWO:
                return e >= 2 || e <= -2;
        }
        throw new Error("Invalid winding rulle");
    }, n1.computeWinding = function(t, e) {
        e.windingNumber = n1.regionAbove(e).windingNumber + e.eUp.winding, e.inside = n1.isWindingInside(t, e.windingNumber);
    }, n1.finishRegion = function(t, e) {
        var r = e.eUp, i = r.Lface;
        i.inside = e.inside, i.anEdge = r, n1.deleteRegion(t, e);
    }, n1.finishLeftRegions = function(t, e, r) {
        for(var i, s1 = null, o = e, a = e.eUp; o !== r;){
            if (o.fixUpperEdge = !1, s1 = n1.regionBelow(o), i = s1.eUp, i.Org != a.Org) {
                if (!s1.fixUpperEdge) {
                    n1.finishRegion(t, o);
                    break;
                }
                i = t.mesh.connect(a.Lprev, i.Sym), n1.fixUpperEdge(t, s1, i);
            }
            a.Onext !== i && (t.mesh.splice(i.Oprev, i), t.mesh.splice(a, i)), n1.finishRegion(t, o), a = s1.eUp, o = s1;
        }
        return a;
    }, n1.addRightEdges = function(t, e, r, i, s1, o) {
        var a, l, c, u1, h = !0;
        c = r;
        do ft(lt.vertLeq(c.Org, c.Dst)), n1.addRegionBelow(t, e, c.Sym), c = c.Onext;
        while (c !== i);
        for(s1 === null && (s1 = n1.regionBelow(e).eUp.Rprev), l = e, u1 = s1; a = n1.regionBelow(l), c = a.eUp.Sym, c.Org === u1.Org;)c.Onext !== u1 && (t.mesh.splice(c.Oprev, c), t.mesh.splice(u1.Oprev, c)), a.windingNumber = l.windingNumber - c.winding, a.inside = n1.isWindingInside(t, a.windingNumber), l.dirty = !0, !h && n1.checkForRightSplice(t, l) && (n1.addWinding(c, u1), n1.deleteRegion(t, l), t.mesh.delete(u1)), h = !1, l = a, u1 = c;
        l.dirty = !0, ft(l.windingNumber - c.winding === a.windingNumber), o && n1.walkDirtyRegions(t, l);
    }, n1.spliceMergeVertices = function(t, e, r) {
        t.mesh.splice(e, r);
    }, n1.vertexWeights = function(t, e, r) {
        var i = lt.vertL1dist(e, t), s1 = lt.vertL1dist(r, t), o = .5 * s1 / (i + s1), a = .5 * i / (i + s1);
        t.coords[0] += o * e.coords[0] + a * r.coords[0], t.coords[1] += o * e.coords[1] + a * r.coords[1], t.coords[2] += o * e.coords[2] + a * r.coords[2];
    }, n1.getIntersectData = function(t, e, r, i, s1, o) {
        e.coords[0] = e.coords[1] = e.coords[2] = 0, e.idx = -1, n1.vertexWeights(e, r, i), n1.vertexWeights(e, s1, o);
    }, n1.checkForRightSplice = function(t, e) {
        var r = n1.regionBelow(e), i = e.eUp, s1 = r.eUp;
        if (lt.vertLeq(i.Org, s1.Org)) {
            if (lt.edgeSign(s1.Dst, i.Org, s1.Org) > 0) return !1;
            lt.vertEq(i.Org, s1.Org) ? i.Org !== s1.Org && (t.pq.delete(i.Org.pqHandle), n1.spliceMergeVertices(t, s1.Oprev, i)) : (t.mesh.splitEdge(s1.Sym), t.mesh.splice(i, s1.Oprev), e.dirty = r.dirty = !0);
        } else {
            if (lt.edgeSign(i.Dst, s1.Org, i.Org) < 0) return !1;
            n1.regionAbove(e).dirty = e.dirty = !0, t.mesh.splitEdge(i.Sym), t.mesh.splice(s1.Oprev, i);
        }
        return !0;
    }, n1.checkForLeftSplice = function(t, e) {
        var r = n1.regionBelow(e), i = e.eUp, s1 = r.eUp, o;
        if (ft(!lt.vertEq(i.Dst, s1.Dst)), lt.vertLeq(i.Dst, s1.Dst)) {
            if (lt.edgeSign(i.Dst, s1.Dst, i.Org) < 0) return !1;
            n1.regionAbove(e).dirty = e.dirty = !0, o = t.mesh.splitEdge(i), t.mesh.splice(s1.Sym, o), o.Lface.inside = e.inside;
        } else {
            if (lt.edgeSign(s1.Dst, i.Dst, s1.Org) > 0) return !1;
            e.dirty = r.dirty = !0, o = t.mesh.splitEdge(s1), t.mesh.splice(i.Lnext, s1.Sym), o.Rface.inside = e.inside;
        }
        return !0;
    }, n1.checkForIntersect = function(t, e) {
        var r = n1.regionBelow(e), i = e.eUp, s1 = r.eUp, o = i.Org, a = s1.Org, l = i.Dst, c = s1.Dst, u1, h, d = new Wd, f, m;
        if (ft(!lt.vertEq(c, l)), ft(lt.edgeSign(l, t.event, o) <= 0), ft(lt.edgeSign(c, t.event, a) >= 0), ft(o !== t.event && a !== t.event), ft(!e.fixUpperEdge && !r.fixUpperEdge), o === a || (u1 = Math.min(o.t, l.t), h = Math.max(a.t, c.t), u1 > h)) return !1;
        if (lt.vertLeq(o, a)) {
            if (lt.edgeSign(c, o, a) > 0) return !1;
        } else if (lt.edgeSign(l, a, o) < 0) return !1;
        return n1.debugEvent(t), lt.intersect(l, o, c, a, d), ft(Math.min(o.t, l.t) <= d.t), ft(d.t <= Math.max(a.t, c.t)), ft(Math.min(c.s, l.s) <= d.s), ft(d.s <= Math.max(a.s, o.s)), lt.vertLeq(d, t.event) && (d.s = t.event.s, d.t = t.event.t), f = lt.vertLeq(o, a) ? o : a, lt.vertLeq(f, d) && (d.s = f.s, d.t = f.t), lt.vertEq(d, o) || lt.vertEq(d, a) ? (n1.checkForRightSplice(t, e), !1) : !lt.vertEq(l, t.event) && lt.edgeSign(l, t.event, d) >= 0 || !lt.vertEq(c, t.event) && lt.edgeSign(c, t.event, d) <= 0 ? c === t.event ? (t.mesh.splitEdge(i.Sym), t.mesh.splice(s1.Sym, i), e = n1.topLeftRegion(t, e), i = n1.regionBelow(e).eUp, n1.finishLeftRegions(t, n1.regionBelow(e), r), n1.addRightEdges(t, e, i.Oprev, i, i, !0), !0) : l === t.event ? (t.mesh.splitEdge(s1.Sym), t.mesh.splice(i.Lnext, s1.Oprev), r = e, e = n1.topRightRegion(e), m = n1.regionBelow(e).eUp.Rprev, r.eUp = s1.Oprev, s1 = n1.finishLeftRegions(t, r, null), n1.addRightEdges(t, e, s1.Onext, i.Rprev, m, !0), !0) : (lt.edgeSign(l, t.event, d) >= 0 && (n1.regionAbove(e).dirty = e.dirty = !0, t.mesh.splitEdge(i.Sym), i.Org.s = t.event.s, i.Org.t = t.event.t), lt.edgeSign(c, t.event, d) <= 0 && (e.dirty = r.dirty = !0, t.mesh.splitEdge(s1.Sym), s1.Org.s = t.event.s, s1.Org.t = t.event.t), !1) : (t.mesh.splitEdge(i.Sym), t.mesh.splitEdge(s1.Sym), t.mesh.splice(s1.Oprev, i), i.Org.s = d.s, i.Org.t = d.t, i.Org.pqHandle = t.pq.insert(i.Org), n1.getIntersectData(t, i.Org, o, l, a, c), n1.regionAbove(e).dirty = e.dirty = r.dirty = !0, !1);
    }, n1.walkDirtyRegions = function(t, e) {
        for(var r = n1.regionBelow(e), i, s1;;){
            for(; r.dirty;)e = r, r = n1.regionBelow(r);
            if (!e.dirty && (r = e, e = n1.regionAbove(e), e === null || !e.dirty)) return;
            if (e.dirty = !1, i = e.eUp, s1 = r.eUp, i.Dst !== s1.Dst && n1.checkForLeftSplice(t, e) && (r.fixUpperEdge ? (n1.deleteRegion(t, r), t.mesh.delete(s1), r = n1.regionBelow(e), s1 = r.eUp) : e.fixUpperEdge && (n1.deleteRegion(t, e), t.mesh.delete(i), e = n1.regionAbove(r), i = e.eUp)), i.Org !== s1.Org) {
                if (i.Dst !== s1.Dst && !e.fixUpperEdge && !r.fixUpperEdge && (i.Dst === t.event || s1.Dst === t.event)) {
                    if (n1.checkForIntersect(t, e)) return;
                } else n1.checkForRightSplice(t, e);
            }
            i.Org === s1.Org && i.Dst === s1.Dst && (n1.addWinding(s1, i), n1.deleteRegion(t, e), t.mesh.delete(i), e = n1.regionAbove(r));
        }
    }, n1.connectRightVertex = function(t, e, r) {
        var i, s1 = r.Onext, o = n1.regionBelow(e), a = e.eUp, l = o.eUp, c = !1;
        if (a.Dst !== l.Dst && n1.checkForIntersect(t, e), lt.vertEq(a.Org, t.event) && (t.mesh.splice(s1.Oprev, a), e = n1.topLeftRegion(t, e), s1 = n1.regionBelow(e).eUp, n1.finishLeftRegions(t, n1.regionBelow(e), o), c = !0), lt.vertEq(l.Org, t.event) && (t.mesh.splice(r, l.Oprev), r = n1.finishLeftRegions(t, o, null), c = !0), c) {
            n1.addRightEdges(t, e, r.Onext, s1, s1, !0);
            return;
        }
        lt.vertLeq(l.Org, a.Org) ? i = l.Oprev : i = a, i = t.mesh.connect(r.Lprev, i), n1.addRightEdges(t, e, i, i.Onext, i.Onext, !1), i.Sym.activeRegion.fixUpperEdge = !0, n1.walkDirtyRegions(t, e);
    }, n1.connectLeftDegenerate = function(t, e, r) {
        var i, s1, o, a, l;
        if (i = e.eUp, lt.vertEq(i.Org, r)) {
            ft(!1), n1.spliceMergeVertices(t, i, r.anEdge);
            return;
        }
        if (!lt.vertEq(i.Dst, r)) {
            t.mesh.splitEdge(i.Sym), e.fixUpperEdge && (t.mesh.delete(i.Onext), e.fixUpperEdge = !1), t.mesh.splice(r.anEdge, i), n1.sweepEvent(t, r);
            return;
        }
        ft(!1), e = n1.topRightRegion(e), l = n1.regionBelow(e), o = l.eUp.Sym, s1 = a = o.Onext, l.fixUpperEdge && (ft(s1 !== o), n1.deleteRegion(t, l), t.mesh.delete(o), o = s1.Oprev), t.mesh.splice(r.anEdge, o), lt.edgeGoesLeft(s1) || (s1 = null), n1.addRightEdges(t, e, o.Onext, a, s1, !0);
    }, n1.connectLeftVertex = function(t, e) {
        var r, i, s1, o, a, l, c = new VE;
        if (c.eUp = e.anEdge.Sym, r = t.dict.search(c).key, i = n1.regionBelow(r), !!i) {
            if (o = r.eUp, a = i.eUp, lt.edgeSign(o.Dst, e, o.Org) === 0) {
                n1.connectLeftDegenerate(t, r, e);
                return;
            }
            if (s1 = lt.vertLeq(a.Dst, o.Dst) ? r : i, r.inside || s1.fixUpperEdge) {
                if (s1 === r) l = t.mesh.connect(e.anEdge.Sym, o.Lnext);
                else {
                    var u1 = t.mesh.connect(a.Dnext, e.anEdge);
                    l = u1.Sym;
                }
                s1.fixUpperEdge ? n1.fixUpperEdge(t, s1, l) : n1.computeWinding(t, n1.addRegionBelow(t, r, l)), n1.sweepEvent(t, e);
            } else n1.addRightEdges(t, r, e.anEdge, e.anEdge, null, !0);
        }
    }, n1.sweepEvent = function(t, e) {
        t.event = e, n1.debugEvent(t);
        for(var r = e.anEdge; r.activeRegion === null;)if (r = r.Onext, r === e.anEdge) {
            n1.connectLeftVertex(t, e);
            return;
        }
        var i = n1.topLeftRegion(t, r.activeRegion);
        ft(i !== null);
        var s1 = n1.regionBelow(i), o = s1.eUp, a = n1.finishLeftRegions(t, s1, null);
        a.Onext === o ? n1.connectRightVertex(t, i, a) : n1.addRightEdges(t, i, a.Onext, o, o, !0);
    }, n1.addSentinel = function(t, e, r, i) {
        var s1 = new VE, o = t.mesh.makeEdge();
        o.Org.s = r, o.Org.t = i, o.Dst.s = e, o.Dst.t = i, t.event = o.Dst, s1.eUp = o, s1.windingNumber = 0, s1.inside = !1, s1.fixUpperEdge = !1, s1.sentinel = !0, s1.dirty = !1, s1.nodeUp = t.dict.insert(s1);
    }, n1.initEdgeDict = function(t) {
        t.dict = new GK(t, n1.edgeLeq);
        var e = t.bmax[0] - t.bmin[0], r = t.bmax[1] - t.bmin[1], i = t.bmin[0] - e, s1 = t.bmax[0] + e, o = t.bmin[1] - r, a = t.bmax[1] + r;
        n1.addSentinel(t, i, s1, o), n1.addSentinel(t, i, s1, a);
    }, n1.doneEdgeDict = function(t) {
        for(var e, r = 0; (e = t.dict.min().key) !== null;)e.sentinel || (ft(e.fixUpperEdge), ft(++r === 1)), ft(e.windingNumber === 0), n1.deleteRegion(t, e);
    }, n1.removeDegenerateEdges = function(t) {
        var e, r, i, s1 = t.mesh.eHead;
        for(e = s1.next; e !== s1; e = r)r = e.next, i = e.Lnext, lt.vertEq(e.Org, e.Dst) && e.Lnext.Lnext !== e && (n1.spliceMergeVertices(t, i, e), t.mesh.delete(e), e = i, i = e.Lnext), i.Lnext === e && (i !== e && ((i === r || i === r.Sym) && (r = r.next), t.mesh.delete(i)), (e === r || e === r.Sym) && (r = r.next), t.mesh.delete(e));
    }, n1.initPriorityQ = function(t) {
        var e, r, i, s1 = 0;
        for(i = t.mesh.vHead, r = i.next; r !== i; r = r.next)s1++;
        for(s1 += 8, e = t.pq = new zK(s1, lt.vertLeq), i = t.mesh.vHead, r = i.next; r !== i; r = r.next)r.pqHandle = e.insert(r);
        return r !== i ? !1 : (e.init(), !0);
    }, n1.donePriorityQ = function(t) {
        t.pq = null;
    }, n1.removeDegenerateFaces = function(t, e) {
        var r, i, s1;
        for(r = e.fHead.next; r !== e.fHead; r = i)i = r.next, s1 = r.anEdge, ft(s1.Lnext !== s1), s1.Lnext.Lnext === s1 && (n1.addWinding(s1.Onext, s1), t.mesh.delete(s1));
        return !0;
    }, n1.computeInterior = function(t, e) {
        e === void 0 && (e = !0);
        var r, i;
        if (n1.removeDegenerateEdges(t), !n1.initPriorityQ(t)) return !1;
        for(n1.initEdgeDict(t); (r = t.pq.extractMin()) !== null;){
            for(; i = t.pq.min(), !(i === null || !lt.vertEq(i, r));)i = t.pq.extractMin(), n1.spliceMergeVertices(t, r.anEdge, i.anEdge);
            n1.sweepEvent(t, r);
        }
        return t.event = t.dict.min().key.eUp.Org, n1.debugEvent(t), n1.doneEdgeDict(t), n1.donePriorityQ(t), n1.removeDegenerateFaces(t, t.mesh) ? (e && t.mesh.check(), !0) : !1;
    }, n1;
}(), HK = function() {
    function n1() {
        this.mesh = new C3, this.normal = [
            0,
            0,
            0
        ], this.sUnit = [
            0,
            0,
            0
        ], this.tUnit = [
            0,
            0,
            0
        ], this.bmin = [
            0,
            0
        ], this.bmax = [
            0,
            0
        ], this.windingRule = qt.ODD, this.dict = null, this.pq = null, this.event = null, this.vertexIndexCounter = 0, this.vertices = [], this.vertexIndices = [], this.vertexCount = 0, this.elements = [], this.elementCount = 0;
    }
    return n1.prototype.dot_ = function(t, e) {
        return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
    }, n1.prototype.normalize_ = function(t) {
        var e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2];
        if (!e) throw "Zero-size vector!";
        e = Math.sqrt(e), t[0] /= e, t[1] /= e, t[2] /= e;
    }, n1.prototype.longAxis_ = function(t) {
        var e = 0;
        return Math.abs(t[1]) > Math.abs(t[0]) && (e = 1), Math.abs(t[2]) > Math.abs(t[e]) && (e = 2), e;
    }, n1.prototype.computeNormal_ = function(t) {
        var e, r, i, s1, o, a, l = [
            0,
            0,
            0
        ], c = [
            0,
            0,
            0
        ], u1 = [
            0,
            0,
            0
        ], h = [
            0,
            0,
            0
        ], d = [
            0,
            0,
            0
        ], f = [
            null,
            null,
            null
        ], m = [
            null,
            null,
            null
        ], p = this.mesh.vHead;
        e = p.next;
        for(var g = 0; g < 3; ++g)s1 = e.coords[g], c[g] = s1, m[g] = e, l[g] = s1, f[g] = e;
        for(e = p.next; e !== p; e = e.next)for(var y = 0; y < 3; ++y)s1 = e.coords[y], s1 < c[y] && (c[y] = s1, m[y] = e), s1 > l[y] && (l[y] = s1, f[y] = e);
        var x = 0;
        if (l[1] - c[1] > l[0] - c[0] && (x = 1), l[2] - c[2] > l[x] - c[x] && (x = 2), c[x] >= l[x]) {
            t[0] = 0, t[1] = 0, t[2] = 1;
            return;
        }
        for(a = 0, r = m[x], i = f[x], u1[0] = r.coords[0] - i.coords[0], u1[1] = r.coords[1] - i.coords[1], u1[2] = r.coords[2] - i.coords[2], e = p.next; e !== p; e = e.next)h[0] = e.coords[0] - i.coords[0], h[1] = e.coords[1] - i.coords[1], h[2] = e.coords[2] - i.coords[2], d[0] = u1[1] * h[2] - u1[2] * h[1], d[1] = u1[2] * h[0] - u1[0] * h[2], d[2] = u1[0] * h[1] - u1[1] * h[0], o = d[0] * d[0] + d[1] * d[1] + d[2] * d[2], o > a && (a = o, t[0] = d[0], t[1] = d[1], t[2] = d[2]);
        a <= 0 && (t[0] = t[1] = t[2] = 0, t[this.longAxis_(u1)] = 1);
    }, n1.prototype.checkOrientation_ = function() {
        for(var t = this.mesh.fHead, e, r = this.mesh.vHead, i, s1 = 0, o = t.next; o !== t; o = o.next)if (i = o.anEdge, !(i.winding <= 0)) do s1 += (i.Org.s - i.Dst.s) * (i.Org.t + i.Dst.t), i = i.Lnext;
        while (i !== o.anEdge);
        if (s1 < 0) {
            for(e = r.next; e !== r; e = e.next)e.t = -e.t;
            this.tUnit[0] = -this.tUnit[0], this.tUnit[1] = -this.tUnit[1], this.tUnit[2] = -this.tUnit[2];
        }
    }, n1.prototype.projectPolygon_ = function() {
        var t = this.mesh.vHead, e = [
            0,
            0,
            0
        ], r, i, s1 = !1;
        e[0] = this.normal[0], e[1] = this.normal[1], e[2] = this.normal[2], !e[0] && !e[1] && !e[2] && (this.computeNormal_(e), s1 = !0), r = this.sUnit, i = this.tUnit;
        var o = this.longAxis_(e);
        r[o] = 0, r[(o + 1) % 3] = 1, r[(o + 2) % 3] = 0, i[o] = 0, i[(o + 1) % 3] = 0, i[(o + 2) % 3] = e[o] > 0 ? 1 : -1;
        for(var a = t.next; a !== t; a = a.next)a.s = this.dot_(a.coords, r), a.t = this.dot_(a.coords, i);
        s1 && this.checkOrientation_();
        for(var l = !0, c = t.next; c !== t; c = c.next)l ? (this.bmin[0] = this.bmax[0] = c.s, this.bmin[1] = this.bmax[1] = c.t, l = !1) : (c.s < this.bmin[0] && (this.bmin[0] = c.s), c.s > this.bmax[0] && (this.bmax[0] = c.s), c.t < this.bmin[1] && (this.bmin[1] = c.t), c.t > this.bmax[1] && (this.bmax[1] = c.t));
    }, n1.prototype.addWinding_ = function(t, e) {
        t.winding += e.winding, t.Sym.winding += e.Sym.winding;
    }, n1.prototype.tessellateMonoRegion_ = function(t, e) {
        var r, i;
        if (r = e.anEdge, !(r.Lnext !== r && r.Lnext.Lnext !== r)) throw "Mono region invalid";
        for(; lt.vertLeq(r.Dst, r.Org); r = r.Lprev);
        for(; lt.vertLeq(r.Org, r.Dst); r = r.Lnext);
        i = r.Lprev;
        for(var s1 = void 0; r.Lnext !== i;)if (lt.vertLeq(r.Dst, i.Org)) {
            for(; i.Lnext !== r && (lt.edgeGoesLeft(i.Lnext) || lt.edgeSign(i.Org, i.Dst, i.Lnext.Dst) <= 0);)s1 = t.connect(i.Lnext, i), i = s1.Sym;
            i = i.Lprev;
        } else {
            for(; i.Lnext !== r && (lt.edgeGoesRight(r.Lprev) || lt.edgeSign(r.Dst, r.Org, r.Lprev.Org) >= 0);)s1 = t.connect(r, r.Lprev), r = s1.Sym;
            r = r.Lnext;
        }
        if (i.Lnext === r) throw "Mono region invalid";
        for(; i.Lnext.Lnext !== r;)s1 = t.connect(i.Lnext, i), i = s1.Sym;
        return !0;
    }, n1.prototype.tessellateInterior_ = function(t) {
        for(var e, r = t.fHead.next; r !== t.fHead; r = e)if (e = r.next, r.inside && !this.tessellateMonoRegion_(t, r)) return !1;
        return !0;
    }, n1.prototype.discardExterior_ = function(t) {
        for(var e, r = t.fHead.next; r !== t.fHead; r = e)e = r.next, r.inside || t.zapFace(r);
    }, n1.prototype.setWindingNumber_ = function(t, e, r) {
        for(var i, s1 = t.eHead.next; s1 !== t.eHead; s1 = i)i = s1.next, s1.Rface.inside !== s1.Lface.inside ? s1.winding = s1.Lface.inside ? e : -e : r ? t.delete(s1) : s1.winding = 0;
    }, n1.prototype.getNeighbourFace_ = function(t) {
        return !t.Rface || !t.Rface.inside ? -1 : t.Rface.n;
    }, n1.prototype.outputPolymesh_ = function(t, e, r, i) {
        var s1, o = 0, a = 0, l;
        r > 3 && t.mergeConvexFaces(r);
        for(var c = t.vHead.next; c !== t.vHead; c = c.next)c.n = -1;
        for(var u1 = t.fHead.next; u1 !== t.fHead; u1 = u1.next)if (u1.n = -1, !!u1.inside) {
            s1 = u1.anEdge, l = 0;
            do {
                var c = s1.Org;
                c.n === -1 && (c.n = a, a++), l++, s1 = s1.Lnext;
            }while (s1 !== u1.anEdge);
            if (l > r) throw "Face vertex greater that support polygon";
            u1.n = o, ++o;
        }
        this.elementCount = o, e === Qr.CONNECTED_POLYGONS && (o *= 2), this.elements = [], this.elements.length = o * r, this.vertexCount = a, this.vertices = [], this.vertices.length = a * i, this.vertexIndices = [], this.vertexIndices.length = a;
        for(var c = t.vHead.next; c !== t.vHead; c = c.next)if (c.n !== -1) {
            var h = c.n * i;
            this.vertices[h + 0] = c.coords[0], this.vertices[h + 1] = c.coords[1], i > 2 && (this.vertices[h + 2] = c.coords[2]), this.vertexIndices[c.n] = c.idx;
        }
        for(var d = 0, u1 = t.fHead.next; u1 !== t.fHead; u1 = u1.next)if (!!u1.inside) {
            s1 = u1.anEdge, l = 0;
            do {
                var c = s1.Org;
                this.elements[d++] = c.n, l++, s1 = s1.Lnext;
            }while (s1 !== u1.anEdge);
            for(var f = l; f < r; ++f)this.elements[d++] = -1;
            if (e === Qr.CONNECTED_POLYGONS) {
                s1 = u1.anEdge;
                do this.elements[d++] = this.getNeighbourFace_(s1), s1 = s1.Lnext;
                while (s1 !== u1.anEdge);
                for(var m = l; m < r; ++m)this.elements[d++] = -1;
            }
        }
    }, n1.prototype.outputContours_ = function(t, e) {
        var r, i, s1 = 0, o = 0;
        this.vertexCount = 0, this.elementCount = 0;
        for(var a = t.fHead.next; a !== t.fHead; a = a.next)if (!!a.inside) {
            i = r = a.anEdge;
            do this.vertexCount++, r = r.Lnext;
            while (r !== i);
            this.elementCount++;
        }
        this.elements = [], this.elements.length = this.elementCount * 2, this.vertices = [], this.vertices.length = this.vertexCount * e, this.vertexIndices = [], this.vertexIndices.length = this.vertexCount;
        var l = 0, c = 0, u1 = 0;
        s1 = 0;
        for(var a = t.fHead.next; a !== t.fHead; a = a.next)if (!!a.inside) {
            o = 0, i = r = a.anEdge;
            do this.vertices[l++] = r.Org.coords[0], this.vertices[l++] = r.Org.coords[1], e > 2 && (this.vertices[l++] = r.Org.coords[2]), this.vertexIndices[c++] = this.vertexIdCallback ? this.vertexIdCallback(r) : r.Org.idx, o++, r = r.Lnext;
            while (r !== i);
            this.elements[u1++] = s1, this.elements[u1++] = o, s1 += o;
        }
    }, n1.prototype.addContour = function(t, e) {
        this.mesh === null && (this.mesh = new C3), t < 2 && (t = 2), t > 3 && (t = 3);
        for(var r = null, i = 0; i < e.length; i += t)r === null ? (r = this.mesh.makeEdge(), this.mesh.splice(r, r.Sym)) : (this.mesh.splitEdge(r), r = r.Lnext), r.Org.coords[0] = e[i + 0], r.Org.coords[1] = e[i + 1], t > 2 ? r.Org.coords[2] = e[i + 2] : r.Org.coords[2] = 0, r.Org.idx = this.vertexIndexCounter++, this.edgeCreateCallback && this.edgeCreateCallback(r), r.winding = 1, r.Sym.winding = -1;
    }, n1.prototype.tesselate = function(t, e, r, i, s1, o) {
        if (t === void 0 && (t = qt.ODD), e === void 0 && (e = Qr.POLYGONS), o === void 0 && (o = !0), this.vertices = [], this.elements = [], this.vertexIndices = [], this.vertexIndexCounter = 0, s1 && (this.normal[0] = s1[0], this.normal[1] = s1[1], this.normal[2] = s1[2]), this.windingRule = t, i < 2 && (i = 2), i > 3 && (i = 3), !this.mesh) return !1;
        this.projectPolygon_(), jK.computeInterior(this, o);
        var a = this.mesh;
        return e === Qr.BOUNDARY_CONTOURS ? this.setWindingNumber_(a, 1, !0) : this.tessellateInterior_(a), o && a.check(), e === Qr.BOUNDARY_CONTOURS ? this.outputContours_(a, i) : this.outputPolymesh_(a, e, r, i), !0;
    }, n1;
}();
function io(n1) {
    var t = n1.windingRule, e = t === void 0 ? qt.ODD : t, r = n1.elementType, i = r === void 0 ? Qr.POLYGONS : r, s1 = n1.polySize, o = s1 === void 0 ? 3 : s1, a = n1.vertexSize, l = a === void 0 ? 2 : a, c = n1.normal, u1 = c === void 0 ? [
        0,
        0,
        1
    ] : c, h = n1.contours, d = h === void 0 ? [] : h, f = n1.strict, m = f === void 0 ? !0 : f, p = n1.debug, g = p === void 0 ? !1 : p;
    if (!d && m) throw new Error("Contours can't be empty");
    if (!!d) {
        var y = new HK;
        n1.edgeCreateCallback && (y.edgeCreateCallback = n1.edgeCreateCallback), n1.vertexIdCallback && (y.vertexIdCallback = n1.vertexIdCallback);
        for(var x = 0; x < d.length; x++)y.addContour(l || 2, d[x]);
        return y.tesselate(e, i, o, l, u1, m), {
            vertices: y.vertices,
            vertexIndices: y.vertexIndices,
            vertexCount: y.vertexCount,
            elements: y.elements,
            elementCount: y.elementCount,
            mesh: g ? y.mesh : void 0
        };
    }
}
var ibe = qt.ODD, nbe = qt.NONZERO, sbe = qt.POSITIVE, obe = qt.NEGATIVE, abe = qt.ABS_GEQ_TWO, lbe = Qr.POLYGONS, cbe = Qr.CONNECTED_POLYGONS, ube = Qr.BOUNDARY_CONTOURS;
var bx = class {
    constructor(t = 256, e = !1){
        this.capacity = t, this.size = 0, this.debug = e, this.debug && console.log(`allocating with cap ${t}`);
        let r = t * bx.eSize;
        this.buffer = new ArrayBuffer(r);
        let i = Float32Array.BYTES_PER_ELEMENT, s1 = 0;
        this.positions = new Float32Array(this.buffer, s1 * i, 3 * t), s1 += 3 * t, this.normals = new Float32Array(this.buffer, s1 * i, 3 * t), s1 += 3 * t, this.uvs = new Float32Array(this.buffer, s1 * i, 2 * t);
    }
    realloc(t, e = !1) {
        if (t < this.size) throw Error("cannot shrink buffer");
        if (t <= this.capacity && !e) return;
        this.debug && console.log(`resizing from ${this.capacity} \u2192 ${t}`);
        let r = t * bx.eSize, i = new ArrayBuffer(r), s1 = Float32Array.BYTES_PER_ELEMENT, o = 0, a = new Float32Array(i, o * s1, 3 * t);
        o += 3 * t;
        let l = new Float32Array(i, o * s1, 3 * t);
        o += 3 * t;
        let c = new Float32Array(i, o * s1, 2 * t);
        e ? (a.set(this.positions.subarray(0, this.size * 3)), l.set(this.normals.subarray(0, this.size * 3)), c.set(this.uvs.subarray(0, this.size * 2))) : (a.set(this.positions), l.set(this.normals), c.set(this.uvs)), this.buffer = i, this.positions = a, this.normals = l, this.uvs = c, this.capacity = t;
    }
    get(t = 1) {
        let e = this.size + t;
        if (e > this.capacity) {
            let i = this.capacity;
            for(; e > i;)i *= 2;
            this.realloc(i);
        }
        let r = this.size;
        return this.size = e, r;
    }
    reserve(t) {
        let e = this.size + t;
        e > this.capacity && this.realloc(e);
    }
    shrink() {
        this.debug && console.log(`shrinking ${this.capacity} \u2192 ${this.size}`), this.realloc(this.size, !0);
    }
}, km = bx;
km.eSize = 8 * Float32Array.BYTES_PER_ELEMENT;
var zm = class {
    constructor(t = [], e = (r, i)=>r < i ? -1 : r > i ? 1 : 0){
        if (this.data = t, this.length = this.data.length, this.compare = e, this.length > 0) for(let r = (this.length >> 1) - 1; r >= 0; r--)this._down(r);
    }
    push(t) {
        this.data.push(t), this._up(this.length++);
    }
    pop() {
        if (this.length === 0) return;
        let t = this.data[0], e = this.data.pop();
        return --this.length > 0 && (this.data[0] = e, this._down(0)), t;
    }
    peek() {
        return this.data[0];
    }
    _up(t) {
        let { data: e, compare: r } = this, i = e[t];
        for(; t > 0;){
            let s1 = t - 1 >> 1, o = e[s1];
            if (r(i, o) >= 0) break;
            e[t] = o, t = s1;
        }
        e[t] = i;
    }
    _down(t) {
        let { data: e, compare: r } = this, i = this.length >> 1, s1 = e[t];
        for(; t < i;){
            let o = (t << 1) + 1, a = o + 1;
            if (a < this.length && r(e[a], e[o]) < 0 && (o = a), r(e[o], s1) >= 0) break;
            e[t] = e[o], t = o;
        }
        e[t] = s1;
    }
};
function UE(n1, t, e = 1, r = !1) {
    let i = 1 / 0, s1 = 1 / 0, o = -1 / 0, a = -1 / 0;
    for (let [x, v] of n1[0])x < i && (i = x), v < s1 && (s1 = v), x > o && (o = x), v > a && (a = v);
    let l = o - i, c = a - s1, u1 = Math.max(e, Math.min(l, c));
    if (u1 === e) {
        let x = [
            i,
            s1
        ];
        return x.distance = 0, x.distance;
    }
    let h = new zm([], (x, v)=>v.max - x.max), d = qK(n1), f = new Sx(i + l / 2, s1 + c / 2, 0, n1);
    f.d > d.d && (d = f);
    let m = 2;
    function p(x, v, b) {
        let w = new Sx(x, v, b, n1);
        if (m++, w.max > d.d + e && h.push(w), w.d > d.d && (d = w, r && console.log(`found best ${Math.round(1e4 * w.d) / 1e4} after ${m} probes`), d.d > t)) return t;
    }
    let g = u1 / 2;
    for(let x = i; x < o; x += u1)for(let v = s1; v < a; v += u1)p(x + g, v + g, g);
    for(; h.length;){
        let { max: x, x: v, y: b, h: w } = h.pop();
        if (x - d.d <= e) break;
        g = w / 2, p(v - g, b - g, g), p(v + g, b - g, g), p(v - g, b + g, g), p(v + g, b + g, g);
    }
    r && console.log(`num probes: ${m}
best distance: ${d.d}`);
    let y = [
        d.x,
        d.y
    ];
    return y.distance = d.d, y.distance;
}
function Sx(n1, t, e, r) {
    this.x = n1, this.y = t, this.h = e, this.d = WK(n1, t, r), this.max = this.d + this.h * Math.SQRT2;
}
function WK(n1, t, e) {
    let r = !1, i = 1 / 0;
    for (let s1 of e)for(let o = 0, a = s1.length, l = a - 1; o < a; l = o++){
        let c = s1[o], u1 = s1[l];
        c[1] > t != u1[1] > t && n1 < (u1[0] - c[0]) * (t - c[1]) / (u1[1] - c[1]) + c[0] && (r = !r), i = Math.min(i, XK(n1, t, c, u1));
    }
    return i === 0 ? 0 : (r ? 1 : -1) * Math.sqrt(i);
}
function qK(n1) {
    let t = 0, e = 0, r = 0, i = n1[0];
    for(let o = 0, a = i.length, l = a - 1; o < a; l = o++){
        let c = i[o], u1 = i[l], h = c[0] * u1[1] - u1[0] * c[1];
        e += (c[0] + u1[0]) * h, r += (c[1] + u1[1]) * h, t += h * 3;
    }
    let s1 = new Sx(e / t, r / t, 0, n1);
    return t === 0 || s1.d < 0 ? new Sx(i[0][0], i[0][1], 0, n1) : s1;
}
function XK(n1, t, e, r) {
    let i = e[0], s1 = e[1], o = r[0] - i, a = r[1] - s1;
    if (o !== 0 || a !== 0) {
        let l = ((n1 - i) * o + (t - s1) * a) / (o * o + a * a);
        l > 1 ? (i = r[0], s1 = r[1]) : l > 0 && (i += o * l, s1 += a * l);
    }
    return o = n1 - i, a = t - s1, o * o + a * a;
}
var Gm = {
    vertices: [
        160,
        160,
        -160,
        160,
        -160,
        -160,
        160,
        -160
    ],
    vertexIndices: [
        1,
        0,
        3,
        2
    ],
    vertexCount: 4,
    elements: [
        0,
        4
    ],
    elementCount: 1,
    mesh: void 0
}, zE = {
    vertices: [],
    vertexIndices: [],
    vertexCount: 0,
    elements: [],
    elementCount: 0,
    mesh: void 0
}, GE = {
    vertices: [
        -160,
        160,
        160,
        -160,
        160,
        160,
        -160,
        -160
    ],
    vertexIndices: [
        1,
        3,
        0,
        2
    ],
    vertexCount: 4,
    elements: [
        0,
        1,
        2,
        1,
        0,
        3
    ],
    elementCount: 2,
    mesh: void 0
}, kE = (n1, t)=>([e, r])=>(r < e && (r += t), (n1 >= e ? n1 : n1 + t) <= r), ec = class extends Ce {
    constructor(e, r, i = 0, s1 = 12, o = 3, a = qt.ODD, l = !1){
        super();
        this.forPathBevel = l;
        this.type = "ShapeGeometry";
        this.vertexCache = {};
        this._shape = e, this._depth = r, this._curveSegments = s1, this._bevelSegmentsInput = o;
        let c = this._shape.extractShapePointsToFlatArray([], s1), u1 = this._shape.shapeHoles.map((P)=>{
            let _ = P.extractShapePointsToFlatArray([], s1), I = [];
            for(let O = _.length - 1; O >= 1; O -= 2){
                let L = _[O - 1], j = _[O - 0];
                I.push(L, j);
            }
            return I;
        }), h = [], d = [];
        for(let P = 0; P < c.length; P += 2)d.push([
            c[P],
            c[P + 1]
        ]);
        h.push(d);
        for(let P = 0; P < u1.length; P++){
            let _ = u1[P], I = [];
            for(let O = 0; O < _.length; O += 2)I.push([
                _[O],
                _[O + 1]
            ]);
            h.push(I);
        }
        let f;
        e.isText ? f = new Pl().setFromPoints(e.points.map((_)=>_.position)).getSize(new U).length() * .1 : h[0].length === 0 ? f = i : i > 0 ? f = UE(h, i) : f = 1e-5, i <= 0 ? (this._bevel = 0, this._bevelSegments = 0) : (this._bevel = Math.min(i, f, r / 2), this._bevelSegments = Math.floor(o));
        let m;
        try {
            m = io({
                windingRule: a,
                elementType: Qr.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    c
                ]
            });
        } catch  {
            m = Gm;
        }
        let p;
        try {
            p = io({
                windingRule: qt.ODD,
                elementType: Qr.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    ...u1
                ]
            });
        } catch  {
            p = zE;
        }
        if (!m) throw new Error("error generating geometry");
        let g = m.elementCount;
        if (p) {
            m.elementCount += p.elementCount;
            for(let P = 0; P < p.elements.length; P++){
                let _ = p.elements[P], I = P % 2 === 0 ? m.vertexCount : 0;
                m.elements.push(_ + I);
            }
            for(let P = 0; P < p.vertexIndices.length; P++){
                let _ = p.vertexIndices[P], I = m.vertexCount;
                m.vertexIndices.push(_ + I);
            }
            for(let P = 0; P < p.vertices.length; P++){
                let _ = p.vertices[P];
                m.vertices.push(_);
            }
        }
        let y = 1 / 0, x = -1 / 0, v = 1 / 0, b = -1 / 0;
        for(let P = 0, _ = m.vertexCount; P < _; P++){
            let I = P * 2, O = m.vertices[I + 0], L = m.vertices[I + 1];
            O < y && (y = O), O > x && (x = O), L < v && (v = L), L > b && (b = L);
        }
        this._minX = y, this._minY = v, this._width = x - y, this._height = b - v, this._buffer = new km(this._computeBufferEstimatedSize(m));
        let w = [], A = [];
        for(let P = m.elementCount - 1; P >= 0; P--){
            let _ = P >= g, I = P * 2, O = m.elements[I + 0], L = m.elements[I + 1], j = O + L, V = {
                start: O,
                count: L,
                normals: [],
                continuous: [],
                concave: []
            }, H = O, q = j - 1, X = O + 1, K = this._shape.roundedCurves.length;
            do {
                let W = H - O, oe = m.vertices[q * 2 + 0], ie = m.vertices[q * 2 + 1], re = m.vertices[H * 2 + 0], J = m.vertices[H * 2 + 1], Ee = m.vertices[X * 2 + 0], xe = m.vertices[X * 2 + 1], de = re - oe, De = J - ie, Pe = Math.sqrt(de * de + De * De);
                de /= Pe, De /= Pe;
                let ze = re - Ee, ke = J - xe, Ue = Math.sqrt(ze * ze + ke * ke);
                ze /= Ue, ke /= Ue, V.normals[W * 2 + 0] = -ke, V.normals[W * 2 + 1] = ze, V.concave[W] = de * ke - De * ze > 0;
                let Le = m.vertexIndices[H];
                if (Array.isArray(Le)) V.continuous[W] = !1;
                else {
                    let [Qe, F] = this._shape.getCurveIndexFromVertexId(Le - 1, !0);
                    if (F > 0 && F < 1) V.continuous[W] = !0;
                    else {
                        let B = F === 1 ? Qe + 1 : Qe - 1;
                        B = (B + K) % K;
                        let N = F === 1 ? 0 : 1, ae = this._shape.roundedCurves[Qe].getTangent(F), ye = this._shape.roundedCurves[B].getTangent(N);
                        V.continuous[W] = ae.dot(ye) > .95;
                    }
                }
                _ && (V.normals[W * 2 + 0] *= -1, V.normals[W * 2 + 1] *= -1), [q, H, X] = [
                    H,
                    X,
                    X + 1
                ], X >= j && (X -= L);
            }while (X !== O + 1);
            let z = [];
            z.push({
                bevelI: 0,
                angle: 0,
                size: 0,
                boundary: {
                    vertices: m.vertices.slice(O * 2, j * 2),
                    vertexCount: L,
                    vertexIndices: new Array(L).fill(!0).map((W, oe)=>[
                            oe,
                            oe
                        ]),
                    elements: [
                        0,
                        L
                    ],
                    elementCount: 1,
                    mesh: null
                },
                reverseMap: [],
                insetPoints: m.vertices.slice(O * 2, j * 2)
            });
            let Q = 0;
            for(let W = 1; W <= this._bevelSegments; W++){
                let oe = W / this._bevelSegments * Math.PI / 2, ie = (1 - Math.cos(oe)) * this._bevel, re = [], J = [], Ee = [], xe = [], de = 0;
                for(let Pe = 0; Pe < L; Pe++){
                    let ze = Pe * 2, ke = (Pe - 1 + L) % L * 2, Ue = m.vertices[V.start * 2 + ze + 0], Le = m.vertices[V.start * 2 + ze + 1], Qe = -V.normals[ke + 0] * ie, F = -V.normals[ke + 1] * ie, B = -V.normals[ze + 0] * ie, N = -V.normals[ze + 1] * ie;
                    if (V.concave[Pe] || !V.concave[Pe] && _) {
                        let ae = Math.atan2(F, Qe), ye = Math.atan2(N, B);
                        ye > ae && (ye -= Math.PI * 2);
                        let me = ye - ae;
                        if (V.continuous[Pe] || _) {
                            let Ne = ae + me / 2, Fe = Math.cos(Ne) * ie, Oe = Math.sin(Ne) * ie;
                            re[2 * de + 0] = Ue + Fe * (_ ? -1 : 1), re[2 * de + 1] = Le + Oe * (_ ? -1 : 1), xe[de] = Pe, de++;
                        } else {
                            let Ne = Math.max(1, Math.floor(s1 / 4 * Math.abs(me) / Math.PI));
                            for(let Fe = 0; Fe <= Ne; Fe++){
                                let Oe = ae + me * (Fe / Ne), pe = Math.cos(Oe) * ie, nt = Math.sin(Oe) * ie;
                                re[2 * de + 0] = Ue + pe, re[2 * de + 1] = Le + nt, xe[de] = Pe, de++;
                            }
                        }
                    } else re[2 * de + 0] = Ue + Qe, re[2 * de + 1] = Le + F, xe[de] = Pe, J[Pe] = de, de++, re[2 * de + 0] = Ue, re[2 * de + 1] = Le, xe[de] = Pe, de++, re[2 * de + 0] = Ue + B, re[2 * de + 1] = Le + N, xe[de] = Pe, Ee[Pe] = de, de++;
                }
                let De = io({
                    windingRule: qt.POSITIVE,
                    elementType: Qr.BOUNDARY_CONTOURS,
                    vertexSize: 2,
                    strict: !0,
                    contours: [
                        re
                    ],
                    edgeCreateCallback: (Pe)=>{
                        let ke = Pe.Org.idx, Ue = xe[ke], Le = xe[(ke + 1) % xe.length];
                        Pe.idx = [
                            Ue,
                            Le
                        ], Pe.Sym.idx = [
                            Le,
                            Ue
                        ];
                    },
                    vertexIdCallback: (Pe)=>{
                        let ze = Pe.Lprev.idx;
                        return [
                            ze ? ze[1] : 0,
                            Pe.idx ? Pe.idx[0] : 0
                        ];
                    }
                });
                if (!De) throw console.log("Error"), new Error(`error generating bevel geometry for ${W}'th loop`);
                if (!De.vertexCount) {
                    let Pe = (W - 1) / this._bevelSegments * Math.PI / 2;
                    Q = (1 - Math.sin(Pe)) * this._bevel;
                    break;
                }
                for(let Pe = 0; Pe < De.vertexIndices.length; Pe++){
                    let [ze, ke] = De.vertexIndices[Pe];
                    if (ze === ke) continue;
                    let Ue = ke;
                    ke < ze && (Ue += L);
                    for(let Le = ze; Le < Ue; Le++){
                        let Qe = Le % L, F = (Le + 1) % L;
                        if (!V.continuous[Qe] || !V.continuous[F]) {
                            De.vertexIndices[Pe] = [
                                ze,
                                Qe
                            ], De.vertexIndices.splice(Pe + 1, 0, [
                                F,
                                ke
                            ]), De.vertices.splice((Pe + 1) * 2, 0, De.vertices[Pe * 2], De.vertices[Pe * 2 + 1]);
                            break;
                        }
                    }
                }
                z.push({
                    bevelI: W,
                    angle: oe,
                    size: ie,
                    boundary: De,
                    reverseMap: xe,
                    insetPoints: re
                });
            }
            let te = (W, oe, ie)=>{
                let re = 0, J = W.boundary.vertexIndices.length;
                for(; re < J && ie(W.boundary.vertexIndices[oe]);)oe = (oe + 1) % J, re++;
                return re;
            }, $ = w.length;
            for(let W = 1; W < z.length; W++){
                let oe = z[W - 1], ie = z[W], re = oe.boundary.vertexIndices.length, J = ie.boundary.vertexIndices.length;
                if (!re || !J) break;
                let Ee = V.concave.length, xe = 0, de = kE(xe, L);
                for(; !oe.boundary.vertexIndices.filter(de).length || !ie.boundary.vertexIndices.filter(de).length;)xe++, de = kE(xe, L);
                let De = oe.boundary.vertexIndices.findIndex(de), Pe = ie.boundary.vertexIndices.findIndex(de);
                do De = (De + 1) % re;
                while (de(oe.boundary.vertexIndices[De]));
                do Pe = (Pe + 1) % J;
                while (de(ie.boundary.vertexIndices[Pe]));
                xe = (xe + 1) % L;
                let ze = xe, ke = 0, Ue = this._buildBevelVert(V, oe, (De - 1 + re) % re, void 0, ke), Le = this._buildBevelVert(V, ie, (Pe - 1 + J) % J, void 0, ke), Qe = Ue, F = Le, B, N, ae = !1;
                do {
                    ke = (xe || Ee) / Ee, de = kE(xe, L);
                    let ye = te(oe, De, de), me = te(ie, Pe, de), Ne = ae;
                    if (ae = !1, ye && !me) {
                        for(let Fe = 0; Fe < ye; Fe++)B = this._buildBevelVert(V, oe, (De + Fe) % re, Fe / (ye - 1), ke), w.push(Qe.topN, B.topP, F.topN), l === !1 && w.push(B.bottomP, Qe.bottomN, F.bottomN), Qe = B;
                        ae = !0;
                    } else if (!ye && me) for(let Fe = 0; Fe < me; Fe++)N = this._buildBevelVert(V, ie, (Pe + Fe) % J, Fe / (me - 1), ke), w.push(F.topN, Qe.topP, N.topP), l === !1 && w.push(Qe.bottomP, F.bottomN, N.bottomP), F = N;
                    else if (ye && me) {
                        if (B = this._buildBevelVert(V, oe, De, 0, ke), N = this._buildBevelVert(V, ie, Pe, 0, ke), Ne ? (w.push(Qe.topN, N.topP, F.topN), w.push(Qe.topN, B.topP, N.topP), l === !1 && (w.push(N.bottomP, Qe.bottomN, F.bottomN), w.push(N.bottomP, B.bottomP, Qe.bottomN))) : (w.push(F.topN, Qe.topN, B.topP), w.push(F.topN, B.topP, N.topP), l === !1 && (w.push(B.bottomP, Qe.bottomN, F.bottomN), w.push(B.bottomP, F.bottomN, N.bottomP))), Qe = B, F = N, ye === me) for(let Fe = 1; Fe < ye; Fe++)B = this._buildBevelVert(V, oe, (De + Fe) % re, Fe / (ye - 1), ke), N = this._buildBevelVert(V, ie, (Pe + Fe) % J, Fe / (me - 1), ke), w.push(Qe.topN, B.topP, F.topN), w.push(F.topN, B.topP, N.topP), l === !1 && (w.push(B.bottomP, Qe.bottomN, F.bottomN), w.push(B.bottomP, F.bottomN, N.bottomP)), Qe = B, F = N;
                        else if (ye > me) {
                            let Fe = ye / me, Oe = 0;
                            for(let pe = 1; pe < ye; pe++)B = this._buildBevelVert(V, oe, (De + pe) % re, pe / (ye - 1), ke), w.push(Qe.topN, B.topP, F.topN), l === !1 && w.push(B.bottomP, Qe.bottomN, F.bottomN), Qe = B, pe > (Oe + 1) * Fe && (Oe++, N = this._buildBevelVert(V, ie, (Pe + Oe) % J, Oe / (me - 1), ke), w.push(F.topN, B.topP, N.topP), l === !1 && w.push(B.bottomP, F.bottomN, N.bottomP), F = N);
                        } else {
                            let Fe = me / ye, Oe = 0;
                            for(let pe = 1; pe < me; pe++)N = this._buildBevelVert(V, ie, (Pe + pe) % J, pe / (me - 1), ke), w.push(F.topN, B.topP, N.topP), l === !1 && w.push(B.bottomP, F.bottomN, N.bottomP), F = N, pe > (Oe + 1) * Fe && (Oe++, B = this._buildBevelVert(V, oe, (De + Oe) % re, Oe / (ye - 1), ke), w.push(Qe.topN, B.topP, F.topN), l === !1 && w.push(B.bottomP, Qe.bottomN, F.bottomN), Qe = B);
                        }
                    }
                    De = (De + ye) % re, Pe = (Pe + me) % J, xe = (xe + 1) % Ee;
                }while (xe !== ze);
            }
            if (l === !1 && this._depth > this._bevel * 2 && this._buildWall(z, V, w), _) {
                let W = [];
                for(let oe = w.length - 1; oe >= $ + 2; oe -= 3){
                    let ie = w[oe - 2], re = w[oe - 1], J = w[oe - 0];
                    W.push(J, re, ie);
                }
                w.splice($, w.length - $, ...W);
            }
            if (_) {
                let W = [];
                for(let oe = z[z.length - 1].boundary.vertices.length - 1; oe >= 1; oe -= 2){
                    let ie = z[z.length - 1].boundary.vertices[oe - 1], re = z[z.length - 1].boundary.vertices[oe - 0];
                    W.push(ie, re);
                }
                A.push(W);
            }
            if (!_) {
                let W = z[z.length - 1], oe;
                try {
                    oe = io({
                        windingRule: z.length > 1 ? qt.POSITIVE : qt.ODD,
                        elementType: Qr.POLYGONS,
                        vertexSize: 2,
                        strict: !0,
                        contours: [
                            W.insetPoints,
                            ...A
                        ]
                    });
                } catch  {
                    oe = GE;
                }
                if (!oe) throw new Error("Error generating geometry for surface");
                u1.length === 0 && this._bevel < f && Object.assign(this, {
                    useNgonForTopBottomFaceDuringBake: !0
                });
                for(let ie = 0; ie < oe.elementCount * 3; ie += 3){
                    let re = this._buildSurfaceVert(oe, oe.elements[ie + 0], Q), J = this._buildSurfaceVert(oe, oe.elements[ie + 1], Q), Ee = this._buildSurfaceVert(oe, oe.elements[ie + 2], Q);
                    w.push(re.top, J.top, Ee.top), l === !1 && w.push(Ee.bottom, J.bottom, re.bottom);
                }
            }
            this.vertexCache = {};
        }
        this._buffer.shrink();
        let T = new je(Uint32Array.from(w), 1), S = new je(this._buffer.positions, 3), M = new je(this._buffer.normals, 3), C = new je(this._buffer.uvs, 2);
        S.needsUpdate = !0, M.needsUpdate = !0, C.needsUpdate = !0, T.needsUpdate = !0, this.setAttribute("position", S), this.setAttribute("normal", M), this.setAttribute("uv", C), this.setIndex(T);
    }
    _computeBufferEstimatedSize(e) {
        return e.vertexCount * 2 * (2 + this._bevelSegments);
    }
    _buildWall(e, r, i) {
        let s1 = e[0];
        for(let o = 0, a = s1.boundary.vertexCount; o < a; o++){
            let l = this._buildBevelVert(r, s1, o), c = this._buildBevelVert(r, s1, (o + 1) % a);
            i.push(c.topP, l.topN, l.bottomN), i.push(c.topP, l.bottomN, c.bottomP);
        }
    }
    _buildSurfaceVert(e, r, i) {
        let s1 = r.toString();
        if (s1 in this.vertexCache) return this.vertexCache[s1];
        let o = e.vertices[r * 2 + 0], a = e.vertices[r * 2 + 1], l = (o - this._minX) / this._width, c = (a - this._minY) / this._height;
        this.forPathBevel && (c = 1);
        let u1 = this._buffer.get(this.forPathBevel ? 1 : 2), h = u1 * 3, d = u1 * 2, f = {
            top: u1 + 0,
            bottom: u1 + 1
        };
        return this._buffer.positions[h + 0] = o, this._buffer.positions[h + 1] = a, this._buffer.positions[h + 2] = this.forPathBevel ? this._bevel : this._depth - i, this._buffer.normals[h + 0] = 0, this._buffer.normals[h + 1] = 0, this._buffer.normals[h + 2] = 1, this._buffer.uvs[d + 0] = l, this._buffer.uvs[d + 1] = c, this.forPathBevel === !1 && (this._buffer.positions[h + 3] = o, this._buffer.positions[h + 4] = a, this._buffer.positions[h + 5] = i, this._buffer.normals[h + 3] = 0, this._buffer.normals[h + 4] = 0, this._buffer.normals[h + 5] = -1, this._buffer.uvs[d + 2] = l, this._buffer.uvs[d + 3] = c), this.vertexCache[s1] = f, f;
    }
    _buildBevelVert(e, r, i, s1 = 1, o) {
        let a = `${r.bevelI}:${i}`;
        if (a in this.vertexCache && o !== 0 && o !== 1 && (!o || o === this.vertexCache[a].pathBevelUCoord)) return this.vertexCache[a];
        let [l, c] = r.boundary.vertexIndices[i], u1, h, d, f;
        l !== c ? (h = l, u1 = c, f = !1, d = e.continuous[h] && e.continuous[u1]) : (u1 = l, h = (u1 - 1 + e.count) % e.count, f = e.concave[u1] && r.bevelI > 0, d = e.continuous[u1] || f);
        let m = Math.cos(r.angle), p = Math.sin(r.angle), g = i * 2, y = u1 * 2, x = h * 2, v = r.boundary.vertices[g + 0], b = r.boundary.vertices[g + 1], w = (1 - p) * this._bevel, A = (v - this._minX) / this._width, T = (b - this._minY) / this._height;
        this.forPathBevel && (o !== void 0 && (A = o), T = 1);
        let S = e.normals[y + 0], M = e.normals[y + 1], C = e.normals[x + 0], P = e.normals[x + 1];
        if (f) {
            let j = C - S, V = P - M;
            S = S + j * (1 - s1), M = M + V * (1 - s1);
            let H = Math.sqrt(S * S + M * M);
            S /= H, M /= H;
        }
        let _ = this.forPathBevel ? this._buffer.get(d ? 1 : 2) : this._buffer.get(d ? 2 : 4), I = _ * 3, O = _ * 2, L = {
            i: i,
            fi: u1,
            topP: _ + 0,
            topN: _ + 0,
            bottomP: _ + 1,
            bottomN: _ + 1,
            pathBevelUCoord: o
        };
        return this._buffer.positions[I + 0] = v, this._buffer.positions[I + 1] = b, this._buffer.positions[I + 2] = (this.forPathBevel ? this._bevel : this._depth) - w, this._buffer.normals[I + 0] = S * m, this._buffer.normals[I + 1] = M * m, this._buffer.normals[I + 2] = p, this._buffer.uvs[O + 0] = A, this._buffer.uvs[O + 1] = T, this.forPathBevel === !1 && (this._buffer.positions[I + 3] = v, this._buffer.positions[I + 4] = b, this._buffer.positions[I + 5] = w, this._buffer.normals[I + 3] = S * m, this._buffer.normals[I + 4] = M * m, this._buffer.normals[I + 5] = -p, this._buffer.uvs[O + 2] = T, this._buffer.uvs[O + 3] = A), d || (this.forPathBevel ? (_ += 1, I += 3, O += 2) : (_ += 2, I += 6, O += 4), L.topP = _ + 0, L.bottomP = _ + 1, this._buffer.positions[I + 0] = v, this._buffer.positions[I + 1] = b, this._buffer.positions[I + 2] = (this.forPathBevel ? this._bevel : this._depth) - w, this._buffer.normals[I + 0] = C * m, this._buffer.normals[I + 1] = P * m, this._buffer.normals[I + 2] = p, this._buffer.uvs[O + 0] = A, this._buffer.uvs[O + 1] = T, this.forPathBevel === !1 && (this._buffer.positions[I + 3] = v, this._buffer.positions[I + 4] = b, this._buffer.positions[I + 5] = w, this._buffer.normals[I + 3] = C * m, this._buffer.normals[I + 4] = P * m, this._buffer.normals[I + 5] = -p, this._buffer.uvs[O + 2] = T, this._buffer.uvs[O + 3] = A)), this.vertexCache[a] = L, L;
    }
    clone() {
        let e = new ec(this._shape, this._depth, this._bevel, this._curveSegments, this._bevelSegmentsInput);
        return e.userData = Ra(this.userData), e;
    }
};
var qd = class extends Ce {
    constructor(e, r = 12, i = {}){
        super();
        this.type = "ShapeGeometry";
        this.windingRule = qt.ODD;
        this.elementType = Qr.POLYGONS;
        this.polySize = 3;
        this.vertexSize = 2;
        this.strict = !0;
        this._shape = e, this._curveSegments = r, this._triangulationOptions = Object.assign({
            windingRule: qt.ODD,
            elementType: Qr.POLYGONS,
            polySize: 3,
            vertexSize: 2,
            strict: !0
        }, i);
        let s1 = this._shape.extractShapePointsToFlatArray([], this._curveSegments), o = this._shape.shapeHoles.map((m)=>m.extractShapePointsToFlatArray([], this._curveSegments)), a, l = !0, c = !0, u1, h;
        for(let m = 0, p = s1.length / 2; m < p; m++){
            let g = m * 2, y = s1[g + 0], x = s1[g + 1];
            if (u1 !== void 0 && y !== u1 && (l = !1), h !== void 0 && x !== h && (c = !1), u1 = y, h = x, !l && !c) break;
        }
        if (!l && !c) try {
            a = io({
                contours: [
                    s1,
                    ...o
                ],
                windingRule: this._triangulationOptions.windingRule,
                elementType: this._triangulationOptions.elementType,
                polySize: this._triangulationOptions.polySize,
                vertexSize: this._triangulationOptions.vertexSize,
                strict: this._triangulationOptions.strict
            });
        } catch  {
            a = Gm;
        }
        let d = a?.vertexCount ?? 1, f = a?.elementCount ?? 1;
        if (this._positionAttribute = new je(new Float32Array(d * 3), 3), this._normalAttribute = new je(new Float32Array(d * 3), 3), this._uvAttribute = new je(new Float32Array(d * 2), 2), this._indexAttribute = new je(new Uint32Array(f * 3), 1), a) {
            let m = 1 / 0, p = -1 / 0, g = 1 / 0, y = -1 / 0;
            for(let b = 0, w = d; b < w; b++){
                let A = b * 2, T = a.vertices[A + 0], S = a.vertices[A + 1];
                T < m && (m = T), T > p && (p = T), S < g && (g = S), S > y && (y = S);
            }
            let x = p - m, v = y - g;
            for(let b = 0, w = d; b < w; b++){
                let A = b * 2, T = a.vertices[A + 0], S = a.vertices[A + 1], M = (T - m) / x, C = (S - g) / v;
                this._positionAttribute.setXYZ(b, T, S, 0), this._normalAttribute.setXYZ(b, 0, 0, 1), this._uvAttribute.setXY(b, M, C);
            }
            for(let b = 0, w = f; b < w; b++){
                let A = b * 3, T = a.elements[A + 0], S = a.elements[A + 1], M = a.elements[A + 2];
                this._indexAttribute.setX(A + 0, T), this._indexAttribute.setX(A + 1, S), this._indexAttribute.setX(A + 2, M);
            }
        }
        this.setAttribute("position", this._positionAttribute), this.setAttribute("normal", this._normalAttribute), this.setAttribute("uv", this._uvAttribute), this.setIndex(this._indexAttribute), this.setDrawRange(0, (a?.elementCount ?? 1) * 3);
    }
    clone() {
        let e = new qd(this._shape, this._curveSegments);
        return e.userData = Ra(this.userData), e;
    }
};
var Xd = class extends ec {
    constructor(e, r, i = 0, s1 = 12, o = 3, a = qt.ODD){
        super(e, r, i, s1, o, a);
        this.type = "ShapeGeometry";
    }
    _computeBufferEstimatedSize(e) {
        return e.vertexCount * 2 * (2 + this._bevelSegments);
    }
    _buildWall(e, r, i) {
        let s1 = e[0];
        for(let o = 0, a = s1.boundary.vertexCount; o < a; o++){
            let l = this._buildBevelVert(r, s1, o), c = this._buildBevelVert(r, s1, (o + 1) % a);
            i.push(c.topP, l.topN, l.bottomN), i.push(c.topP, l.bottomN, c.bottomP);
        }
    }
    clone() {
        let e = new Xd(this._shape, this._depth, this._bevel, this._curveSegments, this._bevelSegmentsInput);
        return e.userData = Ra(this.userData), e;
    }
};
var kn = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            subdivisions: 40,
            roundness: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 3,
            windingRule: qt.ODD
        }, n1.parameters), r = Math.abs(e.width), i = Math.abs(e.height ?? e.width), s1 = Math.abs(e.depth ?? 0), o = n1.shape ?? t?.shape, a = o?.roundness ?? e.roundness;
        o !== void 0 && (o instanceof $t ? (o.width !== r || o.height !== i) && o.applySize(r, i) : o = new $t(r, i).fromJSON(o), n1.parameters?.roundness !== void 0 && n1.parameters?.roundness > 0 && o.update());
        let l = o ?? new $t(r, i);
        return {
            parameters: Object.assign(e, {
                width: r,
                height: i,
                depth: s1,
                roundness: a
            }),
            shape: l
        };
    }
    static build(n1) {
        let { depth: t, extrudeBevelSize: e, extrudeBevelSegments: r, subdivisions: i, roundness: s1, windingRule: o } = n1.parameters;
        n1.shape.roundness = s1;
        let a;
        return t <= 0 ? a = new qd(n1.shape, i, {
            windingRule: o
        }) : a = new Xd(n1.shape, t, e, i, r, o), Object.assign(a, {
            userData: {
                ...n1,
                type: "VectorGeometry"
            }
        });
    }
};
var O3 = Math.PI * 2, Kd = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            spikes: 64,
            angle: 360,
            innerRadius: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        }, n1.parameters);
        return e.angle = Se.clamp(e.angle, 0, 360), {
            shape: n1.shape && n1.shape instanceof $t ? n1.shape : new $t,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, spikes: r, angle: i, innerRadius: s1, depth: o, extrudeBevelSize: a, extrudeBevelSegments: l } = n1.parameters, c = n1.shape, u1 = t * .5, h = e * .5, d = YK(c, u1, h, i * Math.PI / 180, r, s1);
        c.isClosed = !0, c.update();
        let f;
        return i === 0 ? (f = new Ce, f.setAttribute("position", new Te([], 3))) : f = kn.create({
            shape: c,
            parameters: {
                subdivisions: d,
                depth: o,
                extrudeBevelSize: a,
                extrudeBevelSegments: l
            }
        }), Object.assign(f, {
            userData: {
                ...n1,
                type: "EllipseGeometry"
            }
        });
    }
};
function YK(n1, t, e, r, i, s1) {
    if (r >= O3) return i > 30 || i % 4 === 0 ? (QK(n1, t, e, s1), Math.round(i / 4)) : D3(n1, r, i, t, e, s1);
    r = Math.max(r, .001);
    let o = {
        x: 0,
        y: e
    }, a = r + Math.PI * .5, l = {
        x: Math.cos(a) * t,
        y: Math.sin(a) * e
    }, c = M3({
        px: o.x,
        py: o.y,
        cx: l.x,
        cy: l.y,
        rx: t,
        ry: e,
        largeArcFlag: r > Math.PI,
        sweepFlag: !0
    });
    return i > 30 || i % c.length === 0 ? KK(n1, o.x, o.y, c, i, t, e, s1) : D3(n1, r, i, t, e, s1);
}
function KK(n1, t, e, r, i, s1, o, a) {
    let l = Math.round(i / r.length);
    n1.addPoint(Yd(t, e));
    for(let c = 0, u1 = r.length; c < u1; c++){
        let h = r[c], d = n1.points[c], f = Yd(h.x, h.y);
        d.controls[1].position.set(h.x1, h.y1), f.controls[0].position.set(h.x2, h.y2), n1.addPoint(f);
    }
    return a > 0 ? R3(n1, s1, o, a) : n1.addPoint(Yd(0, 0)), l;
}
function D3(n1, t, e, r, i, s1) {
    let o = -t / e;
    for(let a = 0; a <= e; a++){
        let l = o * a, c = Math.sin(l) * r, u1 = Math.cos(l) * i;
        n1.addPoint(Yd(c, u1));
    }
    return t < O3 ? s1 > 0 ? R3(n1, r, i, s1) : n1.addPoint(Yd(0, 0)) : (n1.removePoint(n1.points[n1.points.length - 1]), s1 > 0 && L3(n1, r, i, s1)), 1;
}
function QK(n1, t, e, r = 0, i = 0, s1 = 0) {
    let o = .5522847498, a = t * o, l = e * o;
    n1.addPoint(wx(i - t, s1, i - t, s1 - l, i - t, s1 + l)), n1.addPoint(wx(i, s1 + e, i - a, s1 + e, i + a, s1 + e)), n1.addPoint(wx(i + t, s1, i + t, s1 + l, i + t, s1 - l)), n1.addPoint(wx(i, s1 - e, i + a, s1 - e, i - a, s1 - e)), r > 0 && L3(n1, t, e, r);
}
function Yd(n1, t) {
    return new ro(Se.generateUUID(), new U(n1, t));
}
function wx(n1, t, e, r, i, s1) {
    let o = Yd(n1, t);
    return o.controls[0].position.set(e, r), o.controls[1].position.set(i, s1), o;
}
function R3(n1, t, e, r) {
    N3(n1, t, e, r).forEach((s1)=>n1.addPoint(s1));
}
function L3(n1, t, e, r) {
    let i = N3(n1, t, e, r), s1 = new $t;
    i.forEach((o)=>s1.addPoint(o)), s1.isClosed = !0, n1.shapeHoles.push(s1);
}
function N3(n1, t, e, r) {
    let i = r * t / 100, s1 = i * (Math.abs(e) / Math.abs(t)), o = new U(i / t, s1 / e), a = n1.points.map((l)=>{
        let c = l.clone();
        return c.uuid = Se.generateUUID(), c;
    }).reverse();
    return a.forEach((l)=>{
        l.position.multiply(o);
        let c = l.controls[0].position.clone().multiply(o), u1 = l.controls[1].position.clone().multiply(o);
        l.controls[0].position.copy(u1), l.controls[1].position.copy(c);
    }), a;
}
var B3 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            revolutions: 2,
            segments: 40,
            pathRadius: 10,
            pathType: 0,
            pathSegments: 30,
            cornerRadius: 30,
            cornerSegments: 4
        }, n1.parameters), r = Math.abs(e.width), i = Math.abs(e.height ?? r), s1 = Math.abs(e.depth ?? r), o = Math.abs(Math.min(r, s1)) / 2;
        return {
            parameters: Object.assign(e, {
                width: r,
                height: i,
                depth: s1,
                radius: o,
                segments: Math.round(e.segments),
                pathSegments: Math.round(e.pathSegments),
                cornerSegments: Math.round(e.cornerSegments)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, radius: i, revolutions: s1, segments: o, pathRadius: a, pathType: l, pathSegments: c, cornerRadius: u1, cornerSegments: h } = n1.parameters, d = new jm(!1, t, e, r, i, s1, o, a, l, c, u1, h);
        return Object.assign(d, {
            userData: {
                ...n1,
                type: "HelixGeometry"
            }
        });
    }
}, jE = new To([
    0,
    0,
    0
], 1), jm = class extends Ce {
    constructor(t = !0, e = 1, r = 1, i = 1, s1 = 1, o = 1, a = 1, l = 1, c = 1, u1 = 1, h = 1, d = 1){
        if (super(), o === 0) return;
        let f = t && o === 1;
        f && (d = 0), h > 100 && (h = 100), h === 0 && (d = 0);
        let m = ()=>new E, p = new E, g = m(), y = m(), x = m(), v, b, w, A, T, S, M, C, P = m(), _ = m(), I = m(), O = m(), L = m(), j = m(), V = m(), H = m(), q = r - 2 * l + .001, X = q / o, K = Math.ceil(a * o), z = K + 1, Q = q / K, te = -q / 2, $ = u1 + 1, W = 2 * Math.PI / u1, oe = Math.PI / 2 / d, ie = .01, re = Math.min((1 - h / 100) * l, l - ie), J = l - re, Ee = 0, xe = 2, de = d * xe + xe, De = $ * de / xe, Pe = De + $ * z, ze = Math.max(0, $ * (z + de)), [ke, Ue, Le] = [
            3,
            3,
            2
        ].map((We)=>Array(ze * We).fill(0)), Qe = [], F = s1 - l;
        function B(We, Be) {
            let tt = Math.PI / 2;
            S = Be * Q, C = 2 * Math.PI * (S % X) / X + tt, S += te, M = Math.sin(C) * F, T = Math.cos(C) * F, t ? We.set(T, M, S) : We.set(T, S, M);
        }
        B(p, -0.0000000001), B(g, 0), P.copy(p), B(p, 1);
        let N = p.distanceTo(g), ae = f ? 0 : J + re, ye = N * K + 2 * ae, me = re, Ne = ye - ae;
        for(let We = 0; We <= K; We++){
            B(y, We), H.subVectors(y, P).normalize(), P.copy(y), j.copy(y).setComponent(+t + 1, 0).normalize(), V.crossVectors(H, j).normalize();
            let Be = We === 0, tt = We === K, ot = Be ? 3 * Math.PI / 2 : oe, Gt = Be ? me : Ne, xr = Be ? $ : Pe, Ir = Be ? 0 : ze - $, Z = H.clone().multiplyScalar(Be ? -J : J).add(y), ve = H.clone().multiplyScalar(Be ? -1 : 1).normalize();
            for(let Me = 0; Me < $; Me++){
                let qe = Me * W;
                if (_.addVectors(p.copy(j).multiplyScalar(l * Math.cos(qe)), g.copy(V).multiplyScalar(l * Math.sin(qe))), I.copy(_).normalize(), Be || tt) {
                    f || (Ee = Ir + Me, [
                        0,
                        1,
                        2
                    ].forEach((Xe)=>{
                        ke[Ee * 3 + Xe] = Z.getComponent(Xe), Ue[Ee * 3 + Xe] = ve.getComponent(Xe);
                    }), Le[Ee * 2] = +tt, Le[Ee * 2 + 1] = Me / u1), g.copy(I).multiplyScalar(re), x.addVectors(y, g);
                    for(let Xe = 0; Xe < d; Xe++){
                        let Rt = Xe * oe + ot;
                        O.addVectors(p.copy(H).multiplyScalar(J * Math.sin(Rt)), g.copy(I).multiplyScalar(J * Math.cos(Rt))), L.copy(O).normalize(), g.addVectors(x, O), O.normalize(), Ee = xr + Xe * $ + Me, [
                            0,
                            1,
                            2
                        ].forEach((Wr)=>{
                            ke[Ee * 3 + Wr] = g.getComponent(Wr), Ue[Ee * 3 + Wr] = L.getComponent(Wr);
                        });
                        let Hr = +Be + Math.sin(Rt);
                        Le[Ee * 2] = (Gt + J * Hr) / ye, Le[Ee * 2 + 1] = Me / u1;
                    }
                }
                g.addVectors(y, _), Ee = De + We * $ + Me, [
                    0,
                    1,
                    2
                ].forEach((Xe)=>{
                    ke[Ee * 3 + Xe] = g.getComponent(Xe), Ue[Ee * 3 + Xe] = I.getComponent(Xe);
                }), Le[Ee * 2] = (ae + We * N) / ye, Le[Ee * 2 + 1] = Me / u1;
            }
        }
        let Fe = z + 2 * d + xe, Oe = 1, [pe, nt] = [
            +f,
            Fe - 1
        ];
        for(let We = pe; We <= nt - 1; We++){
            let Be = f && We === nt - 1;
            for(let tt = 0; tt < $ - 1; tt++)v = We * $ + tt, b = v + 1, w = (Be ? tt : v) + $, A = (Be ? tt + 1 : b) + $, We === 0 ? Qe.push(b, A, w) : We === Fe - 2 ? Qe.push(v, b, w) : Qe.push(v, b, w, b, A, w);
        }
        this.setIndex(Qe), this.setAttribute("position", new Te(ke, 3)), this.setAttribute("normal", new Te(Ue, 3)), this.setAttribute("uv", new Te(Le, 2));
    }
    getClosedTorusIndicesForBooleanOrSubdiv() {
        let t = this.userData.parameters, e = Math.ceil(t.tubularSegments), r = t.radialSegments + 1, i = Array.from(this.getIndex().array), s1, o, a, l, c = 6 * (e - 1) * t.radialSegments, u1 = e, h = u1 === e;
        for(let d = 0; d < t.radialSegments; d++)s1 = u1 * r + d, o = s1 + 1, a = (h ? d : s1) + r, l = (h ? d + 1 : o) + r, i[c++] = s1, i[c++] = o, i[c++] = a, i[c++] = o, i[c++] = l, i[c++] = a;
        return i.length = c, jE.array = i, jE.count = i.length, jE;
    }
};
var F3 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            detail: 0,
            corner: 0,
            cornerSides: 4
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, detail: i, corner: s1, cornerSides: o } = n1.parameters, a = i === 0 && s1 !== 0 ? new Hm(t * .5, s1, o) : new ch(t * .5, i);
        return a.scale(1, e / t, r / t), Object.assign(a, {
            userData: {
                ...n1,
                type: "IcosahedronGeometry"
            }
        });
    }
}, Hm = class extends Jl {
    constructor(t = 1, e = .2, r = 4){
        let i = (1 + Math.sqrt(5)) / 2, s1 = [
            -1,
            i,
            0,
            1,
            i,
            0,
            -1,
            -i,
            0,
            1,
            -i,
            0,
            0,
            -1,
            i,
            0,
            1,
            i,
            0,
            -1,
            -i,
            0,
            1,
            -i,
            i,
            0,
            -1,
            i,
            0,
            1,
            -i,
            0,
            -1,
            -i,
            0,
            1
        ], o = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ], a = "IcosahedronGeometry";
        super(s1, o, a, t, e, r), this.type = a;
    }
    static fromJSON(t) {
        return new Hm(t.radius, t.corner, t.cornerSides);
    }
};
var V3 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        (n1.parameters?.points ?? []).forEach((r)=>{
            Array.isArray(r) && (r.x = r[0], r.y = r[1]);
        });
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            segments: 64,
            verticalSegments: 64,
            points: [
                {
                    x: 0,
                    y: -50,
                    id: 0
                },
                {
                    x: 50,
                    y: -50,
                    id: 1
                },
                {
                    x: 50,
                    y: 50,
                    id: 2
                },
                {
                    x: 0,
                    y: 50,
                    id: 3
                }
            ]
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { points: t, segments: e, verticalSegments: r } = n1.parameters, i = new Ca;
        i.moveTo(t[0].x, t[0].y), i.bezierCurveTo(t[1].x, t[1].y, t[2].x, t[2].y, t[3].x, t[3].y);
        let s1 = new sh(i.extractPoints(r).shape, e);
        return s1.rotateZ(Math.PI), Object.assign(s1, {
            userData: {
                ...n1,
                type: "LatheGeometry"
            }
        });
    }
};
var Zo = new ue, HE = new Dt, Ax = new E, tc = class extends ar {
    constructor(){
        super(), this.uuid = Se.generateUUID(), this.name = "", this.type = "Geometry", this.vertices = [], this.colors = [], this.faces = [], this.faceVertexUvs = [
            []
        ], this.morphTargets = [], this.morphNormals = [], this.skinWeights = [], this.skinIndices = [], this.lineDistances = [], this.boundingBox = null, this.boundingSphere = null, this.elementsNeedUpdate = !1, this.verticesNeedUpdate = !1, this.uvsNeedUpdate = !1, this.normalsNeedUpdate = !1, this.colorsNeedUpdate = !1, this.lineDistancesNeedUpdate = !1, this.groupsNeedUpdate = !1;
    }
    applyMatrix4(t) {
        let e = new Sr().getNormalMatrix(t);
        for(let r = 0, i = this.vertices.length; r < i; r++)this.vertices[r].applyMatrix4(t);
        for(let r = 0, i = this.faces.length; r < i; r++){
            let s1 = this.faces[r];
            s1.normal.applyMatrix3(e).normalize();
            for(let o = 0, a = s1.vertexNormals.length; o < a; o++)s1.vertexNormals[o].applyMatrix3(e).normalize();
        }
        return this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this.verticesNeedUpdate = !0, this.normalsNeedUpdate = !0, this;
    }
    rotateX(t) {
        return Zo.makeRotationX(t), this.applyMatrix4(Zo), this;
    }
    rotateY(t) {
        return Zo.makeRotationY(t), this.applyMatrix4(Zo), this;
    }
    rotateZ(t) {
        return Zo.makeRotationZ(t), this.applyMatrix4(Zo), this;
    }
    translate(t, e, r) {
        return Zo.makeTranslation(t, e, r), this.applyMatrix4(Zo), this;
    }
    scale(t, e, r) {
        return Zo.makeScale(t, e, r), this.applyMatrix4(Zo), this;
    }
    lookAt(t) {
        return HE.lookAt(t), HE.updateMatrix(), this.applyMatrix4(HE.matrix), this;
    }
    fromBufferGeometry(t) {
        let e = this, r = t.index !== null ? t.index : void 0, i = t.attributes;
        if (i.position === void 0) return console.error("THREE.Geometry.fromBufferGeometry(): Position attribute required for conversion."), this;
        let s1 = i.position, o = i.normal, a = i.color, l = i.uv, c = i.uv2;
        c !== void 0 && (this.faceVertexUvs[1] = []);
        for(let d = 0; d < s1.count; d++)e.vertices.push(new E().fromBufferAttribute(s1, d)), a !== void 0 && e.colors.push(new Ge().fromBufferAttribute(a, d));
        function u1(d, f, m, p) {
            let g = a === void 0 ? [] : [
                e.colors[d].clone(),
                e.colors[f].clone(),
                e.colors[m].clone()
            ], y = o === void 0 ? [] : [
                new E().fromBufferAttribute(o, d),
                new E().fromBufferAttribute(o, f),
                new E().fromBufferAttribute(o, m)
            ], x = new Qd(d, f, m, y, g, p);
            e.faces.push(x), l !== void 0 && e.faceVertexUvs[0].push([
                new U().fromBufferAttribute(l, d),
                new U().fromBufferAttribute(l, f),
                new U().fromBufferAttribute(l, m)
            ]), c !== void 0 && e.faceVertexUvs[1].push([
                new U().fromBufferAttribute(c, d),
                new U().fromBufferAttribute(c, f),
                new U().fromBufferAttribute(c, m)
            ]);
        }
        let h = t.groups;
        if (h.length > 0) for(let d = 0; d < h.length; d++){
            let f = h[d], m = f.start, p = f.count;
            for(let g = m, y = m + p; g < y; g += 3)r !== void 0 ? u1(r.getX(g), r.getX(g + 1), r.getX(g + 2), f.materialIndex) : u1(g, g + 1, g + 2, f.materialIndex);
        }
        else if (r !== void 0) for(let d = 0; d < r.count; d += 3)u1(r.getX(d), r.getX(d + 1), r.getX(d + 2));
        else for(let d = 0; d < s1.count; d += 3)u1(d, d + 1, d + 2);
        return this.computeFaceNormals(), t.boundingBox !== null && (this.boundingBox = t.boundingBox.clone()), t.boundingSphere !== null && (this.boundingSphere = t.boundingSphere.clone()), this;
    }
    center() {
        return this.computeBoundingBox(), this.boundingBox.getCenter(Ax).negate(), this.translate(Ax.x, Ax.y, Ax.z), this;
    }
    normalize() {
        this.computeBoundingSphere();
        let t = this.boundingSphere.center, e = this.boundingSphere.radius, r = e === 0 ? 1 : 1 / e, i = new ue;
        return i.set(r, 0, 0, -r * t.x, 0, r, 0, -r * t.y, 0, 0, r, -r * t.z, 0, 0, 0, 1), this.applyMatrix4(i), this;
    }
    computeFaceNormals() {
        let t = new E, e = new E;
        for(let r = 0, i = this.faces.length; r < i; r++){
            let s1 = this.faces[r], o = this.vertices[s1.a], a = this.vertices[s1.b], l = this.vertices[s1.c];
            t.subVectors(l, a), e.subVectors(o, a), t.cross(e), t.normalize(), s1.normal.copy(t);
        }
    }
    computeVertexNormals(t = !0) {
        let e = new Array(this.vertices.length);
        for(let r = 0, i = this.vertices.length; r < i; r++)e[r] = new E;
        if (t) {
            let r = new E, i = new E;
            for(let s1 = 0, o = this.faces.length; s1 < o; s1++){
                let a = this.faces[s1], l = this.vertices[a.a], c = this.vertices[a.b], u1 = this.vertices[a.c];
                r.subVectors(u1, c), i.subVectors(l, c), r.cross(i), e[a.a].add(r), e[a.b].add(r), e[a.c].add(r);
            }
        } else {
            this.computeFaceNormals();
            for(let r = 0, i = this.faces.length; r < i; r++){
                let s1 = this.faces[r];
                e[s1.a].add(s1.normal), e[s1.b].add(s1.normal), e[s1.c].add(s1.normal);
            }
        }
        for(let r = 0, i = this.vertices.length; r < i; r++)e[r].normalize();
        for(let r = 0, i = this.faces.length; r < i; r++){
            let s1 = this.faces[r], o = s1.vertexNormals;
            o.length === 3 ? (o[0].copy(e[s1.a]), o[1].copy(e[s1.b]), o[2].copy(e[s1.c])) : (o[0] = e[s1.a].clone(), o[1] = e[s1.b].clone(), o[2] = e[s1.c].clone());
        }
        this.faces.length > 0 && (this.normalsNeedUpdate = !0);
    }
    computeFlatVertexNormals() {
        this.computeFaceNormals();
        for(let t = 0, e = this.faces.length; t < e; t++){
            let r = this.faces[t], i = r.vertexNormals;
            i.length === 3 ? (i[0].copy(r.normal), i[1].copy(r.normal), i[2].copy(r.normal)) : (i[0] = r.normal.clone(), i[1] = r.normal.clone(), i[2] = r.normal.clone());
        }
        this.faces.length > 0 && (this.normalsNeedUpdate = !0);
    }
    computeMorphNormals() {
        for(let e = 0, r = this.faces.length; e < r; e++){
            let i = this.faces[e];
            i.__originalFaceNormal ? i.__originalFaceNormal.copy(i.normal) : i.__originalFaceNormal = i.normal.clone(), i.__originalVertexNormals || (i.__originalVertexNormals = []);
            for(let s1 = 0, o = i.vertexNormals.length; s1 < o; s1++)i.__originalVertexNormals[s1] ? i.__originalVertexNormals[s1].copy(i.vertexNormals[s1]) : i.__originalVertexNormals[s1] = i.vertexNormals[s1].clone();
        }
        let t = new tc;
        t.faces = this.faces;
        for(let e = 0, r = this.morphTargets.length; e < r; e++){
            if (!this.morphNormals[e]) {
                this.morphNormals[e] = {}, this.morphNormals[e].faceNormals = [], this.morphNormals[e].vertexNormals = [];
                let s1 = this.morphNormals[e].faceNormals, o = this.morphNormals[e].vertexNormals;
                for(let a = 0, l = this.faces.length; a < l; a++){
                    let c = new E, u1 = {
                        a: new E,
                        b: new E,
                        c: new E
                    };
                    s1.push(c), o.push(u1);
                }
            }
            let i = this.morphNormals[e];
            t.vertices = this.morphTargets[e].vertices, t.computeFaceNormals(), t.computeVertexNormals();
            for(let s1 = 0, o = this.faces.length; s1 < o; s1++){
                let a = this.faces[s1], l = i.faceNormals[s1], c = i.vertexNormals[s1];
                l.copy(a.normal), c.a.copy(a.vertexNormals[0]), c.b.copy(a.vertexNormals[1]), c.c.copy(a.vertexNormals[2]);
            }
        }
        for(let e = 0, r = this.faces.length; e < r; e++){
            let i = this.faces[e];
            i.normal = i.__originalFaceNormal, i.vertexNormals = i.__originalVertexNormals;
        }
    }
    computeBoundingBox() {
        this.boundingBox === null && (this.boundingBox = new Yt), this.boundingBox.setFromPoints(this.vertices);
    }
    computeBoundingSphere() {
        this.boundingSphere === null && (this.boundingSphere = new ei), this.boundingSphere.setFromPoints(this.vertices);
    }
    merge(t, e, r = 0) {
        if (!(t && t.isGeometry)) {
            console.error("THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.", t);
            return;
        }
        let i, s1 = this.vertices.length, o = this.vertices, a = t.vertices, l = this.faces, c = t.faces, u1 = this.colors, h = t.colors;
        e !== void 0 && (i = new Sr().getNormalMatrix(e));
        for(let d = 0, f = a.length; d < f; d++){
            let p = a[d].clone();
            e !== void 0 && p.applyMatrix4(e), o.push(p);
        }
        for(let d = 0, f = h.length; d < f; d++)u1.push(h[d].clone());
        for(let d = 0, f = c.length; d < f; d++){
            let m = c[d], p, g, y = m.vertexNormals, x = m.vertexColors, v = new Qd(m.a + s1, m.b + s1, m.c + s1);
            v.normal.copy(m.normal), i !== void 0 && v.normal.applyMatrix3(i).normalize();
            for(let b = 0, w = y.length; b < w; b++)p = y[b].clone(), i !== void 0 && p.applyMatrix3(i).normalize(), v.vertexNormals.push(p);
            v.color.copy(m.color);
            for(let b = 0, w = x.length; b < w; b++)g = x[b], v.vertexColors.push(g.clone());
            v.materialIndex = m.materialIndex + r, l.push(v);
        }
        for(let d = 0, f = t.faceVertexUvs.length; d < f; d++){
            let m = t.faceVertexUvs[d];
            this.faceVertexUvs[d] === void 0 && (this.faceVertexUvs[d] = []);
            for(let p = 0, g = m.length; p < g; p++){
                let y = m[p], x = [];
                for(let v = 0, b = y.length; v < b; v++)x.push(y[v].clone());
                this.faceVertexUvs[d].push(x);
            }
        }
    }
    mergeMesh(t) {
        if (!(t && t.isMesh)) {
            console.error("THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.", t);
            return;
        }
        t.matrixAutoUpdate && t.updateMatrix(), this.merge(t.geometry, t.matrix);
    }
    mergeVertices(t = 4) {
        let e = {}, r = [], i = [], s1 = Math.pow(10, t);
        for(let l = 0, c = this.vertices.length; l < c; l++){
            let u1 = this.vertices[l], h = Math.round(u1.x * s1) + "_" + Math.round(u1.y * s1) + "_" + Math.round(u1.z * s1);
            e[h] === void 0 ? (e[h] = l, r.push(this.vertices[l]), i[l] = r.length - 1) : i[l] = i[e[h]];
        }
        let o = [];
        for(let l = 0, c = this.faces.length; l < c; l++){
            let u1 = this.faces[l];
            u1.a = i[u1.a], u1.b = i[u1.b], u1.c = i[u1.c];
            let h = [
                u1.a,
                u1.b,
                u1.c
            ];
            for(let d = 0; d < 3; d++)if (h[d] === h[(d + 1) % 3]) {
                o.push(l);
                break;
            }
        }
        for(let l = o.length - 1; l >= 0; l--){
            let c = o[l];
            this.faces.splice(c, 1);
            for(let u1 = 0, h = this.faceVertexUvs.length; u1 < h; u1++)this.faceVertexUvs[u1].splice(c, 1);
        }
        let a = this.vertices.length - r.length;
        return this.vertices = r, a;
    }
    setFromPoints(t) {
        this.vertices = [];
        for(let e = 0, r = t.length; e < r; e++){
            let i = t[e];
            this.vertices.push(new E(i.x, i.y, i.z || 0));
        }
        return this;
    }
    sortFacesByMaterialIndex() {
        let t = this.faces, e = t.length;
        for(let l = 0; l < e; l++)t[l]._id = l;
        function r(l, c) {
            return l.materialIndex - c.materialIndex;
        }
        t.sort(r);
        let i = this.faceVertexUvs[0], s1 = this.faceVertexUvs[1], o, a;
        i && i.length === e && (o = []), s1 && s1.length === e && (a = []);
        for(let l = 0; l < e; l++){
            let c = t[l]._id;
            o && o.push(i[c]), a && a.push(s1[c]);
        }
        o && (this.faceVertexUvs[0] = o), a && (this.faceVertexUvs[1] = a);
    }
    toJSON() {
        let t = {
            metadata: {
                version: 4.5,
                type: "Geometry",
                generator: "Geometry.toJSON"
            }
        };
        if (t.uuid = this.uuid, t.type = this.type, this.name !== "" && (t.name = this.name), this.parameters !== void 0) {
            let m = this.parameters;
            for(let p in m)m[p] !== void 0 && (t[p] = m[p]);
            return t;
        }
        let e = [];
        for(let m = 0; m < this.vertices.length; m++){
            let p = this.vertices[m];
            e.push(p.x, p.y, p.z);
        }
        let r = [], i = [], s1 = {}, o = [], a = {}, l = [], c = {};
        for(let m = 0; m < this.faces.length; m++){
            let p = this.faces[m], g = !0, y = !1, x = this.faceVertexUvs[0][m] !== void 0, v = p.normal.length() > 0, b = p.vertexNormals.length > 0, w = p.color.r !== 1 || p.color.g !== 1 || p.color.b !== 1, A = p.vertexColors.length > 0, T = 0;
            if (T = u1(T, 0, 0), T = u1(T, 1, g), T = u1(T, 2, y), T = u1(T, 3, x), T = u1(T, 4, v), T = u1(T, 5, b), T = u1(T, 6, w), T = u1(T, 7, A), r.push(T), r.push(p.a, p.b, p.c), r.push(p.materialIndex), x) {
                let S = this.faceVertexUvs[0][m];
                r.push(f(S[0]), f(S[1]), f(S[2]));
            }
            if (v && r.push(h(p.normal)), b) {
                let S = p.vertexNormals;
                r.push(h(S[0]), h(S[1]), h(S[2]));
            }
            if (w && r.push(d(p.color)), A) {
                let S = p.vertexColors;
                r.push(d(S[0]), d(S[1]), d(S[2]));
            }
        }
        function u1(m, p, g) {
            return g ? m | 1 << p : m & ~(1 << p);
        }
        function h(m) {
            let p = m.x.toString() + m.y.toString() + m.z.toString();
            return s1[p] !== void 0 || (s1[p] = i.length / 3, i.push(m.x, m.y, m.z)), s1[p];
        }
        function d(m) {
            let p = m.r.toString() + m.g.toString() + m.b.toString();
            return a[p] !== void 0 || (a[p] = o.length, o.push(m.getHex())), a[p];
        }
        function f(m) {
            let p = m.x.toString() + m.y.toString();
            return c[p] !== void 0 || (c[p] = l.length / 2, l.push(m.x, m.y)), c[p];
        }
        return t.data = {}, t.data.vertices = e, t.data.normals = i, o.length > 0 && (t.data.colors = o), l.length > 0 && (t.data.uvs = [
            l
        ]), t.data.faces = r, t;
    }
    clone() {
        return new tc().copy(this);
    }
    copy(t) {
        this.vertices = [], this.colors = [], this.faces = [], this.faceVertexUvs = [
            []
        ], this.morphTargets = [], this.morphNormals = [], this.skinWeights = [], this.skinIndices = [], this.lineDistances = [], this.boundingBox = null, this.boundingSphere = null, this.name = t.name;
        let e = t.vertices;
        for(let d = 0, f = e.length; d < f; d++)this.vertices.push(e[d].clone());
        let r = t.colors;
        for(let d = 0, f = r.length; d < f; d++)this.colors.push(r[d].clone());
        let i = t.faces;
        for(let d = 0, f = i.length; d < f; d++)this.faces.push(i[d].clone());
        for(let d = 0, f = t.faceVertexUvs.length; d < f; d++){
            let m = t.faceVertexUvs[d];
            this.faceVertexUvs[d] === void 0 && (this.faceVertexUvs[d] = []);
            for(let p = 0, g = m.length; p < g; p++){
                let y = m[p], x = [];
                for(let v = 0, b = y.length; v < b; v++){
                    let w = y[v];
                    x.push(w.clone());
                }
                this.faceVertexUvs[d].push(x);
            }
        }
        let s1 = t.morphTargets;
        for(let d = 0, f = s1.length; d < f; d++){
            let m = {};
            if (m.name = s1[d].name, s1[d].vertices !== void 0) {
                m.vertices = [];
                for(let p = 0, g = s1[d].vertices.length; p < g; p++)m.vertices.push(s1[d].vertices[p].clone());
            }
            if (s1[d].normals !== void 0) {
                m.normals = [];
                for(let p = 0, g = s1[d].normals.length; p < g; p++)m.normals.push(s1[d].normals[p].clone());
            }
            this.morphTargets.push(m);
        }
        let o = t.morphNormals;
        for(let d = 0, f = o.length; d < f; d++){
            let m = {};
            if (o[d].vertexNormals !== void 0) {
                m.vertexNormals = [];
                for(let p = 0, g = o[d].vertexNormals.length; p < g; p++){
                    let y = o[d].vertexNormals[p], x = {};
                    x.a = y.a.clone(), x.b = y.b.clone(), x.c = y.c.clone(), m.vertexNormals.push(x);
                }
            }
            if (o[d].faceNormals !== void 0) {
                m.faceNormals = [];
                for(let p = 0, g = o[d].faceNormals.length; p < g; p++)m.faceNormals.push(o[d].faceNormals[p].clone());
            }
            this.morphNormals.push(m);
        }
        let a = t.skinWeights;
        for(let d = 0, f = a.length; d < f; d++)this.skinWeights.push(a[d].clone());
        let l = t.skinIndices;
        for(let d = 0, f = l.length; d < f; d++)this.skinIndices.push(l[d].clone());
        let c = t.lineDistances;
        for(let d = 0, f = c.length; d < f; d++)this.lineDistances.push(c[d]);
        let u1 = t.boundingBox;
        u1 !== null && (this.boundingBox = u1.clone());
        let h = t.boundingSphere;
        return h !== null && (this.boundingSphere = h.clone()), this.elementsNeedUpdate = t.elementsNeedUpdate, this.verticesNeedUpdate = t.verticesNeedUpdate, this.uvsNeedUpdate = t.uvsNeedUpdate, this.normalsNeedUpdate = t.normalsNeedUpdate, this.colorsNeedUpdate = t.colorsNeedUpdate, this.lineDistancesNeedUpdate = t.lineDistancesNeedUpdate, this.groupsNeedUpdate = t.groupsNeedUpdate, this;
    }
    toBufferGeometry() {
        let t = new WE().fromGeometry(this), e = new Ce, r = new Float32Array(t.vertices.length * 3);
        if (e.setAttribute("position", Ex.call(new je(r, 3), t.vertices)), t.normals.length > 0) {
            let i = new Float32Array(t.normals.length * 3);
            e.setAttribute("normal", Ex.call(new je(i, 3), t.normals));
        }
        if (t.colors.length > 0) {
            let i = new Float32Array(t.colors.length * 3);
            e.setAttribute("color", U3.call(new je(i, 3), t.colors));
        }
        if (t.uvs.length > 0) {
            let i = new Float32Array(t.uvs.length * 2);
            e.setAttribute("uv", k3.call(new je(i, 2), t.uvs));
        }
        if (t.uvs2.length > 0) {
            let i = new Float32Array(t.uvs2.length * 2);
            e.setAttribute("uv2", k3.call(new je(i, 2), t.uvs2));
        }
        e.groups = t.groups;
        for(let i in t.morphTargets){
            let s1 = [], o = t.morphTargets[i];
            for(let a = 0, l = o.length; a < l; a++){
                let c = o[a], u1 = new Te(c.data.length * 3, 3);
                u1.name = c.name, s1.push(Ex.call(u1, c.data));
            }
            e.morphAttributes[i] = s1;
        }
        if (t.skinIndices.length > 0) {
            let i = new Te(t.skinIndices.length * 4, 4);
            e.setAttribute("skinIndex", z3.call(i, t.skinIndices));
        }
        if (t.skinWeights.length > 0) {
            let i = new Te(t.skinWeights.length * 4, 4);
            e.setAttribute("skinWeight", z3.call(i, t.skinWeights));
        }
        return t.boundingSphere !== null && (e.boundingSphere = t.boundingSphere.clone()), t.boundingBox !== null && (e.boundingBox = t.boundingBox.clone()), e;
    }
    computeTangents() {
        console.error("THREE.Geometry: .computeTangents() has been removed.");
    }
    computeLineDistances() {
        console.error("THREE.Geometry: .computeLineDistances() has been removed. Use THREE.Line.computeLineDistances() instead.");
    }
    applyMatrix(t) {
        return console.warn("THREE.Geometry: .applyMatrix() has been renamed to .applyMatrix4()."), this.applyMatrix4(t);
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    static createBufferGeometryFromObject(t) {
        let e = new Ce, r = t.geometry;
        if (t.isPoints || t.isLine) {
            let i = new Te(r.vertices.length * 3, 3), s1 = new Te(r.colors.length * 3, 3);
            if (e.setAttribute("position", Ex.call(i, r.vertices)), e.setAttribute("color", U3.call(s1, r.colors)), r.lineDistances && r.lineDistances.length === r.vertices.length) {
                let o = new Te(r.lineDistances.length, 1);
                e.setAttribute("lineDistance", ZK.call(o, r.lineDistances));
            }
            r.boundingSphere !== null && (e.boundingSphere = r.boundingSphere.clone()), r.boundingBox !== null && (e.boundingBox = r.boundingBox.clone());
        } else t.isMesh && (e = r.toBufferGeometry());
        return e;
    }
};
tc.prototype.isGeometry = !0;
var WE = class {
    constructor(){
        this.vertices = [], this.normals = [], this.colors = [], this.uvs = [], this.uvs2 = [], this.groups = [], this.morphTargets = {}, this.skinWeights = [], this.skinIndices = [], this.boundingBox = null, this.boundingSphere = null, this.verticesNeedUpdate = !1, this.normalsNeedUpdate = !1, this.colorsNeedUpdate = !1, this.uvsNeedUpdate = !1, this.groupsNeedUpdate = !1;
    }
    computeGroups(t) {
        let e = [], r, i, s1, o = t.faces;
        for(i = 0; i < o.length; i++){
            let a = o[i];
            a.materialIndex !== s1 && (s1 = a.materialIndex, r !== void 0 && (r.count = i * 3 - r.start, e.push(r)), r = {
                start: i * 3,
                materialIndex: s1
            });
        }
        r !== void 0 && (r.count = i * 3 - r.start, e.push(r)), this.groups = e;
    }
    fromGeometry(t) {
        let e = t.faces, r = t.vertices, i = t.faceVertexUvs, s1 = i[0] && i[0].length > 0, o = i[1] && i[1].length > 0, a = t.morphTargets, l = a.length, c;
        if (l > 0) {
            c = [];
            for(let y = 0; y < l; y++)c[y] = {
                name: a[y].name,
                data: []
            };
            this.morphTargets.position = c;
        }
        let u1 = t.morphNormals, h = u1.length, d;
        if (h > 0) {
            d = [];
            for(let y = 0; y < h; y++)d[y] = {
                name: u1[y].name,
                data: []
            };
            this.morphTargets.normal = d;
        }
        let f = t.skinIndices, m = t.skinWeights, p = f.length === r.length, g = m.length === r.length;
        r.length > 0 && e.length === 0 && console.error("THREE.DirectGeometry: Faceless geometries are not supported.");
        for(let y = 0; y < e.length; y++){
            let x = e[y];
            this.vertices.push(r[x.a], r[x.b], r[x.c]);
            let v = x.vertexNormals;
            if (v.length === 3) this.normals.push(v[0], v[1], v[2]);
            else {
                let w = x.normal;
                this.normals.push(w, w, w);
            }
            let b = x.vertexColors;
            if (b.length === 3) this.colors.push(b[0], b[1], b[2]);
            else {
                let w = x.color;
                this.colors.push(w, w, w);
            }
            if (s1 === !0) {
                let w = i[0][y];
                w !== void 0 ? this.uvs.push(w[0], w[1], w[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ", y), this.uvs.push(new U, new U, new U));
            }
            if (o === !0) {
                let w = i[1][y];
                w !== void 0 ? this.uvs2.push(w[0], w[1], w[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ", y), this.uvs2.push(new U, new U, new U));
            }
            for(let w = 0; w < l; w++){
                let A = a[w].vertices;
                c[w].data.push(A[x.a], A[x.b], A[x.c]);
            }
            for(let w = 0; w < h; w++){
                let A = u1[w].vertexNormals[y];
                d[w].data.push(A.a, A.b, A.c);
            }
            p && this.skinIndices.push(f[x.a], f[x.b], f[x.c]), g && this.skinWeights.push(m[x.a], m[x.b], m[x.c]);
        }
        return this.computeGroups(t), this.verticesNeedUpdate = t.verticesNeedUpdate, this.normalsNeedUpdate = t.normalsNeedUpdate, this.colorsNeedUpdate = t.colorsNeedUpdate, this.uvsNeedUpdate = t.uvsNeedUpdate, this.groupsNeedUpdate = t.groupsNeedUpdate, t.boundingSphere !== null && (this.boundingSphere = t.boundingSphere.clone()), t.boundingBox !== null && (this.boundingBox = t.boundingBox.clone()), this;
    }
}, Qd = class {
    constructor(t, e, r, i, s1, o = 0){
        this.a = t, this.b = e, this.c = r, this.normal = i && i.isVector3 ? i : new E, this.vertexNormals = Array.isArray(i) ? i : [], this.color = s1 && s1.isColor ? s1 : new Ge, this.vertexColors = Array.isArray(s1) ? s1 : [], this.materialIndex = o;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.a = t.a, this.b = t.b, this.c = t.c, this.normal.copy(t.normal), this.color.copy(t.color), this.materialIndex = t.materialIndex;
        for(let e = 0, r = t.vertexNormals.length; e < r; e++)this.vertexNormals[e] = t.vertexNormals[e].clone();
        for(let e = 0, r = t.vertexColors.length; e < r; e++)this.vertexColors[e] = t.vertexColors[e].clone();
        return this;
    }
};
function ZK(n1) {
    return this.array.set(n1), this;
}
function U3(n1) {
    let t = this.array, e = 0;
    for(let r = 0, i = n1.length; r < i; r++){
        let s1 = n1[r];
        s1 === void 0 && (console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", r), s1 = new Ge), t[e++] = s1.r, t[e++] = s1.g, t[e++] = s1.b;
    }
    return this;
}
function k3(n1) {
    let t = this.array, e = 0;
    for(let r = 0, i = n1.length; r < i; r++){
        let s1 = n1[r];
        s1 === void 0 && (console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", r), s1 = new U), t[e++] = s1.x, t[e++] = s1.y;
    }
    return this;
}
function Ex(n1) {
    let t = this.array, e = 0;
    for(let r = 0, i = n1.length; r < i; r++){
        let s1 = n1[r];
        s1 === void 0 && (console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", r), s1 = new E), t[e++] = s1.x, t[e++] = s1.y, t[e++] = s1.z;
    }
    return this;
}
function z3(n1) {
    let t = this.array, e = 0;
    for(let r = 0, i = n1.length; r < i; r++){
        let s1 = n1[r];
        s1 === void 0 && (console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", r), s1 = new Ze), t[e++] = s1.x, t[e++] = s1.y, t[e++] = s1.z, t[e++] = s1.w;
    }
    return this;
}
var JK = [
    "a",
    "b",
    "c"
];
function $K(n1, t) {
    switch(t){
        case "c":
            return n1.c;
        case "b":
            return n1.b;
        case "a":
        default:
            return n1.a;
    }
}
function qE(n1, t, e) {
    let r = Math.min(n1, t), i = Math.max(n1, t), s1 = r + "_" + i;
    return e.get(s1);
}
function XE(n1, t, e, r, i, s1) {
    let o = Math.min(n1, t), a = Math.max(n1, t), l = o + "_" + a, c;
    if (r.has(l)) c = r.get(l);
    else {
        let u1 = e[o], h = e[a];
        c = {
            a: u1,
            b: h,
            newEdge: null,
            faces: []
        }, r.set(l, c);
    }
    c.faces.push(i), s1[n1].edges.push(c), s1[t].edges.push(c);
}
function eQ(n1, t, e, r) {
    let i, s1, o;
    for(i = 0, s1 = n1.length; i < s1; i++)e[i] = {
        edges: []
    };
    for(i = 0, s1 = t.length; i < s1; i++)o = t[i], XE(o.a, o.b, n1, r, o, e), XE(o.b, o.c, n1, r, o, e), XE(o.c, o.a, n1, r, o, e);
}
function Tx(n1, t, e, r, i) {
    n1.push(new Qd(t, e, r, void 0, void 0, i));
}
function Zd(n1, t) {
    return Math.abs(t - n1) / 2 + Math.min(n1, t);
}
function Mx(n1, t, e, r) {
    n1.push([
        t.clone(),
        e.clone(),
        r.clone()
    ]);
}
var Cx = class {
    constructor(t = 1){
        this.subdivisions = t;
    }
    modify(t) {
        t instanceof Ce ? t = new tc().fromBufferGeometry(t) : t = t.clone(), t.mergeVertices();
        let e = this.subdivisions;
        for(; e-- > 0;)this._smooth(t);
        return t.computeFaceNormals(), t.computeVertexNormals(), t;
    }
    _smooth(t) {
        let e = new E, r, i, s1, o, a, l = t.vertices, c = t.faces, u1 = t.faceVertexUvs[0], h = u1 !== void 0 && u1.length > 0, d = [], f = new Map;
        eQ(l, c, d, f);
        let m = [], p, g, y, x, v, b, w;
        for (let ie of Array.from(f.keys())){
            for(g = f.get(ie), y = new E, v = 3 / 8, b = 1 / 8, w = g.faces.length, w != 2 && (v = .5, b = 0, w), y.addVectors(g.a, g.b).multiplyScalar(v), e.set(0, 0, 0), o = 0; o < w; o++){
                for(x = g.faces[o], a = 0; a < 3 && (p = l[$K(x, JK[a])], !(p !== g.a && p !== g.b)); a++);
                p && e.add(p);
            }
            e.multiplyScalar(b), y.add(e), g.newEdge = m.length, m.push(y);
        }
        let A, T, S, M, C, P, _, I = [];
        for(i = 0, s1 = l.length; i < s1; i++){
            for(P = l[i], C = d[i].edges, r = C.length, r == 3 ? A = 3 / 16 : r > 3 && (A = 3 / (8 * r)), T = 1 - r * Number(A), S = A, r <= 2 && (r == 2 ? (T = 3 / 4, S = 1 / 8) : r == 1 || r), _ = P.clone().multiplyScalar(T), e.set(0, 0, 0), o = 0; o < r; o++)M = C[o], p = M.a !== P ? M.a : M.b, e.add(p);
            e.multiplyScalar(Number(S)), _.add(e), I.push(_);
        }
        let O = I.concat(m), L = I.length, j, V, H, q = [], X = [], K, z, Q, te, $ = new U, W = new U, oe = new U;
        for(i = 0, s1 = c.length; i < s1; i++)x = c[i], j = Number(qE(x.a, x.b, f).newEdge) + L, V = Number(qE(x.b, x.c, f).newEdge) + L, H = Number(qE(x.c, x.a, f).newEdge) + L, Tx(q, j, V, H, x.materialIndex), Tx(q, x.a, j, H, x.materialIndex), Tx(q, x.b, V, j, x.materialIndex), Tx(q, x.c, H, V, x.materialIndex), h && (K = u1[i], z = K[0], Q = K[1], te = K[2], $.set(Zd(z.x, Q.x), Zd(z.y, Q.y)), W.set(Zd(Q.x, te.x), Zd(Q.y, te.y)), oe.set(Zd(z.x, te.x), Zd(z.y, te.y)), Mx(X, $, W, oe), Mx(X, z, $, oe), Mx(X, Q, W, $), Mx(X, te, oe, W));
        t.vertices = O, t.faces = q, h && (t.faceVertexUvs[0] = X);
    }
};
var Ni = new E, G3 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = n1.geometry ?? t?.geometry ?? new Ce().copy(new bi(100, 100, 100)), r;
        t === void 0 ? (e.computeBoundingBox(), e.boundingBox.getSize(Ni), r = {
            width: Ni.x,
            height: Ni.y,
            depth: Ni.z,
            subdivisions: 0
        }) : r = t.parameters;
        let i = {
            ...r,
            ...n1.parameters
        };
        return {
            parameters: {
                width: Math.abs(i.width),
                height: Math.abs(i.height),
                depth: Math.abs(i.depth),
                subdivisions: Math.abs(i.subdivisions)
            },
            geometry: e
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, subdivisions: i } = n1.parameters, s1 = n1.geometry ?? new Ce().copy(new bi(100, 100, 100)), o = s1.userData.parameters;
        o === void 0 ? (s1.computeBoundingBox(), s1.boundingBox.getSize(Ni)) : Ni.set(o.width, o.height, o.depth), (t !== Ni.x || e !== Ni.y || r !== Ni.z) && s1.scale(Ni.x === 0 ? 1 : t / Ni.x, Ni.y === 0 ? 1 : e / Ni.y, Ni.z === 0 ? 1 : r / Ni.z);
        let a = s1.originalGeometry;
        try {
            i > 0 ? (a === void 0 || o?.subdivisions !== i) && (a === void 0 && (a = s1), s1 = new Cx(i).modify(a).toBufferGeometry()) : (a !== void 0 && (s1 = a), a = void 0, s1.getAttribute("normal") === void 0 && s1.computeVertexNormals());
        } catch  {
            a !== void 0 && (s1 = a), a = void 0, s1.getAttribute("normal") === void 0 && s1.computeVertexNormals();
        }
        return a !== void 0 && Object.assign(s1, {
            originalGeometry: a
        }), delete n1.geometry, Object.assign(s1, {
            userData: {
                ...n1,
                type: "NonParametricGeometry"
            }
        });
    }
    static loadFromUrl(n1, t, e) {
        new yh(e).load(n1, (i)=>{
            let s1 = this.normalizeInputs({
                geometry: i
            });
            i.boundingBox.getSize(Ni);
            let o = 100 / Ni.x;
            Object.assign(s1.parameters, {
                width: 100,
                height: Ni.y * o,
                depth: Ni.z * o
            }), t(this.build(s1));
        });
    }
};
var Px = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            spikes: 5,
            cornerRadius: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 3
        }, n1.parameters);
        return {
            shape: n1.shape && n1.shape instanceof $t ? n1.shape : new $t,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, spikes: r, cornerRadius: i, depth: s1, extrudeBevelSize: o, extrudeBevelSegments: a } = n1.parameters, l = n1.shape, c = t * .5, u1 = e * .5, h = 0, d = 0, f = 2 * Math.PI / r;
        for(let p = 0; p < r; p++){
            let g = f * p, y = h + Math.sin(g) * c, x = d + Math.cos(g) * u1;
            l.addPoint(l.createPoint(y, x));
        }
        l.isClosed = !0;
        for(let p = 0, g = l.points.length; p < g; p++)l.points[p].roundness = i;
        l.roundness = i, l.update();
        let m = kn.create({
            shape: l,
            parameters: {
                roundness: i,
                depth: s1,
                extrudeBevelSize: o,
                extrudeBevelSegments: a
            }
        });
        return Object.assign(m, {
            userData: {
                ...n1,
                type: "PolygonGeometry"
            }
        });
    }
};
var j3 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 4,
            heightSegments: 1,
            cornerRadius: 0,
            cornerSegments: 8,
            openEnded: !1
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, radialSegments: i, heightSegments: s1, openEnded: o, cornerRadius: a, cornerSegments: l } = n1.parameters, c = new KE(t * .5, e, i, s1, o, a, l);
        return c.scale(1, 1, r / t), Object.assign(c, {
            userData: {
                ...n1,
                type: "PyramidGeometry"
            }
        });
    }
};
function Wm(n1, t, e) {
    e.x = n1.x * t.x, e.y = n1.y, e.z = n1.x * t.y;
}
function YE(n1, t, e, r, i, s1) {
    let o = t.clone().sub(n1), a = e.clone().sub(n1), l = o.angleTo(a);
    if (o.normalize(), a.normalize(), r === i) {
        let c = o.add(a).normalize();
        s1.copy(n1).addScaledVector(c, r / Math.sin(l / 2));
    } else {
        let c = o.angleTo(a);
        s1.copy(n1), s1.addScaledVector(o, i / Math.sin(c)), s1.addScaledVector(a, r / Math.sin(c));
    }
}
function tQ(n1, t, e) {
    let r = n1.clone().sub(t), i = e.clone().sub(t);
    return r.projectOnVector(i), r.add(t);
}
var KE = class extends Ce {
    constructor(t = .5, e = 1, r = 4, i = 1, s1 = !1, o = 0, a = 4){
        super(), r = Math.floor(Math.max(3, r)), i = Math.floor(i), a = Math.floor(a);
        let l = [], c = [], u1 = [], h = [], d = 0, f = e / 2, m = Math.PI / r, p = t * Math.cos(Math.PI / r), g = 2 * Math.PI / r, y = (r - 2) * Math.PI / r, x = Math.PI - y, v = new E(0, -f, 0), b = new E(0, f, 0), w = new U(t, -f), A = new U(p, -f), T = new U(0, b.y).sub(A), S = new U(0, b.y).sub(w), M = new U(T.y, -T.x).normalize(), C = new U(S.y, -S.x).normalize(), _ = t * Math.cos(Math.PI / r) * Math.tan((Math.PI - T.angle()) / 2) - 1e-8;
        o = Math.min(o, _);
        let I;
        {
            let X = new E(M.x, M.y, 0), K = new E(Math.cos(g) * X.x, X.y, Math.sin(g) * X.x);
            I = X.angleTo(K);
        }
        let O = o / Math.tan((Math.PI - T.angle()) / 2), L = o / Math.tan((Math.PI - I) / 2), j = new E;
        if (!s1) {
            c.push(v.x, v.y, v.z), u1.push(0, -1, 0), h.push(0, 0);
            let X = d++, K = [], z = w.clone(), Q = O / Math.cos(Math.PI / r);
            z.x -= Q;
            for(let te = 0; te < r; te++){
                let $ = te / r * Math.PI * 2 + m, W = new U(Math.sin($), Math.cos($));
                Wm(z, W, j), c.push(j.x, j.y, j.z), u1.push(0, -1, 0), h.push(0, 0), K.push(d++);
            }
            for(let te = 0; te < K.length; te++)l.push(K[te], X, K[(te + 1) % K.length]);
        }
        let V = [];
        {
            let X = new E, K = new E, z = new E, Q = new E, te = new E, $ = new E;
            for(let W = 0; W < r; W++){
                let oe = W / r * Math.PI * 2 + m, ie = (W + .5) / r * Math.PI * 2 + m, re = (W + 1) / r * Math.PI * 2 + m, J = new U(Math.sin(oe), Math.cos(oe)), Ee = new U(Math.sin(ie), Math.cos(ie)), xe = new U(Math.sin(re), Math.cos(re));
                Wm(w, J, K), Wm(w, xe, z), Wm(M, Ee, X), YE(b, K, z, L, L, Q), c.push(Q.x, Q.y, Q.z), YE(K, b, z, L, O, te), c.push(te.x, te.y, te.z), YE(z, K, b, O, L, $), c.push($.x, $.y, $.z), u1.push(X.x, X.y, X.z), u1.push(X.x, X.y, X.z), u1.push(X.x, X.y, X.z), h.push(0, 0), h.push(0, 0), h.push(0, 0);
                let de = d++, De = d++, Pe = d++;
                if (l.push(de, De, Pe), o > 0) {
                    {
                        let Ue = K.clone().add(z).multiplyScalar(.5), Le = b.clone().sub(Ue).normalize(), F = v.clone().sub(Ue).normalize().add(Le).normalize().multiplyScalar(-1), B = $.clone().sub(te);
                        H(Ue, B, F, T.angle());
                    }
                    let ze, ke;
                    {
                        let Ue = new E;
                        Wm(C, xe, Ue);
                        let Le = $.clone().add(Q).multiplyScalar(.5);
                        Le = tQ(Le, z, b);
                        let Qe = $.clone().sub(Q);
                        [ze, ke] = H(Le, Qe, Ue, I, Q.y);
                    }
                    {
                        let Ue = ze, Le = Ue.clone().setY(0).normalize(), Qe = new E(0, -1, 0), F = Le.clone().cross(Qe);
                        q(Ue, Le, Qe, F);
                    }
                    V.concat(ke);
                    {
                        let Ue = T.angle(), Le = Math.PI - Ue, Qe = b.clone();
                        Qe.y -= o / Math.sin(Ue - Math.PI / 2);
                        let F = new E, B = [];
                        for(let ae = 0; ae < a; ae++){
                            let ye = [], me = Math.PI / 2 - Le * ae / a, Ne = Math.cos(me), Fe = Math.sin(me), Oe = ie;
                            for(let pe = 0; pe <= ae; pe++){
                                let nt = Math.cos(Oe), We = Math.sin(Oe);
                                X.x = Ne * We, X.y = Fe, X.z = Ne * nt, F.copy(Qe).addScaledVector(X, o), c.push(F.x, F.y, F.z), u1.push(X.x, X.y, X.z), h.push(0, 0), ye.push(d++), Oe += Math.PI * 2 / ae / r;
                            }
                            B.push(ye);
                        }
                        ke.reverse(), B.push(ke);
                        let N = B.length - 1;
                        for(let ae = 0; ae < N; ae++){
                            let ye = B[ae], me = B[ae + 1], Ne = ye.length - 1;
                            l.push(me[1], ye[0], me[0]);
                            for(let Fe = 1; Fe <= Ne; Fe++)l.push(ye[Fe], ye[Fe - 1], me[Fe]), l.push(me[Fe + 1], ye[Fe], me[Fe]);
                        }
                    }
                }
            }
        }
        this.setIndex(l), this.setAttribute("position", new Te(c, 3)), this.setAttribute("normal", new Te(u1, 3)), this.setAttribute("uv", new Te(h, 2));
        function H(X, K, z, Q, te) {
            let $ = -Q / 2, W = (Math.PI - Q) / 2, oe = K.clone().normalize().cross(z);
            X.addScaledVector(z, -o / Math.sin(W));
            let ie = new E, re = new E, J = 1, Ee = d, xe = [];
            for(let de = 0; de <= a; de++){
                let De = $ + de / a * Q;
                re.set(0, 0, 0), re.addScaledVector(oe, Math.sin(De)), re.addScaledVector(z, Math.cos(De));
                for(let Pe = 0; Pe <= J; Pe++){
                    let ze = Pe / J - .5;
                    if (ie.copy(X), ie.addScaledVector(K, ze), ie.addScaledVector(re, o), te != null) {
                        let ke = Math.max(0, ie.y - te);
                        ie.addScaledVector(K, -ke / K.y);
                    }
                    c.push(ie.x, ie.y, ie.z), u1.push(re.x, re.y, re.z), h.push(0, 0), Pe === 0 && xe.push(d), d++;
                }
            }
            for(let de = 0; de < a; de++)for(let De = 0; De < J; De++){
                let Pe = Ee + De + (J + 1) * de, ze = Pe + (J + 1), ke = ze + 1, Ue = Pe + 1;
                l.push(Pe, ze, Ue), l.push(ze, ke, Ue);
            }
            return [
                X.clone().addScaledVector(K, .5),
                xe
            ];
        }
        function q(X, K, z, Q) {
            let te = Math.PI / 2, $ = S.angle() - te, W = [], oe = new E, ie = new E;
            for(let J = 0; J <= a; J++){
                let Ee = [], xe = J / a;
                for(let de = 0; de <= J; de++){
                    let Pe = ((J ? de / J : 0) - .5) * x, ze = Math.cos(Pe), ke = Math.sin(Pe), Ue = Math.atan(Math.tan($) * ze), Le = (te + Ue) * xe, Qe = Math.cos(Le), F = Math.sin(Le);
                    oe.set(0, 0, 0), oe.addScaledVector(K, F * ze), oe.addScaledVector(z, Qe), oe.addScaledVector(Q, F * ke), ie.copy(X).addScaledVector(oe, o), c.push(ie.x, ie.y, ie.z), u1.push(oe.x, oe.y, oe.z), h.push(0, 0), Ee.push(d++);
                }
                W.push(Ee);
            }
            let re = W.length - 1;
            for(let J = 0; J < re; J++){
                let Ee = W[J], xe = W[J + 1], de = Ee.length - 1;
                l.push(Ee[0], xe[1], xe[0]);
                for(let De = 1; De <= de; De++)l.push(Ee[De - 1], Ee[De], xe[De]), l.push(Ee[De], xe[De + 1], xe[De]);
            }
        }
    }
};
var Jd = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            cornerRadius: [
                0,
                0,
                0,
                0
            ],
            cornerType: 1,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        }, n1.parameters), r = Object.assign(t?.ui ?? {
            enabledIndieCorners: !1
        }, n1.ui);
        return {
            shape: n1.shape && n1.shape instanceof $t ? n1.shape : new $t,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            }),
            ui: r
        };
    }
    static build(n1) {
        let t = n1.shape, { width: e, height: r, cornerRadius: i, cornerType: s1, depth: o, extrudeBevelSize: a, extrudeBevelSegments: l } = n1.parameters, c = {
            x: e * .5,
            y: r * .5
        }, u1 = {
            x: -c.x,
            y: -c.y
        }, h = {
            x: c.x,
            y: c.y
        };
        function d(b, w, A) {
            return w > e && A > r ? Math.min(b * e / w, b * r / A) : w > e ? b * e / w : A > r ? b * r / A : b;
        }
        let f = [];
        f[0] = i[0] === 0 ? 0 : d(i[0], i[0] + i[3], i[0] + i[1]), f[1] = i[1] === 0 ? 0 : d(i[1], i[1] + i[2], i[1] + i[0]), f[2] = i[2] === 0 ? 0 : d(i[2], i[2] + i[1], i[2] + i[3]), f[3] = i[3] === 0 ? 0 : d(i[3], i[3] + i[0], i[3] + i[2]);
        let m = u1.x, p = h.x, g = h.y, y = u1.y;
        t.addPoint(t.createPoint(m, g)), t.addPoint(t.createPoint(p, g)), t.addPoint(t.createPoint(p, y)), t.addPoint(t.createPoint(m, y)), t.isClosed = !0;
        let x = !0;
        for(let b = 0, w = t.points.length; b < w; b++)t.points[b].roundness = f[b], b > 0 && f[b] !== f[b - 1] && (x = !1);
        x && (t.roundness = f[0]), t.useCubicForRoundedCorners = s1 !== 1, t.update();
        let v = kn.create({
            shape: t,
            parameters: {
                depth: o,
                extrudeBevelSize: a,
                extrudeBevelSegments: l
            }
        });
        return Object.assign(v, {
            userData: {
                ...n1,
                type: "RectangleGeometry"
            }
        });
    }
};
var H3 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            widthSegments: 64,
            heightSegments: 64,
            phiStart: 0,
            phiLength: 2 * Math.PI,
            thetaStart: 0,
            thetaLength: 180
        }, n1.parameters);
        return e.thetaLength = Se.clamp(e.thetaLength, 0, 180), {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t = 100, height: e = t, depth: r = t, widthSegments: i = 64, heightSegments: s1 = 64, phiStart: o, phiLength: a, thetaStart: l, thetaLength: c } = n1.parameters, u1;
        return c === 0 ? (u1 = new Ce, u1.setAttribute("position", new Te([], 3))) : u1 = new qs(.5 * t, i, s1, o, a, l, c * Se.DEG2RAD), u1.scale(1, e / t, r / t), Object.assign(u1, {
            userData: {
                ...n1,
                type: "SphereGeometry"
            }
        });
    }
};
var W3 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            widthSegments: 8,
            heightSegments: 8
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: 0
            })
        };
    }
    static build(n1) {
        let { width: t = 100, height: e = t, widthSegments: r = 8, heightSegments: i = 8 } = n1.parameters, s1 = new Si(t, e, r, i);
        return s1.scale(1, 1, 1), Object.assign(s1, {
            userData: {
                ...n1,
                type: "PlaneGeometry"
            }
        });
    }
};
var q3 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            angle: 90,
            cornerRadius: 24,
            cornerSegments: 8
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, angle: i, cornerRadius: s1, cornerSegments: o } = n1.parameters, a = new QE(t, e, r, i, s1, o);
        return Object.assign(a, {
            userData: {
                ...n1,
                type: "BackdropGeometry"
            }
        });
    }
}, QE = class extends Ce {
    constructor(t = 1, e = 1, r = 1, i = 90, s1 = 10, o = 24){
        super(), this.type = "BackdropGeometry";
        let a = [], l = [], c = [], u1 = .001;
        s1 == 0 && (o = 1), o = Math.max(1, Math.floor(o)), s1 = Math.min(s1, 100), i = Math.min(180 - u1, i), i *= Math.PI / 180;
        let h = [], d = Math.PI / 2, f = (ie = 0, re = 0, J = 0)=>new E(ie, re, J), m = f(), p = f(), [g, y, x] = [
            e / 2,
            t / 2,
            r / 2
        ], v = -y, b = +y, [w, A, T] = [
            f(v, -g, +x),
            f(v, -g, -x),
            f(v, +g, -x)
        ], S = (ie, re = !1)=>Math.sin(ie - Math.PI / (1 + +re)), M = (ie, re = !1)=>Math.cos(ie - Math.PI / (1 + +re));
        T.y = Math.sin(i) * e - g;
        let C = Math.cos(i) * e - x, P = w.z - u1;
        i <= d ? (T.z = Math.min(C, P), T.z == P && (T.y -= (C - P) / Math.tan(d - i))) : A.z = Math.min(A.z - C - x, w.z - u1), m.subVectors(w, A), p.subVectors(T, A);
        let _ = Math.min(m.length(), p.length()) * s1 / 100, I = _ * Math.tan(i / 2), O = _ / Math.cos(i / 2), L = m.clone().normalize().add(p.normalize()).setLength(O).add(A);
        m.set(0, S(i, !0), M(i, !0)), h.push([
            T,
            m.clone()
        ]);
        let j = (Math.PI - i) / o;
        for(let ie = 0; ie <= o; ie++){
            let re = d + i + ie * j;
            m.set(0, Math.sin(re) * I, Math.cos(re) * I), m.add(L), p.set(0, S(re), M(re)), h.push([
                m.clone(),
                p.clone()
            ]);
        }
        h.push([
            w,
            f(0, 1, 0)
        ]);
        let V = Math.sin(j / 2) * I * 2, H = h.length - 1, q = h[0][0].distanceTo(h[1][0]), X = h[H - 1][0].distanceTo(h[H][0]), K = q + V * o + X;
        h[0].push(1);
        for(let ie = 0; ie <= o; ie++)h[ie + 1].push(1 - (q + ie * V) / K);
        h[H].push(0);
        let [z, Q, te] = h[0], $, W, oe;
        for(let ie = 1; ie < h.length; ie++)[$, W, oe] = h[ie], a.push(v, z.y, z.z, v, $.y, $.z, b, z.y, z.z, b, z.y, z.z, v, $.y, $.z, b, $.y, $.z), l.push(0, Q.y, Q.z, 0, W.y, W.z, 0, Q.y, Q.z, 0, Q.y, Q.z, 0, W.y, W.z, 0, W.y, W.z), c.push(0, te, 0, oe, 1, te, 1, te, 0, oe, 1, oe), [z, Q, te] = [
            $,
            W,
            oe
        ];
        this.setAttribute("position", new Te(a, 3)), this.setAttribute("normal", new Te(l, 3)), this.setAttribute("uv", new Te(c, 2));
    }
};
var _x = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            innerRadiusPercent: 38.19,
            spikes: 5,
            cornerRadius: 0,
            angle: 360,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        }, n1.parameters);
        return {
            shape: n1.shape && n1.shape instanceof $t ? n1.shape : new $t,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, innerRadiusPercent: r, spikes: i, cornerRadius: s1, angle: o, depth: a, extrudeBevelSize: l, extrudeBevelSegments: c } = n1.parameters, u1 = n1.shape, h = t * .5, d = e * .5, f = 0, m = 0, p = o * Math.PI / 360 / i, g = Math.PI / 2 * -3, y = h * r / 100, x = d * r / 100;
        if (i === 3 && r === 50) {
            p = 2 * Math.PI / i;
            for(let b = 0; b < i; b++){
                let w = p * b, A = f + Math.sin(w) * h, T = m + Math.cos(w) * d;
                u1.addPoint(u1.createPoint(A, T));
            }
        } else for(let b = 0; b < i; b++){
            let w = f + Math.cos(g) * h, A = m + Math.sin(g) * d;
            u1.addPoint(u1.createPoint(w, A)), g += p, w = f + Math.cos(g) * y, A = m + Math.sin(g) * x, u1.addPoint(u1.createPoint(w, A)), g += p;
        }
        u1.isClosed = !0;
        for(let b = 0, w = u1.points.length; b < w; b++)u1.points[b].roundness = s1;
        u1.roundness = s1, u1.update();
        let v = kn.create({
            shape: u1,
            parameters: {
                roundness: s1,
                depth: a,
                extrudeBevelSize: l,
                extrudeBevelSegments: c
            }
        });
        return Object.assign(v, {
            userData: {
                ...n1,
                type: "StarGeometry"
            }
        });
    }
};
var X3 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(n1) {
        let { width: t, height: e } = n1.parameters, r = new Si(t, e);
        return Object.assign(r, {
            userData: {
                ...n1,
                type: "TextFrameGeometry"
            }
        });
    }
};
var Y3 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 32,
            tubularSegments: 64,
            arc: 360,
            cornerRadius: 30,
            cornerSegments: 8
        }, n1.parameters), r = Math.abs(e.width), i = Math.abs(e.height ?? e.width);
        e.shapeBlendNode && (i = r);
        let s1 = Math.round(Math.abs(e.depth ?? e.width * .25));
        return {
            parameters: Object.assign(e, {
                width: r,
                height: i,
                depth: s1
            })
        };
    }
    static build(n1) {
        let { width: t, height: e, depth: r, radialSegments: i, tubularSegments: s1, arc: o, cornerRadius: a, cornerSegments: l } = n1.parameters, c = rQ(t, e, r, t * .5, o, s1, 0, 0, i, a, l);
        return c.scale(1, e / t, 1), Object.assign(c, {
            userData: {
                ...n1,
                type: "TorusGeometry"
            }
        });
    }
};
function rQ(n1, t, e, r, i, s1, o, a, l, c, u1) {
    [t, e] = [
        e,
        t
    ], o = t / 2;
    let h = Se.clamp(i / 360, 0, 1);
    if (h === 0) {
        let d = new Ce;
        return d.setAttribute("position", new Te([], 3)), d;
    }
    return h === 1 && (c = 0), new jm(!0, n1, t, e, r, h, s1, o, a, l, c, u1);
}
var K3 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            tubularSegments: 64,
            radialSegments: 32,
            p: 2,
            q: 3
        }, n1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width),
                tube: e.tube ?? e.width * .125
            })
        };
    }
    static build(n1) {
        let { width: t, tube: e, tubularSegments: r, radialSegments: i, p: s1, q: o } = n1.parameters, a = t * .5;
        a !== e && (a -= e);
        let l = new hh(a, e, r, i, s1, o);
        return Object.assign(l, {
            userData: {
                ...n1,
                type: "TorusKnotGeometry"
            }
        });
    }
};
var Q3 = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            spikes: 5,
            cornerRadius: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1,
            isRect: !1
        }, n1.parameters);
        return {
            shape: n1.shape && n1.shape instanceof $t ? n1.shape : new $t,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width * (e.isRect ? 1 : Math.sqrt(3) / 2)),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(n1) {
        let { width: t = 100, height: e, cornerRadius: r, depth: i, extrudeBevelSize: s1, extrudeBevelSegments: o, isRect: a } = n1.parameters, l = n1.shape, c = t * .5, u1 = e * .5;
        a ? (l.addPoint(l.createPoint(-c, u1)), l.addPoint(l.createPoint(c, -u1)), l.addPoint(l.createPoint(-c, -u1))) : (l.addPoint(l.createPoint(0, u1)), l.addPoint(l.createPoint(c, -u1)), l.addPoint(l.createPoint(-c, -u1))), l.isClosed = !0;
        for(let d = 0, f = l.points.length; d < f; d++)l.points[d].roundness = r;
        l.roundness = r, l.update();
        let h = kn.create({
            shape: l,
            parameters: {
                roundness: r,
                depth: i,
                extrudeBevelSize: s1,
                extrudeBevelSegments: o
            }
        });
        return Object.assign(h, {
            userData: {
                ...n1,
                type: "TriangleGeometry"
            }
        });
    }
};
function Z3(n1, t) {
    let e = 2 * Math.PI;
    return (n1 % e + e) % e === (t % e + e) % e;
}
function iQ(n1) {
    return /^(rgba)?\(\s*(\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\s*\)$/.exec(n1.toLowerCase());
}
function nQ(n1, t, e) {
    let r, i, s1, o = Math.floor(n1 * 6), a = n1 * 6 - o, l = e * (1 - t), c = e * (1 - a * t), u1 = e * (1 - (1 - a) * t);
    switch(o % 6){
        case 0:
            r = e, i = u1, s1 = l;
            break;
        case 1:
            r = c, i = e, s1 = l;
            break;
        case 2:
            r = l, i = e, s1 = u1;
            break;
        case 3:
            r = l, i = c, s1 = e;
            break;
        case 4:
            r = u1, i = l, s1 = e;
            break;
        case 5:
        default:
            r = e, i = l, s1 = c;
            break;
    }
    return {
        r: r * 255,
        g: i * 255,
        b: s1 * 255
    };
}
function sQ(n1, t, e) {
    n1 /= 255, t /= 255, e /= 255;
    let r = Math.max(n1, t, e), i = Math.min(n1, t, e), s1 = r, o = r - i, a = r == 0 ? 0 : o / r, l;
    if (r == i) l = 0;
    else {
        switch(r){
            case n1:
                l = (t - e) / o + (t < e ? 6 : 0);
                break;
            case t:
                l = (e - n1) / o + 2;
                break;
            case e:
            default:
                l = (n1 - t) / o + 4;
                break;
        }
        l /= 6;
    }
    return {
        h: l,
        s: a,
        v: s1
    };
}
function oQ(n1) {
    return n1 = Math.floor(n1), {
        r: n1 >> 16 & 255,
        g: n1 >> 8 & 255,
        b: n1 & 255
    };
}
function aQ(n1, t, e) {
    return (n1 << 16) + (t << 8) + e;
}
function lQ(n1, t, e) {
    return n1 = Math.round(n1), t = Math.round(t), e = Math.round(e), "#" + [
        n1,
        t,
        e
    ].map((r)=>r.toString(16).padStart(2, "0")).join("").toUpperCase();
}
function cQ(n1) {
    let t = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    n1 = n1.replace(t, (r, i, s1, o)=>String(i + i + s1 + s1 + o + o));
    let e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(n1);
    return e ? {
        r: parseInt(e[1], 16),
        g: parseInt(e[2], 16),
        b: parseInt(e[3], 16)
    } : null;
}
var J3 = {
    parseRgba: iQ,
    hsvToRgb: nQ,
    rgbToHsv: sQ,
    hexToRgb: oQ,
    rgbToHex: aQ,
    rgbToHexString: lQ,
    hexStringToRgb: cQ
};
var ZE = class {
    add(t, e, r) {
        if (typeof arguments[0] != "string") for(let i in arguments[0])this.add(i, arguments[0][i], arguments[1]);
        else (Array.isArray(t) ? t : [
            t
        ]).forEach(function(i) {
            this[i] = this[i] || [], e && this[i][r ? "unshift" : "push"](e);
        }, this);
    }
    run(t, e) {
        this[t] = this[t] || [], this[t].forEach(function(r) {
            r.call(e && e.context ? e.context : e, e);
        });
    }
}, JE = class {
    constructor(t){
        this.jsep = t, this.registered = {};
    }
    register(...t) {
        t.forEach((e)=>{
            if (typeof e != "object" || !e.name || !e.init) throw new Error("Invalid JSEP plugin format");
            this.registered[e.name] || (e.init(this.jsep), this.registered[e.name] = e);
        });
    }
}, fe = class {
    static get version() {
        return "1.3.8";
    }
    static toString() {
        return "JavaScript Expression Parser (JSEP) v" + fe.version;
    }
    static addUnaryOp(t) {
        return fe.max_unop_len = Math.max(t.length, fe.max_unop_len), fe.unary_ops[t] = 1, fe;
    }
    static addBinaryOp(t, e, r) {
        return fe.max_binop_len = Math.max(t.length, fe.max_binop_len), fe.binary_ops[t] = e, r ? fe.right_associative.add(t) : fe.right_associative.delete(t), fe;
    }
    static addIdentifierChar(t) {
        return fe.additional_identifier_chars.add(t), fe;
    }
    static addLiteral(t, e) {
        return fe.literals[t] = e, fe;
    }
    static removeUnaryOp(t) {
        return delete fe.unary_ops[t], t.length === fe.max_unop_len && (fe.max_unop_len = fe.getMaxKeyLen(fe.unary_ops)), fe;
    }
    static removeAllUnaryOps() {
        return fe.unary_ops = {}, fe.max_unop_len = 0, fe;
    }
    static removeIdentifierChar(t) {
        return fe.additional_identifier_chars.delete(t), fe;
    }
    static removeBinaryOp(t) {
        return delete fe.binary_ops[t], t.length === fe.max_binop_len && (fe.max_binop_len = fe.getMaxKeyLen(fe.binary_ops)), fe.right_associative.delete(t), fe;
    }
    static removeAllBinaryOps() {
        return fe.binary_ops = {}, fe.max_binop_len = 0, fe;
    }
    static removeLiteral(t) {
        return delete fe.literals[t], fe;
    }
    static removeAllLiterals() {
        return fe.literals = {}, fe;
    }
    get char() {
        return this.expr.charAt(this.index);
    }
    get code() {
        return this.expr.charCodeAt(this.index);
    }
    constructor(t){
        this.expr = t, this.index = 0;
    }
    static parse(t) {
        return new fe(t).parse();
    }
    static getMaxKeyLen(t) {
        return Math.max(0, ...Object.keys(t).map((e)=>e.length));
    }
    static isDecimalDigit(t) {
        return t >= 48 && t <= 57;
    }
    static binaryPrecedence(t) {
        return fe.binary_ops[t] || 0;
    }
    static isIdentifierStart(t) {
        return t >= 65 && t <= 90 || t >= 97 && t <= 122 || t >= 128 && !fe.binary_ops[String.fromCharCode(t)] || fe.additional_identifier_chars.has(String.fromCharCode(t));
    }
    static isIdentifierPart(t) {
        return fe.isIdentifierStart(t) || fe.isDecimalDigit(t);
    }
    throwError(t) {
        let e = new Error(t + " at character " + this.index);
        throw e.index = this.index, e.description = t, e;
    }
    runHook(t, e) {
        if (fe.hooks[t]) {
            let r = {
                context: this,
                node: e
            };
            return fe.hooks.run(t, r), r.node;
        }
        return e;
    }
    searchHook(t) {
        if (fe.hooks[t]) {
            let e = {
                context: this
            };
            return fe.hooks[t].find(function(r) {
                return r.call(e.context, e), e.node;
            }), e.node;
        }
    }
    gobbleSpaces() {
        let t = this.code;
        for(; t === fe.SPACE_CODE || t === fe.TAB_CODE || t === fe.LF_CODE || t === fe.CR_CODE;)t = this.expr.charCodeAt(++this.index);
        this.runHook("gobble-spaces");
    }
    parse() {
        this.runHook("before-all");
        let t = this.gobbleExpressions(), e = t.length === 1 ? t[0] : {
            type: fe.COMPOUND,
            body: t
        };
        return this.runHook("after-all", e);
    }
    gobbleExpressions(t) {
        let e = [], r, i;
        for(; this.index < this.expr.length;)if (r = this.code, r === fe.SEMCOL_CODE || r === fe.COMMA_CODE) this.index++;
        else if (i = this.gobbleExpression()) e.push(i);
        else if (this.index < this.expr.length) {
            if (r === t) break;
            this.throwError('Unexpected "' + this.char + '"');
        }
        return e;
    }
    gobbleExpression() {
        let t = this.searchHook("gobble-expression") || this.gobbleBinaryExpression();
        return this.gobbleSpaces(), this.runHook("after-expression", t);
    }
    gobbleBinaryOp() {
        this.gobbleSpaces();
        let t = this.expr.substr(this.index, fe.max_binop_len), e = t.length;
        for(; e > 0;){
            if (fe.binary_ops.hasOwnProperty(t) && (!fe.isIdentifierStart(this.code) || this.index + t.length < this.expr.length && !fe.isIdentifierPart(this.expr.charCodeAt(this.index + t.length)))) return this.index += e, t;
            t = t.substr(0, --e);
        }
        return !1;
    }
    gobbleBinaryExpression() {
        let t, e, r, i, s1, o, a, l, c;
        if (o = this.gobbleToken(), !o || (e = this.gobbleBinaryOp(), !e)) return o;
        for(s1 = {
            value: e,
            prec: fe.binaryPrecedence(e),
            right_a: fe.right_associative.has(e)
        }, a = this.gobbleToken(), a || this.throwError("Expected expression after " + e), i = [
            o,
            s1,
            a
        ]; e = this.gobbleBinaryOp();){
            if (r = fe.binaryPrecedence(e), r === 0) {
                this.index -= e.length;
                break;
            }
            s1 = {
                value: e,
                prec: r,
                right_a: fe.right_associative.has(e)
            }, c = e;
            let u1 = (h)=>s1.right_a && h.right_a ? r > h.prec : r <= h.prec;
            for(; i.length > 2 && u1(i[i.length - 2]);)a = i.pop(), e = i.pop().value, o = i.pop(), t = {
                type: fe.BINARY_EXP,
                operator: e,
                left: o,
                right: a
            }, i.push(t);
            t = this.gobbleToken(), t || this.throwError("Expected expression after " + c), i.push(s1, t);
        }
        for(l = i.length - 1, t = i[l]; l > 1;)t = {
            type: fe.BINARY_EXP,
            operator: i[l - 1].value,
            left: i[l - 2],
            right: t
        }, l -= 2;
        return t;
    }
    gobbleToken() {
        let t, e, r, i;
        if (this.gobbleSpaces(), i = this.searchHook("gobble-token"), i) return this.runHook("after-token", i);
        if (t = this.code, fe.isDecimalDigit(t) || t === fe.PERIOD_CODE) return this.gobbleNumericLiteral();
        if (t === fe.SQUOTE_CODE || t === fe.DQUOTE_CODE) i = this.gobbleStringLiteral();
        else if (t === fe.OBRACK_CODE) i = this.gobbleArray();
        else {
            for(e = this.expr.substr(this.index, fe.max_unop_len), r = e.length; r > 0;){
                if (fe.unary_ops.hasOwnProperty(e) && (!fe.isIdentifierStart(this.code) || this.index + e.length < this.expr.length && !fe.isIdentifierPart(this.expr.charCodeAt(this.index + e.length)))) {
                    this.index += r;
                    let s1 = this.gobbleToken();
                    return s1 || this.throwError("missing unaryOp argument"), this.runHook("after-token", {
                        type: fe.UNARY_EXP,
                        operator: e,
                        argument: s1,
                        prefix: !0
                    });
                }
                e = e.substr(0, --r);
            }
            fe.isIdentifierStart(t) ? (i = this.gobbleIdentifier(), fe.literals.hasOwnProperty(i.name) ? i = {
                type: fe.LITERAL,
                value: fe.literals[i.name],
                raw: i.name
            } : i.name === fe.this_str && (i = {
                type: fe.THIS_EXP
            })) : t === fe.OPAREN_CODE && (i = this.gobbleGroup());
        }
        return i ? (i = this.gobbleTokenProperty(i), this.runHook("after-token", i)) : this.runHook("after-token", !1);
    }
    gobbleTokenProperty(t) {
        this.gobbleSpaces();
        let e = this.code;
        for(; e === fe.PERIOD_CODE || e === fe.OBRACK_CODE || e === fe.OPAREN_CODE || e === fe.QUMARK_CODE;){
            let r;
            if (e === fe.QUMARK_CODE) {
                if (this.expr.charCodeAt(this.index + 1) !== fe.PERIOD_CODE) break;
                r = !0, this.index += 2, this.gobbleSpaces(), e = this.code;
            }
            this.index++, e === fe.OBRACK_CODE ? (t = {
                type: fe.MEMBER_EXP,
                computed: !0,
                object: t,
                property: this.gobbleExpression()
            }, this.gobbleSpaces(), e = this.code, e !== fe.CBRACK_CODE && this.throwError("Unclosed ["), this.index++) : e === fe.OPAREN_CODE ? t = {
                type: fe.CALL_EXP,
                arguments: this.gobbleArguments(fe.CPAREN_CODE),
                callee: t
            } : (e === fe.PERIOD_CODE || r) && (r && this.index--, this.gobbleSpaces(), t = {
                type: fe.MEMBER_EXP,
                computed: !1,
                object: t,
                property: this.gobbleIdentifier()
            }), r && (t.optional = !0), this.gobbleSpaces(), e = this.code;
        }
        return t;
    }
    gobbleNumericLiteral() {
        let t = "", e, r;
        for(; fe.isDecimalDigit(this.code);)t += this.expr.charAt(this.index++);
        if (this.code === fe.PERIOD_CODE) for(t += this.expr.charAt(this.index++); fe.isDecimalDigit(this.code);)t += this.expr.charAt(this.index++);
        if (e = this.char, e === "e" || e === "E") {
            for(t += this.expr.charAt(this.index++), e = this.char, (e === "+" || e === "-") && (t += this.expr.charAt(this.index++)); fe.isDecimalDigit(this.code);)t += this.expr.charAt(this.index++);
            fe.isDecimalDigit(this.expr.charCodeAt(this.index - 1)) || this.throwError("Expected exponent (" + t + this.char + ")");
        }
        return r = this.code, fe.isIdentifierStart(r) ? this.throwError("Variable names cannot start with a number (" + t + this.char + ")") : (r === fe.PERIOD_CODE || t.length === 1 && t.charCodeAt(0) === fe.PERIOD_CODE) && this.throwError("Unexpected period"), {
            type: fe.LITERAL,
            value: parseFloat(t),
            raw: t
        };
    }
    gobbleStringLiteral() {
        let t = "", e = this.index, r = this.expr.charAt(this.index++), i = !1;
        for(; this.index < this.expr.length;){
            let s1 = this.expr.charAt(this.index++);
            if (s1 === r) {
                i = !0;
                break;
            } else if (s1 === "\\") switch(s1 = this.expr.charAt(this.index++), s1){
                case "n":
                    t += `
`;
                    break;
                case "r":
                    t += "\r";
                    break;
                case "t":
                    t += "	";
                    break;
                case "b":
                    t += "\b";
                    break;
                case "f":
                    t += "\f";
                    break;
                case "v":
                    t += "\v";
                    break;
                default:
                    t += s1;
            }
            else t += s1;
        }
        return i || this.throwError('Unclosed quote after "' + t + '"'), {
            type: fe.LITERAL,
            value: t,
            raw: this.expr.substring(e, this.index)
        };
    }
    gobbleIdentifier() {
        let t = this.code, e = this.index;
        for(fe.isIdentifierStart(t) ? this.index++ : this.throwError("Unexpected " + this.char); this.index < this.expr.length && (t = this.code, fe.isIdentifierPart(t));)this.index++;
        return {
            type: fe.IDENTIFIER,
            name: this.expr.slice(e, this.index)
        };
    }
    gobbleArguments(t) {
        let e = [], r = !1, i = 0;
        for(; this.index < this.expr.length;){
            this.gobbleSpaces();
            let s1 = this.code;
            if (s1 === t) {
                r = !0, this.index++, t === fe.CPAREN_CODE && i && i >= e.length && this.throwError("Unexpected token " + String.fromCharCode(t));
                break;
            } else if (s1 === fe.COMMA_CODE) {
                if (this.index++, i++, i !== e.length) {
                    if (t === fe.CPAREN_CODE) this.throwError("Unexpected token ,");
                    else if (t === fe.CBRACK_CODE) for(let o = e.length; o < i; o++)e.push(null);
                }
            } else if (e.length !== i && i !== 0) this.throwError("Expected comma");
            else {
                let o = this.gobbleExpression();
                (!o || o.type === fe.COMPOUND) && this.throwError("Expected comma"), e.push(o);
            }
        }
        return r || this.throwError("Expected " + String.fromCharCode(t)), e;
    }
    gobbleGroup() {
        this.index++;
        let t = this.gobbleExpressions(fe.CPAREN_CODE);
        if (this.code === fe.CPAREN_CODE) return this.index++, t.length === 1 ? t[0] : t.length ? {
            type: fe.SEQUENCE_EXP,
            expressions: t
        } : !1;
        this.throwError("Unclosed (");
    }
    gobbleArray() {
        return this.index++, {
            type: fe.ARRAY_EXP,
            elements: this.gobbleArguments(fe.CBRACK_CODE)
        };
    }
}, uQ = new ZE;
Object.assign(fe, {
    hooks: uQ,
    plugins: new JE(fe),
    COMPOUND: "Compound",
    SEQUENCE_EXP: "SequenceExpression",
    IDENTIFIER: "Identifier",
    MEMBER_EXP: "MemberExpression",
    LITERAL: "Literal",
    THIS_EXP: "ThisExpression",
    CALL_EXP: "CallExpression",
    UNARY_EXP: "UnaryExpression",
    BINARY_EXP: "BinaryExpression",
    ARRAY_EXP: "ArrayExpression",
    TAB_CODE: 9,
    LF_CODE: 10,
    CR_CODE: 13,
    SPACE_CODE: 32,
    PERIOD_CODE: 46,
    COMMA_CODE: 44,
    SQUOTE_CODE: 39,
    DQUOTE_CODE: 34,
    OPAREN_CODE: 40,
    CPAREN_CODE: 41,
    OBRACK_CODE: 91,
    CBRACK_CODE: 93,
    QUMARK_CODE: 63,
    SEMCOL_CODE: 59,
    COLON_CODE: 58,
    unary_ops: {
        "-": 1,
        "!": 1,
        "~": 1,
        "+": 1
    },
    binary_ops: {
        "||": 1,
        "&&": 2,
        "|": 3,
        "^": 4,
        "&": 5,
        "==": 6,
        "!=": 6,
        "===": 6,
        "!==": 6,
        "<": 7,
        ">": 7,
        "<=": 7,
        ">=": 7,
        "<<": 8,
        ">>": 8,
        ">>>": 8,
        "+": 9,
        "-": 9,
        "*": 10,
        "/": 10,
        "%": 10
    },
    right_associative: new Set,
    additional_identifier_chars: new Set([
        "$",
        "_"
    ]),
    literals: {
        true: !0,
        false: !1,
        null: null
    },
    this_str: "this"
});
fe.max_unop_len = fe.getMaxKeyLen(fe.unary_ops);
fe.max_binop_len = fe.getMaxKeyLen(fe.binary_ops);
var lu = (n1)=>new fe(n1).parse(), hQ = Object.getOwnPropertyNames(fe);
hQ.forEach((n1)=>{
    lu[n1] === void 0 && n1 !== "prototype" && (lu[n1] = fe[n1]);
});
lu.Jsep = fe;
var dQ = "ConditionalExpression", fQ = {
    name: "ternary",
    init (n1) {
        n1.hooks.add("after-expression", function(e) {
            if (e.node && this.code === n1.QUMARK_CODE) {
                this.index++;
                let r = e.node, i = this.gobbleExpression();
                if (i || this.throwError("Expected expression"), this.gobbleSpaces(), this.code === n1.COLON_CODE) {
                    this.index++;
                    let s1 = this.gobbleExpression();
                    if (s1 || this.throwError("Expected expression"), e.node = {
                        type: dQ,
                        test: r,
                        consequent: i,
                        alternate: s1
                    }, r.operator && n1.binary_ops[r.operator] <= .9) {
                        let o = r;
                        for(; o.right.operator && n1.binary_ops[o.right.operator] <= .9;)o = o.right;
                        e.node.test = o.right, o.right = e.node, e.node = r;
                    }
                } else this.throwError("Expected :");
            }
        });
    }
};
lu.plugins.register(fQ);
function Ya(n1) {
    return {
        all: n1 = n1 || new Map,
        on: function(t, e) {
            var r = n1.get(t);
            r ? r.push(e) : n1.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var r = n1.get(t);
            r && (e ? r.splice(r.indexOf(e) >>> 0, 1) : n1.set(t, []));
        },
        emit: function(t, e) {
            var r = n1.get(t);
            r && r.slice().map(function(i) {
                i(e);
            }), (r = n1.get("*")) && r.slice().map(function(i) {
                i(t, e);
            });
        }
    };
}
var $d = class {
    constructor(t, e, r){
        this.id = t;
        this.userAPI = e;
        this.result = void 0;
        this.error = "null";
        this.isPrefetched = !1;
        this.isLoading = !1;
        this.isLoaded = !1;
        this.prefetchPromise = new Promise((t)=>t());
        this.emitter = Ya();
        this._innerCallUserAPI = async (t)=>{
            this.emitter.emit("start", {
                userAPIId: this.id
            }), this.isLoading = !0, this.isLoading = !1;
            try {
                this.result = await vQ(this.userAPI, t), this.error = "null", this.emitter.emit("success", {
                    userAPIId: this.id
                });
            } catch (e) {
                let r = e.message?.split("_:_")?.[0]?.replace("status:", "") ?? "null";
                this.error = r, this.result = null, this.emitter.emit("error", {
                    userAPIId: this.id
                });
            }
            this.isLoading = !1, this.isPrefetched = !0, this.isLoaded = !0;
        };
        e?.integration?.type === "OpenAI" ? this.result = {
            content: ""
        } : e.method === "GET" && e.url !== "" && (this.prefetchPromise = this.prefetch(r)), this._debouncedCallUserAPI = this._innerCallUserAPI, this._updateDebouncedCallUserAPI(), this._debouncedPrefetch = _o(this.prefetch, 1e3, {
            trailing: !0
        });
    }
    _updateDebouncedCallUserAPI() {
        this._debouncedCallUserAPI = this.userAPI.debounce !== void 0 && this.userAPI.debounce > 0 ? _o(this._innerCallUserAPI, this.userAPI.debounce, {
            leading: !0,
            trailing: !0
        }) : this._innerCallUserAPI;
    }
    async prefetch(t) {
        await this.callUserAPI(t);
    }
    async callUserAPI(t) {
        await this._debouncedCallUserAPI(t);
    }
    update(t, e, r = !0) {
        this.userAPI = t, this._updateDebouncedCallUserAPI(), this.userAPI.url !== "" && this.userAPI.method === "GET" && r && this._debouncedPrefetch(e);
    }
    retrieveValue(t) {
        if (this.result) try {
            return Mr.zoom(this.result, t);
        } catch (e) {
            console.error(e);
        }
    }
    retrieveZoomedKeyValues(t) {
        if (this.result) {
            let e = t && t.length ? Mr.zoom(this.result, t) : this.result;
            if (yQ(e)) return Object.entries(e);
            if (gQ(e)) return e.map((r, i)=>[
                    i.toString(),
                    r
                ]);
            throw mQ(e) ? new Error("This path points to a value, use retrieveValue() instead. " + t?.join(".")) : new Error("Path error" + t?.join("."));
        }
    }
    dispose() {}
    on(t, e) {
        this.emitter.on(t, e);
    }
    off(t, e) {
        this.emitter.off(t, e);
    }
    get autostart() {
        return this.userAPI.autoStart;
    }
};
function pQ(n1) {
    let t = new Headers;
    return n1.headers.forEach((e)=>{
        e.data.key !== "" && t.append(e.data.key, e.data.value);
    }), t;
}
function mQ(n1) {
    return typeof n1 == "string" || typeof n1 == "number" || typeof n1 == "boolean" || n1 === null;
}
function gQ(n1) {
    return Array.isArray(n1);
}
function yQ(n1) {
    return typeof n1 == "object" && n1 !== null;
}
async function vQ(n1, t, e = new AbortController) {
    let r, i = n1.url, s1 = n1.proxy?.enabled ?? !1, o;
    if (n1.integration?.type === "OpenAI") {
        let l = qm(n1.integration.prompt === "" ? [] : JSON.parse(n1.integration.prompt), t), c = n1.integration.behavior === "" ? [] : qm(JSON.parse(n1.integration.behavior), t);
        o = `{
		"model": "${n1.integration.model}",
		"messages": [${n1.integration.useBehavior ? `
		{
			"role": "system",
			"content": "${c}"
		},` : ""}
		{
			"role": "user",
			"content": "${l}"
		}
		]
	}`;
    }
    if (s1) {
        i = `${"https://apis.spline.design/"}file/${n1.proxy.fileId}/external-api/request?uuidexternalapi=${n1.proxy.proxyId}`;
        let u1;
        o !== void 0 ? u1 = o : n1.method === "POST" && n1.body && (u1 = qm(JSON.parse(n1.body), t)), u1 !== void 0 && (i += `&data=${encodeURIComponent(u1.replace(/(\r\n|\n|\r|\t)/gm, ""))}`);
    } else n1.integration?.type === "OpenAI" ? r = o : n1.method === "POST" && n1.body && (r = qm(JSON.parse(n1.body), t));
    let a = await fetch(i, {
        method: s1 ? "GET" : n1.method,
        headers: s1 ? void 0 : pQ(n1),
        signal: e.signal,
        body: r
    });
    if (!a.ok) throw new Error("status:" + a.status + "_:_" + a.statusText);
    if (n1.integration?.type === "OpenAI") {
        let l = await a.json();
        return s1 && (l = l.response), {
            content: l.choices[0].message.content
        };
    } else {
        let l = await a.json();
        return s1 && (l = l.response), l;
    }
}
var $3 = (n1, t)=>{
    if (typeof n1 == "string") {
        let e = t.getVariable(n1);
        if (e) return $3(e, t);
    }
    return Gr.isBoolean(n1) ? Gr.getDisplayedValue(n1).toLowerCase() : Gr.getDisplayedValue(n1);
}, qm = (n1, t)=>n1.map((e, r)=>{
        if ("text" in e) return e.text;
        if ("type" in e) {
            if (e.type === "paragraph") return (r > 0 ? `
` : "") + qm(e.children, t);
            if (e.type === "variable") {
                let i = t.getVariable(e.variableId);
                if (i !== void 0) return $3(i, t);
            }
        }
        return "";
    }).join("");
var xQ = [
    "+",
    "-",
    "*",
    "/",
    "(",
    ")",
    "==",
    "!=",
    ">",
    "<",
    ">=",
    "<=",
    "and",
    "or",
    "!",
    "%",
    "^",
    ","
], bQ = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "."
], SQ = [
    "sin",
    "cos",
    "tan",
    "asin",
    "acos",
    "atan",
    "atan2",
    "sqrt",
    "abs",
    "log",
    "exp",
    "floor",
    "ceil",
    "round",
    "min",
    "max",
    "random"
];
function wQ(n1) {
    return typeof n1 != "string" ? !1 : !isNaN(n1) && !isNaN(parseFloat(n1));
}
lu.addBinaryOp("^", 11, !0);
function Ix(n1, t, e = "number") {
    let r = "";
    for(let o = 0; o < n1.length; o++){
        let a = n1[o];
        if ("objType" in a && a.objType === "api") {
            let l = JSON.parse(a.id), c = l[0], u1 = t.getUserAPI(c);
            if (u1 !== void 0 && u1 instanceof $d) {
                let h = u1.retrieveValue(l.slice(1));
                h !== void 0 && (r += h);
            }
            continue;
        }
        if ("objType" in a && a.objType === "webhook") {
            let l = JSON.parse(a.id), [c, u1] = l, h = t.getUserWebhook(c);
            if (h !== void 0) {
                let d = h.getParameterValue(u1);
                d !== void 0 && (r += d);
            }
            continue;
        }
        if ("objType" in a && a.objType === "aiAssistant") {
            let l = t.openAIRealtime;
            if ("objId" in a && a.objId !== void 0) {
                let c;
                if (t.scene.data.objects.traverse((u1, h)=>{
                    let d = h.events?.find((f)=>f.id === a.objId);
                    d && (c = d);
                }), c !== void 0 && c.data.type === "AIAssistantListener") {
                    let u1 = l?.computeAnalysisForListenerEvent(c.data);
                    if (u1 !== void 0) {
                        r += u1;
                        continue;
                    }
                }
            }
            r += l?.voice ?? 0;
            continue;
        }
        if ("id" in a) {
            let l = n1[o - 1];
            if (o > 0 && "id" in l) {
                console.error("Two variables in a row", n1);
                return;
            }
            let c = t.getVariable(a.id), u1 = Gr.getDisplayedValue(c);
            e === "number" && Gr.isTextValue(c) && Array.isArray(c.textValue) && c.textValue.length === 1 ? u1 = parseFloat(u1).toString() : e === "boolean" && Gr.isBoolean(c) ? u1 = c ? "true" : "false" : e === "boolean" && Gr.isTextValue(c) && !Array.isArray(c.textValue) && (u1 = '"' + u1 + '"'), r += u1;
            continue;
        } else if (e === "string") {
            a.name !== '"' && (a.name !== "+" || a.escaped) && (r += a.name), a.name === "+" && !a.escaped && r[r.length - 1] === "\\" && (r = r.slice(0, -1) + a.name);
            continue;
        }
        if (a.name === "and") {
            r += "&&";
            continue;
        }
        if (a.name === "or") {
            r += "||";
            continue;
        }
        if (a.name === "True") {
            r += "true";
            continue;
        }
        if (a.name === "False") {
            r += "false";
            continue;
        }
        if (e === "boolean" && !wQ(a.name) && !bQ.includes(a.name) && !xQ.includes(a.name) && !SQ.includes(a.name.replace(/\($/g, ""))) {
            r += '"' + a.name + '"';
            continue;
        }
        r += a.name;
    }
    if (e === "string") return r;
    if (n1.length === 0) {
        if (e === "number") return 0;
        if (e === "boolean") return !1;
    }
    let i;
    try {
        i = lu(r);
    } catch (o) {
        console.error(r, o);
        return;
    }
    let s1;
    try {
        s1 = Kt(i);
    } catch (o) {
        console.error(r, i, o);
    }
    return s1;
}
function Kt(n1) {
    switch(n1.type){
        case "BinaryExpression":
            switch(n1.operator){
                case "==":
                    return Number(Kt(n1.left) === Kt(n1.right));
                case "!=":
                    return Number(Kt(n1.left) !== Kt(n1.right));
                case ">":
                    return Number(Kt(n1.left) > Kt(n1.right));
                case ">=":
                    return Number(Kt(n1.left) >= Kt(n1.right));
                case "<":
                    return Number(Kt(n1.left) < Kt(n1.right));
                case "<=":
                    return Number(Kt(n1.left) <= Kt(n1.right));
                case "+":
                    return Kt(n1.left) + Kt(n1.right);
                case "-":
                    return Kt(n1.left) - Kt(n1.right);
                case "*":
                    return Kt(n1.left) * Kt(n1.right);
                case "/":
                    return Kt(n1.left) / Kt(n1.right);
                case "%":
                    return Kt(n1.left) % Kt(n1.right);
                case "&&":
                    return Kt(n1.left) && Kt(n1.right);
                case "||":
                    return Kt(n1.left) || Kt(n1.right);
                case "^":
                    return Math.pow(Kt(n1.left), Kt(n1.right));
                default:
                    throw new Error("Unknown operator: " + n1.operator);
            }
        case "UnaryExpression":
            switch(n1.operator){
                case "-":
                    return -Kt(n1.argument);
                case "!":
                    return Number(!Kt(n1.argument));
                default:
                    throw new Error("Unknown operator: " + n1.operator);
            }
        case "Identifier":
            throw new Error("Unknown identifier: " + n1.name);
        case "Literal":
            return n1.value;
        case "CallExpression":
            if (n1.callee.type === "Identifier") {
                if (n1.callee.name === "random") {
                    let t = 0, e = 1;
                    if (n1.arguments.length >= 1) try {
                        t = Kt(n1.arguments[0]);
                    } catch (r) {
                        console.warn(r);
                    }
                    if (n1.arguments.length >= 2) try {
                        e = Kt(n1.arguments[1]);
                    } catch (r) {
                        console.warn(r);
                    }
                    return t = Math.min(e, t), e = Math.max(e, t), t + Math.random() * (e - t);
                }
                return Math[n1.callee.name].apply(null, n1.arguments.map(Kt));
            } else throw new Error("Unknown node");
        default:
            throw new Error("Unknown node type: " + n1.type);
    }
}
var AQ = new ue, EQ = new ue;
function TQ(n1, t, e) {
    let r = [
        new E,
        new E,
        new E
    ], i = [
        new E,
        new E,
        new E
    ];
    return n1.extractBasis(r[0], r[1], r[2]), t.extractBasis(i[0], i[1], i[2]), r.forEach((s1, o)=>{
        let a = i[o], l = Se.lerp(s1.length(), a.length(), e);
        s1.lerp(a, e).setLength(l);
    }), new ue().makeBasis(r[0], r[1], r[2]);
}
var eL = class {
    static create(n1) {
        return this.build(this.normalizeInputs(n1));
    }
    static normalizeInputs(n1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            height: 100,
            depth: 1,
            subdivisions: 12,
            roundness: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 3
        }, n1.parameters), r = Math.abs(e.width), i = Math.abs(e.height ?? e.width), s1 = Math.abs(e.depth ?? 0), o = t?.shapeData ?? Kd.create({
            parameters: {
                ...tu,
                width: typeof tu.width == "number" ? tu.width : 100,
                height: typeof tu.height == "number" ? tu.height : 100
            }
        }).userData.shape;
        return {
            path: n1.path ?? fd.defaultData(),
            parameters: Object.assign(e, {
                width: r,
                height: i,
                depth: s1,
                extrusion: {
                    ...R0,
                    ...e.extrusion
                }
            }),
            shapeData: o
        };
    }
    static build(n1) {
        if (n1.path.points.length >= 2) {
            let e = new $E(n1);
            return Object.assign(e, {
                userData: {
                    ...n1,
                    type: "PathGeometry"
                }
            });
        } else return Object.assign(new Ce, {
            userData: {
                ...n1,
                type: "PathGeometry"
            }
        });
    }
}, $E = class extends Ce {
    constructor(e){
        super();
        this.type = "PathExtrusionGeometry", this.inputs = e, this.build();
    }
    _isGeometryClosed() {
        return this.inputs.path.isClosed && this.inputs.parameters.extrusion.depth === 1;
    }
    _isOpenEnded() {
        let e = this.inputs.parameters.extrusion;
        return !(this.inputs.path.isClosed && e.depth === 1) || !Z3(e.twist, 0) || e.startScale !== e.endScale;
    }
    build() {
        let e = this._extractPathPoints();
        if (e.length < 2) return;
        let r = this._computeBasisMatrices(e), { depth: i, offset: s1 } = this.inputs.parameters.extrusion;
        i = Math.max(0, Math.min(i, 1)), s1 = Math.max(0, Math.min(s1, 1));
        let o = this.inputs.path.isClosed ? e.length : e.length - 1, a = Math.floor(s1 * o), l = this.inputs.path.isClosed ? Math.ceil((i + s1) * o) : Math.ceil(Math.min(1, i + s1) * o), c = Math.min(Math.max(2, l - a + 1), o + 2), u1 = [], h = [];
        for(let q = 0; q < c; q++){
            let X = this.inputs.path.isClosed ? (q + a) % e.length : Math.min(q + a, e.length - 1);
            u1.push(e[X].clone()), h.push(r[X].clone());
        }
        let d = (q, X, K)=>{
            u1[q] = u1[q].clone().lerp(u1[X], K), h[q] = TQ(h[q], h[X], K);
        }, f = 0, m = s1 * o % 1;
        (!this.inputs.path.isClosed || i <= 1) && (m || s1 === 0) && (f = m, d(0, 1, f));
        let p = 0, g = (s1 + i) * o % 1;
        if ((this.inputs.path.isClosed && i <= 1 || !this.inputs.path.isClosed && s1 + i < 1) && g && (p = g, d(u1.length - 1, u1.length - 2, 1 - p)), i === 0) {
            let q = u1.length - 1;
            u1[q].copy(u1[0]), h[q].copy(h[0]);
        }
        this._applyPathModifiers(h, f, p);
        let { bevel: y, bevelSides: x } = this.inputs.parameters.extrusion, v = y > 0 ? this.inputs.parameters.extrusion.capType : "flat", b = 5;
        this.inputs.parameters.extrusion.shape.type === "Custom" && (b = this.inputs.parameters.extrusion.shape.shapeQuality === "low" ? 5 : 12);
        let { regions: w, infos: A, vertices: T } = this._computeShapePoints(b), S = 0, M;
        v === "round" && (M = new ec(this.inputs.shapeData, 2 * y, y, b, x, void 0, !0), S = M.getAttribute("position").count);
        let C = 0, P = 0;
        A.sort((q, X)=>q.start - X.start), A.forEach((q)=>{
            q.verticesStart = C, q.verticesCount = q.continuous.reduce((X, K, z)=>X + (z === 0 || !K ? 2 : 1), 0), P += q.verticesCount, C = P;
        });
        let _ = P * c, I, O = 0;
        if (this._isOpenEnded() && v === "flat") {
            try {
                I = io({
                    windingRule: qt.ODD,
                    elementType: Qr.POLYGONS,
                    polySize: 3,
                    vertexSize: 2,
                    strict: !0,
                    contours: w
                });
            } catch  {
                I = GE;
            }
            O = I.vertexCount;
        }
        let L = _ + 2 * O + S * 2, j = _ + 2 * O, V = {
            positions: new Float32Array(L * 3),
            normals: new Float32Array(L * 3),
            uvs: new Float32Array(L * 2)
        }, H = [];
        if (A.forEach((q)=>{
            this._extrudeRegion(q, T, h, u1, V, H, this._isGeometryClosed() && !this._isOpenEnded());
        }), I && (this._closeEnd(I, _, H, V, h[0], u1[0], !1), this._closeEnd(I, _ + O, H, V, h[h.length - 1], u1[u1.length - 1], !0)), M) {
            V.positions.set(M.getAttribute("position").array, j * 3), V.normals.set(M.getAttribute("normal").array, j * 3), V.uvs.set(M.getAttribute("uv").array, j * 2);
            for(let z = j; z < j + S; z++)V.uvs[z * 2 + 1] = 1e-4;
            let q = H.length;
            H.push(...M.getIndex().array.map((z)=>z + j)), j += S, V.positions.set(M.getAttribute("position").array, j * 3), V.normals.set(M.getAttribute("normal").array, j * 3), V.uvs.set(M.getAttribute("uv").array, j * 2);
            let X = H.length;
            H.push(...M.getIndex().array.map((z)=>z + j)), this.setAttribute("position", new je(V.positions, 3)), this.setAttribute("normal", new je(V.normals, 3)), this.setAttribute("uv", new je(V.uvs, 2)), this.setIndex(H);
            let K = AQ;
            K.copy(h[h.length - 1]).setPosition(u1[u1.length - 1]), this.applyMatrix4OnRange(K, j, L), K.copy(h[0]).setPosition(u1[0]).multiply(EQ.makeScale(1, 1, -1)), this.applyMatrix4OnRange(K, j - S, j), this.reverseIndicesOnRange(q, X);
        } else this.setAttribute("position", new je(V.positions, 3)), this.setAttribute("normal", new je(V.normals, 3)), this.setAttribute("uv", new je(V.uvs, 2)), this.setIndex(H);
    }
    _extractPathPoints() {
        let e = gx(this.inputs.path), r = this.inputs.path.subdivisions, i = this.inputs.path.subdivisionMode === "uniform" ? e.getSpacedPoints(r * 4) : e.getPoints(r);
        if (i.length < 2) return [];
        let s1 = [
            i[0]
        ];
        return i.forEach((a)=>{
            s1[s1.length - 1].distanceToSquared(a) > .001 && s1.push(a);
        }), this.inputs.path.isClosed && s1[s1.length - 1].distanceTo(s1[0]) < .001 && s1.pop(), s1;
    }
    _computeBasisMatrices(e) {
        let r = [], i = e.length, s1 = this.inputs.path.isClosed, o = new E, a = new E, l = new E, c = new E, u1 = new E(0, 1, 0);
        for(let g = 0; g < i; g++){
            let y = e[g], x;
            g === 0 ? x = s1 ? e[e.length - 2] : y.clone().multiplyScalar(2).sub(e[1]) : x = e[g - 1];
            let v;
            g === i - 1 ? v = s1 ? e[1] : y.clone().multiplyScalar(2).sub(e[g - 1]) : v = e[g + 1];
            let b = y.clone().sub(x).normalize(), w = v.clone().sub(y).normalize(), A = b.clone().add(w).normalize();
            l.copy(A), g === 0 && (A.equals(u1) || A.clone().negate().equals(u1)) && u1.set(0, 0, 1);
            let T = u1.clone().cross(A).normalize(), S = A.clone().cross(T).normalize();
            u1.copy(S), c.copy(T), g === 0 && (o.copy(S), a.copy(A));
            let M = new ue().makeBasis(T, S, A);
            r.push(M);
        }
        let h = s1 ? a : l, d = s1 ? o : new E(0, 1, 0), f = h.clone().cross(c).normalize(), m = Math.acos(d.dot(f));
        if (isNaN(m)) return r;
        let p = d.clone().cross(f);
        h.dot(p) > 0 && (m *= -1);
        for(let g = 1; g < r.length; g++){
            let y = new ue().makeRotationZ(m * g / r.length);
            r[g].multiply(y);
        }
        return r;
    }
    _applyPathModifiers(e, r, i) {
        let s1 = e.length, { angle: o, twist: a, startScale: l, endScale: c } = this.inputs.parameters.extrusion, u1 = new ue, h = new ue;
        return e.forEach((d, f)=>{
            let m = f === 0 ? 0 : f === s1 - 1 ? 1 : (f - r) / (s1 - (i === 0 ? 0 : 1) - (r + (1 - i)));
            u1.makeRotationZ(Se.lerp(o, o + a, m) * Se.DEG2RAD);
            let p = Se.lerp(l, c, m);
            h.makeScale(p, p, p), d.multiply(u1).multiply(h);
        }), e;
    }
    _computeShapePoints(e = 12, r = qt.ODD) {
        let i = this.inputs.shapeData, s1 = i.extractShapePointsToFlatArray([], e), o = i.shapeHoles.map((p)=>{
            let g = p.extractShapePointsToFlatArray([], e), y = [];
            for(let x = g.length - 1; x >= 1; x -= 2){
                let v = g[x - 1], b = g[x - 0];
                y.push(v, b);
            }
            return y;
        }), a;
        try {
            a = io({
                windingRule: r,
                elementType: Qr.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    s1
                ]
            });
        } catch  {
            a = Gm;
        }
        let l;
        try {
            l = io({
                windingRule: qt.ODD,
                elementType: Qr.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    ...o
                ]
            });
        } catch  {
            l = zE;
        }
        if (!a) throw new Error("error generating geometry");
        let c = a.elementCount;
        if (l) {
            a.elementCount += l.elementCount;
            for(let p = 0; p < l.elements.length; p++){
                let g = l.elements[p], y = p % 2 === 0 ? a.vertexCount : 0;
                a.elements.push(g + y);
            }
            for(let p = 0; p < l.vertexIndices.length; p++){
                let g = l.vertexIndices[p], y = a.vertexCount;
                a.vertexIndices.push(g + y);
            }
            for(let p = 0; p < l.vertices.length; p++){
                let g = l.vertices[p];
                a.vertices.push(g);
            }
        }
        let u1 = 1 / 0, h = -1 / 0, d = 1 / 0, f = -1 / 0;
        for(let p = 0, g = a.vertexCount; p < g; p++){
            let y = p * 2, x = a.vertices[y + 0], v = a.vertices[y + 1];
            x < u1 && (u1 = x), x > h && (h = x), v < d && (d = v), v > f && (f = v);
        }
        let m = [];
        for(let p = a.elementCount - 1; p >= 0; p--){
            let g = p >= c, y = p * 2, x = a.elements[y + 0], v = a.elements[y + 1], b = x + v, w = {
                start: x,
                count: v,
                normals: [],
                isHole: g,
                continuous: [],
                verticesStart: 0,
                verticesCount: 0
            };
            m.push(w);
            let A = x, T = b - 1, S = x + 1, M = i.roundedCurves.length;
            do {
                let C = A - x, P = a.vertices[T * 2 + 0], _ = a.vertices[T * 2 + 1], I = a.vertices[A * 2 + 0], O = a.vertices[A * 2 + 1], L = a.vertices[S * 2 + 0], j = a.vertices[S * 2 + 1], V = I - P, H = O - _, q = Math.sqrt(V * V + H * H);
                V /= q, H /= q;
                let X = I - L, K = O - j, z = Math.sqrt(X * X + K * K);
                X /= z, K /= z, w.normals[C * 2 + 0] = -K, w.normals[C * 2 + 1] = X;
                let Q = a.vertexIndices[A];
                if (Array.isArray(Q)) w.continuous[C] = !1;
                else {
                    let [te, $] = i.getCurveIndexFromVertexId(Q - 1, !0);
                    if ($ > 0 && $ < 1) w.continuous[C] = !0;
                    else {
                        let W = $ === 1 ? te + 1 : te - 1;
                        W = (W + M) % M;
                        let oe = $ === 1 ? 0 : 1, ie = i.roundedCurves[te].getTangent($), re = i.roundedCurves[W].getTangent(oe);
                        w.continuous[C] = ie.dot(re) > .95;
                    }
                }
                g && (w.normals[C * 2 + 0] *= -1, w.normals[C * 2 + 1] *= -1), [T, A, S] = [
                    A,
                    S,
                    S + 1
                ], S >= b && (S -= v);
            }while (S !== x + 1);
        }
        return {
            regions: [
                s1,
                ...o
            ],
            infos: m,
            vertices: a.vertices
        };
    }
    _insertVertex(e, r, i, s1, o) {
        let a = r * 2, l = r * 3;
        e.positions[l + 0] = i.x, e.positions[l + 1] = i.y, e.positions[l + 2] = i.z, e.normals[l + 0] = s1.x, e.normals[l + 1] = s1.y, e.normals[l + 2] = s1.z, e.uvs[a + 0] = o.x, e.uvs[a + 1] = o.y;
    }
    _extrudeRegion(e, r, i, s1, o, a, l) {
        let c = new E, u1 = new E, h = new E, d = new E, f = new U;
        i.forEach((p, g)=>{
            let y = s1[g], x = e.verticesStart * i.length + e.verticesCount * g;
            for(let v = 0; v < e.count; v++){
                let b = (e.start + v) * 2;
                if (c.set(r[b + 0], r[b + 1], 0), h.copy(c).applyMatrix4(p).add(y), e.continuous[v]) d.set(e.normals[v * 2 + 0], e.normals[v * 2 + 1], 0);
                else {
                    let w = v === 0 ? (e.start + e.count - 1) * 2 : b - 2;
                    u1.set(r[w + 0], r[w + 1], 0), d.copy(c).sub(u1), d.set(-d.y, d.x, 0), e.isHole || d.negate();
                }
                if (d.applyMatrix4(p).normalize(), f.set(v === 0 ? 1 : v / e.count, g / (i.length - 1)), this._insertVertex(o, x, h, d, f), x++, !e.continuous[v] || v === 0) {
                    if (v === 0) d.set(e.normals[v * 2 + 0], e.normals[v * 2 + 1], 0), f.set(0, g / (i.length - 1));
                    else {
                        let w = v === e.count - 1 ? e.start * 2 : b + 2;
                        u1.set(r[w + 0], r[w + 1], 0), d.copy(u1).sub(c), d.set(-d.y, d.x, 0), e.isHole || d.negate();
                    }
                    d.applyMatrix4(p).normalize(), this._insertVertex(o, x, h, d, f), x++;
                }
            }
        });
        let m = i.length - 1;
        for(let p = 0; p < m; p++){
            let g = e.verticesStart * i.length + e.verticesCount * p, y = e.verticesStart * i.length + e.verticesCount * (p + 1), x = 0;
            for(let v = 0; v < e.count; v++){
                (!e.continuous[v] || v === 0) && x++;
                let b = v === e.count - 1 ? 0 : x + 1, w = g + x, A = g + b, T = y + b, S = y + x;
                e.isHole ? a.push(w, T, A, w, S, T) : a.push(w, A, T, w, T, S), x++;
            }
        }
    }
    _closeEnd(e, r, i, s1, o, a, l) {
        let c = e.vertexCount, u1 = new E(0, 0, l ? -1 : 1).applyMatrix4(o), h = new E, d = new U;
        for(let m = 0; m < c; m++){
            let p = 2 * m;
            h.set(e.vertices[p + 0], e.vertices[p + 1], 0).applyMatrix4(o).add(a), this._insertVertex(s1, r + m, h, u1, d);
        }
        let f = e.elements;
        for(let m = 0; m < e.elementCount; m++){
            let p = 3 * m, g = f[p + 0] + r, y = f[p + (l ? 1 : 2)] + r, x = f[p + (l ? 2 : 1)] + r;
            i.push(g, y, x);
        }
    }
    applyMatrix4OnRange(e, r, i) {
        let s1 = e.elements, o = new Sr().getNormalMatrix(e).elements, a, l, c, u1, h = this.attributes.position, d = this.attributes.normal;
        if (!h || !d) return;
        let f = h.array, m = d.array, p = h.itemSize;
        for(let g = r * p, y = i * p; g < y; g += p){
            if (g === r) debugger;
            a = f[g + 0], l = f[g + 1], c = f[g + 2], u1 = 1 / (s1[3] * a + s1[7] * l + s1[11] * c + s1[15]), f[g + 0] = (s1[0] * a + s1[4] * l + s1[8] * c + s1[12]) * u1, f[g + 1] = (s1[1] * a + s1[5] * l + s1[9] * c + s1[13]) * u1, f[g + 2] = (s1[2] * a + s1[6] * l + s1[10] * c + s1[14]) * u1, a = m[g + 0], l = m[g + 1], c = m[g + 2], m[g + 0] = o[0] * a + o[3] * l + o[6] * c, m[g + 1] = o[1] * a + o[4] * l + o[7] * c, m[g + 2] = o[2] * a + o[5] * l + o[8] * c;
        }
        h.needsUpdate = !0, d.needsUpdate = !0;
    }
    reverseIndicesOnRange(e, r) {
        let i = this.index;
        if (i) {
            for(let s1 = e; s1 < r; s1 += 3){
                let o = i.getX(s1), a = i.getX(s1 + 1), l = i.getX(s1 + 2);
                i.setXYZ(s1, l, a, o);
            }
            i.needsUpdate = !0;
        }
    }
};
function tL() {
    let n1 = new Ce;
    return n1.setAttribute("position", new je(new Float32Array([]), 3)), n1.setIndex(new je(new Uint16Array([]), 1)), n1;
}
var CQ = tL().attributes, PQ = 12, _Q = 1, cu = class extends Ce {
    constructor(e, r){
        super();
        this.charWidths = [];
        this.charCoords = [];
        this.wrappedText = [];
        this.isLowResolution = !1;
        this.vectorShapes = [];
        Object.assign(this.attributes, CQ), this.userData = {
            parameters: e,
            type: "TextGeometry"
        };
        let i = r.getFont(e.font);
        i?.isLoaded ? (this.font = i, this.update(e, r)) : this.updateFont(e.font, r).then(()=>{
            this.update(e, r), r?.requestRender();
        });
    }
    async updateFont(e, r) {
        let i = r.getFont(e);
        i && (this.font = i, await i.loadingPromise);
    }
    update(e, r) {
        let i = this.font;
        if (this.userData = {
            parameters: e,
            type: "TextGeometry"
        }, !i?.isLoaded) {
            console.warn("Cannot update text because its font is not loaded");
            return;
        }
        let { width: s1, height: o, depth: a, extrudeBevelSize: l, extrudeBevelSegments: c, text: u1, textTransform: h } = e, d = Gr.getDisplayedValue(u1), f = h === 2 ? d.toUpperCase() : h === 3 ? d.toLowerCase() : d, m = IQ(e, i, f, r), { shapes: p, charWidths: g, charCoords: y } = i.generateShapes(m, e, r), x = (typeof s1 == "number" ? s1 : Number(r.getVariable(s1))) * .5, v = (typeof o == "number" ? o : Number(r.getVariable(o))) * .5, b = p.map((T)=>new $t().fromShape(T, !0));
        this.vectorShapes = b;
        let w = b.map((T)=>kn.create({
                shape: T,
                parameters: {
                    depth: a,
                    extrudeBevelSegments: c,
                    extrudeBevelSize: l,
                    windingRule: a <= 0 ? qt.NONZERO : qt.ODD,
                    subdivisions: this.isLowResolution && a > 0 ? _Q : PQ
                }
            })), A = w.length ? Js(w) : tL();
        A.translate(-x, v, 0), this.dispose(), this.wrappedText = m, this.charCoords = y, this.charWidths = g, this.deleteAttribute("extrudeNormal"), Object.entries(A.attributes).forEach(([T, S])=>{
            this.setAttribute(T, S);
        }), this.setIndex(A.index), this.computeBoundingSphere();
    }
    clone() {
        let e = Ri(new Ce, cu.prototype);
        return e.copy(this), console.log("CloneGeometry", this, e), e;
    }
    copy(e) {
        return Object.entries(e.attributes).forEach(([r, i])=>{
            this.setAttribute(r, i);
        }), this.setIndex(e.index), this.userData = {
            parameters: {
                ...e.userData.parameters
            },
            type: "TextGeometry"
        }, this;
    }
    async setText(e, r) {
        this.font && await this.font.loadingPromise, await this.update({
            ...this.userData.parameters,
            text: {
                textValue: e
            }
        }, r);
    }
    get text() {
        return this.userData.parameters.text ?? "";
    }
};
function IQ(n1, t, e, r) {
    let i = typeof n1.width == "string" ? Number(r.getVariable(n1.width)) : n1.width, s1 = [
        ""
    ], o = "";
    for (let a of e)o += a, a === " " || a === `
` ? (s1[s1.length - 1] += o, o = "", a === `
` && s1.push("")) : t.getTextWidth(s1[s1.length - 1] + o, n1) > i && (s1[s1.length - 1].length && s1.push(""), t.getTextWidth(s1[s1.length - 1] + o, n1) > i && (o.length === 1 ? (s1[s1.length - 1] += o, o = "") : (s1[s1.length - 1] += o.slice(0, -1), o = o[o.length - 1], s1.push(""))));
    return s1[s1.length - 1] += o, s1;
}
var iL, Ox = new Promise((n1)=>{
    iL = n1;
}), rL = !1;
var Dx;

function nL(n1) {
    if (rL) return;
    if (Dx) return Dx;
    async function t() {
        let r = n1 ?? "https://unpkg.com/@splinetool/modelling-wasm@1.12.53/build", s1 = (parcelRequire("9CTrk")), [o, a] = await Promise.all([
            s1,
            fetch(`${r}/process.wasm`).then((u1)=>u1.arrayBuffer())
        ]), l = o.default, c = await l({
            wasmBinary: a
        });
        iL(c), rL = !0;
    }
    return Dx = t(), Dx;
}
var DQ = [
    "font"
];
function Jo(n1, t, e, r) {
    let i, s1, o;
    n1.type === "PathGeometry" ? (s1 = JSON.parse(JSON.stringify(n1)), o = [
        [],
        [
            "extrusion"
        ]
    ]) : (s1 = {
        ...n1
    }, o = [
        []
    ]);
    for (let c of o){
        let u1 = s1;
        for (let h of c)u1 = u1[h];
        for(i in u1){
            let h = u1[i];
            EA(h) && !DQ.includes(i) && (u1[i] = t.getVariable(h, [
                r.uuid,
                "geometry",
                ...c,
                i
            ]), EA(u1[i]) && (u1[i] = 1));
        }
    }
    let a = {
        parameters: s1,
        type: s1.type
    };
    if (s1.type === "PathGeometry") a.path = s1.path;
    else if (s1.type === "VectorGeometry") {
        let c = $t.createFromState(s1.shape, s1.width, s1.height);
        a.shape = c;
    } else if (s1.type === "NonParametricGeometry") {
        if (s1.data.groups && s1.data.groups?.forEach((c)=>c.materialIndex = Math.max(c.materialIndex ?? 0, 0)), a.geometry = new yh().parse(s1), a.geometry.groups.length === 0) {
            let c = a.geometry;
            c.addGroup(0, Math.max(c.getIndex()?.count ?? 0, c.getAttribute("position").count), 0);
        }
    } else if (s1.type === "SubdivGeometry") {
        let c = new ui(s1, e);
        return c.data = n1, c;
    } else {
        if (s1.type === "TextGeometry") return new cu(s1, t);
        if (s1.type === "InputGeometry") return new cu(s1, t);
        if (s1.type === "UIGeometry") return Jd.create({
            parameters: {
                width: s1.width,
                height: s1.height,
                cornerRadius: s1.cornerRadius,
                cornerType: s1.cornerType
            }
        });
    }
    let l;
    try {
        l = eT(a);
    } catch (c) {
        console.error(c), console.error(`Error generating geometry with inputs: ${a}`);
        let u1 = $t.createFromState(dd.defaultData(), 100, 100);
        a.shape = u1, a.type = "VectorGeometry", l = eT(a);
    }
    return l;
}
var OQ = new ue;
function Xm(n1, t, e, r) {
    let i = n1.position.array, s1 = n1.normal.array, o = OQ.makeScale(t, e, r).invert().elements, a, l, c;
    for(var u1 = 0, h = i.length; u1 < h; u1 += 3)i[u1] *= t, i[u1 + 1] *= e, i[u1 + 2] *= r, a = s1[u1], l = s1[u1 + 1], c = s1[u1 + 2], s1[u1] = o[0] * a + o[4] * l + o[8] * c, s1[u1 + 1] = o[1] * a + o[5] * l + o[9] * c, s1[u1 + 2] = o[2] * a + o[6] * l + o[10] * c;
    n1.position.needsUpdate = !0, n1.normal.needsUpdate = !0;
}
var Rx = new Yt, ef = new E, ht;
Ox.then((n1)=>{
    ht = n1;
});
var sL = new Float32Array([
    10,
    10,
    0,
    -10,
    10,
    0,
    -10,
    -10,
    0,
    10,
    -10,
    0
]), oL = new Uint32Array([
    0,
    1,
    2,
    3
]), aL = new Uint8Array([
    4
]), ui = class extends Ce {
    constructor(e, r){
        super();
        this.data = e;
        this.flatShading = r;
        this.subdivPointer = 0;
        this.rebuild(), this.freeSubdivPointer();
    }
    mutateDirectlyScaleBaked(e, r) {
        this.freeSubdivPointer();
        let i = this.data.scaleBaked.map((l)=>typeof l == "number" ? l : 1), s1 = ws.div(r.map((l)=>typeof l == "number" ? l : 0), i);
        if (s1.every((l)=>l === 1)) return;
        this.subdividedGeometry && Xm(this.subdividedGeometry.attributes, ...s1), this.originalGeometry && Xm(this.originalGeometry.attributes, ...s1), this.data = e;
        let o = this.userData.parameters;
        this.userData.parameters = {
            width: o.width * s1[0],
            height: o.height * s1[1],
            depth: o.depth * s1[2]
        }, this.originalGeometry.boundingSphere.center.multiply(ef.fromArray(s1));
        let a = ef.set(o.width, o.height, o.depth).length();
        this.originalGeometry.boundingSphere.radius = a / 2;
    }
    ensureSubdivPointer() {
        return this.subdivPointer === 0 && this.rebuild(), this.subdivPointer;
    }
    rebuild() {
        let e, r, i;
        try {
            ({ originalGeometry: e, subdividedGeometry: r, subdivPointer: i } = ui.build(this.data, void 0, !this.flatShading, void 0));
        } catch  {
            e = new bi(100, 100, 100), i = 0;
        }
        this.subdivPointer = i, this.originalGeometry = e, this.subdividedGeometry = r ?? void 0;
        let s1 = this.subdividedGeometry ?? this.originalGeometry;
        Object.assign(this, s1), this.calcBoundingBox();
    }
    freeSubdivPointer() {
        this.subdivPointer && (ui.freeSubdivPointer(this.subdivPointer), this.subdivPointer = 0);
    }
    dispose() {
        super.dispose(), this.freeSubdivPointer();
    }
    calcBoundingBox() {
        let e = this.originalGeometry;
        e.boundingSphere === null && (e.boundingSphere = new ei, this.subdividedGeometry && (this.subdividedGeometry.boundingSphere = e.boundingSphere));
        let r = e.attributes.position, i = e.boundingSphere.center;
        Rx.setFromBufferAttribute(r), Rx.getCenter(i), e.boundingSphere.radius = i.distanceTo(Rx.max), isNaN(e.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this), Rx.getSize(ef);
        let s1 = {
            width: ef.x,
            height: ef.y,
            depth: ef.z
        };
        return this.userData.parameters = s1, s1;
    }
    static build(e, r, i, s1) {
        let o, a, l, c = e?.phongAngle ?? 35;
        i === !1 && (c = -1), r && (ht.free_bvh(r), ht.free_subdivision_surface(r));
        try {
            o = ui.allocate(e, s1);
        } catch (u1) {
            console.error(u1, e), o = ui.allocate({
                positionWASM: sL,
                indexWASM: oL,
                verticesPerFaceWASM: aL
            }, s1);
        }
        if (ht.set_destination_refinement_level(o, 0), a = ui.buildLevel(o, !0, c), e.subdivisions > 0) try {
            ht.set_destination_refinement_level(o, e.subdivisions), l = ui.buildLevel(o, !1, c);
        } catch  {
            try {
                ht.set_destination_refinement_level(o, e.subdivisions - 1), l = ui.buildLevel(o, !1, c);
            } catch  {
                l = null;
            }
        }
        else l = null;
        return {
            subdivPointer: o,
            originalGeometry: a,
            subdividedGeometry: l
        };
    }
    static primitiveToQuads(e, r, i) {
        e.widthSegments > 16 && (e.widthSegments = 16), e.heightSegments > 16 && (e.heightSegments = 16), e.depthSegments > 16 && (e.depthSegments = 16), e.radialSegments > 16 && (e.radialSegments = 16), e.type === "DodecahedronGeometry" && (e.detail = 0);
        let s1 = e.shape !== void 0 || e.path !== void 0 ? r.geometry : Jo(e, i, !1, r), o;
        e.type === "TorusGeometry" && e.arc === Math.PI * 2 ? o = s1.getClosedTorusIndicesForBooleanOrSubdiv() : o = s1.getIndex();
        let a, l, c, u1;
        ({ positions: a, triIndices: u1 } = uu(s1.getAttribute("position"), o));
        let h;
        if (e.type === "CylinderGeometry" && e.cornerRadius === 0 && e.hollow === 0 && e.openEnded === !1) {
            let d = e.radialSegments * e.heightSegments * 6, f = d + e.radialSegments * 3;
            h = [
                d,
                f
            ];
        }
        return { indices: l, verticesPerFace: c } = nT(a, u1, s1, h), {
            positions: a,
            indices: l,
            verticesPerFace: c
        };
    }
    static allocate(e, r) {
        let i, s1, o, a = [], l = [];
        e.positionWASM && e.positionWASM.length > 0 ? (i = e.positionWASM, s1 = e.indexWASM, o = e.verticesPerFaceWASM) : (i = sL, s1 = oL, o = aL);
        let c = i.length, u1 = s1.length, h = o.length, d = i.length + a.length + l.length, f = s1.length + o.length, m = d * Float32Array.BYTES_PER_ELEMENT + f * Uint32Array.BYTES_PER_ELEMENT, p = d * Float32Array.BYTES_PER_ELEMENT, g = ht._malloc(m), y = new Float32Array(ht.HEAPF32.buffer, g, d), x = new Uint32Array(ht.HEAPU32.buffer, g + p, f);
        y.set(i, 0), y.set(a, i.length), y.set(l, i.length + a.length), x.set(s1, 0), x.set(o, s1.length);
        let v;
        e?.scaleBaked?.some((w)=>w !== 1) && (v = new ue().makeScale(...e.scaleBaked.map((w)=>typeof w == "number" ? w : 1))), r && (v ? v.premultiply(r) : v = r);
        let b = v ? ht.alloc_subdivision_surface2(g, c, g + p, u1, g + p + s1.length * Uint32Array.BYTES_PER_ELEMENT, h, v.elements) : ht.alloc_subdivision_surface(g, c, g + p, u1, g + p + s1.length * Uint32Array.BYTES_PER_ELEMENT, h);
        return ht._free(g), b;
    }
    static buildLevel(e, r, i, s1, o) {
        let a = o ? ht.get_mesh_data2(e, r ? ht.Level.CONTROL : ht.Level.REFINED, i, o.elements) : ht.get_mesh_data(e, r ? ht.Level.CONTROL : ht.Level.REFINED, i), l = 8, c = ht.HEAPU32.subarray(a >> 2, (a >> 2) + l), u1 = c.subarray(4, 8), h = 0, d = ht.HEAPU32[c[h] >> 2], f = ht.HEAPF32.subarray(d >> 2, (d >> 2) + u1[h]);
        h++;
        let m = ht.HEAPU32[c[h] >> 2], p = ht.HEAPF32.subarray(m >> 2, (m >> 2) + u1[h]);
        h++;
        let g = ht.HEAPU32[c[h] >> 2], y = ht.HEAPU32.subarray(g >> 2, (g >> 2) + u1[h]);
        h++;
        let x = ht.HEAPU32[c[h] >> 2], v = ht.HEAPU32.subarray(x >> 2, (x >> 2) + u1[h]);
        if (h++, s1 === void 0) {
            let b = new Ce;
            if (b.setIndex(new To(v, 1)), b.setAttribute("position", new Te(f, 3)), b.setAttribute("normal", new Te(p, 3)), r) {
                b.setAttribute("faceMap", new To(y, 1));
                let w = new Float32Array(p.length / 3 * 4).fill(0);
                b.setAttribute("color", new je(w, 4));
            }
            return ht.free_mesh_data(a), b.userData.type = "SubdivGeometry", b;
        }
        s1.getAttribute("position").copyArray(f), s1.getAttribute("normal").copyArray(p), s1.attributes.position.needsUpdate = !0, s1.attributes.normal.needsUpdate = !0, ht.free_mesh_data(a);
    }
    static freeSubdivPointer(e) {
        ht.free_bvh(e), ht.free_subdivision_surface(e);
    }
    static buildControlCageWireframe(e, r, i) {
        let s1 = ht.get_wireframe_data_for_base_level(e), o = 4, a = ht.HEAPU32.subarray(s1 >> 2, (s1 >> 2) + o), l = a.subarray(2, 4), c = 0, u1 = ht.HEAPU32[a[c] >> 2], h = ht.HEAPF32.subarray(u1 >> 2, (u1 >> 2) + l[c]);
        c++;
        let d = ht.HEAPU32[a[c] >> 2], f = ht.HEAPU32.subarray(d >> 2, (d >> 2) + l[c]);
        if (r === void 0) {
            let m = new Ce;
            m.setAttribute("position", new Te(h, 3));
            let p = new Float32Array(h.length);
            for(let g = 0, y = h.length; g < y;)p[g++] = i.r, p[g++] = i.g, p[g++] = i.b;
            return m.setAttribute("color", new je(p, 3)), m.setIndex(new To(f, 1)), ht.free_wireframe_data_for_base_level(s1), m;
        }
        r.getAttribute("position").copyArray(h), r.attributes.position.needsUpdate = !0, ht.free_wireframe_data_for_base_level(s1);
    }
    static updateCollabMesh(e, r, i) {
        let s1 = r === 0;
        s1 || ht.set_destination_refinement_level(e, r);
        let o = i ? ht.get_topological_data2(e, s1 ? ht.Level.CONTROL : ht.Level.REFINED, i.elements) : ht.get_topological_data(e, s1 ? ht.Level.CONTROL : ht.Level.REFINED), a = 6, l = ht.HEAPU32.subarray(o >> 2, (o >> 2) + a), c = l.subarray(3, 6), u1 = 0, h = ht.HEAPU32[l[u1] >> 2], d = new Float32Array(ht.HEAPF32.subarray(h >> 2, (h >> 2) + c[u1]));
        u1++;
        let f = ht.HEAPU32[l[u1] >> 2], m = new Uint32Array(ht.HEAPU32.subarray(f >> 2, (f >> 2) + c[u1]));
        u1++;
        let p = ht.HEAPU32[l[u1] >> 2], g = new Uint8Array(ht.HEAPU32.subarray(p >> 2, (p >> 2) + c[u1]));
        return ht.free_topological_data(o), {
            positions: d,
            indices: m,
            verticesPerFace: g
        };
    }
};
var lL = [
    "getX",
    "getY",
    "getZ"
];
function uu(n1, t) {
    let e = {}, r = t ? t.count : n1.count, i = 0, s1 = [], o = [], a = 1e4;
    for(let c = 0; c < r; c++){
        let u1 = t ? t.getX(c) : c, h = "";
        for(let d = 0; d < 3; d++)h += `${~~(n1[lL[d]](u1) * a)},`;
        if (h in e) s1.push(e[h]);
        else {
            for(let d = 0; d < 3; d++)o.push(n1[lL[d]](u1));
            e[h] = i, s1.push(i), i++;
        }
    }
    let l = [];
    for(let c = 0; c < s1.length; c += 3)s1[c] === s1[c + 1] || s1[c] === s1[c + 2] || s1[c + 1] === s1[c + 2] || l.push(s1[c], s1[c + 1], s1[c + 2]);
    return {
        positions: o,
        triIndices: l
    };
}
var Lx = new E, tT = new E, rT = new E, iT = new E;
function nT(n1, t, e, r) {
    let i = [], s1 = [];
    if (e.userData.shape !== void 0 && e.userData.parameters.depth === 0 && e.userData.shape.shapeHoles.length === 0) {
        let l = e.userData.shape.extractShapePointsToFlatArray([]), c = e.userData.parameters.spikes;
        if (e.userData.type === "EllipseGeometry" && c <= 24 && c % 4 === 0 && e.userData.parameters.angle >= 360) {
            let d = l.length / 2 / c;
            l = l.filter((f, m)=>Math.floor(m / 2) % d === 0);
        }
        let u1 = 0;
        for(let d = 0; d < l.length; d += 2)u1 += (l[d] - l[(d === 0 ? l.length : d) - 2]) * (l[d + 1] + l[(d === 0 ? l.length : d) - 1]);
        n1.length = 0;
        let h = 0;
        if (u1 < 0) for(let d = 0; d < l.length; d += 2)n1.push(l[d], l[d + 1], 0), i.push(h++);
        else for(let d = l.length - 2; d >= 0; d -= 2)n1.push(l[d], l[d + 1], 0), i.push(h++);
        return s1.push(h), {
            indices: i,
            verticesPerFace: s1
        };
    }
    let o = new Float32Array([
        e.userData.parameters.depth
    ])[0], a = 0;
    for(; a < t.length;){
        if (e.useNgonForTopBottomFaceDuringBake) {
            let l = 0;
            if ((n1[t[a] * 3 + 2] === o || n1[t[a] * 3 + 2] === 0) && l++, (n1[t[a + 1] * 3 + 2] === o || n1[t[a + 1] * 3 + 2] === 0) && l++, (n1[t[a + 2] * 3 + 2] === o || n1[t[a + 2] * 3 + 2] === 0) && l++, l === 3) break;
        }
        if (t[a + 1] === t[a + 3] && t[a + 2] === t[a + 5] || t[a + 0] === t[a + 3] && t[a + 2] === t[a + 4]) {
            Lx.set(n1[t[a] * 3], n1[t[a] * 3 + 1], n1[t[a] * 3 + 2]), tT.set(n1[t[a + 1] * 3], n1[t[a + 1] * 3 + 1], n1[t[a + 1] * 3 + 2]), rT.set(n1[t[a + 4] * 3], n1[t[a + 4] * 3 + 1], n1[t[a + 4] * 3 + 2]), iT.set(n1[t[a + 5] * 3], n1[t[a + 5] * 3 + 1], n1[t[a + 5] * 3 + 2]), tT.sub(Lx).normalize(), rT.sub(Lx).normalize(), iT.sub(Lx).normalize();
            let l = tT.cross(rT).dot(iT), c = a;
            Math.abs(l) > .005 || r && r.some((u1, h)=>h % 2 === 1 ? !1 : c >= r[h] && c < r[h + 1]) ? (i.push(t[a], t[a + 1], t[a + 2]), s1.push(3), a += 3) : (i.push(t[a], t[a + 1], t[a + 4], t[a + 5]), s1.push(4), a += 6);
        } else i.push(t[a], t[a + 1], t[a + 2]), s1.push(3), a += 3;
    }
    if (e.useNgonForTopBottomFaceDuringBake) {
        let l = [], c = [], u1 = 0;
        for(let h = 0, d = 0; h < n1.length; h += 3, d++)n1[h + 2] === 0 && (l.push(d), u1++), n1[h + 2] === o && c.push(d);
        if (e.userData.parameters.extrudeBevelSize === 0) {
            let h = c[0];
            c[0] = c[1], c[1] = h;
        }
        l.reverse(), i.push(...l, ...c), s1.push(u1, u1);
    }
    return {
        indices: i,
        verticesPerFace: s1
    };
}
var _s = {};
nU(_s, {
    calcBoolean: ()=>NQ,
    calcBooleanTopological: ()=>LQ,
    freeMeshSet: ()=>UQ,
    getMeshSet: ()=>BQ,
    hasOpenEdges: ()=>FQ,
    transformMeshSet: ()=>VQ
});
var cL, uL = new Promise((n1)=>{
    cL = n1;
});
var Nx;

function hL(n1) {
    if (Nx) return Nx;
    async function t() {
        let r = n1 ?? "https://unpkg.com/@splinetool/boolean-wasm@1.12.53/build", s1 = (parcelRequire("1Jpra")), [o, a] = await Promise.all([
            s1,
            fetch(`${r}/boolean.wasm`).then((u1)=>u1.arrayBuffer())
        ]), l = o.default, c = await l({
            wasmBinary: a
        });
        cL(c);
    }
    return Nx = t(), Nx;
}
var zt, tf;
uL.then((n1)=>zt = n1);
function RQ(n1, t, e) {
    let r, i;
    n1.userData.parameters.type === "TorusGeometry" && n1.userData.parameters.arc === Math.PI * 2 ? i = n1.getClosedTorusIndicesForBooleanOrSubdiv() : i = n1.getIndex();
    let { positions: s1, triIndices: o } = uu(n1.getAttribute("position"), i), a;
    if (t && e) {
        let { indices: l, verticesPerFace: c } = nT(s1, o, n1);
        a = c.length, r = [];
        for(let u1 = 0, h = 0; u1 < a; u1++){
            r.push(c[u1]);
            for(let d = 0; d < c[u1]; d++)r.push(l[h++]);
        }
    } else {
        let l = o.length;
        r = Array(l + l / 3), a = 0;
        for(let c = 0, u1 = 0; u1 < r.length;)r[u1++] = 3, a++, r[u1++] = o[c++], r[u1++] = o[c++], r[u1++] = o[c++];
    }
    return {
        positions: s1,
        faceIndices: r,
        nFaces: a
    };
}
function dL(n1) {
    let t = n1.length, e = t * Uint32Array.BYTES_PER_ELEMENT, r = t * Float32Array.BYTES_PER_ELEMENT, i = Number.isInteger(n1[0]) ? e : r, s1 = zt._malloc(i);
    return (Number.isInteger(n1[0]) ? new Uint32Array(zt.HEAPU32.buffer, s1, t) : new Float32Array(zt.HEAPF32.buffer, s1, t)).set(n1, 0), s1;
}
function fL(n1) {
    switch(n1){
        case 0:
            return zt.OP.UNION;
        case 1:
            return zt.OP.INTERSECTION;
        case 2:
            return zt.OP.A_MINUS_B;
        default:
            throw new Error("Unknown boolean operation " + n1);
    }
}
function LQ(n1, t) {
    tf === void 0 && (tf = zt.init_csg());
    let e = dL(n1), r = zt.csg_calc_topological(tf, e, n1.length, fL(t));
    zt._free(e);
    let i = 6, s1 = zt.HEAPU32.subarray(r >> 2, (r >> 2) + i), o = s1.subarray(3, 6), a = 0, l = zt.HEAPU32[s1[a] >> 2], c = new Float32Array(zt.HEAPF32.subarray(l >> 2, (l >> 2) + o[a]));
    a++;
    let u1 = zt.HEAPU32[s1[a] >> 2], h = new Uint32Array(zt.HEAPU32.subarray(u1 >> 2, (u1 >> 2) + o[a]));
    a++;
    let d = zt.HEAPU32[s1[a] >> 2], f = new Uint8Array(zt.HEAPU32.subarray(d >> 2, (d >> 2) + o[a]));
    return zt.free_mesh_data(r), {
        positions: c,
        indices: h,
        verticesPerFace: f
    };
}
function NQ(n1, t, e, r) {
    tf === void 0 && (tf = zt.init_csg());
    let i = dL(n1), s1 = zt.csg_calc(tf, i, n1.length, r, fL(t));
    zt._free(i);
    let o = 5, a = zt.HEAPU32.subarray(s1 >> 2, (s1 >> 2) + o), l = a.subarray(2, 5), c = 0, u1 = zt.HEAPU32[a[c] >> 2], h = zt.HEAPF32.subarray(u1 >> 2, (u1 >> 2) + l[c]);
    c++;
    let d = zt.HEAPU32[a[c] >> 2], f = zt.HEAPF32.subarray(d >> 2, (d >> 2) + l[c]);
    c++;
    let m = l[c];
    e.setAttribute("position", new Te(h, 3)), e.setAttribute("normal", new Te(f, 3));
    let p = zt.HEAPF32.subarray((s1 >> 2) + 5, (s1 >> 2) + 5 + 6);
    return e.boundingSphere === null && (e.boundingSphere = new ei), e.boundingSphere.center.set(p[0], p[1], p[2]), e.boundingSphere.radius = (p[3] ** 2 + p[4] ** 2 + p[5] ** 2) ** .5, e.userData.parameters = {
        width: p[3] * 2,
        height: p[4] * 2,
        depth: p[5] * 2
    }, zt.free_mesh_data(s1), m;
}
function BQ(n1, t, e) {
    if (zt === void 0) return -1;
    let r, i, s1;
    if (t && n1.userData.positions !== void 0) {
        let y = n1.userData;
        s1 = y.verticesPerFace.length, r = y.positions, i = Array(y.verticesPerFace.reduce((x, v)=>x + v, 0) + s1);
        for(let x = 0, v = 0, b = 0; x < y.verticesPerFace.length; x++){
            i[b++] = y.verticesPerFace[x];
            for(let w = 0; w < y.verticesPerFace[x]; w++)i[b++] = y.indices[v++];
        }
    } else ({ positions: r, faceIndices: i, nFaces: s1 } = RQ(n1, t, e));
    let o = r.length, a = i.length, l = r.length, c = i.length, u1 = l * Float32Array.BYTES_PER_ELEMENT + c * Uint32Array.BYTES_PER_ELEMENT, h = l * Float32Array.BYTES_PER_ELEMENT, d = c * Uint32Array.BYTES_PER_ELEMENT, f = zt._malloc(u1), m = new Float32Array(zt.HEAPF32.buffer, f, l), p = new Uint32Array(zt.HEAPU32.buffer, f + h, c);
    m.set(r, 0), p.set(i, 0);
    let g = zt.get_csg_mesh(f, o, f + h, a, s1);
    return zt._free(f), g;
}
function FQ(n1) {
    return zt.has_open_edges(n1);
}
function VQ(n1, t) {
    zt.transform_csg_mesh(n1, t.elements);
}
function UQ(n1) {
    zt.free_csg_mesh(n1);
}
var kQ = {
    ConeGeometry: c3,
    CubeGeometry: u3,
    CylinderGeometry: yx,
    DodecahedronGeometry: h3,
    EllipseGeometry: Kd,
    HelixGeometry: B3,
    IcosahedronGeometry: F3,
    LatheGeometry: V3,
    NonParametricGeometry: G3,
    PolygonGeometry: Px,
    PyramidGeometry: j3,
    RectangleGeometry: Jd,
    SphereGeometry: H3,
    PlaneGeometry: W3,
    BackdropGeometry: q3,
    StarGeometry: _x,
    TextFrameGeometry: X3,
    TorusGeometry: Y3,
    TorusKnotGeometry: K3,
    TriangleGeometry: Q3,
    PathGeometry: eL,
    VectorGeometry: kn
}, eT = (n1)=>kQ[n1.type].create(n1);
function rf(n1) {
    return n1 !== null && "booleanOp" in n1;
}
var nf = class extends zd(Mt) {
    constructor(){
        super(...arguments);
        this.booleanMeshSetAddress = -1;
        this.booleanWasTransformed = !1;
        this.booleanMatrixInvOld = new ue;
    }
    updateVisible(e) {
        super.updateVisible(e), this.visible = !rf(this.parent) && this.visible, rf(this.parent) && this.parent.invalidateDownstreamBooleanData();
    }
    freeBooleanPointer() {
        this.booleanMeshSetAddress !== -1 && (_s.freeMeshSet(this.booleanMeshSetAddress), this.booleanMeshSetAddress = -1);
    }
    invalidateDownstreamBooleanData(e = !1) {
        return e ? this.booleanWasTransformed = !0 : this.freeBooleanPointer(), rf(this.parent) ? this.parent.invalidateDownstreamBooleanData() : this;
    }
    invalidateUpstreamBooleanData() {
        this.freeBooleanPointer();
        for (let e of this.children)e instanceof nf && (e.freeBooleanPointer(), rf(e) && e.invalidateUpstreamBooleanData());
    }
    updateTransformState(e, r) {
        let i = super.updateTransformState(e, r);
        return i && rf(this.parent) && this.invalidateDownstreamBooleanData(!0), i;
    }
    onVariableUpdate(e = !1) {
        super.onVariableUpdate(e), rf(this.parent) && this.invalidateDownstreamBooleanData(!0);
    }
};
var Bx = new Yt;
function Ym(n1, t = 0, e = n1.count, r, i) {
    let s1 = 1 / 0, o = 1 / 0, a = 1 / 0, l = -1 / 0, c = -1 / 0, u1 = -1 / 0;
    for(let h = t; h < e; h++){
        let d = n1.getX(h), f = n1.getY(h), m = n1.getZ(h);
        d < s1 && (s1 = d), f < o && (o = f), m < a && (a = m), d > l && (l = d), f > c && (c = f), m > u1 && (u1 = m);
    }
    Bx.min.set(s1, o, a), Bx.max.set(l, c, u1), Bx.getCenter(r), Bx.getSize(i).multiplyScalar(.5);
}
var zQ = new Ce, GQ = new un, nr = class extends nf {
    constructor(t, e){
        super(zQ, GQ), this.super_Entity(t, e);
    }
    updateState(t, e) {
        this.updateState_Entity(t, e);
    }
    updateEntityBoxSize(t, e) {
        let r = this.geometry.getAttribute("position");
        r !== void 0 ? Ym(r, this.geometry.drawRange.start, this.geometry.drawRange.count < 1 / 0 ? this.geometry.drawRange.count : r.count, t, e) : super.updateEntityBoxSize(t, e);
    }
};
var Ka = class {
    constructor(t){
        this.hashProperties = void 0;
        this.isNode = !0;
        this.shortcuts = {};
        if (Ka.uuidContext === null) throw new Error("plz startContext");
        Ka.uuidContext === Ka.globalContext ? this.uuid = "_gid" + Ka.uuidContext.nodeContextUuid++ : this.uuid = "_uid" + Ka.uuidContext.nodeContextUuid++, this.type = t, this.name = "";
    }
    static startContext(t) {
        this.uuidContext === null || this.uuidContext === Ka.globalContext ? this.uuidContext = t : console.error("Can't start context twice");
    }
    static endContext(t) {
        this.uuidContext !== t && console.error("Can't end context twice"), this.uuidContext = null;
    }
    analyze(t, e) {
        e = e ?? {}, t.analyzing = !0, this.build(t.addFlow(e.slot, e.cache, e.context), "v4"), t.clearVertexNodeCode(), t.clearFragmentNodeCode(), t.removeFlow(), t.analyzing = !1;
    }
    analyzeAndFlow(t, e, r) {
        return r = r ?? {}, this.analyze(t, r), this.flow(t, e, r);
    }
    flow(t, e, r) {
        r = r ?? {}, t.addFlow(r.slot, r.cache, r.context);
        let i = {
            result: this.build(t, e),
            code: t.clearNodeCode(),
            extra: t.context.extra
        };
        return t.removeFlow(), i;
    }
    build(t, e, r) {
        e = e ?? this.getType(t, e);
        let i = t.getNodeData(r ?? this);
        return t.analyzing && this.appendDepsNode(t, i, e), t.nodes.indexOf(this) === -1 && t.nodes.push(this), this.updateFrame !== void 0 && t.updaters.indexOf(this) === -1 && t.updaters.push(this), this.generate(t, e, r);
    }
    updateFrame(t) {}
    generateReadonly(t, e, r, i, s1, o) {
        return "";
    }
    generate(t, e, r, i, s1) {
        return "";
    }
    parse(t, e, r, i) {}
    appendDepsNode(t, e, r) {
        e.deps = (e.deps || 0) + 1;
        let i = t.getTypeLength(r);
        (i > (e.outputMax || 0) || this.getType(t, r)) && (e.outputMax = i, e.output = r);
    }
    setName(t) {
        this.name = t;
    }
    getName() {
        return this.name;
    }
    getType(t, e) {
        return e === "sampler2D" || e === "samplerCube" ? e : this.type;
    }
}, pr = Ka;
pr.globalContext = {
    nodeContextUuid: 0
}, pr.uuidContext = Ka.globalContext;
var Km = class {
    constructor(t){
        t = t ?? {}, this.name = t.name, this.type = t.type, this.node = t.node, this.size = t.size, this.needsUpdate = t.needsUpdate;
    }
    get value() {
        return this.node.value;
    }
    set value(t) {
        this.node.value = t;
    }
};
var sT = class {
    constructor(){
        this.nodes = {};
        this.keywords = {};
    }
    add(t) {
        this.nodes[t.name] = t;
    }
    addKeyword(t, e, r) {
        r = r !== void 0 ? r : !0, this.keywords[t] = {
            callback: e,
            cache: r
        };
    }
    remove(t) {
        delete this.nodes[t.name];
    }
    removeKeyword(t) {
        delete this.keywords[t];
    }
    get(t) {
        return this.nodes[t];
    }
    getKeyword(t, e) {
        return this.keywords[t].callback(e);
    }
    getKeywordData(t) {
        return this.keywords[t];
    }
    contains(t) {
        return this.nodes[t] !== void 0;
    }
    containsKeyword(t) {
        return this.keywords[t] !== void 0;
    }
}, Bi = new sT;
var rt = class extends pr {
    constructor(e, r){
        super(e);
        this.scope = "";
        r = r ?? {}, this.shared = r.shared !== void 0 ? r.shared : !0, this.unique = r.unique !== void 0 ? r.unique : !1;
    }
    build(e, r, i, s1) {
        if (r = r ?? this.getType(e), this.getShared(e, r)) {
            let o = this.getUnique(e, r);
            o && this.uuid === void 0 && (this.uuid = Se.generateUUID()), i = e.getUUID(i ?? this.getUUID(), !o);
            let a = e.getNodeData(i), l = a.output || this.getType(e);
            if (e.analyzing) return (a.deps || 0) > 0 || this.getLabel() ? (this.appendDepsNode(e, a, r), this.generate(e, r, i)) : super.build(e, r, i);
            if (o) return a.name = a.name || super.build(e, r, i), a.name;
            if (!this.getLabel() && (!this.getShared(e, l) || e.context.ignoreCache || a.deps === 1)) return super.build(e, r, i);
            i = this.getUUID(!1);
            let c = this.getTemp(e, i);
            if (c) return e.format(c, l, r);
            {
                c = super.generate(e, r, i, a.output, s1);
                let u1 = this.generate(e, l, i);
                return e.addNodeCode(c + " = " + u1 + ";"), e.format(c, l, r);
            }
        }
        return super.build(e, r, i);
    }
    getShared(e, r) {
        return r !== "sampler2D" && r !== "samplerCube" && this.shared;
    }
    getUnique(e, r) {
        return this.unique;
    }
    setLabel(e) {
        return this.label = e, this;
    }
    getLabel() {
        return this.label;
    }
    getUUID(e) {
        let r = this.uuid;
        return typeof this.scope == "string" && (r = this.scope + "-" + r), r;
    }
    getTemp(e, r) {
        r = r || this.uuid;
        let i = e.getVars()[r];
        return i ? i.name : void 0;
    }
    generate(e, r, i, s1, o) {
        return this.getShared(e, r) || console.error("TempNode is not shared"), i = i ?? this.uuid, e.getTempVar(i, s1 ?? this.getType(e), o, this.getLabel()).name;
    }
};
var mr = class extends rt {
    constructor(e, r){
        r = r ?? {}, r.shared = r.shared !== void 0 ? r.shared : !1;
        super(e, r);
        this.readonly = !1;
    }
    setReadonly(e) {
        return this.readonly = e, this.hashProperties = this.readonly ? [
            "value"
        ] : void 0, this;
    }
    getReadonly() {
        return this.readonly;
    }
    generate(e, r, i, s1, o, a) {
        i = e.getUUID(i ?? this.getUUID()), s1 = s1 ?? this.getType(e);
        let l = e.getNodeData(i);
        return this.getReadonly() && this.generateReadonly !== void 0 ? this.generateReadonly(e, r, i, s1, o, a) : e.isShader("vertex") ? (l.vertex || (l.vertex = e.createVertexUniform(s1, this, o, a, this.getLabel())), e.format(l.vertex.name, s1, r)) : (l.fragment || (l.fragment = e.createFragmentUniform(s1, this, o, a, this.getLabel())), e.format(l.fragment.name, s1, r));
    }
};
var Zr = class extends mr {
    constructor(e = 0, r){
        super("v2");
        this.nodeType = "Vector2";
        this.value = e instanceof U ? e : new U(e, r);
    }
    get x() {
        return this.value.x;
    }
    set x(e) {
        this.value.x = e;
    }
    get y() {
        return this.value.y;
    }
    set y(e) {
        this.value.y = e;
    }
    generateReadonly(e, r, i, s1, o, a) {
        return e.format("vec2(" + this.value.x + ", " + this.value.y + ")", s1, r);
    }
};
var Ji = class extends mr {
    constructor(e = 0, r, i){
        super("v3");
        this.nodeType = "Vector3";
        this.value = e instanceof E ? e : new E(e, r, i);
    }
    get x() {
        return this.value.x;
    }
    set x(e) {
        this.value.x = e;
    }
    get y() {
        return this.value.y;
    }
    set y(e) {
        this.value.y = e;
    }
    get z() {
        return this.value.z;
    }
    set z(e) {
        this.value.z = e;
    }
    generateReadonly(e, r, i, s1, o, a) {
        return e.format("vec3(" + this.value.x + ", " + this.value.y + ", " + this.value.z + ")", s1, r);
    }
};
var zn = class extends mr {
    constructor(e){
        super("v4");
        this.nodeType = "Vector4";
        this.value = e instanceof cr ? e : new cr(e.r, e.g, e.b, e.a);
    }
    generateReadonly(e, r, i, s1, o, a) {
        return e.format("vec4(" + this.value.r + ", " + this.value.g + ", " + this.value.b + ", " + this.value.a + ")", s1, r);
    }
};
var jQ = /^\s*([a-z_0-9]+)\s([a-z_0-9]+)\s*\((.*?)\)/i, pL = /[a-z_0-9]+/gi, Ae = class extends rt {
    constructor(e, r, i, s1, o){
        super(o);
        this.src = "";
        this.nodeType = "Function";
        this.useKeywords = !0;
        this.includes = [];
        this.extensions = {};
        this.keywords = {};
        this.isMethod = o === void 0, this.isInterface = !1, this.parse(e, r, i, s1);
    }
    getShared(e, r) {
        return !this.isMethod;
    }
    getType(e) {
        return e.getTypeByFormat(this.type);
    }
    getInputByName(e) {
        if (this.inputs) {
            let r = this.inputs.length;
            for(; r--;)if (this.inputs[r].name === e) return this.inputs[r];
        }
    }
    getIncludeByName(e) {
        if (this.includes) {
            let r = this.includes.length;
            for(; r--;)if (this.includes[r].name === e) return this.includes[r];
        }
    }
    generate(e, r, i, s1, o) {
        let a, l = 0, c = this.src;
        if (this.includes) for(let h = 0; h < this.includes.length; h++)e.include(this.includes[h], this);
        for(let h in this.extensions)e.extensions[h] = !0;
        let u1 = [];
        for(; a = pL.exec(this.src);)u1.push(a);
        for(let h = 0; h < u1.length; h++){
            let d = u1[h], f = d[0], m = this.isMethod ? !this.getInputByName(f) : !0, p = f;
            if (this.keywords[f] || this.useKeywords && m && Bi.containsKeyword(f)) {
                let g = this.keywords[f];
                if (!g) {
                    let y = Bi.getKeywordData(f);
                    y.cache && (g = e.keywords[f]), g = g || Bi.getKeyword(f, e), y.cache && (e.keywords[f] = g);
                }
                p = g.build(e);
            }
            f !== p && c[d.index + l - 1] !== "." && (c = c.substring(0, d.index + l) + p + c.substring(d.index + f.length + l), l += p.length - f.length), this.getIncludeByName(p) === void 0 && Bi.contains(p) && e.include(Bi.get(p));
        }
        return r === "source" ? c : this.isMethod ? (this.isInterface || e.include(this, void 0, c), this.name) : e.format("( " + c + " )", this.getType(e), r);
    }
    parse(e, r, i, s1) {
        if (this.src = e || "", this.includes = r ?? [], this.extensions = i ?? {}, this.keywords = s1 ?? {}, this.isMethod) {
            let o = jQ.exec(this.src);
            if (this.inputs = [], o && o.length == 4) {
                this.type = o[1], this.name = o[2];
                let a = o[3].match(pL);
                if (a) {
                    let l = 0;
                    for(; l < a.length;){
                        let c = a[l++], u1;
                        c === "in" || c === "out" || c === "inout" ? u1 = a[l++] : (u1 = c, c = "");
                        let h = a[l++];
                        this.inputs.push({
                            name: h,
                            type: u1,
                            qualifier: c
                        });
                    }
                }
                this.isInterface = this.src.indexOf("{") === -1;
            } else this.type = "", this.name = "";
        }
    }
};
var HQ = /^([a-z_0-9]+)\s([a-z_0-9]+)\s?\=?\s?(.*?)(\;|$)/i, oT = class extends rt {
    constructor(e = "", r){
        super();
        this.src = "";
        this.useDefine = !1;
        this.nodeType = "Const";
        this.parse(e || oT.PI, void 0, void 0, void 0, r);
    }
    getType(e) {
        return e.getTypeByFormat(this.type);
    }
    parse(e, r, i, s1, o) {
        this.src = e || "";
        let a, l, c = "", u1 = HQ.exec(e);
        this.useDefine = o ?? this.src.charAt(0) === "#", u1 && u1.length > 1 ? (l = u1[1], a = u1[2], c = u1[3]) : (a = this.src, l = "f"), this.name = a, this.type = l, this.value = c;
    }
    build(e, r) {
        if (r === "source") {
            if (this.value) return this.useDefine ? "#define " + this.name + " " + this.value : "const " + this.type + " " + this.name + " = " + this.value + ";";
            if (this.useDefine) return this.src;
        }
        return e.include(this), e.format(this.name, this.getType(e), r);
    }
    generate(e, r, i, s1, o) {
        return e.format(this.name, this.getType(e), r);
    }
}, Ht = oT;
Ht.PI = "PI", Ht.PI2 = "PI2", Ht.RECIPROCAL_PI = "RECIPROCAL_PI", Ht.RECIPROCAL_PI2 = "RECIPROCAL_PI2", Ht.LOG2 = "LOG2", Ht.EPSILON = "EPSILON";
var WQ = new RegExp(`^structs*([a-z_0-9]+)s*{s*((.|
)*?)}`, "gim"), qQ = new RegExp("s*(w*?)s*(w*?)(=|;)", "gim"), sf = class extends rt {
    constructor(e = ""){
        super();
        this.inputs = [];
        this.src = "";
        this.nodeType = "Struct";
        this.parse(e);
    }
    getType(e) {
        return e.getTypeByFormat(this.name);
    }
    getInputByName(e) {
        let r = this.inputs.length;
        for(; r--;)if (this.inputs[r].name === e) return this.inputs[r];
    }
    generate(e, r, i, s1, o) {
        return r === "source" ? this.src + ";" : e.format("( " + this.src + " )", this.getType(e), r);
    }
    parse(e = "") {
        this.src = e, this.inputs = [];
        let r = WQ.exec(e);
        if (r) {
            let i = r[2], s1;
            for(; s1 = qQ.exec(i);)this.inputs.push({
                type: s1[1],
                name: s1[2]
            });
            this.name = r[1];
        } else this.name = "";
        this.type = this.name;
    }
};
var of = class extends rt {
    constructor(e){
        super("v2", {
            shared: !1
        });
        this.nodeType = "UV";
        this.index = e ?? 0;
    }
    generate(e, r) {
        e.requires.uv[this.index] = !0;
        let i = this.index > 0 ? this.index + 1 : "", s1 = e.isShader("vertex") ? "uv" + i : "vUv" + i;
        return e.format(s1, this.getType(e), r);
    }
};
Bi.addKeyword("uv", function() {
    return new of;
});
Bi.addKeyword("uv2", function() {
    return new of(1);
});
var hu = class extends rt {
    constructor(e, r){
        super("v4");
        this.nodeType = "ColorSpace";
        this.input = e, this.method = r ?? hu.LINEAR_TO_LINEAR, this.hashProperties = [
            "method"
        ];
    }
    static getEncodingComponents(e) {
        switch(e){
            case xn:
                return [
                    "Linear"
                ];
            case ut:
                return [
                    "sRGB"
                ];
            default:
                return [];
        }
    }
    generate(e, r) {
        let i = this.input.build(e, "v4"), s1 = this.getType(e), o = hu.Nodes[this.method], a = e.include(o);
        if (a === hu.LINEAR_TO_LINEAR) return e.format(i, s1, r);
        if (o.inputs?.length === 2) {
            let l = this.factor.build(e, "f");
            return e.format(a + "( " + i + ", " + l + " )", s1, r);
        } else return e.format(a + "( " + i + " )", s1, r);
    }
    fromEncoding(e) {
        let r = hu.getEncodingComponents(e);
        this.method = "LinearTo" + r[0], this.factor = r[1];
    }
    fromDecoding(e) {
        let r = hu.getEncodingComponents(e);
        this.method = r[0] + "ToLinear", this.factor = r[1];
    }
}, Tn = hu;
Tn.Nodes = {
    LinearToLinear: new Ae([
        "vec4 LinearToLinear( in vec4 value ) {",
        "	return value;",
        "}"
    ].join(`
`)),
    sRGBToLinear: new Ae([
        "vec4 sRGBToLinear( in vec4 value ) {",
        "	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.w );",
        "}"
    ].join(`
`)),
    LinearTosRGB: new Ae([
        "vec4 LinearTosRGB( in vec4 value ) {",
        "	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.w );",
        "}"
    ].join(`
`))
}, Tn.LINEAR_TO_LINEAR = "LinearToLinear", Tn.SRGB_TO_LINEAR = "sRGBToLinear", Tn.LINEAR_TO_SRGB = "LinearTosRGB";
var er = class extends Ae {
    constructor(e = "", r, i, s1, o){
        super(e, o, s1, i, r);
        this.nodeType = "Expression";
    }
};
var Mn = class extends mr {
    constructor(e = new Zt, r, i, s1){
        super("v4", {
            shared: !0
        });
        this.nodeType = "Texture";
        this.value = e, this.uv = r ?? new of, this.bias = i, this.project = s1 !== void 0 ? s1 : !1;
    }
    getTexture(e, r) {
        return super.generate(e, r, this.value.uuid, "t");
    }
    generate(e, r) {
        if (r === "sampler2D") return this.getTexture(e, r);
        let i = this.getTexture(e, r), s1 = this.uv.build(e, this.project ? "v4" : "v2"), o = this.bias ? this.bias.build(e, "f") : void 0;
        o === void 0 && e.context.bias && (o = e.context.bias.setTexture(this).build(e, "f"));
        let a, l;
        this.project ? a = "texture2DProj" : a = o ? "tex2DBias" : "tex2D", o ? l = a + "( " + i + ", " + s1 + ", " + o + " )" : l = a + "( " + i + ", " + s1 + " )";
        let c = {
            include: e.isShader("vertex"),
            ignoreCache: !0
        }, u1 = this.getType(e);
        return e.addContext(c), this.colorSpace = this.colorSpace ?? new Tn(new er("", u1)), this.colorSpace.fromDecoding(e.getTextureEncodingFromMap(this.value)), this.colorSpace.input.parse(l), l = this.colorSpace.build(e, u1), e.removeContext(), e.format(l, u1, r);
    }
};
var Ve = class extends mr {
    constructor(e){
        super("f");
        this.nodeType = "Float";
        this.value = e ?? 0;
    }
    generateReadonly(e, r, i, s1, o, a) {
        return e.format(this.value + (this.value % 1 ? "" : ".0"), s1, r);
    }
};
var Qm = class extends rt {
    constructor(e, r){
        super();
        this.inputs = [];
        this.nodeType = "FunctionCall";
        this.value = e, this.inputs = r ?? [];
    }
    getFunction() {
        return this.value;
    }
    getType(e) {
        return this.value.getType(e);
    }
    generate(e, r, i, s1, o) {
        s1 = this.getType(e);
        let a = this.value, l = a.build(e, r) + "( ", c = [];
        if (a.inputs) {
            for(let u1 = 0; u1 < a.inputs.length; u1++){
                let h = a.inputs[u1], d = this.inputs[u1] || this.inputs[h.name];
                c.push(d.build(e, e.getTypeByFormat(h.type)));
            }
            l += c.join(", ") + " )";
        }
        return e.format(l, s1, r);
    }
};
var aT = class extends rt {
    constructor(e, r, i = aT.ADD){
        super();
        this.nodeType = "Operator";
        this.type = e.type, this.a = e, this.b = r, this.op = i;
    }
    getType(e) {
        let r = this.a.getType(e), i = this.b.getType(e);
        return e.isTypeMatrix(r) ? "v4" : e.getTypeLength(i) > e.getTypeLength(r) ? i : r;
    }
    generate(e, r) {
        let i = this.getType(e);
        this.type = i;
        let s1 = this.a.build(e, i), o = this.b.build(e, i);
        return e.format("( " + s1 + " " + this.op + " " + o + " )", i, r);
    }
}, qi = aT;
qi.ADD = "+", qi.SUB = "-", qi.MUL = "*", qi.DIV = "/";
var gr = class extends rt {
    constructor(e, r = gr.ABS, i, s1){
        super();
        this.nodeType = "Math";
        this.a = e, typeof r != "string" ? this.b = r : s1 = r, typeof i != "string" ? this.c = i : s1 = i, this.method = s1, this.hashProperties = [
            "method"
        ];
    }
    getNumInputs(e) {
        switch(this.method){
            case gr.MIX:
            case gr.CLAMP:
            case gr.REFRACT:
            case gr.SMOOTHSTEP:
            case gr.FACEFORWARD:
                return 3;
            case gr.MIN:
            case gr.MAX:
            case gr.MOD:
            case gr.STEP:
            case gr.REFLECT:
            case gr.DISTANCE:
            case gr.DOT:
            case gr.CROSS:
            case gr.POW:
                return 2;
            default:
                return 1;
        }
    }
    getInputType(e) {
        let r = e.getTypeLength(this.a.getType(e)), i = this.b ? e.getTypeLength(this.b.getType(e)) : 0, s1 = this.c ? e.getTypeLength(this.c.getType(e)) : 0;
        return r > i && r > s1 ? this.a.getType(e) : i > s1 ? this.b.getType(e) : this.c.getType(e);
    }
    getType(e) {
        switch(this.method){
            case gr.LENGTH:
            case gr.DISTANCE:
            case gr.DOT:
                return "f";
            case gr.CROSS:
                return "v3";
        }
        return this.getInputType(e);
    }
    generate(e, r) {
        let i, s1, o, a = this.a ? e.getTypeLength(this.a.getType(e)) : 0, l = this.b ? e.getTypeLength(this.b.getType(e)) : 0, c = this.c ? e.getTypeLength(this.c.getType(e)) : 0, u1 = this.getInputType(e), h = this.getType(e);
        switch(this.type = h, this.method){
            case gr.NEGATE:
                return e.format("( -" + this.a.build(e, u1) + " )", u1, r);
            case gr.INVERT:
                return e.format("( 1.0 - " + this.a.build(e, u1) + " )", u1, r);
            case gr.CROSS:
                i = this.a.build(e, "v3"), s1 = this.b.build(e, "v3");
                break;
            case gr.STEP:
                i = this.a.build(e, a === 1 ? "f" : u1), s1 = this.b.build(e, u1);
                break;
            case gr.MIN:
            case gr.MAX:
            case gr.MOD:
                i = this.a.build(e, u1), s1 = this.b.build(e, l === 1 ? "f" : u1);
                break;
            case gr.REFRACT:
                i = this.a.build(e, u1), s1 = this.b.build(e, u1), o = this.c.build(e, "f");
                break;
            case gr.MIX:
                i = this.a.build(e, u1), s1 = this.b.build(e, u1), o = this.c.build(e, c === 1 ? "f" : u1);
                break;
            default:
                i = this.a.build(e, u1), this.b && (s1 = this.b.build(e, u1)), this.c && (o = this.c.build(e, u1));
                break;
        }
        let d = [];
        d.push(i), s1 && d.push(s1), o && d.push(o);
        let f = this.getNumInputs(e);
        if (d.length !== f) throw Error(`Arguments not match used in "${this.method}". Require ${f}, currently ${d.length}.`);
        return e.format(this.method + "( " + d.join(", ") + " )", h, r);
    }
}, mt = gr;
mt.RAD = "radians", mt.DEG = "degrees", mt.EXP = "exp", mt.EXP2 = "exp2", mt.LOG = "log", mt.LOG2 = "log2", mt.SQRT = "sqrt", mt.INV_SQRT = "inversesqrt", mt.FLOOR = "floor", mt.CEIL = "ceil", mt.NORMALIZE = "normalize", mt.FRACT = "fract", mt.SATURATE = "saturate", mt.SIN = "sin", mt.COS = "cos", mt.TAN = "tan", mt.ASIN = "asin", mt.ACOS = "acos", mt.ARCTAN = "atan", mt.ABS = "abs", mt.SIGN = "sign", mt.LENGTH = "length", mt.NEGATE = "negate", mt.INVERT = "invert", mt.MIN = "min", mt.MAX = "max", mt.MOD = "mod", mt.STEP = "step", mt.REFLECT = "reflect", mt.DISTANCE = "distance", mt.DOT = "dot", mt.CROSS = "cross", mt.POW = "pow", mt.MIX = "mix", mt.CLAMP = "clamp", mt.REFRACT = "refract", mt.SMOOTHSTEP = "smoothstep", mt.FACEFORWARD = "faceforward";
var af = class extends rt {
    constructor(e, r, i){
        super("v4");
        this.nodeType = "TextureCubeUV";
        this.value = e, this.uv = r, this.bias = i;
    }
    bilinearCubeUV(e, r, i, s1) {
        let o = new Qm(af.Nodes.bilinearCubeUV, [
            r,
            i,
            s1
        ]);
        this.colorSpaceTL = this.colorSpaceTL ?? new Tn(new er("", "v4")), this.colorSpaceTL.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceTL.input.parse(o.build(e) + ".tl"), this.colorSpaceTR = this.colorSpaceTR ?? new Tn(new er("", "v4")), this.colorSpaceTR.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceTR.input.parse(o.build(e) + ".tr"), this.colorSpaceBL = this.colorSpaceBL ?? new Tn(new er("", "v4")), this.colorSpaceBL.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceBL.input.parse(o.build(e) + ".bl"), this.colorSpaceBR = this.colorSpaceBR ?? new Tn(new er("", "v4")), this.colorSpaceBR.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceBR.input.parse(o.build(e) + ".br");
        let a = {
            include: e.isShader("vertex"),
            ignoreCache: !0
        };
        e.addContext(a), this.colorSpaceTLExp = new er(this.colorSpaceTL.build(e, "v4"), "v4"), this.colorSpaceTRExp = new er(this.colorSpaceTR.build(e, "v4"), "v4"), this.colorSpaceBLExp = new er(this.colorSpaceBL.build(e, "v4"), "v4"), this.colorSpaceBRExp = new er(this.colorSpaceBR.build(e, "v4"), "v4"), e.removeContext();
        let l = new er("mix( mix( cubeUV_TL, cubeUV_TR, cubeUV.f.x ), mix( cubeUV_BL, cubeUV_BR, cubeUV.f.x ), cubeUV.f.y )", "v4");
        return l.keywords.cubeUV_TL = this.colorSpaceTLExp, l.keywords.cubeUV_TR = this.colorSpaceTRExp, l.keywords.cubeUV_BL = this.colorSpaceBLExp, l.keywords.cubeUV_BR = this.colorSpaceBRExp, l.keywords.cubeUV = o, l;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            let i = this.uv, s1 = this.bias || e.context.roughness, o = new Qm(af.Nodes.roughnessToMip, [
                s1
            ]), a = new mt(o, af.Nodes.m0, af.Nodes.cubeUV_maxMipLevel, mt.CLAMP), l = new mt(a, mt.FLOOR), c = new mt(a, mt.FRACT), u1 = this.bilinearCubeUV(e, this.value, i, l), h = this.bilinearCubeUV(e, this.value, i, new qi(l, new Ve(1).setReadonly(!0), qi.ADD)), d = new mt(u1, h, c, mt.MIX);
            return e.format(d.build(e), "v4", r);
        } else return console.warn("TextureCubeUVNode is not compatible with " + e.shader + " shader."), e.format("vec4( 0.0 )", this.getType(e), r);
    }
}, lf = af;
lf.Nodes = function() {
    let e = new sf(`struct TextureCubeUVData {
			vec4 tl;
			vec4 tr;
			vec4 br;
			vec4 bl;
			vec2 f;
		}`), r = new Ht("float cubeUV_maxMipLevel 8.0", !0), i = new Ht("float cubeUV_minMipLevel 4.0", !0), s1 = new Ht("float cubeUV_maxTileSize 256.0", !0), o = new Ht("float cubeUV_minTileSize 16.0", !0), a = new Ae(`float getFace(vec3 direction) {
				vec3 absDirection = abs(direction);
				float face = -1.0;
				if (absDirection.x > absDirection.z) {
					if (absDirection.x > absDirection.y)
						face = direction.x > 0.0 ? 0.0 : 3.0;
					else
						face = direction.y > 0.0 ? 1.0 : 4.0;
				} else {
					if (absDirection.z > absDirection.y)
						face = direction.z > 0.0 ? 2.0 : 5.0;
					else
						face = direction.y > 0.0 ? 1.0 : 4.0;
				}
				return face;
		}`);
    a.useKeywords = !1;
    let l = new Ae(`vec2 getUV(vec3 direction, float face) {
				vec2 uv;
				if (face == 0.0) {
					uv = vec2(direction.z, direction.y) / abs(direction.x); // pos x
				} else if (face == 1.0) {
					uv = vec2(-direction.x, -direction.z) / abs(direction.y); // pos y
				} else if (face == 2.0) {
					uv = vec2(-direction.x, direction.y) / abs(direction.z); // pos z
				} else if (face == 3.0) {
					uv = vec2(-direction.z, direction.y) / abs(direction.x); // neg x
				} else if (face == 4.0) {
					uv = vec2(-direction.x, direction.z) / abs(direction.y); // neg y
				} else {
					uv = vec2(direction.x, direction.y) / abs(direction.z); // neg z
				}
				return 0.5 * (uv + 1.0);
		}`);
    l.useKeywords = !1;
    let c = new Ae(`TextureCubeUVData bilinearCubeUV(sampler2D envMap, vec3 direction, float mipInt) {
			float face = getFace(direction);
			float filterInt = max(cubeUV_minMipLevel - mipInt, 0.0);
			mipInt = max(mipInt, cubeUV_minMipLevel);
			float faceSize = exp2(mipInt);
			float texelSize = 1.0 / (3.0 * cubeUV_maxTileSize);
			vec2 uv = getUV(direction, face) * (faceSize - 1.0);
			vec2 f = fract(uv);
			uv += 0.5 - f;
			if (face > 2.0) {
				uv.y += faceSize;
				face -= 3.0;
			}
			uv.x += face * faceSize;
			if(mipInt < cubeUV_maxMipLevel){
				uv.y += 2.0 * cubeUV_maxTileSize;
			}
			uv.y += filterInt * 2.0 * cubeUV_minTileSize;
			uv.x += 3.0 * max(0.0, cubeUV_maxTileSize - 2.0 * faceSize);
			uv *= texelSize;
			vec4 tl = texture2D(envMap, uv);
			uv.x += texelSize;
			vec4 tr = texture2D(envMap, uv);
			uv.y += texelSize;
			vec4 br = texture2D(envMap, uv);
			uv.x -= texelSize;
			vec4 bl = texture2D(envMap, uv);
			return TextureCubeUVData( tl, tr, br, bl, f );
		}`, [
        e,
        a,
        l,
        r,
        i,
        s1,
        o
    ]);
    c.useKeywords = !1;
    let u1 = new Ht("float r0 1.0", !0), h = new Ht("float v0 0.339", !0), d = new Ht("float m0 -2.0", !0), f = new Ht("float r1 0.8", !0), m = new Ht("float v1 0.276", !0), p = new Ht("float m1 -1.0", !0), g = new Ht("float r4 0.4", !0), y = new Ht("float v4 0.046", !0), x = new Ht("float m4 2.0", !0), v = new Ht("float r5 0.305", !0), b = new Ht("float v5 0.016", !0), w = new Ht("float m5 3.0", !0), A = new Ht("float r6 0.21", !0), T = new Ht("float v6 0.0038", !0), S = new Ht("float m6 4.0", !0), M = [
        u1,
        h,
        d,
        f,
        m,
        p,
        g,
        y,
        x,
        v,
        b,
        w,
        A,
        T,
        S
    ], C = new Ae(`float roughnessToMip(float roughness) {
			float mip = 0.0;
			if (roughness >= r1) {
				mip = (r0 - roughness) * (m1 - m0) / (r0 - r1) + m0;
			} else if (roughness >= r4) {
				mip = (r1 - roughness) * (m4 - m1) / (r1 - r4) + m1;
			} else if (roughness >= r5) {
				mip = (r4 - roughness) * (m5 - m4) / (r4 - r5) + m4;
			} else if (roughness >= r6) {
				mip = (r5 - roughness) * (m6 - m5) / (r5 - r6) + m5;
			} else {
				mip = -2.0 * log2(1.16 * roughness);// 1.16 = 1.79^0.25
			}
			return mip;
		}`, M);
    return {
        bilinearCubeUV: c,
        roughnessToMip: C,
        m0: d,
        cubeUV_maxMipLevel: r
    };
}();
var du = class extends rt {
    constructor(e){
        super("v3");
        this.nodeType = "Normal";
        this.scope = e ?? du.VIEW;
    }
    getShared() {
        return this.scope === du.WORLD;
    }
    build(e, r, i, s1) {
        let o = e.context[this.scope + "Normal"];
        return o ? o.build(e, r, i, s1) : super.build(e, r, i);
    }
    generate(e, r, i, s1, o) {
        let a;
        switch(this.scope){
            case du.VIEW:
                e.isShader("vertex") ? a = "transformedNormal" : a = "geometryNormal";
                break;
            case du.LOCAL:
                e.isShader("vertex") ? a = "objectNormal" : (e.requires.normal = !0, a = "vObjectNormal");
                break;
            case du.WORLD:
                e.isShader("vertex") ? a = "inverseTransformDirection( transformedNormal, viewMatrix ).xyz" : (e.requires.worldNormal = !0, a = "vWNormal");
                break;
        }
        return e.format(a, this.getType(e), r);
    }
}, Xi = du;
Xi.LOCAL = "local", Xi.WORLD = "world", Xi.VIEW = "view", Xi.NORMAL = "normal";
Bi.addKeyword("viewNormal", function() {
    return new Xi(Xi.VIEW);
});
Bi.addKeyword("localNormal", function() {
    return new Xi(Xi.NORMAL);
});
Bi.addKeyword("worldNormal", function() {
    return new Xi(Xi.WORLD);
});
var $o = class extends rt {
    constructor(e){
        super("v3");
        this.nodeType = "Position";
        this.scope = e ?? $o.LOCAL;
    }
    getType() {
        switch(this.scope){
            case $o.PROJECTION:
                return "v4";
        }
        return this.type;
    }
    getShader() {
        switch(this.scope){
            case $o.LOCAL:
            case $o.WORLD:
                return !1;
        }
        return !0;
    }
    generate(e, r, i, s1, o) {
        let a;
        switch(this.scope){
            case $o.LOCAL:
                e.isShader("vertex") ? a = "transformed" : (e.requires.position = !0, a = "vPosition");
                break;
            case $o.WORLD:
                if (e.isShader("vertex")) return "( modelMatrix * vec4( transformed, 1.0 ) ).xyz";
                e.requires.worldPosition = !0, a = "vWPosition";
                break;
            case $o.VIEW:
                a = e.isShader("vertex") ? "-mvPosition.xyz" : "vViewPosition";
                break;
            case $o.PROJECTION:
                a = e.isShader("vertex") ? "( projectionMatrix * modelViewMatrix * vec4( position, 1.0 ) )" : "vec4( 0.0 )";
                break;
        }
        return e.format(a, this.getType(), r);
    }
}, Gn = $o;
Gn.LOCAL = "local", Gn.WORLD = "world", Gn.VIEW = "view", Gn.PROJECTION = "projection";
Bi.addKeyword("position", function() {
    return new Gn;
});
Bi.addKeyword("worldPosition", function() {
    return new Gn(Gn.WORLD);
});
Bi.addKeyword("viewPosition", function() {
    return new Gn(Gn.VIEW);
});
var no = class extends rt {
    constructor(e){
        super("v3");
        this.nodeType = "Reflect";
        this.scope = e ?? no.CUBE;
    }
    getUnique(e) {
        return !e.context.viewNormal;
    }
    getType() {
        switch(this.scope){
            case no.SPHERE:
                return "v2";
        }
        return this.type;
    }
    generate(e, r) {
        let i = this.getUnique(e);
        if (e.isShader("fragment")) {
            let s1;
            switch(this.scope){
                case no.VECTOR:
                    {
                        let o = new Xi(Xi.VIEW), a = e.context.roughness, l = o.build(e, "v3"), c = new Gn(Gn.VIEW).build(e, "v3"), u1 = a ? a.build(e, "f") : void 0, h = `reflect( -normalize( ${c} ), ${l} )`;
                        u1 && (h = `normalize( mix( ${h}, ${l}, ${u1} * ${u1} ) )`);
                        let d = `inverseTransformDirection( ${h}, viewMatrix )`;
                        i ? (e.addNodeCode(`vec3 reflectVec = ${d};`), s1 = "reflectVec") : s1 = d;
                        break;
                    }
                case no.CUBE:
                    {
                        let o = new no(no.VECTOR).build(e, "v3"), a = "vec3( -" + o + ".x, " + o + ".yz )";
                        i ? (e.addNodeCode(`vec3 reflectCubeVec = ${a};`), s1 = "reflectCubeVec") : s1 = a;
                        break;
                    }
                case no.SPHERE:
                    {
                        let a = "normalize( ( viewMatrix * vec4( " + new no(no.VECTOR).build(e, "v3") + ", 0.0 ) ).xyz + vec3( 0.0, 0.0, 1.0 ) ).xy * 0.5 + 0.5";
                        i ? (e.addNodeCode(`vec2 reflectSphereVec = ${a};`), s1 = "reflectSphereVec") : s1 = a;
                        break;
                    }
            }
            return e.format(s1, this.getType(), r);
        } else return console.warn("ReflectNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.type, r);
    }
}, ea = no;
ea.CUBE = "cube", ea.SPHERE = "sphere", ea.VECTOR = "vector";
var Fx = class extends rt {
    constructor(e = new Mn, r, i){
        super("v4");
        this.nodeType = "TextureCube";
        this.value = e, this.radianceNode = new lf(this.value, r ?? new ea(ea.VECTOR), i), this.irradianceNode = new lf(this.value, new Xi(Xi.WORLD), new Ve(1).setReadonly(!0));
    }
    generate(e, r) {
        return e.isShader("fragment") ? (e.require("irradiance"), e.context.bias && e.context.bias.setTexture(this.value), (e.slot === "irradiance" ? this.irradianceNode : this.radianceNode).build(e, r)) : (console.warn("TextureCubeNode is not compatible with " + e.shader + " shader."), e.format("vec4( 0.0 )", this.getType(e), r));
    }
};
var Vx = class extends mr {
    constructor(e = new rh, r, i){
        super("v4", {
            shared: !0
        });
        this.nodeType = "CubeTexture";
        this.value = e, this.uv = r ?? new ea, this.bias = i;
    }
    getTexture(e, r) {
        return super.generate(e, r, this.value.uuid, "tc");
    }
    generate(e, r) {
        if (r === "samplerCube") return this.getTexture(e, r);
        let i = this.getTexture(e, r), s1 = this.uv?.build(e, "v3"), o = this.bias ? this.bias.build(e, "f") : void 0;
        o === void 0 && e.context.bias && (o = e.context.bias.setTexture(this).build(e, "f"));
        let a;
        o ? a = "texCubeBias( " + i + ", " + s1 + ", " + o + " )" : a = "texCube( " + i + ", " + s1 + " )";
        let l = {
            include: e.isShader("vertex"),
            ignoreCache: !0
        }, c = this.getType(e);
        return e.addContext(l), this.colorSpace = this.colorSpace ?? new Tn(new er("", c)), this.colorSpace.fromDecoding(e.getTextureEncodingFromMap(this.value)), this.colorSpace.input.parse(a), a = this.colorSpace.build(e, c), e.removeContext(), e.format(a, c, r);
    }
};
var mL = `
uniform int frameIndex;
uniform vec2 resolution;
uniform mat4 previousModelViewMatrix;
uniform mat4 previousProjectionMatrix;

varying vec4 vCurrentPosition;
varying vec4 vPreviousPosition;
`, gL = `
layout(location = 1) out vec4 gVelocity;

uniform int frameIndex;
uniform vec2 resolution;

varying vec4 vCurrentPosition;
varying vec4 vPreviousPosition;

const vec2 haltonSequence[16] = vec2[16](
vec2( 0.000000,-0.333334),
vec2(-0.500000, 0.333334),
vec2( 0.500000,-0.777778),
vec2(-0.750000,-0.111112),
vec2( 0.250000, 0.555556),
vec2(-0.250000,-0.555556),
vec2( 0.750000, 0.111112),
vec2(-0.875000, 0.777778),
vec2(0.125000, -0.925926),
vec2(-0.375000, -0.259260),
vec2(0.625000, 0.407408),
vec2(-0.625000, -0.703704),
vec2(0.375000, -0.037038),
vec2(-0.125000, 0.629630),
vec2(0.875000, -0.481482),
vec2(-0.937500, 0.185186));

vec2 vogelDiskSample(int sampleIndex, int sampleCount, float angle) {
  const float goldenAngle = 2.399963f; // radians
  float r = sqrt(float(sampleIndex) + 0.5f) / sqrt(float(sampleCount));
  float theta = float(sampleIndex) * goldenAngle + angle;
  float sine = sin(theta);
  float cosine = cos(theta);
  return vec2(cosine, sine) * r;
}

// Derived from the interleaved gradient function from Jimenez 2014 http:goo.gl/eomGso
float getNoiseInterleavedGradient(vec2 screenPos) {
    vec3 magic = vec3(0.06711056f, 0.00583715f, 52.9829189f);
    return fract(magic.z * fract(dot(screenPos, magic.xy)));
}

`, yL = `
// TODO: This could be generated CPU side and passed to the shader every frame
const vec2 haltonSequence[16] = vec2[16](
vec2( 0.000000,-0.333334),
vec2(-0.500000, 0.333334),
vec2( 0.500000,-0.777778),
vec2(-0.750000,-0.111112),
vec2( 0.250000, 0.555556),
vec2(-0.250000,-0.555556),
vec2( 0.750000, 0.111112),
vec2(-0.875000, 0.777778),
vec2(0.125000, -0.925926),
vec2(-0.375000, -0.259260),
vec2(0.625000, 0.407408),
vec2(-0.625000, -0.703704),
vec2(0.375000, -0.037038),
vec2(-0.125000, 0.629630),
vec2(0.875000, -0.481482),
vec2(-0.937500, 0.185186));

// TODO: Pass correct view size
vec2 offset = haltonSequence[frameIndex];
offset.x /= resolution.x;
offset.y /= resolution.y;

vec4 currentPosition = gl_Position;
vec4 currentPositionJittered = currentPosition + (vec4(offset.x, offset.y, 0.0, 0.0) * currentPosition.w);

// We want to calculate the velocity with unjittered positions
// so that things that are not moving get a velocity = 0
vCurrentPosition = currentPosition;
vPreviousPosition = previousProjectionMatrix * previousModelViewMatrix * vec4(transformed, 1.0);
#ifdef OUTLINE_COMPENSATION
vPreviousPosition.xy += OUTLINE_COMPENSATION;
#endif
gl_Position = currentPositionJittered;

`, vL = `
vec2 oldPos = vPreviousPosition.xy;
    oldPos /= vPreviousPosition.w;
    oldPos.xy = (oldPos.xy+1.)/2.0;

vec2 newPos = vCurrentPosition.xy;
    newPos /= vCurrentPosition.w;
    newPos.xy = (newPos.xy+1.)/2.0;

vec2 velocity = (newPos - oldPos);

// Discard fully transparent pixels 
if (gl_FragColor.a <= 0.0) discard;

gVelocity = vec4(velocity, 0.0, 1.0);
`, xL = `
layout(location = 1) out vec4 gVelocity;
`, bL = `
    // Discard fully transparent pixels 
    if (gl_FragColor.a <= 0.0) discard;

    gVelocity = vec4(0.0, 0.0, 0.0, 1.0);
`;
var SL = [
    "x",
    "y",
    "z",
    "w"
], XQ = [
    "float",
    "vec2",
    "vec3",
    "vec4"
], YQ = {
    float: "f",
    vec2: "v2",
    vec3: "v3",
    vec4: "v4",
    mat4: "v4",
    int: "i",
    bool: "b",
    "float[]": "f[]",
    "vec4[]": "v4[]"
}, KQ = {
    t: "sampler2D",
    tc: "samplerCube",
    b: "bool",
    i: "int",
    f: "float",
    c: "vec3",
    v2: "vec2",
    v3: "vec3",
    v4: "vec4",
    m3: "mat3",
    m4: "mat4",
    "f[]": "float[]",
    "v4[]": "vec4[]"
}, cf = class {
    constructor(){
        this.includes = {
            consts: {},
            functions: {},
            structs: {}
        };
        this.cache = "";
        this.slot = "";
        this.shader = "";
        this.context = {};
        this.needsJitter = !0;
        this.getIncludesCode = function() {
            function t(e, r) {
                return e.deps.length - r.deps.length;
            }
            return function(r, i) {
                let s1 = this.getIncludes(r, i);
                if (!s1) return "";
                let o = "";
                s1 = s1.sort(t);
                for(let a = 0; a < s1.length; a++)s1[a].src && (o += s1[a].src + `
`);
                return o;
            };
        }();
        this.slots = [], this.caches = [], this.contexts = [], this.keywords = {}, this.nodeData = {}, this.fragmentVariables = {}, this.fragmentParsVariables = {}, this.vertexParsVariables = {}, this.requires = {
            uv: [],
            color: [],
            transparent: !1,
            irradiance: !1,
            position: !1,
            worldPosition: !1,
            normal: !1,
            worldNormal: !1,
            vWorldViewDir: !1,
            modelMatrix: !1,
            viewMatrix: !1,
            projectionMatrix: !1
        }, this.includes = {
            consts: [],
            functions: [],
            structs: []
        }, this.attributes = {}, this.prefixCode = [
            "#ifdef TEXTURE_LOD_EXT",
            "	#define texCube(a, b) textureCube(a, b)",
            "	#define texCubeBias(a, b, c) textureCubeLodEXT(a, b, c)",
            "	#define tex2D(a, b) texture2D(a, b)",
            "	#define tex2DBias(a, b, c) texture2DLodEXT(a, b, c)",
            "#else",
            "	#define texCube(a, b) textureCube(a, b)",
            "	#define texCubeBias(a, b, c) textureCube(a, b, c)",
            "	#define tex2D(a, b) texture2D(a, b)",
            "	#define tex2DBias(a, b, c) texture2D(a, b, c)",
            "#endif",
            `
			// NOTE: Include Spline's blending modes. This could be part of BlendNode
			#define SPE_BLENDING_NORMAL 0
			#define SPE_BLENDING_MULTIPLY 1
			#define SPE_BLENDING_SCREEN 2
			#define SPE_BLENDING_OVERLAY 3

			vec3 spe_normalBlend( vec3 a, vec3 b, float alpha ) {
				return mix( a, b, alpha );
			}

			vec3 spe_multiplyBlend( vec3 a, vec3 b, float alpha ) {
				return mix( a, a * b, alpha );
			}

			vec3 spe_screenBlend( vec3 a, vec3 b, float alpha ) {
				vec3 tmp = 1.0 - ( 1.0 - a ) * ( 1.0 - b );
				return mix( a, tmp, alpha );
			}

			vec3 spe_overlayBlend( vec3 a, vec3 b, float alpha ) {
				vec3 tmp = mix( 1. - 2. * (1. - a) * (1. - b), 2. * a * b, step( a, vec3(.5) ) );
				return clamp( mix( a, tmp, alpha ), 0.0, 1.0 );
			}

			vec3 spe_blend( vec3 a, vec3 b, float alpha, int mode ) {
				if ( mode == SPE_BLENDING_NORMAL ) return spe_normalBlend( a, b, alpha );
				else if ( mode == SPE_BLENDING_MULTIPLY ) return spe_multiplyBlend( a, b, alpha );
				else if ( mode == SPE_BLENDING_SCREEN ) return spe_screenBlend( a, b, alpha );
				else if ( mode == SPE_BLENDING_OVERLAY ) return spe_overlayBlend( a, b, alpha );
				return vec3( 1.0 );
			}
			`,
            "#include <packing>",
            "#include <common>"
        ].join(`
`), this.parsCode = {
            vertex: [
                "float neighbor_offset = 0.0001;",
                ""
            ].join(`
`),
            fragment: [
                "float accumAlpha = 0.0;",
                `void accumulateAlpha(float alpha) {
					accumAlpha += (1.0 - accumAlpha) * alpha;
				}`,
                ""
            ].join(`
`)
        }, this.code = {
            vertex: "",
            fragment: ""
        }, this.nodeCode = {
            vertex: "",
            fragment: ""
        }, this.resultCode = {
            vertex: "",
            fragment: ""
        }, this.finalCode = {
            vertex: "",
            fragment: ""
        }, this.inputs = {
            uniforms: {
                list: [],
                vertex: [],
                fragment: []
            },
            arrayUniforms: {
                list: [],
                vertex: [],
                fragment: []
            },
            vars: {
                varying: [],
                vertex: [],
                fragment: []
            }
        }, this.defines = {}, this.uniforms = {}, this.extensions = {
            derivatives: !1,
            fragDepth: !1,
            drawBuffers: !1,
            shaderTextureLOD: !1
        }, this.updaters = [], this.nodes = [], this.analyzing = !1;
    }
    build(t, e) {
        this.addVertexParsCode(mL), this.addFragmentParsCode(gL), this.buildShader("vertex", t), this.buildShader("fragment", e);
        for(let r = 0; r < this.requires.uv.length; r++)if (this.requires.uv[r]) {
            let i = r > 0 ? r + 1 : "";
            this.addVaryCode("varying vec2 vUv" + i + ";"), r > 0 && this.addVertexParsCode("attribute vec2 uv" + i + ";"), this.addVertexFinalCode("vUv" + i + " = uv" + i + ";");
        }
        return this.requires.color[0] && (this.addVaryCode("varying vec4 vColor;"), this.addVertexParsCode("attribute vec4 color;"), this.addVertexFinalCode("vColor = color;")), this.requires.color[1] && (this.addVaryCode("varying vec4 vColor2;"), this.addVertexParsCode("attribute vec4 color2;"), this.addVertexFinalCode("vColor2 = color2;")), this.requires.position && (this.addVaryCode("varying vec3 vPosition;"), this.addVertexFinalCode("vPosition = transformed;")), this.requires.worldPosition, this.requires.normal && (this.addVaryCode("varying vec3 vObjectNormal;"), this.addVertexFinalCode(`
				#ifndef SHAPEBLEND 
					vObjectNormal = normal;
				#else
					vObjectNormal = objectNormal;
				#endif
			`)), this.requires.modelMatrix && this.addFragmentParsCode("uniform mat4 modelMatrix;"), this.requires.viewMatrix && this.addFragmentParsCode("uniform mat4 viewMatrix;"), this.requires.projectionMatrix && this.addFragmentParsCode("uniform mat4 projectionMatrix;"), this.requires.worldNormal && (this.addVaryCode("varying vec3 vWNormal;"), this.addVertexFinalCode("vWNormal = inverseTransformDirection( transformedNormal, viewMatrix ).xyz;")), this.requires.vWorldViewDir && (this.addVaryCode("varying vec3 vWorldViewDir;"), this.addVertexFinalCode("vWorldViewDir = isPerspectiveMatrix( projectionMatrix ) ?  ( (modelMatrix * vec4(position, 1.0)).xyz - cameraPosition ) : vec3( -viewMatrix[0][2], -viewMatrix[1][2], -viewMatrix[2][2] );")), this.needsJitter && (this.addVertexFinalCode(yL), this.addFragmentFinalCode(vL)), this;
    }
    buildShader(t, e) {
        this.resultCode[t] = e.build(this.setShader(t), "v4");
    }
    setMaterial(t, e) {
        return this.defines = {}, this;
    }
    addFlow(t, e, r) {
        return this.addSlot(t).addCache(e).addContext(r);
    }
    removeFlow() {
        return this.removeSlot().removeCache().removeContext();
    }
    addCache(t) {
        return this.cache = t ?? "", this.caches.push(this.cache), this;
    }
    removeCache() {
        return this.caches.pop(), this.cache = this.caches[this.caches.length - 1] || "", this;
    }
    addContext(t) {
        return this.context = Object.assign({}, this.context, t), this.context.extra = this.context.extra || {}, this.contexts.push(this.context), this;
    }
    removeContext() {
        return this.contexts.pop(), this.context = this.contexts[this.contexts.length - 1] || {}, this;
    }
    addSlot(t) {
        return this.slot = t || "", this.slots.push(this.slot), this;
    }
    removeSlot() {
        return this.slots.pop(), this.slot = this.slots[this.slots.length - 1] || "", this;
    }
    addFragmentVariable(t, e) {
        this.fragmentVariables[t] === void 0 && (this.addFragmentCode(`${e} ${t};`), this.fragmentVariables[t] = "");
    }
    addFragmentParsVariable(t, e) {
        this.fragmentParsVariables[t] === void 0 && (this.addFragmentParsCode(`${e} ${t};`), this.fragmentParsVariables[t] = "");
    }
    addVertexParsVariable(t, e) {
        this.vertexParsVariables[t] === void 0 && (this.addVertexParsCode(`${e} ${t};`), this.vertexParsVariables[t] = "");
    }
    addVertexCode(t) {
        this.addCode(t, "vertex");
    }
    addFragmentCode(t) {
        this.addCode(t, "fragment");
    }
    addCode(t, e) {
        this.code[e ?? this.shader] += t + `
`;
    }
    addVertexNodeCode(t) {
        this.addNodeCode(t, "vertex");
    }
    addFragmentNodeCode(t) {
        this.addNodeCode(t, "fragment");
    }
    addNodeCode(t, e) {
        this.nodeCode[e ?? this.shader] += t + `
`;
    }
    clearNodeCode(t) {
        t = t ?? this.shader;
        let e = this.nodeCode[t];
        return this.nodeCode[t] = "", e;
    }
    clearVertexNodeCode() {
        return this.clearNodeCode("vertex");
    }
    clearFragmentNodeCode() {
        return this.clearNodeCode("fragment");
    }
    addVertexFinalCode(t) {
        this.addFinalCode(t, "vertex");
    }
    addFragmentFinalCode(t) {
        this.addFinalCode(t, "fragment");
    }
    addFinalCode(t, e) {
        this.finalCode[e ?? this.shader] += t + `
`;
    }
    addVertexParsCode(t) {
        this.addParsCode(t, "vertex");
    }
    addFragmentParsCode(t) {
        this.addParsCode(t, "fragment");
    }
    addParsCode(t, e) {
        this.parsCode[e ?? this.shader] += t + `
`;
    }
    addVaryCode(t) {
        this.addVertexParsCode(t), this.addFragmentParsCode(t);
    }
    isCache(t) {
        return this.caches.indexOf(t) !== -1;
    }
    isSlot(t) {
        return this.slots.indexOf(t) !== -1;
    }
    define(t, e) {
        this.defines[t] = e === void 0 ? 1 : e;
    }
    require(t) {
        this.requires[t] = !0;
    }
    isDefined(t) {
        return this.defines[t] !== void 0;
    }
    getVar(t, e, r, i = "varying", s1 = "V", o = "") {
        let a = this.getVars(i), l = a[t];
        if (!l) {
            let c = a.length;
            l = {
                name: r || "node" + s1 + c + (o ? "_" + o : ""),
                type: e
            }, a.push(l), a[t] = l;
        }
        return l;
    }
    getTempVar(t, e, r, i) {
        return this.getVar(t, e, r, this.shader, "T", i);
    }
    getAttribute(t, e) {
        if (!this.attributes[t]) {
            let r = this.getVar(t, e);
            this.addVertexParsCode("attribute " + e + " " + t + ";"), this.addVertexFinalCode(r.name + " = " + t + ";"), this.attributes[t] = {
                varying: r,
                name: t,
                type: e
            };
        }
        return this.attributes[t];
    }
    getCode(t) {
        return [
            this.prefixCode,
            this.parsCode[t],
            this.getVarListCode(this.getVars("varying"), "varying"),
            this.getVarListCode(this.inputs.uniforms[t], "uniform"),
            this.getVarListCode(this.inputs.arrayUniforms[t], "uniform"),
            this.getIncludesCode("consts", t),
            this.getIncludesCode("structs", t),
            this.getIncludesCode("functions", t),
            "void main() {",
            this.getVarListCode(this.getVars(t)),
            this.code[t],
            this.resultCode[t],
            this.finalCode[t],
            "}"
        ].join(`
`);
    }
    getVarListCode(t, e) {
        e = e ?? "";
        let r = "";
        for(let i = 0, s1 = t.length; i < s1; ++i){
            let o = t[i], a = o.type, l = o.name, c = o.size, u1 = this.getFormatByType(a);
            if (u1 === void 0) throw new Error("Node pars " + u1 + " not found.");
            u1.includes("[]") ? r += e + " " + u1.substring(0, u1.length - 2) + " " + l + `[${c}];
` : r += e + " " + u1 + " " + l + `;
`;
        }
        return r;
    }
    getVars(t) {
        return this.inputs.vars[t ?? this.shader];
    }
    getNodeData(t) {
        let e = t instanceof pr ? t.uuid : t;
        return this.nodeData[e] = this.nodeData[e] || {};
    }
    createUniform(t, e, r, i, s1, o) {
        if (e.includes("[]")) {
            let a = this.inputs.arrayUniforms, l = a.list.length, c = new Km({
                type: e,
                size: r.size,
                name: i || "nodeUA" + l + (o ? "_" + o : ""),
                node: r,
                needsUpdate: s1
            });
            return a.list.push(c), a[t].push(c), a[t][c.name] = c, this.uniforms[c.name] = c, c;
        } else {
            let a = this.inputs.uniforms, l = a.list.length, c = new Km({
                type: e,
                name: i || "nodeU" + l + (o ? "_" + o : ""),
                node: r,
                needsUpdate: s1
            });
            return a.list.push(c), a[t].push(c), a[t][c.name] = c, this.uniforms[c.name] = c, c;
        }
    }
    createVertexUniform(t, e, r, i, s1) {
        return this.createUniform("vertex", t, e, r, i, s1);
    }
    createFragmentUniform(t, e, r, i, s1) {
        return this.createUniform("fragment", t, e, r, i, s1);
    }
    include(t, e, r) {
        let i;
        if (t = typeof t == "string" ? Bi.get(t) : t, this.context.include === !1) return t.name;
        t instanceof Ae ? i = this.includes.functions : t instanceof Ht ? i = this.includes.consts : t instanceof sf && (i = this.includes.structs);
        let s1 = i[this.shader] = i[this.shader] || [];
        if (t) {
            let o = s1[t.name];
            if (o || (o = s1[t.name] = {
                node: t,
                deps: []
            }, s1.push(o), o.src = t.build(this, "source")), t instanceof Ae && e && s1[e.name] && s1[e.name].deps.indexOf(t) === -1 && (s1[e.name].deps.push(t), t.includes?.length)) {
                let a = 0;
                do this.include(t.includes[a++], e);
                while (a < t.includes.length);
            }
            return r && (o.src = r), t.name;
        } else throw new Error("Include not found.");
    }
    colorToVectorProperties(t) {
        return t.replace("r", "x").replace("g", "y").replace("b", "z").replace("a", "w");
    }
    colorToVector(t) {
        return t.replace(/c/g, "v3");
    }
    getIncludes(t, e) {
        return this.includes[t][e || this.shader];
    }
    getConstructorFromLength(t) {
        return XQ[t - 1];
    }
    isTypeMatrix(t) {
        return /^m/.test(t);
    }
    getTypeLength(t) {
        return t === "f" ? 1 : parseInt(this.colorToVector(t).substr(1));
    }
    getTypeFromLength(t) {
        return t === 1 ? "f" : "v" + t;
    }
    findNode(...t) {
        for(let e = 0; e < arguments.length; e++){
            let r = t[e];
            if (r?.isNode) return r;
        }
    }
    resolve(...t) {
        for(let e = 0; e < arguments.length; e++){
            let r = t[e];
            if (r !== void 0) {
                if (r.isNode) return r;
                if (r.isTexture) switch(r.mapping){
                    case yl:
                    case vl:
                        return new Vx(r);
                    case xh:
                        return new Fx(new Mn(r));
                    default:
                        return new Mn(r);
                }
                else {
                    if (r.isVector2) return new Zr(r);
                    if (r.isVector3) return new Ji(r);
                    if (r.isVector4) return new zn(r);
                }
            }
        }
    }
    format(t, e, r) {
        switch(this.colorToVector(r + " <- " + e)){
            case "f <- v2":
                return t + ".x";
            case "f <- v3":
                return t + ".x";
            case "f <- v4":
                return t + ".x";
            case "f <- i":
            case "f <- b":
                return "float( " + t + " )";
            case "v2 <- f":
                return "vec2( " + t + " )";
            case "v2 <- v3":
                return t + ".xy";
            case "v2 <- v4":
                return t + ".xy";
            case "v2 <- i":
            case "v2 <- b":
                return "vec2( float( " + t + " ) )";
            case "v3 <- f":
                return "vec3( " + t + " )";
            case "v3 <- v2":
                return "vec3( " + t + ", 0.0 )";
            case "v3 <- v4":
                return t + ".xyz";
            case "v3 <- i":
            case "v3 <- b":
                return "vec2( float( " + t + " ) )";
            case "v4 <- f":
                return "vec4( " + t + " )";
            case "v4 <- v2":
                return "vec4( " + t + ", 0.0, 1.0 )";
            case "v4 <- v3":
                return "vec4( " + t + ", 1.0 )";
            case "v4 <- i":
            case "v4 <- b":
                return "vec4( float( " + t + " ) )";
            case "i <- f":
            case "i <- b":
                return "int( " + t + " )";
            case "i <- v2":
                return "int( " + t + ".x )";
            case "i <- v3":
                return "int( " + t + ".x )";
            case "i <- v4":
                return "int( " + t + ".x )";
            case "b <- f":
                return "( " + t + " != 0.0 )";
            case "b <- v2":
                return "( " + t + " != vec2( 0.0 ) )";
            case "b <- v3":
                return "( " + t + " != vec3( 0.0 ) )";
            case "b <- v4":
                return "( " + t + " != vec4( 0.0 ) )";
            case "b <- i":
                return "( " + t + " != 0 )";
        }
        return t;
    }
    getTypeByFormat(t) {
        return YQ[t] || t;
    }
    getFormatByType(t) {
        return KQ[t] || t;
    }
    getUUID(t, e) {
        return e = e !== void 0 ? e : !0, e && this.cache && (t = this.cache + "-" + t), t;
    }
    getElementByIndex(t) {
        return SL[t];
    }
    getIndexByElement(t) {
        return SL.indexOf(t);
    }
    isShader(t) {
        return this.shader === t;
    }
    setShader(t) {
        return this.shader = t, this;
    }
    mergeDefines(t) {
        for(let e in t)this.defines[e] = t[e];
        return this.defines;
    }
    mergeUniform(t) {
        for(let e in t)this.uniforms[e] = t[e];
        return this.uniforms;
    }
    getTextureEncodingFromMap(t) {
        let e;
        return t ? t.isTexture && (e = t.encoding) : e = xn, e === xn && this.context.gamma && (e = ut), e;
    }
};
var ur = class extends mr {
    constructor(e = 0, r, i, s1){
        super("c");
        this.nodeType = "Color";
        this.value = e instanceof cr ? e : new cr(e || 0, r, i, s1);
    }
    setRGBA(e) {
        this.value.setRGBA(e.r, e.g, e.b, e.a);
    }
    generate(e, r, i, s1, o, a) {
        i = e.getUUID(i ?? this.getUUID()), s1 = s1 ?? this.getType(e);
        let l = e.getNodeData(i), c = this.getReadonly() && this.generateReadonly !== void 0;
        if (this.alpha) {
            let u1 = this.alpha.build(e, "f");
            e.addFragmentNodeCode(`accumAlpha += ( 1.0 - accumAlpha ) * ${u1};`);
        }
        return c ? this.generateReadonly(e, r, i, s1, o, a) : e.isShader("vertex") ? (l.vertex || (l.vertex = e.createVertexUniform(s1, this, o, a, this.getLabel())), e.format(l.vertex.name, s1, r)) : (l.fragment || (l.fragment = e.createFragmentUniform(s1, this, o, a, this.getLabel())), e.format(l.fragment.name, s1, r));
    }
    generateReadonly(e, r, i, s1, o, a) {
        return e.format("vec3(" + this.value.r + ", " + this.value.g + ", " + this.value.b + ")", s1, r);
    }
};
var Bt = class extends mr {
    constructor(e){
        super("i");
        this.nodeType = "Int";
        this.value = Math.floor(e ?? 0);
    }
    generateReadonly(e, r, i, s1, o, a) {
        return e.format(this.value.toString(), s1, r);
    }
};
var Jr = class extends mr {
    constructor(e){
        super("b");
        this.nodeType = "Bool";
        this.value = e ?? !1;
    }
    generateReadonly(e, r, i, s1) {
        return e.format(this.value ? "true" : "false", s1, r);
    }
};
var so = class extends mr {
    constructor(e = 1, r){
        super("f[]");
        this.nodeType = "FloatArray";
        this.size = e, this.value = Array.isArray(r) ? r : typeof r == "number" ? new Array(e).fill(r) : new Array(e).fill(0);
    }
};
var ic = class extends mr {
};
var Ux = class extends ic {
    constructor(e){
        super("v3");
        this.image = e;
        this._value = new E;
    }
    get value() {
        return this._value.x = this.image.isVideo ? this.image.img.videoWidth ?? 0 : this.image.img.width, this._value.y = this.image.isVideo ? this.image.img.videoHeight ?? 0 : this.image.img.height, this._value;
    }
};
var fu = class extends ic {
    constructor(e, r, i = 1008, s1 = 1006){
        super("t");
        this.image = e;
        this.wrap = r;
        this.minFilter = i;
        this.magFilter = s1;
    }
    get value() {
        return this.image.getTexture(this.wrap, this.minFilter, this.magFilter);
    }
};
var uf = class extends mr {
    constructor(e){
        super("m3");
        this.nodeType = "Matrix3";
        this.value = e ?? new Sr;
    }
    generateReadonly(e, r, i, s1, o, a) {
        return e.format("mat3(" + this.value.elements.join(", ") + ")", s1, r);
    }
    get elements() {
        return this.value.elements;
    }
    set elements(e) {
        this.value.fromArray(e);
    }
};
var $i = class extends mr {
    constructor(e){
        super("m4");
        this.nodeType = "Matrix4";
        this.value = e ?? new ue;
    }
    generateReadonly(e, r, i, s1, o, a) {
        return e.format("mat4(" + this.value.elements.join(", ") + ")", s1, r);
    }
    get elements() {
        return this.value.elements;
    }
    set elements(e) {
        this.value.fromArray(e);
    }
};
function wL(n1, t, e, r = 0) {
    n1.setUvTransform(e[0], e[1], t[0], t[1], 0, 0, 0).premultiply(new Sr().makeRotation(r * Se.DEG2RAD));
}
var kx = class extends uf {
    constructor(e, r, i = 0){
        super(new Sr);
        this.repeat = e;
        this.offset = r;
        this.rotation = i;
        wL(this.value, e, r, i);
    }
    updateMatrix() {
        wL(this.value, this.repeat, this.offset, this.rotation);
    }
};
var oo = class extends mr {
    constructor(e = 1, r){
        super("v4[]");
        this.nodeType = "Vector4Array";
        this.size = e, this.value = Array.isArray(r) ? r : r instanceof Ze ? new Array(e).fill(r) : new Array(e).fill(new Ze(0));
    }
};
var hf = class extends rt {
    constructor(e, r, i, s1){
        super("v3");
        this.nodeType = "Blend";
        this.a = e, this.b = r, this.alpha = i, this.mode = s1;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            let i = [];
            return i.push(this.a.build(e, "c")), i.push(this.b.build(e, "c")), i.push(this.alpha.build(e, "f")), i.push(this.mode.build(e, "i")), e.format("spe_blend(" + i.join(",") + ")", this.getType(e), r);
        } else return console.warn("BlendNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
};
var lT = class extends rt {
    constructor(e, r){
        super("v3");
        this.nodeType = "CustomColor";
        this.color = e, this.alpha = r, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            let i = e.include(lT.Nodes.customColor);
            e.addFragmentVariable(this.calpha, "float");
            let s1 = [];
            return s1.push(this.color.build(e, "v3")), s1.push(this.mask ? `luminance(${this.mask.build(e, "v3")})` : "1.0"), s1.push(this.alpha.build(e, "f")), s1.push(this.calpha), e.format(i + "(" + s1.join(",") + ")", this.getType(e), r);
        } else return console.warn("CustomColorNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, pu = lT;
pu.Nodes = function() {
    return {
        customColor: new Ae(`vec3 customColor(vec3 color, float mask, float alpha, out float calpha) {
				float lalpha = alpha * mask;
				calpha =  lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0);
				accumAlpha += (1.0 - accumAlpha) * lalpha;

				return color;
			}`)
    };
}();
var cT = class extends rt {
    constructor(e, r){
        super("v3");
        this.nodeType = "CustomNormal";
        this.cnormal = e, this.alpha = r, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            let i = e.include(cT.Nodes.customNormal);
            e.addFragmentVariable(this.calpha, "float");
            let s1 = [];
            return s1.push(this.cnormal.build(e, "v3")), s1.push("normal"), s1.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s1.push(this.alpha.build(e, "f")), s1.push(this.calpha), e.format(i + "(" + s1.join(",") + ")", this.getType(e), r);
        } else return console.warn("CustomNormalNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, df = cT;
df.Nodes = function() {
    return {
        customNormal: new Ae(`vec3 customNormal(vec3 cnormal, vec3 norm, float mask, float alpha, out float calpha) {
				vec3 normal = packNormalToRGB( norm ).rgb;
				normal *= step( vec3(0.5), cnormal );

				float lalpha = alpha * mask;
				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += ( 1.0 - accumAlpha ) * lalpha;

				return normal;
			}`)
    };
}();
var ff = class extends rt {
    constructor(e, r, i, s1, o, a, l, c, u1, h, d, f){
        super("v3");
        this.nodeType = "CustomTexture";
        this.texture = e, this.textureSize = r, this.crop = i, this.projection = s1, this.axis = o, this.side = a, this.size = l, this.blending = c, this.mat = u1, this.isMask = f, this.alpha = h, this.mode = d, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        e.require("position"), e.require("normal"), e.require("uv"), e.requires.uv = [
            !0
        ], e.extensions.shaderTextureLOD = !0, e.extensions.derivatives = !0;
        let i = `g${this.uuid.toString().replace(/-/g, "")}`, s1;
        switch(this.projection.value){
            case 3:
                s1 = e.include(ff.Nodes.cylindrical);
                break;
            case 2:
                s1 = e.include(ff.Nodes.spherical);
                break;
            case 1:
                let a = [
                    "vec3(1.0, 0.0, 0.0)",
                    "vec3(0.0, 1.0, 0.0)",
                    "vec3(0.0, 0.0, 1.0)"
                ][this.axis.value], l = [
                    "zy",
                    "xz",
                    "xy"
                ][this.axis.value], c = new Ae(`
		vec3 ${i}_planarTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha, out vec2 writeUv) {
				vec2 projected = (1. + (position.${l})) / 2.;
				vec2 uvs = ( mat * vec3( (projected * 2. - 1.) / (size * .5), 1. ) / 2. + 0.5 ).xy;
				writeUv = uvs;

				vec4 tmp = texture2D( tex, uvs );

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;
				${this.side.value === 2 ? "" : `lalpha *= step(0.0, ${this.side.value === 1 ? "-1.0 * " : ""}dot(vObjectNormal, ${a}));`}

				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}
				
				lalpha *= mask;

				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}`);
                s1 = e.include(c);
                break;
            case 4:
                s1 = e.include(ff.Nodes.triplanar);
                break;
            default:
                s1 = e.include(ff.Nodes.uv);
                break;
        }
        e.addFragmentVariable(this.calpha, "float");
        let o = [];
        if (o.push("normal"), o.push(this.texture.generate(e, "t")), o.push(this.textureSize.build(e, "v2")), o.push(this.crop.build(e, "f")), o.push(this.mat.build(e, "mat3")), o.push(this.size.build(e, "v2")), o.push(this.blending.build(e, "f")), o.push(this.isMask.build(e, "b")), o.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), o.push(this.alpha.build(e, "f")), o.push(this.mode.build(e, "i")), o.push(this.calpha), this.projection.value === 4) {
            let a = `${i}_writeUvs`, l = a + "0", c = a + "1", u1 = a + "2", h = `${i}_triplanarWeights`;
            e.addFragmentVariable(l, "vec2"), e.addFragmentVariable(c, "vec2"), e.addFragmentVariable(u1, "vec2"), e.addFragmentVariable(h, "vec3"), o.push(l), o.push(c), o.push(u1), o.push(h);
        } else {
            let a = `${i}_writeUvs`;
            e.addFragmentVariable(a, "vec2"), o.push(a);
        }
        return e.format(s1 + "(" + o.join(",") + ")", this.getType(e), r);
    }
}, nc = ff;
nc.Nodes = function() {
    let e = new Ae(`
vec3 cylindricalTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha, out vec2 writeUv) {
                vec3 posN = normalize(position);
                float u = 0.5 + atan(posN.z, posN.x) / (2.*3.1415);
                float scaledHeight = position.y / (size.y * 0.5);
                float v =  (scaledHeight / 2.) + .5;

                vec2 calculatedUv = vec2(u,v);
				vec2 uvs = ( mat * vec3( calculatedUv * 2. - 1., 1. ) / 2. + 0.5 ).xy;
				writeUv = uvs;

                vec2 df = fwidth(uvs);
               	if(df.x > 0.5) df.x = 0.;

				#ifdef GL_EXT_shader_texture_lod
                vec4 tmp = texture2DLodEXT(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#else
                vec4 tmp = textureLod(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#endif

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;
				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}

				lalpha *= mask;
				
				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}
`), r = new Ae(`
vec3 sphericalTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha, out vec2 writeUv) {
                vec3 posN = normalize(vPosition);
                float u = 0.5 + atan(posN.z, posN.x) / (2.*3.1415);
                float v = 0.5 + asin(posN.y) / 3.1415;

                vec2 calculatedUv = vec2(u,v);
				vec2 uvs = ( mat * vec3( calculatedUv * 2. - 1., 1. ) / 2. + 0.5 ).xy;
				writeUv = uvs;

                vec2 df = fwidth(uvs);
               	if(df.x > 0.5) df.x = 0.;
				#ifdef GL_EXT_shader_texture_lod
                vec4 tmp = texture2DLodEXT(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#else
                vec4 tmp = textureLod(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#endif

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;
				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}

				lalpha *= mask;

				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}
`), i = new Ae(`vec3 uvTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha, out vec2 writeUv) {
				vec2 uvs = ( mat * vec3( vUv * 2. - 1., 1. ) / 2. + 0.5 ).xy;
				writeUv = uvs;

				vec4 tmp = texture2D( tex, uvs );

				vec3 col = tmp.rgb;

				float lalpha = alpha * tmp.a;
				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}
				
				lalpha *= mask;

				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}`), s1 = new Ae(`vec3 triplanarTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha, out vec2 writeUvs0, out vec2 writeUvs1, out vec2 writeUvs2, out vec3 writeWeights) {
				vec3 p = position;
				vec2 uv0 = (1.0 + p.xy) / 2.0;     
				vec2 uv1 = (1.0 + p.zy) / 2.0;		
				vec2 uv2 = (1.0 + p.xz) / 2.0;		
	
				uv0 = (mat * vec3((uv0 * 2.0 - 1.0) / (size * 0.5), 1.0) / 2.0 + 0.5).xy;
				uv1 = (mat * vec3((uv1 * 2.0 - 1.0) / (size * 0.5), 1.0) / 2.0 + 0.5).xy;
				uv2 = (mat * vec3((uv2 * 2.0 - 1.0) / (size * 0.5), 1.0) / 2.0 + 0.5).xy;

				// Range from 3 to 128 seems to be good
				float exponent = (1.0 - blending) * 125.0 + 3.0;

				vec3 n = vObjectNormal;
				vec3 weights = abs(normalize(n));
				weights = pow(weights, vec3(exponent));
				weights /= dot(weights, vec3(1.0));

				// Write out all sets of UVs that we generated
				writeUvs0 = uv0;
				writeUvs1 = uv1;
				writeUvs2 = uv2;
				writeWeights = weights;

				// Derivatives for LOD
				vec2 df0 = fwidth(uv0);
				vec2 df1 = fwidth(uv1);
				vec2 df2 = fwidth(uv2);
				if (df0.x > 0.5) df0.x = 0.0;
				if (df1.x > 0.5) df1.x = 0.0;
				if (df2.x > 0.5) df2.x = 0.0;

				#ifdef GL_EXT_shader_texture_lod
                	vec4 tmp = 
						texture2DLodEXT(tex, uv0, log2(max(df0.x, df0.y)*min(textureSize.x, textureSize.y))) * weights.z + 
						texture2DLodEXT(tex, uv1, log2(max(df1.x, df1.y)*min(textureSize.x, textureSize.y))) * weights.x + 
						texture2DLodEXT(tex, uv2, log2(max(df2.x, df2.y)*min(textureSize.x, textureSize.y))) * weights.y;
				#else
                	vec4 tmp = 
						textureLod(tex, uv0, log2(max(df0.x, df0.y)*min(textureSize.x, textureSize.y))) * weights.z + 
						textureLod(tex, uv1, log2(max(df1.x, df1.y)*min(textureSize.x, textureSize.y))) * weights.x + 
						textureLod(tex, uv2, log2(max(df2.x, df2.y)*min(textureSize.x, textureSize.y))) * weights.y;
				#endif

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;

				// Apply cropping across all 3 planes
				if ( crop > 0.5 ) {
					if ( uv0.x < 0.0 || uv0.x > 1.0 || uv0.y < 0.0 || uv0.y > 1.0 )  {
						lalpha = 0.0;
					}
					if ( uv1.x < 0.0 || uv1.x > 1.0 || uv1.y < 0.0 || uv1.y > 1.0 )  {
						lalpha = 0.0;
					}
					if ( uv2.x < 0.0 || uv2.x > 1.0 || uv2.y < 0.0 || uv2.y > 1.0 )  {
						lalpha = 0.0;
					}
				}

				lalpha *= mask;
				calpha =  lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0);
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;//n * 0.5 + 0.5;
			}			
			`);
    return {
        cylindrical: e,
        spherical: r,
        uv: i,
        triplanar: s1
    };
}();
var pf = class extends rt {
    constructor(e, r, i, s1, o, a, l, c, u1, h, d, f){
        super("v3");
        this.nodeType = "Depth";
        this.gradientType = e, this.smooth = r, this.near = i, this.far = s1, this.isVector = o, this.isWorldSpace = a, this.origin = l, this.direction = c, this.colors = u1, this.steps = h, this.isMask = f, this.alpha = d, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        let i = `g${this.uuid.toString().replace(/-/g, "")}`, s1 = new Ae(`vec3 ${i}_sdepth(float near, float far, vec3 origin, vec3 direction, vec4 colors[${i}_MAX_COLORS], float steps[${i}_MAX_COLORS], bool isMask, float mask, float alpha, out float calpha) {
               vec4 color = colors[0];
               #ifdef ${i}_IS_VECTOR
                   #ifdef ${i}_LINEAR
                       #ifdef ${i}_WORLDSPACE
                       float depth = vectorLinearWorldSpaceDepth(direction, origin, near, far);
                       #else
                       float depth = vectorLinearObjectSpaceDepth(direction, origin, near, far);
                       #endif
                   #else
                       #ifdef ${i}_WORLDSPACE
                           float depth = vectorSphericalWorldSpaceDepth(origin, near, far);
                       #else
                           float depth = vectorSphericalObjectSpaceDepth(origin, near, far);
                       #endif
                   #endif
               #else
                   float dist = length(vWPosition - cameraPosition);
			       float depth = ( dist - near ) / ( far - near );
               #endif


              float p;
              #ifdef ${i}_SMOOTH
				for ( int i = 1; i < ${i}_MAX_COLORS; i++ ) {
						p = clamp( ( depth - steps[i-1] ) / ( steps[i] - steps[i-1] ), 0.0, 1.0 );
						color = mix(color, colors[i], smoothstep(0.0, 1.0, p));
					}
              #else
                for ( int i = 1; i < ${i}_MAX_COLORS; i++ ) {
                   p = clamp(( depth - steps[i - 1] ) / ( steps[i] - steps[i - 1] ), 0.0, 1.0);
                   color = mix(color, colors[i], p);
                 }
              #endif

               float lalpha = alpha * color.a * mask;
               calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
			   accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));
			   
               return color.rgb;
			}`, [
            pf.Nodes.vectorLinearWorldSpaceDepth,
            pf.Nodes.vectorLinearObjectSpaceDepth,
            pf.Nodes.vectorSphericalObjectSpaceDepth,
            pf.Nodes.vectorSphericalWorldSpaceDepth
        ]);
        if (e.isShader("fragment")) {
            e.define(`${i}_MAX_COLORS`, this.colors.value.length), this.smooth.value && e.define(`${i}_SMOOTH`), this.isVector.value > .5 && e.define(`${i}_IS_VECTOR`), this.gradientType.value === 0 && e.define(`${i}_LINEAR`), this.isWorldSpace.value > .5 && e.define(`${i}_WORLDSPACE`), e.require("worldPosition"), e.addFragmentVariable(this.calpha, "float");
            let o = e.include(s1), a = [];
            return a.push(this.near.build(e, "f")), a.push(this.far.build(e, "f")), a.push(this.origin.build(e, "v3")), a.push(this.direction.build(e, "v3")), a.push(this.colors.build(e, "v4[]")), a.push(this.steps.build(e, "f[]")), a.push(this.isMask.build(e, "b")), a.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), a.push(this.alpha.build(e, "f")), a.push(this.calpha), e.format(o + "(" + a.join(",") + ")", this.getType(e), r);
        } else return console.warn("DepthNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, mf = pf;
mf.Nodes = function() {
    let e = new Ae(`float vectorLinearWorldSpaceDepth(vec3 direction, vec3 origin, float near, float far) {
               vec3 n = normalize(direction);
               float dist = (n.x*(vWPosition.x - origin.x) + n.y*(vWPosition.y - origin.y) + n.z*(vWPosition.z - origin.z));
               return ( dist - near ) / ( far - near );
            }`), r = new Ae(`float vectorLinearObjectSpaceDepth(vec3 direction, vec3 origin, float near, float far) {
               vec3 n = normalize(direction);
               float dist = (n.x*(position.x - origin.x) + n.y*(position.y - origin.y) + n.z*(position.z - origin.z));
               return ( dist - near ) / ( far - near );
            }`), i = new Ae(`float vectorSphericalWorldSpaceDepth(vec3 origin, float near, float far) {
               float dist = length(vWPosition - origin);
               return ( dist - near ) / ( far - near );
            }`), s1 = new Ae(`float vectorSphericalObjectSpaceDepth(vec3 origin, float near, float far) {
               float dist = length(position - origin);
               return ( dist - near ) / ( far - near );
            }`);
    return {
        vectorLinearWorldSpaceDepth: e,
        vectorLinearObjectSpaceDepth: r,
        vectorSphericalWorldSpaceDepth: i,
        vectorSphericalObjectSpaceDepth: s1
    };
}();
var Zm = class extends rt {
    constructor(e, r, i, s1, o, a, l, c){
        super("v3");
        this.nodeType = "Fresnel";
        this.color = e, this.bias = r, this.scale = i, this.intensity = s1, this.factor = o, this.isMask = c, this.alpha = a, this.mode = l, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.require("vWorldViewDir"), e.require("worldNormal"), e.isShader("fragment")) {
            e.addFragmentVariable(this.calpha, "float");
            let i = new Ae(`vec3 fresnel(vec3 color, float bias, float scale, float intensity, float factor, bool isMask, float mask, float alpha, int mode, out float calpha) {
					float fresnel = bias + scale * pow( abs( factor + dot( normalize( vWorldViewDir ), normalize( vWNormal ) ) ), intensity );

					float lalpha = clamp(fresnel, 0.0, 1.0) * alpha * mask;
					calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
					accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

					return color;
				}`), s1 = e.include(i), o = [];
            return o.push(this.color.build(e, "c")), o.push(this.bias.build(e, "f")), o.push(this.scale.build(e, "f")), o.push(this.intensity.build(e, "f")), o.push(this.factor.build(e, "f")), o.push(this.isMask.build(e, "b")), o.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), o.push(this.alpha.build(e, "f")), o.push(this.mode.build(e, "i")), o.push(this.calpha), e.format(s1 + "(" + o.join(",") + ")", this.getType(e), r);
        } else return console.warn("FresnelNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
};
var uT = class extends rt {
    constructor(e, r, i, s1, o, a, l, c, u1){
        super("v3");
        this.nodeType = "Gradient";
        this.gradientType = e, this.smooth = r, this.colors = i, this.steps = s1, this.offset = o, this.morph = a, this.angle = l, this.isMask = u1, this.alpha = c, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            e.define("GRAD_MAX", 10), e.require("uv"), e.requires.uv = [
                !0
            ], e.addFragmentVariable(this.calpha, "float");
            let i = e.include(uT.Nodes.gradient), s1 = [];
            return s1.push(this.gradientType.build(e, "i")), s1.push(this.smooth.build(e, "b")), s1.push(this.colors.build(e, "v4[]")), s1.push(this.steps.build(e, "f[]")), s1.push(this.offset.build(e, "v2")), s1.push(this.morph.build(e, "v2")), s1.push(this.angle.build(e, "f")), s1.push(this.isMask.build(e, "b")), s1.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s1.push(this.alpha.build(e, "f")), s1.push(this.calpha), e.format(i + "(" + s1.join(",") + ")", this.getType(e), r);
        } else return console.warn("GradientNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, gf = uT;
gf.Nodes = function() {
    return {
        gradient: new Ae(`vec3 gradient(int gradientType, bool smoothed, vec4 colors[GRAD_MAX], float steps[GRAD_MAX], vec2 offset, vec2 morph, float angle, bool isMask, float mask, float alpha, out float calpha) {
				vec4 color = colors[0];
				vec2 m = morph / vUv.xy;
				vec2 rot = vec2( 0.5 + m.x, m.y );
				vec2 dt = vec2(
					cos( angle ) * rot.x - sin( angle ) * rot.y,
					sin( angle ) * rot.x + cos( angle ) * rot.y
				);
				vec2 pt = ( vUv - 0.5 + offset ) / 2.0 + dt / 2.0;
				float t = dot( pt, dt ) / dot( dt, dt );
				if ( gradientType == 1 ) {
					t = distance (
						( vUv + morph ) * 3.0,
						( vUv + offset ) + 1.0
					) + angle;
				} else if ( gradientType == 2 ) {
					float polar = atan(
						vUv.x + morph.x - 0.5 + offset.x,
						vUv.y + morph.y - 0.5 + offset.y
					) * -1.0;
					t = fract( ( angle / PI / -2.0 ) + 0.5 * ( polar / PI ) );
				}

				float p;
				if (smoothed) {
					for ( int i = 1; i < GRAD_MAX; i++ ) {
						p = clamp( ( t - steps[i-1] ) / ( steps[i] - steps[i-1] ), 0.0, 1.0 );
						color = mix(color, colors[i], smoothstep(0.0, 1.0, p));
					}

				} else {
					for ( int i = 1; i < GRAD_MAX; i++ ) {
						p = clamp( ( t - steps[i-1] ) / ( steps[i] - steps[i-1] ), 0.0, 1.0 );
						color = mix(color, colors[i], p);
					}
				}

				float lalpha = alpha * color.a * mask;
				calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));
				
				return color.xyz;
			}`)
    };
}();
var hT = class extends rt {
    constructor(e, r, i, s1, o){
        super("v3");
        this.nodeType = "Matcap";
        this.texture = e, this.isMask = s1, this.alpha = r, this.mode = i, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`, this.rotation = o;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            e.addFragmentVariable(this.calpha, "float");
            let i = e.include(hT.Nodes.matcap);
            e.require("normal"), e.requires.normal = !0;
            let s1 = [];
            return s1.push(this.texture.generate(e, "t")), s1.push("normal"), s1.push(this.isMask.build(e, "b")), s1.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s1.push(this.alpha.build(e, "f")), s1.push(this.mode.build(e, "i")), s1.push(this.calpha), s1.push(this.rotation.build(e, "f")), e.format(i + "(" + s1.join(",") + ")", this.getType(e), r);
        } else return console.warn("MatcapNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, yf = hT;
yf.Nodes = function() {
    return {
        matcap: new Ae(`vec3 matcap(sampler2D matcapTex, vec3 normal, bool isMask, float mask, float alpha, int mode, out float calpha, float rotation) {
					vec3 viewDir = normalize( vViewPosition );
					vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
					vec3 y = cross( viewDir, x );
					vec2 uv = vec2( dot( x, normal ), dot( y, normal ) );
					uv = mat2( cos(rotation), sin(rotation), -sin(rotation), cos(rotation) ) * uv;
					uv = uv * 0.495 + 0.5;
					vec4 matcapColor = texture2D( matcapTex, uv );

					float lalpha = alpha * mask;
					calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
					accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));
					
					return matcapColor.rgb;
            	}`)
    };
}();
var Yi = function() {
    let t = new Ae(`vec3 random3(vec3 c) {
			float j = 4096.0*sin(dot(c,vec3(17.0, 59.4, 15.0)));
			vec3 r;
			r.z = fract(512.0*j);
			j *= .125;
			r.x = fract(512.0*j);
			j *= .125;
			r.y = fract(512.0*j);
			return r-0.5;
		}`), e = new Ae(`float simplexFast(vec3 p) {
			 vec3 s = floor(p + dot(p, vec3(F3)));
			 mediump vec3 x = p - s + dot(s, vec3(G3));
			 mediump vec3 hs = s;
			 
			 mediump vec3 e = step(vec3(0.0), x - x.yzx);
			 mediump vec3 i1 = e*(1.0 - e.zxy);
			 mediump vec3 i2 = 1.0 - e.zxy*(1.0 - e);
				
			 mediump vec3 x1 = x - i1 + G3;
			 mediump vec3 x2 = x - i2 + 2.0*G3;
			 mediump vec3 x3 = x - 1.0 + 3.0*G3;
			 
			 mediump vec4 w, d;
			 
			 w.x = dot(x, x);
			 w.y = dot(x1, x1);
			 w.z = dot(x2, x2);
			 w.w = dot(x3, x3);
			 
			 w = max(0.6 - w, 0.0);
			 
			 d.x = dot(random3(hs), x);
			 d.y = dot(random3(hs + i1), x1);
			 d.z = dot(random3(hs + i2), x2);
			 d.w = dot(random3(hs + 1.0), x3);
			 
			 w *= w;
			 w *= w;
			 d *= w;
			 
			 return dot(d, vec4(52.0));
		}`, [
        t
    ]);
    e.keywords.F3 = new Ht("float F3 0.3333333"), e.keywords.G3 = new Ht("float G3 0.1666667");
    let r = new Ae(`float simplexPrecise(vec3 p) {
			 vec3 s = floor(p + dot(p, vec3(F3)));
			 vec3 x = p - s + dot(s, vec3(G3));
			 
			 vec3 e = step(vec3(0.0), x - x.yzx);
			 vec3 i1 = e*(1.0 - e.zxy);
			 vec3 i2 = 1.0 - e.zxy*(1.0 - e);
				
			 vec3 x1 = x - i1 + G3;
			 vec3 x2 = x - i2 + 2.0*G3;
			 vec3 x3 = x - 1.0 + 3.0*G3;
			 
			 vec4 w, d;
			 
			 w.x = dot(x, x);
			 w.y = dot(x1, x1);
			 w.z = dot(x2, x2);
			 w.w = dot(x3, x3);
			 
			 w = max(0.6 - w, 0.0);
			 
			 d.x = dot(random3(s), x);
			 d.y = dot(random3(s + i1), x1);
			 d.z = dot(random3(s + i2), x2);
			 d.w = dot(random3(s + 1.0), x3);
			 
			 w *= w;
			 w *= w;
			 d *= w;
			 
			 return dot(d, vec4(52.0));
		}`, [
        t
    ]);
    r.keywords.F3 = new Ht("float F3 0.3333333"), r.keywords.G3 = new Ht("float G3 0.1666667");
    let i = new Ae(`float simplexFractal(vec3 m) {
			mat3 rot1 = mat3(-0.37, 0.36, 0.85,-0.14,-0.93, 0.34,0.92, 0.01,0.4);
			mat3 rot2 = mat3(-0.55,-0.39, 0.74, 0.33,-0.91,-0.24,0.77, 0.12,0.63);
			mat3 rot3 = mat3(-0.71, 0.52,-0.47,-0.08,-0.72,-0.68,-0.7,-0.45,0.56);
			return 0.5333333 * simplexFast(m * rot1)
				 + 0.2666667 * simplexFast(2.0 * m * rot2)
				 + 0.1333333 * simplexFast(4.0 * m * rot3)
				 + 0.0666667 * simplexFast(8.0 * m);
		}`, [
        e
    ]), s1 = new Ae("vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}"), o = new Ae("vec4 taylorInvSqrt(vec4 r){return 1.79284291400159 - 0.85373472095314 * r;}"), a = new Ae(`float simplexAshima(vec3 v) {
		  const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
		  const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);
		  vec3 i  = floor(v + dot(v, C.yyy) );
		  vec3 x0 =   v - i + dot(i, C.xxx) ;
		  vec3 g = step(x0.yzx, x0.xyz);
		  vec3 l = 1.0 - g;
		  vec3 i1 = min( g.xyz, l.zxy );
		  vec3 i2 = max( g.xyz, l.zxy );
		  vec3 x1 = x0 - i1 + 1.0 * C.xxx;
		  vec3 x2 = x0 - i2 + 2.0 * C.xxx;
		  vec3 x3 = x0 - 1. + 3.0 * C.xxx;
		  i = mod(i, 289.0 ); 
		  vec4 p = permute( permute( permute( 
					 i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
				   + i.y + vec4(0.0, i1.y, i2.y, 1.0 )) 
				   + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));
		  float n_ = 1.0/7.0; // N=7
		  vec3  ns = n_ * D.wyz - D.xzx;
		  vec4 j = p - 49.0 * floor(p * ns.z *ns.z);  //  mod(p,N*N)
		  vec4 x_ = floor(j * ns.z);
		  vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)
		  vec4 x = x_ *ns.x + ns.yyyy;
		  vec4 y = y_ *ns.x + ns.yyyy;
		  vec4 h = 1.0 - abs(x) - abs(y);
		  vec4 b0 = vec4( x.xy, y.xy );
		  vec4 b1 = vec4( x.zw, y.zw );
		  vec4 s0 = floor(b0)*2.0 + 1.0;
		  vec4 s1 = floor(b1)*2.0 + 1.0;
		  vec4 sh = -step(h, vec4(0.0));
		  vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
		  vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;
		  vec3 p0 = vec3(a0.xy,h.x);
		  vec3 p1 = vec3(a0.zw,h.y);
		  vec3 p2 = vec3(a1.xy,h.z);
		  vec3 p3 = vec3(a1.zw,h.w);
		  vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
		  p0 *= norm.x;
		  p1 *= norm.y;
		  p2 *= norm.z;
		  p3 *= norm.w;
		  vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
		  m = m * m;
		  return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1), 
										dot(p2,x2), dot(p3,x3) ) );
		}`, [
        s1,
        o
    ]), l = new Ae("vec4 mod289(vec4 x){return x - floor(x * (1.0 / 289.0)) * 289.0;}"), c = new Ae("vec4 perm(vec4 x){return mod289(((x * 34.0) + 1.0) * x);}", [
        l
    ]), u1 = new Ae(`float noise(vec3 p){
			vec3 a = floor(p);
			vec3 d = p - a;
			d = d * d * (3.0 - 2.0 * d);
			vec4 b = a.xxyy + vec4(0.0, 1.0, 0.0, 1.0);
			vec4 k1 = perm(b.xyxy);
			vec4 k2 = perm(k1.xyxy + b.zzww);
			vec4 c = k2 + a.zzzz;
			vec4 k3 = perm(c);
			vec4 k4 = perm(c + 1.0);
			vec4 o1 = fract(k3 * (1.0 / 41.0));
			vec4 o2 = fract(k4 * (1.0 / 41.0));
			vec4 o3 = o2 * d.z + o1 * (1.0 - d.z);
			vec2 o4 = o3.yw * d.x + o3.xz * (1.0 - d.x);
			return o4.y * d.y + o4.x * (1.0 - d.y);
		}`, [
        c
    ]), h = new Ae(`float fbm(vec3 x) {
			float v = 0.0;
			float a = 0.5;
			vec3 shift = vec3(100);
			for (int i = 0; i < NUM_OCTAVES; ++i) {
				v += a * noise(x);
				x = x * 2.0 + shift;
				a *= 0.5;
			}
			return v;
		}`, [
        u1
    ]);
    h.keywords.NUM_OCTAVES = new Ht(`int NUM_OCTAVES ${5}`);
    let d = new Ae("vec3 fade(vec3 t) {return t*t*t*(t*(t*6.0-15.0)+10.0);}"), f = new Ae(`float perlin(vec3 P){
		  vec3 Pi0 = floor(P);
		  vec3 Pi1 = Pi0 + vec3(1.0);
		  Pi0 = mod(Pi0, 289.0);
		  Pi1 = mod(Pi1, 289.0);
		  vec3 Pf0 = fract(P);
		  vec3 Pf1 = Pf0 - vec3(1.0);
		  vec4 ix = vec4(Pi0.x, Pi1.x, Pi0.x, Pi1.x);
		  vec4 iy = vec4(Pi0.yy, Pi1.yy);
		  vec4 iz0 = Pi0.zzzz;
		  vec4 iz1 = Pi1.zzzz;
		  vec4 ixy = permute(permute(ix) + iy);
		  vec4 ixy0 = permute(ixy + iz0);
		  vec4 ixy1 = permute(ixy + iz1);
		  vec4 gx0 = ixy0 / 7.0;
		  vec4 gy0 = fract(floor(gx0) / 7.0) - 0.5;
		  gx0 = fract(gx0);
		  vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0);
		  vec4 sz0 = step(gz0, vec4(0.0));
		  gx0 -= sz0 * (step(0.0, gx0) - 0.5);
		  gy0 -= sz0 * (step(0.0, gy0) - 0.5);
		  vec4 gx1 = ixy1 / 7.0;
		  vec4 gy1 = fract(floor(gx1) / 7.0) - 0.5;
		  gx1 = fract(gx1);
		  vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1);
		  vec4 sz1 = step(gz1, vec4(0.0));
		  gx1 -= sz1 * (step(0.0, gx1) - 0.5);
		  gy1 -= sz1 * (step(0.0, gy1) - 0.5);
		  vec3 g000 = vec3(gx0.x,gy0.x,gz0.x);
		  vec3 g100 = vec3(gx0.y,gy0.y,gz0.y);
		  vec3 g010 = vec3(gx0.z,gy0.z,gz0.z);
		  vec3 g110 = vec3(gx0.w,gy0.w,gz0.w);
		  vec3 g001 = vec3(gx1.x,gy1.x,gz1.x);
		  vec3 g101 = vec3(gx1.y,gy1.y,gz1.y);
		  vec3 g011 = vec3(gx1.z,gy1.z,gz1.z);
		  vec3 g111 = vec3(gx1.w,gy1.w,gz1.w);
		  vec4 norm0 = taylorInvSqrt(vec4(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));
		  g000 *= norm0.x;
		  g010 *= norm0.y;
		  g100 *= norm0.z;
		  g110 *= norm0.w;
		  vec4 norm1 = taylorInvSqrt(vec4(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));
		  g001 *= norm1.x;
		  g011 *= norm1.y;
		  g101 *= norm1.z;
		  g111 *= norm1.w;
		  float n000 = dot(g000, Pf0);
		  float n100 = dot(g100, vec3(Pf1.x, Pf0.yz));
		  float n010 = dot(g010, vec3(Pf0.x, Pf1.y, Pf0.z));
		  float n110 = dot(g110, vec3(Pf1.xy, Pf0.z));
		  float n001 = dot(g001, vec3(Pf0.xy, Pf1.z));
		  float n101 = dot(g101, vec3(Pf1.x, Pf0.y, Pf1.z));
		  float n011 = dot(g011, vec3(Pf0.x, Pf1.yz));
		  float n111 = dot(g111, Pf1);
		  vec3 fade_xyz = fade(Pf0);
		  vec4 n_z = mix(vec4(n000, n100, n010, n110), vec4(n001, n101, n011, n111), fade_xyz.z);
		  vec2 n_yz = mix(n_z.xy, n_z.zw, fade_xyz.y);
		  float n_xyz = mix(n_yz.x, n_yz.y, fade_xyz.x); 
		  return 2.2 * n_xyz;
		}`, [
        s1,
        o,
        d
    ]), m = new Ae(`float hashwithoutsine13(vec3 p3)
		{
			p3  = fract(p3 * .1031);
			p3 += dot(p3, p3.yzx + 33.33);
			return fract((p3.x + p3.y) * p3.z);
		}`), p = new Ae(`vec3 hashwithoutsine33(vec3 p3)
		{
			p3 = fract(p3 * vec3(.1031, .1030, .0973));
			p3 += dot(p3, p3.yxz+33.33);
			return fract((p3.xxy + p3.yxx)*p3.zyx);
		}`), g = new Ae(`float metric(in vec3 p)
		{
			// L2 
			return length(p);

			// Chebyshev 
			// vec3 a = abs(p);
			// return max(a.x, max(a.y, a.z));
		}`), y = new Ae(`float smin( float a, float b, float k )
		{
			float h = smoothstep(0.0, 1.0, 0.5 + 0.5 * (b - a) / k);
			float correction = k * h * (1.0 - h);
			return mix(b, a, h) - correction;
		}`), x = new Ae(`float smax( float a, float b, float k )
		{
			float h = smoothstep(1.0, 0.0, 0.5 + 0.5 * (a - b) / k);
			float correction = k * h * (1.0 - h);
			return mix(a, b, h) + correction;
		}`), v = new Ae(`float remap(float value, float input_min, float input_max, float output_min, float output_max) {
			// Compute width of each interval
			float input_width = input_max - input_min;
			float output_width = output_max - output_min;
		
			// Convert input range into a 0-1 range 
			float scaled = (value - input_min) / input_width;
		
			// Convert the 0-1 range into a value in output range
			return output_min + (scaled * output_width);
		}`), b = new Ae(`float voronoi(in vec3 x, in int style, in float smoothness, in float seed, in int quality) 
		{
			// Integer and fractional parts of this point's coordinates
			ivec3 p = ivec3(floor(x));
			vec3 f = fract(x);

			// Different variables that we will use to construct noise:
			//
			// f1: distance to the closest feature point
			// f2: distance to the second closest feature point
			// e: distance to the closest edge (cell boundary)
			//
			// We also compute "smooth" versions of all of the above quantites, essentially
			// replacing "hard" minimums with "smooth" minimums (described by IQ)
			float f1_smooth = 8.0;
			float f1 = 8.0;
			float f2_smooth = 8.0;
			float f2 = 8.0;
			float e_smooth = 8.0;
			float e = 8.0;

			// Variables stored from closest cell
			ivec3 mb;
			vec3 mr; 

			int steps = quality;
			
			for (int x = -steps; x <= steps; x++) 
			for (int y = -steps; y <= steps; y++)
			for (int z = -steps; z <= steps; z++)
			{
				ivec3 b = ivec3(x, y, z);
				vec3 r = vec3(b) + hashwithoutsine33(vec3(p + b) + seed) - f;
				float d = length(r);
				
				f1_smooth = smin(d, f1_smooth, smoothness);

				// Store un-smoothed distances too 
				if (d < f1) 
				{
					f2 = f1;
					f1 = d;

					mb = ivec3(x, y, z);
					mr = r;
				} 
				else if (d < f2) 
				{
					f2 = d;
				}
			}	
			
			// Second pass for edge distance  
			// skip for styles don't need
			if (style != 0 &&  style != 5 && style != 7)
			for (int x = -steps; x <= steps; x++) 
			for (int y = -steps; y <= steps; y++)
			for (int z = -steps; z <= steps; z++)
			{
				// Start search at the cell that contains the closest point to "x" (found in 1st pass)
				ivec3 b = mb + ivec3(x, y, z);
				vec3 r = vec3(b) + hashwithoutsine33(vec3(p + b) + seed) - f;
				float d1 = dot(0.5 * (mr + r), (r - mr)); 				// IQ normalizes "r - mr" but that breaks things for the smooth version?
				float d2 = dot(0.5 * (mr + r), normalize(r - mr));

				e_smooth = smin(d1, e_smooth, smoothness);

				e = min(e, d2);

				// Also compute a smooth version of F2 in this pass
				{
					ivec3 b = ivec3(x, y, z);
					if (b != mb) 
					{
						vec3 r = vec3(b) + hashwithoutsine33(vec3(p + b) + seed) - f;
						float d = length(r);

						f2_smooth = smin(d, f2_smooth, smoothness);
					}
				}
			}

			// Different visualization modes 
			if (style == 0) 
			{
				return f1_smooth;
			}
			if (style == 1) 
			{
				return f2_smooth;
			}
			if (style == 2) 
			{
				return f2_smooth - f1_smooth;
				
				// "Pebbles" also cool
				//return step(0.2, f2_smooth - f1_smooth);
			}
			if (style == 3) 
			{
				// This one is really good for rock / stone effects
				float a = f1; 
				float b = f2;
				float k = 3.0;
				float h = max(k - abs(a - b), 0.0) / k;
				float final = min(a, b) - h * h * k * (1.0 / 4.0);
				return final;
			}
			if (style == 4) 
			{
				// Some random adjustments to make this style stand out more 
				return exp(5.0 * e_smooth);
			}
			if (style == 5) 
			{
				return pow(f1_smooth, 3.0);
			}
			if (style == 6) 
			{				
				const float eps = 0.0125;

				// Thicker lines as the user increases the smoothness slider
				float thickness = smoothness * 0.25 + eps;

				// Blurrier lines as the user increases the smoothness slider
				float blur = pow(smoothness, 3.0) * 0.25 + eps;

				return smoothstep(
					thickness - thickness * blur, 
					thickness + thickness * blur, 
					e
				);
			}
			if (style == 7) 
			{
				return hashwithoutsine13(vec3(p + mb) + seed);
			}
		}
	`, [
        m,
        p,
        g,
        y,
        x,
        v
    ]);
    return {
        simplexFast: e,
        simplexPrecise: r,
        simplexFractal: i,
        simplexAshima: a,
        fbm: h,
        perlin: f,
        voronoi: b
    };
}();
var vf = class extends rt {
    constructor(e, r, i, s1, o, a, l, c, u1, h, d, f, m, p, g, y, x, v, b){
        super("v3");
        this.nodeType = "Noise";
        this.scale = e, this.size = r, this.move = i, this.fA = s1, this.fB = o, this.distortion = a, this.colorA = l, this.colorB = c, this.colorC = u1, this.colorD = h, this.noiseType = f, this.voronoiStyle = p, this.highCut = g, this.lowCut = y, this.smoothness = x, this.seed = v, this.quality = b, this.isMask = m, this.alpha = d, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r, i, s1, o) {
        e.require("uv"), e.requires.uv = [
            !0
        ], e.addFragmentVariable(this.calpha, "float");
        let l = [
            "simplexFast",
            "simplexFractal",
            "simplexAshima",
            "fbm",
            "perlin",
            "voronoi"
        ][this.noiseType.value], c = l == "voronoi" ? `
		float v = ${l}(st + move, voronoiStyle, smoothness, seed, quality);

		// Apply clipping to colors
		v = remap(v, lowCut, highCut, 0.0, 1.0);
		v = smax(v, 0.0, smoothness * 0.25);
		v = smin(v, 1.0, smoothness * 0.25);

		// Note that the voronoi mode only uses colors "A" and "C" from the UI 
		vec4 color = mix(colorA, colorC, v); 
		` : `
		vec3 q = vec3(${l}(st),
					   ${l}(st + vec3(1.0)),
					   ${l}(st + vec3(1.0)));
		vec3 r = vec3(${l}(st + vec3(distortion, 1.0) * q + vec3(fA, 1.0) + move),
					  ${l}(st + vec3(distortion, 1.0) * q + vec3(fB, 1.0) + move), 
					  ${l}(st * q));
		float f = ${l}(st + r);
		vec4 color;
		color = mix(colorA, colorB, clamp((f * f) * 4.0, 0.0, 1.0));
		color = mix(color, colorC, clamp(length(q), 0.0, 1.0));
		color = mix(color, colorD, clamp(length(r.x), 0.0, 1.0));
		`, u1 = new Ae(`vec3 ${l}customNoise(float scale, vec3 size, float move, vec2 fA, vec2 fB, vec2 distortion, vec4 colorA, vec4 colorB, vec4 colorC, vec4 colorD, int voronoiStyle, float highCut, float lowCut, float smoothness, float seed, int quality, bool isMask, float mask, float alpha, out float calpha) 
			{
                // Prevent scale of zero 
				scale = max(abs(scale), 0.001);

				vec3 st = position / size;
				st /= scale;

				${c}

				float lalpha = alpha * color.a * mask;
				calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return clamp(color, 0.0, 1.0).rgb;
			}`, [
            Yi.simplexFast,
            Yi.simplexFractal,
            Yi.simplexAshima,
            Yi.fbm,
            Yi.perlin,
            Yi.voronoi
        ]), h = e.include(u1), d = [];
        return d.push(this.scale.build(e, "f")), d.push(this.size.build(e, "v3")), d.push(this.move.build(e, "f")), d.push(this.fA.build(e, "v2")), d.push(this.fB.build(e, "v2")), d.push(this.distortion.build(e, "v2")), d.push(this.colorA.build(e, "v4")), d.push(this.colorB.build(e, "v4")), d.push(this.colorC.build(e, "v4")), d.push(this.colorD.build(e, "v4")), d.push(this.voronoiStyle.build(e, "i")), d.push(this.highCut.build(e, "f")), d.push(this.lowCut.build(e, "f")), d.push(this.smoothness.build(e, "f")), d.push(this.seed.build(e, "f")), d.push(this.quality.build(e, "i")), d.push(this.isMask.build(e, "b")), d.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), d.push(this.alpha.build(e, "f")), d.push(this.calpha), e.format(h + "(" + d.join(",") + ")", this.getType(e), r);
    }
};
vf.numOctaves = 5;
var dT = class extends rt {
    constructor(e, r, i, s1, o, a, l, c, u1, h, d, f, m, p, g, y){
        super("v3");
        this.nodeType = "Outline";
        this.firstTime = !0, this.outlineColor = e, this.contourColor = r, this.outlineWidth = i, this.contourWidth = s1, this.contourThreshold = o, this.outlineThreshold = a, this.contourFrequency = l, this.outlineSmoothing = c, this.contourDirection = u1, this.positionalLines = h, this.compensation = d, this.resolution = f, this.normalMap = m, this.depthMap = p, this.pixelRatio = g, this.alpha = y, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        let i = `g${this.uuid.toString().replace(/-/g, "")}`;
        if (e.require("vWorldViewDir"), e.require("worldNormal"), e.extensions.derivatives = !0, this.compensation.value && e.define("OUTLINE_COMPENSATION", `${i}_offset`), this.firstTime) {
            let s1 = this.outlineWidth.build(e, "f"), o = this.resolution.build(e, "v2"), a = this.compensation.build(e, "b"), l = this.pixelRatio.build(e, "f");
            e.addVertexParsVariable("randomColor", "attribute vec3"), e.addVertexParsVariable("extrudeNormal", "attribute vec3"), e.addVertexParsVariable(s1, "uniform float"), e.addVertexParsVariable(o, "uniform vec2"), e.addVertexParsVariable(a, "uniform bool"), e.addVertexParsVariable(l, "uniform float"), e.addVertexParsVariable("vID", "flat out float"), e.addFragmentParsVariable("vID", "flat in float"), e.addVertexFinalCode(`
                vID = randomColor.r;
                vec2 ${i}_offset = vec2(0.0);
                if (${a}) {
                    vec4 ${i}_clipPosition = projectionMatrix * (modelViewMatrix * vec4(transformed, 1.0));
                    // NOTE: For certain shapes, like spheres, we get incorrect extrusion when the
                    // normals face the camera directly. So we hackily fix this by offsetting the normal
                    // by a tiny amount.
                    vec3 ${i}_clipNormal = mat3(projectionMatrix) * (mat3(modelViewMatrix) * extrudeNormal) + 0.0000001;
                    ${i}_offset = normalize(${i}_clipNormal.xy) / ${o} * (${s1} / 2.0) * ${i}_clipPosition.w * 2.0 * ${l};
                    ${i}_clipPosition.xy += ${i}_offset;
                    // TODO(MAX): To handle multiple outline layers, we only want to extrude
                    // if this offset is the biggest of all the potential offsets
                    gl_Position = ${i}_clipPosition;
                }
            `);
        }
        if (e.isShader("fragment")) {
            e.require("uv"), e.requires.uv = [
                !0
            ], e.addFragmentVariable(this.calpha, "float");
            let s1 = e.include(dT.Nodes.outline), o = [];
            return o.push(this.outlineColor.build(e, "c")), o.push(this.contourColor.build(e, "c")), o.push(this.outlineWidth.build(e, "f")), o.push(this.contourWidth.build(e, "f")), o.push(this.contourThreshold.build(e, "f")), o.push(this.outlineThreshold.build(e, "f")), o.push(this.contourFrequency.build(e, "f")), o.push(this.outlineSmoothing.build(e, "f")), o.push(this.contourDirection.build(e, "v3")), o.push(this.positionalLines.build(e, "b")), o.push(this.resolution.build(e, "v2")), o.push(this.normalMap.getTexture(e, "t")), o.push(this.depthMap.getTexture(e, "t")), o.push(this.pixelRatio.build(e, "f")), o.push(this.compensation.build(e, "b")), o.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), o.push(this.alpha.build(e, "f")), o.push(this.calpha), this.firstTime = !this.firstTime, e.format(s1 + "(" + o.join(",") + ")", this.getType(e), r);
        } else return console.warn("OutlineNode is not compatible with " + e.shader + " shader."), "";
    }
}, xf = dT;
xf.Nodes = function() {
    let e = new Ae(`
float sobelSample(sampler2D t, sampler2D d, vec2 uv, vec2 resolution, float outlineWidth, float pixelRatio)
{
    vec2 halton = haltonSequence[frameIndex];
    float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
    float temporalAngle  = temporalOffset * PI2;

    vec2 texelSize = (vec2(1.0) / resolution);
    vec2 offsetSize = texelSize * outlineWidth * pixelRatio;

    vec2 uvSamples[9];
    vec4 normalSamples[9];

	uvSamples[0] = uv + vec2( -offsetSize.x, -offsetSize.y) + (vogelDiskSample(0, 9, temporalAngle) * texelSize);
	uvSamples[1] = uv + vec2(0.0, -offsetSize.y) + (vogelDiskSample(1, 9, temporalAngle) * texelSize);
	uvSamples[2] = uv + vec2(  offsetSize.x, -offsetSize.y) + (vogelDiskSample(2, 9, temporalAngle) * texelSize);
	uvSamples[3] = uv + vec2( -offsetSize.x, 0.0) + (vogelDiskSample(3, 9, temporalAngle) * texelSize);
	uvSamples[4] = uv;
	uvSamples[5] = uv + vec2(  offsetSize.x, 0.0) + (vogelDiskSample(5, 9, temporalAngle) * texelSize);
	uvSamples[6] = uv + vec2( -offsetSize.x, offsetSize.y) + (vogelDiskSample(6, 9, temporalAngle) * texelSize);
	uvSamples[7] = uv + vec2(0.0, offsetSize.y) + (vogelDiskSample(7, 9, temporalAngle) * texelSize);
	uvSamples[8] = uv + vec2(  offsetSize.x, offsetSize.y) + (vogelDiskSample(8, 9, temporalAngle) * texelSize);


    normalSamples[0] = texture2D(t, uvSamples[0]);
    normalSamples[1] = texture2D(t, uvSamples[1]);
    normalSamples[2] = texture2D(t, uvSamples[2]);
    normalSamples[3] = texture2D(t, uvSamples[3]);
    normalSamples[4] = texture2D(t, uvSamples[4]);
    normalSamples[5] = texture2D(t, uvSamples[5]);
    normalSamples[6] = texture2D(t, uvSamples[6]);
    normalSamples[7] = texture2D(t, uvSamples[7]);
    normalSamples[8] = texture2D(t, uvSamples[8]);

    float depthBias = 0.0001;
    // TODO(MAX): Can we somehow reduce the number of conditionals here with MATH?!
    if (normalSamples[0].a != vID && normalSamples[0].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[0]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[1].a != vID && normalSamples[1].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[1]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[2].a != vID && normalSamples[2].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[2]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[3].a != vID && normalSamples[3].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[3]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }


    if (normalSamples[4].a != vID && normalSamples[4].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[4]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[5].a != vID && normalSamples[5].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[5]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[6].a != vID && normalSamples[6].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[6]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[7].a != vID && normalSamples[7].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[7]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[8].a != vID && normalSamples[8].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[8]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    vec3 sobel_edge_h = normalSamples[2].rgb + (2.0*normalSamples[5].rgb) + normalSamples[8].rgb - (normalSamples[0].rgb + (2.0*normalSamples[3].rgb) + normalSamples[6].rgb);
  	vec3 sobel_edge_v = normalSamples[0].rgb + (2.0*normalSamples[1].rgb) + normalSamples[2].rgb - (normalSamples[6].rgb + (2.0*normalSamples[7].rgb) + normalSamples[8].rgb);

    float edgeNormal = sqrt(dot(sobel_edge_h, sobel_edge_h) + dot(sobel_edge_v, sobel_edge_v));
    return edgeNormal;
}
`);
    return {
        outline: new Ae(`vec3 outline(vec3 outlineColor, vec3 contourColor, float outlineWidth, float contourWidth, float outlineThreshold, float contourThreshold, float outlineSmoothing, float contourFrequency, vec3 contourDirection, bool positionalLines, vec2 resolution, sampler2D normalMap, sampler2D depthMap, float pixelRatio, bool compensation, float mask, float alpha, out float calpha) {
                vec3 result = outlineColor;
                float resultAlpha = 0.0;

                vec3 N = normalize(vWNormal);
                vec2 nuv = (gl_FragCoord.xy / resolution);
                float sobelSample = compensation ? sobelSample(normalMap, depthMap, nuv, resolution, outlineWidth / 2., pixelRatio) : sobelSample(normalMap, depthMap, nuv, resolution, outlineWidth, pixelRatio);
                resultAlpha = smoothstep(outlineThreshold - outlineSmoothing, outlineThreshold + outlineSmoothing, sobelSample);

                //resultAlpha = 1.0;
                //result = vec3(sobelSample);

                float t = 1.0 - contourThreshold;
                if(positionalLines) {
                    vec3 NDir = position * contourDirection;
                    float NT = NDir.x + NDir.y + NDir.z;
                    float f  = fract(NT * contourFrequency * 0.01);
                    float df = fwidth(NT * contourFrequency);

                    float g = smoothstep(df * (contourWidth * 0.01), df * (contourWidth * 0.01 * 2.0), f);
                    if (g < 1.0 && resultAlpha == 0.0) {
                        result = contourColor;
                        resultAlpha = 1.0;
                    }
                 }
                 else {
                    vec3 NDir = N * contourDirection;
                    float NT = NDir.x + NDir.y + NDir.z;
                    float df = fwidth(NT * contourThreshold);
                    float f = sin(NT * 1.0 * contourFrequency);
                    float g = smoothstep(0.0, df * contourWidth, 1.0 - f);

                    if (df > (t * 0.5) && g < 1.0 && resultAlpha == 0.0) {
                        result = contourColor;
                        resultAlpha = 1.0 - g;
                    }
                 }

                 float lalpha = alpha * resultAlpha * mask;
                 calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
                 accumAlpha += ( 1.0 - accumAlpha ) * lalpha;
				 
                 return result;
             }`, [
            e
        ])
    };
}();
var ta = class extends rt {
    constructor(e, r, i, s1, o, a, l, c, u1, h, d, f, m, p, g, y, x, v){
        super("v3");
        this.nodeType = "Pattern";
        this.style = e, this.projection = r, this.axis = i, this.blending = s1, this.offset = o, this.colorA = a, this.colorB = l, this.frequency = c, this.size = u1, this.variation = h, this.smoothness = d, this.zigzag = f, this.rotation = m, this.vertical = p, this.horizontal = g, this.sides = y, this.isMask = v, this.alpha = x, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.isShader("fragment")) {
            e.require("position"), e.require("uv"), e.requires.uv = [
                !0
            ], e.require("normal"), e.requires.normal = !0, e.addFragmentVariable(this.calpha, "float");
            let i;
            switch(this.style.value){
                case 0:
                    i = "circle";
                    break;
                case 1:
                    i = "ring";
                    break;
                case 2:
                    i = "polygon";
                    break;
                case 3:
                    i = "xcross";
                    break;
                case 4:
                    i = "diamond";
                    break;
                case 5:
                    i = "checkerboard";
                    break;
                case 6:
                    i = "line";
                    break;
                case 7:
                    i = "wave";
                    break;
                default:
                    i = "circle";
                    break;
            }
            let s1 = `g${this.uuid.toString().replace(/-/g, "")}`, o = new Ae(`float hashwithoutsine12(vec2 p)
				{
					vec3 p3 = fract(vec3(p.xyx) * .1031);
					p3 += dot(p3, p3.yzx + 33.33);
					return fract((p3.x + p3.y) * p3.z);
				}`), a = new Ae(`vec2 rotate_uv(in vec2 uv, float a, bool repeat) 
				{
					const float mid = 0.5;
					float radians = a * (PI / 180.0);
					vec2 rotated = vec2(
						cos(radians) * (uv.x - mid) + sin(radians) * (uv.y - mid) + mid,
						cos(radians) * (uv.y - mid) - sin(radians) * (uv.x - mid) + mid
					);
					return repeat ? fract(rotated): rotated;
				}`), l = "";
            if (this.projection.value === 4) {
                let d = this.style.value === 2 ? `${i}(uv0, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(uv0, frequency, size, variation, smoothness_remapped, zigzag, rotation)`, f = this.style.value === 2 ? `${i}(uv1, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(uv1, frequency, size, variation, smoothness_remapped, zigzag, rotation)`, m = this.style.value === 2 ? `${i}(uv2, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(uv2, frequency, size, variation, smoothness_remapped, zigzag, rotation)`;
                l = `
				vec3 p = position;
				float factor = 0.0125;
				vec2 uv0 = fract(p.xy * factor);
				vec2 uv1 = fract(p.zy * factor);
				vec2 uv2 = fract(p.xz * factor);
				
				uv0 = rotate_uv(uv0 + offset, rotation, true);
				uv1 = rotate_uv(uv1 + offset, rotation, true);
				uv2 = rotate_uv(uv2 + offset, rotation, true);
	
				float d0 = ${d};
				float d1 = ${f};
				float d2 = ${m};
				
				// Range from 3 to 128 seems to be good
				float exponent = (1.0 - blending) * 125.0 + 3.0;

				vec3 n = vObjectNormal;
				vec3 weights = abs(normalize(n));
				weights = pow(weights, vec3(exponent));
				weights /= dot(weights, vec3(1.0));
				d0 *= weights.z;
				d1 *= weights.x;
				d2 *= weights.y;
				float draw = d0 + d1 + d2;
	
				vec2 custom_uv = uv0 * weights.z + uv1 * weights.x + uv2 * weights.y;
				`;
            } else {
                let d = this.style.value === 2 ? `${i}(custom_uv, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(custom_uv, frequency, size, variation, smoothness_remapped, zigzag, rotation)`, f = "";
                this.axis.value === 0 ? f = `float radius = length(p);
					float theta = atan(p.y, p.z);
					float phi = acos(p.x / radius);` : this.axis.value === 1 ? f = `float radius = length(p);
					float theta = atan(p.x, p.z);
					float phi = acos(p.y / radius);` : (this.axis.value, f = `float radius = length(p);
					float theta = atan(p.y, p.x);
					float phi = acos(p.z / radius);`);
                let m = "";
                switch(this.projection.value){
                    case 0:
                        m = "custom_uv = vUv.st;";
                        break;
                    case 1:
                        break;
                    case 2:
                        m = `
							vec3 p = position;
							${f}
							custom_uv = vec2(theta, phi);
							custom_uv /= PI;
							`;
                        break;
                    case 3:
                        break;
                    default:
                        break;
                }
                l = `
				vec2 custom_uv;
				${m}
	
				custom_uv += offset;
				custom_uv = fract(custom_uv);
				custom_uv = rotate_uv(custom_uv, rotation, true);
	
				float draw = ${d};
				`;
            }
            let c = new Ae(`vec3 ${s1}_pattern(vec3 normal, float blending, int style, vec2 offset, vec4 colorA, vec4 colorB, vec2 frequency, float size, float variation, float smoothness, float zigzag, float rotation, vec2 vertical, vec2 horizontal, int sides, bool isMask, float mask, float alpha, out float calpha) {
					const float TWO_PI = PI * 2.0;
					float smoothness_remapped = pow(smoothness, 5.0);	

					${l}

					// Construct final output color
					vec4 color = mix(colorA, colorB, draw);
					color.a = clamp(color.a, 0.0, 1.0);

					// Apply cuts
					color.a *= 
						step(vertical.x, custom_uv.y) * 
						step(custom_uv.y, vertical.y);
					color.a *= 
						step(horizontal.x, abs(custom_uv.x)) * 
						step(abs(custom_uv.x), horizontal.y);

					// Accumulate alpha 
					float lalpha = alpha * clamp(color.a, 0.0, 1.0) * mask;
					calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
					accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

					return clamp(color, 0.0, 1.0).rgb;
				}`, [
                a,
                o,
                ta.DrawFunctions.circle,
                ta.DrawFunctions.ring,
                ta.DrawFunctions.polygon,
                ta.DrawFunctions.cross,
                ta.DrawFunctions.diamond,
                ta.DrawFunctions.checkerboard,
                ta.DrawFunctions.line,
                ta.DrawFunctions.wave
            ]), u1 = e.include(c), h = [];
            return h.push("normal"), h.push(this.blending.build(e, "f")), h.push(this.style.build(e, "i")), h.push(this.offset.build(e, "v2")), h.push(this.colorA.build(e, "v4")), h.push(this.colorB.build(e, "v4")), h.push(this.frequency.build(e, "v2")), h.push(this.size.build(e, "f")), h.push(this.variation.build(e, "f")), h.push(this.smoothness.build(e, "f")), h.push(this.zigzag.build(e, "f")), h.push(this.rotation.build(e, "f")), h.push(this.vertical.build(e, "v2")), h.push(this.horizontal.build(e, "v2")), h.push(this.sides.build(e, "i")), h.push(this.isMask.build(e, "b")), h.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), h.push(this.alpha.build(e, "f")), h.push(this.calpha), e.format(u1 + "(" + h.join(",") + ")", this.getType(e), r);
        } else return console.warn("PatterNode is not compatible with " + e.shader + " shader."), e.format("vec3(0.0)", this.getType(e), r);
    }
}, bf = ta;
bf.DrawFunctions = function() {
    let e = new Ae(`float hashwithoutsine12(vec2 p) {
				vec3 p3 = fract(vec3(p.xyx) * 0.1031);
				p3 += dot(p3, p3.yzx + 33.33);
				return fract((p3.x + p3.y) * p3.z);
			}`), r = new Ae(`vec2 tile_and_center(in vec2 uv, in vec2 frequency, in float variation, in float zigzag, in float rotation) {
                // Create tiles in UV-space
                uv *= frequency;

                // Integer coords
                vec2 i = floor(uv);

                // Offset every other row based on zigzag param, then compute fractional coords
                float row_offset = mod(i.y, 2.0);
                uv.x += row_offset * zigzag;
                vec2 f = fract(uv);

				// Rotate the tile itself:
				// const float mid = 0.5;
				// f = vec2(
				// 	cos(rotation) * (f.x - mid) + sin(rotation) * (f.y - mid) + mid,
				// 	cos(rotation) * (f.y - mid) - sin(rotation) * (f.x - mid) + mid
				// );
				// f = fract(f);

                f = f * 2.0 - 1.0;

				// Recompute integer coords after shifting - then, random value per tile 
				i = floor(uv);
				float rand = (hashwithoutsine12(i) * 5.0 + 1.0);
				float jitter = mix(1.0, rand, variation);
				f *= jitter;

                return f;
            }`, [
        e
    ]), i = new Ae(`float circle(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
                return smoothstep(
                    -smoothness, 
                     smoothness, 
                     length(f) - size
                );
            }`, [
        r
    ]), s1 = new Ae(`float ring(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);

				float d = length(f);
                const float inner_width = 0.5;

                float outer = smoothstep(-smoothness, smoothness, d - size);
                float inner = smoothstep(-smoothness, smoothness, d - size * inner_width);
				return outer + (1.0 - inner);   
            }`, [
        r
    ]), o = new Ae(`float sdf_ngon(in vec2 p, in float r, in int n) {
                float an = (PI * 2.0) / float(n);
                float he = r * tan(0.5 * an);
                
                // Rotate to first sector
                p = -p.yx; 
                float bn = an * floor((atan(p.y, p.x) + 0.5 * an) / an);
                vec2  cs = vec2(cos(bn), sin(bn));
                p = mat2(cs.x, -cs.y, cs.y, cs.x)*p;
            
                // Side of polygon
                return length(p - vec2(r, clamp(p.y, -he, he))) * sign(p.x - r);
            }
            
            float polygon(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation, in int sides) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
                return smoothstep(-smoothness, smoothness, sdf_ngon(f, size, sides));
            }`, [
        r
    ]), a = new Ae(`float sdf_cross(in vec2 p, in vec2 b, float r ) {
                p = abs(p); 
				p = (p.y > p.x) ? p.yx : p.xy;
                vec2  q = p - b;
                float k = max(q.y, q.x);
                vec2  w = (k > 0.0) ? q : vec2(b.y - p.x, -k);
                return sign(k) * length(max(w, 0.0)) + r;
            }
            
            // Avoid namespace conflicts 
            float xcross(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
                return smoothstep(-smoothness, smoothness, sdf_cross(f, vec2(size, size * 0.25), smoothness));
            }`, [
        r
    ]), l = new Ae(`float ndot(vec2 a, vec2 b) { 
                return a.x*b.x - a.y*b.y; 
            }
            
            float sdf_diamond(in vec2 p, in vec2 b) {
                p = abs(p);
                float h = clamp(ndot(b - 2.0 * p, b) / dot(b, b), -1.0, 1.0);
                float d = length(p - 0.5 * b * vec2(1.0 - h, 1.0 + h));
                return d * sign(p.x * b.y + p.y * b.x - b.x * b.y);
            }

            float diamond(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
	            return smoothstep(-smoothness, smoothness, sdf_diamond(f, vec2(size)));
            }`, [
        r
    ]), c = new Ae(`float checkerboard(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                uv *= frequency;
                vec2 i = floor(uv);

                float offset = mod(i.y, 2.0);

                uv.x += offset + zigzag * offset;
                float x = floor(uv.x);
                
                return mod(x, 2.0);
            }`), u1 = new Ae(`float line(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, 0.0, zigzag, rotation);
				
				// Different approach for variation param here
				float row = floor(uv * frequency).y;
				float rand = hashwithoutsine12(vec2(row));
				float s = mix(size, size * rand, variation);

				return smoothstep(
					s - smoothness, 
					s + smoothness, 
					abs(f.y)
				);
            }`, [
        r
    ]), h = new Ae(`// Uses bisection 
            float udf_cos(in vec2 p, in float a, in float b, in float c, in float d) {
                // Convert all data to a primitive cosine wave
                p = c * (p - vec2(d, a));
                
                const float TWO_PI = PI * 2.0;

                // Reduce to principal half cycle
                p.x = mod(p.x, TWO_PI); 
                if (p.x > PI) {
                    p.x = TWO_PI - p.x;
                }
            
                // Find zero of derivative (minimize distance)
                float xa = 0.0;
                float xb = TWO_PI;

                // 24 bit precision
                for (int i = 0; i < 24; i++) {
                    float x = 0.5 * (xa + xb);
                    float y = x - p.x + b * c * sin(x) * (p.y - b * c * cos(x));
                    if (y < 0.0) xa = x; 
                    else xb = x;
                }
                float x = 0.5 * (xa + xb);
                
                // Compute distance    
                vec2 q = vec2(x, b * c * cos(x));
                return length(p - q) / c;
            }

            float wave(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                float repeat = frequency.x;
                uv *= repeat;
                vec2 i = floor(uv);
                float row_offset = mod(i.y, 2.0);
                uv.x += row_offset * zigzag;
                vec2 f = vec2(uv.x, fract(uv.y));

                // Generalized cosine: y(x) = a + b * cos(cx + d)
                const float amplitude = 0.125;
                float wave_frequency = frequency.y * 0.1;
                float distance_estimate = udf_cos(f, 0.50, amplitude, wave_frequency * (2.0 * PI), 0.0);

				// Different approach for variation param here
				float rand = hashwithoutsine12(vec2(i.y));
				float s = mix(size, size * rand, variation);

                return smoothstep(-smoothness, smoothness, distance_estimate - s * 0.5);
            }`);
    return {
        tileAndCenter: r,
        circle: i,
        ring: s1,
        polygon: o,
        cross: a,
        diamond: l,
        checkerboard: c,
        line: u1,
        wave: h
    };
}();
var fT = class extends rt {
    constructor(e, r, i, s1, o, a, l, c){
        super("v3");
        this.nodeType = "Rainbow";
        this.filmThickness = e, this.movement = r, this.wavelengths = i, this.noiseStrength = s1, this.noiseScale = o, this.offset = a, this.isMask = c, this.alpha = l, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.require("vWorldViewDir"), e.require("worldNormal"), e.isShader("fragment")) {
            e.require("uv"), e.requires.uv = [
                !0
            ], e.addFragmentVariable(this.calpha, "float");
            let i = e.include(fT.Nodes.rainbow), s1 = [];
            return s1.push(this.filmThickness.build(e, "f")), s1.push(this.movement.build(e, "f")), s1.push(this.wavelengths.build(e, "v3")), s1.push(this.noiseStrength.build(e, "f")), s1.push(this.noiseScale.build(e, "f")), s1.push(this.offset.build(e, "v3")), s1.push(this.isMask.build(e, "b")), s1.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s1.push(this.alpha.build(e, "f")), s1.push(this.calpha), e.format(i + "(" + s1.join(",") + ")", this.getType(e), r);
        } else return console.warn("RainbowNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Sf = fT;
Sf.Nodes = function() {
    let e = new Ae(`vec3 attenuation(vec3 wavelengths, float filmThickness, float movement, float noiseStrength, float noiseScale, vec3 offset) {
				float f = 0.0;
				
				if (noiseStrength != 0.0) {
					vec3 st = position / noiseScale;
					float noise = simplexFast(1.6 * st + vec3(1.8, 1.5, 1.9) * simplexFast(st) + vec3(1.7, 9.2, 1.0));
					f = noise * noiseStrength;
				}

				vec3 waves = wavelengths * vec3(1.0, 0.8, 0.6) + 1.0;
				float angle = dot(normalize(vWorldViewDir + (offset * -0.001)), normalize(vWNormal));

				mediump vec3 color = cos((((filmThickness + f) / waves) * angle) + movement);
				return .5 + .5 * color;
			 }`, [
        Yi.simplexFast
    ]);
    return {
        rainbow: new Ae(`vec3 rainbow(float filmThickness, float movement, vec3 wavelengths, float noiseStrength, float noiseScale, vec3 offset, bool isMask, float mask, float alpha, out float calpha) {
				mediump vec3 res = clamp(attenuation(wavelengths, filmThickness, movement, noiseStrength, noiseScale, offset), 0.0, 2.0);

				float rainbowContribution = clamp(res.r + res.g + res.b, 0.0, 1.0);

				float lalpha = alpha * rainbowContribution * mask;
				calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return res;
			 }`, [
            e
        ])
    };
}();
var pT = class extends rt {
    constructor(e, r, i, s1, o, a, l, c, u1, h){
        super("v3");
        this.nodeType = "Toon";
        this.positioning = e, this.colors = r, this.steps = i, this.source = s1, this.isWorldSpace = o, this.noiseStrength = a, this.noiseScale = l, this.shadowColor = c, this.offset = u1, this.alpha = h, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.require("worldNormal"), e.require("worldPosition"), e.isShader("fragment")) {
            e.define("COLORS_MAX", 10), e.addFragmentVariable(this.calpha, "float");
            let i = e.include(pT.Nodes.toon), s1 = [];
            return s1.push(this.positioning.build(e, "i")), s1.push(this.colors.build(e, "v4[]")), s1.push(this.steps.build(e, "f[]")), s1.push(this.source.build(e, "v3")), s1.push(this.isWorldSpace.build(e, "b")), s1.push(this.noiseStrength.build(e, "f")), s1.push(this.noiseScale.build(e, "f")), s1.push(this.shadowColor.build(e, "v4")), s1.push(this.offset.build(e, "v3")), s1.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s1.push(this.alpha.build(e, "f")), s1.push(this.calpha), e.format(i + "(" + s1.join(",") + ")", this.getType(e), r);
        } else return console.warn("ToonNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, wf = pT;
wf.Nodes = function() {
    let e = new Ae(`float rand(float n) {
				return fract(sin(n) * 43758.5453123);
			}`), r = new Ae(`float hash1(float p) { 
				p = fract(p * 0.011); 
				p *= p + 7.5; 
				p *= p + p; 
				return fract(p); 
			}`), i = new Ae(`float valueNoise(vec3 x) {
				const vec3 step = vec3(110, 241, 171);
			
				vec3 i = floor(x);
				vec3 f = fract(x);
			 
				// For performance, compute the base input to a 1D hash from the integer part of the argument and the 
				// incremental change to the 1D based on the 3D -> 1D wrapping
				float n = dot(i, step);
			
				vec3 u = f * f * (3.0 - 2.0 * f);
				return mix(mix(mix( hash1(n + dot(step, vec3(0, 0, 0))), hash1(n + dot(step, vec3(1, 0, 0))), u.x),
							   mix( hash1(n + dot(step, vec3(0, 1, 0))), hash1(n + dot(step, vec3(1, 1, 0))), u.x), u.y),
						   mix(mix( hash1(n + dot(step, vec3(0, 0, 1))), hash1(n + dot(step, vec3(1, 0, 1))), u.x),
							   mix( hash1(n + dot(step, vec3(0, 1, 1))), hash1(n + dot(step, vec3(1, 1, 1))), u.x), u.y), u.z);
			}`, [
        r
    ]), s1 = new Ae(`vec3 hash3(vec3 x) {
				x = vec3(dot(x,vec3(127.1, 311.7, 74.7)),
						 dot(x,vec3(269.5, 183.3, 246.1)),
						 dot(x,vec3(113.5, 271.9, 124.6)));
			
				return fract(sin(x)*43758.5453123);
			}`), o = new Ae(`vec3 voronoiNoise(in vec3 x)
			{
				vec3 p = floor(x);
				vec3 f = fract(x);

				float id = 0.0;
				vec2 res = vec2(100.0);

				for(int k=-1; k<=1; k++)
				for(int j=-1; j<=1; j++)
				for(int i=-1; i<=1; i++)
				{
					vec3 b = vec3(float(i), float(j), float(k));

					// Comment out the "+ hash(p + b);" part below to get "square" cells
					vec3 r = vec3(b) - f + hash3(p + b);
					float d = dot(r, r);

					if (d < res.x)
					{
						id = dot(p + b, vec3(1.0, 57.0, 113.0));
						res = vec2(d, res.x);			
					}
					else if (d < res.y)
					{
						res.y = d;
					}
				}

				return vec3(sqrt(res), abs(id));
			}
			`, [
        s1
    ]);
    return {
        toon: new Ae(`vec3 toon(int positioning, vec4 colors[COLORS_MAX], float steps[COLORS_MAX], vec3 source, bool isWorldSpace, float noiseStrength, float noiseScale, vec4 shadowColor, vec3 offset, float mask, float alpha, out float calpha) {
				float t = 0.0;
				float shadow = 1.0;

				if (positioning == 0) {

					// Can't do this mode if lighting is "none"
					#if (defined(PHONG) || defined(LAMBERT) || defined(STANDARD))

						// Algorithm from Chapter 10 of Graphics Shaders
						const vec3 weights = vec3(0.2125, 0.7154, 0.0721);
						vec3 lpos;
						vec3 l;
						float dproduct;

						#if (NUM_POINT_LIGHTS > 0)

							#if defined(USE_SHADOWMAP) && (NUM_POINT_LIGHT_SHADOWS > 0)
								PointLightShadow pointLightShadow;
							#endif 

							#pragma unroll_loop_start
							for (int i = 0; i < NUM_POINT_LIGHTS; i++) {
								// Light positions are in view-space for some reason?
								lpos = (inverse(viewMatrix) * vec4(pointLights[UNROLLED_LOOP_INDEX].position, 1.0)).xyz;
								l = normalize(lpos - worldPosition);
								
								dproduct = dot(l, normalize(worldNormal)) * 0.5 + 0.5;
								
								// TODO: we want to use "intensity" but it isn't available in the shader code
								//dproduct += dot(pointLights[UNROLLED_LOOP_INDEX].color, weights);

								t = max(t, dproduct);

								// Accumulate shadow contribution
								#if defined(USE_SHADOWMAP) && (UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS)
									pointLightShadow = pointLightShadows[UNROLLED_LOOP_INDEX];
									shadow *= getPointShadow( 
											pointShadowMap[UNROLLED_LOOP_INDEX], 
											pointLightShadow.shadowMapSize, 
											pointLightShadow.shadowBias, 
											pointLightShadow.shadowRadius,
											vPointShadowCoord[UNROLLED_LOOP_INDEX], 
											pointLightShadow.shadowCameraNear, 
											pointLightShadow.shadowCameraFar);
								#endif
							}
							#pragma unroll_loop_end

						#endif

						#if NUM_DIR_LIGHTS > 0 
							
							#if defined(USE_SHADOWMAP) && (NUM_DIR_LIGHT_SHADOWS > 0)
								DirectionalLightShadow directionalLightShadow;
							#endif 

							#pragma unroll_loop_start
							for (int i = 0; i < NUM_DIR_LIGHTS; i++) {
								// Use the direction vector for directional lights instead
								l = (inverse(viewMatrix) * vec4(directionalLights[UNROLLED_LOOP_INDEX].direction, 0.0)).xyz;
		
								dproduct = dot(l, normalize(worldNormal)) * 0.5 + 0.5;
								t = max(t, dproduct);

								// Accumulate shadow contribution
								#if defined(USE_SHADOWMAP) && (UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS)
									directionalLightShadow = directionalLightShadows[UNROLLED_LOOP_INDEX];
									shadow *= getShadow( 
										UNROLLED_LOOP_INDEX,
										directionalShadowMap[UNROLLED_LOOP_INDEX], 
										directionalLightShadow.shadowMapSize, 
										directionalLightShadow.shadowBias, 
										directionalLightShadow.shadowRadius, 
										vDirectionalShadowCoord[UNROLLED_LOOP_INDEX]);
								#endif
							}
							#pragma unroll_loop_end

						#endif

						#if NUM_SPOT_LIGHTS > 0 
							
							#if defined(USE_SHADOWMAP) && (NUM_SPOT_LIGHT_SHADOWS > 0)
								SpotLightShadow spotLightShadow;
							#endif 

							#pragma unroll_loop_start
							for (int i = 0; i < NUM_SPOT_LIGHTS; i++) {
								lpos = (inverse(viewMatrix) * vec4(spotLights[UNROLLED_LOOP_INDEX].position, 1.0)).xyz;
								l = normalize(lpos - worldPosition);
								
								dproduct = dot(l, normalize(worldNormal)) * 0.5 + 0.5;
								t = max(t, dproduct);

								// Accumulate shadow contribution
								#if defined(USE_SHADOWMAP) && (UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS)
									spotLightShadow = spotLightShadows[UNROLLED_LOOP_INDEX];
									shadow *= getShadow(
										UNROLLED_LOOP_INDEX,
										spotShadowMap[UNROLLED_LOOP_INDEX], 
										spotLightShadow.shadowMapSize, 
										spotLightShadow.shadowBias, 
										spotLightShadow.shadowRadius, 
										vSpotLightCoord[UNROLLED_LOOP_INDEX]);
								#endif
							}
							#pragma unroll_loop_end

						#endif

						t = clamp(t, 0.0, 1.0);
				
					#endif

				} else if (positioning == 1) {
					
					vec3 origin = mix(position, worldPosition, float(isWorldSpace));
					vec3 direction = normalize(source - origin);
					t = dot(direction, normalize(worldNormal)) * 0.5 + 0.5;	

				} else {

					vec3 origin = worldPosition;
					vec3 source = cameraPosition - offset;
					vec3 direction = normalize(source - origin);
					t = dot(direction, normalize(worldNormal)) * 0.5 + 0.5;	
					
				}

				if (noiseStrength > 0.0) {
					// Distort with noise
					vec3 st = position / noiseScale;
					
					// Voronoi "smooth" noise
					float noise = 1.0 - voronoiNoise(st).x;

					// Voronoi cellular noise
					//float noise = 1.0 - rand(voronoiNoise(st).z);

					// Position warp noise
					// vec3 offset = vec3(
					// 	simplexFast(st),
					// 	simplexFast(st + vec3(111.1, 143.89, 217.19)),
					// 	simplexFast(st + vec3(171.1, 247.89, 117.23))
					// );
					// st += offset;
					// float noise = valueNoise(st);

					t += noise * noiseStrength;
				}

				t = clamp(t, 0.0, 1.0);

				// Compute ramp color
				float p;
				vec4 color = colors[0];
				for (int i = 1; i < COLORS_MAX; i++) {
					p = clamp((t - steps[i-1]) / (steps[i] - steps[i-1]), 0.0, 1.0);
					color = mix(color, colors[i], smoothstep(0.0, 1.0, p));
				}

				// Incorporate custom shadow color
				if (positioning == 0) {

					vec3 blendedShadow = mix(color.rgb, shadowColor.rgb, shadowColor.a);
					color.rgb = mix(blendedShadow, color.rgb, shadow);
				
				}

				// Accumulate alpha as usual
				float lalpha = alpha * color.a * mask;
				calpha =  lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0);
				accumAlpha += (1.0 - accumAlpha) * lalpha;

				return color.xyz;

            }`, [
            Yi.simplexFast,
            e,
            i,
            o
        ])
    };
}();
var AL = function() {
    return {
        textureBicubic: new Ae(`float w0( float a ) {
            return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
        }
    
        float w1( float a ) {
            return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
        }
    
        float w2( float a ){
            return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
        }
    
        float w3( float a ) {
            return ( 1.0 / 6.0 ) * ( a * a * a );
        }
    
        // g0 and g1 are the two amplitude functions
        float g0( float a ) {
            return w0( a ) + w1( a );
        }
    
        float g1( float a ) {
            return w2( a ) + w3( a );
        }
    
        // h0 and h1 are the two offset functions
        float h0( float a ) {
            return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
        }
    
        float h1( float a ) {
            return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
        }
    
        vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
            uv = uv * texelSize.zw + 0.5;
    
            vec2 iuv = floor( uv );
            vec2 fuv = fract( uv );
    
            float g0x = g0( fuv.x );
            float g1x = g1( fuv.x );
            float h0x = h0( fuv.x );
            float h1x = h1( fuv.x );
            float h0y = h0( fuv.y );
            float h1y = h1( fuv.y );
    
            vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
            vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
            vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
            vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
    
            return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) + 
                   g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
        }

        vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
            vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
            vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
            vec2 fLodSizeInv = 1.0 / fLodSize;
            vec2 cLodSizeInv = 1.0 / cLodSize;
            vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
            vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
            return mix( fSample, cSample, fract( lod ) );
        }`)
    };
}();
function EL(n1, t) {
    return n1 >= t ? new U(t / n1, 1) : new U(1, n1 / t);
}
var mT = class extends rt {
    constructor(e, r, i, s1, o, a, l, c){
        super("v3");
        this.nodeType = "Transmission";
        this.thickness = e, this.ior = r, this.roughness = i, this.transmissionSamplerSize = s1, this.transmissionSamplerMap = o, this.transmissionDepthMap = a, this.aspectRatio = l, this.alpha = c, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, r) {
        if (e.extensions.shaderTextureLOD = !0, e.extensions.derivatives = !0, e.isShader("fragment")) {
            e.define("NUM_SAMPLES", 6), e.define("BLUR_SLOD", Math.pow(2, Je.transmissionLod.value)), e.require("worldPosition"), e.requires.worldNormal = !0, e.requires.modelMatrix = !0, e.requires.projectionMatrix = !0, e.addFragmentVariable(this.calpha, "float");
            let i = e.include(mT.Nodes.transmission), s1 = [];
            return s1.push(this.thickness.build(e, "f")), s1.push(this.ior.build(e, "f")), s1.push(this.roughness.build(e, "f")), s1.push(this.transmissionSamplerSize.build(e, "v2")), s1.push(this.transmissionSamplerMap.getTexture(e, "t")), s1.push(this.transmissionDepthMap.getTexture(e, "t")), s1.push(this.aspectRatio.build(e, "v2")), s1.push("normal"), s1.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s1.push(this.alpha.build(e, "f")), s1.push(this.calpha), e.format(i + "(" + s1.join(",") + ")", this.getType(e), r);
        } else return console.warn("TransmissionNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Af = mT;
Af.Nodes = function() {
    let e = new Ae(`vec3 blur(sampler2D sp, vec2 U, vec2 scale, float lod, sampler2D dm, vec2 unrefractedU, vec2 aspectRatio) {
                // Slightly modified version of this:
                // https://www.shadertoy.com/view/ltScRG

				// Special case for blur == 0.0
				if (lod == 0.0) {
					#ifdef TEXTURE_LOD_EXT
					return texture2DLodEXT( sp, U, 0.0).rgb;
					#else
					return textureLod( sp, U, 0.0).rgb;
					#endif
				}
				
				vec2 texelSize = vec2(1.0) / resolution;
                vec2 halton = haltonSequence[frameIndex];
                float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
                float temporalAngle  = temporalOffset * PI2;
				vec3 res = vec3(0.0);
                vec2 uv = vec2(0.0);
                vec2 offset = vec2(0.0);
                vec2 vogelSample = vec2(0.0);
                for (int i = 0; i < NUM_SAMPLES; i++) {
                    vogelSample =  vogelDiskSample(i, NUM_SAMPLES, temporalAngle) * texelSize;
                    offset = vogelSample * scale * (lod * 10.0); // TODO: used to be hardcoded to 20
                    uv = U + offset;
                    float opaqueDepth = unpackRGBAToDepth(textureLod(dm, uv, lod));
                    if (opaqueDepth != 0.0 && opaqueDepth < gl_FragCoord.z) {
                        uv = unrefractedU;
                        lod = lod > 4.0 ? lod : lod / 2.0;
                    }
                    res += textureLod(sp, uv, lod).rgb;
                }
                return res / float(NUM_SAMPLES);
            }`), r = new Ae(`vec3 getVolumeTransmissionRay( vec3 n, vec3 v, float thickness, float ior, mat4 modelMatrix ) {
		        // Direction of refracted light.
		        vec3 refractionVector = refract( -v,  n, 1.0 / ior );
		        
				// Compute rotation-independant scaling of the model matrix.
		        vec3 modelScale;
		        modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		        modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		        modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );

		        // The thickness is specified in local space
		        return normalize( refractionVector ) * thickness * modelScale;
	        }`), i = new Ae(`float applyIorToRoughness( float roughness, float ior ) {
				// Scale roughness with IOR so that an IOR of 1.0 results in no microfacet refraction and
				// an IOR of 1.5 results in the default amount of microfacet refraction.
				return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
			}`), s1 = new Ae(`vec3 getTransmissionSample( vec2 fragCoord, float roughness, float ior, vec2 transmissionSamplerSize, sampler2D transmissionSamplerMap, sampler2D transmissionDepthMap, vec2 unrefractedCoords, vec2 aspectRatio) {
				// Threejs exports do not pass a depth map to this shader, so we have to fallback to the "Threejs method of blurring" - see
				// also the code in convertTransmission.ts, which runs during export
				#ifdef IS_THREEJS_EXPORT
					float lod = log2(transmissionSamplerSize.x) * applyIorToRoughness(roughness / 5.0, ior);
					return textureBicubic(transmissionSamplerMap, fragCoord.xy, lod).rgb;
				#else
					float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
					float lod = applyIorToRoughness(roughness, ior);
					return blur(transmissionSamplerMap, fragCoord, vec2(lod), min(framebufferLod / 5.5, 8.5), transmissionDepthMap, unrefractedCoords, aspectRatio);
				#endif
			}`, [
        AL.textureBicubic,
        i,
        e
    ]), o = new Ae(`vec3 getIBLVolumeRefraction( vec3 n, vec3 v, float roughness, vec3 position, mat4 modelMatrix, mat4 viewMatrix, mat4 projMatrix, float ior, float thickness, vec2 transmissionSamplerSize, sampler2D transmissionSamplerMap, sampler2D transmissionDepthMap, vec2 aspectRatio ) {
				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
				vec3 refractedRayExit = position + transmissionRay;

				// Project refracted vector on the framebuffer, while mapping to normalized device coordinates.
				vec4 ndcPos = projMatrix * viewMatrix *  vec4( refractedRayExit, 1.0 );
				vec2 refractionCoords = ndcPos.xy / ndcPos.w;
				refractionCoords += 1.0;
				refractionCoords /= 2.0;

				vec4 ndcPosUnrefracted = projMatrix * viewMatrix * vec4(position, 1.0 );
				vec2 unrefractedCoords = ndcPosUnrefracted.xy / ndcPosUnrefracted.w;
				unrefractedCoords += 1.0;
				unrefractedCoords /= 2.0;

				// Sample framebuffer to get pixel the refracted ray hits.
				return getTransmissionSample( refractionCoords, roughness, ior, transmissionSamplerSize, transmissionSamplerMap, transmissionDepthMap, unrefractedCoords, aspectRatio );
    		}`, [
        s1,
        r
    ]);
    return {
        transmission: new Ae(`vec3 transmission(float thickness, float ior, float roughness, vec2 transmissionSamplerSize, sampler2D transmissionSamplerMap, sampler2D transmissionDepthMap, vec2 aspectRatio, vec3 normal, float mask, float alpha, out float calpha) {
                vec3 v = vec3(0.);
                if (isOrthographic) {
                    v = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
                } else {
                    v = normalize(vWPosition - cameraPosition);
                }
                vec3 transmission = getIBLVolumeRefraction(vWNormal, -v, roughness,  vWPosition, modelMatrix, viewMatrix, projectionMatrix, ior, thickness, transmissionSamplerSize, transmissionSamplerMap, transmissionDepthMap, aspectRatio );
                
				float lalpha = alpha * mask;
				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += ( 1.0 - accumAlpha ) * alpha;

				return transmission;
            }`, [
            o
        ])
    };
}();
var gT = ((e)=>(e.NOISE = "noise", e.MAP = "map", e))(gT || {}), yT = class extends rt {
    constructor(e, r, i, s1, o, a, l, c, u1, h, d){
        super("v3");
        this.displacementTypeIndex = new Bt(0);
        this.nodeType = "VertexDisplacement";
        this.intensity = e, this.movementOrTexture = r, Object.values(gT)[this.displacementTypeIndex.value] === "map" && (this.mat = new uf(this.movementOrTexture.value.matrix)), this.cropOrOffset = i, this.scale = h, this.noiseFunctionIndex = d, this.voronoiStyle = s1, this.smoothness = o, this.seed = a, this.highCut = l, this.lowCut = c, this.quality = u1;
    }
    generate(e, r) {
        if (e.isShader("vertex")) {
            e.define("USE_LAYER_DISPLACE");
            let i, s1 = [];
            switch(s1.push("displaced_position"), s1.push("displaced_normal"), Object.values(gT)[this.displacementTypeIndex.value]){
                case "map":
                    i = e.include(yT.Nodes.map), s1.push(this.movementOrTexture.getTexture(e, "t")), s1.push("uv"), s1.push(this.cropOrOffset.build(e, "f")), this.mat && s1.push(this.mat.build(e, "mat3"));
                    break;
                case "noise":
                    {
                        let l = [
                            "simplexPrecise",
                            "simplexFractal",
                            "simplexAshima",
                            "fbm",
                            "perlin",
                            "voronoi"
                        ][this.noiseFunctionIndex.value], c = new Ae(`vec3 orthogonal(vec3 v) {
							return normalize(abs(v.x) > abs(v.z) ? vec3(-v.y, v.x, 0.0) : vec3(0.0, -v.z, v.y));
						}`), u1 = l == "voronoi" ? `
					float v = ${l}((p + offset) * scale * 0.001 + neighbour_offset + (movement * 0.1), voronoiStyle, smoothness, seed, quality);
					v = remap(v, lowCut, highCut, 0.0, 1.0);
					v = smax(v, 0.0, smoothness * 0.25);
					v = smin(v, 1.0, smoothness * 0.25);

					return p + n * v * intensity;
					` : `
					return p + n * ${l}((p + offset) * scale * 0.001 + neighbour_offset + (movement * 0.1)) * intensity;
					`, h = new Ae(`vec3 distorted(vec3 p, vec3 n, float scale, float intensity, vec3 offset, float neighbour_offset, float movement, int voronoiStyle, float smoothness, float seed, float highCut, float lowCut, int quality) {
							${u1}
						}`, [
                            Yi.simplexPrecise,
                            Yi.simplexFractal,
                            Yi.simplexAshima,
                            Yi.fbm,
                            Yi.perlin,
                            Yi.voronoi
                        ]), d = new Ae(`vec3 vertexDisplacementNoise(vec3 position, vec3 normal, float scale, vec3 offset, float movement, int voronoiStyle, float smoothness, float seed, float highCut, float lowCut, int quality, float intensity, out vec3 displaced_normal) {
							vec3 displaced_position = distorted(position, normal, scale, intensity, offset, neighbor_offset, movement, voronoiStyle, smoothness, seed, highCut, lowCut, quality);
							vec3 tangent1 = orthogonal(normal);
							vec3 tangent2 = normalize(cross(normal, tangent1));

                            // TODO(Max): The distance to the neighbors was originally scaled by 0.1.
                            // This caused some small oval/circular visual artifacts in the lighting.
                            // For now, simply using neighbors further away betters the problem,
                            // but we should figure out the underlying cause when we have some time.
                            // Maybe its related to how we calculate the tangent and bitangent?
							vec3 nearby1 = position + tangent1;
							vec3 nearby2 = position + tangent2;
							vec3 distorted1 = distorted(nearby1, normal, scale, intensity, offset, neighbor_offset, movement, voronoiStyle, smoothness, seed, highCut, lowCut, quality);
							vec3 distorted2 = distorted(nearby2, normal, scale, intensity, offset, neighbor_offset, movement, voronoiStyle, smoothness, seed, highCut, lowCut, quality);
							displaced_normal = normalize(cross(distorted1 - displaced_position, distorted2 - displaced_position));
							return displaced_position;
						}`, [
                            h,
                            c
                        ]);
                        i = e.include(d), s1.push(this.scale.build(e, "f")), s1.push(this.cropOrOffset.build(e, "v3")), s1.push(this.movementOrTexture.build(e, "f")), s1.push(this.voronoiStyle.build(e, "i")), s1.push(this.smoothness.build(e, "f")), s1.push(this.seed.build(e, "f")), s1.push(this.highCut.build(e, "f")), s1.push(this.lowCut.build(e, "f")), s1.push(this.quality.build(e, "i"));
                        break;
                    }
            }
            return s1.push(this.intensity.build(e, "f")), s1.push("displaced_normal"), e.format(i + "(" + s1.join(",") + ")", this.getType(e), r);
        } else return console.warn("VertexDisplacementNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), r);
    }
}, Ef = yT;
Ef.Nodes = function() {
    let e = new Ae(`vec3 orthogonal(vec3 v) {
				return normalize(abs(v.x) > abs(v.z) ? vec3(-v.y, v.x, 0.0) : vec3(0.0, -v.z, v.y));
			}`), r = new Ae(`float displacementMapTexture(sampler2D tex, float crop, vec2 uv, mat3 mat, vec2 offset) {
				vec2 uvs = (mat * vec3(uv * 2.0 - 1.0, 1.0) / 2.0 + 0.5).xy + offset;
				vec4 tmp = texture2D(tex, uvs);
				vec3 col = tmp.rgb;
				if (crop > 0.5) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						return 0.0;
					}
				}
				return col.r;
			}`);
    return {
        map: new Ae(`vec3 vertexDisplacementMap(vec3 position, vec3 normal, sampler2D tex, vec2 uv, float crop, mat3 mat, float intensity, out vec3 displaced_normal) {
				vec3 displaced_position = position + normal * displacementMapTexture(tex, crop, uv, mat, vec2(0.0)) * intensity;
				vec3 tangent1 = normalize(orthogonal(normal));
				vec3 tangent2 = normalize(cross(normal, tangent1));
				vec3 nearby1 = position + tangent1 * 0.1;
				vec3 nearby2 = position + tangent2 * 0.1;
				vec3 distorted1 = nearby1 + normal * displacementMapTexture(tex, crop, uv, mat, vec2(neighbor_offset)) * intensity;
				vec3 distorted2 = nearby2 + normal * displacementMapTexture(tex, crop, uv, mat, vec2(neighbor_offset)) * intensity;
				displaced_normal = normalize(cross(distorted1 - displaced_position, distorted2 - displaced_position));
				return displaced_position;
			}`, [
            e,
            r
        ])
    };
}();
var Je = {
    normalRenderTarget: new Mn,
    normalRenderTargetDepth: new Mn,
    transmissionRenderTarget: new Mn,
    aspectRatio: new Zr,
    transmissionSize: new Zr(2048, 2048),
    transmissionRenderTargetDepth: new Mn,
    aoRenderTarget: new Mn,
    aoEnabled: new Jr,
    pixelRatioNode: new Ve(1),
    resolution: new Zr,
    penumbraSize: new so(5, .5),
    frameIndex: new Bt(0),
    transmissionLod: new Bt(2),
    taaEnabled: new Jr(!0)
};
for (let n1 of Object.values(Je))n1.isRenderGlobal = !0;
var zx = {
    skiaWasmUrl: "https://unpkg.com/@splinetool/ui-wasm@1.12.53/build/ui.wasm"
};
var Qa = class extends pr {
    constructor(){
        super("basic");
        this.nodeType = "Basic";
        this.color = new ur(ai), this.shadingAlpha = new Ve(1), this.shadingBlend = new Bt(0), this.previousModelViewMatrix = new $i, this.previouseProjectionMatrix = new $i;
    }
    get category() {
        return "phong";
    }
    generate(e) {
        let r;
        if (e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: Je.frameIndex
            }), e.mergeUniform({
                resolution: Je.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Xs.merge([
                Ie.fog
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <skinning_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <morphtarget_pars_vertex>"
            ].join(`
`));
            let s1 = [
                "#include <beginnormal_vertex>",
                "#include <morphnormal_vertex>",
                `
				#include <skinbase_vertex>
				#include <skinnormal_vertex>
				#if !defined( USE_LAYER_DISPLACE )
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = normal;

				#if defined( USE_LAYER_DISPLACE )
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#if !defined( USE_LAYER_DISPLACE )
					#include <begin_vertex>
				#endif /* !USE_LAYER_DISPLACE */
				`
            ];
            i && s1.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s1.push("transformed = displaced_position;", "#include <morphtarget_vertex>", "#include <skinning_vertex>", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "	vNormal = transformedNormal;", "#endif"), s1.push("#include <project_vertex>", "#include <fog_vertex>", "#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "#include <worldpos_vertex>"), s1.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), r = s1.join(`
`);
        } else {
            this.color === void 0 && (this.color = new ur(ai)), this.color.analyze(e, {
                slot: "color"
            }), this.alpha && this.alpha.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            });
            let i = this.color.flow(e, "c", {
                slot: "color"
            }), s1 = this.alpha ? this.alpha.flow(e, "f") : void 0, o = this.alphaOverride ? this.alphaOverride.flow(e, "f") : void 0, a = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0;
            e.requires.transparent = s1 !== void 0, e.addParsCode([
                "varying vec3 vWPosition;",
                "#include <fog_pars_fragment>",
                "#include <dithering_pars_fragment>",
                "varying vec3 vViewPosition;",
                "#include <normal_pars_fragment>"
            ].join(`
`));
            let l = [
                "#include <normal_fragment_begin>",
                i.code
            ];
            s1 && l.push(s1.code, "#ifdef ALPHATEST", " if ( " + s1.result + " <= ALPHATEST ) discard;", "#endif"), a ? l.push(a.code, `vec3 outgoingLight = ${i.result};`, `vec3 finalColor = spe_blend(outgoingLight, ${a.result}, 1.0, SPE_BLENDING_NORMAL);`) : l.push(`vec3 finalColor = ${i.result};`);
            let c = "1.0";
            this.mask && (this.mask.analyze(e), c = `luminance(${this.mask.flow(e, "v3").result})`), s1 ? l.push(`gl_FragColor = vec4( finalColor, accumAlpha * ${s1.result} * ${c} );`) : l.push("gl_FragColor = vec4(" + i.result + ", 1.0 );"), o && l.push(`gl_FragColor.a *= ${o.result};`), l.push("#include <fog_fragment>", "#include <dithering_fragment>"), r = l.join(`
`);
        }
        return r;
    }
};
var Jm = class extends pr {
    constructor(){
        super("lambert");
        this.nodeType = "Lambert";
        this.color = new ur(ai), this.emissive = new ur(0), this.emissiveIntensity = new Ve(1), this.previousModelViewMatrix = new $i, this.previouseProjectionMatrix = new $i, this.shadingAlpha = new Ve(1), this.shadingBlend = new Bt(0), this.occlusion = new Jr(!0);
    }
    get category() {
        return "lambert";
    }
    build(e) {
        let r;
        if (e.define("LAMBERT"), e.requires.lights = !0, e.extensions.derivatives = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: Je.frameIndex
            }), e.mergeUniform({
                resolution: Je.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Xs.merge([
                Ie.fog,
                Ie.lights
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "varying vec3 vLightFront;",
                "varying vec3 vIndirectFront;",
                "#ifndef DOUBLE_SIDED",
                "   #define DOUBLE_SIDED",
                "#endif",
                "#ifdef DOUBLE_SIDED",
                "	varying vec3 vLightBack;",
                "	varying vec3 vIndirectBack;",
                "#endif",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <color_pars_vertex>",
                "#include <fog_pars_vertex>",
                "#include <skinning_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <morphtarget_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s1 = [
                "#include <beginnormal_vertex>",
                "#include <morphnormal_vertex>",
                `
				#include <skinbase_vertex>
				#include <skinnormal_vertex>
				#ifndef USE_LAYER_DISPLACE
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = objectNormal;

				#ifdef USE_LAYER_DISPLACE
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <begin_vertex>
				#endif
				`
            ];
            i && s1.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s1.push("transformed = displaced_position;", "#include <morphtarget_vertex>", "#include <skinning_vertex>", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s1.push("	#include <project_vertex>", "	#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "	#include <worldpos_vertex>", `
					vec3 diffuse = vec3( 1.0 );
					GeometricContext geometry;
					geometry.position = mvPosition.xyz;
					geometry.normal = normalize( transformedNormal );
					geometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );
				`), s1.push(`
					GeometricContext backGeometry;
					backGeometry.position = geometry.position;
					backGeometry.normal = -geometry.normal;
					backGeometry.viewDir = geometry.viewDir;
					vLightFront = vec3( 0.0 );
					vIndirectFront = vec3( 0.0 );
					#ifdef DOUBLE_SIDED
						vLightBack = vec3( 0.0 );
						vIndirectBack = vec3( 0.0 );
					#endif
					IncidentLight directLight;
					float dotNL;
					vec3 directLightColor_Diffuse;
					vIndirectFront += getAmbientLightIrradiance( ambientLightColor );
					vIndirectFront += getLightProbeIrradiance( lightProbe, geometry.normal );
					#ifdef DOUBLE_SIDED
						vIndirectBack += getAmbientLightIrradiance( ambientLightColor );
						vIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry.normal );
					#endif
					#if NUM_POINT_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
							getPointLightInfo( pointLights[ i ], geometry, directLight );
							dotNL = dot( geometry.normal, directLight.direction );
							directLightColor_Diffuse = directLight.color;
							vLightFront += saturate( dotNL ) * directLightColor_Diffuse;
							#ifdef DOUBLE_SIDED
								vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;
							#endif
						}
						#pragma unroll_loop_end
					#endif
					#if NUM_SPOT_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
							getSpotLightInfo( spotLights[ i ], geometry, directLight );
							dotNL = dot( geometry.normal, directLight.direction );
							directLightColor_Diffuse = directLight.color;
							vLightFront += saturate( dotNL ) * directLightColor_Diffuse;
							#ifdef DOUBLE_SIDED
								vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;
							#endif
						}
						#pragma unroll_loop_end
					#endif
					#if NUM_DIR_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
							getDirectionalLightInfo( directionalLights[ i ], geometry, directLight );
							dotNL = dot( geometry.normal, directLight.direction );
							directLightColor_Diffuse = directLight.color;
							vLightFront += saturate( dotNL ) * directLightColor_Diffuse;
							#ifdef DOUBLE_SIDED
								vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;
							#endif
						}
						#pragma unroll_loop_end
					#endif
					#if NUM_HEMI_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
							vIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );
							#ifdef DOUBLE_SIDED
								vIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry.normal );
							#endif
						}
						#pragma unroll_loop_end
					#endif
				`, "	#include <shadowmap_vertex>", "	#include <fog_vertex>"), s1.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), r = s1.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: Je.penumbraSize
            }), e.mergeUniform({
                frameIndex: Je.frameIndex
            }), e.mergeUniform({
                aoMap: Je.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: Je.aoEnabled
            }), this.color === void 0 && (this.color = new ur(ai)), this.color.analyze(e, {
                slot: "color"
            }), this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e);
            let i = this.color.flow(e, "c", {
                slot: "color"
            }), s1 = this.emissive.flow(e, "c", {
                slot: "emissive"
            }), o = this.emissiveIntensity.flow(e, "f", {
                slot: "emissive"
            }), a = this.occlusion.flow(e, "b", {
                slot: "occlusion"
            }), l = this.shadingAlpha.flow(e, "f"), c = this.shadingBlend.flow(e, "i"), u1 = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, h = this.alpha ? this.alpha.flow(e, "f") : void 0, d = this.alphaOverride ? this.alphaOverride.flow(e, "f") : void 0;
            e.requires.transparent = h !== void 0, e.addParsCode([
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "varying vec3 vLightFront;",
                "varying vec3 vIndirectFront;",
                "#ifndef DOUBLE_SIDED",
                "   #define DOUBLE_SIDED",
                "#endif",
                "#include <normal_pars_fragment>",
                "#ifdef DOUBLE_SIDED",
                "	varying vec3 vLightBack;",
                "	varying vec3 vIndirectBack;",
                "#endif",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <fog_pars_fragment>",
                "#include <shadowmap_pars_fragment>",
                "#include <shadowmask_pars_fragment>",
                "#include <clipping_planes_pars_fragment>",
                "#include <dithering_pars_fragment>"
            ].join(`
`));
            let f = [
                "#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx, viewdy));
				bool isFrontFacing = (dot(normal, faceNormal) >= 0.0);
				`,
                "#include <clipping_planes_fragment>"
            ];
            f.push(i.code, "vec3 diffuseColor = " + i.result + ";", "ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );"), h && f.push(h.code, "#ifdef ALPHATEST", "if ( " + h.result + " <= ALPHATEST ) discard;", "#endif"), f.push("#ifdef DOUBLE_SIDED", "	reflectedLight.indirectDiffuse += ( isFrontFacing ) ? vIndirectFront : vIndirectBack;", "#else", "	reflectedLight.indirectDiffuse += vIndirectFront;", "#endif", "#include <lightmap_fragment>", "reflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );", "#ifdef DOUBLE_SIDED", "	reflectedLight.directDiffuse = ( isFrontFacing ) ? vLightFront : vLightBack;", "#else", "	reflectedLight.directDiffuse = vLightFront;", "#endif", "reflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();"), s1 && f.push(s1.code, "reflectedLight.directDiffuse += " + s1.result + " * " + o.result + ";"), f.push("vec3 ao = aoEnabled && " + a.result + " ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = (reflectedLight.directDiffuse + reflectedLight.indirectDiffuse) ;");
            let m = "1.0";
            this.mask && (this.mask.analyze(e), m = `luminance(${this.mask.flow(e, "v3").result})`), f.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${l.result} * ${m} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${l.result} * ${m}, ${c.result} );

					outgoingLight *= ao;
				}
				`), u1 && f.push(u1.code, `outgoingLight = spe_blend(outgoingLight, ${u1.result}, 1.0, SPE_BLENDING_NORMAL);`), h ? f.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${h.result} );`) : f.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), d && f.push(`gl_FragColor.a *= ${d.result};`), f.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), r = f.join(`
`);
        }
        return r;
    }
};
var Za = function() {
    let n1 = new Ae(`vec2 dHdxy(sampler2D bumpMap, vec2 bumpMapUv, float bumpScale) {

            // Gradient of UVs w.r.t. X coordinate (in screen-space)
            vec2 dSTdx = dFdx(bumpMapUv);

            // Gradient of UVs w.r.t. Y coordinate (in screen-space)
            vec2 dSTdy = dFdy(bumpMapUv);
            
            // Forward differencing
            float Hll = bumpScale * luminance(texture(bumpMap, bumpMapUv).rgb);
            float dBx = bumpScale * luminance(texture(bumpMap, bumpMapUv + dSTdx).rgb) - Hll;
            float dBy = bumpScale * luminance(texture(bumpMap, bumpMapUv + dSTdy).rgb) - Hll;
            
            return vec2( dBx, dBy );
        }`), t = new Ae(`vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
            vec3 vSigmaX = dFdx( surf_pos.xyz );
            vec3 vSigmaY = dFdy( surf_pos.xyz );
            vec3 vN = surf_norm; // normalized
            
            vN = normalize(vN);

            vec3 R1 = cross( vSigmaY, vN );
            vec3 R2 = cross( vN, vSigmaX );

            R1 = normalize(R1);
            R2 = normalize(R2);
    
            float fDet = dot( vSigmaX, R1 ) * faceDirection;
    
            vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
            return normalize( abs( fDet ) * vN - vGrad );
        }`);
    return {
        dHdxy: n1,
        perturbNormalArb: t
    };
}();
var $m = class extends pr {
    constructor(){
        super("phong");
        this.nodeType = "Phong";
        this.color = new ur(ai), this.specular = new ur(1118481), this.shininess = new Ve(30), this.previousModelViewMatrix = new $i, this.previouseProjectionMatrix = new $i, this.shadingAlpha = new Ve(1), this.shadingBlend = new Bt(0), this.occlusion = new Jr(!0);
    }
    get category() {
        return "phong";
    }
    build(e) {
        let r;
        if (e.define("PHONG"), e.requires.lights = !0, e.extensions.derivatives = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: Je.frameIndex
            }), e.mergeUniform({
                resolution: Je.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Xs.merge([
                Ie.fog,
                Ie.lights
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <skinning_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <morphtarget_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s1 = [
                "#include <beginnormal_vertex>",
                "#include <morphnormal_vertex>",
                `
				#include <skinbase_vertex>
				#include <skinnormal_vertex>
				#ifndef USE_LAYER_DISPLACE
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = objectNormal;

				#ifdef USE_LAYER_DISPLACE
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <begin_vertex>
				#endif
				`
            ];
            i && s1.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s1.push("transformed = displaced_position;", "#include <morphtarget_vertex>", "#include <skinning_vertex>", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s1.push("	#include <project_vertex>", "	#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "	#include <worldpos_vertex>", "	#include <shadowmap_vertex>", "	#include <fog_vertex>"), s1.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), r = s1.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: Je.penumbraSize
            }), e.mergeUniform({
                frameIndex: Je.frameIndex
            }), e.mergeUniform({
                aoMap: Je.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: Je.aoEnabled
            }), this.color === void 0 && (this.color = new ur(ai)), this.color.analyze(e, {
                slot: "color"
            }), this.specular.analyze(e), this.shininess.analyze(e);
            let i = this.occlusion.flow(e, "b", {
                slot: "occlusion"
            });
            this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e);
            let s1 = this.color.flow(e, "c", {
                slot: "color"
            }), o = this.specular.flow(e, "c"), a = this.shininess.flow(e, "f"), l = this.shadingAlpha.flow(e, "f"), c = this.shadingBlend.flow(e, "i"), u1 = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, h = this.alpha ? this.alpha.flow(e, "f") : void 0, d = this.alphaOverride ? this.alphaOverride.flow(e, "f") : void 0;
            e.requires.transparent = h !== void 0, e.addParsCode([
                "varying vec3 vWPosition;",
                "uniform vec3 emissive;",
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "#include <normal_pars_fragment>",
                "#include <fog_pars_fragment>",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <lights_phong_pars_fragment>",
                "#include <shadowmap_pars_fragment>",
                "#include <dithering_pars_fragment>"
            ].join(`
`));
            let f = [
                "#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx,viewdy));
				if (dot(normal, faceNormal) < 0.0) {
					normal *= -1.0;
				}
				`,
                "	BlinnPhongMaterial material;"
            ];
            if (this.bumpMap) {
                e.include(Za.dHdxy), e.include(Za.perturbNormalArb);
                let p = this.bumpMap.texture.flow(e, "t"), g = this.bumpMap.flow(e, "v3"), y = this.bumpMapIntensity ? this.bumpMapIntensity.flow(e, "f").result : "1.0", x = "";
                this.bumpMap.projection.value === 4 ? x = `
					vec3 bumpNormal = vec3(0.0);
					{
						vec2 uv0 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs0;
						vec2 uv1 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs1;
						vec2 uv2 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs2;
						vec3 weights = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_triplanarWeights;

						vec2 grad0 = dHdxy(${p.result}, uv0, ${y});
						vec3 n0 = perturbNormalArb(-vViewPosition, normal, grad0, faceDirection);

						vec2 grad1 = dHdxy(${p.result}, uv1, ${y});
						vec3 n1 = perturbNormalArb(-vViewPosition, normal, grad1, faceDirection);

						vec2 grad2 = dHdxy(${p.result}, uv2, ${y});
						vec3 n2 = perturbNormalArb(-vViewPosition, normal, grad2, faceDirection);
						
						bumpNormal = n0 * weights.z + n1 * weights.x + n2 * weights.y;
						bumpNormal = normalize(bumpNormal);
					}

					normal = bumpNormal;
					` : x = `
					vec2 bumpMapCachedUv = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs;
					vec2 grad = dHdxy(${p.result}, bumpMapCachedUv, ${y});
					normal = perturbNormalArb( - vViewPosition, normal, grad, faceDirection );
					`, f.push(`// Call the Texture Layer's function once here so that it writes out its procedural UV coordinates
					${g.result};
					${x}
					`);
            }
            f.push(s1.code, "	vec3 diffuseColor = " + s1.result + ";", "	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );", "	vec3 totalEmissiveRadiance = emissive;", o.code, "	vec3 specular = " + o.result + ";", a.code, "	float shininess = max( 0.0001, " + a.result + " );", "	float specularStrength = 1.0;"), h && f.push(h.code, "#ifdef ALPHATEST", "if ( " + h.result + " <= ALPHATEST ) discard;", "#endif"), f.push("material.diffuseColor = diffuseColor;"), f.push("material.specularColor = specular;", "material.specularShininess = shininess;", "material.specularStrength = specularStrength;", "#include <lights_fragment_begin>", "#include <lights_fragment_end>"), f.push("vec3 ao = aoEnabled && " + i.result + " ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = ((reflectedLight.directDiffuse + reflectedLight.indirectDiffuse)) + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;");
            let m = "1.0";
            this.mask && (this.mask.analyze(e), m = `luminance(${this.mask.flow(e, "v3").result})`), f.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${l.result} * ${m} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${l.result} * ${m}, ${c.result} );
					
					outgoingLight *= ao;
				}
				`), u1 && f.push(u1.code, `outgoingLight = spe_blend(outgoingLight, ${u1.result}, 1.0, SPE_BLENDING_NORMAL);`), h ? f.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${h.result});`) : f.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), d && f.push(`gl_FragColor.a *= ${d.result};`), f.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), r = f.join(`
`);
        }
        return r;
    }
};
var eg = class extends pr {
    constructor(){
        super("standard");
        this.nodeType = "Standard";
        this.color = new ur(ai), this.roughness = new Ve(.3), this.metalness = new Ve(0), this.reflectivity = new Ve(.5), this.previousModelViewMatrix = new $i, this.previouseProjectionMatrix = new $i, this.shadingAlpha = new Ve(1), this.shadingBlend = new Bt(0), this.occlusion = new Jr(!0);
    }
    get category() {
        return "physical";
    }
    build(e) {
        let r;
        if (e.define("STANDARD"), e.requires.lights = !0, e.extensions.derivatives = !0, e.extensions.shaderTextureLOD = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: Je.frameIndex
            }), e.mergeUniform({
                resolution: Je.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Xs.merge([
                Ie.fog,
                Ie.lights
            ])), Ie.LTC_1 && (e.uniforms.ltc_1 = {
                value: void 0
            }, e.uniforms.ltc_2 = {
                value: void 0
            }), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <skinning_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <morphtarget_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s1 = [
                "#include <beginnormal_vertex>",
                "#include <morphnormal_vertex>",
                `
				#include <skinbase_vertex>
				#include <skinnormal_vertex>
				#if !defined( USE_LAYER_DISPLACE )
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = objectNormal;

				#if defined( USE_LAYER_DISPLACE )
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#if !defined( USE_LAYER_DISPLACE )
					#include <begin_vertex>
				#endif /* !USE_LAYER_DISPLACE */
				`
            ];
            i && s1.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s1.push("transformed = displaced_position;", "#include <morphtarget_vertex>", "#include <skinning_vertex>", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s1.push("#include <project_vertex>", "#include <fog_vertex>", "#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "#include <worldpos_vertex>", "#include <shadowmap_vertex>"), s1.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), r = s1.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: Je.penumbraSize
            }), e.mergeUniform({
                frameIndex: Je.frameIndex
            }), e.mergeUniform({
                aoMap: Je.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: Je.aoEnabled
            });
            let i = {
                gamma: !0
            };
            this.color === void 0 && (this.color = new ur(ai)), this.color.analyze(e, {
                slot: "color",
                context: i
            }), this.roughness.analyze(e), this.metalness.analyze(e);
            let s1 = this.occlusion.flow(e, "b", {
                slot: "occlusion"
            });
            this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e), this.reflectivity && this.reflectivity.analyze(e);
            let o = this.color.flow(e, "c", {
                slot: "color",
                context: i
            }), a = this.roughness.flow(e, "f"), l = this.metalness.flow(e, "f"), c = this.shadingAlpha.flow(e, "f"), u1 = this.shadingBlend.flow(e, "i"), h = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, d = this.alpha ? this.alpha.flow(e, "f") : void 0, f = this.alphaOverride ? this.alphaOverride.flow(e, "f") : void 0, m = this.reflectivity ? this.reflectivity.flow(e, "f") : void 0;
            e.requires.transparent = d !== void 0, e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "#include <normal_pars_fragment>",
                "#include <dithering_pars_fragment>",
                "#include <fog_pars_fragment>",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <lights_physical_pars_fragment>",
                "#include <shadowmap_pars_fragment>"
            ].join(`
`));
            let p = [
                "#include <clipping_planes_fragment>",
                "	#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx,viewdy));
				if (dot(normal, faceNormal) < 0.0) {
					normal *= -1.0;
				}
				`,
                "	PhysicalMaterial material;",
                "	material.diffuseColor = vec3( 1.0 );"
            ];
            if (this.bumpMap) {
                e.include(Za.dHdxy), e.include(Za.perturbNormalArb);
                let y = this.bumpMap.texture.flow(e, "t"), x = this.bumpMap.flow(e, "v3"), v = this.bumpMapIntensity ? this.bumpMapIntensity.flow(e, "f").result : "1.0", b = "";
                this.bumpMap.projection.value === 4 ? b = `
					vec3 bumpNormal = vec3(0.0);
					{
						vec2 uv0 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs0;
						vec2 uv1 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs1;
						vec2 uv2 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs2;
						vec3 weights = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_triplanarWeights;

						vec2 grad0 = dHdxy(${y.result}, uv0, ${v});
						vec3 n0 = perturbNormalArb(-vViewPosition, normal, grad0, faceDirection);

						vec2 grad1 = dHdxy(${y.result}, uv1, ${v});
						vec3 n1 = perturbNormalArb(-vViewPosition, normal, grad1, faceDirection);

						vec2 grad2 = dHdxy(${y.result}, uv2, ${v});
						vec3 n2 = perturbNormalArb(-vViewPosition, normal, grad2, faceDirection);
						
						bumpNormal = n0 * weights.z + n1 * weights.x + n2 * weights.y;
						bumpNormal = normalize(bumpNormal);
					}

					normal = bumpNormal;
					` : b = `
					vec2 bumpMapCachedUv = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs;
					vec2 grad = dHdxy(${y.result}, bumpMapCachedUv, ${v});
					normal = perturbNormalArb( - vViewPosition, normal, grad, faceDirection );
					`, p.push(`// Call the Texture Layer's function once here so that it writes out its procedural UV coordinates
					${x.result};
					${b}
					`);
            }
            if (p.push(o.code, "	vec3 diffuseColor = " + o.result + ";", "	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );", l.code, "	float metalnessFactor = " + l.result + ";"), this.roughnessMap) {
                let y = this.roughnessMap.texture.flow(e, "t"), x = this.roughnessMap.flow(e, "v3"), v = "";
                this.roughnessMap.projection.value === 4 ? v = `
					float roughnessChange = 1.0;
					{
						vec2 uv0 = g${this.roughnessMap.uuid.toString().replace(/-/g, "")}_writeUvs0;
						vec2 uv1 = g${this.roughnessMap.uuid.toString().replace(/-/g, "")}_writeUvs1;
						vec2 uv2 = g${this.roughnessMap.uuid.toString().replace(/-/g, "")}_writeUvs2;
						vec3 weights = g${this.roughnessMap.uuid.toString().replace(/-/g, "")}_triplanarWeights;

						float r0 = luminance(texture(${y.result}, uv0).rgb) * roughnessScale;
						float r1 = luminance(texture(${y.result}, uv1).rgb) * roughnessScale;
						float r2 = luminance(texture(${y.result}, uv2).rgb) * roughnessScale;

						roughnessChange = (r0 * weights.z + r1 * weights.x + r2 * weights.y);
					}
					float roughnessFactor = roughnessChange * ${a.result};
					` : v = `
					vec2 roughnessMapCachedUv = g${this.roughnessMap.uuid.toString().replace(/-/g, "")}_writeUvs;

					vec4 vals = texture(${y.result},  roughnessMapCachedUv);
					float roughnessFactor = luminance(vals.rgb) * ${a.result};
					`, p.push(`// Call the Texture Layer's function once here so that it writes out its procedural UV coordinates
					${x.result};

					const float roughnessScale = 1.0;

					${v}
				`);
            } else p.push(a.code, "	float roughnessFactor = " + a.result + ";");
            d && p.push(d.code, "#ifdef ALPHATEST", "	if ( " + d.result + " <= ALPHATEST ) discard;", "#endif"), p.push("vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );", "float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );"), p.push("material.diffuseColor = diffuseColor * ( 1.0 - metalnessFactor );", "material.roughness = max( roughnessFactor, 0.0525 );", "material.roughness += geometryRoughness;", "material.roughness = min( material.roughness, 1.0 );", "material.roughness = clamp( roughnessFactor, 0.04, 1.0 );"), m ? p.push(m.code, "material.specularColor = mix( vec3( 0.16 * pow2( " + m.result + " ) ), diffuseColor, metalnessFactor );") : p.push("material.specularColor = mix( vec3( 0.04 ), diffuseColor, metalnessFactor );"), p.push("#include <lights_fragment_begin>"), p.push("#include <lights_fragment_end>"), p.push("vec3 ao = aoEnabled && " + s1.result + " ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = ((reflectedLight.directDiffuse + reflectedLight.indirectDiffuse)) + reflectedLight.directSpecular + reflectedLight.indirectSpecular;");
            let g = "1.0";
            this.mask && (this.mask.analyze(e), g = `luminance(${this.mask.flow(e, "v3").result})`), p.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${c.result} * ${g} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${c.result} * ${g}, ${u1.result} );
					
					outgoingLight *= ao;
				}
				`), h && p.push(h.code, `outgoingLight = spe_blend(outgoingLight, ${h.result}, 1.0, SPE_BLENDING_NORMAL);`), d ? p.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${d.result} );`) : p.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), f && p.push(`gl_FragColor.a *= ${f.result};`), p.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), r = p.join(`
`);
        }
        return r;
    }
};
var tg = class extends pr {
    constructor(){
        super("toon");
        this.nodeType = "Toon";
        this.color = new ur(ai), this.specular = new ur(1118481), this.shininess = new Ve(30), this.previousModelViewMatrix = new $i, this.previouseProjectionMatrix = new $i, this.shadingAlpha = new Ve(1), this.shadingBlend = new Bt(0);
    }
    get category() {
        return "toon";
    }
    build(e) {
        let r;
        if (e.define("TOON"), e.requires.lights = !0, e.extensions.derivatives = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: Je.frameIndex
            }), e.mergeUniform({
                resolution: Je.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Xs.merge([
                Ie.fog,
                Ie.lights
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <skinning_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <morphtarget_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s1 = [
                "#include <beginnormal_vertex>",
                "#include <morphnormal_vertex>",
                `
				#include <skinbase_vertex>
				#include <skinnormal_vertex>
				#ifndef USE_LAYER_DISPLACE
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = objectNormal;

				#ifdef USE_LAYER_DISPLACE
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <begin_vertex>
				#endif
				`
            ];
            i && s1.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s1.push("transformed = displaced_position;", "#include <morphtarget_vertex>", "#include <skinning_vertex>", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s1.push("	#include <project_vertex>", "	#include <fog_vertex>", "	#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "	#include <worldpos_vertex>", "	#include <shadowmap_vertex>", "	#include <fog_vertex>"), s1.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), r = s1.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: Je.penumbraSize
            }), e.mergeUniform({
                frameIndex: Je.frameIndex
            }), e.mergeUniform({
                aoMap: Je.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: Je.aoEnabled
            }), this.color === void 0 && (this.color = new ur(ai)), this.color.analyze(e, {
                slot: "color"
            }), this.specular.analyze(e), this.shininess.analyze(e), this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e);
            let i = this.color.flow(e, "c", {
                slot: "color"
            }), s1 = this.specular.flow(e, "c"), o = this.shininess.flow(e, "f"), a = this.shadingAlpha.flow(e, "f"), l = this.shadingBlend.flow(e, "i"), c = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, u1 = this.alpha ? this.alpha.flow(e, "f") : void 0, h = this.alphaOverride ? this.alphaOverride.flow(e, "f") : void 0;
            e.requires.transparent = u1 !== void 0, e.addParsCode([
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "varying vec3 vWPosition;",
                "#include <normal_pars_fragment>",
                "#include <gradientmap_pars_fragment>",
                "#include <fog_pars_fragment>",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <dithering_pars_fragment>",
                `
					varying vec3 vViewPosition;
					struct ToonMaterial {
						vec3	diffuseColor;
						vec3	specularColor;
						float	specularShininess;
						float	specularStrength;
					};
					void RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
						vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;
			
						reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
						reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;
					}
					void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
						reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
					}
					#define RE_Direct				RE_Direct_Toon
					#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon
					#define Material_LightProbeLOD( material )	(0)
					`,
                "#include <shadowmap_pars_fragment>",
                "#include <bumpmap_pars_fragment>",
                "#include <normalmap_pars_fragment>"
            ].join(`
`));
            let d = [
                "#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx,viewdy));
				if (dot(normal, faceNormal) < 0.0) {
					normal *= -1.0;
				}
				`,
                "	ToonMaterial material;"
            ];
            if (this.bumpMap) {
                e.include(Za.dHdxy), e.include(Za.perturbNormalArb);
                let m = this.bumpMap.texture.flow(e, "t"), p = this.bumpMap.flow(e, "v3"), g = this.bumpMapIntensity ? this.bumpMapIntensity.flow(e, "f").result : "1.0", y = "";
                this.bumpMap.projection.value === 4 ? y = `
					vec3 bumpNormal = vec3(0.0);
					{
						vec2 uv0 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs0;
						vec2 uv1 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs1;
						vec2 uv2 = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs2;
						vec3 weights = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_triplanarWeights;

						vec2 grad0 = dHdxy(${m.result}, uv0, ${g});
						vec3 n0 = perturbNormalArb(-vViewPosition, normal, grad0, faceDirection);

						vec2 grad1 = dHdxy(${m.result}, uv1, ${g});
						vec3 n1 = perturbNormalArb(-vViewPosition, normal, grad1, faceDirection);

						vec2 grad2 = dHdxy(${m.result}, uv2, ${g});
						vec3 n2 = perturbNormalArb(-vViewPosition, normal, grad2, faceDirection);
						
						bumpNormal = n0 * weights.z + n1 * weights.x + n2 * weights.y;
						bumpNormal = normalize(bumpNormal);
					}

					normal = bumpNormal;
					` : y = `
					vec2 bumpMapCachedUv = g${this.bumpMap.uuid.toString().replace(/-/g, "")}_writeUvs;
					vec2 grad = dHdxy(${m.result}, bumpMapCachedUv, ${g});
					normal = perturbNormalArb( - vViewPosition, normal, grad, faceDirection );
					`, d.push(`// Call the Texture Layer's function once here so that it writes out its procedural UV coordinates
					${p.result};
					${y}
					`);
            }
            d.push(i.code, "	vec3 diffuseColor = " + i.result + ";", "	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );", s1.code, "	vec3 specular = " + s1.result + ";", o.code, "	float shininess = max( 0.0001, " + o.result + " );", "	float specularStrength = 1.0;"), u1 && d.push(u1.code, "#ifdef ALPHATEST", "if ( " + u1.result + " <= ALPHATEST ) discard;", "#endif"), d.push("material.diffuseColor = diffuseColor;"), d.push("material.specularColor = specular;", "material.specularShininess = shininess;", "material.specularStrength = specularStrength;", "#include <lights_fragment_begin>", "#include <lights_fragment_end>"), d.push("vec3 ao = aoEnabled ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = ((reflectedLight.directDiffuse + reflectedLight.indirectDiffuse) * ao) + reflectedLight.directSpecular;");
            let f = "1.0";
            this.mask && (this.mask.analyze(e), f = `luminance(${this.mask.flow(e, "v3").result})`), d.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${a.result} * ${f} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${a.result} * ${f}, ${l.result} );
				}
				`), c && d.push(c.code, `outgoingLight = spe_blend(outgoingLight, ${c.result}, 1.0, SPE_BLENDING_NORMAL);`), u1 ? d.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${u1.result} );`) : d.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), h && d.push(`gl_FragColor.a *= ${h.result};`), d.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), r = d.join(`
`);
        }
        return r;
    }
};
var Gx = class {
    constructor(t = 10000){
        this.timeout = t;
        this.cache = new Map;
        this.head = {
            data: null,
            time: 0,
            src: null,
            next: null,
            prev: null
        };
        this.tail = {
            data: null,
            time: 1 / 0,
            src: null,
            next: null,
            prev: null
        };
        this.hasClean = !1;
        this.head.next = this.tail, this.tail.prev = this.head;
    }
    log(...t) {}
    remove(t) {
        let e = this.cache.get(t);
        e && (this.dispose(t, e.data), this.cache.delete(t), e.prev.next = e.next, e.next.prev = e.prev);
    }
    scheduleCleanup() {
        this.hasClean || (this.log("scheduled cleanup"), this.hasClean = !0, setTimeout(()=>{
            this.hasClean = !1, this.log("cleaning");
            let t = Date.now(), e = this.head.next;
            for(; e.time < t - this.timeout;)this.dispose(e.src, e.data), this.cache.delete(e.src), e = e.next, e.prev = this.head, this.head.next = e;
            this.head.next !== this.tail ? this.scheduleCleanup() : this.log("no more cleanup");
        }, this.timeout + 1e3));
    }
    has(t) {
        return this.cache.get(t)?.data;
    }
    load(t) {
        let e = Date.now(), r = this.cache.get(t);
        return r === void 0 ? (r = {
            data: this.create(t),
            src: t,
            time: e,
            next: null,
            prev: null
        }, this.cache.set(t, r)) : (r.time = e, r.prev.next = r.next, r.next.prev = r.prev), r.prev = this.tail.prev, r.next = this.tail, this.tail.prev.next = r, this.tail.prev = r, this.scheduleCleanup(), r.data;
    }
};
var xT = class extends Gx {
    create(t) {
        return URL.createObjectURL(new Blob([
            t
        ]));
    }
    dispose(t, e) {
        URL.revokeObjectURL(e);
    }
}, vT;
function TL(n1) {
    return typeof n1 == "string" ? n1 : (vT || (vT = new xT), vT.load(n1));
}
var jx = class {
    constructor(t, e){
        this.data = t;
        this.cache = e;
        this.refCount = 0;
    }
    deref() {
        this.refCount;
        this.refCount -= 1, this.refCount === 0 && (this.cache.remove(this), this.dispose());
    }
    dispose() {
        this.refCount;
    }
}, Hx = class {
    constructor(){
        this.cache = new Map;
    }
    remove(t) {
        this.cache.delete(t.data);
    }
    load(t) {
        let e = this.cache.get(t);
        return e === void 0 && (e = this.create(t), this.cache.set(t, e)), e.refCount += 1, e;
    }
};
var Tf = class extends jx {
    constructor(e, r){
        super(e, r.imageHolderCache);
        this.data = e;
        this.shared = r;
        this.loaded = !1;
        this.isVideo = !1;
        this.isBuffer = !1;
        this._cache = {
            [1e3]: {},
            [1001]: {},
            [1002]: {}
        };
        this.isVideo = e.type === "video", this.isBuffer = e.isWebGLRenderTarget === !0, this.loadPromise = this.updateSrc(this.isBuffer ? e : e.data);
    }
    async updateSrc(e) {
        if (typeof document > "u") return;
        this.disposeTextures(), this.loaded = !1;
        let r = ()=>{
            this.loaded = !0;
            for (let s1 of Object.values(this._cache))for (let o of Object.values(s1))for (let a of Object.values(o))a && (a.image = this.img, a.needsUpdate = !0);
            this.shared.requestRender();
        };
        if (this.isBuffer) this.img = e, this.loaded = !0;
        else if (this.isVideo) {
            if (this.img = document.createElement("video"), this.img.preload = "auto", this.img.playsInline = !0, this.img.currentTime = .01, typeof e != "string") {
                var i = new FileReader;
                i.readAsDataURL(new Blob([
                    e
                ], {
                    type: "video/mp4"
                }));
                let s1;
                await new Promise((o)=>{
                    i.onloadend = (a)=>{
                        s1 = a.target?.result, o(null);
                    };
                }), this.img.src = s1;
            } else this.img.src = e;
            this.img.onloadeddata = ()=>{
                r();
            };
        } else this.img = new Image, this.img.src = TL(e), this.img.onload = r, await new Promise((s1)=>{
            this.img.onload = ()=>{
                r(), s1(null);
            };
        });
    }
    getTexture(e, r = 1008, i = 1006) {
        let s1 = this._cache[e]?.[r]?.[i];
        if (s1) return s1;
        {
            let o;
            return this.isBuffer ? o = this.img.texture : this.isVideo ? o = new qy(this.img, void 0, e, e) : o = new Zt(this.img, void 0, e, e, i, r), this.loaded && (o.needsUpdate = !0), this._cache[e] === void 0 && (this._cache[e] = {}), this._cache[e][r] === void 0 && (this._cache[e][r] = {}), this._cache[e][r][i] = o, o;
        }
    }
    setNeedsUpdate(e) {
        for (let r of Object.values(this._cache))for (let i of Object.values(r))for (let s1 of Object.values(i))s1 && (s1.needsUpdate = e);
    }
    disposeTextures() {
        for (let [e, r] of Object.entries(this._cache))for (let [i, s1] of Object.entries(r))for (let [o, a] of Object.entries(s1))a?.dispose(), this._cache[e] !== void 0 && this._cache[e][i] !== void 0 && (this._cache[e][i][o] = void 0);
    }
    dispose() {
        super.dispose(), this.disposeTextures();
    }
};
var as = class extends Tf {
};
function ST(n1, t) {
    var e = eZ(t);
    return e.formatToParts ? JQ(e, n1) : $Q(e, n1);
}
var ZQ = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function JQ(n1, t) {
    try {
        for(var e = n1.formatToParts(t), r = [], i = 0; i < e.length; i++){
            var s1 = ZQ[e[i].type];
            s1 >= 0 && (r[s1] = parseInt(e[i].value, 10));
        }
        return r;
    } catch (o) {
        if (o instanceof RangeError) return [
            NaN
        ];
        throw o;
    }
}
function $Q(n1, t) {
    var e = n1.format(t).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(e);
    return [
        r[3],
        r[1],
        r[2],
        r[4],
        r[5],
        r[6]
    ];
}
var bT = {};
function eZ(n1) {
    if (!bT[n1]) {
        var t = new Intl.DateTimeFormat("en-US", {
            hour12: !1,
            timeZone: "America/New_York",
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }).format(new Date("2014-06-25T04:00:00.123Z")), e = t === "06/25/2014, 00:00:00" || t === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        bT[n1] = e ? new Intl.DateTimeFormat("en-US", {
            hour12: !1,
            timeZone: n1,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }) : new Intl.DateTimeFormat("en-US", {
            hourCycle: "h23",
            timeZone: n1,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    }
    return bT[n1];
}
function Wx(n1, t, e, r, i, s1, o) {
    var a = new Date(0);
    return a.setUTCFullYear(n1, t, e), a.setUTCHours(r, i, s1, o), a;
}
var ML = 36e5, tZ = 6e4, wT = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function rg(n1, t, e) {
    var r, i;
    if (!n1 || (r = wT.timezoneZ.exec(n1), r)) return 0;
    var s1;
    if (r = wT.timezoneHH.exec(n1), r) return s1 = parseInt(r[1], 10), CL(s1) ? -(s1 * ML) : NaN;
    if (r = wT.timezoneHHMM.exec(n1), r) {
        s1 = parseInt(r[1], 10);
        var o = parseInt(r[2], 10);
        return CL(s1, o) ? (i = Math.abs(s1) * ML + o * tZ, s1 > 0 ? -i : i) : NaN;
    }
    if (nZ(n1)) {
        t = new Date(t || Date.now());
        var a = e ? t : rZ(t), l = AT(a, n1), c = e ? l : iZ(t, l, n1);
        return -c;
    }
    return NaN;
}
function rZ(n1) {
    return Wx(n1.getFullYear(), n1.getMonth(), n1.getDate(), n1.getHours(), n1.getMinutes(), n1.getSeconds(), n1.getMilliseconds());
}
function AT(n1, t) {
    var e = ST(n1, t), r = Wx(e[0], e[1] - 1, e[2], e[3] % 24, e[4], e[5], 0).getTime(), i = n1.getTime(), s1 = i % 1e3;
    return i -= s1 >= 0 ? s1 : 1e3 + s1, r - i;
}
function iZ(n1, t, e) {
    var r = n1.getTime(), i = r - t, s1 = AT(new Date(i), e);
    if (t === s1) return t;
    i -= s1 - t;
    var o = AT(new Date(i), e);
    return s1 === o ? s1 : Math.max(s1, o);
}
function CL(n1, t) {
    return -23 <= n1 && n1 <= 23 && (t == null || 0 <= t && t <= 59);
}
var PL = {};
function nZ(n1) {
    if (PL[n1]) return !0;
    try {
        return new Intl.DateTimeFormat(void 0, {
            timeZone: n1
        }), PL[n1] = !0, !0;
    } catch  {
        return !1;
    }
}
var VL = cl(IL(), 1), MT = cl(OL(), 1);
var aZ = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, RL = aZ;
var ET = 36e5, LL = 6e4, lZ = 2, Cn = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    timeZone: RL
};
function CT(n1, t) {
    if (arguments.length < 1) throw new TypeError("1 argument required, but only " + arguments.length + " present");
    if (n1 === null) return new Date(NaN);
    var e = t || {}, r = e.additionalDigits == null ? lZ : (0, VL.default)(e.additionalDigits);
    if (r !== 2 && r !== 1 && r !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (n1 instanceof Date || typeof n1 == "object" && Object.prototype.toString.call(n1) === "[object Date]") return new Date(n1.getTime());
    if (typeof n1 == "number" || Object.prototype.toString.call(n1) === "[object Number]") return new Date(n1);
    if (!(typeof n1 == "string" || Object.prototype.toString.call(n1) === "[object String]")) return new Date(NaN);
    var i = cZ(n1), s1 = uZ(i.date, r), o = s1.year, a = s1.restDateString, l = hZ(a, o);
    if (isNaN(l)) return new Date(NaN);
    if (l) {
        var c = l.getTime(), u1 = 0, h;
        if (i.time && (u1 = dZ(i.time), isNaN(u1))) return new Date(NaN);
        if (i.timeZone || e.timeZone) {
            if (h = rg(i.timeZone || e.timeZone, new Date(c + u1)), isNaN(h)) return new Date(NaN);
        } else h = (0, MT.default)(new Date(c + u1)), h = (0, MT.default)(new Date(c + u1 + h));
        return new Date(c + u1 + h);
    } else return new Date(NaN);
}
function cZ(n1) {
    var t = {}, e = Cn.dateTimePattern.exec(n1), r;
    if (e ? (t.date = e[1], r = e[3]) : (e = Cn.datePattern.exec(n1), e ? (t.date = e[1], r = e[2]) : (t.date = null, r = n1)), r) {
        var i = Cn.timeZone.exec(r);
        i ? (t.time = r.replace(i[1], ""), t.timeZone = i[1].trim()) : t.time = r;
    }
    return t;
}
function uZ(n1, t) {
    var e = Cn.YYY[t], r = Cn.YYYYY[t], i;
    if (i = Cn.YYYY.exec(n1) || r.exec(n1), i) {
        var s1 = i[1];
        return {
            year: parseInt(s1, 10),
            restDateString: n1.slice(s1.length)
        };
    }
    if (i = Cn.YY.exec(n1) || e.exec(n1), i) {
        var o = i[1];
        return {
            year: parseInt(o, 10) * 100,
            restDateString: n1.slice(o.length)
        };
    }
    return {
        year: null
    };
}
function hZ(n1, t) {
    if (t === null) return null;
    var e, r, i, s1;
    if (n1.length === 0) return r = new Date(0), r.setUTCFullYear(t), r;
    if (e = Cn.MM.exec(n1), e) return r = new Date(0), i = parseInt(e[1], 10) - 1, BL(t, i) ? (r.setUTCFullYear(t, i), r) : new Date(NaN);
    if (e = Cn.DDD.exec(n1), e) {
        r = new Date(0);
        var o = parseInt(e[1], 10);
        return mZ(t, o) ? (r.setUTCFullYear(t, 0, o), r) : new Date(NaN);
    }
    if (e = Cn.MMDD.exec(n1), e) {
        r = new Date(0), i = parseInt(e[1], 10) - 1;
        var a = parseInt(e[2], 10);
        return BL(t, i, a) ? (r.setUTCFullYear(t, i, a), r) : new Date(NaN);
    }
    if (e = Cn.Www.exec(n1), e) return s1 = parseInt(e[1], 10) - 1, FL(t, s1) ? NL(t, s1) : new Date(NaN);
    if (e = Cn.WwwD.exec(n1), e) {
        s1 = parseInt(e[1], 10) - 1;
        var l = parseInt(e[2], 10) - 1;
        return FL(t, s1, l) ? NL(t, s1, l) : new Date(NaN);
    }
    return null;
}
function dZ(n1) {
    var t, e, r;
    if (t = Cn.HH.exec(n1), t) return e = parseFloat(t[1].replace(",", ".")), TT(e) ? e % 24 * ET : NaN;
    if (t = Cn.HHMM.exec(n1), t) return e = parseInt(t[1], 10), r = parseFloat(t[2].replace(",", ".")), TT(e, r) ? e % 24 * ET + r * LL : NaN;
    if (t = Cn.HHMMSS.exec(n1), t) {
        e = parseInt(t[1], 10), r = parseInt(t[2], 10);
        var i = parseFloat(t[3].replace(",", "."));
        return TT(e, r, i) ? e % 24 * ET + r * LL + i * 1e3 : NaN;
    }
    return null;
}
function NL(n1, t, e) {
    t = t || 0, e = e || 0;
    var r = new Date(0);
    r.setUTCFullYear(n1, 0, 4);
    var i = r.getUTCDay() || 7, s1 = t * 7 + e + 1 - i;
    return r.setUTCDate(r.getUTCDate() + s1), r;
}
var fZ = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
], pZ = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function UL(n1) {
    return n1 % 400 === 0 || n1 % 4 === 0 && n1 % 100 !== 0;
}
function BL(n1, t, e) {
    if (t < 0 || t > 11) return !1;
    if (e != null) {
        if (e < 1) return !1;
        var r = UL(n1);
        if (r && e > pZ[t] || !r && e > fZ[t]) return !1;
    }
    return !0;
}
function mZ(n1, t) {
    if (t < 1) return !1;
    var e = UL(n1);
    return !(e && t > 366 || !e && t > 365);
}
function FL(n1, t, e) {
    return !(t < 0 || t > 52 || e != null && (e < 0 || e > 6));
}
function TT(n1, t, e) {
    return !(n1 != null && (n1 < 0 || n1 >= 25) || t != null && (t < 0 || t >= 60) || e != null && (e < 0 || e >= 60));
}
function Yx(n1, t, e) {
    var r = CT(n1, e), i = rg(t, r, !0), s1 = new Date(r.getTime() - i), o = new Date(0);
    return o.setFullYear(s1.getUTCFullYear(), s1.getUTCMonth(), s1.getUTCDate()), o.setHours(s1.getUTCHours(), s1.getUTCMinutes(), s1.getUTCSeconds(), s1.getUTCMilliseconds()), o;
}
function en(n1, t) {
    return t.color(n1);
}
function PT(n1 = new Date, t) {
    let e = t.format, r = n1.getSeconds(), i = n1;
    t && t.timeZone !== null && (i = Yx(new Date, t.timeZone));
    let s1 = i.getHours(), o = i.getMinutes(), a;
    t.format12h24h === "12ampm" && (a = s1 >= 12 ? "PM" : "AM");
    let l = s1;
    t.format12h24h !== "24" && (l = s1 % 12, l === 0 && (l = 12));
    let c, u1;
    switch(e){
        case "HH:mm:ss":
            c = [
                l,
                o,
                r
            ];
            break;
        case "HH:mm":
            c = [
                l,
                o
            ];
            break;
        case "HH":
            c = [
                l
            ], a = void 0;
            break;
        case "mm":
            c = [
                o
            ], a = void 0;
            break;
        case "ss":
            c = [
                r
            ], a = void 0;
            break;
        case "year":
            u1 = i.getFullYear();
            break;
        case "month":
            u1 = i.getMonth() + 1;
            break;
        case "dayOfYear":
            u1 = Math.floor((i.getTime() - new Date(i.getFullYear(), 0, 0).getTime()) / 864e5);
            break;
        case "dayOfMonth":
            u1 = i.getDate();
            break;
        case "secondOfDay":
            u1 = s1 * 3600 + o * 60 + r;
            break;
        default:
            console.error("Unknown time format", e), u1 = 0;
            break;
    }
    return c !== void 0 ? {
        textValue: c,
        suffix: a
    } : u1;
}
function kL(n1, t) {
    switch(n1.type){
        case "fresnel":
            return vZ(n1, t);
        case "gradient":
            return xZ(n1, t);
        case "depth":
            return bZ(n1, t);
        case "normal":
            return SZ(n1, t);
        case "noise":
            return wZ(n1, t);
        case "rainbow":
            return AZ(n1, t);
        case "toon":
            return EZ(n1, t);
        case "outline":
            return TZ(n1, t);
        case "transmission":
            return MZ(n1, t);
        case "pattern":
            return CZ(n1, t);
        case "color":
        default:
            return yZ(n1, t);
    }
}
function gZ(n1) {
    return {
        type: n1.type
    };
}
function ao(n1, t) {
    let { alpha: e, mode: r, isMask: i } = n1, s1 = typeof e == "string" ? (Number(t.getVariable(e)) ?? 100) / 100 : e;
    return {
        ...gZ(n1),
        alpha: s1,
        mode: r,
        isMask: i
    };
}
function yZ(n1, t) {
    return {
        ...ao(n1, t),
        color: en(n1.color, t)
    };
}
function vZ(n1, t) {
    let { bias: e, scale: r, intensity: i, factor: s1, color: o } = n1;
    return {
        ...ao(n1, t),
        color: en(o, t),
        bias: e,
        scale: r,
        intensity: i,
        factor: s1
    };
}
function xZ(n1, t) {
    let { gradientType: e, smooth: r, colors: i, steps: s1, angle: o, offset: a, morph: l } = n1;
    return {
        ...ao(n1, t),
        gradientType: e,
        smooth: r,
        colors: i.map((c)=>new Ze(c[0], c[1], c[2], c[3])),
        num: i.length,
        steps: s1,
        offset: new U(...a.map((c)=>typeof c == "number" ? c : 0)),
        morph: new U(...l.map((c)=>typeof c == "number" ? c : 0)),
        angle: o
    };
}
function bZ(n1, t) {
    let { gradientType: e, near: r, far: i, isVector: s1, isWorldSpace: o, origin: a, direction: l, colors: c, steps: u1, smooth: h } = n1;
    return {
        ...ao(n1, t),
        gradientType: e,
        near: r,
        far: i,
        isVector: s1,
        isWorldSpace: o,
        origin: new E(...a),
        direction: l ? new E(...l) : new E(1, 0, 0),
        colors: c.map((d)=>d !== void 0 ? new Ze(d[0], d[1], d[2], d[3]) : new Ze(0, 0, 0, 0)),
        steps: u1.slice(0, c.length),
        smooth: h
    };
}
function SZ(n1, t) {
    let { cnormal: e } = n1;
    return {
        ...ao(n1, t),
        cnormal: new E(e[0], e[1], e[2])
    };
}
function wZ(n1, t) {
    return {
        ...ao(n1, t),
        scale: n1.scale,
        move: n1.move,
        fA: new U(...n1.fA.map((e)=>typeof e == "number" ? e : 0)),
        fB: new U(...n1.fB.map((e)=>typeof e == "number" ? e : 0)),
        size: new E(...n1.size),
        distortion: new U(...n1.distortion.map((e)=>typeof e == "number" ? e : 0)),
        colorA: en(n1.colorA, t),
        colorB: en(n1.colorB, t),
        colorC: en(n1.colorC, t),
        colorD: en(n1.colorD, t),
        noiseType: n1.noiseType,
        voronoiStyle: n1.voronoiStyle,
        highCut: n1.highCut,
        lowCut: n1.lowCut,
        smoothness: n1.smoothness,
        seed: n1.seed,
        quality: n1.quality
    };
}
function AZ(n1, t) {
    return {
        ...ao(n1, t),
        filmThickness: n1.filmThickness,
        movement: n1.movement,
        wavelengths: new E(...n1.wavelengths),
        noiseStrength: n1.noiseStrength,
        noiseScale: n1.noiseScale,
        offset: new E(...n1.offset)
    };
}
function EZ(n1, t) {
    return {
        ...ao(n1, t),
        positioning: n1.positioning,
        colors: n1.colors.map((e)=>new Ze(e[0], e[1], e[2], e[3])),
        num: n1.colors.length,
        steps: n1.steps,
        source: new E(...n1.source),
        isWorldSpace: n1.isWorldSpace,
        noiseStrength: n1.noiseStrength,
        noiseScale: n1.noiseScale,
        shadowColor: en(n1.shadowColor, t),
        offset: new E(...n1.offset)
    };
}
function TZ(n1, t) {
    return {
        ...ao(n1, t),
        outlineColor: en(n1.outlineColor, t),
        contourColor: en(n1.contourColor, t),
        outlineWidth: n1.outlineWidth,
        contourWidth: n1.contourWidth,
        outlineThreshold: n1.outlineThreshold,
        contourThreshold: n1.contourThreshold,
        outlineSmoothing: n1.outlineSmoothing,
        contourFrequency: n1.contourFrequency,
        contourDirection: new E(...n1.contourDirection),
        positionalLines: n1.positionalLines,
        compensation: n1.compensation
    };
}
function MZ(n1, t) {
    return {
        ...ao(n1, t),
        thickness: n1.thickness,
        ior: n1.ior,
        roughness: n1.roughness
    };
}
function CZ(n1, t) {
    return {
        ...ao(n1, t),
        style: n1.style,
        projection: n1.projection,
        axis: n1.axis,
        blending: n1.blending,
        offset: new U(...n1.offset.map((e)=>typeof e == "number" ? e : 0)),
        colorA: en(n1.colorA, t),
        colorB: en(n1.colorB, t),
        frequency: new U(...n1.frequency.map((e)=>typeof e == "number" ? e : 0)),
        size: n1.size,
        variation: n1.variation,
        smoothness: n1.smoothness,
        zigzag: n1.zigzag,
        rotation: n1.rotation,
        vertical: new U(...n1.vertical.map((e)=>typeof e == "number" ? e : 0)),
        horizontal: new U(...n1.horizontal.map((e)=>typeof e == "number" ? e : 0)),
        sides: n1.sides
    };
}
var sc = class extends cr {
};
var PZ = {
    noise: [
        "noiseType"
    ],
    texture: [
        "projection",
        "axis",
        "side"
    ],
    video: [
        "projection",
        "axis",
        "side"
    ],
    displace: [
        "noiseType"
    ],
    light: [
        "roughnessMap",
        "bumpMap"
    ],
    depth: [
        "smooth",
        "isWorldSpace",
        "gradientType",
        "isVector"
    ],
    pattern: [
        "style",
        "projection",
        "axis"
    ]
}, _Z = {
    depth: [
        "colors"
    ]
};
function IZ(n1, t, e) {
    if (t === "isMask") return !0;
    let r = PZ[n1.type], i = _Z[n1.type];
    if (i !== void 0) {
        let s1 = n1.color;
        if (i.includes(t)) {
            let o = s1[t]?.value?.length;
            if (o !== void 0 && o !== e.length) return !0;
        }
    }
    return r !== void 0 ? r.includes(t) : !1;
}
function _T(n1, t) {
    if (Array.isArray(t)) {
        if (!Array.isArray(n1) || n1.length !== t.length) return !1;
        for (let [i, s1] of t.entries()){
            let o = n1[i];
            if (typeof s1 == "string" || typeof s1 == "number" && typeof o == "string") return !0;
        }
        return !1;
    }
    let e = typeof n1 == "string", r = typeof t == "string";
    return e !== r || e && r;
}
function ig(n1, t, e) {
    let r = e.uniforms[`f${e.id}_texture`];
    if (!r) return !1;
    let i = !1, s1 = n1;
    if ("image" in s1) {
        let o = s1.image, a = t.image(o), l = r;
        l.image instanceof as || l.image.deref(), l.image = a;
    }
    if ("video" in s1) {
        let o = s1.video, a = t.video(o), l = r;
        l.image instanceof as || l.image.deref(), l.image = a;
    }
    if ("wrapping" in s1) {
        let o = r;
        o.wrap = s1.wrapping;
    }
    if ("minFilter" in s1) {
        let o = r;
        o.minFilter = s1.minFilter;
    }
    if ("magFilter" in s1) {
        let o = r;
        o.magFilter = s1.magFilter;
    }
    if ("rotation" in s1 && e.uniforms[`f${e.id}_rotation`]) return e.uniforms[`f${e.id}_rotation`].value = (ct(s1.rotation ?? 0, t) ?? 0) * Se.DEG2RAD, i;
    if ("repeat" in s1 || "offset" in s1 || "rotation" in s1) {
        let o = "mat", a = e.uniforms[`f${e.id}_${o}`];
        if (!a) return i;
        if ("repeat" in s1) {
            let l = s1.repeat;
            _T(e.data.texture.repeat, l) && (i = !0), a.repeat = Mf(l, t).map((c, u1)=>typeof l[u1] == "string" ? 1 / c : c);
        }
        if ("offset" in s1) {
            let l = s1.offset;
            _T(e.data.texture.offset, l) && (i = !0), a.offset = Mf(l, t).map((c, u1)=>typeof l[u1] == "string" ? -c : c);
        }
        if ("rotation" in s1) {
            let l = e.data.texture.rotation, c = s1.rotation ?? 0;
            (l === void 0 || _T(l, c)) && (i = !0), a.rotation = ct(c, t) ?? 0;
        }
        a.updateMatrix();
    }
    return i;
}
function zL(n1, t, e, r) {
    let i = !1;
    for (let [s1, o] of Object.entries(n1)){
        if (s1 === "bumpMap" || s1 === "roughnessMap") {
            i = !0;
            continue;
        }
        if (!s1 || o === void 0) continue;
        if (IT(s1, e, r, t)) {
            s1 === "visible" && e.type === "light" && (i = !0);
            continue;
        }
        e.visible = r.visible;
        let a = e.uniforms[`f${e.id}_${s1}`];
        if (!!a && !(a instanceof ic)) switch(i = i || IZ(e, s1, o), a.constructor){
            case ur:
                if (typeof o == "string") {
                    let l = t.getColor(o);
                    l && (a.value = l);
                    break;
                } else {
                    let l = o;
                    a.value instanceof sc ? a.value = new cr(l.r, l.g, l.b, l.a) : a.setRGBA(l);
                    break;
                }
            case zn:
                if (typeof o == "string") {
                    let l = t.getColor(o);
                    l && (a.value = l);
                    break;
                } else {
                    let l = o;
                    a.value instanceof sc ? a.value = new cr(l.r, l.g, l.b, l.a) : a.value.setRGBA(l.r, l.g, l.b, l.a);
                    break;
                }
            case Zr:
                {
                    let l = o;
                    a.value.setX(l[0]), a.value.setY(l[1]);
                    break;
                }
            case Ji:
                {
                    let l = o;
                    a.value.setX(l[0]), a.value.setY(l[1]), a.value.setZ(l[2]);
                    break;
                }
            case Mn:
                ig(o, t, e);
                break;
            case oo:
                a.value = o.map((l)=>new Ze(...l));
                break;
            default:
                a.value = o;
                break;
        }
    }
    return i;
}
var ac = (n1, t, e)=>Math.max(0, Math.min(1, Number(t.getVariable(typeof n1 == "number" ? n1 * 100 : n1, e) ?? 100) / 100)) ?? 1, ct = (n1, t, e)=>typeof n1 == "number" ? n1 : t.getVariable(n1, e), oc = (n1, t)=>(n1 || (n1 = new E), n1.x = ct(n1.x, t) ?? 0, n1.y = ct(n1.y, t) ?? 0, n1.z = ct(n1.z, t) ?? 0, n1), Ja = (n1, t)=>(n1 || (n1 = new U), n1.x = ct(n1.x, t) ?? 0, n1.y = ct(n1.y, t) ?? 0, n1), Mf = (n1, t)=>{
    let e = n1.map((r)=>ct(r, t) ?? 0);
    return [
        e[0],
        e[1]
    ];
}, lc = class {
    constructor(t, e, r, i, s1){
        this.id = t;
        this.uuid = e;
        this.data = r;
        this.uniforms = {};
        for(let o in i)this.uniforms[`f${this.id}_${o}`] = i[o];
        for(let o in r)IT(o, this, r, s1);
    }
    get type() {
        return this.data.type;
    }
    static create(t, e, r, i) {
        if (r.type === "light") return Pn.createLightLayer(t, e, r, i);
        if (r.type === "texture" || r.type === "video") {
            let s1 = r.type === "texture" ? i.uiBuffer(r.texture.image) ?? i.image(r.texture.image) : i.video(r.texture.video), o = new fu(s1, r.texture.wrapping, r.texture.minFilter ?? 1008, r.texture.magFilter ?? 1006), a = new Ux(s1), l = new kx(Mf(r.texture.repeat, i), Mf(r.texture.offset, i), ct(r.texture.rotation ?? 0, i)), c = new Ve(r.crop ? 1 : 0), u1 = new Bt(r.projection ?? 0), h = new Bt([
                "x",
                "y",
                "z"
            ].indexOf(r.axis) ?? 0), d = new Bt(r.side ?? 0), f = new Zr(r.size ? new U(...Mf(r.size, i)) : new U(100, 100)), m = new Ve(r.blending ?? 0), p = new Ve(ac(r.alpha, i)), g = new Bt(r.mode ?? 0), y = new Jr(r.isMask ?? !1), x = new nc(o, a, c, u1, h, d, f, m, l, p, g, y), v = new er(x.calpha, "f");
            return new Vr(t, e, r, {
                texture: o,
                textureSize: a,
                crop: c,
                projection: u1,
                axis: h,
                side: d,
                size: f,
                blending: m,
                mat: l,
                alpha: p,
                mode: g,
                isMask: y
            }, x, g, v, y, i);
        } else if (r.type === "matcap") {
            let s1 = i.image(r.texture.image), o = new fu(s1, r.texture.wrapping, r.texture.minFilter ?? 1008, r.texture.magFilter ?? 1006), a = new Ve(ac(r.alpha, i)), l = new Bt(r.mode ?? 0), c = new Jr(r.isMask ?? !1), u1 = new Ve((ct(r.texture.rotation ?? 0, i) ?? 0) * Se.DEG2RAD), h = new yf(o, a, l, c, u1), d = new er(h.calpha, "f");
            return new Vr(t, e, r, {
                texture: o,
                alpha: a,
                mode: l,
                isMask: c,
                rotation: u1
            }, h, l, d, c, i);
        } else if (r.type === "displace") {
            if (r.displacementType === "noise") {
                let s1 = new Ji(new E(...r.offset.map((y)=>ct(y, i) ?? 0))), o = new Ve(ct(r.scale, i) ?? 10), a = new Ve(ct(r.intensity, i) ?? 8), l = new Ve(ct(r.movement, i) ?? 1), c = new Bt(r.noiseType ?? 0), u1 = new Bt(r.voronoiStyle ?? 0), h = new Ve(ct(r.smoothness, i) ?? .5), d = new Ve(ct(r.seed, i) ?? 0), f = new Ve(ct(r.highCut, i) ?? 1), m = new Ve(ct(r.lowCut, i) ?? 0), p = new Bt(ct(r.quality, i) ?? 1), g = new Ef(a, l, s1, u1, h, d, f, m, p, o, c);
                return new ng(t, e, r, {
                    offset: s1,
                    scale: o,
                    intensity: a,
                    movement: l,
                    noiseType: c,
                    voronoiStyle: u1,
                    smoothness: h,
                    seed: d,
                    highCut: f,
                    lowCut: m,
                    quality: p
                }, g, i);
            } else throw new Error;
        } else return RZ(t, e, r, i);
    }
    updateByOp(t, e, r) {
        let i = t, s1 = !1;
        if (i.path[0] === void 0) {
            for (let o of Object.keys(i.props))try {
                let a = this.data[o], l = e[o];
                if (Array.isArray(a) && Array.isArray(l)) {
                    for (let [c, u1] of l.entries()){
                        let h = a[c];
                        if (typeof u1 == "string" || typeof u1 == "number" && typeof h == "string") {
                            s1 = !0;
                            break;
                        }
                    }
                    if (s1) break;
                } else if (typeof l == "string" && typeof a == "number" || typeof l == "number" && typeof a == "string" || typeof l == "string" && typeof a == "string" && l !== a) {
                    s1 = !0;
                    break;
                }
            } catch (a) {
                console.error(a);
            }
            if (i.type === 0) return "type" in i.props || "category" in i.props || "visible" in i.props || "noiseType" in i.props ? (r.scene.markNeedsUpdateRendererDirty(), !0) : zL(i.props, r.shared, this, e) || s1;
        } else if (i.path[0] === "texture") return "texture" in e || "video" in e ? ig(i.props, r.shared, this) || s1 : !0;
        return s1;
    }
    dispose() {
        if (DZ(this)) {
            let t = this.uniforms[`f${this.id}_texture`];
            if (!t) return !1;
            let e = t;
            e.image instanceof as || e.image.deref();
        }
    }
    hasValueByKey(t) {
        return this.uniforms[t] !== void 0;
    }
    hasValue(t) {
        return this.hasValueByKey(`f${this.id}_${t}`);
    }
    setValue(t, e) {
        let r = `f${this.id}_${t}`;
        this.hasValueByKey(r) && e !== void 0 && (this.uniforms[r].value = e);
    }
    getNode(t) {
        let e = `f${this.id}_${t}`;
        if (this.hasValueByKey(e)) return this.uniforms[e];
    }
    getValue(t) {
        let e = `f${this.id}_${t}`;
        if (this.hasValueByKey(e)) return this.uniforms[e].value;
    }
    getName(t) {
        let r = /f\d+_(.*)/.exec(t);
        if (r && r.length > 1) return r[1];
        console.log(`Layer.getName: error ${t}`);
    }
    getNames() {
        let t = [];
        for(let e in this.uniforms){
            let r = this.getName(e);
            r && t.push(r);
        }
        return t;
    }
}, Vr = class extends lc {
    constructor(e, r, i, s1, o, a, l, c, u1){
        super(e, r, i, s1, u1);
        this.params = s1;
        this.color = o;
        this.mode = a;
        this.alpha = l;
        this.isMask = c;
    }
}, ng = class extends lc {
    constructor(e, r, i, s1, o, a){
        super(e, r, i, s1, a);
        this.position = o;
    }
}, Pn = class extends lc {
    constructor(e, r, i, s1, o, a){
        super(e, r, i, o, a);
        this.node = s1;
    }
    static createLightLayer(e, r, i, s1) {
        let o, a = new Ve(ac(i.alpha, s1)), l = new Bt(i.mode), c = new Ve(i.bumpMapIntensity), u1 = new Ve(ac(i.alphaOverride, s1)), h;
        if (!i.visible) o = new Qa, h = {};
        else if (i.category === "lambert") {
            o = new Jm;
            let d = new ur(s1.color(i.emissive) ?? 0), f = new Jr(i.occlusion ?? !0);
            h = {
                emissive: d,
                occlusion: f
            }, o.emissive = d, o.occlusion = f;
        } else if (i.category === "toon") {
            o = new tg;
            let d = new Ve(i.shininess ?? 30), f = new ur(s1.color(i.specular) ?? 1118481);
            h = {
                shininess: d,
                specular: f
            }, o.shininess = d, o.specular = f;
        } else if (i.category === "physical") {
            o = new eg;
            let d = new Ve(i.roughness ?? .3), f = new Ve(i.metalness ?? 0), m = new Ve(i.reflectivity ?? .5), p = new Jr(i.occlusion ?? !0);
            h = {
                roughness: d,
                metalness: f,
                reflectivity: m,
                occlusion: p
            }, o.roughness = d, o.metalness = f, o.reflectivity = m, o.occlusion = p;
        } else {
            o = new $m;
            let d = new Ve(i.shininess ?? 30), f = new ur(i.specular !== void 0 ? s1.color(i.specular) ?? 1118481 : 1118481), m = new Jr(i.occlusion ?? !0);
            h = {
                shininess: d,
                specular: f,
                occlusion: m
            }, o.shininess = d, o.specular = f, o.occlusion = m;
        }
        return o.alpha = new Ve(1), o.shadingAlpha = a, o.shadingBlend = l, o.bumpMapIntensity = c, o.alphaOverride = u1, h.alpha = o.shadingAlpha, h.mode = o.shadingBlend, h.bumpMapIntensity = o.bumpMapIntensity, h.alphaOverride = o.alphaOverride, new Pn(e, r, i, o, h, s1);
    }
    get category() {
        return this.node.category;
    }
};
function DZ(n1) {
    let t = n1 instanceof lc ? n1.type : n1;
    return t === "texture" || t === "video" || t === "displace_map" || t === "matcap";
}
function Is(n1) {
    return {
        alpha: new Ve(n1.alpha ?? 1),
        mode: new Bt(n1.mode ?? 0),
        isMask: new Jr(n1.isMask ?? !1)
    };
}
function OZ(n1, t, e, r, i) {
    switch(n1.type){
        case "color":
            {
                let s1 = new ur(r.color ?? ai), o = Is(r), a = new pu(s1, o.alpha), l = new er(a.calpha, "f");
                return new Vr(t, e, n1, {
                    color: s1,
                    ...o
                }, a, o.mode, l, o.isMask, i);
            }
        case "fresnel":
            {
                let s1 = new ur(r.color ?? 16777215), o = new Ve(ct(r.bias, i) ?? .1), a = new Ve(ct(r.scale, i) ?? 1), l = new Ve(ct(r.intensity, i) ?? 2), c = new Ve(ct(r.factor, i) ?? 1), u1 = Is(r), h = new Zm(s1, o, a, l, c, u1.alpha, u1.mode, u1.isMask), d = new er(h.calpha, "f");
                return new Vr(t, e, n1, {
                    color: s1,
                    bias: o,
                    scale: a,
                    intensity: l,
                    factor: c,
                    ...u1
                }, h, u1.mode, d, u1.isMask, i);
            }
        case "rainbow":
            {
                let s1 = new Ve(ct(r.filmThickness, i) ?? 30), o = new Ve(ct(r.movement, i) ?? 0), a = new Ji(oc(r.wavelengths, i)), l = new Ve(ct(r.noiseStrength, i) ?? 0), c = new Ve(ct(r.noiseScale, i) ?? 1), u1 = new Ji(oc(r.offset, i)), h = Is(r), d = new Sf(s1, o, a, l, c, u1, h.alpha, h.isMask), f = new er(d.calpha, "f");
                return new Vr(t, e, n1, {
                    filmThickness: s1,
                    movement: o,
                    wavelengths: a,
                    noiseStrength: l,
                    noiseScale: c,
                    offset: u1,
                    ...h
                }, d, h.mode, f, h.isMask, i);
            }
        case "transmission":
            {
                let s1 = new Ve(ct(r.thickness ?? 10, i)), o = new Ve(ct(r.ior ?? 1.5, i)), a = new Ve(ct(r.roughness ?? .5, i)), l = Je.transmissionSize, c = Je.transmissionRenderTarget, u1 = Je.transmissionRenderTargetDepth, h = window.innerWidth, d = window.innerHeight, f = h >= d ? new Zr(d / h, 1) : new Zr(1, h / d), m = Is(r), p = new Af(s1, o, a, l, c, u1, f, m.alpha), g = new er(p.calpha, "f");
                return new Vr(t, e, n1, {
                    thickness: s1,
                    ior: o,
                    roughness: a,
                    aspectRatio: f,
                    ...m
                }, p, m.mode, g, m.isMask, i);
            }
        case "toon":
            {
                let s1 = new Bt(r.positioning ?? 0), o;
                r.colors ? o = new oo(r.colors.length, r.colors) : (o = new oo(10, new Ze(0, 0, 0, 1)), o.value[1] = new Ze(1, 1, 1, 1));
                let a;
                r.steps ? a = new so(r.steps.length, r.steps) : (a = new so(10, 1), a.value[0] = 0);
                let l = new Ji(oc(r.source ?? new E(0, 0, 0), i)), c = new Jr(r.isWorldSpace ?? !0), u1 = new Ve(ct(r.noiseStrength ?? 0, i)), h = new Ve(ct(r.noiseScale ?? 1, i)), d = new zn(r.shadowColor), f = new Ji(oc(r.offset ?? new E(0, 0, 0), i)), m = Is(r), p = new wf(s1, o, a, l, c, u1, h, d, f, m.alpha), g = new er(p.calpha, "f");
                return new Vr(t, e, n1, {
                    positioning: s1,
                    colors: o,
                    steps: a,
                    source: l,
                    isWorldSpace: c,
                    noiseStrength: u1,
                    noiseScale: h,
                    shadowColor: d,
                    offset: f,
                    ...m
                }, p, m.mode, g, m.isMask, i);
            }
        case "outline":
            {
                let s1 = new ur(r.outlineColor ?? 16777215), o = new ur(r.contourColor ?? 16777215), a = new Ve(ct(r.outlineWidth ?? .1, i)), l = new Ve(ct(r.contourWidth ?? .1, i)), c = new Ve(ct(r.outlineThreshold ?? .1, i)), u1 = new Ve(ct(r.contourThreshold ?? .1, i)), h = new Ve(ct(r.outlineSmoothing ?? .1, i)), d = new Ve(ct(r.contourFrequency ?? .1, i)), f = new Ji(oc(r.contourDirection ?? new E(0, 1, 0), i)), m = new Jr(r.positionalLines ?? !1), p = new Jr(r.compensation ?? !0), g = Je.normalRenderTarget, y = Je.normalRenderTargetDepth, x = Je.pixelRatioNode, v = Je.resolution, b = Is(r), w = new xf(s1, o, a, l, c, u1, h, d, f, m, p, v, g, y, x, b.alpha), A = new er(w.calpha, "f");
                return new Vr(t, e, n1, {
                    outlineColor: s1,
                    contourColor: o,
                    outlineWidth: a,
                    contourWidth: l,
                    outlineThreshold: c,
                    contourThreshold: u1,
                    outlineSmoothing: h,
                    contourFrequency: d,
                    contourDirection: f,
                    positionalLines: m,
                    compensation: p,
                    ...b
                }, w, b.mode, A, b.isMask, i);
            }
        case "depth":
            {
                let s1 = new Bt(r.gradientType ?? 0), o = new Jr(r.smooth ?? !1), a = new Ve(ct(r.near, i) ?? 50), l = new Ve(ct(r.far, i) ?? 200), c = new Ve(r.isVector ?? 1), u1 = new Ve(r.isWorldSpace ?? 0), h = new Ji(oc(r.origin, i)), d = new Ji(oc(r.direction, i)), f;
                r.colors ? f = new oo(r.colors.length, r.colors) : (f = new oo(2, new Ze(0, 0, 0, 1)), f.value[1] = new Ze(1, 1, 1, 1));
                let m;
                r.steps ? m = new so(r.steps.length, r.steps) : (m = new so(2, 1), m.value[0] = 0);
                let p = Is(r), g = new mf(s1, o, a, l, c, u1, h, d, f, m, p.alpha, p.isMask), y = new er(g.calpha, "f");
                return new Vr(t, e, n1, {
                    gradientType: s1,
                    smooth: o,
                    near: a,
                    far: l,
                    isVector: c,
                    isWorldSpace: u1,
                    origin: h,
                    direction: d,
                    colors: f,
                    steps: m,
                    ...p
                }, g, p.mode, y, p.isMask, i);
            }
        case "noise":
            {
                let s1 = new Ve(ct(r.scale, i) ?? 1), o = new Ji(oc(r.size ?? new E(100, 100, 100), i)), a = new Ve(ct(r.move, i) ?? 1), l = new Zr(Ja(r.fA ?? new U(1.7, 9.2), i)), c = new Zr(Ja(r.fB ?? new U(8.3, 2.8), i)), u1 = new Zr(Ja(r.distortion ?? new U(1, 1), i)), h = new zn(r.colorA), d = new zn(r.colorB), f = new zn(r.colorC), m = new zn(r.colorD), p = new Bt(r.noiseType ?? 0), g = new Bt(r.voronoiStyle ?? 0), y = new Ve(ct(r.highCut, i) ?? 1), x = new Ve(ct(r.lowCut, i) ?? 0), v = new Ve(ct(r.smoothness, i) ?? .5), b = new Ve(ct(r.seed, i) ?? .5), w = new Bt(r.quality ?? 1), A = Is(r), T = new vf(s1, o, a, l, c, u1, h, d, f, m, A.alpha, p, A.isMask, g, y, x, v, b, w), S = new er(T.calpha, "f");
                return new Vr(t, e, n1, {
                    scale: s1,
                    size: o,
                    move: a,
                    fA: l,
                    fB: c,
                    distortion: u1,
                    colorA: h,
                    colorB: d,
                    colorC: f,
                    colorD: m,
                    noiseType: p,
                    ...A,
                    voronoiStyle: g,
                    highCut: y,
                    lowCut: x,
                    smoothness: v,
                    seed: b,
                    quality: w
                }, T, A.mode, S, A.isMask, i);
            }
        case "normal":
            {
                let s1 = new Ji(r.cnormal ?? new E(1, 1, 1)), o = Is(r), a = new df(s1, o.alpha), l = new er(a.calpha, "f");
                return new Vr(t, e, n1, {
                    cnormal: s1,
                    ...o
                }, a, o.mode, l, o.isMask, i);
            }
        case "gradient":
            {
                let s1 = new Bt(r.gradientType ?? 0), o = new Jr(r.smooth ?? !1), a;
                r.colors ? a = new oo(r.colors.length, r.colors) : (a = new oo(10, new Ze(0, 0, 0, 1)), a.value[1] = new Ze(1, 1, 1, 1));
                let l;
                r.steps ? l = new so(r.steps.length, r.steps) : (l = new so(10, 1), l.value[0] = 0);
                let c = new Zr(Ja(r.offset ?? new U(0, 0), i)), u1 = new Zr(Ja(r.morph ?? new U(0, 0), i)), h = new Ve(ct(r.angle ?? 0, i)), d = Is(r), f = new gf(s1, o, a, l, c, u1, h, d.alpha, d.isMask), m = new er(f.calpha, "f");
                return new Vr(t, e, n1, {
                    gradientType: s1,
                    smooth: o,
                    colors: a,
                    steps: l,
                    offset: c,
                    morph: u1,
                    angle: h,
                    ...d
                }, f, d.mode, m, d.isMask, i);
            }
        case "pattern":
            {
                let s1 = new Bt(r.style ?? 0), o = new Bt(r.projection ?? 0), a = new Bt([
                    "x",
                    "y",
                    "z"
                ].indexOf(r.axis) ?? 0), l = new Ve(ct(r.blending ?? 0, i)), c = new Zr(Ja(r.offset, i)), u1 = new zn(r.colorA), h = new zn(r.colorB), d = new Zr(Ja(r.frequency ?? new U(10, 10), i)), f = new Ve(ct(r.size ?? .5, i)), m = new Ve(ct(r.variation ?? 0, i)), p = new Ve(ct(r.smoothness ?? .5, i)), g = new Ve(ct(r.zigzag ?? 0, i)), y = new Ve(ct(r.rotation ?? 0, i)), x = new Zr(Ja(r.vertical ?? new U(0, 1), i)), v = new Zr(Ja(r.horizontal ?? new U(0, 1), i)), b = new Bt(r.sides ?? 6), w = Is(r), A = new bf(s1, o, a, l, c, u1, h, d, f, m, p, g, y, x, v, b, w.alpha, w.isMask), T = new er(A.calpha, "f");
                return new Vr(t, e, n1, {
                    style: s1,
                    projection: o,
                    axis: a,
                    blending: l,
                    offset: c,
                    colorA: u1,
                    colorB: h,
                    frequency: d,
                    size: f,
                    variation: m,
                    smoothness: p,
                    zigzag: g,
                    rotation: y,
                    vertical: x,
                    horizontal: v,
                    sides: b,
                    ...w
                }, A, w.mode, T, w.isMask, i);
            }
        default:
            {
                let s1 = new ur(1, 0, 0, 1), o = Is(r), a = new pu(s1, o.alpha), l = new er(a.calpha, "f");
                return new Vr(t, e, n1, {
                    color: s1,
                    ...o
                }, a, o.mode, l, o.isMask, i);
            }
    }
}
function RZ(n1, t, e, r) {
    let i = kL(e, r);
    return OZ(e, n1, t, i, r);
}
function IT(n1, t, e, r) {
    if (e.type === "displace" && (n1 === "intensity" || n1 === "visible")) {
        let i = t.uniforms[`f${t.id}_intensity`];
        return i ? (i.value = (ct(e.intensity, r) ?? 1) * (e.visible ? 1 : 0), i) : void 0;
    }
    if (e.type !== "displace" && (n1 === "alpha" || n1 === "visible")) {
        let i = t.uniforms[`f${t.id}_alpha`];
        if (!i) return;
        if (i.value = ac(e.alpha, r) * (e.visible ? 1 : 0), e.type === "outline" && n1 === "visible") {
            let s1 = t.uniforms[`f${t.id}_compensation`];
            s1 && (s1.value = e.compensation && e.visible);
        }
        return i;
    }
}
function jn(n1, t, e, r, i, s1, o = []) {
    let a = e;
    for (let l of o)l in a && (a = a[l]);
    for (let l of n1)l in a && i.getVariable(a[l], [
        "material",
        s1,
        "layer",
        r,
        ...o,
        String(l)
    ]);
    for (let l of t)l in a && a[l].forEach((c, u1)=>{
        i.getVariable(c, [
            "material",
            s1,
            "layer",
            r,
            ...o,
            String(l),
            u1 === 0 ? "x" : u1 === 1 ? "y" : "z"
        ]);
    });
}
function gu(n1, t) {
    let e = 0, r = n1.layers.find((i)=>i.data.type === "light");
    if (r) {
        let i = r.data, s1 = Number(t.getVariable(i.alphaOverride));
        if ((typeof i.alphaOverride == "string" ? s1 / 100 : i.alphaOverride) < 1) return !0;
    }
    for (let i of n1.layers){
        if (i.data.type !== "displace" && i.data.isMask) return !0;
        if (i.data.type !== "displace" && "alpha" in i.data && i.data.type !== "light" && i.data.type !== "fresnel" && i.data.type !== "texture" && i.data.type !== "matcap" && i.data.type !== "rainbow" && i.data.type !== "outline" && i.data.type !== "pattern") {
            let s1 = i.data.visible ? i.data.alpha : 0;
            if (typeof s1 == "string" && (s1 = Math.max(0, Math.min(1, Number(t.getVariable(s1) ?? 100) / 100))), s1 === 1 && i.data.type === "depth" || i.data.type === "gradient") {
                for (let o of i.data.colors)if (o[3] < 1) {
                    s1 = o[3];
                    break;
                }
            } else if (s1 === 1 && i.data.type === "noise") {
                let o = t.color(i.data.colorA).a, a = t.color(i.data.colorB).a, l = t.color(i.data.colorC).a, c = t.color(i.data.colorD).a, u1 = Math.min(o, Math.min(a, Math.min(l, c)));
                u1 < 1 && (s1 = u1);
            }
            e += (1 - e) * s1;
        }
    }
    return e < 1;
}
var fn = class extends $e {
    constructor(){
        super(void 0);
        this.flatShading = !1;
        this.needsJitter = !0;
        this.shadersPatchedForShapeBlend = !1;
        this.nodeContextUuid = 0;
        this.fog = !0, this.dithering = !0, this.vertexColors = !0, this.transparent = !0;
    }
    customProgramCacheKey() {
        return "";
    }
}, Kx = class extends fn {
    constructor(e, r, i, s1){
        super();
        this.flatShading = e;
        this.side = r;
        this.wireframe = i;
        this.root = s1;
    }
    updateAfterBuild() {
        let e = this.root;
        this.lights = e.lights, this.vertexShader = e.vertexShader, this.fragmentShader = e.fragmentShader, Object.assign(this.defines, e.defines), Object.assign(this.uniforms, e.uniforms), this.extensions = e.extensions, this.transparent = e.transparent, this.cacheKey = e.customProgramCacheKey() + "flat" + this.flatShading + this.side;
    }
    onBeforeCompile(e, r) {
        this.root.onBeforeCompile(e);
    }
    get data() {
        return this.root.data;
    }
    get category() {
        return this.root.category;
    }
    get hasAO() {
        return this.root.hasAO;
    }
    getFlavor(e, r, i, s1) {
        return this.root.getFlavor(e, r, i, s1);
    }
    get layers() {
        return this.root.layers;
    }
    get fragment() {
        return this.root.fragment;
    }
    getLayersOfType(e) {
        return this.root.getLayersOfType(e);
    }
    getLayerByUuid(e) {
        return this.root.getLayerByUuid(e);
    }
    updateByOp(e, r, i) {
        this.root.updateByOp(e, r, i);
    }
    nodeMaterialDispose() {
        this.root.nodeMaterialDispose();
    }
}, $a = class extends fn {
    constructor(e, r, i = !0){
        super();
        this.data = e;
        this.allowVariableSaves = i;
        this.layerIdGen = 0;
        this.flavors = [];
        this.masks = {};
        this.type = "NodeMaterial";
        this.updaters = [], this.needsJitter = r.shared.needsJitter, pr.startContext(this), this.reset0(e, r), pr.endContext(this);
    }
    get nodeMaterial() {
        return this;
    }
    getFlavor(e, r, i, s1) {
        let o = i ? 6 : (e ? 3 : 0) + r;
        if (o += ((s1?.resolutionLevel ?? 0) - (s1?.useChildrenColors ? 4 : 0)) * 7, o === 0) return this;
        this.flavors === void 0 && (this.flavors = []), o -= 1;
        let a = this.flavors[o];
        return a === void 0 && (a = new Kx(e, r, i, this), a.needsJitter = this.needsJitter, this.flavors[o] = a, a.flatShading = e, a.side = r, a.updateAfterBuild(), s1 && (a.defines.SHAPEBLEND = s1.resolutionLevel, a.defines.SHAPEBLEND_C = s1.useChildrenColors ? 1 : 0)), a;
    }
    get fragment() {
        return this.lightLayer.node;
    }
    get category() {
        return this.lightLayer.category;
    }
    get hasAO() {
        return this.lightLayer.getNode("occlusion")?.value ?? !1;
    }
    reset(e, r, i = !1) {
        pr.startContext(this), (this.data !== e || i) && this.reset0(e, r), pr.endContext(this);
    }
    reset0(e, r) {
        this.data = e;
        let i = e.layers ?? Kr.defaultTwoLayerData("phong").layers;
        try {
            this.layers = i.map((s1)=>lc.create(this.layerIdGen++, s1.id, s1.data, r.shared));
        } catch  {
            this.layers = [];
        }
        this.layers.reverse(), this.name = e.name ?? "Untitled Material", this.onUpdate(r.shared), this.transparent = gu(e, r.shared), this.saveVariableLocations(r);
    }
    onVariableUpdate(e, r, i) {
        if (e[0] === "alphaOverride") this.transparent = gu(this.data, i.shared), this.lightLayer.setValue("alphaOverride", Math.max(0, Math.min(Number(r) / 100, 1)));
        else if (e[0] === "layer") {
            let s1 = e[1], o = e[2];
            if (s1 && o) {
                let a = this.layers.find((l)=>l.uuid === s1);
                if (a?.hasValue(o)) {
                    if (o === "alpha") this.transparent = gu(this.data, i.shared), a.setValue(o, Math.max(0, Math.min(Number(r) / 100, 1)));
                    else {
                        let l = a.getValue(o), c = e[3], u1 = e[4];
                        if (l instanceof Zt) {
                            let h = l[c], d;
                            typeof h == "number" ? d = Number(r) : h.isVector2 && (d = h.toArray(), u1 === "x" ? d[0] = Number(r) : u1 === "y" && (d[1] = Number(r))), ig({
                                [c]: d
                            }, i.shared, a);
                            return;
                        }
                        (c === "x" || c === "y" || c === "z") && l.isVector3 || (c === "x" || c === "y") && l.isVector2 ? l[c] = Number(r) : a.setValue(o, r);
                    }
                }
            }
        }
    }
    saveVariableLocations(e) {
        if (!this.allowVariableSaves) return;
        let r = this.data.layers.find((i)=>i.data.type === "light");
        r && e.shared.getVariable(r.data.alphaOverride, [
            "material",
            this.uuid,
            "alphaOverride"
        ]), this.data.layers.forEach((i)=>{
            "alpha" in i.data && typeof i.data.alpha == "string" && e.shared.getVariable(i.data.alpha, [
                "material",
                this.uuid,
                "layer",
                i.id,
                "alpha"
            ]), i.data.type === "displace" ? i.data.displacementType === "noise" ? jn([
                "intensity",
                "scale",
                "movement",
                "smoothness",
                "seed",
                "highCut",
                "lowCut"
            ], [
                "offset"
            ], i.data, i.id, e.shared, this.uuid) : jn([
                "intensity"
            ], [], i.data, i.id, e.shared, this.uuid) : i.data.type === "depth" ? jn([
                "near",
                "far"
            ], [
                "origin",
                "direction"
            ], i.data, i.id, e.shared, this.uuid) : i.data.type === "fresnel" ? jn([
                "bias",
                "scale",
                "intensity",
                "factor"
            ], [], i.data, i.id, e.shared, this.uuid) : i.data.type === "rainbow" ? jn([
                "filmThickness",
                "movement",
                "noiseStrength",
                "noiseScale"
            ], [
                "offset",
                "wavelengths"
            ], i.data, i.id, e.shared, this.uuid) : i.data.type === "noise" ? jn([
                "scale",
                "move",
                "seed",
                "highCut",
                "lowCut",
                "smoothness"
            ], [
                "size",
                "distortion",
                "fA",
                "fB"
            ], i.data, i.id, e.shared, this.uuid) : i.data.type === "pattern" ? jn([
                "blending",
                "size",
                "variation",
                "smoothness",
                "zigzag",
                "rotation"
            ], [
                "offset",
                "frequency",
                "vertical",
                "horizontal"
            ], i.data, i.id, e.shared, this.uuid) : i.data.type === "outline" ? jn([
                "outlineWidth",
                "contourWidth",
                "outlineThreshold",
                "contourThreshold",
                "outlineSmoothing",
                "contourFrequency"
            ], [
                "contourDirection"
            ], i.data, i.id, e.shared, this.uuid) : i.data.type === "toon" ? jn([
                "noiseStrength",
                "noiseScale"
            ], [
                "offset",
                "source"
            ], i.data, i.id, e.shared, this.uuid) : i.data.type === "transmission" ? jn([
                "roughness",
                "thickness",
                "ior"
            ], [], i.data, i.id, e.shared, this.uuid) : i.data.type === "texture" || i.data.type === "video" ? (jn([], [
                "size"
            ], i.data, i.id, e.shared, this.uuid), jn([
                "rotation"
            ], [
                "repeat",
                "offset"
            ], i.data, i.id, e.shared, this.uuid, [
                "texture"
            ])) : i.data.type === "gradient" ? jn([
                "angle"
            ], [
                "offset",
                "morph"
            ], i.data, i.id, e.shared, this.uuid) : i.data.type === "matcap" && jn([
                "rotation"
            ], [], i.data, i.id, e.shared, this.uuid, [
                "texture"
            ]);
        });
    }
    getLayersOfType(e) {
        return this.layers.filter((r)=>r.type === e);
    }
    getLayerByUuid(e) {
        return this.layers.find((r)=>r.uuid === e);
    }
    onUpdate(e) {
        this.lightLayer = this.layers.find((r)=>r instanceof Pn), this.lightLayer === void 0 && (this.lightLayer = new Pn(0, "", {
            ...Cr.defaultData("light", "phong"),
            visible: !1
        }, new Qa, {}, e)), this.dispose();
        for (let r of this.flavors)r && r.dispose();
        this.applyTextureMaps(), this.applyMasks(), this.blendColors(), this.blendAfterColors(), this.blendPositions(), this.build(), this.nodeContextUuid = 0;
    }
    applyTextureMaps() {
        let e = this.layers.find((o)=>o instanceof Pn);
        if (!e) return;
        let r = e.data, i = r.bumpMap, s1 = r.roughnessMap;
        e.node.bumpMap = void 0, e.node.roughnessMap = void 0;
        for(let o = 0; o < this.layers.length; ++o){
            let a = this.layers[o];
            a instanceof Vr && a.color instanceof nc && (a.uuid === i && (e.node.bumpMap = a.color), a.uuid === s1 && (e.node.roughnessMap = a.color));
        }
    }
    updateByOp(e, r, i) {
        if (pr.startContext(this), r !== void 0 ? this.data = r : r = this.data, this.transparent = gu(r, i.shared), e.path[0] === "layers") {
            let s1 = i.shared, o = e.path[1];
            if (o === void 0) i.scene.markNeedsUpdateRendererDirty(), this.reset0(r, i);
            else {
                e.type === 0 && e.props.occlusion !== void 0 && i.scene.markNeedsUpdateRendererDirty();
                let a = this.layers.find((l)=>l.uuid === o);
                if (a) {
                    let l = r.layers.data(o), c;
                    e.type === 0 && ("alpha" in e.props || "alphaOverride" in e.props) && ("alpha" in e.props ? c = {
                        ...e.props,
                        alpha: ac(e.props.alpha, s1, [
                            "material",
                            this.uuid,
                            "layer",
                            o,
                            "alpha"
                        ])
                    } : c = {
                        ...e.props,
                        alphaOverride: ac(e.props.alphaOverride, s1, [
                            "material",
                            this.uuid,
                            "alphaOverride"
                        ])
                    }), a.updateByOp({
                        ...e,
                        ...c ? {
                            props: c
                        } : {},
                        path: e.path.slice(2)
                    }, l, i) && this.reset0(r, i);
                }
            }
        } else this.reset0(r, i);
        pr.endContext(this);
    }
    applyMasks() {
        for(let e = 0; e < this.layers.length; ++e){
            let r = this.layers[e];
            r instanceof Vr ? r.color.mask = void 0 : r instanceof Pn && (r.node.mask = void 0);
        }
        for(let e = 0; e < this.layers.length; ++e){
            let r = this.layers[e];
            if (r instanceof Vr && r.isMask.value && r.data.visible && e > 0) {
                let i = e - 1, s1 = this.layers[i];
                s1 instanceof Pn ? s1.node.mask = new qi(r.color, r.alpha, qi.MUL) : s1 instanceof Vr && (s1.isMask.value || (s1.color.mask = new qi(r.color, r.alpha, qi.MUL)));
            }
        }
    }
    blendColors() {
        let e = this.layers.findIndex((i)=>i instanceof Vr), r = this.layers.findIndex((i)=>i instanceof Pn);
        if (e !== -1 && e < r) {
            let i = this.layers[e].color;
            for(let s1 = e + 1; s1 < r; ++s1){
                let o = this.layers[s1];
                if (o instanceof Vr) {
                    if (o.isMask.value) continue;
                    i = new hf(i, o.color, o.alpha, o.mode);
                }
            }
            this.fragment.color = i;
        } else this.fragment.color = void 0;
    }
    blendAfterColors() {
        let e = new er("outgoingLight", "f"), r = this.layers.findIndex((i)=>i instanceof Pn);
        if (this.layers.length > r + 1) {
            for(let i = r + 1; i < this.layers.length; ++i){
                let s1 = this.layers[i];
                if (s1 instanceof Vr) {
                    if (s1.isMask.value) continue;
                    e = new hf(e, s1.color, s1.alpha, s1.mode);
                }
            }
            this.fragment.afterColor = e;
        } else this.fragment.afterColor = void 0;
    }
    blendPositions() {
        let e = this.layers.filter((r)=>r instanceof ng);
        if (e.length > 0) {
            let r = e[0].position;
            for(let i = 1; i < e.length; ++i)e[i] && (r = new qi(r, e[i].position, qi.ADD), r = new qi(r, new Ve(.5).setReadonly(!0), qi.MUL));
            this.fragment.position = r;
        } else this.fragment.position = void 0;
    }
    getDefines() {
        return this.defines;
    }
    getUniforms() {
        return this.uniforms;
    }
    getVertexShader() {
        return this.vertexShader;
    }
    getFragmentShader() {
        return this.fragmentShader;
    }
    onBeforeCompile(e) {
        this.shapeBlendhack && this.shapeBlendhack(this), e.uniforms = this.uniforms, e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader, e.extensionDerivatives = this.extensions.derivatives === !0, e.extensionFragDepth = this.extensions.fragDepth === !0, e.extensionDrawBuffers = this.extensions.drawBuffers === !0, e.extensionShaderTextureLOD = this.extensions.shaderTextureLOD === !0;
    }
    clampUniformsForPreview(e, r) {
        let i = (s1, o, a)=>Math.min(Math.max(s1, o), a);
        for (let s1 of this.layers)if (s1.type === "displace") {
            let o = i(s1.uniforms[`f${s1.id}_intensity`].value, e, r);
            s1.uniforms[`f${s1.id}_intensity`].value = o;
        }
    }
    updateFrame(e) {
        for(let r = 0; r < this.updaters.length; ++r)e.updateNode(this.updaters[r]);
    }
    build() {
        let e = new cf;
        e.needsJitter = this.needsJitter, this.lights = this.lightLayer.data.visible, e.build(this.fragment, this.fragment), this.vertexShader = e.getCode("vertex"), this.fragmentShader = e.getCode("fragment"), this.defines = e.defines, this.uniforms = e.uniforms, this.extensions = e.extensions, this.updaters = e.updaters;
        for (let r of this.flavors)r && r.updateAfterBuild();
        return this.shadersPatchedForShapeBlend = !1, this;
    }
    nodeMaterialDispose() {
        this.layers.forEach((e)=>e.dispose()), super.dispose();
        for (let e of this.flavors)e && e.dispose();
    }
    assetsLoaded() {
        for (let e of this.layers)if (e instanceof Vr) {
            let r = e.params.texture;
            if (r instanceof fu && !r.image.loaded) return !1;
        }
        return !0;
    }
};
Object.defineProperties(fn.prototype, {
    properties: {
        get: function() {
            return this.fragment.properties;
        }
    }
});
var yu = class extends $a {
    constructor(t, e, r){
        super(t, e, !1), this.uuid = r, this.allowVariableSaves = !0, this.saveVariableLocations(e);
    }
};
var GL = new Map;
function jL(n1) {
    if (typeof n1 == "string") return n1;
    let t = GL.get(n1);
    return t || (t = {
        url: URL.createObjectURL(new Blob([
            n1
        ]))
    }, GL.set(n1, t)), t.url;
}
var WL, qL = new Promise((n1)=>{
    WL = n1;
}), HL = !1;
var Qx;

function XL() {
    if (HL) return;
    if (Qx) return Qx;
    async function n1() {
        await (parcelRequire("fQPhc")), WL(window !== void 0 ? window : $parcel$global), HL = !0;
    }
    return Qx = n1(), Qx;
}
var KL;
qL.then((n1)=>KL = n1);
function YL(n1, t) {
    n1.forEach((e)=>{
        "dragDropActions" in e.data ? (t.push(...e.data.dragDropActions.drag), t.push(...e.data.dragDropActions.drop)) : "inActions" in e.data ? (t.push(...e.data.inActions), t.push(...e.data.outActions)) : "gameActions" in e.data ? (t.push(...e.data.gameActions.idle), t.push(...e.data.gameActions.move), t.push(...e.data.gameActions.jump), t.push(...e.data.gameActions.run)) : "breakpoints" in e.data ? e.data.breakpoints.forEach((r)=>{
            t.push(...r.data.actions);
        }) : "actions" in e.data && (t.push(...e.data.actions), e.data.actions.forEach((r)=>{
            r.data.type === "Conditional" && r.data.ifActions && (t.push(...r.data.ifActions), t.push(...r.data.elseActions));
        }));
    });
}
function QL(n1) {
    let t = !1, e = [];
    return n1.scene.objects.traverse((r, i)=>{
        if (i.type === "Page" && i.uiScene !== void 0 && i.uiScene.objects.traverse((s1, o)=>{
            if (o.events === void 0 || Array.isArray(o.events) === !1) return !0;
            YL(o.events, e), t = t || e.some((a)=>a.data.type === "Audio");
        }), i.events === void 0 || Array.isArray(i.events) === !1) return !0;
        YL(i.events, e), t = t || e.some((s1)=>s1.data.type === "Audio");
    }), t;
}
var el = class {
    constructor({ src: t, volume: e, delay: r, loop: i }){
        this._volume = 1;
        this.delay = 0;
        this._loop = 1;
        this.loopsRemaining = 0;
        this._status = "stopped";
        this.onEnd = ()=>{
            this.loopsRemaining === 1 / 0 ? this.replay() : this.loopsRemaining > 1 ? (this.replay(), this.loopsRemaining--) : (this._status = "stopped", this.loopsRemaining = this._loop);
        };
        let s1;
        typeof t == "string" ? s1 = {
            src: t
        } : s1 = {
            src: jL(t),
            format: "wav"
        }, this.sound = new KL.Howl(s1), this.sound.on("end", this.onEnd), this.src = t, e !== void 0 && (this.volume = e), r !== void 0 && (this.delay = r), i !== void 0 && (this.loop = i);
    }
    get status() {
        return this._status;
    }
    get volume() {
        return this._volume;
    }
    set volume(t) {
        this._volume = t, this.sound.volume(t);
    }
    get loop() {
        return this._loop;
    }
    set loop(t) {
        this._loop = t, this.loopsRemaining = t;
    }
    replay() {
        this.clearDelay(), this.delayTimerId = window.setTimeout(()=>{
            this.sound.play(), this.clearDelay();
        }, this.delay);
    }
    fade(t, e = 1e3) {
        t ? (this.sound.volume(this._volume), this.clearFade(), this.fadeTimerId = window.setTimeout(()=>{
            this.sound.fade(this._volume, 0, e), this.clearFade();
        }, t)) : this.sound.fade(this._volume, 0, e);
    }
    on(t, e, r) {
        this.sound.on(t, e, r);
    }
    off(t, e, r) {
        this.sound.off(t, e, r);
    }
    play() {
        this._status === "playing" || this.sound.playing() || (this._status === "paused" ? (this.sound.seek() === 0 ? this.replay() : this.sound.play(), this._status = "playing") : this._status === "stopped" && (this.replay(), this._status = "playing"));
    }
    pause() {
        this._status === "playing" && (this.sound.pause(), this.clearFade(), this.clearDelay(), this._status = "paused");
    }
    stop() {
        this.sound.stop(), this.loopsRemaining = this._loop, this.clearFade(), this.clearDelay(), this._status = "stopped";
    }
    clearFade() {
        this.fadeTimerId && (clearTimeout(this.fadeTimerId), delete this.fadeTimerId);
    }
    clearDelay() {
        this.delayTimerId && (clearTimeout(this.delayTimerId), delete this.delayTimerId);
    }
    dispose(t = !1) {
        this.off(), this.stop(), this.clearFade(), this.clearDelay();
    }
};
var Zx = class {
    constructor(){
        this.type = "ShapePath";
        this.color = new Ge;
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(t, e) {
        return this.currentPath = new Gc, this.subPaths.push(this.currentPath), this.currentPath.moveTo(t, e), this;
    }
    lineTo(t, e) {
        return this.currentPath?.lineTo(t, e), this;
    }
    quadraticCurveTo(t, e, r, i) {
        return this.currentPath?.quadraticCurveTo(t, e, r, i), this;
    }
    bezierCurveTo(t, e, r, i, s1, o) {
        return this.currentPath?.bezierCurveTo(t, e, r, i, s1, o), this;
    }
    splineThru(t) {
        return this.currentPath?.splineThru(t), this;
    }
    toShapes() {
        let e = {
            ORIGIN: 0,
            DESTINATION: 1,
            BETWEEN: 2,
            LEFT: 3,
            RIGHT: 4,
            BEHIND: 5,
            BEYOND: 6
        }, r = {
            loc: e.ORIGIN,
            t: 0
        };
        function i(p, g, y, x) {
            let v = p.x, b = g.x, w = y.x, A = x.x, T = p.y, S = g.y, M = y.y, C = x.y, P = (A - w) * (T - M) - (C - M) * (v - w), _ = (b - v) * (T - M) - (S - T) * (v - w), I = (C - M) * (b - v) - (A - w) * (S - T), O = P / I, L = _ / I;
            if (I === 0 && P !== 0 || O <= 0 || O >= 1 || L < 0 || L > 1) return null;
            if (P === 0 && I === 0) {
                for(let j = 0; j < 2; j++)if (s1(j === 0 ? y : x, p, g), r.loc === e.ORIGIN) {
                    let V = j === 0 ? y : x;
                    return {
                        x: V.x,
                        y: V.y,
                        t: r.t
                    };
                } else if (r.loc === e.BETWEEN) {
                    let V = +(v + r.t * (b - v)).toPrecision(10), H = +(T + r.t * (S - T)).toPrecision(10);
                    return {
                        x: V,
                        y: H,
                        t: r.t
                    };
                }
                return null;
            } else {
                for(let H = 0; H < 2; H++)if (s1(H === 0 ? y : x, p, g), r.loc === e.ORIGIN) {
                    let q = H === 0 ? y : x;
                    return {
                        x: q.x,
                        y: q.y,
                        t: r.t
                    };
                }
                let j = +(v + O * (b - v)).toPrecision(10), V = +(T + O * (S - T)).toPrecision(10);
                return {
                    x: j,
                    y: V,
                    t: O
                };
            }
        }
        function s1(p, g, y) {
            let x = y.x - g.x, v = y.y - g.y, b = p.x - g.x, w = p.y - g.y, A = x * w - b * v;
            if (p.x === g.x && p.y === g.y) {
                r.loc = e.ORIGIN, r.t = 0;
                return;
            }
            if (p.x === y.x && p.y === y.y) {
                r.loc = e.DESTINATION, r.t = 1;
                return;
            }
            if (A < -Number.EPSILON) {
                r.loc = e.LEFT;
                return;
            }
            if (A > Number.EPSILON) {
                r.loc = e.RIGHT;
                return;
            }
            if (x * b < 0 || v * w < 0) {
                r.loc = e.BEHIND;
                return;
            }
            if (Math.sqrt(x * x + v * v) < Math.sqrt(b * b + w * w)) {
                r.loc = e.BEYOND;
                return;
            }
            let T;
            x !== 0 ? T = b / x : T = w / v, r.loc = e.BETWEEN, r.t = T;
        }
        function o(p, g) {
            let y = [], x = [];
            for(let v = 1; v < p.length; v++){
                let b = p[v - 1], w = p[v];
                for(let A = 1; A < g.length; A++){
                    let T = g[A - 1], S = g[A], M = i(b, w, T, S);
                    M !== null && y.find((C)=>C.t <= M.t + Number.EPSILON && C.t >= M.t - Number.EPSILON) === void 0 && (y.push(M), x.push(new U(M.x, M.y)));
                }
            }
            return x;
        }
        function a(p, g, y) {
            let x = new U;
            g.getCenter(x);
            let v = [];
            return y.forEach((b)=>{
                b.boundingBox.containsPoint(x) && o(p, b.points).forEach((A)=>{
                    v.push({
                        identifier: b.identifier,
                        isCW: b.isCW,
                        point: A
                    });
                });
            }), v.sort((b, w)=>b.point.x - w.point.x), v;
        }
        function l(p, g, y, x, v) {
            (v == null || v === "") && (v = "nonzero");
            let b = new U;
            p.boundingBox.getCenter(b);
            let w = [
                new U(y, b.y),
                new U(x, b.y)
            ], A = a(w, p.boundingBox, g);
            A.sort((_, I)=>_.point.x - I.point.x);
            let T = [], S = [];
            A.forEach((_)=>{
                _.identifier === p.identifier ? T.push(_) : S.push(_);
            });
            let M = T[0].point.x, C = [], P = 0;
            for(; P < S.length && S[P].point.x < M;)C.length > 0 && C[C.length - 1] === S[P].identifier ? C.pop() : C.push(S[P].identifier), P++;
            if (C.push(p.identifier), v === "evenodd") {
                let _ = C.length % 2 === 0, I = C[C.length - 2];
                return {
                    identifier: p.identifier,
                    isHole: _,
                    for: I
                };
            } else if (v === "nonzero") {
                let _ = !0, I = null, O = null;
                for(let L = 0; L < C.length; L++){
                    let j = C[L];
                    g[j] && (_ ? (O = g[j].isCW, _ = !1, I = j) : O !== g[j].isCW && (O = g[j].isCW, _ = !0));
                }
                return {
                    identifier: p.identifier,
                    isHole: _,
                    for: I
                };
            } else console.warn('fill-rule: "' + v + '" is currently not implemented.');
        }
        let c = 0, u1 = 999999999, h = -999999999, d = [];
        this.subPaths.forEach((p)=>{
            let g = p.getPoints(), y = -999999999, x = 999999999, v = -999999999, b = 999999999;
            for(let w = 0; w < g.length; w++){
                let A = g[w];
                A.y > y && (y = A.y), A.y < x && (x = A.y), A.x > v && (v = A.x), A.x < b && (b = A.x);
            }
            h <= v && (h = v + 1), u1 >= b && (u1 = b - 1), g.length && d.push({
                curves: p.curves,
                points: g,
                isCW: lh.isClockWise(g),
                identifier: c++,
                boundingBox: new Pl(new U(b, x), new U(v, y))
            });
        });
        let f = d.map((p)=>l(p, d, u1, h, this.userData?.style.fillRule)), m = [];
        return d.forEach((p)=>{
            let g = f[p.identifier];
            if (g && !g.isHole) {
                let y = new Ca;
                y.curves = p.curves, f.filter((v)=>v?.isHole && v.for === p.identifier).forEach((v)=>{
                    if (v) {
                        let b = d[v.identifier], w = new Gc;
                        w.curves = b.curves, y.holes.push(w);
                    }
                }), m.push(y);
            }
        }), m;
    }
};
var DT = !1, JL, OT = new Promise((n1)=>{
    JL = n1;
}), ZL = !1;
var Jx;

function $L() {
    if (DT = !0, ZL) return;
    if (Jx) return Jx;
    async function n1() {
        let e = await (parcelRequire("14X3t"));
        JL(e), ZL = !0;
    }
    return Jx = n1(), Jx;
}
var sg = class {
    async load(t, e, r = ()=>{}) {
        let { load: i } = await OT;
        i(t, (s1, o)=>{
            s1 || !o ? r(s1 ?? "Something went wrong") : e(o);
        });
    }
    async parse(t) {
        let { parse: e, Bidi: r } = await OT;
        try {
            let i = e(t), s1 = new r, o = (a)=>i.charToGlyphIndex(a.char);
            return s1.registerModifier("glyphIndex", null, o), s1.applyFeatures(i, i.defaultRenderOptions.features), {
                font: i,
                bidi: s1
            };
        } catch (i) {
            console.error(i);
        }
    }
};
async function LZ(n1) {
    return await (await fetch(n1)).arrayBuffer();
}
var NZ = new sg;
async function RT(n1) {
    let t, e, r = !1;
    if (n1.url ? (t = await LZ(n1.url), e = n1.url, r = n1.url.startsWith("/")) : n1.data && (t = n1.data.buffer.slice(n1.data.byteOffset, n1.data.byteOffset + n1.data.byteLength)), t) {
        if (DT) {
            let i = await NZ.parse(t);
            if (i) return {
                font: i.font,
                url: e,
                intercepted: r,
                arr: t,
                bidi: i.bidi
            };
        } else return {
            font: void 0,
            url: e,
            intercepted: r,
            arr: t,
            bidi: null
        };
    }
}
function BZ(n1, t) {
    return t.state.glyphIndex === n1 || t.state.fina === n1 || t.state.medi === n1 || t.state.init === n1;
}
var $x = class {
    constructor(t){
        this._arrayBuffer = new ArrayBuffer(1);
        this._isLoaded = !1;
        this._intercepted = !1;
        this._isUserFont = t.isUserFont ?? !1, this._loadingPromise = RT(t).then((e)=>{
            e && (this._arrayBuffer = e.arr, this._url = e.url, this.font = e.font, this._intercepted = e.intercepted, this._isLoaded = !0, this._bidi = e.bidi);
        });
    }
    update(t) {
        this._isLoaded = !1, this._isUserFont = t.isUserFont ?? !1, this._loadingPromise = RT(t).then((e)=>{
            e && (this._arrayBuffer = e.arr, this._url = e.url, this.font = e.font, this._intercepted = e.intercepted, this._isLoaded = !0, this._bidi = e.bidi);
        });
    }
    get url() {
        return this._url;
    }
    get intercepted() {
        return this._intercepted;
    }
    get isLoaded() {
        return this._isLoaded;
    }
    get loadingPromise() {
        return this._loadingPromise;
    }
    reverseLigaturesTable(t, e, r) {
        if (!this._bidi) return [];
        let i = this._bidi;
        i.getTextGlyphs(e);
        let s1 = i.tokenizer.tokens, o = [], a = 0, l = r.length === s1.length;
        for(let c = 0; c < r.length; c++){
            let u1 = r[c].index, h = String.fromCharCode(r[c].unicode), d = s1[a];
            if (BZ(u1, d) || l) o.push({
                char: h,
                index: u1,
                replacements: [
                    d.state.glyphIndex
                ],
                replacementChars: [
                    d.char
                ]
            }), a++;
            else {
                let f = d.char, m = "", p = [
                    d.state.glyphIndex
                ], g = [], y = !1;
                for(; !y;)a++, m = e.charAt(a), f += m, p.push(t.charToGlyphIndex(m)), g = t.stringToGlyphs(f), g.length === 1 && g[0].index === u1 && (y = !0), a > e.length && (y = !0);
                o.push({
                    char: h,
                    index: u1,
                    replacements: p,
                    replacementChars: Array.from(f)
                }), a++;
            }
        }
        return o;
    }
    generateShapes(t, e, r) {
        if (!this._isLoaded) return;
        let i = this.font, s1 = e.fontSize / this.unitsPerEm, o = e.fontSize * e.lineHeight, a = t.map((x)=>this.getTextWidth(x, e)), l = typeof e.width == "string" ? Number(r.getVariable(e.width)) : e.width, c = typeof e.height == "string" ? Number(r.getVariable(e.height)) : e.height, u1 = this.getCharWidth(`
`, e), h = e.horizontalAlign === 1 ? u1 : 0, d = this.getLineInitialOffsetX(a[0], l, e.horizontalAlign, t[0], u1), f = this.getLineInitialOffsetY(o, t.length, c, s1, e.verticalAlign), m = [], p = t.map((x)=>[]), g = t.map((x)=>[]);
        for(let x = 0; x < t.length; x++){
            let v = t[x], b = {
                features: {
                    liga: !0
                },
                letterSpacing: e.letterSpacing
            }, w = [];
            try {
                w = i.stringToGlyphs(v, b);
            } catch (C) {
                console.warn(C);
            }
            d = this.getLineInitialOffsetX(a[x], l, e.horizontalAlign, v, u1);
            let A = [];
            try {
                A = this.reverseLigaturesTable(i, v, w);
            } catch (C) {
                console.warn(C);
            }
            let T = this.computeSpaceWidthForLine(t, x, e, r), S = 0, M = w[0];
            M && e.horizontalAlign === 2 && M.leftSideBearing !== void 0 && (d -= M.leftSideBearing * s1), this.font?.forEachGlyph(v, d, f, e.fontSize, b, (C, P, _, I, O)=>{
                let L = C.index === 0 ? `
` : C.unicode ? String.fromCharCode(C.unicode) : void 0, j = A[S], V = 0;
                if (L === `
`) V = h;
                else if (L === " ") V = T;
                else {
                    let H = this.createPath(C, s1, P, _, e);
                    H && (V = H.offsetX, m.push(H.path));
                }
                if (j.replacements.length === 1) g[x].push([
                    P,
                    _
                ]), p[x].push(V);
                else {
                    let H = j.replacements.map((z)=>(i.glyphs.get(z).advanceWidth ?? 0) * s1), q = H.reduce((z, Q)=>z += Q, 0), X = H.map((z)=>z / q), K = P;
                    for(let z = 0; z < X.length; z++){
                        let Q = V * X[z];
                        g[x].push([
                            K,
                            _
                        ]), p[x].push(Q), K += Q;
                    }
                }
                S++;
            }), f -= o;
        }
        let y = [];
        for(let x = 0, v = m.length; x < v; x++)y.push(...m[x].toShapes());
        return {
            shapes: y,
            charWidths: p,
            lineWidths: a,
            charCoords: g
        };
    }
    get isUserFont() {
        return this._isUserFont;
    }
    get arrayBuffer() {
        return this._arrayBuffer;
    }
    get ascender() {
        return this.font?.ascender ?? 0;
    }
    get descender() {
        return this.font?.descender ?? 0;
    }
    get familyName() {
        return this.font?.names.fontFamily ?? "";
    }
    get subfamilyName() {
        return this.font?.names.fontSubfamily ?? "";
    }
    get unitsPerEm() {
        return this.font?.unitsPerEm ?? 1;
    }
    getLineInitialOffsetX(t, e, r, i, s1) {
        return (r === 3 || r === 2) && i.indexOf(`
`) >= 0 && (t -= s1), r === 3 ? e * .5 - t * .5 : r === 2 ? e - t : 0;
    }
    getLineInitialOffsetY(t, e, r, i, s1) {
        let o = e * t, a = Math.abs(this.ascender - this.descender) * i, l = t - a, c = -this.ascender * i - l / 2;
        return s1 === 3 ? -(r - o - c) : s1 === 2 ? -(r * .5 - o * .5 - c) : c;
    }
    createPath(t, e, r, i, s1) {
        let o = t.getPath(r, -i, s1.fontSize, {
            kerning: !1,
            letterSpacing: s1.letterSpacing
        });
        if (!o) {
            console.error('THREE.Font: character "' + t + '" does not exists in font family ' + this.familyName + ".");
            return;
        }
        let a = new Zx, l = (t.advanceWidth ?? 1) * e;
        if (t) for (let c of o.commands){
            let u1 = a.currentPath?.currentPoint;
            if (!(u1 && c.type !== "Z" && u1.x === c.x && -u1.y === c.y)) switch(c.type){
                case "M":
                    a.moveTo(c.x, -c.y);
                    break;
                case "L":
                    a.lineTo(c.x, -c.y);
                    break;
                case "Q":
                    a.quadraticCurveTo(c.x1, -c.y1, c.x, -c.y);
                    break;
                case "C":
                    a.bezierCurveTo(c.x1, -c.y1, c.x2, -c.y2, c.x, -c.y);
                    break;
            }
        }
        return a.subPaths.forEach((c)=>{
            let u1 = FZ(c.curves);
            u1 !== void 0 && c.currentPoint.distanceTo(u1) > 0 && c.lineTo(u1.x, u1.y);
        }), {
            offsetX: l,
            path: a
        };
    }
    getCharWidth(t, e) {
        return this.font?.getAdvanceWidth(t, e.fontSize, {
            kerning: !0,
            letterSpacing: e.letterSpacing
        }) ?? 0;
    }
    getTextWidth(t, e) {
        return this.font?.getAdvanceWidth(t, e.fontSize, {
            kerning: !0,
            letterSpacing: e.letterSpacing
        }) ?? 0;
    }
    computeSpaceWidthForLine(t, e, r, i) {
        let s1 = this.getCharWidth(" ", r), o = t[e];
        if (o) {
            let a = this.countSpaces(o.trimEnd());
            if (r.horizontalAlign === 4 && e < t.length - 1 && a) {
                let l = typeof r.width == "string" ? Number(i.getVariable(r.width)) : r.width, c = this.getTextWidth(o, r);
                return (l - (c - a * s1)) / a;
            }
        }
        return s1;
    }
    countSpaces(t) {
        return (t.match(/ /g) || []).length;
    }
};
function FZ(n1) {
    if (n1.length) {
        let t = n1[0];
        if (t instanceof dn) return t.v1;
        if (t instanceof hn || t instanceof es) return t.v0;
    }
}
var LT = class {
    constructor(){
        this.objects = new Map;
        this.unreachable = new Set;
    }
    getCached(t) {
        return this.objects.get(t);
    }
    get size() {
        return this.objects.size;
    }
    get(t, e, r) {
        let i = this.objects.get(t);
        return i === void 0 ? (i = this.createObject(t, e, r), this.objects.set(t, i)) : i.isShared = !0, i;
    }
    forceDelete(t) {
        let e = this.objects.get(t);
        e && (this.disposeObject(e), this.objects.delete(t));
    }
    mutateIfUnique(t, e) {
        let r = this.objects.get(t);
        if (r && r.isShared !== !0) return this.objects.delete(t), this.objects.set(e, r), r;
    }
    startGc() {
        this.unreachable = new Set(this.objects.keys());
    }
    markAsReachable(t, e) {
        let r = this.objects.get(t);
        e === r && this.unreachable.delete(t);
    }
    endGc() {
        this.unreachable.forEach((t)=>{
            this.disposeObject(this.objects.get(t)), this.objects.delete(t);
        }), this.unreachable.clear();
    }
    dispose() {
        this.objects.forEach((t)=>{
            this.disposeObject(t);
        }), this.objects.clear();
    }
}, og = class extends LT {
    constructor(e){
        super();
        this.flatShading = e;
    }
    disposeObject(e) {
        e.dispose();
    }
    createObject(e, r, i) {
        let s1 = Jo(e, r, this.flatShading, i);
        return s1.computeBoundingSphere(), s1;
    }
};
var eN = {
    markNeedsUpdateRendererDirty: ()=>{}
};
var eb = 1e3, tN = 512 * eb;
function VZ(n1, t) {
    let e = typeof n1;
    return !!((t === "string" || t === "number") && e === t || t === "boolean" && (n1 === "true" || n1 === "false" || n1 === !0 || n1 === !1) || t === "image" && e === "string" && n1.startsWith("http"));
}
var rN = "https://hooks.spline.design", UZ = `${rN}/events?hashFile=`, hDe = `${rN}/`, tb = class {
    constructor(t, e){
        this.id = t;
        this.userWebhook = e;
        this.result = void 0;
        this._connected = !1;
        this.emitter = Ya();
        this.reconnectWaitFor = eb;
        this._onError = (t)=>{
            this.eventSource?.removeEventListener("message", this._onMessage), this.eventSource?.removeEventListener("error", this._onError), this.eventSource?.removeEventListener("open", this._onConnected), this._scheduleReconnect();
        };
        this._onConnected = (t)=>{
            clearTimeout(this.scheduledReconnectHandle), this.reconnectWaitFor = eb, this._connected = !0;
        };
        this._onDisconnected = ()=>{
            clearTimeout(this.scheduledReconnectHandle), this.reconnectWaitFor = eb, this._connected = !1;
        };
        this._onMessage = (t)=>{
            let e = t.data, r;
            try {
                r = JSON.parse(e);
            } catch (i) {
                console.error("Error parsing webhook message", i);
            }
            if (r) {
                let i = !1;
                this.userWebhook.parametersSchemas.forEach(({ data: s1 })=>{
                    r[s1.name] !== void 0 && VZ(r[s1.name], s1.type) && (this.result === void 0 && (this.result = {}), this.result[s1.name] = r[s1.name], i = !0);
                }), i && this.emitter.emit("message", {
                    userWebhookId: this.id
                });
            }
        };
    }
    connect() {
        clearTimeout(this.scheduledReconnectHandle), this.userWebhook.url && (this.eventSource = new EventSource(UZ + this.userWebhook.url), this.eventSource.addEventListener("message", this._onMessage), this.eventSource.addEventListener("error", this._onError), this.eventSource.addEventListener("open", this._onConnected));
    }
    disconnect() {
        this.eventSource?.removeEventListener("message", this._onMessage), this.eventSource?.removeEventListener("error", this._onError), this.eventSource?.removeEventListener("open", this._onConnected), this.eventSource?.close(), this._onDisconnected(), clearTimeout(this.scheduledReconnectHandle);
    }
    _scheduleReconnect() {
        this.reconnectWaitFor *= 2, this.reconnectWaitFor > tN && (this.reconnectWaitFor = tN), clearTimeout(this.scheduledReconnectHandle), this.scheduledReconnectHandle = setTimeout(()=>{
            this.scheduledReconnectHandle = void 0, this.connect();
        }, this.reconnectWaitFor);
    }
    update(t) {
        this.userWebhook = t;
    }
    dispose() {
        this._connected && this.disconnect();
    }
    get connected() {
        return this._connected;
    }
    on(t, e) {
        this.emitter.on(t, e);
    }
    off(t, e) {
        this.emitter.off(t, e);
    }
    getParametersKeys() {
        return this.userWebhook.parametersSchemas.map((t)=>t.data.name);
    }
    getParameterValue(t) {
        if (this.getParametersKeys().includes(t)) {
            if (this.result) return this.result?.[t];
            for (let r of this.userWebhook.parametersSchemas)if (r.data.name === t) return j0.defaultParameterValueByType(r.data.type);
        }
    }
};
var iN = [
    4186.01,
    4434.92,
    4698.63,
    4978.03,
    5274.04,
    5587.65,
    5919.91,
    6271.93,
    6644.88,
    7040,
    7458.62,
    7902.13
], kZ = [
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
    "A",
    "A#",
    "B"
], tl = [], ib = [];
for(let n1 = 1; n1 <= 8; n1++)for(let t = 0; t < iN.length; t++){
    let e = iN[t];
    tl.push(e / Math.pow(2, 8 - n1)), ib.push(kZ[t] + n1);
}
var rb = [
    32,
    2e3
], NT = tl.filter((n1, t)=>tl[t] > rb[0] && tl[t] < rb[1]), nN = ib.filter((n1, t)=>tl[t] > rb[0] && tl[t] < rb[1]);
var nb = class {
    static getFrequencies(t, e, r, i = "frequency", s1 = -100, o = -30) {
        r || (r = new Float32Array(t.frequencyBinCount), t.getFloatFrequencyData(r));
        let a = e / 2, l = 1 / r.length * a, c, u1, h;
        if (i === "music" || i === "voice") {
            let m = i === "voice" ? NT : tl, p = Array(m.length).fill(s1);
            for(let g = 0; g < r.length; g++){
                let y = g * l, x = r[g];
                for(let v = m.length - 1; v >= 0; v--)if (y > m[v]) {
                    p[v] = Math.max(p[v], x);
                    break;
                }
            }
            c = p, u1 = i === "voice" ? NT : tl, h = i === "voice" ? nN : ib;
        } else c = Array.from(r), u1 = c.map((m, p)=>l * p), h = u1.map((m)=>`${m.toFixed(2)} Hz`);
        let d = c.map((m)=>Math.max(0, Math.min((m - s1) / (o - s1), 1)));
        return {
            values: new Float32Array(d),
            frequencies: u1,
            labels: h
        };
    }
};
var zZ = "gpt-4o-realtime-preview-2024-12-17", GZ = ()=>"https://relayserver.spline.design/";
async function jZ(n1) {
    try {
        return (await (await fetch(GZ() + "session?uuidfile=" + n1)).json()).token;
    } catch (t) {
        console.error("Token generation error:", t);
    }
}
var BT = class {
    constructor(t){
        this.value = 0;
        this.frequencies = new Float32Array(0);
        let e = new AudioContext;
        this.source = e.createMediaStreamSource(t), this.analyser = e.createAnalyser(), this.source.connect(this.analyser), this.analyser.fftSize = 8192, this.analyser.smoothingTimeConstant = .1;
    }
    getFrequencies(t = -100, e = -30) {
        if (!this.analyser) throw new Error("Not connected, please call .connect() first");
        return nb.getFrequencies(this.analyser, 44100, void 0, "voice", t, e);
    }
    update() {
        let t = this.getFrequencies(), e = t.values.reduce((r, i)=>r + i, 0) / t.values.length;
        this.value = e, this.frequencies = t.values;
    }
    disconnect() {
        this.source.disconnect(), this.analyser.disconnect();
    }
}, ag = class {
    constructor(t, e, r){
        this.data = t;
        this.id = e;
        this.shared = r;
        this.emitter = Ya();
        this.rafId = 0;
        this.voice = 0;
        this.frequencies = new Float32Array([
            0
        ]);
        this.events = [];
        this.isConnected = !1;
        this.isToolsAdded = !1;
        this.tools = [];
        this.onMessage = (t)=>{
            let e = JSON.parse(t.data);
            if (this.appendEvent(e), e.type === "session.created" && this.onSessionCreated(), e.type === "response.done" && e.response?.output) {
                for (let r of e.response.output)if (r.type === "function_call") for (let [i, s1] of this.tools)r.name === i.name && (s1(JSON.parse(r.arguments)), setTimeout(()=>{
                    this.sendClientEvent({
                        type: "response.create",
                        response: {
                            instructions: "notice the user about what you just did"
                        }
                    });
                }));
            }
        };
        this.onSessionCreated = ()=>{
            this.isToolsAdded || this.registerTools();
        };
        this.onOpen = ()=>{
            this.events = [], this.isConnected = !0, this.sendClientEvent({
                type: "response.create",
                response: {
                    instructions: "Say hi"
                }
            });
        };
        this.animate = ()=>{
            if (this.rafId = requestAnimationFrame(this.animate), this.isConnected && this.analyser) {
                this.analyser.update();
                let t = this.analyser.value, e = this.analyser.frequencies;
                this.voice = t, this.frequencies = e, this.emitter.emit("voice", {
                    value: t,
                    frequencies: e
                });
            }
        };
    }
    update(t) {
        this.data = t;
    }
    setColorByName(t, e) {
        let r = this.shared.getColorByName(t);
        if (r) {
            let { id: i } = r, { r: s1, g: o, b: a } = J3.hexStringToRgb(e) ?? {
                r: 0,
                g: 0,
                b: 0
            };
            this.shared.updateColor(i, {
                r: s1 / 255,
                g: o / 255,
                b: a / 255
            });
        }
    }
    async connect() {
        if (this.isConnected) return;
        let t = await jZ(this.data.integration.hash);
        this.pc = new RTCPeerConnection, this.audioElement = document.createElement("audio"), this.audioElement.autoplay = !0, this.pc.ontrack = (l)=>{
            let c = l.streams[0];
            this.audioElement.srcObject = c, this.analyser = new BT(c);
        };
        let e = await navigator.mediaDevices.getUserMedia({
            audio: !0
        });
        this.pc.addTrack(e.getTracks()[0]), this.dc = this.pc.createDataChannel("oai-events"), this.dc.addEventListener("message", this.onMessage), this.dc.addEventListener("open", this.onOpen);
        let r = await this.pc.createOffer();
        await this.pc.setLocalDescription(r);
        let a = {
            type: "answer",
            sdp: await (await fetch(`https://api.openai.com/v1/realtime?model=${zZ}`, {
                method: "POST",
                body: r.sdp,
                headers: {
                    Authorization: `Bearer ${t}`,
                    "Content-Type": "application/sdp"
                }
            })).text()
        };
        await this.pc.setRemoteDescription(a), this.animate();
    }
    appendEvent(t) {
        this.events = [
            t,
            ...this.events
        ];
    }
    sendClientEvent(t) {
        this.dc ? (t.event_id = t.event_id || crypto.randomUUID(), this.dc.send(JSON.stringify(t)), this.appendEvent(t)) : console.error("Failed to send message - no data channel available", t);
    }
    registerTools() {
        this.isToolsAdded = !0, this.registerTool({
            type: "function",
            name: "set_personality_color",
            description: "returns a color based on the voice personality of the ai assistant. This should be called by the voice assistant each time it is asks to speak differently. If a color cannot be associated to the personality, the color should be a neutral color.",
            parameters: {
                type: "object",
                properties: {
                    color: {
                        type: "string",
                        description: "css hex color string, reflecting the personality"
                    },
                    personality: {
                        type: "string",
                        description: "the personality of the voice assistant"
                    }
                },
                required: [
                    "color",
                    "personality"
                ]
            }
        }, ({ color: s1 })=>{
            this.setColorByName("Voice Assistant Color", s1);
        });
        let t = this.shared.getVariablesNames().join(", ");
        this.registerTool({
            type: "function",
            name: "set_variable",
            description: "Sets a Spline variable value when asked by the user.",
            parameters: {
                type: "object",
                properties: {
                    name: {
                        type: "string",
                        description: `The name of the variable that needs to be set. Here's a list of available variables: ${t}. It the variable does not exist, don't call the function and warn the user about it.`
                    },
                    value: {
                        type: "string",
                        description: "The new value for this variable, should always be a string even for number and boolean variables, assume that the value will be cast to the proper type afterwards."
                    }
                },
                required: [
                    "name",
                    "value",
                    "type"
                ]
            }
        }, ({ name: s1, value: o })=>{
            let a = this.shared.getVariableByName(s1);
            if (a) {
                let l = this.shared.getVariable(a.id), c;
                typeof l == "number" ? c = parseFloat(o) : typeof l == "boolean" ? c = o.toLowerCase() === "true" : c = {
                    textValue: o
                }, this.shared.updateVariable(a.id, c);
            }
        });
        let e = this.shared.getColorNames().join(", ");
        this.registerTool({
            type: "function",
            name: "set_color",
            description: "Sets a Spline color asset value when asked by the user.",
            parameters: {
                type: "object",
                properties: {
                    name: {
                        type: "string",
                        description: `The name of the color asset that needs to be set. Here's a list of available color assets: ${e}. It the color asset does not exist, don't call the function and warn the user about it.`
                    },
                    value: {
                        type: "string",
                        description: "css hex color string"
                    }
                },
                required: [
                    "name",
                    "value"
                ]
            }
        }, ({ name: s1, value: o })=>{
            this.setColorByName(s1, o);
        });
        let r = this.shared.scene, i = [];
        r.traverseEntity((s1)=>{
            s1.data.events.forEach((o)=>{
                if (o.data.type === "AIAssistantTrigger") {
                    let { description: a } = o.data;
                    i.push(a);
                }
            });
        }), this.registerTool({
            type: "function",
            name: "trigger_event",
            description: "Trigger an event by name, here are the available events, please match what the user is asking for to one of these if it applies, otherwise don't call the function and warn the user.",
            parameters: {
                type: "object",
                properties: {
                    description: {
                        type: "string",
                        description: `The name of the event that needs to be triggered. Here's a list of available events: ${JSON.stringify(i)}.`
                    },
                    direction: {
                        type: "string",
                        description: "default is forward, but can be forward or backward. Always set to forward unless the user ask to reverse or cancel the event, then set to backward."
                    }
                },
                required: [
                    "description",
                    "direction"
                ]
            }
        }, ({ description: s1, direction: o })=>{
            this.emitter.emit("trigger_event", {
                description: s1,
                direction: o
            });
        }), this.sendClientEvent({
            type: "session.update",
            session: {
                tools: this.tools.map(([s1])=>s1)
            }
        });
    }
    registerTool(t, e) {
        this.tools.push([
            t,
            e
        ]);
    }
    disconnect() {
        cancelAnimationFrame(this.rafId), this.analyser?.disconnect(), this.voice = 0, this.isConnected = !1, this.isToolsAdded = !1, this.dc?.removeEventListener("message", this.onMessage), this.dc?.removeEventListener("open", this.onOpen), this.dc?.close(), this.pc?.getSenders().forEach((t)=>{
            t.track && t.track.stop();
        }), this.pc?.close(), this.pc = void 0;
    }
    computeAnalysisForListenerEvent(t) {
        if (t.analysis === "range") {
            let e = this.frequencies.slice(...t.analysisRange);
            return e.reduce((r, i)=>r + i, 0) / e.length;
        }
        return t.analysis === "single" ? this.frequencies[t.analysisSingle] : this.voice;
    }
    on(t, e) {
        this.emitter.on(t, e);
    }
    off(t, e) {
        this.emitter.off(t, e);
    }
};
function sb(n1) {
    return "variable_" + n1;
}
var FT = class extends Hx {
    constructor(e){
        super();
        this.shared = e;
    }
    create(e) {
        return new Tf(e, this.shared);
    }
}, vu = class {
    constructor(t, e = {}, r = !0, i = !1){
        this.data = t;
        this.needsJitter = r;
        this.enableLocalStorageForPersistentVariables = i;
        this.geometryCache = new og(!0);
        this.geometryCache2 = new og(!1);
        this.imageHolderCache = new FT(this);
        this.thisContext = {
            scene: eN,
            shared: this
        };
        this.deletedMaterial = new yu(Kr.defaultTwoLayerData("phong"), this.thisContext, "");
        this.deletedImage = new as(q0.emptyImage, this);
        this.deletedVideo = new as(hd.defaultVideo, this);
        this.materials = {};
        this.images = {};
        this.uiBuffers = {};
        this.videos = {};
        this.colors = {};
        this.audios = {};
        this.particles = {};
        this.fonts = {};
        this.timelineAnimations = {};
        this.variables = {};
        this.userAPIs = {};
        this.userWebhooks = {};
        this.mouseProperty = null;
        this.raycastProperty = null;
        this.requestRender = ()=>{
            this._requestRender && this._requestRender();
        };
        if (e.images) for (let [s1, o] of Object.entries(e.images))this.addImage(s1, o);
        if (e.videos) for (let [s1, o] of Object.entries(e.videos))this.addVideo(s1, o);
        if (e.audios) for (let [s1, o] of Object.entries(e.audios))this.addAudio(s1, o);
        if (e.particles) for (let [s1, o] of Object.entries(e.particles))this.addParticle(s1, o);
        this.reset(t);
    }
    setRequestRender(t) {
        this._requestRender = t;
    }
    getImageLoadPromises() {
        return Object.values(this.images).map((t)=>t.loadPromise);
    }
    setEntityOpContext(t) {
        this.entityOpContext = t;
    }
    reset(t, e = !1, r = !1) {
        this.data = t, this.resetLib(t.lib);
        for (let { id: i, data: s1 } of t.variables)this.addVariableHolder(i, s1), e && this.updateVariableHolder(i, s1);
        for (let [i, s1] of Object.entries(t.userAPIs ?? {}))this.addUserAPI(i, s1);
        for (let [i, s1] of Object.entries(t.userWebhooks ?? {}))this.addUserWebhook(i, s1);
        if (!r) {
            for (let [i, s1] of Object.entries(t.images))this.addImage(i, s1);
            for (let [i, s1] of Object.entries(t.videos))this.addVideo(i, s1);
        }
        for (let [i, s1] of Object.entries(t.colors))this.addColor(i, s1);
        for (let [i, s1] of Object.entries(t.materials))this.addMaterial(i, s1);
        for (let [i, s1] of Object.entries(t.audios))this.addAudio(i, s1);
        for (let [i, s1] of Object.entries(t.particles))this.addParticle(i, s1);
        for (let [i, s1] of Object.entries(t.fonts))this.addFont(i, s1);
        for (let [i, s1] of Object.entries(t.timelineAnimations ?? {}))this.addAnimation(i, s1);
    }
    addMaterial(t, e) {
        if (this.materials[t]) {
            let r = this.materials[t];
            r.reset(e, this.thisContext), r.dispose();
        } else {
            let r = new yu(e, this.thisContext, t);
            this.materials[t] = r;
        }
    }
    deleteMaterial(t) {
        this.materials[t] && (this.materials[t].nodeMaterialDispose(), delete this.materials[t]);
    }
    getMaterial(t) {
        let e = this.materials[t];
        return e;
    }
    getMaterialOrDeletedPlaceholder(t) {
        return this.materials[t] ?? this.deletedMaterial;
    }
    material(t) {
        return typeof t == "string" ? this.getMaterialOrDeletedPlaceholder(t) : t == null ? (console.error("material is undefined or null"), this.deletedMaterial) : new $a(t, this.thisContext);
    }
    getMaterials() {
        return this.materials;
    }
    addImage(t, e) {
        return this.images[t] ? (this.onColorOrImageUpdate && this.onColorOrImageUpdate(), this.images[t].updateSrc(e.data), !0) : (this.images[t] = new as(e, this), !1);
    }
    deleteImage(t) {
        let e = this.images[t];
        e && (e.dispose(), delete this.images[t]);
    }
    getDefaultImage() {
        return this.images.image_0;
    }
    getImage(t) {
        return this.images[t] ?? this.deletedImage;
    }
    image(t) {
        return typeof t == "string" ? this.getImage(t) : this.imageHolderCache.load(t);
    }
    addUIBuffer(t, e) {
        return this.uiBuffers[t] ? (this.onColorOrImageUpdate && this.onColorOrImageUpdate(), this.uiBuffers[t].updateSrc(e), !0) : (this.uiBuffers[t] = new as(e, this), !1);
    }
    uiBuffer(t) {
        return this.uiBuffers[t];
    }
    addVideo(t, e) {
        return this.videos[t] ? (this.videos[t].updateSrc(e.data), !0) : (this.videos[t] = new as(e, this), !1);
    }
    deleteVideo(t) {
        let e = this.videos[t];
        e && (e.dispose(), delete this.videos[t]);
    }
    getVideo(t) {
        return this.videos[t] ?? this.deletedVideo;
    }
    video(t) {
        return typeof t == "string" ? this.getVideo(t) : this.imageHolderCache.load(t);
    }
    addColor(t, e) {
        return this.colors[t] ? (this.onColorOrImageUpdate && this.onColorOrImageUpdate(), "a" in e ? this.colors[t].setRGBA(e.r, e.g, e.b, e.a) : this.colors[t].setRGBA(e.r, e.g, e.b, 1), !0) : ("a" in e ? this.colors[t] = new sc(e.r, e.g, e.b, e.a) : this.colors[t] = new sc(e.r, e.g, e.b, 1), !1);
    }
    updateColor(t, e) {
        if (this.colors[t]) {
            this.onColorOrImageUpdate && this.onColorOrImageUpdate();
            let r = this.colors[t];
            return this.colors[t].r = e.r ?? r.r, this.colors[t].g = e.g ?? r.g, this.colors[t].b = e.b ?? r.b, this.colors[t].a = e.a ?? r.a, !0;
        }
        return !1;
    }
    deleteColor(t) {
        this.colors[t] && delete this.colors[t];
    }
    getColor(t) {
        return this.colors[t];
    }
    getColorNames() {
        return Object.values(this.data.colors).map((t)=>t.name);
    }
    getColorByName(t) {
        for(let e in this.data.colors)if (this.data.colors[e].name === t) return {
            color: this.colors[e],
            id: e
        };
    }
    color(t) {
        let e;
        if (typeof t == "string") {
            let r = this.getColor(t);
            r ? e = r : (console.warn("Tried to create color layer params with a color key that does not exist in the assets manager"), e = new cr(0, 0, 0, 0));
        } else return "a" in t ? new cr(t.r, t.g, t.b, t.a) : new cr(t.r, t.g, t.b, 1);
        return e;
    }
    addAudio(t, e) {
        this.audios[t] = e;
    }
    getAudio(t) {
        let e = this.audios[t];
        if (e instanceof el) return e;
        {
            let r = new el({
                src: e.data
            });
            return this.audios[t] = r, r;
        }
    }
    addParticle(t, e) {
        this.particles[t] = e;
    }
    getParticle(t) {
        return this.particles[t];
    }
    deleteParticle(t) {
        this.particles[t] && delete this.particles[t];
    }
    deleteAudio(t) {
        let e = this.audios[t];
        e && (e instanceof el && e.dispose(), delete this.audios[t]);
    }
    addFont(t, e) {
        this.fonts[t] = new $x(e), this.fonts[t].loadingPromise.then(()=>this.requestRender());
    }
    getFont(t) {
        return this.fonts[t];
    }
    deleteFont(t) {
        this.fonts[t] && delete this.fonts[t];
    }
    addAnimation(t, e) {
        this.timelineAnimations[t] = e;
    }
    getAnimation(t) {
        return this.timelineAnimations[t];
    }
    deleteAniamtion(t) {
        this.timelineAnimations[t] && delete this.timelineAnimations[t];
    }
    dispose() {
        Object.keys(this.materials).forEach((e)=>this.deleteMaterial(e)), this._requestRender = void 0, Object.values(this.audios).forEach((e)=>{
            e instanceof el && e.dispose();
        }), this.audios = {}, this.particles = {}, this.geometryCache.dispose(), this.geometryCache2.dispose();
    }
    addVariableHolder(t, e) {
        if (this.variables[t] === void 0) {
            let r = e.value;
            if (this.enableLocalStorageForPersistentVariables && e.persistent) {
                let i = localStorage.getItem(sb(t));
                r = i !== null ? JSON.parse(i) : e.value;
            }
            return this.variables[t] = {
                value: r,
                locations: [],
                persistent: e.persistent
            }, "dynamicVariableType" in e && (this.variables[t].dynamicVariablePlayState = "Playing", this.variables[t].dynamicVariableToggleIsForward = void 0), !0;
        }
        return this.variables[t].value = e.value, !1;
    }
    resetDynamicVariablePlayState() {
        for(let t in this.variables)this.variables[t].dynamicVariablePlayState !== void 0 && (this.variables[t].dynamicVariablePlayState = "Playing", this.variables[t].dynamicVariableToggleIsForward = void 0);
    }
    updateVariableHolder(t, e) {
        this.updateVariable(t, e.value);
    }
    updateVariable(t, e) {
        if (this.variables[t] === void 0) return !1;
        this.variables[t].value = e, this.enableLocalStorageForPersistentVariables && this.variables[t].persistent && localStorage.setItem(sb(t), JSON.stringify(e));
        let r = e;
        for(; typeof r == "string";)r = this.variables[r].value;
        let i = this.entityOpContext.scene;
        for(let s1 = this.variables[t].locations.length - 1; s1 >= 0; s1--){
            let o = this.variables[t].locations[s1];
            if (o[0] === "material") {
                let a = o[1], l = r, c = {
                    scene: i,
                    shared: this
                }, u1 = o.slice(2);
                i.traverseMaterial((d)=>{
                    let f = d.root ?? d;
                    f.uuid === a && f.onVariableUpdate(u1, l, c);
                });
                let h = this.materials[a];
                h && h.onVariableUpdate(u1, l, c);
            } else {
                let a = i.find(o[0]);
                if (a === void 0) {
                    this.variables[t].locations.splice(s1, 1);
                    continue;
                }
                if (o[1] !== "geometry" && o[1] !== "particles") {
                    for(let l = 1; l < o.length - 1; l++)a = a[o[l]];
                    o[1] === "rotation" ? a[o[o.length - 1]] = r * Se.DEG2RAD : a[o[o.length - 1]] = r;
                }
                if (a = i.find(o[0]), a.type === "ParticleEmitter" && a.updateVariableState(r, o), gt.is(a)) {
                    if (o[1] === "position" || o[1] === "rotation" || o[1] === "scale") a.onVariableUpdate();
                    else if (o[1] === "geometry") {
                        let l = a;
                        a.component && (l = a.component);
                        let c = l.dataPatched;
                        l.chooseGeoemtryCache(this).forceDelete(c.geometry), l.createGeometryDelayed(this.entityOpContext), l.onVariableUpdate(!0), l.invalidateDownstreamBooleanData(), l.instances.forEach((u1)=>{
                            let h = u1.dataPatched;
                            u1.chooseGeoemtryCache(this).forceDelete(h.geometry), u1.createGeometryDelayed(this.entityOpContext), u1.onVariableUpdate(!0), u1.invalidateDownstreamBooleanData();
                        });
                    } else o[1] === "morphTargetInfluences" && a.updateMorphInfluences(o[2], r);
                }
            }
        }
        return this.requestRender(), !0;
    }
    deleteVariable(t) {
        this.variables[t] && delete this.variables[t];
    }
    getVariable(t, e) {
        if (Array.isArray(t)) {
            if (t[0] === "mouse") return this.mouseProperty?.[t[1]] ?? 0;
            if (t[0] === "raycast") return this.raycastProperty?.[t[1]] ?? 0;
            let r = this.entityOpContext.scene.find(t[0]);
            if (t[1] === "width" || t[1] === "height" || t[1] === "depth") return r.geometry.userData.parameters[t[1]];
            for(let i = 1; i < t.length; i++)r = r[t[i]];
            return t[1] === "rotation" && (r *= Se.RAD2DEG), r;
        }
        for(let r in this.variables){
            if (e === void 0) break;
            let i = this.variables[r], s1 = i.locations?.findIndex((o)=>Mr.equal(o, e));
            s1 !== void 0 && s1 !== -1 && i.locations.splice(s1, 1);
        }
        if (typeof t == "string") {
            let r = t, i = t;
            do {
                if (i = r, this.variables[r] === void 0) break;
                let s1 = this.variables[r].value;
                e && this.variables[i] !== void 0 && this.variables[i].locations.push(e), r = s1;
            }while (typeof r == "string");
            return r;
        } else return t;
    }
    getVariables() {
        return this.variables;
    }
    getVariablesNames() {
        return this.data.variables.map((t)=>t.data.name);
    }
    getVariableByName(t) {
        for (let e of this.data.variables)if (e.data.name === t) return {
            variable: e.data,
            id: e.id
        };
    }
    getDynamicVariablePlayState(t) {
        return this.variables[t]?.dynamicVariablePlayState;
    }
    setDynamicVariablePlayState(t, e) {
        this.variables[t] !== void 0 && (this.variables[t].dynamicVariablePlayState = e);
    }
    getDynamicVariableToggleIsForward(t) {
        return this.variables[t]?.dynamicVariableToggleIsForward;
    }
    setDynamicVariableToggleIsForward(t, e) {
        this.variables[t] !== void 0 && (this.variables[t].dynamicVariableToggleIsForward = e);
    }
    resetLib(t) {
        for (let [e, r] of Object.entries(t.images))this.addImage(e, r.asset);
        for (let [e, r] of Object.entries(t.audios))this.addAudio(e, r.asset);
        for (let [e, r] of Object.entries(t.particles))this.addParticle(e, r.asset);
        for (let [e, r] of Object.entries(t.colors))this.addColor(e, r.asset);
        for (let [e, r] of Object.entries(t.fonts))this.addFont(e, r.asset);
        for (let [e, r] of Object.entries(t.materials))this.addMaterial(e, r.asset);
        for (let [e, r] of Object.entries(t.videos))this.addVideo(e, r.asset);
        for (let [e, r] of Object.entries(t.variables))this.addVariableHolder(e, r.asset);
    }
    updateLibByOp(t, e) {
        t.path[0] === "images" ? t.path.length === 1 && t.type === 1 ? this.addImage(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteImage(t.id) : t.path[0] === "videos" ? t.path.length === 1 && t.type === 1 ? this.addVideo(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteVideo(t.id) : t.path[0] === "audios" ? t.path.length === 1 && t.type === 1 ? this.addAudio(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteAudio(t.id) : t.path[0] === "particles" ? t.path.length === 1 && t.type === 1 ? this.addParticle(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteParticle(t.id) : t.path[0] === "colors" ? t.path.length === 1 && t.type === 1 ? this.addColor(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteColor(t.id) : t.path[0] === "materials" ? t.path.length === 1 && t.type === 1 ? this.addMaterial(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteMaterial(t.id) : t.path[0] === "fonts" ? t.path.length === 1 && t.type === 1 ? this.addFont(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteFont(t.id) : t.path[0] === "variables" ? t.path.length === 1 && t.type === 1 ? this.addVariableHolder(t.id, t.data.asset) : t.path.length === 1 && t.type === 2 && this.deleteVariable(t.id) : t.path[0] === "components" && e.updateByLibOp(t, this);
    }
    updateByOp(t, e, r) {
        if (this.data = e, t.path[0] === "images") t.path.length === 2 && t.type === 0 ? t.props.data && this.getImage(t.path[1]).updateSrc(t.props.data) : t.path.length === 1 && t.type === 1 ? this.addImage(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteImage(t.id);
        else if (t.path[0] === "videos") t.path.length === 2 && t.type === 0 ? t.props.data && this.getVideo(t.path[1]).updateSrc(t.props.data) : t.path.length === 1 && t.type === 1 ? this.addVideo(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteVideo(t.id);
        else if (t.path[0] === "audios") t.path.length === 2 && t.type === 0 ? t.props.data && this.addAudio(t.path[1], e.audios[t.path[1]]) : t.path.length === 1 && t.type === 1 ? this.addAudio(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteAudio(t.id);
        else if (t.path[0] === "particles") t.path.length === 2 && t.type === 0 ? t.props.data && this.addParticle(t.path[1], e.particles[t.path[1]]) : t.path.length === 1 && t.type === 1 ? this.addParticle(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteParticle(t.id);
        else if (t.path[0] === "colors") t.path.length === 2 && t.type === 0 ? this.updateColor(t.path[1], t.props) : t.path.length === 1 && t.type === 1 ? this.addColor(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteColor(t.id);
        else if (t.path[0] === "materials") t.path.length === 1 && t.type === 1 ? this.addMaterial(t.id, t.data) : t.path.length === 1 && t.type === 2 ? this.deleteMaterial(t.id) : t.path.length > 1 && this.getMaterial(t.path[1]).updateByOp(zr.drop(t, 2), e.materials[t.path[1]], {
            shared: this,
            scene: r
        });
        else if (t.path[0] === "fonts") t.path.length === 2 && t.type === 0 ? this.updateFont(t.path[1], t, r) : t.path.length === 1 && t.type === 1 ? this.addFont(t.id, t.data) : t.path.length === 1 && t.type === 2 && this.deleteFont(t.id);
        else if (t.path[0] === "variables") t.path.length === 2 && t.type === 0 ? "value" in t.props ? this.updateVariable(t.path[1], t.props.value) : "persistent" in t.props && (this.variables[t.path[1]].persistent = t.props.persistent) : t.path.length === 1 && t.type === 4 ? this.addVariableHolder(t.id, t.data) : t.path.length === 1 && t.type === 5 && this.deleteVariable(t.id);
        else if (t.path[0] === "userAPIs") {
            if (t.path.length === 1 && t.type === 1) this.addUserAPI(t.id, t.data);
            else if (t.path.length === 1 && t.type === 2) this.deleteUserAPI(t.id);
            else if (typeof t.path[1] == "string") {
                let i = e.userAPIs[t.path[1]];
                if (i) {
                    let s1 = t.type === 0 && t.props.debounce === void 0, o = this.getUserAPI(t.path[1]);
                    o instanceof ag ? o.update(i) : o?.update(i, this, s1);
                }
            }
        } else if (t.path[0] === "userWebhooks") {
            if (t.path.length === 1 && t.type === 1) this.addUserWebhook(t.id, t.data);
            else if (t.path.length === 1 && t.type === 2) this.deleteUserWebhook(t.id);
            else if (typeof t.path[1] == "string") {
                let i = e.userWebhooks[t.path[1]];
                i && this.getUserWebhook(t.path[1])?.update(i);
            }
        } else t.path[0] === "lib" && this.updateLibByOp(zr.drop(t, 1), r);
    }
    updateFont(t, e, r) {
        if (e.props.url) {
            let i = this.getFont(t), s1 = {
                ...this.data.fonts[t],
                url: e.props.url
            };
            i.update(s1), i.loadingPromise.then(()=>this.requestRender()), r.updateFont(t, this);
        }
    }
    addUserAPI(t, e) {
        return this.userAPIs[t] ? (this.userAPIs[t].update(e, this), !0) : this.openAIRealtime?.id === t ? (this.openAIRealtime.update(e), !0) : e.integration?.type === "VoiceAssistant" ? (this.openAIRealtime = new ag(e, t, this), !1) : (this.userAPIs[t] = new $d(t, e, this), !1);
    }
    getUserAPI(t) {
        return this.openAIRealtime?.id === t ? this.openAIRealtime : this.userAPIs[t];
    }
    getUserAPIs() {
        return this.userAPIs;
    }
    deleteUserAPI(t) {
        let e = this.userAPIs[t];
        e && (e.dispose(), delete this.userAPIs[t]);
    }
    addUserWebhook(t, e) {
        return this.userWebhooks[t] ? (this.userWebhooks[t].update(e), !0) : (this.userWebhooks[t] = new tb(t, e), !1);
    }
    getUserWebhook(t) {
        return this.userWebhooks[t];
    }
    getUserWebhooks() {
        return this.userWebhooks;
    }
    deleteUserWebhook(t) {
        let e = this.userWebhooks[t];
        e && (e.dispose(), delete this.userWebhooks[t]);
    }
    get scene() {
        return this.entityOpContext.scene;
    }
}, nOe = new vu(An.emptyData());
var _n = class extends nr {
    updateByPatchedOp(e, r, i) {
        if (super.updateByPatchedOp(e, r, i), RD(e.path, [
            "materials"
        ]) !== null && e.type === 0 && Array.isArray(this.material)) for (let [s1, o] of Object.entries(e.props)){
            let a = i.shared.material(o);
            this.material[Number(s1)] = a;
        }
        else if (kt(e.path, [
            "material"
        ]) && this.material instanceof fn) "material" in r && typeof r.material != "string" && this.material.updateByOp(zr.drop(e, 1), r.material, i);
        else if (kt(e.path, [
            "materials",
            "*"
        ]) && Array.isArray(this.material)) {
            let s1 = e.path[1];
            if ("materials" in r && s1 < this.material.length) {
                let o = r.materials[s1];
                typeof o != "string" && this.material[s1].updateByOp(zr.drop(e, 2), o, i);
            }
        }
    }
    get needsAO() {
        return this.material !== void 0 ? (Array.isArray(this.material) ? this.material[0] : this.material).hasAO : !1;
    }
    updateState(e, r) {
        super.updateState(e, r), e.castShadow !== void 0 && (this.castShadow = e.castShadow), e.receiveShadow !== void 0 && (this.receiveShadow = e.receiveShadow);
        let i = this.dataPatched;
        this.dataPatched.type === "Mesh" && !!this.dataPatched.geometry.shapeBlendNode && this.layers.set(9);
        let o;
        this.dataPatched.type === "Mesh" && this.dataPatched.geometry.type === "ShapeBlendGeometry" && (o = {
            resolutionLevel: this.dataPatched.geometry.resolutionLevel,
            useChildrenColors: this.dataPatched.geometry.useChildrenColors
        }), e.geometry?.type !== "NonParametricGeometry" && "material" in e && e.material !== void 0 && (this.disposeMaterial(), this.material = r.shared.material(e.material).getFlavor(i.flatShading, i.side, i.wireframe, o), r.scene.markNeedsUpdateRendererDirty()), (e.geometry?.type === "NonParametricGeometry" || "materials" in e) && ("materials" in e && e.materials !== void 0 ? (this.disposeMaterial(), this.material = e.materials.map((l)=>r.shared.material(l).getFlavor(i.flatShading, i.side, i.wireframe)), r.scene.markNeedsUpdateRendererDirty()) : "material" in e && e.material !== void 0 && (this.disposeMaterial(), this.material = [
            r.shared.material(e.material).getFlavor(i.flatShading, i.side, i.wireframe)
        ], r.scene.markNeedsUpdateRendererDirty()));
        let a = this.data;
        if (a.geometry?.type !== "NonParametricGeometry" && "materials" in a && a.materials !== void 0 && (this.disposeMaterial(), this.material = r.shared.material(a.materials[0]).getFlavor(i.flatShading, i.side, i.wireframe)), e.flatShading !== void 0 || e.wireframe !== void 0 || e.side !== void 0) {
            if (Array.isArray(this.material)) for(let l = 0; l < this.material.length; l++)this.material[l] = this.material[l].getFlavor(i.flatShading, i.side, i.wireframe);
            else this.material = this.material.getFlavor(i.flatShading, i.side, i.wireframe, o);
        }
    }
    disposeMaterial() {
        this.material && Wv(this.material).forEach((e)=>{
            e instanceof fn && (e instanceof yu || e.nodeMaterialDispose());
        });
    }
    dispose() {
        this.disposeMaterial(), super.dispose();
    }
};
var sN = new E, oN = new Ze, aN = new Ze, qZ = new E, lN = new ue, Ct = class extends _n {
    constructor(e, r, i){
        super(e, r);
        this.data = r;
        this.isSkinnedMesh = !1;
        this.localGeometry = void 0, r.bindMode && r.bindMatrix && (this.bindMode = r.bindMode, this.bindMatrix = new ue().fromArray(r.bindMatrix), this.bindMatrixInverse = new ue);
    }
    chooseGeoemtryCache(e) {
        return e.geometryCache;
    }
    markGeometryAsReachable(e) {
        this.geometryCreateDeleyed instanceof Ce && this.chooseGeoemtryCache(e).markAsReachable(this.dataPatched.geometry, this.geometryCreateDeleyed);
    }
    get geometry() {
        if (this.localGeometry !== void 0) return this.localGeometry;
        if (this.geometryCreateDeleyed instanceof vu) {
            let e = this.geometryCreateDeleyed, r = this.chooseGeoemtryCache(e);
            this.geometryCreateDeleyed = r.get(this.dataPatched.geometry, e, this);
        }
        return this.geometryCreateDeleyed;
    }
    set geometry(e) {
        this.localGeometry = e;
    }
    get is2DAndNoDepth() {
        let e = this.dataPatched.geometry;
        return xm.is2DParametricMesh(e.type) && e.depth === 0;
    }
    get is2DType() {
        return xm.is2DParametricMesh(this.geometry.userData.type);
    }
    get isNonParametric() {
        return this.geometry.userData.type === "NonParametricGeometry";
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), kt(e.path, [
            "geometry"
        ]) && this.updateByPatchedOpGeometry(zr.drop(e, 1), r.geometry, i);
    }
    removeInteractionGeometry(e) {
        this.localGeometry?.dispose(), this.localGeometry = void 0;
    }
    updateGeometryInteractions(e, r) {
        this.invalidateDownstreamBooleanData();
        let i = this.data.geometry.type;
        if (i === "NonParametricGeometry" || i === "SubdivGeometry") {
            let s1 = e;
            if (this.localGeometry === void 0) {
                let f = {
                    ...this.data.geometry,
                    ...s1
                };
                this.localGeometry = Jo(f, r, this.data.flatShading, this);
            }
            let o, a, l;
            s1.scaleBaked ? [o, a, l] = s1.scaleBaked : { width: o, height: a, depth: l } = s1;
            let c = this.localGeometry.userData, u1 = typeof o == "number" ? o : 1, h = typeof a == "number" ? a : 1, d = typeof l == "number" ? l : 1;
            c.sxPrev !== void 0 && Xm(this.localGeometry.attributes, u1 / c.sxPrev, h / c.syPrev, d / c.szPrev), c.sxPrev = u1, c.syPrev = h, c.szPrev = d;
        } else {
            let s1 = {
                ...this.data.geometry,
                ...e
            };
            this.localGeometry?.dispose(), this.localGeometry = Jo(s1, r, this.data.flatShading, this);
        }
    }
    refreshAttachedClonersInteractions(e) {
        for (let r of this.attachedSurfaceCloners)r.update(e);
    }
    refreshAttachedCloners(e) {
        for (let r of this.attachedSurfaceCloners)e.scene.addPendingUpdateCloner(r.object);
    }
    refreshAttachedPaths(e) {
        for (let r of this.attachedPaths)e.scene.addPendingCommand(()=>r.updateShape());
    }
    createGeometryDelayed(e) {
        this.geometryCreateDeleyed = e.shared, this.refreshAttachedCloners(e), this.refreshAttachedPaths(e);
    }
    updateByPatchedOpGeometry(e, r, i) {
        let s1 = !1;
        e.type === 0 && e.path.length === 0 && Object.keys(e.props).includes("scaleBaked") && this.geometryCreateDeleyed instanceof ui && this.chooseGeoemtryCache(i.shared).mutateIfUnique(this.geometryCreateDeleyed.data, r) === this.geometryCreateDeleyed && (s1 = !0, this.geometryCreateDeleyed.mutateDirectlyScaleBaked(r, e.props.scaleBaked), this.refreshAttachedCloners(i), this.refreshAttachedPaths(i)), s1 || (i.scene?.markGeometryCacheDirty(), this.createGeometryDelayed(i)), this.resetBBoxNeedsUpdate(), this.invalidateDownstreamBooleanData();
    }
    updateGeometryOnStateUpdate(e, r) {
        this.createGeometryDelayed(r);
    }
    updateState(e, r) {
        e.geometry !== void 0 && this.updateGeometryOnStateUpdate(e.geometry, r);
        let i = e.morphTargetInfluences;
        if (i) {
            this.updateMorphTargets(), this.geometry.morphTargetsRelative = !0;
            for (let { data: { name: s1, value: o } } of i)this.updateMorphInfluences(s1, r.shared.getVariable(o, [
                this.uuid,
                "morphTargetInfluences",
                s1
            ]));
        }
        super.updateState(e, r);
    }
    updateMorphInfluences(e, r) {
        if (this.morphTargetDictionary === void 0) return;
        let i = this.morphTargetDictionary[e];
        i !== void 0 && (this.morphTargetInfluences[i] = r);
    }
    updateGeometryGroupsIfNeeded() {
        Array.isArray(this.material) && this.geometry.groups.length === 0 && this.geometry.addGroup(0, Math.max(this.geometry.getIndex()?.count ?? 0, this.geometry.getAttribute("position").count), 0);
    }
    updateEntityBoxSize(e, r) {
        let i = this.geometry.userData.parameters;
        this.is2DType ? e.set(0, 0, i.depth * .5) : this.isNonParametric ? (e.setScalar(0), this.geometry.boundingSphere && e.copy(this.geometry.boundingSphere.center), r.set(i.width, i.height, i.depth ?? 0).multiplyScalar(.5)) : i.centerOffset ? e.fromArray(i.centerOffset) : e.setScalar(0), r.set(i.width, i.height, i.depth ?? 0).multiplyScalar(.5);
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e), this.bindMode === "attached" ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : this.bindMode === "detached" && this.bindMatrixInverse.copy(this.bindMatrix).invert();
    }
    bind(e, r) {
        this.skeleton = e, this.isSkinnedMesh = !0, r === void 0 && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), r = this.matrixWorld), this.bindMatrix.copy(r), this.bindMatrixInverse.copy(r).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights(e) {
        let r = new Ze, i = this.geometry.attributes.skinWeight;
        for(let s1 = 0, o = i.count; s1 < o; s1++){
            r.fromBufferAttribute(i, s1);
            let a = 1 / r.manhattanLength();
            a !== 1 / 0 ? r.multiplyScalar(a) : r.set(1, 0, 0, 0), i.setXYZW(s1, r.x, r.y, r.z, r.w);
        }
    }
    boneTransform(e, r) {
        let i = this.skeleton;
        if (i === void 0) return;
        let s1 = this.geometry;
        oN.fromBufferAttribute(s1.attributes.skinIndex, e), aN.fromBufferAttribute(s1.attributes.skinWeight, e), sN.copy(r).applyMatrix4(this.bindMatrix), r.set(0, 0, 0);
        for(let o = 0; o < 4; o++){
            let a = aN.getComponent(o);
            if (a !== 0) {
                let l = oN.getComponent(o);
                lN.multiplyMatrices(i.bones[l].matrixWorld, i.boneInverses[l]), r.addScaledVector(qZ.copy(sN).applyMatrix4(lN), a);
            }
        }
        return r.applyMatrix4(this.bindMatrixInverse);
    }
};
function XZ(n1) {
    if (n1.geometry.attributes.extrudeNormal || !n1.geometry.attributes.position || !n1.geometry.attributes.normal) return;
    let t = new Map, e = n1.geometry.attributes, r = e.position.array, i = e.normal.array, s1 = new Float32Array(r.length);
    for(let o = 0; o < r.length; o += 3){
        let a = `${r[o]}_${r[o + 1]}_${r[o + 2]}`, l = new E(i[o], i[o + 1], i[o + 2]);
        t.has(a) ? t.get(a)?.normals.push(l) : t.set(a, {
            normals: [
                l
            ],
            result: new E
        });
    }
    t.forEach((o, a)=>{
        for (let l of o.normals)o.result.add(l);
        o.result.divideScalar(o.normals.length);
    });
    for(let o = 0; o < r.length; o += 3){
        let a = `${r[o]}_${r[o + 1]}_${r[o + 2]}`, l = t.get(a)?.result;
        l && (s1[o] = l.x, s1[o + 1] = l.y, s1[o + 2] = l.z);
    }
    n1.geometry.setAttribute("extrudeNormal", new Te(s1, 3));
}
function YZ(n1) {
    if (n1.geometry.attributes.extrudeNormals || !n1.geometry.attributes.position) return;
    let e = n1.geometry.attributes.position.array, r = new Float32Array(e.length), i = new E;
    for(let s1 = 0; s1 < e.length; s1 += 3)i.set(e[s1], e[s1 + 1], e[s1 + 2]).normalize(), r[s1] = i.x, r[s1 + 1] = i.y, r[s1 + 2] = i.z;
    n1.geometry.setAttribute("extrudeNormal", new Te(r, 3));
}
function Cf(n1) {
    if (Array.isArray(n1.material)) {
        for (let t of n1.material)if (t.getLayersOfType("outline").length === 0) return;
    } else if (!(n1.material instanceof fn) || n1.material.getLayersOfType("outline").length === 0) return;
    n1 instanceof Ct && n1.is2DAndNoDepth ? YZ(n1) : XZ(n1);
}
function Pf(n1) {
    if (!n1.geometry.attributes.position) return;
    let e = n1.geometry.attributes.position.array, r = new Float32Array(e.length), i = parseInt(n1.uuid.replace(/\D/g, "")), s1 = [
        Se.seededRandom(i),
        Se.seededRandom(i + 1e4),
        Se.seededRandom(i + 2e4)
    ];
    for(let o = 0; o < e.length; o++)r[o] = s1[o % 3];
    n1.geometry.setAttribute("randomColor", new je(r, 3));
}
var ra = new Yt, lg = new E;
function cN(n1) {
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        r.type === "Mesh" && r.geometry.type === "SubdivGeometry" && (t = !0);
    }), t;
}
var lo = class extends Ct {
    constructor(e, r, i){
        super(e, r, i);
        this.data = r;
        this.hiddenMatrixOld = new ue;
        this.smoothShading = !0;
        this.skipReactionUpdate = !1;
    }
    chooseGeoemtryCache(e) {
        return this.dataPatched.flatShading ? e.geometryCache : e.geometryCache2;
    }
    get subdivPointerNew() {
        return this.localGeometry !== void 0 ? this.subdivPointer : this.geometry.ensureSubdivPointer();
    }
    get originalGeometryNew() {
        return this.localGeometry !== void 0 ? this.originalGeometry : this.geometry.originalGeometry;
    }
    get phongAngle() {
        return this.data.geometry.phongAngle ?? 45;
    }
    updateEntityBoxSize(e, r) {
        let i = this.geometry.userData.parameters;
        e.copy(this.originalGeometryNew.boundingSphere.center), r.set(i.width, i.height, i.depth ?? 0).multiplyScalar(.5);
    }
    createGeometryByControls(e) {
        if (this.skipReactionUpdate === !0) return;
        let r = this.localGeometry?.uuid, { originalGeometry: i, subdividedGeometry: s1, subdivPointer: o } = ui.build(e, this.subdivPointer, this.smoothShading, this.hasNonUniformScale ? this.shearScale : void 0);
        this.subdivPointer = o, i !== void 0 && (this.originalGeometry?.dispose(), this.originalGeometry = i), s1 !== void 0 && (this.subdividedGeometry?.dispose(), this.subdividedGeometry = s1 ?? void 0), this.localGeometry = this.subdividedGeometry ?? this.originalGeometry, Cf(this), Pf(this), this.calcBoundingBox(), r && (this.localGeometry.uuid = r);
    }
    updateState(e, r) {
        if (super.updateState(e, r), e.flatShading !== void 0) {
            let i = this.material;
            this.material = Array.isArray(i) ? i.map((s1)=>s1.getFlavor(!1, s1.side, s1.wireframe)) : i.getFlavor(!1, i.side, i.wireframe), this.smoothShading = !e.flatShading, this.createGeometryDelayed(r);
        }
    }
    updateMesh(e = !1) {
        ui.buildLevel(this.subdivPointer, !0, this.smoothShading ? this.phongAngle : -1, this.originalGeometry, e && this.hasNonUniformScale ? this.shearScaleInv : void 0), this.subdividedGeometry && ui.buildLevel(this.subdivPointer, !1, this.smoothShading ? this.phongAngle : -1, this.subdividedGeometry, e && this.hasNonUniformScale ? this.shearScaleInv : void 0);
    }
    updateTopology() {
        this.originalGeometry.dispose(), this.originalGeometry = ui.buildLevel(this.subdivPointer, !0, this.smoothShading ? this.phongAngle : -1), this.subdividedGeometry && (this.subdividedGeometry.dispose(), this.subdividedGeometry = ui.buildLevel(this.subdivPointer, !1, this.smoothShading ? this.phongAngle : -1)), this.localGeometry = this.subdividedGeometry ?? this.originalGeometry;
    }
    raycast(e, r) {
        let i = this.localGeometry;
        this.localGeometry = this.originalGeometryNew, nr.prototype.raycast.call(this, e, r), this.localGeometry = i;
    }
    activateSVDCompensation() {
        !this.hasNonUniformScale || (this.matrix.copy(this.matrixWorldRigid), this.hiddenMatrixOld.copy(this.hiddenMatrix), this.hiddenMatrix.copy(this.parent.matrixWorld).invert());
    }
    deactivateSVDCompensation() {
        !this.hasNonUniformScale || (this.updateMatrix(), this.hasNonUniformScale = void 0, this.hiddenMatrix.copy(this.hiddenMatrixOld));
    }
    calcBoundingBox() {
        let e = this.originalGeometry;
        e.boundingSphere === null && (e.boundingSphere = new ei, this.subdividedGeometry && (this.subdividedGeometry.boundingSphere = e.boundingSphere));
        let r = e.attributes.position, i = e.boundingSphere.center;
        ra.setFromBufferAttribute(r), ra.getCenter(i), e.boundingSphere.radius = i.distanceTo(ra.max), isNaN(e.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this), ra.getSize(lg), this.hasNonUniformScale && lg.divide(this.scale);
        let s1 = {
            width: lg.x,
            height: lg.y,
            depth: lg.z
        };
        return this.geometry.userData.parameters = s1, s1;
    }
    updateBoundingSphere(e) {
        let r = this.originalGeometry;
        ra.min.set(e[0], e[2], e[4]), ra.max.set(e[1], e[3], e[5]), this.hasNonUniformScale && (ra.min.applyMatrix4(this.shearScaleInv), ra.max.applyMatrix4(this.shearScaleInv)), r.boundingSphere === null && (r.boundingSphere = new ei);
        let i = r.boundingSphere.center;
        ra.getCenter(i), r.boundingSphere.radius = i.distanceTo(ra.max);
    }
    freeSubdivPointer() {
        this.subdivPointer && (ui.freeSubdivPointer(this.subdivPointer), this.subdivPointer = 0), this.localGeometry = void 0, this.originalGeometry?.dispose(), this.subdividedGeometry?.dispose();
    }
    dispose() {
        super.dispose(), this.freeSubdivPointer();
    }
    updateByPatchedOpGeometry(e, r, i) {
        super.updateByPatchedOpGeometry(e, r, i), this.localGeometry && this.createGeometryByControls(r);
    }
};
var uN = -1, KZ = 1, hN = {
    x: [
        1,
        0,
        0
    ],
    "-x": [
        -1,
        0,
        0
    ],
    y: [
        0,
        1,
        0
    ],
    "-y": [
        0,
        -1,
        0
    ],
    z: [
        0,
        0,
        1
    ],
    "-z": [
        0,
        0,
        -1
    ]
}, dN = {
    polygon_center: 0,
    edge: 1,
    vertex: 2
}, cg = (n1, t)=>(e, r)=>!t || e === 0 || n1 === 0 ? 0 : n1 * r / 100, bt = (n1, t)=>{
    let e = Math.abs(t), r = e * -1;
    return (n1 - uN) * (e - r) / (KZ - uN) + r;
}, QZ = new E, ab = new E, ZZ = new E, JZ = new E;
function _f(n1, t) {
    let e = ZZ.fromArray(n1), r = JZ.fromArray(t);
    ab.copy(r).sub(e);
    let i = ab.length();
    return ab.normalize().multiplyScalar(i * .5), QZ.copy(e).add(ab).toArray();
}
var Ds = new Or, lb = new E, cb = new E, xu = new E;
function fN(n1) {
    let t = [];
    for(let e = 0; e <= n1.index.count; e++)if (lb.fromArray(n1.index.array, e * 3), Ds.setFromAttributeAndIndices(n1.attributes.position, lb.x, lb.y, lb.z), Ds.getNormal(cb), Ds.getMidpoint(xu), !(isNaN(xu.x) || isNaN(xu.y) || isNaN(xu.z))) {
        let { a: r, b: i, c: s1 } = Ds, o = r.toArray(), a = i.toArray(), l = s1.toArray(), c = r.distanceTo(i), u1 = i.distanceTo(s1), h = s1.distanceTo(r), d = _f(o, a), f = _f(a, l), m = _f(l, o), p = [
            c,
            u1,
            h
        ], g = Math.max(...p), y = p.filter((b)=>Math.round(b) === Math.round(g)).length > 1, x = [], v = Ds.getMidpoint(xu).toArray();
        g === c && !y && (x = [
            f,
            m,
            m
        ], v = d), g === u1 && !y && (x = [
            d,
            m,
            m
        ], v = f), g === h && !y && (x = [
            d,
            f,
            f
        ], v = m), y && (x = [
            d,
            f,
            m
        ]), t.push({
            vertices: [
                o,
                a,
                l
            ],
            faceCenters: x,
            midpoint: v,
            norm: Ds.getNormal(cb).toArray()
        });
    }
    return t;
}
function pN(n1) {
    let t = [], { position: e } = n1.attributes;
    for(let r = 0; r < e.count; r++){
        Ds.setFromAttributeAndIndices(e, r * 3, r * 3 + 1, r * 3 + 2), Ds.getNormal(cb), Ds.getMidpoint(xu);
        let i = Ds.a.toArray(), s1 = Ds.b.toArray(), o = Ds.c.toArray();
        t.push({
            vertices: [
                i,
                s1,
                o
            ],
            faceCenters: [
                _f(i, s1),
                _f(s1, o),
                _f(o, i)
            ],
            midpoint: xu.toArray(),
            norm: cb.toArray()
        });
    }
    return t;
}
var $Z = 4, eJ = .5, VT = (n1)=>.5 * (1 - Math.cos(n1 * Math.PI)), UT = class {
    constructor(){
        this.perlin = new Array(4096);
    }
    noise(t, e = 0, r = 0) {
        if (this.perlin == null) {
            this.perlin = new Array(4096);
            for(let y = 0; y < 4096; y++)this.perlin[y] = Math.random();
        }
        t < 0 && (t = -t), e < 0 && (e = -e), r < 0 && (r = -r);
        let i = Math.floor(t), s1 = Math.floor(e), o = Math.floor(r), a = t - i, l = e - s1, c = r - o, u1, h, d = 0, f = .5, m, p, g;
        for(let y = 0; y < $Z; y++){
            let x = i + (s1 << 4) + (o << 8);
            u1 = VT(a), h = VT(l), m = this.perlin[x & 4095], m += u1 * (this.perlin[x + 1 & 4095] - m), p = this.perlin[x + 16 & 4095], p += u1 * (this.perlin[x + 16 + 1 & 4095] - p), m += h * (p - m), x += 256, p = this.perlin[x & 4095], p += u1 * (this.perlin[x + 1 & 4095] - p), g = this.perlin[x + 16 & 4095], g += u1 * (this.perlin[x + 16 + 1 & 4095] - g), p += h * (g - p), m += VT(c) * (p - m), d += m * f, f *= eJ, i <<= 1, a *= 2, s1 <<= 1, l *= 2, o <<= 1, c *= 2, a >= 1 && (i++, a--), l >= 1 && (s1++, l--), c >= 1 && (o++, c--);
        }
        return d;
    }
    noiseSeed(t) {
        let e = (()=>{
            let o, a;
            return {
                setSeed (l) {
                    a = o = (l ?? Math.random() * 4294967296) >>> 0;
                },
                getSeed () {
                    return o;
                },
                rand () {
                    return a = (1664525 * a + 1013904223) % 4294967296, a / 4294967296;
                }
            };
        })();
        e.setSeed(t), this.perlin = new Array(4096);
        for(let r = 0; r < 4096; r++)this.perlin[r] = e.rand();
    }
}, mN = UT;
var gN = new E, yN = new ue, vN = new Ws;
function kT(n1) {
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        r.type === "Mesh" && (r.geometry.type === "TextGeometry" || r.geometry.type === "InputGeometry") && (t = !0);
    }), t;
}
var cc = class extends Ct {
    constructor(e, r, i){
        super(e, r, i);
        this.data = r;
    }
    get textGeometry() {
        return this.geometry;
    }
    get charWidths() {
        return this.textGeometry.charWidths;
    }
    get charCoords() {
        return this.textGeometry.charCoords;
    }
    get wrappedText() {
        return this.textGeometry.wrappedText;
    }
    get font() {
        return this.textGeometry.font;
    }
    get initialOffsetY() {
        let e = this.dataPatched;
        return this.font?.getLineInitialOffsetY(this.lineHeight, this.wrappedText.length, typeof e.geometry.height == "number" ? e.geometry.height : 1, this.fontScale, e.geometry.verticalAlign) ?? 0;
    }
    get fontScale() {
        let e = this.dataPatched;
        return this.font ? e.geometry.fontSize / this.font.unitsPerEm : 1;
    }
    get AD() {
        return Math.abs(this.ascender - this.descender);
    }
    get ascender() {
        return (this.font?.ascender ?? 1) * this.fontScale;
    }
    get descender() {
        return (this.font?.descender ?? 1) * this.fontScale;
    }
    get lineHeight() {
        let e = this.dataPatched;
        return e.geometry.fontSize * e.geometry.lineHeight;
    }
    raycast(e, r) {
        let { matrixWorld: i } = this;
        if (!(isNaN(e.ray.origin.x) || this.scale.x === 0 || this.scale.y === 0 || this.scale.z === 0) && (yN.copy(i).invert(), vN.copy(e.ray).applyMatrix4(yN), vN.intersectBox(this.singleBBox, gN))) {
            let s1 = gN.applyMatrix4(i), o = e.ray.origin.distanceTo(s1);
            r.push({
                distance: o,
                point: s1.clone(),
                object: this
            });
        }
    }
};
var In = 1e-4, ia, SN, wN, AN, xN = new E, bN = new E;
Ox.then((n1)=>{
    ia = n1, SN = [
        ia.get_face_center,
        ia.get_edge_midpoint,
        ia.get_vertex_position
    ], wN = [
        ia.get_face_normal,
        ia.get_edge_normal,
        ia.get_vertex_normal
    ], AN = [
        ia.face_count,
        ia.edge_count,
        ia.vertex_count
    ];
});
var tJ = new ue, rJ = new ue, uc = new E, ub = new E, ug = new E, zT = new E, iJ = new E, nJ = new E;
function jr(n1, t) {
    return [
        typeof n1?.[0] == "number" ? n1[0] : typeof n1?.[0] == "string" && t ? parseFloat(String(t.shared.getVariable(n1[0]) ?? "0")) : 0,
        typeof n1?.[1] == "number" ? n1[1] : typeof n1?.[1] == "string" && t ? parseFloat(String(t.shared.getVariable(n1[1]) ?? "0")) : 0,
        typeof n1?.[2] == "number" ? n1[2] : typeof n1?.[2] == "string" && t ? parseFloat(String(t.shared.getVariable(n1[2]) ?? "0")) : 0
    ];
}
var GT = class {
    constructor(t, e){
        this.data = t;
        this.is3D = e;
        this.perlin = new mN;
        t.noiseType === "perlin" ? (this.perlin.noiseSeed(t.seed), e ? this.noise = (i, s1, o)=>this.perlin.noise(i, s1, o) : this.noise = (i)=>this.perlin.noise(i)) : e ? this.noise = e3((0, hb.default)(t.seed)) : this.noise = $R((0, hb.default)(t.seed ?? ""));
    }
}, Ai = class extends Ud(Dt) {
    constructor(e, r){
        super();
        this.parameters = r;
        this.objectForSample = void 0;
        this._pendingMediaLoad = !1;
        this.random = null;
        this.object = e;
    }
    resetOnMove() {
        this.removeFromParent(), this.parent = null;
    }
    expandClones(e) {
        if (this.parent === null) this.updateState(this.parameters, e);
        else for (let r of this.children)r instanceof Lr && r.expand();
    }
    invalidateTransform(e) {
        this.matrixWorldNeedsUpdate = !0, this.traverse((r)=>{
            r instanceof Lr && r.object === e && (r.matrixWorldNeedsUpdate = !0);
        });
    }
    onObjUpdateMatrix() {
        this.parameters.type !== "toObject" && (this.matrixWorldNeedsUpdate = !0);
    }
    update(e) {
        switch(this._updateCount(e), this.parameters.type){
            case "radial":
                this._updateRadial(this.parameters, e);
                break;
            case "linear":
                this._updateLinear(this.parameters, e);
                break;
            case "grid":
                this._updateGrid(this.parameters, e);
                break;
            case "toObject":
                this._updateToObject(this.parameters, e);
        }
        for (let r of this.children)r.updateMatrix(), r.hasNonUniformScale && (r.updateMatrixWorld(), r.updateMatrixWorldSVD());
    }
    _updateCount(e, r) {
        let i;
        if (r !== void 0) i = r;
        else {
            let s1 = jr(this.parameters.grid.count, e);
            i = this.parameters.type === "grid" ? Math.round(s1[0]) * Math.round(s1[1]) * Math.round(s1[2]) : this.parameters.count;
        }
        if (this.parameters.type === "toObject") {
            if (!this.parameters.toObject.object) i = 0;
            else if (r === void 0 && this.parameters.toObject.spreadType !== "random") return;
        }
        if (this.parameters.type === "toObject" && this.objectForSample) {
            let s1 = this.children;
            if (s1.length === i) return;
            if (s1.length < i) for(let o = 0, a = i - s1.length; o < a; ++o){
                let l = new Lr(this.object);
                l.expand(), this.add(l);
            }
            else for(let o = 0, a = s1.length - i; o < a; ++o)this.remove(s1[o]);
        } else {
            if (this.children.length === i) return;
            if (this.children.length < i) for(let s1 = 0, o = i - this.children.length; s1 < o; ++s1){
                let a = new Lr(this.object);
                a.expand(), this.add(a);
            }
            else for(let s1 = 0, o = this.children.length - i; s1 < o; ++s1)this.remove(this.children[s1]);
        }
    }
    getRandom(e, r = !1) {
        return (this.random === null || this.random.data.seed !== e.seed || this.random.is3D !== r) && (this.random = new GT(e, r)), this.random;
    }
    _updateRadial(e, r) {
        let i = e.radial, s1 = i.start * Se.DEG2RAD, o = i.end * Se.DEG2RAD, a = s1 - o, l = jr(i.rotation, r), c = new Jt(l[0], l[1], l[2]), u1;
        switch(i.axis){
            case "z":
                u1 = new E(0, 0, 1);
                break;
            case "y":
                u1 = new E(0, 1, 0);
                break;
            default:
            case "x":
                u1 = new E(1, 0, 0);
                break;
        }
        let h = e.randomnessObject ?? Bo.defaultData([
            1,
            1,
            1
        ]).randomnessObject, d = this.getRandom(h), f = cg(h.strength, this.parameters.randomness);
        for (let [m, p] of this.children.entries()){
            let g = m * (h.freqScale / 10) + h.movement, y = d.noise(g, g, g), x = m + 1, v = jr(i.scale, r), b = jr(h.scale, r);
            p.scale.x = v[0] + f(x, bt(y, b[0])) || In, p.scale.y = v[1] + f(x, bt(y, b[1])) || In, p.scale.z = v[2] + f(x, bt(y, b[2])) || In, p.position.setScalar(0);
            let w = a / e.count * m - s1;
            switch(i.axis){
                case "x":
                    p.rotation.set(0, w, 0);
                    break;
                case "y":
                    p.rotation.set(0, 0, w);
                    break;
                case "z":
                    p.rotation.set(w, 0, 0);
                    break;
            }
            p.translateOnAxis(u1, i.radius);
            let A = jr(i.position, r), T = jr(h.position, r);
            p.position.x += A[0] + f(x, bt(y, T[0])), p.position.y += A[1] + f(x, bt(y, T[1])), p.position.z += A[2] + f(x, bt(y, T[2]));
            let S = jr(h.rotation, r), M = f(x, bt(y, S[0])), C = f(x, bt(y, S[1])), P = f(x, bt(y, S[2]));
            i.alignment === !0 ? (p.rotation.x += c.x + M, p.rotation.y += c.y + C, p.rotation.z += c.z + P) : p.rotation.set(c.x + M, c.y + C, c.z + P);
        }
    }
    _updateLinear(e, r) {
        if (e.type !== "linear") throw new Error;
        let i = e.linear, s1 = jr(i.rotation, r), o = jr(i.scale, r), a = jr(i.position, r), l = new Jt(s1[0] ?? 0, s1[1] ?? 0, s1[2] ?? 0), c = e.randomnessObject ?? Bo.defaultData([
            1,
            1,
            1
        ]).randomnessObject, u1 = jr(c.rotation, r), h = jr(c.scale, r), d = jr(c.position, r), f = this.getRandom(c), m = cg(c.strength, this.parameters.randomness);
        for (let [p, g] of this.children.entries()){
            let y = p * (c.freqScale / 10) + c.movement, x = f.noise(y, y, y), v = p + 1, b = m(v, bt(x, u1[0])), w = m(v, bt(x, u1[1])), A = m(v, bt(x, u1[2]));
            g.scale.x = 1 + (o[0] - 1) * p + m(v, bt(x, h[0])) || In, g.scale.y = 1 + (o[1] - 1) * p + m(v, bt(x, h[1])) || In, g.scale.z = 1 + (o[2] - 1) * p + m(v, bt(x, h[2])) || In, g.rotation.x = l.x * p + b, g.rotation.y = l.y * p + w, g.rotation.z = l.z * p + A, g.position.x = a[0] * p + m(v, bt(x, d[0])), g.position.y = a[1] * p + m(v, bt(x, d[1])), g.position.z = a[2] * p + m(v, bt(x, d[2]));
        }
    }
    _updateGrid(e, r) {
        let i = 0, s1 = e.grid, o = e.randomnessObject ?? Bo.defaultData([
            1,
            1,
            1
        ]).randomnessObject, a = jr(o.scale, r), l = jr(o.rotation, r), c = jr(o.position, r), u1 = this.getRandom(o, !0), h = cg(o.strength, this.parameters.randomness), d = jr(s1.count, r), f = jr(s1.size, r);
        if (s1.useCenter === !0) {
            let m = {
                x: d[0] % 2 === 0 ? 2 : 1,
                y: d[1] % 2 === 0 ? 2 : 1,
                z: d[2] % 2 === 0 ? 2 : 1
            }, p = new E(f[0] * (d[0] - m.x) * .5, f[1] * (d[1] - m.y) * .5, f[2] * (d[2] - m.z) * .5);
            for(let g = 0; g < d[0]; g++)for(let y = 0; y < d[1]; y++)for(let x = 0; x < d[2]; x++){
                let v = u1.noise((g + 1) * (o.freqScale / 10) + o.movement, (y + 1) * (o.freqScale / 10) + o.movement, (x + 1) * (o.freqScale / 10) + o.movement), b = this.children[i++];
                if (!b) continue;
                b.scale.x = 1 + h(i, bt(v, a[0])) || In, b.scale.y = 1 + h(i, bt(v, a[1])) || In, b.scale.z = 1 + h(i, bt(v, a[2])) || In;
                let w = h(i, bt(v, l[0])), A = h(i, bt(v, l[1])), T = h(i, bt(v, l[2]));
                b.rotation.set(w, A, T), b.position.x = f[0] * g - p.x + h(i, bt(v, c[0])), b.position.y = f[1] * y - p.y + h(i, bt(v, c[1])), b.position.z = f[2] * x - p.z + h(i, bt(v, c[2]));
            }
        } else for(let m = 0; m < d[0]; m++)for(let p = 0; p < d[1]; p++)for(let g = 0; g < d[2]; g++){
            let y = u1.noise((m + 1) * (o.freqScale / 10) + o.movement, (p + 1) * (o.freqScale / 10) + o.movement, (g + 1) * (o.freqScale / 10) + o.movement), x = this.children[i++];
            if (!x) continue;
            x.scale.x = 1 + h(i, bt(y, a[0])) || In, x.scale.y = 1 + h(i, bt(y, a[1])) || In, x.scale.z = 1 + h(i, bt(y, a[2])) || In;
            let v = h(i, bt(y, l[0])), b = h(i, bt(y, l[1])), w = h(i, bt(y, l[2]));
            x.rotation.set(v, b, w), x.position.x = f[0] * m + h(i, bt(y, c[0])), x.position.y = -f[1] * p + h(i, bt(y, c[1])), x.position.z = -f[2] * g + h(i, bt(y, c[2]));
        }
    }
    _updateToObject(e, r) {
        if (e.type !== "toObject") throw new Error;
        let { toObject: i } = e, s1 = jr(i.rotation, r), o = jr(i.position, r), a = jr(i.scale, r), l = new Jt(s1[0], s1[1], s1[2]), c = e.randomnessObject ?? Bo.defaultData([
            1,
            1,
            1
        ]).randomnessObject, u1 = jr(c.rotation, r), h = jr(c.position, r), d = jr(c.scale, r), f = this.getRandom(c), m = cg(c.strength, this.parameters.randomness);
        if (!i.object) {
            for (let [, v] of this.children.entries())v.position.set(0, 0, 0), v.scale.setScalar(1), v.rotation.set(0, 0, 0);
            this.objectForSample = void 0;
            return;
        }
        if (!this.objectForSample) return;
        if (this.objectForSample instanceof cc) {
            if (!this.objectForSample.font?.isLoaded || this.objectForSample.geometry.attributes.position === void 0) {
                this._pendingMediaLoad = !0;
                return;
            } else this._pendingMediaLoad = !1;
        }
        if (this.objectForSample.geometry === void 0 && this.objectForSample.isAncestorOf(this.object.uuid)) {
            console.warn(`Oh no! The object "${this.object.name}" (${this.object.uuid}) seem to be a child/descendant of the object it's being cloned to. Please re-parent it so that they are siblings instead.`);
            return;
        }
        let p = this.getSubdivData();
        if (p.length > 0) {
            let v = Math.round(p.length * i.count / 100);
            this._updateCount(r, v);
        } else {
            let v = this.objectForSample.geometry.getAttribute("position");
            if (!v || isNaN(v.count) || v.count === 0) {
                console.warn(`Oh no! The object "${this.object.name}" (${this.object.uuid}) cannot be cloned on the surface of "${this.objectForSample.name}" (${this.objectForSample.uuid}) because the latter does not have a valid geometry.`);
                return;
            }
        }
        this.objectForSample.updateMatrixWorld();
        let g = new px(this.objectForSample).build(), y = hN[i.axis], x = this.children;
        g.setRandomGenerator((0, hb.default)(this.object.uuid + i.seed));
        for (let [v, b] of x.entries()){
            let w = v * (c.freqScale / 10) + c.movement, A = f.noise(w, w, w), T = v + 1, S = m(T, bt(A, u1[0])), M = m(T, bt(A, u1[1])), C = m(T, bt(A, u1[2]));
            i.spreadType === "random" ? g.sample(ug, zT) : (p.length && (ug.fromArray(p[v].pos), zT.fromArray(p[v].norm)), this.objectForSample instanceof lo && ug.applyMatrix4(tJ.copy(this.objectForSample.matrixWorld).invert())), ug.applyMatrix4(this.object.hiddenMatrix.clone().invert()), b.position.copy(ug), uc.fromArray(y);
            let P = i.align === "normal" ? zT : this.object.getWorldDirection(nJ), _ = ub.fromArray(o);
            ub.x += m(T, bt(A, h[0])), ub.y += m(T, bt(A, h[1])), ub.z += m(T, bt(A, h[2]));
            let I = Math.acos(P.dot(uc)), O = iJ.crossVectors(uc, P).normalize(), L = rJ.makeRotationAxis(O, I), j = P.clone().cross(this.object.up).normalize(), V = j.clone().cross(P).normalize(), H = new ue().makeBasis(j, P, V), q = new E(uc.y, uc.z, uc.x).normalize(), X = q.clone().cross(uc).normalize(), K = new ue().makeBasis(q, uc, X).invert(), z = new ue().multiplyMatrices(H, K);
            b.rotation.setFromRotationMatrix(z), _.applyMatrix4(L), b.position.add(_), b.rotation.x = b.rotation.x + l.x + S, b.rotation.y = b.rotation.y + l.y + M, b.rotation.z = b.rotation.z + l.z + C, b.scale.setScalar(1), b.scale.x = b.scale.x + a[0] + m(T, bt(A, d[0])) || In, b.scale.y = b.scale.y + a[1] + m(T, bt(A, d[1])) || In, b.scale.z = b.scale.z + a[2] + m(T, bt(A, d[2])) || In, b.scale.multiply(this.object.scale), b.hiddenMatrix = this.object.hiddenMatrix;
        }
    }
    getSubdivData() {
        if (!this.objectForSample) return [];
        let e = this.parameters.toObject.spreadType, r = new Map, i = (o, a)=>{
            let l = Math.round(o[0] * 1e4) + "_" + Math.round(o[1] * 1e4) + "_" + Math.round(o[2] * 1e4), c = r.get(l);
            c ? (c.pos[0] += o[0], c.pos[1] += o[1], c.pos[2] += o[2], c.norm[0] += a[0], c.norm[1] += a[1], c.norm[2] += a[2], c.count += 1) : r.set(l, {
                pos: [
                    ...o
                ],
                norm: [
                    ...a
                ],
                count: 1
            });
        };
        if (e === "random") return [];
        if (this.objectForSample instanceof lo) {
            let o = this.objectForSample, a = dN[e], l = AN[a], c = SN[a], u1 = wN[a], h = l(o.subdivPointerNew);
            for(let d = 0; d <= h - 1; d++){
                let f = c(o.subdivPointerNew, d), m = u1(o.subdivPointerNew, d);
                xN.fromArray(f).applyMatrix4(o.matrixWorld), bN.fromArray(m), i(xN.toArray(), bN.toArray());
            }
        } else (this.objectForSample.geometry.index ? fN(this.objectForSample.geometry) : pN(this.objectForSample.geometry)).forEach((a, l)=>{
            e === "polygon_center" && i(a.midpoint, a.norm), e === "vertex" && (i(a.vertices[0], a.norm), i(a.vertices[1], a.norm), i(a.vertices[2], a.norm)), e === "edge" && (i(a.faceCenters[0], a.norm), i(a.faceCenters[1], a.norm), i(a.faceCenters[2], a.norm));
        });
        let s1 = Array.from(r.values());
        for (let o of s1)o.pos[0] /= o.count, o.pos[1] /= o.count, o.pos[2] /= o.count, o.norm[0] /= o.count, o.norm[1] /= o.count, o.norm[2] /= o.count;
        return s1;
    }
    updateState(e, r) {
        if (this.parameters = Ra(e), this.parameters.type !== "toObject") (this.parent === null || this.parent !== this.object) && (this.removeFromParent(), this.object.parent?.add(this), this.matrix = this.object.matrix, this.hiddenMatrix = this.object.hiddenMatrix, this.matrixWorldNeedsUpdate = !0, this.matrixAutoUpdate = !1);
        else if (this.parent === null || this.parent.uuid !== this.parameters.toObject.object) {
            this.removeFromParent();
            let i = r.scene.find(this.parameters.toObject.object);
            i instanceof nr ? this.objectForSample = i : this.objectForSample = void 0, this.matrix = new ue, this.hiddenMatrix = new ue, this.matrixWorldNeedsUpdate = !0, this.matrixAutoUpdate = !1, i && i.add(this);
        }
        this.update(r);
    }
    get pendingMediaLoad() {
        return this._pendingMediaLoad;
    }
};
var na = (n1)=>{
    var t;
    return t = class extends n1 {
    }, t.geometryHelper = new bi(30, 30, 30), t;
};
var db = new Ws, jT = new ei, EN = new ue, sa = (n1, t, e, r, i = !1, s1 = n1)=>{
    let o = t, a = s1.matrixWorld;
    if (o.boundingSphere === null && o.computeBoundingSphere(), jT.copy(o.boundingSphere), jT.applyMatrix4(a), e.ray.intersectsSphere(jT) === !1 || (EN.copy(a).invert(), db.copy(e.ray).applyMatrix4(EN), o.boundingBox !== null && db.intersectsBox(o.boundingBox) === !1)) return;
    let l, c, u1, h, d = o.index, f = o.attributes.position, m = o.drawRange, p, g;
    if (i === !1) {
        let x = Math.max(0, m.start), v = Math.min(d.count, m.start + m.count);
        for(p = x, g = v; p < g; p += 3)if (c = d.getX(p), u1 = d.getX(p + 1), h = d.getX(p + 2), l = y(n1, e, db, f, c, u1, h), l) {
            l.faceIndex = Math.floor(p / 3), r.push(l);
            return;
        }
    } else {
        let v = o.attributes.position, b = new E, w = new E, A = new E, T = new E, S = 2, C = 1 / ((s1.scale.x + s1.scale.y + s1.scale.z) / 3), P = C * C, _ = Math.max(0, m.start), I = Math.min(v.count, m.start + m.count);
        for(let O = _, L = I - 1; O < L; O += S){
            if (b.fromBufferAttribute(v, O), w.fromBufferAttribute(v, O + 1), db.distanceSqToSegment(b, w, T, A) > P) continue;
            T.applyMatrix4(s1.matrixWorld);
            let V = e.ray.origin.distanceTo(T);
            V < e.near || V > e.far || r.push({
                distance: V,
                point: A.clone().applyMatrix4(s1.matrixWorld),
                object: n1
            });
        }
    }
    function y(x, v, b, w, A, T, S) {
        let M = new E, C = new E, P = new E, _ = new E, I = new E;
        if (M.fromBufferAttribute(w, A), C.fromBufferAttribute(w, T), P.fromBufferAttribute(w, S), b.intersectTriangle(M, C, P, !1, _) === null) return null;
        I.copy(_), I.applyMatrix4(x.matrixWorld);
        let L = v.ray.origin.distanceTo(I);
        return L < v.near || L > v.far ? null : {
            faceIndex: 1,
            distance: L,
            point: I.clone(),
            object: x
        };
    }
};
var fb = new E, Os = new bn, HT = class extends wl {
    constructor(e){
        let r = new Ce, i = new ms({
            color: 16777215,
            vertexColors: !0,
            toneMapped: !1
        }), s1 = [], o = [], a = {}, l = new Ge(15711266), c = new Ge(15711266), u1 = new Ge(2857471);
        h("n1", "n2", l), h("n2", "n4", l), h("n4", "n3", l), h("n3", "n1", l), h("f1", "f2", l), h("f2", "f4", l), h("f4", "f3", l), h("f3", "f1", l), h("n1", "f1", l), h("n2", "f2", l), h("n3", "f3", l), h("n4", "f4", l), h("p", "n1", c), h("p", "n2", c), h("p", "n3", c), h("p", "n4", c), h("u1", "u2", u1), h("u2", "u3", u1), h("u3", "u1", u1);
        function h(f, m, p) {
            d(f, p), d(m, p);
        }
        function d(f, m) {
            s1.push(0, 0, 0), o.push(m.r, m.g, m.b), a[f] === void 0 && (a[f] = []), a[f].push(s1.length / 3 - 1);
        }
        r.setAttribute("position", new Te(s1, 3)), r.setAttribute("color", new Te(o, 3));
        super(r, i);
        this.type = "CameraHelper", this.camera = e, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = a, this.update();
    }
    update() {
        let e = this.geometry, r = this.pointMap, i = !0;
        Os.projectionMatrixInverse.elements = [
            .5112609807824982,
            -0,
            -0,
            -0,
            -0,
            .41421356237309503,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0.099999,
            -0,
            -0,
            -1.0000000000000002,
            .100001
        ];
        let s1 = 1, o = 1, a = i ? .8 : 1e-4;
        co("n1", r, e, Os, -s1, -o, a), co("n2", r, e, Os, s1, -o, a), co("n3", r, e, Os, -s1, o, a), co("n4", r, e, Os, s1, o, a);
        let l = a;
        co("f1", r, e, Os, -s1, -o, l), co("f2", r, e, Os, s1, -o, l), co("f3", r, e, Os, -s1, o, l), co("f4", r, e, Os, s1, o, l);
        let c = l, u1 = .5;
        co("u1", r, e, Os, s1 * .7 * u1, o * 1.1, c), co("u2", r, e, Os, -s1 * .7 * u1, o * 1.1, c), co("u3", r, e, Os, 0, o * (1.1 + .9 * u1), c), e.getAttribute("position").needsUpdate = !0;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
function co(n1, t, e, r, i, s1, o) {
    fb.set(i, s1, o).unproject(r);
    let a = t[n1];
    if (a !== void 0) {
        let l = e.getAttribute("position");
        for(let c = 0, u1 = a.length; c < u1; c++)l.setXYZ(a[c], fb.x, fb.y, fb.z);
    }
}
var pb = class extends na(HT) {
    constructor(e){
        super(e);
        this.object = e;
        this.object = e, this.name = `CombinedCameraHelper: ${e.uuid}`;
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e), this.updateTarget();
    }
    updateTarget() {
        let e = this.object.getTarget();
        this.updateWorldMatrix(!0, !1), this.worldToLocal(e);
    }
    raycast(e, r) {
        sa(this.object, this.geometry, e, r, !0);
    }
};
var mb;
((t)=>t.is = (e)=>"objectHelper" in e)(mb || (mb = {}));
var Rs = (n1, t)=>class extends zd(n1) {
        constructor(){
            super(...arguments);
            this.objectHelper = new t(this);
            this.gizmos = {};
        }
        get geometryHelper() {
            return t.geometryHelper;
        }
        raycast(i, s1) {
            this.objectHelper.raycast(i, s1);
        }
        showGizmos() {
            for(let i in this.gizmos){
                let s1 = this.gizmos[i];
                s1 instanceof Il && (s1.visible = !0);
            }
        }
        updateEntityBoxSize(i, s1) {
            this.objectHelper.visible && this.geometryHelper instanceof bi ? (i.setScalar(0), s1.set(this.geometryHelper.parameters.width, this.geometryHelper.parameters.height, this.geometryHelper.parameters.height).multiplyScalar(.5)) : super.updateEntityBoxSize(i, s1);
        }
        hideGizmos() {
            for(let i in this.gizmos){
                let s1 = this.gizmos[i];
                s1 instanceof Il && (s1.visible = !1);
            }
        }
    };
var gb = 790, If = new E, WT = new E, qT = new Ye, XT = new E, hg = new E, YT = new E, ir = class extends Rs(bn, pb) {
    constructor(e = "", r = {
        ...ru.defaultData,
        name: ""
    }){
        super();
        this._cameraType = "OrthographicCamera";
        this.targetOffset = jl.DefaultTargetOffset;
        this.isUpVectorFlipped = !1;
        this.angleOffsetFromUp = 0;
        this.wasMovedByUser = !1;
        this.wasMovedBySwitchCameraAction = !1;
        this.super_Entity(e, r), this.previousProjectionMatrix = new ue, this.matrixAutoUpdate = !0, this.width = window.innerWidth, this.height = window.innerHeight;
        let i = this.width, s1 = this.height;
        this.orthoCamera = new bl(i * -0.5, i * .5, s1 * .5, s1 * -0.5, -50000, 1e4), this.perspCamera = new si(45, i / s1, 50, 1e4), this.left = this.orthoCamera.left, this.right = this.orthoCamera.right, this.top = this.orthoCamera.top, this.bottom = this.orthoCamera.bottom, this.far = this.orthoCamera.far, this.view = this.orthoCamera.view, this.aspect = this.perspCamera.aspect, this.focus = this.perspCamera.focus, this.filmGauge = this.perspCamera.filmGauge, this.filmOffset = this.perspCamera.filmOffset, this.objectHelper.update();
    }
    get isPerspectiveCamera() {
        return this.cameraType === "PerspectiveCamera";
    }
    get isOrthographicCamera() {
        return !this.isPerspectiveCamera;
    }
    get cameraType() {
        return this._cameraType;
    }
    set fov(e) {
        this.perspCamera.fov = e;
    }
    get fov() {
        return this.perspCamera.fov;
    }
    setNear(e, r) {
        e === "PerspectiveCamera" ? this.perspCamera.near = r : this.orthoCamera.near = r;
    }
    setZoom(e, r) {
        r >= 0 && (e === "PerspectiveCamera" ? this.perspCamera.zoom = r : this.orthoCamera.zoom = r);
    }
    set cameraType(e) {
        e === "PerspectiveCamera" ? this.toPerspective() : e === "OrthographicCamera" && this.toOrthographic();
    }
    get near() {
        return this._cameraType === "PerspectiveCamera" ? this.perspCamera.near : this.orthoCamera.near;
    }
    set near(e) {
        this._cameraType === "PerspectiveCamera" ? this.perspCamera.near = e : this.orthoCamera.near = e;
    }
    get zoom() {
        return this._cameraType === "PerspectiveCamera" ? this.perspCamera.zoom : this.orthoCamera.zoom;
    }
    set zoom(e) {
        e >= 0 && (this._cameraType === "PerspectiveCamera" ? this.perspCamera.zoom = e : this.orthoCamera.zoom = e);
    }
    lookAt(e, r, i) {
        typeof e == "number" && (e = new E(e, r, i)), super.lookAt(e), this.getWorldPosition(If), this.targetOffset = If.distanceTo(e);
    }
    getTarget(e = new E) {
        return this.getWorldDirection(WT), this.getWorldPosition(If), WT.multiplyScalar(this.targetOffset), e.copy(If).add(WT), e;
    }
    getDistanceToTarget() {
        let e = this.getTarget();
        return this.getWorldPosition(If), If.distanceTo(e);
    }
    updateUp() {
        this.getWorldQuaternion(qT), XT.set(0, 0, 1).applyQuaternion(qT), hg.copy(Dt.DEFAULT_UP), this.isUpVectorFlipped && hg.negate(), hg.applyQuaternion(qT), YT.copy(Dt.DEFAULT_UP).projectOnPlane(XT), this.angleOffsetFromUp = YT.angleTo(hg), this.angleOffsetFromUp *= YT.cross(hg).dot(XT) >= 0 ? 1 : -1;
    }
    updateTransformState(e, r) {
        let i = super.updateTransformState(e, r);
        return e.isUpVectorFlipped !== void 0 && (this.isUpVectorFlipped = e.isUpVectorFlipped), this.updateUp(), i;
    }
    getViewFrontToObject(e) {
        let r = e.getWorldPosition(new E), s1 = e.getWorldDirection(new E).multiplyScalar(this.targetOffset);
        return {
            position: r.clone().add(s1),
            target: r
        };
    }
    getViewToTarget(e) {
        let i = this.getWorldDirection(new E).multiplyScalar(this.targetOffset);
        return {
            position: e.clone().sub(i),
            target: e
        };
    }
    getViewToObject(e) {
        let r = new E;
        return e.getWorldPosition(r), this.getViewToTarget(r);
    }
    setViewplaneSize(e, r, i = !1) {
        if (this.aspect = e / r, i) {
            let s1 = e > r ? this.aspect : 1, o = e > r ? 1 : this.aspect;
            this.left = -gb * .5 * s1, this.right = gb * .5 * s1, this.top = gb * .5 * (1 / o), this.bottom = -gb * .5 * (1 / o);
        } else this.left = -e * .5, this.right = e * .5, this.top = r * .5, this.bottom = -r * .5;
        this.updateProjectionMatrix();
    }
    copyViewPlaneSize(e) {
        this.aspect = e.aspect, this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.updateProjectionMatrix();
    }
    toOrthographic() {
        this.orthoCamera.left = this.left, this.orthoCamera.right = this.right, this.orthoCamera.top = this.top, this.orthoCamera.bottom = this.bottom, this.orthoCamera.view = this.view, this.orthoCamera.far = this.far, this.orthoCamera.updateProjectionMatrix(), this.projectionMatrix = this.orthoCamera.projectionMatrix, this.projectionMatrixInverse = this.orthoCamera.projectionMatrixInverse, this._cameraType = "OrthographicCamera", this.objectHelper && this.objectHelper.update();
    }
    toPerspective() {
        this.perspCamera.aspect = this.aspect, this.perspCamera.fov = this.fov, this.perspCamera.view = this.view, this.perspCamera.far = this.far, this.perspCamera.updateProjectionMatrix(), this.projectionMatrix = this.perspCamera.projectionMatrix, this.projectionMatrixInverse = this.perspCamera.projectionMatrixInverse, this._cameraType = "PerspectiveCamera", this.objectHelper && this.objectHelper.update();
    }
    setFocalLength(e) {
        this.perspCamera.setFocalLength(e), this.toPerspective();
    }
    getFocalLength() {
        return this.perspCamera.getFocalLength();
    }
    getEffectiveFOV() {
        return this.perspCamera.getEffectiveFOV();
    }
    getFilmWidth() {
        return this.perspCamera.getFilmWidth();
    }
    getFilmHeight() {
        return this.perspCamera.getFilmHeight();
    }
    setViewOffset(e, r, i, s1, o, a) {
        this._cameraType === "PerspectiveCamera" ? this.perspCamera.setViewOffset(e, r, i, s1, o, a) : this.orthoCamera.setViewOffset(e, r, i, s1, o, a);
    }
    clearViewOffset() {
        this._cameraType === "PerspectiveCamera" ? (this.perspCamera.clearViewOffset(), this.toPerspective()) : (this.orthoCamera.clearViewOffset(), this.toOrthographic());
    }
    copyHistory() {
        this.previousProjectionMatrix && this.previousProjectionMatrix.copy(this.projectionMatrix);
    }
    updateProjectionMatrix() {
        this._cameraType === "PerspectiveCamera" ? this.toPerspective() : this._cameraType === "OrthographicCamera" && this.toOrthographic();
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(e, r) {
        super.updateWorldMatrix(e, r), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    copy(e, r) {
        return super.copy(e, r), this.parent = e.parent, this.orthoCamera.copy(e.orthoCamera), this.perspCamera.copy(e.perspCamera), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.far = e.far, this.view = e.view === null ? null : Object.assign({}, e.view), this._cameraType = e._cameraType, this.aspect = e.aspect, this.fov = e.fov, this.focus = e.focus, this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this.targetOffset = e.targetOffset, this.updateProjectionMatrix(), this;
    }
    toCameraState(e = []) {
        let r = {
            type: this.cameraType,
            far: this.far,
            orthographic: {
                near: this.orthoCamera.near,
                zoom: this.orthoCamera.zoom
            },
            perspective: {
                near: this.perspCamera.near,
                fov: this.perspCamera.fov,
                zoom: this.perspCamera.zoom
            },
            up: this.up.toArray(),
            targetOffset: this.targetOffset,
            isUpVectorFlipped: this.isUpVectorFlipped
        };
        return Kh(r, e);
    }
    updateCameraSubtype(e, r) {
        let i = e === "perspective" ? "PerspectiveCamera" : "OrthographicCamera";
        r.zoom !== void 0 && this.setZoom(i, r.zoom), r.near !== void 0 && this.setNear(i, r.near), r.fov !== void 0 && i === "PerspectiveCamera" && (this.fov = r.fov);
    }
    updateState(e, r) {
        this.updateCameraState(e, r);
    }
    updateCameraState(e, r) {
        this.updateState_Entity(e, r), e.far !== void 0 && (this.far = e.far), e.orthographic !== void 0 && this.updateCameraSubtype("orthographic", e.orthographic), e.perspective !== void 0 && this.updateCameraSubtype("perspective", e.perspective), e.type !== void 0 && (this.cameraType = e.type), e.up !== void 0 && this.up.fromArray(e.up.map((i)=>typeof i == "number" ? i : 0)), e.targetOffset !== void 0 && (this.targetOffset = e.targetOffset), e.isUpVectorFlipped !== void 0 && (this.isUpVectorFlipped = e.isUpVectorFlipped), this.updateProjectionMatrix();
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), e.path.length === 1 && e.type === 0 && this.updateCameraSubtype(e.path[0], e.props);
    }
    toState(e) {
        return {
            ...super.toState(e),
            ...this.toCameraState(e),
            type: this.cameraType
        };
    }
};
var Df = new ue, aJ = new ue;
function KT(n1) {
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        r.geometry?.type === "BooleanGeometry" && (t = !0);
    }), t;
}
var Hn = class extends _n {
    constructor(e, r, i){
        super(e, r);
        this.data = r;
        this.meshSetAddresses = [];
        this.needsTransformForDownstream = !1;
        this.geometry = new Ce;
        this.onAfterRender = (e, r, i, s1, o, a)=>{
            super.onAfterRender(e, r, i, s1, o, a), this.recomputeBoolean();
        };
        this.geometry.userData.parameters = {
            width: 0,
            height: 0,
            depth: 0
        };
    }
    get booleanOp() {
        return this.data.geometry.operation;
    }
    get phongAngle() {
        return this.data.geometry.phongAngle ?? 45;
    }
    get isLOD() {
        return this.recomputeBoolean(), !1;
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), e.path.length === 1 && e.path[0] === "geometry" && e.type === 0 && e.props.operation !== void 0 && (this.freeBooleanPointer(), this.resetBBoxNeedsUpdate());
    }
    freeBooleanPointer() {
        super.freeBooleanPointer(), this.geometry.dispose();
    }
    recomputeBoolean(e, r = !0) {
        if (this.booleanMeshSetAddress !== -1 && !e) return;
        for(let s1 = 0; s1 < this.children.length; s1++){
            let o = this.children[s1];
            o instanceof Hn && o.dataPatched.visible === !0 && o.recomputeBoolean(e === !0, r);
        }
        this.meshSetAddresses = [];
        for(let s1 = 0; s1 < this.children.length; s1++){
            let o = this.children[s1];
            if (o instanceof nr && o.dataPatched.visible === !0 && o.geometry.attributes.position?.count > 0 && o.geometry.drawRange.count > 0 && o.booleanMeshSetAddress !== 0) {
                Df.multiplyMatrices(o.hiddenMatrix, o.matrix).multiply(o.pivotMatrix);
                try {
                    if (o.booleanMeshSetAddress === -1) {
                        if ((o.geometry.index ?? o.geometry.getAttribute("position")).count / 3 < 15e5 && (o.booleanMeshSetAddress = _s.getMeshSet(o.geometry, e === !0, r)), o.booleanMeshSetAddress === -1) return;
                        _s.transformMeshSet(o.booleanMeshSetAddress, Df), o.booleanMatrixInvOld.copy(Df).invert(), o.booleanWasTransformed = !1;
                    } else o instanceof Hn && o.needsTransformForDownstream === !0 ? (_s.transformMeshSet(o.booleanMeshSetAddress, Df), o.needsTransformForDownstream = !1) : o.booleanWasTransformed === !0 && (_s.transformMeshSet(o.booleanMeshSetAddress, aJ.multiplyMatrices(Df, o.booleanMatrixInvOld)), o.booleanMatrixInvOld.copy(Df).invert(), o.booleanWasTransformed = !1);
                } catch (a) {
                    console.error(a), o.booleanMeshSetAddress = 0, o.geometry.userData.booleanOperationDidFail = !0;
                    continue;
                }
                _s.hasOpenEdges(o.booleanMeshSetAddress) === !1 || s1 === this.children.length - 1 && this.booleanOp === 2 ? (this.meshSetAddresses.push(o.booleanMeshSetAddress), o.geometry.userData.booleanOperationDidFail = !1) : o.geometry.userData.booleanOperationDidFail = "openEdges";
            }
        }
        if (this.meshSetAddresses.length === 0) {
            this.geometry.setAttribute("position", new Te([], 0)), this.geometry.setDrawRange(0, 0);
            return;
        }
        if (e === !0) return _s.calcBooleanTopological(this.meshSetAddresses, this.booleanOp);
        let i = this.geometry;
        i.dispose(), this.geometry = new Ce, this.geometry.userData = i.userData, this.geometry.boundingSphere = i.boundingSphere;
        try {
            this.booleanMeshSetAddress = _s.calcBoolean(this.meshSetAddresses, this.booleanOp, this.geometry, this.phongAngle);
        } catch (s1) {
            this.booleanMeshSetAddress = 0, this.geometry.userData.booleanOperationDidFail = !0, console.error(s1);
        }
        this.booleanMatrixInvOld.copy(this.matrix).invert(), this.needsTransformForDownstream = !0, Cf(this), Pf(this);
    }
    dispose() {
        super.dispose(), this.geometry.dispose();
    }
};
var Of;
((t)=>{
    function n1(e) {
        return gt.is(e) && e instanceof Cl;
    }
    t.is = n1;
})(Of || (Of = {}));
var Rf = (n1, t)=>class extends Rs(n1, t) {
        updateState_Light(r, i) {
            this.updateState_Entity(r, i), r.color !== void 0 && (this.color = i.shared.color(r.color)), r.intensity !== void 0 && (this.intensity = r.intensity), r.depth !== void 0 && (this.shadow.camera.far = r.depth, this.shadow.needsUpdate = !0), r.shadows !== void 0 && (this.castShadow = r.shadows);
        }
    };
var Wn = (n1)=>n1 instanceof nr, Dn = (n1)=>n1 !== null && n1 instanceof Hn;
var dg = (n1)=>mb.is(n1);
var lJ = new E(1, 1, 1), TN = new E, cJ = new E, MN = new Ye, Ls = class extends na(lv) {
    constructor(e, r = 15){
        super(r);
        this.object = e;
        this.dummy = new cn;
        this.object.updateMatrixWorld(), this.name = `EmptyObjectHelper: ${e.uuid}`, this.matrix = this.dummy.matrixWorld, this.matrixAutoUpdate = !1, this.object.isBone && (this.visible = !1);
    }
    raycast(e, r) {
        sa(this.object, Ls.geometryHelper, e, r, !1, this.dummy);
    }
    update() {}
    updateMatrix() {}
    updateMatrixWorld(e) {
        this.object.matrixWorld.decompose(TN, MN, cJ), this.matrix.compose(TN, MN, lJ), super.updateMatrixWorld(e);
    }
    updateWorldMatrix(e, r) {}
};
var Ns = class extends Rs(cn, Ls) {
    constructor(t, e){
        super(), this.super_Entity(t, e), this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Entity(t, e), "buffer" in t && Object.keys(t).length === 1 && e.scene.reloadSplats();
    }
};
var oa = class extends Rs(cn, Ls) {
    constructor(e, r, i){
        super();
        this.super_Entity(e, r), this.context = i, this.objectHelper.update();
    }
    updateState(e, r) {
        this.updateState_Entity(e, r);
    }
};
var RN = {
    RED: 0,
    GREEN: 1,
    BLUE: 2,
    ALPHA: 3
};
var fg = "varying vec2 vUv;void main(){vUv=position.xy*0.5+0.5;gl_Position=vec4(position.xy,1.0,1.0);}";
var uJ = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform lowp sampler2D cocBuffer;uniform vec2 texelSize;uniform float scale;uniform vec4 kernel64[32];varying vec2 vUv;void main(){
#ifdef FOREGROUND
vec2 CoCNearFar=texture2D(cocBuffer,vUv).rg;float CoC=CoCNearFar.r*scale;
#else
float CoC=texture2D(cocBuffer,vUv).g*scale;
#endif
if(CoC==0.0){gl_FragColor=texture2D(inputBuffer,vUv);}else{
#ifdef FOREGROUND
vec2 step=texelSize*max(CoC,CoCNearFar.g*scale);
#else
vec2 step=texelSize*CoC;
#endif
vec4 acc=vec4(0.0);for(int i=0;i<32;++i){vec4 kernel=kernel64[i];vec2 uv=step*kernel.xy+vUv;acc+=texture2D(inputBuffer,uv);uv=step*kernel.zw+vUv;acc+=texture2D(inputBuffer,uv);}gl_FragColor=acc/64.0;}}`, yb = class extends $e {
    constructor(n1 = !1, t = !1){
        super({
            name: "BokehMaterial",
            defines: {
                PASS: n1 ? "2" : "1"
            },
            uniforms: {
                kernel64: new ce(null),
                kernel16: new ce(null),
                inputBuffer: new ce(null),
                cocBuffer: new ce(null),
                texelSize: new ce(new U),
                scale: new ce(1)
            },
            blending: or,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: uJ,
            vertexShader: fg
        }), this.toneMapped = !1, t && (this.defines.FOREGROUND = "1"), this.generateKernel();
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    set cocBuffer(n1) {
        this.uniforms.cocBuffer.value = n1;
    }
    setCoCBuffer(n1) {
        this.uniforms.cocBuffer.value = n1;
    }
    get scale() {
        return this.uniforms.scale.value;
    }
    set scale(n1) {
        this.uniforms.scale.value = n1;
    }
    getScale(n1) {
        return this.uniforms.scale.value = n1;
    }
    setScale(n1) {
        this.uniforms.scale.value = n1;
    }
    generateKernel() {
        let n1 = 2.39996323, t = new Float32Array(128), e = new Float32Array(32), r = 0, i = 0;
        for(let a = 0; a < 80; ++a){
            let l = a * n1, c = Math.sqrt(a) / Math.sqrt(80), u1 = c * Math.cos(l), h = c * Math.sin(l);
            a % 5 === 0 ? (e[i++] = u1, e[i++] = h) : (t[r++] = u1, t[r++] = h);
        }
        let s1 = [], o = [];
        for(let a = 0; a < 128;)s1.push(new Ze(t[a++], t[a++], t[a++], t[a++]));
        for(let a = 0; a < 32;)o.push(new Ze(e[a++], e[a++], e[a++], e[a++]));
        this.uniforms.kernel64.value = s1, this.uniforms.kernel16.value = o;
    }
    setTexelSize(n1, t) {
        this.uniforms.texelSize.value.set(n1, t);
    }
    setSize(n1, t) {
        this.uniforms.texelSize.value.set(1 / n1, 1 / t);
    }
};
function CN(n1, t, e) {
    return n1 * (t - e) - t;
}
function eM(n1, t, e) {
    return Math.min(Math.max((n1 + t) / (t - e), 0), 1);
}
var hJ = `#include <common>
#include <packing>
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
uniform float focusDistance;uniform float focusRange;uniform float cameraNear;uniform float cameraFar;varying vec2 vUv;float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}void main(){float depth=readDepth(vUv);
#ifdef PERSPECTIVE_CAMERA
float viewZ=perspectiveDepthToViewZ(depth,cameraNear,cameraFar);float linearDepth=viewZToOrthographicDepth(viewZ,cameraNear,cameraFar);
#else
float linearDepth=depth;
#endif
float signedDistance=linearDepth-focusDistance;float magnitude=smoothstep(0.0,focusRange,abs(signedDistance));gl_FragColor.rg=magnitude*vec2(step(signedDistance,0.0),step(0.0,signedDistance));}`, dJ = class extends $e {
    constructor(n1){
        super({
            name: "CircleOfConfusionMaterial",
            defines: {
                DEPTH_PACKING: "0"
            },
            uniforms: {
                depthBuffer: new ce(null),
                focusDistance: new ce(0),
                focusRange: new ce(0),
                cameraNear: new ce(.3),
                cameraFar: new ce(1e3)
            },
            blending: or,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: hJ,
            vertexShader: fg
        }), this.toneMapped = !1, this.uniforms.focalLength = this.uniforms.focusRange, this.adoptCameraSettings(n1);
    }
    get near() {
        return this.uniforms.cameraNear.value;
    }
    get far() {
        return this.uniforms.cameraFar.value;
    }
    set depthBuffer(n1) {
        this.uniforms.depthBuffer.value = n1;
    }
    set depthPacking(n1) {
        this.defines.DEPTH_PACKING = n1.toFixed(0), this.needsUpdate = !0;
    }
    setDepthBuffer(n1, t = zi) {
        this.depthBuffer = n1, this.depthPacking = t;
    }
    get focusDistance() {
        return this.uniforms.focusDistance.value;
    }
    set focusDistance(n1) {
        this.uniforms.focusDistance.value = n1;
    }
    get worldFocusDistance() {
        return -CN(this.focusDistance, this.near, this.far);
    }
    set worldFocusDistance(n1) {
        this.focusDistance = eM(-n1, this.near, this.far);
    }
    getFocusDistance(n1) {
        this.uniforms.focusDistance.value = n1;
    }
    setFocusDistance(n1) {
        this.uniforms.focusDistance.value = n1;
    }
    get focalLength() {
        return this.focusRange;
    }
    set focalLength(n1) {
        this.focusRange = n1;
    }
    get focusRange() {
        return this.uniforms.focusRange.value;
    }
    set focusRange(n1) {
        this.uniforms.focusRange.value = n1;
    }
    get worldFocusRange() {
        return -CN(this.focusRange, this.near, this.far);
    }
    set worldFocusRange(n1) {
        this.focusRange = eM(-n1, this.near, this.far);
    }
    getFocalLength(n1) {
        return this.focusRange;
    }
    setFocalLength(n1) {
        this.focusRange = n1;
    }
    adoptCameraSettings(n1) {
        n1 && (this.uniforms.cameraNear.value = n1.near, this.uniforms.cameraFar.value = n1.far, n1 instanceof si ? this.defines.PERSPECTIVE_CAMERA = "1" : delete this.defines.PERSPECTIVE_CAMERA, this.needsUpdate = !0);
    }
}, fJ = `#include <common>
#include <dithering_pars_fragment>
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec4 sum=texture2D(inputBuffer,vUv0);sum+=texture2D(inputBuffer,vUv1);sum+=texture2D(inputBuffer,vUv2);sum+=texture2D(inputBuffer,vUv3);gl_FragColor=sum*0.25;
#include <encodings_fragment>
#include <dithering_fragment>
}`, pJ = "uniform vec2 texelSize;uniform vec2 halfTexelSize;uniform float kernel;uniform float scale;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 uv=position.xy*0.5+0.5;vec2 dUv=(texelSize*vec2(kernel)+halfTexelSize)*scale;vUv0=vec2(uv.x-dUv.x,uv.y+dUv.y);vUv1=vec2(uv.x+dUv.x,uv.y+dUv.y);vUv2=vec2(uv.x+dUv.x,uv.y-dUv.y);vUv3=vec2(uv.x-dUv.x,uv.y-dUv.y);gl_Position=vec4(position.xy,1.0,1.0);}", PN = class extends $e {
    constructor(n1 = new U){
        super({
            name: "KawaseBlurMaterial",
            uniforms: {
                inputBuffer: new ce(null),
                texelSize: new ce(new U),
                halfTexelSize: new ce(new U),
                kernel: new ce(0),
                scale: new ce(1)
            },
            blending: or,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: fJ,
            vertexShader: pJ
        }), this.toneMapped = !1, this.setTexelSize(n1.x, n1.y);
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.inputBuffer = n1;
    }
    get scale() {
        return this.uniforms.scale.value;
    }
    set scale(n1) {
        this.uniforms.scale.value = n1;
    }
    getScale() {
        return this.uniforms.scale.value;
    }
    setScale(n1) {
        this.uniforms.scale.value = n1;
    }
    getKernel() {
        return null;
    }
    get kernel() {
        return this.uniforms.kernel.value;
    }
    set kernel(n1) {
        this.uniforms.kernel.value = n1;
    }
    setKernel(n1) {
        this.kernel = n1;
    }
    setTexelSize(n1, t) {
        this.uniforms.texelSize.value.set(n1, t), this.uniforms.halfTexelSize.value.set(n1, t).multiplyScalar(.5);
    }
    setSize(n1, t) {
        let e = this.uniforms;
        e.texelSize.value.set(1 / n1, 1 / t), e.halfTexelSize.value.copy(e.texelSize.value).multiplyScalar(.5);
    }
}, mJ = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform float opacity;varying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);gl_FragColor=opacity*texel;
#include <encodings_fragment>
}`, gJ = class extends $e {
    constructor(){
        super({
            name: "CopyMaterial",
            uniforms: {
                inputBuffer: new ce(null),
                opacity: new ce(1)
            },
            blending: or,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: mJ,
            vertexShader: fg
        }), this.toneMapped = !1;
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    getOpacity(n1) {
        return this.uniforms.opacity.value;
    }
    setOpacity(n1) {
        this.uniforms.opacity.value = n1;
    }
};
var yJ = `varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;
#if THREE_REVISION < 143
#define luminance(v) linearToRelativeLuminance(v)
#endif
#if EDGE_DETECTION_MODE != 0
varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;
#endif
#if EDGE_DETECTION_MODE == 1
#include <common>
#endif
#if EDGE_DETECTION_MODE == 0 || PREDICATION_MODE == 1
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}vec3 gatherNeighbors(){float p=readDepth(vUv);float pLeft=readDepth(vUv0);float pTop=readDepth(vUv1);return vec3(p,pLeft,pTop);}
#elif PREDICATION_MODE == 2
uniform sampler2D predicationBuffer;vec3 gatherNeighbors(){float p=texture2D(predicationBuffer,vUv).r;float pLeft=texture2D(predicationBuffer,vUv0).r;float pTop=texture2D(predicationBuffer,vUv1).r;return vec3(p,pLeft,pTop);}
#endif
#if PREDICATION_MODE != 0
vec2 calculatePredicatedThreshold(){vec3 neighbours=gatherNeighbors();vec2 delta=abs(neighbours.xx-neighbours.yz);vec2 edges=step(PREDICATION_THRESHOLD,delta);return PREDICATION_SCALE*EDGE_THRESHOLD*(1.0-PREDICATION_STRENGTH*edges);}
#endif
#if EDGE_DETECTION_MODE != 0
uniform sampler2D inputBuffer;
#endif
void main(){
#if EDGE_DETECTION_MODE == 0
const vec2 threshold=vec2(DEPTH_THRESHOLD);
#elif PREDICATION_MODE != 0
vec2 threshold=calculatePredicatedThreshold();
#else
const vec2 threshold=vec2(EDGE_THRESHOLD);
#endif
#if EDGE_DETECTION_MODE == 0
vec3 neighbors=gatherNeighbors();vec2 delta=abs(neighbors.xx-vec2(neighbors.y,neighbors.z));vec2 edges=step(threshold,delta);if(dot(edges,vec2(1.0))==0.0){discard;}gl_FragColor=vec4(edges,0.0,1.0);
#elif EDGE_DETECTION_MODE == 1
float l=luminance(texture2D(inputBuffer,vUv).rgb);float lLeft=luminance(texture2D(inputBuffer,vUv0).rgb);float lTop=luminance(texture2D(inputBuffer,vUv1).rgb);vec4 delta;delta.xy=abs(l-vec2(lLeft,lTop));vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}float lRight=luminance(texture2D(inputBuffer,vUv2).rgb);float lBottom=luminance(texture2D(inputBuffer,vUv3).rgb);delta.zw=abs(l-vec2(lRight,lBottom));vec2 maxDelta=max(delta.xy,delta.zw);float lLeftLeft=luminance(texture2D(inputBuffer,vUv4).rgb);float lTopTop=luminance(texture2D(inputBuffer,vUv5).rgb);delta.zw=abs(vec2(lLeft,lTop)-vec2(lLeftLeft,lTopTop));maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges.xy*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);
#elif EDGE_DETECTION_MODE == 2
vec4 delta;vec3 c=texture2D(inputBuffer,vUv).rgb;vec3 cLeft=texture2D(inputBuffer,vUv0).rgb;vec3 t=abs(c-cLeft);delta.x=max(max(t.r,t.g),t.b);vec3 cTop=texture2D(inputBuffer,vUv1).rgb;t=abs(c-cTop);delta.y=max(max(t.r,t.g),t.b);vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}vec3 cRight=texture2D(inputBuffer,vUv2).rgb;t=abs(c-cRight);delta.z=max(max(t.r,t.g),t.b);vec3 cBottom=texture2D(inputBuffer,vUv3).rgb;t=abs(c-cBottom);delta.w=max(max(t.r,t.g),t.b);vec2 maxDelta=max(delta.xy,delta.zw);vec3 cLeftLeft=texture2D(inputBuffer,vUv4).rgb;t=abs(c-cLeftLeft);delta.z=max(max(t.r,t.g),t.b);vec3 cTopTop=texture2D(inputBuffer,vUv5).rgb;t=abs(c-cTopTop);delta.w=max(max(t.r,t.g),t.b);maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);
#endif
}`, vJ = `uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;
#if EDGE_DETECTION_MODE != 0
varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;
#endif
void main(){vUv=position.xy*0.5+0.5;vUv0=vUv+texelSize*vec2(-1.0,0.0);vUv1=vUv+texelSize*vec2(0.0,-1.0);
#if EDGE_DETECTION_MODE != 0
vUv2=vUv+texelSize*vec2(1.0,0.0);vUv3=vUv+texelSize*vec2(0.0,1.0);vUv4=vUv+texelSize*vec2(-2.0,0.0);vUv5=vUv+texelSize*vec2(0.0,-2.0);
#endif
gl_Position=vec4(position.xy,1.0,1.0);}`, Lf = {
    DEPTH: 0,
    LUMA: 1,
    COLOR: 2
}, xJ = {
    DISABLED: 0,
    DEPTH: 1,
    CUSTOM: 2
}, bJ = class extends $e {
    constructor(n1 = new U, t = Lf.COLOR){
        super({
            name: "EdgeDetectionMaterial",
            defines: {
                THREE_REVISION: Pa.replace(/\D+/g, ""),
                LOCAL_CONTRAST_ADAPTATION_FACTOR: "2.0",
                EDGE_THRESHOLD: "0.1",
                DEPTH_THRESHOLD: "0.01",
                PREDICATION_MODE: "0",
                PREDICATION_THRESHOLD: "0.01",
                PREDICATION_SCALE: "2.0",
                PREDICATION_STRENGTH: "1.0",
                DEPTH_PACKING: "0"
            },
            uniforms: {
                inputBuffer: new ce(null),
                depthBuffer: new ce(null),
                predicationBuffer: new ce(null),
                texelSize: new ce(n1)
            },
            blending: or,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: yJ,
            vertexShader: vJ
        }), this.toneMapped = !1, this.edgeDetectionMode = t;
    }
    set depthBuffer(n1) {
        this.uniforms.depthBuffer.value = n1;
    }
    set depthPacking(n1) {
        this.defines.DEPTH_PACKING = n1.toFixed(0), this.needsUpdate = !0;
    }
    setDepthBuffer(n1, t = zi) {
        this.depthBuffer = n1, this.depthPacking = t;
    }
    get edgeDetectionMode() {
        return Number(this.defines.EDGE_DETECTION_MODE);
    }
    set edgeDetectionMode(n1) {
        this.defines.EDGE_DETECTION_MODE = n1.toFixed(0), this.needsUpdate = !0;
    }
    getEdgeDetectionMode() {
        return this.edgeDetectionMode;
    }
    setEdgeDetectionMode(n1) {
        this.edgeDetectionMode = n1;
    }
    get localContrastAdaptationFactor() {
        return Number(this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR);
    }
    set localContrastAdaptationFactor(n1) {
        this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR = n1.toFixed("6"), this.needsUpdate = !0;
    }
    getLocalContrastAdaptationFactor() {
        return this.localContrastAdaptationFactor;
    }
    setLocalContrastAdaptationFactor(n1) {
        this.localContrastAdaptationFactor = n1;
    }
    get edgeDetectionThreshold() {
        return Number(this.defines.EDGE_THRESHOLD);
    }
    set edgeDetectionThreshold(n1) {
        this.defines.EDGE_THRESHOLD = n1.toFixed("6"), this.defines.DEPTH_THRESHOLD = (n1 * .1).toFixed("6"), this.needsUpdate = !0;
    }
    getEdgeDetectionThreshold() {
        return this.edgeDetectionThreshold;
    }
    setEdgeDetectionThreshold(n1) {
        this.edgeDetectionThreshold = n1;
    }
    get predicationMode() {
        return Number(this.defines.PREDICATION_MODE);
    }
    set predicationMode(n1) {
        this.defines.PREDICATION_MODE = n1.toFixed(0), this.needsUpdate = !0;
    }
    getPredicationMode() {
        return this.predicationMode;
    }
    setPredicationMode(n1) {
        this.predicationMode = n1;
    }
    set predicationBuffer(n1) {
        this.uniforms.predicationBuffer.value = n1;
    }
    setPredicationBuffer(n1) {
        this.uniforms.predicationBuffer.value = n1;
    }
    get predicationThreshold() {
        return Number(this.defines.PREDICATION_THRESHOLD);
    }
    set predicationThreshold(n1) {
        this.defines.PREDICATION_THRESHOLD = n1.toFixed("6"), this.needsUpdate = !0;
    }
    getPredicationThreshold() {
        return this.predicationThreshold;
    }
    setPredicationThreshold(n1) {
        this.predicationThreshold = n1;
    }
    get predicationScale() {
        return Number(this.defines.PREDICATION_SCALE);
    }
    set predicationScale(n1) {
        this.defines.PREDICATION_SCALE = n1.toFixed("6"), this.needsUpdate = !0;
    }
    getPredicationScale() {
        return this.predicationScale;
    }
    setPredicationScale(n1) {
        this.predicationScale = n1;
    }
    get predicationStrength() {
        return Number(this.defines.PREDICATION_STRENGTH);
    }
    set predicationStrength(n1) {
        this.defines.PREDICATION_STRENGTH = n1.toFixed("6"), this.needsUpdate = !0;
    }
    getPredicationStrength() {
        return this.predicationStrength;
    }
    setPredicationStrength(n1) {
        this.predicationStrength = n1;
    }
    setSize(n1, t) {
        this.uniforms.texelSize.value.set(1 / n1, 1 / t);
    }
}, SJ = `#include <common>
#include <packing>
#include <dithering_pars_fragment>
#define packFloatToRGBA(v) packDepthToRGBA(v)
#define unpackRGBAToFloat(v) unpackRGBAToDepth(v)
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;
#if THREE_REVISION < 143
#define luminance(v) linearToRelativeLuminance(v)
#endif
#if THREE_REVISION >= 137
vec4 sRGBToLinear(const in vec4 value){return vec4(mix(pow(value.rgb*0.9478672986+vec3(0.0521327014),vec3(2.4)),value.rgb*0.0773993808,vec3(lessThanEqual(value.rgb,vec3(0.04045)))),value.a);}
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}float getViewZ(const in float depth){
#ifdef PERSPECTIVE_CAMERA
return perspectiveDepthToViewZ(depth,cameraNear,cameraFar);
#else
return orthographicDepthToViewZ(depth,cameraNear,cameraFar);
#endif
}FRAGMENT_HEADvoid main(){FRAGMENT_MAIN_UVvec4 color0=texture2D(inputBuffer,UV);vec4 color1=vec4(0.0);FRAGMENT_MAIN_IMAGEgl_FragColor=color0;
#ifdef ENCODE_OUTPUT
#include <encodings_fragment>
#endif
#include <dithering_fragment>
}`, wJ = "uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;VERTEX_HEADvoid main(){vUv=position.xy*0.5+0.5;VERTEX_MAIN_SUPPORTgl_Position=vec4(position.xy,1.0,1.0);}", uo = {
    FRAGMENT_HEAD: "FRAGMENT_HEAD",
    FRAGMENT_MAIN_UV: "FRAGMENT_MAIN_UV",
    FRAGMENT_MAIN_IMAGE: "FRAGMENT_MAIN_IMAGE",
    VERTEX_HEAD: "VERTEX_HEAD",
    VERTEX_MAIN_SUPPORT: "VERTEX_MAIN_SUPPORT"
}, tM = class extends $e {
    constructor(n1, t, e, r, i = !1){
        super({
            name: "EffectMaterial",
            defines: {
                THREE_REVISION: Pa.replace(/\D+/g, ""),
                DEPTH_PACKING: "0",
                ENCODE_OUTPUT: "1"
            },
            uniforms: {
                inputBuffer: new ce(null),
                depthBuffer: new ce(null),
                resolution: new ce(new U),
                texelSize: new ce(new U),
                cameraNear: new ce(.3),
                cameraFar: new ce(1e3),
                aspect: new ce(1),
                time: new ce(0)
            },
            blending: or,
            depthWrite: !1,
            depthTest: !1,
            dithering: i
        }), this.toneMapped = !1, n1 && this.setShaderParts(n1), t && this.setDefines(t), e && this.setUniforms(e), this.adoptCameraSettings(r);
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    get depthBuffer() {
        return this.uniforms.depthBuffer.value;
    }
    set depthBuffer(n1) {
        this.uniforms.depthBuffer.value = n1;
    }
    get depthPacking() {
        return Number(this.defines.DEPTH_PACKING);
    }
    set depthPacking(n1) {
        this.defines.DEPTH_PACKING = n1.toFixed(0), this.needsUpdate = !0;
    }
    setDepthBuffer(n1, t = zi) {
        this.depthBuffer = n1, this.depthPacking = t;
    }
    setShaderParts(n1) {
        return this.fragmentShader = SJ.replace(uo.FRAGMENT_HEAD, n1.get(uo.FRAGMENT_HEAD)).replace(uo.FRAGMENT_MAIN_UV, n1.get(uo.FRAGMENT_MAIN_UV)).replace(uo.FRAGMENT_MAIN_IMAGE, n1.get(uo.FRAGMENT_MAIN_IMAGE)), this.vertexShader = wJ.replace(uo.VERTEX_HEAD, n1.get(uo.VERTEX_HEAD)).replace(uo.VERTEX_MAIN_SUPPORT, n1.get(uo.VERTEX_MAIN_SUPPORT)), this.needsUpdate = !0, this;
    }
    setDefines(n1) {
        for (let t of n1.entries())this.defines[t[0]] = t[1];
        return this.needsUpdate = !0, this;
    }
    setUniforms(n1) {
        for (let t of n1.entries())this.uniforms[t[0]] = t[1];
        return this;
    }
    setExtensions(n1) {
        this.extensions = {};
        for (let t of n1)this.extensions[t] = !0;
        return this;
    }
    get encodeOutput() {
        return this.defines.ENCODE_OUTPUT !== void 0;
    }
    set encodeOutput(n1) {
        this.encodeOutput !== n1 && (n1 ? this.defines.ENCODE_OUTPUT = "1" : delete this.defines.ENCODE_OUTPUT, this.needsUpdate = !0);
    }
    isOutputEncodingEnabled(n1) {
        return this.encodeOutput;
    }
    setOutputEncodingEnabled(n1) {
        this.encodeOutput = n1;
    }
    get time() {
        return this.uniforms.time.value;
    }
    set time(n1) {
        this.uniforms.time.value = n1;
    }
    setDeltaTime(n1) {
        this.uniforms.time.value += n1;
    }
    adoptCameraSettings(n1) {
        n1 && (this.uniforms.cameraNear.value = n1.near, this.uniforms.cameraFar.value = n1.far, n1 instanceof si ? this.defines.PERSPECTIVE_CAMERA = "1" : delete this.defines.PERSPECTIVE_CAMERA, this.needsUpdate = !0);
    }
    setSize(n1, t) {
        let e = this.uniforms;
        e.resolution.value.set(n1, t), e.texelSize.value.set(1 / n1, 1 / t), e.aspect.value = n1 / t;
    }
    static get Section() {
        return uo;
    }
};
var AJ = `#include <common>
#if THREE_REVISION < 143
#define luminance(v) linearToRelativeLuminance(v)
#endif
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef RANGE
uniform vec2 range;
#elif defined(THRESHOLD)
uniform float threshold;uniform float smoothing;
#endif
varying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);float l=luminance(texel.rgb);
#ifdef RANGE
float low=step(range.x,l);float high=step(l,range.y);l*=low*high;
#elif defined(THRESHOLD)
l=smoothstep(threshold,threshold+smoothing,l);
#endif
#ifdef COLOR
gl_FragColor=vec4(texel.rgb*l,l);
#else
gl_FragColor=vec4(l);
#endif
}`, EJ = class extends $e {
    constructor(n1 = !1, t = null){
        super({
            name: "LuminanceMaterial",
            defines: {
                THREE_REVISION: Pa.replace(/\D+/g, "")
            },
            uniforms: {
                inputBuffer: new ce(null),
                threshold: new ce(0),
                smoothing: new ce(1),
                range: new ce(null)
            },
            blending: or,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: AJ,
            vertexShader: fg
        }), this.toneMapped = !1, this.colorOutput = n1, this.luminanceRange = t;
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    get threshold() {
        return this.uniforms.threshold.value;
    }
    set threshold(n1) {
        this.smoothing > 0 || n1 > 0 ? this.defines.THRESHOLD = "1" : delete this.defines.THRESHOLD, this.uniforms.threshold.value = n1;
    }
    getThreshold() {
        return this.threshold;
    }
    setThreshold(n1) {
        this.threshold = n1;
    }
    get smoothing() {
        return this.uniforms.smoothing.value;
    }
    set smoothing(n1) {
        this.threshold > 0 || n1 > 0 ? this.defines.THRESHOLD = "1" : delete this.defines.THRESHOLD, this.uniforms.smoothing.value = n1;
    }
    getSmoothingFactor() {
        return this.smoothing;
    }
    setSmoothingFactor(n1) {
        this.smoothing = n1;
    }
    get useThreshold() {
        return this.threshold > 0 || this.smoothing > 0;
    }
    set useThreshold(n1) {}
    get colorOutput() {
        return this.defines.COLOR !== void 0;
    }
    set colorOutput(n1) {
        n1 ? this.defines.COLOR = "1" : delete this.defines.COLOR, this.needsUpdate = !0;
    }
    isColorOutputEnabled(n1) {
        return this.colorOutput;
    }
    setColorOutputEnabled(n1) {
        this.colorOutput = n1;
    }
    get useRange() {
        return this.luminanceRange !== null;
    }
    set useRange(n1) {
        this.luminanceRange = null;
    }
    get luminanceRange() {
        return this.uniforms.range.value;
    }
    set luminanceRange(n1) {
        n1 !== null ? this.defines.RANGE = "1" : delete this.defines.RANGE, this.uniforms.range.value = n1, this.needsUpdate = !0;
    }
    getLuminanceRange() {
        return this.luminanceRange;
    }
    setLuminanceRange(n1) {
        this.luminanceRange = n1;
    }
}, TJ = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef MASK_PRECISION_HIGH
uniform mediump sampler2D maskTexture;
#else
uniform lowp sampler2D maskTexture;
#endif
#if MASK_FUNCTION != 0
uniform float strength;
#endif
varying vec2 vUv;void main(){
#if COLOR_CHANNEL == 0
float mask=texture2D(maskTexture,vUv).r;
#elif COLOR_CHANNEL == 1
float mask=texture2D(maskTexture,vUv).g;
#elif COLOR_CHANNEL == 2
float mask=texture2D(maskTexture,vUv).b;
#else
float mask=texture2D(maskTexture,vUv).a;
#endif
#if MASK_FUNCTION == 0
#ifdef INVERTED
mask=step(mask,0.0);
#else
mask=1.0-step(mask,0.0);
#endif
#else
mask=clamp(mask*strength,0.0,1.0);
#ifdef INVERTED
mask=1.0-mask;
#endif
#endif
#if MASK_FUNCTION == 2
gl_FragColor=vec4(mask*texture2D(inputBuffer,vUv).rgb,mask);
#else
gl_FragColor=mask*texture2D(inputBuffer,vUv);
#endif
}`, LN = {
    DISCARD: 0,
    MULTIPLY: 1,
    MULTIPLY_RGB_SET_ALPHA: 2
}, MJ = class extends $e {
    constructor(n1 = null){
        super({
            name: "MaskMaterial",
            uniforms: {
                maskTexture: new ce(n1),
                inputBuffer: new ce(null),
                strength: new ce(1)
            },
            blending: or,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: TJ,
            vertexShader: fg
        }), this.toneMapped = !1, this.setColorChannel(RN.RED), this.setMaskFunction(LN.DISCARD);
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    set maskTexture(n1) {
        this.uniforms.maskTexture.value = n1, delete this.defines.MASK_PRECISION_HIGH, n1.type !== Nr && (this.defines.MASK_PRECISION_HIGH = "1"), this.needsUpdate = !0;
    }
    setMaskTexture(n1) {
        this.maskTexture = n1;
    }
    set colorChannel(n1) {
        this.defines.COLOR_CHANNEL = n1.toFixed(0), this.needsUpdate = !0;
    }
    setColorChannel(n1) {
        this.colorChannel = n1;
    }
    set maskFunction(n1) {
        this.defines.MASK_FUNCTION = n1.toFixed(0), this.needsUpdate = !0;
    }
    setMaskFunction(n1) {
        this.maskFunction = n1;
    }
    get inverted() {
        return this.defines.INVERTED !== void 0;
    }
    set inverted(n1) {
        this.inverted && !n1 ? delete this.defines.INVERTED : n1 && (this.defines.INVERTED = "1"), this.needsUpdate = !0;
    }
    isInverted() {
        return this.inverted;
    }
    setInverted(n1) {
        this.inverted = n1;
    }
    get strength() {
        return this.uniforms.strength.value;
    }
    set strength(n1) {
        this.uniforms.strength.value = n1;
    }
    getStrength() {
        return this.strength;
    }
    setStrength(n1) {
        this.strength = n1;
    }
};
var CJ = `#define sampleLevelZeroOffset(t, coord, offset) texture2D(t, coord + offset * texelSize)
#if __VERSION__ < 300
#define round(v) floor(v + 0.5)
#endif
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform lowp sampler2D areaTexture;uniform lowp sampler2D searchTexture;uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}vec2 decodeDiagBilinearAccess(in vec2 e){e.r=e.r*abs(5.0*e.r-5.0*0.75);return round(e);}vec4 decodeDiagBilinearAccess(in vec4 e){e.rb=e.rb*abs(5.0*e.rb-5.0*0.75);return round(e);}vec2 searchDiag1(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 searchDiag2(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);coord.x+=0.25*texelSize.x;vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;e=decodeDiagBilinearAccess(e);coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 areaDiag(const in vec2 dist,const in vec2 e,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE_DIAG,AREATEX_MAX_DISTANCE_DIAG)*e+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.x+=0.5;texCoord.y+=AREATEX_SUBTEX_SIZE*offset;return texture2D(areaTexture,texCoord).rg;}vec2 calculateDiagWeights(const in vec2 texCoord,const in vec2 e,const in vec4 subsampleIndices){vec2 weights=vec2(0.0);vec4 d;vec2 end;if(e.r>0.0){d.xz=searchDiag1(texCoord,vec2(-1.0,1.0),end);d.x+=float(end.y>0.9);}else{d.xz=vec2(0.0);}d.yw=searchDiag1(texCoord,vec2(1.0,-1.0),end);if(d.x+d.y>2.0){vec4 coords=vec4(-d.x+0.25,d.x,d.y,-d.y-0.25)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.xy=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).rg;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).rg;c.yxwz=decodeDiagBilinearAccess(c.xyzw);vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.z);}d.xz=searchDiag2(texCoord,vec2(-1.0,-1.0),end);if(sampleLevelZeroOffset(inputBuffer,texCoord,vec2(1,0)).r>0.0){d.yw=searchDiag2(texCoord,vec2(1.0),end);d.y+=float(end.y>0.9);}else{d.yw=vec2(0.0);}if(d.x+d.y>2.0){vec4 coords=vec4(-d.x,-d.x,d.y,d.y)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.x=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).g;c.y=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(0,-1)).r;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).gr;vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.w).gr;}return weights;}float searchLength(const in vec2 e,const in float offset){vec2 scale=SEARCHTEX_SIZE*vec2(0.5,-1.0);vec2 bias=SEARCHTEX_SIZE*vec2(offset,1.0);scale+=vec2(-1.0,1.0);bias+=vec2(0.5,-0.5);scale*=1.0/SEARCHTEX_PACKED_SIZE;bias*=1.0/SEARCHTEX_PACKED_SIZE;return texture2D(searchTexture,scale*e+bias).r;}float searchXLeft(in vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x>end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(-2.0,0.0)*texelSize+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.0)+3.25;return texelSize.x*offset+texCoord.x;}float searchXRight(vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x<end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(2.0,0.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.5)+3.25;return-texelSize.x*offset+texCoord.x;}float searchYUp(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.y>end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=-vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.0)+3.25;return texelSize.y*offset+texCoord.y;}float searchYDown(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;i++){if(!(texCoord.y<end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.5)+3.25;return-texelSize.y*offset+texCoord.y;}vec2 area(const in vec2 dist,const in float e1,const in float e2,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE)*round(4.0*vec2(e1,e2))+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.y=AREATEX_SUBTEX_SIZE*offset+texCoord.y;return texture2D(areaTexture,texCoord).rg;}void detectHorizontalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){
#if !defined(DISABLE_CORNER_DETECTION)
vec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,1)).r;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).r;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,-2)).r;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,-2)).r;weights*=clamp(factor,0.0,1.0);
#endif
}void detectVerticalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){
#if !defined(DISABLE_CORNER_DETECTION)
vec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(1,0)).g;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).g;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(-2,0)).g;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(-2,1)).g;weights*=clamp(factor,0.0,1.0);
#endif
}void main(){vec4 weights=vec4(0.0);vec4 subsampleIndices=vec4(0.0);vec2 e=texture2D(inputBuffer,vUv).rg;if(e.g>0.0){
#if !defined(DISABLE_DIAG_DETECTION)
weights.rg=calculateDiagWeights(vUv,e,subsampleIndices);if(weights.r==-weights.g){
#endif
vec2 d;vec3 coords;coords.x=searchXLeft(vOffset[0].xy,vOffset[2].x);coords.y=vOffset[1].y;d.x=coords.x;float e1=texture2D(inputBuffer,coords.xy).r;coords.z=searchXRight(vOffset[0].zw,vOffset[2].y);d.y=coords.z;d=round(resolution.xx*d+-vPixCoord.xx);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.zy,vec2(1,0)).r;weights.rg=area(sqrtD,e1,e2,subsampleIndices.y);coords.y=vUv.y;detectHorizontalCornerPattern(weights.rg,coords.xyzy,d);
#if !defined(DISABLE_DIAG_DETECTION)
}else{e.r=0.0;}
#endif
}if(e.r>0.0){vec2 d;vec3 coords;coords.y=searchYUp(vOffset[1].xy,vOffset[2].z);coords.x=vOffset[0].x;d.x=coords.y;float e1=texture2D(inputBuffer,coords.xy).g;coords.z=searchYDown(vOffset[1].zw,vOffset[2].w);d.y=coords.z;d=round(resolution.yy*d-vPixCoord.yy);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.xz,vec2(0,1)).g;weights.ba=area(sqrtD,e1,e2,subsampleIndices.x);coords.x=vUv.x;detectVerticalCornerPattern(weights.ba,coords.xyxz,d);}gl_FragColor=weights;}`, PJ = "uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void main(){vUv=position.xy*0.5+0.5;vPixCoord=vUv*resolution;vOffset[0]=vUv.xyxy+texelSize.xyxy*vec4(-0.25,-0.125,1.25,-0.125);vOffset[1]=vUv.xyxy+texelSize.xyxy*vec4(-0.125,-0.25,-0.125,1.25);vOffset[2]=vec4(vOffset[0].xz,vOffset[1].yw)+vec4(-2.0,2.0,-2.0,2.0)*texelSize.xxyy*MAX_SEARCH_STEPS_FLOAT;gl_Position=vec4(position.xy,1.0,1.0);}", _J = class extends $e {
    constructor(n1 = new U, t = new U){
        super({
            name: "SMAAWeightsMaterial",
            defines: {
                MAX_SEARCH_STEPS_INT: "16",
                MAX_SEARCH_STEPS_FLOAT: "16.0",
                MAX_SEARCH_STEPS_DIAG_INT: "8",
                MAX_SEARCH_STEPS_DIAG_FLOAT: "8.0",
                CORNER_ROUNDING: "25",
                CORNER_ROUNDING_NORM: "0.25",
                AREATEX_MAX_DISTANCE: "16.0",
                AREATEX_MAX_DISTANCE_DIAG: "20.0",
                AREATEX_PIXEL_SIZE: "(1.0 / vec2(160.0, 560.0))",
                AREATEX_SUBTEX_SIZE: "(1.0 / 7.0)",
                SEARCHTEX_SIZE: "vec2(66.0, 33.0)",
                SEARCHTEX_PACKED_SIZE: "vec2(64.0, 16.0)"
            },
            uniforms: {
                inputBuffer: new ce(null),
                searchTexture: new ce(null),
                areaTexture: new ce(null),
                resolution: new ce(t),
                texelSize: new ce(n1)
            },
            blending: or,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: CJ,
            vertexShader: PJ
        }), this.toneMapped = !1;
    }
    set inputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    setInputBuffer(n1) {
        this.uniforms.inputBuffer.value = n1;
    }
    get searchTexture() {
        return this.uniforms.searchTexture.value;
    }
    set searchTexture(n1) {
        this.uniforms.searchTexture.value = n1;
    }
    get areaTexture() {
        return this.uniforms.areaTexture.value;
    }
    set areaTexture(n1) {
        this.uniforms.areaTexture.value = n1;
    }
    setLookupTextures(n1, t) {
        this.searchTexture = n1, this.areaTexture = t;
    }
    get orthogonalSearchSteps() {
        return Number(this.defines.MAX_SEARCH_STEPS_INT);
    }
    set orthogonalSearchSteps(n1) {
        let t = Math.min(Math.max(n1, 0), 112);
        this.defines.MAX_SEARCH_STEPS_INT = t.toFixed("0"), this.defines.MAX_SEARCH_STEPS_FLOAT = t.toFixed("1"), this.needsUpdate = !0;
    }
    setOrthogonalSearchSteps(n1) {
        this.orthogonalSearchSteps = n1;
    }
    get diagonalSearchSteps() {
        return Number(this.defines.MAX_SEARCH_STEPS_DIAG_INT);
    }
    set diagonalSearchSteps(n1) {
        let t = Math.min(Math.max(n1, 0), 20);
        this.defines.MAX_SEARCH_STEPS_DIAG_INT = t.toFixed("0"), this.defines.MAX_SEARCH_STEPS_DIAG_FLOAT = t.toFixed("1"), this.needsUpdate = !0;
    }
    setDiagonalSearchSteps(n1) {
        this.diagonalSearchSteps = n1;
    }
    get diagonalDetection() {
        return this.defines.DISABLE_DIAG_DETECTION === void 0;
    }
    set diagonalDetection(n1) {
        n1 ? delete this.defines.DISABLE_DIAG_DETECTION : this.defines.DISABLE_DIAG_DETECTION = "1", this.needsUpdate = !0;
    }
    isDiagonalDetectionEnabled() {
        return this.diagonalDetection;
    }
    setDiagonalDetectionEnabled(n1) {
        this.diagonalDetection = n1;
    }
    get cornerRounding() {
        return Number(this.defines.CORNER_ROUNDING);
    }
    set cornerRounding(n1) {
        let t = Math.min(Math.max(n1, 0), 100);
        this.defines.CORNER_ROUNDING = t.toFixed("4"), this.defines.CORNER_ROUNDING_NORM = (t / 100).toFixed("4"), this.needsUpdate = !0;
    }
    setCornerRounding(n1) {
        this.cornerRounding = n1;
    }
    get cornerDetection() {
        return this.defines.DISABLE_CORNER_DETECTION === void 0;
    }
    set cornerDetection(n1) {
        n1 ? delete this.defines.DISABLE_CORNER_DETECTION : this.defines.DISABLE_CORNER_DETECTION = "1", this.needsUpdate = !0;
    }
    isCornerRoundingEnabled() {
        return this.cornerDetection;
    }
    setCornerRoundingEnabled(n1) {
        this.cornerDetection = n1;
    }
    setSize(n1, t) {
        let e = this.uniforms;
        e.texelSize.value.set(1 / n1, 1 / t), e.resolution.value.set(n1, t);
    }
};
var IJ = new bn, hc = null;
function DJ() {
    if (hc === null) {
        let n1 = new Float32Array([
            -1,
            -1,
            0,
            3,
            -1,
            0,
            -1,
            3,
            0
        ]), t = new Float32Array([
            0,
            0,
            2,
            0,
            0,
            2
        ]);
        hc = new Ce, hc.setAttribute !== void 0 ? (hc.setAttribute("position", new je(n1, 3)), hc.setAttribute("uv", new je(t, 2))) : (hc.addAttribute("position", new je(n1, 3)), hc.addAttribute("uv", new je(t, 2)));
    }
    return hc;
}
var Ei = class {
    constructor(n1 = "Pass", t = new Er, e = IJ){
        this.name = n1, this.renderer = null, this.scene = t, this.camera = e, this.screen = null, this.rtt = !0, this.needsSwap = !0, this.needsDepthTexture = !1, this.enabled = !0;
    }
    get renderToScreen() {
        return !this.rtt;
    }
    set renderToScreen(n1) {
        if (this.rtt === n1) {
            let t = this.getFullscreenMaterial();
            t !== null && (t.needsUpdate = !0), this.rtt = !n1;
        }
    }
    setRenderer(n1) {
        this.renderer = n1;
    }
    isEnabled() {
        return this.enabled;
    }
    setEnabled(n1) {
        this.enabled = n1;
    }
    get fullscreenMaterial() {
        return this.screen !== null ? this.screen.material : null;
    }
    set fullscreenMaterial(n1) {
        let t = this.screen;
        t !== null ? t.material = n1 : (t = new Mt(DJ(), n1), t.frustumCulled = !1, this.scene === null && (this.scene = new Er), this.scene.add(t), this.screen = t);
    }
    getFullscreenMaterial() {
        return this.fullscreenMaterial;
    }
    setFullscreenMaterial(n1) {
        this.fullscreenMaterial = n1;
    }
    getDepthTexture() {
        return null;
    }
    setDepthTexture(n1, t = zi) {}
    render(n1, t, e, r, i) {
        throw new Error("Render method not implemented!");
    }
    setSize(n1, t) {}
    initialize(n1, t, e) {}
    dispose() {
        for (let n1 of Object.keys(this)){
            let t = this[n1];
            if (t !== null && typeof t == "object" && typeof t.dispose == "function") {
                if (t instanceof Er || t === this.renderer) continue;
                this[n1].dispose();
            }
        }
    }
}, pg = class extends Ei {
    constructor(n1, t = !0){
        super("CopyPass"), this.fullscreenMaterial = new gJ, this.needsSwap = !1, this.renderTarget = n1, n1 === void 0 && (this.renderTarget = new at(1, 1, {
            minFilter: it,
            magFilter: it,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "CopyPass.Target"), this.autoResize = t;
    }
    get resize() {
        return this.autoResize;
    }
    set resize(n1) {
        this.autoResize = n1;
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    setAutoResizeEnabled(n1) {
        this.autoResize = n1;
    }
    render(n1, t, e, r, i) {
        this.fullscreenMaterial.inputBuffer = t.texture, n1.setRenderTarget(this.renderToScreen ? null : this.renderTarget), n1.render(this.scene, this.camera);
    }
    setSize(n1, t) {
        this.autoResize && this.renderTarget.setSize(n1, t);
    }
    initialize(n1, t, e) {
        e !== void 0 && (this.renderTarget.texture.type = e, e !== Nr ? this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1" : n1.outputEncoding === ut && (this.renderTarget.texture.encoding = ut));
    }
};
var NN = class extends Ei {
    constructor(){
        super("ClearMaskPass", null, null), this.needsSwap = !1;
    }
    render(n1, t, e, r, i) {
        let s1 = n1.state.buffers.stencil;
        s1.setLocked(!1), s1.setTest(!1);
    }
}, QT = new Ge, rM = class extends Ei {
    constructor(n1 = !0, t = !0, e = !1){
        super("ClearPass", null, null), this.needsSwap = !1, this.color = n1, this.depth = t, this.stencil = e, this.overrideClearColor = null, this.overrideClearAlpha = -1;
    }
    setClearFlags(n1, t, e) {
        this.color = n1, this.depth = t, this.stencil = e;
    }
    getOverrideClearColor() {
        return this.overrideClearColor;
    }
    setOverrideClearColor(n1) {
        this.overrideClearColor = n1;
    }
    getOverrideClearAlpha() {
        return this.overrideClearAlpha;
    }
    setOverrideClearAlpha(n1) {
        this.overrideClearAlpha = n1;
    }
    render(n1, t, e, r, i) {
        let s1 = this.overrideClearColor, o = this.overrideClearAlpha, a = n1.getClearAlpha(), l = s1 !== null, c = o >= 0;
        l ? (QT.copy(n1.getClearColor(QT)), n1.setClearColor(s1, c ? o : a)) : c && n1.setClearAlpha(o), n1.setRenderTarget(this.renderToScreen ? null : t), n1.clear(this.color, this.depth, this.stencil), l ? n1.setClearColor(QT, a) : c && n1.setClearAlpha(a);
    }
}, dc = -1, qn = class extends ar {
    constructor(n1, t = dc, e = dc, r = 1){
        super(), this.resizable = n1, this.base = new U(1, 1), this.preferred = new U(t, e), this.target = this.preferred, this.s = r;
    }
    get width() {
        let { base: n1, preferred: t, scale: e } = this, r;
        return t.width !== dc ? r = t.width : t.height !== dc ? r = Math.round(t.height * (n1.width / Math.max(n1.height, 1))) : r = Math.round(n1.width * e), r;
    }
    set width(n1) {
        this.preferredWidth = n1;
    }
    get height() {
        let { base: n1, preferred: t, scale: e } = this, r;
        return t.height !== dc ? r = t.height : t.width !== dc ? r = Math.round(t.width / Math.max(n1.width / Math.max(n1.height, 1), 1)) : r = Math.round(n1.height * e), r;
    }
    set height(n1) {
        this.preferredHeight = n1;
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    get scale() {
        return this.s;
    }
    set scale(n1) {
        this.s !== n1 && (this.s = n1, this.preferred.setScalar(dc), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getScale() {
        return this.scale;
    }
    setScale(n1) {
        this.scale = n1;
    }
    get baseWidth() {
        return this.base.width;
    }
    set baseWidth(n1) {
        this.base.width !== n1 && (this.base.width = n1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getBaseWidth() {
        return this.base.width;
    }
    setBaseWidth(n1) {
        this.base.width !== n1 && (this.base.width = n1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    get baseHeight() {
        return this.base.height;
    }
    set baseHeight(n1) {
        this.base.height !== n1 && (this.base.height = n1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getBaseHeight() {
        return this.baseHeight;
    }
    setBaseHeight(n1) {
        this.baseHeight = n1;
    }
    setBaseSize(n1, t) {
        (this.base.width !== n1 || this.base.height !== t) && (this.base.set(n1, t), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    get preferredWidth() {
        return this.preferred.width;
    }
    set preferredWidth(n1) {
        this.preferred.width !== n1 && (this.preferred.width = n1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getPreferredWidth() {
        return this.preferredWidth;
    }
    setPreferredWidth(n1) {
        this.preferredWidth = n1;
    }
    get preferredHeight() {
        return this.preferred.height;
    }
    set preferredHeight(n1) {
        this.preferred.height !== n1 && (this.preferred.height = n1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getPreferredHeight() {
        return this.preferredHeight;
    }
    setPreferredHeight(n1) {
        this.preferredHeight = n1;
    }
    setPreferredSize(n1, t) {
        (this.preferred.width !== n1 || this.preferred.height !== t) && (this.preferred.set(n1, t), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    copy(n1) {
        this.base.set(n1.getBaseWidth(), n1.getBaseHeight()), this.preferred.set(n1.getPreferredWidth(), n1.getPreferredHeight()), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height);
    }
    static get AUTO_SIZE() {
        return dc;
    }
}, ZT = !1, _N = class {
    constructor(n1 = null){
        this.originalMaterials = new Map, this.material = null, this.materials = null, this.materialsBackSide = null, this.materialsDoubleSide = null, this.materialsFlatShaded = null, this.materialsFlatShadedBackSide = null, this.materialsFlatShadedDoubleSide = null, this.setMaterial(n1), this.meshCount = 0, this.replaceMaterial = (t)=>{
            if (t.isMesh) {
                let e;
                if (t.material.flatShading) switch(t.material.side){
                    case vi:
                        e = this.materialsFlatShadedDoubleSide;
                        break;
                    case xi:
                        e = this.materialsFlatShadedBackSide;
                        break;
                    default:
                        e = this.materialsFlatShaded;
                        break;
                }
                else switch(t.material.side){
                    case vi:
                        e = this.materialsDoubleSide;
                        break;
                    case xi:
                        e = this.materialsBackSide;
                        break;
                    default:
                        e = this.materials;
                        break;
                }
                this.originalMaterials.set(t, t.material), t.isSkinnedMesh ? t.material = e[2] : t.isInstancedMesh ? t.material = e[1] : t.material = e[0], ++this.meshCount;
            }
        };
    }
    setMaterial(n1) {
        if (this.disposeMaterials(), this.material = n1, n1 !== null) {
            let t = this.materials = [
                n1.clone(),
                n1.clone(),
                n1.clone()
            ];
            for (let e of t)e.uniforms = Object.assign({}, n1.uniforms), e.side = Jn;
            t[2].skinning = !0, this.materialsBackSide = t.map((e)=>{
                let r = e.clone();
                return r.uniforms = Object.assign({}, n1.uniforms), r.side = xi, r;
            }), this.materialsDoubleSide = t.map((e)=>{
                let r = e.clone();
                return r.uniforms = Object.assign({}, n1.uniforms), r.side = vi, r;
            }), this.materialsFlatShaded = t.map((e)=>{
                let r = e.clone();
                return r.uniforms = Object.assign({}, n1.uniforms), r.flatShading = !0, r;
            }), this.materialsFlatShadedBackSide = t.map((e)=>{
                let r = e.clone();
                return r.uniforms = Object.assign({}, n1.uniforms), r.flatShading = !0, r.side = xi, r;
            }), this.materialsFlatShadedDoubleSide = t.map((e)=>{
                let r = e.clone();
                return r.uniforms = Object.assign({}, n1.uniforms), r.flatShading = !0, r.side = vi, r;
            });
        }
    }
    render(n1, t, e) {
        let r = n1.shadowMap.enabled;
        if (n1.shadowMap.enabled = !1, ZT) {
            let i = this.originalMaterials;
            this.meshCount = 0, t.traverse(this.replaceMaterial), n1.render(t, e);
            for (let s1 of i)s1[0].material = s1[1];
            this.meshCount !== i.size && i.clear();
        } else {
            let i = t.overrideMaterial;
            t.overrideMaterial = this.material, n1.render(t, e), t.overrideMaterial = i;
        }
        n1.shadowMap.enabled = r;
    }
    disposeMaterials() {
        if (this.material !== null) {
            let n1 = this.materials.concat(this.materialsBackSide).concat(this.materialsDoubleSide).concat(this.materialsFlatShaded).concat(this.materialsFlatShadedBackSide).concat(this.materialsFlatShadedDoubleSide);
            for (let t of n1)t.dispose();
        }
    }
    dispose() {
        this.originalMaterials.clear(), this.disposeMaterials();
    }
    static get workaroundEnabled() {
        return ZT;
    }
    static set workaroundEnabled(n1) {
        ZT = n1;
    }
}, OJ = class extends Ei {
    constructor(n1, t, e = null){
        super("RenderPass", n1, t), this.needsSwap = !1, this.clearPass = new rM, this.overrideMaterialManager = e === null ? null : new _N(e), this.ignoreBackground = !1, this.skipShadowMapUpdate = !1, this.selection = null;
    }
    get renderToScreen() {
        return super.renderToScreen;
    }
    set renderToScreen(n1) {
        super.renderToScreen = n1, this.clearPass.renderToScreen = n1;
    }
    get overrideMaterial() {
        let n1 = this.overrideMaterialManager;
        return n1 !== null ? n1.material : null;
    }
    set overrideMaterial(n1) {
        let t = this.overrideMaterialManager;
        n1 !== null ? t !== null ? t.setMaterial(n1) : this.overrideMaterialManager = new _N(n1) : t !== null && (t.dispose(), this.overrideMaterialManager = null);
    }
    getOverrideMaterial() {
        return this.overrideMaterial;
    }
    setOverrideMaterial(n1) {
        this.overrideMaterial = n1;
    }
    get clear() {
        return this.clearPass.enabled;
    }
    set clear(n1) {
        this.clearPass.enabled = n1;
    }
    getSelection() {
        return this.selection;
    }
    setSelection(n1) {
        this.selection = n1;
    }
    isBackgroundDisabled() {
        return this.ignoreBackground;
    }
    setBackgroundDisabled(n1) {
        this.ignoreBackground = n1;
    }
    isShadowMapDisabled() {
        return this.skipShadowMapUpdate;
    }
    setShadowMapDisabled(n1) {
        this.skipShadowMapUpdate = n1;
    }
    getClearPass() {
        return this.clearPass;
    }
    render(n1, t, e, r, i) {
        let s1 = this.scene, o = this.camera, a = this.selection, l = o.layers.mask, c = s1.background, u1 = n1.shadowMap.autoUpdate, h = this.renderToScreen ? null : t;
        a !== null && o.layers.set(a.getLayer()), this.skipShadowMapUpdate && (n1.shadowMap.autoUpdate = !1), (this.ignoreBackground || this.clearPass.overrideClearColor !== null) && (s1.background = null), this.clearPass.enabled && this.clearPass.render(n1, t), n1.setRenderTarget(h), this.overrideMaterialManager !== null ? this.overrideMaterialManager.render(n1, s1, o) : n1.render(s1, o), o.layers.mask = l, s1.background = c, n1.shadowMap.autoUpdate = u1;
    }
}, iM = class extends Ei {
    constructor(n1, t, { resolutionScale: e = 1, width: r = qn.AUTO_SIZE, height: i = qn.AUTO_SIZE, renderTarget: s1 } = {}){
        super("DepthPass"), this.needsSwap = !1, this.renderPass = new OJ(n1, t, new kp({
            depthPacking: Cw
        }));
        let o = this.renderPass;
        o.skipShadowMapUpdate = !0, o.ignoreBackground = !0;
        let a = o.getClearPass();
        a.overrideClearColor = new Ge(16777215), a.overrideClearAlpha = 1, this.renderTarget = s1, this.renderTarget === void 0 && (this.renderTarget = new at(1, 1, {
            minFilter: vt,
            magFilter: vt,
            stencilBuffer: !1
        }), this.renderTarget.texture.name = "DepthPass.Target");
        let l = this.resolution = new qn(this, r, i, e);
        l.addEventListener("change", (c)=>this.setSize(l.baseWidth, l.baseHeight));
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    getResolution() {
        return this.resolution;
    }
    getResolutionScale() {
        return this.resolution.scale;
    }
    setResolutionScale(n1) {
        this.resolution.scale = n1;
    }
    render(n1, t, e, r, i) {
        let s1 = this.renderToScreen ? null : this.renderTarget;
        this.renderPass.render(n1, s1);
    }
    setSize(n1, t) {
        let e = this.resolution;
        e.setBaseSize(n1, t), this.renderTarget.setSize(e.width, e.height);
    }
};
var lLe = new Float32Array([
    255 / 256 / 256 ** 3,
    255 / 256 / 65536,
    255 / 256 / 256,
    255 / 256
]);
var Ot = {
    SKIP: 0,
    ADD: 1,
    ALPHA: 2,
    AVERAGE: 3,
    COLOR_BURN: 4,
    COLOR_DODGE: 5,
    DARKEN: 6,
    DIFFERENCE: 7,
    EXCLUSION: 8,
    LIGHTEN: 9,
    MULTIPLY: 10,
    DIVIDE: 11,
    NEGATION: 12,
    NORMAL: 13,
    OVERLAY: 14,
    REFLECT: 15,
    SCREEN: 16,
    SOFT_LIGHT: 17,
    SUBTRACT: 18
}, RJ = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return min(x+y,1.0)*opacity+x*(1.0-opacity);}", LJ = "vec3 blend(const in vec3 x,const in vec3 y,const in float opacity){return y*opacity+x*(1.0-opacity);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){float a=min(y.a,opacity);return vec4(blend(x.rgb,y.rgb,a),max(x.a,a));}", NJ = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(x+y)*0.5*opacity+x*(1.0-opacity);}", BJ = "float blend(const in float x,const in float y){return(y==0.0)?y:max(1.0-(1.0-x)/y,0.0);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", FJ = "float blend(const in float x,const in float y){return(y==1.0)?y:min(x/(1.0-y),1.0);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", VJ = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return min(x,y)*opacity+x*(1.0-opacity);}", UJ = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return abs(x-y)*opacity+x*(1.0-opacity);}", kJ = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(x+y-2.0*x*y)*opacity+x*(1.0-opacity);}", zJ = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return max(x,y)*opacity+x*(1.0-opacity);}", GJ = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return x*y*opacity+x*(1.0-opacity);}", jJ = "float blend(const in float x,const in float y){return(y>0.0)?min(x/y,1.0):1.0;}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", HJ = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(1.0-abs(1.0-x-y))*opacity+x*(1.0-opacity);}", WJ = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return y*opacity+x*(1.0-opacity);}", qJ = "float blend(const in float x,const in float y){return(x<0.5)?(2.0*x*y):(1.0-2.0*(1.0-x)*(1.0-y));}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", XJ = "float blend(const in float x,const in float y){return(y==1.0)?y:min(x*x/(1.0-y),1.0);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", YJ = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(1.0-(1.0-x)*(1.0-y))*opacity+x*(1.0-opacity);}", KJ = "float blend(const in float x,const in float y){return(y<0.5)?(2.0*x*y+x*x*(1.0-2.0*y)):(sqrt(x)*(2.0*y-1.0)+2.0*x*(1.0-y));}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", QJ = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return max(x+y-1.0,0.0)*opacity+x*(1.0-opacity);}", ZJ = new Map([
    [
        Ot.SKIP,
        null
    ],
    [
        Ot.ADD,
        RJ
    ],
    [
        Ot.ALPHA,
        LJ
    ],
    [
        Ot.AVERAGE,
        NJ
    ],
    [
        Ot.COLOR_BURN,
        BJ
    ],
    [
        Ot.COLOR_DODGE,
        FJ
    ],
    [
        Ot.DARKEN,
        VJ
    ],
    [
        Ot.DIFFERENCE,
        UJ
    ],
    [
        Ot.EXCLUSION,
        kJ
    ],
    [
        Ot.LIGHTEN,
        zJ
    ],
    [
        Ot.MULTIPLY,
        GJ
    ],
    [
        Ot.DIVIDE,
        jJ
    ],
    [
        Ot.NEGATION,
        HJ
    ],
    [
        Ot.NORMAL,
        WJ
    ],
    [
        Ot.OVERLAY,
        qJ
    ],
    [
        Ot.REFLECT,
        XJ
    ],
    [
        Ot.SCREEN,
        YJ
    ],
    [
        Ot.SOFT_LIGHT,
        KJ
    ],
    [
        Ot.SUBTRACT,
        QJ
    ]
]), JJ = class extends ar {
    constructor(n1, t = 1){
        super(), this.f = n1, this.opacity = new ce(t);
    }
    getOpacity() {
        return this.opacity.value;
    }
    setOpacity(n1) {
        this.opacity.value = n1;
    }
    get blendFunction() {
        return this.f;
    }
    set blendFunction(n1) {
        this.f = n1, this.dispatchEvent({
            type: "change"
        });
    }
    getBlendFunction() {
        return this.blendFunction;
    }
    setBlendFunction(n1) {
        this.blendFunction = n1;
    }
    getShaderCode() {
        return ZJ.get(this.blendFunction);
    }
}, aa = {
    NONE: 0,
    DEPTH: 1,
    CONVOLUTION: 2
};
var la = class extends ar {
    constructor(n1, t, { attributes: e = aa.NONE, blendFunction: r = Ot.SCREEN, defines: i = new Map, uniforms: s1 = new Map, extensions: o = null, vertexShader: a = null } = {}){
        super(), this.name = n1, this.renderer = null, this.attributes = e, this.fragmentShader = t, this.vertexShader = a, this.defines = i, this.uniforms = s1, this.extensions = o, this.blendMode = new JJ(r), this.blendMode.addEventListener("change", (l)=>this.setChanged());
    }
    getName() {
        return this.name;
    }
    setRenderer(n1) {
        this.renderer = n1;
    }
    getDefines() {
        return this.defines;
    }
    getUniforms() {
        return this.uniforms;
    }
    getExtensions() {
        return this.extensions;
    }
    getBlendMode() {
        return this.blendMode;
    }
    getAttributes() {
        return this.attributes;
    }
    setAttributes(n1) {
        this.attributes = n1, this.setChanged();
    }
    getFragmentShader() {
        return this.fragmentShader;
    }
    setFragmentShader(n1) {
        this.fragmentShader = n1, this.setChanged();
    }
    getVertexShader() {
        return this.vertexShader;
    }
    setVertexShader(n1) {
        this.vertexShader = n1, this.setChanged();
    }
    setChanged() {
        this.dispatchEvent({
            type: "change"
        });
    }
    setDepthTexture(n1, t = zi) {}
    update(n1, t, e) {}
    setSize(n1, t) {}
    initialize(n1, t, e) {}
    dispose() {
        for (let n1 of Object.keys(this)){
            let t = this[n1];
            if (t !== null && typeof t == "object" && typeof t.dispose == "function") {
                if (t instanceof Er || t === this.renderer) continue;
                this[n1].dispose();
            }
        }
    }
};
function IN(n1, t, e) {
    for (let r of t){
        let i = "$1" + n1 + r.charAt(0).toUpperCase() + r.slice(1), s1 = new RegExp("([^\\.])(\\b" + r + "\\b)", "g");
        for (let o of e.entries())o[1] !== null && e.set(o[0], o[1].replace(s1, i));
    }
}
function $J(n1, t, e, r, i, s1, o) {
    let a = new Map([
        [
            "fragment",
            t.getFragmentShader()
        ],
        [
            "vertex",
            t.getVertexShader()
        ]
    ]), l = a.get("fragment") !== void 0 && /mainImage/.test(a.get("fragment")), c = a.get("fragment") !== void 0 && /mainUv/.test(a.get("fragment")), u1 = [], h = [], d = !1, f = !1;
    if (a.get("fragment") === void 0) console.error("Missing fragment shader", t);
    else if (c && (o & aa.CONVOLUTION) !== 0) console.error("Effects that transform UV coordinates are incompatible with convolution effects", t);
    else if (!l && !c) console.error("The fragment shader contains neither a mainImage nor a mainUv function", t);
    else {
        let m = /(?:\w+\s+(\w+)\([\w\s,]*\)\s*{[^}]+})/g, p = tM.Section;
        if (c) {
            let y = `	${n1}MainUv(UV);
`;
            e.set(p.FRAGMENT_MAIN_UV, e.get(p.FRAGMENT_MAIN_UV) + y), d = !0;
        }
        if (a.get("vertex") !== null && /mainSupport/.test(a.get("vertex"))) {
            let y = `	${n1}MainSupport(`;
            y += /mainSupport *\([\w\s]*?uv\s*?\)/.test(a.get("vertex")) ? `vUv);
` : `);
`, e.set(p.VERTEX_MAIN_SUPPORT, e.get(p.VERTEX_MAIN_SUPPORT) + y), u1 = u1.concat([
                ...a.get("vertex").matchAll(/(?:varying\s+\w+\s+(\w*))/g)
            ].map((x)=>x[1])), h = h.concat(u1).concat([
                ...a.get("vertex").matchAll(m)
            ].map((x)=>x[1]));
        }
        h = h.concat([
            ...a.get("fragment").matchAll(m)
        ].map((y)=>y[1])), h = h.concat([
            ...t.defines.keys()
        ].map((y)=>y.replace(/\([\w\s,]*\)/g, ""))), h = h.concat([
            ...t.uniforms.keys()
        ]), t.uniforms.forEach((y, x)=>s1.set(n1 + x.charAt(0).toUpperCase() + x.slice(1), y)), t.defines.forEach((y, x)=>i.set(n1 + x.charAt(0).toUpperCase() + x.slice(1), y)), IN(n1, h, i), IN(n1, h, a);
        let g = t.blendMode;
        if (r.set(g.blendFunction, g), l) {
            let y = /MainImage *\([\w\s,]*?depth[\w\s,]*?\)/, x = `${n1}MainImage(color0, UV, `;
            (o & aa.DEPTH) !== 0 && y.test(a.get("fragment")) && (x += "depth, ", f = !0), x += `color1);
	`;
            let v = n1 + "BlendOpacity";
            s1.set(v, g.opacity), x += `color0 = blend${g.blendFunction}(color0, color1, ${v});

	`, e.set(p.FRAGMENT_MAIN_IMAGE, e.get(p.FRAGMENT_MAIN_IMAGE) + x), x = `uniform float ${v};

`, e.set(p.FRAGMENT_HEAD, e.get(p.FRAGMENT_HEAD) + x);
        }
        e.set(p.FRAGMENT_HEAD, e.get(p.FRAGMENT_HEAD) + a.get("fragment") + `
`), a.get("vertex") !== null && e.set(p.VERTEX_HEAD, e.get(p.VERTEX_HEAD) + a.get("vertex") + `
`);
    }
    return {
        varyings: u1,
        transformedUv: d,
        readDepth: f
    };
}
var bu = class extends Ei {
    constructor(n1, ...t){
        super("EffectPass"), this.fullscreenMaterial = new tM(null, null, null, n1), this.effects = t.sort((e, r)=>r.attributes - e.attributes), this.skipRendering = !1, this.uniformCount = 0, this.varyingCount = 0, this.minTime = 1, this.maxTime = Number.POSITIVE_INFINITY;
    }
    get encodeOutput() {
        return this.fullscreenMaterial.encodeOutput;
    }
    set encodeOutput(n1) {
        this.fullscreenMaterial.encodeOutput = n1;
    }
    get dithering() {
        return this.fullscreenMaterial.dithering;
    }
    set dithering(n1) {
        let t = this.fullscreenMaterial;
        t.dithering = n1, t.needsUpdate = !0;
    }
    verifyResources() {
        let n1 = this.renderer.capabilities, t = Math.min(n1.maxFragmentUniforms, n1.maxVertexUniforms);
        this.uniformCount > t && console.warn("The current rendering context doesn't support more than " + t + " uniforms, but " + this.uniformCount + " were defined"), t = n1.maxVaryings, this.varyingCount > t && console.warn("The current rendering context doesn't support more than " + t + " varyings, but " + this.varyingCount + " were defined");
    }
    updateMaterial() {
        let n1 = tM.Section, t = new Map([
            [
                n1.FRAGMENT_HEAD,
                ""
            ],
            [
                n1.FRAGMENT_MAIN_UV,
                ""
            ],
            [
                n1.FRAGMENT_MAIN_IMAGE,
                ""
            ],
            [
                n1.VERTEX_HEAD,
                ""
            ],
            [
                n1.VERTEX_MAIN_SUPPORT,
                ""
            ]
        ]), e = new Map, r = new Map, i = new Map, s1 = new Set, o = 0, a = 0, l = 0, c = !1, u1 = !1;
        for (let d of this.effects)if (d.blendMode.blendFunction === Ot.SKIP) l |= d.getAttributes() & aa.DEPTH;
        else if ((l & d.getAttributes() & aa.CONVOLUTION) !== 0) console.error("Convolution effects cannot be merged", d);
        else {
            l |= d.getAttributes();
            let f = "e" + o++, m = $J(f, d, t, e, r, i, l);
            if (a += m.varyings.length, c = c || m.transformedUv, u1 = u1 || m.readDepth, d.extensions !== null) for (let p of d.extensions)s1.add(p);
        }
        let h = /\bblend\b/g;
        for (let d of e.values()){
            let f = d.getShaderCode().replace(h, `blend${d.blendFunction}`);
            t.set(n1.FRAGMENT_HEAD, t.get(n1.FRAGMENT_HEAD) + f + `
`);
        }
        if ((l & aa.DEPTH) !== 0) {
            if (u1) {
                let d = `float depth = readDepth(UV);

	`;
                t.set(n1.FRAGMENT_MAIN_IMAGE, d + t.get(n1.FRAGMENT_MAIN_IMAGE));
            }
            this.needsDepthTexture = this.getDepthTexture() === null;
        } else this.needsDepthTexture = !1;
        if (c) {
            let d = `vec2 transformedUv = vUv;
`;
            t.set(n1.FRAGMENT_MAIN_UV, d + t.get(n1.FRAGMENT_MAIN_UV)), r.set("UV", "transformedUv");
        } else r.set("UV", "vUv");
        t.forEach((d, f, m)=>m.set(f, d.trim().replace(/^#/, `
#`))), this.uniformCount = i.size, this.varyingCount = a, this.skipRendering = o === 0, this.needsSwap = !this.skipRendering, this.fullscreenMaterial.setShaderParts(t).setExtensions(s1).setUniforms(i).setDefines(r);
    }
    recompile() {
        this.updateMaterial(), this.verifyResources();
    }
    getDepthTexture() {
        return this.fullscreenMaterial.depthBuffer;
    }
    setDepthTexture(n1, t = zi) {
        this.fullscreenMaterial.depthBuffer = n1, this.fullscreenMaterial.depthPacking = t;
        for (let e of this.effects)e.setDepthTexture(n1, t);
    }
    render(n1, t, e, r, i) {
        for (let s1 of this.effects)s1.update(n1, t, r);
        if (!this.skipRendering || this.renderToScreen) {
            let s1 = this.fullscreenMaterial;
            s1.inputBuffer = t.texture, s1.time += r, n1.setRenderTarget(this.renderToScreen ? null : e), n1.render(this.scene, this.camera);
        }
    }
    setSize(n1, t) {
        this.fullscreenMaterial.setSize(n1, t);
        for (let e of this.effects)e.setSize(n1, t);
    }
    initialize(n1, t, e) {
        this.renderer = n1;
        for (let r of this.effects)r.initialize(n1, t, e), r.addEventListener("change", (i)=>this.handleEvent(i));
        this.updateMaterial(), this.verifyResources(), e !== void 0 && e !== Nr && (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1");
    }
    dispose() {
        super.dispose();
        for (let n1 of this.effects)n1.dispose();
    }
    handleEvent(n1) {
        switch(n1.type){
            case "change":
                this.recompile();
                break;
        }
    }
}, e$ = [
    new Float32Array([
        0,
        0
    ]),
    new Float32Array([
        0,
        1,
        1
    ]),
    new Float32Array([
        0,
        1,
        1,
        2
    ]),
    new Float32Array([
        0,
        1,
        2,
        2,
        3
    ]),
    new Float32Array([
        0,
        1,
        2,
        3,
        4,
        4,
        5
    ]),
    new Float32Array([
        0,
        1,
        2,
        3,
        4,
        5,
        7,
        8,
        9,
        10
    ])
], xb = class extends Ei {
    constructor({ resolutionScale: n1 = .5, width: t = qn.AUTO_SIZE, height: e = qn.AUTO_SIZE, kernelSize: r = mg.LARGE } = {}){
        super("KawaseBlurPass"), this.renderTargetA = new at(1, 1, {
            minFilter: it,
            magFilter: it,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTargetA.texture.name = "Blur.Target.A", this.renderTargetB = this.renderTargetA.clone(), this.renderTargetB.texture.name = "Blur.Target.B";
        let i = this.resolution = new qn(this, t, e, n1);
        i.addEventListener("change", (s1)=>this.setSize(i.baseWidth, i.baseHeight)), this.blurMaterial = new PN, this.ditheredBlurMaterial = new PN, this.ditheredBlurMaterial.uniforms.scale = this.blurMaterial.uniforms.scale, this.ditheredBlurMaterial.dithering = !0, this.dithering = !1, this.kernelSize = r;
    }
    getResolution() {
        return this.resolution;
    }
    get width() {
        return this.resolution.width;
    }
    set width(n1) {
        this.resolution.preferredWidth = n1;
    }
    get height() {
        return this.resolution.height;
    }
    set height(n1) {
        this.resolution.preferredHeight = n1;
    }
    get scale() {
        return this.blurMaterial.scale;
    }
    set scale(n1) {
        this.blurMaterial.scale = n1;
    }
    getScale() {
        return this.blurMaterial.scale;
    }
    setScale(n1) {
        this.blurMaterial.scale = n1;
    }
    getKernelSize() {
        return this.kernelSize;
    }
    setKernelSize(n1) {
        this.kernelSize = n1;
    }
    getResolutionScale() {
        return this.resolution.scale;
    }
    setResolutionScale(n1) {
        this.resolution.scale = n1;
    }
    render(n1, t, e, r, i) {
        let s1 = this.scene, o = this.camera, a = this.renderTargetA, l = this.renderTargetB, c = e$[this.kernelSize], u1 = this.blurMaterial, h = t, d, f;
        for(this.fullscreenMaterial = u1, d = 0, f = c.length - 1; d < f; ++d){
            let m = (d & 1) === 0 ? a : l;
            u1.kernel = c[d], u1.inputBuffer = h.texture, n1.setRenderTarget(m), n1.render(s1, o), h = m;
        }
        this.dithering && (u1 = this.ditheredBlurMaterial, this.fullscreenMaterial = u1), u1.kernel = c[d], u1.inputBuffer = h.texture, n1.setRenderTarget(this.renderToScreen ? null : e), n1.render(s1, o);
    }
    setSize(n1, t) {
        let e = this.resolution;
        e.setBaseSize(n1, t);
        let r = e.width, i = e.height;
        this.renderTargetA.setSize(r, i), this.renderTargetB.setSize(r, i), this.blurMaterial.setSize(r, i), this.ditheredBlurMaterial.setSize(r, i);
    }
    initialize(n1, t, e) {
        e !== void 0 && (this.renderTargetA.texture.type = e, this.renderTargetB.texture.type = e, e !== Nr ? (this.blurMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1", this.ditheredBlurMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1") : n1.outputEncoding === ut && (this.renderTargetA.texture.encoding = ut, this.renderTargetB.texture.encoding = ut));
    }
    static get AUTO_SIZE() {
        return qn.AUTO_SIZE;
    }
};
var t$ = class extends Ei {
    constructor({ width: n1 = qn.AUTO_SIZE, height: t = qn.AUTO_SIZE, renderTarget: e, luminanceRange: r, colorOutput: i } = {}){
        super("LuminancePass"), this.fullscreenMaterial = new EJ(i, r), this.needsSwap = !1, this.renderTarget = e, this.renderTarget === void 0 && (this.renderTarget = new at(1, 1, {
            minFilter: it,
            magFilter: it,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "LuminancePass.Target", this.renderTarget.texture.generateMipmaps = !1);
        let s1 = this.resolution = new qn(this, n1, t);
        s1.addEventListener("change", (o)=>this.setSize(s1.baseWidth, s1.baseHeight));
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    getResolution() {
        return this.resolution;
    }
    render(n1, t, e, r, i) {
        let s1 = this.fullscreenMaterial;
        s1.inputBuffer = t.texture, n1.setRenderTarget(this.renderToScreen ? null : this.renderTarget), n1.render(this.scene, this.camera);
    }
    setSize(n1, t) {
        let e = this.resolution;
        e.setBaseSize(n1, t), this.renderTarget.setSize(e.width, e.height);
    }
    initialize(n1, t, e) {
        e !== void 0 && e !== Nr && (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1");
    }
}, BN = class extends Ei {
    constructor(n1, t){
        super("MaskPass", n1, t), this.needsSwap = !1, this.clearPass = new rM(!1, !1, !0), this.inverse = !1;
    }
    get inverted() {
        return this.inverse;
    }
    set inverted(n1) {
        this.inverse = n1;
    }
    get clear() {
        return this.clearPass.enabled;
    }
    set clear(n1) {
        this.clearPass.enabled = n1;
    }
    getClearPass() {
        return this.clearPass;
    }
    isInverted() {
        return this.inverted;
    }
    setInverted(n1) {
        this.inverted = n1;
    }
    render(n1, t, e, r, i) {
        let s1 = n1.getContext(), o = n1.state.buffers, a = this.scene, l = this.camera, c = this.clearPass, u1 = this.inverted ? 0 : 1, h = 1 - u1;
        o.color.setMask(!1), o.depth.setMask(!1), o.color.setLocked(!0), o.depth.setLocked(!0), o.stencil.setTest(!0), o.stencil.setOp(s1.REPLACE, s1.REPLACE, s1.REPLACE), o.stencil.setFunc(s1.ALWAYS, u1, 4294967295), o.stencil.setClear(h), o.stencil.setLocked(!0), this.clearPass.enabled && (this.renderToScreen ? c.render(n1, null) : (c.render(n1, t), c.render(n1, e))), this.renderToScreen ? (n1.setRenderTarget(null), n1.render(a, l)) : (n1.setRenderTarget(t), n1.render(a, l), n1.setRenderTarget(e), n1.render(a, l)), o.color.setLocked(!1), o.depth.setLocked(!1), o.stencil.setLocked(!1), o.stencil.setFunc(s1.EQUAL, 1, 4294967295), o.stencil.setOp(s1.KEEP, s1.KEEP, s1.KEEP), o.stencil.setLocked(!0);
    }
};
var mn = class extends Ei {
    constructor(n1, t = "inputBuffer"){
        super("ShaderPass"), this.fullscreenMaterial = n1, this.inputBufferUniform = null, this.setInput(t);
    }
    setInput(n1) {
        if (this.inputBufferUniform = null, this.fullscreenMaterial !== null) {
            let t = this.fullscreenMaterial.uniforms;
            t !== void 0 && t[n1] !== void 0 && (this.inputBufferUniform = t[n1]);
        }
    }
    render(n1, t, e, r, i) {
        this.inputBufferUniform !== null && t !== null && (this.inputBufferUniform.value = t.texture), n1.setRenderTarget(this.renderToScreen ? null : e), n1.render(this.scene, this.camera);
    }
    initialize(n1, t, e) {
        e !== void 0 && e !== Nr && (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1");
    }
}, JT = 0.001, r$ = 1e3, FN = class {
    constructor(){
        this.previousTime = 0, this.currentTime = 0, this.delta = 0, this.fixedDelta = 1e3 / 60, this.elapsed = 0, this.timescale = 1, this.fixedDeltaEnabled = !1, this.autoReset = !1;
    }
    setFixedDeltaEnabled(n1) {
        return this.fixedDeltaEnabled = n1, this;
    }
    isAutoResetEnabled(n1) {
        return this.autoReset;
    }
    setAutoResetEnabled(n1) {
        return typeof document < "u" && document.hidden !== void 0 && (n1 ? document.addEventListener("visibilitychange", this) : document.removeEventListener("visibilitychange", this), this.autoReset = n1), this;
    }
    getDelta() {
        return this.delta * JT;
    }
    getFixedDelta() {
        return this.fixedDelta * JT;
    }
    setFixedDelta(n1) {
        return this.fixedDelta = n1 * r$, this;
    }
    getElapsed() {
        return this.elapsed * JT;
    }
    getTimescale() {
        return this.timescale;
    }
    setTimescale(n1) {
        return this.timescale = n1, this;
    }
    update(n1) {
        return this.fixedDeltaEnabled ? this.delta = this.fixedDelta : (this.previousTime = this.currentTime, this.currentTime = n1 !== void 0 ? n1 : performance.now(), this.delta = this.currentTime - this.previousTime), this.delta *= this.timescale, this.elapsed += this.delta, this;
    }
    reset() {
        return this.delta = 0, this.elapsed = 0, this.currentTime = performance.now(), this;
    }
    handleEvent(n1) {
        document.hidden || (this.currentTime = performance.now());
    }
    dispose() {
        this.setAutoResetEnabled(!1);
    }
};
var mg = {
    VERY_SMALL: 0,
    SMALL: 1,
    MEDIUM: 2,
    LARGE: 3,
    VERY_LARGE: 4,
    HUGE: 5
};
var i$ = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D map;
#else
uniform lowp sampler2D map;
#endif
uniform float intensity;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=clamp(texture2D(map,uv)*intensity,0.0,1.0);}`, VN = class extends la {
    constructor({ blendFunction: n1 = Ot.SCREEN, luminanceThreshold: t = .9, luminanceSmoothing: e = .025, resolutionScale: r = .5, intensity: i = 1, width: s1 = qn.AUTO_SIZE, height: o = qn.AUTO_SIZE, kernelSize: a = mg.LARGE } = {}){
        super("BloomEffect", i$, {
            blendFunction: n1,
            uniforms: new Map([
                [
                    "map",
                    new ce(null)
                ],
                [
                    "intensity",
                    new ce(i)
                ]
            ])
        }), this.renderTarget = new at(1, 1, {
            minFilter: it,
            magFilter: it,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "Bloom.Target", this.renderTarget.texture.generateMipmaps = !1, this.uniforms.get("map").value = this.renderTarget.texture, this.luminancePass = new t$({
            renderTarget: this.renderTarget,
            colorOutput: !0
        }), this.luminanceMaterial.threshold = t, this.luminanceMaterial.smoothingFactor = e, this.blurPass = new xb({
            resolutionScale: r,
            width: s1,
            height: o,
            kernelSize: a
        });
        let l = this.blurPass.getResolution();
        l.addEventListener("change", (c)=>this.setSize(l.baseWidth, l.baseHeight));
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    get resolution() {
        return this.blurPass.resolution;
    }
    getResolution() {
        return this.blurPass.resolution;
    }
    getBlurPass() {
        return this.blurPass;
    }
    getLuminancePass() {
        return this.luminancePass;
    }
    get luminanceMaterial() {
        return this.luminancePass.fullscreenMaterial;
    }
    getLuminanceMaterial() {
        return this.luminancePass.fullscreenMaterial;
    }
    get width() {
        return this.resolution.width;
    }
    set width(n1) {
        this.resolution.preferredWidth = n1;
    }
    get height() {
        return this.resolution.height;
    }
    set height(n1) {
        this.resolution.preferredHeight = n1;
    }
    get dithering() {
        return this.blurPass.dithering;
    }
    set dithering(n1) {
        this.blurPass.dithering = n1;
    }
    get kernelSize() {
        return this.blurPass.kernelSize;
    }
    set kernelSize(n1) {
        this.blurPass.kernelSize = n1;
    }
    get distinction() {
        return console.warn(this.name, "distinction was removed"), 1;
    }
    set distinction(n1) {
        console.warn(this.name, "distinction was removed");
    }
    get intensity() {
        return this.uniforms.get("intensity").value;
    }
    set intensity(n1) {
        this.uniforms.get("intensity").value = n1;
    }
    getIntensity() {
        return this.intensity;
    }
    setIntensity(n1) {
        this.intensity = n1;
    }
    getResolutionScale() {
        return this.resolution.scale;
    }
    setResolutionScale(n1) {
        this.resolution.scale = n1;
    }
    update(n1, t, e) {
        let r = this.renderTarget;
        this.luminancePass.enabled ? (this.luminancePass.render(n1, t, r), this.blurPass.render(n1, r, r)) : this.blurPass.render(n1, t, r);
    }
    setSize(n1, t) {
        let e = this.resolution;
        e.setBaseSize(n1, t), this.renderTarget.setSize(e.width, e.height), this.luminancePass.resolution.copy(e);
    }
    initialize(n1, t, e) {
        this.blurPass.initialize(n1, t, e), e !== void 0 && (this.renderTarget.texture.type = e, n1.outputEncoding === ut && (this.renderTarget.texture.encoding = ut));
    }
};
var n$ = "uniform float brightness;uniform float contrast;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=inputColor.rgb+vec3(brightness-0.5);if(contrast>0.0){color/=vec3(1.0-contrast);}else{color*=vec3(1.0+contrast);}outputColor=vec4(min(color+vec3(0.5),1.0),inputColor.a);}", UN = class extends la {
    constructor({ blendFunction: n1 = Ot.NORMAL, brightness: t = 0, contrast: e = 0 } = {}){
        super("BrightnessContrastEffect", n$, {
            blendFunction: n1,
            uniforms: new Map([
                [
                    "brightness",
                    new ce(t)
                ],
                [
                    "contrast",
                    new ce(e)
                ]
            ])
        });
    }
    get brightness() {
        return this.uniforms.get("brightness").value;
    }
    set brightness(n1) {
        this.uniforms.get("brightness").value = n1;
    }
    getBrightness(n1) {
        return this.brightness;
    }
    setBrightness(n1) {
        this.brightness = n1;
    }
    get contrast() {
        return this.uniforms.get("contrast").value;
    }
    set contrast(n1) {
        this.uniforms.get("contrast").value = n1;
    }
    getContrast(n1) {
        return this.contrast;
    }
    setContrast(n1) {
        this.contrast = n1;
    }
}, s$ = "void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=vec4(vec3(average(inputColor.rgb)),inputColor.a);}", kN = class extends la {
    constructor(n1 = Ot.NORMAL){
        super("ColorAverageEffect", s$, {
            blendFunction: n1
        });
    }
};
var o$ = "varying vec2 vUvR;varying vec2 vUvB;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec2 ra=texture2D(inputBuffer,vUvR).ra;vec2 ba=texture2D(inputBuffer,vUvB).ba;outputColor=vec4(ra.x,inputColor.g,ba.x,max(max(ra.y,ba.y),inputColor.a));}", a$ = "uniform vec2 offset;varying vec2 vUvR;varying vec2 vUvB;void mainSupport(const in vec2 uv){vec2 shift=offset*vec2(1.0,aspect);vUvR=uv+shift;vUvB=uv-shift;}", zN = class extends la {
    constructor({ blendFunction: n1 = Ot.NORMAL, offset: t = new U(.001, 5e-4) } = {}){
        super("ChromaticAberrationEffect", o$, {
            vertexShader: a$,
            blendFunction: n1,
            attributes: aa.CONVOLUTION,
            uniforms: new Map([
                [
                    "offset",
                    new ce(t)
                ]
            ])
        });
    }
    get offset() {
        return this.uniforms.get("offset").value;
    }
    set offset(n1) {
        this.uniforms.get("offset").value = n1;
    }
    getOffset() {
        return this.offset;
    }
    setOffset(n1) {
        this.offset = n1;
    }
};
var l$ = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D nearColorBuffer;uniform mediump sampler2D farColorBuffer;
#else
uniform lowp sampler2D nearColorBuffer;uniform lowp sampler2D farColorBuffer;
#endif
uniform lowp sampler2D nearCoCBuffer;uniform float scale;void mainImage(const in vec4 inputColor,const in vec2 uv,const in float depth,out vec4 outputColor){vec4 colorNear=texture2D(nearColorBuffer,uv);vec4 colorFar=texture2D(farColorBuffer,uv);float CoCNear=texture2D(nearCoCBuffer,uv).r;CoCNear=min(CoCNear*scale,1.0);vec4 result=inputColor*(1.0-colorFar.a)+colorFar;result=mix(result,colorNear,CoCNear);outputColor=result;}`, GN = class extends la {
    constructor(n1, { blendFunction: t = Ot.NORMAL, worldFocusDistance: e, worldFocusRange: r, focusDistance: i = 0, focalLength: s1 = .1, focusRange: o = s1, bokehScale: a = 1, width: l = qn.AUTO_SIZE, height: c = qn.AUTO_SIZE } = {}){
        super("DepthOfFieldEffect", l$, {
            blendFunction: t,
            attributes: aa.DEPTH,
            uniforms: new Map([
                [
                    "nearColorBuffer",
                    new ce(null)
                ],
                [
                    "farColorBuffer",
                    new ce(null)
                ],
                [
                    "nearCoCBuffer",
                    new ce(null)
                ],
                [
                    "scale",
                    new ce(1)
                ]
            ])
        }), this.camera = n1, this.renderTarget = new at(1, 1, {
            minFilter: it,
            magFilter: it,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "DoF.Intermediate", this.renderTarget.texture.generateMipmaps = !1, this.renderTargetMasked = this.renderTarget.clone(), this.renderTargetMasked.texture.name = "DoF.Masked.Far", this.renderTargetNear = this.renderTarget.clone(), this.renderTargetNear.texture.name = "DoF.Bokeh.Near", this.uniforms.get("nearColorBuffer").value = this.renderTargetNear.texture, this.renderTargetFar = this.renderTarget.clone(), this.renderTargetFar.texture.name = "DoF.Bokeh.Far", this.uniforms.get("farColorBuffer").value = this.renderTargetFar.texture, this.renderTargetCoC = this.renderTarget.clone(), this.renderTargetCoC.texture.name = "DoF.CoC", this.renderTargetCoCBlurred = this.renderTargetCoC.clone(), this.renderTargetCoCBlurred.texture.name = "DoF.CoC.Blurred", this.uniforms.get("nearCoCBuffer").value = this.renderTargetCoCBlurred.texture, this.cocPass = new mn(new dJ(n1));
        let u1 = this.cocMaterial;
        u1.focusDistance = i, u1.focusRange = o, e !== void 0 && (u1.worldFocusDistance = e), r !== void 0 && (u1.worldFocusRange = r), this.blurPass = new xb({
            kernelSize: mg.MEDIUM,
            width: l,
            height: c
        });
        let h = this.blurPass.getResolution();
        h.addEventListener("change", (f)=>this.setSize(h.getBaseWidth(), h.getBaseHeight())), this.maskPass = new mn(new MJ(this.renderTargetCoC.texture));
        let d = this.maskPass.fullscreenMaterial;
        d.maskFunction = LN.MULTIPLY, d.colorChannel = RN.GREEN, this.bokehNearBasePass = new mn(new yb(!1, !0)), this.bokehNearBasePass.fullscreenMaterial.cocBuffer = this.renderTargetCoCBlurred.texture, this.bokehNearFillPass = new mn(new yb(!0, !0)), this.bokehNearFillPass.fullscreenMaterial.cocBuffer = this.renderTargetCoCBlurred.texture, this.bokehFarBasePass = new mn(new yb(!1, !1)), this.bokehFarBasePass.fullscreenMaterial.cocBuffer = this.renderTargetCoC.texture, this.bokehFarFillPass = new mn(new yb(!0, !1)), this.bokehFarFillPass.fullscreenMaterial.cocBuffer = this.renderTargetCoC.texture, this.target = null, this.bokehScale = a;
    }
    get cocTexture() {
        return this.renderTargetCoC.texture;
    }
    get cocMaterial() {
        return this.cocPass.fullscreenMaterial;
    }
    get circleOfConfusionMaterial() {
        return this.cocMaterial;
    }
    getCircleOfConfusionMaterial() {
        return this.circleOfConfusionMaterial;
    }
    getBlurPass() {
        return this.blurPass;
    }
    get resolution() {
        return this.blurPass.getResolution();
    }
    getResolution() {
        return this.blurPass.getResolution();
    }
    get bokehScale() {
        return this.uniforms.get("scale").value;
    }
    set bokehScale(n1) {
        let t = [
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ];
        for (let e of t)e.fullscreenMaterial.setScale(n1);
        this.maskPass.fullscreenMaterial.setStrength(n1), this.uniforms.get("scale").value = n1;
    }
    getBokehScale() {
        return this.bokehScale;
    }
    setBokehScale(n1) {
        this.bokehScale = n1;
    }
    getTarget() {
        return this.target;
    }
    setTarget(n1) {
        this.target = n1;
    }
    calculateFocusDistance(n1) {
        let t = this.camera, e = t.position.distanceTo(n1);
        return eM(-e, t.near, t.far);
    }
    setDepthTexture(n1, t = zi) {
        this.circleOfConfusionMaterial.depthBuffer = n1, this.circleOfConfusionMaterial.depthPacking = t;
    }
    update(n1, t, e) {
        let r = this.renderTarget, i = this.renderTargetCoC, s1 = this.renderTargetCoCBlurred, o = this.renderTargetMasked;
        if (this.target !== null) {
            let a = this.calculateFocusDistance(this.target);
            this.circleOfConfusionMaterial.focusDistance = a;
        }
        this.cocPass.render(n1, null, i), this.blurPass.render(n1, i, s1), this.maskPass.render(n1, t, o), this.bokehFarBasePass.render(n1, o, r), this.bokehFarFillPass.render(n1, r, this.renderTargetFar), this.bokehNearBasePass.render(n1, t, r), this.bokehNearFillPass.render(n1, r, this.renderTargetNear);
    }
    setSize(n1, t) {
        let e = this.resolution;
        e.setBaseSize(n1, t);
        let r = e.width, i = e.height, s1 = [
            this.cocPass,
            this.blurPass,
            this.maskPass,
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ];
        s1.push(this.renderTargetCoC, this.renderTargetMasked), s1.forEach((a)=>a.setSize(n1, t)), s1 = [
            this.renderTarget,
            this.renderTargetNear,
            this.renderTargetFar,
            this.renderTargetCoCBlurred
        ], s1.forEach((a)=>a.setSize(r, i)), [
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ].forEach((a)=>a.fullscreenMaterial.setSize(r, i));
    }
    initialize(n1, t, e) {
        [
            this.cocPass,
            this.maskPass,
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ].forEach((i)=>i.initialize(n1, t, e)), this.blurPass.initialize(n1, t, Nr), e !== void 0 && (this.renderTarget.texture.type = e, this.renderTargetNear.texture.type = e, this.renderTargetFar.texture.type = e, this.renderTargetMasked.texture.type = e, n1.outputEncoding === ut && (this.renderTarget.texture.encoding = ut, this.renderTargetNear.texture.encoding = ut, this.renderTargetFar.texture.encoding = ut, this.renderTargetMasked.texture.encoding = ut));
    }
};
var bLe = new E, SLe = new ue;
var c$ = "uniform vec3 hue;uniform float saturation;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=vec3(dot(inputColor.rgb,hue.xyz),dot(inputColor.rgb,hue.zxy),dot(inputColor.rgb,hue.yzx));float average=(color.r+color.g+color.b)/3.0;vec3 diff=average-color;if(saturation>0.0){color+=diff*(1.0-1.0/(1.001-saturation));}else{color+=diff*-saturation;}outputColor=vec4(min(color,1.0),inputColor.a);}", jN = class extends la {
    constructor({ blendFunction: n1 = Ot.NORMAL, hue: t = 0, saturation: e = 0 } = {}){
        super("HueSaturationEffect", c$, {
            blendFunction: n1,
            uniforms: new Map([
                [
                    "hue",
                    new ce(new E)
                ],
                [
                    "saturation",
                    new ce(e)
                ]
            ])
        }), this.hue = t;
    }
    get saturation() {
        return this.uniforms.get("saturation").value;
    }
    set saturation(n1) {
        this.uniforms.get("saturation").value = n1;
    }
    getSaturation() {
        return this.saturation;
    }
    setSaturation(n1) {
        this.saturation = n1;
    }
    get hue() {
        let n1 = this.uniforms.get("hue").value;
        return Math.acos((n1.x * 3 - 1) / 2);
    }
    set hue(n1) {
        let t = Math.sin(n1), e = Math.cos(n1);
        this.uniforms.get("hue").value.set((2 * e + 1) / 3, (-Math.sqrt(3) * t - e + 1) / 3, (Math.sqrt(3) * t - e + 1) / 3);
    }
    getHue() {
        return this.hue;
    }
    setHue(n1) {
        this.hue = n1;
    }
};
var ELe = new Ge;
var u$ = `void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 noise=vec3(rand(uv*time));
#ifdef PREMULTIPLY
outputColor=vec4(min(inputColor.rgb*noise,vec3(1.0)),inputColor.a);
#else
outputColor=vec4(noise,inputColor.a);
#endif
}`, HN = class extends la {
    constructor({ blendFunction: n1 = Ot.SCREEN, premultiply: t = !1 } = {}){
        super("NoiseEffect", u$, {
            blendFunction: n1
        }), this.premultiply = t;
    }
    get premultiply() {
        return this.defines.has("PREMULTIPLY");
    }
    set premultiply(n1) {
        this.premultiply !== n1 && (n1 ? this.defines.set("PREMULTIPLY", "1") : this.defines.delete("PREMULTIPLY"), this.setChanged());
    }
    isPremultiplied() {
        return this.premultiply;
    }
    setPremultiplied(n1) {
        this.premultiply = n1;
    }
};
var h$ = "uniform bool active;uniform vec2 d;void mainUv(inout vec2 uv){if(active){uv=vec2(d.x*(floor(uv.x/d.x)+0.5),d.y*(floor(uv.y/d.y)+0.5));}}", WN = class extends la {
    constructor(n1 = 30){
        super("PixelationEffect", h$, {
            uniforms: new Map([
                [
                    "active",
                    new ce(!1)
                ],
                [
                    "d",
                    new ce(new U)
                ]
            ])
        }), this.resolution = new U, this.d = 0, this.granularity = n1;
    }
    get granularity() {
        return this.d;
    }
    set granularity(n1) {
        let t = Math.floor(n1);
        t % 2 > 0 && (t += 1), this.d = t, this.uniforms.get("active").value = t > 0, this.setSize(this.resolution.width, this.resolution.height);
    }
    getGranularity() {
        return this.granularity;
    }
    setGranularity(n1) {
        this.granularity = n1;
    }
    setSize(n1, t) {
        this.resolution.set(n1, t), this.uniforms.get("d").value.setScalar(this.d).divide(this.resolution);
    }
};
var CLe = Math.PI * .5, PLe = new E, _Le = new E;
var DN = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAQCAYAAACm53kpAAAAeElEQVRYR+2XSwqAMAxEJ168ePEqwRSKhIIiuHjJqiU0gWE+1CQdApcVAMUAuARaMGCX1MIL/Ow13++9lW2s3mW9MWvsnWc/2fvGygwPAN4E8QzAA4CXAB6AHjG4JTHYI1ey3pcx6FHnEfhLDOIBKAmUBK6/ANUDTlROXAHd9EC1AAAAAElFTkSuQmCC", ON = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAAIwCAYAAAABNmBHAAAgAElEQVR4Xuy9CbhlV1ktOvbpq09DkiIkUBI6kxASIH0DlAQiIK1wRfSJTx+i4JX7vKIigs8HXpXvqVcvrcC9agQ7IDTSSWgqCQQliDRBJKkkhDSkqVPNqVOnP+8b//rH3P+eZ+199tlznVTlvVrft7+1T7OaueZY42/m37QALKNk2wHg1pITlB17mC+Pp11W3X/LHyT32vhg48/5SOv+PnwpsHA70JoGlueB1iKApeqzvOzn44GatTB76Xzhd7suBR7+WWADgDEAwwCG/L54b/poDLrHuvvm70Z2Avhsc+PVcxscBU8F8C8ADg5+ipIjD/PlGwfgju8B924E5seARUfLsiNmqQW0IjL8+7L2NYD/7COBzfcCm+aB8SVgdAkYIRCXKyDax4EdAanL5PuNPllNvXDlAHwFgP8AcC2AhRIoDXbsYb48dl5WkVFTE3LGDcC9m4CZCWBuFFgeAZaGAYJQQCRqDHT+McJrVb8zwATUXH02MHYfMHEIGFsAxgjApQqACYQORjtd/B7Axt/z79sC0+cMPgjjlwPwVwHcA+DfAHzTxcVgWBroqMN8+cYBeM71wH0TwKExYHYUWCIAHYRLTlkCYgcIBcAgU/n3qy8GRu4HRgnAOWBkERhddPAJhGJDBxkvw7cqimr+zFM/ZLnZF64cgL8BYD+AWwB8x/dlWuWagHiYL984AJ/0RWBy1AE4AizyM1yxYAcTigW55xMbAkxEiwEdkJ/ZCQxPAiOHgBECcKEC4TBZcKkSv+mTieNcNPNC26mLNsj45QD8LQDTAO4GcJt/7iw2bfoG4WG+vAGwm9ExiEg69zpg/wgwPQLMjgALzn4E4aIzoJjQ9g4024uygkj+pyuAoX0VAIfngOH5NgCHMhAm8Sv2y3XDZeBhNIp8OzJE8OsBzAKYBHAXgDt8/4O+MVT0j4f58o0D8Pxrgf3DwMwIMEPQEYRkNwfgsuuDZLskip0No0gWMD/9HGDoADAkAC4Aw/wsAgZAgs2Z0ABI0GU6IVmKv+f28KDnHxkA/G0A8y6G73N9kOCjXnh/Ebb6OvgwX75xAF5wLTA1VIHPADgMLDj4yIA5AAm6aCUnv4oz46eeDwxNAUMzwJAz4BABSNDFTwSfg7DDKHE23MG5PqIY8A1u/dINs9dBdy8AgnGPM2NfUBrsnw7z5RsH4IXXAAcJviFgluAbygBINnSLWOAjGxJ4pgOKDV0v/OSLKp8iGXBovhLBBOCQM2ACoTOhnYrAdItYbCij5JFzRyIAqRccAnDAQUjg6UNQ7hsMXP0cRQAexss3DsCLCECCLwCQzMcPwUi2MwAScAKbfnY/YRLFQ8DHX+IAJAMSfDkAF13kLvleIjhjQQHxUVS3jjgGpKeeNzYVQEjgUS8k+PghONdhIwAP4+XXBYCHKIJbwJyDTgaIAdCBJx3Q2M8tYAHP9m4df/ylQOsQ0JqtRLCx30K1wtLBggScQOgsKBGcWHAJeOwRC0BSM1mQIKRbhh+Bj98JQP6t4U0APEyXXxcAEnxkQAFwoVUxID9kvQg+c1C7vidRbIDkc24B//hTQGumDcCWA5DgMxASdNIFBUI5pCML8v8API5zfEQx4BudgqiczviSnJhQwCP4BMCGl+wO8+U7AJi/W4O4YS6+pmK/2ciADsAOBhTIIiAJnPB7AvNjP+0AnANaYkAHX2JBAc+tYaJXOqBZv24Vc386XW5dtkHGW+4HFAJonpOe+YYQZAShgKjv3PNvPQaxVoI8zJdfFwASfPzMUwS3Kt1v0UFIlos6oDFdAGFcliMAP/ryAEAGNwQRnDOgLbdlIEwrIs6AZ/QgkMMHQF6ZAKQcJAsSYPwIeAIk9wJgoPK1gi7+PwF4GC/fOAAvIQPSs0URTPBJ/Pp3GSEGRHfBCIQ0xowBtUbcAj7ys5X4Jfu1HIAGQrIgQRXEsAFQIORDFhiDY/rMHmrU4QUgR08AkgUjCAW6CD6CkwBsAIQC4GG6fPMA3OXiNzCg2I9gNCMksmAAoemDzoimFwL48M85AKkiuQVMAAp8CYRRDAt8GQiJ67N6GJODAXAHlsGguscA2AJg1IPGYmxOpBxFWkRN9LsATgIwXnNs/v/5z/9XCf8BO3YAtxbc/46/KDt+5+ea1Yku2VUxHz/z0v24FwMGK1gWsK2OUUxHHdCBeRUB6OxHABr4ZICIBd0QWSF+XRdMTAjgCdTrG9cBNwE4F8CpDkICyYLGsuhFt6zs+gISwUen8zEAjgMw4cfx2H6O/90yAFo84Cbg4ID3/9TfLTt+5+ebnRABkODjx0SwPi5ec/FrYpmqSAxM8Dn60CsqAFI6GfhqAMiDE/gokmvEr0C4PgDkBQm40wE8zMFEUDKEVoxIMLl/KS73mE7H9d+vcKHQQcjwW0Yu9nP8m8sAmOIBuWY6wP2/4s0ezjjg8TuvaR6ABJ70vxUApGrm7EbGE+i472BAB+WHfqHS/eoAaEwY2E9+wLSXTqhI7CXgnB6LCoOJ4BiST+hTnG0HcCwAglCx3ARoZEVFXnBPp/O/A/hXACc7CPs9/i1lAOyIB+RDX+P9/+pbQjjjAMfv/PL6AFDs1wFAgs/9fgKfgdE/ZEpuiQlbwAde6QAMBgiRmsSwA9BY0JfjovGRDBMH4TlcXGhcBOc6HkF0gjPhZgchxTLZMAci/04W/B6Ab3t09EPXcPyflgFwRTwgJ2MN9/8bf5qFM67x+B/aW4XQz42FeL0YrRyikztUFw0704mf9kXgxhOAqc3AAsPyRxxQCs/PdXOFY0W1KHy3QIUGtx+6vdnx1vsB+dsTncm2AogglFgVEAlUWrOMB2RyEmMCGQ/Y7/HvKns6tfGAnJQ+r/9b76oJZ1zD8WdyQjYBh8aBhVEHjELouQ8ukQ7VRSCJAALwkr+sALhnGzDD3JAJYJHg9uhoi4bx8ytkWUtvHT/7+Zc4dw1uZ3612fH2dkQf7yxIEEockwkJQn4IQoq8unhAhmPRKKFx0uv4K8ueTs94wD7u//VX9ghn7OP4c+4G7h8HpseB+dF2AKlFLwuAIZ8jD6NPrOhAffmfA9/ZBuzZCkyRWSeqBCWyoYGQ5yQrBpDbum/ME1HoPo0XEkSD2zlfbna8q6+EUJcTCxKEtHL5EQjP6BEPyIgYAZBvYt3xHyx7OqvGA65y/7/9wVXCGVc5/sl7qxD66dEqiYgRzAqhN1A4CBNAAlDyAFI+iZ9/N3DLJuC+jcDUBmCWyUnOrmTYCMIOkNclLg0B8/RsNLg9+UvNjnd1APLmmQpFHyEBROuWACQT8nN+H/GAvY7/VNnT6SsesMf13/CpahGnZzhjj+PPmwX2MYdDIfQexWyBAwEUOQDrRDN/98p3A7dvAO6fAA5sqHJDBEAyoUVGkwEd6HR12XU4kwzfl6fCXTZzjy57vvnR513X7Hj7AyDvggAUi9EyFgiZqNxPQF6345nOWbD1HQ/Y5fpvuLa/2+82/vNHgAPDFQDnhoF5j2C2qBWCI8bw1eRw5CL5l94L3DEOTI4DB8Y9OWmsEu/zBJ3rgsaybqBob/7A4C7jtWcooRrczr+u2fH2D0AOQgAUCxKEP7aGgLy64+m6KdjWFA9Yc/03/Osa4glrjr+AupqHz1sEs0cxG0BC9HIePLoit9eNkVf9L+DuUWByDJgaq4ybGYLPAWgiXmLedUE7dwC7saL7CqfPKXi4NYdaykCD410bAHlDEsNiwZ9wAPYbkJcfz6T2gm3N8YDZ9d/wHxUA+739fPwXPrSKYGb+BuP3jAFDElFH9HIWwbzCIGkBr/or4J4RYO8oMOW6ZVcAuvi1Cgoha04BCwT5gfMKHm7NoRde2+x41w5A3hQZkADk5+cGiAeMx3+/7AENFA8Yrv/G71cAXFM4Yzj+otOAaQLQA0gZxaIIZtMDFTigKJV8H9Iq6aZ59ZXAvSPAvpEKgBTtBODcSCWCZeRYtpzrmLyeGNCAyFl1v+Hei8qeb370Rdc2O97BAMi7EgB/2QG41nhAHU9LuWAbOB7Qr//GPRUA13r7Gv9FZwIMoVcEswEwfDoimEP0shKKtIphaZQAXv1+YM+wA3DEdcvRKkGJADQQEsQuhi1Tjt95vBsh5nx2IO59SsHDrTmUOStNjndwAAqEry0IyCMICkOyiuIBNwBvPFQQT7gBuPjc9oRYAIHyOEL4vIFEYVNaOou5vCGE/tV/A0wOVcnpzI47NOri3QFIBpSeaSDUdYLOSWvYImSGgftpJDa4MWJbAGxivGUA5MAOc0Be6eVLj7/4Mk+hzCOYPYpZDBiNkLh+G/M3yFyv/ltgL3W3YQfgcFUhgRY2PwY+Z7/EhAR1SFyXCOb57r28QfQBsJQBMn5D4y0HYLPje9Cd7RIC0PM3EiMofF4gVCBp1P840ix/gyz56r+vAMjk9Gl375iB4+CzveuZdLkkEPJ8ZEfX/6R73vOjzT5Si9hucLxHAVg4PwJgRwh9CKOXK8YA4ZEqKZXSQWh5P+5AftXfA/uGKvYjCKn72cctbFrZNECka5L5CPwIPtMH3TVz17MLB5gdLgA2Nd6jACycHwLQxFEUSR5ASvARDB0h9AQb9bXIgCGk6lUfAPYTgEPAITKgg1BObk58srTJgG58WMkWMaAbQQT1nc8rHGANAJsc71EAFs4PAagQestgC1lsBJ4BMCSOK6dDUcwqqaFiQr/0QeAAAdjy+jBiQQeeMSBZT3nCPUDIa9z+/MIB1gCwyfEeBWDh/BCAeQSzgkjFfGLBBD5nxQ4DxN0wv3hVxX5TBGDwL5obxvVA5YqYL5BeMLd66YYxJpRB0gK+96LCAdYAsMnxHgVg4fwIgMrhUPKQ2C+Bz0PmBTqBMQehAbDlIjj4F80KJguSVZ0FuXpjoCOgXawLjALhbT9eOMAuAGxqvEcBWDg/l1IE05Ed0ygZnyHdz0VwCqEPIfNyx0QQvvLDFQCp+8nfZk5und8tXwIgWcHSNX0N2CJmnAl3v6RwgNnhl17T7HiPArBwfghAS7mV/hey2JS9FvM3BLpUUi1YwDRMXvkRYJoAlAh2l0dcZ04s6JUTDIjyBcrl4yDc/dLCAdYAsMnxHgVg4fxwKVwJgGEJNmWtxpQMpX9on2eRhVA+O56AjMfnP+e3Xvf3NwG4xIPTleiY55bpGh6UbafNU0l0z0p+5Jh5HqYJ6b51nP6XP8cx12XNHQVgIQB/bFPVg2OC7Q+WgVFWng/FvtWLI06uWh5oguKEcXVS/9sEAF//VGD7t4ETDgJbF4CNi8CGZWBs2fPL/H6Vwp2KEtVk4fJ+v/EIYPN9wKa5qu+IncfPwXHVZe/aOL3EbwS7xv8A1rQvnO0j8PArTgTGZ4BxFv9mIxhOCGsv+0OPYDRghcLfkWkEuq0+G00x4OtfDGz+d2DbHmDLjL8si8AYP/7CGIAiEEMTG92zXqSbH+d9R2aA0XnvO+JjthiIrOVDHHPOkBrzUQAWAPsZp3oPDpa/Xag6EVkLBK+5rAnJC3/nYk/APD704WiEAV8OTHwX2LQH2DgFbJgFNrBhjd8r79deGoEwsllgNBOzy8CdjweG9wBj08AIAci2D6HafmyAk4/Z7SJ72hGYRwFYAMDLTwOGp4FRFgD3HhzqRGQiyeurqOdG6r0Rm8IEZjzRlkiqCWoEgK8Axm4BJu4HJhyAbFhDxmbDGnZO4j0SgLGDkpibgEq66TJw/1nA0F5gdLpq+zDqFfd5LMeWqu5HNST0uJOIllg+qgMWgI+HPv0xwLA3gWHpW2sC441gCECbmKziaGrnUdMO4aHeh6MxAP4SMHI7ML4HGD8AjHvHJGNAgpDgY/ck3stipRemvVhc+uASMPUEYGh/9dIRgGx8Y+MNbR/00uVtH0wEx94j/v0oAxaA8Ed+GBieAYZZg5kADC0QWGOFzGJlcGPzl1BxNLXD8sk4xftwNAbA/wwM3wGMUmxOOQBnHXzetIYvibonmSiuYTNjriVg7glAiwBk0fNZH6+PmX9P6kfNmCXGpftJ7TgKwBIAnln14BAAYxMYm5C6RjCyCoOyr0qkD/c+HI0B8DXA8N3AyCQwesD1VQKH7EcASm1Q+y4CkN9pUKiVF5nLvy+fBbTUd8QBaH1HvNBROiZvfsNnrF4kcvPwpdsBLBeU18Nf7AB23Dp4ecHC8oBgUlJJecLS+7+WOpE3gbE+HKw+yoevCYkMGKqPJrdEKARutaFYRs1fiEZ0wP8CDN8LDO8FRqYq3W10pgKgfYLaYCzootgA6KXaTA90y374TKB1sBozy77xHFZ536utRgAmEaw6g5kUSFZwSXnA330qsOlfgHMPDlZesLA8IOjoLypPWHj/11EnCiVwkz7kAExtsGraYUWdSDX5TmsagL8KDBGA7Bd30JsW0oWivnEOQNP7yGTSBR101AlZSUtGyfgZDkCWY1HnJdcBVe6325hTvelg2CQjZNDygG/2An0j1wKnL6y9vGBheUC8prQ8YeH9X39OVQSc7Mc6fCaKvAeHdCIVf4yMYCynTpX+nb97NJmlSQb8r8DQHm9YOFUZTKOzoXGhs6AxF0HIexcLBvWBuiHN8s2ne98R3qc6L4Vyb2oBVjfm9MIFHbjDCh6kPOBbQoG+oW8CO5bWVl6wsDwgfr20PGHh/X/1iaEIuDcCTIW/1Q4rFv8OnYiW3c+W2iKwUjKbyjQNwL1uuR6sAEgDgq1brXOmV81PxhNB6DUDBSYzQJwFtz623XcktX1Q1VWKaTF/zZhVazBVYA1tX5MazsGvobwe/jQr0Ne6BTh5uf/ygoXlAfG60vKEhff/rSe1i4DnTWDUACY1guFTDqLYdCBvf6DJYSMYATBfOx1kLfj1v1axH10nQ3Sd0GUkBnTfpemtBJgseIKQAHLQcVxa2TnuMW0Aqui5es8xBIegVdVVE8VhzHnLh65WMB9An+X18K6aAn2tO4ETl6vqbKuVFywsDwhevqg8YeH93/Rk70JE90nowxZbIJjvS3WYNSGUwGHJTpPxwwcbBuBrgRYBeKACn7VtpdUu/c0NJxO9BIxcKu4TTODzbkonPLoaL0vyUQRb2y8HsL1ckfWzMeuFi40Qezqi+yiPhyt7FOjr6/gCFwgP7Xb5vssTFt7/nQRg6MGRWmDRoeyTlpgw68GRTwgZgo1gGmXAX6/8dtaylSKY/koyID9BhzML3q1gAos2AcOrZYSoq/pJp1VtODRm9Z3LS/7WjVkvXOzEtOpKyGrlAT+4SoG+VY8vBGCvy/dVnrDw/vee65NBJiAjBIVcAJQjOm+DkCZEeiGAMw6sAwDZsJrAdhFM9rPGhd4904Co5oVuCZPV6kD40Ec6+9W8dBTBsfdc3nkpvnB82fp2RPcs79dHgb51LA9ofsDV6vut5/3PnxcAmLVBiDqgevDaJLkYrpuQxzcNwN8AWgIgRbB8loEBzXDwl4cGiDGft58SCOWGedgjvOJ+bPvgRkiuA+ZjzhnQQOiFNVbloa7l/fos0LdO5QENgEXlCfs8Qbf7HyMA3QVjYihYhLENgjX9y/qwxQmRU/asfd0ZcLU2CHVGyusJQLKfVi98CS12T5f7iECkHpsMkAhCF8+nshWH2I/jXsOYO144GV/9ApAIrS3vt4YCfetQHtAA2G+/4PW4/2PPbzMgmUMi2NoeSCRxIt2/FvuxWURIWCXg357gfTjEDNIHnTRXRCpH5ugKwGl3HpMBXQc0v6WLYVm/5limj04rG762K2uYY9jBkr9+rI03NL5ZbczS/dJ+LQyoga4o77fGAn0NlwdMAOy3vl/T938KAcj121z8Bn+Y9eWQJRz8Y6kNagDh2ey5EvxjxQD8TWdAuneCCO4An1vw5vdzQMmdktwq7pLZQR+dM34+ZumAxvY1Y04uqOAJ6FsExzeto7zfAAX6GiwPaLWR1lrfr8n7f/Rl3QGzmsis+/uO71V9OFgP2gpPhgr7TGRqRUT6dyvr4aIs/pm/2zVUNbBSv6G8e5pEv0Cvec7Po7+bTtjlBRlkvAMBkDeQyvsNWKCvofKACYBrre/X1P0/oWEAnnFD1YdjhtXxR73mX10FfCHHE9pVWcGAI/S0gKsfA2y+twrFZw6Hxf/F0Pk8Ri/kpGSnMuDx5T0iACgQHioo0NdAecBUHW6QdsV2/cL7v/Cyqr5gnc42CCOcfX1VIZ/V8We9IDmTzVXwPDJiXuKXPxtDBma8+lzP4WAgKkPxCUAPE4v5GzEuMX0PYJPLhB6FJsc7MAMmkVxaYC/K9gG+F1++8AQ7Gwbgk78I7GFpXgIwFiRXOwaJZPUbiR0yCUDRk+cHf+YpwMj9HgfI8ClGPyvsSiH0WSKRuYlitLb/zHM/JOSs5C/YIC9cMQDZr/dwxgOW9gtGYUBi0wA8l304vDQvAchilFbpIBQhZ7Ejq6ZQ0/Yhil8y4j89Axie9DAsD6FX9HOK3QtROTFkviN83kG4felIY8DCeLrSeMDSfsEovAECUFsTjHD+tcB+tkFgcXKvBRir7qtFl9owmO4Xy/1G3bAFfPrZHorFNWBFwHjQAFctIghj2kBarw06If/+MM9ZqTN6DgsDojCerjQesLRfMApvoGkAWh8Ob/tgAPSKWCp8ngNQtadjmTdltvNvn3peFYhgQQgh+iUmEaUAUoXM1yRLmWuFLaE9Z+XIAWBhPF1pPGBpv2AU3kDTALzwmqo6qtVh9kJErAudABia38TC5wJgS2xIhAwBn3yhByL4EhzXfRXxYsDTJ4IvrNN2JFMxZcBzVo4cABbG05XGA5b2C0bhDTQNQLZBYH1AVsQSAAU+imI1obHyblnjG/kJk3U8BHz8xVUQAhnQIl5CyNgKAGp5LKSSCoAySh5Jj79vTagcxUaIBeRNe79g9gq+DXig4wGzy+PONfT7RWFA4noAkGXZVAhcBckJQgNgrLiaNb3paIDo1vHHX+oA9LQBi4DxJcOUPJUnTgU2NJUyROs8irGARxQAC+PpCtsFd40H/AEf0gMQkLgeACT41PiGoLOKqyrJq3K/Ya9mNyr5FusN/uPLPIeDa8Bc+w3rtyl4VFHaMZc3i9RWBM9jjzgAFsbTFbYLRmm/YBTeQNMAtD4cBKDXBTQGdAB2MGBo8SCLmEuS1AFVAJ3A/NhPt0PoCcA8bSDG76XI7aySg6JYuGfKwJHFgH0E5B3ueMCe/Y4L+xVHAOZ+9EHcEgQgwbeiEYx6jwTdz4qfu7EhEJqxGqruf/RnHIAEnxgwBM0aC8aUAYWNBRCmoIll4HTqO122QcZbrgMWxtMVtgvuOx6wa7/jwhtoGoDWh4MBJ16WN4lfr8AqI0TVV1O1fa9BbQzovkAy4Ed+NgCQUSxZCFWvCOaOFREXyUwZOPIA2GdA3uGOB6wPaOz+QPv5S+MA3OXiN9aclghW+d3IgupBF2pPqxcxGenDPxfSRh2ASiKKiVP2PaZScvAKoA0VDc6cOlIB2GdA3uGOB1zR77iwX/F6AFB9ONSOQW0frA50sILVcckWJyIDSgwPAVcJgFbYuZ3FJvAlEHbJ3IsgJLGedeBIA+AAAXmHOx6wo99xYb/i9QKg2iAIfDJEJHqj4SExbEty0gkdhB/6P9oZbBZIGiKYVb9GKaN50lRHBLOvhDxh/5EKwDUG5B3ueMB2QGM/grb7/6wHAPNGMAY+GSGUjC52VX2f2CD4+HO0gqkZfegXKgBaHkcWtS0AWii9xG1ImrLlN5XR8L8fmQD05BVrmEENmpYSP9QX+KHiqj2/82+HqqDWwnbBRfGATdzAegGwru2DpRq7Mzq2fpAf0Nq0Rl2wBXzglZ4yUAPAmDSVWDBPHQjLcgTqOZ6zUvdKHh4ruDCerox/Dnu7YqwXAC1NI/QcEQuK6WK/kdgCTGC0PYAP/KIDMBgglq+hIkrOfsaCviLSofcJgJ5AdM7kkSaCj/HqQKVIGvD4swF8bcBjmzjsaQ2H5D/6acBd9wALB4DFWWB5AVherMp4GKIYEOp7+26UF0aSfT/xYuDG7wDjrIpAERytXf2vajj7ueryQXSFl10K/ON3gIWDwCLvjfGB8Z54O+Ee4ve6513uB2R1yzsqC+twbC8HcNVhfAeaBuDP/TvwtS3A/ePAIfYFVlPq2HHTuyulZCTlhbjhETF5yxTQGgPGhoHhIWC4VSXGD3n0tLkMHXHxu+YyB+MlPwDuZs5K6FlsbCzdVO9DuKfkHM8AEkP7B8fOkwDcD+B7np42+JkGOvKdAL4E4K8P0zvQdET0b14D3DgB3D0B7B8HZka9WzrD88N6sFm+YcUjrn7E1ZDvMtF9DBgeAYaHgSGB0PNHCD4BLwLRsByAyX/ij0/dDUxuqlIG5hix7eFhvLcOVUAtyPSydAFmOQNe6EYGV/9ZESiKgIEgtbaD/gHALQC4ovY5r5KwtjOU/XfTAHzzLuCmIeDuMWDvKHBwpMoN0WQzNtAaYSs0K4ZlOSAjGG9kPjCBRwZ0ABKEBJexYAZEAU3A7Oi1BeDym4EDnjQ1TwCGWMW8MXcKks0YOyZNlQOQjcgYIUHllEzYQ0ktm+r6oz8G4F4AXwXwRd8/kO9A0wB8y65KmPxgGJgcqYJTKYpTv2CCzyddQJRDOjKivn+Deh8BF8BnwBtaCUA+YYEyAU8h+c6Az9gNHHRmrgOgmDA3jHQ+iWupCeUAvNSrA9HNwqx+muk9nJVNg/CTfrmbAPwbgK8D+PcHkIibjob5o13A3XypWsAkG1cPA9PDFQDZM1id0i1KxsWfOrKnAFXlifCFFMMRcASigOcs2MGAIfE9iWXplS6On7UbmPaUUTXQrgsVMzcRj5Folg2V5ayUA5BWYKwOxKUafnosWjcJwk+7W5F2EKvlE3xcXaNYfiCYsGkA/smuqug6hcleAnAImPbO6YwRpMgjCAVAm/yQmKTv5hNsAf/i7SyNBSl2a8Qv/4/M1yF+BZSYlNQCnnVrpbC+mToAACAASURBVJcaI7sOSEY2NpaDXLqpR+vE/OVksDgImgGgghHoYJbTWc7oJtFWc65/cg2AYvh2ALsB3AzgVv95nS/f4QdsIkT9T3cBrGtITWZfC5hqtQHInsEGQn3UDDvEDEY/ICf7SxMOrAg8T+c00JGkvHGd2DABUYZIAONzCUDppCFhSukCBsLQrFtZe/IixYQpSyEoJoqnuPWrVRAubQh83HNlZB23z7j1ywmj6CIIqUPxw2Xeu9bx2jx10wz4Z7sqTYZaDD8EIDuoE3hMVEphWg66JIp90k0sBxBcy+iPIIaT1RtEsHS/yIAqw+VSNPWQfe5tlVEk8auXgVa5BUsEJuT5uoliAbE5AGotmIAjCPnR9xDG3TQernYAUupTdBGEFMf83OkApHG+XlvTAPwfuyrgSZOhas3u6cwTsUBVn2gTwyFMi8wjHZAA1M9fYGHDULJD1m8Cpa8fRxDad+l+Ykf/3XNvd11U+qiL39SxXevSsshdDFvgbI1O2AwAtRZMZzTBRuDFjxe1Xg8QEIB8yyj5yYIUxfQIkfkIRnmHCM712JoG4FsdgHHp3ACoMH2G6jM4lWzoQarSvwQ6MSB/vporVaFkh+mCLlpVR8Z+dqDZLoDOpHSiQeAFDkBjPrlgCHgCUaFifg67H/9uYjn4Ai1vpTERTAASBaoQJBAKeNqHlL6mwPDZYAOROag/EYRkPX34MwHIvzW9rQcA+TLpI22G7EcQKlJGsYIJhC6ClUMiXfBTbFUQAej6nPS/OuAl9pOOqIc2BLzg++3VmWgIEUz82cRuCAtLIHQQm0gO52uOAb22sC3JEWgRfPpZf2sQBQIgLydPEIFGwPEj8MlF2bSbsulghLftqsCXq9HGgHysznrGgi5qzTUTFH8FLhAUn3hIJwCN0HLncw37qaF2zoYvuKNivmQIuUNc7GvWt6sHNs26twA6vhyq8NEMAHlyntFrDCcQehyaPTl+FwAbXDcmAKMRThakEk8Q8kPg8SPL0qzLBl+A9QCgR6uZGs3vfHz8TtBZvkgGQrEPBVAUg2Sij50QAOjiVKI3saADJRm7dSLYWfSFDkCem/dhZeMy9pPY5QvSDYQyUJoDIK8qMezh3wY6fSL49PcGgCAA8pScJLIgAUYQEmz8RPA17StvGoBv39W24eREiBoNQSgWNI1HBkdgxJSw1AI+dFIbgOYmkjimQ1r6XXC3rAbCHycAgytohf8vsB/r2KRaRq7zpZ+D37HMX0s3DDcCUGLYaw53MJ4YUODzusqlGCQAOQCejuxA8UULUkxIwAmMAp8Wa3qkN/R9W+sBwOhIEPjk5SLr8HeKFbTQfb77csPIMHGl/4MPbReslPhNe4+MiTpi9AFGV4nI7MfvagNQLh/pfrYnDAS8aJQ42A2w4em2cAyWQUuJVQTGWLs1uL7DG9J1RjhA+jvYk4t3KXeMqijpzrud4At9z3XtP16yGfjKZmCGooYh1tZzvv8xXPFl4PoJYC97k9FlwZWD+Azi/deMZWeP13eQCGEyoERudChIjbb3mJYwH7V0QIKuCwj/gfMj0asn2I0FXRSHXfL/iRkNgLyeVj8ccMY//J1fyxzTAXT2+xoQViKYD/1hDqLxPiYxTgSvQrphphG97tz4Slqafnj7uk1kIQDZrvWTw8B3jwEW+RLxPgSiCERdPwPR7+wCPg/gulFgfruDkOMQkFc5x84e708JAMmCuRNBXi4TIg5CGRzGiBGE/D4E/C2r2vcAYJoify62i0aJSMhB+2IHoNwu0fkcjQ85pu3ack5nIBREqneYFyWLkAXIJHESe00Cyx5QyeL6F/tyEcDcrOW2n7fX8df0mME+/vQ/PQjhoy3gzo3AISYf80MQaQx1peH9wb7v2mrtmCBkIMMejp3jIJD1MsaxaMZ8v5N/67INAsB3BAYU4JL4DSo1J15AFPAEwuQHZJzkKfUAtOHLJSOQRWndBYQvCQA01cfnNopfsaCJaD2baBn79QjSTiOEP1EcawIpkq2kegBTNgHWEpOKF8Uwq2NRFPM4AqCf46/rA2U9/uVDvurB01zvAJpiiwOl3fEeciCGF+Ij11f+QkbSfMPfIzqw57mEFZ9Dl3Ps5HXWAYByHJAJKV7N+s0cCQQhwSlfm4lGZ0KB8C/rABgZUS6ZHITBSEhCowUYAAksF7cStWREyxRwtuPpOlgw+5s9sq6OaIJIIlUgEhA1edoTgHxa9HVw5jibZNF+j/9yGQA/7pbujZ4bwv2+cWB6tFo0NzYnkxFA+cvEAo43VBoEo2e+48EMXEOmD9F6xhCE8RwZEJ80VblKvDlmzwicfqy93/o+8K8TwB2jVSgW138FrJQTXBNlnJgmrjZwanow9CBP/rL9wF0jwAGWDtFyoN9PHutnIHT05mPXz93dMGQAPniJsjiBXiTbxDZFMF9NLUPQxKR5qezz1Y6/YZDH0D6GkdAkYJIvRalAdHAMmPZoYhb6NhDWvEyf/ma737CXN7R1ZC7hUbPgcFgqt/ZZjADnM1xqEVhYBpb4CUk5UsL7jQvj///5buDrLeCOEeD+YQchYwG9VIfyg1NaZszFiCH6DkRGLze5/dgk8IMWcMCjdCiCzR8od1B8OTwvJM8JEShFut1fzMhi+eRJr6LI7hYP2M/xVLwKNoZjUTwRMAQQmYyhWGQxsSADOflZ4kukj7PhZ75bETjBpkAGahMkcrGgwhsXeCyBHBj1wmOBQwvAwqKzoFeRV8ZaerjKYAuirmPY/o9X7q5Cyr7fAvYMAftCPGAEoYlBiVtFwLjtp2U4irj7yOANbi+crHyrfCbTquJV44O0F1FrwQGIMZFqdQDyP/gGSZ8TC0ZRRsOlVzzgasd/u+zpMByLehAfCgMQCDyGZJHFCCgLZ2f8mgI5qauEcVx9e5vACTgCTwEMWr5TdIpWKJb5MvrnoocDswvAPAG4VLGg6UKeqmi4iuDz4er30oX0FP7u5moMvIf7W8B+jwlUNAzFnlZCIhvGFRCeWzrgXSSIBreXTFZSgVLHAp4UHOFuociEEsn2PJwl/XEk0dzfSojeerFg1IOo5BKAveIBex1P67lgUzgWQaJwLAKRH04i14ItgDKEtGsRnWx49b2Vkk9wUefTGrKCF7R0JxZMqxN8cmPAxWcAcxGABKEAKPA5u9lEaAbCmKMI+sDN1X3z+ro24wEZFc0VEE64ABgT180PF9ZdBcDb6JpqcPtPk+1ACbmKjJnllwyuILunEAWjZHkBsrsRUnfD0qEiC5IJfyisgMhzWhcP2O14Ro4WbASgAMQJ48SJwchmBCDFa8qpyBbSP7OvU4PQ0p2W7+LSnSJUFOrI4V7w5IoBTQQTfJ6oTSYk2mQcpGRyH2syGjIF6EM3V/fM++C1CfwUExhCsmzCaQT43lZC3e1hBpEHh36XEqrB7Scmq5dV0XZxmV8WuDFzAF9iwhow9seAGoBcGtKjqAc+1l9rLb/1igesO55ysmCrC8ei6IxRMAKTWNBi6Xw98xNTFUi0jEcmpYgRAPhddpVi9OIEPP5cYD4CcLkCooHPwaW9kV+iwWrQHT8uA1fd3F7DFvgUHUP2k8jTiogAqLoxFpDgbMj9jXSuN7i9dLIdaxzBp5XVBMIMgFEnFAPKT9qPd6A9BIGI7MfPmf4U+40HzI8nWgq2PBxL4FEkjKJixGRRFyQQPzzd1iAUzCAQas1YOmAEoFjwkecDC/PAwhKw6CxIkCXwOdVJLxTobMjBdyIgfvimNvNJ7Evf4jWtdnRYD1YNGVuG93VWuWs4Jf+mlZCCZxwP/cnJ6mXVKk2+tK8lQQVHRTGc64SDAZB3Ey3JcxyACkToJx4wHl+YwqloGDICmYmTFgMQFBET8yyYzyAG/AfWX8mCGQg0BTRoHwt9KVaPE/HQ890AIfgWK+CRAaMRYnVdxHbhdY8Wslw1V93UDsmPIj9GxgiAioRRMIJNvoti+SW/Ikd0gwAU8+XxJcbGITJPDvI6XdCFREFSknTB83xka40H1PGF9dnycCxFwygkK0bASJQSVAbAYeD98xUAe5U3jKIwBosSgNsuABYogl3/IwgFPrOIg1Xc4ZrpAsSrvruykl2ucykapkMMh4CExD5DwJfWAYAxwk4MKPAJgOIjGSEGwuCakRhemw6Yv0UUwRf7L00L9pnsNx6Qx4feY4O8pDEcixOjsoTKKpMYjSFYYjOC8Eq3Wnnr0YYS+0Tmi2HysrPGLqwASNYzBnT2Mz2QD91laxLB0gs12GAh81cf/o/OcHyJ+qj0S/zxnhUZbSyYWaL8+Rq2S29wowiWkJPan4MvgrDDGAlRe7KIywDIgR3meEDWg9HbJgApNTkXo8o0i7oVgxnEgFr8F7jEdnU5GvqfJQKQKyEOPlsNIQvyvupAGHS/Okv4qv9oh+PHxMLk8ggBCRxvAmEN+AiEzz2iQfQBeNmkh4K52hJBKOaNe/FSLobLRXCz43rQnu2yi9oMSMDxs2jo8303ERz1wsCGZECF4kd3DwEYYwJjhoNlQrgIjlYodbBPrwMAZfEmyzcIv27gs6XDzC/IR1DOgA9a6DRz4wZAsZ+LYXvQYsHoD4ziOFklna6YD3+nnU6dZ7bGDAcBUImIAmEUw/zbJ1i/scGNDJiLXmle3RhQ+l/aq57gUQCWzwwBKPeLsZ/LFrGg/ShRXAe64Ajkv30kALAjF8R11Dy3K7KRwJcsUTaqWScARou3w/INVnCH+A36n8RvM3nB5XP4oD6DATBYwGb5ajlOLOh6X8JaBKRG77+7ygGYp1bn+V25/01AzBnwQ1ypanD7KWfA1QDYC3zJIj7KgOUzc9nFbetX/r+O5biwNhyX5uSEDr5o0xsJwLp8/m4A7GaJUv/j3/5+HQFYJ3oFPPkho/hNeqBcMkcB2BAA6XrxmMBkfFAci/m0JpwzXw0TXvXtzrz+PKc/Ml/ugzM9MDqCAbz/keVjjGcQA/YLvjoguo1mRslRI6RwfsiA5nqhL5D6nscF8gfTdfxpS+/hLzvWfzMQCoB1Fq/8b3VWaPIDZqsRV64DALsZHVHs1gEvsqFAeBSApQC8pHK90Oql4UEAyvCwNeGcBXNLOPMLftgZsI75ouUr9ousp2TEyIJ/sU4AzC1e+WIFshyAHPZREVwItrrD3wGAhibTYBhxVpe/xePyrNBuWaoNp3DgFwC81O+RAepK/a5Lfe51jxr7JwA83nPXYgq1asl0yX5N48+f4VEGLATlK1vAo5YB1gBSRmsM+NFE57lcfPD5pPFWCJImtyvGgGfOAacBYO59zFglgHgPefZsXV6/gPXBYeC0RVgyJNOGYuJjPka9eHWgjL9bWzhWk0/n/wPn+k8bgFNmgYcsVflZnBRmIShtJM/m7JGibGBoOIIez9wKPP4AcNpylfbNlGfdI+9NjBjz8JVzppckZuJ+dBw4aQ44drk6j1LIY9JkPD7P4s2lwVEGLHwJnncscNIh4Nh5YMsSsHm5ndOu1BGFThJ8/K6JrZtoslST2+XHA6ftB05ZAE5crgAups5TfaL6EF+UyIif3gAcOwtsXep82eIYY9JkXpMgMp/AeZQBC2b8OduBYw8C2+aALQvARgJwGZhY7swEzbNa88IRvAVO1qkF91J36DNOBE7eD2yfB45fqphLnevzdGeBKBfL8UX5/CZgyyyweRHYsFwxYHzRNK6oetSBMDLjUQAWTPqPngpsnQK2zgKbCMAlYMMSME4ALrcnR6JYQIwsoUnjpDRstOLy7cBJB4CHUGwuAtuW2nUDVH1EFUhycSwWjGD64mZg0xywcaECoI0z5P3X5P6nWlHdgHgUgAUAfOYOYMtBYNMssHEe2LgITBCADkIzSJZXpCOnIg25uPrhgnupO/TyhwLHHwSOmwW2LVSik2pCrDsQskzNIBGIpBdGI+VfNgMb5oENCxX4yPRjPj4xaJ0+WGeEHRXBDUz2Mx4FbDoIbJypADixUAFwzAFI8KUJChMV2SUaAGc1cE/xFJef3FYRti64nkqWDrqqEhbrsm5zvZCdPCd8nHzJOLZuABRz9hTHZwPL7LnLnoNMIY2VyaKcjtZLHOAbNgNPngKe4BacfGF1pnydD+hphQ/8XV5UiEueLGnDN1tWXj/3/4cTwAUzwGPcRcFJiDpPt3FLmf5vjwE2HAQ2zPrEzDv7OQg5OSM+ScYQy5Xbo8465u/ZfLTJ7fKHAdumKxVh8wKwealSE6inEoSy2MWCdbUHIghv3AqMzwHji9VLZuDzD8cXxxWZs5c7apmW0fMBnIHKn5X7d6I5npvRz94O7LgXuGIReJSb+Xl1tzqflybwRwqf9i97BQRWomWJQ7oZVFtJoqDX/b/oGODsvcBTATB9gsfGqmzdjtVz+G+PAyamgYmZCoDjFE2anCVg1CeJwOMnTRB/DmUINVkkgia3y08BtkwDW+YqAFJFMD1VAAw6XG61R31O9/fdrcDYPDDmY0zjc1UjivBuAMx1QdMB+WAYXU8dhEU16dOSkppbcHFSrng8MHwnsGMPcN5ypURHp2xMIa7zDz2z8Gn/kVe0YomO0wEwBYKujL7v/zHA6C3AxfOVh58g5AsZxx4fZM7sf3h6BcDxWWeGBZ+cMEFiwGEHHRnDzun7ONHs/djkRgBunql0VDOSHIDU3cxSD4aEajhFXS4H4S1bgVGN0V8we7E0Fh9jVDG6Obr1LJMRwn+kOCaTEYT0dsfqZHXl/p7PrLi9wIY7gO0H2yAgCAWCWCowKrYE8nMLn/a7PQn9X7zIJPPkCcK+758y7x7guNsB6l98gZjLLYet3Ay5n0sv4R+fCYxPA2MOwLEAQLIDPyP8uBg2cRYmzFweAYilKkn+OC8/Fdh0CNhEA4nGA40kd6FES13WLO8v1qHKAfh9B+DoYjU2Ak/js/8NAIwg7OUb7LCC+WAfB4CpBJoIiTRNRmS1l13kqWh3Adv2A8cdqqp1MB+aIOSxWv6pq5D2kkIAvt8rF7BLJksN/jMqfa7v+7/Ak4B3A6ceqpasKMq5akAmlLWY37t8ZW97PDB2qALg2BxgAFwANEGcnI5JcrDZRPlkaXL4u1KJUAfAjbTQ59x6dSvdLPXAgGYshZWR6JIRaXB/NwFI8C1WwLMXzMeSwLfcXuKrA2G+wrLCDcN/IIg4ERRn0qvyySAQX6mG1XuA4fuAbTOVwktRRr2MLCoQyvEZ/UY/WwjAj3jtFJZkU79g1ghkgEBf98+0Umb/3A2M3lkBl/fOcdMok2EjkZyv8773LAfgHDDKjwNwxEUw9yailpwdxBAEYhBbAuGzG3aKkQEJwAkCkOCjlb7Y6SYyf2UwlAS+vKYnAXjfNmDEX7DEfA5CjUcsnzvbu1nDtUMmCDkRZEEyGdlAk6G6lQTSa6m0MP6HuY73AxNTlcJLZ6WOJYC5/CNxLpHMgdKIKNl69Qvu6/75AjHOiTU87gKOOViJb748BKCWrnK/maTA+58AjM0Ao7PA6Lx/xBAupoYDC9okBRAmPdBZ47lNA/DhwMRsxX7mPgl+SrmK5EaRNRslXFQ9CKB9DkADn79cZtkHFkysJ103eBbqlh97DpmTQTYgk9VNxu+xYbXKU3lhFoJPOgdFGY+lPkgQxokkgF9Xgj4AvfoFs84eX4Ke9x9fIC+tRfDxvvniif358sSir2LCj5wNjBKAc8CIi2AxxLCzIAGY9L7AhGIKgpATw4l8wToB0JjPrfTkp+SLQbHrOqm5jNyajS6VCMIpApDAWwQ4LrGgXqzIfnq5cv0vN0ZXHTInME5GBNLb1DGdOYQsI7AfGKFjlgqve8wJwG4T+fuFAFytXzCLb+VgWnH/fIGYfc46Hs7iHC8ZkPcdXx4VfVXJw8+cA4wIgM6AHSLKWZCTESfLfg7WsIyRF3ckiRQ+HACXkwHptyP4KHrpJvKVGnOhRF9eBF9wE0mUEogz2wC+WGI/vVxiQQIxAs9+rmHA6E1YFYB8DJwQMZl0OrLZ++i7sfT8zroYHLS9df4RACWKxSZvLXzG/fQLZqk2gqn2/vUCUQ9UZaM9wDaPeSPrC4A5C1KV+NITKwCS/SiCR/jRBDlLmP7nHynsxno1IPwJSyRpbiMADXzuPDYfZfBTEoAmcuVQdiaW0zwXwQsCYDYmMaDA1wG8TBSvaoR0G77EcGSET6hjOvVApfRPAUN0zjr45JzVcSqiTxD+VeGzXku/4Nr7JwDJOkxFIwt6j6+RqUrlkO4bXzp1gCAAv04AzgLDDsBhKugLFUvQUhTwCEKbnKCw14HwJ9cDgGQ9WegRgDI8XEcVEDvAl7lVlglAgi+I4CR+Zf1mLGgMmDFhBGFfDCicRJFERviSABjLS7FC0MFKMU+07wOPE0kGvaoQgGvtF9z1/iODkwn3VWoEXxres5ib9xx1wZufBAwLgAQexbAD0JiQwJOuJBA68/H3Zhk6+3CifqqwWNMKN8wjKgbk6gWJgC+FMaBb5vJVmsUbV2vCqo3cRWZcCIACoax53+ulkqNd7iqOcU1WcC9cxEm5kQBUdZ+sTnSL/jEtTWngi21jhJNJBivZBukXvOL+yYBkcOqxKjJ4AGgxzMrBVwdAMmHrZOAYF2l6y/mwV6xD17zmWo6MbRyeWtOHwxJ91IIhr6rqZS70DPPLXDVUrfBwzHKr1EUp6/h0T/6L/GcCqslt4IhoTcwdAqDSs7I60WQH6R329pHuFyuXDJmEjuOSbdB+wSvuP5bGUjmsA5XoUvcvBXKKAQnApUdXwah0b8jXR2YzJTsC0ZHB33FL+2yiX3h/1YeD1fFZGT81g/H6yqkVa9YEpqMhTADle8erHA6t7Mh6j4ZBXdBGjFyO4CSIm9wGBiBvgqxwIAJQlXIyEJLyI/i0SkAG/FbhaEr6BXfcv+5dLKhCg4z1C1HEBJ8+BODQGZXfk/quAZC6ketAZEQCTWAU8PIJt0fgwHzZvVWNaKqi7JLOmtDWFy42g1FxH/XfqGkII0C+a0tnDkfsGxQjn3VPsk7tXmuy+Xp0JhtoJosAaFcUAJUYKiYJxcqHqKAH9rPlG2cMrmCUbMX9guMLpGTcCMKDlZGhMK8IPnPIn1X5PA2AwegwEEYmDGBMjOI5whGQP3NPBT7VJlRNaKvF4t2IWHbDErtDlSk1p4lJ7/zd246tglGZryIfrFhQ7pU8WCAX0ZENG+57U14Z4YrCeLrSxXdev6TfLwrbxT7znMrfKQXfHLQCnyvmRIv0Q3430ezMmL98P393G3wqz6am1NYzzoGn+svqRmTAU2citctqAX/2EI8F9ACEmLHXLZGoFxtSl2xyK2bAYwrj6Xr12+1noL/jUTCD9vvFrn6u0v1/nvGkaoVBAQi0eummMAuXQHMWJAA7gCixG8U0gFfcXdlBKk4Z6zELgAJfZEKrxpC1xOIl/+Sk7jkcdYlSco90y9+gK6vJrRiADD0piad7RuFo3udNCgft94vCdrGXn+tujgV3QAcHLcFnroelivHkchEL8ue0uQ74S3eubAITS3IQhKkMRjBMokgWG3L//2z3VSnP4VDgQWxUEEUxAZFHL0eR3HDfm3IRbDHkBfF0zy4EIKNhSvr9goGEBdvTz/MIYQLQdVsTwRTFDj5jQmdArRDYJQNDSs961R3tPhx5NXoVgoxleHnarjohgLec3D2HI492yQNvIwvqO9fJm9zKGbAwnu6FhaP5pFuMg/b7tTbpBdvTz68cz/zI8azVj8iAHTqgmFHXDUB89R2dtaC7tUGw4kDOgFb0R2wYRDGZ8g9O8aU4XwPOczhiwGlMjqqLWiFYGu570wADFsbTvaxg8nkow7E8nM/atfKzln6/1mS4YHv6BQ4+Z0BbqHcd0NwwYbVD3+1yWhXJxPBrbq8AqE/XApSqAxiBV2MZ/54DMOZwKE00rnDUWcR5KiV/brjtSAMALIyn+/mCyeehjIYp6fdrvVELth8RAClyHXxmhPi6r1m8FM0ucgk8+y4RHC1kAK/5XgW+2hZYofafWcPq1B5AqDqEYsQ3nepR2gqhV2yiol1COkD0C+aOaoGx4aL7DQCwMJ7uVwomn4fm7VrX2u/XAlELth+5sHPtN+l/Ap6sX2dCsZ/phZkIJgv9l++1wbcq+2WFv2NXIjNKAPzuw7MUAV8DTuynFIEsQy83RgTAhiv+NgBABaQOGE/3mwWTLwAqHnaQfr9GnwUbARgDNBUlkpzQboyYCyYDYdILdf0l4NduW9kGoa4geNdazLElKoA3Prx7DofiETtC6XvE7hGEzJlpcis3Qgrj6d5UOJoYDcMglrX2+y0NPtl5UZUjkfx/Hqbecoe0OZzdF1gHQrln9Bhee4s3f3Zxm4MvAk9VSFdUIw0i+Q2PaBtISiBSSFgCYMjMW00MP7pwvvLDmwFgQTzdHxcOSGvBg/b7ZRZByWYAlOERluKM3Ra9CKWc0q73dTBhMFT4ZwIw9l5Lrpes+HjeBiGCUOKXeuBvPcKTiEIOR0f+RhDBMYi0Lhea4GTaa5NbOQAVDzhgPB1La5RssV3rIP1+7yy5OAADoAchEHBkFbKfGRpiweAPtMs5IFNokyOGk/7rAYC9OhBFwNXVY1at5tftCBHaWVS2AJdEcEinrDNC+Lumiyc1B8AB4+muLARAXTDCWvr93lR4/Z0Xt6ODFQkj8WtumEwHTKDLQejAfN3uds/dfjoQdatGLxb8jQBAYz6/boxiFgAVudzNIc2/s3xLk1szAORoB4yn+2DhaATAGJCtbpkCYq9+v4V+aBgAQ4i66XtaC85YkDog/zdZvzUgfN1N7a633Xqv6fe9msDIHfNaB6Ay2JRE1AHAEDIfI5nzZCLeN4Nbm9yaA+CA8XSsul6yqV0rJ2WQfr+splCyCYBR/HJyKX4phs0PKBZ0lqOYTpvniAiUAmAd+HKjo1cvDjHgr+3wPJQsVCymUZrPMuRsRBDG4AQCsunyJtFGHwAAIABJREFUcc0BUJlxQoH62q8ST8cggpKNAFRGwCD9fkuvbwAkyGgJE3C+Nz1P1q9/T3F1EZBxvZh50s6AEYC5yyUHXt5/Q8zI5/KrAmAIkkipkyGPYwXz1aRT8v5ZO6jJrRyAvKOvNXlLazsXs9bo/ztc29Pohgotp5J49Rcj/pzfIwGS//3OM4CNd1dpntQpFUmjEH4LYIgnyn/OLjL8FeDGhwJbNgFjI8DIEDA8BAy1PFK7FSKf43cNKrvHx+8C/vmxwMgmYHgEaA35J0StpvvzL/nP8RbLAfhyT207TChgDRiu/ZL9DsfWNABvYzbhCDBKoBAk/pEobGWTqp819hzQ1/0k0PoaMDEJbJjxVZFgDad0SaUO5LksWVj+XScDmw5UEUDJ6U4d0nVbC91S3ovfVHp5al64cgC+k7mZAP768KCA0WD3A/ieLz090CDceVmlAuhBljLgrfcAw6PAyDAwPFwBkCAbItM4a/FiNtERjBl76W9ffD2AbwJDdwFj+6syImRXrd5Y2FjIYcnzWPLEqnsfC0zsr6qBMQmfIDR/pyJ6xMhKyMrSDiKD2xja6TADTt0/AGAs1KcAUCFrOLF6tbtiRVFavT/wuMCa7MfVTlH098YBeBcwNAIMEYAUlS4uBULOmK3LCnwOPANlEIOSoF9+C4DvVoWXhvdWZVOYqWgi3vOXDUQhgieB0EElViMYJ08HxqeqnG8D4IIDkAzo51DKQQJvBKUmKACzbM4+5hUivwrgiwC4LzvjmgCh6nBcgiMTcv9Abo0D8E6g5eCjfpUA6AxoQIzgi8ALmWwC4z//DxcPPwBak8DQFDB8yJPpPZHeGCyC0KN5DFCByfh9/+OAsekKgEzCTwD047X0SCPM1IYQjCv2E/MJoGVwUUQoPboq0MdqkWVn7RtDDMahB4g+P6qhXFpjVtkDtRGA2nKjos7IyOyHFUbIrXe0FXsTuzIYfNb4O2M3ATGIYQOmPn6hG6gi3eUkQQAeAIYOAUOzALMVh2pAlESqGFBAXAYOMQVjxll03iO/yYKRAT0FQXkwZkjp1pz51LO2XAT3KtD3AIAwj4Wg05kfiuUHYlsXAJLVnP0INLM0OYFx78AzcRySeTsw2AJueI+Dj2Fne4EWKz5MA0MzDkCCkAByUWqsJzarEanzj2zXwjEGFHuGY+pYsMojzZL1G9EBexXou339IRBrC3lJGmNDuSHX+w7WC4Cm6wWxm8DngLTImgC8pBcGBuTXf/1fXnyTugnFwxTQOgi0CECyIFlsvvJfEnh0mhsYI/s5uxFYi1xZof7oOqSAawwYjRGBzYGXbtWXaCIrlvHUagX6SP/ruMVYCEbEqECXAMjfree2HgA0ESur1/0vtnNwGSsG0RsZME20/+/XWH6Mugk/yngPAGy5GDYALjiIHIgRUIrsZjM7Ax+BSx1S4pfffQVIep8dL7dMDsTGjJB+CvQxTHmdtrw4l0CovFruC2NOe975egDQsCXRK/eK634JhBK90q2C7I1i+Gt0jxF40k1cPJAB7UP2m3MGJAAFQrGei9iUTH9yBUDTHfU3B5+BOIKQ43BWtNtPcWIOzEZE8FoK9K0DCGNxLi3FqaKA9gTgeoFwPQAoI0OulWT11oEwiFz7cwbErzNxWtEYBB+VY76Vh4DWrH8IOoGQ7Ocg1CqMRLPltmxvs1/SHaP4dcAJePYyyUCRIzrTB8tE8FoL9DUMwl61kQQ87Rmy2PS2rgB0a1ci18RudEJH57OsY02y/+83/sZdBKr4FXQTApBvprGgQCg9UEAM+h9F6ugJDkC3gJPBEvRGrYoYCBX9IxEcS5K4i6cZAHIw8oXQ4mLBb35YH5d7OekadtTV1UZSjaEIPH4nQzYNwgjAHNwDuWGYpZc7lzPfX1cQur5oBorfzDf+zi0yVTuSkuxBI2Q+PhQDIUEnMLo1TBCZLufGw/ixbQa0KB8CTODjPohdY78IQmfDjmW7Yo/doAX6GqIiAtDHaYswSmeMubV81kp11L6hy2PdAcgblfslOKC1IiKRmyRxZgV/8++DS8BFrxXi5Hd/U6MeSKdqEsEKhpBRsgRMbAtuG4KU/+9ry5brzP/lPVMv1EPOQegharrVcgZUhVHFxNPcp9VFtlOWkL437C0WABWypFRGsV0sb5Hn2zYBwvUGoKl10v1knDgo0y7XA8Pfv0UACnjaK33Co9gJQAOe64FkNvtZAHQdjz9v2Nz2GSa3jYej2W3KGuZ9ixGdIVSoKT13B2s5AHkGheST6qn0erHv5AIgAAU+LVfw/wq3CEAV7clBKDDGZG9/5oVXx/oyYARczcqH5GyH8eFplTawFvAtrtXLGpNrQDGbejupB3omlIHQGc/ErzOcGSRs8zrhAbbuL1Tco/JfbLlNwHOmi2kIcs3owbdwNpYtynDQhsFcgvuG9/YapGFvYX22zZcAU0/GwA2LJ/4AmGF9mwEbBu98Y3cMF+uAGQCj2HVp3BbPuo3IlqxAy5wHAq4OfARmEBXGfNIBa0BIsG0ecwC67merHgRpZLwocrWaovuTxew/V0txJQ2DWeae3WAGbdhb2DB4+wRw7w5g8Qpv88liyGtoWHzMi4C9fAEHbBi8kwUKu2xNAdBxaGBLbJdZux1LwAGECYAEm6wyfpelJrEgFnRDxESwgyUxIUsVMwjVy5AYO0bG89Auu1/5BF38KqjBHlUAYXsteNCGwTeWNuwtk4JMkrlzGNizA1hm69g1Nix+zDOBW0aBeRZZGqBh8M4emfWNADDT+zqMjQyESdQFHfDbZECCLRgdHeCTe8CBaKJY1rDnBRCIAuGW4TYAZeFG8ZuMkGiQ1IEwGCJtHZBmy1obBsvVMnDD3jIAerti3LEBOMjGcOpa3WfD4ic9t6oveDtLfw7QMHjnH6wPAybW6yaG4+8D4HIQfvtDIVtLejpBFsVvUI7NIBHw3DUjRzL3rDVtsYPOkAScuX3coNDynT2VYJCkn+PjqvUD8hVbS8NgjphGxcANe8sAGNoVY/824BCBtIaGxRe8pLKZdpMkTvXiJ2toGHzSNHDPScAyq3er4qPyGaNc7JCRXWLT2TjwGmCOeQashq6+qSpZmp8vojQpheF58ncdZVjLnjWPHr4VWKTKxrHGUqq97qXu3jp0wPy+eEC/DYNZsZAO6IEb9pY9lNCuGPcNV830ZmkM9dmw+OKfbdcXvJMPdY0Ng0/7GnDXKcDMccBS7MwdKz8KCAKQIgY0MWGCtr4TOHAasMwOkTqf6unyuLykfd254nkb7qsw/iVg7jhgmSX31Vpd9yRHeLx+zRhjEGRbB6wDYT8NdymyubzDzCCGfpMJWfSRYfr9HP/aMgBm7YoxNQHMbQHm+ID6aFh8yS93tAvGQb7da2gYfPoXgbtPAqaPA+a3AEubgGU1RM6B060fgkRoCzj+TcD+04CFE4BldZdRc4/YxlxgjJMewSiwN1zWfsOngdljq3EmY08vm5i/7j5yIMqpvupKyGoNg9lngYosl9wY/0dZdrMzYl8Ne8sAWNOu2MA3zw/F2CoNiy99XbvftrcLriz6PhsGn3U9cM9xMODObQYWCMANwPJ49UliuW6SaqqBn/gGYP8pwPyJwNIxwDK76ahDeN6uXYCuYyABkEza4LbpY5WEWdSLxjF26/dQB0SJ6r4ByAN6NQxmkWcqrnQ00x1DEDJFjR8CcNWGvWVPp6ZdMQ6OVOCb3wAscPJ6NCy+7PerkP5Q3tBY1PrT9tEw+JwbgPu2AlNbgVkCcCOwtAFYcgAuiwWlM/XqDjMEbP9t4MB2YO54YJFMo/5gHIcALV1TRZ17FXOhPtvgtvkqf9H4kvHDlyKK4l6VzvVSBF22uwjOb7pbw+CfcwBSkyeFEHAUx/yw9JTyEbo27C17Ol3aFWNuAlgIn9QxO2tYfNlbK6MvaxeMRYquvL9rTcPgJ30TuH8LcHAzMOugX3QALo21WXBZLEHwRF1OgHS2eOgbgIPHA7PHAezNu7QFWFZ7JnXJ5rnqxHEulvlzwyVNN3+wern5Yovl7SXLGwvn4riLWO4fgMRJXcPd/+pmOymELEhRzBxJAo9gVL4kwVnbsLccgHEpWi3epocCAMeBRU5eTcPiy/6qtl0wpvhA+2gYfO7NwOQm4OBGYGaDs+5ExYDGgqP+ccAkINaVpB8GTv4d4OBxwNw2YGFrxYCmV0YxLNYheCXau7EhV3ga3Lb8g4+R45uoGLADgHWqhsBXA8K1AZADyRvuvtkBSArh+i9DsQhCOtf0UUgW/7aiYW/Z0+nRrhizoxXwFhyAi5y4rGHxU66qAFhT3rDSIVdpGHzencDejcDBDcDsBDBP1uX1CMJRwFiQIBzxieL3KIY1YW5MPOxNwLRb8gs0aghAss1GZ1O+SFHsdRPt0i/PLHu++dFb/x4mXfhcbWxhfCtYMFr/uWvKxfDaAcg7ipPCvFOVpuo3HrCjYW/ZA+rRrti6TS6MVQ+L4NPH2nx698GnXF0BsKa8Iab4dFZpGHz+JLBvApieqAA4J8CPOQuOBBAOV0CUYbIskRkAecrvAdNbXc/aDCxSpyT4CEIyTgRgneiLIp3nP6fs+a4A4N8B8/48CUC+ZGJA29fpuLmxJW+5h5kNFg2jiWHSi0r0Uv4pCoZsxw8DUfnhd4Vk0XGdGvaWPaBV2hVjdjgA0BlpkQ/K9bmn/HOVqtClvKEBqlfD4AtmgP3jDsBxB6DA7tdbcvYzJvQJkii2n4NOeMpbgJktbYPGACiF3wFoEx1ZMNe/4jnPLXu+KwD4t/5SO/iMBcXuesHylyACMBPDgzGg7opM8mEHIGdwrfGA1rC37AH10a64Yr4APvvOSdwEPOVbKxu+K2pdKRTmdI3dqkPPVgbSTBGAY8AsATjWniBdx0QxJylOFCcr6HBiw1P/CDgU3EgEIMW52M8YkLolQRddIN1AyKWiBretf9MJQN6HsaCPxe4rvgDdHOcOxDIAcmDFDXvLnk4f7Yqt63gEIB/Yoj+4p9xaAbBHeUPM8qF2aRh84QQwNQYcGgdmx4C50WqCFngNsgSvQ+Dxu4MuiawhwIAXVk1O+e/A7CZgThY1dcno1nHL2oDIyZULpBsAFTBZ9pjT0QQgn2V6ufRicS8QRgbs5ZYpEsENDejBfpoLrwAOjgIzZMBRZ0AHoUC+SOA56xJwNlEyTFw5FxBPeWvlzpnbANCdQ1eSGTRybMuydgMggVBsKmtYoC6Mt8znZxsZMLzAxoAOvsh+ydDqtXx4FIDl8L/omQ7A0QqA82S/ERdTI22mNfaTuBIIxR4BhKe+y61punQC+MytI/Zz/c9EuvyBeetLAfGZ5WOMZ9j2/gqABB1fMLsHAVBqhfTcyH5d9MByEdzs+B50Z7voGZX+NzNSsd8cwUcG5ASRKYbdHRNYwhhDIHRgGmO0gFP+HJh15jOXjnyKblVT5Cbfoq+yJOszF8P8+VnNPlICkMAzds/YLxlYznrJwIpO6egTPMqA5ZNDAB6iCCYAyYBcBqTRQ0e4630SxZyQJQIvMJ8mSeLrYe+p/GzGfnTpEIBy6US/out+K1wg+brs88rHmDOgAVCMnrEfxxMte1Mt6j7u9zzKgIXzczEBOJIB0BnCJoqgIfDEhM58SWzJEPGJe9hfVH42un/Mfxl9bgSiBySIBWnAJBDGEDAB8QWFA8wO3/a+wH4+rg4RLPYLul8tCI8CsJmJMQAOuwFC9qMI9g9Z0CxhZz65K0wfFBPqu7PEyVdWAOTHVlTcpxhXHZLz1w0ZA6EDLhkCskRf0sw4dRYC0PQ/vVSRAYPo7QCdj7GqVOSMeBSAzUzMxZcDMwLgcKX/zbv45SQlHXDIgagJc+bjZBqAWhUoH/Y+B2D0J7rFa6LYDRmzomsAaOeKqxEvbWacHQB08JkRIteSXiSBLYJOLB+X4xrzAzY7vgfd2S4RAKkDDgPzNEAIxMASSWF38WsgkuXLyXTRSRCe/DduSZMBMwe6ObTd8JBj24Aot07uDObPP9XsIzUGFPs5+JJ/M6oT4buxHv9X7BeY8KgOWDg/Z58GTC9Xq5FxTXOw9c3Cm6k5fPcjgbHbgAlvVG2tH1T3Oavoq6BlniZ+12n5u/2sDbOvasqoFg8x2Lnbcd1GdhSAhXN+7qMrAC4sA8sORJ6yHwD28z+Ft4fdv8UyqUDrDmCEBcpZ39kLS6aq9l4D2rLb/KYsFTPWdfbvh86vQu2s1K/K+zIjTsXIVQ9a59Egs4Y6sZfIA/EcSp/jEXv8BWcAhxaA+SVgSQAkGAMICcwVlNLlqTc9Gbv/HAA7MrL4+f1VlXwrUq7SvCoyGcrrWpGhuur2fNGYwM8YT67hT3s1LaZvqn5MLM0bzmHMmIFSgdFNj/mIBct63NhFZwEzDsBFgpDPeanNgATfCtGsX9TIKwNrg9tuVkhlng7TI/YArX1VkXKrEe1l2SynN1RCsFJsqnQv3UIMxhwIRjU5AGN9QUteVz3BUAvahuNgjC3HxLAND7nBp/cgONXF5wCz8xUDGgCjKPbvevlzcKUHH2ag6cnYzepYBB9Zi2FxDJdjoXJv1WDFiLJ6MKqKZUzoQFTfj2HmwTKcTpVWvcxHKm6kKgoORAEvVclPD6NdzLXpMT8IYNPcLV7yJGB2AVhYrAC4SNA5AxKM9ryDPE5fs6eeVKWGZ2M3S3MQfEyJUKV8L1ZpJXpVJ9pLilmlAxWkVJHKwIhjjD9TtVXVm1HdOy/pJiaMFRWM+bo0rWl4yM1N7oPhTJecC8wRgAttBjQWdBBGESwgSiV0Pb9DRgu0TY19N+M1mRKh8niqFx3rRDsLqjgl9yaGXT80vcL1wnE252PAZCzAHQCoiqoW3yYWFIt664fUpKaREr1NPakH6XkuOQ+YDwy4FMSwgU8GSRSz0UJx3Vx/5vFNbrs/EiLRY+v4ACITww6iJEodQKwBIyBRv9vwhKzUW6z66TUGEwhDS3ezqusAyNxnJn8xa1KRPSFts9YfFB/QDZcAm78CnDBT5U8rCqjfc3yh8Gn/hGd/MsKf1+QzYJ4891Jye13iy1cAE9cDJ+6FpYrEkidxDN3OtXR+FwBGMezoMmxJLOumAuD4J4rxJrfdH/XCoLGFVKiUbw+LAPQqWWaMMLrd6/+JycSIm85w9lOpt1j1MwAwFTiqAWEUxeYH5ENn/jInUVHeMXQ/f/jRePvCa4DhTwLHfBc4frGqqaNJzLPw6iZxV+HTplFGvZrXZT45N39+HW3TujlZv8D6fp8HRq8Dts9XIOR5YtakgBgdrrrt5Qsq8Ssd0BhQ4HMwmVitAWHAY/LbLDQNQDaTVJ8Q6W4qVB51OOqDZDPVB3TLOBepW5jmqaLbec3jGgBGMSxvvemDYkQ9GoKF1ShUCSKCqBeQrvmfVZPC1keBjXcCmw911tTJ8q5XgOLaQgA+x/OdWA2EGZ98gbjleTHdQHQN+2iwls3nK3/Zhj3VeQhovYzdxmArSwQgDRA3QiSCJUrTnjfl4KozRCSCCeYmt90EoJJbVCk/1+FiCwFZxLk4dRfLFia6x8LbYkD9v9cXtLG6+O4AYQRfrgPygVIcqyhTXcWFOJH8fh3rz7EKwnUArq8mcGwK2MCC1i7WY7Zenh56feHT/jE3yliE4TZncd636gPFCKWavGhcRx2J+cvs9MlSw0Ty3cCm+c7n0G0MExdW4BMIbTXE9UCynvyCCX+Ovm4gbByA/xisVgJPpXrzLj4EoRJjJIZrWHArS9iprK+KcefgiyB0XVKGjOmCmW9xhRVMUSyRFnNeFGEdI2q+/HFXclkp9WsAbgTG9wGj08CI64WxRk/OTDcUAvBHXSLQxcVCDMQSWbzv+1e7WVbz+k5w2tJtsbcCYV6WJY7hmAsDA7r1Sz3OgOgoM+KTOJbcjSI5yGIaNE1uuwlAAU/MF+tF5/0sIghVLdVdM2S0bSzHx2Mi+FTxXf8X925NC4BycK8QwfmgVX1LlcFiykEMcL2BndJJ7aQfijKfxLGDwAhByM7aC5U4qwPzNwufNnNuOH4VZaCPlPo2AahqFqoPVFc14ga2m+WEEL0cAz9kdPrOmMu8r1o/rTsXz7f9oswFs+jO6LAqkvC3Ggg5Fg6mwW03CUI6X12h8lyfcz3QHqr3DIl64DbqaQKc9mI87QXACD6vpJqY0EVxz2CEyCI5eMSGX2e7VtI5J4yTRyZhscrvt1nQuivOAaNLlYESwcySgiVbr37Bfd0/u31yEgg2FVaiPCeVOguqAfGov0iR0R9JABJ0bnwk9nMxw+fOh55EbgRhzozrBUA1polN9CLwok5HEEUQBjFMQB7D+j656PW+IrJ8O/bBCo4sGFdGejqiyYCx3mKe9/JtTiBvmI5OFiTisg9LtJFF7gZGDrUbHKs79+hyu5hSaUvh1foFr3r/6vZJCiXgCDwVVFJ7MVmRLsrGltuFCc68yFdACMDAflwR4QM3HPoKgIExt4gz42SuaQb8hBOE2oZmlu+KFlKR3QSssMJxDPWbbjpfLoJrxG8CYT8MKGZSVTCxYFTIb84nkCxCIPLDiby30gXFghaF4c2ReR466Uu2fvoFr3r/fKAEFxvpqMcd9yonIrkuK5LLV7MVCM+/uDJCyIC2J8a0z1iwqyESgMl15Sa33QKgmtPEBnp11mwuXgO70Ud4DHWzfgDYC3zBEOk7HlA6XKyHQzb8HgGoCSQLqsxorIy1Bxie7Wx0rFaf+wr9Xv32C+56/7HbJ5VHtRYT+GJrsehHcya57PyKAQk6+vBkBZPpjPEExlwU59awg3C24W6KBsC6tqHR+MidyVG3i3rdAnAsH2T093XT+zLr197MTA80h3SfsZP2UqpCrPQ46oF317VrpeiKXTJ9MhMLkgGdCacKG/mupV9w1/vnwyGgCDCKWzJe3lqsyzLWZWe6/kc/oKzgKH4jC7oolhdC4jiuzM0WPo+cPQ2AsX1obFCTO5Jzn566PwbReiwnfTWjI4KvDoh1juh+aT+WKSYD3i8Aql2rJk+VsVQly5kkddv2FvHT61icqO7Fr71/IkLNXOi0FQjV0046oBy6wZ922Q95ICqDEaL4XWw3COcf9Mw73DFB9AqE6wZAAS8XuzGQIDKf+oVkqxt00ttAc+YT0PJ9qRFSB8xoye5Xu1ZVeCSgCLbYLVNswoncHxoeLwCzBGjBNki/4BX3z9lXgUCyIIGmhova83cRgO5Te9yLgP3MfmsBS8xs8/U67ePQOqy9umBUruDchqo8sHSd3PMfT5ifo+ack8eFHI6QEcnT5GvdOnVdXof+ptJ+BVPWceiaRHA8Us/nkACo8mzqlqmWrbFDppT5A5UIZm7CPA2Vgm3QfsEd909kKIqB1qJAKCBG8ZstZz3xHOAAiwmpDIdng1maZQAkZzsHZ537YfQrwNyxoQ+HakrnS0h1mUA1C96TdJTmORyhC3oeqdwROi+GDhkFI6bYNrcNDEDeAkXwQizPRpmnIs3OdqZPSaRFUcbchHlgie6agq2kX7Dd/+d8lUJVXuUzk8ERmS+2vfd4uvN2VOV5rSwb0y3JhgIh9wJeN3YMQCIgR78Q+nDEVYBYZUrUpbXFnM7COSdf7N4IPvtDnT2BY/h8Chh10MXQeYGS+7GGjaQiABpuNIFiECnzdWJMIUHcazLptC7YivsF8/7FgLFMqpiQL5TuNbKfA/DC46rqqAbAwIKWK+timRUBEiNGsOQsyQm+Gpjd4n046hbT84KPuYjOmHHyp92gcgDS2OoIuVIeh/xyUkaVwyEWdLrewHE3uBUDcKIwnq40HpDXL+n3CzbaKdguel5VnFJl2awaghLQBTzteZ0cjLq2A2n0M6EPh2pC57Wg41poLzZsAZNso0Hw6eVR/J8bF9YjWGmVCpGKwQLBRCcrbiSxNLgVAxCF8XSl8YDHHFPW7xeFBRwv/rGqOKUBkODzqgdWPYAM53vTASMQu4Bx9J+69OHIF+N71F1O1gUB+AsBfFqKC+4Wi4BWX+CYgOTAU36wdMVNVKka3MoBWBhPxyiuko3xkSX9fvGMkqsDlzzHC1N6SQ4DoINOe7KelWWTheziObeKCdARApD1AdVnRH048gKUAmAEYi6Oh4DJV4VoGDWqjq4XLbO5o1jBoimEPhPJmwu9FvnTLgdgYTwd2wyXbMyRKen3i2eXXB245FlVYUpVxUpGiLtmGBlrTEhVUwV8dEkVKAq3MHJ1uzRbRx+OOgDWFX6MsXJU/36lJoEoA2AKvw8+uwTEDIBbStdOs8ddDsDCeDom7ZdszBIs6fcL9ror2C75US9IxJJsEsHdGFBil4yYuUwknofJgF4XcEUfjrz+X7fKo4EJJ//PkMORO6FrVjQMeL5kJhZMMXzLwNZCt1nzDFgYT8cQwpLt4hDON0i/X7ys5OrAJVe0S/ISgFY7j9ZvnQ7I3+lyqpYaL98CWp/N+nDkZdhi6bW8An1kP3fRTLKVWlwF6RZCH2L4zDDR0k1IqeTNb2OQSYNbOQMWxtMxeqtkY6I+ny9VEz6btfb7xc+XXB249AoXv85+tIBVgJJ6n4lf6oV+mfjdDJNMH0wAVFX90GMk1f5TxlS3Fggh92DyN0IORy5665KIfCktsl+K3VsGtpVOWOMiuDCerlSnjQ2rB+n3C+pIBdulz8wqonrNPLKgwKaC5B3s53qhXVq6oDNg6sOhqvqhEr3V2VNLBjmnSSNdrOLJ1zkAu6VPRjFcFz4fXDJ8i45hG94Gt3IGjOFYA8TTlQZ/qGH1oP1+8ZtlT1MAtHK8mQg25zOZUSCLIliWcbw8wfW5Ln04ssqnHX04euiCk6/3de66MPpuAQVZAEFkw2MKFw6a1wEL4+lSBvmAOMhD8vkOkFX77feLNw14YT/ssmc4A6oOdHBEkwXlgjH2k4Nal6wB4fIuX9LzZjAmorNeHMo5Tc0OewHwDTUh9HXxfGJsYkAbAAAgAElEQVS/uvCpoAcew6zBBrdyBlQwwoDxdLZWXLDFkHyF8xGE/fb7xR8XXByAAVC1oB18HQYIT+8uGfP75SCUs1o64he8v4j6cIQ+IqkPhxrBCHjdjBH6AblQkAeY1ondukSiELmsUPpjbyp7XuvDgAXxdNZVvWCLIfmKg6Bbhrjup98v3lVwcQLw8gqA5v9zC9jErutltg8gMxDWWMBaMVkmANWFyEV6R0uH2I1IzW7ypbkQOTP5f2ch9KsFkwp0kQlDAOmxzHpscGuGAQvi6VD4RgmAg/b7xZVlT5MATNXwqQc6KGwf2U2uGV2uzg3D4ua7fDnPwZcKgIdq9GaIBPZb0YdD7hgyIFWMXiH0eQ5vXS5HcMkc++9lz2t9GLAgns7KxxZsCkgdtN8vWD+vYDMAUpcja7lOR9eLVcIP4tcuob/3AOHCdW02VTX62ApB4Mv1v24gnPy9HiH03fJ366KYHYTHsgBBg1s5AxbG0+HLZaOp65i+ln6/YM5EwdYBwGj1cmUkE7+8THLNdAHhwrUOXtcrO/pwhF4cct2oN68BMDCfmsJM/n6PEPoYPp8bH3kCkbtjji2tJJA962YAWBBPZ0WBCrbYsFoOf9pDAiENk179fkuvf9nTXewKcBSjsn7ldonWbgQpx+26otaLIwAlfi2QQSJY3Yjy5i9dmsFM/oEDMM/Z7Uf0RiYUA7J+ToNbOQC3e0WBBm9qLad6HICG1ZK1XB5PoxnuOOIcxSXe/Of8xHV/P+FpwN47gKUpYHmuSve0pKZgCKSq5wqniWE1WZz/xouBm74KTMwBI17lVBXwtWSs+8/vL45Ff3vhpcAnvwos8d48DZX3M2hx9XIAnu0IIO0chu35AOgLL0yuG/jOmwbg028G/mNz1YWdETbm4I5BrFlov+EtD2wIo7l+Atg8D2xY7iw3V5diEqO54mnj6XdMAYcU+6gon7A3NSO2qFjlyZYDkAX6uD5Iam44YaUfVNDNxaJcLIPXcGGpfi6PnZdVD1wPspQBX/wl4OaNwN6Jqg+xwrxslcVFuYJblehkcYYZGPS3L20BxueBcS8nwg5H5kZkx6TQSbXFZcCQKadx5Cz5mPurAFxrRaa17pAR2PFC+ElSHKQ/0QjQcgCyGyM9v3SnsDBRJgL6msWCf6IfWeUJac8UFlpY8500DcCfvgb43hiwZwyYVhd2D/VSrKGAmIDnBkiafEcN9cprHgKMzgNjS1V7rRjRlceyrqif6KAkMgXIM+6tAnDl+zSL36O9+U8p9jGHQo285/2XA/AnXeNnKAorDXH/AILwbSvLEz6Ql2+cAf/3XcCdw8DkKHBwpOpFbE2wadzIdyh3jjNQirYWEwYq+/zJwMh8pf+xKNSwM6DZMmzNRRbM2K+2Ii6TlFrAWfd5V3i/F7IgT2LBF5LbIdkqxLPWvtzlAGQ3RpU3Y7AiixMxLOUB2t7pKQ8M0qCTnp8HkojJgNqaMEJesQv4AR3Iw8DB4QqAs+6SWRiqgJgY0HVDAdBA4Ba4xN7ndlSFAAjAYX4IPO5dBDMAdS2i+Jx7XTf1eEdTDfgAQnR34p/wQkRmjNAoByDT/ugFphXAmjAEn8qaPQAgZCs0lSckCNmVigEbFMsPBBE3DcBX7gLuawH7hoAD7EM8DMw48AhATrjtQwiXoqkTEwWd7LOneXNCbz6Tiq/TInb2M8ZzIFrTQbGiy92oGz7pXl/7jvdAJnb2470IbB3T77Sai+hyAP5voTqW6sKwFAc/TAdc5+3dvcsTrvPVYSK4SQb8xV3+6IaAqSHg0FDVh3iOIFTIFxtit9orL5Z/LD1Q4s+B8OnHVuXwhhdd5DoLGsgCCJ04q66X/Ju/vSaeAxDPvbdtmdtKDV90gVEPIl/xySkviOhmAEjrlzSkwj40SlQZYZ39I+8JBMx8mZryhOsKwqYB+KpdVSDFvhYwPVR9BD7uyX4SwRS59nNI+bRck/DzJ05v12M0nY8fAk8iWL5BB5qASPGRCi8EVjzv3mqpkC9ACrrwhKukB67GhpqRRowQMqCiYbj8oOoHeUWpdYIBAUj8c8WjrjyhNIJ1unzjDPjqXdUjJAAP8TMEzLYq9uOHICQALe/EwWe+QgddAqCzzD8+vgIgg0qp+5nYjaDzCgjmnCYone0klqP4JSgvvK+6LoFPoFMlkPGh+0rPWta4RHTNJJQz4M8EAGoNTPVU8opS64CC9zoAWTFChcq7lCdch6s3L4J/2QFIEBKA1P9mHIBmhPh3Ai354RyAAmWsR/PRs6vOR8Z8FMPS97yxtIlYgVB/I7jC0rIKSfLXF1EEB+BFFjQ3jCLA49OWsRTTEPzvzQEwry7VrZ5KwzAQAPssT9jw1dcHgCrORQCS/bgn+1HsCYQSveaHkzvGv1scgU/6R55Y1YIxhvOm1EZekQWl8wVDxJgwc88QiJc6AKX/meHDawX9z16M/Em7bO8Q08GBP/jEkAEVjMBoAFWXUjRA3KtNwOBXW3EkAZhrALktpC6lKtTV4OU7RHB+3kHWgv/zrnYZl2kCkF4uF8MGQGc+MqEYUCA0n1tkwxbw4ScHAHr71Q7W4++c8czwcBAmHVB/c7Bcek9b3FuwbdD/kjGWgzJjQ3thGmVA3jhfOyU+RxB6FamOFp8NrhsTgLy8Cpzm5QlVptAU+6CiNgXCaIQ0BcDYV8b0P4pi30vfIxD5+w72C9aliegW8MHzqrmh/meuFhYi0pKbs6D9fsh/n1XFMrYMbPgUByCZz6J+uEknDA9AornWFRb01WZEsACoHhOqyC7wdetT0QAK2KqOb5MCUvPyhLE0oQxzqaYNXL5xBvyVXe12vByLADjXAvgxBvSPGFGMIjCmJbEW8HfntxtQmxT0cmxp9UPAdKAZ1upA6EB7qgDo6oCUxXRtPVSpAwJpnUhuxAqWCCYK1MBExZljY5S8SYr+pxAFAuBayhNG26jw8usCQLX0SAAkwwcAEngyQizaXoziIli+Oe7/9kJvNk1LmBMe9ECO3XRB7aPeF0EYHNVPdT8gj016YBcWtBfBVYJuz7mF7VgGY/pO8f5WdQ1/7U67nIKNS7j0wIbDPFZsyNHHY7od/xdlEHj8CcC3TgCWHgGAPSxiSdt4312u/8SPAl8/Dlh4pDeZW2PD4J1c9+uyDaIDkgEJQKnTfG/N8nUAmu5HUnMW5ARbPfEuIHy/ACjRK7FL5pOR4RaxgTHofKl8r/S1ZWBnAGDKefbn3AFIPRPXB7sFiVQimKVgGdl5ooNwLQ1/1U+DQGSXQ9r5Evy1q9rZbP1lGQDZsPpzI8APHgXgod7qUx11YtBbFzC+/C+BL7SAWwhgdoLkONSLqy5oLogYft3ZI1F7EAC+phsAnekokhP4HIzml/PvthQWmPB9LJ7jxkcSr14jWj4/0wFlgJD5eoDw6fe4DzAYPHokWhHJZ3TFSkn4h7YOSOBwEtiMTv1aY0uktFYTmI2/43EMQmCuAJmUE0gmVD8EFdPpdnxhVhqzDr8F4NMtYM9Jfg98EVTeNu9Q2OFZBX7vr9vtgm/lcezczZ61ZNN8DCvilYCdPXqNDQpAlfGTKm0M6AA0PTAyoMSx64cRfPQHXsniOTI+fEWDFGp+Qb9BeySRBV2kpl0QxxGAlHDmkI56X6z+EP7UDYSdRgh/IouwIZ36lHabBE0GJ0r10Rgb/xA/tt/j/6aMAf+7R4CxzuBXWRGULwBfIrY6UNfpvLae7n0I+LO/reoLMqiVMbW38oUhkNkQIzZO7tIweGePcmWlAFTjAYHPVGwXxWoLYblEDkLuTT8MDPhXLJ4jALpaJB+ggU6xfgJknT7IKXIQXh4Y0FZCog+wxiUTwSkXUbSMV1rB/A31OXWuFpPUda/mRHKi1e6U+hA7Zq7l+A+UAfDtHg/LrptkQpZ727cRWOL9542Pa3rOvuOqagUltgtmJM08j4/PILbIDKz6w5PAHsbraTnMGdZWIwIzxIfeK0rn578J3LAVuH8CODRahV/FFQ/1IumIvXP1QudNfyNT8oVqcHviPcBd48A0g2RDuoDqHdb2SalZAdG9dnfDkAE0gXnH5ijWCDbKCq5/MRiV0QD8HgHQ63jG0hdsLGxA3x9Bw1Asli7hO3BwApgng/Gjvq01IHrXJ7q3Cz7E++YziF2rs1ZLZ+8H9jJsSoECWXj6igmR87aLgfbGq4GvbgLu2gjsHwdmCEIPSI1h+SkCRjpfUC3iNWcpoRrcnrYbuGsUOMBo7QBCxSTG/igxVcBIVGPWM1h1JYQPnyKNExGZMDIJ9b66eEBGxPDY1Y5nv+GCjfGAxD+DDpiawphABWZPjwNzNLAEIH4XCH0M7/5c93bBfI8Yk2cgVAdvdT10ifDkBWC/r9lGH51NhIsnsWHOfPmEUKT94WeAG8eAO8aAfWPAwVEHISNQlKQUglJjJExqC+H6Nq93kOpUg9szbwLuHa66QzFWkaFieXxi6hgVHOMCYGRuJ+5V4jYJIDKI9KlsAvFDq8QDrnb8NWVPh9EwdFkQ79TlSMIsN0Mi5s9MoOGno4U6f3YAvefL7Y7rvdoFLxOANSA8f7xSgWmd0kCQbmZ6mTLEnJ0UqWLhUkxlrBn6n3wWuGkYuGukCsufGq2iojnRFpafsU7MDxErJuZhYCsJosHtWTcBe1oeq+hxigJgXBrMmTBPnJKLrr+VED54ibHYvZos8sO+DNcrHrDX8YVVyglAKud0LtMjFPtNMz6QLDY7VomLJd671AEH4Xu+3g7nWq28ISvX58/hguOBg8vtFQvV/hEzxfqOevuTfpjri8vAWz8L3NYCfjBc6ZYHmBcitnFd06pxyb8W4gPlgonBqffTtdTg9pybqiVNBssyUsdUD7eGO9amnf3sXtxQipl7Wg/sD4A8AwHIyZMYky50Tp/xgN2OL8y051qw2hXzwRCEdT2nmck1RxHG+w5jeO9NFQBpR6ldMIMXlFWgVndqF2dVFsJzuOgRwMElB6DcI6rznemD0RnbwQiSRS3g7Z+tVIl7PC9kahiYZm6IizuLigliT/VoUog+p8P9l3wJ7qGEanB77k3VczroUToWLCsABud4ypaLCUoxf9i/9w9ADiICULrQRWuIB6w7nuZrwaZwLBGwClSqSyz3AhHbaRGEFGOmC44D72UVgjW2C2Z4lIF4ArjodODQcqUGqAxfcpG4mJVuVqcL5tbs2z/veV0tYK/nhTAqesYNHdO5PCJZos+WuzxHJIViuXFyJxupNLg976ZK2lizUKodilGUgzyGhokF8yw5Mf+qRkjdjfuDtwkkm7DTkNaBaQ2ox1q3eMD8+B6O3H6em8Kx1Ccx9ptWl9iYIUAAWrI3I3nHgPdOtsO5eOuxXXBdj0V1vOL/so3Cxef60tlSpYwveKf0pAu6ohfdJ8k4CUqgvr5jV6VGTBKALeCAh+VbZLTnh5gu6D44A6H8cVlkNK95O1WkBrfn31R5HSy+JCwPplAxRegE/2T+AloGncNmbQyogUQx/KwB4gHj8YWNTwRAOW0FIIIndoqNkTAxz/bd09XDGLBdMM6/pLKi5whAX60gCK2ujxzEAqGL2pQ1Jis5AJEAFHvTujYAKjRf+SEugm1d2COQLU/DAwQ44caEw8AtZzSIPgAvuKkdrWMM6M7xCMBoiBn4YpCE2NCfxWAA5MEuwvCCEICwlnhAHV+YORfDsWJGgPpMKwg1b9QpFnzHbD2BK2JGul9s8KkYW17vLALQRTCBpzXZpS4gtCXXMAkduuAy8E7PijPWprXJ5CR38ygw1fJDohh2BlRAgq2OeN7uTWc1D0AFNtmL54ESBsCaJcLkDajxj5ZXRiCIGA0waDwgjy8sk5+HY+X9ppUbJSCp6TnFCMXwny1WAFQ8rUAc2wUrRL6mXTAefWnFfnz3FpbagQKLAqAzoZjAKkkpXkNO5GCEvOMLFXOnnC4xIKOjnQGNdWSM+GqHQGd7JSsxUf+JzQLwhTdV4je1nQvr1MkPGtlf9yP2Dy+gAqZ6rQytfvdHSDxgLwBF8AmAYjHWluEDiKGMiqOVvtejXTBOuRSYJwDJAARgZAGWL9Nk+IM3SzgTydE4eec1nZHbtDaNAf1Dpd/SMx2END6kD0oXtFhBXmcY+OY6AFChnKnzl7NfdMR3qCAae2B+VVMYXASvDs3/X/zHJZcB84vuiqABEo0QPnhnwqQLyRURmZBPytnwHde0M1vN2lR6picoKULaxHDIEdHkW2iWg4/7b5zb7DSQAVd0/griV2JYojfpwRGEYsGBrOBmx/OgP5sAKANkcbFzNWTRnX/GSGImMYH/LYlk+gGvdT+bW+SWH+Ig1GqL5QeTtR2EYj5LVHfjw/ZDwL8yJ6TB7UU3VVoTjTYxYDK+Ivv7dzNAZIxpZSiU8jjKgIWTcykZkBawDBBnQdMr5QeTKI5iWCB09AmEb7+ucnOQ/aTPWn6wuzyS4u+R0Ob6CUGqJpIDA97AdqINbgRgBJ69CG4Jp6q/ckjXqB/RKla4WpkO2ODgHoynigA0JiLwaNiEt95YQKJ4FRC+7brKzRH9jZbN6iJYuSHm9I5iOAOhHNJfZkh+gxsBKPbLu3+JgaWDdojhMO5kkDWSlNTg4B6MpyIAjf3IggJgMD4MCARjFMU9QCgAykhSKnUCYHB9JB0wy5aTRUxmup4h+Q1uAmDs+hpXgFLnB6ULONOn5xACNJqxghsc3IPxVBGAiQG9aLeilWUJW1FvVXEN0TKp1C6At19TMSCBpz1dHtT/JH7N9yaxp6QkF73KBxYIr10nAMproB44qQGTj6sjUrtOFPtLeFQHLES9AdDFrq1E6M13MaxVCTNAXNFThIylLcor40zxtgDAPKuVwDMrOKw+SBTbtR2MND7sZwC7Qvm4wqHa4T/uIrhb+7n0EgbQdTijoyg+agWXT8llDsAFWr/B8qP1K7bT0pvtVwHhW6+t2C/m8svvZlawi2CKe37nhFtapkDnILRqBQA+v04AjMyn79EIkXO/DnzyCBwVweX4wxs9B4rRZgyPVFqykgDd+5JSpBU5r0vHyHz+jsc3ub0KABsZMCyQgeExKyFPVIz3lmcM6OfPAGCADYPE67Jfs6h7G0o+xvi7oyK4cLZfOgpsXwC2Lq9MwuuVERonKn4nSJrcXnQKcM7dwMMXgYcsVxkSebJgzOWPqdB1ad2f3gpsnwK2LXWeR9m3danUIV1lBSCPArBwtp+7DThuBti6UDWDmWA/DvXk8LRptfPtNUlihYZTOPCi04GH3wFsnwGOW6iAs5n3GeJJ+KLoE+9VDClQ8R6vOQHYegDYwuY3S6H/iJ8jb11ck0q9Qhoc9QMWgPBZJwFbpoFN88DGRWBiqQIgWyJY3lPozaGJ1KTEPh36zpTkJrcXPRE44S7g+Cng2DlgyyKwaclfFoIwvCwx9Zn3Q1DmIPx/2/sSaMuusszvjfXq1ZRUElJkKsBEGQyYhJCBSkUqAW1tsBdpuxEVaBzowXZqe1g90G2LotjQdmMjKqtBxQERdAWUAkUlZNBGkQRNyIAEMAkxpFKpqjfUG3t9//m/c/+737njPq9uVeqcte66b7jnnn32/s6///3v//++Tz0dmD0KzC4DM6vAFpd/0L3Gh6yTDgnvLwKzAWDGiH/ThcC2OWDrErB1pRgQisIQhAa+AED+HEEY6uNLyrRnZLSl6tSbrgLOeBQ44yiw8ziwfaV4UGbdegmA5QMTLFlqsfn7XecDW+eAmePAltXiXnkuZSBkRcm4UGXtU2uo3xsAZgz6y54JzMwDWzkgBOAqMMVBCSAUObh8QuN/CiTgcWAuyWhL1amvvBbY+VgxbW477paa7gIBqCnUrbUBiQuhAKDUot13IbBlDtiyBEyvtO5VDxvvVfxW/JkWNFrCeK8NAGsY7BsvKQC4hQCkJNaKy2LRIsg6SJ3IQSe1onKKC2CsOYMeN+0Dtj0ObDsGbFsEZmWp5S74g2Ir2uA22BScAJGA+dJFwPQ8ML0ETAUAkgDTPq9zdK/+sMWpPF19NxYwA4g3PtsHxAE4SQC6FdSgmGWRRIJLZJll8EGKjHiX1jwaN10HzD4BbD0GzC4WrsKMW2pNobZoCu6CLCDfCTqzgg6sr+wFphaAKQfgZHKvpRSYg7HN5XCL2AbAZwPrZGaj6ippXhgn0kqmU1woxnHedg5AATuWHig2FE1uVRwoxoX+Wcbg89S3AqCKPONcCi8oPtVP+9++G3j+oSK2xRBFDElUxbTS+3nvc4FpDsjxllXQoJg8FgdCQoGJJTTicLcQ6vPL6wbg9cDM4cJv27oAzFA5ky9/UOSvmg8oP86n0dICBn25JwjARWDSAUgBHN6vfdbv10AbARh8X91vDM2ss+NvAECKPVLCsHoyUgRqrlbnRwB933OBc+4DXrIC0IEmiLnE75di8HsyAcjzWUVGUi6uICMpVwwJVMXdeOk3XAxc+Hng+vV2esAYw+sWoP31r3eLcLwQBeQUrEHh4Jo2h4vDmJPuAyMLGAeEn7uqbgB+I7DlSWBGCwe31Gb9aL20kGDb/EGRxY6WTz8f2wtM8l4pgL1SgM8esHCvsuylME4nn9cfQLtldg6TZ0kUKorAfij23vAPCmqp3fcCl60XFINid1PlZrf41/dnApB6wSQjutUfIDJR8CGIQOwWEH7DywpKrWc8CFzqRLHkVYrB2jS2FQH5vkuBycXCAlIUUAAkCM2iRBA6+ARCe7DjYmQduLYTleiQ/XTTS4DpI+6nLhZW2nzVCEBaMLd+soIGqjD1ampdugiYWCpeBKA9bBJC9ActAk8LES26SqsftInLZ44dQif4Igdhym5WLrPDyuYH/7HTCNwDnPko8LXrBccjQaioe6BiKad3+QY/MGTH6rS3OBvCnQDuAIyqhiDkQ9RX+29yE3on8IwjxQPI8zkTiApGU3oVkD/4fGDieAuAdMw5MFQjEgg1DYsUku+a3uI0TGBfV7PotwHwaOEmbHEATvuDIutni6UAQoFRIFRYhfe/dhEw7tbe9Of0Si1g8HkrwRcevDajz07gIJ7n05rYyWIpb4ya/7vv8PRdFpj/LXDmkQLAnA4jCCOlTBRN/rFMAJKgkkVHpGUjySSBSFeg7/azqk8EgbSEq8UDRACLKDXSyaQ7Br//DcA4LSCtwnKhTEkQcmAIQhtM+Uaajl0uS9NatITXWzpzfcdNB4DpY+6nBgDaCtanYLN6fCj4u1ay0QIqtML/EYC61wSA9tAJeP6eWsAoDysFpg1eB0HIQRCIIkVeCqQf/05P3WCB+UPA+CPAzvmCaFWDKEuYcl1yMN+Y2dckqGTeHPEvvWDSNhOAfbefX0A6rS8CUw8X9066bFIfdqMHJID++DJgLACQumyc3gyAEYRRKFCLD1eu5ODLF6QvXedx0w3A1BwwxdAJLTXjd8seQnGrZ9bPFxLyA7WIKON63tYtCQBN/sv9QPm6BkLp0vl9t/m6ietR6fbyBA4gnXtORwRRpNnTtPpW6gWLH83lKqcOFTEnDiKtoHwy8RNFhrefyeztbnrBfbWfgttsP+kIyO32ELD1cHHvInrlvWs6TsnB7qAUlg/suFtAWkE55zYQ0QpqcALoNCXTEt7A3KoaDwGQfqoAOEUBa7fUbKctltwCajVbxvSiyvoasM0BaBKwwdKb9fN7NfcqBWGiSWykWXER0umeacUEonQgCKRfIgDFjya5yq8Wfsfs8dYgiuMxgpAg/vnMzu6mF0z6Zj5APdvPQec0TEosnvQosGOhaLuIYvnwEYSithE52F1XFAA0p5yigD4otCqygFKnpHUpLYP0OcKURYv6Mj4MNR433QhM0gL6QongawOg+6rl9CswKoSkEIxPyTsuAPigCYBmAXVfYcVf+n0SRYw6dP1YwNgHsgSajiJP429RrpWOM6cxDiJB6NINM4w7LbUGMQUwB/M9mZ3dSy+YVG0EoBiDBST5ddZ+PkCsAiIlQZDa3LVatJ0WXG2PbL98AB+4omB3oP/HgTUhmGgBfRqWf2TTrUSjExDSP/qWzQDgfAFAWyzR8rkFtDAKX75jo6nUguZxZ8NByHbvvqBQ36T1swcsBaBAGGRg40Ir+rt9WUDhQ5ZAU7Es2e9LLzglqHRxNkbeuW+oQRRls5jaMjnK0a9ecNf2R4LAwO829kQB3LTtEYQPUwzQAWgW0AGo8AQH0ljp/V17pm0KRcEifGuNOnocO1rACQbKPXhs8TtNwVr5uh+n6Zf3wDgu29g2FdMtOc8B6PdpFj08ZFrplw+ZA5FTvAQQ0/BT36FPDkRqBT9Jag7xYlQItY0f88j78sZzCcKPZlrAQfSCK9uvB4h577SCotUiEJ8opq8IQFl/PUBPEoBLxbRE62LSqG4dFB8r5bHcOtiOQSqT5T7RKzYDgJx+BUCCTxZQCwhaQc9oKcEnEBKknj5FsJ1LAPo9xoWWPWDy+6IIoqbeaO0VA+zHB0zxIQDKkn1GgtXiRxMIAx0Vn0Db+lkuFjLRCt5WEwD71Qvu2H5OfekD5FaciQay/GIbFgBXriwAyGmJADR1ck3DwTE3TQ4B0LetzBJErTYAr2BBSI3HTS8tLKBZPo/fWQDZp197Z3scjGb5BDp/L3+njMweB6B83Gj9wj3atOsPWin9WgXCFlVO/3ctf4iD8XkBkH5USlAZlNPZAQqARr5vxu1yjmH0givbX0UQKI63o0Wun/xHuR8E4VnPK5JQLd4VNttTBvK2uoiKOUf/f+GjwMNBh0NMV6J0c0NpcRv7mrYv3kh8/uHxYp+bVpwLp3R7sts2YzouSq3KGa+q7+x7Co4nazAerRKsVlV1QitF59dyyFZaYY0HMu9mWL3gtvZXMbymBIFMZ1ov2h0B+LTLisxgW+Eq5uU92iZ72ud9vvR+4JFp4NjkRh2ONi0OB1/UBCkvEYRhfuNs4OmhhiPKnFQlx6aAjMnSXJUAACAASURBVPjmz1w41nnwO4cCIBvBwZgTAOUHRq3gyDExD4zRGVYEnpm5LqmQc0M5esFt7acFl0SlHiBxuTkYxxdaihUC4QVXFu5FCUD5QtJl85sjGA0ziQxqeu/fem+hw0F2fLLQGxFlYMRvo7v1WmIVtpt1DFkXvOR7LwJ2HSkyoZmEypoVVe8p7b6qEMnidGG/Vl/L2aPOIwuA1pAIQE3DAmFa4j9f7CPaFpCHKujr5xzZesGdHqAqKz5X+FLRAl58le+jui+kTBALMcgZ73CDBkpN2/7+bfcWOhwUyCEAjQTcAVhKdjkPc2RajewKyu/n1//qJcA2uhBMRGXQOcn9U6JIOjXHQqSYOsVoQp1HNgAvz8yny80H5PVz9H6RqVd849WtXQ/zA0Ow2ayGLJ474L0G79vvbulwkJi8BGCg4S01SKqofoNvSIC+5zkhFUupV8rUTpJN06KpaBkFQm5M1HlkA3AyM5/u9Zl38zrk6f0iU6/4hmscgK5ISUtCTowyDqb7UxwsqFJW3fo/vbuIBJEZ1YRgyHwQKNi0KEl1OKTCZJdxtPDn//v8ooaDaVgqFyiTD2IKfcjZS4Fo+7g+HXOPv84jG4DIzKfLzQf8KVfI/FNKrQ6h94tfz+vOA9cGAAbrpylY2SDlVTTt+uCnV3/V3a7DQQAysJAwobZJgUXi78Qayhd812WeiOAZzEyUiAkHMeu5BF5FwZQAWLPwknkLQy9CrPMy8+lIHZFzvN3T+YbV+8X7c64OHHix74V6zIxB+RJ0wQ+UU992tYoFy3fcXcTDxQkoPsCUhFIczKVCegSg5B8A/PILN9ZwxBSxtiKiUAOi7JW0dLTustF8AGbm0/1o3vjjnSGdj+lYlGwdRO8XN+c1wABIoHk6k61yuSCJITq3jDY9Vx0BqK++uwAfX6JkI/hME0SC1EGguiQ+isqcQRLrF6/0jO2w+6FMnZhyZYsQ1W50qOHgPX1NXndtODsfgMwHzMin+0+ZN0S9YOllMzWfLwKQSS396P3iY3kNOLDPM1y065H4gOW3p4uTDkB8zWdb7FgbdDhEgJkCUDRvogTmd/vPv3BVAUBuvylNzAAYi4hisVQnEHoIqWblrxqm4Mx8ujfljT+YjsWBYgIOc0oJPsq1slCpH71fKybJOEoAuuVTRSCnYlmU6P/Z4iSJEcbLv+Yu9/1EAh7JKEXDKxq4ChUiKymRbwjgHdcUWTARgLYXHSr2LOU+BV7MVwzxwOfkOWybYAGZD5iRT0edjpxD6VhcOQ6j94tP51wdOHBdMeXa9OqWRcmWXA1XLUIUH6zyCwlAs3z+YBkfs1u+VIejJEF3ckrjI9T0y/aMA2+/tgAg08VURKT8vbKMUgAMIGzzAcOi5HknHQAz8+l+MW/829KxhtH7tTz+jIMAJPCYMULAWd6fvi+EY9ouoZBM/Kx/4LUBgFLgNC5o16FrE8JJVJgkiFhaQQBv3+dVbMrWVsC8UxFRkjjaVsW2DtRdOJ/vAyohVYK7A+bTvTdj8HlqTMcaRu/XxHkzjgNkIOWuDr8jnYYDKDutgpUhra0uAlAyCCUAK8BXcjBXgLCk/h0D/hcByDxFAdAzoFUqUBYRJTUcMWdPP7ONL6i5bLQeALJRQ+bT/W7G4AuAOXq/lsGdcRgAY+glLkYclJVTsa6ptCX3uQjAKINQstFrAZKIwWxQIhIJuovB/Nx+r2LzFCwlj8Y0evl/MYk0kieVtcvrwGUnHQCVjjVkPl3mItQsIPuElx9G79dOzDgMgGkAWlNyBJn8xKprBRC+zgEo4LWRgcdVcOCjjlNvmx84DrzNAahaFZWLygKWxUNibIhTcPD9BMLLa65bzreAMSGVoXvJ/Cgh1WUfO+XTZS5CDYDs9GH1fnOrIDcAkABTTDCCLYK0Cwi/586WcKJUiEpC8CCBYDsiiSplqUIUmOjf+o2tIiKVUJbgU5uSWl4DWwX4+PcXnrQATBNS+8yny1yEopdcay+930y5YhgAg+9n2OoUeI5TdQer+32fdhmGoOBZanBo+g1yEKU4dYgFSvqB//vZBIBt9RshkTbW8ZZZ2hUgvDL3iU3uux4LSBM0ZD7dPRnTH08VAIfV+2XAOucQAMuVcKfFSD/+IAABsEoGwYAoHZIKEEYxRIHwLS8pUuhjFVs6/ZZhIVWyxVKBBIRXnbQATBNS+8ynI4tBzkEACv+chlUVIKE/5cRGsWmlKfIzudc3APLQSlg3E2OCyVRc1kpU3DgBmKoQsWtlBcswjPu+nfTYtBL+GQdgOf16GCZW6pXlBCqWSgqJypoOAFfXXDifbwFJLvi5HAjlnUsiIe6AjOp4iQNQHRlT2PlgJCUbbc2s+v/hFwFb/q7gm6HlYpBbmTV2sscQyy/qFBj2v0/cAdz/HGD7NDA1AUyOOU+1CwWOewNjKj6/O03F1/WuugW4/XJgfBoYmwDGdH7IxB5kLPIB+I8AfNwZgga5ck2fJbEm8V9zNWPfrasbgMuPAcuseJ8Exsb9FdBhA+7gaQNKB6TfcgCYug+YJT+g89aoBDMmIMScP12uTKj13uDv8zsKig/uJ1uQOsnojm3qB5P5ACRBH3OhPuzzRN9DV88HqQLEWPJnvTy5nm/t/1s4BcuSpRZtGAu4fi+wtBVYEyccrYwn6hF8/FkJp9bKxAKVFsn/d8urgbHPA9NPOEOWl4+2cfoFHhfVrJTZPKHSj5daOtup6JyCpPx8rHWRVQ7WOlrYCMx8AHIzlxkALPD9c0VB+x/A3E/+E2fUYHXdF7KTGwdvTd0AHP9r4PgWYG0KWBdfsBdsMPfPrKKsoL9XAVLAvO2fFylCE4cKliyrDVZNcGS1CqEYhWFiAZV+XntaURdTLmpCEbpchTYLqi6NrkMCzLzt5Xc4HwyJmmkJ+Z73jQOh4NWeDUZiK1K08f0EXt7CMHVawIk7gaVpYJUA9LI1Ao8bzKX1cytoFtFfpdCIWz7rgzHgth8u0oPGDwETc8CEMySUzFaikgtlpW1Ta8JqNba7lVljSRgW+Q6ZP/57WQvj6fydBjXfAjKbgEvMLwWCvhNoipgNpnQshlS4IGFWzIk6ylWwAz93ETLxGWB5ClidLABoIOS7pmGfG+33YAG5mND0G8F4678vkiPJczNOAC4UyQm2N8w94kirFlfIAl7i402d6dbPWWAtrsjOFiuCvAJZOQE0pHTFsckHYDeCvhNgipQNxoAz8/8IPr5nbvH2jd+6AThJAE4AqwTdZKEBLDoDgU4+YVkPHIBoPwareOt/BkDexsMFAFnbzNJYm0IDnVwbt4uyur1kwL7Tp+iZM/08WT9Rc7DHUmuYTr/x+6o4ovvu9fjBbgR9JyA+omwwxvZI5ULg6ZW7y9FPf9QNwKm/CgCcKABovh8ByVy/UCtJq2f+X1yYJPGU27lIZLbuEWDsWBHesZeDz4iURLUWa1TE47LqK12fZmd3OXidFctqm92KatVs1jAEsNv6sdymaa2g8+xUL4I+Pn2beCgbLGWHI/h8G3oTr45iK86POlbBU9yKI/AcfLR+ouQwH9BfmmbLlTHboOnZ/T9+5vaf8FUaAThXsFOQ45mUcgZCWTAxe0UQ+urYMO1/37GtxQmoLCBtRSp30LrDp2SFdzYMgk/R+VNwvwR9mwQDsaspGSfJgYDYNTbp8psCQFJxEIBkQjDrxt8dXCUIY+COH5MVFPi8SOn2n/QYLZ9Gp0cxANIP5IvAkzVzxivRydnKNzBa8fddM84b6AFyAriMF2pajk9kYIeoClXmA3AQgr5NQEHMBqMVFMNaIOayNRL/vhlH3RZwmhbQQUcAasrVVGz4EtjCu/3dfb/ID3PbT7uKAZ/MhcIC0vqRTo4W0IBIEAmEtFwCYqjW03bcmdwBYeoWgetUbrR8snrloiR2drpACf+rD4D9EvTVjIJu7HBV+781X752Czj9lwUZkTEgcPoNPp5Nv4oBRhCG6dd+1DkMz1JIhR1BAHJ7zwqO3fIRRM5tmDK5CoQKsSgOeBYBKFZULTqcB9r6Ni5KYmd3WKDUA0BlhNLM8EbT1QBXBU72aI5ZjUcVOxz7WLkQ8d37vsart/uA6RcPsxNSAtAXHDYNC1AEpf9s01kKwuBwGU7HgVt/1jtD1e60fgQigSe/j5bQp+KYpGB+H62jT7P8/ZypBIC8Dhcx8eY9wF015abhmnoAyJ5WSrKeNgKO9SHxnT/LSasJBim5lRjWBEIVeROInKL1qunybRawLgASdEy74qjaNNzJCgqEEYzBGvK0297mAFSHEIB6ebKDgc8J1ksmV8t29f1en6L5v6cxIK5iK6Xne/5jCTiFcTqVn/r/tWDPWwXnEPTVgIKUHU7ljASawKefIwDpMdRxRB+wFgD+RREDJABpwSzz2c0LfxczVjkVKwaYgtBBezu3SvX08d39P5uO3QKahXMQciourZRAGKZWar/YZ1xXRPe8wQr2AUK7TvbOVTZBXx4MBECRnConUBSFEXT6mf/TK+/qmzAF/0UBOPqBZYF52HrTFCw2LH5G8UCzJEko5nZqmRnPh/uCXmpnVpDTsIPPwKApOaSA2QLDLSHf97iPx0tpISLfz7bl4iFfsUsnj+HZWEeOYDCDnDmCvZkEgedcCjxGseIhBYt3vx049HwMLRh8gA9gh2MoH9ABqKJzxf0McO7XlSAU4HzhYYFq+5D7hwBu/98OQLlIBCKnW39SlXNY+nqeiq2dkQg+gnGPb9/ZpT0lq6MV5D96gLCwgDmCwbdnCvZmCgY/dxy47xxg5SWuUjigYPHFbwA+fyGwfr2rXrMvPB+vp3L3GHCgi9JOHQCkRVPppeUBigXLFymyejYTB4YsgfA20ofRAlYB0FfAlvQqP0/TsX5PLOB5DNu471cmIwiBaRww/F01J+mz2pqChxUMZvpJlmBv3iTocsW4dzewfhkGFix+2febXDAeJO/YEILBB7pU1g8LQFo98QASVGYNQ6DZfEG3fnEqrgLhbf/HV15anbkFNCvohWSl9XPQ2XTM/2s3I4DwPIZwBEDfgitH0Ek6N6x+u/iD7T4g/YdBBYPpWHEaHlqwNw+AQa4Yj54JrJO+aQDB4pt+oCAyYvOPEIQDCgYfeF/9U3AbAMX7ItAlVtAspKZdz5SOlvA2pstxjES3wJ+92NgAGK2gwi78QoVfEhBeQACqNNP1RdoA18kKdgDhxkUI/zKIYDCnqyzB3jwAJnLFOEIW7QEEi1/1Y21ywVglCAcQDD5/Efj7M4CVrZ5AKlkhxeQUaxBI4nvFzxf8IfCVC4HV7cC6ZEX5nen3VX1vAGLZq8ysrvHY+QBwbGfI2E6JpLvdX+ksthpUvQrmX/sVDGZVUJZgb17vJHLFeGQcmCdVb5+Cxd/5xjZ6QzzMLOQBBIOfTV2Ps4HFHQ7CLQUQmUrV0rgKJMsCjsxGAqTn/hzw0EXA4tnAyg5gbTYBorKkUyLnkB9YVhTxu+kT13iccwtwdBewPAus+b2ar9xJAafqfgMQO4dh+J9+BHe5gqZZZzYok1JJUcpaR6bp93P+W/N6p0KuGIemgEWKgPQhWPxdP7NBLhiHKYHUp2DwpZ8rLOD8tmJQVplOLxAqmbRKC6EDYC7/CeCRPcCx3cDSrsISrs04CPm9ArZk55UvKAspYLqPaPdR4/H0g8DRHcDyVr/X6VabLHk2PhjpPVZY7d5xwF6CwS9y/4LbbVyQsEKIufGiKe0p2JvXOx3kinF0GjhOQY+oNRtljji9TQPf/fOV9IZY4Gq4D8Hgy/4W+Oo2YG5bUUy04vUcLCqSJVRWszJbNgxSmMau+q/Ao2cBR88EjtOqbgNWWaTkIFz3YiWrF4nAjtN0nBZrJnU+/8PA3CxwfMYB6LUra3oglL0tps6wlVha5rLiqd9AdDfB4Je6U0s/0BXTDYh80Sr2FOzNA2AXuWIszABL1JaKWq1R+nwGeM17OsoFY5XTVw/B4Cv+Djg0C8xvLYqJCECzgsxmZlq9T8e0XGUyaUizavPtxoFr/zvw2BnA0Z3A8e2FVV3x6c4sqwObckeyhiXAowUSADhD1XhceDMwx37lvU4XxVN2n3rJIocygkr/Vbs7fe+EdBLcfaXXQ3IPWIrpBB6XlnwpR76jYG9e7/SQKzarxM7qJFj8mg8UarMV9IZ4gvNDD8HgKx8HDs8A8zMFAFnPYQPDl0Co2g4fpDZLqKCxT0/7fhJ4fCdwbFvhRiwRgJruCOwUgCpeCvUjZmEFxhfk9W969kW/B8xvKQqnVgg+B6CB0MsI7P70AHgmd2n1NQ0rv7FvALIlVYK73MnQCDLThSGZoDpuP7uCeuX5n8zroB5yxThGnQ0CgyBMxY63Aq/5aBHG6EBviDlOLV0Eg1+0AByZLgbl+HRxnZXJoqqttA4ODovlJZVuSjTQFtq+NwNPbHMAzramdVpVs6wEoPtdNg37wJfvsYiJP9NFqvHY+7vAwjSwxAeNxVO8T6aNVRRRlT6hHrJ0Ovaw0WDJCKng7g86APvNB9wg2JvXO33IFWOBgn8EIf2nRLD4tbe1+AU7yAWbZeskGHwVdd2mgAUCcNKnJgLQrZ/V9/Jnn5JUYmnAE3hCmv3+t8AWQfSzyPK/POOgJgDdsgqA5nfJAvLdLV+bz0kK4RqPZ3wQWJxyAPqDVhZQyQr7gyaXI9axWCFVAGLvRUhV46PgLnUWBs0HbBPszeudPuWKsTRZAJDTo8l8ui/42juL5veQC7ZpsEow+OrZQlqVVuH4FLA8WVyDAOTAmHUQCAWQkOlsQAwDt/9/AE8SgPQpNa07+AhAA6HLXbb5Xr4IaAMfv/eGvP5NzyYA7UGjBWTWjh40v9fSyscHLtaxhJWxFVsNNAXH1khw983+DYPmA5aCvXkdNIBccemfceooAfhAAcA+6A2xLuAGucxrzgKOMexDfV9OwbS2BB/BEoqLSrBoYGgJ3E8qLcIEsP/ngCPuUy7S13L3wb6PU56/m/Xj4Ps0TKCXQA6AXuNeZY3HMz5QANAeND1kwcKXlj6wOZQ+b7R+Pi0PD0DeFAfk590CKg8qncfoFzIRVWVqfFfBhgn25vXOAHLFWCDbvPstBsJZ4LUPt+jdesgFg+qVptWq11bg2gtgfuLiRAAgQeg+oEmsOujsXb5SsAoCIN/3vx04OlNM6Yv0tdx1MKvK7/TFjVmeCD4HQQQhf159eV7/pmc/kwCcKABoeYvR0oept7SEoZQ0Tr1lPuPQFlAtO0nyAcWhpzw/FSjFzGjLx+RGvxzoSeC1hwsA9klvaFN5FAy+9mJgnhaQ0qqagglADo4c9AhCDpJPl5ZommQ8738HcGw6AJBW1VecZv0cePwOY0/wl1lAD/WUCx0mMlDLr8bjmb+Dwp3x4nkDYbD0thIO5aNtfmDi/xGEeRawxhs7Vb/q2huABQJwAlhyy2cC0xoggjAAUCWWAkksOiIY978TmOOqeqqwqAx3WGhHK06n7TDwOcAV/iipPAKjwgrZm2o8nkUA0gKmAHTrp+o9MTrEYvq44o9pZIOtgmu8mafCV72YAKT/RwAy5OPOuVlAAk9Oule6xQRTWUKlWtkU/IvAHAHti5oIwDK841ZPFtCmdr0U8PaC9hVultd4CIC8P2Ztt/m5/qC11TJXlJDGGpfGAmYODgFoCxACkLpuWh3KCgqE8gNVZK4KtxgjJAB/2X1Krao1rfN7CWZf3LSBT4uAEIyWBVpipL7GgwA0AW25GbGENBTRx3rm1M2w39mmrFVwjTd1Kn+VAZALEE5LtIDyMWUBvbLNLGHgd5H/V07BDp7r3uU+Jadgn3ptxekA5MBri0/Wp4wzBjDbCnkMWMqVpE8GJwLQqvfc0pqbkVj5aNk7gbCxgJno30cAjntowtXNaZ1suvSKNhsYTcVKmw9F5xGE+94dfEoP+JYhD/8OC8eIPUsUHokVVKB78XszbzAF4Pvd//PCKVGIpOAr78mn4DZOm8YC1jco+w6EFTDDPJqeCEBZBa5GffVbhmQ8DtZW5TYOvPhXip0GTuu22lTMLSw+aAVl9QhEWjurI/aQiLJkTMLsX9R3r/ymZ73fp1+37OU9hunXSkdl7T3QrhKCtlCM59k2i5CMMSIAGdqxEIwrmptzTsCEut5yilKoJLAcxCq3fe8tLCDBFwO+tKjyuxSCMdYEXoeDrHcHvu0tTwLzmwHA4N/Gh6zNCqqeOSxC2lb8tQSiMwbuqXIqAcjFh2JjBKGJyShQG6ygVbfJegULWBYcMR3rvb6oCRaQwFPgl1M5rR7/JtBZOIZWx/0+s4QeY5z/1/X2tFnAxPpFELaVkdLN8MWGVr4pCBsfMHN8bmTKfCjZ0Ncp456/x58zLzfw6Qf3ABd8pUgEYmqk5bGyek06IQl1bkXScnlN/u8L24Gdx1qVq91KQvrpgwaAAw9p+wnXPw1YjyWMGtDo2ASOFGMU7SIEUzdYD34vMPmXwLbHgdkFYAtlGiim6DpxJtvq9LtlVr/aWKEB8pUXAOOPAFPzwBTZ9r04vdQ9Ts4pAZ3cd+yHxgfMAOH+vcA69/9Uxijmz/AerYpdar1lNSMYzV+vWY/34I8DY58Gph8Bpo8A04vAFEFIknIHohGVR62QhFRSYjQE6qFri2z3iaPAhHNNlxKwArI0Q1IAxwfReacbC5gBPp66/5ICgLKCtqnsrKKlrFZUFPKOr7osMTtdsxzqQRZ93Q1MPARMPllohUxRqkEK6gShOP0S+dY2hlRv99y+ovRi7IiTnTvLqmg6xDPYpqAUgRgsoR7MxgJmgHD/c4E1FXu7FRRbvEgd7evXWlbPpp9EgUjiJpwe6zwOMlvpAWCMVusJYPIYMOlSDZRpoGiNxKzbdIQlXONMWJbGtw4svdgz3El47nzTRvPrrKptAJT6ZrzfintvAJgx4vsvdQvIXK5VYF3sUZxmJUvgA1FOvwF8spKyBtM1y6EepI4LqVMedbEaTp0EIKdPKh5FqYYqSxgo2jgFr13j6XXHnOiSZOeBVSvyC8qC2r05FVvVw9cAMAOA178AWPMp2LJaaekiCPXExwHw660n1oB/niGQazwOkkSepbJ/72I1x4CJ+cJ6lYI1riccrVicUuVSmIW82pkwnHHVOKbFsOozQGkFkwewnBES37ABYMaAX39ZAUCCb82nIlo+40p2gNnvsoKunxH1xGwA/LOzdQOQJPIuHzV2GBg7Cow7AI0l33XfjOsv6oVodes6ISbBsAZMX+kJxU56KY7pkmFVhOciuvTzSt05v0+ryuT/9gDrZNe4wPMsI7VJP3GcP7gUOOdvgL1rRYJ0ZI5IV3hV4/wrGYPPU3/AiRhYusy2K7mU999P+z90ObD7LuBZK0Xdkeq9NSX2+o4HLwfWlopFCC0fgciBMtAFC8CGrYXVoVjnU2G7rTXrzh4kfRzLY1kyGwBoeiGcPiXb5eAzdXWnazPCSScb4j3xfmav8Cx2p50lAMW0VXINitCogl2r9H2dcctWwQxQsn6ZTBbMNtcgdKIbiZj51VcBk38CXPxoQcfCUg8pjcYgZScw/momACnXyr4leBhs5QaBTHpf7X8dMPYJYO8XgAv9e8QJlAZZq8D4xSuANYKPJQn0AR2AHKy1MACKe9nfFI6IEqduEWoHIJ9wlsVKLekoMCa9EAegSTYQeM4TXco2SEMkAHEbBZoj4bbYtdyCVrFqGXgTSxgXYTZeHLi9AMjEQRCVUXP/n4KUaaT8vVTi+Rtg7GPAuYcAWlMCgUVkQfJ2Q12yBvPXMwHImhDWwf81imsTiLSEvHZkr+jY/p9CQRD4p8DOBwteItai05qn31FFdfLlFxYWgCDUIkRkj/TxbCEi/89jfPZ3X2VqYSJQbmUNQY3HQT7hbv2sLoerVwKQHNEEoCsm8R4MhPRjXUGzVEIKIoY7yaEYuY4dgGb5RXruoSgtSCLLarkICQ9f6QNykGjFdjsIBaI4kGlt8W+Rg5g0HJ8qAp47nihAzFpuWtPIMBZJlASILvR6fQ0DCVbJCkJOJCqnk4pGpb99tZ8MopyiKDX7WWDiwYKXiEQOehCrgKh+eJQ+EQHo1Lby/zRlyf8TIbf9XS5ftIb8I92YugH4ay2pLusorl7dAoonWtMwQSTdOFuQSLTGHyIC8kxSIQuA4hwU2WUAoO4/grBcDbsfWElSzg+JCoYDoEGM1ixSkHzgF/wG7y8sIa3J7JPAGWuFJSQIaU01iJHUiYP4e33BrPOHmG/JMaOfTZVYRhwGav87vWKPJ9/rSH4IOGO5sITqg/ggxXs4TOaBAECbeoOsgfl+DrQShFqcEIhyyt0MbMusEkx76iAZXKM8BvXiZAGlF+KaIbaadYpem4aDgpJZQz6YJABV5VcHAJZ0v4FxX6KG5UpYs0KnqjhRuagEVgPglYAl9ciHf8mdUrJh0Qx9vkDBzBywfbkYQIGwahA/kglATsHsDzKA0BATiPyZ4NEDwIeoa/uFYKKXL2f24nQoIgd9R3yQCMTFqwIAfdBWI7+yB5ZLECYLETd85YJl+2YAUNosLIel/xYlu4Jsl6bhNhD6it4WJCvA2Zc4Gxo73RcgJeOqFmGR6rcChLYACyGojmEYdj59KnZ+tIQRhH9IvWA2hiREjDeRI9Cly7fMF3EtWRFawhQIf5IJwE56wdTIYdt7tp9ys1K8JnoJvod9Wn682PNkP4hUy1ndWgstAtBDMLYN5/6PAc5DGNoF4SrZfN+4+IhT8jqwg2Cp8ThIJ5vfSWBXAVCrWN9SMxDK+skaOvhoAc8me654pmUB3f0wyt+E8FyRAGmPlOEoiSD2qgvmAKoOm52fAuiTDHSyIRxx+lI0QxxADubfF5vffMmSajrWlP7nmZ3dSy+4r/ZzAUEHnQ8R70HsXlK+PgJsW68G4XYGZj0EY2EYATCAT6tAhmE0DXcC4faapcwMgAIfLb0kuzT9Qmw5uwAAIABJREFUSi+EfeALkSrpBovbrQDnkm8wAo8/E3i+CCsZ98NCpAp8cUekZyBavI4ET/TnaAk/RQCyAXy6uNSPA0i+wMeB6ePA5HFgZq2wpNGK3FUDAHmv3fSCe7afX8CB4UNEEOolVi/3obastNwJ9cO5BOBKEQMsAcifHWzRAigWWAlCn5K2bQYAOe1KMjTIR2kRUhKVS7IrLia0v+3xwHMZMCbYNP0KfG79zAqK5DxOvyEuWu6VD5KSHy2YAEQAfpaRdl5UkuUctIpBnCIIl4psD03FtIIP1ADAlBuJM47EqqUX3LX9kSBQcuuyftK78xUkHyQ+RLqHZ3Fv1KcgLj5kAQ1s0Qo6IA1nHhNLQzA8ZxvBXuNx8DcS5UYpNnoYxsCnUIqvZo0F3wPTMa7Hv53HOJVbS/l+5bumX7d+5WLE44hxIRJB2NMCqj9ixwuE90svWCaIA6bAp959EKeWChAyA0PTOV2unGMQveCO7bfqHbcS4rJR7Ewqnw5AWhLuImg2uFQAXAVs8RGmntW4+g2hB3P79L/EJ9zGvqrxOPibiVihAOgrWQOf/EBfBcsPNBBqW9Hv6zzGqFzmoXz3B9AePgXiq6bgiv4YOB9QHS8AfpkAFMMjrWAcQA0iO9XJiQyAnos2vV7ESHOOQfWCO7Zf7F40mZFQScRKAYBaSU6vAVcTgN7xXHiUFpDTMK2dFh56912BTiDcvpkATIXzCL4g3WXTZ4jpGfjoF/oihL+fx+0yWUABLwIwtYKKIabgCzHQvi2ggBKn0McEQDaKT5cGkIOo6SuyYzEfjQB0EM5nZgAPoxe8of3sgSqCQM3jkdFLvpRvR13+7UVRuhUFSavNO6otwp88ZZ3+t4M6HLtch6OT9AG/q9cmtf//gV1JDYcnQ2zY6/YakfSrU+Pg1M45NqPt3IEtoM7WFHokyrWKkooglCMWLYjiUXMtK3g8Uzd1WL3gDe3vRRCoUEYCwGtYFxxqgA2E/jI20F5hhmQod98BHNnlxOTig1aGiDanO21yV4DygWuB8YeB6fnC9WEtiKVVKeE0ZGiXWczeJoWMIig5a9V5DA1ANoKDeDylZ9NSXxyAsiKawrQqmCv2HVf5e8aRoxfc1n7xs+khItAUvojvyWryxVcWJZksVSyZoQRA3dcAoHzax4Gj2wtu6FVKM7gMgti02jbV476oUJJs1j/AbA1mQ3Pm8eTRsoZDtR+xZKCiEKmMXTIeXHPGdhYArX8FwG4DGMEnAHIK4yvT58nWC2b73cexaZgWWaEKgU1gjNbPP7PvOYGsUSBkv3hBtmRWNzxjTk9RWktvxp6POj0vARjY9sWkFel8RWxegjIF4RjwAOnZWMPBTGjqvHmszxJOBUD3xyznL2bqROvoP3N3q84jG4C7M/PpcvMBef0cvV9k6hXv+2Yno5QfGArRbaCC0mWv2YtF3ecerNDhkNZIIsXQRv5dlTtGADJSz2gEE1EJQM//026HdIEZLC8B6A0tk0g1Ja8DuzJdphS82QBEZj5dbj7gxZN5er/IZI+67pscgE7QaDOUMyC0Wb8+gXjuR4F5J6YsaXnFhBoAGEVvUhb60jISgCQnoh/OLBgvIrL8v7DdFkEYM5dtNg97tvz5zJqzdfIBmJlPl5sP+DJP5xtW7xffnzeh7H+Z+3+RpkyWT1YxuURJYVtx6T0fCTocouQV85VkHRIGegEuEv/YKpkA/JceVmL8kv6t5/9pu62tfiPWcFQVEa0DZ9WcLJEPwMx8uvfnjT9IgZyj94t/ldeA/S9tMaGa9SNdmsIxbvVscVJ1GScoMt4UPwhAsmMZ0aXzQBsvdGRBjQz0FUpEJRAJQOq4KAnBdz+sfiPJ3bOYn8fsykyVWMfiN3BOzckS+QDMzKe7OW/88aqQzsfE5kH1fvGjeQ0wADodmVGwOeiMsUqHrGOnS4UFy9P/wAEojkEnI+IqOIJQNLgpCXhcmLAtD/D+kgQE235L93tj+YBqgTX9BiCeW/NedT4AmQ+YkU/3sbzxBymQuZhm8g1T+QbV+wWFdjKO/Te2mEFNlCb6gPF708VJ1TXHgKd91GnZpDfi1k/gM2vqU3DUnCuBmNQe3P9vw6pe229KOvB0K1k+ZS+rnrfM2AlA3JMZtah/EZKZT3drxuDz1O/yxAwu9JgJxr3lQfR+8aa8Buy/wdWQZAVl+ZzCrG3q9c/YrkmHy3IRYryAAqAkEBIlopJxNNUbER+fA/H+/+AAdP9PmS9dazicJybm7mlB8nR2dI1HvgVkOlZGPt2nM29GCamcGZjAwlQ+vvrV+8X/zGsAAUiLVPp/wd+zaTMFWw+/kAA0GQQnpCw5mDsAMIrcRB5mC/+MAffTwgfwKY2KfmCZ6ZIkUShrxXxBX4yYaV8Hzmcn13jUA8CMfDqWYeQcSkhVOl8U6uxH7xekrsg49h8oiCENgC5TUG5vKxxT8f2aRtOtcAKQ1s8soPuOVUIwpchNlEEIOyNSIrrvv3hwnckWIZPZsnbcDyzTpvg3lU8mpZQqozyfK74aj3wAKh1LgrsD5tMxiz/nkGD1sHq/YNFOxkEAcuW7oqmXlisuQOT7VV2jwi/kTgj1RkoZhBje8Z83SCAEEJZW0C3gff8tADCt4VASaWIBK0HI9q8BF5yUAMzIp8tNx5Jg9bB6v/jdDPSRns0BWIZeUitIo9IhHmhXTvzCPQddccnZ76U1V/IvC4SBCFyg26DFNg7c++Mhhb6qiCikT7WVUmr6lYn2nRKyrdZ51GMBlZIc07GUBdMjny6XCiUmpA6j94vMZbgBMFo552pu27PXAqXTyAUQcitOQjAm9xX0N9pIwIPmSCmH5QuPqER0L4kDYgp9zOUL6fYxkbZcFceyAreAF3GlV+NRDwAz8uksnT3jiILVSmpWNlhMze+k94vMZfgGAPJeHDjpCrgM01Tdry9OzvmYAzAqLVWIwEShwzbRwwSEn+MqP6bQK5tZlWyhjCCCsC19Xv7gOnBRbgp7cu/5AOyVjqVMmA75dJZ9nHF0yohWNlhMxKnS+0XmMtwAmFq4imnYbrEqNJPc+9kfd62RKh0On8qV9hXZ9askEPgAfI56ziocUgVbzGT28lEtRMoKtg7lBHtznfZNA+CQ+XQWM8k4uglWK/NLYKzS+8U9GReXD0g/Tyvh4Ne17Yb4Zbr6g6y7/aNWcoPpjKRTsJIags5IJwkEAv6en05S6GUBfRWsUExZyVZVQCQwrgN7Wfdd41GPBczIp8ODeXfTSbBa6YYxlY8/p3q/udc3C+jTbtvqt2oadnB2m4oNgMn0W0p+hYWHWbwg9yU/0Kb9EIy+5y2hiCit4UgKyTeAkN8Valk4Le/ldlONRz4AWWBRM6fdIPfHstw/G+SE5rMnVQ/kA5AkLHS0ak7V7reXfhgACaBqDtD3e/nmc5k9kA/A80JReq+U38zGVp3ObJo/BvAOD3dtwiWar9zEHsgHIGlFubqSx7+Jja36anLLcDvvgwA+NDpDfILv+qlzuXwAXuSjrkKemlO2e3U1uWUYnL8dwB/5e2apca9LNv+vsQfyAUheX4VguB+mzIsaG9ntqxhF4Xbe3QD+n7/uHLAW9wQ1tblMRQ/UA0CaHC7plXEh+q4T0OWcfhleYTSHBK0EH/mi+fcRuKQn4I6fWpeoB4AevCz3HOOm9yb3F5mBlZBNclYCj1aRfyfrbgPCTR6AzK+vD4CyglX7jpmN7HY66d1E0ctdIrEEE4wEIMlam+Pk7YF6AMj7EwAVbU82vTerCwhAXopJN9zVI+AYrOeULLZgErY2x8nZA/kAJGWr0naUWdFpy2cT+oCWjpdjLFxE5UzYIBBpEUX5nLnlvAktb76SPVAfAOUHpiAMm96bsVtCAMaKALICMyxDq6cXfycA+b/mOLl6oF4AiqBRIEzBp7/X2Af0+fi1XIioMIlAI+AIPIGPmeROWV3j1Zuvyu2B+gHoFfZiDS2lC0LiY52WUADkQoTTMH1BFSYRdHoRfKSu5v9qrizMHYPT+vx6ARhSuDcAzzmDo5ZGHT1PAKYMwQxME2jiSo/gEwBrrq+u41ZOy++oD4BaCcsXTPiSI3ey8s4KGoG8QwCMFM+0ggQhLR0BF19SXuD/ayakz7uR0/TsMcxg3SjfqWNA0hsrga/ojaq/8WPcC+YIk4Ke4CMSuB2XVht1Oj8zIfXlU8BtU8DhmYRXWdfrdF1fgr3+S8At48CD04DVjXQSDO70PTUnaJ5uOCwsIIFHSSFy1pKPWCDsZxCpw8UVgKSPxLXM937OzxxAljzcPAbcswU4Qh4V3UN8mKoeKm/bu78IfKJQa8VD48CylHQiL3O3/qg5Rf30BKACMtJXjXKQcfBSK8Dfqc3KVCwuN2VFGRnm/yKZtq4Re5ifyQQgM2A+BeB3GHaZBo5MAIue0l7Kt3cC4xhw+5eL7TuCkJk1jBtyerbUfYG5ExjZ/pqrxE5fAOrOq5SmowVIrRp1IyT2R6+fg0bgVYG4CsyZe2UsaiOGKXr4Sfp9k8CxCYAFSKyvXeY1o1BxQux91yMtfsHPutgnnyUuUvhc0ZsgUXib+nVkq6+ZKaABIHsgVZnuwD9sVo66rrR4ImdhLGSQ8zPL/JgBQxeU1ouWkO9PTgDzbgmXxrzMkatl3keivfG5x4r4IRcz5BfkO5vEZ0kgpIfBZ8yKjlL17syy0tMNcOn9dl4Fy6dLFabj1Mpvow9Ify+I4Nlo9Xt+ZqU9VdJpqZh4QDDyxUyYOYJwHDg+DhgI/WUVZl7aSEt93+GO9Ia2iuZKOfA7lhp9JpvAVy61w2mOwO5hmCgMHC1H9O24gu6UD9jP+ZmbtLRaSsei9SL4XDPbAEh/kGQ/pSUcc0lbApFWb67lQUhpVnLBsoKqqZclFMmUtrxPcwxl3X7vOCAtYLSCcugFQmqhdssH7HU+RznjiOlYXA8wqkOfkItTAom+oKygca4ES8jY+N3z7fSG4hfUtp3ihUHruVSsFy1iRvNP+1N7A5BdJACmVpAgZPhGOyCigEjlPLudn7kvFtOxuB4g6OjD8UWLRkCZFRwrLCEXJQQhp2K+37lQeBCRX1A7KPQto1prFEmSYn2mB9EAsO+kYfk8KQhZF8yjVz5gp/MztyOUjiW9bCUhEBhKRCCgSis45uQ/PhX/xfFWMgOnWu2gxB0TF/o0kEZ/kCDM1Ts+3RHYnwVUL6XhDFrAswfIB6w6P1MrTulY0sum1VICglKwCEACqvQFCUK3gHcsFQCM/ILayqP1k9JshVqrncMalOYYvgcGAyCvIwuod8YBJQmZpmGJeyRwkGw4n8jJOJQNw3idLFhMRNB0SgASTJyKoy/4ieXCeFfJBUeV2SoAclFyR0bbm1OHTUiN0/DTAwD7zQeM52dqj8VsGEkVE2jKetG7AEhQ0frJAv6RC0trC1skl+IWlNinGLbSaZg7Mc0xfA8MbgF1LQV1z08A2G8+oM7PVF9Ms2GUE0gQyp+Lwu2yagLgR9ZaYpkSypQ6a6Q2DCqzpkvietXIFdoZfuieGmcOD0DeP0HEbBhNwYPmA/L8zJQsATAKnguEqS+XTqkE4YfWWwCUFZTksYAYwZfIBeN9Tw0cjOwu8gDIZqsoSSvhEeQDiiGYFoyWiSDRypWgi69UP5sc5fIcquSCNeXqe2X9ZAHfM7Khe2pcOB+AT41+aO5iRD3QAHBEHd9ctuiBBoANEkbaAw0AR9r9zcUbADYYGGkPNAAcafc3F28A2GBgpD3QAHCk3d9cvAFgg4GR9kADwJF2f3PxBoANBkbaAw0AR9r9zcUbADYYGGkPNAAcafc3F28A2GBgpD3QAHCk3d9cfOxqYJ2au9RdPtdp/khoEOlglDYT39V1PzQFXLsMXAlgt9PCxJKPbufyf8/KHIPfBPAZABf79Xc5XQ0ZQ1Q7360NbxoHrlsDvs5ZRsgo0une06by6X1mZvtP99PNAp4F4LsBXA5gjw8EGTeqaGF4QhzQF80CX7cAvGIdeDYAfhdZ2sTKUcVrpE7nd31N5gj8e2dIo2osk7NZpMdK0Z19tv+bJ4F9K8D1ACj8yfNSikHeg+5Z969m57Y/8/ZP+dPLKZhP/rcA+AYAF7g1oRUhEMUzFMt6eSJfX78b2DkPfM0i8GIAX+uWlAMppreUUErn8p2gzTl+2flg/sDbTkvIOik+CP20//mzwAXzwDcCuNTPJeFXpEpM6QEjIHm/zTF8D7T5gATYNQCe69aAloRTGulfBESBSYNyxR5g/Bhw7hKwZwl4vk9LnM5JmsBzUyDGAX3B8G23Mz/g9BuUa/0IiutfMkj7zwKmngAuXSvOpUvAWYBtF4BTnspIj/O8zPaf7qdvWITw6eZA0JLQEhKEGgxZhUj/dz3NzSKwbR44exnYvVKcy+mM5Km0JhxInUtrGkmzCPicg3W5LMGkQiZZTm9xS9Z3+4m2o8C5c4X15pTKW2Lb+fCx7WLtjYxzqiql29Icw/dA5SqYf6RTTilg+lYCIXmICKQ4IK9wxfSJY8AZK8CuFWDnanEua9ZTAMsaCog3Dt92O/MvnRGBtGwkqKRmMEkqCaa+2k+0LQDTh4rP88UHj74kF1WaATo9QHQ7mmP4HugYhtEKj4PB6ZQ+FS0hQahpldPya1kXTOqNY8DscgG+HavAttUCvBxInitrkgL4lcO33c7spBdM3kAuSnq2nx9gQfAh4JyVwvrxwel2z3p4aMlzH6DM2z/lT+8aB+Q/OT4EEqckWQSBkGD6EQKQnDCLwBSnYgcf32fXioGUFawC4esyu7CXXnDP9tOCsyD4KLB1rmgvX7zfbu2WG/Jtme0/3U/vKxBNAMoi0KcjkATCN3HOEr3UAjDrwOP71rXixYEkeKMFlSX8ocwR6KUXTJ7AaNE2tF8WfA4Ye7Kw1mwvX/yZn+eKnvcrfzC6IK/ObP/pfnpfAGQnySoISBqUXyAASS1AK0JfagWYcRDOrAF66TxZQU7jBOEbM0egH71gcgXSFZAV54NQtj9YcNIpbONCyh8Ygi8CVospApDuB63g92W2/3Q/vW8AsqM4gLIKBBIH8bcJwMCNMX68BTqBb8s6sGWtsIA6jwDk662ZI9CvXjA5A6NVa2t/IAicnC/aGV+8T74IQPm/AmGuBc+8/VP+9IEAyLslAKMV/LgAyIUInfnjwPQqMOOgI/DstQ5Mr7UAqMF8V2YXDqoXXNl+EQQ6N9v29aKdesUpWJZbAPyPme0/3U8fGIDssDid/pUASCvCaXgJmFguAEfgEXT27gDkuwaUg/nbmSMwjF7whvbLhSDL5TwwvdRqo9oqHzACkCB8U2b7T/fThwIgO01T1IMCoAZxGRhbKoAXQUcQTjkI+a4B5e5FzjGsXvCG9gdqrLGFYrpVG/UuHzBOw2/LaXxzbh43DKeoJwlAHqLndSs4udoCoIBHQE45EPk3DuitmYOQoxdctp8+rFwIWsGFYiFFoLGNchcEQC6e+OJC5J2Z7T/dTx/aApYdJ37AyJK/DIwvFxYvWr0IwEn/H1Opco5sveDUhSAAF4HJpQJkWixp6k2n4IYfMGf0amDHev2I8+l4/UbvNw8Eozw72wJePOJ8und7EkKj9ztKGA1/7WwATo44n45pWI3e7/AAGPWZ2QBkYHCU+XTMfGGQmYIxjd7vqOE0+PXzATjifDrKtTZ6v4MP/MlyRj4AR5xPF+VaqZLJF1UzKdPV6P2eLDDr3I58AI44n07ZMARbo/d78gMubWE+AEecT8e9YOn2Uheu0fs9tUCYD8AR59MpG6bR+z21gKfW1gNAz4geRT5dTEZo9H5PPRDmAzBmRM8BJzqfLiYjSKKr0fs9dYBYDwBHmE9XtRfMsIz04aQZ1+j9npygrA+Akqs8wfl0BCCTWRq935MTYL1aVQ8Ao1zlAnAi8+kEQGZTNXq/vYb75Pt/fQAcUT5dBGCj93vyAaxXi+oDoFLyT3A+3Rcavd9eY3xS/z8fgCQX/LPR3SOzkon55jg1eyAfgD8M4NcAPD6aDmBtB1e4NMDNcer1QD4AbwbwxwDe4UvRE9wHZG1gNSXDLlwLNcep1QP5APxzzwj9IIAPnXhT5ORc5EYCA9HNcWr1QD4AmRH6FQBMTSZZH98ZmD5Bh5g1FopiNns1x6nTA/kAvAfAEwDudnI+EvQxPfkEzYfaCXRSBluQMB7YHKdGD+QDsBNBH/9+AkAobqTADGK7Inw1x8nfA/kA7EXQt8kgrGAGMfBxZ5Cv5ji5eyAfgL0I+r68uR0QmUFoBQU8vfNvzXHy9kA9AORoMw7CdGQCjoUZDwL4kv/+8OZ1gJhBIjGDgMh3vTavBc035/RAPgD7JegjODfhiMwgoqeJwNPPTaB6Ezq/hq+sB4AcXeXEP+ZhGVo9vRimIQD5v5oPAZCupgDI9wg8/qz/1Xz55usyeyAfgMMQ9GU2Op4eAchpOIJQQEz/VuPlm6/K7IH6AMjgGzdl6QtyX5jWjpQFevF3lq3xf6yhrOlIAUgQCojR8gmE+l9Nl2++JrMH6gEgR5UA5KYsc+AZmCbQCDi+IvgEQMob1XBEAHIajgBMLV+0kCdws6aGu3zqfkV9AGTwjftg3JRVVRAtHQEXX/wbAcoXP5d5CID8GoJKvqDAloKOoIz/y7x8c3pmD4zhaqwjRzCYyQg5gr2ZgsFTLweWr8XQgsXjbwLWrnNtMlKgNoLBmZAa7PTCAuYIBlMvlWQswwr2UlUw45jdDSx8HbD+Ctd+HVCwePKbgJV9aASDM8Yg59TWFDysYPBtmYK91IbNOHaPA/M7gUXKXA4hWDz79cA8+W0aweCMURj+1HYfcBjBYO54MMY3tGDv8I3nmWSHOzYOLJ0LLPGXAQWLz3oB8MQUsEa16kYwOG8whjh74yJkUMFgbsNlCfYO0epwissVY34bsHw2sEIRkAEEi/dcU0SP5qhF1ggG5w3GEGdXr4L5134Fg4kAjuDQgr1DtDqcUmZETwArZwAru4BVqsv0KVh8/o3F4v0QXZBGMDhvMIY4u3MYhv95Zh+Cu1xBcxuOU/HfeDIq5cv7FuwdotXhlCBXjOXZAnyrO4BV6in0IVh8wStLuWCsUAyvEQzOG5ABz+4eB+R/ewnu/kOP/3G/l4kJTERlljQtIot2e53/IwO2OPl4FLtcnCqAp9cahT56CBZf+LpSLhhz1N5qBIPzBmTAs/sLRHcTDKbiNHdBGGymOC/3hglEvgjAnoK9A7Y4+XgiV4zVWYDAs/etxaubYPFFP1QkLtCIP8neaASD8wZkwLP7AyC/tJNg8L/xLNBu+YBdBXsHbHEFAINcMVamgdWZAoRrfPdXm8KitLdmgYveWAq+2y7iMqfuRjA4b1AGOLt/APJLqwSD3+y5T1yI0AoSbAxMMzGV1o8/My2ro2DvAK2t+GgiV4zj4+3AIwDXtwBrVJeuECze+9aW4Dut4PxkIhYsdetGMDhvoDqcPRgA+SWp4O4veQ5Uv/mAGwR78+6rQq4Yq9PAOi2fA4/vBkKudKVU7VZw77uKvWFuZbtcMNb5v0YwOG9g+jx7cADyi6Pg7gccgIxlcA5TKhaD01yYKBmVFpBZMfx/m2Bvny3t8LGqoqTliZbVI+gMgHwnMAnCIFi897cLAAZ6QyzFzzSCwXkD1OPs4QDIL5XgLmk5JHk/SD5gKdibd38VcsVYGmuBTaAzEHLHgyCcaokB7/1IkUET5IKxwF5pBIPzBqbPs4cHIC/AaeqvPL9pmHxAE+zts6VdLCD/lcgVY3UyWD0Bj1ZwqgCggXA7sPfWAoAJvaEtZBrB4Lyx6efsPADyCtmCvf00s/NnOsgVY3m8BTRZPZuGBUACdArY+5lWDqGmYbIrLHEx0ggG5w1OH2fnA7CPizQfaXqgUw80AGywMdIeaAA40u5vLt4AsMHASHugAeBIu7+5eAPABgMj7YEGgCPt/ubiDQAbDIy0BxoAjrT7m4s3AGwwMNIeaAA40u5vLt4AsMHASHugAeBIu7+5eAPABgMj7YEGgCPt/ubiDQAbDIy0B8ZYNMbkX+ZekpuIiOQrPar+xs889HJg6jZg5jAwvVZ8B+ll9PlO5/Fc/o+ECjnHfi8zYfkvM5ulmp4qJXVqx5deD4zfAkw/CGxdAZgoHfuh131QkaI5hu8Bs4Ds8B0AWLnIRGCBsFfn87JffDMwdjOw5R5g8giwZa34jnQQUwDo99wBfJ4TM7COiNdlaj2rA/jeV/vfDeATAP4UGH8I2Lrc6gc+SHqY4oMZ74VSKM0xfA+UUzB/oBUUCKMl6zSQ/PsXqZD5KQC/A0w/DEwcAcYXgYnVwppwADuBkefnCim90FmBWXwnK87Uen53BI8sbuwqaz9p5UgnQhBS+ZN1zE8Ak0utviCwq8DI8/nx5hi+Bzb4gJzKZE1SEFZZgS9/2pWR/gTAJ4HJQ8DEMWB8ARhfBsaWCwDquwQKvvNgHXvOcYVbPFJPkw+dDxC/W1Y4tWDpw/Rlgo4lo1T4/KxTihDNpJwj3/UiMLXemprjffC7eWpzDN8DlYsQDiKtVxzEqoHkyX9HRizW+nIgaQnvAiaeBCbmC0s4tgSMu2rMePAR9X252jXklaTFU108K0MHav/nvJ6ZxVVk9OI7GR2IZoGQNc/HgbHgIwqILIVujuF7oOMqWFawCoRxkfEIB5CWgkREBCNf9wMTc8A4QciBWyoGz16rwNgaML5eWKpctYZL3N+TWLX0gvtuP0HHk2n16JDyxXmVhfU0qywbJbr5GSuXKxA/sV5Y9UYWdnjwyS3qKKgarWA69Wg6fjQOIK0HadnIjPVFB+AiME4AuiUkCFnESyCSkmAuU7Cjm15wX+2X2ifBRn9A8mKcW2UFjULVQcgVDl80u40SYh763FfvquhLCxitoBYUsoJfjXKttByMq9CKcHn4sPuCbgXNJwyWkECcz5Q376UX3LNncZyQAAADEklEQVT9fFgIJs6lBBwtn3Tt6FpIz4RWnuQxPh2XIGzm4CwQ9hWIFgBTK0gQHiIAJddKq0ELQh+KL1qUR4MvSEsoENIKrgALHNiMox+94K7tl9qnnMio8MSf6SNwGpYVjCDk/Ju7isq496fCqX0BkDeqlWwKwic1gAQSpzGREnFgREz01eALLvvq2Kfi45m6cf3qBXdsfxRbJMho8dimqOhEK8cXQRr9QVpvPoDNMXQP9A3ACELFxPh+jACkP0fLIKFCCRRqKuPUdqjlC9o07JZwKVNHeBC94DQcZO0XAAkmgotAk9QYrR9f/BvByYfMSATDVMzwTXMM3QMDAVAgVHCZ7/MaQK4QZUHiNCbBQlqUw74YCb7gcmYkelC9YFlwvVv7RRAorTuBkECU9asCID9/x9B935zYzyKkqpfiNHxcA0gLQgvBAaPVkCqm3h2AtC5m/RyEqzw/4xhGL3hD++MmslgqCbgUfLKAcRrmTlBzDN0DA1tAXUlWcDm1IOIIJAjlT/Fd05lbFQFwjdtgGcewesFt7Rc/Gx8iWjUCjGCT1YvWT1MwgUqrf3NG45tTbcu0aximWx9xENcEQHGbcYAEwtSXSqY0gnCdgeuMI0cvuGx/FUGgFhwEYrR80QckWN+X0fjm1DwAWv8RgJFilJZBznz0pQg+AZAAlVWh1GvGka0XzB0cCQi30aSGVa9AF62fLOB7MhrfnJoPwPER59Px+o3e76mL5Kwp2G57xPl0kxc3er+nLvyKtLmhfUC78RHn081ONnq/pzcAR5xPR9mRRu/31IVgvgUccT4dNaobvd/TGYAjzqejumqj93s6A3DE+XRUg2VSCjdaGr3fUw+I+VPwiPPpqJjO8J1Nw43e7ymHwHoAKMFd7QErAeEE5NNJMb3R+z3lsGcNzgfgiPPpomJ6o/d76oGwPgCOKJ8uKqY3er+nKwBHmE+noqRG7/fUA199U/AI8+kEwEbv93QHoEhZTnA+nYqSGr3fBoAtaiqBUImdm5hPJwA2er+nKwBHnE+X1gUzSbnR+z11wPj/AeCpPDD3t7rvAAAAAElFTkSuQmCC", d$ = "uniform sampler2D weightMap;varying vec2 vOffset0;varying vec2 vOffset1;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec4 a;a.x=texture2D(weightMap,vOffset0).a;a.y=texture2D(weightMap,vOffset1).g;a.wz=texture2D(weightMap,uv).rb;vec4 color=inputColor;if(dot(a,vec4(1.0))>=1e-5){bool h=max(a.x,a.z)>max(a.y,a.w);vec4 blendingOffset=vec4(0.0,a.y,0.0,a.w);vec2 blendingWeight=a.yw;movec(bvec4(h),blendingOffset,vec4(a.x,0.0,a.z,0.0));movec(bvec2(h),blendingWeight,a.xz);blendingWeight/=dot(blendingWeight,vec2(1.0));vec4 blendingCoord=blendingOffset*vec4(texelSize,-texelSize)+uv.xyxy;color=blendingWeight.x*texture2D(inputBuffer,blendingCoord.xy);color+=blendingWeight.y*texture2D(inputBuffer,blendingCoord.zw);}outputColor=color;}", f$ = "varying vec2 vOffset0;varying vec2 vOffset1;void mainSupport(const in vec2 uv){vOffset0=uv+texelSize*vec2(1.0,0.0);vOffset1=uv+texelSize*vec2(0.0,1.0);}", rl = {
    LOW: 0,
    MEDIUM: 1,
    HIGH: 2,
    ULTRA: 3
}, bb = class extends la {
    constructor({ preset: n1 = rl.MEDIUM, edgeDetectionMode: t = Lf.COLOR, predicationMode: e = xJ.DISABLED } = {}){
        super("SMAAEffect", d$, {
            vertexShader: f$,
            blendFunction: Ot.NORMAL,
            attributes: aa.CONVOLUTION | aa.DEPTH,
            uniforms: new Map([
                [
                    "weightMap",
                    new ce(null)
                ]
            ])
        });
        let r, i;
        arguments.length > 1 && (r = arguments[0], i = arguments[1], arguments.length > 2 && (n1 = arguments[2]), arguments.length > 3 && (t = arguments[3])), this.renderTargetEdges = new at(1, 1, {
            minFilter: it,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTargetEdges.texture.name = "SMAA.Edges", this.renderTargetWeights = this.renderTargetEdges.clone(), this.renderTargetWeights.texture.name = "SMAA.Weights", this.uniforms.get("weightMap").value = this.renderTargetWeights.texture, this.clearPass = new rM(!0, !1, !1), this.clearPass.overrideClearColor = new Ge(0), this.clearPass.overrideClearAlpha = 1, this.edgeDetectionPass = new mn(new bJ), this.edgeDetectionMaterial.edgeDetectionMode = t, this.edgeDetectionMaterial.predicationMode = e, this.weightsPass = new mn(new _J);
        let s1 = new Xp;
        s1.onLoad = ()=>{
            let o = new Zt(r);
            o.name = "SMAA.Search", o.magFilter = vt, o.minFilter = vt, o.generateMipmaps = !1, o.needsUpdate = !0, o.flipY = !0, this.weightsMaterial.searchTexture = o;
            let a = new Zt(i);
            a.name = "SMAA.Area", a.magFilter = it, a.minFilter = it, a.generateMipmaps = !1, a.needsUpdate = !0, a.flipY = !1, this.weightsMaterial.areaTexture = a, this.dispatchEvent({
                type: "load"
            });
        }, s1.itemStart("search"), s1.itemStart("area"), r !== void 0 && i !== void 0 ? (s1.itemEnd("search"), s1.itemEnd("area")) : typeof Image < "u" && (r = new Image, i = new Image, r.addEventListener("load", ()=>s1.itemEnd("search")), i.addEventListener("load", ()=>s1.itemEnd("area")), r.src = DN, i.src = ON), this.applyPreset(n1);
    }
    get edgesTexture() {
        return this.renderTargetEdges.texture;
    }
    getEdgesTexture() {
        return this.edgesTexture;
    }
    get weightsTexture() {
        return this.renderTargetWeights.texture;
    }
    getWeightsTexture() {
        return this.weightsTexture;
    }
    get edgeDetectionMaterial() {
        return this.edgeDetectionPass.fullscreenMaterial;
    }
    get colorEdgesMaterial() {
        return this.edgeDetectionMaterial;
    }
    getEdgeDetectionMaterial() {
        return this.edgeDetectionMaterial;
    }
    get weightsMaterial() {
        return this.weightsPass.fullscreenMaterial;
    }
    getWeightsMaterial() {
        return this.weightsMaterial;
    }
    setEdgeDetectionThreshold(n1) {
        this.edgeDetectionMaterial.edgeDetectionThreshold = n1;
    }
    setOrthogonalSearchSteps(n1) {
        this.weightsMaterial.orthogonalSearchSteps = n1;
    }
    applyPreset(n1) {
        let t = this.edgeDetectionMaterial, e = this.weightsMaterial;
        switch(n1){
            case rl.LOW:
                t.edgeDetectionThreshold = .15, e.orthogonalSearchSteps = 4, e.diagonalDetection = !1, e.cornerDetection = !1;
                break;
            case rl.MEDIUM:
                t.edgeDetectionThreshold = .1, e.orthogonalSearchSteps = 8, e.diagonalDetection = !1, e.cornerDetection = !1;
                break;
            case rl.HIGH:
                t.edgeDetectionThreshold = .1, e.orthogonalSearchSteps = 16, e.diagonalSearchSteps = 8, e.cornerRounding = 25, e.diagonalDetection = !0, e.cornerDetection = !0;
                break;
            case rl.ULTRA:
                t.edgeDetectionThreshold = .05, e.orthogonalSearchSteps = 32, e.diagonalSearchSteps = 16, e.cornerRounding = 25, e.diagonalDetection = !0, e.cornerDetection = !0;
                break;
        }
    }
    setDepthTexture(n1, t = zi) {
        this.edgeDetectionMaterial.depthBuffer = n1, this.edgeDetectionMaterial.depthPacking = t;
    }
    update(n1, t, e) {
        this.clearPass.render(n1, this.renderTargetEdges), this.edgeDetectionPass.render(n1, t, this.renderTargetEdges), this.weightsPass.render(n1, this.renderTargetEdges, this.renderTargetWeights);
    }
    setSize(n1, t) {
        this.edgeDetectionMaterial.setSize(n1, t), this.weightsMaterial.setSize(n1, t), this.renderTargetEdges.setSize(n1, t), this.renderTargetWeights.setSize(n1, t);
    }
    dispose() {
        let { searchTexture: n1, areaTexture: t } = this.weightsMaterial;
        n1 !== null && t !== null && (n1.dispose(), t.dispose()), super.dispose();
    }
    static get searchImageDataURL() {
        return DN;
    }
    static get areaImageDataURL() {
        return ON;
    }
};
var p$ = `uniform float offset;uniform float darkness;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){const vec2 center=vec2(0.5);vec3 color=inputColor.rgb;
#if VIGNETTE_TECHNIQUE == 0
float d=distance(uv,center);color*=smoothstep(0.8,offset*0.799,d*(darkness+offset));
#else
vec2 coord=(uv-center)*vec2(offset);color=mix(color,vec3(1.0-darkness),dot(coord,coord));
#endif
outputColor=vec4(color,inputColor.a);}`, vb = {
    DEFAULT: 0,
    ESKIL: 1
}, qN = class extends la {
    constructor({ blendFunction: n1 = Ot.NORMAL, technique: t = vb.DEFAULT, eskil: e = !1, offset: r = .5, darkness: i = .5 } = {}){
        super("VignetteEffect", p$, {
            blendFunction: n1,
            defines: new Map([
                [
                    "VIGNETTE_TECHNIQUE",
                    t.toFixed(0)
                ]
            ]),
            uniforms: new Map([
                [
                    "offset",
                    new ce(r)
                ],
                [
                    "darkness",
                    new ce(i)
                ]
            ])
        });
    }
    get technique() {
        return Number(this.defines.get("VIGNETTE_TECHNIQUE"));
    }
    set technique(n1) {
        this.technique !== n1 && (this.defines.set("VIGNETTE_TECHNIQUE", n1.toFixed(0)), this.setChanged());
    }
    get eskil() {
        return this.technique === vb.ESKIL;
    }
    set eskil(n1) {
        this.technique = n1 ? vb.ESKIL : vb.DEFAULT;
    }
    getTechnique() {
        return this.technique;
    }
    setTechnique(n1) {
        this.technique = n1;
    }
    get offset() {
        return this.uniforms.get("offset").value;
    }
    set offset(n1) {
        this.uniforms.get("offset").value = n1;
    }
    getOffset() {
        return this.offset;
    }
    setOffset(n1) {
        this.offset = n1;
    }
    get darkness() {
        return this.uniforms.get("darkness").value;
    }
    set darkness(n1) {
        this.uniforms.get("darkness").value = n1;
    }
    getDarkness() {
        return this.darkness;
    }
    setDarkness(n1) {
        this.darkness = n1;
    }
}, OLe = [
    new Float32Array(3),
    new Float32Array(3)
], RLe = [
    new Float32Array(3),
    new Float32Array(3),
    new Float32Array(3),
    new Float32Array(3)
], LLe = [
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            0
        ]),
        new Float32Array([
            1,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            0,
            1
        ]),
        new Float32Array([
            1,
            0,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            1,
            0
        ]),
        new Float32Array([
            0,
            1,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            0,
            1
        ]),
        new Float32Array([
            0,
            1,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ]
];
var NLe = [
    new Float32Array(2),
    new Float32Array(2)
];
var BLe = new Float32Array([
    0,
    -0.25,
    .25,
    -0.125,
    .125,
    -0.375,
    .375
]), FLe = [
    new Float32Array([
        0,
        0
    ]),
    new Float32Array([
        .25,
        -0.25
    ]),
    new Float32Array([
        -0.25,
        .25
    ]),
    new Float32Array([
        .125,
        -0.125
    ]),
    new Float32Array([
        -0.125,
        .125
    ])
], VLe = [
    new Uint8Array([
        0,
        0
    ]),
    new Uint8Array([
        3,
        0
    ]),
    new Uint8Array([
        0,
        3
    ]),
    new Uint8Array([
        3,
        3
    ]),
    new Uint8Array([
        1,
        0
    ]),
    new Uint8Array([
        4,
        0
    ]),
    new Uint8Array([
        1,
        3
    ]),
    new Uint8Array([
        4,
        3
    ]),
    new Uint8Array([
        0,
        1
    ]),
    new Uint8Array([
        3,
        1
    ]),
    new Uint8Array([
        0,
        4
    ]),
    new Uint8Array([
        3,
        4
    ]),
    new Uint8Array([
        1,
        1
    ]),
    new Uint8Array([
        4,
        1
    ]),
    new Uint8Array([
        1,
        4
    ]),
    new Uint8Array([
        4,
        4
    ])
], ULe = [
    new Uint8Array([
        0,
        0
    ]),
    new Uint8Array([
        1,
        0
    ]),
    new Uint8Array([
        0,
        2
    ]),
    new Uint8Array([
        1,
        2
    ]),
    new Uint8Array([
        2,
        0
    ]),
    new Uint8Array([
        3,
        0
    ]),
    new Uint8Array([
        2,
        2
    ]),
    new Uint8Array([
        3,
        2
    ]),
    new Uint8Array([
        0,
        1
    ]),
    new Uint8Array([
        1,
        1
    ]),
    new Uint8Array([
        0,
        3
    ]),
    new Uint8Array([
        1,
        3
    ]),
    new Uint8Array([
        2,
        1
    ]),
    new Uint8Array([
        3,
        1
    ]),
    new Uint8Array([
        2,
        3
    ]),
    new Uint8Array([
        3,
        3
    ])
];
var kLe = new Map([
    [
        pn(0, 0, 0, 0),
        new Float32Array([
            0,
            0,
            0,
            0
        ])
    ],
    [
        pn(0, 0, 0, 1),
        new Float32Array([
            0,
            0,
            0,
            1
        ])
    ],
    [
        pn(0, 0, 1, 0),
        new Float32Array([
            0,
            0,
            1,
            0
        ])
    ],
    [
        pn(0, 0, 1, 1),
        new Float32Array([
            0,
            0,
            1,
            1
        ])
    ],
    [
        pn(0, 1, 0, 0),
        new Float32Array([
            0,
            1,
            0,
            0
        ])
    ],
    [
        pn(0, 1, 0, 1),
        new Float32Array([
            0,
            1,
            0,
            1
        ])
    ],
    [
        pn(0, 1, 1, 0),
        new Float32Array([
            0,
            1,
            1,
            0
        ])
    ],
    [
        pn(0, 1, 1, 1),
        new Float32Array([
            0,
            1,
            1,
            1
        ])
    ],
    [
        pn(1, 0, 0, 0),
        new Float32Array([
            1,
            0,
            0,
            0
        ])
    ],
    [
        pn(1, 0, 0, 1),
        new Float32Array([
            1,
            0,
            0,
            1
        ])
    ],
    [
        pn(1, 0, 1, 0),
        new Float32Array([
            1,
            0,
            1,
            0
        ])
    ],
    [
        pn(1, 0, 1, 1),
        new Float32Array([
            1,
            0,
            1,
            1
        ])
    ],
    [
        pn(1, 1, 0, 0),
        new Float32Array([
            1,
            1,
            0,
            0
        ])
    ],
    [
        pn(1, 1, 0, 1),
        new Float32Array([
            1,
            1,
            0,
            1
        ])
    ],
    [
        pn(1, 1, 1, 0),
        new Float32Array([
            1,
            1,
            1,
            0
        ])
    ],
    [
        pn(1, 1, 1, 1),
        new Float32Array([
            1,
            1,
            1,
            1
        ])
    ]
]);
function $T(n1, t, e) {
    return n1 + (t - n1) * e;
}
function pn(n1, t, e, r) {
    let i = $T(n1, t, .75), s1 = $T(e, r, 0.75);
    return $T(i, s1, 0.875);
}
var hi = class {
    constructor(t, e){
        this.enabled = !1;
        this.effect = new t(e), Object.defineProperty(this, "opacity", {
            enumerable: !0,
            set (r) {
                this.effect.blendMode.opacity.value = r;
            },
            get () {
                return this.effect.blendMode.opacity.value;
            }
        }), Object.defineProperty(this, "blendFunction", {
            enumerable: !0,
            set (r) {
                this.effect.blendMode.setBlendFunction(Number(r));
            },
            get () {
                return this.effect.blendMode.blendFunction;
            }
        }), this.blendFunction = Ot.NORMAL;
    }
};
var Nf = class extends hi {
    constructor(){
        super(VN), this.blendFunction = Ot.SCREEN;
    }
    set intensity(t) {
        this.effect.intensity = t;
    }
    get intensity() {
        return this.effect.intensity;
    }
    set luminanceThreshold(t) {
        this.effect.luminanceMaterial.threshold = t;
    }
    get luminanceThreshold() {
        return this.effect.luminanceMaterial.threshold;
    }
    set luminanceSmoothing(t) {
        this.effect.luminanceMaterial.smoothing = t;
    }
    get luminanceSmoothing() {
        return this.effect.luminanceMaterial.smoothing;
    }
    set blurScale(t) {
        this.effect.blurPass.scale = t;
    }
    get blurScale() {
        return this.effect.blurPass.scale;
    }
    set kernelSize(t) {
        this.effect.blurPass.kernelSize = t;
    }
    get kernelSize() {
        return this.effect.blurPass.kernelSize;
    }
};
var Bf = class extends hi {
    constructor(){
        super(UN);
    }
    set contrast(t) {
        this.effect.uniforms.get("contrast").value = t;
    }
    get contrast() {
        return this.effect.uniforms.get("contrast").value;
    }
    set brightness(t) {
        this.effect.uniforms.get("brightness").value = t;
    }
    get brightness() {
        return this.effect.uniforms.get("brightness").value;
    }
};
var Ff = class extends hi {
    constructor(){
        super(zN), this.effect.offset = new U(.01, .01);
    }
    set offset(t) {
        this.effect.offset.set(t[0] / 1e3, t[1] / 1e3);
    }
    get offset() {
        return [
            this.effect.offset.x * 1e3,
            this.effect.offset.y * 1e3
        ];
    }
};
var Vf = class extends hi {
    constructor(){
        super(kN);
    }
};
var Uf = class extends hi {
    constructor(){
        super(jN);
        this._hue = 0;
    }
    set hue(e) {
        this._hue = e, this.effect.setHue(e);
    }
    get hue() {
        return this._hue;
    }
    set saturation(e) {
        this.effect.uniforms.get("saturation").value = e;
    }
    get saturation() {
        return this.effect.uniforms.get("saturation").value;
    }
};
var kf = class extends hi {
    constructor(){
        super(HN), this.blendFunction = Ot.OVERLAY;
    }
};
var zf = class extends hi {
    constructor(){
        super(qN);
    }
    get eskil() {
        return this.effect.eskil;
    }
    set eskil(t) {
        this.effect.eskil = t;
    }
    get darkness() {
        return this.effect.uniforms.get("darkness").value;
    }
    set darkness(t) {
        this.effect.uniforms.get("darkness").value = t;
    }
    get offset() {
        return this.effect.uniforms.get("offset").value;
    }
    set offset(t) {
        this.effect.uniforms.get("offset").value = t;
    }
};
var Gf = class extends hi {
    constructor(e){
        super(GN);
    }
    set focalLength(e) {
        this.effect.circleOfConfusionMaterial.uniforms.focalLength.value = e / 2e3;
    }
    get focalLength() {
        return this.effect.circleOfConfusionMaterial.uniforms.focalLength.value;
    }
    set focusDistance(e) {
        this.effect.circleOfConfusionMaterial.uniforms.focusDistance.value = this.isPerspectiveCamera ? e / 2e3 : (e + 992) / 2e3;
    }
    get focusDistance() {
        return this.effect.circleOfConfusionMaterial.uniforms.focusDistance.value;
    }
    get bokehScale() {
        return this.effect.bokehScale;
    }
    set bokehScale(e) {
        this.effect.bokehScale = e;
    }
    setCamera(e) {
        let r = !1;
        (e.isPerspectiveCamera && this.isPerspectiveCamera === !1 || !e.isPerspectiveCamera && this.isPerspectiveCamera === !0) && (r = !0), e.isPerspectiveCamera ? (this.effect.circleOfConfusionMaterial.adoptCameraSettings(e.perspCamera), this.isPerspectiveCamera = !0) : (this.effect.circleOfConfusionMaterial.adoptCameraSettings(e), this.isPerspectiveCamera = !1), r && this.effect.setChanged();
    }
};
var jf = class extends hi {
    constructor(){
        super(WN);
    }
    get granularity() {
        return this.effect.getGranularity();
    }
    set granularity(t) {
        this.effect.setGranularity(t);
    }
};
var XN = `#define GLSLIFY 1
varying vec2 vUv;varying vec2 vTexCoords[9];uniform vec2 resolution;void main(){vUv=position.xy*0.5+0.5;vec2 texelSize=vec2(1.0)/resolution;vTexCoords[0]=vUv+vec2(-texelSize.x,-texelSize.y);vTexCoords[1]=vUv+vec2(0.0,-texelSize.y);vTexCoords[2]=vUv+vec2(texelSize.x,-texelSize.y);vTexCoords[3]=vUv+vec2(-texelSize.x,0.0);vTexCoords[4]=vUv+vec2(0.0,0.0);vTexCoords[5]=vUv+vec2(texelSize.x,0.0);vTexCoords[6]=vUv+vec2(-texelSize.x,texelSize.y);vTexCoords[7]=vUv+vec2(0.0,texelSize.y);vTexCoords[8]=vUv+vec2(texelSize.x,texelSize.y);gl_Position=vec4(position.xy,1.0,1.0);}`;
var YN = `#define GLSLIFY 1
#include <common>
varying vec2 vUv;varying vec2 vTexCoords[9];uniform sampler2D inputBuffer;uniform sampler2D historyBuffer;uniform sampler2D velocityBuffer;uniform sampler2D depthBuffer;uniform vec2 resolution;
#define USE_YCOCG
#define USE_CATMULL_ROM
const float feedback_min=0.5;const float feedback_max=0.95;vec3 RGB_YCoCg(vec3 c){return vec3(c.x/4.0+c.y/2.0+c.z/4.0,c.x/2.0-c.z/2.0,-c.x/4.0+c.y/2.0-c.z/4.0);}vec3 YCoCg_RGB(vec3 c){return clamp(vec3(c.x+c.y-c.z,c.x+c.z,c.x-c.y-c.z),vec3(0.0),vec3(1.0));}vec4 sample_color(sampler2D tex,vec2 uv){
#ifdef USE_YCOCG
vec4 c=texture(tex,uv);return vec4(RGB_YCoCg(c.rgb),c.a);
#else
return texture(tex,uv);
#endif
}vec4 sample_catmull_rom(sampler2D tex,vec2 uv,vec2 texSize){vec2 samplePos=uv*texSize;vec2 texPos1=floor(samplePos-0.5)+0.5;vec2 f=samplePos-texPos1;vec2 w0=f*(-0.5+f*(1.0-0.5*f));vec2 w1=1.0+f*f*(-2.5+1.5*f);vec2 w2=f*(0.5+f*(2.0-1.5*f));vec2 w3=f*f*(-0.5+0.5*f);vec2 w12=w1+w2;vec2 offset12=w2/(w1+w2);vec2 texPos0=texPos1-1.0;vec2 texPos3=texPos1+2.0;vec2 texPos12=texPos1+offset12;texPos0/=texSize;texPos3/=texSize;texPos12/=texSize;vec4 result=vec4(0.0);result+=texture2D(tex,vec2(texPos12.x,texPos0.y))*w12.x*w0.y;result+=texture2D(tex,vec2(texPos0.x,texPos12.y))*w0.x*w12.y;result+=texture2D(tex,vec2(texPos12.x,texPos12.y))*w12.x*w12.y;result+=texture2D(tex,vec2(texPos3.x,texPos12.y))*w3.x*w12.y;result+=texture2D(tex,vec2(texPos12.x,texPos3.y))*w12.x*w3.y;return result;}vec3 choose_motion_vector(){
#ifdef CHOOSE_LONGEST_MOTION_VECTOR
float longest=-1.0;vec3 v_choose=vec3(-1.0);for(int i=0;i<9;i++){vec3 v=texture2D(velocityBuffer,vTexCoords[i]).rgb;float l=length(v.xy);if(l>longest){longest=l;v_choose=v;}}return v_choose;
#else
float closest_depth=1000.0;vec2 closest_uv_offset=vec2(0.0);for(int i=0;i<9;i++){float neighbor_depth=texture2D(depthBuffer,vTexCoords[i]).r;if(neighbor_depth<closest_depth){closest_uv_offset=vTexCoords[i];closest_depth=neighbor_depth;}}return texture2D(velocityBuffer,closest_uv_offset).rgb;
#endif
}vec4 clipAabb(vec3 aabb_min,vec3 aabb_max,vec4 avg,vec4 input_texel){const float FLT_EPS=0.00000001;vec3 p_clip=0.5*(aabb_max+aabb_min);vec3 e_clip=0.5*(aabb_max-aabb_min)+FLT_EPS;vec4 v_clip=input_texel-vec4(p_clip,avg.w);vec3 v_unit=v_clip.xyz/e_clip;vec3 a_unit=abs(v_unit);float ma_unit=max(a_unit.x,max(a_unit.y,a_unit.z));if(ma_unit>1.0){return vec4(p_clip,avg.w)+v_clip/ma_unit;}else{return input_texel;}}vec3 clip_aabb_variance(in vec3 cOld,in vec3 cNew,in vec3 centre,in vec3 halfSize){if(all(lessThanEqual(abs(cOld-centre),halfSize))){return cOld;}vec3 dir=(cNew-cOld);vec3 near=centre-sign(dir)*halfSize;vec3 tAll=(near-cOld)/dir;float t=0.0001;for(int i=0;i<3;i++){if(tAll[i]>=0.0&&tAll[i]<t){t=tAll[i];}}if(t>=0.0001){return cOld;}return cOld+dir*t;}void main(){vec3 v=choose_motion_vector();vec2 velocity=v.rg;vec2 previousPixelPos=vUv-velocity;vec4 currentColor=sample_color(inputBuffer,vUv);
#ifdef USE_CATMULL_ROM
vec4 previousColor=sample_catmull_rom(historyBuffer,previousPixelPos,resolution);
#else
vec4 previousColor=sample_color(historyBuffer,previousPixelPos);
#endif
#ifdef USE_YCOCG
previousColor=vec4(RGB_YCoCg(previousColor.rgb),previousColor.a);
#endif
vec4 ctl=sample_color(inputBuffer,vTexCoords[0]);vec4 ctc=sample_color(inputBuffer,vTexCoords[1]);vec4 ctr=sample_color(inputBuffer,vTexCoords[2]);vec4 cml=sample_color(inputBuffer,vTexCoords[3]);vec4 cmc=sample_color(inputBuffer,vTexCoords[4]);vec4 cmr=sample_color(inputBuffer,vTexCoords[5]);vec4 cbl=sample_color(inputBuffer,vTexCoords[6]);vec4 cbc=sample_color(inputBuffer,vTexCoords[7]);vec4 cbr=sample_color(inputBuffer,vTexCoords[8]);vec4 cmin=min(ctl,min(ctc,min(ctr,min(cml,min(cmc,min(cmr,min(cbl,min(cbc,cbr))))))));vec4 cmax=max(ctl,max(ctc,max(ctr,max(cml,max(cmc,max(cmr,max(cbl,max(cbc,cbr))))))));vec4 cavg=(ctl+ctc+ctr+cml+cmc+cmr+cbl+cbc+cbr)/9.0;vec4 cmin5=min(ctc,min(cml,min(cmc,min(cmr,cbc))));vec4 cmax5=max(ctc,max(cml,max(cmc,max(cmr,cbc))));vec4 cavg5=(ctc+cml+cmc+cmr+cbc)/5.0;cmin=0.5*(cmin+cmin5);cmax=0.5*(cmax+cmax5);cavg=0.5*(cavg+cavg5);
#ifdef USE_YCOCG
vec2 chroma_extent=vec2(0.25*0.5*(cmax.r-cmin.r));vec2 chroma_center=currentColor.gb;cmin.yz=chroma_center-chroma_extent;cmax.yz=chroma_center+chroma_extent;cavg.yz=chroma_center;
#endif
vec4 previousColorClipped=clamp(previousColor,cmin,cmax);
#ifdef LUMINANCE_DIFFERENCES
#ifdef USE_YCOCG
float lum0=currentColor.r;float lum1=previousColorClipped.r;
#else
float lum0=luminance(currentColor.rgb);float lum1=luminance(previousColorClipped.rgb);
#endif
float unbiased_diff=abs(lum0-lum1)/max(lum0,max(lum1,0.2));float unbiased_weight=1.0-unbiased_diff;float unbiased_weight_sqr=unbiased_weight*unbiased_weight;float k_feedback=mix(feedback_min,feedback_max,unbiased_weight_sqr);vec4 result=mix(currentColor,previousColorClipped,vec4(k_feedback));
#else
const float alpha=0.1;vec4 result=mix(currentColor,previousColorClipped,1.0-alpha);
#endif
#ifdef USE_YCOCG
gl_FragColor=vec4(YCoCg_RGB(result.rgb).rgb,result.a);
#else
gl_FragColor=result;
#endif
}`;
var KN = `#define GLSLIFY 1
varying vec2 vUv;void main(){gl_Position=vec4(position.xy,1.0,1.0);vUv=position.xy*0.5+0.5;}`;
var QN = `#define GLSLIFY 1
layout(location=1)out vec4 gVelocity;varying vec2 vUv;uniform sampler2D inputBuffer;void main(){gl_FragColor=texture2D(inputBuffer,vUv);gVelocity=vec4(0.0);}`;
var Hf = class extends $e {
    constructor(){
        super({
            name: "PassthroughMaterial",
            uniforms: {
                inputBuffer: new ce(null)
            },
            blending: or,
            depthWrite: !1,
            depthTest: !1,
            vertexShader: KN,
            fragmentShader: QN
        });
    }
    set inputBuffer(t) {
        this.uniforms.inputBuffer.value = t;
    }
}, Sb = class extends Ei {
    constructor(){
        super("TAAResolvePass");
        this.MRTCompatible = !0;
        this.needsSwap = !1, this.passThroughMaterial = new Hf, this.resolutionVector = new U, this.resolveMaterial = new $e({
            name: "TAAResolveMaterial",
            uniforms: {
                inputBuffer: new ce(null),
                historyBuffer: new ce(null),
                velocityBuffer: new ce(null),
                depthBuffer: new ce(null),
                resolution: new ce(new U)
            },
            blending: or,
            depthWrite: !1,
            depthTest: !1,
            vertexShader: XN,
            fragmentShader: YN
        }), this.historyRenderTarget = new at(1024, 1024, {
            minFilter: it,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.historyRenderTarget.texture.name = "TAA.History", this.resultRenderTarget = new at(1024, 1024, {
            minFilter: it,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.resultRenderTarget.texture.name = "TAA.Output";
    }
    setSize(e, r) {
        this.historyRenderTarget.setSize(e, r), this.resultRenderTarget.setSize(e, r);
    }
    render(e, r) {
        this.fullscreenMaterial = this.resolveMaterial, this.resolveMaterial.uniforms.inputBuffer.value = r.texture[0], this.resolveMaterial.uniforms.velocityBuffer.value = r.texture[1], this.resolveMaterial.uniforms.depthBuffer.value = r.depthTexture, this.resolveMaterial.uniforms.historyBuffer.value = this.historyRenderTarget.texture, this.resolveMaterial.uniforms.resolution.value.set(r.width, r.height), e.setRenderTarget(this.resultRenderTarget), e.render(this.scene, this.camera), this.fullscreenMaterial = this.passThroughMaterial, this.passThroughMaterial.inputBuffer = this.resultRenderTarget.texture, e.setRenderTarget(this.historyRenderTarget), e.render(this.scene, this.camera);
        let i = this.renderToScreen ? null : r;
        this.fullscreenMaterial = this.passThroughMaterial, this.passThroughMaterial.inputBuffer = this.resultRenderTarget.texture, e.setRenderTarget(i), e.render(this.scene, this.camera);
    }
    dispose() {
        this.resultRenderTarget.dispose(), this.historyRenderTarget.dispose(), this.resolveMaterial.dispose(), this.passThroughMaterial.dispose();
    }
};
var wb = class extends Ei {
    constructor(e, r, i){
        super("TransmissionPass", void 0, r);
        this.MRTCompatible = !0;
        this.depthPass = new iM(e, r, {
            renderTarget: i.transmissionDepthTarget
        }), this.passThroughMaterial = new Hf, this.splineScene = e, this.needsSwap = !1;
    }
    updatePasses(e) {
        this.passThroughMaterial = new Hf, this.depthPass = new iM(this.splineScene, this.camera, {
            renderTarget: e.transmissionDepthTarget
        });
    }
    setCamera(e) {
        this.camera = e;
    }
    setScene(e) {
        this.splineScene = e;
    }
    render(e, r, i) {
        let s1 = this.camera.layers.mask, o = e;
        o.setRenderTarget(o.transmissionRenderTarget), this.fullscreenMaterial = this.passThroughMaterial, this.passThroughMaterial.inputBuffer = r.texture[0], o.clear(), o.render(this.scene, this.camera), this.camera.layers.disable(3), this.depthPass.render(e, r, i), o.shadowMap.needsUpdate = !1, o.shadowMap.autoUpdate = !1;
        let a = this.renderToScreen ? null : r;
        this.camera.layers.set(3), e.setRenderTarget(a), e.render(this.splineScene, this.camera), this.camera.layers.mask = s1;
    }
};
var ZN = new Er, b$ = new $e({
    transparent: !0,
    vertexShader: `
        void main() {
            gl_Position = vec4(0.0);
        }
    `,
    fragmentShader: `
        layout(location = 1) out vec4 gVelocity;

        void main() {
            gl_FragColor = vec4(0.0);
			gVelocity = vec4(0.0);
        }
    `
}), Su = class extends Ei {
    constructor(e, r, i){
        super("OpaquePass", r ?? ZN, i);
        this.MRTCompatible = !0;
        this.originalMaterials = [];
        this.hasTransmissionPass = !1;
        this.clear = !0;
        this.clearColorOnly = !1;
        this.clearDepth = !1;
        this.needsSwap = !1, this.MRTCompatible = e;
    }
    setCamera(e) {
        this.camera = e;
    }
    setScene(e) {
        this.scene = e ?? ZN;
    }
    getScene() {
        return this.scene;
    }
    render(e, r) {
        this.camera.layers.enable(3), this.hasTransmissionPass && (this.originalMaterials.length = 0, this.scene.traverse((s1)=>{
            s1.layers.isEnabled(3) && s1 instanceof nr && (this.originalMaterials.push([
                s1,
                s1.material
            ]), s1.material = b$);
        }), e.shadowMap.needsUpdate = !0, e.shadowMap.autoUpdate = !0), this.camera.layers.enable(8);
        let i = this.renderToScreen ? null : r;
        e.setRenderTarget(i), this.clearColorOnly && e.clear(!0, !1, !0), this.clear && e.clear(), e.render(this.scene, this.camera), this.clearDepth && e.clear(!1, !0, !1), this.hasTransmissionPass && this.originalMaterials.forEach((s1)=>{
            s1[0].material = s1[1];
        });
    }
};
var Ab = class {
    constructor(t, { depthBuffer: e = !0, stencilBuffer: r = !1, multisampling: i = 0, frameBufferType: s1 = 0 } = {}){
        this.renderer = t;
        this.helperStartIndex = 0;
        this.copyPass = new pg;
        this.depthTexture = null;
        this.timer = new FN;
        this._width = 1;
        this._height = 1;
        this.passes = [];
        this.helperPasses = [];
        this.autoRenderToScreen = !0;
        this.inputBuffer = this.createBuffer(e, r, s1, i, !0, "input buffer mrt"), this.inputBufferSingle = this.createBuffer(e, r, s1, i, !1, " input buffer single"), this.inputBufferSingle.texture.dispose(), this.inputBufferSingle.depthTexture.dispose(), this.inputBufferSingle.texture = this.inputBuffer.texture[0], this.inputBufferSingle.depthTexture = this.inputBuffer.depthTexture, this.outputBuffer = this.inputBuffer.clone(), this.outputBuffer.name = "output buffer mrt", this.outputBufferSingle = this.createBuffer(e, r, s1, i, !1, "output buffer single"), this.outputBufferSingle.texture.dispose(), this.outputBufferSingle.depthTexture.dispose(), this.outputBufferSingle.texture = this.outputBuffer.texture[0], this.outputBufferSingle.depthTexture = this.outputBuffer.depthTexture, this.setRenderer(t);
    }
    get multisampling() {
        return this.inputBuffer.samples || 0;
    }
    set multisampling(t) {
        let e = this.inputBuffer, r = this.multisampling;
        r > 0 && t > 0 ? (this.inputBuffer.samples = t, this.outputBuffer.samples = t, this.inputBuffer.dispose(), this.outputBuffer.dispose()) : r !== t && (this.inputBuffer.dispose(), this.outputBuffer.dispose(), console.log("creating new input buffer"), this.inputBuffer = this.createBuffer(e.depthBuffer, e.stencilBuffer, e.texture.type, t, !0, "new input buffer"), this.inputBuffer.depthTexture = this.depthTexture, this.outputBuffer = this.inputBuffer.clone());
    }
    getTimer() {
        return this.timer;
    }
    getRenderer() {
        return this.renderer;
    }
    setRenderer(t) {
        if (this.renderer = t, t !== null) {
            let e = t.getSize(new U), r = t.getContext().getContextAttributes()?.alpha ?? !1, i = this.inputBuffer.texture[0].type;
            i === Nr && t.outputEncoding === ut && (this.inputBuffer.texture[0].encoding = ut, this.outputBuffer.texture[0].encoding = ut, this.inputBuffer.dispose(), this.outputBuffer.dispose(), console.log("doing some kinda dispose??")), t.autoClear = !1, this.setSize(e.width, e.height, !1);
            for (let s1 of this.passes)s1.initialize(t, r, i);
        }
    }
    replaceRenderer(t, e = !0) {
        let r = this.renderer, i = r.domElement.parentNode;
        return this.setRenderer(t), e && i !== null && (i.removeChild(r.domElement), i.appendChild(t.domElement)), r;
    }
    createDepthTexture() {
        let t = this.depthTexture = new ps(this._width, this._height);
        return this.inputBuffer.depthTexture = t, this.inputBuffer.stencilBuffer ? (t.format = xl, t.type = gl) : t.type = Gs, t;
    }
    deleteDepthTexture() {
        if (this.depthTexture !== null) {
            this.depthTexture.dispose(), this.depthTexture = null, this.inputBuffer.depthTexture = null, this.inputBuffer.dispose();
            for (let t of this.passes)t.setDepthTexture(null);
        }
    }
    createBuffer(t, e, r, i, s1, o) {
        let a = this.renderer, l = a === null ? new U : a.getDrawingBufferSize(new U), c = {
            minFilter: it,
            magFilter: it,
            wrapS: tr,
            wrapT: tr,
            stencilBuffer: e,
            depthBuffer: t
        }, u1;
        return i > 0 ? (u1 = new at(l.width, l.height, c), u1.samples = i) : (s1 ? (u1 = new eh(l.width, l.height, 2, c), u1.texture[1].type = $n) : u1 = new at(l.width, l.height, c), u1.depthTexture = new ps(2048, 2048), u1.depthTexture.type = Ut), r === Nr && a !== null && a.outputEncoding === ut && (Array.isArray(u1.texture) ? u1.texture.forEach((h)=>h.encoding = ut) : u1.texture.encoding = ut), Array.isArray(u1.texture) ? u1.texture.forEach((h, d)=>{
            h.name = `EffectComposer.Buffer ${s1} ${d}`, h.generateMipmaps = !1;
        }) : (u1.texture.name = `EffectComposer.Buffer ${s1}`, u1.texture.generateMipmaps = !1), u1.name = o, u1;
    }
    addPass(t, e) {
        let r = this.passes, i = this.renderer, s1 = i.getDrawingBufferSize(new U), o = i.getContext().getContextAttributes()?.alpha ?? !1, a;
        if (t.MRTCompatible && (a = this.inputBuffer.texture[0].type), t.MRTCompatible || (a = this.inputBuffer.texture.type), t.setRenderer(i), t.setSize(s1.width, s1.height), t.initialize(i, o, a), this.autoRenderToScreen && (r.length > 0 && (r[r.length - 1].renderToScreen = !1), t.renderToScreen && (this.autoRenderToScreen = !1)), e !== void 0 ? r.splice(e, 0, t) : r.push(t), this.autoRenderToScreen && (r[r.length - 1].renderToScreen = !0), t.needsDepthTexture || this.depthTexture !== null) {
            if (this.depthTexture === null) {
                let l = this.createDepthTexture();
                for (t of r)t.setDepthTexture(l);
            } else t.setDepthTexture(this.depthTexture);
        }
    }
    setHelperStartIndex(t) {
        this.helperStartIndex = t;
    }
    removePass(t) {
        let e = this.passes, r = e.indexOf(t);
        if (r !== -1 && e.splice(r, 1).length > 0) {
            if (this.depthTexture !== null) {
                let o = (l, c)=>l || c.needsDepthTexture;
                e.reduce(o, !1) || t.getDepthTexture() === this.depthTexture && t.setDepthTexture(null);
            }
            this.autoRenderToScreen && r === e.length && (t.renderToScreen = !1, e.length > 0 && (e[e.length - 1].renderToScreen = !0));
        }
    }
    removeAllPasses() {
        let t = this.passes;
        t.length > 0 && (this.autoRenderToScreen && (t[t.length - 1].renderToScreen = !1), this.passes = []);
    }
    render(t) {
        let e = this.renderer, r = this.copyPass, i = this.inputBuffer, s1 = this.outputBuffer, o = this.inputBufferSingle, a = this.outputBufferSingle, l = !1, c, u1, h, d;
        t === void 0 && (t = this.timer.update().getDelta());
        for (let f of this.passes)f.enabled && (f.MRTCompatible ? f.render(e, i, s1, t, l) : f.render(e, o, a, t, l), f.needsSwap && (l && (r.renderToScreen = f.renderToScreen, c = e.getContext(), u1 = e.state.buffers.stencil, u1.setFunc(c.NOTEQUAL, 1, 4294967295), r.render(e, i, s1, t, l), u1.setFunc(c.EQUAL, 1, 4294967295)), h = i, d = o, i = s1, o = a, s1 = h, a = d), f instanceof BN ? l = !0 : f instanceof NN && (l = !1));
    }
    setSize(t, e, r) {
        let i = this.renderer;
        if (this._width = t, this._height = e, t === void 0 || e === void 0) {
            let o = i.getSize(new U);
            t = o.width, e = o.height;
        }
        i.setSize(t, e, r);
        let s1 = i.getDrawingBufferSize(new U);
        this.inputBuffer.setSize(s1.width, s1.height), this.outputBuffer.setSize(s1.width, s1.height), this.inputBufferSingle.setSize(s1.width, s1.height), this.outputBufferSingle.setSize(s1.width, s1.height);
        for (let o of this.passes)o.setSize(s1.width, s1.height);
    }
    reset() {
        let t = this.timer.isAutoResetEnabled();
        this.dispose(), this.autoRenderToScreen = !0, this.timer.setAutoResetEnabled(t);
    }
    dispose() {
        for (let t of this.passes)t.dispose();
        this.passes = [], this.inputBuffer !== null && this.inputBuffer.dispose(), this.outputBuffer !== null && this.outputBuffer.dispose(), this.inputBufferSingle !== null && this.inputBufferSingle.dispose(), this.outputBufferSingle !== null && this.outputBufferSingle.dispose(), this.deleteDepthTexture(), this.copyPass.dispose(), this.timer.dispose();
    }
};
var S$ = new $e({
    name: "CombineMaterial",
    uniforms: {
        inputBufferA: new ce(null),
        inputBufferB: new ce(null)
    },
    blending: or,
    depthWrite: !1,
    depthTest: !1,
    vertexShader: `
varying vec2 vUv;
void main() {
    gl_Position = vec4(position.xy, 1.0, 1.0);
    vUv = position.xy * 0.5 + 0.5;
}
`,
    fragmentShader: `
    varying vec2 vUv;
    uniform sampler2D inputBufferA;
    uniform sampler2D inputBufferB;

    // TODO: Why do we need these when postpro of framemode is enabled???
    layout(location = 1) out vec4 gVelocity;

    void main() {
	vec4 resA = texture2D(inputBufferA, vUv);
	vec4 resB = texture2D(inputBufferB, vUv);
    float a = resA.a + resB.a * ( 1.0 - resA.a );

	vec4 res;
	res.rgb =  resA.rgb + (resB.rgb * (1.0 - resA.a));
	res.a = resA.a + resB.a * (1.0 - resA.a);
	gl_FragColor = res;
    gVelocity = vec4(0.0);
    }
`
}), Eb = class extends Ei {
    constructor(e){
        super("HelperPass", void 0, e);
        this.MRTCompatible = !1;
        this.fullscreenMaterial = S$, this.helperPass = new Su(!1, void 0, this.camera), this.helperPass.hasTransmissionPass = !1, this.helperPass.clear = !1, this.helperPass.renderToScreen = !1, this.helperPassOnTop = new Su(!1, void 0, this.camera), this.helperPassOnTop.hasTransmissionPass = !1, this.helperPassOnTop.clear = !1, this.helperPassOnTop.renderToScreen = !1;
        let r = new bb({
            preset: rl.LOW,
            edgeDetectionMode: Lf.COLOR
        });
        this.effectPass = new bu(this.camera, r), this.rt = new at(10, 10, {
            minFilter: it,
            magFilter: it,
            wrapS: tr,
            wrapT: tr,
            depthBuffer: !0
        });
    }
    setSize(e, r) {
        this.rt.setSize(e, r), this.effectPass.setSize(e, r);
    }
    set sceneHelpers(e) {
        this.helperPass.setScene(e);
    }
    get sceneHelpers() {
        return this.helperPass.getScene();
    }
    set sceneHelpersOnTop(e) {
        this.helperPassOnTop.setScene(e);
    }
    get sceneHelpersOnTop() {
        return this.helperPassOnTop.getScene();
    }
    setCamera(e) {
        this.helperPass.setCamera(e), this.helperPassOnTop.setCamera(e);
    }
    initialize(e, r, i) {
        super.initialize(e, r, i), this.effectPass.initialize(e, r, i);
    }
    dispose() {
        super.dispose(), this.rt.dispose(), this.effectPass.dispose();
    }
    render(e, r, i) {
        this.rt.depthTexture = r.depthTexture;
        let s1 = e.getClearAlpha();
        e.setClearAlpha(0), this.helperPass.clearDepth = !0, this.helperPass.clearColorOnly = !0, this.helperPass.render(e, this.rt), this.helperPassOnTop.render(e, this.rt), this.effectPass.renderToScreen = !1, this.effectPass.render(e, this.rt, i), this.fullscreenMaterial.uniforms.inputBufferA.value = i.texture, this.fullscreenMaterial.uniforms.inputBufferB.value = r.texture, e.setClearAlpha(s1), e.setRenderTarget(null), e.clear(), e.render(this.scene, this.camera);
    }
};
var JN = `#define GLSLIFY 1
#include <skinning_pars_vertex>
#include <morphtarget_pars_vertex>
out vec3 n;void main(){
#include <beginnormal_vertex>
#include <morphnormal_vertex>
#include <skinbase_vertex>
#include <skinnormal_vertex>
#include <defaultnormal_vertex>
#include <begin_vertex>
#include <morphtarget_vertex>
#include <skinning_vertex>
vec4 view_space=viewMatrix*modelMatrix*vec4(transformed,1.0);gl_Position=projectionMatrix*view_space;n=normalize(transformedNormal);}`;
var $N = `#define GLSLIFY 1
in vec3 n;void main(){gl_FragColor=vec4(n,1.0);}`;
var eB = `#define GLSLIFY 1
out vec2 v_uv;void main(){v_uv=uv;gl_Position=vec4(position.xy,1.0,1.0);}`;
var tB = `#define GLSLIFY 1
in vec2 v_uv;const float pi=3.14159265;const float num_steps=4.0;const float num_directions=4.0;uniform float near;uniform float far;uniform float fov;uniform vec4 proj_info;uniform bool is_ortho;uniform vec2 resolution;uniform float radius_of_influence;uniform float radius_in_screen_space;uniform float exponent;uniform vec3 ao_color;uniform float bias;uniform sampler2D texture_depth;uniform sampler2D texture_normals;uniform sampler2D texture_blue_noise;uniform sampler2D texture_blue_noise_in_disk;uniform sampler2D texture_color_pass;uniform int frame_index;uniform bool fog_enabled;uniform float fog_near;uniform float fog_far;vec3 uv_to_view_space(vec2 uv,float eye_z){return vec3((uv*proj_info.xy+proj_info.zw)*(is_ortho ? 1.0 : eye_z),eye_z);}float linearize_depth(float depth_sampled){float z=is_ortho ? depth_sampled : depth_sampled*2.0-1.0;return mix((2.0*near*far)/(far+near-z*(far-near)),near+z*(far-near),float(is_ortho));}vec3 get_view_position(vec2 uv_coords){float linear_depth=linearize_depth(texture(texture_depth,uv_coords).x);return uv_to_view_space(uv_coords,linear_depth);}vec3 min_difference(vec3 p,vec3 right,vec3 left){vec3 v1=right-p;vec3 v2=p-left;return(dot(v1,v1)<dot(v2,v2))? v1 : v2;}vec3 rebuild_normal(in vec2 uv,in vec3 p){vec2 one_over_resolution=1.0/resolution;vec3 r=get_view_position(uv+vec2(one_over_resolution.x,0));vec3 l=get_view_position(uv+vec2(-one_over_resolution.x,0));vec3 t=get_view_position(uv+vec2(0,one_over_resolution.y));vec3 b=get_view_position(uv+vec2(0,-one_over_resolution.y));return normalize(cross(min_difference(p,r,l),min_difference(p,t,b)));}float falloff(float distance_squared){float neg_inv_r2=-1.0/(radius_of_influence*radius_of_influence);return distance_squared*neg_inv_r2+1.0;}float ao_contribution(vec3 P,vec3 N,vec3 S){vec3 to_sample=S-P;float norm_squared=dot(to_sample,to_sample);float norm=sqrt(norm_squared);float cos_theta=dot(N,to_sample)/norm;return clamp(cos_theta-bias,0.0,1.0)*clamp(falloff(norm_squared),0.0,1.0);}float compute_ambient_occlusion(vec2 uv,float radius_in_screen_space,vec3 pc,vec3 view_space_n){vec2 one_over_resolution=1.0/resolution;ivec2 noise_uv=ivec2(int(mod(gl_FragCoord.x,128.0)),int(mod(gl_FragCoord.y,128.0)));float noise=texelFetch(texture_blue_noise,noise_uv,0).r;noise=fract(noise+0.61803398875*float(frame_index));float theta=noise*2.0*3.1415;float ct=cos(theta);float st=sin(theta);float step_size=radius_in_screen_space/(num_steps+1.0);const float angle_step=2.0*pi/num_directions;float contribution=0.0;for(int i=0;i<int(num_directions);++i){float current_pixel=step_size+1.0;for(int j=0;j<int(num_steps);++j){int index=i*int(num_steps)+j;vec2 blue_noise_sample=texelFetch(texture_blue_noise_in_disk,ivec2(index,0),0).rg;vec2 disk_point;disk_point.x=blue_noise_sample.x*ct-blue_noise_sample.y*st;disk_point.y=blue_noise_sample.x*st+blue_noise_sample.y*ct;vec2 sample_direction=disk_point;vec2 snapped_uv=round(current_pixel*sample_direction)*one_over_resolution+uv;vec3 ps=get_view_position(snapped_uv);current_pixel+=step_size;contribution+=ao_contribution(pc,view_space_n,ps);}}float mult=1.0/(1.0-bias);contribution*=mult/(num_directions*num_steps);return clamp(1.0-contribution*2.0,0.0,1.0);}
#define USE_GBUFFER_NORMALS
void main(){vec3 view_space_p=get_view_position(v_uv);
#ifdef USE_GBUFFER_NORMALS
vec3 view_space_n=texture(texture_normals,v_uv).rgb;view_space_n.z*=-1.0;
#else
vec3 view_space_n=-rebuild_normal(v_uv,view_space_p);
#endif
float radius_ss=radius_in_screen_space/(is_ortho ? 1.0 : view_space_p.z);float ao=compute_ambient_occlusion(v_uv,radius_ss,view_space_p,view_space_n);float final=pow(ao,exponent);if(view_space_p.z>=far){final=1.0;}vec3 color=mix(ao_color,vec3(1.0),final);if(fog_enabled){float fog_factor=smoothstep(fog_near,fog_far,view_space_p.z);color=mix(color,vec3(1.0),fog_factor);}gl_FragColor=vec4(color,1.0);}`;
var rB = `#define GLSLIFY 1
out vec2 v_uv;void main(){gl_Position=vec4(position.xy,1.0,1.0);v_uv=uv;}`;
var iB = `#define GLSLIFY 1
in vec2 v_uv;uniform sampler2D texture_ao_lrez;uniform sampler2D texture_depth_lrez;uniform sampler2D texture_depth_hrez;uniform float near;uniform float far;float linearize_depth(float depth_sampled){float z=depth_sampled*2.0-1.0;return(2.0*near*far)/(far+near-z*(far-near));}vec2 nearest_depth_filter(in vec2 uv){vec2 resolution=vec2(textureSize(texture_depth_lrez,0));vec2 texel_size=1.0/resolution;vec2 offset=uv-0.5*texel_size;float d_hrez=texture(texture_depth_hrez,uv).r;float a=abs(d_hrez-texture(texture_depth_lrez,offset).r);float b=abs(d_hrez-texture(texture_depth_lrez,offset+vec2(texel_size.x,0.0)).r);float c=abs(d_hrez-texture(texture_depth_lrez,offset+vec2(0.0,texel_size.y)).r);float d=abs(d_hrez-texture(texture_depth_lrez,offset+vec2(texel_size.x,texel_size.y)).r);float min_diff=min(a,min(b,min(c,d)));if(min_diff==a)return offset;if(min_diff==b)return offset+vec2(texel_size.x,0.0);if(min_diff==c)return offset+vec2(0.0,texel_size.y);if(min_diff==d)return offset+vec2(texel_size.x,texel_size.y);}void main(){
#ifdef DEBUG
float d_lrez=texture(texture_depth_lrez,v_uv).r;float d_hrez=texture(texture_depth_hrez,v_uv).r;float output_d=mix(linearize_depth(d_lrez)/far,linearize_depth(d_hrez)/far,step(0.5,v_uv.x));gl_FragColor=vec4(vec3(output_d),1.0);
#else
vec2 filtered_uv=nearest_depth_filter(v_uv);vec4 ao=texture(texture_ao_lrez,filtered_uv);gl_FragColor=vec4(ao.rgb,1.0);gl_FragColor=ao;
#endif
}`;
var Wf = [
    [
        .478712,
        .875764
    ],
    [
        -0.337956,
        -0.793959
    ],
    [
        -0.955259,
        -0.028164
    ],
    [
        .864527,
        .325689
    ],
    [
        .209342,
        -0.395657
    ],
    [
        -0.106779,
        .672585
    ],
    [
        .156213,
        .235113
    ],
    [
        -0.413644,
        -0.082856
    ],
    [
        -0.415667,
        .323909
    ],
    [
        .141896,
        -0.93998
    ],
    [
        .954932,
        -0.182516
    ],
    [
        -0.766184,
        .410799
    ],
    [
        -0.434912,
        -0.458845
    ],
    [
        .415242,
        -0.078724
    ],
    [
        .728335,
        -0.491777
    ],
    [
        -0.058086,
        -0.066401
    ],
    [
        .20299,
        .686837
    ],
    [
        -0.808362,
        -0.556402
    ],
    [
        .507386,
        -0.640839
    ],
    [
        -0.723494,
        -0.22924
    ],
    [
        .48974,
        .317826
    ],
    [
        -0.622663,
        .765301
    ],
    [
        -0.01064,
        .929347
    ],
    [
        .663146,
        .647618
    ],
    [
        -0.096674,
        -0.413835
    ],
    [
        .525945,
        -0.321063
    ],
    [
        -0.122533,
        .366019
    ],
    [
        .195235,
        -0.687983
    ],
    [
        -0.563203,
        .098748
    ],
    [
        .418563,
        .561335
    ],
    [
        -0.378595,
        .800367
    ],
    [
        .826922,
        .001024
    ],
    [
        -0.085372,
        -0.766651
    ],
    [
        -0.92192,
        .183673
    ],
    [
        -0.590008,
        -0.721799
    ],
    [
        .167751,
        -0.164393
    ],
    [
        .032961,
        -0.56253
    ],
    [
        .6329,
        -0.107059
    ],
    [
        -0.46408,
        .569669
    ],
    [
        -0.173676,
        -0.958758
    ],
    [
        -0.242648,
        -0.234303
    ],
    [
        -0.275362,
        .157163
    ],
    [
        .382295,
        -0.795131
    ],
    [
        .562955,
        .115562
    ],
    [
        .190586,
        .470121
    ],
    [
        .770764,
        -0.297576
    ],
    [
        .237281,
        .93105
    ],
    [
        -0.666642,
        -0.455871
    ],
    [
        -0.905649,
        -0.298379
    ],
    [
        .33952,
        .157829
    ],
    [
        .701438,
        -0.7041
    ],
    [
        -0.062758,
        .160346
    ],
    [
        -0.220674,
        .957141
    ],
    [
        .642692,
        .432706
    ],
    [
        -0.77339,
        -0.015272
    ],
    [
        -0.671467,
        .24688
    ],
    [
        .158051,
        .062859
    ],
    [
        .806009,
        .527232
    ],
    [
        -0.05762,
        -0.247071
    ],
    [
        .333436,
        -0.51671
    ],
    [
        -0.550658,
        -0.315773
    ],
    [
        -0.652078,
        .589846
    ],
    [
        .008818,
        .530556
    ],
    [
        -0.210004,
        .519896
    ]
];
var P$ = new $e({
    vertexShader: JN,
    fragmentShader: $N
}), qf = new $e({
    vertexShader: rB,
    fragmentShader: iB,
    uniforms: {
        texture_ao_lrez: new ce(null),
        texture_depth_lrez: new ce(null),
        texture_depth_hrez: new ce(null),
        near: new ce(null),
        far: new ce(null)
    }
}), Tb = class extends Ei {
    constructor(e, r){
        super("AmbientOcclusionPass", void 0, r);
        this.fogEnabled = !1;
        this.fogNear = 1;
        this.fogFar = 1e3;
        this.frameIndex = 0;
        this.sanitizeViewport = !1;
        this._runHalfRes = !0;
        this._width = 1;
        this._height = 1;
        let i = 1024, s1 = 1024;
        this.gBuffer = new at(i, s1, {
            type: bs ? $n : Ut,
            depthTexture: new ps(i, s1),
            minFilter: it,
            magFilter: it
        }), this.depthBufferHighRes = new at(i, s1, {
            depthTexture: new ps(i, s1)
        }), this.aoBuffer = new at(i, s1, {
            minFilter: it,
            magFilter: it
        }), this.splineScene = e, this.splineCamera = r;
        let o = new Float32Array(Wf.length * 2);
        for(let l = 0; l < Wf.length; l++){
            let c = l * 2;
            o[c + 0] = Wf[l][0], o[c + 1] = Wf[l][1];
        }
        this.blueNoiseInDiskTexture = new Ur(o, Wf.length, 1, bh, Ut), this.blueNoiseInDiskTexture.wrapS = Hs, this.blueNoiseInDiskTexture.wrapT = Hs, this.blueNoiseInDiskTexture.needsUpdate = !0, this.hbaoMaterial = new $e({
            vertexShader: eB,
            fragmentShader: tB,
            uniforms: {
                near: new ce(null),
                far: new ce(null),
                fov: new ce(null),
                proj_info: new ce(new Ze),
                is_ortho: new ce(!1),
                resolution: new ce(new U),
                radius_of_influence: new ce(8),
                radius_in_screen_space: new ce(1),
                exponent: new ce(1),
                ao_color: new ce(new E),
                bias: new ce(.5),
                texture_depth: new ce(null),
                texture_normals: new ce(null),
                texture_blue_noise: new ce(null),
                texture_blue_noise_in_disk: new ce(this.blueNoiseInDiskTexture),
                frame_index: new ce(0),
                fog_enabled: new ce(!1),
                fog_near: new ce(1),
                fog_far: new ce(1e3)
            }
        }), this.radius = 128, this.aoColor = {
            r: 0,
            g: 0,
            b: 0
        }, this.bias = .5, this.hbaoMaterial.uniforms.texture_depth.value = this.gBuffer.depthTexture, this.hbaoMaterial.uniforms.texture_normals.value = this.gBuffer.texture, this.needsSwap = !0, this.aaBuffer = new at(i, s1, {
            minFilter: it,
            magFilter: it,
            wrapS: tr,
            wrapT: tr,
            depthBuffer: !1,
            type: Ut
        });
        let a = new bb({
            preset: rl.ULTRA,
            edgeDetectionMode: Lf.COLOR
        });
        this.effectPass = new bu(this.camera, a);
    }
    initialize(e, r, i) {
        super.initialize(e, r, i), this.effectPass.initialize(e, r, i);
    }
    setBlueNoiseTexture(e) {
        this.hbaoMaterial.uniforms.texture_blue_noise.value = e;
    }
    setSize(e, r) {
        this._width = e, this._height = r, this.depthBufferHighRes.setSize(e, r);
        let i = this._runHalfRes ? .5 : 1, s1 = e * i, o = r * i;
        this.gBuffer.setSize(s1, o), this.aoBuffer.setSize(s1, o), this.hbaoMaterial.uniforms.resolution.value.set(s1, o), this.aaBuffer.setSize(s1, o), this.effectPass.setSize(s1, o);
    }
    get runHalfRes() {
        return this._runHalfRes;
    }
    set runHalfRes(e) {
        this._runHalfRes = e, this.setSize(this._width, this._height);
    }
    setCamera(e) {
        this.splineCamera = e;
    }
    setScene(e) {
        this.splineScene = e;
    }
    setDepthTexture(e) {
        this.depthBufferHighRes.depthTexture = e, qf.uniforms.texture_depth_hrez.value = e, qf.needsUpdate = !0;
    }
    render(e, r, i) {
        let s1 = null, o = null, a = null, l = null, c = (d)=>{
            e.setViewport(0, 0, d.width, d.height);
        };
        this.sanitizeViewport && (s1 = new Ze, o = new Ze, e.getViewport(s1), e.getScissor(o), a = e.getScissorTest(), l = e.getRenderTarget(), e.setScissorTest(!1)), this.splineScene.overrideMaterial = P$;
        let u1 = this.splineCamera.layers.mask;
        if (this.splineCamera.layers.set(5), e.setRenderTarget(this.gBuffer), this.sanitizeViewport && c(this.gBuffer), e.clear(), e.render(this.splineScene, this.splineCamera), e.setRenderTarget(this.depthBufferHighRes), this.sanitizeViewport && c(this.depthBufferHighRes), e.clear(), e.render(this.splineScene, this.splineCamera), this.splineScene.overrideMaterial = null, this.splineCamera.layers.mask = u1, this.hbaoMaterial.uniforms.radius_of_influence.value = this.radius, this.hbaoMaterial.uniforms.ao_color.value.set(this.aoColor.r, this.aoColor.g, this.aoColor.b), this.hbaoMaterial.uniforms.bias.value = this.bias, this.hbaoMaterial.uniforms.fog_enabled.value = this.fogEnabled, this.hbaoMaterial.uniforms.fog_near.value = this.fogNear, this.hbaoMaterial.uniforms.fog_far.value = this.fogFar, this.hbaoMaterial.uniforms.frame_index.value = this.frameIndex, this.frameIndex++, this.splineCamera.isPerspectiveCamera) {
            this.hbaoMaterial.uniforms.near.value = this.splineCamera.perspCamera.near, this.hbaoMaterial.uniforms.far.value = this.splineCamera.perspCamera.far;
            let d = this.splineCamera.perspCamera.projectionMatrix.elements, f = 2 / d[0], m = 2 / d[5], p = -(1 - d[8]) / d[0], g = -(1 + d[9]) / d[5];
            this.hbaoMaterial.uniforms.proj_info.value.set(f, m, p, g);
            let x = this.splineCamera.perspCamera.fov * (Math.PI / 180), b = this.hbaoMaterial.uniforms.resolution.value.y / (Math.tan(x * .5) * 2), w = this.hbaoMaterial.uniforms.radius_of_influence.value * .5 * b;
            this.hbaoMaterial.uniforms.radius_in_screen_space.value = w, this.hbaoMaterial.uniforms.is_ortho.value = !1;
        } else {
            this.hbaoMaterial.uniforms.near.value = this.splineCamera.orthoCamera.near, this.hbaoMaterial.uniforms.far.value = this.splineCamera.orthoCamera.far;
            let d = this.splineCamera.orthoCamera.projectionMatrix.elements, f = 2 / d[0], m = 2 / d[5], p = -(1 + d[12]) / d[0], g = -(1 - d[13]) / d[5];
            this.hbaoMaterial.uniforms.proj_info.value.set(f, m, p, g);
            let x = .5 * (this.hbaoMaterial.uniforms.resolution.value.y / m), v = this.hbaoMaterial.uniforms.radius_of_influence.value * x;
            this.hbaoMaterial.uniforms.radius_in_screen_space.value = v, this.hbaoMaterial.uniforms.is_ortho.value = !0;
        }
        let h = e.aoRenderTarget;
        this.runHalfRes ? (this.fullscreenMaterial = this.hbaoMaterial, e.setRenderTarget(this.aoBuffer), this.sanitizeViewport && c(this.aoBuffer), e.clear(), e.render(this.scene, this.camera), this.fullscreenMaterial = qf, qf.uniforms.texture_ao_lrez.value = this.aoBuffer.texture, qf.uniforms.texture_depth_lrez.value = this.gBuffer.depthTexture, qf.uniforms.texture_depth_hrez.value = this.depthBufferHighRes.depthTexture, e.setRenderTarget(h), this.sanitizeViewport && c(h), e.clear(), e.render(this.scene, this.camera)) : (this.fullscreenMaterial = this.hbaoMaterial, e.setRenderTarget(this.aaBuffer), this.sanitizeViewport && c(this.aaBuffer), e.clear(), e.render(this.scene, this.camera), this.effectPass.renderToScreen = !1, this.effectPass.render(e, this.aaBuffer, h)), this.sanitizeViewport && s1 && o && a !== null && (e.setRenderTarget(l), e.setViewport(s1.x, s1.y, s1.z, s1.w), e.setScissor(o.x, o.y, o.z, o.w), e.setScissorTest(a));
    }
    dispose() {
        this.gBuffer.dispose(), this.depthBufferHighRes.dispose(), this.aoBuffer.dispose();
    }
};
var _$ = `
varying vec2 vUv;
void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, I$ = `
uniform sampler2D tInput;
uniform sampler2D tMap;
uniform vec2 resolution;
varying vec2 vUv;

uniform vec2 uResolution;
uniform vec2 uCoords;

// Draws a rectangle at center <st> with size <size>
float rectangle(vec2 st, vec2 size) {
    size = vec2(0.5) - size * 0.5;
    vec2 uv = vec2(step(size.x, st.x), step(size.y, st.y));
    uv *= vec2(step(size.x, 1.0 - st.x), step(size.y, 1.0 - st.y));

    return uv.x * uv.y;
}

uniform vec2 uSize;
uniform float uScale;
uniform float uDPR;
uniform float uCurrent;
uniform vec3 uSceneColor;

void main() {
    vec2 screenUv = gl_FragCoord.xy / uResolution.xy;
    screenUv *= 1.0 / uDPR;

    vec2 center = vec2(0.5, -0.5);
    vec2 outsideUv = screenUv;
    outsideUv += center;
    outsideUv -= uCoords.xy / uResolution.xy;
    outsideUv = (outsideUv - 0.5) + 0.5;
    outsideUv -= center;
    vec2 s = (uSize / uResolution) * uScale;
    float isOutside = 1.0 - rectangle(outsideUv, s);
    
    vec2 mid = vec2(0.5);
    vec2 insideUv = (screenUv - mid + s * mid) / s;
    vec4 background = texture2D(tInput, screenUv);
    vec4 image = texture2D(tMap, insideUv);
    gl_FragColor = mix(image, background, isOutside);
}
`, Mb = class extends mn {
    constructor(){
        super(new $e({
            vertexShader: _$,
            fragmentShader: I$,
            uniforms: {
                tInput: new ce(null),
                tMap: new ce(null),
                uResolution: new ce(new U),
                uSize: new ce(new U),
                uCoords: new ce(new U),
                uScale: new ce(1),
                uSceneColor: new ce(new Ge(16711680)),
                uDPR: new ce(1),
                uCurrent: new ce(0)
            }
        }), "tInput"), this.needsSwap = !0;
    }
    get uniforms() {
        return this.fullscreenMaterial.uniforms;
    }
    get texture() {
        return this.uniforms.tMap.value;
    }
    set texture(t) {
        this.uniforms.tMap.value = t;
    }
};
var D$ = `
void main() {
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, O$ = `
uniform sampler2D toScene;
uniform sampler2D fromScene;
uniform vec2 resolution;

uniform vec2 uResolution;
uniform float uDPR;

uniform float mixRatio;
uniform sampler2D tMixTexture;
uniform int useTexture;
uniform float threshold;

void main() {
	vec2 screenUv = gl_FragCoord.xy / uResolution.xy;
	screenUv *= 1.0 / uDPR;

	vec4 texel1 = texture2D( fromScene, screenUv );
	vec4 texel2 = texture2D( toScene, screenUv );

	if (useTexture==1) {
		
		vec4 transitionTexel = texture2D( tMixTexture, screenUv );
		float r = mixRatio * (1.0 + threshold * 2.0) - threshold;
		float mixf=clamp((transitionTexel.r - r)*(1.0/threshold), 0.0, 1.0);
		
		gl_FragColor = mix( texel1, texel2, mixf );
	} else {
		
		gl_FragColor = mix( texel1, texel2, mixRatio );
		
	}
}
`, R$ = [], Cb = class extends mn {
    constructor(){
        super(new $e({
            vertexShader: D$,
            fragmentShader: O$,
            uniforms: {
                toScene: new ce(null),
                fromScene: new ce(null),
                uResolution: new ce(new U),
                uDPR: new ce(1),
                mixRatio: new ce(0),
                threshold: new ce(.1),
                useTexture: new ce(0),
                tMixTexture: {
                    value: R$[0]
                }
            }
        }), "toScene"), this.needsSwap = !0;
    }
    get uniforms() {
        return this.fullscreenMaterial.uniforms;
    }
    get texture() {
        return this.uniforms.fromScene.value;
    }
    set texture(t) {
        this.uniforms.fromScene.value = t;
    }
};
var L$ = `
void main() {
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, N$ = `
uniform sampler2D inputBuffer;
uniform sampler2D blurredInputBuffer;
uniform sampler2D overlay;
uniform float blurIntensity;

uniform vec2 uResolution;
uniform float uDPR;

void main() {
	vec2 screenUv = gl_FragCoord.xy / uResolution.xy;
	screenUv *= 1.0 / uDPR;

	vec4 texel1 = texture2D( overlay, screenUv );
	vec4 texel2 = texture2D( inputBuffer, screenUv );
	vec4 texel3 = texture2D( blurredInputBuffer, screenUv );

	float blurMask2 = max(sign(texel1.a), 0.0) * blurIntensity;
    gl_FragColor = mix( mix(texel2, texel3, blurMask2), texel1, texel1.a );
}
`, Pb = class extends mn {
    constructor(){
        super(new $e({
            vertexShader: L$,
            fragmentShader: N$,
            uniforms: {
                inputBuffer: new ce(null),
                blurredInputBuffer: new ce(null),
                overlay: new ce(null),
                uResolution: new ce(new U),
                uDPR: new ce(1),
                blurIntensity: new ce(0)
            }
        }));
        this._blurEnabled = !1;
        this.blurTarget = new at(1, 1, {
            minFilter: it,
            magFilter: it,
            wrapS: tr,
            wrapT: tr
        }), this.blurPass = new xb({
            width: window.innerWidth,
            height: window.innerHeight,
            kernelSize: mg.HUGE,
            resolutionScale: .25
        }), this.blurPass.renderToScreen = !1, this.uniforms.blurredInputBuffer.value = this.blurTarget.texture;
    }
    get uniforms() {
        return this.fullscreenMaterial.uniforms;
    }
    get texture() {
        return this.uniforms.overlay.value;
    }
    set texture(e) {
        this.uniforms.overlay.value = e;
    }
    setResolution(e, r, i = 1) {
        this.uniforms.uResolution.value.set(e, r), this.uniforms.uDPR.value = i, this.blurPass.setSize(e, r), this.blurTarget.setSize(e, r), this.blurPass.setSize(e, r);
    }
    get uiCanvas() {
        return this._uiCanvas;
    }
    set uiCanvas(e) {
        this._uiCanvas = e, e.texture && (this.uniforms.overlay.value = e.texture);
        let i = e.frame;
        if (i) {
            let s1 = i.data.backgroundBlur, o = s1.radius;
            this._blurEnabled = s1.enabled, this.uniforms.blurIntensity.value = this._blurEnabled ? 1 : 0, this.blurPass.scale = o / 3;
        }
    }
    render(e, r, i, s1, o) {
        this._blurEnabled && (this.blurPass.setDepthTexture(this.getDepthTexture()), this.blurPass.render(e, r, this.blurTarget, s1, o)), super.render(e, r, i, s1, o);
    }
};
var B$ = `
varying vec2 vUv;
void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, F$ = `
uniform sampler2D tInput;
uniform sampler2D tOverlayImage;
varying vec2 vUv;
uniform vec2 uResolution;
uniform vec2 uRightBottom;
uniform vec2 uImageSize;
uniform float uScale;
uniform float uDPR;

vec3 blendNormal(vec3 base, vec3 blend) {
	return blend;
}

vec3 blendNormal(vec3 base, vec3 blend, float opacity) {
	return (blendNormal(base, blend) * opacity + base * (1.0 - opacity));
}

vec4 drawFixedSizeImage(sampler2D image, vec2 screenUV, vec2 imageSize, vec2 imageCoords, vec2 screenSize, float dpr) {
	vec2 uv = (screenUV * screenSize * dpr - imageCoords) / (imageSize * dpr);
	if (uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0) {
		return vec4(0.0);
	}
	return texture2D(image, uv);
}

void main() {
    vec2 screenUV = gl_FragCoord.xy / (uResolution.xy * uDPR);
	vec2 imageCoords = vec2(uResolution.x * uDPR - uImageSize.x * uScale * uDPR - uRightBottom.x * uDPR, uRightBottom.y * uDPR);
    vec4 background = texture2D(tInput, screenUV);
    vec4 image = drawFixedSizeImage(tOverlayImage, screenUV, uImageSize * uScale, imageCoords, uResolution, uDPR);
    gl_FragColor = vec4(blendNormal(background.rgb, image.rgb, image.a), max(background.a, image.a));
}
`, _b = class extends mn {
    constructor(){
        super(new $e({
            vertexShader: B$,
            fragmentShader: F$,
            uniforms: {
                tInput: new ce(null),
                tOverlayImage: new ce(null),
                uResolution: new ce(new U),
                uImageSize: new ce(new U),
                uRightBottom: new ce(new U(20, 20)),
                uScale: new ce(.25),
                uDPR: new ce(1)
            }
        }), "tInput");
    }
    get uniforms() {
        return this.fullscreenMaterial.uniforms;
    }
    get texture() {
        return this.uniforms.tOverlayImage.value;
    }
    set texture(t) {
        this.uniforms.tOverlayImage.value = t, this.uniforms.uImageSize.value.set(t.image.width, t.image.height);
    }
};
function sB(n1, t) {
    return t && t.enabled && n1.push(t.effect), n1;
}
var V$ = (n1)=>Object.values(Ot).includes(n1) ? n1 : Ot.NORMAL, gg = class extends ar {
    constructor(e, r){
        super();
        this._needsDOFResize = r;
        this.postprocessingState = pd.defaultData;
        this._scene = new Er;
        this._camera = new ir;
        this.effects = new Map;
        this.blueNoiseTexture = new Ur;
        this._renderToScreen = !0;
        this._isUIOverlayEnabled = !1;
        this.clock = new iv, this.renderer = e, this.debug = !1, this.effects.set("bloom", new Nf), this.effects.set("chromaticAberration", new Ff), this.effects.set("vignette", new zf), this.effects.set("noise", new kf), this.effects.set("colorAverage", new Vf), this.effects.set("hueSaturation", new Uf), this.effects.set("brightnessContrast", new Bf), this.effects.set("depthOfField", new Gf), this.effects.set("pixelation", new jf), this.effectComposer = new Ab(this.renderer), this.effectComposer.autoRenderToScreen = !1, this.opaquePass = new Su(!0, this.scene, this.camera), this.opaquePass.clear = !0, this.transmissionPass = new wb(this.scene, this.camera, this.renderer), this.aoPass = new Tb(this.scene, this.camera), this.taaPass = new Sb, this.taaPass.renderToScreen = !1, this.helperPass = new Eb(this.camera), this.helperPass.renderToScreen = !1, this.stylesOverlayPass = new Mb, this.stylesOverlayPass.enabled = !1, this.uiOverlayPass = new Pb, this.uiOverlayPass.enabled = !1, this.logoOverlayPass = new _b, this.logoOverlayPass.enabled = !1, this.sceneTransitionPass = new Cb, this.sceneTransitionPass.enabled = !1, this._initCopyPass(), this._initPasses();
    }
    set overlayTexture(e) {
        e !== void 0 ? (this.stylesOverlayPass.texture = e, this.stylesOverlayPass.enabled = !0) : this.stylesOverlayPass.enabled = !1;
    }
    get overlayTexture() {
        return this.stylesOverlayPass.texture;
    }
    set sceneHelpers(e) {
        this.helperPass.sceneHelpers = e;
    }
    get sceneHelpers() {
        return this.helperPass.sceneHelpers;
    }
    set sceneHelpersOnTop(e) {
        this.helperPass.sceneHelpersOnTop = e;
    }
    get sceneHelpersOnTop() {
        return this.helperPass.sceneHelpersOnTop;
    }
    get scene() {
        return this._scene;
    }
    set scene(e) {
        this._scene = e, this.opaquePass.setScene(e), this.transmissionPass.setScene(e), this.aoPass.setScene(e);
    }
    get camera() {
        return this._camera;
    }
    set camera(e) {
        let r = this._camera !== e;
        this._camera = e, this.opaquePass.setCamera(e), this.transmissionPass.setCamera(e), r && this.transmissionPass.updatePasses(this.renderer), this.aoPass.setCamera(e), this.helperPass.setCamera(e), this.effects.get("depthOfField").setCamera(e);
    }
    updateRenderToScreen() {
        let e = !1;
        for(let r = this.effectComposer.passes.length - 1; r >= 0; r--){
            let i = this.effectComposer.passes[r];
            if (i.enabled === !0 && !e && this._renderToScreen) {
                i.renderToScreen = !0, e = !0;
                continue;
            }
            i.renderToScreen = !1;
        }
    }
    get isUIOverlayEnabled() {
        return this._isUIOverlayEnabled;
    }
    disableUIOverlay() {
        this._isUIOverlayEnabled = !1;
    }
    enableUIOverlay() {
        this._isUIOverlayEnabled = !0;
    }
    disableHelpers() {
        this.helperPass.enabled = !1, this.updateRenderToScreen();
    }
    enableHelpers() {
        this.helperPass.enabled = !0, this.updateRenderToScreen();
    }
    updateBlueNoiseTexture(e) {
        this.blueNoiseTexture = new Ur(e, 128, 128), this.blueNoiseTexture.wrapS = Hs, this.blueNoiseTexture.wrapT = Hs, this.blueNoiseTexture.minFilter = vt, this.blueNoiseTexture.magFilter = vt, this.blueNoiseTexture.needsUpdate = !0;
    }
    setAmbientOcclusionParams(e, r, i, s1, o, a, l, c) {
        this.aoPass.enabled = e, this.aoPass.radius = r, this.aoPass.bias = i, this.aoPass.aoColor = s1, this.aoPass.fogEnabled = o, this.aoPass.fogNear = a, this.aoPass.fogFar = l, this.aoPass.runHalfRes !== !c && (this.aoPass.runHalfRes = !c);
    }
    setTransmissionPassEnabled(e) {
        this.transmissionPass.enabled = e, this.opaquePass.hasTransmissionPass = e;
    }
    _initPasses() {
        if (this.uvEffectPass?.dispose(), this.effectPass?.dispose(), this.effectComposer.removeAllPasses(), this.transmissionPass.updatePasses(this.renderer), this.effectComposer.addPass(this.aoPass), this.effectComposer.addPass(this.opaquePass), this.effectComposer.addPass(this.transmissionPass), this.effectComposer.addPass(this.taaPass), this.postprocessingState.enabled) {
            let e = [
                this.effects.get("pixelation")
            ].reduce(sB, []);
            e.length > 0 && (this.uvEffectPass = new bu(this.camera, ...e), this.uvEffectPass.renderToScreen = !1, this.effectComposer.addPass(this.uvEffectPass));
            let r = [
                this.effects.get("chromaticAberration"),
                this.effects.get("bloom"),
                this.effects.get("depthOfField"),
                this.effects.get("colorAverage"),
                this.effects.get("hueSaturation"),
                this.effects.get("brightnessContrast"),
                this.effects.get("vignette"),
                this.effects.get("noise")
            ].reduce(sB, []);
            if (r.length > 0 && (this.effectPass = new bu(this.camera, ...r), this.effectPass.renderToScreen = !1, this.effectComposer.addPass(this.effectPass), this._needsDOFResize && this.effects.get("depthOfField")?.enabled && window !== void 0)) {
                let i = this.renderer.viewportWidth, s1 = this.renderer.viewportHeight;
                this.renderer.setSize(i - 1, s1 - 1), this.renderer.setSize(i, s1);
            }
        }
        this.effectComposer.addPass(this.stylesOverlayPass), this.effectComposer.addPass(this.uiOverlayPass), this.effectComposer.addPass(this.sceneTransitionPass), this.effectComposer.addPass(this.helperPass), this.effectComposer.addPass(this.logoOverlayPass);
    }
    _initCopyPass() {
        if (this._savePass) return;
        let e = new U;
        this.renderer.getDrawingBufferSize(e), this._rt = new at(e.x, e.y, {
            depthBuffer: !1,
            stencilBuffer: !1,
            wrapS: Hs,
            wrapT: Hs
        }), this._rt.samples = 0, this._savePass = new pg(this._rt, !1), this._savePass.renderToScreen = !1;
    }
    setCopyPass(e) {
        this._rt = e, this._savePass = new pg(this._rt, !1), this.renderToScreen = !1;
    }
    get renderToScreen() {
        return this._renderToScreen;
    }
    set renderToScreen(e) {
        if (this._renderToScreen === e) return;
        let r = this.effectComposer;
        !r || (e === !0 ? r.removePass(this._savePass) : r.addPass(this._savePass), this._renderToScreen = e, this.updateRenderToScreen());
    }
    set sceneTransitionFromTexture(e) {
        e !== this.sceneTransitionPass.texture && (e !== null ? this.sceneTransitionPass.enabled = !0 : (this.sceneTransitionPass.enabled = !1, this.updateRenderToScreen()), this.sceneTransitionPass.texture = e);
    }
    setWatermark(e) {
        this.logoOverlayPass.enabled = e !== null, e && (this.logoOverlayPass.texture = e);
    }
    get texture() {
        return this._rt && this._rt.texture;
    }
    get renderTarget() {
        return this._rt;
    }
    updatePostprocessing(e) {
        let { enabled: r, ...i } = e, s1 = !1;
        r !== this.postprocessingState.enabled && (s1 = !0);
        for (let o of Object.entries(i)){
            let a = o[1], l = this.effects.get(o[0]);
            if (l) {
                l.enabled !== a.enabled && (s1 = !0), l.enabled = a.enabled;
                for (let [c, u1] of Object.entries(a))c === "blendFunction" ? l.blendFunction = V$(u1) : l[c] = u1;
            }
        }
        this.postprocessingState = e, s1 && this._initPasses();
    }
    render() {
        this.effectComposer.render(this.clock.getDelta());
    }
    setScissor(e, r, i, s1) {
        e instanceof Ze ? (this.effectComposer.inputBuffer.scissor.set(e.x, e.y, e.z, e.w), this.effectComposer.outputBuffer.scissor.set(e.x, e.y, e.z, e.w)) : (this.effectComposer.inputBuffer.scissor.set(e, r, i, s1), this.effectComposer.outputBuffer.scissor.set(e, r, i, s1));
        let o = this.renderer.getPixelRatio();
        this.effectComposer.inputBuffer.scissor.multiplyScalar(o), this.effectComposer.outputBuffer.scissor.multiplyScalar(o), this.renderer.setScissor(e, r, i, s1);
    }
    setScissorTest(e) {
        this.effectComposer.inputBuffer.scissorTest = e, this.effectComposer.outputBuffer.scissorTest = e, this.renderer.setScissorTest(e);
    }
    setViewport(e, r, i, s1) {
        e instanceof Ze ? (this.effectComposer.inputBuffer.viewport.copy(e), this.effectComposer.outputBuffer.viewport.copy(e)) : (this.effectComposer.inputBuffer.viewport.set(e, r, i, s1), this.effectComposer.outputBuffer.viewport.set(e, r, i, s1));
    }
    resize(e, r, i) {
        if (this.effectComposer.setSize(e, r, i), this._rt) {
            let s1 = this.renderer.getPixelRatio();
            this._rt.setSize(e * s1, r * s1);
        }
    }
    dispose() {
        this.uvEffectPass?.dispose(), this.effectPass?.dispose(), this.effectComposer.dispose();
    }
};
var U$ = (n1)=>`

// PCSS implementation based on:
// https://www.gamedev.net/articles/programming/graphics/contact-hardening-soft-shadows-made-fast-r4906/
// NOTE: This number affects how big the shadow blur can
// possibly get. Bigger number == bigger blur, but less precise results

const float  gPenumbraFilterSize = 80.0;
const int   gPenumbraSamples = ${n1};
const int gShadowSamples = ${n1};
const float gShadowSamplesRpc = 1.0f / float(gShadowSamples);

#ifdef USE_SHADOWMAP
    #if NUM_DIR_LIGHT_SHADOWS > 0

        uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
        varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];

        struct DirectionalLightShadow {
            float shadowBias;
            float shadowNormalBias;
            float shadowRadius;
            vec2 shadowMapSize;
        };

        uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];

    #endif

    #if NUM_SPOT_LIGHT_SHADOWS > 0

        uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
        varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_SHADOWS ];

        struct SpotLightShadow {
            float shadowBias;
            float shadowNormalBias;
            float shadowRadius;
            vec2 shadowMapSize;
        };

        uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];

    #endif

    #if NUM_POINT_LIGHT_SHADOWS > 0

        uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
        varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];

        struct PointLightShadow {
            float shadowBias;
            float shadowNormalBias;
            float shadowRadius;
            vec2 shadowMapSize;
            float shadowCameraNear;
            float shadowCameraFar;
        };

        uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];

    #endif

    /*
    #if NUM_RECT_AREA_LIGHTS > 0

        // TODO (abelnation): create uniforms for area light shadows

    #endif
    */

float computePenumbra(int index, sampler2D shadowMap, float temporalAngle, float texelSize, vec2 uv, float compare, float texelScalar, float shadowRadius)
{
    float penumbra = 1.0;
    float blockerDepthAvg = 0.0;
    float blockerCount = 0.0;

    #pragma unroll_loop_start
    for(int i = 0; i < gPenumbraSamples; i ++)
    {
        vec2 offset = (vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize) * texelScalar;
        float depth = unpackRGBAToDepth( texture2D( shadowMap, uv + offset ) );

        if(depth < compare + 0.0001)
        {
            blockerDepthAvg += depth;
            blockerCount++;
        }
    }
    #pragma unroll_loop_end

    if (blockerCount > 0.0)
    {
        blockerDepthAvg /= blockerCount;

        // Compute penumbra
        penumbra = (compare - blockerDepthAvg) / (blockerDepthAvg);
        penumbra *= penumbra;
        penumbra *= 200.0 * penumbraSize[min(index, ${5} - 1)]; // Magic number that affects how quickly the penumbra grows

        return clamp(penumbra, 0.00, 1.0);
    }
    return 0.0;
}

float vogelShadow(int index, sampler2D shadowMap, vec2 uv, float texelSize, float compare, float shadowRadius)
{
    float shadow         = 0.0f;

    // NOTE: When using TAA, we should use screen space interleaved gradient noise
    vec2 halton = haltonSequence[frameIndex];
    float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
    float temporalAngle  = temporalOffset * PI2;

    float texelScalar = (gPenumbraFilterSize) / (texelSize * 1024.);
    float penumbra = computePenumbra(index, shadowMap, temporalAngle, texelSize, uv, compare, texelScalar, shadowRadius);
    if (penumbra == -1.0) {
        return 1.0;
    }

    #pragma unroll_loop_start
    for (int i = 0; i < gShadowSamples; i++)
    {
        vec2 vogelSample =  vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize;
        // Overall blurring offset
        vec2 offset = vogelSample * (shadowRadius * 2.);

        // Penumbra offset
        offset += vogelSample * (penumbra * texelScalar);

        shadow += step( compare, unpackRGBAToDepth( texture2D( shadowMap, uv + offset ) ) );
    }
    #pragma unroll_loop_end

    return shadow * gShadowSamplesRpc;
}


    float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {

        return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );

    }

    vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {

        return unpackRGBATo2Half( texture2D( shadow, uv ) );

    }

    float VSMShadow (sampler2D shadow, vec2 uv, float compare ){

        float occlusion = 1.0;

        vec2 distribution = texture2DDistribution( shadow, uv );

        float hard_shadow = step( compare , distribution.x ); // Hard Shadow

        if (hard_shadow != 1.0 ) {

            float distance = compare - distribution.x ;
            float variance = max( 0.00000, distribution.y * distribution.y );
            float softness_probability = variance / (variance + distance * distance ); // Chebeyshevs inequality
            softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 ); // 0.3 reduces light bleed
            occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );

        }
        return occlusion;

    }

    float getShadow( int i, sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {

        float shadow = 1.0;

        shadowCoord.xyz /= shadowCoord.w;
        shadowCoord.z += shadowBias;

        // if ( something && something ) breaks ATI OpenGL shader compiler
        // if ( all( something, something ) ) using this instead

        bvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );
        bool inFrustum = all( inFrustumVec );

        bvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );

        bool frustumTest = all( frustumTestVec );

        if ( frustumTest ) {

        #if defined( SHADOWMAP_TYPE_PCF )

            vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
            return vogelShadow(i, shadowMap, shadowCoord.xy, texelSize.x, shadowCoord.z, shadowRadius );

        #elif defined( SHADOWMAP_TYPE_PCF_SOFT )

            vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
            float dx = texelSize.x;
            float dy = texelSize.y;

            vec2 uv = shadowCoord.xy;
            vec2 f = fract( uv * shadowMapSize + 0.5 );
            uv -= f * texelSize;

            shadow = (
                texture2DCompare( shadowMap, uv, shadowCoord.z ) +
                texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
                texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
                texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
                mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
                     f.x ) +
                mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
                     f.x ) +
                mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
                     f.y ) +
                mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
                     f.y ) +
                mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
                          texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
                          f.x ),
                     mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
                          texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
                          f.x ),
                     f.y )
            ) * ( 1.0 / 9.0 );

        #elif defined( SHADOWMAP_TYPE_VSM )

            shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );

        #else // no percentage-closer filtering:

            shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );

        #endif

        }

        return shadow;

    }

    // cubeToUV() maps a 3D direction vector suitable for cube texture mapping to a 2D
    // vector suitable for 2D texture mapping. This code uses the following layout for the
    // 2D texture:
    //
    // xzXZ
    //  y Y
    //
    // Y - Positive y direction
    // y - Negative y direction
    // X - Positive x direction
    // x - Negative x direction
    // Z - Positive z direction
    // z - Negative z direction
    //
    // Source and test bed:
    // https://gist.github.com/tschw/da10c43c467ce8afd0c4

    vec2 cubeToUV( vec3 v, float texelSizeY ) {

        // Number of texels to avoid at the edge of each square

        vec3 absV = abs( v );

        // Intersect unit cube

        float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
        absV *= scaleToCube;

        // Apply scale to avoid seams

        // two texels less per square (one texel will do for NEAREST)
        v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );

        // Unwrap

        // space: -1 ... 1 range for each square
        //
        // #X##         dim    := ( 4 , 2 )
        //  # #         center := ( 1 , 1 )

        vec2 planar = v.xy;

        float almostATexel = 1.5 * texelSizeY;
        float almostOne = 1.0 - almostATexel;

        if ( absV.z >= almostOne ) {

            if ( v.z > 0.0 )
                planar.x = 4.0 - v.x;

        } else if ( absV.x >= almostOne ) {

            float signX = sign( v.x );
            planar.x = v.z * signX + 2.0 * signX;

        } else if ( absV.y >= almostOne ) {

            float signY = sign( v.y );
            planar.x = v.x + 2.0 * signY + 2.0;
            planar.y = v.z * signY - 2.0;

        }

        // Transform to UV space

        // scale := 0.5 / dim
        // translate := ( center + 0.5 ) / dim
        return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );

    }

    float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {

        float shadow = 1.0;
        vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );

        // for point lights, the uniform @vShadowCoord is re-purposed to hold
        // the vector from the light to the world-space position of the fragment.
        vec3 lightToPosition = shadowCoord.xyz;

        // dp = normalized distance from light to fragment position
        float compare = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear ); // need to clamp?
        compare += shadowBias;

        // bd3D = base direction 3D
        vec3 bd3D = normalize( lightToPosition );

        vec2 halton = haltonSequence[frameIndex];
        float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
        float temporalAngle  = temporalOffset * PI2;

        #if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_VSM )
            for (int i = 0; i < gShadowSamples; i++) {
                vec2 vogelSample = vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize;

                // Overall blurring offset
                vec3 offset = vec3(vogelSample.x, vogelSample.y, -vogelSample.x) * (shadowRadius + 5.);

                // NOTE: Removed for now
                // Penumbra offset
                //offset += vec3(vogelSample.x, vogelSample.y, vogelSample.y)  * (penumbra * gPenumbraFilterSize);

                shadow += texture2DCompare( shadowMap, cubeToUV( bd3D + offset, texelSize.y ), compare );

            }
            return shadow * gShadowSamplesRpc;

        #elif defined( SHADOWMAP_TYPE_PCF_SOFT )
            for (int i = 0; i < 16; i++) {
                vec2 vogelSample = vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize;

                // Overall blurring offset
                vec3 offset = vec3(vogelSample.x, vogelSample.y, -vogelSample.x) * (shadowRadius + 5.);

                shadow += texture2DCompare( shadowMap, cubeToUV( bd3D + offset, texelSize.y ), compare );

            }
            return shadow * (1.0 / 16.0);
        #else // no percentage-closer filtering

            return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), compare );

        #endif

    }

#endif
`, k$ = wt.lights_fragment_begin, z$ = wt.shadowmask_pars_fragment, oB = null, G$ = (n1)=>{
    switch(n1){
        case "low":
            return 8;
        case "medium":
            return 16;
        case "high":
            return 32;
        default:
            return 16;
    }
}, aB = (n1 = "medium")=>{
    if (oB === n1) return !1;
    oB = n1;
    let t = G$(n1);
    wt.shadowmap_pars_fragment = U$(t);
    let e = k$.slice();
    e = e.replace("getShadow( spotShadowMap[ i ]", `getShadow( UNROLLED_LOOP_INDEX + ${3}, spotShadowMap[ i ]`), e = e.replace("getShadow( directionalShadowMap[ i ]", "getShadow( UNROLLED_LOOP_INDEX, directionalShadowMap[ i ]"), wt.lights_fragment_begin = e;
    let r = z$.slice();
    return r = r.replaceAll("getShadow(", "getShadow( UNROLLED_LOOP_INDEX, "), wt.shadowmask_pars_fragment = r, !0;
};
var j$ = `
attribute vec3 randomColor;
varying vec3 vNormal;
flat out vec3 vColor;
#include <skinning_pars_vertex>
#include <morphtarget_pars_vertex>
	
void main()
{
#include <beginnormal_vertex>
#include <morphnormal_vertex>
#include <skinbase_vertex>
#include <skinnormal_vertex>
vec3 transformed = vec3(position);
#include <morphtarget_vertex>
#include <skinning_vertex>

vNormal = normal;
vColor = randomColor;
gl_Position = projectionMatrix * (modelViewMatrix * vec4(transformed, 1.0));
}
`, H$ = `
uniform float depthContrast;
varying vec3 vNormal;
flat in vec3 vColor;
void main()
{
vec3 normal = (normalize(vNormal)).rgb;

float contrastDepth = (gl_FragCoord.z - 0.5) * depthContrast + 0.5;

vec3 resultColor = mix(mix(vColor, normal, 0.2), vec3(contrastDepth), 0.4);
gl_FragColor = vec4(resultColor, vColor.r);
gl_FragColor = vec4(resultColor, vColor.r);
}
`, Ib = new $e({
    vertexShader: j$,
    fragmentShader: H$,
    uniforms: {
        depthContrast: {
            value: 1
        }
    }
});
var lB = new Zt, cB = new U, Db = class extends Iw {
    constructor(e){
        super(e);
        this._pixelRatio = this.getPixelRatio();
        this.viewportWidth = 1;
        this.viewportHeight = 1;
        this.resolution = new U;
        this.dummyCamera = new ir;
        this.sceneTransitionDuration = 0;
        this.sceneTransitionTimeRemaining = -1;
        this.isXRCopyPassSet = !1;
        this.clear = (e = !0, r = !0, i = !0)=>{
            let s1 = this.getContext(), o = 0;
            e && (o |= s1.COLOR_BUFFER_BIT), r && (o |= s1.DEPTH_BUFFER_BIT), i && (o |= s1.STENCIL_BUFFER_BIT), s1.clear(o), s1.clearBufferfv(s1.COLOR, 1, [
                0,
                0,
                0,
                1
            ]);
        };
        this.pipeline = new gg(this, e?.needsDOFResize ?? !1), this.autoClear = !1;
        let r = this.setPixelRatio.bind(this), i = this.setSize.bind(this);
        this.shadowMap.enabled = !0, this.shadowMap.type = cv, this.dummyCamera.matrixAutoUpdate = !1, this.domElement.removeAttribute("data-engine");
        let s1 = this.getContext();
        if (s1 && "drawingBufferColorSpace" in s1) try {
            s1.drawingBufferColorSpace = "display-p3";
        } catch (o) {
            console.warn(o);
        }
        this.setPixelRatio = (o)=>{
            this._pixelRatio !== o && (this._pixelRatio = o, r(o));
        }, this.setSize = (o, a, l = !0)=>{
            (this.viewportWidth !== o || this.viewportHeight !== a) && (this.viewportWidth = o, this.viewportHeight = a, i(o, a, l), this.normalRenderTarget?.setSize(o * this._pixelRatio, a * this._pixelRatio), this._resizeTransmission(o, a), this.transmissionDepthTarget?.setSize(o * this._pixelRatio / 2, a * this._pixelRatio / 2), this.pipeline.resize(o, a, l));
        }, this._superDispose = this.dispose, this.dispose = this._currentDispose;
    }
    createAORenderTarget() {
        this.aoRenderTarget === void 0 && (this.aoRenderTarget = new at(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio, {
            generateMipmaps: !1,
            minFilter: it,
            magFilter: it,
            wrapS: tr,
            wrapT: tr,
            depthBuffer: !1
        }));
    }
    _resizeTransmission(e, r) {
        this.transmissionRenderTarget?.setSize(e * this._pixelRatio / (this.hdTransmission ? 1 : 2), r * this._pixelRatio / (this.hdTransmission ? 1 : 2)), this.aoRenderTarget?.setSize(e * this._pixelRatio / 1, r * this._pixelRatio / 1);
    }
    get hdTransmission() {
        return Je.transmissionLod.value === 1;
    }
    set hdTransmission(e) {
        Je.transmissionLod.value = e === !0 ? 1 : 2, this._resizeTransmission(this.viewportWidth, this.viewportHeight);
    }
    createTransmissionRenderTarget() {
        this.transmissionRenderTarget === void 0 && (this.transmissionRenderTarget = new at(this.viewportWidth * this._pixelRatio / (this.hdTransmission ? 1 : 2), this.viewportHeight * this._pixelRatio / (this.hdTransmission ? 1 : 2), {
            generateMipmaps: !0,
            minFilter: Bc,
            magFilter: it,
            wrapS: tr,
            wrapT: tr,
            depthBuffer: !1
        }), this.transmissionDepthTarget = new at(this.viewportWidth * this._pixelRatio / 2, this.viewportHeight * this._pixelRatio / 2, {
            minFilter: vt,
            magFilter: vt,
            depthBuffer: !1
        }));
    }
    createNormalRenderTarget() {
        this.normalRenderTarget === void 0 && (this.normalRenderTarget = new at(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio, {
            generateMipmaps: !1,
            minFilter: vt,
            magFilter: vt,
            type: Ut,
            depthTexture: new ps(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio)
        }));
    }
    renderNormal(e, r, i) {
        this.normalRenderTarget && (this.setClearColor(0), i.layers.enable(8), i.layers.disable(0), i.layers.disable(3), r.traverseEntity((s1)=>{
            s1.layers.isEnabled(8) && (s1.copyPreviousMatrix = !1);
        }), this.setRenderTarget(this.normalRenderTarget), this.clear(), i instanceof ir ? Ib.uniforms.depthContrast.value = (i.far - i.near) / 1e4 : Ib.uniforms.depthContrast.value = 1, r.overrideMaterial = Ib, this.render(r, i), this.setClearColor(r.bgColor, r.bgColor.a), this.setRenderTarget(null), r.overrideMaterial = e.wireframeState ? Ob : null, i.layers.enable(0), i.layers.enable(3), r.traverseEntity((s1)=>{
            s1.layers.isEnabled(8) && (s1.copyPreviousMatrix = !0);
        }));
    }
    renderSplineSceneWithDummyCamera(e, r, i = 1) {
        this.dummyCamera.updateCameraState(r.dataPatched), this.dummyCamera.matrix.copy(r.matrixWorld);
        let s1 = r.height, o = r.width, a = this.viewportWidth / this.viewportHeight;
        o < s1 ? o = s1 * a : s1 = o / a, this.dummyCamera.setViewplaneSize(o, s1);
        for(let l = 0; l < i; l++)this.renderSplineScene(e, this.dummyCamera);
    }
    renderSplineScene(e, r, { sceneHelpers: i = this.sceneHelpers, sceneHelpersOnTop: s1 = this.sceneHelpersOnTop, overrideTransmission: o, overrideNormal: a } = {}) {
        let l = e instanceof fc ? e.activePage : e, c = l.visible;
        l.visible = !0;
        let u1 = l.scene;
        this.xr.enabled && (this.isXRCopyPassSet === !1 && this.getRenderTarget() !== null && (this.pipeline.setCopyPass(this.getRenderTarget()), this.isXRCopyPassSet = !0), this.xr.updateCamera(r)), this.setClearColor(l.bgColor, l.bgColor.a), l.penumbraSizeArray.forEach((m, p)=>{
            Je.penumbraSize.value[p] = m;
        }), Je.pixelRatioNode.value = this.getPixelRatio(), this.resolution.x !== 0 && this.resolution.y !== 0 ? Je.resolution.value.set(this.resolution.x, this.resolution.y) : Je.resolution.value.set(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio), a !== void 0 ? (Je.normalRenderTarget.value = a, Je.normalRenderTargetDepth.value = lB) : u1.needsNormal() && (this.createNormalRenderTarget(), Je.normalRenderTarget.value = this.normalRenderTarget.texture, Je.normalRenderTargetDepth.value = this.normalRenderTarget.depthTexture, this.renderNormal(u1, l, r));
        let h = l.data.ao, d = h.occlusion;
        if (d && (this.createAORenderTarget(), Je.aoRenderTarget.value = this.aoRenderTarget.texture), Je.aoEnabled.value = d, this.pipeline.setAmbientOcclusionParams(h.occlusion, h.radius, h.bias, l.aoColor, l.fog !== null, l.backupFog.near, l.backupFog.far, h.aoFullRes && !bs), this.pipeline.aoPass.setBlueNoiseTexture(this.pipeline.blueNoiseTexture), this.pipeline.isUIOverlayEnabled && l.uiCanvas?.enabled && l.uiCanvas.texture && l.uiCanvas.texture.image.width > 0) {
            let m = this.getSize(cB), p = this.getPixelRatio();
            (l.uiCanvas.width !== this.viewportWidth || l.uiCanvas.height !== this.viewportHeight || l.uiCanvas.dpr !== p) && l.uiCanvas.applySize({
                width: this.viewportWidth,
                height: this.viewportHeight
            }, p), l.uiCanvas.render(this), this.pipeline.uiOverlayPass.uiCanvas = l.uiCanvas, this.pipeline.uiOverlayPass.enabled = !0, this.pipeline.uiOverlayPass.setResolution(m.x, m.y, p), this.pipeline.updateRenderToScreen();
        } else this.pipeline.uiOverlayPass.enabled = !1, this.pipeline.updateRenderToScreen();
        if (this.pipeline.logoOverlayPass.enabled) {
            let m = this.getSize(cB), p = this.getPixelRatio();
            this.pipeline.logoOverlayPass.uniforms.uResolution.value.set(m.x, m.y), this.pipeline.logoOverlayPass.uniforms.uDPR.value = p;
        }
        let f = !1;
        if (o !== void 0) Je.transmissionRenderTarget.value = o, Je.transmissionRenderTargetDepth.value = lB, this.pipeline.setTransmissionPassEnabled(!1);
        else {
            let m = u1.needsTransmission();
            m && (this.transmissionRenderTarget === void 0 && (f = !0), this.createTransmissionRenderTarget(), Je.transmissionRenderTarget.value = this.transmissionRenderTarget.texture, Je.aspectRatio.value = EL(this.viewportWidth, this.viewportHeight), Je.transmissionRenderTargetDepth.value = this.transmissionDepthTarget.texture), this.pipeline.setTransmissionPassEnabled(m);
        }
        r.layers.enable(3), r.layers.enable(8), this.pipeline.sceneHelpers = i, this.pipeline.sceneHelpersOnTop = s1, this.pipeline.taaPass.enabled = Je.taaEnabled.value, this.pipeline.scene = l, this.pipeline.camera = r, f && this.pipeline.transmissionPass.updatePasses(this), this.pipeline.postprocessingState !== l.postprocessing && (this.pipeline.updatePostprocessing(l.postprocessing), !i && !s1 && this.pipeline.disableHelpers()), this.clearAlphaOverride !== void 0 && this.setClearAlpha(this.clearAlphaOverride), u1.shapeBlendIntances.forEach((m)=>{
            m.onBeforeShadowPass(this);
        }), l.overrideMaterial = u1.wireframeState ? Ob : null, this.pipeline.render(), Je.taaEnabled.value && (Je.frameIndex.value = (Je.frameIndex.value + 1) % 16), r instanceof ir && r.copyHistory(), l.visible = c;
    }
    renderFromSceneForSceneTransitionPass(e, r, i) {
        this.pipeline.renderToScreen = !1, this.pipeline.renderTarget, this.renderSplineScene(e, r), this.pipeline.sceneTransitionFromTexture = this.pipeline.renderTarget.texture, this.sceneTransitionDuration = i, this.sceneTransitionTimeRemaining = i, this.pipeline.renderToScreen = !0;
        let s1 = this.pipeline.sceneTransitionPass.uniforms;
        s1.uDPR.value = window.devicePixelRatio, s1.uResolution.value.set(this.domElement.width, this.domElement.height).divideScalar(window.devicePixelRatio);
    }
    _currentDispose() {
        this._superDispose(), this.pipeline.dispose(), this.aoRenderTarget?.dispose(), this.transmissionRenderTarget?.dispose(), this.transmissionDepthTarget?.dispose(), this.normalRenderTarget?.dispose(), this.normalRenderTarget?.depthTexture?.dispose();
    }
};
var Xf = class extends na(av) {
    constructor(e, r = 15, i = 10066329){
        super(e, r, i);
        this.object = e;
        this.added = !1;
        this.name = `DirectionalLightHelper: ${e.uuid}`;
    }
    raycast(e, r) {
        sa(this.object, Xf.geometryHelper, e, r);
    }
};
var Yf = class extends na(ov) {
    constructor(e, r = 15, i = 6710886){
        super(e, r, i);
        this.object = e;
        this.name = `PointLightHelper: ${e.uuid}`;
    }
    raycast(e, r) {
        sa(this.object, Yf.geometryHelper, e, r);
    }
};
var Rb = class extends na(sv) {
    constructor(e, r = 6710886){
        super(e, r);
        this.object = e;
        this.name = `SpotLightHelper: ${e.uuid}`;
    }
    raycast(e, r) {
        sa(this.object, Rb.geometryHelper, e, r);
    }
    update() {
        if (this.object !== void 0) {
            let e = Rb._vector, r = this.object.distance ? this.object.distance : 1e3, i = r * Math.tan(this.object.angle);
            this.cone.scale.set(i, i, r), e.setFromMatrixPosition(this.object.target.matrixWorld), this.cone.lookAt(e);
            let s1 = this.color !== void 0 ? this.color : this.light.color;
            if (this.cone.material instanceof Array) for(let o = 0, a = this.cone.material.length; o < a; o++)this.cone.material[o].color.set(s1);
            else this.cone.material.color.set(s1);
        }
    }
}, yg = Rb;
yg._vector = new E;
var Kf = class extends cn {
    constructor(){
        super();
        this.caretIndex = 0;
        this._caretVisibleAlpha = 1;
        this._selectionVisibleAlpha = .3;
        this.current = {
            start: 0,
            end: void 0
        };
        this.matrixAutoUpdate = !1, this.caretMesh = new Mt(new Si(1, 1), new un({
            transparent: !0,
            opacity: 0,
            side: vi
        })), this.add(this.caretMesh), this.selectionMesh = new Mt(new Si(1, 1), new un({
            color: 2857471,
            transparent: !0,
            depthTest: !1,
            depthWrite: !1,
            opacity: 0,
            side: vi
        })), this.add(this.selectionMesh), this.hide();
    }
    get caretHeight() {
        return this.object?.AD ?? 0;
    }
    show(e) {
        this.visible = !0, this.object = e, this.caretMesh.scale.set(1, this.caretHeight, 1), this.caretMesh.position.y = -this.caretHeight * .5, this.setCaretPosition(this.caretIndex), this.update();
    }
    hide() {
        this.visible = !1;
    }
    update() {
        if (this.object === void 0) return;
        this.updateHelperMatrix();
        let { depth: e } = this.object.geometry.userData.parameters;
        this.caretMesh.position.z = e, this.selectionMesh.position.z = e;
    }
    updateHelperMatrix() {
        if (this.object === void 0) return;
        let e = this.object, r = e.parent;
        r !== null && r.updateWorldMatrix(!0, !1), e.matrixAutoUpdate && e.updateMatrix(), r !== null ? (this.matrixWorld.multiplyMatrices(r.matrixWorld, e.hiddenMatrix), this.matrixWorld.multiplyMatrices(this.matrixWorld, e.matrix)) : this.matrixWorld.multiplyMatrices(e.hiddenMatrix, e.matrix), this.matrix.copy(this.matrixWorld);
        for (let i of this.children)i.matrixWorld.copy(this.matrixWorld);
        e.updateWorldMatrix(!0, !0);
    }
    setCaretColor(e) {
        let r = this.caretMesh.material;
        r.color.setRGB(e.r, e.g, e.b);
        let i = this._caretVisibleAlpha === r.opacity;
        this._caretVisibleAlpha = e.a, i && (r.opacity = this._caretVisibleAlpha);
    }
    setSelectionColor(e) {
        this.selectionMesh.material.color.setRGB(e.r, e.g, e.b);
    }
    setCaretPosition(e, r = {}) {
        if (this.object === void 0) return;
        this.caretIndex = e;
        let i = this.object.wrappedText, [s1, o] = Lb(i, e), [a, l] = e > 0 ? Lb(i, e - 1) : [
            null,
            null
        ];
        (e > 0 && i.length ? i[a].charAt(l) : null) === `
` && (s1++, o = 0), this.current.start = e, this.current.end = void 0;
        let [u1, h] = sM(this.object, s1, o), { AD: d, descender: f } = this.object, m = f + d * .5, { width: p, height: g, depth: y } = this.object.geometry.userData.parameters, x = typeof p == "string" ? 0 : p, v = typeof g == "string" ? 0 : g;
        this.caretMesh.scale.set(1, this.caretHeight, 1), this.caretMesh.position.set(u1 - x * .5, h + m + v * .5, y), this.hideSelectionMesh(), this.showCaretMesh();
    }
    setSelection(e, r) {
        if (this.object === void 0) return;
        let i = this.object.wrappedText;
        this.current.start = e, this.current.end = r;
        let s1 = [], o = [], a = X$(i, e, r), { lineHeight: l, AD: c, descender: u1 } = this.object, h = u1 + c * .5 - l * .5;
        for (let [x, v, b] of a)if (v !== b) {
            let [w, A] = sM(this.object, x, v), [T, S] = sM(this.object, x, b);
            A += h, S += h, S += l;
            let M = s1.length / 3;
            s1.push(w, A, 0), s1.push(T, A, 0), s1.push(T, S, 0), s1.push(w, S, 0), o.push(M + 0, M + 1, M + 2), o.push(M + 2, M + 3, M + 0);
        }
        let d = new Ce;
        d.setIndex(o), d.setAttribute("position", new Te(s1, 3));
        let { width: f, height: m, depth: p } = this.object.geometry.userData.parameters, g = typeof f == "string" ? 0 : f, y = typeof m == "string" ? 0 : m;
        this.selectionMesh.geometry.dispose(), this.selectionMesh.geometry = d, this.selectionMesh.position.x = -g * .5, this.selectionMesh.position.y = y * .5, this.selectionMesh.position.z = p, this.showSelectionMesh(), this.hideCaretMesh();
    }
    getSelectionFromPosition(e, r, i = "previous") {
        if (this.object === void 0 || this.object.font === void 0) return;
        let s1 = this.object.wrappedText, o = s1.length, a = this.object.lineHeight, l = o * a, { height: c, verticalAlign: u1 } = this.object.geometry.userData.parameters, h = typeof c == "string" ? 0 : c, d = 0;
        u1 === 3 ? d = h - l : u1 === 2 && (d = h * .5 - l * .5);
        let f = Math.min(Math.floor(Math.max(Math.min(-r - d, l), 0) / a), o - 1), m = this.object.charCoords[f], p = this.object.charWidths[f], g = 0, y = !1;
        if (i === "previous") {
            for(let v = 0; v < m.length; v++)if (m[v][0] + p[v] * .5 - e > 0) {
                g = v, y = !0;
                break;
            }
        } else if (i === "closest") {
            let v = 1 / 0;
            for(let b = 0; b < m.length; b++){
                let w = m[b][0] + p[b] * .5, A = Math.abs(w - e);
                A < v && (v = A, g = b, y = !0);
            }
        } else for(let v = 0; v < m.length; v++){
            let b = m[v][0], w = m[v][0] + p[v];
            if (e >= b && e < w) {
                g = v, y = !0;
                break;
            }
        }
        return y || (g = m.length), {
            index: this.getGlobalIndexFromLineAndCharIndexes(s1, f, g),
            lineIndex: f,
            characterIndex: g
        };
    }
    getGlobalIndexFromLineAndCharIndexes(e, r, i) {
        return e.slice(0, r).reduce((s1, o)=>s1 += o.length, 0) + i;
    }
    showSelectionMesh() {
        this.selectionMesh.material.opacity = this._selectionVisibleAlpha;
    }
    hideSelectionMesh() {
        this.selectionMesh.material.opacity = 0;
    }
    showCaretMesh() {
        this.caretMesh.material.opacity = this._caretVisibleAlpha;
    }
    hideCaretMesh() {
        this.caretMesh.material.opacity = 0;
    }
};
function sM(n1, t, e) {
    let { charCoords: r, charWidths: i, initialOffsetY: s1, lineHeight: o } = n1;
    if (r[t] && r[t].length === 0 || r.length === 0) {
        let u1 = 0, { horizontalAlign: h } = n1.data.geometry, d = n1.wrappedText, { width: f } = n1.geometry.userData.parameters;
        return d.length === 1 && d[0].length === 0 && (h === 3 ? u1 = f * .5 : h === 2 && (u1 = f)), [
            u1,
            s1 - o * t
        ];
    }
    let a = r[t];
    if (a === void 0 || a.length === 0) return [
        0,
        0
    ];
    let [l, c] = a[Math.min(e, a.length - 1)];
    return e >= a.length && (l += i[t][e - 1]), [
        l,
        c
    ];
}
function Lb(n1, t) {
    let e = 0;
    for(let r = 0; r < n1.length; r++){
        let i = n1[r], s1 = t - e;
        if (s1 <= i.length) return [
            r,
            s1
        ];
        e += i.length;
    }
    return [
        Math.max(0, n1.length - 1),
        n1[n1.length - 1]?.length ?? 0
    ];
}
function X$(n1, t, e) {
    let [r, i] = Lb(n1, t), [s1, o] = Lb(n1, e), a = [];
    i >= n1[r].length && (r++, i = 0);
    for(let l = r; l <= s1; l++){
        let c = n1[l], u1 = l === r ? i : 0, h = l === s1 ? o : c.length;
        a.push([
            l,
            u1,
            h
        ]);
    }
    return a;
}
function uB(n1, t) {
    let e = Fr.fromHex(3223857), r = .8;
    for (let i of n1.layers){
        if (i.data.type === "light" || i.data.type === "displace" || i.data.type === "fresnel" || i.data.type === "matcap" || i.data.type === "texture" || i.data.type === "toon" || i.data.type === "outline" || i.data.type === "transmission" || i.data.type === "noise") continue;
        let s1 = typeof i.data.alpha == "string" ? Number(t.getVariable(i.data.alpha)) : i.data.alpha;
        if (i.data.type === "color" && s1 > .3) {
            e = Y$(i.data.color, t), r = s1;
            break;
        } else if ((i.data.type === "depth" || i.data.type === "gradient") && s1 > .3) {
            let o = K$(i.data);
            e = {
                r: o[0],
                g: o[1],
                b: o[2]
            }, r = typeof i.data.alpha == "string" ? 1 : i.data.alpha;
            break;
        }
    }
    return {
        ...e,
        a: r
    };
}
function Y$(n1, t) {
    return typeof n1 == "string" ? t.data.colors[n1] : n1;
}
function K$(n1) {
    return n1.colors[0];
}
function Q$(n1, t) {
    n1.shadow.camera.right = t / 2, n1.shadow.camera.left = -t / 2, n1.shadow.camera.top = t / 2, n1.shadow.camera.bottom = -t / 2, n1.shadow.needsUpdate = !0;
}
var Ho = class extends Rf(rv, Xf) {
    constructor(t, e, r){
        super(), this.super_Entity(t, e), this.castShadow = !0, this.shadow.mapSize.width = 2048, this.shadow.mapSize.height = 2048, this.shadow.normalBias = 1, this.layers.enable(3);
        let s1 = this.shadow.camera;
        s1.top = 1250, s1.bottom = -1250, s1.right = 1250, s1.left = -1250, s1.near = -10000, s1.far = 2500;
        let o = new _l(this.shadow.camera);
        o.visible = !1, this.gizmos.shadowmap = o;
    }
    update() {
        this.shadow.camera.updateProjectionMatrix();
        for(let t in this.gizmos){
            let e = this.gizmos[t];
            e instanceof _l && e.update();
        }
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), this.objectHelper && this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Light(t, e);
        let r = t.depth !== void 0 && t.depth !== this.shadow.camera.far || t.size !== void 0 && t.size / 2 !== this.shadow.camera.right;
        t.size !== void 0 && Q$(this, t.size), t.shadowRadius !== void 0 && (this.shadow.radius = t.shadowRadius), t.shadowResolution !== void 0 && (this.shadow.mapSize.set(t.shadowResolution, t.shadowResolution), this.shadow.map && (this.shadow.map.dispose(), this.shadow.map = null)), t.penumbraSize !== void 0 && e.scene.markPenumbraSizeDirty(), r && this.update();
    }
};
var hB = new E, dB = new E, fB = new Ye, Wo = class extends Rf(ev, yg) {
    constructor(t, e, r){
        super(), this.super_Entity(t, e), this.castShadow = !0, this.shadow.mapSize.width = 1024, this.shadow.mapSize.height = 1024, this.shadow.normalBias = 1, this.layers.enable(3);
        let s1 = this.shadow.camera;
        s1.fov = Se.RAD2DEG * 2 * this.angle, s1.aspect = 1, s1.near = 100, s1.far = 2500;
        let o = new _l(this.shadow.camera);
        o.visible = !1, this.gizmos.shadowmap = o, this.update();
    }
    update() {
        this.shadow.camera.updateProjectionMatrix();
        for(let t in this.gizmos){
            let e = this.gizmos[t];
            e instanceof _l && e.update();
        }
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), dB.setFromMatrixPosition(this.matrixWorld), fB.setFromRotationMatrix(this.matrixWorld), hB.copy(this.up).applyQuaternion(fB).negate().multiplyScalar(this.distance), this.target.position.copy(dB).add(hB), this.target.updateMatrixWorld(), this.objectHelper && this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Light(t, e), t.distance !== void 0 && (this.distance = t.distance), t.decay !== void 0 && (this.decay = t.decay), t.angle !== void 0 && (this.angle = t.angle), t.penumbra !== void 0 && (this.penumbra = t.penumbra), t.shadowRadius !== void 0 && (this.shadow.radius = t.shadowRadius), t.penumbraSize !== void 0 && e.scene.markPenumbraSizeDirty(), t.shadowResolution !== void 0 && (this.shadow.mapSize.set(t.shadowResolution, t.shadowResolution), this.shadow.map && (this.shadow.map.dispose(), this.shadow.map = null));
    }
};
function Z$(n1) {
    let t = (n1[0][0] + n1[1][1]) / 2, e = (n1[0][0] - n1[1][1]) / 2, r = (n1[1][0] + n1[0][1]) / 2, i = (n1[1][0] - n1[0][1]) / 2, s1 = Math.sqrt(t * t + i * i), o = Math.sqrt(e * e + r * r), a = s1 + o, l = s1 - o, c = Math.atan2(r, e), u1 = Math.atan2(i, t), h = (u1 - c) / 2, d = (u1 + c) / 2, f = [
        [
            Math.cos(d),
            Math.sin(d)
        ],
        [
            -Math.sin(d),
            Math.cos(d)
        ]
    ], m = [
        [
            a,
            0
        ],
        [
            0,
            l
        ]
    ], p = [
        [
            Math.cos(h),
            Math.sin(h)
        ],
        [
            -Math.sin(h),
            Math.cos(h)
        ]
    ];
    return f[0][0] *= -1, f[0][1] *= -1, p[0][0] *= -1, p[1][0] *= -1, [
        f,
        m,
        p
    ];
}
function Nb(n1, t) {
    return [
        [
            n1[0][0] * t[0][0] + n1[0][1] * t[1][0],
            n1[0][0] * t[0][1] + n1[0][1] * t[1][1]
        ],
        [
            n1[1][0] * t[0][0] + n1[1][1] * t[1][0],
            n1[1][0] * t[0][1] + n1[1][1] * t[1][1]
        ]
    ];
}
function pB(n1) {
    return [
        [
            n1[0][0],
            n1[1][0]
        ],
        [
            n1[0][1],
            n1[1][1]
        ]
    ];
}
function mB(n1) {
    let [t, e, r] = Z$(n1), i = Nb(t, pB(r)), s1 = Nb(Nb(r, e), pB(r)), o = Math.atan2(i[1][0], i[0][0]), a = [
        s1[0][0],
        s1[1][1]
    ], l = [
        s1[0][1] / s1[1][1],
        s1[1][0] / s1[0][0]
    ];
    return {
        rotation: o,
        scale: a,
        shear: l
    };
}
function gB({ rotation: n1, scale: t, shear: e }) {
    let r = Math.cos(n1), i = Math.sin(n1), s1 = [
        [
            r,
            -i
        ],
        [
            i,
            r
        ]
    ], o = [
        [
            t[0],
            e[0] * t[1]
        ],
        [
            e[1] * t[0],
            t[1]
        ]
    ], a = Nb(s1, o);
    return [
        a[0][0],
        a[1][0],
        a[0][1],
        a[1][1]
    ];
}
var Pt;
((w)=>{
    function n1() {
        return [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
    }
    w.identity = n1;
    function t(A, T = w.identity()) {
        for(let S = 0, M = A.length; S < M; S++)T[S] = A[S];
        return T;
    }
    w.copy = t;
    function e(A, T, S, M, C, P) {
        return w.setAbcdef(w.identity(), A, T, S, M, C, P);
    }
    w.create = e;
    function r(A, T, S, M, C, P, _) {
        return A[0] = T, A[1] = M, A[2] = P, A[3] = S, A[4] = C, A[5] = _, A;
    }
    w.setAbcdef = r;
    function i(A, T) {
        let [S, M, C, P, _, I] = o(A), [O, L, j, V, H, q] = o(T), X = O * S + L * C, K = O * M + L * P, z = j * S + V * C, Q = j * M + V * P, te = H * S + q * C + _, $ = H * M + q * P + I;
        return w.create(X, K, z, Q, te, $);
    }
    w.append = i;
    function s1(A, T) {
        let [S, M, C, P, _, I] = o(A), [O, L, j, V, H, q] = o(T), X = S, K = M, z = C, Q = P;
        (O !== 1 || L !== 0 || j !== 0 || V !== 1) && (X = S * O + M * j, K = S * L + M * V, z = C * O + P * j, Q = C * L + P * V);
        let te = _ * O + I * j + H, $ = _ * L + I * V + q;
        return w.create(X, K, z, Q, te, $);
    }
    w.prepend = s1;
    function o(A) {
        return [
            A[0],
            A[3],
            A[1],
            A[4],
            A[2],
            A[5]
        ];
    }
    w.getAbcdef = o;
    function a(A) {
        let [T, S, M, C, P, _] = w.getAbcdef(A), I = T * C - S * M, O = C / I, L = -S / I, j = -M / I, V = T / I, H = (M * _ - C * P) / I, q = -(T * _ - S * P) / I;
        return w.create(O, L, j, V, H, q);
    }
    w.invert = a;
    function l([A, T], S) {
        let [M, C, P, _, I, O] = w.getAbcdef(S);
        return [
            M * A + P * T + I,
            C * A + _ * T + O
        ];
    }
    w.apply = l;
    function c(A, T) {
        let [S, M, C, P, _, I] = w.getAbcdef(T), O = 1 / (S * P + C * -M), [L, j] = A;
        return [
            P * O * L + -C * O * j + (I * C - _ * P) * O,
            S * O * j + -M * O * L + (-I * S + _ * M) * O
        ];
    }
    w.applyInverse = c;
    function u1(A, T, S = T) {
        let [M, C, P, _, I, O] = w.getAbcdef(A);
        return w.setAbcdef(A, M * T, C * S, P * T, _ * S, I * T, O * S), A;
    }
    w.scale = u1;
    function h(A, T) {
        let S = Math.cos(T), M = Math.sin(T), [C, P, _, I, O, L] = w.getAbcdef(A);
        return w.setAbcdef(A, C * S - P * M, C * M + P * S, _ * S - I * M, _ * M + I * S, O * S - L * M, O * M + L * S), A;
    }
    w.rotate = h;
    function d(A, T, S) {
        let [M, C] = S, P = w.translate(A, -M, -C);
        return P = w.rotate(P, T), P = w.translate(P, M, C), P;
    }
    w.rotateAround = d;
    function f(A, T, S) {
        let [M, C, P, _, I, O] = w.getAbcdef(A);
        return w.setAbcdef(A, M, C, P, _, I + T, O + S), A;
    }
    w.translate = f;
    function m(A, T, S) {
        let [M, C, P, _] = w.getAbcdef(A);
        return w.setAbcdef(A, M, C, P, _, T, S), A;
    }
    w.setTranslate = m;
    function p(A, T, S) {
        let [M, C, P, _] = w.getAbcdef(A);
        return w.setAbcdef(A, M, C, P, _, T, S), A;
    }
    w.setPosition = p;
    function g(A) {
        let [T, S, M, C] = w.getAbcdef(A), P = Math.sqrt(T * T + S * S), _ = Math.sqrt(M * M + C * C);
        return [
            P,
            _
        ];
    }
    w.getScale = g;
    function y(A) {
        let [, , , , T, S] = w.getAbcdef(A);
        return [
            T,
            S
        ];
    }
    w.getPosition = y;
    function x(A, T) {
        return w.decompose(A, T).rotation;
    }
    w.getRotation = x;
    function v(A, T) {
        let [S, M, C, P, _, I] = w.getAbcdef(A), { rotation: O, scale: L, shear: j } = mB([
            [
                S,
                C
            ],
            [
                M,
                P
            ]
        ]);
        return {
            position: [
                _ + (T[0] * S + T[1] * C) - T[0],
                I + (T[0] * M + T[1] * P) - T[1]
            ],
            scale: L,
            rotation: O,
            shear: j,
            pivot: T
        };
    }
    w.decompose = v;
    function b(A, T, S, M, C = [
        0,
        0
    ]) {
        let [P, _] = A, [I, O] = M, [L, j, V, H] = gB({
            rotation: S,
            scale: T,
            shear: C
        }), q = P - (I * L + O * V) + I, X = _ - (I * j + O * H) + O;
        return w.create(L, j, V, H, q, X);
    }
    w.compose = b;
})(Pt || (Pt = {}));
var J$ = Math.PI / 180, uUe = 180 / Math.PI;
function yB(n1, t, e, r, i, s1) {
    let o = n1 - e, a = t - r;
    return o * o / (i * i) + a * a / (s1 * s1) <= 1;
}
function vB(n1) {
    return n1 * J$;
}
var hr = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.localMatrix = Pt.identity();
        this.worldMatrix = Pt.identity();
        this.ignoreCameraZoom = !1;
        this.visible = !0;
        this._singleBBox = new pc;
        this._recursiveBBox = new pc;
        this.singleBBoxNeedsUpdate = !0;
        this.recursiveBBoxNeedsUpdate = !0;
        this.stateSelection = null;
        this.prevState = null;
        this.currentState = null;
        this.reversibleToState = null;
        this.currentTransitionEvent = null;
        this.previousAction = null;
        this.name = "";
        this.position = [
            0,
            0
        ];
        this.scale = [
            1,
            1
        ];
        this.rotation = 0;
        this.shear = [
            0,
            0
        ];
        this.emitter = Ya();
        this.dpr = r.dpr ?? 1, this.dataPatched = e;
    }
    project(t, e) {
        let r = this.worldMatrix;
        return e && (r = Pt.append(e.worldMatrix, r)), Pt.applyInverse(t, r);
    }
    intersects(t, e, r, i = !1) {
        return this.visible && !this.data.raycastLock && this.intersectsInLocalSpace(...this.project([
            t,
            e
        ], r), i);
    }
    intersectsInLocalSpace(t, e, r = !1) {
        let { min: i, max: s1 } = r ? this.recursiveBBox : this.singleBBox;
        return t >= i[0] && t <= s1[0] && e >= i[1] && e <= s1[1];
    }
    applyTransforms(t) {
        t.setTransform(this.worldMatrix, this.ignoreCameraZoom);
    }
    get singleBBox() {
        return this.singleBBoxNeedsUpdate && (this.singleBBoxNeedsUpdate = !1, this._singleBBox.setFromObjectSize(this, !1), this._singleBBox.computeVertices(), this._singleBBox.computeEdges()), this._singleBBox;
    }
    get recursiveBBox() {
        return this.recursiveBBoxNeedsUpdate && (this.recursiveBBoxNeedsUpdate = !1, this._recursiveBBox.setFromObjectSize(this, !0), this._recursiveBBox.computeVertices(), this._recursiveBBox.computeEdges()), this._recursiveBBox;
    }
    updateLocalMatrix() {
        this.localMatrix = Pt.compose(this.position, this.scale, vB(this.rotation), ja.getPivot(this.dataPatched), this.shear);
    }
    updateWorldMatrix(t, e, r) {
        let i = this.parent;
        e && i !== null && i !== void 0 && i.updateWorldMatrix(t, !0, !1), t && this.updateLocalMatrix(), this.parent ? this.worldMatrix = Pt.append(this.parent.worldMatrix, this.localMatrix) : this.worldMatrix = Pt.copy(this.localMatrix), this.singleBBoxNeedsUpdate = !0, this.recursiveBBoxNeedsUpdate = !0;
    }
    get pivot() {
        return ja.getPivot(this.data);
    }
    getCenter() {
        return [
            0,
            0
        ];
    }
    getHalfSize() {
        return [
            0,
            0
        ];
    }
    get id() {
        return this.uuid;
    }
    resetBBoxNeedsUpdateSelf() {
        this.singleBBoxNeedsUpdate = !0, this.recursiveBBoxNeedsUpdate = !0;
    }
    resetBBoxNeedsUpdate() {
        this.resetBBoxNeedsUpdateSelf(), this.traverseAncestors((t)=>{
            t.resetBBoxNeedsUpdateSelf();
        });
    }
    updateTransformState(t) {
        let e = !1;
        t.position !== void 0 && (e = !0, this.position = t.position), t.rotation !== void 0 && (e = !0, this.rotation = t.rotation), t.scale !== void 0 && (e = !0, this.scale = t.scale), t.shear !== void 0 && (e = !0, this.shear = t.shear), e && (this.updateWorldMatrix(!0, !1, !0), this.resetBBoxNeedsUpdate());
    }
    updateByOp(t, e, r) {
        t.type === 0 && t.props.visible !== void 0 && (this.visible = t.props.visible), this.data = e, this.data = e;
        let i = t, s1 = kt(t.path, [
            "states",
            "*"
        ]);
        if (s1 !== null) {
            if (t.type === 0) {
                let [o] = s1;
                if (this?.stateSelection === o) {
                    let a = {
                        ...t.props
                    };
                    if (delete a.name, Object.values(t.props).some((l)=>l === void 0)) {
                        let l = this.data;
                        if (l !== void 0) {
                            let c = Mr.zoom(l, t.path.slice(2));
                            if (c) for(let u1 in t.props)t.props[u1] === void 0 && u1 in c && (a[u1] = c[u1]);
                        }
                    }
                    i = {
                        ...t,
                        props: a,
                        path: t.path.slice(2)
                    };
                }
            }
        } else if (t.type === 0) {
            let o = this.stateSelection ? this.data.states.data(this.stateSelection) : void 0;
            if (o !== void 0) {
                if (t.props.name !== void 0 && o.name) {
                    let { name: l, ...c } = o;
                    o = c;
                }
                let a = Mr.removeOverridden(t.path, t.props, o);
                i = {
                    ...t,
                    props: a
                };
            }
        }
        this.updateByPatchedOpBase(i, Ga.patch(this.data, this.stateSelection ? this.data.states.data(this.stateSelection) : void 0), r);
    }
    changeSelectedState(t, e, r = !1) {
        if (!(this.data.states.length === 0 && !r)) {
            for (let i of this.data.states)Ga.toOps(this.data, i.data).forEach((o)=>{
                let a = rd.replaceProps(o, this.data);
                this.dataPatched = this.data, this.updateByPatchedOp(a, this.data, e);
            });
            if (t !== null) {
                let i = this.data.states.data(t);
                i && (this.dataPatched = Ga.patch(this.data, i), Ga.toOps(this.data, i).forEach((o)=>{
                    this.updateByPatchedOp(o, this.dataPatched, e);
                }));
            }
            r && this.updateTransformState(this.dataPatched), this.stateSelection = t;
        }
    }
    updateState(t, e) {
        t.name !== void 0 && (this.name = t.name), t.visible !== void 0 && (this.visible = t.visible), this.updateTransformState(t);
    }
    updateByPatchedOpBase(t, e, r) {
        this.dataPatched = e, this.updateByPatchedOp(t, e, r);
    }
    updateByPatchedOp(t, e, r) {
        t.path.length === 0 && t.type === 0 && this.updateState(t.props, r), this.requestRender();
    }
    traverseFrameAncestors(t) {
        this.traverseAncestors((e)=>{
            e.data.type === "frame2d" && t(e);
        });
    }
    traverseAncestors(t) {
        let e = this.parent;
        for(; e;)t(e), e = e.parent;
    }
    requestRender() {
        this.traverseFrameAncestors((t)=>{
            t.requestRender();
        });
    }
    clone(t) {
        let e = new hr(this.uuid, this.data, t);
        return e.parent = void 0, e;
    }
    addEventListener(t, e) {
        this.emitter.on(t, e);
    }
    removeEventListener(t, e) {
        this.emitter.off(t, e);
    }
    dispatchEvent(t) {
        this.emitter.emit(t.type, {
            ...t,
            target: t.target ?? this
        });
    }
    traverseSortNextHelper() {
        let t = this.parent;
        if (t) {
            let e = t.children;
            if (e) {
                let r = e.indexOf(this) + 1;
                return e[r] ? e[r] : t.traverseSortNextHelper();
            }
        }
    }
    sortNext() {
        let t = this.children;
        return t && t.length > 0 && t[0] ? t[0] : this.traverseSortNextHelper();
    }
    isDescendantOf(t) {
        t instanceof hr && (t = t.uuid);
        let e = this;
        for(; e.parent;){
            if (e.parent.uuid === t) return !0;
            e = e.parent;
        }
        return !1;
    }
};
var tn = class extends hr {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.context = i;
        this.children = [];
    }
    add(e) {
        e.parent && e.parent instanceof tn && e.parent.remove(e), this.children.push(e), e.parent = this;
    }
    remove(e) {
        let r = this.children.indexOf(e);
        r >= 0 && (this.children.splice(r, 1), e.parent = void 0);
    }
    traverse(e) {
        let r = e(this);
        if (r !== !0) for (let i of this.children)i instanceof tn ? i.traverse(e) : r = e(i);
    }
    intersectsChildrenHelper(e, r, i, s1, o) {
        for (let a of this.children)if (a.intersects(e, r, i, !1) && (o.push(a), s1) || a instanceof tn && a.intersectsChildrenHelper(e, r, i, s1, o)) return !0;
        return !1;
    }
    intersectsChildren(e, r, i, s1 = !1, o = [], a = !1) {
        return this.intersectsChildrenHelper(e, r, i, s1, o), o;
    }
    intersectsChildrenHelperReverse(e, r, i, s1, o) {
        for (let a of this.children)if (a instanceof tn && a.intersectsChildrenHelperReverse(e, r, i, s1, o) || a.intersects(e, r, i, !1) && (o.push(a), s1)) return !0;
        return !1;
    }
    intersectsChildrenReverse(e, r, i, s1 = !1, o = [], a = !1) {
        return this.intersectsChildrenHelperReverse(e, r, i, s1, o), o;
    }
    updateWorldMatrix(e, r, i) {
        if (super.updateWorldMatrix(e, r, i), i && this.children) for (let s1 of this.children)s1.updateWorldMatrix(e, !1, !0);
    }
    find(e) {
        let r;
        return this.traverse((i)=>{
            i.uuid === e && (r = i);
        }), r;
    }
    innerDrawChildren(e) {
        for(let r = this.children.length - 1; r >= 0; r--)this.children[r].draw(e);
    }
    resetBBoxNeedsUpdate() {
        super.resetBBoxNeedsUpdate(), this.traverse((e)=>{
            e.resetBBoxNeedsUpdateSelf();
        });
    }
    clone(e) {
        let r = new tn(this.uuid, this.data, e);
        r.parent = void 0;
        for (let i of this.children)r.add(i.clone(e));
        return r;
    }
}, Xn = class extends tn {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.updateState(r, i);
    }
    draw(e) {
        !this.visible || (e.save(), this.applyTransforms(e), this.innerDrawChildren(e), e.restore());
    }
    clone(e) {
        let r = new Xn(this.uuid, this.data, e);
        r.parent = void 0;
        for (let i of this.children)r.add(i.clone(e));
        return r;
    }
};
function $$(n1, t) {
    let [[e, r], [i, s1]] = n1, [[o, a], [l, c]] = t, u1 = (e - i) * (a - c) - (r - s1) * (o - l);
    if (u1 === 0) return !1;
    let h = ((e - o) * (a - c) - (r - a) * (o - l)) / u1, d = -((e - i) * (r - a) - (r - s1) * (e - o)) / u1;
    return h >= 0 && h <= 1 && d >= 0 && d <= 1;
}
var bB = [
    [
        -1,
        1
    ],
    [
        -1,
        -1
    ],
    [
        1,
        -1
    ],
    [
        1,
        1
    ]
], xB = (n1, t, e)=>{
    let r = n1.getCenter(), i = n1.getHalfSize(), s1 = Pt.append(t, n1.worldMatrix);
    i[0] === 0 && i[1] === 0 ? e.push(Pt.apply(r, s1)) : bB.forEach((o)=>{
        let a = [
            o[0] * i[0] + r[0],
            o[1] * i[1] + r[1]
        ];
        e.push(Pt.apply(a, s1));
    });
}, pc = class {
    constructor(){
        this.matrix = Pt.identity();
        this.min = [
            1 / 0,
            1 / 0
        ];
        this.max = [
            -1 / 0,
            -1 / 0
        ];
        this.vertices = [];
        this.edges = [];
    }
    setFromObjectSize(t, e = !1) {
        t.updateWorldMatrix(), this.makeEmpty(), Pt.copy(t.worldMatrix, this.matrix);
        let r = Pt.invert(t.worldMatrix);
        this.expandByObjectSize(t, r, e);
    }
    expandByObjectSize(t, e, r = !1) {
        let i = [];
        r === !0 && t instanceof tn ? t.traverse((s1)=>{
            s1.visible && xB(s1, e, i);
        }) : xB(t, e, i), this.setFromPoints(i);
    }
    setFromSize(t, e, r) {
        this.makeEmpty(), Pt.copy(r, this.matrix), this.expandBySize(t, e, r);
    }
    expandBySize(t, e, r) {
        [
            Pt.apply([
                0,
                0
            ], r),
            Pt.apply([
                0,
                e
            ], r),
            Pt.apply([
                t,
                e
            ], r),
            Pt.apply([
                t,
                0
            ], r)
        ].forEach((s1)=>this.expandByPoint(s1));
    }
    getCenter() {
        let [t, e] = this.min, [r, i] = this.getHalfSize();
        return Pt.apply([
            t + r,
            e + i
        ], this.matrix);
    }
    getSize() {
        return [
            this.max[0] - this.min[0],
            this.max[1] - this.min[1]
        ];
    }
    getHalfSize() {
        return [
            (this.max[0] - this.min[0]) * .5,
            (this.max[1] - this.min[1]) * .5
        ];
    }
    makeEmpty() {
        this.min = [
            1 / 0,
            1 / 0
        ], this.max = [
            -1 / 0,
            -1 / 0
        ];
    }
    setFromPoints(t) {
        this.makeEmpty();
        for (let e of t)this.expandByPoint(e);
    }
    expandByPoint(t) {
        this.min = [
            Math.min(this.min[0], t[0]),
            Math.min(this.min[1], t[1])
        ], this.max = [
            Math.max(this.max[0], t[0]),
            Math.max(this.max[1], t[1])
        ];
    }
    computeVertices() {
        let [t, e] = this.getHalfSize(), r = this.getCenter(), [i, s1, o, a] = Pt.getAbcdef(this.matrix), l = Pt.create(i, s1, o, a, r[0], r[1]);
        this.vertices = bB.map(([c, u1])=>Pt.apply([
                c * t,
                u1 * e
            ], l));
    }
    computeEdges() {
        this.edges = [];
        for(let t = 0, e = this.vertices.length; t < e; ++t)this.edges.push([
            this.vertices[t],
            this.vertices[(t + 1) % e]
        ]);
    }
    project(t, e) {
        let r = this.matrix;
        return e && (r = Pt.append(e.worldMatrix, r)), Pt.applyInverse(t, r);
    }
    intersects(t, e, r) {
        return this.intersectsInLocalSpace(...this.project([
            t,
            e
        ], r));
    }
    intersectsInLocalSpace(t, e) {
        let { min: r, max: i } = this;
        return t >= r[0] && t <= i[0] && e >= r[1] && e <= i[1];
    }
    containsPoint(t) {
        let [e, r] = t, [i, s1] = this.min, [o, a] = this.max;
        return e >= i && e <= o && r >= s1 && r <= a;
    }
    intersectsBBox2D(t) {
        for(let e = 0, r = this.edges.length; e < r; e++){
            let i = this.edges[e];
            for(let s1 = 0, o = t.edges.length; s1 < o; s1++){
                let a = t.edges[s1];
                if ($$(i, a)) return !0;
            }
        }
        for(let e = 0, r = t.vertices.length; e < r; e++){
            let i = t.vertices[e];
            if (this.containsPoint(i)) return !0;
        }
        return !1;
    }
    ensureMinMax() {
        let t = this.min, e = this.max;
        this.min = [
            Math.min(t[0], e[0]),
            Math.min(t[1], e[1])
        ], this.max = [
            Math.max(t[0], e[0]),
            Math.max(t[1], e[1])
        ];
    }
    copy(t) {
        this.min = [
            ...t.min
        ], this.max = [
            ...t.max
        ], Pt.copy(t.matrix, this.matrix), this.computeVertices(), this.computeEdges();
    }
    clone() {
        let t = new pc;
        return t.copy(this), t;
    }
};
var wB, AB = new Promise((n1)=>{
    wB = n1;
}), SB = !1;
var Bb;

function EB() {
    if (SB) return;
    if (Bb) return Bb;
    async function n1() {
        let e = await (parcelRequire("836Xp"));
        wB(e.default ?? e), SB = !0;
    }
    return Bb = n1(), Bb;
}
function aM(n1) {
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        (r.type === "Mesh" && r.geometry.type === "UIGeometry" || r.type === "Page" && r.uiFrame !== void 0) && (t = !0);
    }), t;
}
var yt, oM;
async function eee(n1) {
    let t = await AB;
    yt || (oM || (oM = t({
        locateFile: ()=>n1
    })), yt = await oM);
}
var TB = Pt.identity(), vg = class {
    constructor(t, e = 1){
        this.canvas = t;
        this._dpr = e;
        this._width = 0;
        this._height = 0;
        this._strokeMode = "inside";
        this._layerBlur = 0;
        this._backgroundBlur = 0;
        this._dropShadowBlur = 0;
        this._dropShadowOffsetX = 0;
        this._dropShadowOffsetY = 0;
        this._dropShadowColor = At.transparent;
        this._innerShadowBlur = 0;
        this._innerShadowOffsetX = 0;
        this._innerShadowOffsetY = 0;
        this._innerShadowSpread = 0;
        this._innerShadowColor = At.transparent;
        this._fonts = new Map;
        this._isSizeDirty = !1;
        try {
            let r = t.getBoundingClientRect();
            t.width = r.width * e, t.height = r.height * e;
        } catch  {
            console.log(t.width, e);
        }
        this._currentM3Transform = TB, this._currentTransform = new Float32Array(TB);
    }
    get dpr() {
        return this._dpr;
    }
    set dpr(t) {
        this._dpr = t, this._isSizeDirty = !0;
    }
    async init() {
        if (!this.wasmURL) throw Error("Your must set the wasm binary url with renderer.wasmURL = ... before you can call renderer.init");
        await eee(this.wasmURL), this._surface = yt.MakeWebGLCanvasSurface(this.canvas), this.ctx = this._surface?.getCanvas(), this._paint = new yt.Paint, this._paint.setAntiAlias(!0), this._paintFill = this._paint.copy(), this._paintFill.setStyle(yt.PaintStyle.Fill), this._paintStroke = this._paint.copy(), this._paintStroke.setStyle(yt.PaintStyle.Stroke), this.ctx?.scale(this.dpr, this.dpr);
    }
    get currentTransform() {
        return this._currentM3Transform;
    }
    get currentTransformBuffer() {
        return this._currentTransform;
    }
    set currentTransform(t) {
        this._currentM3Transform = t, this._currentTransform.set(t);
    }
    async loadFont(t, e) {
        let r = await (await fetch(t)).arrayBuffer();
        this.registerFont(r, e);
    }
    registerFont(t, e) {
        if (this._fonts.has(e)) return;
        let r = yt.FontMgr.FromData(t);
        if (r) this._fonts.set(e, r);
        else throw new Error("Invalid font data for " + e);
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    set strokeColor(t) {
        this._paintStroke && this._paintStroke.setColor(Fb(t), yt.ColorSpace.DISPLAY_P3);
    }
    set fillColor(t) {
        this._paintFill && this._paintFill.setColor(Fb(t), yt.ColorSpace.DISPLAY_P3);
    }
    set lineWidth(t) {
        this._paintStroke && this._paintStroke.setStrokeWidth(this._strokeMode === "center" ? t : t * 2);
    }
    set strokeMode(t) {
        this._strokeMode = t;
    }
    set dropShadowBlur(t) {
        this._dropShadowBlur = t;
    }
    set dropShadowColor(t) {
        this._dropShadowColor = t;
    }
    set dropShadowOffsetX(t) {
        this._dropShadowOffsetX = t;
    }
    set dropShadowOffsetY(t) {
        this._dropShadowOffsetY = t;
    }
    set innerShadowBlur(t) {
        this._innerShadowBlur = t;
    }
    set innerShadowColor(t) {
        this._innerShadowColor = t;
    }
    set innerShadowOffsetX(t) {
        this._innerShadowOffsetX = t;
    }
    set innerShadowOffsetY(t) {
        this._innerShadowOffsetY = t;
    }
    set innerShadowSpread(t) {
        this._innerShadowSpread = t;
    }
    set layerBlur(t) {
        this._layerBlur = t;
    }
    set backgroundBlur(t) {
        this._backgroundBlur = t;
    }
    clear() {
        this.ctx?.clear(yt.TRANSPARENT);
    }
    save() {
        this.ctx?.save();
    }
    restore() {
        this.ctx?.restore();
    }
    beginPath() {
        this._currentPath?.delete(), this._currentPath = new yt.Path;
    }
    closePath() {
        let t = this._currentPath;
        if (t) {
            if (t.isEmpty()) return;
            let e = t.getBounds();
            (e[3] - e[1] || e[2] - e[0]) && t.close();
        }
    }
    fill() {
        this._paintInner(this._paintFill, !0);
    }
    stroke() {
        this._paintInner(this._paintStroke, !1);
    }
    clipRect(t, e, r, i, s1 = 0, o = 0, a = 0, l = 0) {
        let c = yt.XYWHRect(t, e, r, i);
        if (s1 === 0 && o === 0 && l === 0 && a === 0) this.ctx?.clipRect(c, yt.ClipOp.Intersect, !0);
        else {
            let u1 = yt.RRectXY(c, s1, s1);
            u1[4] = u1[5] = s1, u1[6] = u1[7] = o, u1[8] = u1[9] = a, u1[10] = u1[11] = l, this.ctx?.clipRRect(u1, yt.ClipOp.Intersect, !0);
        }
    }
    _applyShadowOffsetMatrix() {
        if (this.ctx) {
            let t = Pt.invert(this.currentTransform);
            this.ctx.concat(t);
            let e = Pt.translate(Pt.identity(), this._dropShadowOffsetX, this._dropShadowOffsetY);
            this.ctx.concat(e), this.ctx.concat(this._currentTransform);
        }
    }
    _applyEffectsToPaint(t, e, r = !0) {
        if (this.ctx && this._currentPath) {
            let i, s1 = !1;
            if (r && this._hasDropShadow()) {
                let o = t.copy();
                o.setColor(Fb(this._dropShadowColor));
                let a;
                this._dropShadowBlur > 0 && (a = yt.MaskFilter.MakeBlur(yt.BlurStyle.Normal, this._dropShadowBlur * this.dpr * (this.camera?.scale ?? 1), !1), o.setMaskFilter(a)), this.ctx.save(), this.ctx.clipPath(this._currentPath, yt.ClipOp.Difference, !0), this._applyShadowOffsetMatrix(), e(o), this.ctx.restore(), o.delete(), a?.delete();
            }
            if (this._backgroundBlur > 0 && r) {
                this.ctx.save(), this.ctx.clipPath(this._currentPath, yt.ClipOp.Intersect, !0);
                let o = yt.ImageFilter.MakeBlur(this._backgroundBlur, this._backgroundBlur, yt.TileMode.Clamp, null), a = t.copy();
                a.setImageFilter(o), a.setAlphaf(1);
                let l = this._currentPath.computeTightBounds();
                this.ctx.saveLayer(a, l, null, yt.SaveLayerInitWithPrevious), this.ctx.drawColor(t.getColor()), this.ctx.restore(), this.ctx.restore(), a.delete(), o.delete(), s1 = !0;
            }
            if (this._layerBlur > 0) {
                let o = t.copy();
                i = yt.MaskFilter.MakeBlur(yt.BlurStyle.Normal, this._layerBlur * this.dpr * (this.camera?.scale ?? 1), !1), o.setMaskFilter(i), e(o), o.delete(), i.delete(), s1 = !0;
            }
            if (s1 || e(t), r && this._hasInnerShadow()) {
                let o = new yt.Paint;
                o.setAntiAlias(!0), o.setStyle(yt.PaintStyle.Fill), o.setColor(Fb(this._innerShadowColor));
                let a;
                this._innerShadowBlur > 0 && (a = yt.MaskFilter.MakeBlur(yt.BlurStyle.Normal, this._innerShadowBlur * this.dpr * (this.camera?.scale ?? 1), !1), o.setMaskFilter(a));
                let l = this._currentPath.computeTightBounds(), [c, u1, h, d] = l, f = h - c, m = d - u1;
                this.ctx.save(), this.ctx.clipPath(this._currentPath, yt.ClipOp.Intersect, !0), this.ctx.saveLayer(o, l, null, yt.SaveLayerInitWithPrevious), this.ctx?.translate(this._innerShadowOffsetX, this._innerShadowOffsetY), this.ctx.drawRect(yt.XYWHRect(-1000 - this._innerShadowOffsetX, -1000 - this._innerShadowOffsetY, 2e3 + f + Math.abs(this._innerShadowOffsetX * 2), 2e3 + m + Math.abs(this._innerShadowOffsetY * 2)), o), o.setBlendMode(yt.BlendMode.Clear), this.ctx.drawPath(this._currentPath, o), this.ctx.restore(), this.ctx.restore(), o.delete(), a?.delete();
            }
        }
    }
    _paintInner(t, e = !0) {
        if (this.ctx && this._currentPath && t) {
            let r = this.ctx, i = this._currentPath;
            this._applyEffectsToPaint(t, (s1)=>{
                let o = !1;
                !e && this._strokeMode !== "center" && (r.save(), r.clipPath(i, this._strokeMode === "outside" ? yt.ClipOp.Difference : yt.ClipOp.Intersect, !0), o = !0), r.drawPath(i, s1), o && r.restore();
            }, e);
        }
    }
    _hasDropShadow() {
        return this._dropShadowColor?.a > 0;
    }
    _hasInnerShadow() {
        return this._innerShadowColor?.a > 0;
    }
    path(t) {
        this._currentPath?.addPath(yt.Path.MakeFromSVGString(t));
    }
    ellipse(t, e, r, i, s1, o, a, l) {
        if (!MB([
            t,
            e,
            r,
            i
        ]) || !this._currentPath) return;
        if (r < 0 || i < 0) throw Error("radii cannot be negative");
        let c = yt.XYWHRect(t - r, e - i, r * 2, i * 2);
        this._currentPath?.addOval(c);
    }
    rect(t, e, r, i, s1 = 0, o = 0, a = 0, l = 0) {
        let c = yt.XYWHRect(t, e, r, i);
        if (!!MB(c)) {
            if (s1 === 0 && o === 0 && l === 0 && a === 0) this._currentPath?.addRect(c);
            else {
                let u1 = yt.RRectXY(c, s1, s1);
                u1[4] = u1[5] = s1, u1[6] = u1[7] = o, u1[8] = u1[9] = a, u1[10] = u1[11] = l, this._currentPath?.addRRect(u1);
            }
        }
    }
    getHorizontalAlign(t) {
        switch(t){
            case 2:
                return yt.TextAlign.Right;
            case 3:
                return yt.TextAlign.Center;
            case 4:
                return yt.TextAlign.Justify;
            case 1:
            default:
                return yt.TextAlign.Left;
        }
    }
    drawTextInner(t, e, r, [i, s1, o, a], l, c, u1 = !0) {
        let h = 0, { ctx: d } = this;
        if (!d) return h;
        let f = c.copy(), m = c.copy();
        return m.setAlphaf(0), this._applyEffectsToPaint(f, (p)=>{
            e.pushPaintStyle(r, p, m), e.addText(t);
            let g = e.build();
            g.layout(o);
            let y = s1;
            l === 2 ? y += (a - g.getHeight()) / 2 : l === 3 && (y += a - g.getHeight()), d.drawParagraph(g, i, y), h = g.getHeight(), e.reset(), g.delete();
        }, u1), f.delete(), m.delete(), h;
    }
    drawText(t, e) {
        let r = 0, i = this._fonts.get(e.font), { ctx: s1, _paintFill: o, _paintStroke: a } = this;
        if (i && s1) {
            let l = new yt.TextStyle({
                fontFamilies: [
                    e.font
                ],
                fontSize: e.fontSize,
                heightMultiplier: e.lineHeight,
                letterSpacing: e.letterSpacing
            }), c = new yt.ParagraphStyle({
                textStyle: l,
                textAlign: this.getHorizontalAlign(e.horizontalAlign)
            }), u1 = yt.XYWHRect(e.x, e.y, e.width, e.height), h = yt.ParagraphBuilder.Make(c, i);
            o && (r = this.drawTextInner(t, h, l, u1, e.verticalAlign, o, !0)), a && (r = this.drawTextInner(t, h, l, u1, e.verticalAlign, a, !1)), h.delete();
        }
        return {
            height: r
        };
    }
    render() {
        this._surface?.flush();
    }
    moveTo(t, e) {
        this._currentPath?.moveTo(t, e);
    }
    lineTo(t, e) {
        this._currentPath?.lineTo(t, e);
    }
    bezierCurveTo(t, e, r, i, s1, o) {
        this._currentPath?.cubicTo(t, e, r, i, s1, o);
    }
    quadraticCurveTo(t, e, r, i) {
        this._currentPath?.quadTo(t, e, r, i);
    }
    setTransform(t, e = !1) {
        if (!this.ctx) return;
        let r = this.ctx.getTotalMatrix(), i = Pt.invert(r);
        if (i && this.ctx.concat(i), this.ctx?.scale(this.dpr, this.dpr), this.camera?.enabled && (this.ctx?.concat(this.camera.worldMatrix), e)) {
            let s1 = Pt.getScale(this.camera.worldMatrix);
            this.ctx?.scale(1 / s1[0], 1 / s1[1]);
        }
        this.ctx?.concat(t), this.currentTransform = t;
    }
    transform(t) {
        this.ctx?.concat(t);
    }
    setSize(t, e) {
        !this._isSizeDirty && t === this._width && e === this._height || (this._isSizeDirty = !1, this._width = t, this._height = e, this.canvas.style.width = t + "px", this.canvas.style.height = e + "px", this.canvas.width = t * this.dpr, this.canvas.height = e * this.dpr, this._surface && (this._surface = yt.MakeWebGLCanvasSurface(this.canvas), this.ctx = this._surface?.getCanvas()));
    }
};
function MB(n1) {
    for(let t = 0; t < n1.length; t++)if (n1[t] !== void 0 && !Number.isFinite(n1[t])) return !1;
    return !0;
}
function Fb({ r: n1, g: t, b: e, a: r }) {
    return yt.Color4f(n1, t, e, r);
}
var xg = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.enabled = !1;
        this.color = At.transparent;
        this.blurRadius = 0;
        this.offset = [
            0,
            0
        ];
        this.spread = 0;
        this.update(e);
    }
    update(t) {
        t.color !== void 0 && (this.color = t.color), t.enabled !== void 0 && (this.enabled = t.enabled), t.blurRadius !== void 0 && (this.blurRadius = t.blurRadius), t.offset !== void 0 && (this.offset = t.offset), t.spread !== void 0 && (this.spread = t.spread);
    }
};
var bg = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.enabled = !1;
        this.radius = 0;
        this.update(e);
    }
    update(t) {
        t.enabled !== void 0 && (this.enabled = t.enabled), t.radius !== void 0 && (this.radius = t.radius);
    }
};
var Vb = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.enabled = !1;
        this.color = At.transparent;
        this.update(e);
    }
    update(t) {
        t.enabled !== void 0 && (this.enabled = t.enabled), t.color !== void 0 && (this.color = t.color);
    }
};
var Ub = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.enabled = !1;
        this.color = At.transparent;
        this.thickness = 0;
        this.mode = "inside";
        this.update(e);
    }
    update(t) {
        t.enabled !== void 0 && (this.enabled = t.enabled), t.color !== void 0 && (this.color = t.color), t.thickness !== void 0 && (this.thickness = t.thickness), t.mode !== void 0 && (this.mode = t.mode);
    }
};
var Pr = class extends hr {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.autoClose = !0;
        this.fill = new Vb(e + "-fill", r.fill, i), this.stroke = new Ub(e + "-stroke", r.stroke, i), this.dropShadow = new xg(e + "-dropShadow", r.dropShadow, i), this.innerShadow = new xg(e + "-innerShadow", r.innerShadow, i), this.backgroundBlur = new bg(e + "-backgroundBlur", r.backgroundBlur, i), this.layerBlur = new bg(e + "-layerBlur", r.layerBlur, i);
    }
    applyFillStroke(e) {
        e.fillColor = this.fill.enabled ? this.fill.color : At.transparent, e.strokeColor = this.stroke.enabled && this.stroke.thickness > 0 ? this.stroke.color : At.transparent, e.strokeMode = this.stroke.mode, e.lineWidth = this.stroke.thickness;
    }
    applyFilters(e) {
        this.layerBlur.enabled ? e.layerBlur = this.layerBlur.radius * 5 : e.layerBlur = 0, this.backgroundBlur.enabled ? e.backgroundBlur = this.backgroundBlur.radius * 5 : e.backgroundBlur = 0, this.dropShadow.enabled ? (e.dropShadowBlur = this.dropShadow.blurRadius * 5, e.dropShadowColor = this.dropShadow.color, e.dropShadowOffsetX = this.dropShadow.offset[0], e.dropShadowOffsetY = this.dropShadow.offset[1]) : e.dropShadowColor = At.transparent, this.innerShadow.enabled ? (e.innerShadowSpread = this.innerShadow.spread, e.innerShadowBlur = this.innerShadow.blurRadius * 5, e.innerShadowColor = this.innerShadow.color, e.innerShadowOffsetX = this.innerShadow.offset[0], e.innerShadowOffsetY = this.innerShadow.offset[1]) : e.innerShadowColor = At.transparent;
    }
    innerDraw(e) {}
    draw(e) {
        !this.visible || (e.save(), this.applyTransforms(e), this.applyFilters(e), this.applyFillStroke(e), e.beginPath(), this.innerDraw(e), this.autoClose && e.closePath(), this.fill.enabled && e.fill(), this.stroke.enabled && e.stroke(), e.restore());
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), e.type === 0 && (kt(e.path, [
            "fill"
        ]) ? this.fill.update(e.props) : kt(e.path, [
            "stroke"
        ]) ? this.stroke.update(e.props) : kt(e.path, [
            "dropShadow"
        ]) ? this.dropShadow.update(e.props) : kt(e.path, [
            "innerShadow"
        ]) ? this.innerShadow.update(e.props) : kt(e.path, [
            "layerBlur"
        ]) ? this.layerBlur.update(e.props) : kt(e.path, [
            "backgroundBlur"
        ]) ? this.backgroundBlur.update(e.props) : this.resetBBoxNeedsUpdate());
    }
    updateState(e, r) {
        super.updateState(e, r), e.fill !== void 0 && this.fill.update(e.fill), e.stroke !== void 0 && this.stroke.update(e.stroke), e.dropShadow !== void 0 && this.dropShadow.update(e.dropShadow), e.innerShadow !== void 0 && this.innerShadow.update(e.innerShadow), e.layerBlur !== void 0 && this.layerBlur.update(e.layerBlur), e.backgroundBlur !== void 0 && this.backgroundBlur.update(e.backgroundBlur);
    }
    clone(e) {
        let r = new Pr(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
};
var mc = class extends Pr {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.width = 0;
        this.height = 0;
        this.updateState(r, i);
    }
    innerDraw(e) {
        e.ellipse(this.width * .5, this.height * .5, this.width * .5, this.height * .5, 0, 0, Math.PI * 2);
    }
    intersectsInLocalSpace(e, r) {
        return yB(e, r, this.width * .5, this.height * .5, this.width * .5, this.height * .5);
    }
    getCenter() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    getHalfSize() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    updateSizeState(e) {
        let r = !1;
        e.width !== void 0 && (this.width = typeof e.width == "number" ? e.width : this.width, r = !0), e.height !== void 0 && (this.height = typeof e.height == "number" ? e.height : this.height, r = !0), r && this.updateWorldMatrix(!0, !1, !0);
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateSizeState(e);
    }
    clone(e) {
        let r = new mc(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
};
var Bs = class extends Pr {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.width = 0;
        this.height = 0;
        this.cornerRadius = [
            0,
            0,
            0,
            0
        ];
        this.updateState(r, i);
    }
    innerDraw(e) {
        e.rect(0, 0, this.width, this.height, ...this.cornerRadius);
    }
    getCenter() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    getHalfSize() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    updateCornerState(e) {
        e.cornerRadius !== void 0 && (this.cornerRadius = e.cornerRadius);
    }
    updateSizeState(e) {
        let r = !1;
        e.width !== void 0 && (this.width = typeof e.width == "number" ? e.width : this.width, r = !0), e.height !== void 0 && (this.height = typeof e.height == "number" ? e.height : this.height, r = !0), r && this.updateWorldMatrix(!0, !1, !0);
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateSizeState(e), this.updateCornerState(e);
    }
    clone(e) {
        let r = new Bs(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
};
var gc = class extends Pr {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this._textHeight = 0;
        this._textHeightDirty = !0;
        this.width = 0;
        this.height = 0;
        this.updateState(r, i);
    }
    get textHeight() {
        return this._textHeight;
    }
    applyFillStroke(e) {
        e.fillColor = this.fill.enabled ? this.fill.color : At.transparent, e.strokeColor = this.stroke.enabled && this.stroke.thickness > 0 ? this.stroke.color : At.transparent, e.strokeMode = "center", e.lineWidth = this.stroke.thickness;
    }
    innerDraw(e) {
        this._fontHolder?.arrayBuffer && this._fontHolder.arrayBuffer.byteLength > 1 && this.data.font && e.registerFont(this._fontHolder.arrayBuffer, this.data.font);
        let r = this.data.textTransform, i = this.data.text.textValue.toString(), s1 = r === 2 ? i.toUpperCase() : r === 3 ? i.toLowerCase() : i, { height: o } = e.drawText(s1, {
            x: 0,
            y: 0,
            width: this.width,
            height: this.height,
            fontSize: this.data.fontSize,
            lineHeight: this.data.lineHeight ?? 1,
            letterSpacing: this.data.letterSpacing ?? 0,
            horizontalAlign: this.data.horizontalAlign,
            verticalAlign: this.data.verticalAlign,
            font: this.data.font
        });
        this._textHeight = o;
    }
    getCenter() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    getHalfSize() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    updateSizeState(e) {
        let r = !1;
        e.width !== void 0 && (this.width = typeof e.width == "number" ? e.width : this.width, r = !0), e.height !== void 0 && (this.height = typeof e.height == "number" ? e.height : this.height, r = !0), r && this.updateWorldMatrix(!0, !1, !0);
    }
    updateFontState(e, { shared: r }) {
        e.font !== void 0 && (this._fontHolder = r.getFont(e.font), this._fontHolder && !this._fontHolder.isLoaded && this._fontHolder.loadingPromise.then(()=>{
            this.requestRender();
        }));
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateSizeState(e), this.updateFontState(e, r);
    }
    clone(e) {
        let r = new gc(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
};
var Qf = class extends Pr {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this.curves = [];
        this.extremasBBox = {
            min: [
                0,
                0
            ],
            max: [
                0,
                0
            ]
        };
        this.updateState(r, i);
    }
    computeExtremas() {
        this.curves.length === 0 && this.computeCurves();
        let e = this.curves.map((s1)=>kb.extremas(s1)), r = [
            1 / 0,
            1 / 0
        ], i = [
            -1 / 0,
            -1 / 0
        ];
        for(let s1 = 0, o = e.length; s1 < o; s1++){
            let a = e[s1];
            a[0][0] < r[0] && (r[0] = a[0][0]), a[0][1] < r[1] && (r[1] = a[0][1]), a[1][0] > i[0] && (i[0] = a[1][0]), a[1][1] > i[1] && (i[1] = a[1][1]);
        }
        return this.extremasBBox.min = [
            r[0],
            r[1]
        ], this.extremasBBox.max = [
            i[0],
            i[1]
        ], this.extremasBBox;
    }
    computeCurves() {
        this.curves = [];
        for(let i = 1, s1 = this.data.points.length; i < s1; i++){
            let o = this.data.points[i].data, a = this.data.points[i - 1].data, l = {
                start: a.position,
                cp1: a.controlNext.position,
                cp2: o.controlPrevious.position,
                end: o.position
            };
            this.curves.push(l);
        }
        let e = this.data.points[0].data, r = this.data.points[this.data.points.length - 1].data;
        if (this.data.isClosed) {
            let i = {
                start: r.position,
                cp1: r.controlNext.position,
                cp2: e.controlPrevious.position,
                end: e.position
            };
            this.curves.push(i);
        }
    }
    getCenter() {
        let [e, r] = this.extremasBBox.min, [i, s1] = this.getHalfSize();
        return [
            e + i,
            r + s1
        ];
    }
    getHalfSize() {
        let { min: e, max: r } = this.extremasBBox;
        return [
            (r[0] - e[0]) * .5,
            (r[1] - e[1]) * .5
        ];
    }
    innerDraw(e) {
        for(let s1 = 0, o = this.data.points.length; s1 < o; s1++){
            let a = this.data.points[s1].data;
            if (s1 === 0) {
                let [l, c] = a.position;
                e.moveTo(l, c);
            } else {
                let l = this.data.points[s1 - 1].data, [c, u1] = l.controlNext.position, [h, d] = a.controlPrevious.position, [f, m] = a.position, p = {
                    start: l.position,
                    cp1: l.controlNext.position,
                    cp2: a.controlPrevious.position,
                    end: a.position
                };
                kb.derive(p), e.bezierCurveTo(c, u1, h, d, f, m);
            }
        }
        let r = this.data.points[0].data, i = this.data.points[this.data.points.length - 1].data;
        if (this.data.isClosed) {
            let [s1, o] = i.controlNext.position, [a, l] = r.controlPrevious.position, [c, u1] = r.position;
            e.bezierCurveTo(s1, o, a, l, c, u1);
        }
    }
    updateState(e, r) {
        super.updateState(e, r), this.computeExtremas();
    }
    clone(e) {
        let r = new Qf(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
}, kb;
((s1)=>{
    function n1(o) {
        let a = o.start, l = o.cp1, c = o.cp2, u1 = o.end, h = [
            3 * (l[0] - a[0]),
            3 * (l[1] - a[1])
        ], d = [
            3 * (c[0] - l[0]),
            3 * (c[1] - l[1])
        ], f = [
            3 * (u1[0] - c[0]),
            3 * (u1[1] - c[1])
        ], m = {
            start: h,
            cp: d,
            end: f
        };
        return o.derivative = m, m.derivative = lM.derive(m), m;
    }
    s1.derive = n1;
    function t(o, a, l, c = !1) {
        let u1 = o - 2 * a + l;
        if (u1 !== 0) {
            let h = -Math.sqrt(Math.abs(a * a - o * l)), d = -o + a, f = -(h + d) / u1, m = -(-h + d) / u1;
            return [
                f,
                m
            ];
        } else if (a !== l && u1 === 0) return [
            (2 * a - l) / (2 * (a - l))
        ];
        return [];
    }
    function e(o) {
        let a = o.derivative ?? s1.derive(o), l = a.start, c = a.cp, u1 = a.end;
        return [
            t(l[0], c[0], u1[0]),
            t(l[1], c[1], u1[1])
        ];
    }
    s1.droot = e;
    function r(o) {
        let [a, l] = s1.droot(o), c = [
            o.start[0],
            o.end[0]
        ], u1 = [
            o.start[1],
            o.end[1]
        ];
        for (let h of a)c.push(s1.compute(o, Math.min(1, Math.max(0, h)))[0]);
        for (let h of l)u1.push(s1.compute(o, Math.min(1, Math.max(0, h)))[1]);
        return c.sort((h, d)=>h - d), u1.sort((h, d)=>h - d), [
            [
                c[0],
                u1[0]
            ],
            [
                c[c.length - 1],
                u1[u1.length - 1]
            ]
        ];
    }
    s1.extremas = r;
    function i(o, a) {
        if (a === 0) return [
            ...o.start
        ];
        if (a === 1) return [
            ...o.end
        ];
        let l = 1 - a, c = l * l, u1 = a * a, h = c * l, d = c * a * 3, f = l * u1 * 3, m = a * u1;
        return [
            h * o.start[0] + d * o.cp1[0] + f * o.cp2[0] + m * o.end[0],
            h * o.start[1] + d * o.cp1[1] + f * o.cp2[1] + m * o.end[1]
        ];
    }
    s1.compute = i;
})(kb || (kb = {}));
var lM;
((r)=>{
    function n1(i) {
        let s1 = i.start, o = i.cp, a = i.end, l = [
            2 * (o[0] - s1[0]),
            2 * (o[1] - s1[1])
        ], c = [
            2 * (a[0] - o[0]),
            2 * (a[1] - o[1])
        ], u1 = {
            start: l,
            end: c
        };
        return u1.derivative = cM.derive(u1), i.derivative = u1, u1;
    }
    r.derive = n1;
    function t(i) {
        let s1 = i.derivative ?? r.derive(i), o = s1.start, a = s1.end;
        return [
            o[0] !== a[0] ? o[0] / (o[0] - a[0]) : 0,
            o[1] !== a[1] ? o[1] / (o[1] - a[1]) : 0
        ];
    }
    r.droot = t;
    function e(i, s1) {
        if (s1 === 0) return [
            ...i.start
        ];
        if (s1 === 1) return [
            ...i.end
        ];
        let o = 1 - s1, a = o * o, l = s1 * s1, c = a, u1 = o * s1 * 2, h = l;
        return [
            c * i.start[0] + u1 * i.cp[0] + h * i.end[0],
            c * i.start[1] + u1 * i.cp[1] + h * i.end[1]
        ];
    }
    r.compute = e;
})(lM || (lM = {}));
var cM;
((e)=>{
    function n1(r) {
        let i = r.start, s1 = r.end, o = [
            s1[0] - i[0],
            s1[1] - i[1]
        ];
        return r.derivative = o, r.derivative;
    }
    e.derive = n1;
    function t(r, i) {
        if (i === 0) return [
            ...r.start
        ];
        if (i === 1) return [
            ...r.end
        ];
        let s1 = r.start, o = r.end;
        return [
            s1[0] + (o[0] - s1[0]) * i,
            s1[1] + (o[1] - s1[1]) * i
        ];
    }
    e.compute = t;
})(cM || (cM = {}));
var rn = class extends tn {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.width = 0;
        this.height = 0;
        this.clipped = !0;
        this.background = new Bs(e + "-background", Ad.defaultData, i), this.background.parent = this, this.updateState(r, i);
    }
    get fill() {
        return this.background.fill;
    }
    get stroke() {
        return this.background.stroke;
    }
    get backgroundBlur() {
        return this.background.backgroundBlur;
    }
    get layerBlur() {
        return this.background.layerBlur;
    }
    get dropShadow() {
        return this.background.dropShadow;
    }
    get innerShadow() {
        return this.background.innerShadow;
    }
    get cornerRadius() {
        return this.background.cornerRadius;
    }
    set cornerRadius(e) {
        this.background.cornerRadius = e;
    }
    updateLocalMatrix() {
        super.updateLocalMatrix(), this.background?.updateLocalMatrix();
    }
    updateWorldMatrix(e, r, i) {
        super.updateWorldMatrix(e, r, i), this.background?.updateWorldMatrix(e, r, i);
    }
    draw(e) {
        if (!this.visible) return;
        e.save();
        let r = this.width, i = this.height;
        this.applyTransforms(e), this.background.width = r, this.background.height = i, this.background.draw(e), this.clipped && e.clipRect(0, 0, r, i, ...this.cornerRadius), this.innerDrawChildren(e), e.restore();
    }
    getCenter() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    getHalfSize() {
        return [
            this.width * .5,
            this.height * .5
        ];
    }
    updateCornerState(e) {
        e.cornerRadius !== void 0 && (this.cornerRadius = e.cornerRadius);
    }
    updateSizeState(e) {
        let r = !1;
        e.width !== void 0 && (this.width = typeof e.width == "number" ? e.width : this.width, r = !0), e.height !== void 0 && (this.height = typeof e.height == "number" ? e.height : this.height, r = !0), r && this.updateWorldMatrix(!0, !1, !0);
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateSizeState(e), this.updateCornerState(e), e.fill !== void 0 && this.fill.update(e.fill), e.stroke !== void 0 && this.stroke.update(e.stroke), e.dropShadow !== void 0 && this.dropShadow.update(e.dropShadow), e.innerShadow !== void 0 && this.innerShadow.update(e.innerShadow), e.layerBlur !== void 0 && this.layerBlur.update(e.layerBlur), e.backgroundBlur !== void 0 && this.backgroundBlur.update(e.backgroundBlur), e.clipped !== void 0 && (this.clipped = e.clipped);
    }
    requestRender() {
        super.requestRender(), this.dispatchEvent({
            type: "render"
        });
    }
    dispose() {
        this.removeEventListener("render");
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), e.type === 0 && (kt(e.path, [
            "fill"
        ]) ? this.fill.update(e.props) : kt(e.path, [
            "stroke"
        ]) ? this.stroke.update(e.props) : kt(e.path, [
            "dropShadow"
        ]) ? this.dropShadow.update(e.props) : kt(e.path, [
            "innerShadow"
        ]) ? this.innerShadow.update(e.props) : kt(e.path, [
            "layerBlur"
        ]) ? this.layerBlur.update(e.props) : kt(e.path, [
            "backgroundBlur"
        ]) ? this.backgroundBlur.update(e.props) : this.resetBBoxNeedsUpdate());
    }
    clone(e) {
        let r = new rn(this.uuid, this.data, e);
        r.parent = void 0;
        for (let i of this.children)r.add(i.clone(e));
        return r;
    }
};
var IB = cl(uM(), 1), il = class extends Pr {
    constructor(e, r, i){
        super(e, r, i);
        this.uuid = e;
        this.data = r;
        this._pathBBox = new DOMRect;
        this.path = "";
        this.updateState(r, i), this.autoClose = !1, this.computeSVGBBox();
    }
    computeSVGBBox() {
        let e = this.path;
        DB(this.path) && (console.warn("Invalid SVG path", this.uuid), e = "");
        let r = document.createElementNS("http://www.w3.org/2000/svg", "svg"), i = document.createElementNS("http://www.w3.org/2000/svg", "path");
        document.body.appendChild(r), i.setAttribute("d", e), r.appendChild(i), this._pathBBox = i.getBBox(), r.remove();
    }
    innerDraw(e) {
        e.path(this.path);
    }
    intersectsInLocalSpace(e, r) {
        return e >= this._pathBBox.x && e <= this._pathBBox.x + this._pathBBox.width && r >= this._pathBBox.y && r <= this._pathBBox.y + this._pathBBox.height;
    }
    getCenter() {
        return [
            (this._pathBBox.x + this._pathBBox.width) / 2,
            (this._pathBBox.y + this._pathBBox.height) / 2
        ];
    }
    getHalfSize() {
        return [
            (this._pathBBox.x + this._pathBBox.width) / 2,
            (this._pathBBox.y + this._pathBBox.height) / 2
        ];
    }
    updateState(e, r) {
        super.updateState(e, r), e.path !== void 0 && (this.path = e.path, this.computeSVGBBox());
    }
    clone(e) {
        let r = new il(this.uuid, this.data, e);
        return r.parent = void 0, r;
    }
};
function DB(n1) {
    return /NaN/.test(n1);
}
function OB(n1, t = 1, e = 1) {
    if (t <= 0 || e <= 0) return n1;
    if (DB(n1)) return console.warn("Cannot scale invalid path", n1), Gb([]);
    try {
        let i = (0, IB.parseSVG)(n1).map((s1)=>{
            let o = {
                ...s1
            };
            return "x" in o && (o.x = o.x * t), "y" in o && (o.y = o.y * e), "x1" in o && (o.x1 = o.x1 * t), "x2" in o && (o.x2 = o.x2 * t), "y1" in o && (o.y1 = o.y1 * e), "y2" in o && (o.y2 = o.y2 * e), "rx" in o && (o.rx = o.rx * t), "ry" in o && (o.ry = o.ry * e), o;
        });
        return Gb(i);
    } catch (r) {
        return console.warn("Error parsing SVG path", r), Gb([]);
    }
}
function Gb(n1) {
    let t = [
        "rx",
        "ry",
        "xAxisRotation",
        "largeArc",
        "sweep",
        "x1",
        "y1",
        "x2",
        "y2",
        "x",
        "y"
    ], e;
    return n1.map((r)=>{
        let i = [];
        t.forEach((o)=>{
            if (o in r) {
                let a = r[o] * 1;
                i.length && a >= 0 && i.push(","), i.push(a);
            }
        });
        let s1 = (e === r.code ? i[0] < 0 ? "" : "," : r.code) + i.join("");
        return e = r.code, s1;
    }).join("");
}
function RB(n1, t, e) {
    switch(t.type){
        case "ellipse2d":
            return new mc(n1, t, e);
        case "rectangle2d":
            return new Bs(n1, t, e);
        case "text2d":
            return new gc(n1, t, e);
        case "vector2d":
            return new Qf(n1, t, e);
        case "path2d":
            return new il(n1, t, e);
        case "frame2d":
            return new rn(n1, t, e);
        case "group2d":
        default:
            return new Xn(n1, t, e);
    }
}
var hM = class {
    constructor(t, e, r){
        this.uuid = t;
        this.data = e;
        this.group = new Xn(hM.GROUP_ID, {
            ...Sm.defaultData
        }, r), this.createChildrenObjects(e.objects, this.group, r);
    }
    createObject(t, e, r, i, s1, o) {
        let a = RB(t, e, o);
        a && (i.add(a), i.children.splice(s1, 0, i.children.pop()), a.updateWorldMatrix(), r.length > 0 && (a instanceof Xn || a instanceof rn) && this.createChildrenObjects(r, a, o));
    }
    createChildrenObjects(t, e, r) {
        let i = 0;
        for (let s1 of t)this.createObject(s1.id, s1.data, s1.children, e, i, r), i += 1;
    }
    draw(t) {
        this.group.draw(t);
    }
    updateEntityByOp(t, e, r, i) {
        let s1 = this.find(t);
        if (s1) try {
            s1.updateByOp(e, r, {
                shared: i
            });
        } catch (o) {
            console.error(o);
        }
    }
    updateTreeByOp(t, e) {
        if (t.path.length === 0 && t.type === 7) {
            let r = t.parent === null ? this.group : this.find(t.parent);
            r !== void 0 && r instanceof tn && (this.createObject(t.id, t.data, t.children, r, t.localIndex, e), r.requestRender());
        } else if (t.path.length === 0 && t.type === 8) {
            let r = this.find(t.id);
            if (r !== void 0 && r.parent !== void 0 && r.parent instanceof tn) {
                let i = r.parent;
                r.resetBBoxNeedsUpdate(), i?.remove(r), i?.requestRender();
            }
        } else if (t.path.length === 0 && t.type === 9) {
            let r = this.find(t.id);
            if (r !== void 0) {
                let i = r.parent, s1 = t.parent === null ? this : this.find(t.parent);
                if (s1, s1 instanceof tn || s1 === this) {
                    s1.add(r);
                    let o = t.localIndex;
                    s1.children.splice(o, 0, s1.children.pop()), r.updateWorldMatrix(!0, !1, !0), i?.requestRender(), r.requestRender();
                }
                r.resetBBoxNeedsUpdate();
            }
        }
    }
    add(t) {
        this.group.add(t);
    }
    remove(t) {
        this.group.remove(t);
    }
    traverse(t) {
        this.group.traverse((e)=>{
            e !== this.group && t(e);
        });
    }
    intersectsChildren(t, e, r, i = !1, s1 = []) {
        return this.group.intersectsChildren(t, e, r, i, s1, !0);
    }
    intersectsChildrenReverse(t, e, r, i = !1, s1 = []) {
        return this.group.intersectsChildrenReverse(t, e, r, i, s1, !0);
    }
    find(t) {
        return this.group.find(t);
    }
    get children() {
        return this.group.children;
    }
    project(t, e) {
        return this.group.project(t, e);
    }
    getWithSortKey(t) {
        let e = this.find(t);
        if (e === void 0) return;
        let r = [], i = e;
        for(; i !== this.group;){
            let s1 = i;
            i = i.parent;
            let o = i.children.indexOf(s1);
            r.splice(0, 0, o);
        }
        return {
            entity: e,
            sortKey: r
        };
    }
    getAllSorted(t) {
        let e = [];
        for (let r of t){
            let i = this.getWithSortKey(r.id);
            i !== void 0 && e.push(i);
        }
        return e.sort((r, i)=>qv(r.sortKey, i.sortKey)), e.map((r)=>r.entity);
    }
}, Eu = hM;
Eu.GROUP_ID = "scene2d";
function dM({ constraints: n1, newParentWidth: t, newParentHeight: e, initialParentWidth: r, initialParentHeight: i, objectInitialWidth: s1, objectInitialHeight: o, objectInitialPosition: a }) {
    let { horizontalConstraint: l, verticalConstraint: c } = n1, u1 = t - r, h = e - i, d = s1, f = o, m = a[0], p = a[1];
    if (l !== 0) {
        if (l === 1) m += u1;
        else if (l === 3) m += u1 / 2;
        else if (l === 2) d = Math.max(1, d + u1);
        else if (l === 4) {
            let g = t / r;
            d *= g, m *= g;
        }
    }
    if (c !== 0) {
        if (c === 1) p += h;
        else if (c === 3) p += h / 2;
        else if (c === 2) f = Math.max(1, f + h);
        else if (c === 4) {
            let g = e / i;
            f *= g, p *= g;
        }
    }
    return {
        width: d,
        height: f,
        position: [
            m,
            p
        ]
    };
}
var nee = cl(uM(), 1);
var Fze = {
    mm: {
        mm: 1,
        cm: .1,
        in: 1 / 25.4,
        pt: 72 / 25.4,
        pc: 6 / 25.4,
        px: -1
    },
    cm: {
        mm: 10,
        cm: 1,
        in: 1 / 2.54,
        pt: 72 / 2.54,
        pc: 6 / 2.54,
        px: -1
    },
    in: {
        mm: 25.4,
        cm: 2.54,
        in: 1,
        pt: 72,
        pc: 6,
        px: -1
    },
    pt: {
        mm: 25.4 / 72,
        cm: 2.54 / 72,
        in: 1 / 72,
        pt: 1,
        pc: 6 / 72,
        px: -1
    },
    pc: {
        mm: 25.4 / 6,
        cm: 2.54 / 6,
        in: 1 / 6,
        pt: 12,
        pc: 1,
        px: -1
    },
    px: {
        mm: 1,
        px: 1,
        cm: 1,
        in: 1,
        pt: 1,
        pc: 1
    }
};
var see = `
	varying vec2 vUv;
	void main() {
		vUv = uv;
		gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
	}`, oee = `
	uniform sampler2D tDiffuse;
	varying vec2 vUv;
	void main() {
		vec4 texel = texture2D( tDiffuse, vUv );
		gl_FragColor = texel;
	}`, aee = new bl(-1, 1, 1, -1, 0, 1), mM = class extends Ce {
    constructor(){
        super(), this.setAttribute("position", new Te([
            -1,
            3,
            0,
            -1,
            -1,
            0,
            3,
            -1,
            0
        ], 3)), this.setAttribute("uv", new Te([
            0,
            2,
            0,
            0,
            2,
            0
        ], 2));
    }
}, lee = new mM, gM = class {
    constructor(t){
        this._mesh = new Mt(lee, t);
    }
    dispose() {
        this._mesh.geometry.dispose();
    }
    render(t) {
        t.render(this._mesh, aee);
    }
    get material() {
        return this._mesh.material;
    }
    set material(t) {
        this._mesh.material = t;
    }
}, LB = new $e({
    defines: {},
    uniforms: {
        tDiffuse: new ce(null)
    },
    vertexShader: see,
    fragmentShader: oee
}), cee = new gM(LB), fM = null, pM = null, uee = ()=>(fM === null && (fM = document.createElement("canvas")), fM), hee = (n1)=>(pM === null && (pM = new vg(n1)), pM), dee = Pt.identity(), Zf = class {
    constructor(t, e, r, i){
        this.uuid = t;
        this.width = e;
        this.height = r;
        this.context = i;
        this.enabled = !0;
        this.isScreenSpace = !1;
        this.dpr = window.devicePixelRatio;
        this.isFrameDirty = !1;
        this.onRenderRequestedDownstream = ()=>{
            this.isFrameDirty = !0, this.context.shared.requestRender();
        };
        this._innerApplySize = ()=>{
            let t = this.width, e = this.height, r = this.dpr;
            this.renderer.dpr = this.isScreenSpace ? r : Math.floor(2048 / Math.max(t, e)), this.renderer.setSize(t, e);
        };
        this.onFrameOverrideObjectEvent = (t)=>{
            if (t.target?.uuid !== void 0) {
                let e = this.frameRoot?.find(t.target.uuid);
                e && e.dispatchEvent({
                    ...t,
                    target: e
                });
            }
        };
        this.scene2d = new Eu(Se.generateUUID(), Q0.defaultData, {
            dpr: window.devicePixelRatio,
            shared: i.shared
        }), this.canvas = uee(), this.renderer = hee(this.canvas), this.promise = this.init(), this.renderTarget = new at(1, 1, {
            type: $n,
            stencilBuffer: !1,
            depthBuffer: !1
        }), i.shared.addUIBuffer(this.uuid, this.renderTarget), this.textureHolder = i.shared.uiBuffer(this.uuid);
    }
    get canvasTexture() {
        return this._canvasTexture || (this._canvasTexture = new Xy(this.canvas)), this._canvasTexture;
    }
    async init() {
        this.renderer instanceof vg && (this.renderer.wasmURL = zx.skiaWasmUrl), await this.renderer.init();
    }
    render(t) {
        if (this.isFrameDirty) {
            this.isFrameDirty = !1, this._innerApplySize(), this.renderer.clear(), this.frameOverride?.draw(this.renderer), this.renderer.render(), LB.uniforms.tDiffuse.value = this.canvasTexture, this.canvasTexture.needsUpdate = !0;
            let e = t.getRenderTarget();
            t.setRenderTarget(this.renderTarget), t.clear(), cee.render(t), t.setRenderTarget(e), this.textureHolder?.setNeedsUpdate(!0);
        }
    }
    updateEntity2DByOp(t, e, r, i) {
        this.scene2d.updateEntityByOp(t, e, r, i), this.applySize();
    }
    updateTreeByOp(t, e) {
        this.scene2d.updateTreeByOp(t, e), this.applySize();
    }
    applyOverrides(t) {
        if (this.frameOverride && this.frameRoot) {
            this.frameOverride.position = [
                0,
                0
            ], this.frameOverride.rotation = 0;
            let e = t?.width ?? this.width, r = t?.height ?? this.height;
            this.frameOverride.width = e, this.frameOverride.height = r, this.frameOverride.localMatrix = dee, this.isScreenSpace && (this.frameOverride.fill.color = At.from0to1([
                0,
                0,
                0,
                0
            ])), this.frameOverride.data = {
                ...this.frameOverride.data,
                width: e,
                height: r
            }, NB({
                objectOverride: this.frameOverride,
                objectRoot: this.frameRoot,
                newParentWidth: this.frameOverride.width,
                newParentHeight: this.frameOverride.height,
                initialParentWidth: this.frameRoot.width,
                initialParentHeight: this.frameRoot.height
            }), this.frameOverride.updateWorldMatrix(!0, !1, !0);
        }
    }
    applySize(t, e = window.devicePixelRatio) {
        let r = Math.max(1, t?.width ?? this.width), i = Math.max(1, t?.height ?? this.height);
        this.dpr = e, this.width = r, this.height = i, this._innerApplySize();
        let s1 = 1, o = 512, a = 512;
        (r * e < o || i * e < a) && (s1 = Math.max(o / (r * e), a / (i * e))), this.renderTarget.setSize(r * e * s1, i * e * s1), this._canvasTexture?.dispose(), this._canvasTexture = void 0, this.applyOverrides(t), this.frameOverride?.requestRender();
    }
    applyFrame(t) {
        let e = this.context.scene.find2D(t);
        if (!(!e || !(e instanceof rn))) return this.disposeFrameOverride(), this.frameRoot = e, this.frameOverride = e.clone({
            dpr: this.renderer.dpr,
            shared: this.context.shared
        }), this.scene2d.add(this.frameOverride), this.applySize(), this.frame?.addEventListener("render", this.onRenderRequestedDownstream), this.frameOverride.traverse((r)=>{
            r.addEventListener("beginState", this.onFrameOverrideObjectEvent);
        }), this.frameOverride.traverse((r)=>{
            r.addEventListener("completeState", this.onFrameOverrideObjectEvent);
        }), this.frame?.requestRender(), e;
    }
    get frame() {
        return this.frameOverride;
    }
    get frameId() {
        return this.frame?.uuid;
    }
    find(t) {
        return this.scene2d.find(t);
    }
    get texture() {
        return this.textureHolder?.getTexture(1001);
    }
    disposeFrameOverride() {
        this.frameOverride?.removeEventListener("render", this.onRenderRequestedDownstream), this.frameOverride?.traverse((t)=>{
            t.removeEventListener("beginStateChange", this.onFrameOverrideObjectEvent);
        }), this.frameOverride?.traverse((t)=>{
            t.removeEventListener("completeState", this.onFrameOverrideObjectEvent);
        }), this.frameOverride && this.scene2d.remove(this.frameOverride);
    }
};
function NB({ objectOverride: n1, objectRoot: t, newParentWidth: e, newParentHeight: r, initialParentWidth: i, initialParentHeight: s1 }) {
    if (n1 instanceof rn && t instanceof rn || n1 instanceof Xn && t instanceof Xn) for(let o = 0, a = n1.children.length; o < a; o++){
        let l = n1.children[o], c = t.children[o];
        l && c && l.uuid === c.uuid && pee({
            objectOverride: l,
            objectRoot: c,
            newParentWidth: e,
            newParentHeight: r,
            initialParentWidth: i,
            initialParentHeight: s1
        });
    }
}
function fee(n1) {
    if (yM(n1)) return [
        n1.width,
        n1.height
    ];
    if (n1 instanceof il) {
        let [t, e] = n1.getHalfSize();
        return [
            t * 2,
            e * 2
        ];
    } else if (n1 instanceof Xn) {
        let [t, e] = n1.recursiveBBox.getHalfSize();
        return [
            t * 2,
            e * 2
        ];
    }
    return [
        0,
        0
    ];
}
function pee({ objectOverride: n1, objectRoot: t, newParentWidth: e, newParentHeight: r, initialParentWidth: i, initialParentHeight: s1 }) {
    let [o, a] = fee(t), { width: l, height: c, position: u1 } = dM({
        constraints: n1.data,
        newParentWidth: e,
        newParentHeight: r,
        initialParentWidth: i,
        initialParentHeight: s1,
        objectInitialWidth: o,
        objectInitialHeight: a,
        objectInitialPosition: t.position
    });
    if (n1.position = u1, n1.data = {
        ...n1.data,
        position: u1
    }, n1.states) for(let h in n1.states)mee({
        stateId: h,
        objectOverride: n1,
        objectRoot: t,
        newParentWidth: e,
        newParentHeight: r,
        initialParentWidth: i,
        initialParentHeight: s1
    });
    if (yM(n1) || n1 instanceof Xn) yM(n1) && (n1.width = l, n1.height = c, n1.data = {
        ...n1.data,
        width: l,
        height: c
    }), NB({
        objectOverride: n1,
        objectRoot: t,
        newParentWidth: l,
        newParentHeight: c,
        initialParentWidth: o,
        initialParentHeight: a
    });
    else if (n1 instanceof il) {
        let h = t, d = o !== 0 ? l / o : 1, f = a !== 0 ? c / a : 1;
        n1.path = OB(h.path, d, f), n1.data = {
            ...n1.data,
            path: n1.path
        };
    }
}
function mee({ stateId: n1, objectOverride: t, objectRoot: e, newParentWidth: r, newParentHeight: i, initialParentWidth: s1, initialParentHeight: o }) {
    let a = t.states?.[n1], l = e.states?.[n1];
    if (a && l) {
        let { width: c, height: u1, position: h } = dM({
            constraints: t.data,
            newParentWidth: r,
            newParentHeight: i,
            initialParentWidth: s1,
            initialParentHeight: o,
            objectInitialWidth: ja.isResizeable(l) ? l.width : 0,
            objectInitialHeight: ja.isResizeable(l) ? l.height : 0,
            objectInitialPosition: l.position
        });
        Object.assign(t.states[n1], {
            position: h
        }), ja.isResizeable(a) && Object.assign(t.states[n1], {
            width: c,
            height: u1
        });
    }
}
function yM(n1) {
    return n1 instanceof Bs || n1 instanceof rn || n1 instanceof mc || n1 instanceof gc;
}
var yr = class extends zd(Er) {
    constructor(e, r, i){
        super();
        this.data = r;
        this.bgColor = new cr(1, 1, 1, 1);
        this.fog = null;
        this.backupFog = new ih(16777215, .1, 2e3);
        this.fogUseBGColor = !1;
        this.isActive = !1;
        this.aoColor = new Ge;
        this.penumbraSizeArrayCache = null;
        this.super_Entity(e, r), this.personalCamera = new ir(As, {
            ...ru.defaultData,
            ...r.camera,
            name: "Personal Camera"
        }), this.personalCamera.objectHelper.visible = !1, this.add(this.personalCamera), this.activeCamera = this.personalCamera, this.ambientLight = new $y(13882323, 8553090, .75), this.ambientLight.name = "Default Ambient Light", this.ambientLight.layers.enable(3), this.ambientLight.removeFromParent(), this.add(this.ambientLight), r.uiScene ? this.uiScene = new Eu((Array.isArray(e) ? e[0] : e) + "-ui", r.uiScene, {
            dpr: window.devicePixelRatio,
            shared: i.shared
        }) : r.uiFrame && this.createUICanvas(r.uiFrame, i);
    }
    get scene() {
        return this.parent;
    }
    get postprocessing() {
        return this.data.postprocessing;
    }
    get frameId() {
        return this.data.uiFrame;
    }
    get frame() {
        return this.uiCanvas?.frame;
    }
    createUICanvas(e, r) {
        this.uiCanvas = new Zf(this.uuid + "-uiscreen", window.innerWidth, window.innerHeight, r), this.uiCanvas.isScreenSpace = !0, this.uiCanvas.promise.then(()=>{
            this.uiCanvas?.applyFrame(e), this.uiCanvas?.applySize();
        });
    }
    updateVisible() {}
    setBackgroundColor(e) {
        this.bgColor = e, this.fogUseBGColor === !0 && (this.backupFog.color = e);
    }
    entityChildrenCount() {
        return this.uiScene ? this.uiScene.children.length : super.entityChildrenCount();
    }
    updateAmbientLight(e, r) {
        e.color !== void 0 && (this.ambientLight.color = en(e.color, r)), e.intensity !== void 0 && (this.ambientLight.intensity = e.intensity), e.enabled !== void 0 && (e.enabled ? this.add(this.ambientLight) : this.remove(this.ambientLight));
    }
    onDeactive() {
        this.isActive = !1;
    }
    onActive(e) {
        this.isActive = !0, e.fog = this.fog, this.traverseEntity((r)=>{
            r instanceof Hn && r.recomputeBoolean();
        }), this.updateShadow(this.data.shadow);
    }
    forceMaterialsUpdate() {
        this.traverseEntity((e)=>{
            if (e instanceof _n) {
                if (Array.isArray(e.material)) for (let r of e.material)r.needsUpdate = !0;
                else e.material.needsUpdate = !0, e.material.dispose();
            }
        });
    }
    updateShadow(e) {
        e.softShadowQuality !== void 0 && this.isActive && aB(e.softShadowQuality) && this.forceMaterialsUpdate();
    }
    updateFog(e, r) {
        if (e.enabled ? this.fog = this.backupFog : this.fog = null, this.isActive) {
            let i = this.scene;
            i.fog = this.fog;
        }
        this.fogUseBGColor = e.useBackgroundColor, e.useBackgroundColor ? this.backupFog.color.set(this.bgColor) : this.backupFog.color = en(e.color, r), this.backupFog.near = e.near, this.backupFog.far = e.far;
    }
    updateAo(e, r) {
        e.aoColor !== void 0 && (this.aoColor = en(e.aoColor, r));
    }
    updateByOp(e, r, i, s1) {
        let o = this.data.uiFrame;
        super.updateByOp(e, r, i, s1);
        let a = r;
        kt(e.path, [
            "fog"
        ]) ? this.updateFog(a.fog, i.shared) : kt(e.path, [
            "ao"
        ]) ? this.updateAo(a.ao, i.shared) : kt(e.path, [
            "ambient"
        ]) ? this.updateAmbientLight(a.ambient, i.shared) : kt(e.path, [
            "shadow"
        ]) ? this.updateShadow(a.shadow) : e.type === 0 && e.path.length === 0 && (e.props.uiFrame !== void 0 || o !== a.uiFrame) && this.updateUIFrame(e.props.uiFrame, i);
    }
    updateUIFrame(e, r) {
        e ? (this.uiCanvas || this.createUICanvas(e, r), this.uiCanvas.enabled = !0, this.uiCanvas.applyFrame(e)) : this.uiCanvas && (this.uiCanvas.enabled = !1);
    }
    updateState(e, r) {
        this.updateState_Entity(e, r), e.backgroundColor !== void 0 && this.setBackgroundColor(en(e.backgroundColor, r.shared)), e.fog !== void 0 && this.updateFog(e.fog, r.shared), e.ambient !== void 0 && this.updateAmbientLight(e.ambient, r.shared), e.ao !== void 0 && this.updateAo(e.ao, r.shared), e.shadow !== void 0 && this.updateShadow(e.shadow);
    }
    createFrame(e, r) {}
    raycast(e, r) {
        super.raycast(e, r);
    }
    switchActiveCamera(e) {
        e && e.isDescendantOf(this) && (this.activeCamera !== this.personalCamera && (this.activeCamera.objectHelper.visible = !0), this.activeCamera = e, e.objectHelper.visible = !1);
    }
    get playCamera() {
        return this.scene?.find(this.data.publish.playCamera) ?? this.personalCamera;
    }
    switchToPlayCamera() {
        this.switchActiveCamera(this.playCamera);
    }
    get penumbraSizeArray() {
        return this.penumbraSizeArrayCache === null && this.updatePenumbraSizeArray(), this.penumbraSizeArrayCache;
    }
    updatePenumbraSizeArray() {
        this.penumbraSizeArrayCache = new Array(5).fill(.5);
        let e = 0, r = 0;
        this.traverseEntity((i)=>{
            if (!i.visible) return !0;
            i instanceof Ho && i.visible && e < 3 && (this.penumbraSizeArrayCache[e] = i.data.penumbraSize ?? .5, e += 1), i instanceof Wo && i.visible && e < 2 && (this.penumbraSizeArrayCache[3 + r] = i.data.penumbraSize ?? .5, r += 1);
        });
    }
    raycastWithClones(e) {
        let r = [], i = (s1)=>{
            for (let o of s1.children){
                let a = o.cloner;
                gt.is(o) && (o.visible || a?.object.data.visible) && ((Wn(o) || dg(o) && this.scene.enableHelpers && o.objectHelper.visible) && (e.intersectObject(o, !1, r), Sg(o, e, r, !0)), i(o));
            }
        };
        return i(this), r;
    }
    updateEntity2DByOp(e, r, i, s1) {
        this.uiCanvas?.updateEntity2DByOp(e, r, i, s1);
    }
};
var Xl = class extends Rf(tv, Yf) {
    constructor(t, e, r){
        super(), this.super_Entity(t, e), this.castShadow = !0, this.shadow.mapSize.width = 1024, this.shadow.mapSize.height = 1024, this.shadow.normalBias = 1, this.layers.enable(3);
        let s1 = this.shadow.camera;
        s1.fov = 90, s1.aspect = 1, s1.near = 100, s1.far = 2500;
        let o = new E(-s1.far + this.position.x, -s1.far + this.position.y, -s1.far + this.position.z), a = new E(s1.far + this.position.x, s1.far + this.position.y, s1.far + this.position.z), l = new Yt(o, a), c = new Il(l, new Ge(16755200));
        c.visible = !1, this.gizmos.shadowmap = c, this.update();
    }
    update() {
        if (this.shadow && (this.shadow.camera.updateProjectionMatrix(), this.gizmos)) for(let t in this.gizmos){
            let e = this.gizmos[t];
            if (e instanceof Il) {
                let r = this.shadow.camera, i = new E(-r.far + this.position.x, -r.far + this.position.y, -r.far + this.position.z), s1 = new E(r.far + this.position.x, r.far + this.position.y, r.far + this.position.z);
                e.box.set(i, s1), e.updateMatrixWorld(!0);
            }
        }
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), this.objectHelper && this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Light(t, e), t.distance !== void 0 && (this.distance = t.distance), t.decay !== void 0 && (this.decay = t.decay), t.shadowRadius !== void 0 && (this.shadow.radius = t.shadowRadius), t.shadowResolution !== void 0 && (this.shadow.mapSize.set(t.shadowResolution, t.shadowResolution), this.shadow.map && (this.shadow.map.dispose(), this.shadow.map = null));
    }
};
var jb = class extends Ct {
    get forceComputeSize() {
        return !0;
    }
    get shape() {
        return this.geometry.userData.shape;
    }
    updateEntityBoxSize(t, e) {
        let r = this.geometry.getAttribute("position");
        r !== void 0 ? Ym(r, this.geometry.drawRange.start, this.geometry.drawRange.count < 1 / 0 ? this.geometry.drawRange.count : r.count, t, e) : super.updateEntityBoxSize(t, e);
    }
};
var qo = class extends Ct {
    constructor(e, r, i){
        super(e, r, i);
        this._shapeId = null;
        this._context = i;
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateShape(), this.refreshAttachedCloners(r);
    }
    updateShape() {
        let e = {
            ...this.data.geometry.extrusion.shape
        };
        for(let s1 in e)typeof e[s1] == "string" && (e[s1] = this._context.shared.getVariable(e[s1], [
            this.uuid,
            "geometry",
            "extrusion",
            "shape",
            s1
        ]));
        let r;
        if (e.type === "Custom") {
            let s1 = e.shapeId;
            if (s1 !== this._shapeId && this.detachShape(), s1) {
                this._shapeId = s1;
                let o = this._context.scene.find(s1);
                o?.data && (o.attachedPaths.add(this), r = o.geometry.userData?.shape), r || this._context.scene.addPendingCommand(()=>this.updateShape());
            }
        } else {
            let s1;
            switch(e.type){
                case "Rectangle":
                    s1 = Jd;
                    break;
                case "Ellipse":
                    s1 = Kd;
                    break;
                case "Polygon":
                    s1 = Px;
                    break;
                case "Star":
                    s1 = _x;
                    break;
                default:
                    throw new Error(`Unknown shape type: ${e.type}`);
            }
            r = s1.create({
                parameters: e
            }).userData.shape;
        }
        let i = this.geometry;
        r && i.inputs && (i.inputs.shapeData = r, i.build());
    }
    detachShape() {
        this._shapeId !== null && this._context.scene.find(this._shapeId)?.attachedPaths.delete(this);
    }
    createGeometryDelayed(e) {
        this.geometryCreateDeleyed = e.shared, this.updateShape(), this.refreshAttachedPaths(e);
    }
    updateTransformState(e, r) {
        return super.updateTransformState(e, r);
    }
    updateGeometryInteractions(e, r) {
        super.updateGeometryInteractions(e, r), this.updateShape();
    }
    updateEntityBoxSize(e, r) {
        let i = this.geometry.getAttribute("position");
        i !== void 0 ? Ym(i, this.geometry.drawRange.start, this.geometry.drawRange.count < 1 / 0 ? this.geometry.drawRange.count : i.count, e, r) : super.updateEntityBoxSize(e, r);
    }
};
var yc = class extends cc {
    constructor(e, r, i){
        super(e, r, i);
        this.data = r;
    }
};
var ho = class extends Rs(cn, Ls) {
    constructor(e, r, i){
        super();
        r.type === "Instance" && typeof e == "string" && (r = this.transformAssignData(r, i)), this.super_Entity(e, r), this.objectHelper.update();
    }
    get isComponentRoot() {
        return this.data.type === "Component" && typeof this.identity == "string";
    }
    get isInstanceRoot() {
        return this.data.type === "Instance" && typeof this.identity == "string";
    }
    transformAssignData(e, r) {
        let i = Uo.getComponentData({
            scene: r.scene.data,
            shared: r.shared.data
        }, e.component);
        if (i) {
            let s1, o;
            for (let a of Vo.rootOverrideProps)e[a] === void 0 ? (s1 === void 0 && (s1 = {
                ...e
            }), s1[a] = i.data[a]) : (o === void 0 && (o = {}), o[a] = e[a], s1 === void 0 && (s1 = {
                ...e
            }), s1[a] = Do.apply(i.data[a], e[a]));
            return this.overrideData = o, s1;
        } else return {
            ...li.defaultData,
            ...e,
            ...Nn(li.defaultData, Vo.rootOverrideProps)
        };
    }
    updateByOp(e, r, i, s1) {
        let o;
        if (this.isInstanceRoot && !s1) {
            if (r = this.transformAssignData(r, i), e.type === 0 && e.path.length === 0 && this.component) for (let a of Vo.rootOverrideProps)a in e.props && e.props[a] === void 0 && (o === void 0 && (o = {
                ...e,
                props: {
                    ...e.props
                }
            }), o.props[a] = this.component.data[a]);
            else if (e.type === 0 && e.path.length > 0 && Vo.rootOverrideProps.includes(e.path[0])) {
                let a = e.path[0];
                o === void 0 && (o = {
                    ...e,
                    path: [],
                    props: {
                        [a]: r[a]
                    }
                });
            }
        }
        super.updateByOp(o ?? e, r, i, s1);
    }
    updateState(e, r) {
        this.updateState_Entity(e, r);
    }
    expandInstanceChildren(e) {
        let r = this.data;
        if (this.component === void 0) {
            let i = e.scene.find(r.component) ?? null, s1 = !1;
            if (i !== this.oldComponent) {
                if (this.oldComponent) {
                    let o = 0;
                    for (let a of this.children)if (gt.is(a)) e.scene.disposeAndUnregisterEntityRecursivelyIfNotReregistered(a), Hb(a), o += 1;
                    else break;
                    this.children.splice(0, o);
                }
                s1 = !0;
            }
            if (i) {
                let o = {};
                FB(e, [
                    this.uuid
                ], r.overrides, this, i, i, 0, s1, o);
                for (let a of this.children)if (gt.is(a)) {
                    let l = a.data;
                    l.type === "Empty" && l.animations && a.traverseEntity((c)=>{
                        let u1 = c.dataPatched;
                        if (c instanceof Ct && u1.bones && u1.boneInverses) {
                            let h = c.dataPatched;
                            if (h.bones && h.boneInverses) {
                                let d = h.bones.map((p)=>e.scene.find(o[p])), f = h.boneInverses.map((p)=>new ue().fromArray(p)), m = new Sl(d, f);
                                c.bind(m, c.bindMatrix);
                            }
                        } else c.matrixAutoUpdate = !0;
                    });
                }
            }
            this.oldComponent = this.component;
        }
    }
};
function Hb(n1) {
    if (n1.component) {
        let t = n1.component.instances.indexOf(n1);
        t >= 0 && n1.component.instances.splice(t, 1);
        for (let e of n1.children)gt.is(e) && Hb(e);
    }
}
function BB(n1, t, e, r) {
    return n1.component === t && Qc(n1.identity, r) ? n1.overrideData === e ? 2 : 1 : 0;
}
function FB(n1, t, e, r, i, s1, o, a, l) {
    if (o > 50) return !1;
    if (r.component !== i) {
        if (r.component) {
            let u1 = r.component.instances.indexOf(r);
            u1 >= 0 && r.component.instances.splice(u1, 1);
        }
        i.instances.find((u1)=>u1 === r) || i.instances.push(r), r.component = i;
    }
    i instanceof ho && i.isInstanceRoot && i.expandInstanceChildren(n1);
    let c = 0;
    for (let u1 of i.children)if (gt.is(u1)) {
        let h = [
            ...t,
            ...typeof u1.identity == "string" ? [
                u1.identity
            ] : u1.identity
        ], d = gd.resolve(e, h, 1);
        if (d != null && !(d instanceof lr)) Object.setPrototypeOf(d, lr.prototype), console.error("wrong prototype");
        let f = null, m;
        if (!a) {
            let p = r.children[c];
            if (f = gt.is(p) ? p : null, f !== null) {
                let g = BB(f, u1, d, h);
                m = g >= 1 ? f.stateSelection : void 0, g !== 2 && (f = null);
            }
            if (f === null && (f = n1.scene.findInstance(h) ?? null, f !== null)) {
                let g = BB(f, u1, d, h);
                if (m = g >= 1 ? f.stateSelection : void 0, g !== 2) f = null;
                else {
                    let y = f.parent.children.indexOf(f);
                    f.parent.children.splice(y, 1), r.children.splice(c, 0, f), f.parent === r ? y <= c && console.error("not possible") : (f.parent = r, f.matrixWorldNeedsUpdate = !0, f.resetBBoxNeedsUpdate(), f.updateVisible(), n1.pendingDeletes.delete(f));
                }
            }
        }
        if (f === null) {
            let p = d ? Do.apply(u1.data, d) : u1.data;
            Ks.is(p.type) && (p = {
                ...p,
                type: "Empty"
            }), f = to.createEntity(h, p, n1), f.overrideData = d, r.add(f), r.children.splice(r.children.length - 1, 1), r.children.splice(c, 0, f), f.updateState(f.data, n1), m && f.changeSelectedState(m, n1), n1.scene.registerInstanceAndSetUuid(f);
        }
        if (f.isBone) {
            let p = f.identity[f.identity.length - 1];
            l[p] = f.uuid;
        }
        c += 1, FB(n1, t, e, f, u1, s1, o + 1, a, l);
    }
    if (!a) {
        let u1 = c;
        for(;;){
            let h = r.children[c];
            if (gt.is(h)) n1.pendingDeletes.add(h);
            else break;
            c += 1;
        }
        r.children.splice(u1, c - u1);
    }
    return !0;
}
var Wb = class extends Rs(zp, Ls) {
    constructor(t, e){
        super(), this.super_Entity(t, e), this.objectHelper.update(), this.matrixAutoUpdate = !0;
    }
    updateState(t, e) {
        this.updateState_Entity(t, e);
    }
};
var _r = class extends Ct {
    constructor(e, r, i){
        super(e, r, i);
        this.onBeforeRender = (e)=>{
            this.uiCanvas.render(e);
        };
        this.uiCanvas = new Zf(e + "-canvas", r.geometry.width, r.geometry.height, i), this.uiCanvas.promise.then(()=>{
            this.applyFrame(this.dataPatched.geometry.frame, i.shared);
        });
    }
    updateByPatchedOpGeometry(e, r, i) {
        super.updateByPatchedOpGeometry(e, r, i), e.type === 0 && (e.props.frame !== void 0 && this.applyFrame(e.props.frame, i.shared), (e.props.width !== void 0 || e.props.height !== void 0) && this.applySize(e.props, i.shared));
    }
    applySize(e, r) {
        let i = e?.width ?? this.dataPatched.geometry.width, s1 = e?.height ?? this.dataPatched.geometry.height;
        this.uiCanvas.applySize({
            width: i,
            height: s1
        }), this.applyGeometryParametersFromFrame(r);
    }
    applyFrame(e, r) {
        this.uiCanvas.applyFrame(e), this.applyGeometryParametersFromFrame(r), this.applyMaterialParametersFromFrame({
            shared: r
        });
    }
    applyGeometryParametersFromFrame(e) {
        let r = this.frame;
        r && (Object.assign(this.data, {
            geometry: Object.assign(this.data.geometry, {
                cornerRadius: r.cornerRadius,
                cornerType: 0
            })
        }), Object.assign(this.dataPatched, {
            geometry: Object.assign(this.dataPatched.geometry, {
                cornerRadius: r.cornerRadius,
                cornerType: 0
            })
        }), this.localGeometry?.dispose(), this.localGeometry = Jo(this.dataPatched.geometry, e, this.data.flatShading, this));
    }
    applyMaterialParametersFromFrame(e) {
        let r = this.frame;
        if (r) {
            let i = r.data.backgroundBlur;
            Object.assign(this.data.material.layers[0].data.texture, {
                image: this.uiCanvas.uuid
            }), Object.assign(this.data.material.layers[1].data, {
                roughness: i.radius,
                alpha: i.enabled ? 1 : 0
            }), Object.assign(this.dataPatched.material.layers[0].data.texture, {
                image: this.uiCanvas.uuid
            }), Object.assign(this.dataPatched.material.layers[1].data, {
                roughness: i.radius,
                alpha: i.enabled ? 1 : 0
            }), this.material.reset?.(this.dataPatched.material, e, !0);
        }
    }
    updateEntity2DByOp(e, r, i, s1) {
        this.uiCanvas.updateEntity2DByOp(e, r, i, s1), e === this.frameId && r.type === 0 && (r.props.cornerRadius !== void 0 ? this.applyGeometryParametersFromFrame(s1) : kt(r.path, [
            "backgroundBlur"
        ]) && this.applyMaterialParametersFromFrame({
            shared: s1
        }));
    }
    get frame() {
        return this.uiCanvas.frame;
    }
    get frameId() {
        return this.frame?.uuid;
    }
    removeInteractionGeometry(e) {
        super.removeInteractionGeometry(e), this.applySize({}, e);
    }
    updateGeometryInteractions(e, r) {
        super.updateGeometryInteractions(e, r), this.applySize({
            width: e.width,
            height: e.height
        }, r);
        let i = {
            ...this.data.geometry,
            ...e
        };
        this.localGeometry?.dispose(), this.localGeometry = Jo(i, r, this.data.flatShading, this);
    }
};
var qb = class {
    constructor(t, e, r){
        this.variables = [], this.currentTextureIndex = 0;
        let i = Ut, s1 = new Er, o = new bn;
        o.position.z = 1;
        let a = {
            passThruTexture: {
                value: null
            }
        }, l = h(f(), a), c = new Mt(new Si(2, 2), l);
        s1.add(c), this.setDataType = function(m) {
            return i = m, this;
        }, this.addVariable = function(m, p, g) {
            let y = this.createShaderMaterial(p), x = {
                name: m,
                initialValueTexture: g,
                material: y,
                dependencies: null,
                renderTargets: [],
                wrapS: null,
                wrapT: null,
                minFilter: vt,
                magFilter: vt
            };
            return this.variables.push(x), x;
        }, this.setVariableDependencies = function(m, p) {
            m.dependencies = p;
        }, this.init = function() {
            if (r.capabilities.isWebGL2 === !1 && r.extensions.has("OES_texture_float") === !1) return "No OES_texture_float support for float textures.";
            if (r.capabilities.maxVertexTextures === 0) return "No support for vertex shader textures.";
            for(let m = 0; m < this.variables.length; m++){
                let p = this.variables[m];
                p.renderTargets[0] = this.createRenderTarget(t, e, p.wrapS, p.wrapT, p.minFilter, p.magFilter), p.renderTargets[1] = this.createRenderTarget(t, e, p.wrapS, p.wrapT, p.minFilter, p.magFilter), this.renderTexture(p.initialValueTexture, p.renderTargets[0]), this.renderTexture(p.initialValueTexture, p.renderTargets[1]);
                let g = p.material, y = g.uniforms;
                if (p.dependencies !== null) for(let x = 0; x < p.dependencies.length; x++){
                    let v = p.dependencies[x];
                    if (v.name !== p.name) {
                        let b = !1;
                        for(let w = 0; w < this.variables.length; w++)if (v.name === this.variables[w].name) {
                            b = !0;
                            break;
                        }
                        if (!b) return "Variable dependency not found. Variable=" + p.name + ", dependency=" + v.name;
                    }
                    y[v.name] = {
                        value: null
                    }, g.fragmentShader = `
uniform sampler2D ` + v.name + `;
` + g.fragmentShader;
                }
            }
            return this.currentTextureIndex = 0, null;
        }, this.compute = function() {
            let m = this.currentTextureIndex, p = this.currentTextureIndex === 0 ? 1 : 0;
            for(let g = 0, y = this.variables.length; g < y; g++){
                let x = this.variables[g];
                if (x.dependencies !== null) {
                    let v = x.material.uniforms;
                    for(let b = 0, w = x.dependencies.length; b < w; b++){
                        let A = x.dependencies[b];
                        v[A.name].value = A.renderTargets[m].texture;
                    }
                }
                this.doRenderTarget(x.material, x.renderTargets[p]);
            }
            this.currentTextureIndex = p;
        }, this.getCurrentRenderTarget = function(m) {
            return m.renderTargets[this.currentTextureIndex];
        }, this.getAlternateRenderTarget = function(m) {
            return m.renderTargets[this.currentTextureIndex === 0 ? 1 : 0];
        }, this.dispose = function() {
            c.geometry.dispose(), c.material.dispose();
            let m = this.variables;
            for(let p = 0; p < m.length; p++){
                let g = m[p];
                g.initialValueTexture && g.initialValueTexture.dispose();
                let y = g.renderTargets;
                for(let x = 0; x < y.length; x++)y[x].dispose();
            }
        };
        function u1(m) {
            m.defines.resolution = "vec2( " + t.toFixed(1) + ", " + e.toFixed(1) + " )";
        }
        this.addResolutionDefine = u1;
        function h(m, p) {
            p = p || {};
            let g = new $e({
                uniforms: p,
                vertexShader: d(),
                fragmentShader: m
            });
            return u1(g), g;
        }
        this.createShaderMaterial = h, this.createRenderTarget = function(m, p, g, y, x, v) {
            return m = m || t, p = p || e, g = g || tr, y = y || tr, x = x || vt, v = v || vt, new at(m, p, {
                wrapS: g,
                wrapT: y,
                minFilter: x,
                magFilter: v,
                format: br,
                type: i,
                depthBuffer: !1
            });
        }, this.createTexture = function() {
            let m = new Float32Array(t * e * 4), p = new Ur(m, t, e, br, Ut);
            return p.needsUpdate = !0, p;
        }, this.renderTexture = function(m, p) {
            a.passThruTexture.value = m, this.doRenderTarget(l, p), a.passThruTexture.value = null;
        }, this.doRenderTarget = function(m, p) {
            let g = r.getRenderTarget(), y = r.xr.enabled, x = r.shadowMap.autoUpdate, v = r.outputEncoding, b = r.toneMapping;
            r.xr.enabled = !1, r.shadowMap.autoUpdate = !1, r.outputEncoding = xn, r.toneMapping = js, c.material = m, r.setRenderTarget(p), r.render(s1, o), c.material = l, r.xr.enabled = y, r.shadowMap.autoUpdate = x, r.outputEncoding = v, r.toneMapping = b, r.setRenderTarget(g);
        };
        function d() {
            return `void main()	{

	gl_Position = vec4( position, 1.0 );

}
`;
        }
        function f() {
            return `uniform sampler2D passThruTexture;

void main() {

	vec2 uv = gl_FragCoord.xy / resolution.xy;

	gl_FragColor = texture2D( passThruTexture, uv );

}
`;
        }
    }
};
var nn = new Or, Xb = new E, Yb = class {
    constructor(t){
        let e = t.geometry;
        if (!e.isBufferGeometry || e.attributes.position.itemSize !== 3) throw new Error("THREE.MeshSurfaceSampler: Requires BufferGeometry triangle mesh.");
        e.index && (console.warn("THREE.MeshSurfaceSampler: Converting geometry to non-indexed BufferGeometry."), e = e.toNonIndexed()), this.geometry = e, this.randomFunction = Math.random, this.positionAttribute = this.geometry.getAttribute("position"), this.colorAttribute = this.geometry.getAttribute("color"), this.weightAttribute = null, this.distribution = null;
    }
    setWeightAttribute(t) {
        return this.weightAttribute = t ? this.geometry.getAttribute(t) : null, this;
    }
    build() {
        let t = this.positionAttribute, e = this.weightAttribute, r = new Float32Array(t.count / 3);
        for(let s1 = 0; s1 < t.count; s1 += 3){
            let o = 1;
            e && (o = e.getX(s1) + e.getX(s1 + 1) + e.getX(s1 + 2)), nn.a.fromBufferAttribute(t, s1), nn.b.fromBufferAttribute(t, s1 + 1), nn.c.fromBufferAttribute(t, s1 + 2), o *= nn.getArea(), r[s1 / 3] = o;
        }
        this.distribution = new Float32Array(t.count / 3);
        let i = 0;
        for(let s1 = 0; s1 < r.length; s1++)i += r[s1], this.distribution[s1] = i;
        return this;
    }
    setRandomGenerator(t) {
        return this.randomFunction = t, this;
    }
    sample(t, e, r) {
        let i = this.distribution[this.distribution.length - 1], s1 = this.binarySearch(this.randomFunction() * i);
        return this.sampleFace(s1, t, e, r);
    }
    binarySearch(t) {
        let e = this.distribution, r = 0, i = e.length - 1, s1 = -1;
        for(; r <= i;){
            let o = Math.ceil((r + i) / 2);
            if (o === 0 || e[o - 1] <= t && e[o] > t) {
                s1 = o;
                break;
            } else t < e[o] ? i = o - 1 : r = o + 1;
        }
        return s1;
    }
    sampleFace(t, e, r, i) {
        let s1 = this.randomFunction(), o = this.randomFunction();
        return s1 + o > 1 && (s1 = 1 - s1, o = 1 - o), nn.a.fromBufferAttribute(this.positionAttribute, t * 3), nn.b.fromBufferAttribute(this.positionAttribute, t * 3 + 1), nn.c.fromBufferAttribute(this.positionAttribute, t * 3 + 2), e.set(0, 0, 0).addScaledVector(nn.a, s1).addScaledVector(nn.b, o).addScaledVector(nn.c, 1 - (s1 + o)), r !== void 0 && nn.getNormal(r), i !== void 0 && this.colorAttribute !== void 0 && (nn.a.fromBufferAttribute(this.colorAttribute, t * 3), nn.b.fromBufferAttribute(this.colorAttribute, t * 3 + 1), nn.c.fromBufferAttribute(this.colorAttribute, t * 3 + 2), Xb.set(0, 0, 0).addScaledVector(nn.a, s1).addScaledVector(nn.b, o).addScaledVector(nn.c, 1 - (s1 + o)), i.r = Xb.x, i.g = Xb.y, i.b = Xb.z), this;
    }
};
function VB(n1) {
    let t = new Float32Array(n1 * n1 * 2);
    for(let e = 0; e < n1; e++)for(let r = 0; r < n1; r++){
        let i = e * n1 + r;
        t[i * 2 + 0] = e / (n1 - 1), t[i * 2 + 1] = r / (n1 - 1);
    }
    return t;
}
function UB(n1) {
    let t = Math.ceil(Math.sqrt(n1));
    return Math.max(t, 1);
}
function kB(n1, t) {
    let e = new Mt(n1.geometry, n1.material), r = [], i = [], s1 = new E, o = new E;
    e.geometry.index !== null && (e.geometry = e.geometry.toNonIndexed());
    let a = new Yb(e).build();
    for(let u1 = 0; u1 < t; u1++)a.sample(s1, o), r.push(s1.x, s1.y, s1.z), i.push(o.x, o.y, o.z);
    let l = new Float32Array(r), c = new Float32Array(i);
    return {
        positions: l,
        normals: c
    };
}
function vM(n1, t) {
    let e = n1, r = new Float32Array(4 * t * t);
    for(let s1 = 0; s1 < t * t; s1++)r[4 * s1] = e[3 * s1], r[4 * s1 + 1] = e[3 * s1 + 1], r[4 * s1 + 2] = e[3 * s1 + 2], r[4 * s1 + 3] = 0;
    let i = new Ur(r, t, t, br, Ut);
    return i.needsUpdate = !0, i;
}
function zB({ size: n1 }) {
    let t = new Float32Array(4 * n1 * n1);
    for(let r = 0; r < n1 * n1; r++)t[4 * r] = r, t[4 * r + 1] = 0, t[4 * r + 2] = 0, t[4 * r + 3] = 0;
    let e = new Ur(t, n1, n1, br, Ut);
    return e.needsUpdate = !0, e;
}
function GB(n1) {
    let t = new Float32Array(4 * n1 * n1);
    for(let r = 0; r < n1 * n1; r++)t[4 * r] = 0, t[4 * r + 1] = 0, t[4 * r + 2] = 0, t[4 * r + 3] = 0;
    let e = new Ur(t, n1, n1, br, Ut);
    return e.needsUpdate = !0, e;
}
var jB = `
// uniform sampler2D uCurrentPosition; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentVelocity; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentEmissionRate; // Pass in the variable from GPGPU
uniform sampler2D uOriginalPosition;
uniform float uTime;
uniform float uSpeed;     // update speed of the particles
uniform vec3 uWorldOffset;    
uniform vec4 uWorldQuaternion;
uniform float uMaxLifeTime;
uniform vec3 uEmitterSize;
uniform float uFPSRatio;     // 1  for 60 FPS

float random (vec2 st) {
    return fract(sin(dot(st.xy,
        vec2(12.9898,78.233)))*
        43758.5453123);
}
vec3 applyQuaternionToVector( vec4 q, vec3 v ){
    return v + 2.0 * cross( q.xyz, cross( q.xyz, v ) + q.w * v );
}

vec3 applyForce(vec3 force, float mass) {
    vec3 acceleration = force / mass;
    
    return acceleration;
  }
  

void main() {
    vec2 vUv = gl_FragCoord.xy / resolution.xy;
    vec3 position = texture2D( uCurrentPosition, vUv ).xyz;
    float currentLife = texture2D( uCurrentPosition, vUv ).w;   // from 1 to 0
    float isSpawning = texture2D( uCurrentEmissionRate, vUv ).r;        // 1. = spawning, 0. = not spawning
    float isActive = texture2D( uCurrentEmissionRate, vUv ).g;          // 1. = active, 0. = not active
    float timeStart = texture2D( uCurrentEmissionRate, vUv ).b;         // timeStart in seconds when the particle was emitted
    vec3 originalPosition = ((texture2D( uOriginalPosition, vUv ).xyz) * uEmitterSize);
    vec3 velocity = texture2D( uCurrentVelocity, vUv ).xyz;
    float collisionFlag = texture2D( uCurrentVelocity, vUv ).w;             // 1. = collided, 0. = not collided
    float lifeTime = uMaxLifeTime;

    // Calculate the position adjustment based on collision
    //     if (collisionFlag > .5) {  
    float isColliding = step(0.5, collisionFlag); // 1.0 if collisionFlag > 0.5, otherwise 0.0
    float bounceOffset = 3.0 * isColliding; // Becomes 3.0 if colliding, 0.0 otherwise
    vec3 collisionAdjustedVelocity = velocity * (1.0 + bounceOffset);

    // Update position based on collision or normal movement
    vec3 fpsVelocity = velocity * min(uFPSRatio, 5.0);
    position += mix(fpsVelocity, collisionAdjustedVelocity, isColliding);

    // EMISSION RATE - BIRTH
    // if (isSpawning == 1.0) {
    // Better Approach to avoid If statement
    vec3 newPosition = applyQuaternionToVector(uWorldQuaternion, originalPosition) + uWorldOffset;
    originalPosition = mix(originalPosition, newPosition, isSpawning);
    position = mix(position, originalPosition, isSpawning);;
    timeStart = mix(timeStart, uTime, isSpawning);

    // Calculate timeLeft for life normalization
    float timeLeft = max(lifeTime - (uTime - timeStart), 0.0);
    float life_Normalize = timeLeft / lifeTime;

    // Use isActive to blend between the calculated color and black
    vec4 activeColor = vec4(position, life_Normalize);
    // if (isActive == 1.0) {
    gl_FragColor = mix(vec4(0.0), activeColor, isActive);

}
`;
var HB = `

    vec3 mod289(vec3 x) {
      return x - floor(x * (1.0 / 289.0)) * 289.0;
    }
    
    vec4 mod289(vec4 x) {
    return x - floor(x * (1.0 / 289.0)) * 289.0;
    }
    
    vec4 permute(vec4 x) {
        return mod289(((x*34.0)+1.0)*x);
    }
    
    vec4 taylorInvSqrt(vec4 r)
    {
    return 1.79284291400159 - 0.85373472095314 * r;
    }
    
    vec3 fade(vec3 t) {
  return t*t*t*(t*(t*6.0-15.0)+10.0);
}

    float snoise(vec3 v)
    {
    const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
    const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);
    vec3 i  = floor(v + dot(v, C.yyy) );
    vec3 x0 =   v - i + dot(i, C.xxx) ;
    vec3 g = step(x0.yzx, x0.xyz);
    vec3 l = 1.0 - g;
    vec3 i1 = min( g.xyz, l.zxy );
    vec3 i2 = max( g.xyz, l.zxy );
    vec3 x1 = x0 - i1 + C.xxx;
    vec3 x2 = x0 - i2 + C.yyy; // 2.0*C.x = 1/3 = C.y
    vec3 x3 = x0 - D.yyy;      // -1.0+3.0*C.x = -0.5 = -D.y
    
    // Permutations
    i = mod289(i);
    vec4 p = permute( permute( permute(
                i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
              + i.y + vec4(0.0, i1.y, i2.y, 1.0 ))
              + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));
    
    // Gradients: 7x7 points over a square, mapped onto an octahedron.
    // The ring size 17*17 = 289 is close to a multiple of 49 (49*6 = 294)
    float n_ = 0.142857142857; // 1.0/7.0
    vec3  ns = n_ * D.wyz - D.xzx;
    
    vec4 j = p - 49.0 * floor(p * ns.z * ns.z);  //  mod(p,7*7)
    
    vec4 x_ = floor(j * ns.z);
    vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)
    
    vec4 x = x_ *ns.x + ns.yyyy;
    vec4 y = y_ *ns.x + ns.yyyy;
    vec4 h = 1.0 - abs(x) - abs(y);
    
    vec4 b0 = vec4( x.xy, y.xy );
    vec4 b1 = vec4( x.zw, y.zw );
    
    vec4 s0 = floor(b0)*2.0 + 1.0;
    vec4 s1 = floor(b1)*2.0 + 1.0;
    vec4 sh = -step(h, vec4(0.0));
    
    vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
    vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;
    
    vec3 p0 = vec3(a0.xy,h.x);
    vec3 p1 = vec3(a0.zw,h.y);
    vec3 p2 = vec3(a1.xy,h.z);
    vec3 p3 = vec3(a1.zw,h.w);
    
    //Normalise gradients
    vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
    p0 *= norm.x;
    p1 *= norm.y;
    p2 *= norm.z;
    p3 *= norm.w;
    
    // Mix final noise value
    vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
    m = m * m;
    return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1),
                                  dot(p2,x2), dot(p3,x3) ) );
    }
    
    vec3 snoiseVec3( vec3 x ){
    
      float s  = snoise(vec3( x ));
      float s1 = snoise(vec3( x.y - 19.1 , x.z + 33.4 , x.x + 47.2 ));
      float s2 = snoise(vec3( x.z + 74.2 , x.x - 124.5 , x.y + 99.4 ));
      vec3 c = vec3( s , s1 , s2 );
      return c;
    
    }
    
      
    vec3 curlNoise( vec3 p, float seed){
      p += seed;
      const float e = .1;
      vec3 dx = vec3( e   , 0.0 , 0.0 );
      vec3 dy = vec3( 0.0 , e   , 0.0 );
      vec3 dz = vec3( 0.0 , 0.0 , e   );
    
      vec3 p_x0 = snoiseVec3( p - dx );
      vec3 p_x1 = snoiseVec3( p + dx );
      vec3 p_y0 = snoiseVec3( p - dy );
      vec3 p_y1 = snoiseVec3( p + dy );
      vec3 p_z0 = snoiseVec3( p - dz );
      vec3 p_z1 = snoiseVec3( p + dz );
    
      float x = p_y1.z - p_y0.z - p_z1.y + p_z0.y;
      float y = p_z1.x - p_z0.x - p_x1.z + p_x0.z;
      float z = p_x1.y - p_x0.y - p_y1.x + p_y0.x;
    
      const float divisor = 1.0 / ( 2.0 * e );
      return normalize( vec3( x , y , z ) * divisor );
    
    }


// Classic Perlin noise
float cnoise(vec3 P)
{
  vec3 Pi0 = floor(P); // Integer part for indexing
  vec3 Pi1 = Pi0 + vec3(1.0); // Integer part + 1
  Pi0 = mod289(Pi0);
  Pi1 = mod289(Pi1);
  vec3 Pf0 = fract(P); // Fractional part for interpolation
  vec3 Pf1 = Pf0 - vec3(1.0); // Fractional part - 1.0
  vec4 ix = vec4(Pi0.x, Pi1.x, Pi0.x, Pi1.x);
  vec4 iy = vec4(Pi0.yy, Pi1.yy);
  vec4 iz0 = Pi0.zzzz;
  vec4 iz1 = Pi1.zzzz;

  vec4 ixy = permute(permute(ix) + iy);
  vec4 ixy0 = permute(ixy + iz0);
  vec4 ixy1 = permute(ixy + iz1);

  vec4 gx0 = ixy0 * (1.0 / 7.0);
  vec4 gy0 = fract(floor(gx0) * (1.0 / 7.0)) - 0.5;
  gx0 = fract(gx0);
  vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0);
  vec4 sz0 = step(gz0, vec4(0.0));
  gx0 -= sz0 * (step(0.0, gx0) - 0.5);
  gy0 -= sz0 * (step(0.0, gy0) - 0.5);

  vec4 gx1 = ixy1 * (1.0 / 7.0);
  vec4 gy1 = fract(floor(gx1) * (1.0 / 7.0)) - 0.5;
  gx1 = fract(gx1);
  vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1);
  vec4 sz1 = step(gz1, vec4(0.0));
  gx1 -= sz1 * (step(0.0, gx1) - 0.5);
  gy1 -= sz1 * (step(0.0, gy1) - 0.5);

  vec3 g000 = vec3(gx0.x,gy0.x,gz0.x);
  vec3 g100 = vec3(gx0.y,gy0.y,gz0.y);
  vec3 g010 = vec3(gx0.z,gy0.z,gz0.z);
  vec3 g110 = vec3(gx0.w,gy0.w,gz0.w);
  vec3 g001 = vec3(gx1.x,gy1.x,gz1.x);
  vec3 g101 = vec3(gx1.y,gy1.y,gz1.y);
  vec3 g011 = vec3(gx1.z,gy1.z,gz1.z);
  vec3 g111 = vec3(gx1.w,gy1.w,gz1.w);

  vec4 norm0 = taylorInvSqrt(vec4(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));
  g000 *= norm0.x;
  g010 *= norm0.y;
  g100 *= norm0.z;
  g110 *= norm0.w;
  vec4 norm1 = taylorInvSqrt(vec4(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));
  g001 *= norm1.x;
  g011 *= norm1.y;
  g101 *= norm1.z;
  g111 *= norm1.w;

  float n000 = dot(g000, Pf0);
  float n100 = dot(g100, vec3(Pf1.x, Pf0.yz));
  float n010 = dot(g010, vec3(Pf0.x, Pf1.y, Pf0.z));
  float n110 = dot(g110, vec3(Pf1.xy, Pf0.z));
  float n001 = dot(g001, vec3(Pf0.xy, Pf1.z));
  float n101 = dot(g101, vec3(Pf1.x, Pf0.y, Pf1.z));
  float n011 = dot(g011, vec3(Pf0.x, Pf1.yz));
  float n111 = dot(g111, Pf1);

  vec3 fade_xyz = fade(Pf0);
  vec4 n_z = mix(vec4(n000, n100, n010, n110), vec4(n001, n101, n011, n111), fade_xyz.z);
  vec2 n_yz = mix(n_z.xy, n_z.zw, fade_xyz.y);
  float n_xyz = mix(n_yz.x, n_yz.y, fade_xyz.x); 
  return 2.2 * n_xyz;
}


vec3 fbm_vec3(vec3 p, float frequency, float offset)
{
  return vec3(
    cnoise((p+vec3(offset))*frequency),
    cnoise((p+vec3(offset+20.0))*frequency),
    cnoise((p+vec3(offset-30.0))*frequency)
  );
}

`;
var WB = `
  #ifdef USE_COLLIDER
    float restitution = max(uBounce * 2., .01); // Energy Loss
    // SPHERE COLLIDER
    // **************************************************************
    #ifdef USE_SPHERE_COLLIDER       
      // Convert collider size to radii (assuming uColliderSize is the diameter in each axis)
      vec3 radii = uColliderSize;
      // Adjust position relative to collider
      vec3 relPos = position - uColliderPos;
      // Apply rotation of the collider to the relative position
      relPos = applyQuaternionToVector(uColliderQuaternionInvert, relPos);            
      // Scale relative position by radii (for ellipsoid collision detection)
      vec3 scaledPos = relPos / radii;
      // Calculate ellipsoidal distance
      float dist = length(scaledPos); // Distance in terms of ellipsoid
      
      // Check for collision
      if (dist <= 1. + particleSize / length(radii) && collisionFlag == 0.0) {
          // Compute the normal at the collision point, accounting for particle size
        vec3 adjustedPos = scaledPos * (1.0 + particleSize / length(radii));          
        // Compute the normal at the collision point
        vec3 normal = ellipsoidNormal(adjustedPos, radii);
        // Rotate the normal back to world space
        normal = applyQuaternionToVector(uColliderQuaternion, normal);
        // Reflect the velocity vector off the normal
        velocity = reflect(velocity, normal) * restitution;

        collisionFlag = 1.0;
      } else {
        collisionFlag = 0.0;
      }
    #endif

    // BOX COLLIDER or PLANE COLLIDER 
    // **************************************************************
    #ifdef USE_BOX_COLLIDER
      // Box dimensions and repulsion variables
      vec3 boxHalfSize = uColliderSize / 2.0;
      // Convert world position to box's local space
      vec3 localPos = applyQuaternionToVector(uColliderQuaternionInvert, position - uColliderPos);      
      // Collision detection
      vec3 localDistance = abs(localPos) - boxHalfSize;
      float distToSurface = max(localDistance.x, max(localDistance.y, localDistance.z));    

      // Collision Detected
      if (distToSurface <= particleSize * 0.5 && collisionFlag == 0.0) {      
        // Find the nearest face normal for bounce direction
        vec3 normal;
        if (localDistance.x > localDistance.y && localDistance.x > localDistance.z) {
            normal = vec3(sign(localPos.x), 0.0, 0.0);
        } else if (localDistance.y > localDistance.z) {
            normal = vec3(0.0, sign(localPos.y), 0.0);
        } else {
            normal = vec3(0.0, 0.0, sign(localPos.z));
        }            
        // Rotate normal back to world space
        normal = applyQuaternionToVector(uColliderQuaternion, normal);      
        // Reflect velocity and apply repulsion force
        velocity = reflect(velocity, normal) * restitution;
        
        collisionFlag = 1.0;
      } else {
        collisionFlag = 0.0;
      }
    #endif      
  #endif      
  // END COLLIDER    
`;
var qB = `
  #ifdef USE_ATTRACTOR

      #ifdef USE_SPHERE_COLLIDER      
        // Convert collider size to radii (assuming uColliderSize is the diameter in each axis)
        vec3 radii = uColliderSize;
        // Adjust position relative to collider
        vec3 relPos = position - uColliderPos;
        // Apply rotation of the collider to the relative position
        relPos = applyQuaternionToVector(uColliderQuaternionInvert, relPos);            
        // Scale relative position by radii (for ellipsoid collision detection)
        vec3 scaledPos = relPos / radii;
        // Calculate ellipsoidal distance
        float distToSurface = length(scaledPos); // Distance in terms of ellipsoid
        float insideCheck = 1.0;

      #endif


      #ifdef USE_BOX_COLLIDER
        // Box dimensions
        vec3 boxHalfSize = uColliderSize / 2.0;
        // Convert world position to box's local space
        vec3 localPos = applyQuaternionToVector(uColliderQuaternionInvert, position - uColliderPos);      
        vec3 localDistance = abs(localPos) - boxHalfSize;
        float distToSurface = max(localDistance.x, max(localDistance.y, localDistance.z));
        float insideCheck = particleSize;
      #endif      
  
      // Apply vortex force inside the Helper
      #ifdef USE_FORCE_LOCAL_SPACE
        if (distToSurface <= insideCheck ) {    
            // Define parameters for the attractor field
            #ifdef USE_SPHERE_COLLIDER      
              float attractorStrength = (1.0 - distToSurface ) * uForceIntensity; // Adjust as needed
            #endif

            #ifdef USE_BOX_COLLIDER
              float attractorStrength = max((1.0 - insideCheck / distToSurface), 0.) * uForceIntensity; // Adjust as needed
              #endif

            float attractorDamping = uForceDamping;  // Adjust as needed (higher values will attenuate velocity more)
          
            // Use the same radii calculation code as for the collider
            vec3 attractorRadii = uColliderSize;
            // Adjust position relative to attractor center
            vec3 relPos = position - uColliderPos;
            // Apply rotation of the collider to the relative position
            relPos = applyQuaternionToVector(uColliderQuaternionInvert, relPos);            
            // Scale relative position by radii (for ellipsoid attraction)
            vec3 scaledPos = relPos / attractorRadii;

            // Calculate ellipsoidal distance as attractor radius
            float attractorRadius = length(scaledPos);
            // Calculate the distance from the attractor center
            vec3 relativePosition = position - uColliderPos;
            // Calculate the force vector towards the attractor center
            vec3 attractorForce = normalize(relativePosition) * attractorStrength;
            // Apply the attractor force to the particle
            velocity -= attractorForce;
            // Attenuate the particle's velocity
            velocity *= attractorDamping;
        }
      #else 
            // Calculate the distance from the attractor center
            vec3 relativePosition = position - uColliderPos;
            // Calculate the force vector towards the attractor center
            vec3 attractorForce = normalize(relativePosition) * uForceIntensity;
            // Apply the attractor force to the particle
            velocity -= attractorForce;
            // Attenuate the particle's velocity
            velocity *= uForceDamping;
      #endif    
  #endif      
`;
var XB = `
  #ifdef USE_VORTEX
    // Box dimensions
    vec3 boxHalfSize = uColliderSize / 2.0;
    // Convert world position to box's local space
    vec3 localPos = applyQuaternionToVector(uColliderQuaternionInvert, position - uColliderPos);      
    vec3 localDistance = abs(localPos) - boxHalfSize;
    float distToSurface = max(localDistance.x, max(localDistance.y, localDistance.z));

    // Apply vortex force inside the box
    if (distToSurface <= particleSize) {
      float vortexStrength = uForceIntensity;
      vec3 localTopCenter = vec3(0.0, 0., 0.0);

      // Transform the local top center to the world space
      vec3 vortexCenter = uColliderPos + applyQuaternionToVector(uColliderQuaternion, localTopCenter);
      // Calculate the vector from particle to vortex center
      vec3 vortexVector = vortexCenter - position;

      // Calculate the rotation axis from the inverse of the collider's quaternion and the fixed up vector
      // Note: important to add a tiny z component to the up vector to avoid instability
      vec3 upVector = vec3(0.0, 1.0, 0.01);
      vec3 rotationAxis = cross(upVector, applyQuaternionToVector(uColliderQuaternion, vortexVector));
      rotationAxis = normalize(rotationAxis);

      // Add rotational component to velocity
      float rotationSpeed = length(vortexVector * vortexStrength * 3.0) ; 

      vec3 rotationVelocity = rotationAxis * rotationSpeed;
      // velocity += rotationVelocity * 0.005 ;
      velocity = rotationVelocity * 0.005 ;

      // Calculate vortex force
      // vec3 vortexForce = normalize(vortexVector) * uSpeed * .1 ;
      // Apply the vortex force to the particle
      vec3 originDirection = applyQuaternionToVector(uWorldQuaternion, directions);
      velocity += applyForce( originDirection * uSpeed * (1. - uForceDamping) , mass * .5);
    }
  #endif      
`;
var YB = `
// uniform sampler2D uCurrentPosition; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentVelocity; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentEmissionRate; // Pass in the variable from GPGPU
uniform sampler2D uOriginalPosition;
uniform sampler2D uDirections;     
uniform vec3 uDirectionsAxis;
uniform vec4 uWorldQuaternion;
uniform vec3 uGravity;        
uniform float uNoiseStrength;     // Variation of the noise
uniform float uNoiseScale;        // Scale of the noise
uniform float uNoiseSeed;         // Seed of the noise
uniform float particleSize;
uniform float uSpeed;     // update speed of the particles
uniform float uRandomMassFactor;

// COLLIDER
uniform vec3 uColliderPos;                // Collider Position
uniform vec3 uColliderSize;               // Collider Dimension
uniform vec4 uColliderQuaternion;         // Collider Rotation
uniform vec4 uColliderQuaternionInvert;   // Collider Rotation
uniform float uBounce;                    // Bounce factor
uniform float uForceDamping;
uniform float uForceIntensity;


` + HB + `
float rand(vec2 co){
    return fract(sin(dot(co, vec2(12.9898, 78.233))) * 43758.5453);
}
vec3 applyQuaternionToVector( vec4 q, vec3 v ){
    return v + 2.0 * cross( q.xyz, cross( q.xyz, v ) + q.w * v );
 } 
vec3 applyForce(vec3 force, float mass) {
  vec3 acceleration = force / mass;
  
  return acceleration;
}

vec4 conjugate(vec4 q) {
  return vec4(q.w, -q.x, -q.y, -q.z);
}

// Function to compute the normal of the ellipsoid at a given point
vec3 ellipsoidNormal(vec3 p, vec3 radii) {
  return normalize(p / (radii * radii));
}

float friction = .3;

void main() {
    vec2 vUv = gl_FragCoord.xy / resolution.xy;
    vec3 position = texture2D( uCurrentPosition, vUv ).xyz;
    vec3 originalPosition = texture2D( uOriginalPosition, vUv ).xyz;
    float timeLeft = texture2D( uCurrentPosition, vUv ).w;
    vec3 directions = texture2D( uDirections, vUv ).xyz;    
    vec3 velocity = texture2D( uCurrentVelocity, vUv ).xyz;
    float mass = rand(originalPosition.xy) * 0.5 + 0.5;
    float isSpawning = texture2D( uCurrentEmissionRate, vUv ).x;        // 1. = spawning, 0. = not spawning
    float isActive = texture2D( uCurrentEmissionRate, vUv ).y;          // 1. = active, 0. = not active
    float collisionFlag =texture2D( uCurrentVelocity, vUv ).w;          // Indicate collision

    // Randomness Mass
    mass = (1.0 - (uRandomMassFactor * mass));
    
    if (isActive == 1.0) {
      // **************************************************************
      // FORCES NOISES
      // **************************************************************
      #ifdef USE_CURL_NOISE
        if (uNoiseScale > 0.0 ) {
          velocity = curlNoise(position * uNoiseScale * .002, uNoiseSeed) * ( uNoiseStrength + 1.0) * .05 * uSpeed;
        }
        // Variation of the noise Over Time
        if (uNoiseStrength > 0.0 && uNoiseScale == 0.0 ) {
          velocity += curlNoise( position, uNoiseSeed)  * uNoiseStrength * 0.05 * uSpeed;
        }
      #endif
      // **************************************************************
      #ifdef USE_SIMPLEX_NOISE
        if (uNoiseScale > 0.0 ) {
          velocity = vec3(snoise(position * uNoiseScale * .001) * ( uNoiseStrength + 1.0) * .1);
          velocity *= uSpeed;
        }
        // Variation of the noise Over Time
        if (uNoiseStrength > 0.0 && uNoiseScale == 0.0) {
          velocity += vec3(snoise(position * uNoiseStrength * .001) * .05 * uSpeed);
        }
      #endif
      // ************************************************************** 
      #ifdef USE_FBM_NOISE
        if (uNoiseScale > 0.0 ) {
          velocity = fbm_vec3(position * uNoiseScale * .001, ( uNoiseStrength + 1.0), uNoiseSeed);
          velocity *= uSpeed;
        }
        // Variation of the noise Over Time
        if (uNoiseStrength > 0.0 && uNoiseScale == 0.0 ) {      
          velocity += fbm_vec3(position * uNoiseStrength * .001, ( uNoiseStrength + 1.0), uNoiseSeed) * .1 * uSpeed;
        }
      #endif

      // COLLIDER
      ${WB}
      // ATTRACTION
      ${qB}  
      // VORTEX
      ${XB}
    } 
    // End isActive

    // SPAWN BIRTH 
    // **************************************************************
    // if (isSpawning == 1.)
    #ifdef USE_NORMALS
      velocity = mix(velocity, applyQuaternionToVector(uWorldQuaternion, directions) * uSpeed, isSpawning);
    #else
      velocity = mix(velocity, applyQuaternionToVector(uWorldQuaternion, uDirectionsAxis) * uSpeed, isSpawning);    
    #endif
    
    // if (collisionFlag == 0.0)
    velocity += applyForce(uGravity, mass * .5) * (1.0 - collisionFlag);

    gl_FragColor = vec4(velocity, collisionFlag);
}
`;
var xM = `

  // Linear Fade In
  float linearFadeIn(float t) {
    return t;
  }


  // linear fade out
  float linearFadeOut(float t) {
    return 1.0 - t;
  }
  
  float linearInOut(float t) {
    return t < 0.5 ? t :  (1.0 - t);  
  }

    // lerp
    float lerp(float a, float b, float t) {
      return a + (b - a) * t;
    }

  // Ease In Out Quart
  float exponentialInOut(float t) {
    return t < 0.4 ? lerp(0.0, 1.0, t / 0.4) :
    t > 0.6 ? lerp(1.0, 0.0, (t - 0.6) / 0.4) :
    1.0;
   }

  // constant
  float constant(float t) {
    return 1.0;
  } 
`;
var KB = `

float rand(vec3 co){
  return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);
}

vec3 applyQuaternionToVector( vec4 q, vec3 v ){
  return v + 2.0 * cross( q.xyz, cross( q.xyz, v ) + q.w * v );
}

vec3 applyForce(vec3 force, float mass) {
  vec3 acceleration = force / mass;
    
  return acceleration;
}
`;
var QB = `
vec3 rgb2xyz (in vec3 rgb) {
    float r = rgb.r;
	float g = rgb.g;
	float b = rgb.b;

	r = r > 0.04045 ? pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	float x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	float y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	float z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
    
    vec3 xyz = vec3(
        (r * 0.4124) + (g * 0.3576) + (b * 0.1805) * 100.0,
        (r * 0.2126) + (g * 0.7152) + (b * 0.0722) * 100.0,
        (r * 0.0193) + (g * 0.1192) + (b * 0.9505) * 100.0
    );
    return(xyz);
}

vec3 xyz2lab (in vec3 xyz) {
	float x = xyz.x / 95.047;
	float y = xyz.y / 100.0;
	float z = xyz.z / 108.883;

	x = x > 0.008856 ? pow(x, 1.0 / 3.0) : (7.787 * x) + (16.0 / 116.0);
	y = y > 0.008856 ? pow(y, 1.0 / 3.0) : (7.787 * y) + (16.0 / 116.0);
	z = z > 0.008856 ? pow(z, 1.0 / 3.0) : (7.787 * z) + (16.0 / 116.0);

    vec3 lab = vec3((116.0 * y) - 16.0, 500.0 * (x - y), 200.0 * (y - z));
    return(lab);
}

vec3 rgb2lab(in vec3 rgb) {
    vec3 xyz = rgb2xyz(rgb);
    vec3 lab = xyz2lab(xyz);
    return(lab);
}

vec3 xyz2rgb (in vec3 xyz) {
	float x = xyz.x / 100.0;
	float y = xyz.y / 100.0;
	float z = xyz.z / 100.0;
	
    
	float r = (x *  3.2406) + (y * -1.5372) + (z * -0.4986);
	float g = (x * -0.9689) + (y *  1.8758) + (z *  0.0415);
	float b = (x *  0.0557) + (y * -0.2040) + (z *  1.0570);

	r = r > 0.0031308 ? ((1.055 * pow(r, 1.0 / 2.4)) - 0.055) : r * 12.92;
	g = g > 0.0031308 ? ((1.055 * pow(g, 1.0 / 2.4)) - 0.055) : g * 12.92;
	b = b > 0.0031308 ? ((1.055 * pow(b, 1.0 / 2.4)) - 0.055) : b * 12.92;

	r = min(max(0.0, r), 1.0);
	g = min(max(0.0, g), 1.0);
	b = min(max(0.0, b), 1.0);

	return(vec3(r, g, b));
}

vec3 lab2xyz (in vec3 lab) {
    float l = lab.x;
	float a = lab.y;
	float b = lab.z;

  	float y = (l + 16.0) / 116.0;
	float x = a / 500.0 + y;
	float z = y - b / 200.0;

	float y2 = pow(y, 3.0);
	float x2 = pow(x, 3.0);
	float z2 = pow(z, 3.0);

  	y = y2 > 0.008856 ? y2 : (y - 16.0 / 116.0) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16.0 / 116.0) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16.0 / 116.0) / 7.787;

	x *= 95.047;
	y *= 100.0;
	z *= 108.883;

	return(vec3(x, y, z));
}
vec3 lab2rgb (in vec3 lab) {
    vec3 xyz = lab2xyz(lab);
    vec3 rgb = xyz2rgb(xyz);
    return(rgb);
}

`;
var ZB = `
  uniform sampler2D uPosition;
  uniform float uSize;
  uniform float uSizeEnd;
  uniform vec3 uWorldOffset;
  uniform vec4 uWorldQuaternion;
  // Billboard Behavior - Currently at Zero, but we can change that
  uniform float uRotation;
  uniform float uRotationEnd;
  uniform vec2 center;

  // Randomness
  uniform float uRandScaleFactor;
  uniform float uRandRotationFactor;

  attribute vec2 ref;

  varying float v_LifeLeft;    // normalized lifetime 1 to 0
  varying vec2 vUv;
  varying vec2 vRef;

  ${KB}
  ${xM}
`, JB = ({ easeSize: n1 = "linearFadeOut" })=>`
  vUv = uv;  
  vRef = ref;
  // Normalized LifeTime 1 to 0
  float lifeLeft = texture2D(uPosition, ref).w;
  v_LifeLeft = lifeLeft;
  // Position From DataTexture Simulation
  vec3 pos = texture2D(uPosition, ref).rgb - uWorldOffset;
  // Apply World Quaternion
  pos = applyQuaternionToVector(uWorldQuaternion, pos);  
            
  #ifdef  USE_SIZE_END
    // Scaled Over Time
    float t = 1. - lifeLeft;
    float currentSize = mix(uSize, uSizeEnd, t); // Linearly interpolate between uSize and uSizeEnd
    vec3 scaledPosition = position * vec3(currentSize);
  #else
    // Change Size Behavior over LifeTime
    float easeSize = ${n1}(1. - lifeLeft);
    // Scaled Over Time
    vec3 scaledPosition = position * vec3(uSize * easeSize);
  #endif

  // Billboard Behavior
  vec2 scale;
  scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
  scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );    
  // Randomness 
  float randRef = rand(ref);
  scale *= (1.0 - (uRandScaleFactor * randRef));
  // Rotation
  float randRotation =  2.0 * PI * ( uRandRotationFactor * randRef);
  float originalRotation = (1.0 - uRotation) * 2.0 * PI;
  float originalRotationEnd = (1.0 - uRotationEnd) * 2.0 * PI;
  // OverTime
  float finalRotation = mix(originalRotation + randRotation, originalRotationEnd + randRotation, lifeLeft);

  vec2 alignedPosition = ( scaledPosition.xy - ( center - vec2( 0.5 ) ) ) * scale;
  vec2 rotatedPosition;
  rotatedPosition.x = cos( finalRotation ) * alignedPosition.x - sin( finalRotation ) * alignedPosition.y;
  rotatedPosition.y = sin( finalRotation ) * alignedPosition.x + cos( finalRotation ) * alignedPosition.y;
  
  mat4 instanceMatrix = mat4(
    vec4(1.0, 0.0, 0.0, 0.0),
    vec4(0.0, 1.0, 0.0, 0.0),
    vec4(0.0, 0.0, 1.0, 0.0),
    vec4(pos.x, pos.y, pos.z, 1.0)
  );  

  mvPosition = modelViewMatrix * instanceMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
  mvPosition.xy += rotatedPosition;
  gl_Position = projectionMatrix  * mvPosition;   
`, $B = `
  uniform vec4 uColor;                // start color
  uniform vec4 uColor2;               // end color
  uniform sampler2D uTexture;         // texture
  varying float v_LifeLeft;   // normalized lifetime 1 to 0
  varying vec2 vUv;
  varying vec2 vRef;

  float random(vec2 co) {
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
  }
  ` + xM + `  
  ${QB}

`, eF = ({ easeOpacity: n1 = "linearFadeOut" })=>`  
  // if Particle is dead, hide it
  if (v_LifeLeft <= 0.005 ) {
    discard;
  }

  #ifdef USE_RANDOM_COLORING
    float randVal = random(vRef); // Generate a random value based on the reference
    vec4 color = mix(uColor, uColor2, randVal); // Interpolate between the two colors
  #else
    vec4 color = mix(uColor, uColor2, 1. - v_LifeLeft);
  #endif

  // Opacity over Life Time
  float finalAlpha = ${n1}(1. - v_LifeLeft);  
  vec4 textureColor = texture2D(uTexture, vUv).rgba; 
  finalColor = textureColor.rgb * color.rgb;
  finalAlpha = color.a * textureColor.a * finalAlpha;
  
  gl_FragColor = vec4(finalColor, finalAlpha);     

`;
var Kb = class extends $e {
    constructor(e, r){
        super();
        this.needsJitter = !0;
        this.type = "ParticleMaterial";
        this.easeOpacity = "linearFadeIn";
        this.easeSize = "linearFadeIn";
        this.useSizeEnd = !1;
        this.isColoringRandom = !1;
        this.init(e, r), this.context = r;
    }
    reset() {}
    init(e, r) {
        this.transparent = !0, this.depthTest = !0, this.depthWrite = !1, this.easeOpacity = e.ease, this.easeSize = e.easeSize, this.layers = [], pr.startContext(pr.globalContext), this.lightLayer = new Pn(0, "", {
            ...Cr.defaultData("light", "phong"),
            visible: !1
        }, new Qa, {}, r.shared), pr.endContext(pr.globalContext), this.build();
    }
    updateState(e) {
        e.coloring !== void 0 && (this.isColoringRandom = e.coloring === "random"), e.color !== void 0 && (e.color instanceof Array ? this.uniforms.uColor.value = e.color : this.uniforms.uColor.value = this.context.shared.color(e.color)), e.color2 !== void 0 && (e.color2 instanceof Array ? this.uniforms.uColor2.value = e.color2 : this.uniforms.uColor2.value = this.context.shared.color(e.color2)), e.size !== void 0 && (this.uniforms.uSize.value = e.size[0], this.uniforms.uSizeEnd.value = e.size[1], e.size[0] !== e.size[1] ? this.useSizeEnd = !0 : this.useSizeEnd = !1), e.ease !== void 0 && (this.easeOpacity = e.ease, this.build()), e.easeSize !== void 0 && (this.easeSize = e.easeSize, this.build()), this.needsUpdate = !0;
    }
    onBeforeCompile(e) {
        this.build(), e.defines = this.defines, e.uniforms = this.uniforms, e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader;
    }
    build() {
        let e = new cf;
        return e.needsJitter = this.needsJitter, e.addFragmentParsCode(xL), e.buildShader("vertex", this.fragment), e.buildShader("fragment", this.fragment), e.addFragmentFinalCode(bL), this.isColoringRandom && e.define("USE_RANDOM_COLORING"), this.useSizeEnd && e.define("USE_SIZE_END"), e.addVertexParsCode(ZB), e.addFragmentParsCode($B), e.addVertexFinalCode(JB({
            easeSize: this.easeSize
        })), e.addFragmentFinalCode(eF({
            easeOpacity: this.easeOpacity
        })), this.vertexShader = e.getCode("vertex"), this.fragmentShader = e.getCode("fragment"), this.defines = e.defines, this.uniforms = {
            ...e.uniforms,
            ...this.uniforms
        }, this.extensions = e.extensions, this;
    }
    get nodeMaterial() {
        return this;
    }
    get fragment() {
        return this.lightLayer.node;
    }
    getDefines() {
        return this.defines;
    }
    nodeMaterialDispose() {
        this.layers.forEach((e)=>e.dispose()), super.dispose();
    }
};
var Jf = class {
    constructor(t, e, r, i){
        this.type = "SphereEmitterShape";
        this.targetMesh = void 0;
        this.size = t, this.type = r, this.textureSize = UB(e);
        let s1 = 1;
        this.targetMesh = i?.geometry.type === "BufferGeometry" || i?.type === "Mesh" && i && i.geometry.hasAttribute("position") && i.geometry.hasAttribute("normal") ? i : this.getMesh(r, s1);
        let { positions: o, dataTexture: a, dataTextureNormals: l } = this.createPositions(this.textureSize, this.targetMesh ?? this.getMesh(r, s1));
        this.positionsTexture = a, this.positionsAttribute = o, this.directionsTexture = l;
    }
    createPositions(t, e) {
        let { positions: r, normals: i } = kB(e, t * t), s1 = vM(r, t), o = vM(i, t);
        return {
            dataTexture: s1,
            positions: r,
            dataTextureNormals: o
        };
    }
    getMesh(t, e) {
        let r = null;
        switch(t){
            case "SphereEmitterShape":
                r = new qs(e * .5, 32, 32);
                break;
            case "TorusEmitterShape":
                r = new uh(e * .5, .3, 15, 40);
                break;
            case "ConeEmitterShape":
                r = new Al(e, e, 15);
                break;
            case "BoxEmitterShape":
                r = new bi(e, e, e);
                break;
            case "PlaneEmitterShape":
                r = new Si(e, e), r.rotateX(-Math.PI / 2);
                break;
            case "MeshEmitterShape":
                r = new qs(e, 32, 32);
                break;
            default:
                r = new qs(e, 32, 32);
                break;
        }
        return new Mt(r, new un({
            color: 16711680
        }));
    }
    applyToShader(t, e) {
        this.size = new E().fromArray(e.size.map((r)=>typeof r == "number" ? r : 1)), t.uEmitterSize.value = this.size;
    }
    dispose() {
        this.positionsTexture.dispose(), this.directionsTexture.dispose(), this.positionsAttribute = new Float32Array;
    }
};
function vc(n1) {
    let t = {
        ...n1
    }, e = ud.defaultData;
    t.forceFieldObjectId && (t.colliderEntityId = t.forceFieldObjectId);
    let r = {
        ...e.shape,
        ...t.shape
    }, i = {
        ...e.renderMaterial,
        ...t.renderMaterial
    };
    return {
        ...e,
        ...t,
        shape: r,
        renderMaterial: i
    };
}
var tF = `
// uniform sampler2D uCurrentPosition; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentVelocity; // Pass in the variable from GPGPU
// uniform sampler2D uCurrentEmissionRate; // Pass in the variable from GPGPU

uniform sampler2D uIndex; // Texture with corresponding index
uniform float uLastIndexEmitted; // Last emitted index
uniform float uParticlesToEmit; // Number of particles to emit on that frame
uniform float uTime;

void main() {
    vec2 vUv = gl_FragCoord.xy / resolution.xy;
    float particleIndex = texture(uIndex, vUv).x;
    float timeLeft = texture2D( uCurrentPosition, vUv ).w;
    float isActive = texture2D( uCurrentEmissionRate, vUv ).g;    // 1. = active, 0. = not active
    float timeStart = texture2D( uCurrentEmissionRate, vUv ).b;


    // ********** Detect Colision to Create a flag and use it in position **********
    // We are doing this here, so

    // ********** Emit Particles **********
    // X = isSpawning 0.0 or 1.0
    // Y = isActive 0.0 or 1.0
    // Check if the vertex index is between the first value and the last value
    // if (particleIndex >= uLastIndexEmitted && particleIndex < uLastIndexEmitted + uParticlesToEmit) {
    //     // Emit a particle by writing 1 to the red channel of the color output
    //     // r: 1. == emit the particle
    //     // g: 1. == particle is now active
    //     timeStart = uTime;
    //     gl_FragColor = vec4(1.0, 1.0, timeStart, 1.0);
    // } else {
    //     // The Particle is either already emitted or not in the range of the particles to emit
    //     // Do not emit a particle by writing 0 to the red channel of the color output        
    //     gl_FragColor = vec4(0.0, isActive, timeStart, 1.0);
    // }
    // Determine if the particle is within the emission range
    float emitLowerBound = step(uLastIndexEmitted, particleIndex);
    float emitUpperBound = step(particleIndex, uLastIndexEmitted + uParticlesToEmit - 1.0);
    float emitParticle = emitLowerBound * emitUpperBound; // 1.0 if in range, 0.0 otherwise

    // Set timeStart and color
    timeStart = mix(timeStart, uTime, emitParticle);
    gl_FragColor = vec4(emitParticle, mix(isActive, 1.0, emitParticle), timeStart, 1.0);


}
`;
var bM = 10, Qb = class extends Dt {
    constructor(e, r){
        super();
        this.type = "ParticleEmitter";
        this.debugMode = !1;
        this.worldSpace = !0;
        this.rootObject = null;
        this.gpuCompute = null;
        this.positionSimRT = null;
        this.velocitySimRT = null;
        this.emissionRateSimRT = null;
        this.emitterShape = void 0;
        this.isEmitting = !1;
        this.hasBeenReset = !1;
        this.emittedParticlesAmount = 0;
        this.lastEmitTime = 0;
        this.globalTime = 0;
        this.targetFPS = 60;
        this.previousRatio = 1;
        this.lerpFactor = .4;
        this.particlesAmount = 0;
        this.noiseStrength = 0;
        this.noiseScale = 0;
        this.isBillboardBased = !0;
        this.simFeaturesDefinition = {
            USE_COLLIDER: !1,
            USE_ATTRACTOR: !1,
            USE_VORTEX: !1,
            USE_SPHERE_COLLIDER: !1,
            USE_BOX_COLLIDER: !1,
            USE_FORCE_LOCAL_SPACE: !1,
            USE_NORMALS: !1,
            USE_CURL_NOISE: !0,
            USE_SIMPLEX_NOISE: !1,
            USE_FBM_NOISE: !1
        };
        this.textureLoader = new Jy;
        this.currentWorldPosition = new E;
        this.systemQuaternion = new Ye;
        this.worldGravity = new E(0, 0, 0);
        this.directionAxis = new E(0, 0, 0);
        this.colliderV3 = new E(0, 0, 0);
        this.colliderQuaternion = new Ye(0, 0, 0, 1);
        this.matrixAutoUpdate = !0, this.renderer = e, this.system = r, this.shared = r.context.shared;
        let i = r.data;
        this.material = new Kb(i.renderMaterial, r.context), this.material.uniforms = {
            uSize: {
                value: 0
            },
            uSizeEnd: {
                value: 0
            },
            uColor: {
                value: i.renderMaterial.color
            },
            uColor2: {
                value: i.renderMaterial.color2
            },
            uPosition: {
                value: new E(0, 0, 0)
            },
            uEmissionData: {
                value: new E(0, 0, 0)
            },
            uTexture: {
                value: this.defaultTexture
            },
            uWorldOffset: {
                value: new E(0, 0, 0)
            },
            uWorldQuaternion: {
                value: new Ze(0, 0, 0, 1)
            },
            uRandScaleFactor: {
                value: i.randomScale ?? 0
            },
            uRandRotationFactor: {
                value: i.randomRotation ?? 0
            },
            uRotation: {
                value: i.renderMaterial.spriteRotation[0] ?? 0
            },
            uRotationEnd: {
                value: i.renderMaterial.spriteRotation[1] ?? 0
            }
        }, this.setTexture(this.material.uniforms, i.renderMaterial.texture), this.init(i);
    }
    setTexture(e, r) {
        let i = r.data;
        if (typeof r == "string") {
            let s1 = this.shared.image(r), o = new Zt(s1.img);
            o.needsUpdate = !0, e.uTexture.value = o;
            return;
        }
        if (typeof i != "string") {
            let s1 = new Image;
            s1.onload = ()=>{
                let l = new Zt(s1);
                l.needsUpdate = !0, e.uTexture.value = l;
            };
            let o = new Blob([
                i
            ], {
                type: "image/*"
            }), a = URL.createObjectURL(o);
            s1.src = a;
        }
    }
    updateGeometryAttributes(e, r) {
        let i = VB(r);
        !this.emitterShape?.positionsAttribute || e.geometry.setAttribute("ref", new Mo(i, 2));
    }
    applyWorldSpace() {
        if (!this.system.started || !this.worldSpace || !this.positionSimRT || !this.velocitySimRT) return;
        let e = this.system;
        e.getWorldQuaternion(this.systemQuaternion), this.systemQuaternion.invert(), e.getWorldPosition(this.currentWorldPosition), this.material.uniforms.uWorldOffset.value = this.currentWorldPosition, this.material.uniforms.uWorldQuaternion.value.copy(this.systemQuaternion.normalize()), this.positionSimRT.material.uniforms.uWorldOffset.value = this.currentWorldPosition, this.systemQuaternion.invert(), this.positionSimRT.material.uniforms.uWorldQuaternion.value.copy(this.systemQuaternion.normalize()), this.velocitySimRT.material.uniforms.uWorldQuaternion.value.copy(this.systemQuaternion.normalize());
    }
    update(e, r) {
        if (!this.gpuCompute || !this.positionSimRT || !this.velocitySimRT || !this.emissionRateSimRT || this.hasBeenReset) return;
        if (this.checkIfAllParticlesAreDead() && !this.hasBeenReset) {
            this.reset();
            return;
        }
        this.applyWorldSpace(), this.globalTime = e, this.positionSimRT.material.uniforms.uTime.value = e, this.emissionRateSimRT.material.uniforms.uTime.value = e;
        let i = 1e3 / r, s1 = this.targetFPS / i, o = this.previousRatio + (s1 - this.previousRatio) * this.lerpFactor;
        this.positionSimRT.material.uniforms.uFPSRatio.value = o, this.previousRatio = o;
        let a = this.isEmitting ? this.GoEmitSomeParticles(e, this.system.data.birthRatePerSec) : 0;
        this.emissionRateSimRT.material.uniforms.uLastIndexEmitted.value = this.emittedParticlesAmount, this.emissionRateSimRT.material.uniforms.uParticlesToEmit.value = a, this.material.uniforms.uPosition.value = this.gpuCompute.getCurrentRenderTarget(this.positionSimRT)?.texture, this.system.colliderEntities.length > 0 && this.renderColliders(), this.gpuCompute.compute();
    }
    renderColliders() {
        if (!this.velocitySimRT) return;
        let e = this.system.colliderEntities[0], r = this.simFeaturesDefinition.USE_COLLIDER || this.simFeaturesDefinition.USE_ATTRACTOR || this.simFeaturesDefinition.USE_VORTEX;
        if (e.destroyedInAction && r && this.init(vc({
            ...this.system.data,
            colliderEntityId: null
        })), !e || e.destroyedInAction) return;
        e.getWorldPosition(this.colliderV3), this.colliderV3.y === 0 && (this.colliderV3.y = 1e-4), this.velocitySimRT.material.uniforms.uColliderPos.value.copy(this.colliderV3);
        let i = e.data.size;
        this.colliderV3.fromArray(i), this.velocitySimRT.material.uniforms.uColliderSize.value.copy(this.simFeaturesDefinition.USE_SPHERE_COLLIDER ? this.colliderV3.multiplyScalar(.5) : this.colliderV3), e.getWorldQuaternion(this.colliderQuaternion), this.velocitySimRT.material.uniforms.uColliderQuaternion.value.copy(this.colliderQuaternion.normalize()), this.velocitySimRT.material.uniforms.uColliderQuaternionInvert.value.copy(this.colliderQuaternion.normalize().invert());
    }
    updateState(e) {
        !this.velocitySimRT || !this.positionSimRT || (e.renderMaterial && this.updateMaterialState(e.renderMaterial), this.updateParticleState(e));
    }
    updateVariableState(e, r) {
        if (!this.velocitySimRT || !this.positionSimRT) return;
        r[2] === "size" && this.material.updateState({
            size: [
                e,
                this.material.uniforms.uSizeEnd.value
            ]
        }), r[2] === "sizeEnd" && this.material.updateState({
            size: [
                this.material.uniforms.uSize.value,
                e
            ]
        });
        let i = (s1, o)=>{
            let a = [
                ...this.system.data.shape.size
            ];
            a[s1] = o, this.updateParticleState({
                shape: {
                    ...this.system.data.shape,
                    size: a
                }
            });
        };
        r[2] === "shape_size_0" && i(0, e), r[2] === "shape_size_1" && i(1, e), r[2] === "shape_size_2" && i(2, e), r[2] === "speed" && (this.velocitySimRT.material.uniforms.uSpeed.value = e / bM), r[2] === "gravity" && this.worldGravity.set(0, e / 100, 0), r[2] === "noiseStrength" && (this.noiseStrength = e, this.velocitySimRT.material.uniforms.uNoiseStrength.value = this.noiseStrength), r[2] === "noiseScale" && (this.noiseScale = e, this.velocitySimRT.material.uniforms.uNoiseScale.value = this.noiseScale), r[2] === "direction_x" && (this.directionAxis = this.getDirectionAxis([
            Number(e),
            this.system.data.direction[1],
            this.system.data.direction[2]
        ])), r[2] === "direction_y" && (this.directionAxis = this.getDirectionAxis([
            this.system.data.direction[0],
            Number(e),
            this.system.data.direction[2]
        ])), r[2] === "direction_z" && (this.directionAxis = this.getDirectionAxis([
            this.system.data.direction[0],
            this.system.data.direction[1],
            Number(e)
        ]));
    }
    updateMaterialState(e) {
        this.material.updateState({
            ...e,
            size: e.size ? [
                Number(this.shared.getVariable(e.size[0], [
                    this.uuid,
                    "particles",
                    "size"
                ])),
                Number(this.shared.getVariable(e.size[1], [
                    this.uuid,
                    "particles",
                    "sizeEnd"
                ]))
            ] : [
                0,
                0
            ]
        }), e.texture && (this.setTexture(this.material.uniforms, e.texture), this.material.needsUpdate = !0);
    }
    updateParticleState(e) {
        if (!(!this.positionSimRT || !this.velocitySimRT)) {
            if (this.shouldReInitGPUCompute(e) && this.init(vc(this.system.data)), e.life !== void 0 && (this.positionSimRT.material.uniforms.uMaxLifeTime.value = e.life), e.speed !== void 0 && (this.velocitySimRT.material.uniforms.uSpeed.value = Number(this.shared.getVariable(e.speed, [
                this.uuid,
                "particles",
                "speed"
            ])) / bM), e.collisionBounce !== void 0 && (this.velocitySimRT.material.uniforms.uBounce.value = e.collisionBounce), e.noiseStrength !== void 0 && (this.noiseStrength = Number(this.shared.getVariable(e.noiseStrength, [
                this.uuid,
                "particles",
                "noiseStrength"
            ])), this.velocitySimRT.material.uniforms.uNoiseStrength.value = this.noiseStrength), e.noiseScale !== void 0 && (this.noiseScale = Number(this.shared.getVariable(e.noiseScale, [
                this.uuid,
                "particles",
                "noiseScale"
            ])), this.velocitySimRT.material.uniforms.uNoiseScale.value = this.noiseScale), e.noiseSeed !== void 0 && (this.velocitySimRT.material.uniforms.uNoiseSeed.value = e.noiseSeed), e.randomMass !== void 0 && (this.velocitySimRT.material.uniforms.uRandomMassFactor.value = e.randomMass), e.renderMaterial?.size !== void 0) {
                let r = this.shared.getVariable(e.renderMaterial.size[0], [
                    this.uuid,
                    "particles",
                    "size"
                ]);
                this.velocitySimRT.material.uniforms.particleSize.value = Number(r);
            }
            if (e.renderMaterial?.spriteRotation !== void 0 && (this.material.uniforms.uRotation.value = e.renderMaterial.spriteRotation[0], this.material.uniforms.uRotationEnd.value = e.renderMaterial.spriteRotation[1]), e.shape !== void 0) {
                let r = e.shape.size ?? this.system.data.shape.size, i = [
                    Number(this.shared.getVariable(r[0], [
                        this.uuid,
                        "particles",
                        "shape_size_0"
                    ])),
                    Number(this.shared.getVariable(r[1], [
                        this.uuid,
                        "particles",
                        "shape_size_1"
                    ])),
                    Number(this.shared.getVariable(r[2], [
                        this.uuid,
                        "particles",
                        "shape_size_2"
                    ]))
                ], s1 = {
                    ...vc(this.system.data).shape,
                    size: i
                };
                this.emitterShape?.applyToShader(this.positionSimRT.material.uniforms, s1);
            }
            if (e.gravity !== void 0 && (this.worldGravity.set(0, Number(this.shared.getVariable(this.system.data.gravity, [
                this.uuid,
                "particles",
                "gravity"
            ])) / 100, 0), this.velocitySimRT.material.uniforms.uGravity = {
                value: this.worldGravity
            }), e.direction !== void 0) {
                let r = this.getDirectionFromVariable(e.direction);
                this.directionAxis = this.getDirectionAxis(r), this.velocitySimRT.material.uniforms.uDirectionsAxis.value = this.directionAxis;
            }
            e.randomRotation !== void 0 && (this.material.uniforms.uRandRotationFactor.value = e.randomRotation), e.randomScale !== void 0 && (this.material.uniforms.uRandScaleFactor.value = e.randomScale);
        }
    }
    updateForceFieldParameters(e) {
        !this.velocitySimRT || (e.forceIntensity !== void 0 && (this.velocitySimRT.material.uniforms.uForceIntensity.value = e.forceIntensity), e.forceDambing !== void 0 && (this.velocitySimRT.material.uniforms.uForceDamping.value = e.forceDambing));
    }
    getDirectionAxis(e) {
        let r = [
            Number(e[0]) * Se.DEG2RAD,
            Number(e[1]) * Se.DEG2RAD,
            Number(e[2]) * Se.DEG2RAD
        ], i = new Jt(r[0], r[1], r[2], "XYZ");
        return this.directionAxis.set(0, 1, 0).applyEuler(i).normalize(), this.velocitySimRT && (this.velocitySimRT.material.uniforms.uDirectionsAxis.value = this.directionAxis), this.directionAxis;
    }
    shouldReInitGPUCompute(e) {
        let { birthRatePerSec: r, rootObjectType: i, colliderEntityId: s1, shape: o, emitTimeDuration: a, emitTimeCycle: l, life: c, directionMode: u1, noiseType: h } = e;
        return r !== void 0 || i !== void 0 || s1 || s1 === null || l !== void 0 || o !== void 0 || c !== void 0 || a !== void 0 || u1 !== void 0 || h !== void 0;
    }
    init(e) {
        this.dispose(), this.particlesAmount = this.getMaxParticlesAmount({
            birthRatePerSecond: e.birthRatePerSec,
            particleMaxLifeTime: e.life,
            loopDuration: e.emitTimeCycle === "infinity" ? 0 : e.emitTimeDuration
        }), this.particlesAmount > 1e5 && (console.warn(`The maximum number of particles is limited to ${1e5}.`), this.particlesAmount = 1e5), this.emitterShape = this.createShape(e.shape, this.particlesAmount);
        let r = setInterval(()=>{
            if (!!this.emitterShape) {
                if (isNaN(this.emitterShape.positionsTexture.source.data.data[0])) {
                    this.init(e);
                    return;
                } else clearInterval(r);
            }
        }, 100);
        if (!this.emitterShape) return;
        let i = new qb(this.emitterShape.textureSize, this.emitterShape.textureSize, this.renderer), s1 = this.updateSimulationDefinition(e), o = i.addVariable("uCurrentPosition", s1 + jB, this.emitterShape.positionsTexture), a = i.addVariable("uCurrentVelocity", s1 + YB, this.emitterShape.directionsTexture), l = i.addVariable("uCurrentEmissionRate", tF, GB(this.emitterShape.textureSize));
        i.setVariableDependencies(o, [
            o,
            a,
            l
        ]), i.setVariableDependencies(a, [
            o,
            a,
            l
        ]), i.setVariableDependencies(l, [
            o,
            a,
            l
        ]);
        let c = zB({
            size: this.emitterShape.textureSize
        }), u1 = {
            uOriginalPosition: {
                value: this.emitterShape.positionsTexture
            },
            uWorldOffset: {
                value: new E(0, 0, 0)
            },
            uWorldQuaternion: {
                value: new Ze(0, 0, 0, 1)
            },
            uTime: {
                value: 0
            },
            uFPSRatio: {
                value: 1
            },
            uMaxLifeTime: {
                value: e.life
            },
            uEmitterSize: {
                value: new E(Number(this.shared.getVariable(e.shape.size[0], [
                    this.uuid,
                    "particles",
                    "shape_size_0"
                ])), Number(this.shared.getVariable(e.shape.size[1], [
                    this.uuid,
                    "particles",
                    "shape_size_1"
                ])), Number(this.shared.getVariable(e.shape.size[2], [
                    this.uuid,
                    "particles",
                    "shape_size_2"
                ])))
            },
            particleSize: {
                value: 0
            }
        };
        o.material.uniforms = u1;
        let h = this.getDirectionFromVariable(e.direction);
        this.directionAxis = this.getDirectionAxis(h), this.worldGravity.set(0, Number(this.shared.getVariable(this.system.data.gravity, [
            this.uuid,
            "particles",
            "gravity"
        ])) / 100, 0), this.noiseStrength = Number(this.shared.getVariable(e.noiseStrength, [
            this.uuid,
            "particles",
            "noiseStrength"
        ])), this.noiseScale = Number(this.shared.getVariable(e.noiseScale, [
            this.uuid,
            "particles",
            "noiseScale"
        ]));
        let d = e.colliderEntityId && this.system.getColliderData(e.colliderEntityId), f = {
            uOriginalPosition: {
                value: this.emitterShape.positionsTexture
            },
            uDirections: {
                value: this.emitterShape.directionsTexture
            },
            uDirectionsAxis: {
                value: this.directionAxis
            },
            uWorldQuaternion: {
                value: new Ze(0, 0, 0, 1)
            },
            uColliderPos: {
                value: new E(0, 0, 0)
            },
            uColliderSize: {
                value: new E(0, 0, 0)
            },
            uForceIntensity: {
                value: d ? d.forceIntensity : 0
            },
            uForceDamping: {
                value: d ? d.forceDambing : 0
            },
            uColliderQuaternion: {
                value: new Ze(0, 0, 0, 1)
            },
            uColliderQuaternionInvert: {
                value: new Ze(0, 0, 0, 1)
            },
            particleSize: {
                value: 0
            },
            uGravity: {
                value: this.worldGravity
            },
            uNoiseStrength: {
                value: this.noiseStrength
            },
            uNoiseScale: {
                value: this.noiseScale
            },
            uNoiseSeed: {
                value: e.noiseSeed
            },
            uRandomMassFactor: {
                value: e.randomMass
            },
            uBounce: {
                value: e.collisionBounce
            },
            uSpeed: {
                value: Number(this.shared.getVariable(e.speed, [
                    this.uuid,
                    "particles",
                    "speed"
                ])) / bM
            }
        };
        a.material.uniforms = f;
        let m = {
            uIndex: {
                value: c
            },
            uTime: {
                value: 0
            },
            uLastIndexEmitted: {
                value: 0
            },
            uParticlesToEmit: {
                value: 0
            }
        };
        l.material.uniforms = m;
        let p = [
            Number(this.shared.getVariable(e.shape.size[0], [
                this.uuid,
                "particles",
                "shape_size_0"
            ])),
            Number(this.shared.getVariable(e.shape.size[1], [
                this.uuid,
                "particles",
                "shape_size_1"
            ])),
            Number(this.shared.getVariable(e.shape.size[2], [
                this.uuid,
                "particles",
                "shape_size_2"
            ]))
        ], g = {
            ...vc(this.system.data).shape,
            size: p
        };
        this.emitterShape.applyToShader(o.material.uniforms, g), i.init(), this.gpuCompute = i, this.positionSimRT = o, this.velocitySimRT = a, this.emissionRateSimRT = l, this.rootObject = this.createPrimaryEmitter(this.emitterShape.textureSize), this.add(this.rootObject), this.material.needsUpdate = !0;
    }
    getDirectionFromVariable(e) {
        let r = Number(this.shared.getVariable(e[0], [
            this.uuid,
            "particles",
            "direction_x"
        ])), i = Number(this.shared.getVariable(e[1], [
            this.uuid,
            "particles",
            "direction_y"
        ])), s1 = Number(this.shared.getVariable(e[2], [
            this.uuid,
            "particles",
            "direction_z"
        ]));
        return [
            r,
            i,
            s1
        ];
    }
    updateSimulationDefinition(e) {
        if (this.simFeaturesDefinition.USE_COLLIDER = !1, this.simFeaturesDefinition.USE_ATTRACTOR = !1, this.simFeaturesDefinition.USE_VORTEX = !1, this.simFeaturesDefinition.USE_SPHERE_COLLIDER = !1, this.simFeaturesDefinition.USE_BOX_COLLIDER = !1, this.simFeaturesDefinition.USE_FORCE_LOCAL_SPACE = !1, this.simFeaturesDefinition.USE_NORMALS = !1, this.simFeaturesDefinition.USE_CURL_NOISE = !1, this.simFeaturesDefinition.USE_SIMPLEX_NOISE = !1, this.simFeaturesDefinition.USE_FBM_NOISE = !1, e.colliderEntityId && this.system.colliderEntities.length > 0) {
            let i = this.system.getColliderData(e.colliderEntityId);
            switch(i?.forceType){
                case "attractor":
                    this.simFeaturesDefinition.USE_ATTRACTOR = !0;
                    break;
                case "collider":
                    this.simFeaturesDefinition.USE_COLLIDER = !0;
                    break;
                case "vortex":
                    this.simFeaturesDefinition.USE_VORTEX = !0;
                    break;
            }
            let s1 = i?.colliderType;
            s1 === "sphere" && (this.simFeaturesDefinition.USE_SPHERE_COLLIDER = !0), s1 === "box" && (this.simFeaturesDefinition.USE_BOX_COLLIDER = !0), i?.forceRange === "helper" && (this.simFeaturesDefinition.USE_FORCE_LOCAL_SPACE = !0);
        }
        e.directionMode === "normals" && (this.simFeaturesDefinition.USE_NORMALS = !0), e.noiseType === "curl" && (this.simFeaturesDefinition.USE_CURL_NOISE = !0), e.noiseType === "simplex" && (this.simFeaturesDefinition.USE_SIMPLEX_NOISE = !0), e.noiseType === "fbm" && (this.simFeaturesDefinition.USE_FBM_NOISE = !0);
        let r = "";
        for (let [i, s1] of Object.entries(this.simFeaturesDefinition))s1 && (r += `#define ${i}
`);
        return r;
    }
    createShape(e, r) {
        this.emitterShape && this.emitterShape.dispose();
        let i = new E(Number(this.shared.getVariable(e.size[0], [
            this.uuid,
            "particles",
            "shape_size_0"
        ])), Number(this.shared.getVariable(e.size[1], [
            this.uuid,
            "particles",
            "shape_size_1"
        ])), Number(this.shared.getVariable(e.size[2], [
            this.uuid,
            "particles",
            "shape_size_2"
        ])));
        if (e.type === "MeshEmitterShape") {
            let s1 = null;
            return this.system.context.scene.traverseEntity((o)=>{
                o.uuid === e.fromMeshId && (s1 = o);
            }), s1 ? new Jf(i, r, e.type, s1) : new Jf(i, r, "SphereEmitterShape");
        } else return new Jf(i, r, e.type);
    }
    createPrimaryEmitter(e) {
        let r, i = e * e;
        return r = new Wy(new Si(1, 1, 1), this.material, i), this.updateGeometryAttributes(r, e), this.material.needsUpdate = !0, r.onBeforeRender = ()=>{
            this.applyWorldSpace();
        }, r;
    }
    getMaxParticlesAmount({ birthRatePerSecond: e, particleMaxLifeTime: r, loopDuration: i = 0 }) {
        return Math.ceil(e * (r + i));
    }
    dispose() {
        !this.gpuCompute || (this.rootObject?.parent?.remove(this.rootObject), this.gpuCompute.dispose(), this.material.nodeMaterialDispose(), this.emitterShape?.dispose());
    }
    GoEmitSomeParticles(e, r) {
        let i = e - this.lastEmitTime, s1 = 1 / r;
        if (i >= s1) {
            let o = Math.max(1, Math.floor(i / s1));
            return this.lastEmitTime = e, this.emittedParticlesAmount + o > this.particlesAmount && (this.emittedParticlesAmount = 0), this.emittedParticlesAmount += o, o;
        }
        return 0;
    }
    checkIfAllParticlesAreDead() {
        return this.lastEmitTime + this.system.data.life + 1 < this.globalTime;
    }
    reset() {
        this.hasBeenReset = !0, this.lastEmitTime = 0, this.emittedParticlesAmount = 0, this.gpuCompute && this.init(vc(this.system.data));
    }
    startEmitting(e) {
        this.isEmitting = !0, this.hasBeenReset = !1, this.lastEmitTime = e;
    }
    stopEmitting() {
        this.isEmitting = !1;
    }
};
var ca = class extends nr {
    constructor(e, r, i){
        super(e, r);
        this.type = "ParticleSystem";
        this.geometry = new Ce;
        this.actualTime = 0;
        this.currentLoopTime = 0;
        this.started = !1;
        this.stopped = !1;
        this.timeoutId = void 0;
        this.isFrozen = !1;
        this.isIdle = !0;
        this.emitter = null;
        this.colliderEntities = [];
        this.renderer = null;
        this.isPreWarm = !1;
        this._hasOnAfterRenderBeenCalled = !1;
        this.onAfterRender = (e)=>{
            this._hasOnAfterRenderBeenCalled || (this._hasOnAfterRenderBeenCalled = !0, this.init(e));
        };
        this.context = i, this.data = {
            ...r,
            ...vc(r)
        }, this.geometry.setAttribute("position", new Te([], 3)), this.material = new un({
            colorWrite: !1
        }), this.frustumCulled = !1;
    }
    init(e) {
        this.renderer = e, this.emitter = new Qb(e, this), this.add(this.emitter), this.updateParticleState(this.data);
    }
    update(e) {
        if (!this.isReady || !this.started || this.isFrozen || this.isIdle) return;
        this.actualTime += e, this.stopped || (this.currentLoopTime += e);
        let r = this.data.emitTimeCycle === "one_time";
        if ((this.data.emitTimeCycle === "loop" || r) && this.currentLoopTime > this.data.emitTimeDuration * 1e3 && (this.stopped || (this.stop(), r || this.start(this.data.emitTimeDelay * 1e3))), this.emitter && this.started) {
            let s1 = this.actualTime / 1e3;
            this.emitter.update(s1, e);
        }
        this.scale.set(1, 1, 1), this.updateMatrix();
    }
    isReady() {
        return !!this.emitter;
    }
    hasCollider(e) {
        return this.colliderEntities.some((r)=>r.identity === e);
    }
    getColliderData(e) {
        let r = this.colliderEntities.find((i)=>i.identity === e);
        return r ? r.data : null;
    }
    updateByPatchedOp(e, r, i) {
        super.updateByPatchedOp(e, r, i), kt(e.path, [
            "renderMaterial"
        ]) && this.updateParticleState({
            renderMaterial: {
                ...this.data.renderMaterial,
                ...zr.drop(e, 1).props
            }
        }), kt(e.path, [
            "shape"
        ]) && this.updateParticleState({
            shape: {
                ...this.data.shape,
                ...zr.drop(e, 1).props
            }
        });
    }
    updateState(e, r) {
        super.updateState(e, r), this.updateParticleState(e);
    }
    updateParticleState(e) {
        if (!!this.emitter) {
            if (e.colliderEntityId !== void 0 && e.colliderEntityId !== null) {
                let r = this.context.scene.find(e.colliderEntityId);
                this.colliderEntities = r ? [
                    r
                ] : [];
            }
            e.colliderEntityId === null && (this.colliderEntities = []), this.emitter.updateState(e), e.emitTimeCycle && this.started && this.start();
        }
    }
    updateFromColliderEntity(e) {
        !this.emitter || (this.emitter.updateForceFieldParameters(e), this.stop(), this.start());
    }
    start(e = 0) {
        if (this.currentLoopTime = 0, e) {
            this.timeoutId = window.setTimeout(()=>{
                this.start(0);
            }, e);
            return;
        }
        this.started = !0, this.stopped = !1, this.isFrozen = !1, this.emitter?.startEmitting(this.actualTime / 1e3);
    }
    froze() {
        this.isFrozen = !0;
    }
    unFroze() {
        this.isFrozen = !1;
    }
    stop() {
        this.stopped = !0, this.currentLoopTime = 0, this.emitter?.stopEmitting(), clearTimeout(this.timeoutId);
    }
    reset() {
        this.started = !1, this.stopped = !1, this.emitter?.reset();
    }
    wakeUp() {
        this.isIdle = !1;
    }
    sleep() {
        this.isIdle = !0, this.reset();
    }
};
function gee() {
    try {
        let n1 = window.location.href;
        if (n1.includes("reducesubdiv=")) {
            let t = n1.indexOf("reducesubdiv=") + 13;
            return parseInt(n1.slice(t, t + 1));
        }
    } catch  {}
}
var SM = gee();
function yee(n1, t, e) {
    SM !== void 0 && t?.geometry && "subdivisions" in t.geometry && (t.geometry.subdivisions ?? 0) > SM && Object.assign(t.geometry, {
        subdivisions: SM
    });
    let r;
    return t.geometry.type === "TextGeometry" ? new cc(n1, t, e) : t.geometry.type === "InputGeometry" ? new yc(n1, t, e) : (t.geometry.type === "SubdivGeometry" ? r = new lo(n1, t, e) : t.geometry.type === "PathGeometry" ? r = new qo(n1, t, e) : t.geometry.type === "VectorGeometry" ? r = new jb(n1, t, e) : t.geometry.type === "BooleanGeometry" ? r = new Hn(n1, t, e) : t.geometry.type === "ShapeBlendGeometry" ? r = new cs(n1, t, e) : t.geometry.type === "UIGeometry" ? r = new _r(n1, t, e) : r = new Ct(n1, t, e), r);
}
function Zb(n1, t, e) {
    return console.assert(t.type !== void 0), t.type === "Mesh" ? yee(n1, t, e) : t.type === "Empty" ? new Ns(n1, t) : t.type === "Particle" ? new ca(n1, t, e) : t.type === "ParticleCollider" ? new oa(n1, t, e) : t.type === "Splat" ? new Ns(n1, t) : t.type === "Bone" ? new Wb(n1, t) : t.type === "Page" ? new yr(n1, t, e) : t.type === "PointLight" ? new Xl(n1, t, e) : t.type === "SpotLight" ? new Wo(n1, t, e) : t.type === "DirectionalLight" ? new Ho(n1, t, e) : t.type === "Component" || t.type === "Instance" ? new ho(n1, t, e) : Ks.is(t.type) ? new ir(n1, t) : (console.error(t), new Ns(n1, t));
}
to.createEntity = Zb;
function vee(n1, t, e) {
    let r = Zb(n1.identity, t, e), i = n1.children, s1 = n1.attachedPaths, o = n1.parent, a = n1.component, l = n1.instances, c = n1.overrideData, u1 = n1.uuid, h = n1.stateSelection;
    n1.dispose();
    for (let d of Object.keys(n1))delete n1[d];
    Object.setPrototypeOf(n1, Object.getPrototypeOf(r));
    for (let d of Object.keys(r))n1[d] = r[d];
    n1.children = [
        ...n1.children,
        ...i
    ], n1.attachedPaths = s1, n1.parent = o, n1.component = a, n1.instances = l, n1.uuid = u1, n1.overrideData = c, n1.updateState(n1.data, e), h && n1.changeSelectedState(h, e), n1.resetBBoxNeedsUpdate();
}
to.changeEntityProptotype = vee;
to.Cloner = Ai;
function iF(n1, t, e, r) {
    n1.updateByOp(t, e, r, !1);
}
var xc = 5, $f = new Ce;
$f.setAttribute("position", new je(new Float32Array([
    -1,
    -1,
    0,
    3,
    -1,
    0,
    -1,
    3,
    0
]), 3));
var Tu = class extends Yy {
    constructor(t){
        super({
            ...t,
            depthTest: !1,
            depthWrite: !1,
            glslVersion: By,
            vertexShader: `
				precision highp float;
				in vec3 position;
				void main() {
					gl_Position = vec4(position, 1);
				}
			`
        });
    }
    customProgramCacheKey() {
        return "";
    }
};
function nF() {
    return {
        shapeInput: ()=>`
			const float posRowCoord = ${.5 / xc};  // vec4: px py pz opType
			const float quatRowCoord = ${1.5 / xc};  // vec4: qx qy qz qw
			const float param1RowCoord = ${2.5 / xc};// vec4: type param1 param2 param3
			const float param2RowCoord = ${3.5 / xc};// vec4: blendRange roundness scale param4
			const float colorRowCoord = ${4.5 / xc}; // vec4: r g b a
			uniform sampler2D shapesDataTexture;
			vec4 shapePos(float iin) { 
				vec4 r = texture(shapesDataTexture, vec2(iin, posRowCoord));
				return r;
			}
			vec4 shapeQuat(float iin) {
				vec4 r = texture(shapesDataTexture, vec2(iin, quatRowCoord));
				return r;
			}
			vec4 shapeParams1(float iin) {
				vec4 r = texture(shapesDataTexture, vec2(iin, param1RowCoord));
				return r;
			}
			vec4 shapeParams2(float iin) {
				vec4 r = texture(shapesDataTexture, vec2(iin, param2RowCoord));
				return r;
			}
			vec4 shapeColor(float iin) {
				vec4 r = texture(shapesDataTexture, vec2(iin, colorRowCoord));
				return r;
			}
		`,
        getxyzi: `
			// this code must complement lookup
			float xi = mod(gl_FragCoord.x - 0.5, VOXEL_RESOLUTION);
			float yi = mod(gl_FragCoord.y - 0.5, VOXEL_RESOLUTION);
			float zi = floor((gl_FragCoord.x - 0.5) * INV_VOXEL_RESOLUTION) + floor((gl_FragCoord.y - 0.5) * INV_VOXEL_RESOLUTION) * Z_LAYERS_PER_ROW;
		`,
        lookup: `
			uniform sampler2D potentialPassTexture;
			uniform sampler2D voxelPassTexture; // includes normal (in xyz) and key (in w)
			
			// box or marching cube lookup value in value texture, integer box coord inputs
			// this code must complement codebits.getxyzi
			vec4 look(float xi, float yi, float zi, sampler2D rt) {// range 0 .. numv etc
				vec2 uv = vec2(
					mod(zi, Z_LAYERS_PER_ROW) + (xi + 0.5) / VOXEL_RESOLUTION,
					floor(zi / Z_LAYERS_PER_ROW) + (yi + 0.5) / VOXEL_RESOLUTION
				); 
				uv /= Z_LAYERS_PER_ROW;
				return texture(rt, uv);
			}
		`,
        getpart: `
			float getpart(inout float a, float b) {
				float t = floor(a/b);
				float r = a - t*b;
				a = t;
				return r;
			}
		`,
        triTable: new Float32Array([
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            3,
            8,
            0,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            9,
            1,
            0,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            3,
            8,
            1,
            1,
            8,
            9,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            2,
            1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            3,
            8,
            0,
            10,
            2,
            1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            2,
            9,
            9,
            2,
            0,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            3,
            8,
            2,
            8,
            10,
            2,
            8,
            9,
            10,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            2,
            11,
            3,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            2,
            11,
            0,
            0,
            11,
            8,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            0,
            9,
            1,
            11,
            3,
            2,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            2,
            11,
            1,
            11,
            9,
            1,
            11,
            8,
            9,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            10,
            3,
            3,
            10,
            11,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            10,
            0,
            10,
            8,
            0,
            10,
            11,
            8,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            0,
            9,
            3,
            9,
            11,
            3,
            9,
            10,
            11,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            8,
            9,
            11,
            8,
            10,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            7,
            4,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            0,
            3,
            4,
            4,
            3,
            7,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            9,
            1,
            0,
            7,
            4,
            8,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            9,
            1,
            4,
            1,
            7,
            4,
            1,
            3,
            7,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            2,
            1,
            7,
            4,
            8,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            7,
            4,
            3,
            4,
            0,
            3,
            10,
            2,
            1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            2,
            9,
            2,
            0,
            9,
            7,
            4,
            8,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            9,
            10,
            2,
            7,
            9,
            2,
            3,
            7,
            2,
            4,
            9,
            7,
            -1,
            -1,
            -1,
            -1,
            7,
            4,
            8,
            2,
            11,
            3,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            7,
            4,
            11,
            4,
            2,
            11,
            4,
            0,
            2,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            0,
            9,
            7,
            4,
            8,
            11,
            3,
            2,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            11,
            7,
            4,
            11,
            4,
            9,
            2,
            11,
            9,
            1,
            2,
            9,
            -1,
            -1,
            -1,
            -1,
            1,
            10,
            3,
            10,
            11,
            3,
            4,
            8,
            7,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            11,
            1,
            11,
            4,
            1,
            4,
            0,
            1,
            4,
            11,
            7,
            -1,
            -1,
            -1,
            -1,
            8,
            7,
            4,
            11,
            0,
            9,
            10,
            11,
            9,
            3,
            0,
            11,
            -1,
            -1,
            -1,
            -1,
            11,
            7,
            4,
            9,
            11,
            4,
            10,
            11,
            9,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            4,
            5,
            9,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            4,
            5,
            9,
            3,
            8,
            0,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            4,
            5,
            0,
            0,
            5,
            1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            4,
            5,
            8,
            5,
            3,
            8,
            5,
            1,
            3,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            2,
            1,
            4,
            5,
            9,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            0,
            3,
            10,
            2,
            1,
            5,
            9,
            4,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            2,
            5,
            2,
            4,
            5,
            2,
            0,
            4,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            5,
            10,
            2,
            5,
            2,
            3,
            4,
            5,
            3,
            8,
            4,
            3,
            -1,
            -1,
            -1,
            -1,
            4,
            5,
            9,
            11,
            3,
            2,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            2,
            11,
            0,
            11,
            8,
            0,
            5,
            9,
            4,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            4,
            5,
            0,
            5,
            1,
            0,
            11,
            3,
            2,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            5,
            1,
            2,
            8,
            5,
            2,
            11,
            8,
            2,
            5,
            8,
            4,
            -1,
            -1,
            -1,
            -1,
            11,
            3,
            10,
            3,
            1,
            10,
            4,
            5,
            9,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            5,
            9,
            4,
            1,
            8,
            0,
            1,
            10,
            8,
            10,
            11,
            8,
            -1,
            -1,
            -1,
            -1,
            0,
            4,
            5,
            11,
            0,
            5,
            10,
            11,
            5,
            3,
            0,
            11,
            -1,
            -1,
            -1,
            -1,
            8,
            4,
            5,
            10,
            8,
            5,
            11,
            8,
            10,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            7,
            9,
            9,
            7,
            5,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            0,
            3,
            9,
            3,
            5,
            9,
            3,
            7,
            5,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            7,
            0,
            7,
            1,
            0,
            7,
            5,
            1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            3,
            5,
            1,
            7,
            5,
            3,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            7,
            9,
            7,
            5,
            9,
            2,
            1,
            10,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            2,
            1,
            10,
            0,
            5,
            9,
            0,
            3,
            5,
            3,
            7,
            5,
            -1,
            -1,
            -1,
            -1,
            2,
            0,
            8,
            5,
            2,
            8,
            7,
            5,
            8,
            2,
            5,
            10,
            -1,
            -1,
            -1,
            -1,
            5,
            10,
            2,
            3,
            5,
            2,
            7,
            5,
            3,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            5,
            9,
            7,
            9,
            8,
            7,
            2,
            11,
            3,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            7,
            5,
            9,
            2,
            7,
            9,
            0,
            2,
            9,
            11,
            7,
            2,
            -1,
            -1,
            -1,
            -1,
            11,
            3,
            2,
            8,
            1,
            0,
            8,
            7,
            1,
            7,
            5,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            2,
            11,
            7,
            1,
            11,
            5,
            1,
            7,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            5,
            9,
            7,
            5,
            8,
            3,
            1,
            10,
            11,
            3,
            10,
            -1,
            -1,
            -1,
            -1,
            0,
            7,
            5,
            9,
            0,
            5,
            0,
            11,
            7,
            10,
            0,
            1,
            0,
            10,
            11,
            -1,
            0,
            10,
            11,
            3,
            0,
            11,
            0,
            5,
            10,
            7,
            0,
            8,
            0,
            7,
            5,
            -1,
            5,
            10,
            11,
            5,
            11,
            7,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            5,
            6,
            10,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            3,
            8,
            0,
            6,
            10,
            5,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            0,
            9,
            6,
            10,
            5,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            3,
            8,
            1,
            8,
            9,
            1,
            6,
            10,
            5,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            5,
            6,
            1,
            1,
            6,
            2,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            5,
            6,
            1,
            6,
            2,
            1,
            8,
            0,
            3,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            5,
            6,
            9,
            6,
            0,
            9,
            6,
            2,
            0,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            9,
            5,
            2,
            8,
            5,
            6,
            2,
            5,
            8,
            2,
            3,
            -1,
            -1,
            -1,
            -1,
            11,
            3,
            2,
            5,
            6,
            10,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            0,
            11,
            0,
            2,
            11,
            5,
            6,
            10,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            9,
            1,
            0,
            11,
            3,
            2,
            6,
            10,
            5,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            6,
            10,
            5,
            2,
            9,
            1,
            2,
            11,
            9,
            11,
            8,
            9,
            -1,
            -1,
            -1,
            -1,
            11,
            3,
            6,
            3,
            5,
            6,
            3,
            1,
            5,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            11,
            8,
            0,
            5,
            11,
            0,
            1,
            5,
            0,
            6,
            11,
            5,
            -1,
            -1,
            -1,
            -1,
            6,
            11,
            3,
            6,
            3,
            0,
            5,
            6,
            0,
            9,
            5,
            0,
            -1,
            -1,
            -1,
            -1,
            9,
            5,
            6,
            11,
            9,
            6,
            8,
            9,
            11,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            6,
            10,
            5,
            8,
            7,
            4,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            0,
            3,
            4,
            3,
            7,
            4,
            10,
            5,
            6,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            0,
            9,
            1,
            6,
            10,
            5,
            7,
            4,
            8,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            5,
            6,
            10,
            7,
            9,
            1,
            3,
            7,
            1,
            4,
            9,
            7,
            -1,
            -1,
            -1,
            -1,
            2,
            1,
            6,
            1,
            5,
            6,
            8,
            7,
            4,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            5,
            2,
            1,
            6,
            2,
            5,
            4,
            0,
            3,
            7,
            4,
            3,
            -1,
            -1,
            -1,
            -1,
            7,
            4,
            8,
            5,
            0,
            9,
            5,
            6,
            0,
            6,
            2,
            0,
            -1,
            -1,
            -1,
            -1,
            9,
            3,
            7,
            4,
            9,
            7,
            9,
            2,
            3,
            6,
            9,
            5,
            9,
            6,
            2,
            -1,
            2,
            11,
            3,
            4,
            8,
            7,
            5,
            6,
            10,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            6,
            10,
            5,
            2,
            7,
            4,
            0,
            2,
            4,
            11,
            7,
            2,
            -1,
            -1,
            -1,
            -1,
            9,
            1,
            0,
            8,
            7,
            4,
            11,
            3,
            2,
            6,
            10,
            5,
            -1,
            -1,
            -1,
            -1,
            1,
            2,
            9,
            2,
            11,
            9,
            11,
            4,
            9,
            4,
            11,
            7,
            6,
            10,
            5,
            -1,
            7,
            4,
            8,
            5,
            11,
            3,
            1,
            5,
            3,
            6,
            11,
            5,
            -1,
            -1,
            -1,
            -1,
            11,
            1,
            5,
            6,
            11,
            5,
            11,
            0,
            1,
            4,
            11,
            7,
            11,
            4,
            0,
            -1,
            9,
            5,
            0,
            5,
            6,
            0,
            6,
            3,
            0,
            3,
            6,
            11,
            7,
            4,
            8,
            -1,
            9,
            5,
            6,
            11,
            9,
            6,
            9,
            7,
            4,
            9,
            11,
            7,
            -1,
            -1,
            -1,
            -1,
            9,
            4,
            10,
            10,
            4,
            6,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            6,
            10,
            4,
            10,
            9,
            4,
            3,
            8,
            0,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            0,
            10,
            0,
            6,
            10,
            0,
            4,
            6,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            3,
            8,
            6,
            1,
            8,
            4,
            6,
            8,
            10,
            1,
            6,
            -1,
            -1,
            -1,
            -1,
            9,
            4,
            1,
            4,
            2,
            1,
            4,
            6,
            2,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            0,
            3,
            9,
            2,
            1,
            9,
            4,
            2,
            4,
            6,
            2,
            -1,
            -1,
            -1,
            -1,
            4,
            2,
            0,
            6,
            2,
            4,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            2,
            3,
            8,
            4,
            2,
            8,
            6,
            2,
            4,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            9,
            4,
            10,
            4,
            6,
            10,
            3,
            2,
            11,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            2,
            8,
            0,
            11,
            8,
            2,
            10,
            9,
            4,
            6,
            10,
            4,
            -1,
            -1,
            -1,
            -1,
            2,
            11,
            3,
            6,
            1,
            0,
            4,
            6,
            0,
            10,
            1,
            6,
            -1,
            -1,
            -1,
            -1,
            1,
            4,
            6,
            10,
            1,
            6,
            1,
            8,
            4,
            11,
            1,
            2,
            1,
            11,
            8,
            -1,
            4,
            6,
            9,
            6,
            3,
            9,
            3,
            1,
            9,
            3,
            6,
            11,
            -1,
            -1,
            -1,
            -1,
            1,
            11,
            8,
            0,
            1,
            8,
            1,
            6,
            11,
            4,
            1,
            9,
            1,
            4,
            6,
            -1,
            6,
            11,
            3,
            0,
            6,
            3,
            4,
            6,
            0,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            4,
            6,
            8,
            6,
            11,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            6,
            10,
            7,
            10,
            8,
            7,
            10,
            9,
            8,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            3,
            7,
            0,
            7,
            10,
            0,
            10,
            9,
            0,
            10,
            7,
            6,
            -1,
            -1,
            -1,
            -1,
            7,
            6,
            10,
            7,
            10,
            1,
            8,
            7,
            1,
            0,
            8,
            1,
            -1,
            -1,
            -1,
            -1,
            7,
            6,
            10,
            1,
            7,
            10,
            3,
            7,
            1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            6,
            2,
            1,
            8,
            6,
            1,
            9,
            8,
            1,
            7,
            6,
            8,
            -1,
            -1,
            -1,
            -1,
            9,
            6,
            2,
            1,
            9,
            2,
            9,
            7,
            6,
            3,
            9,
            0,
            9,
            3,
            7,
            -1,
            0,
            8,
            7,
            6,
            0,
            7,
            2,
            0,
            6,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            2,
            3,
            7,
            2,
            7,
            6,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            11,
            3,
            2,
            8,
            6,
            10,
            9,
            8,
            10,
            7,
            6,
            8,
            -1,
            -1,
            -1,
            -1,
            7,
            0,
            2,
            11,
            7,
            2,
            7,
            9,
            0,
            10,
            7,
            6,
            7,
            10,
            9,
            -1,
            0,
            8,
            1,
            8,
            7,
            1,
            7,
            10,
            1,
            10,
            7,
            6,
            11,
            3,
            2,
            -1,
            1,
            2,
            11,
            7,
            1,
            11,
            1,
            6,
            10,
            1,
            7,
            6,
            -1,
            -1,
            -1,
            -1,
            6,
            9,
            8,
            7,
            6,
            8,
            6,
            1,
            9,
            3,
            6,
            11,
            6,
            3,
            1,
            -1,
            1,
            9,
            0,
            7,
            6,
            11,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            0,
            8,
            7,
            6,
            0,
            7,
            0,
            11,
            3,
            0,
            6,
            11,
            -1,
            -1,
            -1,
            -1,
            6,
            11,
            7,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            11,
            6,
            7,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            0,
            3,
            6,
            7,
            11,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            9,
            1,
            0,
            6,
            7,
            11,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            9,
            1,
            8,
            1,
            3,
            8,
            6,
            7,
            11,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            2,
            1,
            10,
            7,
            11,
            6,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            2,
            1,
            8,
            0,
            3,
            7,
            11,
            6,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            0,
            9,
            2,
            9,
            10,
            2,
            7,
            11,
            6,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            7,
            11,
            6,
            3,
            10,
            2,
            3,
            8,
            10,
            8,
            9,
            10,
            -1,
            -1,
            -1,
            -1,
            3,
            2,
            7,
            7,
            2,
            6,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            0,
            7,
            0,
            6,
            7,
            0,
            2,
            6,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            6,
            7,
            2,
            7,
            3,
            2,
            9,
            1,
            0,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            2,
            6,
            1,
            6,
            8,
            1,
            8,
            9,
            1,
            6,
            7,
            8,
            -1,
            -1,
            -1,
            -1,
            6,
            7,
            10,
            7,
            1,
            10,
            7,
            3,
            1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            6,
            7,
            10,
            10,
            7,
            1,
            7,
            8,
            1,
            8,
            0,
            1,
            -1,
            -1,
            -1,
            -1,
            7,
            3,
            0,
            10,
            7,
            0,
            9,
            10,
            0,
            7,
            10,
            6,
            -1,
            -1,
            -1,
            -1,
            10,
            6,
            7,
            8,
            10,
            7,
            9,
            10,
            8,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            4,
            8,
            6,
            6,
            8,
            11,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            11,
            6,
            3,
            6,
            0,
            3,
            6,
            4,
            0,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            11,
            6,
            8,
            6,
            4,
            8,
            1,
            0,
            9,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            6,
            4,
            9,
            3,
            6,
            9,
            1,
            3,
            9,
            6,
            3,
            11,
            -1,
            -1,
            -1,
            -1,
            4,
            8,
            6,
            8,
            11,
            6,
            1,
            10,
            2,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            2,
            1,
            11,
            0,
            3,
            11,
            6,
            0,
            6,
            4,
            0,
            -1,
            -1,
            -1,
            -1,
            8,
            11,
            4,
            11,
            6,
            4,
            9,
            2,
            0,
            9,
            10,
            2,
            -1,
            -1,
            -1,
            -1,
            3,
            9,
            10,
            2,
            3,
            10,
            3,
            4,
            9,
            6,
            3,
            11,
            3,
            6,
            4,
            -1,
            3,
            2,
            8,
            2,
            4,
            8,
            2,
            6,
            4,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            2,
            4,
            0,
            2,
            6,
            4,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            0,
            9,
            1,
            4,
            3,
            2,
            6,
            4,
            2,
            8,
            3,
            4,
            -1,
            -1,
            -1,
            -1,
            4,
            9,
            1,
            2,
            4,
            1,
            6,
            4,
            2,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            3,
            1,
            8,
            1,
            6,
            8,
            6,
            4,
            8,
            1,
            10,
            6,
            -1,
            -1,
            -1,
            -1,
            0,
            1,
            10,
            6,
            0,
            10,
            4,
            0,
            6,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            3,
            6,
            4,
            8,
            3,
            4,
            3,
            10,
            6,
            9,
            3,
            0,
            3,
            9,
            10,
            -1,
            4,
            9,
            10,
            4,
            10,
            6,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            5,
            9,
            4,
            11,
            6,
            7,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            3,
            8,
            0,
            5,
            9,
            4,
            6,
            7,
            11,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            0,
            5,
            0,
            4,
            5,
            11,
            6,
            7,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            6,
            7,
            11,
            4,
            3,
            8,
            4,
            5,
            3,
            5,
            1,
            3,
            -1,
            -1,
            -1,
            -1,
            4,
            5,
            9,
            2,
            1,
            10,
            11,
            6,
            7,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            7,
            11,
            6,
            10,
            2,
            1,
            3,
            8,
            0,
            5,
            9,
            4,
            -1,
            -1,
            -1,
            -1,
            11,
            6,
            7,
            10,
            4,
            5,
            10,
            2,
            4,
            2,
            0,
            4,
            -1,
            -1,
            -1,
            -1,
            8,
            4,
            3,
            4,
            5,
            3,
            5,
            2,
            3,
            2,
            5,
            10,
            6,
            7,
            11,
            -1,
            3,
            2,
            7,
            2,
            6,
            7,
            9,
            4,
            5,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            4,
            5,
            9,
            6,
            8,
            0,
            2,
            6,
            0,
            7,
            8,
            6,
            -1,
            -1,
            -1,
            -1,
            2,
            6,
            3,
            6,
            7,
            3,
            0,
            5,
            1,
            0,
            4,
            5,
            -1,
            -1,
            -1,
            -1,
            8,
            2,
            6,
            7,
            8,
            6,
            8,
            1,
            2,
            5,
            8,
            4,
            8,
            5,
            1,
            -1,
            4,
            5,
            9,
            6,
            1,
            10,
            6,
            7,
            1,
            7,
            3,
            1,
            -1,
            -1,
            -1,
            -1,
            10,
            6,
            1,
            6,
            7,
            1,
            7,
            0,
            1,
            0,
            7,
            8,
            4,
            5,
            9,
            -1,
            10,
            0,
            4,
            5,
            10,
            4,
            10,
            3,
            0,
            7,
            10,
            6,
            10,
            7,
            3,
            -1,
            10,
            6,
            7,
            8,
            10,
            7,
            10,
            4,
            5,
            10,
            8,
            4,
            -1,
            -1,
            -1,
            -1,
            5,
            9,
            6,
            9,
            11,
            6,
            9,
            8,
            11,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            11,
            6,
            3,
            3,
            6,
            0,
            6,
            5,
            0,
            5,
            9,
            0,
            -1,
            -1,
            -1,
            -1,
            8,
            11,
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            11,
            6,
            5,
            -1,
            -1,
            -1,
            -1,
            3,
            11,
            6,
            5,
            3,
            6,
            1,
            3,
            5,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            2,
            1,
            11,
            5,
            9,
            8,
            11,
            9,
            6,
            5,
            11,
            -1,
            -1,
            -1,
            -1,
            3,
            11,
            0,
            11,
            6,
            0,
            6,
            9,
            0,
            9,
            6,
            5,
            10,
            2,
            1,
            -1,
            5,
            8,
            11,
            6,
            5,
            11,
            5,
            0,
            8,
            2,
            5,
            10,
            5,
            2,
            0,
            -1,
            3,
            11,
            6,
            5,
            3,
            6,
            3,
            10,
            2,
            3,
            5,
            10,
            -1,
            -1,
            -1,
            -1,
            9,
            8,
            5,
            8,
            2,
            5,
            2,
            6,
            5,
            2,
            8,
            3,
            -1,
            -1,
            -1,
            -1,
            6,
            5,
            9,
            0,
            6,
            9,
            2,
            6,
            0,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            5,
            1,
            0,
            8,
            1,
            8,
            6,
            5,
            2,
            8,
            3,
            8,
            2,
            6,
            -1,
            6,
            5,
            1,
            6,
            1,
            2,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            6,
            3,
            1,
            10,
            6,
            1,
            6,
            8,
            3,
            9,
            6,
            5,
            6,
            9,
            8,
            -1,
            0,
            1,
            10,
            6,
            0,
            10,
            0,
            5,
            9,
            0,
            6,
            5,
            -1,
            -1,
            -1,
            -1,
            8,
            3,
            0,
            10,
            6,
            5,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            6,
            5,
            10,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            5,
            11,
            11,
            5,
            7,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            5,
            11,
            5,
            7,
            11,
            0,
            3,
            8,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            7,
            11,
            5,
            11,
            10,
            5,
            0,
            9,
            1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            5,
            7,
            10,
            7,
            11,
            10,
            1,
            8,
            9,
            1,
            3,
            8,
            -1,
            -1,
            -1,
            -1,
            2,
            1,
            11,
            1,
            7,
            11,
            1,
            5,
            7,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            3,
            8,
            0,
            7,
            2,
            1,
            5,
            7,
            1,
            11,
            2,
            7,
            -1,
            -1,
            -1,
            -1,
            5,
            7,
            9,
            7,
            2,
            9,
            2,
            0,
            9,
            7,
            11,
            2,
            -1,
            -1,
            -1,
            -1,
            2,
            5,
            7,
            11,
            2,
            7,
            2,
            9,
            5,
            8,
            2,
            3,
            2,
            8,
            9,
            -1,
            10,
            5,
            2,
            5,
            3,
            2,
            5,
            7,
            3,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            0,
            2,
            8,
            2,
            5,
            8,
            5,
            7,
            8,
            5,
            2,
            10,
            -1,
            -1,
            -1,
            -1,
            1,
            0,
            9,
            3,
            10,
            5,
            7,
            3,
            5,
            2,
            10,
            3,
            -1,
            -1,
            -1,
            -1,
            2,
            8,
            9,
            1,
            2,
            9,
            2,
            7,
            8,
            5,
            2,
            10,
            2,
            5,
            7,
            -1,
            5,
            3,
            1,
            5,
            7,
            3,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            7,
            8,
            0,
            1,
            7,
            0,
            5,
            7,
            1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            3,
            0,
            9,
            5,
            3,
            9,
            7,
            3,
            5,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            7,
            8,
            9,
            7,
            9,
            5,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            4,
            8,
            5,
            8,
            10,
            5,
            8,
            11,
            10,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            4,
            0,
            5,
            0,
            11,
            5,
            11,
            10,
            5,
            0,
            3,
            11,
            -1,
            -1,
            -1,
            -1,
            9,
            1,
            0,
            10,
            4,
            8,
            11,
            10,
            8,
            5,
            4,
            10,
            -1,
            -1,
            -1,
            -1,
            4,
            11,
            10,
            5,
            4,
            10,
            4,
            3,
            11,
            1,
            4,
            9,
            4,
            1,
            3,
            -1,
            1,
            5,
            2,
            5,
            8,
            2,
            8,
            11,
            2,
            8,
            5,
            4,
            -1,
            -1,
            -1,
            -1,
            11,
            4,
            0,
            3,
            11,
            0,
            11,
            5,
            4,
            1,
            11,
            2,
            11,
            1,
            5,
            -1,
            5,
            2,
            0,
            9,
            5,
            0,
            5,
            11,
            2,
            8,
            5,
            4,
            5,
            8,
            11,
            -1,
            5,
            4,
            9,
            3,
            11,
            2,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            5,
            2,
            2,
            5,
            3,
            5,
            4,
            3,
            4,
            8,
            3,
            -1,
            -1,
            -1,
            -1,
            2,
            10,
            5,
            4,
            2,
            5,
            0,
            2,
            4,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            2,
            10,
            3,
            10,
            5,
            3,
            5,
            8,
            3,
            8,
            5,
            4,
            9,
            1,
            0,
            -1,
            2,
            10,
            5,
            4,
            2,
            5,
            2,
            9,
            1,
            2,
            4,
            9,
            -1,
            -1,
            -1,
            -1,
            5,
            4,
            8,
            3,
            5,
            8,
            1,
            5,
            3,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            5,
            4,
            0,
            5,
            0,
            1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            5,
            4,
            8,
            3,
            5,
            8,
            5,
            0,
            9,
            5,
            3,
            0,
            -1,
            -1,
            -1,
            -1,
            5,
            4,
            9,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            7,
            11,
            4,
            11,
            9,
            4,
            11,
            10,
            9,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            3,
            8,
            0,
            7,
            9,
            4,
            7,
            11,
            9,
            11,
            10,
            9,
            -1,
            -1,
            -1,
            -1,
            11,
            10,
            1,
            4,
            11,
            1,
            0,
            4,
            1,
            11,
            4,
            7,
            -1,
            -1,
            -1,
            -1,
            4,
            1,
            3,
            8,
            4,
            3,
            4,
            10,
            1,
            11,
            4,
            7,
            4,
            11,
            10,
            -1,
            7,
            11,
            4,
            4,
            11,
            9,
            11,
            2,
            9,
            2,
            1,
            9,
            -1,
            -1,
            -1,
            -1,
            4,
            7,
            9,
            7,
            11,
            9,
            11,
            1,
            9,
            1,
            11,
            2,
            3,
            8,
            0,
            -1,
            4,
            7,
            11,
            2,
            4,
            11,
            0,
            4,
            2,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            4,
            7,
            11,
            2,
            4,
            11,
            4,
            3,
            8,
            4,
            2,
            3,
            -1,
            -1,
            -1,
            -1,
            10,
            9,
            2,
            9,
            7,
            2,
            7,
            3,
            2,
            9,
            4,
            7,
            -1,
            -1,
            -1,
            -1,
            7,
            10,
            9,
            4,
            7,
            9,
            7,
            2,
            10,
            0,
            7,
            8,
            7,
            0,
            2,
            -1,
            10,
            7,
            3,
            2,
            10,
            3,
            10,
            4,
            7,
            0,
            10,
            1,
            10,
            0,
            4,
            -1,
            2,
            10,
            1,
            4,
            7,
            8,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            9,
            4,
            7,
            1,
            4,
            3,
            1,
            7,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            9,
            4,
            7,
            1,
            4,
            1,
            8,
            0,
            1,
            7,
            8,
            -1,
            -1,
            -1,
            -1,
            3,
            0,
            4,
            3,
            4,
            7,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            7,
            8,
            4,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            10,
            9,
            8,
            11,
            10,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            9,
            0,
            3,
            11,
            9,
            3,
            10,
            9,
            11,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            1,
            0,
            8,
            10,
            0,
            11,
            10,
            8,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            10,
            1,
            3,
            10,
            3,
            11,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            11,
            2,
            1,
            9,
            11,
            1,
            8,
            11,
            9,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            9,
            0,
            3,
            11,
            9,
            3,
            9,
            2,
            1,
            9,
            11,
            2,
            -1,
            -1,
            -1,
            -1,
            11,
            2,
            0,
            11,
            0,
            8,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            11,
            2,
            3,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            3,
            2,
            10,
            8,
            2,
            9,
            8,
            10,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            2,
            10,
            9,
            2,
            9,
            0,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            3,
            2,
            10,
            8,
            2,
            8,
            1,
            0,
            8,
            10,
            1,
            -1,
            -1,
            -1,
            -1,
            2,
            10,
            1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            3,
            1,
            8,
            1,
            9,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            9,
            0,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            8,
            3,
            0,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        numTrisTable: new Float32Array([
            0,
            1,
            1,
            2,
            1,
            2,
            2,
            3,
            1,
            2,
            2,
            3,
            2,
            3,
            3,
            2,
            1,
            2,
            2,
            3,
            2,
            3,
            3,
            4,
            2,
            3,
            3,
            4,
            3,
            4,
            4,
            3,
            1,
            2,
            2,
            3,
            2,
            3,
            3,
            4,
            2,
            3,
            3,
            4,
            3,
            4,
            4,
            3,
            2,
            3,
            3,
            2,
            3,
            4,
            4,
            3,
            3,
            4,
            4,
            3,
            4,
            5,
            5,
            2,
            1,
            2,
            2,
            3,
            2,
            3,
            3,
            4,
            2,
            3,
            3,
            4,
            3,
            4,
            4,
            3,
            2,
            3,
            3,
            4,
            3,
            4,
            4,
            5,
            3,
            4,
            4,
            5,
            4,
            5,
            5,
            4,
            2,
            3,
            3,
            4,
            3,
            4,
            2,
            3,
            3,
            4,
            4,
            5,
            4,
            5,
            3,
            2,
            3,
            4,
            4,
            3,
            4,
            5,
            3,
            2,
            4,
            5,
            5,
            4,
            5,
            2,
            4,
            1,
            1,
            2,
            2,
            3,
            2,
            3,
            3,
            4,
            2,
            3,
            3,
            4,
            3,
            4,
            4,
            3,
            2,
            3,
            3,
            4,
            3,
            4,
            4,
            5,
            3,
            2,
            4,
            3,
            4,
            3,
            5,
            2,
            2,
            3,
            3,
            4,
            3,
            4,
            4,
            5,
            3,
            4,
            4,
            5,
            4,
            5,
            5,
            4,
            3,
            4,
            4,
            3,
            4,
            5,
            5,
            4,
            4,
            3,
            5,
            2,
            5,
            4,
            2,
            1,
            2,
            3,
            3,
            4,
            3,
            4,
            4,
            5,
            3,
            4,
            4,
            5,
            2,
            3,
            3,
            2,
            3,
            4,
            4,
            5,
            4,
            5,
            5,
            2,
            4,
            3,
            5,
            4,
            3,
            2,
            4,
            1,
            3,
            4,
            4,
            5,
            4,
            5,
            3,
            4,
            4,
            5,
            5,
            2,
            3,
            4,
            2,
            1,
            2,
            3,
            3,
            2,
            3,
            4,
            2,
            1,
            3,
            2,
            4,
            1,
            2,
            1,
            1,
            0
        ])
    };
}
var wg = new bn, Jb = class {
    constructor(){
        this.pyramidPassScene = new Er;
        this.pyramidPassMaterial = new Tu({
            name: "PyramidPass"
        });
        this.pyramidPassUniforms = {
            inputTexture: {
                value: void 0
            },
            inputWidth: {
                value: 0
            },
            inputHeight: {
                value: 0
            },
            inputShiftX: {
                value: 0
            },
            outputShiftX: {
                value: 0
            }
        };
        this.pyramidTopLevelReadPixelBuffer = new Float32Array(4);
        let t = `
			precision highp float;
			precision highp sampler2D;
			layout(location = 0) out vec4 pc_FragColor;
			uniform sampler2D inputTexture;
			uniform float inputWidth;
			uniform float inputHeight;
			uniform float inputShiftX;
			uniform float outputShiftX;
			const vec2 half_unit_coord = vec2(0.5);
			const vec4 one = vec4(1.0);
			void main() {
				vec2 inputSize = vec2(inputWidth, inputHeight);
				vec2 input_pixel_uv = 1. / inputSize;
				vec2 coord = gl_FragCoord.xy - half_unit_coord;
				coord.x -= outputShiftX;
				coord = coord * 2. + half_unit_coord;
				coord.x += inputShiftX;

				// sample bottom left corner
				vec2 input_uv = coord / inputSize;
				float bl = texture(inputTexture, input_uv).r;

				// sample bottom right corner
				input_uv.x += input_pixel_uv.x;
				float br = texture(inputTexture, input_uv).r;

				// sample top right corner
				input_uv.y += input_pixel_uv.y;
				float tr = texture(inputTexture, input_uv).r;

				// sample top left corner
				input_uv.x -= input_pixel_uv.x;
				float tl = texture(inputTexture, input_uv).r;

				pc_FragColor.a = bl;
				pc_FragColor.b = pc_FragColor.a + br;
				pc_FragColor.g = pc_FragColor.b + tr;
				pc_FragColor.r = pc_FragColor.g + tl; 
			}
		`;
        this.pyramidPassMaterial.fragmentShader = t, this.pyramidPassMaterial.uniforms = this.pyramidPassUniforms, this.pyramidPassMaterial.depthTest = !1, this.pyramidPassMaterial.depthWrite = !1;
        let e = new Mt($f, this.pyramidPassMaterial);
        e.frustumCulled = !1, this.pyramidPassScene.add(e);
    }
    renderPyramid(t, e, r, i, s1) {
        new Pl().min.setScalar(0);
        let a = e.length - 1, l = new Ze;
        r.getViewport(l), this.pyramidPassUniforms.inputShiftX.value = 0, this.pyramidPassUniforms.outputShiftX.value = 0;
        let c = a - 1;
        for(let h = c; h >= 0; h--){
            let d = h % 2 === c % 2 ? s1[0] : s1[1], f = h === c ? i : h % 2 === c % 2 ? s1[1] : s1[0];
            this.pyramidPassUniforms.inputTexture.value = Array.isArray(f.texture) ? f.texture[1] : f.texture, this.pyramidPassUniforms.inputWidth.value = "width" in f ? f.width : 1, this.pyramidPassUniforms.inputHeight.value = "height" in f ? f.height : 1, r.setRenderTarget(d);
            let m = e[h], p = r.getPixelRatio();
            r.setViewport(this.pyramidPassUniforms.outputShiftX.value / p, 0, m / p, m / p), h === 2 && t % 2 !== 0 && r.setViewport(this.pyramidPassUniforms.outputShiftX.value / p, 0, 3 / p, 3 / p), r.render(this.pyramidPassScene, wg);
            let g = this.pyramidPassUniforms.inputShiftX.value;
            this.pyramidPassUniforms.inputShiftX.value = this.pyramidPassUniforms.outputShiftX.value, this.pyramidPassUniforms.outputShiftX.value = g, h < c && (this.pyramidPassUniforms.outputShiftX.value += e[h + 1]);
        }
        r.setViewport(l);
        let u1 = e.length % 2 === 0 ? 0 : 1;
        return r.readRenderTargetPixelsAsync(s1[u1], s1[u1].width - 1, 0, 1, 1, this.pyramidTopLevelReadPixelBuffer).then(()=>this.pyramidTopLevelReadPixelBuffer[0]);
    }
};
var fo = 24, sn = 96, ua = nF(), nl = 2, wM = class extends Ct {
    constructor(e, r, i){
        super(e, r, i);
        this.data = r;
        this.needsRebuild = !0;
        this.customDepthMaterialNeedsUpdate = !1;
        this._npart = -1;
        this.spatialn = 1;
        this.drawRangeNeedsForceUpdate = !0;
        this._resolutionLevel = -1;
        this.resolution = 64;
        this.spatialDivisions = 25;
        this.zLayersPerRow = 8;
        this.basePyramidSize = 512;
        this.pyramidTexture1Width = 341;
        this.pyramidTexture1Height = 256;
        this.pyramidTexture2Width = 170;
        this.pyramidTexture2Height = 128;
        this.numLevels = 9;
        this.pyramidLevelSizes = [
            1,
            2,
            4,
            8,
            16,
            32,
            64,
            128,
            256,
            512
        ];
        this.bboxSize = 0;
        this.bboxOffset = 0;
        this.shapesDataTexture = {
            value: void 0
        };
        this.spatialscene = new Er;
        this.potentialPassScene = new Er;
        this.voxelPassScene = new Er;
        this._spatialPassRenderTargets = [];
        this._potentialPassRenderTargets = [];
        this._voxelPassRenderTargets = [];
        this._pyramidRenderTargets = [];
        this.geometry = new Ce, this.geometry.drawRange.count = 0, this.spatialPassUniforms = {
            span: {
                value: -1
            },
            shapesDataTexture: this.shapesDataTexture,
            npart: {
                value: this.npart
            },
            spatialn: {
                value: this.spatialn
            }
        }, this.spatialMesh = new Mt($f, this.spatialPassMaterial()), this.spatialMesh.frustumCulled = !1, this.spatialscene.add(this.spatialMesh);
        let s1 = new Ur(ua.triTable, 16, 256, Zp, Ut);
        s1.needsUpdate = !0;
        let o = new Ur(ua.numTrisTable, 256, 1, Zp, Ut);
        o.needsUpdate = !0, this.voxelPassUniforms = {
            potentialPassTexture: {
                value: void 0
            },
            numTrisTable: {
                value: o
            }
        }, this.voxelMesh = new Mt($f, this.voxelPassMaterial()), this.voxelMesh.frustumCulled = !1, this.voxelPassScene.add(this.voxelMesh), this.potentialPassUniforms = {
            shapesDataTexture: this.shapesDataTexture,
            spatialPassTexture: {
                value: void 0
            },
            npart: {
                value: this.npart
            },
            spatialn: {
                value: this.spatialn
            }
        }, this.potentialMesh = new Mt($f, this.potentialPassMaterial()), this.potentialMesh.frustumCulled = !1, this.potentialPassScene.add(this.potentialMesh), this.marchPassUniforms = {
            triTable: {
                value: s1
            },
            potentialPassTexture: {
                value: void 0
            },
            voxelPassTexture: {
                value: void 0
            },
            pyramidTexture1: {
                value: void 0
            },
            pyramidTexture1Size: {
                value: void 0
            },
            pyramidTexture2: {
                value: void 0
            },
            pyramidTexture2Size: {
                value: void 0
            }
        }, this.frustumCulled = !1, this.onBeforeShadowPass = (a)=>{
            if (Aee.call(this), this.npart === 0) {
                this.geometry.drawRange.count = 0;
                return;
            }
            let l = this.material.root;
            if (!l.shadersPatchedForShapeBlend) this.patchVertexShaderForShapeBlend(l), l.shadersPatchedForShapeBlend = !0, this.customDepthMaterialNeedsUpdate = !0;
            else if (this.customDepthMaterialNeedsUpdate) {
                this.customDepthMaterialNeedsUpdate = !1, this.customDepthMaterial = new $e({
                    vertexShader: l.vertexShader,
                    fragmentShader: `
						#include <packing>
						void main()
						{
							gl_FragColor = packDepthToRGBA(gl_FragCoord.z);
						}
					`,
                    uniforms: l.uniforms,
                    defines: this.material.defines
                }), this.isMeshDepthMaterial = !0, this.customDistanceMaterial = new $e({
                    vertexShader: l.vertexShader,
                    fragmentShader: `
					#include <common>
					#include <packing>
					uniform vec3 referencePosition;
					uniform float nearDistance;
					uniform float farDistance;
					// World-space position
					varying vec3 vWPosition;
					void main()
					{
						float dist = length(vWPosition - referencePosition);
						dist = (dist - nearDistance) / (farDistance - nearDistance);
						dist = saturate(dist);
						// Required by Three.js for this to work
						gl_FragColor = packDepthToRGBA( dist );
					}`,
                    uniforms: {
                        nearDistance: {
                            value: 0
                        },
                        farDistance: {
                            value: 0
                        },
                        referencePosition: {
                            value: new E
                        },
                        opacity: {
                            value: 0
                        },
                        ...l.uniforms
                    },
                    defines: this.material.defines
                });
                let h = this.customDistanceMaterial;
                h.referencePosition = new E, h.nearDistance = 0, h.farDistance = 0, h.opacity = 1, h.isMeshDistanceMaterial = !0;
            }
            if (this.spatialPassUniforms.npart.value = this.npart, this.spatialPassUniforms.spatialn.value = this.spatialn, this.potentialPassUniforms.npart.value = this.npart, this.potentialPassUniforms.spatialn.value = this.spatialn, this.needsRebuild) {
                this.needsRebuild = !1, this.spatialMesh.material.defines.RES = this.resolutionLevel, this.spatialMesh.material.needsUpdate = !0, this.potentialMesh.material.defines.RES = this.resolutionLevel, this.potentialPassUniforms.spatialPassTexture.value = this.spatialPassRenderTarget.texture, this.potentialMesh.material.needsUpdate = !0, this.voxelMesh.material.defines.RES = this.resolutionLevel, this.voxelMesh.material.needsUpdate = !0, this.voxelPassUniforms.potentialPassTexture.value = this.potentialPassRenderTarget.texture, this.marchPassUniforms.potentialPassTexture.value = this.potentialPassRenderTarget.texture, this.marchPassUniforms.voxelPassTexture.value = this.voxelPassRenderTarget.texture[0], this.material.defines.RES = this.resolutionLevel, this.material.defines.LEVELS = this.pyramidLevelSizes.length, this.material.defines.LOOP = this.pyramidLevelSizes.length % 2 === 0 ? this.pyramidLevelSizes.length - 3 : this.pyramidLevelSizes.length - 2, this.material.defines.HALF = this.pyramidLevelSizes.length % 2 === 0 ? 1 : 0, this.material.needsUpdate = !0;
                let h = this.pyramidLevelSizes.length % 2 === 0 ? 0 : 1, d = this.pyramidLevelSizes.length % 2 === 0 ? 1 : 0;
                this.marchPassUniforms.pyramidTexture2.value = this.pyramidRenderTarget[h].texture, this.marchPassUniforms.pyramidTexture2Size.value = new U(this.pyramidRenderTarget[h].width, this.pyramidRenderTarget[h].height), this.marchPassUniforms.pyramidTexture1.value = this.pyramidRenderTarget[d].texture, this.marchPassUniforms.pyramidTexture1Size.value = new U(this.pyramidRenderTarget[d].width, this.pyramidRenderTarget[d].height), Object.assign(this.material.uniforms, this.marchPassUniforms);
            }
            let c = a.shadowMap.enabled;
            a.shadowMap.enabled = !1;
            let u1 = a.getRenderTarget();
            a.setRenderTarget(this.spatialPassRenderTarget), a.render(this.spatialscene, wg), a.setRenderTarget(this.potentialPassRenderTarget), a.render(this.potentialPassScene, wg), a.setRenderTarget(this.voxelPassRenderTarget), a.render(this.voxelPassScene, wg), wM.streamCompaction.renderPyramid(this.resolutionLevel, this.pyramidLevelSizes, a, this.voxelPassRenderTarget, this.pyramidRenderTarget).then((h)=>{
                this.material.wireframe && (h * 3 > this.geometry.attributes.position.count || this.drawRangeNeedsForceUpdate) && (this.geometry.dispose(), this.geometry = new Ce, this.geometry.userData.parameters = {
                    width: this.bboxSize,
                    height: this.bboxSize,
                    depth: this.bboxSize,
                    centerOffset: [
                        this.bboxOffset,
                        this.bboxOffset,
                        this.bboxOffset
                    ]
                }, this.geometry.attributes.position = new je(new Float32Array(h * 6), 3)), (h * 3 > this.geometry.drawRange.count || this.drawRangeNeedsForceUpdate) && (this.geometry.drawRange.count = Math.floor(h * 1.2) * 3), this.drawRangeNeedsForceUpdate = !1;
            }), a.shadowMap.enabled = c, a.setRenderTarget(u1);
        };
    }
    set npart(e) {
        e !== this._npart && (this.drawRangeNeedsForceUpdate = !0, this._npart = e, this.spatialn = Math.ceil(e / (4 * fo)));
    }
    get npart() {
        return this._npart;
    }
    set resolutionLevel(e) {
        let r = Math.min(8, Math.max(5, e));
        if (r !== this._resolutionLevel) {
            switch(this._resolutionLevel = r, this.resolution = Math.pow(2, r), this.resolutionLevel){
                case 5:
                    this.pyramidLevelSizes = [
                        1,
                        2,
                        4,
                        6,
                        12,
                        24,
                        48,
                        96,
                        192
                    ], this.bboxSize = 248 * nl, this.bboxOffset = 8 * nl * -1 / 2;
                    break;
                case 6:
                    this.pyramidLevelSizes = [
                        1,
                        2,
                        4,
                        8,
                        16,
                        32,
                        64,
                        128,
                        256,
                        512
                    ], this.bboxSize = 252 * nl, this.bboxOffset = 4 * nl * -1 / 2;
                    break;
                case 7:
                    this.pyramidLevelSizes = [
                        1,
                        2,
                        4,
                        6,
                        12,
                        24,
                        48,
                        96,
                        192,
                        384,
                        768,
                        1536
                    ], this.bboxSize = 254 * nl, this.bboxOffset = 2 * nl * -1 / 2;
                    break;
                case 8:
                    this.pyramidLevelSizes = [
                        1,
                        2,
                        4,
                        8,
                        16,
                        32,
                        64,
                        128,
                        256,
                        512,
                        1024,
                        2048,
                        4096
                    ], this.bboxSize = 255 * nl, this.bboxOffset = nl * -1 / 2;
                    break;
            }
            this.pyramidTexture1Width = 0, this.pyramidTexture2Width = 0, this.pyramidTexture1Height = this.pyramidLevelSizes[this.pyramidLevelSizes.length - 2], this.pyramidTexture2Height = this.pyramidLevelSizes[this.pyramidLevelSizes.length - 3];
            for(let i = this.pyramidLevelSizes.length - 2; i >= 0; i--)(this.pyramidLevelSizes.length - 2) % 2 === i % 2 ? this.pyramidTexture1Width += this.pyramidLevelSizes[i] : this.pyramidTexture2Width += this.pyramidLevelSizes[i];
            this.basePyramidSize = this.pyramidLevelSizes[this.pyramidLevelSizes.length - 1], this.zLayersPerRow = this.basePyramidSize / this.resolution, this.numLevels = this.pyramidLevelSizes.length - 1, this.geometry.userData.parameters = {
                width: this.bboxSize,
                height: this.bboxSize,
                depth: this.bboxSize,
                centerOffset: [
                    this.bboxOffset,
                    this.bboxOffset,
                    this.bboxOffset
                ]
            }, this.needsRebuild = !0, this.customDepthMaterialNeedsUpdate = !0;
        }
    }
    get resolutionLevel() {
        return this._resolutionLevel;
    }
    get spatialPassRenderTarget() {
        let e = this._spatialPassRenderTargets[this.resolutionLevel];
        return e || (e = new at(this.spatialDivisions * this.spatialn, this.spatialDivisions ** 2, {
            format: br,
            type: Ut,
            stencilBuffer: !1,
            depthBuffer: !1,
            generateMipmaps: !1,
            minFilter: vt,
            magFilter: vt
        }), this._spatialPassRenderTargets[this.resolutionLevel] = e), e;
    }
    get potentialPassRenderTarget() {
        let e = this._potentialPassRenderTargets[this.resolutionLevel];
        return e || (e = new at(this.basePyramidSize, this.basePyramidSize, {
            format: br,
            type: Ut,
            stencilBuffer: !1,
            depthBuffer: !1,
            generateMipmaps: !1,
            minFilter: vt,
            magFilter: vt
        }), this._potentialPassRenderTargets[this.resolutionLevel] = e), e;
    }
    get voxelPassRenderTarget() {
        let e = this._voxelPassRenderTargets[this.resolutionLevel];
        return e || (e = new eh(this.basePyramidSize, this.basePyramidSize, 2, {
            stencilBuffer: !1,
            depthBuffer: !1,
            generateMipmaps: !1,
            minFilter: vt,
            magFilter: vt
        }), e.texture[0].format = br, e.texture[0].type = Ut, e.texture[1].format = Zp, e.texture[1].type = Ut, this._voxelPassRenderTargets[this.resolutionLevel] = e), e;
    }
    get pyramidRenderTarget() {
        let e = this._pyramidRenderTargets[this.resolutionLevel];
        if (!e) {
            let r = new at(this.pyramidTexture1Width, this.pyramidTexture1Height, {
                format: br,
                type: Ut,
                stencilBuffer: !1,
                depthBuffer: !1,
                magFilter: vt,
                minFilter: vt
            }), i = new at(this.pyramidTexture2Width, this.pyramidTexture2Height, {
                format: br,
                type: Ut,
                stencilBuffer: !1,
                depthBuffer: !1,
                magFilter: vt,
                minFilter: vt
            });
            e = [
                r,
                i
            ], this._pyramidRenderTargets[this.resolutionLevel] = e;
        }
        return e;
    }
    updateState(e, r) {
        let i = this.material;
        super.updateState(e, r), i !== this.material && (this.needsRebuild = !0), e.geometry && (this.resolutionLevel = e.geometry.resolutionLevel, this.geometry.userData.parameters = {
            width: this.bboxSize,
            height: this.bboxSize,
            depth: this.bboxSize,
            centerOffset: [
                this.bboxOffset,
                this.bboxOffset,
                this.bboxOffset
            ]
        }), e.wireframe && !this.geometry.getAttribute("position") ? this.geometry.setAttribute("position", new je(new Float32Array(this.geometry.drawRange.count * 3), 3)) : !e.wireframe && this.geometry.getAttribute("position") && this.geometry.deleteAttribute("position");
    }
    spatialPassMaterial() {
        let e = `
			precision highp float;
			out vec4 pc_FragColor;
			const float spatialDivisions = ${this.spatialDivisions}.;
			uniform float span;
			uniform float npart;
			uniform float spatialn;
			${ua.shapeInput()}

			vec3 low, high;     // range of current div; subset of -1 .. 1 with span border

			// lookup one element/channel's worth of spheres for current division
			// stating with low sphere number lowi
			// gives a key to which spheres from lowi..lowi+23 are active within given div (low..high)
			float spatialKey(float lowi) {
				float t = 0.;
				for (float ii = ${fo - 1}.; ii >= 0.; ii--) {
					float i = ii + lowi;
					float iin = (i + 0.5) / ${sn}.;
					vec4 shape = shapePos(iin);
					vec3 d = shape.xyz;
					float op = shape.w;
	
					t *= 2.;
					t += (
						low.x < d.x && d.x < high.x &&
						low.y < d.y && d.y < high.y &&
						low.z < d.z && d.z < high.z &&
						i < npart || op == -2. // always include if op is -2, which is the intersection operation
					) ? 1. : 0.;
				}
				return t;
			}

			${ua.getpart}

			void main() {               // spatialial fragment shader
				// find active div
				vec3 div;                               // which div is current
				// out holds x=> x, lowi faster moving and y=> z, y faster moving
				float yz = float(gl_FragCoord.y - 0.5);     // contains  z, y faster moving
				div.y = getpart(yz, spatialDivisions);
				div.z = yz; // getpart(yz, spatialDivisions.z); // what's left, should be the same as getpart

				float lx = float(gl_FragCoord.x - 0.5);     // contains x, lowi faster moving
				float lowi = getpart(lx, spatialn) * ${4 * fo}.;
				div.x = lx;

				low = div / spatialDivisions * 2. - 1. - span;
				high = (div+1.) / spatialDivisions * 2. - 1. + span;

				// find active range of spheres
				pc_FragColor.x = spatialKey(lowi);
				pc_FragColor.y = spatialKey(lowi+${fo}.);
				pc_FragColor.z = spatialKey(lowi+${2 * fo}.);
				pc_FragColor.w = spatialKey(lowi+${3 * fo}.);
			}
		`;
        return new Tu({
            name: "Spatial Pass",
            fragmentShader: e,
            uniforms: this.spatialPassUniforms
        });
    }
    potentialPassMaterial() {
        let e = `
			precision highp float;
			out vec4 pc_FragColor;

			${ua.shapeInput()}
			uniform sampler2D spatialPassTexture;

			const float res = float(RES);
			const float VOXEL_RESOLUTION = pow(2., res);
			const float Z_LAYERS_PER_ROW = ceil(pow(2., res / 2.));
			const float VOXEL_RESOLUTION_SUB1 = VOXEL_RESOLUTION - 1.;
			const float INV_VOXEL_RESOLUTION = 1.0 / VOXEL_RESOLUTION;

			uniform float npart;
			uniform float spatialn;
			const float spatialDivisions = ${this.spatialDivisions}.;
			const float spatialDivisions2 = spatialDivisions * spatialDivisions;
			const float spatialDivisionsSub1 = spatialDivisions - 1.;

			${ua.getpart}

			vec3 packRGBAToVec3(vec4 color) {
				uint r = uint(color.r * 255.);
				uint g = uint(color.g * 255.);
				uint combined = (r << 8) | g; 
				return vec3(float(combined) * 0.00001525902, color.b, color.a); // 1/65535
			}

			void applyQuaternionToVector(in vec4 q, inout vec3 v) {
				v += 2.0 * cross(q.xyz, cross(q.xyz, v) + q.w * v);
			}

			/**
			 * SDF functions (reference: https://iquilezles.org/articles/distfunctions/)
			 */

			// branchless version of "Smooth Union, Subtraction and Intersection - bound, bound, bound" in above reference
			float smoothOperation(float op, float sdf, float d, float k) {
			  //        union: op =  1 => signSubtract =  1, signIntersection =  1
			  //     subtract: op = -1 => signSubtract = -1, signIntersection =  1
				// intersection: op = -2 => signSubtract = -1, signIntersection = -1

				float signSubtract = clamp(op, -1., 1.);
				float signIntersection = 2. * (op - signSubtract) + 1.;
				float h = clamp(
					0.5 + signSubtract * 0.5 * (sdf - signSubtract * signIntersection * d) / k,
					0.0,
					1.0
				);
				return mix(sdf, signSubtract * signIntersection * d, h) - 
							 signSubtract * k * h * (1.0 - h);
			}

			float sdSphere( vec3 p, float s )
			{
				return length(p)-s;
			}

			float sdEllipsoid( vec3 p, vec3 r )
			{
				float k0 = length(p/r);
				float k1 = length(p/(r*r));
				return k0*(k0-1.0)/k1;
			}

			float sdBox( vec3 p, vec3 b )
			{
				vec3 q = abs(p) - b;
				return length(max(q,0.0)) + min(max(q.x,max(q.y,q.z)),0.0);
			}

			float sdTorus( vec3 p, vec2 t )
			{
				vec2 q = vec2(length(p.xy)-t.x,p.z);
				return length(q)-t.y;
			}

			float sdCappedTorus( vec3 p, vec2 sc, float ra, float rb)
			{
				p.x = abs(p.x);
				float k = (sc.y*p.x>sc.x*p.y) ? dot(p.xy,sc) : length(p.xy);
				return sqrt( dot(p,p) + ra*ra - 2.0*ra*k ) - rb;
			}

			float dot2( in vec2 v ) { return dot(v,v); }
			float sdCappedCone( vec3 p, float h, float r1, float r2 )
			{
				vec2 q = vec2( length(p.xz), p.y );
				vec2 k1 = vec2(r2,h);
				vec2 k2 = vec2(r2-r1,2.0*h);
				vec2 ca = vec2(q.x-min(q.x,(q.y<0.0)?r1:r2), abs(q.y)-h);
				vec2 cb = q - k1 + k2*clamp( dot(k1-q,k2)/dot2(k2), 0.0, 1.0 );
				float s = (cb.x<0.0 && ca.y<0.0) ? -1.0 : 1.0;
				return s*sqrt( min(dot2(ca),dot2(cb)) );
			}

			float sdCappedCylinder( vec3 p, float h, float r )
			{
				vec2 d = abs(vec2(length(p.xz),p.y)) - vec2(r,h);
				return min(max(d.x,d.y),0.0) + length(max(d,0.0));
			}

			float maxBlend = 0.0;
			// compute potential from A (=24) spheres, using the bit flags in 'activeKey'
			// to avoid lookup/compute for inactive spheres
			// return field potential, side effect updates track,
			// compute and return +ve and -ve values separately
			void fillSpatialInner(
				float ii,
				float activeKey,
				vec3 corner,
				inout float sdf,
				inout float colorDivisor,
				inout vec4 trackColor
			) {
				for (float i = 0.; i < ${fo}.; i++) {
					if (activeKey < 1.) break; // activeKey exhausted, no more active spheres
					activeKey *= 0.5;
					if (fract(activeKey) < 0.5) continue;

					float iin = (i + ii + 0.5) * ${1 / sn};
					vec4 shape = shapePos(iin);
					vec4 quat = shapeQuat(iin);
					vec4 params1 = shapeParams1(iin);
					vec4 params2 = shapeParams2(iin);

					vec3 p = corner - shape.xyz;
					applyQuaternionToVector(quat, p);
					p /= params2.z; // scale
					float d; // d in -1..1 coordinates
					switch (int(params1.x)) {
						case 0: d = sdSphere(p, params1.y); break;
						case 1: d = sdEllipsoid(p, params1.yzw); break;
						case 2: d = sdBox(p, params1.yzw); break;
						case 3: d = sdCappedCylinder(p, params1.y, params1.z); break;
						case 4: d = sdCappedCone(p, params1.y, params1.z, params1.w); break;
						case 5: d = sdTorus(p, params1.yz); break;
						case 6: d = sdCappedTorus(p, params1.yz, params1.w, params2.w); break;
					}
					d -= params2.y; // rounded edge
					d *= params2.z; // scale

					float k = params2.x;
					float op = shape.w;

					sdf = smoothOperation(shape.w, sdf, d, k);

					float isNegativeOne = step(-1.5, op) * step(op, -0.5); // 1 when op == -1, 0 otherwise
					float colorCull = smoothstep(maxBlend, 0., -d);
					float cullFactor = mix(1.0, colorCull, isNegativeOne);
					trackColor *= cullFactor;
					colorDivisor *= cullFactor;

					maxBlend = max(maxBlend, k);

					k += 2. * INV_VOXEL_RESOLUTION; // avoid division by zero, and other color artifacts with very small k
					float nearness = smoothstep(k, 0., d);

					vec4 color = shapeColor(iin);
					nearness *= float(color.a >= 0.);

					colorDivisor += nearness;
					trackColor += color * nearness;
				}
			}

			vec3 div;
			// compute potential from all spheres; collect +ve and =ve values separately
			// work in blocks of A*4 (=96) spheres, using the bit flags in 4 float channel 'activeKey' values
			// TODO check if extra vec3 output useful, not really used at present
			float fillSpatial(vec3 corner, inout vec4 trackColor) {
				float sdf = 1e3; // hack: initialize to large value
				float colorDivisor = 0.;
				// spatialPassTexture holds x=> lowi, x faster moving and y=> z, y faster moving
				float divyz = (div.y + div.z * spatialDivisions + 0.5) / (spatialDivisions2);
				for (float ii = 0.; ii < spatialn; ii++) {
					float i = ii * ${4 * fo}.;

					vec4 activeKey = texture(spatialPassTexture, vec2((div.x * spatialn + ii + 0.5)/(spatialn * spatialDivisions), divyz));
					fillSpatialInner(i, activeKey.x, corner, sdf, colorDivisor, trackColor);
					fillSpatialInner(i+${fo}., activeKey.y, corner, sdf, colorDivisor, trackColor);
					fillSpatialInner(i+${2 * fo}., activeKey.z, corner, sdf, colorDivisor, trackColor);
					fillSpatialInner(i+${3 * fo}., activeKey.w, corner, sdf, colorDivisor, trackColor);
				}

				trackColor /= colorDivisor;
				return mix(sdf, 0.0, step(1e20 - 0.1, sdf));
			}

			void main() {
				${ua.getxyzi}    // get xi yi zi from 2d position

				vec3 xyzi = vec3(xi,yi,zi);
				vec3 corner = xyzi / VOXEL_RESOLUTION_SUB1 * 2. - 1.;  // -1..1 coords

				div = floor(xyzi / VOXEL_RESOLUTION_SUB1 * spatialDivisionsSub1);

				vec4 c = vec4(0.);
				float t = fillSpatial(corner, c);

				pc_FragColor = vec4(t, packRGBAToVec3(c)); // RGB texture
			}
		`;
        return new Tu({
            name: "PotentialPass",
            fragmentShader: e,
            uniforms: this.potentialPassUniforms
        });
    }
    voxelPassMaterial() {
        let e = `
			precision highp float;
			layout(location = 0) out vec4 pc_FragColor;
			layout(location = 1) out vec4 numTris;

			const float res = float(RES);
			const float VOXEL_RESOLUTION = pow(2., res);
			const float VOXEL_RESOLUTION_SUB1 = VOXEL_RESOLUTION - 1.; 
			const float Z_LAYERS_PER_ROW = ceil(pow(2., res / 2.));
			const float INV_VOXEL_RESOLUTION = 1.0 / VOXEL_RESOLUTION;
			uniform sampler2D numTrisTable; // 256 x 1

			float keyi(float f000, float f100, float f010, float f110, float f001, float f101, float f011, float f111) {
				return (float(f000 < 0.) * 1.) +
							 (float(f100 < 0.) * 2.) +
							 (float(f010 < 0.) * 8.) +
							 (float(f110 < 0.) * 4.) +
							 (float(f001 < 0.) * 16.) +
							 (float(f101 < 0.) * 32.) +
							 (float(f011 < 0.) * 128.) +
							 (float(f111 < 0.) * 64.);
			}

			${ua.lookup}

			vec3 compNormi(float xi, float yi, float zi) {
				float dx = look(xi + 1., yi, zi, potentialPassTexture).r - look(xi - 1., yi, zi, potentialPassTexture).r;
				float dy = look(xi, yi + 1., zi, potentialPassTexture).r - look(xi, yi - 1., zi, potentialPassTexture).r;
				float dz = look(xi, yi, zi + 1., potentialPassTexture).r - look(xi, yi, zi - 1., potentialPassTexture).r;
				// if we allow (common) 0,0,0 case through then NaN can spread
				// eg r = vec4(compNorm i(???), 1.) will pollute r.w
				if (dx == 0.0 && dy == 0.0 && dz == 0.0) {
					return vec3(0.199, 0.299, 0.399);
				}
				return normalize(vec3(dx, dy, dz));
			}

			void main() {
				${ua.getxyzi}    // get xi yi zi from 2d

				vec3 normal = compNormi(xi, yi, zi);  // even if our key is -1 this may be needed by a neighbouring voxel

				if (xi >= VOXEL_RESOLUTION_SUB1 || yi >= VOXEL_RESOLUTION_SUB1 || zi >= VOXEL_RESOLUTION_SUB1) {
					pc_FragColor = vec4(normal, 0.);
					numTris = vec4(0.);
					return;
				}

				float
					f000 = look(xi, yi, zi, potentialPassTexture).r,
					f100 = look(xi+1., yi, zi, potentialPassTexture).r,
					f010 = look(xi, yi+1., zi, potentialPassTexture).r,
					f110 = look(xi+1., yi+1., zi, potentialPassTexture).r,
					f001 = look(xi, yi, zi+1., potentialPassTexture).r,
					f101 = look(xi+1., yi, zi+1., potentialPassTexture).r,
					f011 = look(xi, yi+1., zi+1., potentialPassTexture).r,
					f111 = look(xi+1., yi+1., zi+1., potentialPassTexture).r;
				float key = keyi(f000, f100, f010, f110, f001, f101, f011, f111);

				pc_FragColor = vec4(normal, key);

				numTris = texture(numTrisTable, vec2((key + 0.5) / 256., 0.5));
			}
		`;
        return new Tu({
            name: "VoxelPass",
            fragmentShader: e,
            uniforms: this.voxelPassUniforms
        });
    }
    patchVertexShaderForShapeBlend(e) {
        let r = `
		#ifdef SHAPEBLEND 
			precision highp sampler2D;

			uniform float isol;

			uniform sampler2D triTable;     // 256 x 16
			uniform sampler2D pyramidTexture1;
			uniform vec2 pyramidTexture1Size;
			uniform sampler2D pyramidTexture2;
			uniform vec2 pyramidTexture2Size;

			const vec2 halfPixelOffset = vec2(0.5, 0.5);

			const vec2 rShift = vec2(0., 1.);
			const vec2 gShift = vec2(1., 1.);
			const vec2 bShift = vec2(1., 0.);

			const float res = float(RES);
			const float VOXEL_RESOLUTION = pow(2., res);
			const float Z_LAYERS_PER_ROW = ceil(pow(2., res / 2.));
			const float INV_VOXEL_RESOLUTION = 1.0 / VOXEL_RESOLUTION;

			const float scale_factor = ${nl}.;

			#if SHAPEBLEND == 5
				const float levelShiftX[7] = float[7](4., 6., 12., 24., 48., 96., 192.);
				const float scale = 8. * scale_factor;
				const vec3 originOffset = vec3(16.);
			#elif SHAPEBLEND == 7
				const float levelShiftX[10] = float[10](4., 6., 12., 24., 48., 96., 192., 384., 768., 1536.); 
				const float scale = 2. * scale_factor;
				const vec3 originOffset = vec3(64.);
			#elif SHAPEBLEND == 8
				const float levelShiftX[11] = float[11](4., 8., 16., 32., 64., 128., 256., 512., 1024., 2048., 4096.);
				const float scale = scale_factor;
				const vec3 originOffset = vec3(128.);
			#else
				const float levelShiftX[8] = float[8](4., 8., 16., 32., 64., 128., 256., 512.);
				const float scale = 4. * scale_factor;
				const vec3 originOffset = vec3(32.);
			#endif

			${ua.lookup}

			const vec3 offsets[24] = vec3[](
				vec3(0., 0., 0.), vec3(1., 0., 0.),
				vec3(1., 0., 0.), vec3(1., 1., 0.),
				vec3(0., 1., 0.), vec3(1., 1., 0.),
				vec3(0., 0., 0.), vec3(0., 1., 0.),
				vec3(0., 0., 1.), vec3(1., 0., 1.),
				vec3(1., 0., 1.), vec3(1., 1., 1.),
				vec3(0., 1., 1.), vec3(1., 1., 1.),
				vec3(0., 0., 1.), vec3(0., 1., 1.),
				vec3(0., 0., 0.), vec3(0., 0., 1.),
				vec3(1., 0., 0.), vec3(1., 0., 1.),
				vec3(1., 1., 0.), vec3(1., 1., 1.),
				vec3(0., 1., 0.), vec3(0., 1., 1.)
			);

			vec2 computeShiftedPosition1(vec2 xy, float levelOriginX) {
				vec2 xyShifted = xy;
				xyShifted.x += levelOriginX;
				return (xyShifted + halfPixelOffset) / pyramidTexture1Size;
			}

			vec2 computeShiftedPosition2(vec2 xy, float levelOriginX) {
				vec2 xyShifted = xy;
				xyShifted.x += levelOriginX;
				return (xyShifted + halfPixelOffset) / pyramidTexture2Size;
			}

			vec4 unpackVec3ToRGBA(vec3 vec) {
				uint combined = uint(vec.x * 65535.0 + 0.5); // Add 0.5 for rounding
				float g = float(combined & uint(0xFF)) * 0.00392156862; // 1/255
				float r = float((combined >> 8) & uint(0xFF)) * 0.00392156862; 
		
				return vec4(r, g, vec.y, vec.z);
			}

			out vec4 marchColor;
			// end of marchvertPre
		#endif
		`, i = `
		#ifdef SHAPEBLEND
			float triIndex = floor(float(gl_VertexID/3));
			float vertexIndex = float(gl_VertexID);
			
			// Initial pyramid lookup
			float levelOriginX1 = pyramidTexture1Size.x - 2.;
			float levelOriginX2 = pyramidTexture2Size.x - 1.;
			vec2 xy = vec2(0.);
			vec4 lookUp = texture(pyramidTexture2, computeShiftedPosition2(xy, levelOriginX2));
			
			// Early exit check
			if (triIndex >= lookUp.r) return;
			
			// Optimize loop variables
			float start = 0.;
			vec4 triIndexVec = vec4(triIndex);
			
			// Main position computation loop
			for (int i = 0; i < LOOP;) {
				// Compute boundaries
				vec4 ends = lookUp + vec4(start);
				vec4 starts = vec4(ends.gba, start);
				vec4 check = vec4(greaterThanEqual(triIndexVec, starts)) * 
											vec4(lessThan(triIndexVec, ends));
				
				// Update position
				xy *= 2.;
				xy += check.r * rShift + check.g * gShift + check.b * bShift;
				
				// Update loop variables
				start = dot(check, starts);
				levelOriginX2 -= levelShiftX[i];
				
				// Update lookup
				lookUp = texture(pyramidTexture1, computeShiftedPosition1(xy, levelOriginX1));
				i++;

				ends = lookUp + vec4(start);
				starts = vec4(ends.gba, start);
				check = vec4(greaterThanEqual(triIndexVec, starts)) * 
											vec4(lessThan(triIndexVec, ends));
				
				// Update position
				xy *= 2.;
				xy += check.r * rShift + check.g * gShift + check.b * bShift;
				
				// Update loop variables
				start = dot(check, starts);
				levelOriginX1 -= levelShiftX[i];
				
				// Update lookup
				lookUp = texture(pyramidTexture2, computeShiftedPosition2(xy, levelOriginX2));

				i++;
			}

			#if HALF == 1
				vec4 ends = lookUp + vec4(start);
				vec4 starts = vec4(ends.gba, start);
				vec4 check = vec4(greaterThanEqual(triIndexVec, starts)) * vec4(lessThan(triIndexVec, ends));
			
				// Update position
				xy *= 2.;
				xy += check.r * rShift + check.g * gShift + check.b * bShift;
			
				// Update loop variables
				start = dot(check, starts);
			#endif
			
			// Compute final coordinates
			vec3 gridPos;
			gridPos.x = mod(xy.x, VOXEL_RESOLUTION);
			gridPos.y = mod(xy.y, VOXEL_RESOLUTION);
			gridPos.z = floor(xy.x * INV_VOXEL_RESOLUTION) + 
									floor(xy.y * INV_VOXEL_RESOLUTION) * Z_LAYERS_PER_ROW;
			
			// Vertex key computation
			vertexIndex -= start * 3.;
			float vk = vertexIndex * 0.0625 + 0.03125; // Optimized division by 16 and addition of 1/32
			
			// Voxel lookup and edge computation
			vec4 voxel = look(gridPos.x, gridPos.y, gridPos.z, voxelPassTexture);
			float key = (voxel.w + 0.5) * 0.00390625; // Optimized division by 256
			
			// Edge lookup and offset computation
			float edgeNum = texture(triTable, vec2(vk, key)).x;
			int edgeIndex = int(edgeNum) * 2;
			
			// Compute edge positions
			vec3 p1 = gridPos + offsets[edgeIndex];
			vec3 p2 = gridPos + offsets[edgeIndex + 1];
			
			// Compute potentials and normals
			vec4 potential1 = look(p1.x, p1.y, p1.z, potentialPassTexture);
			vec4 potential2 = look(p2.x, p2.y, p2.z, potentialPassTexture);
			
			// Final position and normal computation
			float mu = potential1.r / (potential1.r - potential2.r);

			marchColor = mix(
				unpackVec3ToRGBA(potential1.gba),
				unpackVec3ToRGBA(potential2.gba),
				mu
			);

			transformed = p1 + (p2 - p1) * mu;
			transformed -= originOffset;
			transformed *= scale;
			vec4 data1 = look(p1.x, p1.y, p1.z, voxelPassTexture);
			vec4 data2 = look(p2.x, p2.y, p2.z, voxelPassTexture);
			objectNormal = normalize(mix(data1.xyz, data2.xyz, mu));
			transformedNormal = normalMatrix * objectNormal;
			#ifndef FLAT_SHADED
				vNormal = transformedNormal;
			#endif
		#endif
		`;
        e.vertexShader = r + e.vertexShader.replace("#include <project_vertex>", i + `
#include <project_vertex>`);
        let s1 = e.fragmentShader.match(/vec3 diffuseColor[^\n]*\n/);
        if (!s1) return;
        let a = `
		#ifdef SHAPEBLEND_C
			#if SHAPEBLEND_C == 1
				${s1[0].replace(/nodeU0,/g, "marchColor.rgb,").replace(/nodeU\d+(?=,g_uid\d+_calpha\))/g, "marchColor.a")}
			#else
				${s1[0]}
			#endif
		#else
			${s1[0]}
		#endif
		`;
        e.fragmentShader = `in vec4 marchColor;
` + e.fragmentShader.replace(s1[0], a), Object.assign(e.uniforms, this.marchPassUniforms);
    }
    initDebugPass(e) {
        console.log("fboToDebug.width", e.width, e.height), this.geometry = new Si(e.width, e.height), this.geometry.userData = {
            parameters: {
                width: 4,
                height: 4
            }
        };
        let r = {
            inputTexture: {
                value: Array.isArray(e.texture) ? e.texture[1] : e.texture
            },
            pyramidTextureSize: {
                value: void 0
            }
        }, i = (s1)=>{
            s1.vertexShader = `
				precision highp float;

				varying vec2 vUv;

				void main() {
						gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
						vUv = uv;
				}
			`, s1.fragmentShader = `
				layout(location = 1) out vec4 gVelocity;

				precision highp float;
				
				uniform sampler2D inputTexture;
				varying vec2 vUv;

				uniform vec2 pyramidTextureSize;

				void main() {
						// Sample the input texture using UV coordinates
						gl_FragColor = texture(inputTexture, vUv);
						gVelocity = vec4(0.0);
				}
			`, r.pyramidTextureSize.value = new U(this.pyramidRenderTarget[0].width, this.pyramidRenderTarget[0].height), Object.assign(s1.uniforms, r);
        };
        this.material.shapeBlendhack = i, this.material.root.shapeBlendhack = i;
    }
}, cs = wM;
cs.streamCompaction = new Jb;
var xee = new ue, bee = new ue, ep = new Ye, bc = new E, $b = new E, See = new Ye;
function wee(n1, t = 0) {
    let e = this.children.length;
    for(; e--;){
        let r = this.children[e];
        Xa.is(r) && sF.call(r, n1, t + 1);
    }
}
function sF(n1, t = 0) {
    if (n1(this, t) !== !0) {
        let r = this.children.length;
        for(; r--;){
            let i = this.children[r];
            Xa.is(i) && sF.call(i, n1, t + 1);
        }
    }
}
function Aee() {
    if (this.shapesDataTexture.value === void 0) {
        let o = new Ur(new Float32Array(4 * sn * xc), sn, xc, br, Ut);
        this.shapesDataTexture.value = o;
    }
    let n1 = this.shapesDataTexture.value, t = n1.image.data;
    n1.needsUpdate = !0;
    let e = 0, r = this.data.geometry.blendRange, i = xee.copy(this.matrixWorld).invert(), s1 = 0;
    wee.call(this, (o)=>{
        if (o.visible === !1) return !0;
        let a;
        if (o instanceof Ai) return;
        if (o instanceof oa || o instanceof ca) return;
        o instanceof Lr ? a = o.object : a = o;
        let l = o.data?.cloner;
        if (gt.is(o) && l && !l.hideBase && l.type !== "radial" && l.disabled !== !0 || !(a instanceof Ct)) return;
        let c = a.geometry.userData.parameters, u1 = c.shapeBlendNode;
        if (u1 === void 0) return;
        if (bee.multiplyMatrices(i, o.matrixWorld).decompose($b, ep, bc), c.type === "TorusGeometry" && c.arc !== 360) {
            let x = c.arc * Math.PI / 180;
            x = x / 4, ep.multiply(See.set(0, 0, Math.sin(x), Math.cos(x)));
        }
        let d = u1.overrideGlobalBlend ? u1.blendRange : r;
        d = d / this.bboxSize * 2, t[s1 * 4] = ($b.x - this.bboxOffset) / this.bboxSize * 2, t[s1 * 4 + 1] = ($b.y - this.bboxOffset) / this.bboxSize * 2, t[s1 * 4 + 2] = ($b.z - this.bboxOffset) / this.bboxSize * 2, t[s1 * 4 + 3] = u1.operation === 0 ? 1 : u1.operation === 2 ? -1 : -2, t[sn * 4 + s1 * 4] = -ep.x, t[sn * 4 + s1 * 4 + 1] = -ep.y, t[sn * 4 + s1 * 4 + 2] = -ep.z, t[sn * 4 + s1 * 4 + 3] = ep.w;
        let f = new Float32Array(4), m = 0;
        if (c.type === "SphereGeometry") c.width === c.height && c.width === c.depth ? f[0] = 0 : f[0] = 1, f[1] = c.width / this.bboxSize, f[2] = c.height / this.bboxSize, f[3] = c.depth / this.bboxSize, e = Math.max(e, f[1] * bc.x + d, f[2] * bc.x + d, f[3] * bc.x + d);
        else if (c.type === "CubeGeometry") {
            m = c.cornerRadius;
            let x = c.width, v = c.height, b = c.depth;
            f[0] = 2, f[1] = (x - 2 * m) / this.bboxSize, f[2] = (v - 2 * m) / this.bboxSize, f[3] = (b - 2 * m) / this.bboxSize, e = Math.max(e, Math.sqrt(x ** 2 + v ** 2 + b ** 2) / this.bboxSize * bc.x + d);
        } else if (c.type === "CylinderGeometry") {
            m = c.cornerRadius;
            let x = c.height, v = c.radiusBottom, b = c.radiusTop;
            if (b >= v) {
                let w = Math.atan2(b - v, x), A = (Math.PI / 2 - w) / 2;
                b -= m / Math.tan(A), v -= m * Math.tan(A);
            } else if (v > b) {
                let w = Math.atan2(v - b, x), A = (Math.PI / 2 - w) / 2;
                b -= m * Math.tan(A), v -= m / Math.tan(A);
            }
            f[1] = (c.height - 2 * m) / this.bboxSize, v === b ? (f[0] = 3, f[2] = v / this.bboxSize * 2) : (f[0] = 4, f[2] = v / this.bboxSize * 2, f[3] = b / this.bboxSize * 2), e = Math.max(e, f[1] * 4 * bc.x + d);
        } else if (c.type === "TorusGeometry") {
            if (f[0] = 5, f[1] = (c.width - c.depth) / this.bboxSize, f[2] = c.depth / this.bboxSize, c.arc !== 360) {
                f[0] = 6, f[3] = f[1], t[sn * 12 + s1 * 4 + 3] = f[2];
                let x = 2 * Math.atan2(f[2] / 2, f[1]), v = c.arc * Math.PI / 180 / 2 - x;
                f[1] = Math.sin(v), f[2] = Math.cos(v);
            }
            e = Math.max(e, c.width * bc.x / this.bboxSize + d);
        }
        t.set(f, sn * 8 + s1 * 4), t[sn * 12 + s1 * 4] = d, t[sn * 12 + s1 * 4 + 1] = m / this.bboxSize * 2, t[sn * 12 + s1 * 4 + 2] = bc.x;
        let p = a.material, g = p.uniforms.nodeU0.node.value, y = p.uniforms.nodeU1.value;
        u1.operation !== 0 && !u1.useColor && (y = -1), t[sn * 16 + s1 * 4] = g.r, t[sn * 16 + s1 * 4 + 1] = g.g, t[sn * 16 + s1 * 4 + 2] = g.b, t[sn * 16 + s1 * 4 + 3] = y, y < 1 && this.material.defines.SHAPEBLEND_C === 1 && (this.material.transparent = !0), s1++;
    }), this.npart = s1, this.spatialPassUniforms.span.value = e * 1.4;
}
var lF = 512;
function oF(n1, t) {
    let e = !1, r = n1.layers.mask & lF, i = t.getLayersOfType("transmission"), s1 = t.getLayersOfType("outline");
    return s1.length > 0 && (n1.layers.set(8), i.length > 0 && n1.layers.enable(3), e = !0, Pf(n1), Cf(n1)), i.length === 0 && s1.length === 0 && n1.layers.set(0), r && n1.layers.set(9), n1 instanceof _n && n1.needsAO && n1.layers.enable(5), e;
}
function aF(n1, t) {
    if (!t.layers) return !1;
    let e = n1.layers.mask & lF, r = !1, i = t.getLayersOfType("transmission").filter((o)=>o.data.visible), s1 = t.getLayersOfType("outline").filter((o)=>o.data.visible);
    return i.length > 0 && (n1.layers.set(3), s1.length > 0 && n1.layers.enable(8), r = !0), i.length === 0 && s1.length === 0 && n1.layers.set(0), e && n1.layers.set(9), n1.needsAO && n1.layers.enable(5), r;
}
function cF(n1) {
    let t = !1;
    return n1.traverseEntity((e)=>{
        if (e instanceof _n) {
            if (Array.isArray(e.material)) for(let r = 0; r < e.material.length; r++)oF(e, e.material[r]) && (t = !0);
            else oF(e, e.material) && (t = !0);
        }
    }), t;
}
function uF(n1) {
    let t = !1;
    return n1.traverseEntity((e)=>{
        if (e instanceof _n) {
            if (Array.isArray(e.material)) for(let r = 0; r < e.material.length; r++)aF(e, e.material[r]) && (t = !0);
            else aF(e, e.material) && (t = !0);
        }
    }), t;
}
var Eee = new vh, Tee = new ue, Mee = new Ws;
function Sg(n1, t, e, r = !1) {
    let i = n1.cloner;
    if (i) for (let s1 of i.children){
        let o = Tee.copy(s1.matrixWorld).invert(), a = Mee.copy(t.ray).applyMatrix4(o), l = n1.matrixWorld;
        a.applyMatrix4(l);
        let c = Eee;
        c.set(a.origin, a.direction), c.near = t.near, c.far = t.far;
        let u1 = c.intersectObject(n1, !1);
        u1.length > 0 && e.push({
            ...u1[0],
            object: r ? s1 : n1
        });
    }
}
var e1 = class {
    constructor(){
        this._constraints = new Map;
    }
    setConstraint(t, e) {
        e === null ? this._constraints.delete(t) : this._constraints.set(t, e);
    }
    removeDependencies(t) {
        this._constraints.delete(t);
    }
    applyConstraints(t) {
        let e = new Set;
        this._constraints.forEach((r, i)=>{
            let s1 = [
                i,
                r
            ], o = r;
            for(; this._constraints.has(o);){
                if (o = this._constraints.get(o), s1.includes(o)) {
                    console.warn(`circular dependency detected: ${s1.join(" -> ")}`);
                    break;
                }
                e.has(o) || s1.push(o);
            }
            for(let a = s1.length - 2; a >= 0; a--)if (!e.has(s1[a])) {
                let l = t.find(s1[a]);
                l ? l.applyPathSnapping(t) : console.warn(`missing entity ${s1[a]}`), e.add(s1[a]);
            }
        });
    }
    findDependency(t, e) {
        let r = t;
        for(; this._constraints.has(r);)if (r = this._constraints.get(r), r === e) return !0;
        return !1;
    }
};
var hF = "AGFzbQEAAAAADwhkeWxpbmsuMAEEAAAAAAETA2AAAGAIf39/f39/f38AYAABfwISAQNlbnYGbWVtb3J5AgMAgIAEAwQDAAECBzkDEV9fd2FzbV9jYWxsX2N0b3JzAAALc29ydEluZGV4ZXMAARNlbXNjcmlwdGVuX3Rsc19pbml0AAIK3gMDAwABC9IDAwF/BnwBfgJAIAdFDQAgAysDUCEMIAMrAzAhDSADKwMQIQ5BACEDRP///////+9/IQtEAAAAAAAAEAAhCgNAIAIgA0ECdGoCfyAOIAEgA0EMbGoiCCoCALuiIA0gCCoCBLuioCAMIAgqAgi7oqBEAAAAAAAAsECiIgmZRAAAAAAAAOBBYwRAIAmqDAELQYCAgIB4CzYCACAJIAsgCSALYxshCyAJIAogCSAKZBshCiADQQFqIgMgB0cNAAsgB0UNACAGuCAKIAuhoyEJQQAhAwNAAn8gCSACIANBAnRqIgEoAgC3IAuhoiIKmUQAAAAAAADgQWMEQCAKqgwBC0GAgICAeAshCCABIAg2AgAgBCAIQQJ0aiIBIAEoAgBBAWo2AgAgA0EBaiIDIAdHDQALCyAGQQJPBEAgBCgCACEIQQEhAwNAIAQgA0ECdGoiASABKAIAIAhqIgg2AgAgA0EBaiIDIAZHDQALCyAHQQFrIgGtIQ8DQCAEIAIgD6dBAnQiA2ooAgBBAnRqIgcgBygCAEEBayIHNgIAIAUgASAHa0ECdGogACADaigCADYCACAPUCEDIA9CAX0hDyADRQ0ACyAGBEAgBEEAIAZBAnT8CwALCwQAQQAL";
var ha = class {
};
Pc(ha, "DepthMapRange", 65536), Pc(ha, "MemoryPageSize", 65536), Pc(ha, "BytesPerFloat", 4), Pc(ha, "BytesPerInt", 4);
function Cee(n1) {
    let t, e, r, i, s1, o, a, l, c, u1, h, d, f, m, p, g;
    function y(P) {
        let _ = new Float64Array(u1, o, 16);
        for(let O = 0; O < 16; O++)_[O] = P[O];
        let I;
        if (r > 1) {
            t.exports.sortIndexes(i, s1, c, o, a, l, d.DepthMapRange, r);
            let O = new Uint32Array(r);
            I = O.buffer, O.set(new Uint32Array(u1, l, r));
        } else if (r === 1) {
            let O = new Uint32Array(r);
            O[0] = new Uint32Array(u1, i, e)[0], I = O.buffer;
        } else I = new ArrayBuffer(0);
        n1.postMessage({
            sortDone: !0,
            indexesBuffer: I
        }, [
            I
        ]);
    }
    function x(P, _, I) {
        let O = new Float32Array(u1, s1, e * 3);
        r = 0;
        let L = new Uint32Array(u1, i, e);
        for(let j = 0; j < I.length - 1; j++){
            let V = _[j], H = P[j].elements, q = V.filter((K)=>K.enabled && K.mode === "Include").map((K)=>K.type === "Box" ? A(K) : M(K)), X = V.filter((K)=>K.enabled && K.mode === "Exclude").map((K)=>K.type === "Box" ? A(K) : M(K));
            for(let K = I[j]; K < I[j + 1]; K++){
                let z = f[K * 3], Q = f[K * 3 + 1], te = f[K * 3 + 2];
                if ((q.length === 0 || b(z, Q, te, q)) && (X.length === 0 || !b(z, Q, te, X))) {
                    let $ = 1 / (H[3] * z + H[7] * Q + H[11] * te + H[15]);
                    O[r * 3] = (H[0] * z + H[4] * Q + H[8] * te + H[12]) * $, O[r * 3 + 1] = (H[1] * z + H[5] * Q + H[9] * te + H[13]) * $, O[r * 3 + 2] = (H[2] * z + H[6] * Q + H[10] * te + H[14]) * $, L[r] = K, r++;
                }
            }
        }
    }
    function v(P, _) {
        let I = [], O = _.filter((V)=>V.enabled && V.mode === "Include").map((V)=>V.type === "Box" ? A(V) : M(V)), L = _.filter((V)=>V.enabled && V.mode === "Exclude").map((V)=>V.type === "Box" ? A(V) : M(V)), j = P.length;
        for(let V = 0; V < j; V += 3){
            let H = P[V], q = P[V + 1], X = P[V + 2];
            (O.length === 0 || b(H, q, X, O)) && (L.length === 0 || !b(H, q, X, L)) || I.push(V / 3);
        }
        return I;
    }
    function b(P, _, I, O, L) {
        return O[L === "Intersect" ? "every" : "some"]((j)=>{
            let V = w(P, _, I, j.invRotationMatrix, j.cropCenter);
            return Array.isArray(j) ? S(V.x, V.y, V.z, j) : C(V.x, V.y, V.z, j);
        });
    }
    function w(P, _, I, O, L) {
        let j = P - L[0], V = _ - L[1], H = I - L[2], q = 1 / (O[3] * j + O[7] * V + O[11] * H + O[15]);
        return {
            x: (O[0] * j + O[4] * V + O[8] * H + O[12]) * q + L[0],
            y: (O[1] * j + O[5] * V + O[9] * H + O[13]) * q + L[1],
            z: (O[2] * j + O[6] * V + O[10] * H + O[14]) * q + L[2]
        };
    }
    function A(P) {
        let _ = P.cropSize[0] / 2, I = P.cropSize[1] / 2, O = P.cropSize[2] / 2, L = [
            P.cropCenter[0] - _,
            P.cropCenter[1] - I,
            P.cropCenter[2] - O,
            P.cropCenter[0] + _,
            P.cropCenter[1] + I,
            P.cropCenter[2] + O
        ], j = T(P.cropRotation);
        return Object.assign(L, {
            invRotationMatrix: j,
            cropCenter: P.cropCenter
        });
    }
    function T(P) {
        let _ = [], I = P[0] * Math.PI / 180, O = P[1] * Math.PI / 180, L = P[2] * Math.PI / 180, j = Math.cos(I), V = Math.sin(I), H = Math.cos(O), q = Math.sin(O), X = Math.cos(L), K = Math.sin(L), z = j * X, Q = j * K, te = V * X, $ = V * K;
        return _[0] = H * X, _[1] = -H * K, _[2] = q, _[4] = Q + te * q, _[5] = z - $ * q, _[6] = -V * H, _[8] = $ - z * q, _[9] = te + Q * q, _[10] = j * H, _[12] = 0, _[13] = 0, _[14] = 0, _[3] = 0, _[7] = 0, _[11] = 0, _[15] = 1, _;
    }
    function S(P, _, I, O) {
        return P >= O[0] && P <= O[3] && _ >= O[1] && _ <= O[4] && I >= O[2] && I <= O[5];
    }
    function M(P) {
        let _ = 2 / P.cropSize[0], I = 2 / P.cropSize[1], O = 2 / P.cropSize[2], L = T(P.cropRotation);
        return {
            invRadiusX: _,
            invRadiusY: I,
            invRadiusZ: O,
            cropCenter: P.cropCenter,
            invRotationMatrix: L
        };
    }
    function C(P, _, I, O) {
        let L = (P - O.cropCenter[0]) * O.invRadiusX, j = (_ - O.cropCenter[1]) * O.invRadiusY, V = (I - O.cropCenter[2]) * O.invRadiusZ;
        return L * L + j * j + V * V <= 1;
    }
    n1.onmessage = (P)=>{
        if (P.data.getCroppedIndexes) {
            let _ = new Uint32Array(v(new Float32Array(P.data.positions), P.data.crops)).buffer;
            n1.postMessage({
                outOfBoundsIndexes: _
            }, [
                _
            ]);
        } else if (P.data.positions) h = P.data.positions, f = new Float32Array(h), p = P.data.meshMatrixWorlds, g = P.data.cropsArray, m = P.data.meshIndexIntervals, x(p, g, m), n1.postMessage({
            sortSetupComplete: !0
        });
        else if (P.data.sort || P.data.newMatrixWorlds || P.data.newCropsArray) (P.data.newMatrixWorlds || P.data.newCropsArray) && (g = P.data.newCropsArray || g, p = P.data.newMatrixWorlds || p, x(p, g, m)), y(P.data.sort.view, P.data.sort.cameraPosition);
        else if (P.data.init) {
            d = P.data.init.Constants, e = P.data.init.splatCount;
            let _ = d.BytesPerInt, I = d.BytesPerFloat * 3, O = new Uint8Array(P.data.init.sorterWasmBytes), L = _ + I, j = e * L, V = e * d.BytesPerInt * 2 + d.DepthMapRange * d.BytesPerInt * 2, H = d.MemoryPageSize * 32, q = j + V + H, X = Math.floor(q / d.MemoryPageSize) + 1, K = {
                module: {},
                env: {
                    memory: new WebAssembly.Memory({
                        initial: X * 2,
                        maximum: X * 3,
                        shared: !0
                    })
                }
            };
            WebAssembly.compile(O).then((z)=>WebAssembly.instantiate(z, K)).then((z)=>{
                t = z, i = 0, s1 = e * _, o = s1 + e * I, c = o + 16 * d.BytesPerFloat * 2, a = c + e * d.BytesPerInt, l = a + d.DepthMapRange * d.BytesPerInt, u1 = K.env.memory.buffer, n1.postMessage({
                    sortSetupPhase1Complete: !0
                });
            });
        }
    };
}
function dF(n1) {
    let t = new Worker(URL.createObjectURL(new Blob([
        "(",
        Cee.toString(),
        ")(self)"
    ], {
        type: "application/javascript"
    }))), e = atob(hF), r = new Uint8Array(e.length);
    for(let i = 0; i < e.length; i++)r[i] = e.charCodeAt(i);
    return t.postMessage({
        init: {
            sorterWasmBytes: r.buffer,
            splatCount: n1,
            Constants: {
                BytesPerFloat: ha.BytesPerFloat,
                BytesPerInt: ha.BytesPerInt,
                DepthMapRange: ha.DepthMapRange,
                MemoryPageSize: ha.MemoryPageSize
            }
        }
    }), t;
}
var t1 = function() {
    let n1 = new Float32Array(1), t = new Int32Array(n1.buffer);
    return function(e) {
        return n1[0] = e, t[0];
    };
}(), fF = function(n1, t, e, r) {
    return n1 + (t << 8) + (e << 16) + (r << 24);
};
var r1 = new U;
function i1(n1) {
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        if (r.visible === !1) return !0;
        r.type === "Splat" && (t = !0);
    }), t;
}
var Sc = class extends Mt {
    constructor(e, r, i, s1, o = !1, a = 1, l, c){
        super(i, s1);
        this.splatCount = r, this.meshIndexIntervals = l, this.meshMatrixWorlds = c, this.splatBuffers = e, this.geometry = i, this.material = s1, this.splatDataTextures = null, this.halfPrecisionCovariancesOnGPU = o, this.devicePixelRatio = a, this.resetLocalSplatDataAndTexturesFromSplatBuffer();
    }
    static buildMesh(e, r, i = !1, s1 = 1, o, a) {
        let l = Sc.buildGeomtery(r), c = Sc.buildMaterial(o);
        return new Sc(e, r, l, c, i, s1, o, a);
    }
    static buildMaterial(e) {
        let r = `
            precision highp float;
            #include <common>

            attribute uint splatIndex;

            uniform highp sampler2D covariancesTexture;
            uniform highp usampler2D centersColorsTexture;
            uniform vec2 focal;
            uniform vec2 viewport;
            uniform vec2 basisViewport;
            uniform vec2 covariancesTextureSize;
            uniform vec2 centersColorsTextureSize;
						uniform highp sampler2D meshMatrixWorldsTexture;
						uniform uint meshIndexIntervals[257];
						uniform float orthoZoom;

            varying vec4 vColor;
            varying vec2 vUv;

            varying vec2 vPosition;

            const vec4 encodeNorm4 = vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0);
            const uvec4 mask4 = uvec4(uint(0x000000FF), uint(0x0000FF00), uint(0x00FF0000), uint(0xFF000000));
            const uvec4 shift4 = uvec4(0, 8, 16, 24);
            vec4 uintToRGBAVec (uint u) {
               uvec4 urgba = mask4 & u;
               urgba = urgba >> shift4;
               vec4 rgba = vec4(urgba) * encodeNorm4;
               return rgba;
            }

            vec2 getDataUV(in int stride, in int offset, in vec2 dimensions) {
                vec2 samplerUV = vec2(0.0, 0.0);
                float d = float(splatIndex * uint(stride) + uint(offset)) / dimensions.x;
                samplerUV.y = float(floor(d)) / dimensions.y;
                samplerUV.x = fract(d);
                return samplerUV;
            }

            void main () {
                uvec4 sampledCenterColor = texture(centersColorsTexture, getDataUV(1, 0, centersColorsTextureSize));
                vec3 splatCenter = uintBitsToFloat(uvec3(sampledCenterColor.gba));
                vColor = uintToRGBAVec(sampledCenterColor.r);

                vPosition = position.xy * 2.0;

								uint meshIndex;
								for (int i = 1; i < 257; i++) {
									if (splatIndex < meshIndexIntervals[i]) {
										meshIndex = uint(i - 1);
										break;
									}
								}

								float strideMulmeshIndex = float(4u*meshIndex);
								float meshMatrixWorldsTextureLength = float(256*4);

								mat4 modelMat = mat4(
									texture(meshMatrixWorldsTexture, vec2((strideMulmeshIndex+0.0)/meshMatrixWorldsTextureLength, 0)),
									texture(meshMatrixWorldsTexture, vec2((strideMulmeshIndex+1.0)/meshMatrixWorldsTextureLength, 0)),
									texture(meshMatrixWorldsTexture, vec2((strideMulmeshIndex+2.0)/meshMatrixWorldsTextureLength, 0)),
									texture(meshMatrixWorldsTexture, vec2((strideMulmeshIndex+3.0)/meshMatrixWorldsTextureLength, 0))
								);
								mat4 modelViewMat = viewMatrix * modelMat;
								vec4 viewCenter = modelViewMat * vec4(splatCenter, 1.0); 
                vec4 clipCenter = projectionMatrix * viewCenter;

                vec2 sampledCovarianceA = texture(covariancesTexture, getDataUV(3, 0, covariancesTextureSize)).rg;
                vec2 sampledCovarianceB = texture(covariancesTexture, getDataUV(3, 1, covariancesTextureSize)).rg;
                vec2 sampledCovarianceC = texture(covariancesTexture, getDataUV(3, 2, covariancesTextureSize)).rg;

                vec3 cov3D_M11_M12_M13 = vec3(sampledCovarianceA.rg, sampledCovarianceB.r);
                vec3 cov3D_M22_M23_M33 = vec3(sampledCovarianceB.g, sampledCovarianceC.rg);

                // Compute the 2D covariance matrix from the upper-right portion of the 3D covariance matrix
                mat3 Vrk = mat3(
                    cov3D_M11_M12_M13.x, cov3D_M11_M12_M13.y, cov3D_M11_M12_M13.z,
                    cov3D_M11_M12_M13.y, cov3D_M22_M23_M33.x, cov3D_M22_M23_M33.y,
                    cov3D_M11_M12_M13.z, cov3D_M22_M23_M33.y, cov3D_M22_M23_M33.z
                );
                float s = 1.0 / (viewCenter.z * viewCenter.z);

                mat3 W = transpose(mat3(modelViewMat));
                mat3 T = orthoZoom > 0.0 ? W : W * mat3(
									focal.x / viewCenter.z, 0., -(focal.x * viewCenter.x) * s,
									0., focal.y / viewCenter.z, -(focal.y * viewCenter.y) * s,
									0., 0., 0.
								);
                mat3 cov2Dm = transpose(T) * Vrk * T;
                cov2Dm[0][0] += 0.3;
                cov2Dm[1][1] += 0.3;

                // We are interested in the upper-left 2x2 portion of the projected 3D covariance matrix because
                // we only care about the X and Y values. We want the X-diagonal, cov2Dm[0][0],
                // the Y-diagonal, cov2Dm[1][1], and the correlation between the two cov2Dm[0][1]. We don't
                // need cov2Dm[1][0] because it is a symetric matrix.
                vec3 cov2Dv = vec3(cov2Dm[0][0], cov2Dm[0][1], cov2Dm[1][1]);

                vec3 ndcCenter = clipCenter.xyz / clipCenter.w;

                // We now need to solve for the eigen-values and eigen vectors of the 2D covariance matrix
                // so that we can determine the 2D basis for the splat. This is done using the method described
                // here: https://people.math.harvard.edu/~knill/teaching/math21b2004/exhibits/2dmatrices/index.html
                //
                // This is a different approach than in the original work at INRIA. In that work they compute the
                // max extents of the 2D covariance matrix in screen space to form an axis aligned bounding rectangle
                // which forms the geometry that is actually rasterized. They then use the inverse 2D covariance
                // matrix (called 'conic') to determine fragment opacity.
                float a = cov2Dv.x;
                float d = cov2Dv.z;
                float b = cov2Dv.y;
                float D = a * d - b * b;
                float trace = a + d;
                float traceOver2 = 0.5 * trace;
                float term2 = sqrt(trace * trace / 4.0 - D);
                float eigenValue1 = traceOver2 + term2;
								float eigenValue2 = max(traceOver2 - term2, 0.00); // prevent negative eigen value

                const float maxSplatSize = 1024.0;
                vec2 eigenVector1 = normalize(vec2(b, eigenValue1 - a));
                // since the eigen vectors are orthogonal, we derive the second one from the first
                vec2 eigenVector2 = vec2(eigenVector1.y, -eigenVector1.x);
                vec2 basisVector1 = eigenVector1 * min(sqrt(2.0 * eigenValue1), maxSplatSize);
                vec2 basisVector2 = eigenVector2 * min(sqrt(2.0 * eigenValue2), maxSplatSize);

                vec2 ndcOffset = vec2(vPosition.x * basisVector1 + vPosition.y * basisVector2) * basisViewport;

								if (orthoZoom > 0.0) {
									ndcOffset *= orthoZoom;
								}

                gl_Position = vec4(ndcCenter.xy + ndcOffset, ndcCenter.z, 1.0);
            }`, i = `
            precision highp float;
            #include <common>

            uniform vec3 debugColor;

            varying vec4 vColor;
            varying vec2 vUv;

            varying vec2 vPosition;
						layout(location = 1) out vec4 gVelocity; 

            void main () {
                // compute the negative squared distance from the center of the splat to the
                // current fragment in the splat's local space.
                float A = -dot(vPosition, vPosition);
                if (A < -4.0) discard;
                vec3 color = vColor.rgb;
                A = exp(A) * vColor.a;
                gl_FragColor = vec4(color.rgb, A);
								gVelocity = vec4(0.0); // so it is ignored by TAA
            }`, s1 = {
            covariancesTexture: {
                type: "t",
                value: null
            },
            centersColorsTexture: {
                type: "t",
                value: null
            },
            meshIndexIntervals: {
                value: e
            },
            meshMatrixWorldsTexture: {
                type: "t",
                value: null
            },
            focal: {
                type: "v2",
                value: new U
            },
            viewport: {
                type: "v2",
                value: new U
            },
            basisViewport: {
                type: "v2",
                value: new U
            },
            debugColor: {
                type: "v3",
                value: new Ge
            },
            covariancesTextureSize: {
                type: "v2",
                value: new U(1024, 1024)
            },
            centersColorsTextureSize: {
                type: "v2",
                value: new U(1024, 1024)
            },
            orthoZoom: {
                type: "f",
                value: -1
            }
        };
        return new $e({
            uniforms: s1,
            vertexShader: r,
            fragmentShader: i,
            transparent: !0,
            alphaTest: 1,
            blending: ml,
            depthTest: !0,
            depthWrite: !1,
            side: vi
        });
    }
    static buildGeomtery(e) {
        let r = new Ce;
        r.setIndex([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
        let i = new Float32Array(12), s1 = new je(i, 3);
        r.setAttribute("position", s1), s1.setXYZ(0, -1, -1, 0), s1.setXYZ(1, -1, 1, 0), s1.setXYZ(2, 1, 1, 0), s1.setXYZ(3, 1, -1, 0), s1.needsUpdate = !0;
        let o = new Kp().copy(r), a = new Uint32Array(e), l = new Mo(a, 1, !1);
        return l.setUsage(o_), o.setAttribute("splatIndex", l), o.instanceCount = e, o;
    }
    resetLocalSplatDataAndTexturesFromSplatBuffer() {
        this.updateLocalSplatDataFromSplatBuffer(), this.allocateAndStoreLocalSplatDataInTextures();
    }
    updateLocalSplatDataFromSplatBuffer() {
        this.splatBuffers.forEach((s1)=>s1.buildPreComputedBuffers()), this.covariances = new Float32Array(this.splatCount * 6), this.colors = new Uint8Array(this.splatCount * 4), this.centers = new Float32Array(this.splatCount * 3);
        let e = 0, r = 0, i = 0;
        for (let s1 of this.splatBuffers){
            let o = s1.nsplats;
            this.colors.subarray(e, e + o * 4).set(s1.colorsA), e += o * 4, this.centers.subarray(r, r + o * 3).set(s1.decoded.xyz.denormDequant().data), r += o * 3, this.covariances.subarray(i, i + o * 6).set(new Float32Array(s1.precomputedCovarianceBufferData)), i += o * 6;
        }
    }
    allocateAndStoreLocalSplatDataInTextures() {
        let i = this.splatCount, s1 = new U(4096, 1024);
        for(; s1.x * s1.y * 2 < i * 6;)s1.y *= 2;
        let o = new U(4096, 1024);
        for(; o.x * o.y * 4 < i * 4;)o.y *= 2;
        let a, l;
        if (this.halfPrecisionCovariancesOnGPU) {
            l = new Uint16Array(s1.x * s1.y * 2);
            for(let m = 0; m < this.covariances.length; m++)l[m] = S_.toHalfFloat(this.covariances[m]);
            a = new Ur(l, s1.x, s1.y, bh, $n);
        } else l = new Float32Array(s1.x * s1.y * 2), l.set(this.covariances), a = new Ur(l, s1.x, s1.y, bh, Ut);
        a.needsUpdate = !0, this.material.uniforms.covariancesTexture.value = a, this.material.uniforms.covariancesTextureSize.value.copy(s1);
        let c = new Uint32Array(o.x * o.y * 4);
        for(let m = 0; m < i; m++){
            let p = m * 4, g = m * 3, y = m * 4;
            c[y] = fF(this.colors[p], this.colors[p + 1], this.colors[p + 2], this.colors[p + 3]), c[y + 1] = t1(this.centers[g]), c[y + 2] = t1(this.centers[g + 1]), c[y + 3] = t1(this.centers[g + 2]);
        }
        let u1 = new Ur(c, o.x, o.y, Aw, Gs);
        u1.internalFormat = "RGBA32UI", u1.needsUpdate = !0, this.material.uniforms.centersColorsTexture.value = u1, this.material.uniforms.centersColorsTextureSize.value.copy(o);
        let h = 1024, d = new Float32Array(4096);
        for(let m = 0; m < this.meshMatrixWorlds.length; m++)d.set(this.meshMatrixWorlds[m].elements, m * 16);
        let f = new Ur(d, h, 1, br, Ut);
        f.needsUpdate = !0, this.material.uniforms.meshMatrixWorldsTexture.value = f, this.material.uniformsNeedUpdate = !0, this.splatDataTextures = {
            covariances: {
                data: l,
                texture: a,
                size: s1
            },
            centerColors: {
                data: c,
                texture: u1,
                size: o
            },
            meshMatrixWorlds: {
                data: d,
                texture: f
            }
        };
    }
    updateIndexes(e) {
        let r = this.geometry;
        r.attributes.splatIndex.set(e), r.attributes.splatIndex.needsUpdate = !0, r.instanceCount = e.length;
    }
    updateUniforms(e, r, i, s1) {
        this.splatCount > 0 && (r1.set(e.x * this.devicePixelRatio, e.y * this.devicePixelRatio), this.material.uniforms.viewport.value.copy(r1), this.material.uniforms.basisViewport.value.set(2 / r1.x, 2 / r1.y), this.material.uniforms.focal.value.set(r, i), this.material.uniforms.orthoZoom.value = s1, this.material.uniformsNeedUpdate = !0);
    }
    getSplatDataTextures() {
        return this.splatDataTextures;
    }
    getSplatCount() {
        return this.splatCount;
    }
    getCenters() {
        return this.centers;
    }
    getColors() {
        return this.colors;
    }
    getCovariances() {
        return this.covariances;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose(), this.splatDataTextures && (this.splatDataTextures.covariances.texture.dispose(), this.splatDataTextures.centerColors.texture.dispose(), this.splatDataTextures.meshMatrixWorlds.texture.dispose()), this.removeFromParent();
    }
};
var mF, AM = new Promise((n1)=>{
    mF = n1;
}), pF = !1;
var n1;

function EM() {
    if (pF) return;
    if (n1) return n1;
    async function n2() {
        let e = await (parcelRequire("88rJr"));
        mF(e), pF = !0;
    }
    return n1 = n2(), n1;
}
var gF;
AM.then((n1)=>gF = n1);
var Ag = class {
    constructor(t = {}){
        Pc(this, "updateView", function() {
            let t = new ue, e = [], r = new E(0, 0, -1), i = new E(0, 0, -1), s1 = new E, o = new E;
            return function(a = !1, l) {
                let c = this.updateMatrixWorldsInWorkerIfNeeded(), u1 = this.cropsChanged();
                if (!a) {
                    i.set(0, 0, -1).applyQuaternion(l.quaternion);
                    let d = !1, f = !1;
                    if (i.dot(r) <= .95 && (d = !0), o.copy(l.position).sub(s1).length() >= 1 && (f = !0), !d && !f && !c && !u1 && !this.needsInitialRender) return;
                }
                this.needsInitialRender = !1, s1.copy(l.position), r.copy(i), t.copy(l.matrixWorld).invert(), t.premultiply(this.dummyPerspectiveMatrix), e[0] = l.position.x, e[1] = l.position.y, e[2] = l.position.z;
                let h = {
                    sort: {
                        view: t.elements,
                        cameraPosition: e,
                        splatRenderCount: this.splatRenderCount,
                        splatSortCount: this.splatRenderCount
                    },
                    ...c ? {
                        newMatrixWorlds: this.meshMatrixWorlds
                    } : {},
                    ...u1 ? {
                        newCropsArray: this.cropsArray
                    } : {}
                };
                this.sortRunning ? this.queuedMessage = h : (this.queuedMessage = null, this.sortRunning = !0, this.sortWorker.postMessage(h));
            };
        }());
        this.scene = t.scene, this.currentPage = null, this.devicePixelRatio = window.devicePixelRatio, this.sortWorker = null, this.splatRenderCount = 0, this.splatSortCount = 0, this.splatMesh = null, this.sortRunning = !1, this.meshMatrixWorlds = null, this.meshMatrixWorldsOld = null, this.cropsArray = null, this.splatEntries = null, this.queuedMessage = null, this.needsInitialRender = !0, this.dummyPerspectiveMatrix = new ue().makePerspective(-1, 1, -1, 1, .1, 1e3);
    }
    updateSplatMeshUniforms(t, e) {
        let r = new U;
        if (this.splatMesh === null) return;
        this.splatMesh.getSplatCount() > 0 && (t.getSize(r), this.cameraFocalLengthX = e.projectionMatrix.elements[0] * this.devicePixelRatio * r.x * .45, this.cameraFocalLengthY = e.projectionMatrix.elements[5] * this.devicePixelRatio * r.y * .45, this.splatMesh.updateUniforms(r, this.cameraFocalLengthX, this.cameraFocalLengthY, e.isPerspectiveCamera ? -1 : e.zoom * this.devicePixelRatio));
    }
    loadSplat(t = {}) {
        this.activePage = this.scene.activePage, t.position && (t.position = new E().fromArray(t.position)), t.orientation && (t.orientation = new Ye().fromArray(t.orientation)), t.halfPrecisionCovariances = !!t.halfPrecisionCovariances;
        let e = [];
        if (this.splatEntries = e, this.activePage.traverseVisibleEntity((o)=>{
            o.data.type === "Splat" && e.push(o);
        }), this.splatMesh && this.splatMesh.dispose(), e.length === 0) return this.splatMesh = null, !1;
        this.meshMatrixWorlds = e.map((o)=>o.matrixWorld), this.meshMatrixWorldsOld = e.map((o)=>o.matrixWorld.clone()), this.cropsArray = e.map((o)=>o.data.crops.map((a)=>a.data));
        let r = e.map((o)=>new gF.GSplineBuffer(new Uint8Array(o.data.buffer).buffer)), i = 0, s1 = [
            0
        ];
        for (let o of r)i += o.getSplatCount(), s1.push(i);
        return this.setupSplatMesh(r, i, t.position, t.orientation, t.halfPrecisionCovariances, this.devicePixelRatio, s1, this.meshMatrixWorlds), this.setupSortWorker(i), !0;
    }
    updateMatrixWorldsInWorkerIfNeeded() {
        let t = this.splatDataTextures.meshMatrixWorlds.data;
        for(let e = 0; e < this.meshMatrixWorlds.length; e++)t.set(this.meshMatrixWorlds[e].elements, e * 16);
        return this.splatDataTextures.meshMatrixWorlds.texture.needsUpdate = !0, this.meshMatrixWorlds.every((e, r)=>e.equals(this.meshMatrixWorldsOld[r])) ? !1 : (this.meshMatrixWorldsOld = this.meshMatrixWorlds.map((e)=>e.clone()), !0);
    }
    cropsChanged() {
        let t = !1;
        return this.splatEntries.forEach((e, r)=>{
            e.data.crops.forEach((i, s1)=>{
                this.cropsArray[r][s1] === void 0 ? (t = !0, this.cropsArray[r][s1] = i.data) : Object.entries(i.data).forEach(([o, a])=>{
                    Array.isArray(a) && a.some((l, c)=>l !== this.cropsArray[r][s1][o][c]) ? (t = !0, this.cropsArray[r][s1][o] = a) : a !== this.cropsArray[r][s1]?.[o] && (t = !0, this.cropsArray[r][s1][o] = a);
                });
            }), e.data.crops.length !== this.cropsArray[r]?.length && (this.cropsArray[r].length = e.data.crops.length, t = !0);
        }), t;
    }
    setupSplatMesh(t, e, r = new E, i = new Ye, s1 = !1, o = 1, a, l) {
        this.splatMesh = Sc.buildMesh(t, e, s1, o, a, l), this.splatMesh.position.copy(r), this.splatMesh.quaternion.copy(i), this.splatMesh.frustumCulled = !1, this.splatMesh.renderOrder = 99999, this.splatRenderCount = e, this.splatMesh.onBeforeRender = (c, u1, h)=>this.update(c, h);
    }
    setupSortWorker(t) {
        this.sortWorker = dF(t), this.sortWorker.onmessage = (e)=>{
            e.data.sortDone ? (this.sortRunning = !1, this.splatMesh?.updateIndexes(new Uint32Array(e.data.indexesBuffer)), this.lastSortTime = e.data.sortTime, this.queuedMessage && (this.sortWorker.postMessage(this.queuedMessage), this.queuedMessage = null)) : e.data.sortCanceled ? this.sortRunning = !1 : e.data.sortSetupPhase1Complete ? this.sortWorker.postMessage({
                positions: this.splatMesh.getCenters().buffer,
                meshMatrixWorlds: this.splatMesh.meshMatrixWorlds,
                meshIndexIntervals: this.splatMesh.meshIndexIntervals,
                cropsArray: this.cropsArray
            }) : e.data.sortSetupComplete && (this.splatDataTextures = this.splatMesh.getSplatDataTextures(), this.scene.activePage.add(this.splatMesh), this.needsInitialRender = !0);
        };
    }
    update(t, e) {
        this.splatMesh !== null && (this.updateSplatMeshUniforms(t, e), this.updateView(!1, e));
    }
    getSplatMesh() {
        return this.splatMesh;
    }
};
var Ob = new un;
Ob.wireframe = !0;
var yF = new E, fc = class extends Er {
    constructor(e, r){
        super();
        this.data = e;
        this.sharedAssets = r;
        this.enableHelpers = !1;
        this.wireframeState = !1;
        this.needsTransmissionDirty = !0;
        this.needsNormalDirty = !0;
        this._needsTransmission = !1;
        this._needsNormal = !1;
        this.geometryCacheChanged = !1;
        this.splatViewer = null;
        this.shapeBlendIntances = [];
        this.entityByUuid = {};
        this.entityIdentityToEntity = {};
        this.toExpandCloner = new Set;
        this.toUpdateCloner = new Set;
        this.pendingCommands = [];
        this.pathConstraints = new e1;
        this.invisibleObjects = new Ns("jflkdsafjasdifjaslk", {
            ...k0.defaultData,
            visible: !1,
            name: "buildin invisible"
        });
        this.needsRecomputeInstances = !1;
        this.init(e, r), this.matrixAutoUpdate = !1, this.errorPage = new yr("fdasfa", {
            ...Fa.defaultData,
            name: ""
        }, {
            shared: r,
            scene: this
        });
    }
    markGeometryCacheDirty() {
        this.geometryCacheChanged = !0;
    }
    markNeedsUpdateRendererDirty() {
        this.needsTransmissionDirty = !0, this.needsNormalDirty = !0;
    }
    needsTransmission() {
        return this.needsTransmissionDirty && (this._needsTransmission = uF(this), this.needsTransmissionDirty = !1), this._needsTransmission;
    }
    needsNormal() {
        return this.needsNormalDirty && (this._needsNormal = cF(this), this.needsNormalDirty = !1), this._needsNormal;
    }
    registerInstanceAndSetUuid(e) {
        let r = e.identity.join("-"), i = this.entityIdentityToEntity[r];
        i && (e.uuid = i.uuid), this.entityIdentityToEntity[r] = e, this.entityByUuid[e.uuid] = e;
    }
    markPenumbraSizeDirty() {
        for (let e of this.children)e instanceof yr && (e.penumbraSizeArrayCache = null);
    }
    findInstance(e) {
        return this.entityIdentityToEntity[e.join("-")];
    }
    get bgColor() {
        return this.activePage.bgColor;
    }
    get postprocessing() {
        return this.activePage.data.postprocessing;
    }
    getWithSortKey(e) {
        let r = this.find(e);
        if (r === void 0) return;
        let i = [], s1 = r;
        for(; s1 !== this;){
            let o = s1;
            s1 = s1.parent;
            let a = s1.children.indexOf(o);
            i.splice(0, 0, a);
        }
        return {
            entity: r,
            sortKey: i
        };
    }
    getAllSorted(e) {
        let r = [];
        for (let i of e){
            let s1 = this.getWithSortKey(i.id);
            s1 !== void 0 && r.push(s1);
        }
        return r.sort((i, s1)=>qv(i.sortKey, s1.sortKey)), r.map((i)=>i.entity);
    }
    nonExistOrDescendantOf(e, r) {
        let i = this.find(e);
        if (i === void 0) return !0;
        for(; i;){
            if (i.uuid === r) return !0;
            i = i.parent;
        }
        return !1;
    }
    find(e) {
        if (this.activePage && this.activePage.personalCamera.parent) {
            if (e === "f23858d0-4a3b-4bd8-8173-66ed0af7f6fb-personalCamera") return this.activePage.personalCamera;
            if (e === As) return this.activePage.personalCamera;
        }
        if (e === "" || e === void 0) return;
        let r = this.entityByUuid[e];
        return r === void 0 ? this.getObjectByProperty("uuid", e) : r;
    }
    find2D(e) {
        for (let r of this.children)if (r instanceof yr && r.uiScene) {
            let i = r.uiScene.find(e);
            if (i) return i;
        }
    }
    findScene2DfromObject2D(e) {
        for (let r of this.children)if (r instanceof yr && r.uiScene && r.uiScene.find(e)) return r.uiScene;
    }
    find2DInUIObjects(e) {
        let r;
        return this.traverseEntity((i)=>{
            r === void 0 && i instanceof _r && (r = i.uiCanvas.find(e));
        }), r;
    }
    traverse2D(e) {
        for (let r of this.children)r instanceof yr && r.uiScene && r.uiScene.traverse(e);
    }
    debugEnsureEntity(e) {
        let r = this.find(e);
        if (r) {
            if (Array.isArray(r.identity) && this.findInstance(r.identity) === void 0) {
                console.error("not found instance");
                debugger;
            }
        } else {
            console.error("not found");
            debugger;
        }
    }
    addPendingExpandCloner(e) {
        this.toExpandCloner.add(e);
    }
    addPendingUpdateCloner(e) {
        this.toUpdateCloner.add(e);
    }
    markToExpandCloner(e) {
        this.toExpandCloner.add(e), e.traverseEntityAncestors((r)=>{
            this.toExpandCloner.add(r);
        });
    }
    doPendingExpandCloner(e) {
        this.toExpandCloner.forEach((r)=>{
            r.expandCloner(e);
        }), this.toExpandCloner.clear();
    }
    doPendingUpdateCloner(e) {
        this.toUpdateCloner.forEach((r)=>{
            r.cloner?.update(e);
        }), this.toUpdateCloner.clear();
    }
    doPendingUpdates(e) {
        this.doPendingExpandCloner(e), this.doPendingUpdateCloner(e), this.applyPendingCommands();
    }
    addPendingCommand(e) {
        this.pendingCommands.push(e);
    }
    applyPendingCommands() {
        this.pendingCommands.forEach((e)=>e()), this.pendingCommands.length = 0;
    }
    updateByLibOp(e, r) {
        e.path.length === 1 && e.path[0] === "components" && e.type === 1 && this.createChildrenObjects([
            {
                ...e.data.asset,
                id: e.id
            }
        ], this.invisibleObjects, r);
    }
    updateTreeByOp(e, r) {
        if (e.path.length === 0 && e.type === 7) {
            let i = e.parent === null ? this : this.find(e.parent);
            if (i === void 0) throw new Error("unexpected");
            let s1 = this.createObject(e.id, e.data, e.children, i, e.localIndex, r);
            s1.updateVisible(this), s1.resetBBoxNeedsUpdate(), Wn(s1) && Dn(s1.parent) && (s1.invalidateUpstreamBooleanData(), s1.parent.invalidateDownstreamBooleanData().recomputeBoolean()), this.markNeedsRecomputeInstancesForAncessors(i), this.markNeedsRecomputeInstancesForChildren(s1), this.markToExpandCloner(s1), this.markPenumbraSizeDirty(), s1.updatePathSnapping();
        } else if (e.path.length === 0 && e.type === 8) {
            let i = this.find(e.id);
            if (i === void 0) throw new Error("unexpected");
            i.traverseEntity((o)=>{
                o instanceof cs && (this.shapeBlendIntances = this.shapeBlendIntances.filter((a)=>a !== o));
            }), this.markToExpandCloner(i), i.resetBBoxNeedsUpdate(), this.unregisterObject(i);
            let s1 = i.parent;
            this.markNeedsRecomputeInstancesForAncessors(s1), this.markNeedsRecomputeInstancesForChildren(i), this.markPenumbraSizeDirty(), i.parent.remove(i), Dn(i.parent) && (i.parent.invalidateUpstreamBooleanData(), i.parent.invalidateDownstreamBooleanData().recomputeBoolean()), Wn(i) && (i.freeBooleanPointer(), s1 instanceof Hn && s1.invalidateDownstreamBooleanData().recomputeBoolean()), i instanceof qo && i.detachShape(), this.disposeAndUnregisterEntityRecursivelyIfNotReregistered(i), this.pathConstraints.removeDependencies(i.uuid), i.updatePathSnapping();
        } else if (e.path.length === 0 && e.type === 9) {
            let i = this.find(e.id);
            if (i === void 0) throw new Error("unexpected");
            this.markNeedsRecomputeInstancesForChildren(i);
            let s1 = i.parent;
            this.markNeedsRecomputeInstancesForAncessors(s1), i.cloner?.resetOnMove(), this.markToExpandCloner(i);
            let o = e.parent === null ? this : this.find(e.parent);
            if (o === void 0) throw new Error("unexpected");
            o.add(i), this.markNeedsRecomputeInstancesForAncessors(o), this.markToExpandCloner(i), i.invalidateClonerTransform(i), i.updateVisible(this), i.resetBBoxNeedsUpdate(), this.markPenumbraSizeDirty();
            let a = e.localIndex;
            o.children.splice(a, 0, o.children.pop()), Wn(i) && (i.invalidateUpstreamBooleanData(), Dn(i.parent) ? i.parent.invalidateDownstreamBooleanData().recomputeBoolean() : s1 instanceof Hn && s1.invalidateDownstreamBooleanData().recomputeBoolean()), i.updatePathSnapping();
        }
        this.markNeedsUpdateRendererDirty(), this.markGeometryCacheDirty();
    }
    get playPage() {
        return this.find(this.data.publish.playPage) ?? this.errorPage;
    }
    updatePage(e) {
        this.activePage && this.activePage.onDeactive(), this.activePage = this.errorPage;
        for (let r of this.children)r instanceof yr && (r.visible = r.uuid === e, r.visible && (this.activePage = r, this.activePage.onActive(this)));
        this.activePage !== this.splatViewer?.activePage && this.reloadSplats();
    }
    updateEntityByOp(e, r, i, s1) {
        if (r.type === 0) {
            if (("overrides" in r.props || "component" in r.props) && this.markNeedsRecomputeInstances(), "visible" in r.props && this.markPenumbraSizeDirty(), r.path.includes("overrides") && "states" in r.props) {
                let { rest: a } = r.props;
                r = {
                    ...r,
                    props: a
                }, this.markNeedsRecomputeInstances();
            }
            r.path[0] === "pathSnapping" && r.props.pathId !== void 0 && this.pathConstraints.setConstraint(e, r.props.pathId);
        }
        let o = this.find(e);
        if (o) try {
            iF(o, r, i, {
                scene: this,
                shared: s1
            }), o instanceof Ct && o.updateGeometryGroupsIfNeeded();
        } catch (a) {
            console.error(a);
        }
    }
    updateEntity2DByOp(e, r, i, s1, o, a = []) {
        e.updateEntityByOp(r, i, s1, o), this.traverseEntity((l)=>{
            (l instanceof _r || l instanceof yr) && (a.includes(l.frameId ?? "") || l.frameId === r) && l.updateEntity2DByOp(r, i, s1, o);
        });
    }
    get activeCamera() {
        return this.activePage.activeCamera;
    }
    switchActiveCamera(e) {
        this.activePage.switchActiveCamera(e);
    }
    isInvisibleObjects(e) {
        return e === this.invisibleObjects || e.hasAnccestor(this.invisibleObjects);
    }
    init(e, r) {
        let i = Object.entries(r.data.lib.components).map((s1, o)=>({
                data: s1[1].asset.data,
                children: s1[1].asset.children,
                id: s1[0],
                fi: o
            }));
        this.invisibleObjects.updateState(this.invisibleObjects.data, {
            scene: this,
            shared: r
        }), this.add(this.invisibleObjects), this.createChildrenObjects(i, this.invisibleObjects, r), this.createChildrenObjects(e.objects, this, r), this.updatePage(e.publish.playPage), this.activePage.switchToPlayCamera(), this.expandInstances(r, !0), this.traverseEntity((s1)=>{
            s1 instanceof ir && s1.updateUp();
        }), this.doPendingExpandCloner({
            scene: this,
            shared: r
        }), this.applyPendingCommands();
    }
    markNeedsRecomputeInstances() {
        this.needsRecomputeInstances = !0;
    }
    markNeedsRecomputeInstancesForChildren(e) {
        e.traverseEntity((r)=>{
            (r.data.type === "Component" || r.data.type === "Instance") && this.markNeedsRecomputeInstances();
        });
    }
    markNeedsRecomputeInstancesForAncessors(e) {
        gt.is(e) && (e.data.type === "Component" && this.markNeedsRecomputeInstances(), e.traverseAncestors((r)=>{
            gt.is(r) && r.data.type === "Component" && this.markNeedsRecomputeInstances();
        }));
    }
    relativeizeInner(e, r, i, s1, o, a, l) {
        if (e) {
            let c = s1.find(e);
            c && c !== s1 && o.forInstancesRec((u1)=>{
                u1.data = Fl(u1.data, (h)=>{
                    let d = h.events.data(l.id), f = u1.goUp(a);
                    if (f) {
                        let m = [
                            ...Wv(f.identity),
                            e
                        ].join("-"), p = this.entityIdentityToEntity[m];
                        if (p) {
                            let g = p.uuid, y = Mr.zoom(d, r);
                            y[i] = g;
                        } else console.warn("cannot find instance");
                    }
                }).data;
            });
        }
    }
    rewriteActions(e, r, i, s1, o, a) {
        e.forEach((l)=>{
            l.data.type === "Transition" ? this.relativeizeInner(l.data.object, [
                ...r,
                l.id
            ], "object", i, s1, o, a) : l.data.type === "Animation" ? this.relativeizeInner(l.data.object, [
                ...r,
                l.id
            ], "object", i, s1, o, a) : l.data.type === "Conditional" && (this.rewriteActions(l.data.ifActions, [
                ...r,
                l.id,
                "ifActions"
            ], i, s1, o, a), this.rewriteActions(l.data.elseActions, [
                ...r,
                l.id,
                "elseActions"
            ], i, s1, o, a));
        });
    }
    rewriteEventsBeforeGoToPlayMode() {
        this.traverseEntity((e)=>{
            if (e instanceof ho && typeof e.identity == "string" && e.data.type === "Component") return e.traverseEntity((r, i)=>{
                r.data.events.forEach((s1)=>{
                    if (s1.data.type === "GameControl") {
                        let o = !1;
                        if (r.forInstancesRec((a)=>{
                            a.data = Fl(a.data, (l)=>{
                                a.isInstanceRoot || (l.events.delete(s1.id), o = !0);
                            }).data;
                        }), o === !1) for (let a of xd.list)this.rewriteActions(s1.data.gameActions[a], [
                            "gameActions",
                            a
                        ], e, r, i, s1);
                    } else s1.data.type === "Conditional" ? (s1.data.condition.type === "Distance" ? (this.relativeizeInner(s1.data.condition.fromObject, [
                        "condition"
                    ], "fromObject", e, r, i, s1), this.relativeizeInner(s1.data.condition.toObject, [
                        "condition"
                    ], "toObject", e, r, i, s1)) : s1.data.condition.type === "State" ? this.relativeizeInner(s1.data.condition.object, [
                        "condition"
                    ], "object", e, r, i, s1) : s1.data.condition.type === "Comparison" && (s1.data.condition.lOperand.type === "Property" && this.relativeizeInner(s1.data.condition.lOperand.value[0], [
                        "condition",
                        "lOperand",
                        "value"
                    ], 0, e, r, i, s1), s1.data.condition.rOperand.type === "Property" && this.relativeizeInner(s1.data.condition.rOperand.value[0], [
                        "condition",
                        "rOperand",
                        "value"
                    ], 0, e, r, i, s1)), this.rewriteActions(s1.data.inActions, [
                        "inActions"
                    ], e, r, i, s1), this.rewriteActions(s1.data.outActions, [
                        "outActions"
                    ], e, r, i, s1)) : "actions" in s1.data && this.rewriteActions(s1.data.actions, [
                        "actions"
                    ], e, r, i, s1);
                });
            }), !0;
        });
    }
    expandInstances(e, r, i) {
        let s1 = new Set;
        this.traverseEntity((o)=>{
            if (o instanceof ho && o.isInstanceRoot) return o.expandInstanceChildren({
                scene: this,
                shared: e,
                pendingDeletes: s1
            }), r || o.resetBBoxNeedsUpdate(), i && o.traverseEntity((a)=>{
                i.addClip(a);
            }), !0;
        });
        for (let o of s1)this.disposeAndUnregisterEntityRecursivelyIfNotReregistered(o), Hb(o);
    }
    recomputeInstances(e, r) {
        this.needsRecomputeInstances && (this.needsRecomputeInstances = !1, this.traverseEntity((i)=>{
            i instanceof ho && i.isInstanceRoot && (i.component = void 0);
        }), this.expandInstances(e, !1, r));
    }
    disposeAndUnregisterEntityRecursivelyIfNotReregistered(e) {
        e.traverseEntity((r)=>{
            let i = typeof r.identity == "string" ? r.identity : r.identity.join("-");
            this.entityIdentityToEntity[i] === r && (delete this.entityByUuid[r.uuid], delete this.entityIdentityToEntity[i]), r.dispose();
        });
    }
    clearScene() {
        for (let e of this.children)gt.is(e) && e.disposeRecursively();
        this.children.length = 0;
    }
    resetAfterClear(e, r) {
        this.init(e, r);
    }
    raycast(e) {
        return this.raycast1(e, !1);
    }
    raycast1(e, r) {
        let i = [], s1 = (o)=>{
            for (let a of o.children){
                let l = a.cloner;
                if (gt.is(a) && !a.raycastLock && (a.visible || l?.object.data.visible)) {
                    if (r === !0 && a.isInstanceRoot) {
                        let c = [];
                        if (e.intersectObject(a, !0, c), c.length) {
                            let u1 = c[0];
                            u1.object = a, u1.point.applyMatrix4(u1.object.matrixWorld);
                            let h = a.matrixWorld.clone().invert();
                            u1.point.applyMatrix4(h), i.push(u1);
                        }
                    } else (Wn(a) || dg(a) && this.enableHelpers && a.objectHelper.visible) && (e.intersectObject(a, !1, i), Sg(a, e, i)), s1(a);
                }
            }
        };
        return s1(this.activePage), i;
    }
    raycastWithClones(e) {
        let r = [], i = (s1)=>{
            for (let o of s1.children){
                let a = o.cloner;
                gt.is(o) && (o.visible || a?.object.data.visible) && ((Wn(o) || dg(o) && this.enableHelpers && o.objectHelper.visible) && (e.intersectObject(o, !1, r), Sg(o, e, r, !0)), i(o));
            }
        };
        return i(this), r;
    }
    forEachEntity(e) {
        for (let r of this.children)gt.is(r) && e(r);
    }
    traverseConcreteEntity(e) {
        for (let r of this.children)gt.is(r) && r.isConcreteEntity && r.traverseEntity(e);
    }
    traverseEntity(e) {
        for (let r of this.children)gt.is(r) && r.traverseEntity(e);
    }
    updateFont(e, r) {
        this.traverseEntity((i)=>{
            if (i instanceof Ct && i.data.type === "Mesh" && (i.data.geometry.type === "TextGeometry" || i.data.geometry.type === "InputGeometry") && i.data.geometry.font === e) {
                let s1 = i.geometry, o = i.data.geometry;
                s1.updateFont(e, r).then(()=>{
                    s1.update(o, r);
                    let a = i.invalidateDownstreamBooleanData();
                    Dn(a) && a.recomputeBoolean();
                });
            }
        });
    }
    traverseObject(e) {
        for (let r of this.children)Xa.is(r) && r.traverseObject(e);
    }
    traverseVisibleEntity(e) {
        for (let r of this.children)gt.is(r) && r.visible && r.traverseVisibleEntity(e);
    }
    dispose() {
        this.clearScene();
    }
    createChildrenObjects(e, r, i) {
        let s1 = 0;
        for (let o of e)this.createObject(o.id, o.data, o.children, r, s1, i), s1 += 1;
    }
    registerObjectCreatedInLegacy(e) {
        this.entityByUuid[e.uuid] = e;
    }
    unregisterObject(e) {
        delete this.entityByUuid[e.uuid];
        for (let r of e.children)this.unregisterObject(r);
    }
    createObject(e, r, i, s1, o, a) {
        let l = {
            scene: this,
            shared: a
        }, c = Zb(e, r, l);
        return c instanceof cs && this.shapeBlendIntances.push(c), c && (this.entityByUuid[e] = c, s1.add(c), s1.children.splice(o, 0, s1.children.pop()), i.length > 0 && (c.isInstanceRoot ? console.error("instance should not have children!") : this.createChildrenObjects(i, c, a)), c.updateState(r, l), c instanceof Ct && c.updateGeometryGroupsIfNeeded(), c.updateVisible(this), c.cloner && this.toExpandCloner.add(c), r.pathSnapping?.pathId && this.pathConstraints.setConstraint(e, r.pathSnapping.pathId)), r.type === "Empty" && r.animations && c.traverseEntity((u1)=>{
            let h = u1.dataPatched;
            if (u1 instanceof Ct && h.bones && h.boneInverses) {
                let d = h.bones.map((p)=>this.find(p)), f = h.boneInverses.map((p)=>new ue().fromArray(p)), m = new Sl(d, f);
                u1.bind(m, u1.bindMatrix);
            } else u1.matrixAutoUpdate = !0;
        }), c;
    }
    getCenter(e) {
        let r = [];
        for(let s1 = 0, o = e.length; s1 < o; ++s1){
            let { id: a, recursive: l } = e[s1], c = this.find(a), u1 = l ? c.recursiveBBox : c.singleBBox;
            r.push(...u1.vertices);
        }
        let i = new Yt;
        return i.setFromPoints(r), i.getCenter(yF), yF;
    }
    copyMatrixWorld(e, r) {
        if (e === null) {
            r.identity();
            return;
        }
        let i = this.find(e);
        i ? r.copy(i.matrixWorld) : r.identity();
    }
    copyParentMatrixWorld(e, r) {
        if (e === null) {
            r.identity();
            return;
        }
        let i = this.find(e)?.parent;
        i ? r.copy(i.matrixWorld) : r.identity();
    }
    traverseMaterial(e) {
        this.traverseEntity((r)=>{
            if (r instanceof nr) {
                if (Array.isArray(r.material)) for(let i = 0; i < r.material.length; i++)r.material[i] instanceof fn && e(r.material[i]);
                else r.material instanceof fn && e(r.material);
            }
        });
    }
    updateViewPlaneSize(e, r, i = !1) {
        this.traverseConcreteEntity((s1)=>{
            s1 instanceof ir && s1.setViewplaneSize(e, r, i);
        });
    }
    initializeSplatViewer() {
        this.splatViewer = new Ag({
            scene: this
        }), this.reloadSplats();
    }
    reloadSplats() {
        this.splatViewer?.loadSplat();
    }
};
var Eg = (n1, t)=>{
    let e = t.x - n1.x, r = t.y - n1.y;
    return Math.sqrt(e * e + r * r);
}, vF = (n1, t)=>{
    let e = t.x - n1.x, r = t.y - n1.y;
    return Pee(Math.atan2(r, e));
}, xF = (n1, t, e)=>{
    let r = {
        x: 0,
        y: 0
    };
    return e = s1(e), r.x = n1.x - t * Math.cos(e), r.y = n1.y - t * Math.sin(e), r;
}, s1 = (n1)=>n1 * (Math.PI / 180), Pee = (n1)=>n1 * (180 / Math.PI), bF = (n1)=>isNaN(n1.buttons) ? n1.pressure !== 0 : n1.buttons !== 0, TM = new Map, MM = (n1)=>{
    TM.has(n1) && clearTimeout(TM.get(n1)), TM.set(n1, setTimeout(n1, 100));
}, tp = (n1, t, e)=>{
    let r = t.split(/[ ,]+/g), i;
    for(let s1 = 0; s1 < r.length; s1 += 1)i = r[s1], n1.addEventListener ? n1.addEventListener(i, e, !1) : n1.attachEvent && n1.attachEvent(i, e);
}, CM = (n1, t, e)=>{
    let r = t.split(/[ ,]+/g), i;
    for(let s1 = 0; s1 < r.length; s1 += 1)i = r[s1], n1.removeEventListener ? n1.removeEventListener(i, e) : n1.detachEvent && n1.detachEvent(i, e);
};
var o1 = (n1)=>(n1.preventDefault(), n1.type.match(/^touch/) ? n1.changedTouches : n1), PM = ()=>{
    if (typeof window > "u") return;
    let n1 = window.pageXOffset !== void 0 ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft, t = window.pageYOffset !== void 0 ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    return {
        x: n1,
        y: t
    };
}, a1 = (n1, t)=>{
    t.top || t.right || t.bottom || t.left ? (n1.style.top = t.top, n1.style.right = t.right, n1.style.bottom = t.bottom, n1.style.left = t.left) : (n1.style.left = t.x + "px", n1.style.top = t.y + "px");
}, l1 = (n1, t, e)=>{
    let r = wF(n1);
    for(let i in r)if (r.hasOwnProperty(i)) {
        if (typeof t == "string") r[i] = t + " " + e;
        else {
            let s1 = "";
            for(let o = 0, a = t.length; o < a; o += 1)s1 += t[o] + " " + e + ", ";
            r[i] = s1.slice(0, -2);
        }
    }
    return r;
}, SF = (n1, t)=>{
    let e = wF(n1);
    for(let r in e)e.hasOwnProperty(r) && (e[r] = t);
    return e;
}, wF = (n1)=>{
    let t = {};
    return t[n1] = "", [
        "webkit",
        "Moz",
        "o"
    ].forEach(function(r) {
        t[r + n1.charAt(0).toUpperCase() + n1.slice(1)] = "";
    }), t;
}, c1 = (n1, t)=>{
    for(let e in t)t.hasOwnProperty(e) && (n1[e] = t[e]);
    return n1;
}, AF = (n1, t)=>{
    let e = {};
    for(let r in n1)n1.hasOwnProperty(r) && t.hasOwnProperty(r) ? e[r] = t[r] : n1.hasOwnProperty(r) && (e[r] = n1[r]);
    return e;
}, Tg = (n1, t)=>{
    if (n1.length) for(let e = 0, r = n1.length; e < r; e += 1)t(n1[e]);
    else t(n1);
}, EF = (n1, t, e)=>({
        x: Math.min(Math.max(n1.x, t.x - e), t.x + e),
        y: Math.min(Math.max(n1.y, t.y - e), t.y + e)
    });
typeof window < "u" && (TF = "ontouchstart" in window, MF = !!window.PointerEvent, CF = !!window.MSPointerEvent);
var TF, MF, CF, Mg = {
    touch: {
        start: "touchstart",
        move: "touchmove",
        end: "touchend, touchcancel"
    },
    mouse: {
        start: "mousedown",
        move: "mousemove",
        end: "mouseup"
    },
    pointer: {
        start: "pointerdown",
        move: "pointermove",
        end: "pointerup, pointercancel"
    },
    MSPointer: {
        start: "MSPointerDown",
        move: "MSPointerMove",
        end: "MSPointerUp"
    }
}, rp, Cg = {};
MF ? rp = Mg.pointer : CF ? rp = Mg.MSPointer : TF ? (rp = Mg.touch, Cg = Mg.mouse) : rp = Mg.mouse;
function Mu() {}
Mu.prototype.on = function(n1, t) {
    var e = this, r = n1.split(/[ ,]+/g), i;
    e._handlers_ = e._handlers_ || {};
    for(var s1 = 0; s1 < r.length; s1 += 1)i = r[s1], e._handlers_[i] = e._handlers_[i] || [], e._handlers_[i].push(t);
    return e;
};
Mu.prototype.off = function(n1, t) {
    var e = this;
    return e._handlers_ = e._handlers_ || {}, n1 === void 0 ? e._handlers_ = {} : t === void 0 ? e._handlers_[n1] = null : e._handlers_[n1] && e._handlers_[n1].indexOf(t) >= 0 && e._handlers_[n1].splice(e._handlers_[n1].indexOf(t), 1), e;
};
Mu.prototype.trigger = function(n1, t) {
    var e = this, r = n1.split(/[ ,]+/g), i;
    e._handlers_ = e._handlers_ || {};
    for(var s1 = 0; s1 < r.length; s1 += 1)i = r[s1], e._handlers_[i] && e._handlers_[i].length && e._handlers_[i].forEach(function(o) {
        o.call(e, {
            type: i,
            target: e
        }, t);
    });
};
Mu.prototype.config = function(n1) {
    var t = this;
    t.options = t.defaults || {}, n1 && (t.options = AF(t.options, n1));
};
Mu.prototype.bindEvt = function(n1, t) {
    var e = this;
    return e._domHandlers_ = e._domHandlers_ || {}, e._domHandlers_[t] = function() {
        typeof e["on" + t] == "function" ? e["on" + t].apply(e, arguments) : console.warn('[WARNING] : Missing "on' + t + '" handler.');
    }, tp(n1, rp[t], e._domHandlers_[t]), Cg[t] && tp(n1, Cg[t], e._domHandlers_[t]), e;
};
Mu.prototype.unbindEvt = function(n1, t) {
    var e = this;
    return e._domHandlers_ = e._domHandlers_ || {}, CM(n1, rp[t], e._domHandlers_[t]), Cg[t] && CM(n1, Cg[t], e._domHandlers_[t]), delete e._domHandlers_[t], this;
};
var ip = Mu;
function Fi(n1, t) {
    return this.identifier = t.identifier, this.position = t.position, this.frontPosition = t.frontPosition, this.collection = n1, this.defaults = {
        size: 100,
        threshold: .1,
        color: "white",
        fadeTime: 250,
        dataOnly: !1,
        restJoystick: !0,
        restOpacity: 1,
        mode: "dynamic",
        zone: document.body,
        lockX: !1,
        lockY: !1,
        shape: "circle"
    }, this.config(t), this.options.mode === "dynamic" && (this.options.restOpacity = 0), this.id = Fi.id, Fi.id += 1, this.buildEl().stylize(), this.instance = {
        el: this.ui.el,
        on: this.on.bind(this),
        off: this.off.bind(this),
        show: this.show.bind(this),
        hide: this.hide.bind(this),
        add: this.addToDom.bind(this),
        remove: this.removeFromDom.bind(this),
        destroy: this.destroy.bind(this),
        setPosition: this.setPosition.bind(this),
        resetDirection: this.resetDirection.bind(this),
        computeDirection: this.computeDirection.bind(this),
        trigger: this.trigger.bind(this),
        position: this.position,
        frontPosition: this.frontPosition,
        ui: this.ui,
        identifier: this.identifier,
        id: this.id,
        options: this.options
    }, this.instance;
}
Fi.prototype = new ip;
Fi.constructor = Fi;
Fi.id = 0;
Fi.prototype.buildEl = function(n1) {
    return this.ui = {}, this.options.dataOnly ? this : (this.ui.el = document.createElement("div"), this.ui.back = document.createElement("div"), this.ui.front = document.createElement("div"), this.ui.el.className = "nipple collection_" + this.collection.id, this.ui.back.className = "back", this.ui.front.className = "front", this.ui.el.setAttribute("id", "nipple_" + this.collection.id + "_" + this.id), this.ui.el.appendChild(this.ui.back), this.ui.el.appendChild(this.ui.front), this);
};
Fi.prototype.stylize = function() {
    if (this.options.dataOnly) return this;
    var n1 = this.options.fadeTime + "ms", t = SF("borderRadius", "50%"), e = l1("transition", "opacity", n1), r = {};
    return r.el = {
        position: "absolute",
        opacity: this.options.restOpacity,
        display: "block",
        zIndex: 999
    }, r.back = {
        position: "absolute",
        display: "block",
        width: this.options.size + "px",
        height: this.options.size + "px",
        marginLeft: -this.options.size / 2 + "px",
        marginTop: -this.options.size / 2 + "px",
        background: "rgba(255, 255, 255, .4)",
        border: "solid 2px rgba(0, 0, 0, .1)"
    }, r.front = {
        width: this.options.size / 2 + "px",
        height: this.options.size / 2 + "px",
        position: "absolute",
        display: "block",
        marginLeft: -this.options.size / 4 + "px",
        marginTop: -this.options.size / 4 + "px",
        background: "rgba(255, 255, 255, .8)",
        border: "solid 2px rgba(0, 0, 0, .1)"
    }, c1(r.el, e), this.options.shape === "circle" && c1(r.back, t), c1(r.front, t), this.applyStyles(r), this;
};
Fi.prototype.applyStyles = function(n1) {
    for(var t in this.ui)if (this.ui.hasOwnProperty(t)) for(var e in n1[t])this.ui[t].style[e] = n1[t][e];
    return this;
};
Fi.prototype.addToDom = function() {
    return this.options.dataOnly || document.body.contains(this.ui.el) ? this : (this.options.zone.appendChild(this.ui.el), this);
};
Fi.prototype.removeFromDom = function() {
    return this.options.dataOnly || !document.body.contains(this.ui.el) ? this : (this.options.zone.removeChild(this.ui.el), this);
};
Fi.prototype.destroy = function() {
    clearTimeout(this.removeTimeout), clearTimeout(this.showTimeout), clearTimeout(this.restTimeout), this.trigger("destroyed", this.instance), this.removeFromDom(), this.off();
};
Fi.prototype.show = function(n1) {
    var t = this;
    return t.options.dataOnly || (clearTimeout(t.removeTimeout), clearTimeout(t.showTimeout), clearTimeout(t.restTimeout), t.addToDom(), t.restCallback(), setTimeout(function() {
        t.ui.el.style.opacity = 1;
    }, 0), t.showTimeout = setTimeout(function() {
        t.trigger("shown", t.instance), typeof n1 == "function" && n1.call(this);
    }, t.options.fadeTime)), t;
};
Fi.prototype.hide = function(n1) {
    var t = this;
    if (t.options.dataOnly) return t;
    if (t.ui.el.style.opacity = t.options.restOpacity, clearTimeout(t.removeTimeout), clearTimeout(t.showTimeout), clearTimeout(t.restTimeout), t.removeTimeout = setTimeout(function() {
        var e = t.options.mode === "dynamic" ? "none" : "block";
        t.ui.el.style.display = e, typeof n1 == "function" && n1.call(t), t.trigger("hidden", t.instance);
    }, t.options.fadeTime), t.options.restJoystick) {
        let e = t.options.restJoystick, r = {};
        r.x = e === !0 || e.x !== !1 ? 0 : t.instance.frontPosition.x, r.y = e === !0 || e.y !== !1 ? 0 : t.instance.frontPosition.y, t.setPosition(n1, r);
    }
    return t;
};
Fi.prototype.setPosition = function(n1, t) {
    var e = this;
    e.frontPosition = {
        x: t.x,
        y: t.y
    };
    var r = e.options.fadeTime + "ms", i = {};
    i.front = l1("transition", [
        "top",
        "left"
    ], r);
    var s1 = {
        front: {}
    };
    s1.front = {
        left: e.frontPosition.x + "px",
        top: e.frontPosition.y + "px"
    }, e.applyStyles(i), e.applyStyles(s1), e.restTimeout = setTimeout(function() {
        typeof n1 == "function" && n1.call(e), e.restCallback();
    }, e.options.fadeTime);
};
Fi.prototype.restCallback = function() {
    var n1 = this, t = {};
    t.front = l1("transition", "none", ""), n1.applyStyles(t), n1.trigger("rested", n1.instance);
};
Fi.prototype.resetDirection = function() {
    this.direction = {
        x: !1,
        y: !1,
        angle: !1
    };
};
Fi.prototype.computeDirection = function(n1) {
    var t = n1.angle.radian, e = Math.PI / 4, r = Math.PI / 2, i, s1, o;
    if (t > e && t < e * 3 && !n1.lockX ? i = "up" : t > -e && t <= e && !n1.lockY ? i = "left" : t > -e * 3 && t <= -e && !n1.lockX ? i = "down" : n1.lockY || (i = "right"), n1.lockY || (t > -r && t < r ? s1 = "left" : s1 = "right"), n1.lockX || (t > 0 ? o = "up" : o = "down"), n1.force > this.options.threshold) {
        var a = {}, l;
        for(l in this.direction)this.direction.hasOwnProperty(l) && (a[l] = this.direction[l]);
        var c = {};
        this.direction = {
            x: s1,
            y: o,
            angle: i
        }, n1.direction = this.direction;
        for(l in a)a[l] === this.direction[l] && (c[l] = !0);
        if (c.x && c.y && c.angle) return n1;
        (!c.x || !c.y) && this.trigger("plain", n1), c.x || this.trigger("plain:" + s1, n1), c.y || this.trigger("plain:" + o, n1), c.angle || this.trigger("dir dir:" + i, n1);
    } else this.resetDirection();
    return n1;
};
var PF = Fi;
function di(n1, t) {
    var e = this;
    e.nipples = [], e.idles = [], e.actives = [], e.ids = [], e.pressureIntervals = {}, e.manager = n1, e.id = di.id, di.id += 1, e.defaults = {
        zone: document.body,
        multitouch: !1,
        maxNumberOfNipples: 10,
        mode: "dynamic",
        position: {
            top: 0,
            left: 0
        },
        catchDistance: 200,
        size: 100,
        threshold: .1,
        color: "white",
        fadeTime: 250,
        dataOnly: !1,
        restJoystick: !0,
        restOpacity: 1,
        lockX: !1,
        lockY: !1,
        shape: "circle",
        dynamicPage: !1,
        follow: !1
    }, e.config(t), (e.options.mode === "static" || e.options.mode === "semi") && (e.options.multitouch = !1), e.options.multitouch || (e.options.maxNumberOfNipples = 1);
    let r = getComputedStyle(e.options.zone.parentElement);
    return r && r.display === "flex" && (e.parentIsFlex = !0), e.updateBox(), e.prepareNipples(), e.bindings(), e.begin(), e.nipples;
}
di.prototype = new ip;
di.constructor = di;
di.id = 0;
di.prototype.prepareNipples = function() {
    var n1 = this, t = n1.nipples;
    t.on = n1.on.bind(n1), t.off = n1.off.bind(n1), t.options = n1.options, t.destroy = n1.destroy.bind(n1), t.ids = n1.ids, t.id = n1.id, t.processOnMove = n1.processOnMove.bind(n1), t.processOnEnd = n1.processOnEnd.bind(n1), t.get = function(e) {
        if (e === void 0) return t[0];
        for(var r = 0, i = t.length; r < i; r += 1)if (t[r].identifier === e) return t[r];
        return !1;
    };
};
di.prototype.bindings = function() {
    var n1 = this;
    n1.bindEvt(n1.options.zone, "start"), n1.options.zone.style.touchAction = "none", n1.options.zone.style.msTouchAction = "none";
};
di.prototype.begin = function() {
    var n1 = this, t = n1.options;
    if (t.mode === "static") {
        var e = n1.createNipple(t.position, n1.manager.getIdentifier());
        e.add(), n1.idles.push(e);
    }
};
di.prototype.createNipple = function(n1, t) {
    var e = this, r = e.manager.scroll, i = {}, s1 = e.options, o = {
        x: e.parentIsFlex ? r.x : r.x + e.box.left,
        y: e.parentIsFlex ? r.y : r.y + e.box.top
    };
    if (n1.x && n1.y) i = {
        x: n1.x - o.x,
        y: n1.y - o.y
    };
    else if (n1.top || n1.right || n1.bottom || n1.left) {
        var a = document.createElement("DIV");
        a.style.display = "hidden", a.style.top = n1.top, a.style.right = n1.right, a.style.bottom = n1.bottom, a.style.left = n1.left, a.style.position = "absolute", s1.zone.appendChild(a);
        var l = a.getBoundingClientRect();
        s1.zone.removeChild(a), i = n1, n1 = {
            x: l.left + r.x,
            y: l.top + r.y
        };
    }
    var c = new PF(e, {
        color: s1.color,
        size: s1.size,
        threshold: s1.threshold,
        fadeTime: s1.fadeTime,
        dataOnly: s1.dataOnly,
        restJoystick: s1.restJoystick,
        restOpacity: s1.restOpacity,
        mode: s1.mode,
        identifier: t,
        position: n1,
        zone: s1.zone,
        frontPosition: {
            x: 0,
            y: 0
        },
        shape: s1.shape
    });
    return s1.dataOnly || (a1(c.ui.el, i), a1(c.ui.front, c.frontPosition)), e.nipples.push(c), e.trigger("added " + c.identifier + ":added", c), e.manager.trigger("added " + c.identifier + ":added", c), e.bindNipple(c), c;
};
di.prototype.updateBox = function() {
    var n1 = this;
    n1.box = n1.options.zone.getBoundingClientRect();
};
di.prototype.bindNipple = function(n1) {
    var t = this, e, r = function(i, s1) {
        e = i.type + " " + s1.id + ":" + i.type, t.trigger(e, s1);
    };
    n1.on("destroyed", t.onDestroyed.bind(t)), n1.on("shown hidden rested dir plain", r), n1.on("dir:up dir:right dir:down dir:left", r), n1.on("plain:up plain:right plain:down plain:left", r);
};
di.prototype.pressureFn = function(n1, t, e) {
    var r = this, i = 0;
    clearInterval(r.pressureIntervals[e]), r.pressureIntervals[e] = setInterval((function() {
        var s1 = n1.force || n1.pressure || n1.webkitForce || 0;
        s1 !== i && (t.trigger("pressure", s1), r.trigger("pressure " + t.identifier + ":pressure", s1), i = s1);
    }).bind(r), 100);
};
di.prototype.onstart = function(n1) {
    var t = this, e = t.options, r = n1;
    n1 = o1(n1), t.updateBox();
    var i = function(s1) {
        t.actives.length < e.maxNumberOfNipples ? t.processOnStart(s1) : r.type.match(/^touch/) && (Object.keys(t.manager.ids).forEach(function(o) {
            if (Object.values(r.touches).findIndex(function(l) {
                return l.identifier === o;
            }) < 0) {
                var a = [
                    n1[0]
                ];
                a.identifier = o, t.processOnEnd(a);
            }
        }), t.actives.length < e.maxNumberOfNipples && t.processOnStart(s1));
    };
    return Tg(n1, i), t.manager.bindDocument(), !1;
};
di.prototype.processOnStart = function(n1) {
    var t = this, e = t.options, r, i = t.manager.getIdentifier(n1), s1 = n1.force || n1.pressure || n1.webkitForce || 0, o = {
        x: n1.pageX,
        y: n1.pageY
    }, a = t.getOrCreate(i, o);
    a.identifier !== i && t.manager.removeIdentifier(a.identifier), a.identifier = i;
    var l = function(u1) {
        u1.trigger("start", u1), t.trigger("start " + u1.id + ":start", u1), u1.show(), s1 > 0 && t.pressureFn(n1, u1, u1.identifier), t.processOnMove(n1);
    };
    if ((r = t.idles.indexOf(a)) >= 0 && t.idles.splice(r, 1), t.actives.push(a), t.ids.push(a.identifier), e.mode !== "semi") l(a);
    else {
        var c = Eg(o, a.position);
        if (c <= e.catchDistance) l(a);
        else {
            a.destroy(), t.processOnStart(n1);
            return;
        }
    }
    return a;
};
di.prototype.getOrCreate = function(n1, t) {
    var e = this, r = e.options, i;
    return /(semi|static)/.test(r.mode) ? (i = e.idles[0], i ? (e.idles.splice(0, 1), i) : r.mode === "semi" ? e.createNipple(t, n1) : (console.warn("Coudln't find the needed nipple."), !1)) : (i = e.createNipple(t, n1), i);
};
di.prototype.processOnMove = function(n1) {
    var t = this, e = t.options, r = t.manager.getIdentifier(n1), i = t.nipples.get(r), s2 = t.manager.scroll;
    if (!bF(n1)) {
        this.processOnEnd(n1);
        return;
    }
    if (!i) {
        console.error("Found zombie joystick with ID " + r), t.manager.removeIdentifier(r);
        return;
    }
    if (e.dynamicPage) {
        var o = i.el.getBoundingClientRect();
        i.position = {
            x: s2.x + o.left,
            y: s2.y + o.top
        };
    }
    i.identifier = r;
    var a = i.options.size / 2, l = {
        x: n1.pageX,
        y: n1.pageY
    };
    e.lockX && (l.y = i.position.y), e.lockY && (l.x = i.position.x);
    var c = Eg(l, i.position), u1 = vF(l, i.position), h = s1(u1), d = c / a, f = {
        distance: c,
        position: l
    }, m, p;
    if (i.options.shape === "circle" ? (m = Math.min(c, a), p = xF(i.position, m, u1)) : (p = EF(l, i.position, a), m = Eg(p, i.position)), e.follow) {
        if (c > a) {
            let v = l.x - p.x, b = l.y - p.y;
            i.position.x += v, i.position.y += b, i.el.style.top = i.position.y - (t.box.top + s2.y) + "px", i.el.style.left = i.position.x - (t.box.left + s2.x) + "px", c = Eg(l, i.position);
        }
    } else l = p, c = m;
    var g = l.x - i.position.x, y = l.y - i.position.y;
    i.frontPosition = {
        x: g,
        y: y
    }, e.dataOnly || a1(i.ui.front, i.frontPosition);
    var x = {
        identifier: i.identifier,
        position: l,
        force: d,
        pressure: n1.force || n1.pressure || n1.webkitForce || 0,
        distance: c,
        angle: {
            radian: h,
            degree: u1
        },
        vector: {
            x: g / a,
            y: -y / a
        },
        raw: f,
        instance: i,
        lockX: e.lockX,
        lockY: e.lockY
    };
    x = i.computeDirection(x), x.angle = {
        radian: s1(180 - u1),
        degree: 180 - u1
    }, i.trigger("move", x), t.trigger("move " + i.id + ":move", x);
};
di.prototype.processOnEnd = function(n1) {
    var t = this, e = t.options, r = t.manager.getIdentifier(n1), i = t.nipples.get(r), s1 = t.manager.removeIdentifier(i.identifier);
    !i || (e.dataOnly || i.hide(function() {
        e.mode === "dynamic" && (i.trigger("removed", i), t.trigger("removed " + i.id + ":removed", i), t.manager.trigger("removed " + i.id + ":removed", i), i.destroy());
    }), clearInterval(t.pressureIntervals[i.identifier]), i.resetDirection(), i.trigger("end", i), t.trigger("end " + i.id + ":end", i), t.ids.indexOf(i.identifier) >= 0 && t.ids.splice(t.ids.indexOf(i.identifier), 1), t.actives.indexOf(i) >= 0 && t.actives.splice(t.actives.indexOf(i), 1), /(semi|static)/.test(e.mode) ? t.idles.push(i) : t.nipples.indexOf(i) >= 0 && t.nipples.splice(t.nipples.indexOf(i), 1), t.manager.unbindDocument(), /(semi|static)/.test(e.mode) && (t.manager.ids[s1.id] = s1.identifier));
};
di.prototype.onDestroyed = function(n1, t) {
    var e = this;
    e.nipples.indexOf(t) >= 0 && e.nipples.splice(e.nipples.indexOf(t), 1), e.actives.indexOf(t) >= 0 && e.actives.splice(e.actives.indexOf(t), 1), e.idles.indexOf(t) >= 0 && e.idles.splice(e.idles.indexOf(t), 1), e.ids.indexOf(t.identifier) >= 0 && e.ids.splice(e.ids.indexOf(t.identifier), 1), e.manager.removeIdentifier(t.identifier), e.manager.unbindDocument();
};
di.prototype.destroy = function() {
    var n1 = this;
    n1.unbindEvt(n1.options.zone, "start"), n1.nipples.forEach(function(e) {
        e.destroy();
    });
    for(var t in n1.pressureIntervals)n1.pressureIntervals.hasOwnProperty(t) && clearInterval(n1.pressureIntervals[t]);
    n1.trigger("destroyed", n1.nipples), n1.manager.unbindDocument(), n1.off();
};
var _F = di;
function Ki(n1) {
    var t = this;
    t.ids = {}, t.index = 0, t.collections = [], t.scroll = PM(), t.config(n1), t.prepareCollections();
    var e = function() {
        var i;
        t.collections.forEach(function(s1) {
            s1.forEach(function(o) {
                i = o.el.getBoundingClientRect(), o.position = {
                    x: t.scroll.x + i.left,
                    y: t.scroll.y + i.top
                };
            });
        });
    };
    if (typeof window > "u") return t.collections;
    tp(window, "resize", function() {
        MM(e);
    });
    var r = function() {
        t.scroll = PM();
    };
    return tp(window, "scroll", function() {
        MM(r);
    }), t.collections;
}
Ki.prototype = new ip;
Ki.constructor = Ki;
Ki.prototype.prepareCollections = function() {
    var n1 = this;
    n1.collections.create = n1.create.bind(n1), n1.collections.on = n1.on.bind(n1), n1.collections.off = n1.off.bind(n1), n1.collections.destroy = n1.destroy.bind(n1), n1.collections.get = function(t) {
        var e;
        return n1.collections.every(function(r) {
            return e = r.get(t), !e;
        }), e;
    };
};
Ki.prototype.create = function(n1) {
    return this.createCollection(n1);
};
Ki.prototype.createCollection = function(n1) {
    var t = this, e = new _F(t, n1);
    return t.bindCollection(e), t.collections.push(e), e;
};
Ki.prototype.bindCollection = function(n1) {
    var t = this, e, r = function(i, s1) {
        e = i.type + " " + s1.id + ":" + i.type, t.trigger(e, s1);
    };
    n1.on("destroyed", t.onDestroyed.bind(t)), n1.on("shown hidden rested dir plain", r), n1.on("dir:up dir:right dir:down dir:left", r), n1.on("plain:up plain:right plain:down plain:left", r);
};
Ki.prototype.bindDocument = function() {
    var n1 = this;
    n1.binded || (n1.bindEvt(document, "move").bindEvt(document, "end"), n1.binded = !0);
};
Ki.prototype.unbindDocument = function(n1) {
    var t = this;
    (!Object.keys(t.ids).length || n1 === !0) && (t.unbindEvt(document, "move").unbindEvt(document, "end"), t.binded = !1);
};
Ki.prototype.getIdentifier = function(n1) {
    var t;
    return n1 ? (t = n1.identifier === void 0 ? n1.pointerId : n1.identifier, t === void 0 && (t = this.latest || 0)) : t = this.index, this.ids[t] === void 0 && (this.ids[t] = this.index, this.index += 1), this.latest = t, this.ids[t];
};
Ki.prototype.removeIdentifier = function(n1) {
    var t = {};
    for(var e in this.ids)if (this.ids[e] === n1) {
        t.id = e, t.identifier = this.ids[e], delete this.ids[e];
        break;
    }
    return t;
};
Ki.prototype.onmove = function(n1) {
    var t = this;
    return t.onAny("move", n1), !1;
};
Ki.prototype.onend = function(n1) {
    var t = this;
    return t.onAny("end", n1), !1;
};
Ki.prototype.oncancel = function(n1) {
    var t = this;
    return t.onAny("end", n1), !1;
};
Ki.prototype.onAny = function(n1, t) {
    var e = this, r, i = "processOn" + n1.charAt(0).toUpperCase() + n1.slice(1);
    t = o1(t);
    var s1 = function(a, l, c) {
        c.ids.indexOf(l) >= 0 && (c[i](a), a._found_ = !0);
    }, o = function(a) {
        r = e.getIdentifier(a), Tg(e.collections, s1.bind(null, a, r)), a._found_ || e.removeIdentifier(r);
    };
    return Tg(t, o), !1;
};
Ki.prototype.destroy = function() {
    var n1 = this;
    n1.unbindDocument(!0), n1.ids = {}, n1.index = 0, n1.collections.forEach(function(t) {
        t.destroy();
    }), n1.off();
};
Ki.prototype.onDestroyed = function(n1, t) {
    var e = this;
    if (e.collections.indexOf(t) < 0) return !1;
    e.collections.splice(e.collections.indexOf(t), 1);
};
var IF = Ki;
var DF = new IF, OF = {
    create: function(n1) {
        return DF.create(n1);
    },
    factory: DF
};
var RF = new Map, Pg = new Map, da = class {
    constructor(t, e, r, i){
        this.data = e;
        let { audio: s1, volume: o, delay: a, loop: l } = e;
        if (!s1) throw new Error("Missing property");
        try {
            let c = typeof s1 == "string" ? i.getAudio(s1).src : s1.data;
            this.audioPlayer = new el({
                src: c,
                volume: o,
                delay: a,
                loop: l
            });
        } catch  {
            console.warn(`Could not create an audio player for this object: "${r.name}" and this audio: "${s1}"`);
        }
        Pg.has(r.uuid) ? Pg.get(r.uuid).push(this) : Pg.set(r.uuid, [
            this
        ]), RF.set(t, this);
    }
    playByToggle() {
        this.data.toggle === "stop" ? this.audioPlayer?.status === "playing" ? this.audioPlayer.stop() : (this.audioPlayer?.stop(), this.audioPlayer?.play()) : this.data.toggle === "pause" ? this.audioPlayer?.status === "playing" ? this.audioPlayer?.pause() : this.audioPlayer?.play() : (this.audioPlayer?.stop(), this.audioPlayer?.play());
    }
    dispose() {
        this.audioPlayer?.stop();
    }
}, np = class {
    constructor(t){
        this.data = t;
    }
    dispatch() {
        this.data.playAudio ? this.pauseAudio(this.data.playAudio) : this.data.object ? this.pauseAllAudiosFromObject(this.data.object) : this.pauseAllAudios();
    }
    pauseAudio(t) {
        let e = RF.get(t);
        !e || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e.audioPlayer?.[this.data.interaction](), this.disposeDelay();
        }, this.data.delay)) : e.audioPlayer?.[this.data.interaction]());
    }
    pauseAllAudiosFromObject(t) {
        let e = Pg.get(t);
        !e?.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e.forEach((r)=>r.audioPlayer?.[this.data.interaction]()), this.disposeDelay();
        }, this.data.delay)) : e.forEach((r)=>r.audioPlayer?.[this.data.interaction]()));
    }
    pauseAllAudios() {
        let t = [
            ...Pg.values()
        ];
        !t.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            t.forEach((e)=>{
                e.forEach((r)=>{
                    r.audioPlayer?.[this.data.interaction]();
                });
            }), this.disposeDelay();
        }, this.data.delay)) : t.forEach((e)=>{
            e.forEach((r)=>{
                r.audioPlayer?.[this.data.interaction]();
            });
        }));
    }
    disposeDelay() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
    dispose() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
}, _g = class {
    constructor(t, e, r, i, s1){
        this.data = e;
        this.shared = i;
        this.condition = s1;
        if (e.interaction === "play") this.interaction = new da(t, e, r, i);
        else if (e.interaction === "pause" || e.interaction === "stop") this.interaction = new np(e);
        else throw new Error("Missing property");
    }
    dispatchBasic() {
        if (_t(this.shared, this.condition) === !1) return !1;
        this.interaction instanceof da ? this.interaction.playByToggle() : this.interaction.dispatch();
    }
    dispatchConditional() {
        if (_t(this.shared, this.condition) === !1) return !1;
        this.interaction instanceof da ? this.interaction.audioPlayer?.play() : this.interaction.dispatch();
    }
    dispatchGameControl(t) {
        if (_t(this.shared, this.condition) === !1) return !1;
        this.interaction instanceof da && (t === "start" ? this.interaction.audioPlayer?.play() : this.interaction.audioPlayer?.stop());
    }
    dispose() {
        this.interaction.dispose();
    }
};
var Ig = class {
    constructor(t, e, r, i){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.condition = i;
        this.delay = 0;
        this.emission = t.emission, t.delay !== void 0 && (this.delay = t.delay), this.particleSystem = this.page.scene.find(this.data.emitterObjectId);
    }
    toggleEmitting() {
        this.particleSystem.started && !this.particleSystem.stopped ? this.stop(this.delay) : this.start(this.delay);
    }
    toggleFroze() {
        this.particleSystem.started && !this.particleSystem.isFrozen ? this.freeze(this.delay) : this.unFreeze(this.delay);
    }
    start(t = 0) {
        if (t) {
            this.delayTimerId = window.setTimeout(()=>{
                this.start(0), this.clearDelay();
            }, t);
            return;
        }
        this.particleSystem.start();
    }
    stop(t = 0) {
        if (t) {
            this.delayTimerId = window.setTimeout(()=>{
                this.stop(0), this.clearDelay();
            }, t);
            return;
        }
        this.particleSystem.stop();
    }
    freeze(t = 0) {
        if (t) {
            this.delayTimerId = window.setTimeout(()=>{
                this.freeze(0), this.clearDelay();
            }, t);
            return;
        }
        this.particleSystem.froze();
    }
    unFreeze(t = 0) {
        if (t) {
            this.delayTimerId = window.setTimeout(()=>{
                this.unFreeze(0), this.clearDelay();
            }, t);
            return;
        }
        this.particleSystem.unFroze();
    }
    reset(t = 0) {
        if (t) {
            this.delayTimerId = window.setTimeout(()=>{
                this.reset(0), this.clearDelay();
            }, t);
            return;
        }
        this.particleSystem.reset();
    }
    reverseFromCurrent() {
        switch(this.emission){
            case "emitToggle":
                this.toggleEmitting();
                break;
            case "pauseToggle":
                this.toggleFroze();
                break;
        }
    }
    dispatchBasic() {
        if (_t(this.shared, this.condition) === !1 || !this.particleSystem) return !1;
        switch(this.emission){
            case "start":
                this.start(this.delay);
                break;
            case "emitToggle":
                this.toggleEmitting();
                break;
            case "pause":
                this.freeze(this.delay);
                break;
            case "pauseToggle":
                this.toggleFroze();
                break;
            case "stop":
                this.stop(this.delay);
                break;
            case "reset":
                this.reset(this.delay);
                break;
            default:
                break;
        }
    }
    dispatchConditional() {
        if (_t(this.shared, this.condition) === !1 || !this.particleSystem) return !1;
        switch(this.emission){
            case "start":
                this.start(this.delay);
                break;
            case "stop":
                this.stop(this.delay);
                break;
            case "reset":
                this.reset(this.delay);
                break;
            default:
                break;
        }
    }
    dispatchGameControl(t) {
        if (_t(this.shared, this.condition) === !1 || !this.particleSystem) return !1;
        t === "start" ? this.start(this.delay) : this.stop(this.delay);
    }
    dispose() {
        !this.particleSystem || (this.particleSystem.reset(), this.clearDelay());
    }
    clearDelay() {
        this.delayTimerId && (clearTimeout(this.delayTimerId), delete this.delayTimerId);
    }
};
var _ee = "text/plain", Iee = "us-ascii", LF = (n1, t)=>t.some((e)=>e instanceof RegExp ? e.test(n1) : e === n1), Dee = (n1, { stripHash: t })=>{
    let e = /^data:(?<type>[^,]*?),(?<data>[^#]*?)(?:#(?<hash>.*))?$/.exec(n1);
    if (!e) throw new Error(`Invalid URL: ${n1}`);
    let { type: r, data: i, hash: s1 } = e.groups, o = r.split(";");
    s1 = t ? "" : s1;
    let a = !1;
    o[o.length - 1] === "base64" && (o.pop(), a = !0);
    let l = (o.shift() || "").toLowerCase(), u1 = [
        ...o.map((h)=>{
            let [d, f = ""] = h.split("=").map((m)=>m.trim());
            return d === "charset" && (f = f.toLowerCase(), f === Iee) ? "" : `${d}${f ? `=${f}` : ""}`;
        }).filter(Boolean)
    ];
    return a && u1.push("base64"), (u1.length > 0 || l && l !== _ee) && u1.unshift(l), `data:${u1.join(";")},${a ? i.trim() : i}${s1 ? `#${s1}` : ""}`;
};
function _M(n1, t) {
    if (t = {
        defaultProtocol: "http:",
        normalizeProtocol: !0,
        forceHttp: !1,
        forceHttps: !1,
        stripAuthentication: !0,
        stripHash: !1,
        stripTextFragment: !0,
        stripWWW: !0,
        removeQueryParameters: [
            /^utm_\w+/i
        ],
        removeTrailingSlash: !0,
        removeSingleSlash: !0,
        removeDirectoryIndex: !1,
        sortQueryParameters: !0,
        ...t
    }, n1 = n1.trim(), /^data:/i.test(n1)) return Dee(n1, t);
    if (/^view-source:/i.test(n1)) throw new Error("`view-source:` is not supported as it is a non-standard protocol");
    let e = n1.startsWith("//");
    !e && /^\.*\//.test(n1) || (n1 = n1.replace(/^(?!(?:\w+:)?\/\/)|^\/\//, t.defaultProtocol));
    let i = new URL(n1);
    if (t.forceHttp && t.forceHttps) throw new Error("The `forceHttp` and `forceHttps` options cannot be used together");
    if (t.forceHttp && i.protocol === "https:" && (i.protocol = "http:"), t.forceHttps && i.protocol === "http:" && (i.protocol = "https:"), t.stripAuthentication && (i.username = "", i.password = ""), t.stripHash ? i.hash = "" : t.stripTextFragment && (i.hash = i.hash.replace(/#?:~:text.*?$/i, "")), i.pathname) {
        let o = /\b[a-z][a-z\d+\-.]{1,50}:\/\//g, a = 0, l = "";
        for(;;){
            let u1 = o.exec(i.pathname);
            if (!u1) break;
            let h = u1[0], d = u1.index, f = i.pathname.slice(a, d);
            l += f.replace(/\/{2,}/g, "/"), l += h, a = d + h.length;
        }
        let c = i.pathname.slice(a, i.pathname.length);
        l += c.replace(/\/{2,}/g, "/"), i.pathname = l;
    }
    if (i.pathname) try {
        i.pathname = decodeURI(i.pathname);
    } catch  {}
    if (t.removeDirectoryIndex === !0 && (t.removeDirectoryIndex = [
        /^index\.[a-z]+$/
    ]), Array.isArray(t.removeDirectoryIndex) && t.removeDirectoryIndex.length > 0) {
        let o = i.pathname.split("/"), a = o[o.length - 1];
        LF(a, t.removeDirectoryIndex) && (o = o.slice(0, -1), i.pathname = o.slice(1).join("/") + "/");
    }
    if (i.hostname && (i.hostname = i.hostname.replace(/\.$/, ""), t.stripWWW && /^www\.(?!www\.)[a-z\-\d]{1,63}\.[a-z.\-\d]{2,63}$/.test(i.hostname) && (i.hostname = i.hostname.replace(/^www\./, ""))), Array.isArray(t.removeQueryParameters)) for (let o of [
        ...i.searchParams.keys()
    ])LF(o, t.removeQueryParameters) && i.searchParams.delete(o);
    if (t.removeQueryParameters === !0 && (i.search = ""), t.sortQueryParameters) {
        i.searchParams.sort();
        try {
            i.search = decodeURIComponent(i.search);
        } catch  {}
    }
    t.removeTrailingSlash && (i.pathname = i.pathname.replace(/\/$/, ""));
    let s1 = n1;
    return n1 = i.toString(), !t.removeSingleSlash && i.pathname === "/" && !s1.endsWith("/") && i.hash === "" && (n1 = n1.replace(/\/$/, "")), (t.removeTrailingSlash || i.pathname === "/") && i.hash === "" && t.removeSingleSlash && (n1 = n1.replace(/\/$/, "")), e && !t.normalizeProtocol && (n1 = n1.replace(/^http:\/\//, "//")), t.stripProtocol && (n1 = n1.replace(/^(?:https?:)?\/\//, "")), n1;
}
var h1 = class {
    constructor({ url: t, context: e }, r, i, s1){
        this.controlsManager = r;
        this.shared = i;
        this.condition = s1;
        if (!t) throw new Error("Missing property");
        this.url = t.startsWith("mailto:") ? t : _M(t, {
            removeTrailingSlash: !1,
            removeSingleSlash: !1,
            stripWWW: !1
        }), this.context = e ?? "tab";
    }
    dispatch() {
        if (_t(this.shared, this.condition) === !1) return !1;
        bs ? window.location.assign(this.url) : (this.context === "tab" || rA && this.context === "none" ? window.open(this.url, "_blank") : this.context === "window" ? window.open(this.url, "_blank", `width=${window.innerWidth}, height=${window.innerHeight}`) : window.open(this.url, "_parent"), this.controlsManager.orbitControls?.onPointerUp(et[0]), pD());
    }
};
var Dg = class {
    constructor(t, e, r, i, s1){
        this.data = t;
        this.page = e;
        this.controlsManager = r;
        this.shared = i;
        this.condition = s1;
        this.timeoutIdQueue = [];
        this.dispatchInner = ()=>{
            this.objects.forEach(this.destroyCallback);
        };
        this.destroyCallback = (t)=>{
            this.timeoutIdQueue.shift();
            let e = this.page.scene.find(t);
            if (e === void 0) return;
            let r = this.controlsManager.sharedGameControlGlobals.rapierWorld, i = r ? e.dataPatched.physics?.fusedBody : !0;
            if (e.cloner) {
                for (let s1 of e.cloner.children)i ? (s1.playModeVisible = !1, s1.rigidBody && e.dataPatched.physics?.rigidBody === "positioned" && (this.controlsManager.sharedGameControlGlobals.colliderToEntity.delete(s1.rigidBody.collider(0).handle), r.removeRigidBody(s1.rigidBody), s1.rigidBody = void 0), s1.bvhGeometry && (s1.bvhGeometry = void 0)) : this.clone === void 0 || this.clone === s1 ? (s1.playModeVisible = !1, s1.rigidBody && (this.controlsManager.sharedGameControlGlobals.colliderToEntity.delete(s1.rigidBody.collider(0).handle), r.removeRigidBody(s1.rigidBody), s1.rigidBody = void 0)) : s1.playModeVisible === void 0 && (s1.playModeVisible = !0);
                (i || this.clone === void 0 || this.clone === !1) && (e.visible = !1, e.rigidBody && (this.controlsManager.sharedGameControlGlobals.colliderToEntity.delete(e.rigidBody.collider(0).handle), r.removeRigidBody(e.rigidBody), e.rigidBody = void 0), e.bvhGeometry && (e.bvhGeometry = void 0));
            } else e.rigidBody && (this.controlsManager.sharedGameControlGlobals.colliderToEntity.delete(e.rigidBody.collider(0).handle), r.removeRigidBody(e.rigidBody), e.rigidBody = void 0), e.bvhGeometry && (e.bvhGeometry = void 0), e.visible = !1;
            r === void 0 ? this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim = this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.filter((s1)=>s1.bvhGeometry !== void 0) : this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim = this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.filter((s1)=>s1.rigidBody !== void 0), e.destroyedInAction = !0, this.controlsManager.requestRender();
        };
        this.objects = [
            ...t.objects
        ];
    }
    dispatch(t) {
        if (_t(this.shared, this.condition) === !1) return !1;
        this.clone = t, this.data.delay ? this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3)) : this.dispatchInner();
    }
    dispatchFromStart() {
        if (_t(this.shared, this.condition) === !1) return !1;
        this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3));
    }
    dispose() {
        this.timeoutIdQueue.forEach((t)=>window.clearTimeout(t));
    }
};
var Og = class {
    constructor(t, e, r, i, s1){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.eventManager = i;
        this.condition = s1;
        this.shared = r;
    }
    dispatch() {
        if (_t(this.shared, this.condition) === !1) return !1;
        clearTimeout(this.timeoutId), delete this.timeoutId, this.timeoutId = window.setTimeout(()=>{
            this.shared.reset(this.shared.data, !0), sp(this.page, this.shared, !0), this.eventManager.reset(), this.eventManager.controlsManager.gameControl?.reset(!0), this.page.switchToPlayCamera(), this.eventManager.controlsManager.requestRender(), delete this.timeoutId;
        }, (this.data.delay ?? 0) * 1e3);
    }
    dispose() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
};
function NF(n1, t, e, r) {
    let i = [], s1 = n1.cameraType === "OrthographicCamera" ? t.orthographic?.zoom : t.perspective?.zoom, o = n1.cameraType === "OrthographicCamera" ? e.orthographic?.zoom : e.perspective?.zoom;
    if (o !== void 0) {
        let a = s1 ?? n1.zoom, l = o;
        a !== l && i.push({
            update: (c)=>{
                n1.zoom = Se.lerp(a, l, c), n1.updateProjectionMatrix();
            },
            start: ()=>{
                n1.zoom = a, n1.updateProjectionMatrix();
            },
            end: ()=>{
                n1.zoom = l, n1.updateProjectionMatrix();
            }
        });
    }
    if (e.targetOffset !== void 0) {
        let a = ii("targetOffset", n1, t, e, r);
        a && i.push(a);
    }
    return i;
}
function Oee(n1, t, e, r) {
    if (e.scaleBaked === void 0) return;
    let i = (t.scaleBaked ?? n1.data.geometry.scaleBaked).map((a)=>typeof a == "string" ? Number(r.shared.getVariable(a) ?? 0) : a), s1 = e.scaleBaked.map((a)=>typeof a == "string" ? Number(r.shared.getVariable(a) ?? 0) : a);
    if (ws.isEqual(i, s1)) return;
    let o = [];
    return o.push({
        update: (a)=>{
            n1.updateGeometryInteractions({
                scaleBaked: [
                    Se.lerp(i[0], s1[0], a),
                    Se.lerp(i[1], s1[1], a),
                    Se.lerp(i[2], s1[2], a)
                ]
            }, r.shared), n1.invalidateDownstreamBooleanData(), n1.refreshAttachedClonersInteractions(r);
        },
        start: ()=>{
            n1.updateGeometryInteractions({
                scaleBaked: i
            }, r.shared), n1.invalidateDownstreamBooleanData(), n1.refreshAttachedClonersInteractions(r);
        },
        end: ()=>{
            n1.updateGeometryInteractions({
                scaleBaked: s1
            }, r.shared), n1.invalidateDownstreamBooleanData(), n1.refreshAttachedClonersInteractions(r);
        }
    }), o;
}
function Ree(n1, t, e, r) {
    if (!e.extrusion) return;
    let i = n1.extrusion, s1 = t.extrusion ?? {}, o = e.extrusion, a = [];
    return L0.forEach((l)=>{
        let c = Go(l, i, s1, o, r);
        c && a.push(c);
    }), a;
}
function BF(n1, t, e, r) {
    let i = [];
    if (!("geometry" in e)) return i;
    let s1 = n1.geometry.userData.parameters, o = "geometry" in t ? t.geometry : {}, a = e.geometry;
    if (n1 instanceof lo) {
        let l = Oee(n1, o, a, r);
        l && i.push(...l);
    } else {
        let l = {};
        if (Object.assign(l, Nn(s1, B0), Nn(o, B0)), B0.forEach((c)=>{
            let u1 = Go(c, l, o, a, r.shared);
            u1 && i.push(u1);
        }), n1 instanceof qo) {
            Object.assign(l, {
                extrusion: {
                    ...s1.extrusion
                }
            });
            let c = Ree(l, o, a, r.shared);
            c && i.push(...c);
        }
        i.length && i.push({
            update: (c)=>{
                n1.updateGeometryInteractions(l, r.shared), n1.updateGeometryGroupsIfNeeded(), n1.refreshAttachedClonersInteractions(r);
            },
            start: (c)=>{
                n1.updateGeometryInteractions(l, r.shared), n1.updateGeometryGroupsIfNeeded(), n1.refreshAttachedClonersInteractions(r);
            },
            end: (c)=>{
                n1.updateGeometryInteractions(l, r.shared), n1.updateGeometryGroupsIfNeeded(), n1.refreshAttachedClonersInteractions(r);
            }
        });
    }
    return i;
}
function LR(n1, t, e, r) {
    let i = n1.geometry.userData.parameters.extrusion;
    if (!!i) return L0.forEach((s1)=>{
        jo(s1, i, t, e, r);
    }), i;
}
function NR(n1, t, e, r) {
    let i = n1.updatedPathSnapping;
    if (!!i) return DO.forEach((s1)=>{
        jo(s1, i, t, e, r);
    }), i;
}
function FF(n1, t, e, r) {
    let i = [];
    if (e.intensity !== void 0) {
        let s1 = ii("intensity", n1, t, e, r);
        s1 && i.push(s1);
    }
    if (e.color !== void 0) {
        let s1 = MR("color", n1, t, e, r);
        s1 && i.push(s1);
    }
    return i;
}
function UF(n1, t, e, r) {
    let i = [];
    if (Array.isArray(n1.material)) {
        if (!("materials" in e && e.materials)) return i;
        let s1 = "materials" in t && t.materials ? t.materials : [], o = e.materials;
        n1.material.forEach((a, l)=>{
            if (!o[l]) return;
            let c = s1[l] ?? {}, u1 = o[l];
            typeof c == "string" || typeof u1 == "string" || i.push(...VF(a, c, u1, r));
        });
    } else {
        if (!("material" in e && e.material)) return i;
        let s1 = "material" in t && t.material ? t.material : {}, o = e.material;
        if (typeof s1 == "string" || typeof o == "string") return i;
        i.push(...VF(n1.material, s1, o, r));
    }
    return i;
}
function VF(n1, t, e, r) {
    let i = [], s1 = gu(e, r) || !!t.layers && gu(t, r);
    i.push(Lee(n1, s1));
    for (let o of n1.layers){
        let a = t.layers?.data(o.uuid), l = e.layers.data(o.uuid);
        if (!l || o.type !== "light" && (!(o.visible ?? !0) || !(l.visible ?? !0))) continue;
        let c = o.getNames().filter((u1)=>!D0.some((h)=>u1.includes(h)));
        for (let u1 of c)try {
            let h = o.getValue(u1), d;
            if (u1 === "colors") d = qF(o, a, l, u1);
            else if (Array.isArray(h)) u1 === "steps" && (d = WF(o, a, l, u1));
            else if (typeof h == "number") d = kF(o, a, l, u1, r);
            else {
                if (typeof h == "boolean") continue;
                h instanceof U ? d = zF(o, a, l, u1) : h instanceof E ? d = GF(o, a, l, u1, r) : h instanceof cr ? d = HF(o, a, l, u1, r) : h instanceof Ge ? d = jF(o, a, l, u1, r) : "isTexture" in h && (d = XF(o, a, l, u1));
            }
            d && (Array.isArray(d) ? i.push(...d) : i.push(d));
        } catch (h) {
            console.error(`lerpMaterial: unexpected material layer for ${u1}`, h);
        }
    }
    return i;
}
function kF(n1, t, e, r, i) {
    if (!n1.hasValue(r) || !(r in e)) return;
    let s1 = t ? t[r] : n1.getValue(r), o = e[r], a = typeof s1 == "string" ? Number(i.getVariable(s1) ?? 0) : s1, l = typeof o == "string" ? Number(i.getVariable(o) ?? 0) : o;
    if (a !== l) return {
        update: (c)=>{
            n1.setValue(r, Se.lerp(a, l, c));
        },
        start: ()=>{
            n1.setValue(r, a);
        },
        end: ()=>{
            n1.setValue(r, l);
        }
    };
}
function zF(n1, t, e, r) {
    if (!n1.hasValue(r) || !(r in e)) return;
    let i = n1.getValue(r), s1 = t ? new U().fromArray(t[r]) : i.clone(), o = new U().fromArray(e[r]);
    if (!s1.equals(o)) return {
        update: (a)=>{
            i.lerpVectors(s1, o, a);
        },
        start: ()=>{
            i.copy(s1);
        },
        end: ()=>{
            i.copy(o);
        }
    };
}
function GF(n1, t, e, r, i) {
    if (!n1.hasValue(r) || !(r in e)) return;
    let s1 = n1.getValue(r), o = t ? t[r] : void 0, a = e[r], l = o ? Am(new E, o, i) : s1.clone(), c = Am(new E, a, i);
    if (!l.equals(c)) return {
        update: (u1)=>{
            s1.lerpVectors(l, c, u1);
        },
        start: ()=>{
            s1.copy(l);
        },
        end: ()=>{
            s1.copy(c);
        }
    };
}
function jF(n1, t, e, r, i) {
    if (!n1.hasValue(r) || !(r in e)) return;
    let s1 = t ? t[r] : void 0, o = e[r], a = n1.getValue(r), l = s1 ? typeof s1 == "string" ? i.getColor(s1).clone() : new Ge().setRGB(s1.r, s1.g, s1.b) : a.clone(), c = typeof o == "string" ? i.getColor(o).clone() : new Ge().setRGB(o.r, o.g, o.b);
    if (l.equals(c)) return;
    let u1 = a.clone();
    return {
        update: (h)=>{
            n1.getValue(r) !== u1 && n1.setValue(r, u1), u1.lerpColors(l, c, h);
        },
        start: ()=>{
            u1.copy(l);
        },
        end: ()=>{
            u1.copy(c);
        }
    };
}
function HF(n1, t, e, r, i) {
    if (!n1.hasValue(r) || !(r in e)) return;
    let s1 = t ? t[r] : void 0, o = e[r], a = n1.getValue(r), l = s1 ? typeof s1 == "string" ? i.color(s1).clone() : new Ge().setRGB(s1.r, s1.g, s1.b) : a.clone(), c = typeof o == "string" ? i.getColor(o).clone() : new cr(o.r, o.g, o.b, o.a);
    if (l.equals(c)) return;
    let u1 = a.clone();
    return {
        update: (h)=>{
            n1.getValue(r) !== u1 && n1.setValue(r, u1), u1.lerpColors(l, c, h);
        },
        start: ()=>{
            u1.copy(l);
        },
        end: ()=>{
            u1.copy(c);
        }
    };
}
function WF(n1, t, e, r = "steps") {
    if (!n1.hasValue(r) || !(r in e)) return;
    let i = [], s1 = n1.getValue(r), o = t ? t[r] : s1, a = e[r];
    return Qc(o, a) || i.push({
        update: (l)=>{
            let c = [
                ...s1
            ];
            for(let u1 = 0; u1 < s1.length; ++u1){
                let h = o[u1], d = a[u1];
                c[u1] = Se.lerp(h, d, l);
            }
            n1.setValue(r, c);
        },
        start: ()=>{
            n1.setValue(r, o);
        },
        end: ()=>{
            n1.setValue(r, a);
        }
    }), i.length ? i : void 0;
}
function qF(n1, t, e, r = "colors") {
    if (!n1.hasValue(r) || !(r in e)) return;
    let i = [], s1 = n1.getValue(r), o = t ? t[r] : s1.map((l)=>l.toArray()), a = e[r];
    for(let l = 0; l < s1.length; ++l){
        let c = [
            ...o[l]
        ], u1 = [
            ...a[l]
        ];
        eu.isEqual(c, u1) || i.push({
            update: (h)=>{
                s1[l].fromArray(eu.lerp(c, u1, h));
            },
            start: ()=>{
                s1[l].fromArray(c);
            },
            end: ()=>{
                s1[l].fromArray(u1);
            }
        });
    }
    return i.length ? i : void 0;
}
function XF(n1, t, e, r = "texture") {
    if (!n1.hasValue(r) || !(r in e)) return;
    let i = n1.getNode("rotation"), s1 = t?.[r]?.rotation ?? 0, o = e[r]?.rotation ?? 0;
    if (i && s1 !== o) return {
        update: (g)=>{
            i.value = Se.lerp(s1, o, g) * Se.DEG2RAD;
        },
        start: ()=>{
            i.value = s1 * Se.DEG2RAD;
        },
        end: ()=>{
            i.value = o * Se.DEG2RAD;
        }
    };
    let a = n1.getNode("mat");
    if (!a) return;
    let l = t ? t[r] : a, c = e[r], u1 = [
        ...l.repeat
    ], h = [
        ...l.offset
    ], d = [
        ...c.repeat
    ], f = [
        ...c.offset
    ], m = l.rotation ?? 0, p = c.rotation ?? 0;
    if (!ss.isEqual(u1, d) || !ss.isEqual(h, f) || m !== p) return {
        update: (g)=>{
            a.repeat = ss.lerp(u1, d, g), a.offset = ss.lerp(h, f, g), a.rotation = Se.lerp(m, p, g), a.updateMatrix();
        },
        start: ()=>{
            a.repeat = [
                ...u1
            ], a.offset = [
                ...h
            ], a.rotation = m, a.updateMatrix();
        },
        end: ()=>{
            a.repeat = [
                ...d
            ], a.offset = [
                ...f
            ], a.rotation = p, a.updateMatrix();
        }
    };
}
function IM(n1, t, e, r, i, s1, o) {
    if (n1 === "colors") qF(t, e, r, n1)?.forEach((a)=>a.update(i));
    else if (Array.isArray(s1)) n1 === "steps" && WF(t, e, r, n1)?.forEach((a)=>a.update(i));
    else if (typeof s1 == "number") kF(t, e, r, n1, o)?.update(i);
    else {
        if (typeof s1 == "boolean") return;
        s1 instanceof U ? zF(t, e, r, n1)?.update(i) : s1 instanceof E ? GF(t, e, r, n1, o)?.update(i) : s1 instanceof cr && o ? HF(t, e, r, n1, o)?.update(i) : s1 instanceof Ge && o ? jF(t, e, r, n1, o)?.update(i) : "isTexture" in s1 && XF(t, e, r, n1)?.update(i);
    }
}
function Lee(n1, t) {
    return {
        update: ()=>{
            n1.transparent = t;
        }
    };
}
var DM = new E, YF = new Jt;
function KF(n1, t, e, r, i) {
    let s1 = [], o, a, l, c, u1, h, d, f;
    if (n1 instanceof hr ? (o = Td("position", n1, t, e, i), o && s1.push(o), l = ii("rotation", n1, t, e, i), l && s1.push(l), c = Td("shear", n1, t, e, i), c && s1.push(c)) : (f = {
        slide: t.pathSnapping?.slide ?? n1.updatedPathSnapping?.slide ?? n1.dataPatched.pathSnapping?.slide ?? 0,
        offset: t.pathSnapping?.offset ?? n1.updatedPathSnapping?.offset ?? n1.dataPatched.pathSnapping?.offset ?? 0
    }, h = ii("slide", f, t.pathSnapping ?? n1.updatedPathSnapping ?? n1.dataPatched.pathSnapping, e.pathSnapping ?? n1.dataPatched.pathSnapping, i), h && s1.push(h), d = ii("offset", f, t.pathSnapping ?? n1.updatedPathSnapping ?? n1.dataPatched.pathSnapping, e.pathSnapping ?? n1.dataPatched.pathSnapping, i), d && s1.push(d), !h && !d && (o = nE("position", n1, t, e, i), o && s1.push(o), a = nE("scale", n1, t, e, i), a && s1.push(a), l = Nee(n1, t, e, r, i), l && s1.push(l), u1 = TR("hiddenMatrix", n1, t, e), u1 && s1.push(u1))), o || a || l || u1 || h || d) {
        let m = n1 instanceof hr ? ()=>{
            n1.updateWorldMatrix(!0, !1, !0), n1.resetBBoxNeedsUpdate();
        } : ()=>{
            n1.updateMatrix(), n1.hasNonUniformScale && (n1.updateMatrixWorld(), n1.updateMatrixWorldSVD()), n1.parent?.matrixWorldFusedFalse && (n1.matrixWorld.multiplyMatrices(n1.parent.matrixWorldFusedFalse, n1.matrix), n1.matrixWorldNeedsUpdate = !1), Wn(n1) && Dn(n1.parent) && n1.invalidateDownstreamBooleanData(!0), n1.updatePathSnapping(Object.assign({}, t.pathSnapping, f));
        };
        s1.push({
            update: m,
            start: m,
            end: m
        });
    }
    return s1;
}
function Nee(n1, t, e, r, i) {
    let s1 = t?.rotation ? t.rotation.map((u1)=>(typeof u1 == "string" ? Number(i.getVariable(u1) ?? 0) : u1) * Se.DEG2RAD) : void 0, o = e.rotation?.map((u1)=>(typeof u1 == "string" ? Number(i.getVariable(u1) ?? 0) : u1) * Se.DEG2RAD);
    if (!o) return;
    let a = s1 ? new E().fromArray(s1) : new E().setFromEuler(n1.rotation), l = new E().fromArray(o);
    if (a.equals(l)) return;
    let c = DM.subVectors(l, a);
    if (r && c.toArray().every((u1)=>Math.abs(u1) < 2 * Math.PI)) {
        let u1 = new Ye().setFromEuler(YF.setFromVector3(a)), h = new Ye().setFromEuler(YF.setFromVector3(l));
        return {
            update: (d)=>{
                ER(u1, h, n1.quaternion, d);
            },
            start: ()=>{
                n1.rotation.setFromVector3(a);
            },
            end: ()=>{
                n1.rotation.setFromVector3(l);
            }
        };
    } else return {
        update: (u1)=>{
            DM.lerpVectors(a, l, u1), n1.rotation.setFromVector3(DM);
        },
        start: ()=>{
            n1.rotation.setFromVector3(a);
        },
        end: ()=>{
            n1.rotation.setFromVector3(l);
        }
    };
}
function Bee(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Pr && (n1.fill.enabled = t);
        }
    };
}
function Fee(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Pr && (n1.stroke.enabled = t);
        }
    };
}
function Vee(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Pr && (n1.dropShadow.enabled = t);
        }
    };
}
function Uee(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Pr && (n1.innerShadow.enabled = t);
        }
    };
}
function kee(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Pr && (n1.backgroundBlur.enabled = t);
        }
    };
}
function zee(n1, t) {
    return {
        update: ()=>{
            n1 instanceof Pr && (n1.layerBlur.enabled = t);
        }
    };
}
function QF(n1, t, e, r, i) {
    let s1 = [], o, a, l, c, u1, h, d, f, m, p, g, y, x, v, b;
    if ("width" in n1 && (o = ii("width", n1, t, e, i), o && s1.push(o)), "height" in n1 && (a = ii("height", n1, t, e, i), a && s1.push(a)), n1 instanceof Pr || n1 instanceof rn) {
        let w = {
            ...t.fill
        }, A = {
            ...e.fill
        };
        w.enabled !== void 0 && w.enabled !== A.enabled && (s1.push(Bee(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            color: {
                ...w.color,
                a: 0
            }
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            color: {
                ...A.color,
                a: 0
            }
        })), l = Tm("color", n1.fill, w, A, i), l && s1.push(l);
    }
    if (n1 instanceof Pr) {
        let w = {
            ...t.stroke
        }, A = {
            ...e.stroke
        };
        (w.enabled || A.enabled) && (s1.push(Fee(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            color: {
                ...w.color,
                a: 0
            }
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            color: {
                ...A.color,
                a: 0
            }
        })), c = Tm("color", n1.stroke, w, A, i), c && s1.push(c), u1 = ii("thickness", n1.stroke, w, A, i), u1 && s1.push(u1);
    }
    if (n1 instanceof Pr) {
        let w = {
            ...t.dropShadow
        }, A = {
            ...e.dropShadow
        };
        (w.enabled || A.enabled) && (s1.push(Vee(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            color: {
                ...w.color,
                a: 0
            }
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            color: {
                ...A.color,
                a: 0
            }
        })), h = Tm("color", n1.dropShadow, w, A, i), h && s1.push(h), d = ii("blurRadius", n1.dropShadow, w, A, i), d && s1.push(d), m = ii("spread", n1.dropShadow, w, A, i), m && s1.push(m), f = Td("offset", n1.dropShadow, w, A, i), f && s1.push(f);
    }
    if (n1 instanceof Pr) {
        let w = {
            ...t.innerShadow
        }, A = {
            ...e.innerShadow
        };
        (w.enabled || A.enabled) && (s1.push(Uee(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            color: {
                ...w.color,
                a: 0
            }
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            color: {
                ...A.color,
                a: 0
            }
        })), p = Tm("color", n1.innerShadow, w, A, i), p && s1.push(p), g = ii("blurRadius", n1.innerShadow, w, A, i), g && s1.push(g), x = ii("spread", n1.innerShadow, w, A, i), x && s1.push(x), y = Td("offset", n1.innerShadow, w, A, i), y && s1.push(y);
    }
    if (n1 instanceof Pr || n1 instanceof rn) {
        let w = {
            ...t.backgroundBlur
        }, A = {
            ...e.backgroundBlur
        };
        (w.enabled || A.enabled) && (s1.push(kee(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            radius: 0
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            radius: 0
        })), v = ii("radius", n1.backgroundBlur, w, A, i), v && s1.push(v);
    }
    if (n1 instanceof Pr) {
        let w = {
            ...t.layerBlur
        }, A = {
            ...e.layerBlur
        };
        (w.enabled || A.enabled) && (s1.push(zee(n1, !0)), w.enabled || Object.assign(w, {
            enabled: !0,
            radius: 0
        }), A.enabled || Object.assign(A, {
            enabled: !0,
            radius: 0
        })), b = ii("radius", n1.layerBlur, w, A, i), b && s1.push(b);
    }
    if (n1 instanceof rn || n1 instanceof Bs) {
        let w = Em("cornerRadius", n1, t, e, i);
        w && s1.push(w);
    }
    return s1;
}
function OM(n1, t, e, r, i) {
    let s1 = [];
    return n1.data.visible && s1.push(...KF(n1, t, e, i, r.shared)), n1 instanceof hr ? s1.push(...QF(n1, t, e, i, r.shared)) : (n1.data.visible && s1.push(...CR(n1, t, e, r)), n1 instanceof nr ? (n1 instanceof Ct && n1.data.visible && s1.push(...BF(n1, t, e, r)), n1.data.visible && s1.push(...UF(n1, t, e, r.shared))) : Of.is(n1) ? n1.data.visible && s1.push(...FF(n1, t, e, r.shared)) : n1 instanceof ir && s1.push(...NF(n1, t, e, r.shared))), s1.length ? {
        update: (o)=>{
            s1.forEach((a)=>a.update(o));
        },
        start: (o)=>{
            s1.forEach((a)=>a.start?.(o));
        },
        end: (o)=>{
            s1.forEach((a)=>a.end?.(o));
        }
    } : void 0;
}
function ZF(n1, t) {
    return {
        position (e) {
            Object.assign(n1.position, e), (e.x !== void 0 || e.y !== void 0 || e.z !== void 0) && (n1.updateMatrix(), n1.resetBBoxNeedsUpdate(), n1 instanceof Ct && n1.invalidateDownstreamBooleanData(), n1.dispatchEvent({
                type: "requestRender"
            }));
        },
        rotation (e) {
            let r = Object.keys(e)[0];
            n1.rotation[r] = e[r] * Se.DEG2RAD, (e.x !== void 0 || e.y !== void 0 || e.z !== void 0) && (n1.updateMatrix(), n1.resetBBoxNeedsUpdate(), n1 instanceof Ct && n1.invalidateDownstreamBooleanData(), n1.dispatchEvent({
                type: "requestRender"
            }));
        },
        scale (e) {
            Object.assign(n1.scale, e), (e.x !== void 0 || e.y !== void 0 || e.z !== void 0) && (n1.updateMatrix(), n1.resetBBoxNeedsUpdate(), n1 instanceof Ct && n1.invalidateDownstreamBooleanData(), n1.dispatchEvent({
                type: "requestRender"
            }));
        },
        shapeSize (e) {
            n1 instanceof Ct && (n1.userData.value = {
                ...n1.userData.value,
                ...e
            }, (e.x !== void 0 || e.y !== void 0 || e.z !== void 0) && (n1.updateGeometryInteractions({
                width: n1.userData.value.x,
                height: n1.userData.value.y,
                depth: n1.userData.value.z
            }, t.shared), n1.resetBBoxNeedsUpdate(), n1.invalidateDownstreamBooleanData(), n1.dispatchEvent({
                type: "requestRender"
            })));
        },
        material (e, r, i) {
            i && (Object.entries(i).forEach(([s1, { start: o, end: a, t: l }])=>{
                let c = r.getValue(s1);
                c !== void 0 && IM(s1, r, o, a, l, c, t.shared);
            }), n1.dispatchEvent({
                type: "requestRender"
            }));
        },
        opacity (e) {
            if (n1 instanceof nr && !Array.isArray(n1.material)) {
                let r = n1.material.getLayersOfType("light")[0];
                n1.material.transparent = !0, IM("alphaOverride", r, {
                    alphaOverride: e
                }, {
                    alphaOverride: e + 1
                }, 0, e, t.shared), n1.dispatchEvent({
                    type: "requestRender"
                });
            }
        },
        light (e, r) {
            (n1 instanceof Ho || n1 instanceof Xl || n1 instanceof Wo) && (n1[e] = r, n1.dispatchEvent({
                type: "requestRender"
            }));
        },
        cloner (e) {
            e.cloner?.update(t), e instanceof Ct && e.invalidateDownstreamBooleanData(), e.dispatchEvent({
                type: "requestRender"
            });
        },
        pathExtrusion (e, r) {
            e.geometry.userData.parameters.extrusion = {
                ...e.geometry.userData.parameters.extrusion,
                ...r
            }, e.updateGeometryInteractions({
                extrusion: {
                    ...e.geometry.userData.parameters.extrusion
                }
            }, t.shared), e.resetBBoxNeedsUpdate(), e.invalidateDownstreamBooleanData(), e.dispatchEvent({
                type: "requestRender"
            });
        },
        pathSnapping (e) {
            n1.userData.pathSnapping = {
                ...n1.userData.pathSnapping,
                ...e
            }, n1.updatePathSnapping(n1.userData.pathSnapping), n1.dispatchEvent({
                type: "requestRender"
            });
        }
    };
}
var JF = new E;
function sp(n1, t, e = !1) {
    let r = [], i = (s1)=>{
        let o = s1.data;
        delete s1.states, s1.currentState = null, s1.reversibleToState = null, s1.currentTransitionEvent = null;
        for (let a of o.states){
            let l = {
                ...a.data
            };
            s1.states || (s1.states = {}), s1.states[a.id] = Ga.patch(o, l);
        }
        eV(n1.scene, s1, null, t, o.events.find((a)=>a.data.type === "Follow" || a.data.type === "LookAt") !== void 0), $F(n1);
    };
    n1.scene.traverse2D(i), n1.traverseChildren((s1)=>{
        if (e && (s1.rigidBody?.setTranslation(s1.position0, !0), s1.rigidBody?.setRotation(s1.rotation0, !0), s1.rigidBody?.setLinvel(JF, !0), s1.rigidBody?.setAngvel(JF, !0)), !gt.is(s1)) return;
        let o = s1.uuid, a = s1.data;
        if (delete s1.states, s1.uuid === As) return;
        let l = !1;
        r.some((c)=>n1.scene.find(o)?.isDescendantOf(c)) ? l = !0 : a.physics?.fusedBody === !0 && a.physics.rigidBody === "dynamic" && r.push(o), s1.data = a, s1.currentState = null, s1.reversibleToState = null, s1.currentTransitionEvent = null;
        for (let c of a.states){
            let u1 = {
                ...c.data
            };
            n1.data.globalPhysics.usePhysics === !0 && a.physics && (a.physics.rigidBody === "dynamic" || l) && (c.data.position !== void 0 && delete u1.position, c.data.rotation !== void 0 && delete u1.rotation, c.data.hiddenMatrix !== void 0 && delete u1.hiddenMatrix), s1.states || (s1.states = {}), s1.states[c.id] = Qs.patch(a, u1);
        }
        eV(n1.scene, s1, null, t, a.events.find((c)=>c.data.type === "Follow" || c.data.type === "LookAt") !== void 0), s1 instanceof _r && s1.frame && (s1.frame.traverse((c)=>i(c)), s1.uiCanvas?.applySize());
    }), $F(n1), n1.frame && (n1.frame.traverse((s1)=>i(s1)), n1.uiCanvas?.applySize());
}
function $F(n1) {
    n1.traverseEntity((t)=>{
        for (let e of t.data.events){
            let r = [];
            switch(e.data.type){
                case "Follow":
                case "MouseHover":
                case "Scroll":
                case "MouseDown":
                case "MouseUp":
                case "MousePress":
                case "KeyUp":
                case "KeyDown":
                case "KeyPress":
                case "Collision":
                    r.push(...e.data.actions);
                    break;
                case "GameControl":
                    for (let i of Object.values(e.data.gameActions))r.push(...i);
                    break;
                case "DragDrop":
                    r.push(...e.data.dragDropActions.drag, ...e.data.dragDropActions.drop);
                    break;
                case "Conditional":
                    r.push(...e.data.inActions, ...e.data.outActions);
                    break;
            }
            for (let i of r)if (i.data.type === "Create" && i.data.hideBase === "Yes") {
                let s1 = n1.scene.find(i.data.object);
                s1 && (s1.visible = !1);
            }
        }
    });
}
function eV(n1, t, e, r, i = !1) {
    if (t instanceof Ct && !(t instanceof cs) && t.removeInteractionGeometry(r), t instanceof hr ? t.changeSelectedState(e, {
        shared: r
    }, i) : t.changeSelectedState(e, {
        scene: n1,
        shared: r
    }, i), t instanceof Ct && t.updateGeometryGroupsIfNeeded(), t instanceof ir && t.updateCameraState(t.dataPatched, {
        scene: n1,
        shared: r
    }), !(t instanceof hr)) {
        if (t.cloner) for (let s1 of t.cloner.children)s1.playModeVisible = void 0;
        t.updateVisible();
    }
}
function RM(n1) {
    let t;
    if (n1.easing === 5) {
        let { control1: e, control2: r } = n1;
        t = `cubicBezier(
			${e[0]}, ${e[1]}, ${r[0]}, ${r[1]}
		)`;
    } else if (n1.easing === 6) {
        let { mass: e, stiffness: r, damping: i, velocity: s1 } = n1;
        t = `spring( ${e}, ${r}, ${i}, ${s1} )`;
    } else {
        let e;
        switch(n1.easing){
            case 0:
                e = Na.linear;
                break;
            case 1:
                e = Na.ease;
                break;
            case 2:
                e = Na.easeIn;
                break;
            case 3:
                e = Na.easeOut;
                break;
            case 4:
                e = Na.easeInOut;
                break;
            default:
                e = Na.linear;
        }
        let [r, i, s1, o] = e;
        t = `cubicBezier( ${r}, ${i}, ${s1}, ${o} )`;
    }
    return {
        duration: Math.max(n1.duration, 1e-4),
        easing: t
    };
}
function Rg(n1) {
    let t = {
        delay: 0,
        loop: n1.repeat === -1 ? !0 : n1.repeat + 1
    };
    if (n1.repeat === 0) t.direction = "normal", t.rewind = !1;
    else switch(n1.direction){
        case "pingpong":
            t.direction = "alternate", t.rewind = !1;
            break;
        case "pingpong-rewind":
            t.direction = "alternate", t.rewind = !0;
            break;
        default:
            t.direction = "normal", t.rewind = !1;
            break;
    }
    switch(t.delay = 0, t.endDelay = 0, t.startOnceDelay = 0, t.pingPongDelayCorrection = 0, t.pingPongEndDelayCorrection = 0, n1.delayDirection){
        case "start-once":
            t.startOnceDelay = n1.delay;
            break;
        case "start":
            t.delay = n1.delay;
            break;
        case "end":
            t.endDelay = n1.delay;
            break;
        case "start-end":
        case void 0:
            t.delay = n1.delay, t.endDelay = n1.delay;
            break;
    }
    return t.direction === "alternate" && (t.delay /= 2, t.endDelay /= 2, n1.delayDirection === "start" ? (t.pingPongDelayCorrection = t.delay, typeof t.loop == "number" && t.loop % 2 === 0 && (t.pingPongEndDelayCorrection = t.delay)) : n1.delayDirection === "end" ? typeof t.loop == "number" && t.loop % 2 !== 0 && (t.pingPongEndDelayCorrection = t.endDelay) : n1.delayDirection === "start-end" && (t.pingPongDelayCorrection = t.delay, t.pingPongEndDelayCorrection = t.endDelay)), t;
}
var LM = {
    type: "beginState"
}, NM = {
    type: "completeState",
    isfromEntity: !1
}, op = class {
    constructor(t, e, r, i, s1, o, a){
        this.object = t;
        this.data = i;
        this.sharedAssets = s1;
        this.allowSlerp = o;
        this.page = a;
        this.targets = {
            t: 0
        };
        this.firstLoop = !0;
        this._changeBegan = !1;
        this._changeCompleted = !0;
        this.onChange = ()=>{
            this.callback && (this.callback.update(this.targets.t), this.object.requestRender()), this.targets.t === 0 || this.targets.t === 1 ? this._changeCompleted || (this._changeCompleted = !0, this._changeBegan = !1, this.onChangeComplete()) : (this._changeCompleted && (this._changeCompleted = !1), this._changeBegan || (this._changeBegan = !0, this.onChangeBegin()));
        };
        this.onChangeBegin = ()=>{
            this.object.reversibleToState = this.to.id;
            let t = this.targets.t > .5 ? this.from.id : this.to.id;
            this.object.prevState !== this.object.currentState && (this.object.prevState = this.object.currentState), this.object.currentState = t, this.object.dispatchEvent({
                type: "beginState",
                state: t
            }), this.object instanceof hr || this.object.traverseEntity((e)=>{
                e !== this.object && e instanceof ir && e.dispatchEvent(LM);
            });
        };
        this.onChangeComplete = ()=>{
            this.firstLoop && (this.onFirstLoop(), this.firstLoop = !1), this.object.reversibleToState = this.to.id;
            let t = this.targets.t < .5 ? this.from.id : this.to.id;
            this.object.prevState !== this.object.currentState && (this.object.prevState = this.object.currentState), this.object.currentState = t, this.object.dispatchEvent({
                type: "completeState",
                state: t
            }), this.object instanceof hr || this.object.traverseEntity((e)=>{
                e !== this.object && e instanceof ir && e.dispatchEvent(NM);
            });
        };
        this.onFirstLoop = ()=>{
            this.useCurrentState && (this.callback = OM(this.object, this.from.data, this.to.data, {
                scene: this.page.scene,
                shared: this.sharedAssets
            }, this.allowSlerp));
        };
        if (e === void 0) {
            let l = d1(this.object, this.object.currentState === r ? this.object.prevState : this.object.currentState);
            if (!l) throw new Error("Missing property");
            this.from = l;
        } else {
            let l = d1(this.object, e);
            if (!l) throw new Error("Missing property");
            this.from = l;
        }
        if (r === void 0) throw new Error("Missing property");
        {
            let l = d1(this.object, r);
            if (!l) throw new Error("Missing property");
            this.to = l;
        }
        this.useCurrentState = e === void 0 || r === void 0, this.params = {
            targets: this.targets,
            t: 1,
            autoplay: !1,
            ...Rg(i),
            ...RM(i),
            change: this.onChange
        }, this.callback = OM(this.object, e === void 0 ? {} : this.from.data, r === void 0 ? {} : this.to.data, {
            scene: this.page.scene,
            shared: this.sharedAssets
        }, this.allowSlerp);
    }
    get changeBegan() {
        return this._changeBegan;
    }
    get changeCompleted() {
        return this._changeCompleted;
    }
}, ap = class extends ar {
    constructor(e, r, i, s1, o){
        super();
        this.eventType = e;
        this.data = r;
        this.page = i;
        this.shared = s1;
        this.condition = o;
        this.toggleIsForward = !1;
        this.timelineNeedsRebuild = !1;
        this.hasPlayedOnce = !1;
        this.pauseOnNextLoopEnd = !1;
        this.onTimelineChangeComplete = ()=>{
            if (this.pauseOnNextLoopEnd) {
                this.pauseOnNextLoopEnd = !1, this.timeline?.pause();
                return;
            }
            this.data.tweens[0].data.direction !== "normal" && (this.toggleIsForward = !this.toggleIsForward), this.timelineNeedsRebuild !== !1 && (this.timeline?.pause(), this.buildTimeline({
                isForward: this.toggleIsForward,
                needsRebuild: !1,
                isRebuild: !0
            }), this.timeline.play());
        };
        if (!r.object) throw new Error("Missing property");
        let a = this.page.scene.find(r.object) ?? this.page.uiCanvas?.find(r.object) ?? this.page.scene.find2DInUIObjects(r.object);
        if (!a) throw new Error("Missing property");
        if (!a.states) throw new Error("Missing property");
        if (this.object = a, r.tweens.length < 2) throw new Error("Missing property");
        this.tweens = Array(this.data.tweens.length - 1), this.startOnceDelay = r.tweens[0].data.delayDirection === "start-once" ? r.tweens[0].data.delay : 0, this.init();
    }
    get playing() {
        return this.timeline?.paused === !1;
    }
    get changeBegan() {
        return this.tweens.some((e)=>e.changeBegan) ?? !1;
    }
    init() {
        this.initialCurrentState = d1(this.object, this.object.currentState).id, this.toggleIsForward = !1;
    }
    get currentState() {
        return this.data.runMode === "Toggle" && vm(this.eventType) ? this.initialCurrentState : this.object.currentState;
    }
    buildTimeline({ isForward: e = !0, needsRebuild: r = !1, isRebuild: i = !1 } = {}) {
        try {
            let s1 = Rg(this.data.tweens[0].data);
            i && typeof s1.loop == "number" && s1.loop--, this.timeline?.pause(), this.timeline = Ms.timeline({
                autoplay: !1,
                ...s1,
                ...s1.loop === !0 || s1.loop > 1 ? {
                    timelineChangeComplete: this.onTimelineChangeComplete
                } : {}
            });
            let o = this.tweens.findIndex((a)=>a?.changeBegan);
            if (r === !0 && (this.timelineNeedsRebuild = !0), e) {
                let a = o === -1 ? 0 : o;
                for(let l = a; l < this.data.tweens.length - 1; l++){
                    let c = this.data.tweens[l], u1 = this.data.tweens[l + 1], h;
                    l === a && (this.object.wasMovedByUser === !0 || this.object.previousAction?.changeBegan === !0) ? (h = void 0, this.object instanceof ir && (this.object.wasMovedByUser = !1)) : h = c.data.state === void 0 ? this.currentState : c.data.state;
                    let d = new op(this.object, h, u1.data.state === void 0 ? this.currentState : u1.data.state, u1.data, this.shared, this.data.allowSlerp ?? !1, this.page);
                    o !== -1 && l === a && Object.assign(d.params, {
                        startOnceDelay: 0
                    }), this.tweens[l] = d, this.timeline.add(d.params, this.timeline.duration + (l === a ? s1.delay : 0));
                }
                this.timeline.duration += s1.endDelay;
            } else {
                let a = o === -1 ? this.data.tweens.length - 1 : o + 1;
                for(let l = a; l > 0; l--){
                    let c = this.data.tweens[l], u1 = this.data.tweens[l - 1], h;
                    l === a && (this.object.wasMovedByUser === !0 || this.object.previousAction?.changeBegan === !0) ? (h = void 0, this.object instanceof ir && (this.object.wasMovedByUser = !1)) : h = c.data.state === void 0 ? this.currentState : c.data.state;
                    let d = new op(this.object, h, u1.data.state === void 0 ? this.currentState : u1.data.state, c.data, this.shared, this.data.allowSlerp ?? !1, this.page);
                    o !== -1 && l === a && Object.assign(d.params, {
                        startOnceDelay: 0
                    }), this.tweens[l - 1] = d, this.timeline.add(d.params, this.timeline.duration + (l === a ? s1.endDelay : 0));
                }
                this.timeline.duration += s1.delay;
            }
        } catch (s1) {
            s1 instanceof Error && console.error(s1.message);
        }
        this.object.previousAction?.playing === !0 && this.object.previousAction.pause(), this.object.previousAction = this;
    }
    play() {
        if (_t(this.shared, this.condition) === !1 || vm(this.eventType) && this.data.runMode === "Once" && this.hasPlayedOnce || (this.hasPlayedOnce = !0, this.playing)) return !1;
        this.startTimeout?.pause();
        let e = Rg(this.data.tweens[0].data).pingPongDelayCorrection;
        this.startTimeout = Ms({
            targets: {},
            duration: this.startOnceDelay + e,
            easing: "linear",
            complete: ()=>{
                this.startTimeout = void 0;
                try {
                    this.buildTimeline(), this.timeline.play();
                } catch (r) {
                    r instanceof Error && console.error(r.message);
                }
            }
        });
    }
    pause() {
        this.timeline?.pause(), this.startTimeout?.pause(), this.tweens = Array(this.data.tweens.length - 1), delete this.startTimeout;
    }
    stop() {
        this.pause();
        let e = this.data.tweens[0].data.state === void 0 ? this.initialCurrentState : this.data.tweens[0].data.state;
        this.object instanceof hr ? this.object.changeSelectedState(e, {
            shared: this.shared
        }) : this.object.changeSelectedState(e, {
            scene: this.page.scene,
            shared: this.shared
        }), this.object.currentState = e;
    }
    seek(e) {
        if (_t(this.shared, this.condition) === !1) return !1;
        this.timeline === void 0 && this.buildTimeline(), this.timeline?.seek(e * this.timeline.duration, !0);
    }
    toggle(e) {
        if (_t(this.shared, this.condition) === !1) return !1;
        this.startTimeout?.pause(), this.toggleIsForward = e ?? !this.toggleIsForward, this.playing ? (this.timeline?.pause(), this.buildTimeline({
            isForward: this.toggleIsForward,
            needsRebuild: !0
        }), this.pauseOnNextLoopEnd = !0, this.timeline.play()) : this.startTimeout = Ms({
            targets: {},
            duration: this.startOnceDelay,
            easing: "linear",
            complete: ()=>{
                this.startTimeout = void 0, this.timeline?.pause(), this.buildTimeline({
                    isForward: this.toggleIsForward
                }), this.timeline.play();
            }
        });
    }
    playFromCurrent() {
        this.toggle(!0);
    }
    reverseFromCurrent() {
        this.toggle(!1);
    }
    dispose() {
        this.pause();
    }
};
function d1(n1, t) {
    let e, r;
    if (typeof t == "string" ? (e = t, r = n1.states?.[e]) : t === null && (e = null, r = n1.data), !(e === void 0 || r === void 0)) return {
        id: e,
        data: r
    };
}
var Gee = {
    type: "beginState"
}, tV = {
    type: "completeState",
    isfromEntity: !1
}, rV = {
    type: "requestRender"
}, Lg = class extends ar {
    constructor(e, r, i, s1){
        super();
        this.data = e;
        this.page = r;
        this.shared = i;
        this.condition = s1;
        this.toggleIsForward = !1;
        this.posStart = new E;
        this.posEnd = new E;
        this.qStart = new Ye;
        this.qEnd = new Ye;
        this.zoomStart = 1;
        this.zoomEnd = 1;
    }
    init() {}
    get playing() {
        return this.animation && this.animation.began && !this.animation.completed;
    }
    buildAnimation(e = !1) {
        if (!this.data.animate) return;
        let r = this.page.scene.find(this.data.targetCamera);
        if (!r || !r.visible) throw new ReferenceError("Target camera not founded or not visible");
        let i = {
            t: 0
        };
        this.posStart.copy(this.page.activeCamera.position), this.qStart.copy(this.page.activeCamera.quaternion), this.zoomStart = this.page.activeCamera.zoom, this.animation = Ms({
            targets: i,
            t: 1,
            ...RM(this.data),
            update: ()=>{
                i.t === 0 && (this.data.runMode === "Toggle" && !this.toggleIsForward ? this.fromCamera && (this.posEnd.copy(this.fromCamera.position), this.qEnd.copy(this.fromCamera.quaternion), this.zoomEnd = this.fromCamera.zoom, this.switchCamera(this.fromCamera.uuid)) : (this.posEnd.copy(r.position), this.qEnd.copy(r.quaternion), this.zoomEnd = r.zoom, this.fromCamera = this.page.activeCamera, this.switchCamera(r.uuid)), this.page.activeCamera.dispatchEvent(Gee));
                let s1 = this.page.activeCamera;
                s1.position.lerpVectors(this.posStart, this.posEnd, i.t), s1.quaternion.slerpQuaternions(this.qStart, this.qEnd, i.t), s1.zoom = this.zoomStart + (this.zoomEnd - this.zoomStart) * i.t, s1.wasMovedBySwitchCameraAction = !0, s1.updateMatrix(), s1.updateMatrixWorld(), s1.updateProjectionMatrix(), s1.dispatchEvent(rV), i.t === 1 && s1.dispatchEvent(tV);
            }
        });
    }
    switchCamera(e) {
        let r = this.page.activeCamera, i = this.page.scene.find(e);
        if (!i || !i.visible) throw new ReferenceError("Target camera not founded or not visible");
        this.page.switchActiveCamera(i), r.dispatchEvent({
            type: "cameraChange",
            camera: i
        });
    }
    play() {
        if (_t(this.shared, this.condition) === !1) return !1;
        if (!this.playing && this.page.activeCamera.uuid !== this.data.targetCamera) try {
            clearTimeout(this.timeoutId), this.timeoutId = window.setTimeout(()=>{
                delete this.timeoutId, this.data.animate ? (this.buildAnimation(), this.animation?.play()) : this.switchCamera(this.data.targetCamera);
            }, this.data.delay * 1e3);
        } catch  {}
    }
    pause() {
        this.animation?.pause(), clearTimeout(this.timeoutId), delete this.timeoutId;
    }
    toggle(e) {
        if (_t(this.shared, this.condition) === !1) return !1;
        if (window.clearTimeout(this.timeoutId), delete this.timeoutId, e !== this.toggleIsForward) try {
            this.playing ? (this.animation?.pause(), this.toggleIsForward = e ?? !this.toggleIsForward, this.buildAnimation(!0), this.animation?.play()) : this.timeoutId = window.setTimeout(()=>{
                this.toggleIsForward = e ?? !this.toggleIsForward, this.data.animate ? (this.animation?.pause(), this.buildAnimation(), this.animation?.play()) : (this.toggleIsForward ? (this.fromCamera = this.page.activeCamera, this.switchCamera(this.data.targetCamera)) : this.fromCamera && this.switchCamera(this.fromCamera.uuid), this.page.activeCamera.dispatchEvent(tV), this.page.activeCamera.dispatchEvent(rV));
            }, this.data.delay * 1e3);
        } catch  {}
    }
    playFromCurrent() {
        this.toggle(!0);
    }
    reverseFromCurrent() {
        this.toggle(!1);
    }
    dispose() {
        this.pause(), this.toggleIsForward = !1;
    }
};
var Ng = class extends ar {
    constructor(e, r, i, s1, o){
        super();
        this.id = e;
        this.data = r;
        this.scene = i;
        this.sharedAssets = s1;
        this.eventType = o;
        this.toggleIsForward = !1;
        this._finished = !1;
        this.hasPlayedOnce = !1;
        this._shouldForwardLoop = !1;
        this._shouldPauseOnNextLoopComplete = !1;
        this._onLoopComplete = ()=>{
            this._shouldPauseOnNextLoopComplete && (this.timeline.pause(), this._shouldPauseOnNextLoopComplete = !1);
        };
        try {
            let a = Rg(this.data);
            typeof a.loop == "number" && a.loop--, this.timeline = Ms.timeline({
                ...a,
                autoplay: !1
            }), this._shouldForwardLoop = a.loop === !0 || typeof a.loop == "number" && a.loop > 1;
            let l = this.sharedAssets.data.timelineAnimations[this.data.timeline].mapping;
            Object.entries(l).forEach(([c, u1])=>{
                let h = this.scene.find(c);
                if (!h) return;
                let d = h.data.timelineAnimations[u1];
                if (!d) return;
                let f = tx.addKeyframesToTimeline(h, {
                    ...d
                }, ZF(h, {
                    scene: i,
                    shared: s1
                }), this.sharedAssets), m = (this.data.delayDirection === "start" ? this.data.delay : 0) + (this.data.delayDirection === "start-end" ? this.data.delay : 0) + (this.data.delayDirection === "start-once" ? this.data.delay : 0);
                f.forEach((p)=>{
                    this.timeline.add(p, m);
                }), this.timeline.duration = d.to * 1e3 + m;
            }), this.timeline.delay = 0, this.timeline.duration += (this.data.delayDirection === "start" ? this.data.delay : 0) + (this.data.delayDirection === "end" ? this.data.delay : 0) + (this.data.delayDirection === "start-end" ? this.data.delay * 2 : 0) + (this.data.delayDirection === "start-once" ? this.data.delay * 2 : 0), this.timeline.finished.then(()=>{
                Object.keys(l).forEach((c)=>{
                    let u1 = this.scene.find(c);
                    u1 instanceof ir && u1.dispatchEvent(NM);
                }), this._finished = !0;
            }), this.timeline.loopComplete = this._onLoopComplete;
        } catch (a) {
            throw new Error("Missing property");
        }
    }
    get playing() {
        return this.timeline.paused === !1;
    }
    get finished() {
        return this._finished;
    }
    get paused() {
        return this.timeline.paused;
    }
    play() {
        if (this.eventType !== void 0 && vm(this.eventType) && this.data.runMode === "Once" && this.hasPlayedOnce || this.eventType === void 0 && this._finished) return !1;
        this.hasPlayedOnce = !0;
        let e = this.sharedAssets.data.timelineAnimations[this.data.timeline].mapping;
        Object.keys(e).forEach((r)=>{
            let i = this.scene.find(r);
            i instanceof ir && i.dispatchEvent(LM);
        }), this.timeline.restart();
    }
    pause() {
        this.timeline.pause();
    }
    stop() {
        this.pause(), this.seek(0), this.timeline.reset(), this._finished = !1;
    }
    seek(e) {
        this.timeline.seek(e * this.timeline.duration, !0);
    }
    toggle(e) {
        if (this.toggleIsForward = e ?? !this.toggleIsForward, this.playing) {
            if (!this.toggleIsForward && this.timeline.reversed && this._shouldForwardLoop && this.timeline.remaining % 2 === 1) {
                this._shouldPauseOnNextLoopComplete = !0;
                return;
            }
            this.timeline.reverse(this.timeline.duration - this.timeline.currentTime), this._shouldForwardLoop && this.timeline.loop && this.timeline.reversed && (this._shouldPauseOnNextLoopComplete = !0);
        } else (!this.toggleIsForward !== this.timeline.reversed || !this.toggleIsForward && this.timeline.reversed && this.timeline.direction === "alternate") && this.timeline.reverse(), typeof this.timeline.loop == "number" && typeof this.timeline.remaining == "number" && this.timeline.remaining < this.timeline.loop && this.toggleIsForward && (this.timeline.remaining = this.timeline.loop), this.timeline.play();
    }
    playFromCurrent() {
        this.toggle(!0);
    }
    reverseFromCurrent() {
        this.toggle(!1);
    }
    dispose() {
        this.pause();
    }
};
function BM(n1) {
    let t = n1?.tracks.filter((e)=>e.ValueTypeName === "vector" || e.ValueTypeName === "quaternion").map((e)=>e.times.length);
    if (t?.length) {
        let e = $w(t);
        return e && e > 2 ? e : 2;
    }
    return 2;
}
var Bg = class extends ar {
    constructor(e, r, i, s1, o){
        super();
        this.data = e;
        this.page = r;
        this.animationControls = i;
        this.shared = s1;
        this.condition = o;
        this.startOnceDelay = 0;
        this.toggleIsForward = !1;
        let a = e.object, l = r.scene.find(e.object);
        l && Array.isArray(l.identity) && (a = l.identity[0]), this.data = {
            ...e,
            object: a
        };
        let c = this.animationControls.clipIdToAction[e.clipId + "/" + a];
        if (this.duration = c?.getClip()?.duration ?? 1, this.data.crop2) {
            let u1 = BM(c?.getClip());
            this.leftFrameTime = this.data.crop2[0] / (u1 - 1) * this.duration, this.rightFrameTime = this.data.crop2[1] / (u1 - 1) * this.duration;
        } else {
            let u1 = c?.getClip()?.tracks[0]?.times.length;
            u1 && u1 > 1 ? (this.leftFrameTime = this.data.crop[0] / u1 * this.duration, this.rightFrameTime = this.data.crop[1] / u1 * this.duration) : (this.leftFrameTime = 0, this.rightFrameTime = this.duration);
        }
        this.startOnceDelay = e.delay;
    }
    get playing() {
        return this.threeAnimAction?.isRunning() ?? !1;
    }
    play(e = !1) {
        if (_t(this.shared, this.condition) === !1) return !1;
        window.clearTimeout(this.timeoutId), this.timeoutId = window.setTimeout(()=>{
            if (this.threeAnimAction = this.animationControls.play(this.data), !this.threeAnimAction) return;
            this.threeAnimAction.reset(), this.threeAnimAction.time = this.leftFrameTime, this.threeAnimAction._clip.start = this.leftFrameTime, this.threeAnimAction._clip.duration = this.rightFrameTime;
            let r = this.data.object;
            Object.entries(this.animationControls.clipIdToAction).forEach(([i, s1])=>{
                let o = i.split("/")[1];
                this.threeAnimAction !== s1 && o === r && (e ? s1.fadeOut(.2) : s1.stop());
            }), e && this.threeAnimAction?.fadeIn(.2);
        }, this.startOnceDelay);
    }
    pause() {
        this.threeAnimAction && (this.threeAnimAction.paused = !0), window.clearTimeout(this.timeoutId), delete this.timeoutId;
    }
    stop() {
        this.threeAnimAction?.fadeOut(.2);
    }
    seek(e) {
        this.threeAnimAction = this.animationControls.play(this.data), this.threeAnimAction && (this.threeAnimAction.paused = !0, this.threeAnimAction.time = Se.clamp(this.threeAnimAction.time + 1 / 60 * e, this.leftFrameTime, this.rightFrameTime - 16e-5), this.animationControls.needsUpdate = !0, this.animationControls.requestRender());
    }
    toggle(e, r = !1) {
        if (_t(this.shared, this.condition) === !1) return !1;
        this.toggleIsForward = e ?? !this.toggleIsForward, this.threeAnimAction && (this.threeAnimAction._loopCount = 0), this.playing ? this.threeAnimAction && (this.threeAnimAction.timeScale = this.toggleIsForward ? 1 : -1, this.toggleIsForward ? (this.threeAnimAction._clip.start = this.leftFrameTime, this.threeAnimAction._clip.duration = this.rightFrameTime) : (this.threeAnimAction._clip.start = this.rightFrameTime, this.threeAnimAction._clip.duration = this.leftFrameTime)) : this.timeoutId = window.setTimeout(()=>{
            if (this.threeAnimAction = this.animationControls.play(this.data), this.threeAnimAction) {
                this.toggleIsForward ? (this.threeAnimAction.time = this.leftFrameTime, this.threeAnimAction._clip.start = this.leftFrameTime, this.threeAnimAction._clip.duration = this.rightFrameTime) : (this.threeAnimAction.time = this.rightFrameTime, this.threeAnimAction._clip.start = this.rightFrameTime, this.threeAnimAction._clip.duration = this.leftFrameTime), this.threeAnimAction.paused = !1, this.threeAnimAction.timeScale = this.toggleIsForward ? 1 : -1;
                let i = this.data.clipId.split("/")[1];
                Object.entries(this.animationControls.clipIdToAction).forEach(([s1, o])=>{
                    let a = s1.split("/")[1];
                    this.threeAnimAction !== o && a === i && o.isRunning() && (r ? o.fadeOut(.2) : o.stop());
                }), r && this.threeAnimAction?.fadeIn(.2);
            }
        }, this.startOnceDelay);
    }
    playFromCurrent() {
        this.toggle(!0);
    }
    reverseFromCurrent() {
        this.toggle(!1);
    }
    dispose() {
        let e = this.animationControls.clipIdToAction[this.data.clipId + "/" + this.data.object]?.getClip();
        e && (e.duration = this.duration), this.pause();
    }
};
var Fg = class {
    constructor(t, e, r, i, s1){
        this.data = t;
        this.page = e;
        this.eventManager = r;
        this.shared = i;
        this.condition = s1;
        this.timeOutId = -1;
        this.scene = e.scene;
    }
    dispatch() {
        if (_t(this.shared, this.condition) === !1) return !1;
        this.data.target !== this.page.uuid && (window.clearTimeout(this.timeOutId), this.timeOutId = window.setTimeout(()=>{
            this.play();
        }, this.data.delay * 1e3));
    }
    dispose() {
        window.clearTimeout(this.timeOutId);
    }
    play() {
        if (this.scene.children.every((r)=>r.uuid !== this.data.target || r.data.uiScene)) return;
        this.data.transition === "fade" && this.data.duration > 0 && this.eventManager.eventContext.renderer.renderFromSceneForSceneTransitionPass(this.scene, this.scene.activeCamera, this.data.duration * 1e3), this.eventManager.deactivate(), this.eventManager.controlsManager.deactivate();
        let t = this.scene.activeCamera;
        this.scene.updatePage(this.data.target), this.scene.traverseVisibleEntity((r)=>{
            r.type === "ParticleSystem" && (r.sleep(), r.wakeUp(), r.data.autoPlay ? r.start() : r.stop());
        }), this.scene.activePage.switchToPlayCamera(), this.scene.activeCamera.copyViewPlaneSize(t), sp(this.scene.activePage, this.shared), this.eventManager.activate(), this.eventManager.controlsManager.activate(this.eventManager);
    }
};
var Vg = class {
    constructor(t, e, r, i){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.condition = i;
        this.evaluatedCondition = !1;
    }
    checkConditions() {
        this.evaluatedCondition = _t(this.shared, this.condition);
    }
    dispatch() {
        if (this.evaluatedCondition === !1) return !1;
        let t = this.shared.getVariable(this.data.variableId), e = Ix(this.data.expression, this.shared, Gr.typeOfVariable(t));
        e !== void 0 && this.shared.updateVariable(this.data.variableId, typeof e == "string" ? {
            textValue: e
        } : e);
    }
    dispose() {}
};
var Ug = class {
    constructor(t, e, r, i){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.condition = i;
        this.timeoutId = null;
    }
    dispatchInner() {
        if (_t(this.shared, this.condition) === !1) return !1;
        let t = this.shared.getDynamicVariablePlayState(this.data.variableId);
        if (this.data.mode === "PlayPause") this.shared.getDynamicVariableToggleIsForward(this.data.variableId) === void 0 && this.shared.setDynamicVariableToggleIsForward(this.data.variableId, !0), this.shared.setDynamicVariablePlayState(this.data.variableId, t === "Playing" ? "Paused" : "Playing");
        else if (this.data.mode === "Play" && t !== "Playing") this.shared.getDynamicVariableToggleIsForward(this.data.variableId) === void 0 && this.shared.setDynamicVariableToggleIsForward(this.data.variableId, !0), this.shared.setDynamicVariablePlayState(this.data.variableId, "Playing");
        else if (this.data.mode === "Stop" && t !== "Stopped") this.shared.setDynamicVariablePlayState(this.data.variableId, "Stopped");
        else if (this.data.mode === "Pause" && t !== "Paused") this.shared.setDynamicVariablePlayState(this.data.variableId, "Paused");
        else if (this.data.mode === "Restart") this.shared.setDynamicVariablePlayState(this.data.variableId, "Restarted");
        else if (this.data.mode === "Toggle") {
            let e = this.shared.getDynamicVariableToggleIsForward(this.data.variableId);
            t === "Playing" ? this.shared.setDynamicVariableToggleIsForward(this.data.variableId, e === void 0 ? !1 : !e) : (this.shared.setDynamicVariableToggleIsForward(this.data.variableId, !e), this.shared.setDynamicVariablePlayState(this.data.variableId, "Playing"));
        }
    }
    dispatch() {
        let t = this.data.delay, e = this.shared.getDynamicVariablePlayState(this.data.variableId);
        this.data.mode === "PlayPause" && e === "Playing" && (t = this.data.pauseDelay), t !== 0 ? (this.timeoutId && window.clearTimeout(this.timeoutId), this.timeoutId = window.setTimeout(()=>{
            this.timeoutId = null, this.dispatchInner();
        }, t)) : this.dispatchInner();
    }
    dispose() {
        this.timeoutId && window.clearTimeout(this.timeoutId);
    }
};
var f1 = class {
    constructor(t, e, r, i){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.condition = i;
    }
    dispatch() {
        if (_t(this.shared, this.condition) === !1) return !1;
        (this.data.target === "single" ? this.data.variableId ? [
            this.data.variableId
        ] : [] : Object.keys(this.shared.getVariables())).forEach((e)=>{
            this.shared.getVariable(e);
            let r = this.shared.data.variables.data(e)?.value;
            r !== void 0 && this.shared.updateVariable(e, r), this.shared.enableLocalStorageForPersistentVariables && localStorage.removeItem(sb(e));
        });
    }
    dispose() {}
};
var p1 = class {
    constructor(t, e, r, i){
        this.data = t;
        this.page = e;
        this.shared = r;
        this.condition = i;
    }
    dispatch() {
        if (_t(this.shared, this.condition) === !1) return !1;
        if (this.data.userAPIId) {
            let t = this.shared.getUserAPI(this.data.userAPIId);
            t && "callUserAPI" in t && t.callUserAPI(this.shared);
        }
    }
    dispose() {}
};
function _t(n1, t) {
    if (t === void 0) return !0;
    if (t.expression.length === 0) return !1;
    let e = Ix(t.expression, n1, "boolean");
    return t.negate ? !e : !!e;
}
function Wt(n1, t, e, r, i, s1) {
    let o = {
        Audio: [],
        Video: [],
        Particles: [],
        Link: [],
        Destroy: [],
        Create: [],
        Reset: [],
        Transition: [],
        TimelineAnimation: [],
        SwitchCamera: [],
        Animation: [],
        SceneTransition: [],
        SetVariable: [],
        DynamicVariablePlay: [],
        ClearLocalStorage: [],
        UserAPI: []
    }, a = (l)=>({ id: c, data: u1 })=>{
            try {
                u1.type === "Audio" ? Wi[n1.type].includes("Audio") && o.Audio.push(new _g(c, u1, s1, r, l)) : u1.type === "Video" && !(s1 instanceof hr) ? Wi[n1.type].includes("Video") && o.Video.push(new kg(c, u1, s1, r, l)) : u1.type === "Particles" ? Wi[n1.type].includes("Particles") && o.Particles.push(new Ig(u1, e, r, l)) : u1.type === "Link" ? Wi[n1.type].includes("Link") && o.Link.push(new h1(u1, i.controlsManager, r, l)) : u1.type === "Create" ? Wi[n1.type].includes("Create") && o.Create.push(new zg(u1, e, i.controlsManager, r, l)) : u1.type === "Destroy" ? Wi[n1.type].includes("Destroy") && o.Destroy.push(new Dg(u1, e, i.controlsManager, r, l)) : u1.type === "Reset" ? Wi[n1.type].includes("Reset") && o.Reset.push(new Og(u1, e, r, i, l)) : u1.type === "Transition" ? Wi[n1.type].includes("Transition") && o.Transition.push(new ap(n1.type, u1, e, r, l)) : u1.type === "SwitchCamera" ? Wi[n1.type].includes("SwitchCamera") && o.SwitchCamera.push(new Lg(u1, e, r, l)) : u1.type === "SceneTransition" ? Wi[n1.type].includes("SceneTransition") && o.SceneTransition.push(new Fg(u1, e, i, r, l)) : u1.type === "Animation" ? Wi[n1.type].includes("Animation") && o.Animation.push(new Bg(u1, e, i.animationControls, r, l)) : u1.type === "SetVariable" ? Wi[n1.type].includes("SetVariable") && o.SetVariable.push(new Vg(u1, e, r, l)) : u1.type === "DynamicVariablePlay" ? Wi[n1.type].includes("DynamicVariablePlay") && o.DynamicVariablePlay.push(new Ug(u1, e, r, l)) : u1.type === "Conditional" ? Wi[n1.type].includes("Conditional") && (u1.ifActions.forEach(a({
                    expression: u1.condition,
                    negate: !1
                })), u1.elseActions.forEach(a({
                    expression: u1.condition,
                    negate: !0
                }))) : u1.type === "ClearLocalStorage" ? Wi[n1.type].includes("ClearLocalStorage") && o.ClearLocalStorage.push(new f1(u1, e, r, l)) : u1.type === "UserAPI" ? Wi[n1.type].includes("UserAPI") && o.UserAPI.push(new p1(u1, e, r, l)) : u1.type === "TimelineAnimation" && Wi[n1.type].includes("TimelineAnimation") && o.TimelineAnimation.push(new Ng(c, u1, e.scene, r, n1.type));
            } catch (h) {}
        };
    return t.forEach(a()), o;
}
function vr(n1) {
    Object.values(n1).forEach((t)=>{
        t.forEach((e)=>{
            (e instanceof _g || e instanceof kg || e instanceof ap || e instanceof Ng || e instanceof Ig || e instanceof Bg || e instanceof ap || e instanceof zg || e instanceof Dg || e instanceof Lg || e instanceof Fg || e instanceof Og || e instanceof Vg || e instanceof Ug) && e.dispose();
        });
    });
}
function iV(n1, t) {
    let e;
    if ("material" in n1) {
        let r = n1.material;
        Array.isArray(r) ? e = n1.material[0].layers.find((i)=>i.uuid === t) : e = n1.material.layers.find((i)=>i.uuid === t);
    }
    if (!!e) return e.color.texture.image.img instanceof HTMLVideoElement ? e.color.texture.image.img : void 0;
}
var nV = new Map, Gg = new Map, po = class {
    constructor(t, e, r){
        this.data = e;
        this.delay = 0;
        this.status = "stopped";
        let { layerId: i, loop: s1, volume: o, delay: a } = e;
        if (this.object = r, i === void 0) throw new Error("Missing property");
        let l = iV(r, i);
        l && (this.videoElement = l, this.videoElement.loop = s1 === 1 / 0, bs && (this.videoElement.autoplay = !0), o !== void 0 && (this.videoElement.volume = o)), a !== void 0 && (this.delay = a), Gg.has(r.uuid) ? Gg.get(r.uuid).push(this) : Gg.set(r.uuid, [
            this
        ]), nV.set(t, this), this.pause();
    }
    mute() {
        !this.videoElement || (this.videoElement.muted = !0);
    }
    unMute() {
        !this.videoElement || (this.videoElement.muted = !1);
    }
    play(t) {
        if (!this.videoElement) return;
        let e = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        t ? (this.mute(), this.delay += 150) : e ? (this.mute(), window.setTimeout(()=>{
            this.unMute();
        }, 100)) : this.unMute(), this.delayTimerId = window.setTimeout(()=>{
            if (!this.videoElement) return;
            let r = this.videoElement.play();
            r !== void 0 && r.then((i)=>{}).catch((i)=>{
                this.play();
            }), this.clearDelay();
        }, this.delay), this.status = "playing";
    }
    clearDelay() {
        this.delayTimerId && (clearTimeout(this.delayTimerId), delete this.delayTimerId);
    }
    pause() {
        !this.videoElement || (this.videoElement.pause(), this.status = "paused");
    }
    stop() {
        !this.videoElement || (this.videoElement.pause(), this.videoElement.currentTime = 0, this.status = "stopped", this.clearDelay());
    }
    seek(t) {
        return new Promise((e)=>{
            if (!this.videoElement) return e();
            let r = this.videoElement.duration;
            if (r > 0) {
                let i = t % r;
                this.videoElement.currentTime = i;
            }
            this.videoElement.addEventListener("seeked", ()=>e(), {
                once: !0
            });
        });
    }
    playByToggle() {
        this.data.toggle === "stop" ? this.status === "playing" ? this.stop() : (this.stop(), this.play()) : this.data.toggle === "pause" ? this.status === "playing" ? this.pause() : this.play() : (this.stop(), this.play());
    }
    dispose() {
        !this.videoElement || (this.stop(), this.videoElement.muted = !0);
    }
}, lp = class {
    constructor(t){
        this.data = t;
    }
    dispatch() {
        this.data.playVideo ? this.pauseVideo(this.data.playVideo) : this.data.object ? this.pauseAllVideosFromObject(this.data.object) : this.pauseAllVideos();
    }
    pauseVideo(t) {
        let e = nV.get(t);
        !e || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e[this.data.interaction](), this.disposeDelay();
        }, this.data.delay)) : e[this.data.interaction]());
    }
    pauseAllVideosFromObject(t) {
        let e = Gg.get(t);
        !e?.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e.forEach((r)=>r[this.data.interaction]()), this.disposeDelay();
        }, this.data.delay)) : e.forEach((r)=>r[this.data.interaction]()));
    }
    pauseAllVideos() {
        let t = [
            ...Gg.values()
        ];
        !t.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            t.forEach((e)=>{
                e.forEach((r)=>{
                    r[this.data.interaction]();
                });
            }), this.disposeDelay();
        }, this.data.delay)) : t.forEach((e)=>{
            e.forEach((r)=>{
                r[this.data.interaction]();
            });
        }));
    }
    disposeDelay() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
    dispose() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
}, kg = class {
    constructor(t, e, r, i, s1){
        this.data = e;
        this.shared = i;
        this.condition = s1;
        if (e.interaction === "play") this.interaction = new po(t, e, r);
        else if (e.interaction === "pause" || e.interaction === "stop") this.interaction = new lp(e);
        else throw new Error("Missing property");
    }
    dispatchBasic() {
        if (_t(this.shared, this.condition) === !1) return !1;
        this.interaction instanceof po ? this.interaction.playByToggle() : this.interaction.dispatch();
    }
    dispatchConditional() {
        if (_t(this.shared, this.condition) === !1) return !1;
        this.interaction instanceof po ? this.interaction.play() : this.interaction.dispatch();
    }
    dispose() {
        this.interaction.dispose();
    }
};
var sV = (()=>{
    let n1, t, e, r;
    function i(a) {
        !n1 && !oV() && t?.sharedGameControlGlobals.createdObjects.length > 0 && (n1 = requestAnimationFrame(s1)), a && (t = a, r = a.requestRender);
    }
    function s1(a) {
        let l = e ? a - e : 0, c = t.sharedGameControlGlobals.createdObjects, u1 = t.sharedGameControlGlobals.nCreatedPerAction, h = c.length, d = 0;
        for(; d < h;){
            let f = c[d];
            f.userData.createdTime === void 0 && (f.userData.createdTime = a), f.userData.lifetime === void 0 && f.userData.quantity === void 0 || f.userData.lifetime && a - f.userData.createdTime < f.userData.lifetime || f.userData.quantity && u1[f.userData.actionId] <= f.userData.quantity ? (f.userData.velocity && (f.position.addScaledVector(f.userData.velocity, l / 1e3), f.updateMatrix(), r()), d++) : (u1[f.userData.actionId] > f.userData.quantity && u1[f.userData.actionId]--, c.splice(d, 1), f.removeFromParent(), t.sharedGameControlGlobals.rapierWorld && f.rigidBody ? (t.sharedGameControlGlobals.colliderToEntity.delete(f.rigidBody.collider(0).handle), t.sharedGameControlGlobals.rapierWorld.removeRigidBody(f.rigidBody)) : (f.bvhGeometry = void 0, t.sharedGameControlGlobals.entitiesWithTransformAnim = t.sharedGameControlGlobals.entitiesWithTransformAnim.filter((m)=>m.bvhGeometry !== void 0)), h--, r());
        }
        n1 = d > 0 ? requestAnimationFrame(s1) : void 0, e = d > 0 ? a : void 0;
    }
    function o() {
        oV() ? n1 && (cancelAnimationFrame(n1), n1 = void 0, e = void 0) : i();
    }
    return typeof document < "u" && document.addEventListener("visibilitychange", o), i;
})();
function oV() {
    return !!document && document.hidden;
}
var aV = new Ye, jee = new E, Hee = new E, zg = class {
    constructor(t, e, r, i, s1){
        this.data = t;
        this.page = e;
        this.controlsManager = r;
        this.shared = i;
        this.condition = s1;
        this.intervalId = null;
        this.timeoutIdQueue = [];
        this.uniqueId = Se.generateUUID();
        this.dispatch = ()=>{
            if (_t(this.shared, this.condition) === !1) return !1;
            this.data.delay ? this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3)) : this.dispatchInner();
        };
        this.dispatchFromStart = ()=>{
            if (_t(this.shared, this.condition) === !1) return !1;
            this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3));
        };
        this.dispatchThrottled = eA(this.dispatch, 1e3 / this.data.creationSpeed);
        this.dispatchStart = ()=>{
            this.intervalId === null && (this.intervalId = window.setInterval(this.dispatch, 1e3 / this.data.creationSpeed));
        };
        this.dispatchStop = ()=>{
            this.intervalId !== null && (window.clearInterval(this.intervalId), this.intervalId = null);
        };
        this.dispatchInner = ()=>{
            this.timeoutIdQueue.shift();
            let t = new Lr(this.object);
            if (t.playModeVisible = !0, t.expand(), this.data.coordinateSystem !== "world") {
                let r = this.data.coordinateSystem, i = this.page.scene.find(r);
                i && (i.updateMatrixWorldSVD(), t.hiddenMatrix.copy(i.matrixWorldRigid));
            }
            t.scale.copy(this.object.scale), t.position.fromArray(this.data.position.map((r)=>typeof r == "number" ? r : 0)), t.rotation.fromArray(this.data.rotation.map((r)=>typeof r == "number" ? r : 0)), t.updateMatrix(), this.page.add(t);
            let e = this.controlsManager.sharedGameControlGlobals;
            e.createdObjects.push(t), e.nCreatedPerAction[this.uniqueId] === void 0 ? e.nCreatedPerAction[this.uniqueId] = 1 : e.nCreatedPerAction[this.uniqueId]++, t.updateWorldMatrix(!0, !0), t.traverseObject(this.traverseObjectCB), sV(), this.controlsManager.requestRender();
        };
        this.traverseObjectCB = (t)=>{
            t.hasNonUniformScale && t.updateMatrixWorldSVD();
            let e;
            if (this.controlsManager.sharedGameControlGlobals.rapierWorld) {
                if (t instanceof Ai) {
                    if (t.objectForSample) {
                        if (t.objectForSample.dataPatched.physics.fusedBody) return;
                        e = t.object;
                    } else return t.object.dataPatched.physics.fusedBody === !0 && t.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                } else if (t instanceof Lr) e = t.object;
                else if (e = t, e.dataPatched.cloner?.hideBase) return !0;
            } else {
                if (t instanceof Ai) return;
                t instanceof Lr ? e = t.object : e = t;
            }
            this.data.destroy === "Time" ? t.userData.lifetime = this.data.lifetime * 1e3 : this.data.destroy === "Quantity" && (t.userData.quantity = this.data.destroyAfterQuantity, t.userData.actionId = this.uniqueId);
            let r = new E().fromArray(this.data.velocity.map((s1)=>typeof s1 == "number" ? s1 : 0)), i = e.dataPatched;
            if (!(i.physics.enabled === "visibility" ? !i.visible : !i.physics.enabled) && (this.controlsManager.sharedGameControlGlobals.rapierWorld ? (this.controlsManager.addRigidBody(t, e, {
                fromCreate: !0,
                dynamic: this.data.dynamic
            }), this.data.destroy === "Collision" && (t.rigidBody?.collider(0).setActiveEvents(1), t.userData.hasCollisionDestroy = !0), t.matrixWorld.decompose(jee, aV, Hee), r.applyQuaternion(aV), this.data.velocity.some((s1)=>s1 !== 0) && this.data.dynamic && t.rigidBody?.setLinvel(r.divideScalar(this.controlsManager.pixelsPerMeter), !0)) : ("geometry" in t.object && this.controlsManager.addBoundsTree(t), this.data.velocity.some((s1)=>s1 !== 0) && this.data.dynamic && (t.userData.velocity = r)), e.dataPatched.physics?.fusedBody === !0)) return !0;
        };
        let o = this.page.scene.find(this.data.object);
        if (!o) throw new Error("Missing Property");
        if (this.object = o, this.data.coordinateSystem !== "world" && !this.page.scene.find(this.data.coordinateSystem)) throw new Error("Missing Property");
        sV(r);
    }
    dispose() {
        this.intervalId !== null && (window.clearInterval(this.intervalId), this.intervalId = null), this.timeoutIdQueue.forEach((t)=>window.clearTimeout(t)), this.dispatchThrottled.cancel(), this.page.remove(...this.controlsManager.sharedGameControlGlobals.createdObjects), this.controlsManager.sharedGameControlGlobals.createdObjects = [];
    }
};
var kM = 200, FM = .02, VM = .3, Wee = 65, lV = new E, cV = new E, qee = new E, On = new E, Yn = new E, wc = new E, UM = new ue, uV = new ue, Xee = new ue, mo = new Ye, sl = new Ye, fa = new Jt(0, 0, 0, "YXZ"), Yee = new E(1, 0, 0), go = new E(0, 1, 0), Kee = new E(0, 0, 1), hV = new E(1, 1, 1), Qee = 1, Zee = .025, Jee = 16e-6, dV = 12, $ee = 20, Qi = new Di, Fs = new Yt, ete = {
    type: "requestRender"
}, tte = {
    type: "updateMatrix"
}, fV = Math.PI / 6, m1 = class extends ar {
    constructor(e, r, i, s1, o, a, l, c, u1){
        super();
        this.object = e;
        this.domElement = r;
        this.data = i;
        this.gloabalPhysics = s1;
        this.controlsManager = o;
        this.cameraFollow = a;
        this.camera = l;
        this.page = c;
        this.sharedAssets = u1;
        this.enableDamping = !0;
        this.hiddenMatrix0 = new ue;
        this.target0 = new E;
        this.zoom0 = 1;
        this.rotForce = 1;
        this.moveForce = 1;
        this.pixelsPerMeter = kM;
        this.euler0 = new Jt(0, 0, 0, "YXZ");
        this.position0Cam = new E;
        this.quat0Cam = new Ye;
        this.scale0Cam = new E;
        this.hiddenMatrix0Cam = new ue;
        this.threshEndTranslate = .01;
        this.threshEndRotate = 1e-8;
        this.threshEndRotVel = .005;
        this.collider = {
            type: "capsule",
            radius: 40,
            segment: new Di(new E(0, -40, 0), new E(0, 40, 0)),
            matrix: new ue,
            position: new E,
            rotation: new Ye
        };
        this.euler = new Jt(0, 0, 0, "YXZ");
        this.eulerDelta = new E;
        this.lastPosition = new E;
        this.lastCameraQuaternion = new Ye;
        this.lastCameraPosition = new E;
        this.PI_2 = Math.PI / 2;
        this.prevMouse = new U;
        this.velocityTarget = new E;
        this.velocity = new E;
        this.directionXZ = new E;
        this.rotVelocityStick = new E;
        this.rotVelocityTarget = new E;
        this.rotVelocity = new E;
        this.rotDirection = new E;
        this.nonColliderRotOffset = new ue;
        this.nonColliderPosOffset = new ue;
        this.firstPointerId = -1;
        this.rot = new E;
        this.path = [];
        this.movementState = {
            moveNegZ: 0,
            movePosZ: 0,
            moveNegX: 0,
            movePosX: 0,
            moveNegY: 0,
            movePosY: 0,
            rotPosX: 0,
            rotNegX: 0,
            rotPosY: 0,
            rotNegY: 0,
            jump: 0,
            run: 0
        };
        this.vrEulerYOffset = 0;
        this.onObject = !1;
        this.actionState = {};
        this.keyAssignments = [
            [
                "moveNegZ",
                "W"
            ],
            [
                "moveNegX",
                "A"
            ],
            [
                "movePosZ",
                "S"
            ],
            [
                "movePosX",
                "D"
            ],
            [
                "rotPosX",
                "ArrowUp"
            ],
            [
                "rotPosY",
                "ArrowLeft"
            ],
            [
                "rotNegX",
                "ArrowDown"
            ],
            [
                "rotNegY",
                "ArrowRight"
            ],
            [
                "jump",
                " "
            ]
        ];
        this.collisionEnabled = !0;
        this.offsetMatrix = new ue;
        this.objectToTarget = new E;
        this.objectToTarget0 = new E;
        this.objectToCamXZ = new E;
        this.objectToCamXZ0 = new E;
        this.targetToCamera = new E;
        this.targetToCamera0 = new E;
        this.cameraPolarAxis0 = new E;
        this.targetPos = new E;
        this.targetQuat = new Ye;
        this.lerpFactorPos = new E().setScalar(.3);
        this.lerpFactorPosStart = .3;
        this.lerpFactorPosEnd = .3;
        this.lerpFactorRotStart = .3;
        this.lerpFactorRotEnd = .3;
        this.lerpFactorPosCamera = .3;
        this.lerpFactorRotCamera = .3;
        this.objXZQuat = new Ye;
        this.objXZQuatInv = new Ye;
        this.objXZRotMat = new ue;
        this.isFirstPerson = !1;
        this.didHit = !1;
        this.groundVelocity = new E;
        this.pushedVelocity = new E;
        this.groundYRotation = 0;
        this.objectRealQuat = new Ye;
        this.colliderWorldQuat = new Ye;
        this.groundNormal = new E;
        this.groundTilt = new Ye;
        this.groundTiltInv = new Ye;
        this.lastHitObj = null;
        this.isFirstFrame = !0;
        this.rotationAccumWhenOrientWithCamera = 0;
        this.navMeshPathDest = null;
        this.position = new E;
        this.quaternion = new Ye;
        this.scale = new E;
        this.initialAction = !0;
        this.onPointerDown = (e)=>{
            !(e.target === this.domElement || e.target instanceof HTMLElement && e.target.tagName === "SPLINE-VIEWER" && e.target.shadowRoot?.contains(this.domElement)) || this.firstPointerId !== -1 || (this.firstPointerId = e.pointerId, this.domElement.ownerDocument.addEventListener("pointermove", this.onPointerMove), this.domElement.ownerDocument.addEventListener("pointerup", this.onPointerUp), this.rotBy !== "keys" && !Li && !iA && this.domElement.requestPointerLock(), this.prevMouse.set(e.clientX, e.clientY));
        };
        this.onPointerUp = (e)=>{
            this.firstPointerId = -1, this.domElement.ownerDocument.removeEventListener("pointermove", this.onPointerMove), this.domElement.ownerDocument.removeEventListener("pointerup", this.onPointerUp), e.pointerType === "mouse" && this.domElement.ownerDocument.exitPointerLock();
        };
        this.onPointerMove = (e)=>{
            if (e.pointerId !== this.firstPointerId) return;
            let r = e.clientX - this.prevMouse.x, i = e.clientY - this.prevMouse.y;
            this.prevMouse.set(e.clientX, e.clientY), e.pointerType === "mouse" && this.rotBy !== "keys" && (iA && hD < 15.5 && !Li ? (this.eulerDelta.y = -r * this.mouseOrbitSensitivity, this.eulerDelta.x = -i * this.mouseOrbitSensitivity) : (this.eulerDelta.y = -e.movementX * this.mouseOrbitSensitivity, this.eulerDelta.x = -e.movementY * this.mouseOrbitSensitivity)), e.pointerType !== "mouse" && this.rotByTouch === "drag" && (this.eulerDelta.y = -r * this.mouseOrbitSensitivity * 5, this.eulerDelta.x = -i * this.mouseOrbitSensitivity * 5), this.controlsManager.requestRender();
        };
        this.onPointerlockChange = (e)=>{
            this.domElement.ownerDocument.pointerLockElement === this.domElement ? m1.isLocked = !0 : m1.isLocked = !1;
        };
        this.onPointerlockError = ()=>{
            console.error("SPE.GameControls: Unable to use Pointer Lock API");
        };
        this.handleVisibilityChange = ()=>{
            if (document?.hidden) for(let e in this.movementState)this.movementState[e] = 0;
        };
        this.onKeyDown = (e)=>{
            !(e.target instanceof HTMLInputElement) && (e.code === "ArrowLeft" || e.code === "ArrowUp" || e.code === "ArrowRight" || e.code === "ArrowDown" || e.code === "Space") && e.preventDefault();
            for (let r of this.keyAssignments)if (e.key.toUpperCase() === r[1] || e.key === r[1]) {
                this.movementState[r[0]] = 1;
                break;
            }
            this.controlsManager.requestRender();
        };
        this.onKeyUp = (e)=>{
            for (let r of this.keyAssignments)if (e.key.toUpperCase() === r[1] || e.key === r[1] || e.code.slice(3, e.code.length).toUpperCase() === r[1]) {
                this.movementState[r[0]] = 0;
                break;
            }
        };
        this.copyVRGamePadValues = (e, r)=>{
            for(let i = 2; i < 4; i++){
                let s1 = e.axes[i];
                r === 0 ? i === 2 ? this.movementState.movePosX = s1 : this.movementState.movePosZ = s1 : (e.buttons[3].pressed ? this.movementState.jump = 1 : this.movementState.jump = 0, i === 2 ? (Math.abs(this.movementState.rotPosY) < .3 && Math.abs(s1) >= .3 && (this.vrEulerYOffset += s1 < 0 ? 1 : -1), this.movementState.rotPosY = s1) : this.moveMode === "fly" && (this.movementState.moveNegY = s1));
            }
        };
        this.sharedGameControlGlobals = o.sharedGameControlGlobals, e === l && (this.isFirstPerson = !0), this.hiddenMatrix0.copy(this.object.hiddenMatrix), this.object.parent ? this.object.hiddenMatrix.copy(this.object.parent.matrixWorld).invert() : this.object.hiddenMatrix.identity(), this.object.matrix.copy(this.object.matrixWorld), this.object.matrix.decompose(this.position, this.quaternion, this.scale), this.euler0.setFromQuaternion(this.quaternion, "YXZ");
        let h = this.euler0.clone(), d = h.y;
        if (this.objectRealQuat.copy(this.quaternion), h.y = 0, this.quaternion.setFromEuler(h), this.objXZQuat.copy(this.quaternion), this.objXZQuatInv.copy(this.objXZQuat).invert(), this.objXZRotMat.makeRotationFromQuaternion(this.quaternion), h.set(0, d, 0), this.quaternion.setFromEuler(h), this.rot.setFromEuler(h), this.object.matrixAutoUpdate = !1, (this.isFirstPerson || this.cameraFollow === !0) && (this.target0.copy(this.camera.getTarget()), this.zoom0 = this.camera.zoom), this.cameraFollow === !0) {
            this.position0Cam.copy(this.camera.position), this.quat0Cam.copy(this.camera.quaternion), this.scale0Cam.copy(this.camera.scale), this.hiddenMatrix0Cam.copy(this.camera.hiddenMatrix), this.camera.parent ? (this.camera.hiddenMatrix.copy(this.camera?.parent.matrixWorld), this.camera.matrix.copy(this.camera.matrixWorld)) : this.camera.hiddenMatrix.identity(), this.camera.matrix.copy(this.camera.matrixWorld), this.camera.matrix.decompose(this.camera.position, this.camera.quaternion, this.camera.scale), this.camera.matrixAutoUpdate = !1, this.offsetMatrix.copy(this.object.matrix).invert().multiply(this.camera.matrix);
            let g = new E(0, 0, -1).applyQuaternion(this.camera.quaternion), y = new E().subVectors(this.position, this.camera.position);
            this.objectToCamXZ.copy(y), this.objectToCamXZ.y = 0, this.objectToCamXZ0.copy(this.objectToCamXZ);
            let x, v;
            Math.abs(g.y) < 1e-6 ? (y.y = 0, g.y = 0, v = y.projectOnVector(g)) : y.y / g.y > 0 ? v = g.multiplyScalar(y.y / g.y) : v = g.multiplyScalar(y.length()), this.targetToCamera0.copy(v).negate(), x = this.camera.position.clone().add(v), this.objectToTarget0.subVectors(x, this.position);
            let b = new Jt().setFromQuaternion(this.camera.quaternion, "YXZ");
            this.cameraPolarOffset = -b.x, b.x = 0, b.z = 0, b.y -= Math.PI / 2, this.cameraPolarAxis0.set(0, 0, -1).applyEuler(b);
        }
        if (this.object instanceof ir && (this.object.matrixAutoUpdate = !1), this.euler.setFromQuaternion(this.quaternion, "YXZ"), this.rotByTouch = i.rotByTouch ?? "joystick", this.rotBy = i.rotBy ?? "keys", this.rotationMode = i.rotationMode ?? "normal", this.moveMode = i.moveMode ?? "walk", this.collisionEnabled = i.collisionEnabled, this.speedTranslate = (i.speedTranslate ?? 250) * Qee, this.speedOrbit = (i.speedRotate ?? 100) * Zee, this.mouseOrbitSensitivity = (i.speedRotate ?? 100) * Jee, this.keyAssignments = i.keyAssignments.map((g)=>{
            let y = [
                g[0],
                g[1]
            ];
            return y[1] === "\u25B2" ? y[1] = "ArrowUp" : y[1] === "\u25C0" ? y[1] = "ArrowLeft" : y[1] === "\u25BC" ? y[1] = "ArrowDown" : y[1] === "\u25B6" ? y[1] = "ArrowRight" : y[1] === "\u21E7" ? y[1] = "Shift" : y[1] === "\u21B5" ? y[1] = "Enter" : y[1] === "Space" ? y[1] = " " : y[1] === "\u2318" ? y[1] = "Meta" : y[1] === "Ctrl" ? y[1] = "Control" : y[1] === "Esc" && (y[1] = "Escape"), y;
        }), i.rotBy === "mouse") {
            let g;
            g = this.keyAssignments.findIndex((y)=>y[0] === "rotNegX"), g !== -1 && (this.keyAssignments[g][1] = ""), g = this.keyAssignments.findIndex((y)=>y[0] === "rotPosX"), g !== -1 && (this.keyAssignments[g][1] = ""), g = this.keyAssignments.findIndex((y)=>y[0] === "rotPosY"), g !== -1 && (this.keyAssignments[g][1] = ""), g = this.keyAssignments.findIndex((y)=>y[0] === "rotNegY"), g !== -1 && (this.keyAssignments[g][1] = "");
        }
        this.lerpFactorPosStart = 1 - .02 ** (1 / ((i.delayPos[0] ?? .3) * 60)), this.lerpFactorPosEnd = 1 - .02 ** (1 / ((i.delayPos[1] ?? .3) * 60)), this.lerpFactorPos.setScalar(this.lerpFactorPosStart), this.lerpFactorRotStart = 1 - .02 ** (1 / ((i.delayRot[0] ?? .3) * 60)), this.lerpFactorRotEnd = 1 - .02 ** (1 / ((i.delayRot[1] ?? .3) * 60)), this.lerpFactorPosCamera = 1 - .02 ** (1 / ((i.delayPosCamera ?? .3) * 60)), this.lerpFactorRotCamera = 1 - .02 ** (1 / ((i.delayRotCamera ?? .3) * 60)), this.gravity = (this.gloabalPhysics.gravity ?? Wl.defaultData.gravity) * dV, this.usePhysics = this.gloabalPhysics.usePhysics ?? Wl.defaultData.usePhysics, this.jumpPower = i.jumpPower * $ee, this.resetYPosition = this.position.y + Math.abs(i.resetYPosition) * (this.gravity > 0 ? 1 : -1), this.alignToGround = i.alignToGround ?? !1, this.orientMode = i.autoOrientMove ? i.orientMode : "none", this.orientWith = i.orientWith ?? bd.defaultDataThirdPerson.orientWith, this.slopeThresh = Wee * Math.PI / 180, i.collider.type === "capsule" ? (this.collider.radius = i.collider.radius, this.collider.segment.start.y = i.collider.height / 2 - i.collider.radius, this.collider.segment.end.y = -this.collider.segment.start.y, this.offset = i.collider.height * FM / this.pixelsPerMeter, this.stepThresh = i.collider.height * VM / this.pixelsPerMeter, this.colliderHeight = i.collider.height) : i.collider.type === "sphere" ? (this.collider.radius = i.collider.radius, this.collider.segment.start.y = 0, this.collider.segment.end.y = 0, this.offset = 2 * i.collider.radius * FM / this.pixelsPerMeter, this.stepThresh = 2 * i.collider.radius * VM / this.pixelsPerMeter, this.colliderHeight = i.collider.radius * 2) : (this.offset = i.collider.height * FM / this.pixelsPerMeter, this.stepThresh = i.collider.height * VM / this.pixelsPerMeter, this.colliderHeight = i.collider.height), this.collider.type = i.collider.type;
        let f = new E().fromArray(i.collider.position.map((g)=>typeof g == "number" ? g : 0)), m = new Ye().setFromEuler(new Jt().fromArray([
            ...i.collider.rotation.map((g)=>typeof g == "number" ? g : 0),
            "XYZ"
        ]));
        this.collider.position.copy(f).multiply(this.scale), this.collider.rotation.copy(m), this.collider.matrix.compose(f, m, hV), i.cameraXAxis !== void 0 && (this.cameraXAxis = i.cameraXAxis, this.cameraYAxis = i.cameraYAxis, this.minPolarAngle = i.cameraRotXLimits[0], this.maxPolarAngle = i.cameraRotXLimits[1], this.minAzimuthAngleRel = i.cameraRotYLimits[0], this.maxAzimuthAngleRel = i.cameraRotYLimits[1]), this.forwardDir = i.forwardDirection ?? "-z", this.isFirstPerson && (this.forwardDir = "-z"), this.runMultiplier = i.runMultiplier ?? 2;
        let p = i.navmesh.destinationHelperRadius * 2;
        if (p > 0) {
            let g = new Re;
            g.push({
                fi: 0,
                data: {
                    ...Cr.defaultData("light", "phong"),
                    alpha: 0
                },
                id: "layer1"
            }), g.push({
                fi: 0,
                data: {
                    ...Cr.defaultData("color"),
                    color: i.navmesh.destinationHelperColor,
                    alpha: i.navmesh.destinationHelperColor.a
                },
                id: "layer2"
            });
            let y = new $a({
                layers: g
            }, {
                scene: this.page.scene,
                shared: this.sharedAssets
            });
            this.navMeshPathDest = new Mt(yx.create({
                parameters: {
                    width: p,
                    height: p / 10,
                    hollow: .7
                }
            }), y), this.navMeshPathDest.material.userData.opacity0 = i.navmesh.destinationHelperColor.a;
        }
        this.activate();
    }
    reset(e = !1) {
        if (this.object.hiddenMatrix.copy(this.hiddenMatrix0), e) {
            this.object.updateMatrix(), this.object.updateMatrixWorld(), this.object.matrix.copy(this.object.matrixWorld), this.object.matrix.decompose(this.position, this.quaternion, this.scale), this.object.parent ? this.object.hiddenMatrix.copy(this.object.parent.matrixWorld).invert() : this.object.hiddenMatrix.identity();
            let r = new Jt().setFromQuaternion(this.quaternion, "YXZ"), i = r.y;
            this.objectRealQuat.copy(this.quaternion), r.y = 0, this.quaternion.setFromEuler(r), this.objXZQuat.copy(this.quaternion), this.objXZQuatInv.copy(this.objXZQuat).invert(), this.objXZRotMat.makeRotationFromQuaternion(this.quaternion), r.set(0, i, 0), this.quaternion.setFromEuler(r), this.rot.setFromEuler(r), this.euler.setFromQuaternion(this.quaternion, "YXZ"), this.velocityTarget.set(0, 0, 0), this.velocity.set(0, 0, 0);
        } else this.object instanceof ir ? this.object.matrixAutoUpdate = !0 : this.object.updateMatrix();
        this.cameraFollow === !0 && (this.camera.quaternion.copy(this.quat0Cam), this.camera.position.copy(this.position0Cam), this.camera.scale.copy(this.scale0Cam), this.camera.hiddenMatrix.copy(this.hiddenMatrix0Cam), this.camera.matrixAutoUpdate = !0), this.controlsManager.requestRender();
    }
    activate() {
        this.instantiateActions(), this.domElement.ownerDocument.addEventListener("pointerdown", this.onPointerDown), this.domElement.ownerDocument.addEventListener("keydown", this.onKeyDown), this.domElement.ownerDocument.addEventListener("keyup", this.onKeyUp), this.domElement.ownerDocument.addEventListener("pointerlockchange", this.onPointerlockChange), this.domElement.ownerDocument.addEventListener("pointerlockerror", this.onPointerlockError), this.domElement.ownerDocument.addEventListener("visibilitychange", this.handleVisibilityChange);
    }
    deactivate() {
        this.disposeActions(), this.domElement.ownerDocument.removeEventListener("pointerdown", this.onPointerDown), this.domElement.ownerDocument.removeEventListener("keydown", this.onKeyDown), this.domElement.ownerDocument.removeEventListener("keyup", this.onKeyUp), this.domElement.ownerDocument.removeEventListener("pointerlockchange", this.onPointerlockChange), this.domElement.ownerDocument.removeEventListener("pointerlockerror", this.onPointerlockError), this.domElement.ownerDocument.removeEventListener("visibilitychange", this.handleVisibilityChange);
    }
    dispose() {
        this.deactivate(), this.navMeshPathDest?.parent && this.page.remove(this.navMeshPathDest);
    }
    instantiateActions() {
        let e = this.data, r = this.sharedAssets;
        e.gameActions !== void 0 && (this.actions = {}, xd.list.forEach((i)=>{
            this.actions[i] = Wt({
                ...e,
                disabled: !1,
                type: "GameControl"
            }, e.gameActions[i], this.page, r, this.controlsManager.eventManager, this.object);
        })), this.dispatchStopEvent("move"), this.dispatchStopEvent("run"), this.dispatchStopEvent("jump"), this.dispatchStartEvent("idle"), this.initialAction && (this.initialAction = !1);
    }
    disposeActions() {
        this.initialAction = !1, this.dispatchStopEvent("idle"), this.dispatchStopEvent("move"), this.dispatchStopEvent("run"), this.dispatchStopEvent("jump"), vr(this.actions.idle), vr(this.actions.move), vr(this.actions.run), vr(this.actions.jump);
    }
    dispatchStartEvent(e) {
        this.actions[e] !== void 0 && (this.actionState[e] || (this.actionState[e] = !0, this.actions[e].Transition.forEach((r)=>{
            r.play();
        }), this.actions[e].Animation.forEach((r)=>{
            r.play(this.initialAction === !1);
        }), this.actions[e].TimelineAnimation.forEach((r)=>{
            r.play();
        }), this.actions[e].Create.forEach((r)=>{
            r.dispatchStart();
        }), this.actions[e].Audio.forEach((r)=>{
            r.dispatchGameControl("start");
        }), this.actions[e].Particles.forEach((r)=>{
            r.dispatchGameControl("start");
        })));
    }
    dispatchStopEvent(e) {
        this.actions[e] !== void 0 && (!this.actionState[e] || (this.actionState[e] = !1, this.actions[e].Transition.forEach((r)=>{
            r.stop(), r.object.currentState !== null && r.object.changeSelectedState(null, {
                scene: this.page.scene,
                shared: this.sharedAssets
            });
        }), this.actions[e].TimelineAnimation.forEach((r)=>{
            r.stop();
        }), this.actions[e].Create.forEach((r)=>{
            r.dispatchStop();
        }), this.actions[e].Audio.forEach((r)=>{
            r.dispatchGameControl("stop");
        }), this.actions[e].Particles.forEach((r)=>{
            r.dispatchGameControl("stop");
        })));
    }
    get colliderWorldPosition() {
        return On.copy(this.collider.position).applyQuaternion(this.objectRealQuat).add(this.position);
    }
    update(e, r, i) {
        if (this.gravity < 0 ? this.position.y < this.resetYPosition : this.position.y > this.resetYPosition) return this.reset(!0), !0;
        this.sharedGameControlGlobals.gamePads.forEach(this.copyVRGamePadValues);
        let s1 = (this.isFirstFrame ? 16.6 : e) / 1e3;
        this.isFirstFrame && (this.isFirstFrame = !1);
        let o = s1 * 60, a = !1;
        if (this.usePhysics && this.collisionEnabled && this.object.rigidBody?.collider(0).shape) {
            let c = Yn.set(0, (this.velocity.y === 0 ? this.pixelsPerMeter * Math.max(Math.abs(this.gravity) / (10 * dV), 1) * (this.gravity > 0 ? 1 : -1) : this.velocity.y) * s1, 0).divideScalar(this.pixelsPerMeter), u1 = this.sharedGameControlGlobals.rapierWorld.castShape(this.colliderWorldPosition.divideScalar(this.pixelsPerMeter), this.colliderWorldQuat, c, this.object.rigidBody?.collider(0).shape, 1, !1, 16, void 0, void 0, this.object.rigidBody);
            if (u1) {
                this.onObject = !0, this.groundNormal.set(u1.normal2.x, u1.normal2.y, u1.normal2.z).applyQuaternion(this.colliderWorldQuat).negate(), this.alignToGround && this.groundTiltAdjustment(this.groundNormal), Math.acos(this.groundNormal.y) < this.slopeThresh && (a = !0), u1.collider.parent()?.bodyType() === 0 && Math.acos(this.groundNormal.y) * (180 / Math.PI) > 45 && (this.onObject = !1);
                let h = u1.collider.parent();
                this.groundYRotation = 0, this.groundVelocity.set(0, 0, 0);
                for (let d of this.sharedGameControlGlobals.entitiesWithTransformAnim)if (d.rigidBody === h && d.userData.isFollowingObj !== this.object.uuid) {
                    (d.hasNonUniformScale ? d.matrixWorldRigid : d.matrixWorld).decompose(On, sl, Yn), this.groundVelocity.subVectors(On, d.prevT), this.object.getWorldPosition(Yn).add(this.collider.position).sub(On), this.groundYRotation = fa.setFromQuaternion(sl).y - d.prevR.y, wc.copy(Yn).applyAxisAngle(go, this.groundYRotation), this.groundVelocity.add(wc.sub(Yn)).divideScalar(s1);
                    break;
                }
            } else this.onObject = !1;
        }
        if (this.moveMode === "walk" && this.collisionEnabled && (this.movementState.jump === 1 && this.onObject && (this.velocityTarget.y = this.jumpPower, this.movementState.jump = 0, this.dispatchStopEvent("idle"), this.dispatchStopEvent("move"), this.dispatchStopEvent("run"), this.dispatchStopEvent("jump"), this.dispatchStartEvent("jump"), this.onObject = !1), this.onObject ? this.velocityTarget.y /= 2 : this.velocityTarget.y += this.gravity * o), this.moveMode === "fly" && (this.velocityTarget.y = (this.movementState.movePosY - this.movementState.moveNegY) * this.speedTranslate), this.directionXZ.z = this.movementState.movePosZ - this.movementState.moveNegZ, this.directionXZ.x = this.movementState.movePosX - this.movementState.moveNegX, this.forwardDir === "+z" && this.directionXZ.multiplyScalar(-1), this.directionXZ.manhattanLength() > 0 && (this.path = []), this.navMeshPathDest) {
            let c = this.navMeshPathDest.material;
            if (this.moveMode === "walk" && this.path.length > 1) {
                this.navMeshPathDest.position.copy(this.path[this.path.length - 1]), this.navMeshPathDest.parent || this.page.add(this.navMeshPathDest);
                let u1 = On.subVectors(this.path[1], this.position), h = Yn.subVectors(this.path[1], this.path[0]);
                u1.dot(h) < 0 ? this.path.shift() : (this.directionXZ.x = h.x, this.directionXZ.z = h.z), c.opacity = c.userData.opacity0;
            } else c.opacity -= .05 * c.userData.opacity0, this.navMeshPathDest.material.opacity <= 0 && this.navMeshPathDest.parent && this.page.remove(this.navMeshPathDest);
        }
        this.directionXZ.normalize(), this.movementState.run ? this.moveForce = this.runMultiplier : this.moveForce = 1, this.velocityTarget.z = this.directionXZ.z * this.speedTranslate * this.moveForce, this.velocityTarget.x = this.directionXZ.x * this.speedTranslate * this.moveForce, (this.moveMode === "walk" ? this.velocityTarget.x + this.velocityTarget.z === 0 : this.velocityTarget.manhattanLength() === 0) ? this.lerpFactorPos.setScalar(this.lerpFactorPosEnd) : this.lerpFactorPos.setScalar(this.lerpFactorPosStart), this.moveMode === "walk" && (this.lerpFactorPos.y = 1), this.didHit === !1 && this.pushedVelocity.manhattanLength() === 0 || this.usePhysics === !1 ? (this.velocity.x += (this.velocityTarget.x - this.velocity.x) * (1 - (1 - this.lerpFactorPos.x) ** o), this.velocity.y += (this.velocityTarget.y - this.velocity.y) * (1 - (1 - this.lerpFactorPos.y) ** o), this.velocity.z += (this.velocityTarget.z - this.velocity.z) * (1 - (1 - this.lerpFactorPos.z) ** o)) : this.velocity.copy(this.velocityTarget), (this.moveMode === "walk" ? this.velocity.x ** 2 + this.velocity.z ** 2 < this.speedTranslate : this.velocity.lengthSq() < this.speedTranslate) ? (this.dispatchStopEvent("move"), this.dispatchStopEvent("run"), this.onObject && (this.dispatchStopEvent("jump"), this.dispatchStartEvent("idle"))) : (this.dispatchStopEvent("idle"), (this.onObject || this.moveMode === "fly") && (this.dispatchStopEvent("jump"), this.movementState.run ? (this.dispatchStopEvent("move"), this.dispatchStartEvent("run")) : (this.dispatchStopEvent("run"), this.dispatchStartEvent("move"))));
        let l = qee.copy(this.velocity);
        if (this.orientMode !== "none" && this.isFirstPerson === !1) {
            let c = Yn.copy(l);
            c.y = 0, l.set(0, l.y, c.length() * (this.forwardDir === "+z" ? 1 : -1));
        }
        if (this.directionXZ.manhattanLength() > 0 && this.orientMode !== "none" && this.isFirstPerson === !1) {
            if (this.orientWith === "camera" && this.path.length <= 1) {
                let c = On;
                this.camera.getWorldDirection(c);
                let u1 = wc.copy(go).multiplyScalar(c.dot(go));
                c.sub(u1);
                let h = Yn.copy(this.directionXZ);
                h.x *= -1, this.rot.y = c.angleTo(h) * (c.cross(h).y > 0 ? -1 : 1) + this.rotationAccumWhenOrientWithCamera;
            } else this.rot.y = (this.path.length > 1 ? 0 : this.euler.y) + Math.atan2(-this.directionXZ.z, this.directionXZ.x) + Math.PI / 2 * (this.forwardDir === "+z" ? 1 : -1);
        }
        if (fa.setFromVector3(this.rot), this.moveMode === "walk" && (fa.x = 0), l.applyEuler(fa), a && (sl.setFromUnitVectors(go, this.groundNormal), l.applyQuaternion(sl)), i) {
            let c = fa.set(0, this.vrEulerYOffset * fV, 0);
            i.applyEuler(c), l.x += i.x, l.z += i.z, this.nonColliderPosOffset.elements[13] += i.y * s1;
        }
        if (this.usePhysics === !0 && this.object.rigidBody) {
            let c = Yn;
            this.pushedVelocity.set(0, 0, 0);
            for (let u1 of this.sharedGameControlGlobals.entitiesWithTransformAnim){
                let h = wc.setFromMatrixPosition(u1.matrixWorld).sub(u1.prevT).divideScalar(s1).divideScalar(this.pixelsPerMeter), d = u1.rigidBody.collider(0).castCollider(h, this.object.rigidBody.collider(0), On.copy(l).divideScalar(this.pixelsPerMeter), s1, !1);
                h.multiplyScalar(this.pixelsPerMeter);
                let f = gt.is(u1) ? u1 : u1.object;
                if (d !== null && this.lastHitObj !== f) {
                    let m;
                    u1 instanceof Lr && (m = u1);
                    let p = this.sharedGameControlGlobals.entityToCollisionEvents[f.uuid];
                    if (p) for (let g of p)g.data.target === "character" && (g.dispatch(m), f.dispatchEvent(g1));
                    this.lastHitObj = f;
                }
                if (d !== null) {
                    this.pushedVelocity.copy(h), c.copy(d.normal1).applyQuaternion(u1.quaternion);
                    break;
                }
            }
            if (this.pushedVelocity.manhattanLength() !== 0) {
                let u1 = c.dot(l);
                u1 < 0 && l.addScaledVector(c, -u1), l.add(this.pushedVelocity);
            } else l.add(this.groundVelocity);
        }
        if (this.rotDirection.y = Number(this.movementState.rotPosY) - Number(this.movementState.rotNegY), this.rotDirection.x = Number(this.movementState.rotPosX) - Number(this.movementState.rotNegX), this.rotDirection.normalize(), this.rotationMode === "normal" && (this.movementState.rotPosX || this.movementState.rotNegX) || this.rotationMode === "steer" && (this.movementState.rotPosX || this.movementState.rotNegX) && (this.movementState.movePosZ || this.movementState.moveNegZ || this.moveMode === "walk") ? this.rotVelocityStick.x = -this.rotDirection.x * this.speedOrbit * this.rotForce : this.rotVelocityStick.x = 0, this.rotationMode === "normal" && (this.movementState.rotPosY || this.movementState.rotNegY) || this.rotationMode === "steer" && (this.movementState.rotPosY || this.movementState.rotNegY) && (this.movementState.movePosZ || this.movementState.moveNegZ) ? this.rotVelocityStick.y = -this.rotDirection.y * this.speedOrbit * this.rotForce : this.rotVelocityStick.y = 0, this.rotVelocityTarget.subVectors(this.eulerDelta.divideScalar(s1), this.rotVelocityStick), this.rotVelocityTarget.manhattanLength() === 0 ? this.rotVelocity.lerp(this.rotVelocityTarget, 1 - (1 - this.lerpFactorRotEnd) ** o) : this.rotVelocity.lerp(this.rotVelocityTarget, 1 - (1 - this.lerpFactorRotStart) ** o), this.euler.x += this.rotVelocity.x * s1, this.euler.y += this.rotVelocity.y * s1 + this.groundYRotation, this.rotVelocityTarget.y === 0 && this.directionXZ.manhattanLength() === 0 ? this.rotationAccumWhenOrientWithCamera = 0 : (this.cameraFollow === !1 || this.cameraYAxis === "Locked") && (this.rotationAccumWhenOrientWithCamera += this.rotVelocity.y * s1), this.isFirstPerson === !1 && this.orientMode !== "none" && this.directionXZ.manhattanLength() > 0) {
            if (this.orientMode === "radial") {
                this.objectToCamXZ.copy(this.objectToCamXZ0).applyAxisAngle(go, this.euler.y - this.euler0.y);
                let c = Yn.copy(this.objectToCamXZ).normalize(), u1 = wc.copy(l).multiplyScalar(s1);
                u1.y = 0;
                let h = u1.sub(On.copy(c).multiplyScalar(u1.dot(c))).cross(c).y;
                this.euler.y -= Math.atan2(h, this.objectToCamXZ.length());
            }
        } else this.rot.y += this.rotVelocity.y * s1 + this.groundYRotation, this.rotVelocityTarget.y !== 0 && (this.cameraFollow === !1 || this.cameraYAxis === "Locked") && (this.euler.y = this.rot.y);
        if (this.cameraFollow === !0 && (this.moveMode === "walk" ? this.cameraXAxis === "Limit" ? this.euler.x = Se.clamp(this.euler.x, -this.maxPolarAngle + this.cameraPolarOffset + 1e-6, -this.minPolarAngle + this.cameraPolarOffset - 1e-6) : this.euler.x = Se.clamp(this.euler.x, -this.PI_2 + this.cameraPolarOffset, this.PI_2 + this.cameraPolarOffset) : this.cameraXAxis === "Limit" && (this.euler.x = Se.clamp(this.euler.x, -this.PI_2, this.PI_2))), this.moveMode === "fly" ? this.rot.x = this.euler.x : this.isFirstPerson && (r ? (fa.copy(r), fa.y = 0) : (fa.copy(this.euler), fa.y = 0), this.nonColliderRotOffset.makeRotationFromEuler(fa)), r && (this.moveMode === "walk" ? (this.rot.y = r.y, this.rot.x = 0, this.rot.z = 0) : this.rot.setFromEuler(r), this.rot.y += this.vrEulerYOffset * fV), mo.setFromAxisAngle(Yee, this.rot.x), sl.setFromAxisAngle(go, this.rot.y), sl.multiply(mo), mo.setFromAxisAngle(Kee, this.rot.z), sl.multiply(mo), this.quaternion.copy(sl), this.objectRealQuat.multiplyQuaternions(this.quaternion, this.objXZQuat), this.colliderWorldQuat.copy(this.objectRealQuat).multiply(this.collider.rotation), this.collisionEnabled) {
            if (this.usePhysics && this.object.rigidBody?.collider(0).shape) {
                let c = Yn.copy(l).multiplyScalar(s1 / this.pixelsPerMeter), u1 = null;
                this.didHit = !1;
                let h = new E;
                for(let d = 0; d < 5; d++){
                    let f = c.length(), m = wc.copy(c).normalize();
                    if (u1 = this.sharedGameControlGlobals.rapierWorld.castShape(this.colliderWorldPosition.divideScalar(this.pixelsPerMeter).add(h), this.colliderWorldQuat, m, this.object.rigidBody.collider(0).shape, f, !1, 24, void 0, void 0, this.object.rigidBody), u1 !== null) {
                        this.didHit = !0;
                        let p = this.sharedGameControlGlobals.colliderToEntity.get(u1.collider.handle);
                        if (p !== this.lastHitObj && d === 0) {
                            this.lastHitObj = p;
                            let v = this.sharedGameControlGlobals.entityToCollisionEvents[p?.uuid];
                            if (v) {
                                for (let b of v)if (b.data.target === "character") {
                                    let w = (this.sharedGameControlGlobals.rapierWorld?.getCollider(u1.collider.handle))._parent, A;
                                    if (p.cloner) {
                                        for (let T of p.cloner.children)if (T.rigidBody === w) {
                                            A = T;
                                            break;
                                        }
                                    }
                                    b.dispatch(A), p.dispatchEvent(g1);
                                }
                            }
                        }
                        let g = lV.set(u1.normal2.x, u1.normal2.y, u1.normal2.z).applyQuaternion(this.colliderWorldQuat), y = cV.copy(m).multiplyScalar(u1.toi).dot(g), x = u1.toi;
                        if (x === 0 && (this.position.y += this.offset * this.pixelsPerMeter), y > this.offset && (x = u1.toi * (y - this.offset) / y, h.addScaledVector(m, x)), c.copy(m).multiplyScalar(f - x), Math.acos(-g.y) > this.slopeThresh) {
                            let v = this.colliderWorldPosition.divideScalar(this.pixelsPerMeter).add(h), b = wc.copy(u1.witness2).applyQuaternion(this.colliderWorldQuat);
                            b.y = 0;
                            let w = v.add(b);
                            w.y += this.stepThresh;
                            let A = this.sharedGameControlGlobals.rapierWorld.castShape(w, this.colliderWorldQuat, c, this.object.rigidBody?.collider(0).shape, 1, !1, 24, void 0, void 0, this.object.rigidBody);
                            A !== null && A.toi === 0 && (g.y = 0, g.normalize());
                        }
                        c.addScaledVector(g, -c.dot(g));
                    } else {
                        d === 0 && this.directionXZ.manhattanLength() !== 0 && (this.lastHitObj = null), h.add(c);
                        break;
                    }
                }
                this.position.addScaledVector(h, this.pixelsPerMeter), this.object.rigidBody?.setTranslation(On.copy(this.position).divideScalar(this.pixelsPerMeter), !0), this.object.rigidBody?.setRotation(mo.copy(this.quaternion).premultiply(this.groundTilt).multiply(this.objXZQuat), !0);
            } else {
                let c = this.onObject ? 1 : 5, u1 = l.multiplyScalar(s1 / c);
                for(let h = 0; h < c; h++)this.position.add(u1), this.collisionAdjustment(s1 / c);
            }
        } else this.position.addScaledVector(l, s1);
        if (this.moveMode === "walk" && this.onObject && (this.velocityTarget.y = 0, this.velocity.y = 0), this.quaternion.premultiply(this.groundTilt).multiply(this.objXZQuat), this.object.matrix.compose(this.position, this.quaternion, this.scale), this.object.matrixWorldNeedsUpdate = !0, this.object.matrix.multiply(this.nonColliderPosOffset).multiply(this.nonColliderRotOffset), this.quaternion.premultiply(this.groundTiltInv).multiply(this.objXZQuatInv), this.cameraFollow === !0) {
            this.updateFollowArms();
            let c = this.objectToTarget.add(this.position), u1 = this.targetToCamera.add(c);
            UM.lookAt(u1, c, go).setPosition(u1), UM.decompose(this.targetPos, this.targetQuat, On), this.camera.quaternion.slerp(this.targetQuat, 1 - (1 - this.lerpFactorRotCamera) ** o), this.camera.position.lerp(this.targetPos, 1 - (1 - this.lerpFactorPosCamera) ** o), this.camera.updateMatrix(), this.camera.updateMatrixWorld(), this.cameraYAxis === "Limit" && this.orientMode === "cartesian" && (this.euler.y = Se.clamp(this.euler.y, this.minAzimuthAngleRel, this.maxAzimuthAngleRel)), this.euler.x = Se.clamp(this.euler.x, -this.PI_2 + (this.cameraPolarOffset < 0 ? this.cameraPolarOffset : 0), this.PI_2 + (this.cameraPolarOffset > 0 ? this.cameraPolarOffset : 0));
        }
        return this.eulerDelta.set(0, 0, 0), this.object.dispatchEvent(tte), this.path.length < 2 && this.lastPosition.distanceToSquared(this.position) < this.threshEndTranslate && Math.abs(this.rotVelocity.x) < this.threshEndRotVel && Math.abs(this.rotVelocity.y) < this.threshEndRotVel && (this.camera === void 0 || this.isFirstPerson || this.lastCameraPosition.distanceToSquared(this.camera.position) < this.threshEndTranslate && 8 * (1 - this.lastCameraQuaternion.dot(this.camera.quaternion)) < this.threshEndRotate) && (this.moveMode === "fly" || this.onObject === !0 || this.collisionEnabled === !1) && (this.navMeshPathDest === null || this.navMeshPathDest.material.opacity < -0.04 * this.navMeshPathDest?.material?.userData.opacity0) ? !1 : (this.camera && (this.lastCameraPosition.copy(this.camera.position), this.lastCameraQuaternion.copy(this.camera.quaternion)), this.lastPosition.copy(this.position), this.object.dispatchEvent(ete), !0);
    }
    updateFollowArms() {
        this.objectToTarget.copy(this.objectToTarget0), this.targetToCamera.copy(this.targetToCamera0);
        let e = mo.setFromAxisAngle(go, this.cameraYAxis === "Limit" && this.orientMode !== "radial" ? Se.clamp(this.euler.y - this.euler0.y, this.minAzimuthAngleRel, this.maxAzimuthAngleRel) : this.euler.y - this.euler0.y);
        (this.cameraYAxis !== "Locked" || this.orientMode === "radial") && this.objectToTarget.applyQuaternion(e);
        let r;
        this.cameraXAxis === "Limit" ? r = Se.clamp(this.euler.x, -this.maxPolarAngle + this.cameraPolarOffset + 1e-6, -this.minPolarAngle + this.cameraPolarOffset - 1e-6) : r = Se.clamp(this.euler.x, -this.PI_2 + this.cameraPolarOffset + 1e-6, this.PI_2 + this.cameraPolarOffset - 1e-6);
        let i = On.copy(this.cameraPolarAxis0);
        (this.cameraYAxis !== "Locked" || this.orientMode === "radial") && i.applyQuaternion(e);
        let s1 = sl.setFromAxisAngle(i, r);
        this.cameraYAxis !== "Locked" && this.targetToCamera.applyQuaternion(e), this.cameraXAxis !== "Locked" && this.targetToCamera.applyQuaternion(s1);
    }
    groundTiltAdjustment(e) {
        go.angleTo(e) * 180 / Math.PI < 15 || go.angleTo(e) * 180 / Math.PI > 85 ? mo.identity() : mo.setFromUnitVectors(go, e), this.groundTilt.slerp(mo, .06), this.groundTiltInv.copy(this.groundTilt).invert();
    }
    collisionAdjustment(e) {
        let r = cV.set(0, 0, 0);
        this.object.matrix.compose(this.position, this.quaternion, this.scale);
        let i = UM.multiplyMatrices(this.object.matrix, this.objXZRotMat).multiply(this.collider.matrix).decompose(On, mo, Yn).compose(On, mo, hV);
        this.sharedGameControlGlobals.entitiesWithTransformAnim.forEach((o)=>{
            if (o === this.object || o.isDescendantOf(this.object) || !o.bvhGeometry || !o.bvhGeometry.boundsTree) return;
            Fs.makeEmpty(), o.updateMatrixWorldSVD();
            let a = o.matrixWorldRigid, l = uV.copy(a).invert(), c = Xee.copy(uV).multiply(i);
            Qi.copy(this.collider.segment), Qi.start.applyMatrix4(c), Qi.end.applyMatrix4(c);
            let u1 = lV.copy(this.position).applyMatrix4(l);
            Fs.expandByPoint(Qi.start), Fs.expandByPoint(Qi.end), Fs.min.addScalar(-this.collider.radius), Fs.max.addScalar(this.collider.radius), o.bvhGeometry.boundsTree.shapecast({
                traverseBoundsOrder (h) {
                    return h.distanceToPoint(Qi.end);
                },
                intersectsBounds: (h)=>h.intersectsBox(Fs),
                intersectsTriangle: (h)=>{
                    let d = On, f = Yn, m = h.closestPointToSegment(Qi, d, f);
                    if (m < this.collider.radius) {
                        let p = this.collider.radius - m, g = f.sub(d).normalize(), y = wc.copy(u1);
                        y.addScaledVector(g, p);
                        let x = y.applyMatrix4(a).sub(this.position);
                        r.add(x), Qi.start.addScaledVector(g, p), Qi.end.addScaledVector(g, p);
                    }
                }
            });
        }), Fs.makeEmpty(), Qi.copy(this.collider.segment), Qi.start.applyMatrix4(i), Qi.end.applyMatrix4(i), Fs.expandByPoint(Qi.start), Fs.expandByPoint(Qi.end), Fs.min.addScalar(-this.collider.radius), Fs.max.addScalar(this.collider.radius), this.sharedGameControlGlobals.staticMeshBVH?.shapecast({
            traverseBoundsOrder (o) {
                return o.distanceToPoint(Qi.end);
            },
            intersectsBounds: (o)=>o.intersectsBox(Fs),
            intersectsTriangle: (o)=>{
                let a = On, l = Yn, c = o.closestPointToSegment(Qi, a, l);
                if (c < this.collider.radius) {
                    let u1 = this.collider.radius - c, h = l.sub(a).normalize();
                    this.alignToGround && this.groundTiltAdjustment(h), r.addScaledVector(h, u1), Qi.start.addScaledVector(h, u1), Qi.end.addScaledVector(h, u1);
                }
            }
        }), this.onObject = Math.abs(r.y) > Math.abs(e * this.velocity.y * .25), this.onObject && this.dispatchStopEvent("jump");
        let s1 = Math.max(0, r.length() - 1e-5);
        r.normalize().multiplyScalar(s1), this.position.add(r);
    }
    pause() {
        this.firstPointerId = -1, this.movementState = {
            moveNegZ: 0,
            movePosZ: 0,
            moveNegX: 0,
            movePosX: 0,
            moveNegY: 0,
            movePosY: 0,
            rotPosX: 0,
            rotNegX: 0,
            rotPosY: 0,
            rotNegY: 0,
            jump: 0,
            run: 0
        }, this.deactivate();
    }
    resume() {
        this.activate();
    }
}, jg = m1;
jg.isLocked = !1;
var pV = cl(SE());
function zM(n1) {
    let t = n1.elements, e = t[0] ** 2 + t[1] ** 2 + t[2] ** 2, r = t[4] ** 2 + t[5] ** 2 + t[6] ** 2, i = t[8] ** 2 + t[9] ** 2 + t[10] ** 2, s1 = t[0] ** 2 + t[4] ** 2 + t[8] ** 2, o = t[1] ** 2 + t[5] ** 2 + t[9] ** 2, a = t[2] ** 2 + t[6] ** 2 + t[10] ** 2, l = 1e-8;
    return e < l || r < l || i < l || s1 < l || o < l || a < l;
}
function yo(n1, t) {
    let e = new Ce;
    if (t && zM(t)) return e.setAttribute("position", new Te([], 3)), e.setIndex([]), e;
    if (!n1.getAttribute("position")) return e.setAttribute("position", new Te([], 3)), e.setIndex([]), e;
    let { positions: r, triIndices: i } = uu(n1.getAttribute("position"), n1.getIndex());
    return e.setAttribute("position", new Te(r, 3)), e.setIndex(i), t && e.applyMatrix4(t), e;
}
var rte = new ue, ite = new ue, pa = [
    [
        0,
        0,
        0
    ],
    [
        0,
        0,
        0
    ],
    [
        0,
        0,
        0
    ]
];
function GM(n1) {
    let t = n1.elements;
    pa[0][0] = t[0], pa[0][1] = t[4], pa[0][2] = t[8], pa[1][0] = t[1], pa[1][1] = t[5], pa[1][2] = t[9], pa[2][0] = t[2], pa[2][1] = t[6], pa[2][2] = t[10];
    let { u: e, v: r } = (0, pV.SVD)(pa), i = rte.set(e[0][0], e[0][1], e[0][2], 0, e[1][0], e[1][1], e[1][2], 0, e[2][0], e[2][1], e[2][2], 0, 0, 0, 0, 1), s1 = ite.set(r[0][0], r[0][1], r[0][2], 0, r[1][0], r[1][1], r[1][2], 0, r[2][0], r[2][1], r[2][2], 0, 0, 0, 0, 1);
    return i.multiply(s1.transpose());
}
var y1 = class extends vh {
    constructor(){
        super(), this.layers.enable(3), this.layers.enable(8), this.layers.enable(9);
    }
    setFromCamera(t, e) {
        e.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, -1).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : e.isPerspectiveCamera ? (this.ray.origin.set(t.x, t.y, -1).unproject(e), this.ray.direction.set(t.x, t.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : console.error("Raycaster: Unsupported camera type.");
    }
    intersectVisibleObjects(t, e = !0, r = []) {
        return t.forEach((i)=>{
            i.visible && this.intersectObject(i, e, r);
        }), r;
    }
    createRaycastLineHelper() {
        let t = new ms({
            color: 65280,
            linewidth: 10
        }), e = new E(this.ray.origin.x, this.ray.origin.y, this.ray.origin.z), r = new E(this.ray.direction.x, this.ray.direction.y, this.ray.direction.z), i = this.camera.far - this.camera.near, s1 = new E().addVectors(e, r.multiplyScalar(i)), o = new Ce;
        return o.setFromPoints([
            e,
            s1
        ]), new Uc(o, t);
    }
};
var mV = (n1)=>n1 instanceof Ns || n1 instanceof ho;
function nte(n1, t) {
    return n1.distance - t.distance;
}
function gV(n1, t, e) {
    if (!(!Qo(t) || !t.visible)) {
        Wn(t) && t.raycast(n1, e);
        for (let r of t.children)gV(n1, r, e);
    }
}
function cp(n1, t, e, r = !1) {
    if (!r && !e.some((s1)=>up(n1, s1) !== void 0)) return [];
    let i = [];
    return t.children.forEach((s1)=>gV(n1, s1, i)), i.sort(nte), i;
}
function Hg(n1) {
    let t = [];
    if (n1.length) {
        let e = n1[0].object;
        Qo(e) && t.push(e);
        let r = e.parent;
        for(; r;)mV(r) && t.push(r), r = r.parent;
    }
    return t;
}
function vo(n1, t, e, r) {
    let i = n1.frame;
    if (i) {
        let s1 = t[0] * i.width, o = (1 - t[1]) * i.height;
        for (let a of e){
            let l = a === i.uuid ? i : i.find(a);
            if (l?.intersects(s1, o)) return r(l), !0;
        }
    }
    return !1;
}
function up(n1, t) {
    if (Wn(t)) {
        if (t.visible) {
            let e = [];
            return t.raycast(n1, e), e.length ? e[0] : void 0;
        }
    } else if (mV(t)) return yV(n1, t);
}
function yV(n1, t) {
    if (!(!Qo(t) || !t.visible)) {
        if (Wn(t)) {
            let e = [];
            if (t.raycast(n1, e), e.length) return e[0];
        }
        for (let e of t.children){
            let r = yV(n1, e);
            if (r) return r;
        }
    }
}
function ste(n1, t, e) {
    return {
        x: (n1 - (e.left + window.scrollX)) / e.width * 2 - 1,
        y: -((t - (e.top + window.scrollY)) / e.height) * 2 + 1
    };
}
function ote(n1, t, e) {
    return {
        x: (n1 - (e.left + window.scrollX)) / e.width,
        y: 1 - (t - (e.top + window.scrollY)) / e.height
    };
}
var v1 = class {
    constructor(t, e, r, i, s1, o, a, l){
        this.renderer = t;
        this.publish = e;
        this.scene = r;
        this.getCamera = i;
        this.sharedAssets = s1;
        this.requestRender = o;
        this.isExport = a;
        this.frame = l;
        this.raycaster = new y1;
        this._useWindowEvents = !1;
        this.pointerWorld = {
            x: 0,
            y: 0
        };
        this.pointerScreen = {
            x: 0,
            y: 0
        };
        this._useWindowEvents = e.mouseEventTarget === "window", this.domElement = t.domElement, this.eventElement = this._useWindowEvents ? window : t.domElement, this._domRect = this.domElement.getBoundingClientRect();
    }
    get stopRaycast() {
        return this.publish.stopRaycast;
    }
    get page() {
        return this.scene.activePage;
    }
    set useWindowEvents(t) {
        this._useWindowEvents = t, this.eventElement = t ? window : this.renderer.domElement;
    }
    get useWindowEvents() {
        return this._useWindowEvents;
    }
    set domRect(t) {
        this._domRect = t;
    }
    get domRect() {
        return this._domRect;
    }
    updateRaycaster(t) {
        let { pageX: e, pageY: r } = t.touches?.length > 0 ? t.touches[0] : t;
        this.pointerWorld = ste(e, r, this._domRect), this.pointerScreen = ote(e, r, this._domRect), this.raycaster.setFromCamera(this.pointerWorld, this.getCamera());
    }
};
var Qt = class {
    constructor(t){
        this.eventContext = t;
        this.domEventsNeeded = new Set;
        this.hasVideoAction = !1;
    }
    connect() {}
    disconnect() {}
};
var jM = [
    [
        "start",
        "Start"
    ],
    [
        "keyDown",
        "KeyDown"
    ],
    [
        "keyUp",
        "KeyUp"
    ],
    [
        "mouseDown",
        "MouseDown"
    ],
    [
        "mouseUp",
        "MouseUp"
    ],
    [
        "mouseHover",
        "MouseHover"
    ],
    [
        "collision",
        "Collision"
    ],
    [
        "lookAt",
        "LookAt"
    ],
    [
        "follow",
        "Follow"
    ],
    [
        "scroll",
        "Scroll"
    ]
], vV = (n1)=>jM.find(([t, e])=>e === n1)?.[0], ma = (n1)=>jM.find(([t])=>t === n1)?.[1], ate = (n1, t)=>{
    let e = vV(n1);
    if (e) {
        let r = new CustomEvent(e, {
            bubbles: !0
        });
        return Object.defineProperty(r, "target", {
            writable: !1,
            value: t
        }), r;
    }
}, x1 = class extends Qt {
    constructor(){
        super(...arguments);
        this.objectsPerEvents = new Map;
        this.splineEvents = {};
        this.onBeginEvent = (e)=>{
            if (!e.eventName || !e.target || e.eventName === "Scroll") return;
            let r = this.splineEvents[vV(e.eventName)]?.[e.target.uuid];
            if (!r) return;
            e.eventName === "Scroll" && e.deltaY !== void 0 && Object.assign(r, {
                deltaY: e.deltaY
            });
            let { domElement: i } = this.eventContext;
            i.dispatchEvent(r);
        };
    }
    connect() {
        let { page: e } = this.eventContext;
        e.traverseEntity((r)=>{
            if (!!r.data?.events.length) {
                for (let [i, s1] of jM)if (r.data.events.some((o)=>o.data.type === s1 && !o.data.disabled)) {
                    this.objectsPerEvents.has(i) ? this.objectsPerEvents.get(i)?.push(r) : this.objectsPerEvents.set(i, [
                        r
                    ]);
                    let o = {
                        id: r.uuid,
                        name: r.name
                    }, a = ate(s1, o), l = this.splineEvents[i];
                    l ? l[r.uuid] = a : this.splineEvents[i] = {
                        [r.uuid]: a
                    };
                }
            }
        }), this.objectsPerEvents.forEach((r)=>{
            r.forEach((i)=>{
                i.addEventListener("beginEvent", this.onBeginEvent);
            });
        });
    }
    disconnect() {
        this.objectsPerEvents.forEach((e)=>{
            e.forEach((r)=>{
                r.removeEventListener("beginEvent", this.onBeginEvent);
            });
        });
    }
};
var HM = class {
    constructor(t, e, r, i, s1, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.entered = !1;
        if ((e.type === "KeyDown" || e.type === "KeyUp" || e.type === "KeyPress") && !e.key) throw new Error("Missing property");
        this.actions = Wt(e, e.actions, i, s1, o, r);
    }
    disconnect() {
        vr(this.actions);
    }
    dispatchHeld(t) {
        this.actions.Create.forEach((e)=>{
            t && e.dispatchThrottled.cancel(), e.dispatchThrottled();
        });
    }
    dispatch(t = !1) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), this.data.type === "MousePress" || this.data.type === "KeyPress" ? this.entered || (this.entered = !0, this.actions.Transition.forEach((e)=>e.playFromCurrent()), this.actions.Animation.forEach((e)=>e.playFromCurrent()), this.actions.TimelineAnimation.forEach((e)=>e.playFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.playFromCurrent()), this.actions.Create.forEach((e)=>e.dispatchStart())) : (this.actions.Transition.some((i)=>i.playing && i.data.runMode !== "Toggle") || this.actions.Transition.forEach((i)=>{
            i.data.runMode === "Toggle" ? i.toggle() : i.play();
        }), this.actions.SwitchCamera.some((i)=>i.playing && i.data.runMode !== "Toggle") || this.actions.SwitchCamera.forEach((i)=>{
            i.data.runMode === "Toggle" ? i.toggle() : i.play();
        }), this.actions.Animation.forEach((i)=>{
            i.data.runMode === "Toggle" ? i.toggle() : i.play();
        }), this.actions.TimelineAnimation.forEach((i)=>{
            i.data.runMode === "Toggle" ? i.toggle() : i.play();
        })), this.actions.Link.forEach((e)=>{
            e.dispatch();
        }), this.actions.SceneTransition.forEach((e)=>{
            e.dispatch();
        }), t === !1 && this.actions.Create.forEach((e)=>{
            e.dispatch();
        }), this.actions.Destroy.forEach((e)=>{
            e.dispatch();
        }), this.actions.Reset.forEach((e)=>{
            e.dispatch();
        }), this.actions.Audio.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Video.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Particles.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.ClearLocalStorage.forEach((e)=>e.dispatch()), this.actions.UserAPI.forEach((e)=>e.dispatch());
    }
    dispatchRelease() {
        this.entered && (this.entered = !1, this.actions.Transition.forEach((t)=>t.reverseFromCurrent()), this.actions.Particles.forEach((t)=>t.reverseFromCurrent()), this.actions.Animation.forEach((t)=>t.reverseFromCurrent()), this.actions.SwitchCamera.forEach((t)=>t.reverseFromCurrent()), this.actions.Create.forEach((t)=>t.dispatchStop()));
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.Animation.forEach((e)=>e.reverseFromCurrent()), this.actions.TimelineAnimation.forEach((e)=>e.reverseFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>e.playFromCurrent()), this.actions.Animation.forEach((e)=>e.playFromCurrent()), this.actions.TimelineAnimation.forEach((e)=>e.playFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.playFromCurrent())), this.actions.Link.forEach((e)=>{
            e.dispatch();
        }), this.actions.SceneTransition.forEach((e)=>{
            e.dispatch();
        }), this.actions.Create.forEach((e)=>{
            e.dispatch();
        }), this.actions.Destroy.forEach((e)=>{
            e.dispatch();
        }), this.actions.Reset.forEach((e)=>{
            e.dispatch();
        }), this.actions.Audio.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Video.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Particles.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.ClearLocalStorage.forEach((e)=>e.dispatch()), this.actions.UserAPI.forEach((e)=>e.dispatch());
    }
}, b1 = class extends Qt {
    constructor(e, r, i){
        super(e);
        this.eventManager = r;
        this.useForRaycastProperty = i;
        this.objectsPerTypes = {
            MouseDown: [],
            MouseUp: [],
            MousePress: [],
            KeyDown: [],
            KeyUp: [],
            KeyPress: []
        };
        this.canvasMouseEvents = [];
        this.eventsPerObjects = {
            MouseDown: {},
            MouseUp: {},
            MousePress: {},
            KeyDown: {},
            KeyUp: {},
            KeyPress: {}
        };
        this.heldKeys = {};
        this.heldKeysPress = {};
        this._prevObjects = [];
        this.sceneInterects = null;
        this.onCanvasRaycast = (e)=>{
            if (this.useForRaycastProperty === !0 && this.sceneInterects === null) {
                this.eventContext.updateRaycaster(e);
                let { raycaster: r, page: i } = this.eventContext, s1 = cp(r, i, [], !0);
                this.sceneInterects = s1, s1.length && (this.eventContext.sharedAssets.raycastProperty = {
                    x: s1[0].point.x,
                    y: s1[0].point.y,
                    z: s1[0].point.z,
                    objX: s1[0].object.matrixWorld.elements[12],
                    objY: s1[0].object.matrixWorld.elements[13],
                    objZ: s1[0].object.matrixWorld.elements[14]
                });
            }
        };
        this.onCanvasMouseDown = (e)=>{
            (e.target === this.eventContext.domElement || e.target.tagName === "SPLINE-VIEWER") && this.canvasMouseEvents.forEach((r)=>{
                (r.data.type === "MouseDown" || r.data.type === "MousePress") && (this.onCanvasRaycast(e), r.dispatch());
            });
        };
        this.onCanvasMouseUp = (e)=>{
            (e.target === this.eventContext.domElement || e.target.tagName === "SPLINE-VIEWER") && this.canvasMouseEvents.forEach((r)=>{
                r.data.type === "MouseUp" ? (this.onCanvasRaycast(e), r.dispatch()) : r.data.type === "MousePress" && r.dispatchRelease();
            });
        };
        this.onMouseDown = (e)=>{
            et.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseEvent("MouseDown"));
        };
        this.onMouseUp = (e)=>{
            et.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseEvent("MouseUp"));
        };
        this.onMousePressDown = (e)=>{
            et.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMousePressEvent());
        };
        this.onMousePressRelease = (e)=>{
            et.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMousePressEvent(!0));
        };
        this.onKeyDown = (e)=>{
            this.heldKeys[e.key] || (this.handleKeyEvent(e, "KeyDown"), this.handleKeyEventHeld(e, "KeyDown", !0)), this.heldKeys[e.key] = !0;
        };
        this.onKeyUp = (e)=>{
            this.handleKeyEvent(e, "KeyUp"), this.handleKeyEventHeld(e, "KeyUp", !0);
        };
        this.onKeyPressDown = (e)=>{
            this.heldKeysPress[e.key] ? this.handleKeyEventHeld(e, "KeyPress") : (this.handleKeyEvent(e, "KeyPress"), this.handleKeyEventHeld(e, "KeyPress", !0)), this.heldKeysPress[e.key] = !0;
        };
        this.onKeyPressUp = (e)=>{
            this.handleKeyEvent(e, "KeyPress", !0);
        };
        this.releaseHeldKey = (e)=>{
            delete this.heldKeys[e.key];
        };
        this.releaseHeldKeyPress = (e)=>{
            delete this.heldKeysPress[e.key];
        };
        this._onUserEvent = ({ eventName: e, target: r, reverse: i })=>{
            if (!e || !r) return;
            let s1 = ma(e);
            s1 && (s1 === "MouseDown" || s1 === "MouseUp" || s1 === "MousePress" ? (r.dispatchEvent({
                type: "beginEvent",
                eventName: s1
            }), this.eventsPerObjects[s1]?.[r.uuid]?.forEach((o)=>{
                o.dispatchUserEvent(i);
            }), this.canvasMouseEvents.forEach((o)=>{
                o.dispatchUserEvent(i);
            })) : (s1 === "KeyDown" || s1 === "KeyUp" || s1 === "KeyPress") && (r.dispatchEvent({
                type: "beginEvent",
                eventName: s1
            }), this.eventsPerObjects[s1]?.[r.uuid]?.forEach((o)=>{
                o.dispatchUserEvent();
            })));
        };
    }
    connect() {
        let { page: e, sharedAssets: r, domElement: i } = this.eventContext, s1 = (o, a)=>{
            if (!o.data?.events.length) return;
            let l = [
                "MouseDown",
                "MouseUp",
                "MousePress",
                "KeyDown",
                "KeyUp",
                "KeyPress"
            ];
            for (let c of l){
                let u1 = this.eventsPerObjects[c];
                if (o.data.events.filter(({ data: h })=>h.type === c && h.disabled !== !0).forEach(({ id: h, data: d })=>{
                    try {
                        let f = new HM(h, d, o, e, r, this.eventManager);
                        f.actions.Video.length && (this.hasVideoAction = !0), (d.type === "MouseDown" || d.type === "MouseUp" || d.type === "MousePress") && (d.mode === "Canvas" || d.mode === "Window") ? this.canvasMouseEvents.push(f) : (u1[o.uuid] ? u1[o.uuid].some((m)=>m.id === f.id) || u1[o.uuid].push(f) : u1[o.uuid] = [
                            f
                        ], o instanceof cs && o.traverseChildren((m)=>{
                            if (!m.visible) return !0;
                            m instanceof Ct && "shapeBlendNode" in m.data.geometry && m.data.geometry.shapeBlendNode?.operation !== 2 && (u1[m.uuid] ? u1[m.uuid].push(f) : u1[m.uuid] = [
                                f
                            ]);
                        }));
                    } catch (f) {}
                }), u1[o.uuid]?.length && (this.objectsPerTypes[c].push(o instanceof hr && (c === "MouseDown" || c === "MouseUp" || c === "MousePress") ? a : o), o instanceof cs)) {
                    let h = this.objectsPerTypes[c];
                    o.traverseChildren((d)=>{
                        if (!d.visible) return !0;
                        d instanceof Ct && h.indexOf(d) === -1 && h.push(d);
                    });
                }
            }
        };
        e.traverseEntity((o)=>{
            (o instanceof _r || o instanceof yr) && o.frame?.traverse((a)=>{
                s1(a, o);
            }), s1(o);
        }), this.heldKeys = {}, this.heldKeysPress = {}, this.domEventsNeeded.clear(), i.addEventListener("pointerdown", this.onCanvasMouseDown), i.addEventListener("pointerup", this.onCanvasMouseUp), (this.objectsPerTypes.MouseDown?.length || this.useForRaycastProperty) && (this.domEventsNeeded.add("pointerdown"), i.addEventListener("pointerdown", this.onMouseDown)), this.objectsPerTypes.MouseUp?.length && (this.domEventsNeeded.add("pointerup"), i.addEventListener("pointerup", this.onMouseUp)), this.objectsPerTypes.MousePress?.length && (this.domEventsNeeded.add("pointerdown"), i.addEventListener("pointerdown", this.onMousePressDown), this.domEventsNeeded.add("pointerup"), i.addEventListener("pointerup", this.onMousePressRelease)), this.objectsPerTypes.KeyDown?.length && (this.domEventsNeeded.add("keydown"), document.addEventListener("keydown", this.onKeyDown), document.addEventListener("keyup", this.releaseHeldKey)), this.objectsPerTypes.KeyUp?.length && (this.domEventsNeeded.add("keyup"), document.addEventListener("keyup", this.onKeyUp)), this.objectsPerTypes.KeyPress?.length && (this.domEventsNeeded.add("keydown"), document.addEventListener("keydown", this.onKeyPressDown), document.addEventListener("keyup", this.releaseHeldKeyPress), this.domEventsNeeded.add("keyup"), document.addEventListener("keyup", this.onKeyPressUp)), Object.entries(this.objectsPerTypes).forEach(([o, a])=>{
            a.forEach((l)=>{
                l.addEventListener("userEvent", this._onUserEvent);
            });
        }), this.canvasMouseEvents.forEach((o)=>{
            o.object.addEventListener("userEvent", this._onUserEvent);
        });
    }
    disconnect() {
        let { domElement: e } = this.eventContext;
        this.domEventsNeeded.clear(), this.heldKeys = {}, this.heldKeysPress = {}, e.removeEventListener("pointerdown", this.onCanvasMouseDown), e.removeEventListener("pointerup", this.onCanvasMouseUp), e.removeEventListener("pointerdown", this.onMouseDown), e.removeEventListener("pointerdown", this.onMousePressDown), e.removeEventListener("pointerup", this.onMouseUp), e.removeEventListener("pointerup", this.onMousePressRelease), document.removeEventListener("keydown", this.onKeyDown), document.removeEventListener("keyup", this.onKeyUp), document.removeEventListener("keydown", this.onKeyPressDown), document.removeEventListener("keyup", this.onKeyPressUp), document.removeEventListener("keyup", this.releaseHeldKey), Object.values(this.eventsPerObjects).forEach((r)=>{
            Object.values(r).forEach((i)=>{
                i.forEach((s1)=>{
                    s1.disconnect();
                });
            });
        }), this.canvasMouseEvents.forEach((r)=>{
            r.disconnect();
        }), Object.entries(this.objectsPerTypes).forEach(([r, i])=>{
            i.forEach((s1)=>{
                s1.removeEventListener("userEvent", this._onUserEvent);
            });
        }), this.canvasMouseEvents.forEach((r)=>{
            r.object.removeEventListener("userEvent", this._onUserEvent);
        });
    }
    handleMouseEvent(e) {
        let { stopRaycast: r, raycaster: i, page: s1, pointerScreen: o } = this.eventContext, a = this.objectsPerTypes[e], l = a.filter((c)=>!(c instanceof hr));
        if (!(!a.length && !this.useForRaycastProperty) && !(s1.uiCanvas && vo(s1, [
            o.x,
            o.y
        ], Object.keys(this.eventsPerObjects[e]), (u1)=>{
            this.handleObjectMouseEventDispatch(u1, e);
        }))) {
            if (r || this.useForRaycastProperty) {
                let c;
                if (this.sceneInterects === null ? c = cp(i, s1, l, this.useForRaycastProperty) : (c = this.sceneInterects, this.sceneInterects = null), this.useForRaycastProperty && c.length && (this.eventContext.sharedAssets.raycastProperty = {
                    x: c[0].point.x,
                    y: c[0].point.y,
                    z: c[0].point.z,
                    objX: c[0].object.matrixWorld.elements[12],
                    objY: c[0].object.matrixWorld.elements[13],
                    objZ: c[0].object.matrixWorld.elements[14]
                }), r) {
                    let u1 = [
                        c[0]?.uv?.x ?? 0,
                        c[0]?.uv?.y ?? 0
                    ];
                    Hg(c).forEach((h)=>{
                        h instanceof _r && vo(h, u1, Object.keys(this.eventsPerObjects[e]), (d)=>{
                            this.handleObjectMouseEventDispatch(d, e);
                        }), this.eventsPerObjects[e][h.uuid] && this.handleObjectMouseEventDispatch(h, e);
                    });
                }
            }
            r || l.forEach((c)=>{
                let u1 = up(i, c);
                u1 && (this.handleObjectMouseEventDispatch(c, e), c instanceof _r && vo(c, [
                    u1?.uv?.x ?? 0,
                    u1?.uv?.y ?? 0
                ], Object.keys(this.eventsPerObjects[e]), (h)=>{
                    this.handleObjectMouseEventDispatch(h, e);
                }));
            });
        }
    }
    handleMousePressEvent(e = !1) {
        let r = "MousePress", i = this.objectsPerTypes[r], s1 = i.filter((a)=>!(a instanceof hr)), o = [];
        if (!!i.length) {
            if (!e) {
                let { stopRaycast: a, raycaster: l, page: c, pointerScreen: u1 } = this.eventContext, h = !1;
                if (c.uiCanvas && (h = vo(c, [
                    u1.x,
                    u1.y
                ], Object.keys(this.eventsPerObjects[r]), (d)=>{
                    o.push(d);
                })), a && !h) {
                    let d = cp(l, c, s1);
                    o = Hg(d), d.forEach((f)=>{
                        f.object instanceof _r && vo(f.object, [
                            f?.uv?.x ?? 0,
                            f?.uv?.y ?? 0
                        ], Object.keys(this.eventsPerObjects[r]), (m)=>{
                            o.push(m);
                        });
                    });
                } else s1.forEach((d)=>{
                    let f = up(l, d);
                    f && (o.push(d), d instanceof _r && vo(d, [
                        f?.uv?.x ?? 0,
                        f?.uv?.y ?? 0
                    ], Object.keys(this.eventsPerObjects[r]), (m)=>{
                        o.push(m);
                    }));
                });
            }
            this._prevObjects.length && this._prevObjects.forEach((a)=>{
                o.includes(a) || this.handleObjectMouseEventDispatchRelease(a, r);
            }), o.length && o.forEach((a)=>{
                this.handleObjectMouseEventDispatch(a, r);
            }), this._prevObjects = o;
        }
    }
    handleObjectMouseEventDispatch(e, r) {
        e.dispatchEvent({
            type: "beginEvent",
            eventName: r
        }), this.eventsPerObjects[r]?.[e.uuid]?.forEach((i)=>{
            i.dispatch();
        });
    }
    handleObjectMouseEventDispatchRelease(e, r) {
        e.dispatchEvent({
            type: "beginEvent",
            eventName: r
        }), this.eventsPerObjects[r]?.[e.uuid]?.forEach((i)=>{
            i.dispatchRelease();
        });
    }
    handleKeyEvent(e, r, i = !1) {
        this.objectsPerTypes[r].forEach((s1)=>{
            let o = this.eventsPerObjects[r][s1.uuid];
            o.some(({ data: a })=>"key" in a && a.key === e.key) && s1.dispatchEvent({
                type: "beginEvent",
                eventName: r
            }), o.forEach((a)=>{
                "key" in a.data && a.data.key === e.key && (i ? a.dispatchRelease() : a.dispatch(!0));
            });
        });
    }
    handleKeyEventHeld(e, r, i = !1) {
        this.objectsPerTypes[r].forEach((s1)=>{
            this.eventsPerObjects[r][s1.uuid].forEach((a)=>{
                "key" in a.data && a.data.key === e.key && a.dispatchHeld(i);
            });
        });
    }
};
var lte = new E, cte = new E;
var S1 = class {
    constructor(t, e, r, i, s1){
        this.actionsIn = Wt(t, t.inActions, r, i, s1, e), this.actionsOut = Wt(t, t.outActions, r, i, s1, e);
    }
    disconnect() {
        vr(this.actionsIn), vr(this.actionsOut);
    }
};
var WM = class extends S1 {
    constructor(e, r, i, s1, o, a){
        super(r, i, s1, o, a);
        this.id = e;
        this.data = r;
        this.object = i;
        this.stage = "out";
        this.objects = [];
        this.onUpdateMatrixWorld = ()=>{
            for (let s1 of this.objects)if (!s1.visible) return;
            let e = lte.setFromMatrixPosition(this.objects[0].matrixWorld), r = cte.setFromMatrixPosition(this.objects[1].matrixWorld), i = e.distanceTo(r) <= this.distance ? "in" : "out";
            if (this.stage !== i) {
                this.stage = i;
                let s1 = i === "in" ? this.actionsIn : this.actionsOut;
                s1.Audio.forEach((o)=>o.dispatchConditional()), s1.Particles.forEach((o)=>o.dispatchConditional()), s1.Video.forEach((o)=>o.dispatchConditional()), s1.Link.forEach((o)=>o.dispatch()), s1.Create.forEach((o)=>o.dispatch()), s1.Destroy.forEach((o)=>o.dispatch()), s1.Reset.forEach((o)=>o.dispatch()), s1.Transition.forEach((o)=>{
                    o.object.currentTransitionEvent !== this && (o.object.currentTransitionEvent = this), o.init();
                }), s1.Transition.forEach((o)=>o.play()), s1.Animation.forEach((o)=>o.play()), s1.TimelineAnimation.forEach((o)=>o.play()), s1.SwitchCamera.forEach((o)=>o.play()), s1.SceneTransition.forEach((o)=>o.dispatch()), s1.SetVariable.forEach((o)=>o.checkConditions()), s1.SetVariable.forEach((o)=>o.dispatch()), s1.DynamicVariablePlay.forEach((o)=>o.dispatch()), s1.ClearLocalStorage.forEach((o)=>o.dispatch()), s1.UserAPI.forEach((o)=>o.dispatch());
            }
        };
        let { distance: l, fromObject: c, toObject: u1 } = r.condition;
        this.distance = l;
        for (let h of [
            c,
            u1
        ]){
            if (!h) throw new Error("Missing property");
            let d = s1.find(h);
            if (!d) throw new Error("Missing property");
            this.objects.push(d);
        }
    }
    connect() {
        window.setTimeout(()=>{
            this.objects.forEach((e)=>{
                e.addEventListener("updateMatrixWorld", this.onUpdateMatrixWorld);
            }), this.onUpdateMatrixWorld();
        }, 0);
    }
    disconnect() {
        super.disconnect(), this.stage = "out", this.objects.forEach((e)=>{
            e.removeEventListener("updateMatrixWorld", this.onUpdateMatrixWorld);
        });
    }
}, qM = class extends S1 {
    constructor(e, r, i, s1, o, a){
        super(r, i, s1, o, a);
        this.id = e;
        this.data = r;
        this.object = i;
        this.onBegin = ({ target: e, state: r })=>{
            this.toState !== r && (this.actionsOut.Audio.forEach((i)=>i.dispatchConditional()), this.actionsOut.Particles.forEach((i)=>i.dispatchConditional()), this.actionsOut.Video.forEach((i)=>i.dispatchConditional()), this.actionsOut.Link.forEach((i)=>i.dispatch()), this.actionsOut.Create.forEach((i)=>i.dispatch()), this.actionsOut.Destroy.forEach((i)=>i.dispatch()), this.actionsOut.Reset.forEach((i)=>i.dispatch()), this.actionsIn.Transition.forEach((i)=>i.pause()), this.object.currentTransitionEvent = this, this.actionsOut.Transition.forEach((i)=>i.play()), this.actionsOut.Animation.forEach((i)=>i.play()), this.actionsOut.TimelineAnimation.forEach((i)=>i.play()), this.actionsIn.SwitchCamera.forEach((i)=>i.pause()), this.actionsOut.SwitchCamera.forEach((i)=>i.play()), this.actionsOut.SceneTransition.forEach((i)=>i.dispatch()), this.actionsOut.SetVariable.forEach((i)=>i.checkConditions()), this.actionsOut.SetVariable.forEach((i)=>i.dispatch()), this.actionsOut.DynamicVariablePlay.forEach((i)=>i.dispatch()), this.actionsOut.ClearLocalStorage.forEach((i)=>i.dispatch()), this.actionsOut.UserAPI.forEach((i)=>i.dispatch()));
        };
        this.onComplete = ({ target: e, state: r })=>{
            this.toState === r && (this.actionsIn.Audio.forEach((i)=>i.dispatchConditional()), this.actionsIn.Particles.forEach((i)=>i.dispatchConditional()), this.actionsIn.Video.forEach((i)=>i.dispatchConditional()), this.actionsIn.Link.forEach((i)=>i.dispatch()), this.actionsIn.Create.forEach((i)=>i.dispatch()), this.actionsIn.Destroy.forEach((i)=>i.dispatch()), this.actionsIn.Reset.forEach((i)=>i.dispatch()), this.actionsOut.Transition.forEach((i)=>i.pause()), this.actionsOut.Transition.forEach((i)=>i.pause()), this.object.currentTransitionEvent = this, this.actionsIn.Transition.forEach((i)=>i.play()), this.actionsIn.Animation.forEach((i)=>i.play()), this.actionsIn.TimelineAnimation.forEach((i)=>i.play()), this.actionsOut.SwitchCamera.forEach((i)=>i.pause()), this.actionsIn.SwitchCamera.forEach((i)=>i.play()), this.actionsIn.SceneTransition.forEach((i)=>i.dispatch()), this.actionsIn.SetVariable.forEach((i)=>i.checkConditions()), this.actionsIn.SetVariable.forEach((i)=>i.dispatch()), this.actionsIn.DynamicVariablePlay.forEach((i)=>i.dispatch()), this.actionsOut.ClearLocalStorage.forEach((i)=>i.dispatch()), this.actionsOut.UserAPI.forEach((i)=>i.dispatch()));
        };
        let { condition: l } = r;
        if (!l.object) throw new Error("Missing property");
        let c = s1.find(l.object) ?? s1.scene.find2D(l.object);
        if (!c) throw new Error("Missing property");
        if (this.toObject = c, l.state && !this.toObject.states?.[l.state]) throw new Error("Missing property");
        this.toState = l.state;
    }
    connect() {
        vs(this.actionsOut).forEach((e)=>{
            this.actionsOut[e]?.length && this.toObject.addEventListener("beginState", this.onBegin);
        }), vs(this.actionsIn).forEach((e)=>{
            this.actionsIn[e]?.length && this.toObject.addEventListener("completeState", this.onComplete);
        });
    }
    disconnect() {
        super.disconnect(), vs(this.actionsOut).forEach((e)=>{
            this.actionsIn[e]?.length && this.toObject.removeEventListener("beginState", this.onBegin);
        }), vs(this.actionsIn).forEach((e)=>{
            this.actionsIn[e]?.length && this.toObject.removeEventListener("completeState", this.onComplete);
        });
    }
}, w1 = class extends Qt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.eventsPerConditions = {
            Comparison: [],
            Distance: [],
            State: []
        };
        this.hasVideoAction = !1;
    }
    connect() {
        super.connect();
        let { page: e, sharedAssets: r } = this.eventContext;
        e.traverseEntity((i)=>{
            if (!!i.data?.events.length) {
                for (let { id: s1, data: o } of i.data.events)if (!o.disabled && o.type === "Conditional") try {
                    let a;
                    o.condition.type === "Comparison" || (o.condition.type === "Distance" ? a = new WM(s1, o, i, e, r, this.eventManager) : o.condition.type === "State" && (a = new qM(s1, o, i, e, r, this.eventManager))), a && (this.eventsPerConditions[o.condition.type].push(a), (a.actionsIn.Video.length || a.actionsOut.Video.length) && (this.hasVideoAction = !0));
                } catch (a) {}
            }
        }), Object.values(this.eventsPerConditions).forEach((i)=>i.forEach((s1)=>s1.connect()));
    }
    disconnect() {
        super.disconnect(), Object.values(this.eventsPerConditions).forEach((e)=>e.forEach((r)=>r.disconnect()));
    }
};
var Wg = new E, Ac = new E, Cu = new E, xV = new qr, ute = .01, dr = new E, Vi = new E, bV = new E, Pu = new Ye, XM = new Jt, hte = new ue, YM = new Sr, hp = new E, ga = new E, dp = .2;
function KM(n1, t) {
    !t || (t[0] < t[1] && (n1.x = Math.min(Math.max(n1.x, t[0]), t[1])), t[2] < t[3] && (n1.y = Math.min(Math.max(n1.y, t[2]), t[3])), t[4] < t[5] && (n1.z = Math.min(Math.max(n1.z, t[4]), t[5])));
}
var dte = function() {
    let n1 = new ue;
    return (t, e, r)=>{
        let i = t.obj;
        n1.copy(i.hiddenMatrix), i.parent !== null && n1.premultiply(i.parent.matrixWorld), n1.invert(), i.position.copy(e), t.reference === "global" && KM(i.position, t.limits), i.position.applyMatrix4(n1), t.reference === "parent" ? KM(i.position, t.limits) : t.reference === "local" && (Pu.copy(t.quat0).invert(), i.position.sub(t.position0), i.position.applyQuaternion(Pu), KM(i.position, t.limits), Pu.invert(), i.position.applyQuaternion(Pu), i.position.add(t.position0)), n1.multiply(r ?? i.matrixWorld).decompose(dr, i.quaternion, Vi), i.updateMatrix(), i.hasNonUniformScale && (i.updateMatrixWorld(), i.updateMatrixWorldSVD()), i instanceof nr && Dn(i.parent) && i.invalidateDownstreamBooleanData(!0);
    };
}(), QM = class {
    constructor(t, e, r, i, s1, o, a){
        this.object = t;
        this.id = e;
        this.data = r;
        this.dropDestIds = [];
        this.activeIdx = null;
        this.wasDragEventTriggered = !1;
        this.resetDampingFactor = this.data.resetSpeed === 0 ? 1 : 8 / this.data.resetSpeed + 1, this.snapDampingFactor = this.data.snapSpeed === 0 ? 1 : 8 / this.data.snapSpeed + 1, this.actionsDrag = Wt(r, r.dragDropActions.drag, i, s1, o, this.object), this.actionsDrop = Wt(r, r.dragDropActions.drop, i, s1, o, this.object);
        let l = [];
        this.data.objects.forEach((c)=>{
            let u1 = i.find(c);
            !u1 || u1.data.visible !== !1 && (l.push(u1), a[u1.uuid] && a[u1.uuid].forEach((h)=>{
                let d = i.find(h);
                !d || d.data.visible !== !1 && l.push(d);
            }));
        }), this.data.dropDestinations.forEach((c)=>{
            let u1 = i.find(c);
            !u1 || u1.data.visible !== !1 && (this.dropDestIds.push(u1.uuid), a[u1.uuid] && a[u1.uuid].forEach((h)=>{
                let d = i.find(h);
                !d || d.data.visible !== !1 && this.dropDestIds.push(d.uuid);
            }));
        }), this.dragItems = l.map((c)=>(this.data.planeMode === "locked" && (c.userData.lockedPlane = !0), c.userData.worldPosition0 = new E().setFromMatrixPosition(c.matrixWorld), {
                obj: c,
                fromPosition: new E().setFromMatrixPosition(c.matrixWorld),
                pointStart: new E,
                pointEnd: new E,
                paused: !0,
                currentDampingFactor: this.data.dampingFactor,
                reset: !1,
                position0: new E().copy(c.position),
                quat0: new Ye().copy(c.quaternion),
                snapped: !1,
                orientationMatrix: new ue,
                limits: this.data.limits,
                reference: this.data.referenceFrame
            }));
    }
    get activeDragItem() {
        return this.activeIdx !== null ? this.dragItems[this.activeIdx] : null;
    }
    dispose() {
        vr(this.actionsDrag), vr(this.actionsDrop), this.dragItems.forEach((t)=>{
            t.fromPosition.copy(t.obj.userData.worldPosition0), t.pointStart.copy(t.fromPosition), t.pointEnd.copy(t.pointStart), t.obj.recursiveBBoxNeedsUpdate = !0, t.obj.userData.lockedPlane = void 0, t.obj.position.copy(t.position0), t.obj.quaternion.copy(t.quat0), t.obj.updateMatrix();
        });
    }
}, A1 = class extends Qt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.events = [];
        this.lastDropDestination = null;
        this.dragTimeout = null;
        this.onPointerDown = (e)=>{
            if (et.length > 1) return;
            this.eventContext.updateRaycaster(e);
            let { raycaster: r, page: i } = this.eventContext, s1 = i.raycastWithClones(r);
            if (this.lastDropDestination = null, s1.length === 0) {
                this.activeEvent = null;
                return;
            }
            for (let o of this.events){
                let a = 0;
                for (let { obj: l, pointEnd: c, pointStart: u1 } of o.dragItems){
                    if (l === s1[0].object || l === s1[0].object.object || gt.is(l) && l.isAncestorOf(s1[0].object.uuid)) {
                        if (o.activeIdx = a, o.activeDragItem.reset = !1, o.activeDragItem.currentDampingFactor = o.data.dampingFactor, o.activeDragItem.snapped = !1, o.data.cursor === "hand" && this.setCursor("grabbing"), this.eventManager.controlsManager.usePhysics) {
                            o.activeDragItem.obj.rigidBody && o.activeDragItem.obj.rigidBody.setBodyType(2, !0);
                            let h = o.activeDragItem.obj;
                            l.hasNonUniformScale && l.updateMatrixWorldSVD(), (h.hasNonUniformScale ? h.matrixWorldRigid : h.matrixWorld).decompose(dr, Pu, Vi), XM.setFromQuaternion(Pu), h.prevR === void 0 ? (h.prevR = XM.clone(), h.prevT = dr.clone()) : (h.prevR.copy(XM), h.prevT.copy(dr)), this.eventManager.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.push(o.activeDragItem.obj);
                        }
                        this.calcPlaneIntersectPos(l, u1, o.data.plane, o.data.referenceFrame), c.copy(u1), (this.eventManager.controlsManager.usePhysics && l.data.physics?.rigidBody === "dynamic" || o.data.drop === !1 || o.data.resetOnSnapFail === !1) && o.activeDragItem.fromPosition.setFromMatrixPosition(o.activeDragItem.obj.matrixWorld), this.activeEvent = o, this.eventManager.controlsManager.orbitControls && (this.eventManager.controlsManager.orbitControls.enabled = !1);
                        return;
                    }
                    a++;
                }
            }
            this.activeEvent = null;
        };
        this.onPointerMove = (e)=>{
            if (et.length > 1) return;
            this.eventContext.updateRaycaster(e);
            let { raycaster: r, page: i } = this.eventContext, s1 = i.raycastWithClones(r);
            if (et.length === 0) {
                let o = !1;
                for (let a of this.events){
                    for (let { obj: l } of a.dragItems)if (l === s1[0]?.object || l === s1[0]?.object?.object || gt.is(l) && l.isAncestorOf(s1[0]?.object.uuid)) {
                        switch(o = !0, a.data.cursor){
                            case "hand":
                                this.setCursor("grab");
                                break;
                            case "move":
                                this.setCursor("move");
                                break;
                            default:
                                break;
                        }
                        break;
                    }
                    if (o) break;
                }
                o || this.setCursor("default");
                return;
            }
            if (this.activeEvent && this.activeEvent.activeDragItem) {
                let o = this.activeEvent.activeDragItem;
                o.snapped = !1;
                let a;
                if (this.activeEvent.data.drop && (a = s1.filter((l)=>o.obj !== l.object && !o.obj.isAncestorOf(l.object.uuid) && !(l.object instanceof Ns) && (this.activeEvent.data.dropOn === "all" || this.activeEvent.dropDestIds.some((c)=>c === l.object.uuid || i.scene.find(c).isAncestorOf(l.object.uuid))))[0]), a) {
                    let l = bV.copy(a.face.normal).applyMatrix3(YM.getNormalMatrix(a.object.matrixWorld));
                    if (this.activeEvent.data.snapTo === "center") o.fromPosition.setFromMatrixPosition(a.object.matrixWorld);
                    else if (this.activeEvent.data.snapTo === "surface") {
                        if (o.fromPosition.copy(a.point), this.activeEvent.data.snapSurfaceMode === "bbox") {
                            dr.copy(l).applyMatrix3(YM.setFromMatrix4(o.obj.matrixWorld).transpose());
                            let c = o.obj;
                            dr.x > dp ? Vi.x = -c.recursiveBBox.min.x : dr.x < -dp && (Vi.x = -c.recursiveBBox.max.x), dr.y > dp ? Vi.y = -c.recursiveBBox.min.y : dr.y < -dp && (Vi.y = -c.recursiveBBox.max.y), dr.z > dp ? Vi.z = -c.recursiveBBox.min.z : dr.z < -dp && (Vi.z = -c.recursiveBBox.max.z), Vi.applyMatrix3(YM.invert());
                        } else Vi.copy(l).multiplyScalar(this.activeEvent.data.snapSurfaceOffset);
                        o.fromPosition.add(Vi);
                    }
                    this.activeEvent.data.autoOrient && (dr.set(0, 1, 0).cross(l), dr.length() < 1e-4 && dr.set(-1, 0, 0).cross(l), Vi.crossVectors(bV, dr), o.orientationMatrix.makeBasis(dr, Vi, l)), o.pointStart.copy(o.fromPosition), o.pointEnd.copy(o.pointStart), o.currentDampingFactor = this.activeEvent.snapDampingFactor, o.snapped = !0, this.lastDropDestination !== a.object && (this.lastDropDestination = a.object, this.activeEvent.actionsDrop.Transition.forEach((c)=>{
                        c.play();
                    }), this.activeEvent.actionsDrop.Animation.forEach((c)=>{
                        c.play();
                    }), this.activeEvent.actionsDrop.Audio.forEach((c)=>{
                        c.dispatchGameControl("start");
                    }), this.activeEvent.actionsDrop.Particles.forEach((c)=>{
                        c.dispatchGameControl("start");
                    }), this.activeEvent.actionsDrop.Create.forEach((c)=>{
                        c.dispatchThrottled();
                    }));
                } else o.orientationMatrix.makeRotationFromQuaternion(o.quat0), this.lastDropDestination = null, o.currentDampingFactor = this.activeEvent.data.dampingFactor, this.calcPlaneIntersectPos(o.obj, o.pointEnd, this.activeEvent.data.plane, this.activeEvent.data.referenceFrame), this.activeEvent.actionsDrop.Transition.forEach((l)=>{
                    l.stop(), l.object.currentState !== null && l.object.changeSelectedState(null, {
                        scene: this.eventContext.page.scene,
                        shared: this.eventContext.sharedAssets
                    });
                }), this.activeEvent.actionsDrop.Animation.forEach((l)=>{
                    l.stop();
                }), this.activeEvent.actionsDrop.Audio.forEach((l)=>{
                    l.dispatchGameControl("stop");
                }), this.activeEvent.actionsDrop.Particles.forEach((l)=>{
                    l.dispatchGameControl("stop");
                });
                this.activeEvent.actionsDrag.Create.forEach((l)=>{
                    l.dispatchThrottled();
                }), this.activeEvent.actionsDrag.SetVariable.forEach((l)=>l.checkConditions()), this.activeEvent.actionsDrag.SetVariable.forEach((l)=>l.dispatch()), this.activeEvent.actionsDrag.DynamicVariablePlay.forEach((l)=>l.dispatch()), this.activeEvent.actionsDrag.ClearLocalStorage.forEach((l)=>l.dispatch()), this.activeEvent.actionsDrag.UserAPI.forEach((l)=>l.dispatch()), this.activeEvent.wasDragEventTriggered === !1 && (this.activeEvent.wasDragEventTriggered = !0, this.activeEvent.actionsDrag.Transition.forEach((l)=>{
                    l.play();
                }), this.activeEvent.actionsDrag.Animation.forEach((l)=>{
                    l.play();
                }), this.activeEvent.actionsDrag.Audio.forEach((l)=>{
                    l.dispatchGameControl("start");
                }), this.activeEvent.actionsDrag.Particles.forEach((l)=>{
                    l.dispatchGameControl("start");
                })), this.dragTimeout && window.clearTimeout(this.dragTimeout), this.dragTimeout = window.setTimeout(()=>{
                    !this.activeEvent || (this.activeEvent.wasDragEventTriggered = !1, this.activeEvent.actionsDrag.Audio.forEach((l)=>{
                        l.dispatchGameControl("stop");
                    }), this.activeEvent.actionsDrag.Particles.forEach((l)=>{
                        l.dispatchGameControl("stop");
                    }), this.activeEvent.actionsDrag.Transition.forEach((l)=>{
                        l.stop(), l.object.currentState !== null && l.object.changeSelectedState(null, {
                            scene: this.eventContext.page.scene,
                            shared: this.eventContext.sharedAssets
                        });
                    }), this.activeEvent.actionsDrag.Animation.forEach((l)=>{
                        l.stop();
                    }));
                }, 500), this.updateDragItem(o), o.obj.dispatchEvent({
                    type: "requestRender"
                });
            }
        };
        this.onPointerUp = (e)=>{
            if (this.activeEvent && this.activeEvent.activeDragItem) {
                this.activeEvent.data.cursor === "hand" && this.setCursor("grab");
                let r = this.activeEvent.activeDragItem.obj.data.physics?.rigidBody === "dynamic";
                this.activeEvent.activeDragItem.snapped === !1 && this.activeEvent.data.drop && this.activeEvent.data.resetOnSnapFail && (this.eventManager.controlsManager.usePhysics === !1 || !r) && (this.activeEvent.activeDragItem.reset = this.activeEvent.data.resetOnSnapFail, this.activeEvent.activeDragItem.paused = !1, this.activeEvent.activeDragItem.currentDampingFactor = this.activeEvent.resetDampingFactor), this.eventManager.controlsManager.usePhysics && r && (this.eventManager.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.pop(), this.activeEvent.activeDragItem.obj.rigidBody.setBodyType(0, !0), this.activeEvent.activeDragItem.paused = !0), this.activeEvent.wasDragEventTriggered === !0 && (this.activeEvent.wasDragEventTriggered = !1, this.activeEvent.actionsDrag.Transition.forEach((i)=>{
                    i.stop(), i.object.currentState !== null && i.object.changeSelectedState(null, {
                        scene: this.eventContext.page.scene,
                        shared: this.eventContext.sharedAssets
                    });
                }), this.activeEvent.actionsDrag.Animation.forEach((i)=>{
                    i.stop();
                }), this.activeEvent.actionsDrag.Audio.forEach((i)=>{
                    i.dispatchGameControl("stop");
                }), this.activeEvent.actionsDrag.Particles.forEach((i)=>{
                    i.dispatchGameControl("stop");
                }), this.activeEvent.actionsDrop.SetVariable.forEach((i)=>i.checkConditions()), this.activeEvent.actionsDrop.SetVariable.forEach((i)=>i.dispatch()), this.activeEvent.actionsDrop.DynamicVariablePlay.forEach((i)=>i.dispatch()), this.activeEvent.actionsDrop.ClearLocalStorage.forEach((i)=>i.dispatch()), this.activeEvent.actionsDrop.UserAPI.forEach((i)=>i.dispatch())), this.eventManager.controlsManager.orbitControls && (this.eventManager.controlsManager.orbitControls.enabled = !0);
            }
        };
    }
    connect() {
        let e = {};
        if (this.eventContext.page.traverseEntity((i)=>{
            i.component && (e[i.component.uuid] ? e[i.component.uuid].push(i.uuid) : e[i.component.uuid] = [
                i.uuid
            ]);
        }), this.eventContext.page.traverseEntity((i)=>{
            i.data?.events.filter((s1)=>s1.data.type === "DragDrop" && !s1.data.disabled).forEach((s1)=>{
                this.events.push(new QM(i, s1.id, s1.data, this.eventContext.page, this.eventContext.sharedAssets, this.eventManager, e));
            });
        }), !this.events.length) return;
        this.domEventsNeeded.clear(), this.domEventsNeeded.add("pointerdown");
        let r = this.eventContext.domElement;
        r.addEventListener("pointerdown", this.onPointerDown), r.addEventListener("pointermove", this.onPointerMove), r.addEventListener("pointerup", this.onPointerUp), this.domEventsNeeded.add("pointermove");
    }
    disconnect() {
        if (!this.events.length) return;
        this.domEventsNeeded.clear();
        let e = this.eventContext.domElement;
        e.removeEventListener("pointerdown", this.onPointerDown), e.removeEventListener("pointermove", this.onPointerMove), e.removeEventListener("pointerup", this.onPointerUp), this.events.forEach((r)=>r.dispose());
    }
    setCursor(e) {
        this.eventContext.domElement.style.cursor = e;
    }
    onAnimationFrameDamping() {
        for (let e of this.events)for (let r of e.dragItems)r.paused || this.updateDragItem(r, !0);
    }
    calcPlaneIntersectPos(e, r, i, s1) {
        let { getCamera: o, raycaster: a } = this.eventContext;
        o().getWorldDirection(Ac), Ac.negate();
        let l = Pu.identity();
        switch(s1 === "parent" ? hte.multiplyMatrices(e.parent.matrixWorld, e.hiddenMatrix).decompose(dr, l, Vi) : s1 === "local" && e.matrixWorld.decompose(dr, l, Vi), i){
            case "x":
                dr.set(1, 0, 0).applyQuaternion(l), hp.copy(Ac).cross(dr), ga.copy(dr).cross(hp);
                break;
            case "y":
                dr.set(0, 1, 0).applyQuaternion(l), hp.copy(Ac).cross(dr), ga.copy(dr).cross(hp);
                break;
            case "z":
                dr.set(0, 0, 1).applyQuaternion(l), hp.copy(Ac).cross(dr), ga.copy(dr).cross(hp);
                break;
            case "xy":
                ga.set(0, 0, 1).applyQuaternion(l);
                break;
            case "yz":
                ga.set(1, 0, 0).applyQuaternion(l);
                break;
            case "xz":
                ga.set(0, 1, 0).applyQuaternion(l);
                break;
            case "adaptive":
                Ac.angleTo(Vi.set(0, 1, 0)) > Math.PI / 6 ? (dr.crossVectors(Vi.set(0, 1, 0), Ac), ga.crossVectors(dr, Vi)) : ga.set(0, 1, 0);
                break;
            default:
                ga.copy(Ac);
                break;
        }
        Cu.setFromMatrixPosition(e.matrixWorld);
        let c = e.userData.lockedPlane ? e.userData.worldPosition0 : Cu;
        if (xV.setFromNormalAndCoplanarPoint(ga, c), !!a.ray.intersectPlane(xV, r) && (i === "x" || i === "y" || i === "z")) {
            let u1 = Vi.subVectors(r, c).dot(dr);
            r.copy(c).addScaledVector(dr, u1);
        }
    }
    updateDragItem(e, r = !1) {
        Cu.setFromMatrixPosition(e.obj.matrixWorld), e.reset === "current" ? Wg.subVectors(e.fromPosition, Cu).divideScalar(e.currentDampingFactor) : e.reset === "original" ? (Wg.subVectors(e.obj.userData.worldPosition0, Cu).divideScalar(e.currentDampingFactor), e.fromPosition.copy(e.obj.userData.worldPosition0), e.pointStart.copy(e.fromPosition), e.pointEnd.copy(e.pointStart)) : Wg.subVectors(e.pointEnd, e.pointStart).add(e.fromPosition).sub(Cu).divideScalar(e.currentDampingFactor), e.paused = e.currentDampingFactor > 1 ? Wg.length() < ute : !0, (this.activeEvent && this.activeEvent.data.dampingFactor === 1 || r) && dte(e, Wg.add(Cu), this.activeEvent?.data.drop && this.activeEvent?.data.autoOrient ? e.orientationMatrix : null), e.obj.dispatchEvent({
            type: "beginEvent",
            eventName: "DragDrop"
        }), this.eventManager.requestRender();
    }
};
var fp = new E, ZM = new E, ol = new E, al = new E, SV = new qr, fte = .01, pte = {
    type: "requestRender"
}, mte = function() {
    let n1 = new E, t = new E;
    return (e, r, i)=>i > 0 ? (n1.subVectors(e, r), n1.length() <= i ? e : t.copy(r).add(n1.normalize().multiplyScalar(i))) : r;
}(), wV = function() {
    let n1 = new ue;
    return (t, e)=>{
        t.position.copy(e), t.parent !== null && (n1.copy(t.parent.matrixWorld).invert(), t.position.applyMatrix4(n1)), n1.copy(t.hiddenMatrix).invert(), t.position.applyMatrix4(n1), t.updateMatrix(), t.hasNonUniformScale && (t.updateMatrixWorld(), t.updateMatrixWorldSVD()), t instanceof nr && Dn(t.parent) && t.invalidateDownstreamBooleanData(!0);
    };
}(), JM = class {
    constructor(t, e, r, i, s1, o){
        this.data = t;
        this.id = e;
        this.object = r;
        this.paused = !1;
        this.currentDampingFactor = 1;
        this.snapComplete = !1;
        this.isReset = !1;
        this.worldPosition0 = new E;
        this.timeoutId = null;
        this.delayFinished = !0;
        this.wasOutside = !1;
        this.data = {
            ...g0.defaultData,
            ...t,
            ...t.resetOnPointerLeave === void 0 && {
                resetOnPointerLeave: !1
            }
        }, t.target === void 0 || t.target === "cursor" || (this.target = i.find(t.target)), this.data.dampingFactor && (this.currentDampingFactor = this.data.dampingFactor), this.resetDampingFactor = 80 / this.data.resetSpeed + 1, this.object.getWorldPosition(this.worldPosition0), this.actions = Wt(t, t.actions, i, s1, o, r);
    }
}, E1 = class extends Qt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.events = [];
        this.pairOfEventListeners = [];
        this.onMouseMove = (e)=>{
            if (!(et.length > 1)) {
                this.eventContext.updateRaycaster(e);
                for (let r of this.events)r.target === void 0 && this.updateSingleEvent(r);
            }
        };
        this.onMouseEnter = (e)=>{
            for (let r of this.events)r.target === void 0 && (r.isReset = !1, r.currentDampingFactor = r.data.dampingFactor);
        };
        this.onMouseLeave = (e)=>{
            for (let r of this.events)r.target === void 0 && (r.data.resetOnPointerLeave && (r.isReset = !0, r.currentDampingFactor = r.resetDampingFactor), this.updateSingleEvent(r));
        };
        this.onTargetChange = (e)=>()=>{
                this.updateSingleEvent(e);
            };
    }
    connect() {
        let { page: e } = this.eventContext;
        if (e.traverseEntity((s1)=>{
            let o = s1.data?.events.find((a)=>a.data.type === "Follow" && !a.data.disabled);
            o && (!e.data.globalPhysics.usePhysics || s1.dataPatched.physics?.rigidBody !== "dynamic") && this.events.push(new JM(o.data, o.id, s1, e, this.eventContext.sharedAssets, this.eventManager));
        }), !this.events.length) return;
        let { domElement: r, eventElement: i } = this.eventContext;
        this.domEventsNeeded.clear(), Li && (this.domEventsNeeded.add("pointerdown"), r.addEventListener("pointerdown", this.onMouseMove)), this.domEventsNeeded.add("pointermove"), i.addEventListener("pointermove", this.onMouseMove), this.eventContext.useWindowEvents || (r.addEventListener("pointerenter", this.onMouseEnter), r.addEventListener("pointerleave", this.onMouseLeave));
        for (let s1 of this.events)if (s1.target !== void 0) {
            let o = s1.target, a = this.onTargetChange(s1);
            this.pairOfEventListeners.push([
                o,
                a
            ]), o.addEventListener("requestRender", a);
        }
    }
    disconnect() {
        if (!this.events.length) return;
        let { domElement: e, eventElement: r } = this.eventContext;
        this.domEventsNeeded.clear(), Li && e.removeEventListener("pointerdown", this.onMouseMove), r.removeEventListener("pointermove", this.onMouseMove), e.removeEventListener("pointerenter", this.onMouseEnter), e.removeEventListener("pointerleave", this.onMouseLeave);
        for (let [i, s1] of this.pairOfEventListeners)i.removeEventListener("requestRender", s1);
        for (let i of this.events)i.paused = !0, i.isReset = !1, vr(i.actions);
    }
    onAnimationFrameDamping() {
        for (let e of this.events)e.paused || this.updateSingleEvent(e, !0);
    }
    updateSingleEvent(e, r = !1) {
        this.events.forEach((l)=>{
            l.actions.Create.forEach((c)=>{
                c.dispatchThrottled();
            });
        });
        let { plane: i, limitDistance: s1, limitDistanceEnabled: o } = e.data;
        if (e.object.getWorldPosition(ol), e.isReset) al.copy(e.worldPosition0);
        else if (e.target) e.target.getWorldPosition(al);
        else {
            let { getCamera: l, raycaster: c } = this.eventContext;
            if (i === "custom" ? (l().getWorldDirection(ZM), ZM.negate(), fp.copy(ZM)) : i === "xy" ? fp.set(0, 0, 1) : i === "xz" ? fp.set(0, 1, 0) : i === "yz" && fp.set(1, 0, 0), SV.setFromNormalAndCoplanarPoint(fp, ol), !c.ray.intersectPlane(SV, al)) return;
        }
        if (!e.isReset) {
            if (al.distanceTo(e.worldPosition0) > s1 && o && e.target) {
                if (e.snapComplete = !1, e.data.snapDelay && (e.delayFinished = !1, typeof window < "u" && e.timeoutId !== null && (window.clearTimeout(e.timeoutId), e.timeoutId = null)), e.wasOutside = !0, e.data.resetAfterDistanceLimit) al.copy(e.worldPosition0), e.currentDampingFactor = e.resetDampingFactor;
                else return;
            } else if (e.wasOutside && (e.data.snapDelay && typeof window < "u" && (e.timeoutId = window.setTimeout(()=>{
                e.delayFinished = !0, e.paused = !1, this.updateSingleEvent(e);
            }, e.data.snapDelay * 1e3)), e.currentDampingFactor = e.data.dampingFactor, e.wasOutside = !1), e.delayFinished === !1) return;
        }
        e.data.enabledTranslation[0] === !1 && (al.x = ol.x), e.data.enabledTranslation[1] === !1 && (al.y = ol.y), e.data.enabledTranslation[2] === !1 && (al.z = ol.z);
        let a = mte(ol, al, e.wasOutside ? 0 : e.data.maxDelta);
        if (e.currentDampingFactor > 1) {
            let l = fp.subVectors(a, ol).divideScalar(e.currentDampingFactor);
            ol.add(l), r && wV(e.object, ol), e.paused = l.length() < fte;
        } else wV(e.object, a), e.paused = !0;
        e.object?.dispatchEvent({
            type: "beginEvent",
            eventName: "Follow"
        }), e.object.dispatchEvent(pte);
    }
};
var qg = new E, T1 = new E, Xg = new ue, pp = new Ye, Ec = new Ye, Yg = new E, Kg = new E, _u = new E, ll = new E, $M = new qr, gte = 1e-6, yte = {
    type: "requestRender"
}, vte = {
    type: "changeRotation"
}, AV = function() {
    let n1 = new ue;
    return function(e, r) {
        e.parent !== null ? n1.multiplyMatrices(e.parent.matrixWorld, e.hiddenMatrix) : n1.copy(e.hiddenMatrix), r.premultiply(GM(n1).invert()), e.rotation.setFromRotationMatrix(r), e.updateMatrix(), e instanceof nr && Dn(e.parent) && e.invalidateDownstreamBooleanData(!0);
    };
}(), eC = class {
    constructor(t, e, r, i){
        this.id = e;
        this.object = r;
        this.paused = !1;
        this.currentDampingFactor = 1;
        this.isReset = !1;
        this.worldQuaternion0 = new Ye;
        this.timeoutId = null;
        this.delayFinished = !0;
        this.wasOutside = !1;
        this.data = {
            ...y0.defaultData,
            ...t,
            ...t.resetOnPointerLeave === void 0 && {
                resetOnPointerLeave: !1
            }
        }, t.target === void 0 || t.target === "cursor" || (this.target = i.find(t.target)), this.data.dampingFactor && (this.currentDampingFactor = this.data.dampingFactor), this.object.getWorldQuaternion(this.worldQuaternion0), isNaN(this.worldQuaternion0.x) && (this.worldQuaternion0.x = 0), isNaN(this.worldQuaternion0.y) && (this.worldQuaternion0.y = 0), isNaN(this.worldQuaternion0.z) && (this.worldQuaternion0.z = 0), isNaN(this.worldQuaternion0.w) && (this.worldQuaternion0.w = 1), this.resetDampingFactor = 80 / this.data.resetSpeed + 1;
    }
}, M1 = class extends Qt {
    constructor(){
        super(...arguments);
        this.events = [];
        this.pairOfEventListeners = [];
        this.pairOfUserEventListeners = [];
        this.onMouseMove = (e)=>{
            if (!(et.length > 1)) {
                this._lastMouseEvent = e, this.eventContext.updateRaycaster(e);
                for (let r of this.events)r.target === void 0 && this.updateSingleEvent(r);
            }
        };
        this.onMouseEnter = (e)=>{
            for (let r of this.events)r.target === void 0 && (r.isReset = !1, r.currentDampingFactor = r.data.dampingFactor);
        };
        this.onMouseLeave = (e)=>{
            for (let r of this.events)r.target === void 0 && (r.data.resetOnPointerLeave && (r.isReset = !0, r.currentDampingFactor = r.resetDampingFactor), this.updateSingleEvent(r));
        };
        this.onScroll = (e)=>{
            if (this._lastMouseEvent) {
                let r = new PointerEvent("pointermove", {
                    clientX: this._lastMouseEvent.clientX,
                    clientY: this._lastMouseEvent.clientY,
                    bubbles: !0,
                    cancelable: !0,
                    view: window
                });
                this.eventContext.eventElement.dispatchEvent(r);
            }
        };
        this.onTargetChange = (e)=>()=>{
                this.updateSingleEvent(e);
            };
        this.createUserEventListener = (e)=>({ eventName: r, target: i })=>{
                if (!r || !i) return;
                let s1 = ma(r);
                s1 && s1 === "LookAt" && this.updateSingleEvent(e);
            };
    }
    connect() {
        let { page: e } = this.eventContext;
        if (e.traverseEntity((s1)=>{
            let o = s1.data?.events.find((a)=>a.data.type === "LookAt" && !a.data.disabled);
            o && (!e.data.globalPhysics.usePhysics || s1.dataPatched.physics?.rigidBody !== "dynamic") && this.events.push(new eC(o.data, o.id, s1, e));
        }), !this.events.length) return;
        let { domElement: r, eventElement: i } = this.eventContext;
        this.domEventsNeeded.clear(), Li && (this.domEventsNeeded.add("pointerdown"), r.addEventListener("pointerdown", this.onMouseMove)), this.domEventsNeeded.add("pointermove"), i.addEventListener("pointermove", this.onMouseMove), this.eventContext.useWindowEvents ? i.addEventListener("scroll", this.onScroll) : (r.addEventListener("pointerenter", this.onMouseEnter), r.addEventListener("pointerleave", this.onMouseLeave));
        for (let s1 of this.events){
            if (s1.target !== void 0) {
                let l = this.onTargetChange(s1), c = s1.target;
                this.pairOfEventListeners.push([
                    c,
                    l
                ]), c.addEventListener("requestRender", l);
            }
            let o = this.createUserEventListener(s1), a = s1.object;
            this.pairOfUserEventListeners.push([
                a,
                o
            ]), a.addEventListener("userEvent", o);
        }
    }
    disconnect() {
        if (!this.events.length) return;
        let { domElement: e, eventElement: r } = this.eventContext;
        this.domEventsNeeded.clear(), Li && e.removeEventListener("pointerdown", this.onMouseMove), r.removeEventListener("pointermove", this.onMouseMove), e.removeEventListener("pointerenter", this.onMouseEnter), e.removeEventListener("pointerleave", this.onMouseLeave), r.removeEventListener("scroll", this.onScroll);
        for (let [i, s1] of this.pairOfEventListeners)i.removeEventListener("requestRender", s1);
        for (let [i, s1] of this.pairOfUserEventListeners)i.removeEventListener("userEvent", s1);
        for (let i of this.events)i.paused = !0, i.isReset = !1;
    }
    onAnimationFrameDamping() {
        for (let e of this.events)e.paused || this.updateSingleEvent(e);
    }
    updateSingleEvent(e) {
        let { tilt: r, axis: i, distance: s1, plane: o, limitDistance: a, enabledRotation: l, limitDistanceEnabled: c } = e.data, { getCamera: u1, raycaster: h } = this.eventContext, { object: d, target: f } = e;
        if (d.getWorldPosition(Yg), !e.isReset) {
            if (e.target) e.target.getWorldPosition(Kg);
            else {
                if (o === "custom" ? (u1().getWorldDirection(T1), T1.negate(), $M.setFromNormalAndCoplanarPoint(T1, Yg)) : (o === "xy" ? qg.set(0, 0, 1) : o === "xz" ? qg.set(0, 1, 0) : o === "yz" && qg.set(1, 0, 0), $M.setFromNormalAndCoplanarPoint(qg, Yg)), !h.ray.intersectPlane($M, Kg)) return;
                s1 > 0 && (o === "custom" || o === void 0) && Kg.addScaledVector(T1, s1);
            }
        }
        if (e.isReset || (f ? r === "target" ? _u.copy(f.up).applyMatrix4(Xg.extractRotation(f.matrixWorld)).normalize() : l.some((m)=>m === !1) ? (i === "x" ? (ll.set(0, 0, 1), l[2] === !1 && ll.set(0, 1, 0)) : i === "y" ? (ll.set(1, 0, 0), l[0] === !1 && ll.set(0, 0, 1)) : (ll.set(0, 1, 0), l[1] === !1 && ll.set(1, 0, 0)), _u.copy(ll).applyQuaternion(e.worldQuaternion0).normalize()) : _u.set(0, 1, 0) : o === "custom" ? _u.set(0, 1, 0) : _u.copy(qg)), e.isReset) Ec.copy(e.worldQuaternion0);
        else if (Yg.distanceTo(Kg) > a && c && f) {
            if (e.data.snapDelay && (e.delayFinished = !1, typeof window < "u" && e.timeoutId !== null && (window.clearTimeout(e.timeoutId), e.timeoutId = null)), e.wasOutside = !0, e.data.resetAfterDistanceLimit) Ec.copy(e.worldQuaternion0), e.currentDampingFactor = e.resetDampingFactor;
            else return;
        } else {
            if (e.wasOutside && (e.data.snapDelay && typeof window < "u" && (e.timeoutId = window.setTimeout(()=>{
                e.delayFinished = !0, e.paused = !1, this.updateSingleEvent(e);
            }, e.data.snapDelay * 1e3)), e.currentDampingFactor = e.data.dampingFactor, e.wasOutside = !1), e.delayFinished === !1) return;
            xte(Xg, Kg, Yg, _u, i, ll), Ec.setFromRotationMatrix(Xg), pp.setFromUnitVectors(ll.applyQuaternion(Ec), _u), l.some((m)=>m === !1) && r !== "target" && Ec.premultiply(pp).normalize();
        }
        e.currentDampingFactor > 1 ? (d.updateWorldMatrix(!0, !1), pp.setFromRotationMatrix(GM(d.matrixWorld)), pp.slerp(Ec, 1 / e.currentDampingFactor), AV(d, Xg.makeRotationFromQuaternion(pp)), e.paused = 8 * (1 - pp.dot(Ec)) < gte) : (AV(d, Xg.makeRotationFromQuaternion(Ec)), e.paused = !0), e.object?.dispatchEvent({
            type: "beginEvent",
            eventName: "LookAt"
        }), d.dispatchEvent(yte), d.dispatchEvent(vte);
    }
}, Vs = new E, Ui = new E, fi = new E;
function xte(n1, t, e, r, i, s1) {
    let o = n1.elements;
    fi.subVectors(t, e), fi.lengthSq() === 0 && (fi.z = 1), fi.normalize(), Ui.crossVectors(r, fi), Ui.lengthSq() === 0 && (Math.abs(r.z) === 1 ? fi.x += 1e-4 : fi.z += 1e-4, fi.normalize(), Ui.crossVectors(r, fi)), Ui.normalize(), Vs.crossVectors(fi, Ui), i === "x" ? s1.z === 1 ? [Ui, Vs, fi] = [
        fi,
        Ui,
        Vs
    ] : (Ui.negate(), [Ui, fi] = [
        fi,
        Ui
    ]) : i === "y" ? s1.x === 1 ? [Ui, Vs, fi] = [
        Vs,
        fi,
        Ui
    ] : (Ui.negate(), [Vs, fi] = [
        fi,
        Vs
    ]) : s1.x === 1 && (Ui.negate(), [Ui, Vs] = [
        Vs,
        Ui
    ]), o[0] = Ui.x, o[4] = Vs.x, o[8] = fi.x, o[1] = Ui.y, o[5] = Vs.y, o[9] = fi.y, o[2] = Ui.z, o[6] = Vs.z, o[10] = fi.z;
}
var tC = class {
    constructor(t, e, r, i, s1, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.entered = !1;
        this.actions = Wt(e, e.actions, i, s1, o, r);
    }
    disconnect() {
        vr(this.actions);
    }
    dispatchEnter() {
        this.actions.Transition.forEach((t)=>{
            t.object.currentTransitionEvent !== this && (t.object.currentTransitionEvent = this, t.init());
        }), this.entered || (this.entered = !0, this.actions.TimelineAnimation.forEach((t)=>t.playFromCurrent()), this.actions.Transition.forEach((t)=>t.playFromCurrent()), this.actions.Animation.forEach((t)=>t.play()), this.actions.Create.forEach((t)=>t.dispatchStart()), this.actions.Particles.forEach((t)=>t.dispatchBasic()), this.actions.Destroy.forEach((t)=>t.dispatch()), this.actions.SwitchCamera.forEach((t)=>t.playFromCurrent()), this.actions.SceneTransition.forEach((t)=>t.dispatch()), this.actions.SetVariable.forEach((t)=>t.checkConditions()), this.actions.SetVariable.forEach((t)=>t.dispatch()), this.actions.DynamicVariablePlay.forEach((t)=>t.dispatch()), this.actions.ClearLocalStorage.forEach((t)=>t.dispatch()), this.actions.UserAPI.forEach((t)=>t.dispatch()));
    }
    dispatchLeave() {
        this.actions.Transition.forEach((t)=>{
            t.object.currentTransitionEvent !== this && (t.object.currentTransitionEvent = this, t.init());
        }), this.entered && (this.entered = !1, this.actions.TimelineAnimation.forEach((t)=>t.reverseFromCurrent()), this.actions.Create.forEach((t)=>t.dispatchStop()), this.actions.Transition.forEach((t)=>t.reverseFromCurrent()), this.actions.Particles.forEach((t)=>t.reverseFromCurrent()), this.actions.SwitchCamera.forEach((t)=>t.reverseFromCurrent()));
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.Particles.forEach((e)=>e.reverseFromCurrent()), this.actions.Animation.forEach((e)=>e.reverseFromCurrent()), this.actions.TimelineAnimation.forEach((e)=>e.reverseFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>e.playFromCurrent()), this.actions.Animation.forEach((e)=>e.playFromCurrent()), this.actions.TimelineAnimation.forEach((e)=>e.playFromCurrent()), this.actions.Create.forEach((e)=>e.dispatch()), this.actions.Particles.forEach((e)=>e.dispatchBasic()), this.actions.Destroy.forEach((e)=>e.dispatch()), this.actions.SwitchCamera.forEach((e)=>e.playFromCurrent())), this.actions.SceneTransition.forEach((e)=>e.dispatch()), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.ClearLocalStorage.forEach((e)=>e.dispatch()), this.actions.UserAPI.forEach((e)=>e.dispatch());
    }
}, C1 = class extends Qt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.eventsPerObjects = {};
        this.objects = [];
        this.objects2D = [];
        this._prevObjects = [];
        this.onMouseDown = (e)=>{
            et.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseHoverEvent());
        };
        this.onMouseUp = (e)=>{
            et.length > 1 || this.handleMouseHoverEvent(!0);
        };
        this.onMouseMove = (e)=>{
            et.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseHoverEvent());
        };
        this.onUserEvent = ({ eventName: e, target: r, reverse: i })=>{
            if (!e || !r) return;
            let s1 = ma(e);
            s1 && s1 === "MouseHover" && (r.dispatchEvent({
                type: "beginEvent",
                eventName: "MouseHover"
            }), this.eventsPerObjects[r.uuid]?.forEach((o)=>o.dispatchUserEvent(i)));
        };
    }
    connect() {
        let { page: e, sharedAssets: r } = this.eventContext, i = (o, a)=>{
            if (!(!o.visible || !o.data?.events.length)) {
                for (let { id: l, data: c } of o.data.events)if (!c.disabled && c.type === "MouseHover") try {
                    let u1 = new tC(l, c, o, e, r, this.eventManager);
                    this.eventsPerObjects[o.uuid] ? this.eventsPerObjects[o.uuid].push(u1) : this.eventsPerObjects[o.uuid] = [
                        u1
                    ];
                } catch (u1) {}
                this.eventsPerObjects[o.uuid]?.length && this.objects.push(o instanceof hr ? a : o);
            }
        };
        if (e.traverseEntity((o)=>{
            (o instanceof _r || o instanceof yr) && o.frame?.traverse((a)=>{
                i(a, o);
            }), i(o);
        }), !this.objects.length) return;
        let { domElement: s1 } = this.eventContext;
        this.domEventsNeeded.clear(), Li && (this.domEventsNeeded.add("pointerdown"), s1.addEventListener("pointerdown", this.onMouseDown), this.domEventsNeeded.add("pointerup"), s1.addEventListener("pointerup", this.onMouseUp)), this.domEventsNeeded.add("pointermove"), s1.addEventListener("pointermove", this.onMouseMove), this.objects.forEach((o)=>{
            o.addEventListener("userEvent", this.onUserEvent);
        });
    }
    disconnect() {
        if (!this.objects.length) return;
        let { domElement: e } = this.eventContext;
        this.domEventsNeeded.clear(), Li && (e.removeEventListener("pointerdown", this.onMouseDown), e.removeEventListener("pointerup", this.onMouseUp)), e.removeEventListener("pointermove", this.onMouseMove), Object.values(this.eventsPerObjects).forEach((r)=>{
            r.forEach((i)=>{
                i.disconnect();
            });
        }), this.objects.forEach((r)=>{
            r.removeEventListener("userEvent", this.onUserEvent);
        });
    }
    handleMouseHoverEvent(e = !1) {
        let r = [];
        if (!e) {
            let { stopRaycast: i, raycaster: s1, page: o, pointerScreen: a } = this.eventContext, l = !1;
            if (o.uiCanvas && (l = vo(o, [
                a.x,
                a.y
            ], Object.keys(this.eventsPerObjects), (c)=>{
                r.push(c);
            })), i && !l) {
                let c = cp(s1, o, this.objects);
                r = Hg(c), c.forEach((u1)=>{
                    u1.object instanceof _r && vo(u1.object, [
                        u1?.uv?.x ?? 0,
                        u1?.uv?.y ?? 0
                    ], Object.keys(this.eventsPerObjects), (h)=>{
                        r.push(h);
                    });
                });
            } else this.objects.forEach((c)=>{
                let u1 = up(s1, c);
                u1 && (r.push(c), c instanceof _r && vo(c, [
                    u1?.uv?.x ?? 0,
                    u1?.uv?.y ?? 0
                ], Object.keys(this.eventsPerObjects), (h)=>{
                    r.push(h);
                }));
            });
        }
        this._prevObjects.length && this._prevObjects.forEach((i)=>{
            r.includes(i) || (i.dispatchEvent({
                type: "beginEvent",
                eventName: "MouseHover"
            }), this.eventsPerObjects[i.uuid]?.forEach((s1)=>s1.dispatchLeave()));
        }), r.length && r.forEach((i)=>{
            i.dispatchEvent({
                type: "beginEvent",
                eventName: "MouseHover"
            }), this.eventsPerObjects[i.uuid]?.forEach((s1)=>s1.dispatchEnter());
        }), this._prevObjects = r;
    }
};
var rC = class {
    constructor(t, e, r, i, s1, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.scrollCounter = 0;
        this.actions = Wt(e, e.actions, i, s1, o, r);
    }
    connect() {
        this.scrollCounter = 0;
    }
    disconnect() {
        vr(this.actions);
    }
    dispatch(t) {
        this.actions.Transition.forEach((i)=>{
            i.object.currentTransitionEvent !== this && (i.object.currentTransitionEvent = this, i.init());
        });
        let e = t > 0 ? 1 : -1;
        this.scrollCounter += e, this.scrollCounter = Math.min(Math.max(this.scrollCounter, 0), this.data.steps);
        let r = this.scrollCounter / this.data.steps;
        this.actions.Transition.forEach((i)=>i.seek(r)), this.actions.Animation.forEach((i)=>i.seek(e)), this.actions.TimelineAnimation.forEach((i)=>i.seek(r)), this.actions.Create.forEach((i)=>i.dispatchThrottled()), this.actions.SetVariable.forEach((i)=>i.checkConditions()), this.actions.SetVariable.forEach((i)=>i.dispatch()), this.actions.DynamicVariablePlay.forEach((i)=>i.dispatch()), this.actions.ClearLocalStorage.forEach((i)=>i.dispatch()), this.actions.UserAPI.forEach((i)=>i.dispatch());
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.Animation.forEach((e)=>e.reverseFromCurrent()), this.actions.TimelineAnimation.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>{
            e.playFromCurrent();
        }), this.actions.Animation.forEach((e)=>{
            e.playFromCurrent();
        }), this.actions.TimelineAnimation.forEach((e)=>{
            e.playFromCurrent();
        })), this.actions.Create.forEach((e)=>e.dispatchThrottled()), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.ClearLocalStorage.forEach((e)=>e.dispatch()), this.actions.UserAPI.forEach((e)=>e.dispatch());
    }
}, iC = class {
    constructor(t, e, r, i, s1, o, a){
        this.id = t;
        this.data = e;
        this.object = r;
        this.domElement = o;
        this.eventManager = a;
        this.scrollStart = 0;
        this.scrollEnd = 0;
        this.actions = Wt(e, e.actions, i, s1, a, r);
    }
    getStickyParentElement() {
        let t = this.domElement;
        for(; t;){
            if (window.getComputedStyle(t).position === "sticky") return t;
            t = t.parentElement;
        }
        return null;
    }
    computeScrollBounds() {
        let t = this.getStickyParentElement(), e = t?.parentElement, r = this.domElement.getBoundingClientRect(), i = {
            top: r.top,
            bottom: r.bottom,
            left: r.left,
            right: r.right,
            width: r.width,
            height: r.height
        };
        if (e) {
            let u1 = e.getBoundingClientRect(), h = window.getComputedStyle(t), d = parseFloat(h.marginTop) + parseFloat(h.marginBottom), f = parseFloat(h.top), m = parseFloat(h.bottom), p = u1.height - d;
            if (!isNaN(f)) r.top === f ? (i.top += u1.top - f, i.bottom += u1.top - f) : r.top < 0 && (i.top -= p - r.height, i.bottom -= p - r.height);
            else if (!isNaN(m)) {
                let g = document.body.clientHeight ?? window.innerHeight, y = window.innerWidth - (document.documentElement.clientWidth ?? window.innerWidth);
                r.bottom === g - m ? (i.top += u1.top - r.height + m + y, i.bottom += u1.top - r.height + m + y) : r.bottom < g - m && (i.top -= p - r.height, i.bottom -= p - r.height);
            }
        }
        let s1 = document.body, o = document.documentElement, a = window.pageYOffset || o.scrollTop || s1.scrollTop, l = o.clientTop || s1.clientTop || 0, c = Math.round(i.top + a - l);
        if (this.data.startFrom === "enter") {
            let u1 = window.innerHeight, h = i.height, d = this.data.enterAnchor, f = d === "top" ? u1 : d === "bottom" ? u1 - h : u1 - h * .5;
            this.scrollStart = c - f;
        } else this.scrollStart = 0;
        this.scrollStart += this.data.startOffset ?? 0, this.scrollEnd = this.scrollStart + (this.data.endAfter ?? 400), this.box = i, this.computeScroll({
            x: window.scrollX,
            y: window.scrollY
        });
    }
    connect() {
        this.computeScrollBounds();
    }
    disconnect() {
        vr(this.actions);
    }
    handleResize() {
        this.computeScrollBounds();
    }
    get isInvalidBox() {
        return this.box === void 0 || this.box.width === 0 && this.box.height === 0 && this.box.top === 0 && this.box.bottom === 0;
    }
    computeScroll({ x: t, y: e }) {
        this.actions.Transition.forEach((s1)=>{
            s1.object.currentTransitionEvent !== this && (s1.object.currentTransitionEvent = this, s1.init());
        });
        let r = this.scrollEnd - this.scrollStart, i = Math.min(1, Math.max(0, (e - this.scrollStart) / r));
        this.actions.Transition.forEach((s1)=>s1.seek(i)), this.actions.Animation.forEach((s1)=>s1.seek(i)), this.actions.TimelineAnimation.forEach((s1)=>s1.seek(i)), this.actions.Create.forEach((s1)=>s1.dispatchThrottled()), this.actions.SetVariable.forEach((s1)=>s1.checkConditions()), this.actions.SetVariable.forEach((s1)=>s1.dispatch()), this.actions.DynamicVariablePlay.forEach((s1)=>s1.dispatch()), this.actions.ClearLocalStorage.forEach((s1)=>s1.dispatch()), this.actions.UserAPI.forEach((s1)=>s1.dispatch());
    }
    dispatch(t) {
        this.isInvalidBox && this.computeScrollBounds(), this.computeScroll(t);
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.Animation.forEach((e)=>e.reverseFromCurrent()), this.actions.TimelineAnimation.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>{
            e.playFromCurrent();
        }), this.actions.Animation.forEach((e)=>{
            e.playFromCurrent();
        }), this.actions.TimelineAnimation.forEach((e)=>{
            e.playFromCurrent();
        })), this.actions.Create.forEach((e)=>e.dispatchThrottled()), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.ClearLocalStorage.forEach((e)=>e.dispatch()), this.actions.UserAPI.forEach((e)=>e.dispatch());
    }
}, P1 = class extends Qt {
    constructor(e, r){
        super(e);
        this.managers = r;
        this.wheelEventsPerObject = new Map;
        this.scrollEventsPerObject = new Map;
        this.isInview = !0;
        this.handleResize = ()=>{
            [
                ...this.scrollEventsPerObject.entries()
            ].forEach(([e, r])=>{
                r.forEach((i)=>i.handleResize());
            });
        };
        this.onScroll = (e)=>{
            if (!this.isInview) return;
            let r = {
                y: window.scrollY,
                x: window.scrollX
            };
            [
                ...this.scrollEventsPerObject.entries()
            ].forEach(([i, s1])=>{
                i.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Scroll",
                    scroll: r
                }), s1.forEach((o)=>o.dispatch(r));
            });
        };
        this.onWheel = (e)=>{
            !this.isInview || e.ctrlKey || [
                ...this.wheelEventsPerObject.entries()
            ].forEach(([r, i])=>{
                r.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Scroll",
                    deltaY: e.deltaY
                }), i.forEach((s1)=>s1.dispatch(e.deltaY));
            });
        };
        this.onUserEvent = ({ eventName: e, target: r, reverse: i })=>{
            if (!e || !r) return;
            let s1 = ma(e);
            s1 && s1 === "Scroll" && (r.dispatchEvent({
                type: "beginEvent",
                eventName: "Scroll"
            }), this.wheelEventsPerObject.get(r)?.forEach((o)=>{
                o.dispatchUserEvent(i);
            }));
        };
    }
    connect() {
        let { page: e, sharedAssets: r, domElement: i, isExport: s1 } = this.eventContext, o = (a)=>{
            if (!!a.data?.events.length) {
                for (let { id: l, data: c } of a.data.events)if (!c.disabled && c.type === "Scroll") {
                    if (c.trigger === "load" || !s1) {
                        let u1 = new rC(l, c, a, e, r, this.managers);
                        this.wheelEventsPerObject.has(a) ? this.wheelEventsPerObject.get(a)?.push(u1) : this.wheelEventsPerObject.set(a, [
                            u1
                        ]);
                    } else {
                        let u1 = new iC(l, c, a, e, r, i, this.managers);
                        this.scrollEventsPerObject.has(a) ? this.scrollEventsPerObject.get(a)?.push(u1) : this.scrollEventsPerObject.set(a, [
                            u1
                        ]);
                    }
                }
            }
        };
        e.traverseEntity((a)=>{
            (a instanceof _r || a instanceof yr) && a.frame?.traverse((l)=>{
                o(l);
            }), o(a);
        }), this.intersectionObserver = new IntersectionObserver((a)=>{
            let l = a[0];
            l && (this.isInview = l.isIntersecting);
        }, {
            root: null
        }), this.intersectionObserver.observe(this.eventContext.domElement), [
            ...this.wheelEventsPerObject.entries()
        ].forEach(([a, l])=>{
            l.forEach((c)=>c.connect()), a.addEventListener("userEvent", this.onUserEvent);
        }), [
            ...this.scrollEventsPerObject.entries()
        ].forEach(([a, l])=>{
            l.forEach((c)=>c.connect()), a.addEventListener("userEvent", this.onUserEvent);
        }), [
            ...this.wheelEventsPerObject.values()
        ].some((a)=>a.length) && (this.domEventsNeeded.add("wheel"), window.addEventListener("wheel", this.onWheel)), [
            ...this.scrollEventsPerObject.values()
        ].some((a)=>a.length) && (this.domEventsNeeded.add("scroll"), window.addEventListener("scroll", this.onScroll), window.addEventListener("resize", this.handleResize));
    }
    disconnect() {
        window.removeEventListener("wheel", this.onWheel), window.removeEventListener("scroll", this.onScroll), window.removeEventListener("resize", this.handleResize), this.intersectionObserver.unobserve(this.eventContext.domElement), this.domEventsNeeded.clear(), [
            ...this.wheelEventsPerObject.entries()
        ].forEach(([e, r])=>{
            r.forEach((i)=>i.disconnect()), e.removeEventListener("userEvent", this.onUserEvent);
        }), [
            ...this.scrollEventsPerObject.entries()
        ].forEach(([e, r])=>{
            r.forEach((i)=>i.disconnect()), e.removeEventListener("userEvent", this.onUserEvent);
        });
    }
};
var nC = class {
    constructor(t, e, r, i, s1, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.actions = Wt(e, e.actions, i, s1, o, r);
    }
    disconnect() {
        vr(this.actions);
    }
    dispatch() {
        this.actions.Transition.forEach((t)=>{
            t.play();
        }), this.actions.Animation.forEach((t)=>{
            t.play();
        }), this.actions.TimelineAnimation.forEach((t)=>{
            t.play();
        }), this.actions.SwitchCamera.forEach((t)=>{
            t.play();
        }), this.actions.SceneTransition.forEach((t)=>{
            t.dispatch();
        }), this.actions.Reset.forEach((t)=>t.dispatch()), this.actions.SetVariable.forEach((t)=>t.checkConditions()), this.actions.SetVariable.forEach((t)=>t.dispatch()), this.actions.DynamicVariablePlay.forEach((t)=>t.dispatch()), this.actions.ClearLocalStorage.forEach((t)=>t.dispatch()), this.actions.UserAPI.forEach((t)=>t.dispatch()), this.actions.Create.forEach((t)=>{
            t.dispatchFromStart();
        }), this.actions.Destroy.forEach((t)=>{
            t.dispatchFromStart();
        });
    }
    dispatchAfter(t) {
        this.actions.Audio.forEach((e)=>{
            (e.interaction.data.triggerAfter ?? "any") === t && (e.interaction instanceof da ? e.interaction.audioPlayer?.play() : e.interaction instanceof np && e.interaction.dispatch());
        }), this.actions.Video.forEach((e)=>{
            let r = e.interaction.data.triggerAfter ?? "autoplay";
            r === t && (e.interaction instanceof po ? e.interaction.play(r === "autoplay") : e.interaction instanceof lp && e.interaction.dispatch());
        }), this.actions.Particles.forEach((e)=>{
            (e.data.triggerAfter ?? "any") === t && e.dispatchBasic();
        });
    }
    async seekVideos(t) {
        let e = [];
        this.actions.Video.forEach((r)=>{
            (r.interaction.data.triggerAfter ?? "autoplay") === "autoplay" && r.interaction instanceof po && e.push(r.interaction.seek(t));
        }), await Promise.all(e);
    }
    pauseVideos() {
        this.actions.Video.forEach((t)=>{
            t.interaction instanceof po && t.interaction.pause();
        });
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.Animation.forEach((e)=>e.reverseFromCurrent()), this.actions.TimelineAnimation.forEach((e)=>e.reverseFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>e.playFromCurrent()), this.actions.Animation.forEach((e)=>e.playFromCurrent()), this.actions.TimelineAnimation.forEach((e)=>e.playFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.playFromCurrent())), this.actions.SceneTransition.forEach((e)=>e.dispatch()), this.actions.Reset.forEach((e)=>e.dispatch()), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.ClearLocalStorage.forEach((e)=>e.dispatch()), this.actions.UserAPI.forEach((e)=>e.dispatch()), this.actions.Create.forEach((e)=>{
            e.dispatch();
        }), this.actions.Destroy.forEach((e)=>{
            e.dispatch();
        }), this.actions.Audio.forEach((e)=>{
            e.interaction instanceof da ? e.interaction.audioPlayer?.play() : e.interaction instanceof np && e.interaction.dispatch();
        }), this.actions.Video.forEach((e)=>{
            e.interaction instanceof po ? e.interaction.play() : e.interaction instanceof lp && e.interaction.dispatch();
        }), this.actions.Particles.forEach((e)=>{
            e.dispatchBasic();
        });
    }
}, _1 = class extends Qt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.eventsPerObject = new Map;
        this.eventsAfterPerObject = new Map;
        this.onMouseDown = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, r])=>{
                e.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), r.forEach((i)=>{
                    i.dispatchAfter("mouseDown");
                });
            });
        };
        this.onKeyDown = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, r])=>{
                e.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), r.forEach((i)=>{
                    i.dispatchAfter("keyDown");
                });
            });
        };
        this.onAny = ()=>{
            let { domElement: e, isExport: r } = this.eventContext, i = r ? document : e;
            i.removeEventListener("pointerdown", this.onAny), i.removeEventListener("mousedown", this.onAny), document.removeEventListener("keydown", this.onAny), [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([s1, o])=>{
                s1.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), o.forEach((a)=>{
                    a.dispatchAfter("any");
                });
            });
        };
        this.onSceneTransitionAudioVideoPlay = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, r])=>{
                e.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), r.forEach((i)=>{
                    i.actions.Audio.forEach((s1)=>{
                        s1.interaction instanceof da && s1.interaction.audioPlayer?.play();
                    }), i.actions.Video.forEach((s1)=>{
                        let o = s1.interaction.data.triggerAfter ?? "autoplay";
                        s1.interaction instanceof po && s1.interaction.play(o === "autoplay");
                    }), i.actions.Particles.forEach((s1)=>{
                        s1.dispatchBasic();
                    });
                });
            });
        };
        this.onPlay = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, r])=>{
                e.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), r.forEach((i)=>{
                    i.dispatchAfter("autoplay");
                });
            });
        };
        this.seekVideos = async (e)=>{
            let r = [];
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([i, s1])=>{
                !i.data.visible || s1.forEach((o)=>{
                    r.push(o.seekVideos(e));
                });
            }), await Promise.all(r);
        };
        this.pauseVideos = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, r])=>{
                r.forEach((i)=>{
                    i.pauseVideos();
                });
            });
        };
        this.onUserEvent = ({ eventName: e, target: r, reverse: i })=>{
            if (!e || !r) return;
            let s1 = ma(e);
            s1 && s1 === "Start" && (r instanceof hr || r.dispatchEvent({
                type: "beginEvent",
                eventName: "Start"
            }), this.eventsPerObject.get(r)?.forEach((o)=>{
                o.dispatchUserEvent(i);
            }), this.eventsAfterPerObject.get(r)?.forEach((o)=>{
                o.dispatchUserEvent(i);
            }));
        };
    }
    connect() {
        let { sharedAssets: e, page: r } = this.eventContext, i = (s1)=>{
            if (!!s1.data?.events.length) for (let { id: o, data: a } of s1.data.events){
                if (a.disabled || a.type !== "Start") continue;
                let l = new nC(o, a, s1, r, e, this.eventManager);
                (l.actions.Transition.length || l.actions.TimelineAnimation.length || l.actions.Animation.length || l.actions.SwitchCamera.length || l.actions.Create.length || l.actions.Destroy.length || l.actions.SceneTransition.length || l.actions.Reset.length || l.actions.SetVariable.length || l.actions.DynamicVariablePlay.length || l.actions.ClearLocalStorage.length || l.actions.UserAPI.length) && (this.eventsPerObject.has(s1) ? this.eventsPerObject.get(s1)?.push(l) : this.eventsPerObject.set(s1, [
                    l
                ])), l.actions.Audio.length && (this.eventsAfterPerObject.has(s1) ? this.eventsAfterPerObject.get(s1)?.push(l) : this.eventsAfterPerObject.set(s1, [
                    l
                ])), l.actions.Video.length && (this.hasVideoAction = !0, this.eventsAfterPerObject.has(s1) ? this.eventsAfterPerObject.get(s1)?.push(l) : this.eventsAfterPerObject.set(s1, [
                    l
                ])), l.actions.Particles.length && (this.eventsAfterPerObject.has(s1) ? this.eventsAfterPerObject.get(s1)?.push(l) : this.eventsAfterPerObject.set(s1, [
                    l
                ]));
            }
        };
        if (r.traverseEntity((s1)=>{
            (s1 instanceof _r || s1 instanceof yr) && s1.frame?.traverse((o)=>{
                i(o);
            }), i(s1);
        }), [
            ...this.eventsAfterPerObject.values()
        ].some((s1)=>s1.length)) {
            if (this.eventManager.activateCount === 0) {
                let { domElement: s1, isExport: o } = this.eventContext, a = o ? document : s1;
                a.addEventListener("pointerdown", this.onMouseDown, {
                    once: !0
                }), a.addEventListener("mousedown", this.onMouseDown, {
                    once: !0
                }), document.addEventListener("keydown", this.onKeyDown, {
                    once: !0
                }), a.addEventListener("pointerdown", this.onAny), a.addEventListener("mousedown", this.onAny), document.addEventListener("keydown", this.onAny), [
                    ...this.eventsAfterPerObject.entries()
                ].forEach(([l, c])=>{
                    l.addEventListener("userEvent", this.onUserEvent);
                });
            } else this.onSceneTransitionAudioVideoPlay();
            this.onPlay();
        }
        [
            ...this.eventsPerObject.entries()
        ].forEach(([s1, o])=>{
            s1.dispatchEvent({
                type: "beginEvent",
                eventName: "Start"
            }), o.forEach((a)=>a.dispatch()), s1.addEventListener("userEvent", this.onUserEvent);
        });
    }
    disconnect() {
        if ([
            ...this.eventsAfterPerObject.values()
        ].some((e)=>e.length)) {
            let { domElement: e, isExport: r } = this.eventContext, i = r ? document : e;
            i.removeEventListener("pointerdown", this.onMouseDown), i.removeEventListener("mousedown", this.onMouseDown), document.removeEventListener("keydown", this.onKeyDown), i.removeEventListener("pointerdown", this.onAny), i.removeEventListener("mousedown", this.onAny), document.removeEventListener("keydown", this.onAny), [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([s1, o])=>{
                s1.removeEventListener("userEvent", this.onUserEvent), o.forEach((a)=>a.disconnect());
            });
        }
        [
            ...this.eventsPerObject.entries()
        ].forEach(([e, r])=>{
            e.removeEventListener("userEvent", this.onUserEvent), r.forEach((i)=>i.disconnect());
        }), this.eventsPerObject.clear(), this.eventsAfterPerObject.clear();
    }
};
var I1 = class {
    constructor(t, e, r, i, s1, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.initialDisabled = !1;
        this.actions = Wt(e, e.actions, i, s1, o, r), this.target = e.target;
    }
    disconnect() {
        vr(this.actions);
    }
    dispatch(t) {
        this.initialDisabled || (this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), this.object.dispatchEvent({
            type: "beginEvent",
            eventName: "Collision"
        }), this.actions.Transition.forEach((e)=>{
            e.data.runMode === "Toggle" ? e.toggle() : e.play();
        }), this.actions.Animation.forEach((e)=>{
            e.data.runMode === "Toggle" ? e.toggle() : e.play();
        }), this.actions.TimelineAnimation.forEach((e)=>{
            e.data.runMode === "Toggle" ? e.toggle() : e.play();
        }), this.actions.Reset.forEach((e)=>{
            e.dispatch();
        }), this.actions.Link.forEach((e)=>{
            e.dispatch();
        }), this.actions.Reset.forEach((e)=>{
            e.dispatch();
        }), this.actions.Create.forEach((e)=>{
            e.dispatch();
        }), this.actions.Destroy.forEach((e)=>{
            e.dispatch(t ?? !1);
        }), this.actions.SetVariable.forEach((e)=>e.checkConditions()), this.actions.SetVariable.forEach((e)=>e.dispatch()), this.actions.DynamicVariablePlay.forEach((e)=>e.dispatch()), this.actions.Audio.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Particles.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Video.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.ClearLocalStorage.forEach((e)=>e.dispatch()), this.actions.UserAPI.forEach((e)=>e.dispatch()));
    }
};
var D1 = class extends Qt {
    constructor(e, r, i, s1, o){
        super(e);
        this.sharedVariables = r;
        this.eventManager = i;
        this.needsMouse = s1;
        this.needsRaycast = o;
        this.dynamicVars = [];
        this.variablesToWatch = [];
        this.prevMouseProperty = null;
        this.prevRaycastProperty = null;
        this.pauseTime = 0;
        this.isOutOfFocus = !1;
        this.events = [];
        this.onFrame = (e)=>{
            let r = this.eventContext.sharedAssets;
            if (this.rafId = window.requestAnimationFrame(this.onFrame), this.isOutOfFocus) return;
            let i = new Date, s1 = [], o = [];
            for(let c = 0; c < this.propertiesToWatch.length; c++){
                let { objectId: u1, property: h, prevValue: d } = this.propertiesToWatch[c], f = this.eventContext.scene.find(u1), m = x0.propertyPaths[h];
                if (m[0] === "width" || m[0] === "height" || m[0] === "depth") f = f.geometry.userData.parameters[m[0]];
                else for(let p = 0; p < m.length; p++)f = f[m[p]];
                d === null ? this.propertiesToWatch[c].prevValue = f instanceof E ? f.clone() : f : (f instanceof E ? !f.equals(d) : d !== f) && (o.push({
                    objId: u1,
                    property: h
                }), f instanceof E ? this.propertiesToWatch[c].prevValue.copy(f) : this.propertiesToWatch[c].prevValue = f);
            }
            for(let c = 0; c < this.variablesToWatch.length; c++){
                let { id: u1, prevValue: h } = this.variablesToWatch[c], d = r.getVariable(u1);
                d !== h && (s1.push(u1), this.variablesToWatch[c].prevValue = d);
            }
            for(let c = 0; c < this.dynamicVars.length; c++){
                let { id: u1, expectedTime: h, last: d, data: f, timerSeconds: m, startValue: p } = this.dynamicVars[c], g = 1e3;
                if ((f.dynamicVariableType === "timer" || f.dynamicVariableType === "stopwatch") && f.format === "number3decimal" ? g = 1 : f.dynamicVariableType === "counter" ? g = f.updateInterval : f.dynamicVariableType === "random" && (g = f.isStatic ? 1 / 0 : f.updateInterval), h === -1) {
                    this.dynamicVars[c].last = e, this.dynamicVars[c].expectedTime = e + g;
                    continue;
                }
                if (!((r.getDynamicVariablePlayState(u1) === "Stopped" || r.getDynamicVariablePlayState(u1) === "Restarted") && (this.dynamicVars[c].last = e, this.dynamicVars[c].expectedTime = e + g, f.dynamicVariableType === "counter" && r.getVariable(u1) !== p && (r.updateVariable(u1, p), this.eventManager.requestRender()), (f.dynamicVariableType === "timer" || f.dynamicVariableType === "stopwatch") && this.dynamicVars[c].timerSeconds !== p && (this.dynamicVars[c].timerSeconds = p, r.updateVariable(u1, An.getFormattedTimerTime(p, f)), this.eventManager.requestRender()), r.getDynamicVariablePlayState(u1) === "Restarted" && r.setDynamicVariablePlayState(u1, "Playing"), r.getDynamicVariablePlayState(u1) === "Stopped"))) {
                    if (r.getDynamicVariablePlayState(u1) === "Paused") {
                        this.dynamicVars[c].deltaToExpectedTime === void 0 && (this.dynamicVars[c].deltaToExpectedTime = Math.max(this.dynamicVars[c].expectedTime - e, 0)), this.dynamicVars[c].last = e - (g - this.dynamicVars[c].deltaToExpectedTime), this.dynamicVars[c].expectedTime = e + this.dynamicVars[c].deltaToExpectedTime;
                        continue;
                    } else this.dynamicVars[c].deltaToExpectedTime = void 0;
                    if (e >= h) {
                        if (this.dynamicVars[c].last = e, this.dynamicVars[c].expectedTime += g, f.dynamicVariableType === "random") {
                            let y = f.min + Math.random() * (f.max - f.min), x = f.decimals;
                            y = Math.round(y * Math.pow(10, x)) / Math.pow(10, x), r.updateVariable(u1, y), s1.push(u1), this.eventManager.requestRender();
                        } else if (f.dynamicVariableType === "counter") {
                            let y = r.getVariable(u1), x = r.getDynamicVariableToggleIsForward(u1) ?? !0, v = r.getVariable(u1) + f.increment * (x ? 1 : -1);
                            f.hasEnd && (v = f.increment > 0 ? Se.clamp(v, p, f.endValue) : Se.clamp(v, f.endValue, p), v === p && r.setDynamicVariableToggleIsForward(u1, void 0), f.repeat ? v === f.endValue && (v = p) : (v === p || v === f.endValue) && r.setDynamicVariablePlayState(u1, "Paused")), v !== y && (s1.push(u1), r.updateVariable(u1, v), this.eventManager.requestRender());
                        } else if (f.dynamicVariableType === "time") {
                            let y = r.getVariable(u1), x = PT(i, f);
                            if (typeof y == "object" && "textValue" in y && typeof x == "object" && "textValue" in x) {
                                if (Array.isArray(y.textValue) && Array.isArray(x.textValue)) {
                                    if (y.textValue.every((v, b)=>v === x.textValue[b])) continue;
                                } else if (y.textValue === x.textValue) continue;
                            } else if (y === x) continue;
                            r.updateVariable(u1, x), s1.push(u1), this.eventManager.requestRender();
                        } else {
                            let y = Gr.isTextValue(f.endValue) ? EV(f.endValue.textValue) : f.endValue, x = r.getDynamicVariableToggleIsForward(u1) ?? !0, v = m + (e - d) / 1e3 * (f.dynamicVariableType === "timer" ? -1 : 1) * (x ? 1 : -1);
                            v = Math.max(v, 0), f.hasEnd && (v = f.dynamicVariableType === "stopwatch" ? Se.clamp(v, p, y) : Se.clamp(v, y, p), v === p && r.setDynamicVariableToggleIsForward(u1, void 0), f.repeat ? Math.abs(v - y) < (f.format === "number3decimal" ? 1e-4 : .1) && (v = p) : (Math.abs(v - p) < (f.format === "number3decimal" ? 1e-4 : .1) || Math.abs(v - y) < (f.format === "number3decimal" ? 1e-4 : .1)) && r.setDynamicVariablePlayState(u1, "Paused")), v !== m && (s1.push(u1), this.dynamicVars[c].timerSeconds = v, r.updateVariable(u1, An.getFormattedTimerTime(v, f)), this.eventManager.requestRender());
                        }
                    }
                }
            }
            let a = !1;
            r.mouseProperty !== this.prevMouseProperty && (this.prevMouseProperty = r.mouseProperty, a = !0);
            let l = !1;
            r.raycastProperty !== this.prevRaycastProperty && (this.prevRaycastProperty = r.raycastProperty, l = !0), this.events.forEach((c)=>{
                (s1.includes(c.data.variableId) || o.find((u1)=>u1.objId === c.data.objectId && u1.property === c.data.property) || c.data.variableId === "mouseProperty" && a || c.data.variableId === "raycastProperty" && l) && (c.dispatch(), this.eventManager.requestRender());
            });
        };
        this.onBlur = ()=>{
            this.pause();
        };
        this.onFocus = ()=>{
            this.resume();
        };
    }
    pause() {
        this.isOutOfFocus || (this.isOutOfFocus = !0, this.pauseTime = Date.now());
    }
    resume() {
        if (!this.isOutOfFocus) return;
        this.isOutOfFocus = !1;
        let e = Date.now() - this.pauseTime;
        for(let r = 0; r < this.dynamicVars.length; r++)this.dynamicVars[r].last += e, this.dynamicVars[r].expectedTime += e;
    }
    connect() {
        this.eventContext.page.traverseEntity((r)=>{
            r.data?.events.filter((i)=>i.data.type === "VariableChange" && !i.data.disabled).forEach((i)=>{
                this.events.push(new sC(i.id, i.data, r, this.eventContext.page, this.eventContext.sharedAssets, this.eventManager));
            });
        }), this.propertiesToWatch = this.events.filter((r)=>r.data.variableId === "objectProperty" && r.data.objectId !== null).map((r)=>({
                objectId: r.data.objectId,
                property: r.data.property,
                prevValue: null
            }));
        let e = this.eventContext.sharedAssets;
        this.sharedVariables.forEach(({ id: r, data: i })=>{
            if (!("dynamicVariableType" in i)) {
                this.events.find((o)=>o.data.variableId === r) && this.variablesToWatch.push({
                    id: r,
                    prevValue: e.getVariable(r)
                });
                return;
            }
            let s1;
            if (i.dynamicVariableType === "timer" || i.dynamicVariableType === "stopwatch") {
                let o;
                if (Gr.isTextValue(i.value) && Array.isArray(i.value.textValue)) {
                    let a = i.value.textValue;
                    a.length === 3 ? o = a[2] + a[1] * 60 + a[0] * 3600 : o = a[1] + a[0] * 60;
                } else o = i.value;
                s1 = o, this.dynamicVars.push({
                    id: r,
                    last: -1,
                    expectedTime: -1,
                    data: i,
                    timerSeconds: o,
                    startValue: s1
                });
            } else i.dynamicVariableType === "time" && e.updateVariable(r, PT(new Date, i)), i.dynamicVariableType === "counter" && (s1 = Gr.isTextValue(i.value) ? EV(i.value.textValue) : i.value), this.dynamicVars.push({
                id: r,
                last: -1,
                expectedTime: -1,
                data: i,
                startValue: s1
            });
        }), this.rafId = window.requestAnimationFrame(this.onFrame), window.addEventListener("blur", this.onBlur), window.addEventListener("focus", this.onFocus);
    }
    disconnect() {
        window.removeEventListener("blur", this.onBlur), window.removeEventListener("focus", this.onFocus), this.rafId && (window.cancelAnimationFrame(this.rafId), this.rafId = void 0), this.events.forEach((e)=>e.dispose());
    }
}, sC = class {
    constructor(t, e, r, i, s1, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.actions = Wt(e, e.actions, i, s1, o, r);
    }
    dispatch() {
        let t = this.actions;
        t.Audio.forEach((e)=>e.dispatchConditional()), t.Particles.forEach((e)=>e.dispatchConditional()), t.Video.forEach((e)=>e.dispatchConditional()), t.Create.forEach((e)=>e.dispatch()), t.Destroy.forEach((e)=>e.dispatch()), t.Reset.forEach((e)=>e.dispatch()), t.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this), e.init();
        }), t.Transition.forEach((e)=>e.play()), t.Animation.forEach((e)=>e.play()), t.SwitchCamera.forEach((e)=>e.play()), t.SceneTransition.forEach((e)=>e.dispatch()), t.SetVariable.forEach((e)=>e.checkConditions()), t.SetVariable.forEach((e)=>e.dispatch()), t.DynamicVariablePlay.forEach((e)=>e.dispatch()), t.ClearLocalStorage.forEach((e)=>e.dispatch()), t.UserAPI.forEach((e)=>e.dispatch());
    }
    dispose() {
        vr(this.actions);
    }
};
function EV(n1) {
    return n1.length === 3 ? n1[2] + n1[1] * 60 + n1[0] * 3600 : n1[1] + n1[0] * 60;
}
var MV = "https://unpkg.com/@splinetool/runtime@1.12.53/build/", bte = "https://unpkg.com/@splinetool/navmesh-wasm@1.12.53/build/", Ste = `
(async function() {
	const [wasmImport, wasmBinary] = await Promise.all([
		import('${MV}' + 'navmesh.js'),
		fetch('${bte}' + 'navmesh.wasm').then((res) => res.arrayBuffer()),
	]);
	const wasmModule = wasmImport.default;
	self.module = await wasmModule({ wasmBinary });
	postMessage('ready');
})();
`, wte = `
(async function() {
	const [wasmImport, wasmBinary] = await Promise.all([
		import(self.location.origin + '/_libraries/navmesh.js'),
		fetch(self.location.origin + '/_libraries/navmesh.wasm').then((res) => res.arrayBuffer()),
	]);
	const wasmModule = wasmImport.default;
	self.module = await wasmModule({ wasmBinary });
	postMessage('ready');
})();
`, Ate = `

onmessage = function(messageEvent) {
	const meshData = messageEvent.data;
	const positions = meshData[0];
	const offset = meshData[1];
	const indices = meshData[2];
	const indicesLength = meshData[3];
	const parameters = meshData[4];

	const module = self.module;
	const rc = new module.rcConfig();
	rc.cs = parameters.cs;
	rc.ch = parameters.ch;
	rc.borderSize = parameters.borderSize ? parameters.borderSize : 0;
	rc.tileSize = parameters.tileSize ? parameters.tileSize : 0;
	rc.walkableSlopeAngle = parameters.walkableSlopeAngle;
	rc.walkableHeight = parameters.walkableHeight;
	rc.walkableClimb = parameters.walkableClimb;
	rc.walkableRadius = parameters.walkableRadius;
	rc.maxEdgeLen = parameters.maxEdgeLen;
	rc.maxSimplificationError = parameters.maxSimplificationError;
	rc.minRegionArea = parameters.minRegionArea;
	rc.mergeRegionArea = parameters.mergeRegionArea;
	rc.maxVertsPerPoly = parameters.maxVertsPerPoly;
	rc.detailSampleDist = parameters.detailSampleDist;
	rc.detailSampleMaxError = parameters.detailSampleMaxError;

	if (!self.navMesh) {
		self.navMesh = new module.NavMesh();
	}
	self.navMesh.build(positions, offset, indices, indicesLength, rc);

	const navmeshData = navMesh.getNavmeshData();
	const arrView = new Uint8Array(module.HEAPU8.buffer, navmeshData.dataPointer, navmeshData.size);
	const ret = new Uint8Array(navmeshData.size);
	ret.set(arrView);
	navMesh.freeNavmeshData(navmeshData);

	postMessage(ret);
}
`, TV = .001, Ete = {
    cs: 6,
    ch: 2,
    walkableSlopeAngle: 90,
    walkableHeight: 20,
    walkableClimb: 5,
    walkableRadius: 0,
    maxEdgeLen: 12,
    maxSimplificationError: 1.3,
    minRegionArea: 8,
    mergeRegionArea: 20,
    maxVertsPerPoly: 6,
    detailSampleDist: 6,
    detailSampleMaxError: 1
}, CV, Ft, on;
bD.then((n1)=>{
    CV = n1, Ft = new n1.Vec3, on = new n1.Vec3;
});
var Tte = new E, O1 = class {
    constructor(t = !1, e = !1){
        this.usePhysics = t;
        this.isExport = e;
        this.onPointerDown = (t)=>{
            if (et.length !== 1) return;
            let { raycaster: e, page: r } = this.eventContext;
            this.eventContext.updateRaycaster(t);
            let i = r.raycastWithClones(e);
            if (i.length !== 0) {
                if (this.gameControl) {
                    let s1 = Tte.copy(this.gameControl.colliderWorldPosition);
                    s1.y -= this.gameControl.colliderHeight / 2, this.gameControl.path = this.computePath(s1, i[0].point);
                }
                this.eventContext.requestRender();
            }
        };
        this.traverseWithPhysics = (t, e)=>(r)=>{
                let i;
                if (r instanceof Ai) {
                    if (r.objectForSample) {
                        if (r.objectForSample.dataPatched.physics.fusedBody) return;
                        i = r.object;
                    } else return r.object.dataPatched.physics.fusedBody === !0 && r.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                } else if (r instanceof Lr) i = r.object;
                else if (i = r, i.dataPatched.cloner?.disabled === !1 && i.dataPatched.cloner?.hideBase && i.dataPatched.physics?.fusedBody !== !0) return !0;
                if (e && !i.userData.navmesh) return;
                let s1 = i.dataPatched;
                if (!s1.visible && s1.physics?.enabled !== !0) return !0;
                r.updateMatrixWorldSVD();
                let o = Qg(s1), a = i.userData.hasDestroy, l = i.userData.hasDrag, c = !1, u1 = !1;
                for (let h of s1.events)h.data.disabled !== !0 && (h.data.type === "GameControl" ? c = !0 : h.data.type === "Follow" && (u1 = !0));
                if (c || o || u1 || a || l) return !0;
                if (this.usePhysics && s1.physics?.rigidBody === "dynamic") {
                    if (this.usePhysics && s1.physics?.fusedBody) return !0;
                } else if ("geometry" in r && r.geometry && t.push(yo(r.geometry, r.matrixWorld)), this.usePhysics && s1.physics?.fusedBody) return r.traverseObject((h, d)=>{
                    if (d === 0) return;
                    let f;
                    if (h instanceof Ai) {
                        if (h.objectForSample) {
                            if (h.objectForSample.dataPatched.physics.fusedBody) return;
                            f = h.object;
                        } else return h.object.dataPatched.physics.fusedBody === !0 && h.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                    } else if (h instanceof Lr) f = h.object;
                    else if (f = h, h.dataPatched.cloner?.hideBase) return !0;
                    let m = f.dataPatched;
                    if (!m.visible && m.physics?.enabled !== !0) return !0;
                    "geometry" in h && h.geometry && t.push(yo(h.geometry, h.matrixWorld));
                }), !0;
            };
        this.traverseNoPhysics = (t, e)=>(r)=>{
                let i;
                if (r instanceof Ai) return;
                r instanceof Lr ? i = r.object : i = r;
                let s1 = i.dataPatched;
                if (s1.physics.enabled === "visibility" ? !s1.visible : !s1.physics.enabled) return !0;
                if (e && !i.userData.navmesh) return;
                let o = r.geometry, a = i.userData.hasDestroy === !0, l = i.userData.hasDrag === !0;
                if (Qg(s1) || a || l || i.dataPatched.events.some((c)=>c.data.disabled !== !0 && c.data.type === "GameControl")) return !0;
                o && t.push(yo(o, r.matrixWorld));
            };
        this.navmeshWasm = CV, this.navMesh = new this.navmeshWasm.NavMesh, this._workerURL = URL.createObjectURL(new Blob([
            (e ? Ste : wte) + Ate
        ])), this._worker = new Worker(this._workerURL);
    }
    init(t, e, r) {
        this.gameControl = e, this.eventContext = r, this.setDefaultQueryExtent(new E().setScalar(t.ch * t.walkableRadius * 1.2)), this._worker.onmessage = ()=>{
            this.createNavMesh(r.page, t, (i)=>{
                this.buildFromNavmeshData(i.data);
            });
        }, this.eventContext.renderer.domElement.addEventListener("pointerdown", this.onPointerDown);
    }
    createNavMesh(t, e, r) {
        e.objects.forEach((c)=>{
            let u1 = t.scene.find(c);
            u1.traverseEntity((h)=>{
                h.userData.navmesh = !0;
            }), u1.cloner?.traverseObject((h)=>{
                h.userData.navmesh = !0;
            });
        });
        let i = [], s1 = (this.usePhysics ? this.traverseWithPhysics : this.traverseNoPhysics)(i, e.zones === "custom");
        if (t.traverseChildren(s1), e.objects.forEach((c)=>{
            let u1 = t.scene.find(c);
            u1.traverseEntity((h)=>{
                h.userData.navmesh = void 0;
            }), u1.cloner?.traverseObject((h)=>{
                h.userData.navmesh = void 0;
            });
        }), i.length === 0) return !1;
        let o = Js(i), { positions: a, triIndices: l } = uu(o.getAttribute("position"), o.getIndex());
        return this._worker.postMessage([
            a,
            a.length / 3,
            l,
            l.length,
            {
                ...Ete,
                ...e
            }
        ]), this._worker.onmessage = r, !0;
    }
    createDebugNavGeometry() {
        let t, e, r = this.navMesh.getDebugNavMesh(), i = r.getTriangleCount(), s1 = new Uint32Array(i * 3), o = new Float32Array(i * 9);
        for(t = 0; t < i * 3; t++)s1[t] = t;
        for(t = 0; t < i; t++)for(e = 0; e < 3; e++){
            let l = r.getTriangle(t).getPoint(e);
            o[t * 9 + e * 3 + 0] = l.x, o[t * 9 + e * 3 + 1] = l.y, o[t * 9 + e * 3 + 2] = l.z;
        }
        let a = new Ce;
        return a.setIndex(new je(s1, 1)), a.setAttribute("position", new je(o, 3)), a;
    }
    getClosestPoint(t) {
        return Ft.x = t.x, Ft.y = t.y, Ft.z = t.z, this.navMesh.getClosestPoint(Ft);
    }
    getClosestPointToRef(t, e) {
        Ft.x = t.x, Ft.y = t.y, Ft.z = t.z;
        let r = this.navMesh.getClosestPoint(Ft);
        e.set(r.x, r.y, r.z);
    }
    getRandomPointAround(t, e) {
        return Ft.x = t.x, Ft.y = t.y, Ft.z = t.z, this.navMesh.getRandomPointAround(Ft, e);
    }
    getRandomPointAroundToRef(t, e, r) {
        Ft.x = t.x, Ft.y = t.y, Ft.z = t.z;
        let i = this.navMesh.getRandomPointAround(Ft, e);
        r.set(i.x, i.y, i.z);
    }
    moveAlong(t, e) {
        return Ft.x = t.x, Ft.y = t.y, Ft.z = t.z, on.x = e.x, on.y = e.y, on.z = e.z, this.navMesh.moveAlong(Ft, on);
    }
    moveAlongToRef(t, e, r) {
        return Ft.x = t.x, Ft.y = t.y, Ft.z = t.z, on.x = e.x, on.y = e.y, on.z = e.z, this.navMesh.moveAlong(Ft, on);
    }
    computePath(t, e) {
        let r = this.getClosestPoint(e);
        if (on.x = r.x, on.y = r.y, on.z = r.z, Math.sqrt(Math.pow(e.x - r.x, 2) + Math.pow(e.y - r.y, 2) + Math.pow(e.z - r.z, 2)) > this.getDefaultQueryExtent().y) return [];
        this.getClosestPoint(t);
        let s1 = this.navMesh.computePath(Ft, on), o = s1.getPointCount(), a = [];
        for(let l = 0; l < o; l++){
            let c = s1.getPoint(l);
            a.push(new E(c.x, c.y, c.z));
        }
        return a;
    }
    createCrowd(t, e) {
        return new oC(this, t, e);
    }
    setDefaultQueryExtent(t) {
        Ft.x = t.x, Ft.y = t.y, Ft.z = t.z, this.navMesh.setDefaultQueryExtent(Ft);
    }
    getDefaultQueryExtent() {
        return this.navMesh.getDefaultQueryExtent();
    }
    buildFromNavmeshData(t) {
        let e = t.length * t.BYTES_PER_ELEMENT, r = this.navmeshWasm._malloc(e), i = new Uint8Array(this.navmeshWasm.HEAPU8.buffer, r, e);
        i.set(t);
        let s1 = new this.navmeshWasm.NavmeshData;
        s1.dataPointer = i.byteOffset, s1.size = t.length, this.navMesh.buildFromNavmeshData(s1), this.navmeshWasm._free(i.byteOffset);
    }
    getNavmeshData() {
        let t = this.navMesh.getNavmeshData(), e = new Uint8Array(this.navmeshWasm.HEAPU8.buffer, t.dataPointer, t.size), r = new Uint8Array(t.size);
        return r.set(e), this.navMesh.freeNavmeshData(t), r;
    }
    getDefaultQueryExtentToRef(t) {
        let e = this.navMesh.getDefaultQueryExtent();
        t.set(e.x, e.y, e.z);
    }
    dispose() {
        this.navMesh.destroy(), this._worker.terminate(), URL.revokeObjectURL(this._workerURL), this.eventContext?.renderer.domElement.removeEventListener("pointerdown", this.onPointerDown);
    }
    addCylinderObstacle(t, e, r) {
        return Ft.x = t.x, Ft.y = t.y, Ft.z = t.z, this.navMesh.addCylinderObstacle(Ft, e, r);
    }
    addBoxObstacle(t, e, r) {
        return Ft.x = t.x, Ft.y = t.y, Ft.z = t.z, on.x = e.x, on.y = e.y, on.z = e.z, this.navMesh.addBoxObstacle(Ft, on, r);
    }
    removeObstacle(t) {
        this.navMesh.removeObstacle(t);
    }
    isSupported() {
        return this.navmeshWasm !== void 0;
    }
}, oC = class {
    constructor(t, e, r){
        this.navmeshWasmWrapper = t;
        this.transforms = [];
        this.agents = new Array;
        this.reachRadii = new Array;
        this._agentDestinationArmed = new Array;
        this._agentDestination = new Array;
        this.crowd = new this.navmeshWasmWrapper.navmeshWasm.Crowd(e, r, this.navmeshWasmWrapper.navMesh.getNavMesh());
    }
    onReachTarget(t, e) {}
    addAgent(t, e, r) {
        let i = new this.navmeshWasmWrapper.navmeshWasm.dtCrowdAgentParams;
        i.radius = e.radius, i.height = e.height, i.maxAcceleration = e.maxAcceleration, i.maxSpeed = e.maxSpeed, i.collisionQueryRange = e.collisionQueryRange, i.pathOptimizationRange = e.pathOptimizationRange, i.separationWeight = e.separationWeight, i.updateFlags = 7, i.obstacleAvoidanceType = 0, i.queryFilterType = 0, i.userData = 0;
        let s1 = this.crowd.addAgent(new this.navmeshWasmWrapper.navmeshWasm.Vec3(t.x, t.y, t.z), i);
        return this.transforms.push(r), this.agents.push(s1), this.reachRadii.push(e.reachRadius ? e.reachRadius : e.radius), this._agentDestinationArmed.push(!1), this._agentDestination.push(new E(0, 0, 0)), s1;
    }
    getAgentPosition(t) {
        return this.crowd.getAgentPosition(t);
    }
    getAgentPositionToRef(t, e) {
        let r = this.crowd.getAgentPosition(t);
        e.set(r.x, r.y, r.z);
    }
    getAgentVelocity(t) {
        return this.crowd.getAgentVelocity(t);
    }
    getAgentVelocityToRef(t, e) {
        let r = this.crowd.getAgentVelocity(t);
        e.set(r.x, r.y, r.z);
    }
    getAgentNextTargetPath(t) {
        return this.crowd.getAgentNextTargetPath(t);
    }
    getAgentNextTargetPathToRef(t, e) {
        let r = this.crowd.getAgentNextTargetPath(t);
        e.set(r.x, r.y, r.z);
    }
    getAgentState(t) {
        return this.crowd.getAgentState(t);
    }
    overOffmeshConnection(t) {
        return this.crowd.overOffmeshConnection(t);
    }
    agentGoto(t, e) {
        this.crowd.agentGoto(t, new this.navmeshWasmWrapper.navmeshWasm.Vec3(e.x, e.y, e.z));
        let r = this.agents.indexOf(t);
        r > -1 && (this._agentDestinationArmed[r] = !0, this._agentDestination[r].set(e.x, e.y, e.z));
    }
    agentTeleport(t, e) {
        this.crowd.agentTeleport(t, new this.navmeshWasmWrapper.navmeshWasm.Vec3(e.x, e.y, e.z));
    }
    updateAgentParameters(t, e) {
        let r = this.crowd.getAgentParameters(t);
        e.radius !== void 0 && (r.radius = e.radius), e.height !== void 0 && (r.height = e.height), e.maxAcceleration !== void 0 && (r.maxAcceleration = e.maxAcceleration), e.maxSpeed !== void 0 && (r.maxSpeed = e.maxSpeed), e.collisionQueryRange !== void 0 && (r.collisionQueryRange = e.collisionQueryRange), e.pathOptimizationRange !== void 0 && (r.pathOptimizationRange = e.pathOptimizationRange), e.separationWeight !== void 0 && (r.separationWeight = e.separationWeight), this.crowd.setAgentParameters(t, r);
    }
    removeAgent(t) {
        this.crowd.removeAgent(t);
        let e = this.agents.indexOf(t);
        e > -1 && (this.agents.splice(e, 1), this.transforms.splice(e, 1), this.reachRadii.splice(e, 1), this._agentDestinationArmed.splice(e, 1), this._agentDestination.splice(e, 1));
    }
    getAgents() {
        return this.agents;
    }
    update(t) {
        if (this.navmeshWasmWrapper.navMesh.update(), t <= TV) return;
        let e = 1 / 60, r = 10;
        if (e <= TV) this.crowd.update(t);
        else {
            let i = Math.floor(t / e);
            r && i > r && (i = r), i < 1 && (i = 1);
            let s1 = t / i;
            for(let o = 0; o < i; o++)this.crowd.update(s1);
        }
        for(let i = 0; i < this.agents.length; i++){
            let s1 = this.agents[i], o = this.getAgentPosition(s1);
            if (this.transforms[i].copy(o), this._agentDestinationArmed[i]) {
                let a = o.x - this._agentDestination[i].x, l = o.z - this._agentDestination[i].z, c = this.reachRadii[i], u1 = this._agentDestination[i].y - this.reachRadii[i], h = this._agentDestination[i].y + this.reachRadii[i], d = a * a + l * l;
                o.y > u1 && o.y < h && d < c * c && (this.onReachTarget(s1, this._agentDestination[i]), this._agentDestinationArmed[i] = !1);
            }
        }
    }
    setDefaultQueryExtent(t) {
        let e = new this.navmeshWasmWrapper.navmeshWasm.Vec3(t.x, t.y, t.z);
        this.crowd.setDefaultQueryExtent(e);
    }
    getDefaultQueryExtent() {
        return this.crowd.getDefaultQueryExtent();
    }
    getDefaultQueryExtentToRef(t) {
        let e = this.crowd.getDefaultQueryExtent();
        t.set(e.x, e.y, e.z);
    }
    getCorners(t) {
        let e, r = this.crowd.getCorners(t), i = r.getPointCount(), s1 = [];
        for(e = 0; e < i; e++){
            let o = r.getPoint(e);
            s1.push(new E(o.x, o.y, o.z));
        }
        return s1;
    }
    dispose() {
        this.crowd.destroy();
    }
};
function aC(n1) {
    let t = !1;
    return n1.scene.objects.forEach((e)=>{
        e.data.type === "Page" && !t && e.data.publish.gameControlObject && ql.traverseModuleInstances(n1, e.id, (i, s1, o)=>{
            for (let a of o)a.data.type === "GameControl" && a.data.navmesh.enabled && (t = !0);
        });
    }), t;
}
var R1 = {
    type: "change"
}, Zg = {
    type: "start"
}, mp = {
    type: "end",
    nonOrbit: !0
}, Mte = {
    type: "end",
    nonOrbit: !1
}, Cte = {
    type: "end",
    isZoom: !0,
    nonOrbit: !0
}, Pte = {
    type: "end",
    changed: !1
}, lC = {
    type: "cameraAnimatingInTimeline"
}, cC = new Ye, PV = new U, _te = 2 * Math.PI, Ite = 1e-8, Dte = .01, uC = new E, L1 = new U, hC = new E, N1 = new Ye, _V = new ue;
var Ote = {
    type: "requestRender"
}, gp = class extends ar {
    constructor(e, r, i = {
        isPlayMode: !1,
        isExport: !1
    }, s1){
        super();
        this.object = e;
        this.domElement = r;
        this.options = i;
        this.timelineState = s1;
        this.enabled = !0;
        this.useKeyEvents = !0;
        this.enableDamping = !1;
        this.enableZoom = !0;
        this.enableRotate = !0;
        this.enablePan = !0;
        this.autoRotate = !1;
        this.rotationLimitsMode = 0;
        this.panLimitsMode = 0;
        this.rotationSoftLimit = 2;
        this.panSoftLimit = 2;
        this.hoverRotatePanMode = 0;
        this.zoomLimitsEnabled = !1;
        this.mouseButtons = [
            0,
            5
        ];
        this.mouseButtonsPlay = [
            3,
            4,
            5
        ];
        this.touches = [
            null,
            ts.DOLLY_ROTATE,
            ts.PAN
        ];
        this.offset = new E;
        this.eye = new E;
        this.lastPosition = new E;
        this.lastQuaternion = new Ye;
        this.current = new U;
        this.overShoot = new U;
        this.overRatio = new U;
        this.spherical = new Qp;
        this.sphericalDelta = new Qp;
        this.panOffset = new E;
        this.panLeftV = new E;
        this.panUpV = new E;
        this.panV = new E;
        this.rotateStart = new U;
        this.rotateEnd = new U;
        this.rotateDelta = new U;
        this.panStart = new U;
        this.panEnd = new U;
        this.panDelta = new U;
        this.dollyStart = new U;
        this.dollyEnd = new U;
        this.dollyDelta = new U;
        this.rotationRangeFactor = new U;
        this.panRangeFactor = new U;
        this.state = -1;
        this.zoomChanged = !1;
        this.isPointerDown = !1;
        this.isThetaFlipped = !1;
        this.prevScale = 0;
        this.scale = 1;
        this.gesture = !1;
        this.timer = -1;
        this.timerHover = -1;
        this.minDistance = 0;
        this.maxDistance = 1 / 0;
        this.minZoom = 0;
        this.maxZoom = 1 / 0;
        this.minPhi = 0;
        this.maxPhi = Math.PI;
        this.minTheta = -1 / 0;
        this.maxTheta = 1 / 0;
        this.minH = 0;
        this.maxH = Math.PI;
        this.minV = -1 / 0;
        this.maxV = 1 / 0;
        this.autoRotateClockwise = !0;
        this.isPanOverShoot = !1;
        this.isRotateOverShoot = !1;
        this.resetHoverEffectOnPointerLeave = !1;
        this.hasChange = !1;
        this.useWindowEvents = !1;
        this.isTouchZoom = !0;
        this.autoRotateSpeed = 2;
        this.dampingFactor = .125;
        this.zoomSpeed = 2;
        this.rotateSpeed = 1;
        this.rotateFactor = 1;
        this.panSpeed = 1;
        this.hoverRotatePanStrength = .1;
        this.hoverRotateDamping = this.dampingFactor;
        this.isCurrentlyDamping = !1;
        this.thetaIsFree = !1;
        this.phiIsFree = !1;
        this.needsUpdate = !0;
        this.onCameraChange = (e)=>{
            this.object.removeEventListener("beginState", this.onBeginState), this.object.removeEventListener("completeState", this.onCompleteState), this.object.removeEventListener("cameraChange", this.onCameraChange), this.object = e.camera, this.object.addEventListener("beginState", this.onBeginState), this.object.addEventListener("completeState", this.onCompleteState), this.object.addEventListener("cameraChange", this.onCameraChange);
        };
        this.update = ()=>{
            this.object.updateWorldMatrix(!0, !1), this.object.matrixWorld.decompose(hC, N1, uC), this.offset.copy(hC).sub(this.target), this.spherical.setFromVector3(this.offset), this.object.isUpVectorFlipped && (this.spherical.phi *= -1, this.spherical.theta -= Math.PI), this.autoRotate && this.state === -1 && this.rotateLeft((this.autoRotateClockwise === !0 ? 1 : -1) * this.getAutoRotationAngle()), this.rotationLimitsMode !== 0 && this.applyLimits(this.sphericalDelta, this.rotationLimitsMode, this.rotationSoftLimit, this.maxTheta, this.minTheta, this.maxPhi, this.minPhi, this.rotationRangeFactor), this.rotationLimitsMode !== 2 && (this.spherical.phi += this.sphericalDelta.phi), (this.rotationLimitsMode !== 1 || this.autoRotate === !0) && (this.spherical.theta += this.sphericalDelta.theta), this.spherical.radius *= this.scale, this.zoomLimitsEnabled && this.object.isPerspectiveCamera && (this.spherical.radius = Math.max(this.minDistance, Math.min(this.maxDistance, this.spherical.radius))), this.panLimitsMode !== 0 && (this.target.applyQuaternion(cC.copy(N1).invert()), this.panOffset.applyQuaternion(cC), this.applyLimits(this.panOffset, this.panLimitsMode, this.panSoftLimit, this.maxH, this.minH, this.maxV, this.minV, this.panRangeFactor), this.target.applyQuaternion(N1), this.panOffset.applyQuaternion(N1)), this.panLimitsMode === 2 && (this.panOffset.y = 0), this.panLimitsMode === 1 && (this.panOffset.x = 0), this.state === -1 && !this.gesture ? (this.panOffset.multiplyScalar(1 - this.dampingFactor), this.target.add(this.panOffset)) : (this.target.add(this.panOffset), this.panOffset.set(0, 0, 0)), this.offset.setFromSpherical(this.spherical), hC.copy(this.target).add(this.offset), this.object.position.copy(this.target).add(this.offset), this.object.parent && (_V.copy(this.object.parent.matrixWorld).invert(), this.object.position.applyMatrix4(_V));
            let e = this.spherical.phi % _te;
            if (this.eye.copy(this.offset).normalize(), this.object.up.copy(Dt.DEFAULT_UP).applyAxisAngle(this.eye, this.object.angleOffsetFromUp), e > 0 && e > Math.PI || e < 0 && e > -Math.PI ? (this.object.up.negate(), this.object.lookAt(this.target), this.object.isUpVectorFlipped = !0) : (this.object.lookAt(this.target), this.object.isUpVectorFlipped = !1), this.state === -1 || this.enableDamping === !0) {
                let r = this.hoverRotatePanMode === 1 ? this.hoverRotateDamping : this.dampingFactor;
                this.sphericalDelta.theta *= 1 - r, this.sphericalDelta.phi *= 1 - r;
            } else this.sphericalDelta.set(0, 0, 0);
            if (this.scale = 1, this.lastPosition.distanceToSquared(this.object.position) > Dte || 8 * (1 - this.lastQuaternion.dot(this.object.quaternion)) > Ite) {
                this.dispatchEvent(R1), this.object.dispatchEvent(Ote), this.lastPosition.copy(this.object.position), this.lastQuaternion.copy(this.object.quaternion), this.isCurrentlyDamping = !0;
                return;
            }
            this.isPanOverShoot = !1, this.isRotateOverShoot = !1, this.object.wasMovedBySwitchCameraAction = !1, this.sphericalDelta.set(0, 0, 0), this.panOffset.set(0, 0, 0), this.isCurrentlyDamping = !1;
        };
        this.onPointerDown = (e)=>{
            this.enabled !== !1 && (e.pointerType === "touch" || e.pointerType === "pen" && Li ? this.onPointerDownTouch(e) : this.onPointerDownMouse(e), this.state !== -1 && (this.isPointerDown = !0, this.dispatchEvent(Zg), this.domElement.addEventListener("pointermove", this.onPointerMove), this.domElement.addEventListener("pointerup", this.onPointerUp), e.stopPropagation(), e.pointerType === "touch" || e.pointerType === "pen" && Li || this.domElement.setPointerCapture(e.pointerId)));
        };
        this.onPointerLeave = (e)=>{
            this.resetHoverEffectOnPointerLeave && !this.useWindowEvents ? (this.hoverRotatePanMode === 1 ? (this.sphericalDelta.theta = -this.spherical.theta, this.sphericalDelta.phi = -this.spherical.phi, uC.subVectors(this.position0, this.target0), this.spherical.setFromVector3(uC), this.sphericalDelta.theta += this.spherical.theta, this.sphericalDelta.phi += this.spherical.phi, this.sphericalDelta.theta /= 8, this.sphericalDelta.phi /= 8) : this.hoverRotatePanMode === 2 && this.panOffset.subVectors(this.target0, this.target).divideScalar(8), this.update()) : this.pointerLeaveEvent = e;
        };
        this.onPointerEnter = (e)=>{
            this.resetHoverEffectOnPointerLeave || this.pointerLeaveEvent === void 0 ? L1.set(e.clientX - this.domElement.clientWidth / 2, e.clientY - this.domElement.clientHeight / 2) : L1.set(e.clientX - this.pointerLeaveEvent.clientX, e.clientY - this.pointerLeaveEvent.clientY), this.hoverRotatePanMode === 1 ? (this.rotateDelta.copy(L1).multiplyScalar(this.rotateSpeed * this.hoverRotatePanStrength).rotateAround(PV, -this.object.angleOffsetFromUp), this.rotateLeft(2 * Math.PI * this.rotateDelta.x / this.domElement.clientHeight), this.rotateUp(2 * Math.PI * this.rotateDelta.y / this.domElement.clientHeight), this.rotateStart.set(e.clientX, e.clientY)) : this.hoverRotatePanMode === 2 && (this.panDelta.copy(L1).multiplyScalar(this.panSpeed * this.hoverRotatePanStrength), this.pan(this.panDelta.x, this.panDelta.y), this.panStart.set(e.clientX, e.clientY)), this.update();
        };
        this.onPointerMove = (e)=>{
            if (this.timelineState?.isPlayingCameraAnimation) {
                this.dispatchEvent(lC);
                return;
            }
            this.enabled !== !1 && (this.checkRaycastLock() || (e.pointerType === "touch" || e.pointerType === "pen" && Li ? this.onPointerMoveTouch(e) : this.onPointerMoveMouse(e), e.stopPropagation()));
        };
        this.onPointerUp = (e)=>{
            this.isPointerDown = !1, et.length === 0 && (this.domElement.removeEventListener("pointermove", this.onPointerMove), this.domElement.removeEventListener("pointerup", this.onPointerUp)), et.length > 1 && e.preventDefault(), this.hasChange ? this.dispatchEvent(this.state === 0 ? Mte : mp) : this.dispatchEvent(Pte), this.state = -1, e && (e.stopPropagation(), e.pointerType === "touch" || e.pointerType === "pen" && Li || this.domElement.releasePointerCapture(e.pointerId));
        };
        this.onPointerDownMouse = (e)=>{
            let r;
            switch(this.useKeyEvents ? r = this.mouseButtons[e.button] : r = this.mouseButtonsPlay[e.button], r){
                case 0:
                    if (e.altKey === !0 && !e.shiftKey && !lm(e)) {
                        if (this.enableRotate === !1) return;
                        this.handleMouseDownRotate(e), this.state = 0;
                    } else if (this.key === " ") {
                        if (this.enablePan === !1) return;
                        this.handleMouseDownPan(e), this.state = 2;
                    }
                    break;
                case 4:
                    if (this.enablePan === !1) return;
                    this.handleMouseDownPan(e), this.state = 2;
                    break;
                case 3:
                    if (lm(e) || e.shiftKey) {
                        if (this.enablePan === !1) return;
                        this.handleMouseDownPan(e), this.state = 2;
                    } else {
                        if (this.enableRotate === !1) return;
                        this.handleMouseDownRotate(e), this.state = 0;
                    }
                    break;
                case 5:
                    if (lm(e) || e.shiftKey) {
                        if (this.enableRotate === !1) return;
                        this.handleMouseDownRotate(e), this.state = 0;
                    } else {
                        if (this.enablePan === !1) return;
                        this.handleMouseDownPan(e), this.state = 2;
                    }
                    break;
                default:
                    this.state = -1;
            }
        };
        this.onPointerMoveMouse = (e)=>{
            switch(this.state){
                case 0:
                    if (this.enableRotate === !1) return;
                    this.handleMouseMoveRotate(e);
                    break;
                case 1:
                    if (this.enableZoom === !1) return;
                    this.handleMouseMoveDolly(e);
                    break;
                case 2:
                    if (this.enablePan === !1) return;
                    this.handleMouseMovePan(e);
                    break;
            }
            this.object.wasMovedByUser = !0;
        };
        this.onPointerDownTouch = (e)=>{
            switch(et.length > 1 && e.preventDefault(), this.touches[et.length - 1]){
                case ts.ROTATE:
                    if (this.enableRotate === !1) {
                        this.state = -1;
                        return;
                    }
                    this.handleTouchStartRotate(), this.state = 3;
                    break;
                case ts.PAN:
                    if (this.enablePan === !1) {
                        this.state = -1;
                        return;
                    }
                    this.handleTouchStartPan(), this.state = 4;
                    break;
                case ts.DOLLY_PAN:
                    if (this.enableZoom === !1 && this.enablePan === !1) return;
                    this.handleTouchStartDollyPan(), this.state = 5;
                    break;
                case ts.DOLLY_ROTATE:
                    if (this.enableZoom === !1 && this.enableRotate === !1) return;
                    this.handleTouchStartDollyRotate(), this.state = 6;
                    break;
                default:
                    this.state = -1;
            }
        };
        this.onPointerMoveTouch = (e)=>{
            switch(et.length > 1 && e.preventDefault(), this.state){
                case 3:
                    if (this.enableRotate === !1) return;
                    this.handleTouchMoveRotate(e), this.update();
                    break;
                case 4:
                    if (this.enablePan === !1) return;
                    this.handleTouchMovePan(e), this.update();
                    break;
                case 5:
                    if (this.enableZoom === !1 && this.enablePan === !1) return;
                    this.handleTouchMoveDollyPan(e), this.update();
                    break;
                case 6:
                    if (this.enableZoom === !1 && this.enableRotate === !1) return;
                    this.handleTouchMoveDollyRotate(e), this.update();
                    break;
                default:
                    this.state = -1;
            }
            this.object.wasMovedByUser = !0;
        };
        this.dispatchEndDebounced = _o(()=>{
            this.zoomChanged ? this.dispatchEvent(Cte) : this.dispatchEvent(mp), this.zoomChanged = !1;
        }, 33);
        this.onMouseWheel = (e)=>{
            if (!(this.enabled === !1 || this.enableZoom === !1 && this.enablePan === !1) && !this.checkRaycastLock()) {
                if (!this.options.isExport && this.domElement.clientHeight === document.body.clientHeight && this.domElement.clientWidth === document.body.clientWidth && e.preventDefault(), this.dispatchEvent(Zg), this.timelineState?.isPlayingCameraAnimation) {
                    this.dispatchEvent(lC);
                    return;
                }
                this.handleMouseWheel(e), this.dispatchEndDebounced(), this.object.wasMovedByUser = !0;
            }
        };
        this.onGesture = (e)=>{
            if (e.preventDefault(), this.enabled !== !1 && !this.checkRaycastLock() && !bs) {
                if (this.timelineState?.isPlayingCameraAnimation) {
                    this.dispatchEvent(lC);
                    return;
                }
                if (e.type === "gesturechange") {
                    if (this.enableZoom === !1 || this.isTouchZoom === !1) return;
                    this.dispatchEvent(Zg), e.scale > this.prevScale ? this.dollyIn(this.getZoomScale()) : e.scale < this.prevScale && this.dollyOut(this.getZoomScale()), this.prevScale = e.scale, this.update(), this.object.wasMovedByUser = !0;
                } else this.dispatchEvent(mp);
            }
        };
        this.onContextMenu = (e)=>{
            e.preventDefault();
        };
        this.onTouchEnd = (e)=>{
            e.preventDefault();
        };
        this.onKeyDown = (e)=>{
            this.enabled !== !1 && (this.key = e.key, e.key === " " && this.dispatchEvent(Zg));
        };
        this.onKeyUp = (e)=>{
            this.enabled !== !1 && (this.key = void 0, this.state !== -1 && e.key === "Alt" && this.onPointerUp(et[0]), e.key === " " && this.dispatchEvent(mp));
        };
        this.onPointerHover = (e)=>{
            e.pointerType !== "mouse" || this.enabled === !1 || this.state !== -1 || this.hoverRotatePanMode === 2 && this.isPanOverShoot || this.hoverRotatePanMode === 1 && this.isRotateOverShoot || (this.isPointerDown = !0, this.hoverRotatePanMode === 2 ? this.handleMouseMovePan(e, this.hoverRotatePanStrength) : this.hoverRotatePanMode === 1 && this.handleMouseMoveRotate(e, this.hoverRotatePanStrength));
        };
        this.onBeginState = ()=>{
            this.enabled = !1, this.needsUpdate = !1;
        };
        this.onCompleteState = (e)=>{
            e.isfromEntity && this.options.isPlayMode || (this.enabled = !0, this.needsUpdate = !0, this.object.updateUp(), this.object.getTarget(this.target));
        };
        this.target = this.object.getTarget(), this.target0 = this.target.clone(), this.position0 = this.object.position.clone(), this.zoom0 = this.object.zoom, this.quat0 = this.object.quaternion.clone(), this.isUpVectorFlipped0 = this.object.isUpVectorFlipped, this.offset.copy(this.object.position).sub(this.target), this.spherical.setFromVector3(this.offset), this.object.isUpVectorFlipped && (this.spherical.phi *= -1, this.spherical.theta -= Math.PI), this.initialSphericalRadius = this.spherical.radius, this.addEventListenersToCamera();
    }
    dispatchEvent(e) {
        e.type === "start" ? this.hasChange = !1 : this.hasChange = !0, super.dispatchEvent(e);
    }
    addEventListenersToCamera() {
        this.object.addEventListener("beginState", this.onBeginState), this.object.addEventListener("completeState", this.onCompleteState), this.object.addEventListener("cameraChange", this.onCameraChange);
    }
    removeEventListenersFromCamera() {
        this.object.removeEventListener("beginState", this.onBeginState), this.object.removeEventListener("completeState", this.onCompleteState), this.object.removeEventListener("cameraChange", this.onCameraChange);
    }
    updateUseWindowEvents(e) {
        if (window.removeEventListener("pointermove", this.onPointerHover), this.domElement.removeEventListener("pointermove", this.onPointerHover), this.useWindowEvents = e, this.hoverRotatePanMode !== 0 && (this.useWindowEvents ? window.addEventListener("pointermove", this.onPointerHover) : this.domElement.addEventListener("pointermove", this.onPointerHover)), this.domElement.removeEventListener("pointerleave", this.onPointerLeave), this.domElement.removeEventListener("pointerenter", this.onPointerEnter), window.removeEventListener("pointerleave", this.onPointerLeave), window.removeEventListener("pointerenter", this.onPointerEnter), this.hoverRotatePanMode !== 0 && !this.useWindowEvents) {
            let r = this.useWindowEvents ? window : this.domElement;
            r.addEventListener("pointerleave", this.onPointerLeave), r.addEventListener("pointerenter", this.onPointerEnter);
        }
    }
    fromJSON(e, r) {
        this.rotateFactor = e.rotationSpeed ?? 1, this.setEnableDampingSpeed(e.enableDamping), this.enablePan = e.enablePan, this.enableZoom = e.enableZoom, this.enableRotate = e.enableRotate, this.rotationLimitsMode = e.rotationLimitsMode, this.thetaIsFree = e.rotationHorizontalOffset.min === e.rotationHorizontalOffset.max && e.rotationHorizontalOffset.min === Math.PI, this.phiIsFree = e.rotationVerticalOffset.min === e.rotationVerticalOffset.max && e.rotationVerticalOffset.min === Math.PI, this.panLimitsMode = e.panLimitsMode, this.panSoftLimit = e.panSoftLimit, this.rotationSoftLimit = e.rotationSoftLimit, this.hoverRotatePanMode = e.hoverRotatePanMode, this.hoverRotateDamping = e.hoverRotateDamping ?? this.dampingFactor, this.useWindowEvents = r === "window", this.hoverRotatePanMode !== 0 && (this.useWindowEvents ? window.addEventListener("pointermove", this.onPointerHover) : this.domElement.addEventListener("pointermove", this.onPointerHover));
        let i = e.hoverRotatePanStrength / 100;
        this.hoverRotatePanStrength = i ** 2, this.zoomLimitsEnabled = e.zoomLimitsEnabled, this.minZoom = e.zoomLimits.min, this.maxZoom = Math.max(e.zoomLimits.min, e.zoomLimits.max), this.minDistance = 1e3 / this.maxZoom, this.maxDistance = Math.max(this.minDistance, 1e3 / e.zoomLimits.min), this.autoRotate = e.autoRotate, this.autoRotateSpeed = e.autoRotateSpeed, this.autoRotateClockwise = e.autoRotateClockwise;
        let s1 = this.object.getTarget().applyQuaternion(cC.copy(this.object.quaternion).invert());
        this.minV = -e.panVerticalOffset.min + s1.y, this.maxV = e.panVerticalOffset.max + s1.y, this.minH = -e.panHorizontalOffset.min + s1.x, this.maxH = e.panHorizontalOffset.max + s1.x, this.panRangeFactor.set(this.maxH - this.minH, this.maxV - this.minV).divideScalar(2), this.rotationRangeFactor.setScalar(Math.PI).divideScalar(4), this.minPhi = ya(this.spherical.phi - e.rotationVerticalOffset.min), this.maxPhi = ya(this.spherical.phi + e.rotationVerticalOffset.max), this.minTheta = ya(ya(this.spherical.theta) - e.rotationHorizontalOffset.min), this.maxTheta = ya(ya(this.spherical.theta) + e.rotationHorizontalOffset.max), this.isThetaFlipped = this.minTheta > this.maxTheta, e.orbitTouches === 1 && (this.touches[0] = ts.ROTATE), e.panTouches === 1 && (this.touches[0] = ts.PAN), e.orbitTouches === 2 && (this.touches[1] = ts.DOLLY_ROTATE), e.panTouches === 2 && (this.touches[1] = ts.DOLLY_PAN), e.orbitTouches === 3 && (this.touches[2] = ts.ROTATE), e.panTouches === 3 && (this.touches[2] = ts.PAN), this.isTouchZoom = e.isTouchZoom, this.resetHoverEffectOnPointerLeave = e.resetHoverEffectOnPointerLeave ?? !1;
    }
    connect() {
        if (this.domElement.addEventListener("contextmenu", this.onContextMenu), this.domElement.addEventListener("pointerdown", this.onPointerDown), this.domElement.addEventListener("wheel", this.onMouseWheel), window.addEventListener("keydown", this.onKeyDown, !1), window.addEventListener("keyup", this.onKeyUp, !1), this.domElement.addEventListener("gesturestart", this.onGesture), this.domElement.addEventListener("gesturechange", this.onGesture), this.domElement.addEventListener("gestureend", this.onGesture), this.domElement.addEventListener("touchend", this.onTouchEnd), this.hoverRotatePanMode !== 0 && !this.useWindowEvents) {
            let e = this.useWindowEvents ? window : this.domElement;
            e.addEventListener("pointerleave", this.onPointerLeave), e.addEventListener("pointerenter", this.onPointerEnter);
        }
        this.pointerLeaveEvent = void 0;
    }
    dispose() {
        this.removeEventListenersFromCamera(), this.domElement.removeEventListener("contextmenu", this.onContextMenu), this.domElement.removeEventListener("pointerdown", this.onPointerDown), this.domElement.removeEventListener("wheel", this.onMouseWheel), window.removeEventListener("keydown", this.onKeyDown, !1), window.removeEventListener("keyup", this.onKeyUp, !1), this.domElement.removeEventListener("pointermove", this.onPointerHover), window.removeEventListener("pointermove", this.onPointerHover), this.domElement.removeEventListener("gesturestart", this.onGesture), this.domElement.removeEventListener("gesturechange", this.onGesture), this.domElement.removeEventListener("gestureend", this.onGesture), this.domElement.removeEventListener("touchend", this.onTouchEnd), this.domElement.removeEventListener("pointerleave", this.onPointerLeave), this.domElement.removeEventListener("pointerenter", this.onPointerEnter), window.removeEventListener("pointerleave", this.onPointerLeave), window.removeEventListener("pointerenter", this.onPointerEnter), this.domElement.removeEventListener("pointermove", this.onPointerMove), this.domElement.removeEventListener("pointerup", this.onPointerUp);
    }
    applyLimits(e, r, i, s1, o, a, l, c) {
        this.overShoot.set(0, 0);
        let u1, h, d;
        e instanceof E ? (u1 = e.x, h = e.y, this.current.set(this.target.x, this.target.y), d = !0) : (u1 = e.theta, h = e.phi, this.current.set(ya(this.spherical.theta), ya(this.spherical.phi)), d = !1), i === 0 && (this.current.x += u1, this.current.y += h), (r === 3 || r === 2) && (!d && this.isThetaFlipped ? this.current.x > s1 && this.current.x < 0 ? this.overShoot.x = s1 - this.current.x : this.current.x < o && this.current.x > 0 && (this.overShoot.x = o - this.current.x) : this.current.x > s1 ? this.overShoot.x = s1 - this.current.x : this.current.x < o && (this.overShoot.x = o - this.current.x)), (r === 3 || r === 1) && (this.current.y > a ? this.overShoot.y = a - this.current.y : this.current.y < l && (this.overShoot.y = l - this.current.y)), d || (this.overShoot.x = ya(this.overShoot.x), this.overShoot.y = ya(this.overShoot.y)), i !== 0 ? (this.overRatio.copy(this.overShoot).divide(c), this.overRatio.x = Math.min(Math.abs(this.overRatio.x), 1), this.overRatio.y = Math.min(Math.abs(this.overRatio.y), 1), i === 1 && (this.overRatio.x = IV(Math.abs(this.overRatio.x)), this.overRatio.y = IV(Math.abs(this.overRatio.y))), this.isPointerDown || i === 1 ? i === 2 && (this.overRatio.x > .9 && !this.thetaIsFree || this.overRatio.y > .9 && !this.phiIsFree) ? this.isPointerDown = !1 : (u1 * this.overShoot.x < 0 && !this.thetaIsFree && (u1 *= 1 - this.overRatio.x), h * this.overShoot.y < 0 && !this.phiIsFree && (h *= 1 - this.overRatio.y)) : i === 2 && (!d && (this.overRatio.x > .002 && !this.thetaIsFree || this.overRatio.y > .002 && !this.phiIsFree) || d && (Math.abs(this.overShoot.x) > 2 || Math.abs(this.overShoot.y) > 2) ? (this.thetaIsFree || (u1 = this.overShoot.x * .05), this.phiIsFree || (h = this.overShoot.y * .05), d ? this.isPanOverShoot = !0 : this.isRotateOverShoot = !0) : d ? this.isPanOverShoot = !1 : this.isRotateOverShoot = !1)) : (u1 += this.overShoot.x, h += this.overShoot.y), e instanceof E ? (e.x = u1, e.y = h) : (this.thetaIsFree || (e.theta = u1), this.phiIsFree || (e.phi = h));
    }
    setEnableDampingSpeed(e) {
        this.enableDamping = e, this.rotateSpeed = (e === !0 ? .2 : 1) * this.rotateFactor;
    }
    stopDamping() {
        this.sphericalDelta.theta = 0, this.sphericalDelta.phi = 0;
    }
    getAutoRotationAngle() {
        return 2 * Math.PI / 60 / 60 * this.autoRotateSpeed;
    }
    getZoomScale() {
        return Math.pow(.95, this.zoomSpeed);
    }
    rotateLeft(e) {
        this.sphericalDelta.theta -= e;
    }
    rotateUp(e) {
        this.sphericalDelta.phi -= e;
    }
    panLeft(e, r) {
        this.panLeftV.setFromMatrixColumn(r, 0), this.panLeftV.multiplyScalar(-e), this.panOffset.add(this.panLeftV);
    }
    panUp(e, r) {
        this.panUpV.setFromMatrixColumn(r, 1), this.panUpV.multiplyScalar(e), this.panOffset.add(this.panUpV);
    }
    pan(e, r) {
        let i = this.domElement;
        if (i && this.object.isPerspectiveCamera) {
            let s1 = this.object.position;
            this.panV.copy(s1).sub(this.target);
            let o = this.panV.length();
            o *= Math.tan(this.object.fov / 2 * Math.PI / 180), this.panLeft(2 * e * o / i.clientHeight, this.object.matrixWorld), this.panUp(2 * r * o / i.clientHeight, this.object.matrixWorld);
        } else i && this.object.isOrthographicCamera && (this.panLeft(e * (this.object.right - this.object.left) / this.object.zoom / i.clientWidth, this.object.matrixWorld), this.panUp(r * (this.object.top - this.object.bottom) / this.object.zoom / i.clientHeight, this.object.matrixWorld));
        this.dispatchEvent(R1);
    }
    dollyOut(e) {
        this.object.isPerspectiveCamera ? this.scale /= e : this.object.isOrthographicCamera && (this.object.zoom *= e, this.zoomLimitsEnabled && (this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom))), this.object.updateProjectionMatrix(), this.zoomChanged = !0), this.dispatchEvent(R1);
    }
    dollyIn(e) {
        this.object.isPerspectiveCamera ? this.scale *= e : this.object.isOrthographicCamera && (this.object.zoom /= e, this.zoomLimitsEnabled && (this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom))), this.object.updateProjectionMatrix(), this.zoomChanged = !0), this.dispatchEvent(R1);
    }
    setZoom(e) {
        if (this.dispatchEvent(Zg), this.object.isPerspectiveCamera) {
            let i = this.initialSphericalRadius / e / this.spherical.radius;
            this.scale = i;
        } else this.object.isOrthographicCamera && (this.object.zoom = e, this.zoomLimitsEnabled && (this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom))), this.object.updateProjectionMatrix(), this.zoomChanged = !0);
        this.dispatchEvent(mp);
    }
    handleMouseDownRotate(e) {
        this.rotateStart.set(e.clientX, e.clientY);
    }
    handleMouseDownDolly(e) {
        this.dollyStart.set(e.clientX, e.clientY);
    }
    handleMouseDownPan(e) {
        this.panStart.set(e.clientX, e.clientY);
    }
    handleMouseMoveRotate(e, r = 1) {
        e.movementX !== void 0 ? this.rotateDelta.set(e.movementX, e.movementY) : (this.rotateEnd.set(e.clientX, e.clientY), this.rotateDelta.subVectors(this.rotateEnd, this.rotateStart), this.rotateStart.copy(this.rotateEnd)), this.rotateDelta.multiplyScalar(this.rotateSpeed * r).rotateAround(PV, -this.object.angleOffsetFromUp);
        let i = this.domElement, s1 = this.useWindowEvents ? window.innerHeight : i.clientHeight, o = 2 * Math.PI * this.rotateDelta.x / s1, a = 2 * Math.PI * this.rotateDelta.y / s1;
        this.rotateLeft(o), this.rotateUp(a), this.update();
    }
    handleMouseMoveDolly(e) {
        this.dollyEnd.set(e.clientX, e.clientY), this.dollyDelta.subVectors(this.dollyEnd, this.dollyStart), this.dollyDelta.y > 0 ? this.dollyOut(this.getZoomScale()) : this.dollyDelta.y < 0 && this.dollyIn(this.getZoomScale()), this.dollyStart.copy(this.dollyEnd), this.update();
    }
    handleMouseMovePan(e, r = 1) {
        e.movementX !== void 0 ? this.panDelta.set(e.movementX, e.movementY) : (this.panEnd.set(e.clientX, e.clientY), this.panDelta.subVectors(this.panEnd, this.panStart), this.panStart.copy(this.panEnd)), this.panDelta.multiplyScalar(this.panSpeed * r), this.pan(this.panDelta.x, this.panDelta.y), this.update();
    }
    handleMouseWheel(e) {
        if (uD === !1 && lm(e) === !1 && dD(e) === !0) {
            if (this.enablePan === !1) return;
            this.gesture ? (this.panDelta.set(-e.deltaX, -e.deltaY).multiplyScalar(this.panSpeed), this.panDelta.x = Math.min(Math.abs(this.panDelta.x), 100) * (this.panDelta.x < 0 ? -1 : 1), this.panDelta.y = Math.min(Math.abs(this.panDelta.y), 100) * (this.panDelta.y < 0 ? -1 : 1), e.altKey ? this.pan(0, this.panDelta.y) : e.shiftKey ? this.pan(this.panDelta.x, 0) : this.pan(this.panDelta.x, this.panDelta.y), this.update()) : (this.gesture = !0, this.isPointerDown = !0), window.clearTimeout(this.timer), this.timer = window.setTimeout(()=>{
                this.gesture = !1, this.isPointerDown = !1, this.dispatchEvent(mp);
            }, 30);
        } else {
            if (this.enableZoom === !1 || this.gesture) return;
            e.deltaY === 0 ? e.deltaX < 0 ? this.dollyIn(this.getZoomScale()) : e.deltaX > 0 && this.dollyOut(this.getZoomScale()) : e.deltaY < 0 ? this.dollyIn(this.getZoomScale()) : e.deltaY > 0 && this.dollyOut(this.getZoomScale()), this.update(), this.gesture = !1, this.isPointerDown = !1;
        }
    }
    handleTouchStartRotate() {
        if (et.length === 2) {
            let e = .5 * (et[0].pageX + et[1].pageX), r = .5 * (et[0].pageY + et[1].pageY);
            this.rotateStart.set(e, r);
        } else this.rotateStart.set(et[0].pageX, et[0].pageY);
    }
    handleTouchStartPan() {
        if (et.length === 2) {
            let e = .5 * (et[0].pageX + et[1].pageX), r = .5 * (et[0].pageY + et[1].pageY);
            this.panStart.set(e, r);
        } else this.panStart.set(et[0].pageX, et[0].pageY);
    }
    handleTouchStartDolly() {
        let e = et[0].pageX - et[1].pageX, r = et[0].pageY - et[1].pageY, i = Math.sqrt(e * e + r * r);
        this.dollyStart.set(0, i);
    }
    handleTouchStartDollyPan() {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchStartDolly(), this.enablePan && this.handleTouchStartPan();
    }
    handleTouchStartDollyRotate() {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchStartDolly(), this.enableRotate && this.handleTouchStartRotate();
    }
    handleTouchMoveRotate(e) {
        if (et.length === 2) {
            let i = Qv(e), s1 = .5 * (e.pageX + i.x), o = .5 * (e.pageY + i.y);
            this.rotateEnd.set(s1, o);
        } else {
            if (e.pointerId !== et[0].pointerId) return;
            this.rotateEnd.set(e.pageX, e.pageY);
        }
        this.rotateDelta.subVectors(this.rotateEnd, this.rotateStart).multiplyScalar(this.rotateSpeed);
        let r = this.domElement;
        r && (this.rotateLeft(2 * Math.PI * this.rotateDelta.x / r.clientHeight), this.rotateUp(2 * Math.PI * this.rotateDelta.y / r.clientHeight)), this.rotateStart.copy(this.rotateEnd);
    }
    handleTouchMovePan(e) {
        if (et.length === 2) {
            let r = Qv(e), i = .5 * (e.pageX + r.x), s1 = .5 * (e.pageY + r.y);
            this.panEnd.set(i, s1);
        } else {
            if (e.pointerId !== et[0].pointerId) return;
            this.panEnd.set(e.pageX, e.pageY);
        }
        this.panDelta.subVectors(this.panEnd, this.panStart).multiplyScalar(this.panSpeed), this.pan(this.panDelta.x, this.panDelta.y), this.panStart.copy(this.panEnd);
    }
    handleTouchMoveDolly(e) {
        let r = Qv(e), i = e.pageX - r.x, s1 = e.pageY - r.y, o = Math.sqrt(i * i + s1 * s1);
        this.dollyEnd.set(0, o), this.dollyDelta.set(0, Math.pow(this.dollyEnd.y / this.dollyStart.y, this.zoomSpeed)), this.dollyOut(this.dollyDelta.y), this.dollyStart.copy(this.dollyEnd);
    }
    handleTouchMoveDollyPan(e) {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchMoveDolly(e), this.enablePan && this.handleTouchMovePan(e);
    }
    handleTouchMoveDollyRotate(e) {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchMoveDolly(e), this.enableRotate && this.handleTouchMoveRotate(e);
    }
    checkRaycastLock() {
        if (this.object.data.raycastLock) {
            if (this.options.isPlayMode) return !1;
            {
                let e = this.options?.showCameraLock;
                return e && e(), !0;
            }
        } else return !1;
    }
};
function ya(n1) {
    let t = Math.PI * 2;
    for(; n1 <= -Math.PI;)n1 += t;
    for(; n1 > Math.PI;)n1 -= t;
    return n1;
}
function IV(n1) {
    return 1 - Math.pow(1 - n1, 4);
}
var Jg = class {
    constructor(t, e, r, i, s1, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.page = i;
        this.currentIntersectedObjects = [];
        this.actions = Wt(e, e.actions, i, s1, o, r), this.target = e.target, this.triggeringObjects = [];
        for (let a of e.triggeringObjects){
            let l = i.scene.find(a);
            l && this.triggeringObjects.push(l);
        }
    }
    isValidTriggeringObject(t) {
        return this.target === "all" ? !0 : this.triggeringObjects.some((e)=>e === t || e.isAncestorOf(t.uuid) || t.isAncestorOf(e.uuid));
    }
    disconnect() {
        vr(this.actions);
    }
    dispatch() {
        this.object.destroyedInAction || (this.actions.Transition.forEach((t)=>{
            t.object.currentTransitionEvent !== this && (t.object.currentTransitionEvent = this, t.init());
        }), this.object.dispatchEvent({
            type: "beginEvent",
            eventName: "Trigger"
        }), this.actions.Transition.forEach((t)=>{
            t.data.runMode === "Toggle" ? t.toggle() : t.play();
        }), this.actions.SwitchCamera.forEach((t)=>{
            t.data.runMode === "Toggle" ? t.toggle() : t.play();
        }), this.actions.TimelineAnimation.forEach((t)=>{
            t.data.runMode === "Toggle" ? t.toggle() : t.play();
        }), this.actions.Link.forEach((t)=>{
            t.dispatch();
        }), this.actions.Reset.forEach((t)=>{
            t.dispatch();
        }), this.actions.Create.forEach((t)=>{
            t.dispatch();
        }), this.actions.Destroy.forEach((t)=>{
            t.dispatch(!1);
        }), this.actions.Audio.forEach((t)=>{
            t.dispatchBasic();
        }), this.actions.Particles.forEach((t)=>{
            t.dispatchBasic();
        }), this.actions.Video.forEach((t)=>{
            t.dispatchBasic();
        }), this.actions.SceneTransition.forEach((t)=>{
            t.dispatch();
        }), this.actions.SetVariable.forEach((t)=>t.checkConditions()), this.actions.SetVariable.forEach((t)=>t.dispatch()), this.actions.DynamicVariablePlay.forEach((t)=>t.dispatch()), this.actions.ClearLocalStorage.forEach((t)=>t.dispatch()), this.actions.UserAPI.forEach((t)=>t.dispatch()));
    }
};
var Xt;
AD.then((n1)=>Xt = n1);
var Ti = new E, xo = new Ye, Tc = new E, dC = new Jt(0, 0, 0, "YXZ"), DV = new Jt(0, 0, 0, "XYZ"), bo = new E, fC = new E, pC = new E(1, 1, 1), yp = new Ye, B1 = new ue, OV = new ue, Rte = {
    type: "updateMatrix"
}, RV = new Ye, mC = new ei, g1 = {
    type: "beginEvent",
    eventName: "Collision"
}, Lte = {
    type: "beginEvent",
    eventName: "Trigger"
};
function LV(n1) {
    if (ql.physicsEnabled(n1.scene.objects)) return !0;
    let t = !1;
    return n1.scene.objects.traverse((e, r)=>{
        if (r.events) {
            if (Array.isArray(r.events)) {
                for (let i of r.events)if (i.data.disabled !== !0 && i.data.type === "GameControl" && i.data.collisionEnabled) {
                    t = !0;
                    break;
                }
            } else for (let i of Object.values(r.events))if (i.disabled !== !0 && i.type === "GameControl" && i.collisionEnabled) {
                t = !0;
                break;
            }
        }
    }), t;
}
var Qg = (n1)=>n1.states.some((t)=>t.data.position !== void 0 || t.data.rotation !== void 0 || t.data.hiddenMatrix !== void 0 || t.data.cloner !== void 0 || t.data.pathSnapping !== void 0), F1 = class {
    constructor(t){
        this.eventContext = t;
        this.isEnabled = !1;
        this.gameControl = null;
        this.joysticks = [];
        this.joystickToGameControls = [];
        this.sharedGameControlGlobals = {
            entitiesWithTransformAnim: [],
            entityToCollisionEvents: {},
            colliderToEntity: new Map,
            triggers: [],
            gamePads: [],
            createdObjects: [],
            nCreatedPerAction: {}
        };
        this.sensorToTriggerEvent = {};
        this.eventManager = void 0;
        this.needsCollisionDetection = !1;
        this.initializationCounter = -1;
        this.rigidBodyToMesh = new Map;
        this.nActiveRigidBodies = 0;
        this.collisionEvents = [];
        this.isExport = !1;
        this.skipRender = !0;
        this.processRigidBody = (t)=>{
            if (t.bodyType() !== Xt.RigidBodyType.Dynamic) return;
            t.isSleeping() || this.nActiveRigidBodies++;
            let [e, r, i] = this.rigidBodyToMesh.get(t.handle);
            if (Ti.copy(t.translation()).multiplyScalar(this.pixelsPerMeter), xo.copy(t.rotation()), e.matrixWorld.compose(Ti, xo, r), e.hasNonUniformScale && e.matrixWorld.multiply(e.shearScale), e.dispatchEvent(Rte), i) {
                let s1 = e.cloner;
                if (s1 && s1.objectForSample === void 0) {
                    s1.matrixWorld.copy(e.matrixWorld);
                    for (let o of s1.children)o.updateMatrixWorld(!0);
                }
                for (let o of e.children)o.updateMatrixWorld(!0);
            }
        };
        this.accumulator = 0;
        this.handleCollisionEvents = (t, e, r)=>{
            if (r === !1) return;
            let i, s1;
            if (this.sensorToTriggerEvent[t] ? (i = this.sensorToTriggerEvent[t], s1 = this.sharedGameControlGlobals.colliderToEntity.get(e)) : this.sensorToTriggerEvent[e] && (i = this.sensorToTriggerEvent[e], s1 = this.sharedGameControlGlobals.colliderToEntity.get(t)), i && s1 && i.isValidTriggeringObject(s1)) {
                i.dispatch();
                return;
            }
            for(let o = this.sharedGameControlGlobals.createdObjects.length - 1; o >= 0; o--){
                let a = this.sharedGameControlGlobals.createdObjects[o];
                if (a.userData.hasCollisionDestroy && (a.rigidBody?.collider(0).handle === t || a.rigidBody?.collider(0).handle === e)) {
                    this.sharedGameControlGlobals.createdObjects.splice(o, 1), a.removeFromParent(), requestAnimationFrame(()=>this.sharedGameControlGlobals.rapierWorld?.removeRigidBody(a.rigidBody));
                    break;
                }
            }
            if (this.gameControl?.object !== void 0 && this.gameControl.object === this.sharedGameControlGlobals.colliderToEntity.get(t)) {
                let o = this.sharedGameControlGlobals.colliderToEntity.get(e), a = this.sharedGameControlGlobals.entityToCollisionEvents[o.uuid];
                if (a === void 0) return;
                for (let l of a)l.data.target === "character" && this.dispatchCollisionEvent(l, o, e);
            } else if (this.gameControl?.object !== void 0 && this.gameControl.object === this.sharedGameControlGlobals.colliderToEntity.get(e)) {
                let o = this.sharedGameControlGlobals.colliderToEntity.get(t), a = this.sharedGameControlGlobals.entityToCollisionEvents[o.uuid];
                if (a === void 0) return;
                for (let l of a)l.data.target === "character" && this.dispatchCollisionEvent(l, o, t);
            } else {
                let o = this.sharedGameControlGlobals.colliderToEntity.get(t), a = this.sharedGameControlGlobals.entityToCollisionEvents[o.uuid];
                if (a !== void 0) for (let u1 of a)u1.data.target === "scene" && this.dispatchCollisionEvent(u1, o, t);
                let l = this.sharedGameControlGlobals.colliderToEntity.get(e), c = this.sharedGameControlGlobals.entityToCollisionEvents[l?.uuid];
                if (c !== void 0) for (let u1 of c)u1.data.target === "scene" && this.dispatchCollisionEvent(u1, l, e);
            }
        };
        this.isExport = t.isExport, this.sharedAssets = t.sharedAssets, this.renderer = t.renderer, this.requestRender = t.requestRender, this.domElement = this.renderer.domElement, this.pixelsPerMeter = kM, this.gravity = this.page.data.globalPhysics.gravity;
    }
    get page() {
        return this.eventContext.page;
    }
    attachVRControllers(t) {
        t.forEach((e)=>{
            e.addEventListener("connected", (r)=>{
                "gamepad" in r.data && "axes" in r.data.gamepad && this.sharedGameControlGlobals.gamePads.push(r.data.gamepad);
            });
        });
    }
    markIsDestroyTarget() {
        this.page.traverseVisibleEntity((t)=>{
            let e = t.dataPatched;
            for (let r of e.events){
                if (r.data.disabled === !0) continue;
                let i = r.data.actions?.find((s1)=>s1.data.type === "Destroy")?.data;
                if (i) for (let s1 of i.objects){
                    let o = this.page.scene.find(s1);
                    o && (o.userData.hasDestroy = !0);
                }
            }
        });
    }
    markIsDragObject() {
        this.page.traverseVisibleEntity((t)=>{
            let e = t.dataPatched;
            for (let r of e.events)if (!(r.data.disabled === !0 || r.data.type !== "DragDrop")) for (let i of r.data.objects){
                let s1 = this.page.scene.find(i);
                s1 && (s1.userData.hasDrag = !0);
            }
        });
    }
    initBVH() {
        let t = [];
        if (this.page.traverseChildren((e)=>{
            let r, i = e instanceof oa, s1 = e instanceof ca;
            if (e instanceof Ai || i || s1) return;
            e instanceof Lr ? r = e.object : r = e;
            let o = r.dataPatched;
            if (o.physics?.enabled === "visibility" ? !o.visible : !o.physics?.enabled) return !0;
            let a = e.geometry, l = r.userData.hasDestroy === !0, c = r.userData.hasDrag === !0;
            if (Qg(o) || l || c || r.dataPatched.events.some((u1)=>u1.data.disabled !== !0 && (u1.data.type === "GameControl" || u1.data.type === "Follow"))) return e.updateMatrixWorldSVD(), this.addBoundsTree(e), !0;
            a && a.getAttribute("position").count > 0 && t.push(yo(a, e.matrixWorld));
        }), t.length > 0) {
            let e = Js(t, !1);
            this.sharedGameControlGlobals.staticMeshBVH = new Yo(e);
        }
    }
    addRigidBody(t, e, r) {
        if (zM(t.matrixWorld)) return;
        let i = [], s1 = "geometry" in t ? t.geometry : void 0, o = e.dataPatched;
        if (s1?.getAttribute("position") !== void 0 && i.push(yo(s1, t.shearScale)), o.physics.fusedBody) {
            let a = this.gatherChildrenGeom(t, i);
            t.traverseObject(a), t.children.forEach((c)=>c.updateMatrixWorld(!0));
            let l = t.cloner;
            l && l.objectForSample === void 0 && o.physics.rigidBody === "dynamic" && (l.traverseObject(a), l.children.forEach((c)=>c.updateMatrixWorld(!0)));
        }
        if (i.length > 0) {
            let a, l = !r.fromCreate && o.physics.rigidBody === "dynamic" || r.fromCreate && r.dynamic;
            l ? (a = Xt.RigidBodyDesc.dynamic(), a.setLinearDamping(o.physics.damping).setAngularDamping(o.physics.damping).setAdditionalMass(1e-9).setGravityScale(o.physics.gravityScale).enabledRotations(...o.physics.enabledRotation).enabledTranslations(...o.physics.enabledTranslation)) : (r.hasTransformAnim || r.hasFollow || r.hasDrag) && !r.fromCreate ? (a = Xt.RigidBodyDesc.kinematicPositionBased(), this.sharedGameControlGlobals.entitiesWithTransformAnim.push(t)) : a = Xt.RigidBodyDesc.fixed();
            let c = Js(i);
            (t.hasNonUniformScale ? t.matrixWorldRigid : t.matrixWorld).decompose(Ti, xo, Tc), t.position0 = Ti.clone().divideScalar(this.pixelsPerMeter), t.rotation0 = xo.clone(), Ti.divideScalar(this.pixelsPerMeter), a.setTranslation(Ti.x, Ti.y, Ti.z).setRotation(xo), s1 ? c?.scale(1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter) : c?.scale(Tc.x / this.pixelsPerMeter, Tc.y / this.pixelsPerMeter, Tc.z / this.pixelsPerMeter);
            let u1 = this.sharedGameControlGlobals.rapierWorld.createRigidBody(a);
            l && this.rigidBodyToMesh.set(u1.handle, [
                t,
                Tc.clone(),
                o.physics.fusedBody
            ]);
            let h = !(o.geometry === void 0 || o.geometry.type === "SubdivGeometry" || o.geometry.type === "NonParametricGeometry" || o.geometry.type === "BooleanGeometry" || o.geometry.type === "VectorGeometry" || o.geometry.type === "StarGeometry" || o.geometry.type === "RectangleGeometry" || o.geometry.type === "EllipseGeometry" || o.geometry.type === "TriangleGeometry" || o.geometry.type === "TorusGeometry" || o.geometry.type === "HelixGeometry");
            try {
                this.addCollider(u1, o.physics, c, e, h);
            } catch  {
                try {
                    this.addCollider(u1, o.physics, c, e, !1);
                } catch (f) {
                    console.error(f);
                }
            }
            t.rigidBody = u1;
        }
    }
    addBoundsTree(t) {
        let e = [];
        if (t.geometry?.getAttribute("position") !== void 0 && t.geometry?.getAttribute("position").count > 0 && e.push(yo(t.geometry, t.shearScale)), t.traverseObject(this.gatherChildrenGeom(t, e)), t.children.forEach((r)=>r.updateMatrixWorld(!0)), e.length > 0) {
            let r = Js(e, !1);
            t.bvhGeometry = r, r.getAttribute("position").count > 0 && (t.bvhGeometry.boundsTree = new Yo(r), this.sharedGameControlGlobals.entitiesWithTransformAnim.push(t));
        }
    }
    addCollider(t, e, r, i, s1 = !0) {
        if (r?.getAttribute("position").count === 0 || r?.getIndex()?.count === 0) return;
        let o;
        r && (e.colliderType === "trimesh" ? o = Xt.ColliderDesc.trimesh(r.getAttribute("position").array, r.getIndex().array) : o = Xt.ColliderDesc.convexMesh(r.getAttribute("position").array, s1 ? r.getIndex().array : void 0)), o.setFrictionCombineRule(Xt.CoefficientCombineRule.Average).setRestitutionCombineRule(Xt.CoefficientCombineRule.Average).setDensity(e.density).setFriction(e.friction).setRestitution(e.restitution);
        let a = this.sharedGameControlGlobals.rapierWorld.createCollider(o, t);
        this.sharedGameControlGlobals.colliderToEntity.set(a.handle, i), this.sharedGameControlGlobals.entityToCollisionEvents[i.uuid]?.some((l)=>l.target === "scene") && a.setActiveEvents(Xt.ActiveEvents.COLLISION_EVENTS);
    }
    gatherChildrenGeom(t, e) {
        return (r, i)=>{
            if (i === 0) return;
            let s1;
            if (r instanceof Ai) {
                if (r.objectForSample) {
                    if (r.objectForSample.dataPatched.physics.fusedBody) return;
                    s1 = r.object;
                } else return r.object.dataPatched.physics.fusedBody === !0 && r.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
            } else if (r instanceof Lr) s1 = r.object;
            else if (s1 = r, s1.dataPatched.cloner?.hideBase) return !0;
            let o = s1.dataPatched;
            if (o.physics.enabled === "visibility" ? !o.visible : !o.physics.enabled) return !0;
            i === 1 ? t.hasNonUniformScale ? r.matrixWorld.multiplyMatrices(t.shearScale, r.hiddenMatrix) : r.matrixWorld.copy(r.hiddenMatrix) : r.matrixWorld.multiplyMatrices(r.parent.matrixWorld, r.hiddenMatrix), r.matrixWorld.multiply(r.matrix);
            let a = r.geometry;
            a?.getAttribute("position") !== void 0 && e.push(yo(a, r.matrixWorld));
        };
    }
    activate(t) {
        if (this.isEnabled) return;
        this.isEnabled = !0, this.eventManager = t, this.usePhysics = this.page.data.globalPhysics.usePhysics;
        let e = this.page.playCamera, r = !1, i = 5, s1 = 8, o = 9, a = "drag", l = this.page.data.publish.gameControlObject, c = l !== null ? this.page.find(l) : null, u1 = null;
        if (c) for (let f of c.data.events){
            if (f.data.disabled || f.data.type !== "GameControl") continue;
            let m = c;
            for(; this.usePhysics && (m = m.parent)?.parent !== null;)m.data.physics?.fusedBody;
            f.data.collisionEnabled && (this.needsCollisionDetection = !0), u1 === null && (u1 = f.data);
        }
        if (this.page.traverseEntity((f)=>{
            for (let m of f.dataPatched.events)if (m.data.disabled === !1 && m.data.type === "Trigger") return this.needsCollisionDetection = !0, !0;
        }), c && u1 && (c.data.visible === !0 || c.data.physics.enabled === !0)) {
            r = r || u1.camera === e.uuid || c.uuid === e.uuid;
            let f = new jg(c, this.renderer.domElement, u1, this.eventContext.page.data.globalPhysics, this, c.uuid !== e.uuid && u1.camera === e.uuid, e, this.page, this.sharedAssets);
            this.gameControl = f, i = u1.joystickPosLoc, s1 = u1.joystickRotLoc, o = u1.jumpTouchButtonLoc, a = u1.rotByTouch, Li && u1.touchControl && (this.joystickToGameControls[i] = "pos", u1.moveMode === "walk" && (this.joystickToGameControls[o] = "jmp"), a === "joystick" && (this.joystickToGameControls[s1] = "rot"));
        }
        if (this.gameControl && this.gameControl.data.navmesh.enabled) {
            let f = this.gameControl.data;
            if (!this.navigationMeshWrapper) {
                this.navigationMeshWrapper = new O1(this.usePhysics, this.isExport);
                let m;
                f.collider.type === "sphere" ? m = f.collider.radius * 2 : m = f.collider.height, m = Math.floor(m / f.navmesh.ch - 1), this.navigationMeshWrapper.init({
                    ...f.navmesh,
                    walkableHeight: m
                }, this.gameControl, this.eventContext);
            }
        }
        if (r === !1) {
            let { enableRotate: f, enablePan: m, enableZoom: p, autoRotate: g, hoverRotatePanMode: y } = this.eventManager.publish.orbitControls;
            (f || m || p || g || y !== 0) && (this.orbitControls = new gp(e, this.renderer.domElement, {
                isExport: this.isExport,
                isPlayMode: !0
            }), this.orbitControls.addEventListener("change", this.requestRender), this.orbitControls.addEventListener("end", this.requestRender), this.orbitControls.addEventListener("start", this.requestRender), this.orbitControls.fromJSON(this.eventManager.publish.orbitControls, this.eventManager.publish.mouseEventTarget), this.orbitControls.useKeyEvents = !1, this.orbitControls.addEventListenersToCamera(), this.orbitControls.connect(), this.orbitControls.update());
        }
        let h = this.renderer.domElement.width / this.renderer.getPixelRatio(), d = this.renderer.domElement.height / this.renderer.getPixelRatio();
        this.joystickToGameControls.forEach((f, m)=>{
            let p = document.body.appendChild(document.createElement("div")), [g, y, x] = this.eventManager.eventContext.publish.joystickSizeAndXYOffset[m], v = (h - 5 * g) / 4 + g, b = {}, w = f === "jmp", A = w ? 0 : g;
            m < 10 ? (m < 5 ? b.top = A / 2 : b.bottom = A / 2, b.left = A / 2 + m % 5 * v) : m === 10 ? (b.left = A / 2, b.top = d / 2) : (b.right = A / 2, b.top = d / 2), b.top ? b.top -= y[1] : b.bottom += y[1], b.left ? b.left += y[0] : b.right -= y[0];
            for(let M in b)b[M] += "px";
            if (w) {
                let M = p.appendChild(document.createElement("div"));
                Object.assign(M.style, b, {
                    position: "absolute",
                    width: g + "px",
                    height: g + "px",
                    backgroundColor: `rgba(255,255,255,${x === "show" ? .4 : 0})`,
                    zIndex: "9999",
                    borderRadius: g + "px",
                    border: x === "show" ? "solid 2px rgba(0, 0, 0, .1)" : "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    touchAction: "none"
                });
                let C = g / 16 * 6.4;
                x === "show" && (M.innerHTML = `
						<svg width="${C}" height="${g * .4}" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M2 10L8 4L14 10" stroke="black" stroke-opacity="40%" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					`), M.addEventListener("pointerdown", ()=>{
                    this.gameControl.movementState.jump = 1, this.requestRender();
                }), M.addEventListener("touchend", (P)=>P.preventDefault()), this.joysticks[m] = [
                    void 0,
                    p
                ];
                return;
            }
            let T = {
                zone: p,
                mode: "static",
                position: b,
                size: g
            };
            x === "hide" && (T.restOpacity = 0);
            let S = OF.create(T);
            S.on("move", (M, C)=>{
                let P = this.gameControl;
                f === "pos" ? C.force < .2 ? P.moveForce = 0 : (P.movementState.movePosZ = Math.sin(-C.angle.radian), P.movementState.movePosX = Math.cos(-C.angle.radian), C.force > 1.2 ? P.movementState.run = 1 : P.movementState.run = 0, C.force < .3 ? P.moveForce = (C.force - .2) / .1 : P.moveForce = 1) : f === "rot" && (C.force < .2 ? P.rotForce = 0 : (P.movementState.rotPosX = C.vector.y, P.movementState.rotPosY = -C.vector.x, C.force < .3 ? P.rotForce = (C.force - .2) / .1 : P.rotForce = 1)), this.requestRender();
            }), S.on("end", (M, C)=>{
                let P = this.gameControl;
                f === "pos" ? (P.movementState.movePosZ = 0, P.movementState.movePosX = 0, P.moveForce = 1) : f === "rot" && (P.movementState.rotPosX = 0, P.movementState.rotPosY = 0, P.rotForce = 1);
            }), this.joysticks[m] = [
                S,
                p
            ];
        }), this.markIsDestroyTarget(), this.markIsDragObject(), this.rebuildBVH(), this.initializationCounter++, window.setTimeout(()=>{
            this.collisionEvents.forEach((f)=>f.initialDisabled = !1);
        }, 80);
    }
    initPhysics() {
        this.sharedGameControlGlobals.rapierWorld?.free(), this.sharedGameControlGlobals.rapierWorld = new Xt.World(new Xt.Vector3(0, this.gravity, 0)), this.events = new Xt.EventQueue(!0);
        let t = [], e = [];
        if (this.page.traverseChildren((a)=>{
            let l;
            if (a instanceof Ai) {
                if (a.objectForSample) {
                    if (a.objectForSample.dataPatched.physics.fusedBody) return;
                    l = a.object;
                } else return a.object.dataPatched.physics.fusedBody === !0 && a.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
            } else if (a instanceof Lr) l = a.object;
            else {
                if (a instanceof ca || a instanceof oa) return;
                if (l = a, l.dataPatched.cloner?.disabled === !1 && l.dataPatched.cloner?.hideBase && l.dataPatched.physics?.fusedBody !== !0) return !0;
            }
            let c = l.dataPatched, u1;
            for (let y of c.events)y.data.disabled !== !0 && y.data.type === "GameControl" && (u1 = y.data);
            if (!c.physics || (c.physics.enabled === "visibility" ? !c.visible : !c.physics.enabled)) return !0;
            a.updateMatrixWorldSVD();
            let h = Qg(c), d = !1, f = l.userData.hasDestroy, m = l.userData.hasDrag, p = !1;
            for (let y of c.events)if (y.data.disabled !== !0) {
                if (y.data.type === "Collision") {
                    d = !0;
                    let x = new I1(y.id, y.data, l, this.page, this.sharedAssets, this.eventManager);
                    x.initialDisabled = !0, this.collisionEvents.push(x), this.sharedGameControlGlobals.entityToCollisionEvents[l.uuid] && this.sharedGameControlGlobals.entityToCollisionEvents[l.uuid].every((v)=>v.id !== y.id) ? this.sharedGameControlGlobals.entityToCollisionEvents[l.uuid].push(x) : this.sharedGameControlGlobals.entityToCollisionEvents[l.uuid] = [
                        x
                    ];
                } else if (y.data.type === "Follow") {
                    p = !0;
                    let x = y.data.target;
                    a.traverseVisible((v)=>{
                        v.userData.isFollowingObj = x;
                    });
                }
            }
            c.physics.rigidBody === "dynamic" && c.physics.fusedBody === !1 && (a.matrixWorldFusedFalse = a.matrixWorld.clone());
            let g = a.geometry;
            if (u1 !== void 0) {
                let y = Xt.RigidBodyDesc.kinematicPositionBased();
                (a.hasNonUniformScale ? a.matrixWorldRigid : a.matrixWorld).decompose(Ti, xo, Tc), a.position0 = Ti.clone().divideScalar(this.pixelsPerMeter), a.rotation0 = xo.clone(), Ti.divideScalar(this.pixelsPerMeter), y.setTranslation(Ti.x, Ti.y, Ti.z).setRotation(xo);
                let x = this.sharedGameControlGlobals.rapierWorld.createRigidBody(y);
                a.rigidBody = x;
                let v;
                u1.collider.type === "sphere" ? v = Xt.ColliderDesc.ball(u1.collider.radius / this.pixelsPerMeter) : u1.collider.type === "capsule" ? v = Xt.ColliderDesc.capsule((u1.collider.height / 2 - u1.collider.radius) / this.pixelsPerMeter, u1.collider.radius / this.pixelsPerMeter) : v = Xt.ColliderDesc.cuboid(u1.collider.width / this.pixelsPerMeter / 2, u1.collider.height / this.pixelsPerMeter / 2, u1.collider.depth / this.pixelsPerMeter / 2), v.setFrictionCombineRule(Xt.CoefficientCombineRule.Average).setRestitutionCombineRule(Xt.CoefficientCombineRule.Average).setDensity(c.physics.density).setFriction(c.physics.friction).setRestitution(c.physics.restitution);
                let b = this.sharedGameControlGlobals.rapierWorld.createCollider(v, x);
                this.sharedGameControlGlobals.colliderToEntity.set(b.handle, l), Ti.fromArray(u1.collider.position.map((A)=>typeof A == "number" ? A : 0)).multiply(Tc.setFromMatrixScale(l.matrixWorld)).divideScalar(this.pixelsPerMeter), b.setTranslationWrtParent(Ti);
                let w = new Ye().setFromEuler(new Jt().setFromVector3(new E().fromArray(u1.collider.rotation.map((A)=>typeof A == "number" ? A : 0))));
                b.setRotationWrtParent(w), b.setActiveEvents(Xt.ActiveEvents.COLLISION_EVENTS), this.generateSensorColliderDescs(l, !0);
            } else c.physics.rigidBody === "dynamic" || h || p || f || m || d ? (this.addRigidBody(a, l, {
                hasFollow: p,
                hasTransformAnim: h,
                hasDrag: m
            }), this.generateSensorColliderDescs(l, c.physics.fusedBody)) : (g && t.push(yo(g, a.matrixWorld)), c.physics.fusedBody && a.traverseObject((y, x)=>{
                if (x === 0) return;
                let v;
                if (y instanceof Ai) {
                    if (y.objectForSample) {
                        if (y.objectForSample.dataPatched.physics.fusedBody) return;
                        v = y.object;
                    } else return y.object.dataPatched.physics.fusedBody === !0 && y.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                } else {
                    if (y instanceof ca || y instanceof oa) return;
                    if (y instanceof Lr) v = y.object;
                    else if (v = y, v.dataPatched.cloner?.hideBase) return !0;
                }
                let b = v.dataPatched;
                if (b.physics.enabled === "visibility" ? !b.visible : !b.physics.enabled) return !0;
                let w = y.geometry;
                w?.getAttribute("position") !== void 0 && t.push(yo(w, y.matrixWorld));
            }), this.generateSensorColliderDescs(l, c.physics.fusedBody, e));
            if (c.physics?.fusedBody === !0 || u1) return !0;
        }), t.length === 0) return;
        let r = Js(t);
        r.scale(1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter);
        let i = Xt.RigidBodyDesc.fixed(), s1 = this.sharedGameControlGlobals.rapierWorld.createRigidBody(i), o = Xt.ColliderDesc.trimesh(r.getAttribute("position").array, r.getIndex().array).setFrictionCombineRule(Xt.CoefficientCombineRule.Multiply).setRestitutionCombineRule(Xt.CoefficientCombineRule.Multiply).setFriction(1).setRestitution(1);
        this.sharedGameControlGlobals.rapierWorld.createCollider(o, s1);
        for (let [a, l] of e){
            let c = this.sharedGameControlGlobals.rapierWorld.createCollider(a, s1);
            this.sensorToTriggerEvent[c.handle] = l;
        }
    }
    updatePositions() {
        return this.nActiveRigidBodies = 0, this.sharedGameControlGlobals.rapierWorld.forEachRigidBody(this.processRigidBody), this.nActiveRigidBodies > 0;
    }
    rebuildBVH() {
        this.usePhysics ? this.initPhysics() : (this.page.traverseEntity((t)=>{
            for (let e of t.dataPatched.events)if (e.data.type === "Trigger" && e.data.disabled !== !0) {
                let r = new Jg(e.id, e.data, t, this.page, this.sharedAssets, this.eventManager), i = new ue().compose(bo.fromArray(e.data.position.map((s1)=>typeof s1 == "number" ? s1 : 0)), yp.setFromEuler(DV.fromArray(e.data.rotation.map((s1)=>typeof s1 == "number" ? s1 : 0))), pC);
                if (e.data.triggerZone === "box") {
                    let s1 = new Yt;
                    s1.min.fromArray(e.data.size.map((o)=>typeof o == "number" ? o : 0)).multiplyScalar(-0.5), s1.max.fromArray(e.data.size.map((o)=>typeof o == "number" ? o : 0)).multiplyScalar(.5), this.sharedGameControlGlobals.triggers.push([
                        s1,
                        i,
                        t,
                        r
                    ]);
                } else this.sharedGameControlGlobals.triggers.push([
                    e.data.radius,
                    i,
                    t,
                    r
                ]);
            }
        }), this.needsCollisionDetection && this.initBVH());
    }
    disconnectEvents() {
        this.collisionEvents.forEach((t)=>t.disconnect()), this.sharedGameControlGlobals.triggers.forEach((t)=>t[3].disconnect()), this.sharedGameControlGlobals.triggers.length = 0;
    }
    deactivate() {
        if (!!this.isEnabled) {
            this.isEnabled = !1, this.page.traverse((t)=>{
                let e = t;
                e.matrixWorldFusedFalse && (e.matrixWorldFusedFalse = void 0), e.rigidBody && (e.rigidBody = void 0), e.position0 && (e.position0 = void 0), e.rotation0 && (e.rotation0 = void 0);
            }), this.sharedGameControlGlobals.rapierWorld?.free(), this.sharedGameControlGlobals.rapierWorld = void 0, this.sharedGameControlGlobals.staticMeshBVH = void 0, this.accumulator = 0, this.sharedGameControlGlobals.entitiesWithTransformAnim = [], this.disconnectEvents(), this.gameControl?.reset(), this.gameControl?.dispose(), this.gameControl = null, this.initializationCounter = -1, this.joysticks.forEach(([t, e])=>{
                t?.destroy(), e.remove();
            }), this.joystickToGameControls = [], this.joysticks = [], this.orbitControls && (this.orbitControls.dispose(), this.orbitControls = void 0), this.navigationMeshWrapper?.dispose(), this.navigationMeshWrapper = void 0;
            for (let t of Object.values(this.sharedGameControlGlobals.entityToCollisionEvents))t.forEach((e)=>e.disconnect());
            this.sharedGameControlGlobals.entityToCollisionEvents = {}, this.page.updateMatrixWorld(!0);
        }
    }
    update(t, e, r) {
        if (!this.isEnabled) return !0;
        let i = !0;
        if (this.orbitControls !== void 0 && this.orbitControls.needsUpdate && (this.orbitControls.update(), i = !this.orbitControls.isCurrentlyDamping), this.initializationCounter >= 0 && this.initializationCounter < 2 ? (this.initializationCounter++, i = !1) : this.initializationCounter === 2 && this.gameControl && (i = !this.gameControl.update(t, e, r) && i), this.usePhysics === !1 && this.checkTrigger(), this.usePhysics) {
            let s1 = .016666666666666666;
            if (t === 0) i = this.stepPhysics() && i;
            else {
                let o = t / 1e3;
                o < s1 && o > s1 * .55 && (o = s1), this.accumulator += o;
                let a = performance.now(), l = 0, c = 6;
                for(; this.accumulator >= s1 && l < c && (i = this.stepPhysics() && i, this.accumulator -= s1, l++, !(performance.now() - a > s1 * 1e3)););
                this.accumulator = this.accumulator % s1;
            }
        }
        this.skipRender = i;
    }
    stepPhysics() {
        for (let e of this.sharedGameControlGlobals.entitiesWithTransformAnim){
            (e.hasNonUniformScale ? e.matrixWorldRigid : e.matrixWorld).decompose(Ti, xo, Tc), dC.setFromQuaternion(xo);
            let r = e;
            r.prevR === void 0 ? (r.prevR = dC.clone(), r.prevT = Ti.clone()) : (r.prevR.copy(dC), r.prevT.copy(Ti)), e.rigidBody && (e.rigidBody.setNextKinematicTranslation(Ti.divideScalar(this.pixelsPerMeter)), e.rigidBody.setNextKinematicRotation(xo));
        }
        return this.sharedGameControlGlobals.rapierWorld.step(this.events), this.events?.drainCollisionEvents(this.handleCollisionEvents), !this.updatePositions();
    }
    dispatchCollisionEvent(t, e, r) {
        let i = (this.sharedGameControlGlobals.rapierWorld?.getCollider(r))._parent, s1;
        if (e.cloner) {
            for (let o of e.cloner.children)if (o.rigidBody === i) {
                s1 = o;
                break;
            }
        }
        t.dispatch(s1), e.dispatchEvent(g1);
    }
    updateUseWindowEvents(t) {
        this.orbitControls?.updateUseWindowEvents(t);
    }
    generateSensorColliderDescs(t, e, r) {
        let i = OV.copy(t.matrixWorld).invert();
        t.traverseEntity((s1, o)=>{
            if (e === !1 && o === 1) return !0;
            for (let a of s1.dataPatched.events)if (a.data.type === "Trigger" && a.data.disabled !== !0) {
                let l = new Jg(a.id, a.data, s1, this.page, this.sharedAssets, this.eventManager), c;
                if (a.data.triggerZone === "box" ? c = Xt.ColliderDesc.cuboid(...a.data.size.map((u1)=>(typeof u1 == "number" ? u1 : 1) / (2 * this.pixelsPerMeter))) : c = Xt.ColliderDesc.ball(a.data.radius / this.pixelsPerMeter), c.setDensity(0).setSensor(!0).setActiveEvents(Xt.ActiveEvents.COLLISION_EVENTS), bo.fromArray(a.data.position.map((u1)=>typeof u1 == "number" ? u1 : 0)), yp.setFromEuler(DV.fromArray(a.data.rotation.map((u1)=>typeof u1 == "number" ? u1 : 0))), B1.compose(bo, yp, pC).premultiply(s1.matrixWorld), r ? (B1.decompose(bo, yp, fC), c.setActiveCollisionTypes(Xt.ActiveCollisionTypes.KINEMATIC_FIXED | Xt.ActiveCollisionTypes.DYNAMIC_FIXED)) : (B1.premultiply(i).decompose(bo, yp, fC), t.rigidBody.bodyType() === Xt.RigidBodyType.Dynamic || (t.rigidBody.bodyType() === Xt.RigidBodyType.Fixed ? c.setActiveCollisionTypes(Xt.ActiveCollisionTypes.KINEMATIC_FIXED | Xt.ActiveCollisionTypes.DYNAMIC_FIXED) : c.setActiveCollisionTypes(Xt.ActiveCollisionTypes.KINEMATIC_KINEMATIC | Xt.ActiveCollisionTypes.DYNAMIC_KINEMATIC))), bo.divideScalar(this.pixelsPerMeter), c.setTranslation(bo.x, bo.y, bo.z), c.setRotation(yp), r) r.push([
                    c,
                    l
                ]);
                else {
                    let u1 = this.sharedGameControlGlobals.rapierWorld.createCollider(c, t.rigidBody);
                    this.sensorToTriggerEvent[u1.handle] = l;
                }
            }
        });
    }
    checkTrigger() {
        let t;
        for(let e = 0; e < this.sharedGameControlGlobals.triggers.length; e++){
            let [r, i, s1, o] = this.sharedGameControlGlobals.triggers[e];
            for(let a = 0; a < this.sharedGameControlGlobals.entitiesWithTransformAnim.length; a++){
                let l = this.sharedGameControlGlobals.entitiesWithTransformAnim[a];
                if (s1 === l || o.isValidTriggeringObject(gt.is(l) ? l : l.object) === !1) continue;
                let c = OV.copy(s1.matrixWorld).decompose(bo, RV, fC).compose(bo, RV, pC).multiply(i), u1 = B1.copy(l.matrixWorld).invert().multiply(c);
                r instanceof Yt ? t = l.bvhGeometry.boundsTree.intersectsBox(r, u1) : (mC.radius = r, mC.center.setFromMatrixPosition(u1), t = l.bvhGeometry.boundsTree.intersectsSphere(mC)), t ? o.currentIntersectedObjects.indexOf(l) === -1 && (o.currentIntersectedObjects.push(l), o.dispatch(), s1.dispatchEvent(Lte)) : o.currentIntersectedObjects = o.currentIntersectedObjects.filter((h)=>h !== l);
            }
        }
    }
};
function NV(n1) {
    let t = this._clip.duration, e = this._clip.start ?? 0, r = this.loop, i = this.time + n1, s1 = this._loopCount, o = r === Jp;
    if (n1 === 0) return s1 === -1 ? i : o && (s1 & 1) === 1 ? t - (i - e) : i;
    if (r === Ew) {
        s1 === -1 && (this._loopCount = 0, this._setEndings(!0, !0, !1));
        e: {
            if (i >= t) i = t;
            else if (i < 0) i = 0;
            else {
                this.time = i;
                break e;
            }
            this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = i, this._mixer.dispatchEvent({
                type: "finished",
                action: this,
                direction: n1 < 0 ? -1 : 1
            });
        }
    } else {
        if (s1 === -1 && (n1 >= 0 ? (s1 = 0, this._setEndings(!0, this.repetitions === 0, o)) : this._setEndings(this.repetitions === 0, !0, o)), i >= t || i < e) {
            let a = Math.floor((i - e) / (t - e));
            i -= (t - e) * a, s1 += Math.abs(a);
            let l = this.repetitions - s1;
            if (l <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, o || (i = n1 > 0 ? t : e, this.repetitions === 1 && (i = t)), this.time = i, this._mixer.dispatchEvent({
                type: "finished",
                action: this,
                direction: n1 > 0 ? 1 : -1
            });
            else {
                if (l === 1) {
                    let c = n1 < 0;
                    this._setEndings(c, !c, o);
                } else this._setEndings(!1, !1, o);
                this._loopCount = s1, this.time = i, this._mixer.dispatchEvent({
                    type: "loop",
                    action: this,
                    loopDelta: a
                });
            }
        } else this.time = i;
        if (o && (s1 & 1) === 1) return t - (i - e);
    }
    return i;
}
var BV = !1, V1 = class {
    constructor(t, e, r, i){
        this.scene = t;
        this.requestRender = e;
        this.updateDisplayProgress = r;
        this.animationInspectorState = i;
        this.clipIdToAction = {};
        this.activeClip = null;
        this.needsUpdate = !1;
        this.addClip = (t)=>{
            t.data.type === "Empty" && t.data.animations && t.data.animations.forEach((e, r)=>{
                let i = e[0] + "/";
                if (Array.isArray(t.identity) ? i += t.identity[0] : i += t.uuid, this.clipIdToAction[i]) return;
                let s1 = mh.parse(JSON.parse(e[2]));
                t.animations[r] = s1;
                let o = this.mixer.clipAction(s1, t);
                BV === !1 && (Object.getPrototypeOf(o)._updateTime = NV, BV = !0), o.clampWhenFinished = !0, this.clipIdToAction[i] = o;
            });
        };
        this.mixer = new nv(t), this.scene.traverseEntity(this.addClip);
    }
    deleteClip(t, e) {
        let r = this.scene.find(e);
        if (!r) return;
        let i = r.animations.find((o)=>o.uuid === t);
        if (!i) return;
        let s1 = this.clipIdToAction[t];
        !s1 || (s1.stop(), this.mixer.uncacheClip(i), delete this.clipIdToAction[t], r.animations = r.animations.filter((o)=>o.uuid !== t));
    }
    get isPlaying() {
        return Object.values(this.clipIdToAction).some((t)=>t.isRunning());
    }
    playFromInspector(t) {
        this.mixer.stopAllAction();
        let e = this.clipIdToAction[t];
        !e || (e.play(), this.activeClip = e.getClip(), this.requestRender());
    }
    onExitPlayMode() {
        Object.values(this.clipIdToAction).forEach((t)=>{
            t.repetitions = 1 / 0, t.loop = Tw;
        }), this.mixer.stopAllAction(), this.requestRender();
    }
    play(t) {
        let e = t.clipId + "/" + t.object, r = this.clipIdToAction[e];
        if (!!r) return t && (t.repeat >= 0 && (r.repetitions = t.repeat + 1), t.direction === "pingpong" && t.repeat !== 0 && (r.loop = Jp)), r.play(), r.paused = !1, this.requestRender(), r;
    }
    resumeFromInspector(t) {
        let e = this.clipIdToAction[t];
        !e || (e.play(), e.paused = !1, this.requestRender());
    }
    pauseFromInspector(t) {
        let e = this.clipIdToAction[t];
        !e || (e.paused = !0);
    }
    stop() {
        this.mixer.stopAllAction(), this.requestRender();
    }
    update(t) {
        if (this.needsUpdate) this.needsUpdate = !1;
        else if (this.isPlaying === !1 || this.animationInspectorState?.isScrubbing) return;
        this.mixer.update(t / 1e3), this.activeClip && this.updateDisplayProgress(Math.round(this.mixer.time / this.activeClip.duration * (this.maxFrames - 1) % (this.maxFrames - 1))), this.requestRender();
    }
    get maxFrames() {
        return BM(this.activeClip ?? void 0);
    }
    setProgressFromInspector(t, e) {
        if (!this.clipIdToAction[e]) return;
        this.activeClip !== this.clipIdToAction[e].getClip() && this.playFromInspector(e);
        let r = this.clipIdToAction[e].paused;
        this.clipIdToAction[e].paused = !1, this.mixer.setTime(Math.min(t / (this.maxFrames - 1), .9999) * this.activeClip.duration), this.requestRender(), r && (this.clipIdToAction[e].paused = !0);
    }
};
var gC = new WeakMap, U1 = class extends Ml {
    constructor(t){
        super(t), this.decoderPath = "", this.decoderConfig = {}, this.decoderBinary = null, this.decoderPending = null, this.workerLimit = 4, this.workerPool = [], this.workerNextTaskID = 1, this.workerSourceURL = "", this.defaultAttributeIDs = {
            position: "POSITION",
            normal: "NORMAL",
            color: "COLOR",
            uv: "TEX_COORD"
        }, this.defaultAttributeTypes = {
            position: "Float32Array",
            normal: "Float32Array",
            color: "Float32Array",
            uv: "Float32Array"
        };
    }
    setDecoderPath(t) {
        return this.decoderPath = t, this;
    }
    setDecoderConfig(t) {
        return this.decoderConfig = t, this;
    }
    setWorkerLimit(t) {
        return this.workerLimit = t, this;
    }
    load(t, e, r, i) {
        let s1 = new gh(this.manager);
        s1.setPath(this.path), s1.setResponseType("arraybuffer"), s1.setRequestHeader(this.requestHeader), s1.setWithCredentials(this.withCredentials), s1.load(t, (o)=>{
            this.decodeDracoFile(o, e).catch(i);
        }, r, i);
    }
    decodeDracoFile(t, e, r, i) {
        let s1 = {
            attributeIDs: r || this.defaultAttributeIDs,
            attributeTypes: i || this.defaultAttributeTypes,
            useUniqueIDs: !!r
        };
        return this.decodeGeometry(t, s1).then(e);
    }
    decodeGeometry(t, e) {
        let r = JSON.stringify(e);
        if (gC.has(t)) {
            let l = gC.get(t);
            if (l.key === r) return l.promise;
            if (t.byteLength === 0) throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
        }
        let i, s1 = this.workerNextTaskID++, o = t.byteLength, a = this._getWorker(s1, o).then((l)=>(i = l, new Promise((c, u1)=>{
                i._callbacks[s1] = {
                    resolve: c,
                    reject: u1
                }, i.postMessage({
                    type: "decode",
                    id: s1,
                    taskConfig: e,
                    buffer: t
                }, [
                    t
                ]);
            }))).then((l)=>this._createGeometry(l.geometry));
        return a.catch(()=>!0).then(()=>{
            i && s1 && this._releaseTask(i, s1);
        }), gC.set(t, {
            key: r,
            promise: a
        }), a;
    }
    _createGeometry(t) {
        let e = new Ce;
        t.index && e.setIndex(new je(t.index.array, 1));
        for(let r = 0; r < t.attributes.length; r++){
            let i = t.attributes[r], s1 = i.name, o = i.array, a = i.itemSize;
            e.setAttribute(s1, new je(o, a));
        }
        return e;
    }
    _loadLibrary(t, e) {
        let r = new gh(this.manager);
        return r.setPath(this.decoderPath), r.setResponseType(e), r.setWithCredentials(this.withCredentials), new Promise((i, s1)=>{
            r.load(t, i, void 0, s1);
        });
    }
    preload() {
        return this._initDecoder(), this;
    }
    _initDecoder() {
        if (this.decoderPending) return this.decoderPending;
        let t = typeof WebAssembly != "object" || this.decoderConfig.type === "js", e = [];
        return t ? e.push(this._loadLibrary("draco_decoder.js", "text")) : (e.push(this._loadLibrary("draco_wasm_wrapper.js", "text")), e.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"))), this.decoderPending = Promise.all(e).then((r)=>{
            let i = r[0];
            t || (this.decoderConfig.wasmBinary = r[1]);
            let s1 = Nte.toString(), o = [
                "/* draco decoder */",
                i,
                "",
                "/* worker */",
                s1.substring(s1.indexOf("{") + 1, s1.lastIndexOf("}"))
            ].join(`
`);
            this.workerSourceURL = URL.createObjectURL(new Blob([
                o
            ]));
        }), this.decoderPending;
    }
    _getWorker(t, e) {
        return this._initDecoder().then(()=>{
            if (this.workerPool.length < this.workerLimit) {
                let i = new Worker(this.workerSourceURL);
                i._callbacks = {}, i._taskCosts = {}, i._taskLoad = 0, i.postMessage({
                    type: "init",
                    decoderConfig: this.decoderConfig
                }), i.onmessage = function(s1) {
                    let o = s1.data;
                    switch(o.type){
                        case "decode":
                            i._callbacks[o.id].resolve(o);
                            break;
                        case "error":
                            i._callbacks[o.id].reject(o);
                            break;
                        default:
                            console.error('THREE.DRACOLoader: Unexpected message, "' + o.type + '"');
                    }
                }, this.workerPool.push(i);
            } else this.workerPool.sort(function(i, s1) {
                return i._taskLoad > s1._taskLoad ? -1 : 1;
            });
            let r = this.workerPool[this.workerPool.length - 1];
            return r._taskCosts[t] = e, r._taskLoad += e, r;
        });
    }
    _releaseTask(t, e) {
        t._taskLoad -= t._taskCosts[e], delete t._callbacks[e], delete t._taskCosts[e];
    }
    debug() {
        console.log("Task load: ", this.workerPool.map((t)=>t._taskLoad));
    }
    dispose() {
        for(let t = 0; t < this.workerPool.length; ++t)this.workerPool[t].terminate();
        return this.workerPool.length = 0, this.workerSourceURL !== "" && URL.revokeObjectURL(this.workerSourceURL), this;
    }
};
function Nte() {
    let n1, t;
    onmessage = function(o) {
        let a = o.data;
        switch(a.type){
            case "init":
                n1 = a.decoderConfig, t = new Promise(function(u1) {
                    n1.onModuleLoaded = function(h) {
                        u1({
                            draco: h
                        });
                    }, DracoDecoderModule(n1);
                });
                break;
            case "decode":
                let l = a.buffer, c = a.taskConfig;
                t.then((u1)=>{
                    let h = u1.draco, d = new h.Decoder, f = new h.DecoderBuffer;
                    f.Init(new Int8Array(l), l.byteLength);
                    try {
                        let m = e(h, d, f, c), p = m.attributes.map((g)=>g.array.buffer);
                        m.index && p.push(m.index.array.buffer), self.postMessage({
                            type: "decode",
                            id: a.id,
                            geometry: m
                        }, p);
                    } catch (m) {
                        console.error(m), self.postMessage({
                            type: "error",
                            id: a.id,
                            error: m.message
                        });
                    } finally{
                        h.destroy(f), h.destroy(d);
                    }
                });
                break;
        }
    };
    function e(o, a, l, c) {
        let u1 = c.attributeIDs, h = c.attributeTypes, d, f, m = a.GetEncodedGeometryType(l);
        if (m === o.TRIANGULAR_MESH) d = new o.Mesh, f = a.DecodeBufferToMesh(l, d);
        else if (m === o.POINT_CLOUD) d = new o.PointCloud, f = a.DecodeBufferToPointCloud(l, d);
        else throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
        if (!f.ok() || d.ptr === 0) throw new Error("THREE.DRACOLoader: Decoding failed: " + f.error_msg());
        let p = {
            index: null,
            attributes: []
        };
        for(let g in u1){
            let y = self[h[g]], x, v;
            if (c.useUniqueIDs) v = u1[g], x = a.GetAttributeByUniqueId(d, v);
            else {
                if (v = a.GetAttributeId(d, o[u1[g]]), v === -1) continue;
                x = a.GetAttribute(d, v);
            }
            p.attributes.push(i(o, a, d, g, y, x));
        }
        return m === o.TRIANGULAR_MESH && (p.index = r(o, a, d)), o.destroy(d), p;
    }
    function r(o, a, l) {
        let u1 = l.num_faces() * 3, h = u1 * 4, d = o._malloc(h);
        a.GetTrianglesUInt32Array(l, h, d);
        let f = new Uint32Array(o.HEAPF32.buffer, d, u1).slice();
        return o._free(d), {
            array: f,
            itemSize: 1
        };
    }
    function i(o, a, l, c, u1, h) {
        let d = h.num_components(), m = l.num_points() * d, p = m * u1.BYTES_PER_ELEMENT, g = s1(o, u1), y = o._malloc(p);
        a.GetAttributeDataArrayForAllPoints(l, h, g, p, y);
        let x = new u1(o.HEAPF32.buffer, y, m).slice();
        return o._free(y), {
            name: c,
            array: x,
            itemSize: d
        };
    }
    function s1(o, a) {
        switch(a){
            case Float32Array:
                return o.DT_FLOAT32;
            case Int8Array:
                return o.DT_INT8;
            case Int16Array:
                return o.DT_INT16;
            case Int32Array:
                return o.DT_INT32;
            case Uint8Array:
                return o.DT_UINT8;
            case Uint16Array:
                return o.DT_UINT16;
            case Uint32Array:
                return o.DT_UINT32;
        }
    }
}
var Mc;
function yC(n1) {
    return Mc || (Mc = new U1, Mc.setDecoderPath(n1 ? `${n1}/` : "https://www.gstatic.com/draco/versioned/decoders/1.5.2/").preload()), Mc.decoderPending;
}
async function Bte(n1) {
    if (Mc) {
        let t = {
            attributeIDs: Mc.defaultAttributeIDs,
            attributeTypes: Mc.defaultAttributeTypes,
            useUniqueIDs: !1
        }, e;
        try {
            e = await Mc.decodeGeometry(new Int8Array(n1).buffer, t);
        } catch (r) {
            console.error(r);
        }
        if (e) return {
            index: e.index ? {
                array: e.index.array
            } : void 0,
            attributes: Object.entries(e.attributes).map(([r, i])=>({
                    name: r,
                    itemSize: i.itemSize,
                    array: i.array
                }))
        };
    }
    return null;
}
async function FV(n1, t) {
    let [e, r] = cA(od.deserialize(new Uint8Array(n1)));
    return W0(e), t && t(e), r.result().data;
}
function VV(n1) {
    let t = [];
    return n1.scene.objects.traverse((e, r)=>{
        r.type === "Mesh" && r.geometry.type === "NonParametricGeometry" && r.geometry.data.draco !== void 0 && t.push(r);
    }), t;
}
async function vC(n1) {
    for (let t of n1){
        let e = await Bte(t.geometry.data.draco);
        if (e) {
            let r = t.geometry.data;
            e.index && (r.index = {
                array: e.index.array,
                itemSize: 1,
                normalized: !1,
                type: "Uint32Array"
            });
            let i = {};
            e.attributes.forEach(({ name: s1, array: o, itemSize: a })=>{
                i[s1] = {
                    array: o,
                    itemSize: a,
                    type: "Float32Array",
                    normalized: !1
                };
            }), r.attributes = i, r.draco = void 0;
        }
    }
}
var k1 = class {
    constructor(){
        this._clickCount = 0;
        this._lastTime = 0;
        this._lastPosition = [
            0,
            0
        ];
        this._delay = 500;
        this._distance = 2;
        this._onMouseDown = (t)=>{
            let e = [
                t.clientX,
                t.clientY
            ], r = new Date().getTime();
            if (this._clickCount > 0) {
                let i = e[0] - this._lastPosition[0], s1 = e[1] - this._lastPosition[1];
                Math.sqrt(i * i + s1 * s1) > this._distance && (this._clickCount = 0);
            }
            this._lastPosition = e, this._clickCount = r - this._lastTime > this._delay ? 1 : this._clickCount + 1, this._lastTime = r;
        };
        this._onMouseUp = (t)=>{};
    }
    start(t, e = 500, r = 2) {
        this._target && this.stop(), this.reset(), this._delay = e, this._distance = r, this._target = t, this._target.addEventListener("pointerdown", this._onMouseDown, !1), this._target.addEventListener("pointerup", this._onMouseUp, !1);
    }
    stop() {
        this._target && (this._target.removeEventListener("pointerdown", this._onMouseDown, !1), this._target.removeEventListener("pointerup", this._onMouseUp, !1), this._target = void 0);
    }
    get clickCount() {
        return this._clickCount;
    }
    reset() {
        this._clickCount = 0, this._lastTime = 0, this._lastPosition = [
            0,
            0
        ];
    }
};
var xC = class {
    constructor(t, e, r, i, s1, o, a, l){
        this.eventId = t;
        this.id = e;
        this.data = r;
        this.dataEvent = i;
        this.object = s1;
        this.stage = !1;
        this.actions = Wt(i, r.actions, o, a, l, s1);
    }
    disconnect() {
        vr(this.actions);
    }
    dispatchIn() {
        this.actions.Audio.forEach((t)=>t.dispatchBasic()), this.actions.Particles.forEach((t)=>t.dispatchBasic()), this.actions.Video.forEach((t)=>t.dispatchBasic()), this.actions.Create.forEach((t)=>t.dispatch()), this.actions.Destroy.forEach((t)=>t.dispatch()), this.actions.Reset.forEach((t)=>t.dispatch()), this.actions.Link.forEach((t)=>t.dispatch()), this.actions.Transition.forEach((t)=>{
            t.object.currentTransitionEvent !== this && (t.object.currentTransitionEvent = this, t.init());
        }), this.actions.Transition.forEach((t)=>t.toggle()), this.actions.Animation.forEach((t)=>t.play()), this.actions.SwitchCamera.forEach((t)=>t.play()), this.actions.SceneTransition.forEach((t)=>t.dispatch()), this.actions.SetVariable.forEach((t)=>t.checkConditions()), this.actions.SetVariable.forEach((t)=>t.dispatch()), this.actions.DynamicVariablePlay.forEach((t)=>t.dispatch()), this.actions.ClearLocalStorage.forEach((t)=>t.dispatch()), this.actions.UserAPI.forEach((t)=>t.dispatch());
    }
    dispatchOut() {
        this.actions.Transition.forEach((t)=>{
            t.toggle();
        });
    }
}, z1 = class extends Qt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.breakpoints = [];
        this.resize = (e, r)=>{
            this.breakpoints.forEach((i)=>{
                let s1 = v0.deviceToSize(i.data.size), o = i.dataEvent.orientation === "horizontal" ? e : r, a;
                switch(i.data.operator){
                    case "<":
                        a = o < s1[0];
                        break;
                    case ">":
                        a = o > s1[0];
                        break;
                    case "<>":
                        a = o > s1[0] && o < s1[1];
                        break;
                }
                i.stage !== a && (i.stage = a, i.stage ? i.dispatchIn() : i.dispatchOut());
            });
        };
        this.onResizeObserver = new ResizeObserver((e)=>{
            for (let r of e){
                let { width: i, height: s1 } = r.contentRect;
                this.resize(i, s1);
            }
        });
    }
    connect() {
        let { page: e, sharedAssets: r, domElement: i } = this.eventContext;
        this.onResizeObserver.observe(i);
        let s1 = (o)=>{
            if (!(!o.visible || !o.data?.events.length)) for (let { data: a, id: l } of o.data.events)a.disabled || a.type === "Resize" && a.breakpoints.forEach(({ data: c, id: u1 })=>{
                try {
                    let h = new xC(l, u1, c, a, o, e, r, this.eventManager);
                    this.breakpoints.push(h);
                } catch (h) {}
            });
        };
        e.traverseEntity((o)=>{
            (o instanceof _r || o instanceof yr) && o.frame?.traverse((a)=>{
                s1(a);
            }), s1(o);
        });
    }
    disconnect() {
        this.onResizeObserver.disconnect(), this.breakpoints.forEach((e)=>{
            e.disconnect();
        }), this.breakpoints = [];
    }
};
var G1 = class extends Qt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.userAPIs = {};
        this.events = [];
        this.onSuccess = ({ userAPIId: e })=>{
            this.events.forEach((r)=>{
                r.data.userAPIId === e && r.dispatchSuccess();
            });
        };
        this.onError = ({ userAPIId: e })=>{
            this.events.forEach((r)=>{
                r.data.userAPIId === e && r.dispatchError();
            });
        };
        this.userAPIs = e.sharedAssets.getUserAPIs();
    }
    connect() {
        this.eventContext.page.traverseEntity((e)=>{
            e.data?.events.filter((r)=>r.data.type === "API" && !r.data.disabled).forEach((r)=>{
                this.events.push(new bC(r.id, r.data, e, this.eventContext.page, this.eventContext.sharedAssets, this.eventManager));
            });
        }), Object.entries(this.userAPIs).forEach(([e, r])=>{
            r.on("success", this.onSuccess), r.on("error", this.onError), r.autostart && r.callUserAPI(this.eventContext.sharedAssets);
        });
    }
    disconnect() {
        Object.entries(this.userAPIs).forEach(([e, r])=>{
            r.off("success", this.onSuccess), r.off("error", this.onError);
        });
    }
}, bC = class {
    constructor(t, e, r, i, s1, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.successActions = Wt(e, e.successActions, i, s1, o, r), this.errorActions = Wt(e, e.errorActions, i, s1, o, r);
    }
    dispatchSuccess() {
        this.dispatchActions(this.successActions);
    }
    dispatchError() {
        this.dispatchActions(this.errorActions);
    }
    dispatchActions(t) {
        t.Audio.forEach((e)=>e.dispatchConditional()), t.Particles.forEach((e)=>e.dispatchConditional()), t.Video.forEach((e)=>e.dispatchConditional()), t.Create.forEach((e)=>e.dispatch()), t.Destroy.forEach((e)=>e.dispatch()), t.Reset.forEach((e)=>e.dispatch()), t.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this), e.init();
        }), t.Transition.forEach((e)=>e.play()), t.Animation.forEach((e)=>e.play()), t.SwitchCamera.forEach((e)=>e.play()), t.SceneTransition.forEach((e)=>e.dispatch()), t.SetVariable.forEach((e)=>e.checkConditions()), t.SetVariable.forEach((e)=>e.dispatch()), t.DynamicVariablePlay.forEach((e)=>e.dispatch()), t.ClearLocalStorage.forEach((e)=>e.dispatch()), t.UserAPI.forEach((e)=>e.dispatch());
    }
};
var j1 = class extends Qt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.userWebhooks = {};
        this.events = [];
        this.onMessage = ({ userWebhookId: e })=>{
            this.events.forEach((r)=>{
                r.data.userWebhookId === e && r.dispatch();
            });
        };
        this.userWebhooks = e.sharedAssets.getUserWebhooks();
    }
    connect() {
        this.eventContext.page.traverseEntity((e)=>{
            e.data?.events.filter((r)=>r.data.type === "WEBHOOK" && !r.data.disabled).forEach((r)=>{
                this.events.push(new SC(r.id, r.data, e, this.eventContext.page, this.eventContext.sharedAssets, this.eventManager));
            });
        }), Object.entries(this.userWebhooks).forEach(([e, r])=>{
            r.connect(), r.on("message", this.onMessage);
        });
    }
    disconnect() {
        Object.entries(this.userWebhooks).forEach(([e, r])=>{
            r.off("message", this.onMessage), r.disconnect();
        });
    }
}, SC = class {
    constructor(t, e, r, i, s1, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.actions = Wt(e, e.actions, i, s1, o, r);
    }
    dispatch() {
        let t = this.actions;
        t.Audio.forEach((e)=>e.dispatchConditional()), t.Particles.forEach((e)=>e.dispatchConditional()), t.Video.forEach((e)=>e.dispatchConditional()), t.Create.forEach((e)=>e.dispatch()), t.Destroy.forEach((e)=>e.dispatch()), t.Reset.forEach((e)=>e.dispatch()), t.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this), e.init();
        }), t.Transition.forEach((e)=>e.play()), t.Animation.forEach((e)=>e.play()), t.SwitchCamera.forEach((e)=>e.play()), t.SceneTransition.forEach((e)=>e.dispatch()), t.SetVariable.forEach((e)=>e.checkConditions()), t.SetVariable.forEach((e)=>e.dispatch()), t.DynamicVariablePlay.forEach((e)=>e.dispatch()), t.ClearLocalStorage.forEach((e)=>e.dispatch()), t.UserAPI.forEach((e)=>e.dispatch());
    }
};
function Fte() {
    let n1 = document.createElement("textarea");
    return n1.style.position = "fixed", n1.style.top = "200px", n1.style.left = "400px", n1.style.zIndex = "-1", n1.style.border = "1px solid rgba(255,0,0,0.5)", n1.style.width = "10px", n1.style.height = "500px", n1.style.color = "white", n1.style.opacity = "0.5", n1.style.background = "transparent", n1.style.display = "none", n1.style.margin = "0px", n1.style.padding = "0px", n1.style.boxSizing = "content-box", n1.style.pointerEvents = "none", n1;
}
var Vte = new E(0, 0, 1), UV = new E, kV = new E, zV = new Sr, H1 = class {
    constructor(t, e, r, i, s1){
        this.containerScene = t;
        this.raycaster = e;
        this.sharedAssets = r;
        this.requestRender = i;
        this.onExit = s1;
        this.htmlInput = null;
        this.virtualInput = null;
        this.helper = new Kf;
        this.doubleClickHandler = new k1;
        this.isDragging = !1;
        this.plane = new qr;
        this.caretInterval = 0;
        this.planeIntersection = new E;
        this.projected = new U;
        this._lastIndex = 0;
        this._isFirstDragMove = !1;
        this.selectionOnDragStart = 0;
        this.onTextMaterialChanged = ()=>{
            let t = this.virtualInput?.data;
            if (this.virtualInput !== void 0 && t) {
                let e = t.material, r = typeof e == "string" ? this.sharedAssets.data.materials[e] : e, i = uB(r, this.sharedAssets);
                this.helper.setCaretColor(i);
            }
        };
        this.stopAnimateTextCursor = ()=>{
            clearInterval(this.caretInterval), this.helper && (this.helper.caretMesh.visible = !1);
        };
        this.startAnimateTextCursor = ()=>{
            this.stopAnimateTextCursor(), this.helper && (this.helper.caretMesh.visible = !0, this.caretInterval = setInterval(()=>{
                this.helper && (this.helper.caretMesh.visible = !this.helper.caretMesh.visible), this.requestRender();
            }, 600));
        };
        this.handleCaretUpdate = (t)=>{
            if (!this.htmlInput || !this.virtualInput) return;
            let e = this.helper, r = t?.key === "ArrowLeft" || t?.key === "ArrowRight", i = t?.key === "ArrowUp" || t?.key === "ArrowDown";
            this.htmlInput.selectionStart === this.htmlInput.selectionEnd ? (e.setCaretPosition(this.htmlInput.selectionStart, {
                horizontalKeyMove: r,
                verticalKeyMove: i
            }), this.startAnimateTextCursor()) : e.setSelection(this.htmlInput.selectionStart, this.htmlInput.selectionEnd), this.requestRender();
        };
        this.containerScene.add(this.helper);
    }
    createInput() {
        return this.htmlInput = Fte(), this.htmlInput;
    }
    connect() {}
    disconnect() {
        this.stopAnimateTextCursor(), this.helper.hide(), this.htmlInput?.remove(), this.doubleClickHandler.stop();
    }
    handleMouseDown() {
        if (!this.htmlInput || !this.virtualInput) return !0;
        this.getPointOnPlane();
        let t = this.doubleClickHandler.clickCount, { index: e, lineIndex: r, characterIndex: i } = this.helper.getSelectionFromPosition(this.projected.x, this.projected.y, t > 1 ? "inside" : "previous") ?? {
            index: 0,
            lineIndex: 0,
            characterIndex: 0
        };
        this.virtualInput?.wrappedText?.length && this.virtualInput.wrappedText[r][Math.max(0, i - 1)] === `
` && (e--, i--), this._lastIndex = e, this._isFirstDragMove = !0;
        let s1 = this.checkClickedObject();
        if (t === 1) {
            if (s1 === null) return this.onExit(this.virtualInput), !0;
            this.selectionOnDragStart = e, this.isDragging = !0, this.setInputSelection(e);
        } else s1 === this.virtualInput && (t === 2 ? this.selectClosestWord(r, i) : t > 2 && (this.setInputSelection(0, this.htmlInput.value.length), this.doubleClickHandler.reset()));
    }
    handleMouseUp() {
        this.applyRangeToTextInput(), this.isDragging = !1, this._isFirstDragMove = !1;
    }
    handleMouseMove() {
        !this.virtualInput || (this._isFirstDragMove && this.doubleClickHandler.clickCount > 1 && (this.selectionOnDragStart = this._lastIndex, this.isDragging = !0, this.setInputSelection(this._lastIndex)), this._isFirstDragMove = !1, this.getPointOnPlane(), this.applyRangeToTextInput());
    }
    focus(t) {
        if (this.virtualInput = t, this.updateTextInputStyles(), this.htmlInput) {
            if (t) {
                let e = this.data?.geometry.text;
                this.htmlInput.value = typeof e == "string" ? "" : e?.textValue.toString() ?? "";
            } else this.htmlInput.value = "";
        }
    }
    blur() {}
    get data() {
        let { virtualInput: t } = this;
        if (t) return t.dataPatched;
    }
    applyRangeToTextInput() {
        if (!this.isDragging || !this.virtualInput || !this.htmlInput) return;
        let t = this.selectionOnDragStart, { index: e, lineIndex: r, characterIndex: i } = this.helper.getSelectionFromPosition(this.projected.x, this.projected.y, this.doubleClickHandler.clickCount > 2 ? "inside" : "previous") ?? {
            index: 0
        };
        r !== void 0 && i !== void 0 && this.virtualInput?.wrappedText[r][i - 1] === `
` && e--, this.htmlInput.setSelectionRange(Math.min(t, e), Math.max(t, e));
    }
    checkClickedObject() {
        if (this.virtualInput) {
            let t = this.raycaster.intersectObject(this.virtualInput, !1);
            if (t.length > 0) {
                let e = t[0];
                if (e.object instanceof yc) return e.object;
            }
        }
        return null;
    }
    selectClosestWord(t, e) {
        if (!this.virtualInput) return;
        let r = this.virtualInput.wrappedText, i = r[t], s1 = e + 1, o = e;
        i[e] !== " " && (s1 = this.findNextCharOccurence(i, e, "forward", " "), o = this.findNextCharOccurence(i, e, "backward", " "), o > 0 && o++, s1 >= i.length - 1 && t === r.length - 1 && s1++);
        let a = this.helper, l = a.getGlobalIndexFromLineAndCharIndexes(r, t, o), c = a.getGlobalIndexFromLineAndCharIndexes(r, t, s1);
        this.setInputSelection(l, c);
    }
    findNextCharOccurence(t, e, r, i = " ") {
        let s1 = Math.max(0, t.length - 1), o = r === "forward" ? s1 : 0, a = r === "forward" ? 1 : -1, l = Math.max(Math.min(e, s1), 0);
        for(; l !== o;)if (l += a, t.charAt(l) === i) return l;
        return o;
    }
    getPointOnPlane() {
        let t = this.virtualInput?.data;
        if (!(!this.virtualInput || !t) && this.raycaster.ray.intersectsPlane(this.plane)) {
            this.planeIntersection === null && (this.planeIntersection = new E);
            let e = this.raycaster.ray.intersectPlane(this.plane, this.planeIntersection);
            if (e) {
                this.planeIntersection.copy(this.virtualInput.worldToLocal(e));
                let r = typeof t.geometry.width == "number" ? t.geometry.width : 1, i = typeof t.geometry.height == "number" ? t.geometry.height : 1;
                this.projected.set(e.x + r * .5, e.y - i * .5);
            }
        }
    }
    updatePlane() {
        let t = this.virtualInput?.data;
        this.virtualInput && t && (zV.getNormalMatrix(this.virtualInput.matrixWorld), UV.copy(Vte).applyMatrix3(zV).normalize(), this.virtualInput.localToWorld(kV.set(0, 0, t.geometry.depth)), this.plane.setFromNormalAndCoplanarPoint(UV, kV));
    }
    setInputSelection(t, e = t) {
        this.htmlInput?.setSelectionRange(t, e), bs && this.htmlInput?.focus(), setTimeout(()=>{
            this.htmlInput?.focus();
        });
    }
    updateTextInputStyles() {
        let t = this.virtualInput?.data;
        this.virtualInput && t && this.htmlInput && (this.htmlInput.style.fontSize = t.geometry.fontSize + "px", this.htmlInput.style.letterSpacing = t.geometry.letterSpacing * t.geometry.fontSize + "px", this.htmlInput.style.lineHeight = t.geometry.fontSize * t.geometry.lineHeight + "px", this.htmlInput.style.width = t.geometry.width + "px", this.htmlInput.style.height = t.geometry.height + "px", this.htmlInput.style.textAlign = Ute(t.geometry.horizontalAlign));
    }
};
function Ute(n1) {
    return n1 === 4 ? "justify" : n1 === 2 ? "right" : n1 === 3 ? "center" : "left";
}
var jV = (n1, t)=>{
    if (typeof n1 == "string") {
        let e = t.data(n1);
        if (e) return jV(e.value, t);
    }
    return Gr.getDisplayedValue(n1);
};
function GV(n1, t) {
    let e = n1.text, r = "";
    if (typeof e == "string") {
        let i = t.variables.data(r);
        i && (r = jV(i.value, t.variables));
    } else r = e.textValue.toString();
    return r;
}
var W1 = class extends Qt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this._textInputs = [];
        this.sceneHelpers = new Er;
        this.helper = new Kf;
        this._onMouseDownFocusIn = (e)=>{
            if (et.length > 1) return;
            this.eventContext.updateRaycaster(e);
            let r = null;
            if (this.eventContext.raycaster) {
                for (let i of this._textInputs)if (this.eventContext.raycaster.intersectObject(i, !0).length > 0) {
                    r = i;
                    break;
                }
            }
            this.focusOnTextInput(r), this._onCaretUpdate(), this._onMouseUp(), this.textInputManager.doubleClickHandler.start(this.eventContext.domElement), this.textInputManager.doubleClickHandler._onMouseDown(e), this._onMouseDown(e);
        };
        this.onExit = ()=>{
            let { virtualInput: e } = this.textInputManager;
            if (e === null) return;
            let r = this.textInputManager.htmlInput;
            this.helper.hide(), r?.setSelectionRange(r.value.length, r.value.length), this.eventManager.controlsManager.orbitControls && (this.eventManager.controlsManager.orbitControls.enabled = !0);
            let { domElement: i } = this.eventContext;
            i.removeEventListener("pointerdown", this._onMouseDown, !1), i.removeEventListener("pointerup", this._onMouseUp, !1), i.removeEventListener("pointermove", this._onMouseMove, !1), window.removeEventListener("keydown", this._onKeyPress), this.textInputManager.doubleClickHandler.reset(), i.addEventListener("pointerdown", this._onMouseDownFocusIn), this.eventContext.renderer.sceneHelpersOnTop = void 0, this.eventContext.renderer.pipeline.disableHelpers();
        };
        this._onMouseDown = (e)=>{
            this.eventContext.updateRaycaster(e), this.textInputManager.handleMouseDown(), this.textInputManager.virtualInput && this.eventContext.raycaster.intersectObject(this.textInputManager.virtualInput, !0).length > 0 && this.eventManager.controlsManager.orbitControls && (this.eventManager.controlsManager.orbitControls.enabled = !1);
        };
        this._onMouseUp = ()=>{
            this.textInputManager.handleMouseUp(), this.eventManager.controlsManager.orbitControls && !this.eventManager.controlsManager.orbitControls.enabled && (this.eventManager.controlsManager.orbitControls.enabled = !0);
        };
        this._onMouseMove = (e)=>{
            this.eventContext.updateRaycaster(e), this.textInputManager.handleMouseMove();
        };
        this._onTextEdit = (e)=>{
            let { htmlInput: r, virtualInput: i, helper: s1 } = this.textInputManager;
            if (!r || !i) return;
            let o = r.value;
            i.textGeometry.setText(o, this.eventContext.sharedAssets).then(()=>{
                this.eventContext.requestRender();
            });
            let a = i.data;
            s1.update();
            let l = a.geometry.text;
            if (typeof l == "string") {
                let c = l;
                this.eventContext.sharedAssets.updateVariable(c, {
                    textValue: o
                });
            }
            this.textInputManager.updateTextInputStyles(), this._onCaretUpdate();
        };
        this._onCaretUpdate = (e)=>{
            this.textInputManager.handleCaretUpdate(e);
        };
        this._onKeyPress = (e)=>{
            e.key === "Escape" && this.onExit();
        };
        this.textInputManager = new H1(this.sceneHelpers, e.raycaster, e.sharedAssets, e.requestRender, this.onExit);
    }
    connect() {
        let e = [];
        if (this.eventContext.scene.traverseEntity((s1)=>{
            s1 instanceof yc && e.push(s1);
        }), this._textInputs = e, e.length === 0) return;
        let { domElement: r } = this.eventContext;
        r.addEventListener("pointerdown", this._onMouseDownFocusIn), this.textInputManager.connect();
        let i = this.textInputManager.createInput();
        document.body.appendChild(i), i.style.display = "none", i.addEventListener("keyup", this._onCaretUpdate), i.addEventListener("keydown", this._onCaretUpdate), i.addEventListener("beforeinput", this._onCaretUpdate), i.addEventListener("paste", this._onCaretUpdate), i.addEventListener("cut", this._onCaretUpdate), i.addEventListener("select", this._onCaretUpdate), i.addEventListener("selectstart", this._onCaretUpdate);
    }
    disconnect() {
        let e = this.textInputManager.htmlInput, { domElement: r, sharedAssets: i } = this.eventContext;
        r.removeEventListener("pointerdown", this._onMouseDownFocusIn), e?.removeEventListener("keyup", this._onCaretUpdate), e?.removeEventListener("keydown", this._onCaretUpdate), e?.removeEventListener("beforeinput", this._onCaretUpdate), e?.removeEventListener("paste", this._onCaretUpdate), e?.removeEventListener("cut", this._onCaretUpdate), e?.removeEventListener("select", this._onCaretUpdate), e?.removeEventListener("selectstart", this._onCaretUpdate), this._textInputs.forEach((s1)=>{
            let o = GV(s1.data.geometry, this.eventContext.sharedAssets.data);
            s1.textGeometry.setText(o, i);
        }), r.removeEventListener("pointerdown", this._onMouseDown, !1), r.removeEventListener("pointerup", this._onMouseUp, !1), r.removeEventListener("pointermove", this._onMouseMove, !1), window.addEventListener("keydown", this._onKeyPress), this.eventContext.renderer.sceneHelpersOnTop = void 0, this.eventContext.renderer.pipeline.disableHelpers(), this.textInputManager.disconnect();
    }
    focusOnTextInput(e) {
        this.textInputManager.focus(e), this.textInputManager.onTextMaterialChanged();
        let r = this.textInputManager.htmlInput;
        if (!r || e === null) return;
        this.textInputManager.updateTextInputStyles(), this.eventContext.renderer.sceneHelpersOnTop = this.sceneHelpers, this.eventContext.renderer.pipeline.enableHelpers(), this.textInputManager.isDragging = !1;
        let i = GV(e.textGeometry.userData.parameters, this.eventContext.sharedAssets.data);
        r.value = i, r.setSelectionRange(0, 0), this.textInputManager.helper.show(e), r.style.display = "block", r.addEventListener("input", this._onTextEdit), this.textInputManager.updatePlane();
        let { domElement: s1 } = this.eventContext;
        s1.removeEventListener("pointerdown", this._onMouseDownFocusIn), s1.addEventListener("pointerdown", this._onMouseDown, !1), s1.addEventListener("pointerup", this._onMouseUp, !1), s1.addEventListener("pointermove", this._onMouseMove, !1), window.addEventListener("keydown", this._onKeyPress);
    }
};
var q1 = class extends Qt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.events = [];
        this.onVoice = ({ value: e, frequencies: r })=>{
            this.events.forEach((i)=>{
                i.dispatch();
            });
        };
    }
    connect() {
        this.openAIRealtime = this.eventContext.sharedAssets.openAIRealtime, this.openAIRealtime && (this.eventContext.page.traverseEntity((e)=>{
            e.data?.events.filter((r)=>r.data.type === "AIAssistantListener" && !r.data.disabled).forEach((r)=>{
                this.events.push(new wC(r.id, r.data, e, this.eventContext.page, this.eventContext.sharedAssets, this.eventManager));
            });
        }), this.openAIRealtime.on("voice", this.onVoice));
    }
    disconnect() {
        this.openAIRealtime?.off("voice", this.onVoice);
    }
}, wC = class {
    constructor(t, e, r, i, s1, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.actions = Wt(e, e.actions, i, s1, o, r);
    }
    dispatch() {
        this.dispatchActions(this.actions);
    }
    dispatchActions(t) {
        t.Audio.forEach((e)=>e.dispatchConditional()), t.Particles.forEach((e)=>e.dispatchConditional()), t.Video.forEach((e)=>e.dispatchConditional()), t.Create.forEach((e)=>e.dispatch()), t.Destroy.forEach((e)=>e.dispatch()), t.Reset.forEach((e)=>e.dispatch()), t.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this), e.init();
        }), t.Transition.forEach((e)=>e.play()), t.Animation.forEach((e)=>e.play()), t.SwitchCamera.forEach((e)=>e.play()), t.SceneTransition.forEach((e)=>e.dispatch()), t.SetVariable.forEach((e)=>e.checkConditions()), t.SetVariable.forEach((e)=>e.dispatch()), t.DynamicVariablePlay.forEach((e)=>e.dispatch()), t.ClearLocalStorage.forEach((e)=>e.dispatch()), t.UserAPI.forEach((e)=>e.dispatch());
    }
};
var X1 = class extends Qt {
    constructor(e, r){
        super(e);
        this.eventManager = r;
        this.events = [];
        this.onTriggerEvent = ({ description: e, direction: r })=>{
            let i = this.events.find((s1)=>s1.data.description === e);
            i && (r === "backward" ? i.dispatchReverse() : i.dispatch());
        };
    }
    connect() {
        this.openAIRealtime = this.eventContext.sharedAssets.openAIRealtime, this.openAIRealtime && (this.eventContext.page.traverseEntity((e)=>{
            e.data?.events.filter((r)=>r.data.type === "AIAssistantTrigger" && !r.data.disabled).forEach((r)=>{
                this.events.push(new AC(r.id, r.data, e, this.eventContext.page, this.eventContext.sharedAssets, this.eventManager));
            });
        }), this.openAIRealtime.on("trigger_event", this.onTriggerEvent));
    }
    disconnect() {
        this.openAIRealtime?.off("trigger_event", this.onTriggerEvent);
    }
}, AC = class {
    constructor(t, e, r, i, s1, o){
        this.id = t;
        this.data = e;
        this.object = r;
        this.actions = Wt(e, e.actions, i, s1, o, r);
    }
    dispatch() {
        let t = this.actions;
        t.Audio.forEach((e)=>e.dispatchConditional()), t.Particles.forEach((e)=>e.dispatchConditional()), t.Video.forEach((e)=>e.dispatchConditional()), t.Create.forEach((e)=>e.dispatch()), t.Destroy.forEach((e)=>e.dispatch()), t.Reset.forEach((e)=>e.dispatch()), t.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this), e.init();
        }), t.Transition.forEach((e)=>e.play()), t.Animation.forEach((e)=>e.play()), t.SwitchCamera.forEach((e)=>e.play()), t.SceneTransition.forEach((e)=>e.dispatch()), t.SetVariable.forEach((e)=>e.checkConditions()), t.SetVariable.forEach((e)=>e.dispatch()), t.DynamicVariablePlay.forEach((e)=>e.dispatch()), t.ClearLocalStorage.forEach((e)=>e.dispatch()), t.UserAPI.forEach((e)=>e.dispatch());
    }
    dispatchReverse() {
        let t = this.actions;
        t.Transition.forEach((e)=>e.reverseFromCurrent()), t.Particles.forEach((e)=>e.reverseFromCurrent()), t.Animation.forEach((e)=>e.reverseFromCurrent()), t.SwitchCamera.forEach((e)=>e.reverseFromCurrent()), t.Create.forEach((e)=>e.dispatchStop());
    }
};
var Y1 = class {
    constructor(t, e, r, i, s1){
        this.publish = t;
        this.controlsManager = e;
        this.animationControls = r;
        this.eventContext = i;
        this.sharedVariables = s1;
        this.isEnabled = !1;
        this.activateCount = 0;
        this.needsMouse = !1;
        this.needsRaycast = !1;
        this.onTouchMovePreventScroll = (t)=>{
            let e = window.parent !== window, r = document.documentElement.scrollHeight > document.documentElement.clientHeight || document.documentElement.scrollWidth > document.documentElement.clientWidth;
            (t.touches.length > 1 || this.preventTouchScroll || e === !1 && r === !1) && t.preventDefault();
        };
        this.onMouseWheelPreventScroll = (t)=>{
            this.preventScroll && t.preventDefault();
        };
        this.onMouseMove = (t)=>{
            this.eventContext.sharedAssets.mouseProperty = {
                ...this.getMousePosition(t),
                pressed: t.buttons > 0
            };
        };
        this.onMouseDown = (t)=>{
            this.eventContext.sharedAssets.mouseProperty = {
                ...this.getMousePosition(t),
                pressed: !0
            };
        };
        this.onMouseUp = (t)=>{
            this.eventContext.sharedAssets.mouseProperty = {
                ...this.getMousePosition(t),
                pressed: !1
            };
        };
        this.getMousePosition = (t)=>{
            let { domRect: e } = this.eventContext, { pageX: r, pageY: i } = t.touches?.length > 0 ? t.touches[0] : t;
            return {
                x: r - (e.left + window.scrollX),
                y: i - (e.top + window.scrollY)
            };
        };
        this.stopRaycast = t.stopRaycast, this.preventScroll = t.preventScroll, this.preventTouchScroll = t.preventTouchScroll, this.hideCursor = t.hideCursor, this.requestRender = i.requestRender;
    }
    activate(t = !1) {
        if (this.isEnabled) return;
        this.isEnabled = !0, this.initializeActionsDependentStates(), this.needsMouse && (this.eventContext.domElement.addEventListener("pointermove", this.onMouseMove), this.eventContext.domElement.addEventListener("pointerdown", this.onMouseDown)), this.handlers = {
            Spline: new x1(this.eventContext),
            ["VariableChange"]: new D1(this.eventContext, this.sharedVariables, this, this.needsMouse, this.needsRaycast),
            ["API"]: new G1(this.eventContext, this),
            ["WEBHOOK"]: new j1(this.eventContext, this),
            ["AIAssistantListener"]: new q1(this.eventContext, this),
            ["AIAssistantTrigger"]: new X1(this.eventContext, this),
            ["Conditional"]: new w1(this.eventContext, this),
            ["Start"]: new _1(this.eventContext, this),
            Basic: new b1(this.eventContext, this, this.needsRaycast),
            ["MouseHover"]: new C1(this.eventContext, this),
            ["Scroll"]: new P1(this.eventContext, this),
            ["Follow"]: new E1(this.eventContext, this),
            ["DragDrop"]: new A1(this.eventContext, this),
            ["LookAt"]: new M1(this.eventContext),
            ["Resize"]: new z1(this.eventContext, this),
            Textfields: new W1(this.eventContext, this)
        };
        let { page: e, domElement: r } = this.eventContext;
        this.hideCursor && (r.style.cursor = "none"), e.traverseEntity((i)=>{
            i.addEventListener("requestRender", this.requestRender);
        }), Object.values(this.handlers).forEach((i)=>i.connect()), r.addEventListener("wheel", this.onMouseWheelPreventScroll), r.addEventListener("touchmove", this.onTouchMovePreventScroll), this.activateCount++, t || this.eventContext.sharedAssets.openAIRealtime?.connect();
    }
    deactivate(t = !1) {
        if (!this.isEnabled) return;
        this.isEnabled = !1, this.eventContext.domElement.removeEventListener("pointermove", this.onMouseMove), this.eventContext.domElement.removeEventListener("pointerdown", this.onMouseDown), this.eventContext.domElement.removeEventListener("pointerup", this.onMouseUp), this.eventContext.sharedAssets.mouseProperty = null, this.eventContext.sharedAssets.raycastProperty = null;
        let { page: e, domElement: r } = this.eventContext;
        r.style.cursor = "", Object.values(this.handlers).forEach((i)=>i.disconnect()), this.controlsManager.gameControl?.disposeActions(), this.controlsManager.disconnectEvents(), e.traverseEntity((i)=>{
            i.removeEventListener("requestRender", this.requestRender), i.destroyedInAction = !1;
        }), r.removeEventListener("touchmove", this.onTouchMovePreventScroll), r.removeEventListener("wheel", this.onMouseWheelPreventScroll), this.animationControls.onExitPlayMode(), t || this.eventContext.sharedAssets.openAIRealtime?.disconnect();
    }
    get isPaused() {
        return this.isEnabled;
    }
    pause() {
        this.deactivate();
    }
    resume() {
        this.activate();
    }
    reset() {
        this.deactivate(!0), this.activate(!0), this.controlsManager.deactivate(), this.controlsManager.activate(this), this.controlsManager.page.updateMatrixWorld(!0), this.controlsManager.rebuildBVH();
    }
    updateUseWindowEvents(t) {
        let e = this.isEnabled;
        e && this.deactivate(), this.eventContext.useWindowEvents = t, e && this.activate();
    }
    initializeActionsDependentStates() {
        let t = this.eventContext.sharedAssets;
        t.resetDynamicVariablePlayState();
        let e = (r)=>{
            if (r.data.type === "Conditional" && (r.data.ifActions.forEach(e), r.data.elseActions.forEach(e)), r.data.type === "Conditional" || r.data.type === "SetVariable") for (let i of r.data.type === "Conditional" ? r.data.condition : r.data.expression)"id" in i && Array.isArray(i.id) && (i.id[0] === "mouse" && (this.needsMouse = !0), i.id[0] === "raycast" && (this.needsRaycast = !0));
            r.data.type === "DynamicVariablePlay" && r.data.variableId !== "" && (r.data.mode === "Play" || r.data.mode === "PlayPause" || r.data.mode === "Toggle") && t.setDynamicVariablePlayState(r.data.variableId, "Stopped");
        };
        this.eventContext.page.traverseEntity((r)=>{
            if (!!r.data?.events.length) for (let i of r.data.events)if (i.data.type === "VariableChange" && (i.data.variableId === "mouseProperty" && (this.needsMouse = !0), i.data.variableId === "raycastProperty" && (this.needsRaycast = !0)), i.data.type === "Conditional") for (let s1 of [
                "inActions",
                "outActions"
            ])i.data[s1].forEach(e);
            else if (i.data.type === "DragDrop") for (let s1 of [
                "drag",
                "drop"
            ])i.data.dragDropActions[s1].forEach(e);
            else if (i.data.type === "GameControl") for (let s1 of [
                "idle",
                "move",
                "jump",
                "run"
            ])i.data.gameActions[s1].forEach(e);
            else if (i.data.type === "Resize") for (let s1 of i.data.breakpoints)s1.data.actions.forEach(e);
            else i.data.type === "LookAt" || i.data.type === "API" || i.data.actions.forEach(e);
        });
    }
};
var K1 = class {
    constructor(t, e, r, i, s1){
        this._aspect = 1;
        this.enableResponsive = !1;
        this._renderer = t, this._camera = e, this._frameSize = new U().copy(r), this._editorSize = new U().copy(i), this._aspect = e.aspect, this._fov = s1 ?? e.fov;
    }
    set frameSize(t) {
        this._frameSize.copy(t);
    }
    updateRenderer() {
        !this._renderer || this._renderer.setSize(this._frameSize.x, this._frameSize.y);
    }
    updateViewport() {
        if (!this._renderer || !this._camera || this._camera.cameraType !== "PerspectiveCamera") return;
        let t = this._frameSize.x, e = this._frameSize.y, r = this._editorSize.y;
        this._aspect = t / e, e <= r && (this._camera.zoom *= r / e), this._renderer.setViewport(0, 0, t, e);
    }
    updateCamera(t = !0) {
        if (!!this._camera) {
            if (this._camera.cameraType === "PerspectiveCamera") {
                let e = this._frameSize.y, r = this._editorSize.y, i = this._fov;
                if (t && e > r) {
                    let s1 = kte(e, 1080, 2160, 1, 15) / 100;
                    i *= e / r, i *= 1 - s1;
                }
                this._camera.aspect = this._aspect, this._camera.fov = i, this._camera.updateProjectionMatrix();
            } else this._camera.setViewplaneSize(this._frameSize.x, this._frameSize.y, this.enableResponsive);
        }
    }
    setCamera(t) {
        this._camera = t, this._aspect = t.aspect, this._fov = t.fov;
    }
    revert() {
        let t = window.innerWidth, e = window.innerHeight;
        this._renderer && (this._renderer.setViewport(0, 0, t, e), this._renderer.setSize(t, e)), this._camera && (this._camera.aspect = t / e, this._camera.fov = this._fov, this._camera.setViewplaneSize(t, e, this.enableResponsive), this._camera.updateProjectionMatrix());
    }
};
function kte(n1, t, e, r, i) {
    return (n1 - t) / (e - t) * (i - r) + r;
}
var Q1 = class {
    get sharedAssets() {
        return this.shared;
    }
    constructor(t, e = {}, r = !0){
        this.shared = new vu(t.shared, e, !0, r), this.scene = new fc(t.scene, this.sharedAssets), this.shared.setEntityOpContext({
            scene: this.scene,
            shared: this.shared
        });
    }
    reset(t, e) {
        this.scene.clearScene(), this.sharedAssets.reset(t.shared), this.scene.resetAfterClear(t.scene, this.sharedAssets);
    }
    resetPersonalCameraFromDocumentData() {
        for (let t of this.scene.children)t instanceof yr && !t.uiScene && t.personalCamera.updateState(t.data.camera, {
            scene: this.scene,
            shared: this.shared
        });
    }
    dispose() {
        this.scene.dispose(), this.shared.dispose();
    }
    gc() {
        this.shared.geometryCache.startGc(), this.shared.geometryCache2.startGc(), this.scene.traverseEntity((t)=>{
            t instanceof Ct && t.markGeometryAsReachable(this.shared);
        }), this.shared.geometryCache.endGc(), this.shared.geometryCache2.endGc();
    }
};
var Z1 = class {
    constructor({ x: t = 10, y: e = 10 }){
        this._startTime = 0;
        let r = document.getElementById("spe-perfs");
        r ? this.element = r : (this.element = document.createElement("div"), document.body.appendChild(this.element), this.element.style.position = "absolute", this.element.style.zIndex = "10000", this.element.style.fontFamily = "monospace", this.element.style.background = "black", this.element.style.color = "white", this.element.style.padding = "10px", this.element.style.opacity = "0.5", this.element.style.fontSize = "11px", this.element.setAttribute("id", "spe-perfs")), this.element.style.left = `${t}px`, this.element.style.top = `${e}px`;
    }
    dispose() {
        this.element.parentElement?.removeChild(this.element);
    }
    start() {
        this._startTime = performance.now();
    }
    end() {
        let e = performance.now() - this._startTime;
        this.element.innerHTML = e.toFixed(3) + " ms";
    }
};
function zte(n1) {
    let t;
    if (!!n1.index) for(let e = 0; e < n1.index.array.length; e += 3)t = n1.index.array[e], n1.index.array[e] = n1.index.array[e + 2], n1.index.array[e + 2] = t;
}
function $g(n1) {
    return n1 instanceof lo ? "SubdivObject" : n1.geometry.type === "NonParametricGeometry" ? "NonParametric" : "Mesh";
}
function Gte(n1, t) {
    let e = {};
    return n1.traverseEntity((r)=>{
        if (!r.visible || !(r instanceof nr) || r.type !== "Mesh" || Array.isArray(r.material) || r.states && Object.keys(r.states).length) return;
        let i = r.parent;
        for(; i;){
            if (i instanceof nr && r.states && Object.keys(r.states).length) return;
            i = i.parent;
        }
        let s1 = r.material.uuid, o = t.shared.materials[s1];
        if (o) {
            if (!Kr.isMergable(o)) return;
        } else {
            let c = t.scene.objects.get(r.uuid)?.data;
            if (c && "material" in c && typeof c.material != "string") {
                if (!Kr.isMergable(c.material)) return;
                s1 = Kr.getHash(c.material);
            }
        }
        e[s1] || (e[s1] = {});
        let l = e[s1][$g(r)];
        if (l) {
            if (l.push(r), r.cloner) for (let c of r.cloner.children)l.push(c);
        } else if (e[s1][$g(r)] = [
            r
        ], r.cloner) for (let c of r.cloner.children)e[s1][$g(r)].push(c);
    }), e;
}
function jte(n1) {
    let t = 0;
    return Object.values(n1).forEach((e)=>{
        Object.values(e).forEach((r)=>{
            let i = r.length;
            i > t && (t = i);
        });
    }), t;
}
function HV(n1, t) {
    let e = Gte(t, n1), r = jte(e), i = new Array(r), s1 = 0, o = new Array(r), a = 0, l = new Array(r), c = 0, u1 = new Array(r), h = 0;
    for (let [d, f] of Object.entries(e))for (let m of Object.values(f)){
        if (a = 0, c = 0, m.forEach((g)=>{
            g instanceof nr && (o[a++] = g.geometry.clone(), l[c++] = g);
        }), c < 2) continue;
        for(let g = 0; g < c; g++)l[g].updateWorldMatrix(!0, !1), o[g].applyMatrix4(l[g].matrixWorld), l[g].matrixWorld.determinant() < 0 && zte(o[g]);
        let p = Js(o.slice(0, a), !1);
        if (p) {
            let g;
            switch(d){
                case "SubdivObject":
                    console.warn("Turning subdiv object into mesh"), g = new Mt(p, l[0].material);
                    break;
                default:
                    g = new Mt(p, l[0].material);
                    break;
            }
            g.castShadow = l[0].castShadow, g.receiveShadow = l[0].receiveShadow, t.add(g);
            let y = (x)=>{
                h = 0;
                for (let v of x)v.children && y(v.children), v instanceof nr && (Array.isArray(v.material) || e[v.material.uuid] && e[v.material.uuid][$g(v)] && e[v.material.uuid][$g(v)].length > 1 || (u1[h++] = v));
                for(let v = 0; v < h; v++)t.attach(u1[v]);
            };
            for(let x = 0; x < c; x++){
                let v = l[x];
                y(v.children), i[s1++] = v;
            }
        }
    }
    for(let d = 0; d < s1; d++)i[d].removeFromParent();
}
var ZV = cl(qV(), 1);
function XV(n1) {
    let t = Array.isArray(n1) ? n1[0] : n1, e = t.layers.map(Hte), r = t.layers.find((i)=>i.type === "light");
    return {
        layers: e,
        alpha: r.node.alphaOverride?.value ?? 1
    };
}
function Hte(n1) {
    return n1.type === "texture" || n1.type === "video" || n1.type === "matcap" ? {
        ...n1.data,
        updateTexture (t) {
            return n1.color.texture.image.updateSrc(t);
        }
    } : {
        ...n1.data
    };
}
function YV(n1, t, e) {
    let r = Array.isArray(e) ? e[0] : e;
    if (n1[0] === "layers") {
        let i = parseInt(n1[1]), s1 = r.layers[i], o = n1[2];
        s1 && o && Wte(n1.slice(2), t, s1);
    } else n1[0] === "alpha" && r.layers.forEach((i)=>{
        i.type === "light" && i.node.alphaOverride !== void 0 && (i.node.alphaOverride.value = t, t < 1 && (r.transparent = !0));
    });
}
var ey = new cr(0, 0, 0, 1);
function Wte(n1, t, e) {
    let r = n1[0];
    try {
        if (Yte(r, e.type, n1.slice(1))) {
            if (r === "colors") {
                if (n1.length < 2) throw new Error("You cannot mutate the colors array, only its items");
                let i = parseInt(n1[1]), o = e.getValue(r)?.[i];
                if (o) ey.setStyle(t), o.set(ey.r, ey.g, ey.b, ey.a);
                else throw new Error("Color index out of range");
            } else e.getValue(r)?.setStyle(t);
        } else if (r === "texture" || r === "video") {
            let i = e.color;
            qte(n1.slice(1), t, i, e);
        } else {
            let i = n1[1], s1 = e.getValue(r);
            s1?.isVector3 && i !== void 0 || s1?.isVector2 && i !== void 0 ? s1.setComponent(parseInt(i), t) : e.setValue(r, t);
        }
    } catch (i) {
        console.error("Error setting material value", i);
    }
}
function qte(n1, t, e, r) {
    let i = n1[0];
    if (i === "repeat" || i === "offset") {
        let s1 = n1[1];
        if (s1 === void 0) t instanceof Array && t.length === 2 && Object.assign(e.mat, {
            [i]: t
        });
        else {
            let o = e.mat[i], a = parseInt(s1) === 0 ? [
                parseFloat(t),
                o[1]
            ] : [
                o[0],
                parseFloat(t)
            ];
            Object.assign(e.mat, {
                [i]: a
            });
        }
        e.mat.updateMatrix();
    } else i === "rotation" ? (e.mat.rotation = parseFloat(t), e.mat.updateMatrix()) : i === "wrapping" || i === "minFilter" || i === "magFilter" ? i === "wrapping" ? e.texture.wrap = t : e.texture[i] = t : i === "image" && n1[1] === "data" && e.texture.image.updateSrc(t);
}
var Xte = {
    color: [
        "color"
    ],
    fresnel: [
        "color"
    ],
    normal: [],
    gradient: [
        "colors"
    ],
    depth: [
        "colors"
    ],
    texture: [],
    video: [],
    noise: [
        "colorA",
        "colorB",
        "colorC",
        "colorD"
    ],
    toon: [
        "colors",
        "shadowColor"
    ],
    outline: [
        "outlineColor",
        "contourColor"
    ],
    transmission: [
        "attenuationColor"
    ],
    matcap: [],
    pattern: [
        "colorA",
        "colorB"
    ],
    light: [],
    displace: [],
    rainbow: [],
    particle: []
};
function Yte(n1, t, e) {
    return !!Xte[t]?.includes(n1);
}
var Qte = new U;
function Zte(n1) {
    let t = "The Spline Runtime only accepts .splinecode files that are generated from Spline export panel.";
    n1.endsWith(".spline") ? console.warn(t + " The .spline files are only meant to be used by the Editor.") : n1.endsWith(".splinecode") || console.warn(t);
}
function KV(n1) {
    let t = new cr(0, 0, 0, 1);
    try {
        t.setStyle(n1);
    } catch (e) {
        console.error(e);
    } finally{
        return t;
    }
}
var QV = class {
    constructor(t, { renderOnDemand: e, renderMode: r = "auto", wasmPath: i } = {}){
        this._viewportMode = 1;
        this._viewportWidth = window.innerWidth;
        this._viewportHeight = window.innerHeight;
        this._proxyObjectCache = new Map;
        this._variablesCache = new Map;
        this._isPaused = !1;
        this._renderRequested = !1;
        this._skipRender = !1;
        this.time = performance.now();
        this.dt = 0;
        this.currentTAAFrame = 0;
        this.disposed = !1;
        this._requestRenderAutoMode = ()=>{
            this._skipRender = !1;
        };
        this.requestRender = ()=>{
            this._renderRequested = !0;
        };
        this.render = (t)=>{
            if (this.time = t, this._lastTime && (this.dt = this.time - this._lastTime), this._lastTime = this.time, this._perfs?.start(), !this._renderer) {
                this._perfs?.end();
                return;
            }
            if (!this._isPaused && (this.renderMode === "manual" && !this._renderRequested || this.renderMode === "auto" && this._skipRender)) {
                this._perfs?.end();
                return;
            }
            if (this._renderRequested = !1, this._skipRender = !0, this._controls && (this._skipRender = this._controls.update(this.dt) ?? !1), this._eventManager && (this._eventManager.handlers?.Start.hasVideoAction || this._eventManager.handlers?.Basic.hasVideoAction || this._eventManager.handlers?.Conditional.hasVideoAction) && (this._skipRender = !1), this._animationControls?.update(this.dt), this._skipRender ? (this.currentTAAFrame++, this.currentTAAFrame < 32 ? this._skipRender = !1 : this.currentTAAFrame = 0) : this.currentTAAFrame = 0, this._scene?.traverseVisibleEntity((e)=>{
                e.type === "ParticleSystem" && (e.update(this.dt), this._skipRender = !1);
            }), this._scene && this._scene.activeCamera !== this._camera && (this._camera = this._scene.activeCamera), this._eventManager?.isEnabled && ((this._eventManager.handlers?.Follow).onAnimationFrameDamping(), (this._eventManager.handlers?.LookAt).onAnimationFrameDamping(), (this._eventManager.handlers?.DragDrop).onAnimationFrameDamping()), this._scene && this._camera) {
                if (this._scene.pathConstraints.applyConstraints(this._scene), this._renderer.sceneTransitionTimeRemaining > 0) {
                    this._renderer.sceneTransitionTimeRemaining -= this.dt;
                    let e = 1 - this._renderer.sceneTransitionTimeRemaining / this._renderer.sceneTransitionDuration;
                    this._renderer.pipeline.sceneTransitionPass.uniforms.mixRatio.value = e, this._skipRender = !1;
                } else this._renderer.pipeline.sceneTransitionFromTexture = null;
                this._renderer.renderSplineScene(this._scene, this._camera);
            }
            this.canvas.dispatchEvent(this._renderedEvent), this._perfs?.end();
        };
        this._resize = (t)=>{
            if (!!this._renderer) {
                if (this._viewportMode === 1 && this._frameView && (this._frameView.frameSize = Qte.set(this._viewportWidth, this._viewportHeight)), t) {
                    let e = this._viewportWidth, r = this._viewportHeight;
                    this._renderer.setSize(e - 1, r - 1, !1), this._renderer.setSize(e, r, !1);
                } else this._renderer.setSize(this._viewportWidth, this._viewportHeight, !1);
                if (this._camera = this._scene?.activeCamera, this._scene?.updateViewPlaneSize(this._frameView?.frameSize?.x ?? this._viewportWidth, this._frameView?.frameSize?.y ?? this._viewportHeight, this._frameView?.enableResponsive ?? !1), this._camera) {
                    let e = Object.values(this._data?.frames ?? {})[0].preset ?? "fullscreen";
                    this._frameView?.setCamera(this._camera), this._frameView?.updateCamera(e !== "fullscreen"), this._camera.cameraType === "PerspectiveCamera" && (this._camera.aspect = this._viewportWidth / this._viewportHeight), this._camera.updateProjectionMatrix();
                }
                this.eventManager && (this.eventManager.eventContext.domRect = this.canvas.getBoundingClientRect()), this._requestRenderAutoMode();
            }
        };
        this._debouncedResize = _o(this._resize, 10);
        this._onScroll = (t)=>{
            this.eventManager && (this.eventManager.eventContext.domRect = this.canvas.getBoundingClientRect());
        };
        this.canvas = t, this.renderMode = e ? "auto" : r, i && (this._wasmPath = tA(i, "/")), this._renderedEvent = new CustomEvent("rendered", {
            bubbles: !0
        }), Object.defineProperty(this._renderedEvent, "target", {
            writable: !1,
            value: this
        }), window.location.search.includes("perfs") && (this._perfs = new Z1({
            x: 10,
            y: 10
        })), yD(t);
    }
    async load(t, e, r) {
        Zte(t), this.disposed = !1;
        let s1 = await (await fetch(t, r)).arrayBuffer();
        await this.start(s1, {
            variables: e
        });
    }
    async start(t, { interactive: e = !0, variables: r } = {}) {
        if (this.disposed) return;
        let i = await FV(t);
        this._data = i;
        let s1 = VV(i);
        i.version && (0, ZV.default)(i.version, "1.12.53") > 0 && console.warn("Your .splinecode file is more recent than the library. Please upgrade @splinetool/runtime to the latest version."), this._wasmPath && this.setUIWasmUrl(`${this._wasmPath}/ui.wasm`), await Promise.all([
            s1.length && yC(this._wasmPath),
            KT(i) && hL(this._wasmPath),
            cN(i) && nL(this._wasmPath),
            ql.physicsEnabled(i.scene.objects) && ED(),
            kT(i) && $L(),
            i1(i) && EM(),
            QL(i) && XL(),
            aM(i) && EB(),
            aC(i) && SD(this._wasmPath)
        ].filter(Boolean)), s1.length && await vC(s1), this._eventManager?.deactivate(), this._controls?.deactivate(), this._scene?.dispose();
        let o = new Q1(i);
        if (o.resetPersonalCameraFromDocumentData(), this._scene = o.scene, this._sharedAssetsManager = o.sharedAssets, this._camera = this._scene.activeCamera, window.location.search.includes("merge-geometries")) {
            let c = performance.now();
            HV(i, o.scene);
            let u1 = performance.now();
            console.log("Merged geometries in ", u1 - c, " ms");
        }
        KT(i) && this._scene.traverse((c)=>{
            Dn(c) && c.recomputeBoolean();
        }), this._sharedAssetsManager.setRequestRender(()=>{
            this._requestRenderAutoMode(), this._scene?.traverse((c)=>{
                c instanceof Ai && c.pendingMediaLoad && c.update({
                    scene: this._scene,
                    shared: this._sharedAssetsManager
                });
            });
        }), this._scene?.traverse((c)=>{
            c.type === "ParticleSystem" && (c.wakeUp(), c.data.autoPlay ? c.start() : c.stop());
        });
        let a = Object.keys(i.shared.fonts).map((c)=>this._sharedAssetsManager.getFont(c).loadingPromise);
        if (Promise.all(a).then(()=>{
            o.scene.markNeedsUpdateRendererDirty(), this._requestRenderAutoMode();
        }), kT(i) && LV(i) && await Promise.all(a), aM(i)) {
            let c = [];
            this._scene.traverseEntity((u1)=>{
                (u1 instanceof _r || u1 instanceof yr) && u1.uiCanvas && c.push(u1.uiCanvas);
            }), await Promise.all(c.map((u1)=>u1.promise));
        }
        if (this._scene.rewriteEventsBeforeGoToPlayMode(), sp(this._scene.activePage, this._sharedAssetsManager), !this._renderer) {
            this._renderer = new Db({
                canvas: this.canvas,
                antialias: !1,
                alpha: !0,
                stencil: !1,
                depth: !1,
                powerPreference: "high-performance"
            }), this._renderer.hdTransmission = i.scene.publish.hdTransmission === !0;
            let c = ()=>/Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), u1 = this._getPixelRatio(c() ? i.scene.publish.settings.web.pixelRatioMobile : i.scene.publish.settings.web.pixelRatioDesktop);
            if (this._renderer.setPixelRatio(u1), this._renderer.pipeline.enableUIOverlay(), this._renderer.pipeline.addEventListener("smaaloaded", this._requestRenderAutoMode), i.shared.images.SplineWatermark) {
                let h = this._sharedAssetsManager.getImage("SplineWatermark");
                await h.loadPromise;
                let d = h.getTexture(1001);
                this._renderer.pipeline.setWatermark(d);
            }
        }
        i1(i) && this._scene.initializeSplatViewer(), i.scene.blueNoiseTextureData !== void 0 && this._renderer.pipeline.updateBlueNoiseTexture(i.scene.blueNoiseTextureData);
        let l = Object.values(i.frames)[0];
        if (this._frameView ? this._frameView.setCamera(this._camera) : (l.preset === "fullscreen" ? (this._viewportMode = 1, this.canvas.style.display = "block", this.canvas.parentElement && (this._viewportWidth = this.canvas.parentElement.clientWidth || 300, this.canvas.style.width = "100%"), this.canvas.parentElement && (this._viewportHeight = this.canvas.parentElement.clientHeight || 150, this.canvas.style.height = "100%")) : (this._viewportMode = 2, this._viewportWidth = l.size[0], this._viewportHeight = l.size[1], this.canvas.style.width = `${this._viewportWidth}px`, this.canvas.style.height = `${this._viewportHeight}px`), this._renderer.setSize(this._viewportWidth, this._viewportHeight, !1), this._frameView = new K1(this._renderer, this._camera, new U(this._viewportWidth, this._viewportHeight), new U(window.innerWidth, window.innerHeight)), this._frameView.enableResponsive = (l.allowResponsive ?? !1) && l.preset === "fullscreen"), e) {
            let c = new v1(this._renderer, this.data.scene.publish, this._scene, ()=>this._scene.activeCamera, this._sharedAssetsManager, this._requestRenderAutoMode, !0, l);
            this._scene.updateMatrixWorld(!0), this._controls = new F1(c), this._animationControls = new V1(this._scene, this._requestRenderAutoMode), this._eventManager = new Y1(i.scene.publish, this._controls, this._animationControls, c, i.shared.variables), this._eventManager.activate(), this._controls.activate(this._eventManager);
        }
        this._resize(), this._scene.activePage.data.postprocessing.depthOfField.enabled && Promise.all(this._sharedAssetsManager.getImageLoadPromises()).then(()=>{
            this._resize(!0);
        }), r !== void 0 && this.setVariables(r), this.dt === 0 && (this.render(performance.now()), setTimeout(()=>{
            this._renderer?.setAnimationLoop(this.render);
        }, 0)), this._resizeObserverTimeout = setTimeout(()=>{
            !this._resizeObserver && this.canvas.parentElement && (this._resizeObserver = new ResizeObserver(()=>{
                this._viewportWidth = this.canvas.clientWidth, this._viewportHeight = this.canvas.clientHeight, this._debouncedResize();
            }), this._resizeObserver.observe(this.canvas.parentElement));
        }, 300), document.addEventListener("scroll", this._onScroll);
    }
    setVariables(t) {
        if (this._data !== void 0) {
            let e = Object.entries(t);
            for (let [r, i] of e)this.setVariable(r, i);
        }
    }
    setVariable(t, e) {
        let r = this._getVariableByName(t);
        if (r && !("dynamicVariableType" in r.data)) {
            let i = e;
            typeof r.data.value == "number" ? i = typeof e == "number" ? e : typeof e == "boolean" ? e === !0 ? 1 : 0 : parseFloat(e) : typeof r.data.value == "boolean" ? i = typeof e == "number" ? !!e : typeof e == "boolean" ? e : e.toLocaleLowerCase() === "false" ? !1 : !!e : typeof r.data.value != "string" && r.data.value.textValue !== void 0 && (i = e.toString());
            let s1 = typeof i == "string" ? {
                textValue: i
            } : i;
            this._sharedAssetsManager?.updateVariable(r.id, s1), this.requestRender(), this._requestRenderAutoMode();
        } else r === void 0 ? console.warn(`No variable named ${t} was found in your Spline file. Make sure to create it from Spline editor.`) : "dynamicVariableType" in r.data && console.warn(`Dynamic variables like ${t} cannot be updated from code.`);
    }
    getVariables() {
        let t = {};
        return this._data && this._data.shared.variables.forEach((e)=>{
            t[e.data.name] === void 0 && (t[e.data.name] = this._getVariableValue(this._sharedAssetsManager.getVariable(e.id)));
        }), t;
    }
    getVariable(t) {
        let e = this._getVariableByName(t);
        if (e) {
            let r = this._sharedAssetsManager.getVariable(e.id);
            return this._getVariableValue(r);
        }
    }
    _getVariableValue(t) {
        return typeof t != "string" && Gr.isTextValue(t) ? Gr.getDisplayedValue(t) : t;
    }
    _getVariableByName(t) {
        if (this._data) {
            if (this._variablesCache.has(t)) return this._variablesCache.get(t);
            let e = this._data.shared.variables.find((r)=>r.data.name === t);
            return e && this._variablesCache.set(t, e), e;
        }
    }
    _getPixelRatio(t) {
        switch(t){
            case 0:
                return window.devicePixelRatio;
            case 1:
                return 1;
            case 2:
                return 2;
        }
    }
    findObjectById(t) {
        let e = this._scene?.getObjectByProperty("uuid", t);
        return this._createProxyObject(e);
    }
    findObjectByName(t) {
        let e = this._scene?.getObjectByName(t);
        return this._createProxyObject(e);
    }
    getAllObjects() {
        let t = [];
        return this._scene?.traverseEntity((e)=>{
            if (e.uuid !== As && !this._scene.isInvisibleObjects(e) && !(e instanceof yr)) {
                let r = this._createProxyObject(e);
                r && t.push(r);
            }
        }), t;
    }
    getSplineEvents() {
        return (this._eventManager?.handlers?.Spline).splineEvents;
    }
    emitEvent(t, e) {
        (this.findObjectById(e) || this.findObjectByName(e))?.emitEvent(t);
    }
    emitEventReverse(t, e) {
        (this.findObjectById(e) || this.findObjectByName(e))?.emitEventReverse(t);
    }
    addEventListener(t, e) {
        this.canvas.addEventListener(t, e);
    }
    removeEventListener(t, e) {
        this.canvas.removeEventListener(t, e);
    }
    setZoom(t) {
        this._controls?.orbitControls instanceof gp && this._controls?.orbitControls.setZoom(t);
    }
    get eventManager() {
        return this._eventManager;
    }
    get controls() {
        return this._controls;
    }
    setSize(t, e) {
        this._viewportWidth = t, this._viewportHeight = e, this._viewportMode = 2, this._resize();
    }
    setBackgroundColor(t) {
        let e = KV(t);
        this._scene?.activePage.setBackgroundColor(e), this._requestRenderAutoMode();
    }
    dispose() {
        this.disposed = !0, this._eventManager?.deactivate(), this._scene?.dispose(), this._sharedAssetsManager?.dispose(), this._proxyObjectCache.forEach((t)=>{
            jw.unsubscribe(t);
        }), this._variablesCache.clear(), this._renderer?.setAnimationLoop(null), this._renderer?.dispose(), this._renderer = void 0, this._sharedAssetsManager?.dispose(), this._resizeObserver && (this._resizeObserver.disconnect(), this._resizeObserver = void 0), this._resizeObserverTimeout !== void 0 && clearTimeout(this._resizeObserverTimeout), this.canvas.style.width = "", this.canvas.style.height = "", this.canvas.removeAttribute("width"), this.canvas.removeAttribute("height"), this._frameView && (this._frameView = void 0), this._controls?.deactivate(), this.dt = 0, vD(this.canvas), document.removeEventListener("scroll", this._onScroll);
    }
    get isStopped() {
        return this._isPaused;
    }
    stop() {
        this._isPaused || (this._renderer?.setAnimationLoop(null), this._isPaused = !0, this._eventManager?.pause(), this._controls?.orbitControls && (this._controls.orbitControls.enabled = !1));
    }
    play() {
        !this._isPaused || (this._isPaused = !1, this._eventManager?.resume(), this._controls?.orbitControls && (this._controls.orbitControls.enabled = !0), this._renderer?.setAnimationLoop(this.render));
    }
    setGlobalEvents(t) {
        this._eventManager?.updateUseWindowEvents(t);
    }
    get data() {
        return this._data;
    }
    _createProxyObject(t) {
        if (!this._scene) return;
        let e = this._scene;
        if (t == null) return;
        if (this._proxyObjectCache.has(t.uuid)) return this._proxyObjectCache.get(t.uuid);
        let r;
        t.traverseAncestors((u1)=>{
            u1 instanceof yr && (r = u1.name);
        });
        let i = this._sharedAssetsManager, s1 = {
            shared: i,
            scene: this._scene
        }, o = (u1)=>{
            if (u1 === null || u1 === "Base State") return null;
            if (u1 && t.data.states) {
                let h = t.data.states.find((d)=>d.data.name === u1);
                return h ? h.id : void 0;
            }
        }, a = "material" in t ? t.material : void 0, l = {
            name: t.name,
            uuid: t.uuid,
            visible: t.visible,
            intensity: t.intensity,
            position: t.position,
            rotation: t.rotation,
            scale: t.scale,
            type: t.data.type,
            page: r,
            material: a ? XV(a) : void 0,
            parentUuid: t.parent instanceof yr || t instanceof fc ? void 0 : t.parent?.uuid,
            emitEvent (u1) {
                t.dispatchEvent({
                    type: "userEvent",
                    eventName: u1
                });
            },
            emitEventReverse (u1) {
                t.dispatchEvent({
                    type: "userEvent",
                    eventName: u1,
                    reverse: !0
                });
            },
            hide () {
                t.visible && (t.visible = !1, s1.shared.requestRender());
            },
            show () {
                t.visible || (t.visible = !0, s1.shared.requestRender());
            },
            get state () {
                let u1 = t.stateSelection;
                if (u1 !== null) return t.data.states.find(({ id: h })=>h === u1)?.data.name;
            },
            set state (u){
                let h;
                if (u !== void 0) {
                    let d = typeof u == "string" ? t.data.states.find(({ id: f })=>f === u) : t.data.states[u];
                    if (d) h = d.id;
                    else {
                        let f = typeof u == "string" ? o(u) : void 0;
                        f && (h = f);
                    }
                }
                t.changeSelectedState(h ?? null, s1), t.currentState = h ?? null, t.dispatchEvent({
                    type: "completeState",
                    state: h ?? null
                }), s1.shared.requestRender();
            },
            transition (u1) {
                let h = this, d, f = Ms.timeline({
                    autoplay: u1.autoPlay ?? !0
                }), m = {
                    transition ({ from: p, to: g, duration: y, delay: x, ...v }) {
                        let b = o(p);
                        b === void 0 && (b = d);
                        let w = o(g);
                        d = w;
                        let A = new op(t, b, w, {
                            state: w,
                            repeat: 0,
                            delay: x ?? 0,
                            delayDirection: "start-once",
                            direction: "normal",
                            duration: y ?? 1e3,
                            ...v,
                            ...v.easing === 6 ? ad.defaultData : v.easing === 5 ? ld.defaultData : {}
                        }, i, !1, e.activePage);
                        return f.add({
                            ...A.params,
                            begin: ()=>{
                                (p && b || p === "Base State" && !b) && (h.state = b ?? void 0);
                            },
                            complete: ()=>{
                                h.state = w ?? void 0;
                            }
                        }, f.duration), this;
                    },
                    play () {
                        return f.play(), this;
                    },
                    pause () {
                        return f.pause(), this;
                    },
                    reset () {
                        return f.reset(), this;
                    },
                    seek (p) {
                        return f.seek(p), this;
                    }
                };
                return m.transition(u1), m;
            },
            set color (u){
                let h = KV(u);
                if (Of.is(t)) {
                    t.color = h;
                    return;
                } else if (t.type !== "Mesh" || !("material" in t) || !(t instanceof _n)) return;
                let d = {
                    r: h.r,
                    g: h.g,
                    b: h.b,
                    a: h.a
                }, f = Array.isArray(t.material) ? t.material[0] : t.material, m = f.data.layers.find((p)=>p.data.type === "color")?.id;
                if (m) f.updateByOp({
                    type: 0,
                    path: [
                        "layers",
                        m
                    ],
                    props: {
                        color: {
                            ...d
                        }
                    }
                }, f.data, s1);
                else {
                    let p = f.data, g = p.layers.find((T)=>T.data.type === "light");
                    if (!g) return;
                    let y = p.layers.indexOf(g) === 0 ? g : null, x = p.layers.at(y ? p.layers.indexOf(y) + 1 : 0), v = y ? y.fi + (x ? (x.fi - y.fi) / 2 : 1) : x ? x.fi / 2 : 1, b = {
                        type: 4,
                        fi: v,
                        id: Se.generateUUID(),
                        data: {
                            ...Cr.defaultData("color"),
                            color: d
                        },
                        localIndex: 0
                    }, w = p.layers.insertAfterHelper(y?.id ?? null, 1), A = p.layers.runOp({
                        ...b,
                        fi: w[0]
                    }).data;
                    Object.assign(f.data, {
                        layers: A
                    }), f.updateByOp({
                        ...b,
                        path: [
                            "layers"
                        ]
                    }, f.data, s1);
                }
            }
        }, c = jw(l, (u1, h)=>{
            let d = t[u1], f = Jte(u1);
            f[0] === "material" && a && YV(f.slice(1), h, a), typeof d != "object" && Object.getOwnPropertyDescriptor(t, u1)?.writable && (t[u1] = h), this._requestRenderAutoMode(), t.updateMatrix();
        });
        return this._proxyObjectCache.set(t.uuid, c), c;
    }
    setUIWasmUrl(t) {
        zx.skiaWasmUrl = t;
    }
    pauseGameControls() {
        this._eventManager?.controlsManager.gameControl?.pause();
    }
    resumeGameControls() {
        this._eventManager?.controlsManager.gameControl?.resume();
    }
    async swapGeometry(t, e) {
        let r;
        if (typeof e == "string") {
            if (e.endsWith(".splinegeometry")) {
                let u1 = await (await fetch(e)).arrayBuffer();
                r = new Uint8Array(u1);
            } else throw new Error("Only .splinegeometry format is supported");
        } else r = e;
        let i = od.deserialize(r), s1 = "data" in i && i.data.draco !== void 0;
        s1 && await yC(this._wasmPath);
        let o = this._scene?.getObjectByProperty("uuid", t) ?? this._scene?.getObjectByName(t);
        if (!o) {
            console.warn(`Object ${t} not found`);
            return;
        }
        if (o.data.type !== "Mesh" || !(o instanceof _n)) {
            console.warn(`Object ${t} is not a mesh`);
            return;
        }
        let a = o, l = {
            ...a.data,
            geometry: i
        };
        s1 && await vC([
            l
        ]), a.updateByOp({
            type: 0,
            path: [],
            props: {
                geometry: l.geometry
            }
        }, l, {
            shared: this._sharedAssetsManager,
            scene: this._scene
        }, !1);
        for (let c of a.data.states){
            let u1 = {
                ...c.data
            };
            a.states || (a.states = {}), a.states[c.id] = Qs.patch(l, u1);
        }
        return r;
    }
};
function Jte(n1) {
    return n1.split(".");
}

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("8b5hF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7ld7l").then(()=>parcelRequire("gRaTy"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("lUNnT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cxrcT").then(()=>parcelRequire("lxep3"));

});

parcelRegister("9CTrk", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cM1YA").then(()=>parcelRequire("1eBiX"));

});

parcelRegister("1Jpra", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9WKx7").then(()=>parcelRequire("Aa6gW"));

});

parcelRegister("fQPhc", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("13cBi").then(()=>parcelRequire("8pSbm"));

});

parcelRegister("14X3t", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dtqLr").then(()=>parcelRequire("lq4np"));

});

parcelRegister("836Xp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5fiVm").then(()=>parcelRequire("jRJKa"));

});

parcelRegister("88rJr", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3MkNW").then(()=>parcelRequire("5nvck"));

});


parcelRequire("6THZ6");
// // Initialize 3D canvas if available and not on mobile
// const canvas = document.getElementById("canvas3d");
// const app = new Application(canvas);
// app.load("https://prod.spline.design/pW2zyj3hL0Hs-BUk/scene.splinecode");
// Black fade transition overlay
function $54b47fc030b7b21e$var$createTransitionOverlay() {
    const overlay = document.createElement("div");
    overlay.className = "transition-overlay opening";
    document.body.appendChild(overlay);
    return overlay;
}
const $54b47fc030b7b21e$var$overlay = $54b47fc030b7b21e$var$createTransitionOverlay();
// Fade in when page loads (with delay to avoid flash)
window.addEventListener("load", ()=>{
    setTimeout(()=>{
        $54b47fc030b7b21e$var$overlay.classList.remove("closing");
        $54b47fc030b7b21e$var$overlay.classList.add("opening");
    }, 300);
});
// Mobile Burger Menu functionality
function $54b47fc030b7b21e$var$initBurgerMenu() {
    const burgerButtons = document.querySelectorAll(".burger-menu-btn");
    const mobileNav = document.getElementById("mobileNav");
    burgerButtons.forEach((button)=>{
        button.addEventListener("click", (e)=>{
            e.stopPropagation();
            if (mobileNav) mobileNav.classList.toggle("active");
        });
    });
    // Close mobile menu when clicking on a link
    if (mobileNav) {
        const navLinks = mobileNav.querySelectorAll("a");
        navLinks.forEach((link)=>{
            link.addEventListener("click", ()=>{
                mobileNav.classList.remove("active");
            });
        });
    }
    // Close menu when clicking outside
    document.addEventListener("click", (e)=>{
        if (mobileNav && mobileNav.classList.contains("active")) {
            if (!e.target.closest(".burger-menu-btn") && !e.target.closest(".mobile-nav")) mobileNav.classList.remove("active");
        }
    });
}
// Initialize burger menu when DOM is ready
document.addEventListener("DOMContentLoaded", $54b47fc030b7b21e$var$initBurgerMenu);
// Intercept all navigation links
document.addEventListener("click", (e)=>{
    const link = e.target.closest("a");
    if (link && link.href && !link.target) {
        const href = link.getAttribute("href");
        // Only animate for internal navigation
        if (href && !href.startsWith("http") && !href.startsWith("#")) {
            e.preventDefault();
            $54b47fc030b7b21e$var$overlay.classList.remove("opening");
            $54b47fc030b7b21e$var$overlay.classList.add("closing");
            setTimeout(()=>{
                window.location.href = href;
            }, 450);
        }
    }
});
// Player counter functionality
const $54b47fc030b7b21e$var$counterElement = document.getElementById("counter");
const $54b47fc030b7b21e$var$incrementBtn = document.getElementById("incrementBtn");
const $54b47fc030b7b21e$var$decrementBtn = document.getElementById("decrementBtn");
let $54b47fc030b7b21e$var$playerCount = 3;
const $54b47fc030b7b21e$var$MIN_PLAYERS = 2;
const $54b47fc030b7b21e$var$MAX_PLAYERS = 8;
function $54b47fc030b7b21e$var$updateDisplay() {
    if ($54b47fc030b7b21e$var$counterElement) $54b47fc030b7b21e$var$counterElement.textContent = $54b47fc030b7b21e$var$playerCount;
}
if ($54b47fc030b7b21e$var$incrementBtn) $54b47fc030b7b21e$var$incrementBtn.addEventListener("click", ()=>{
    if ($54b47fc030b7b21e$var$playerCount < $54b47fc030b7b21e$var$MAX_PLAYERS) {
        $54b47fc030b7b21e$var$playerCount++;
        $54b47fc030b7b21e$var$updateDisplay();
    }
});
if ($54b47fc030b7b21e$var$decrementBtn) $54b47fc030b7b21e$var$decrementBtn.addEventListener("click", ()=>{
    if ($54b47fc030b7b21e$var$playerCount > $54b47fc030b7b21e$var$MIN_PLAYERS) {
        $54b47fc030b7b21e$var$playerCount--;
        $54b47fc030b7b21e$var$updateDisplay();
    }
});
// Reservation card click persistence
const $54b47fc030b7b21e$var$reservationClickable = document.querySelector(".reservation-clickable");
if ($54b47fc030b7b21e$var$reservationClickable) {
    const cards = $54b47fc030b7b21e$var$reservationClickable.querySelectorAll(".reservation-card");
    cards.forEach((card)=>{
        card.addEventListener("click", (e)=>{
            e.stopPropagation();
            // Remove active class from all cards
            cards.forEach((c)=>c.classList.remove("active"));
            // Add active class to clicked card
            card.classList.add("active");
        });
    });
}
// Calendar date selection persistence
const $54b47fc030b7b21e$var$calendarDates = document.querySelectorAll(".calendar .dates button");
if ($54b47fc030b7b21e$var$calendarDates.length > 0) $54b47fc030b7b21e$var$calendarDates.forEach((dateBtn)=>{
    dateBtn.addEventListener("click", (e)=>{
        e.preventDefault();
        // Remove selected class from all date buttons
        $54b47fc030b7b21e$var$calendarDates.forEach((btn)=>btn.classList.remove("selected"));
        // Add selected class to clicked date
        dateBtn.classList.add("selected");
    });
});
// Time slot selection with completed slots disabled
const $54b47fc030b7b21e$var$timeSlots = document.querySelectorAll(".time-slot");
if ($54b47fc030b7b21e$var$timeSlots.length > 0) $54b47fc030b7b21e$var$timeSlots.forEach((timeSlot)=>{
    // Disable completed time slots
    if (timeSlot.classList.contains("completed")) {
        timeSlot.disabled = true;
        timeSlot.setAttribute("disabled", "");
        timeSlot.style.cursor = "not-allowed";
        timeSlot.style.opacity = "0.5";
    } else // Add click handler for available slots
    timeSlot.addEventListener("click", (e)=>{
        e.preventDefault();
        // Remove selected class from all time slots
        $54b47fc030b7b21e$var$timeSlots.forEach((slot)=>slot.classList.remove("selected"));
        // Add selected class to clicked slot
        timeSlot.classList.add("selected");
    });
});
// Room link selection with salle-focus-card class
const $54b47fc030b7b21e$var$roomLinks = document.querySelectorAll(".room-link");
if ($54b47fc030b7b21e$var$roomLinks.length > 0) $54b47fc030b7b21e$var$roomLinks.forEach((link)=>{
    link.addEventListener("click", (e)=>{
        e.preventDefault();
        // Remove salle-focus-card class from all reservation-cards
        const allReservationCards = document.querySelectorAll(".reservation-card");
        allReservationCards.forEach((card)=>{
            card.classList.remove("salle-focus-card");
        });
        // Add salle-focus-card class to the clicked room's card
        const roomCard = link.querySelector(".reservation-card");
        if (roomCard) roomCard.classList.add("salle-focus-card");
    });
});
// Search bar functionality
const $54b47fc030b7b21e$var$searchBarWrapper = document.getElementById("searchBarWrapper");
const $54b47fc030b7b21e$var$searchIconBtn = document.getElementById("searchIconBtn");
const $54b47fc030b7b21e$var$searchInput = document.getElementById("searchInput");
const $54b47fc030b7b21e$var$searchBtn = document.getElementById("searchBtn");
if ($54b47fc030b7b21e$var$searchBarWrapper && $54b47fc030b7b21e$var$searchIconBtn && $54b47fc030b7b21e$var$searchInput && $54b47fc030b7b21e$var$searchBtn) {
    // Toggle expanded/collapsed on icon click
    $54b47fc030b7b21e$var$searchIconBtn.addEventListener("click", (e)=>{
        e.preventDefault();
        $54b47fc030b7b21e$var$searchBarWrapper.classList.remove("collapsed");
        $54b47fc030b7b21e$var$searchBarWrapper.classList.add("expanded");
        $54b47fc030b7b21e$var$searchInput.focus();
    });
    // Collapse search bar
    function collapseSearch() {
        $54b47fc030b7b21e$var$searchBarWrapper.classList.add("collapsed");
        $54b47fc030b7b21e$var$searchBarWrapper.classList.remove("expanded");
        $54b47fc030b7b21e$var$searchInput.value = "";
    }
    // Define search mappings
    const searchMappings = {
        witch: "salle-witch.html",
        "sorci\xe8re": "salle-witch.html",
        pirate: "salle-pirate.html",
        forest: "salle-forest.html",
        "for\xeat": "salle-forest.html",
        accueil: "index.html",
        home: "index.html",
        tarifs: "tarifs.html",
        pricing: "tarifs.html",
        reservation: "reservation.html",
        "r\xe9servation": "reservation.html",
        book: "reservation.html",
        compte: "mon-compte.html",
        account: "mon-compte.html",
        profil: "mon-compte.html",
        profile: "mon-compte.html"
    };
    function performSearch() {
        const searchTerm = $54b47fc030b7b21e$var$searchInput.value.trim().toLowerCase();
        if (!searchTerm) return;
        // Check for exact or partial matches
        const matchedPage = searchMappings[searchTerm];
        if (matchedPage) {
            // Create transition overlay and navigate
            const overlay = document.querySelector(".transition-overlay");
            if (overlay) {
                overlay.classList.remove("opening");
                overlay.classList.add("closing");
            }
            setTimeout(()=>{
                window.location.href = matchedPage;
            }, 450);
        } else {
            // Show "no results" feedback
            const searchBar = $54b47fc030b7b21e$var$searchInput.parentElement;
            searchBar.style.borderColor = "#e10000";
            $54b47fc030b7b21e$var$searchInput.placeholder = "Aucun r\xe9sultat...";
            // Reset after 2 seconds
            setTimeout(()=>{
                searchBar.style.borderColor = "";
                $54b47fc030b7b21e$var$searchInput.placeholder = "Rechercher...";
            }, 2000);
        }
    }
    // Search on button click
    $54b47fc030b7b21e$var$searchBtn.addEventListener("click", performSearch);
    // Search on Enter key
    $54b47fc030b7b21e$var$searchInput.addEventListener("keypress", (e)=>{
        if (e.key === "Enter") performSearch();
    });
    // Close search bar when clicking outside
    document.addEventListener("click", (e)=>{
        if (!$54b47fc030b7b21e$var$searchBarWrapper.contains(e.target)) {
            if ($54b47fc030b7b21e$var$searchBarWrapper.classList.contains("expanded")) collapseSearch();
        }
    });
}
// Burger menu functionality
const $54b47fc030b7b21e$var$burgerBtn = document.getElementById("burgerBtn");
const $54b47fc030b7b21e$var$headerNav = document.getElementById("headerNav");
if ($54b47fc030b7b21e$var$burgerBtn && $54b47fc030b7b21e$var$headerNav) {
    $54b47fc030b7b21e$var$burgerBtn.addEventListener("click", ()=>{
        $54b47fc030b7b21e$var$headerNav.classList.toggle("active");
    });
    // Close menu when clicking on a link
    $54b47fc030b7b21e$var$headerNav.addEventListener("click", (e)=>{
        if (e.target.tagName === "A") $54b47fc030b7b21e$var$headerNav.classList.remove("active");
    });
    // Close menu when clicking outside
    document.addEventListener("click", (e)=>{
        if (!$54b47fc030b7b21e$var$burgerBtn.contains(e.target) && !$54b47fc030b7b21e$var$headerNav.contains(e.target)) $54b47fc030b7b21e$var$headerNav.classList.remove("active");
    });
}
// Game overlay functionality
const $54b47fc030b7b21e$var$gameOverlay = document.getElementById("gameOverlay");
const $54b47fc030b7b21e$var$gameStartBtn = document.getElementById("gameStartBtn");
if ($54b47fc030b7b21e$var$gameOverlay && $54b47fc030b7b21e$var$gameStartBtn) $54b47fc030b7b21e$var$gameStartBtn.addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$gameOverlay.classList.add("fade-out");
    setTimeout(()=>{
        $54b47fc030b7b21e$var$gameOverlay.style.display = "none";
    }, 500);
});
// Prevent scroll on iframe
const $54b47fc030b7b21e$var$iframeContainer = document.querySelector(".iframe-container");
if ($54b47fc030b7b21e$var$iframeContainer) {
    // Block body scroll when mouse enters iframe
    $54b47fc030b7b21e$var$iframeContainer.addEventListener("mouseenter", ()=>{
        document.body.style.overflow = "hidden";
    });
    // Restore body scroll when mouse leaves iframe
    $54b47fc030b7b21e$var$iframeContainer.addEventListener("mouseleave", ()=>{
        document.body.style.overflow = "";
    });
}


//# sourceMappingURL=index.deacc46d.js.map
